webpackJsonp([0],{

/***/ "+2NR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        index: { type: Number },
        item: { type: Object },
        mudarOportunidade: { type: Function },
        ajustIdOportunidade: { type: Function },
        formatarScore: { type: Function },
        formatarTipoEmprestimo: { type: Function },
        money: { type: Function },
        inteiro: { type: Function },
        levantado: { type: Function },
        faltam: { type: Function },
        diffDate: { type: Function },
        valor: { type: Function },
        templateRender: { type: Function }
    }
});

/***/ }),

/***/ "+AAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    metaInfo: {
        htmlAttrs: {
            lang: 'pt-br'
        },
        bodyAttrs: {
            class: 'simulacao'
        }
    },
    data: function data() {
        return {
            type: this.$route.query.type,
            dataSimulator: JSON.parse(localStorage.getItem('simulatorData'))
        };
    },

    computed: {
        loansName: function loansName() {
            return this.titleTipe();
        },
        valor: function valor() {
            return this.currencyFormat(parseFloat(localStorage.getItem('loansValue')));
        },
        numeroParcelas: function numeroParcelas() {
            return this.dataSimulator.n;
        },
        parcelaIouu: function parcelaIouu() {
            return this.currencyFormat(this.dataSimulator.parcelas);
        },
        totalIouu: function totalIouu() {
            return this.currencyFormat(this.dataSimulator.total);
        },
        jurosamIouu: function jurosamIouu() {
            return this.currencyFormat(this.dataSimulator.juros);
        },
        jurosaaIouu: function jurosaaIouu() {
            return this.currencyFormat(this.dataSimulator.jurosaa);
        },
        juroscetIouu: function juroscetIouu() {
            return this.currencyFormat(this.dataSimulator.juroscet);
        },
        jurosaacet: function jurosaacet() {
            return this.currencyFormat(this.dataSimulator.jurosaacet);
        },
        parcelaCheque: function parcelaCheque() {
            return this.currencyFormat(this.dataSimulator.chequeparcelas);
        },
        totalCheque: function totalCheque() {
            return this.currencyFormat(this.dataSimulator.chequetotal);
        },
        jurosamCheque: function jurosamCheque() {
            return this.currencyFormat(this.dataSimulator.chequeam);
        },
        jurosaaCheque: function jurosaaCheque() {
            return this.currencyFormat(this.dataSimulator.chequeaa);
        },
        parcelaCartao: function parcelaCartao() {
            return this.currencyFormat(this.dataSimulator.capitalparcelas);
        },
        totalCartao: function totalCartao() {
            return this.currencyFormat(this.dataSimulator.capitaltotal);
        },
        jurosamCartao: function jurosamCartao() {
            return this.currencyFormat(this.dataSimulator.capitalam);
        },
        jurosaaCartao: function jurosaaCartao() {
            return this.currencyFormat(this.dataSimulator.capitalaa);
        }
    },
    methods: {
        titleTipe: function titleTipe() {
            var title = void 0;

            switch (this.type) {
                case 'EMPPES':
                    title = ' Emprestimo Pessoal';
                    break;

                case 'EMPVEI':
                    title = ' Veículo em Garantia';
                    break;

                case 'EMIMB':
                    title = ' Imóvel em Garantia';
                    break;

                case 'EMPIMP2':
                    title = ' Empréstimo de Impacto';
                    break;

                default:
                    title = ' Emprestimo Coletivo';
                    break;
            }

            return title;
        },
        currencyFormat: function currencyFormat(num) {
            return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/tipo-de-emprestimo/simulacao-emprestimo',
                title: 'simulacao-emprestimo'
            });
        }
    },
    beforeCreate: function beforeCreate() {},
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.taggingGA();

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ "+OiO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+TVj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{staticClass:"float-left",attrs:{"for":"valor-divida-bancaria"}},[_vm._v("Valor da Dívida")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valorDividaBancaria),expression:"valorDividaBancaria"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"R$","required":""},domProps:{"value":(_vm.valorDividaBancaria)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valorDividaBancaria=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary float-right",attrs:{"disabled":_vm.dividaValida}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Qual é o saldo das dívidas bancárias?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+UOL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+aTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TelefonesStep_vue__ = __webpack_require__("YZc4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e7241c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TelefonesStep_vue__ = __webpack_require__("SVqm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TelefonesStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e7241c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TelefonesStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+d5J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalLoansLayout_vue__ = __webpack_require__("uMvy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e3de26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalLoansLayout_vue__ = __webpack_require__("jHEz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalLoansLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e3de26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalLoansLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+hsU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AdditionalInformationPeerToPeer__ = __webpack_require__("rSIk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StepBackButton__ = __webpack_require__("g50h");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var components = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ StepBackButton: __WEBPACK_IMPORTED_MODULE_2__components_StepBackButton__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_1__components_AdditionalInformationPeerToPeer__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      transitionName: 'slide-left'
    };
  },

  components: components,
  computed: {
    currentStepComponent: function currentStepComponent() {
      return 'finished-step';
    },
    progress: function progress() {
      return 100;
    }
  },
  methods: {},
  beforeCreate: function beforeCreate() {},
  beforeUpdate: function beforeUpdate() {
    this.$Loading.update(this.progress);
  }
});

/***/ }),

/***/ "+kyS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-info"},[(this.MeusInvestimentosAll != null && this.MeusInvestimentosAll.length > 0)?_c('div',{staticClass:"user-profile ccbs"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 tit_page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"back float-right text-right"},[_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"back"},[_vm._v(" ")]),_vm._v(" "),_c('span',[_vm._v("Voltar")])])])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.pcScreen)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.MeusInvestimentosAll),function(sol){return _c('tr',{key:sol._id},[_c('th',{staticClass:"align-middle",attrs:{"scope":"row"}},[_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/investimentos/historico/historico-de-investimento/" + sol._id}},[_vm._v("\n                                        #"+_vm._s(_vm.ajustIdOportunidade(sol.SolicitacaoId.IdOportunidade,5))+"\n                                    ")])],1),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm.ObterNome(sol.SolicitacaoId)))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm.formattedCnpj(sol.SolicitacaoId.Documento)))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("R$ "+_vm._s(_vm.formatCurrency(sol.Valor)))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(sol.SolicitacaoId.Prazo)+" Meses")]),_vm._v(" "),(sol.AssinouCCB == true)?_c('td',[_c('a',{staticClass:"btn btn-secondary btn-block",attrs:{"href":_vm.CCB_URL+"/imprimirccb.aspx?code="+sol.CodigoBMP+"&copias=1","target":"_blank"}},[_vm._v("Visualizar\n                                    ")])]):_vm._e(),_vm._v(" "),(sol.AssinouCCB != true)?_c('td',[_c('router-link',{staticClass:"btn btn-primary btn-block",attrs:{"to":"/investimentos/minhas-ccbs/formalizar/" + sol._id}},[_vm._v("Assinar\n                                    ")])],1):_vm._e()])}),0)])]):_c('div',{staticClass:"margin"},_vm._l((_vm.MeusInvestimentosAll),function(item){return _c('div',{key:item.id,staticClass:"col-12 mb-3"},[_c('div',{class:'card rounded shadow status-' + _vm.Status(item.AssinouCCB)},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('span',[_vm._v("ID: "),_c('strong',[_vm._v("#"+_vm._s(_vm.ajustIdOportunidade(item.SolicitacaoId.IdOportunidade,5)))])])]),_vm._v(" "),_c('div',{staticClass:"card-body rounded bg-white"},[_c('div',{staticClass:"row no-gutters align-items-center"},[_c('div',{staticClass:"card-info"},[_c('h4',[_vm._v(_vm._s(_vm.ObterNome(item.SolicitacaoId)))]),_vm._v(" "),_c('span',[_vm._v("CNPJ: "),_c('strong',[_vm._v(_vm._s(_vm.formattedCnpj(item.SolicitacaoId.Documento)))])]),_vm._v(" "),_c('span',[_vm._v("Valor investido: "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(item.Valor)))])]),_vm._v(" "),_c('span',[_vm._v("Prazo: "),_c('strong',[_vm._v(_vm._s(item.SolicitacaoId.Prazo))])])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12"},[(item.AssinouCCB)?_c('router-link',{staticClass:"btn btn-sm btn-primary btn-block font-weight-bold text-uppercase status-deactivate",attrs:{"to":"/investimentos/minhas-ccbs/formalizar/" + item._id}},[_vm._v("Visualizar CCB")]):_vm._e(),_vm._v(" "),(!item.AssinouCCB)?_c('router-link',{staticClass:"btn btn-sm btn-primary btn-block font-weight-bold text-uppercase",attrs:{"to":"/investimentos/minhas-ccbs/formalizar/" + item._id}},[_vm._v("Assinar")]):_vm._e()],1)])])])])}),0)])])]):_vm._e(),_vm._v(" "),(_vm.MeusInvestimentosAll == null || _vm.MeusInvestimentosAll.length == 0)?_c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard"},[_vm._m(2)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("Minhas CCB's")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"align-middle",attrs:{"scope":"col"}},[_vm._v("  ID")]),_vm._v(" "),_c('th',{staticClass:"align-middle",attrs:{"scope":"col"}},[_vm._v("Empresa")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Valor investido")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Prazo")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(" ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard__complete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Minhas CCB's")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+m4H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+oIw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+sT0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InicioQuestionario_vue__ = __webpack_require__("mmm7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36aeddb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InicioQuestionario_vue__ = __webpack_require__("hpPs");
function injectStyle (ssrContext) {
  __webpack_require__("mRyX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36aeddb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InicioQuestionario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36aeddb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InicioQuestionario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+yYx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/01O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/2VA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: this.solicitacao.ArquivosFaturamento || []
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do faturamento é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {
        var newData = {
          ArquivosFaturamento: this.arquivosRecebidos
        };
        this.$emit('on-submit', newData);
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "/4fP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("96tf");




var _this = this;


var BASE_URI_GO_API = "https://api.iouu.com.br" + '/api/v1';

var CreateReservation = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(solicitacaoId, data) {
        var listaEspera = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* default */].AxiosAuthPost(BASE_URI_GO_API + '/reserva/criar/solicitacao/' + solicitacaoId, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data, { listaEspera: listaEspera }));

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function CreateReservation(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

var CreateBoleto = function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(reservaId, data) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* default */].AxiosAuthPost(BASE_URI_GO_API + '/gerarBoleto/' + reservaId, data);

                    case 2:
                        return _context2.abrupt('return', _context2.sent);

                    case 3:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this);
    }));

    return function CreateBoleto(_x4, _x5) {
        return _ref2.apply(this, arguments);
    };
}();

var DeleteReservation = function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id, motivo) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* default */].AxiosAuthDelete(BASE_URI_GO_API + '/reserva/cancelar/' + id, motivo);

                    case 2:
                        return _context3.abrupt('return', _context3.sent);

                    case 3:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this);
    }));

    return function DeleteReservation(_x6, _x7) {
        return _ref3.apply(this, arguments);
    };
}();

var CreateInvestDepositRecord = function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dados) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* default */].AxiosAuthPost(BASE_URI_GO_API + '/reserva/criar/deposito', dados);

                    case 2:
                        return _context4.abrupt('return', _context4.sent);

                    case 3:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, _this);
    }));

    return function CreateInvestDepositRecord(_x8) {
        return _ref4.apply(this, arguments);
    };
}();

var CreateInvestDebtRecord = function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dados) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* default */].AxiosAuthPost(BASE_URI_GO_API + '/reserva/criar/debito', dados);

                    case 2:
                        return _context5.abrupt('return', _context5.sent);

                    case 3:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, _this);
    }));

    return function CreateInvestDebtRecord(_x9) {
        return _ref5.apply(this, arguments);
    };
}();

/* harmony default export */ __webpack_exports__["a"] = ({ CreateReservation: CreateReservation, CreateBoleto: CreateBoleto, DeleteReservation: DeleteReservation, CreateInvestDepositRecord: CreateInvestDepositRecord, CreateInvestDebtRecord: CreateInvestDebtRecord });

/***/ }),

/***/ "/7yn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilesInput_vue__ = __webpack_require__("9QUb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_276c694f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilesInput_vue__ = __webpack_require__("KcDe");
function injectStyle (ssrContext) {
  __webpack_require__("+UOL")
  __webpack_require__("mm4S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-276c694f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilesInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_276c694f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilesInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Cwo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Fak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"nomeCompleto"}},[_vm._v("Nome completo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fullName),expression:"fullName"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":""},domProps:{"value":(_vm.fullName)},on:{"keyup":_vm.AlterarNome,"input":function($event){if($event.target.composing){ return; }_vm.fullName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',[_vm._v("Nome Completo da Mãe")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.Social.NomeCompletoMae),expression:"currentUser.Social.NomeCompletoMae"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":""},domProps:{"value":(_vm.currentUser.Social.NomeCompletoMae)},on:{"keyup":_vm.AlterarNome,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentUser.Social, "NomeCompletoMae", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"DataNascimento"}},[_vm._v("Data de Nascimento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.birthDate),expression:"birthDate"},{name:"mask",rawName:"v-mask",value:('date'),expression:"'date'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"__/__/____","title":"dd/mm/yyyy","required":"","pattern":"\\d{2}/\\d{2}/\\d{4}"},domProps:{"value":(_vm.birthDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.birthDate=$event.target.value}}})]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Nome Completo")]),_vm._v(" "),_c('p',[_vm._v("Agora, por favor, forneça seu "),_c('strong',[_vm._v("Nome completo")]),_vm._v(", sua "),_c('strong',[_vm._v("Data de Nascimento")]),_vm._v(" e o "),_c('strong',[_vm._v("Nome Completo da sua Mãe")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/LYO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_c('div',{staticClass:"tit"},[_c('p',[_vm._v("\n      Declaração completa de Imposto de Renda do último ano para o avalista do empréstimo.\n      "),_c('a',{staticClass:"infos",attrs:{"href":"https://ajuda.iouu.com.br/hc/pt-br/articles/360006108993","target":"_blank"}},[_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Dúvidas? Clique aqui!"}},[_c('i',{staticClass:"fas fa-info-circle"})])],1),_vm._v(" "),_c('br'),_vm._v("\n      Caso haja mais de um avalista acrescente sua declaração de IR.\n    ")])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/MnN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid login"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"ico-iouu",attrs:{"href":_vm.lpUrl,"target":"_blank","title":"IOUU"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('social-network')],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-7 d-flex flex-column form"},[_c('header',{staticClass:"align-self-center align-self-md-end"},[_vm._v("\n        Já tem uma conta?\n          "),_c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":"login"}},[_vm._v("Entrar")])],1),_vm._v(" "),(_vm.visivel)?_c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-5 text-center"},[_c('h2',[_vm._v("Criar uma conta")]),_vm._v(" "),_c('form',{attrs:{"id":"form-contaConvidado"},on:{"submit":function($event){$event.preventDefault();return _vm.signUp($event)}}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","name":"firtname","autofocus":""},domProps:{"value":(_vm.name)},on:{"keyup":function($event){return _vm.validateName()},"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Endereço de email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",attrs:{"type":"email","id":"Email"},domProps:{"value":(_vm.email)},on:{"focusout":_vm.ValidarEmail,"focusin":_vm.RetirarAnimacao,"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Senha")]),_vm._v(" "),_c('password-field',{model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Código de Convite")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.CodConvite),expression:"CodConvite"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.CodConvite)},on:{"input":function($event){if($event.target.composing){ return; }_vm.CodConvite=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-check text-left d-flex justify-content-center"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enabled),expression:"enabled"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.enabled)?_vm._i(_vm.enabled,null)>-1:(_vm.enabled)},on:{"change":function($event){var $$a=_vm.enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.enabled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.enabled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.enabled=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_c('label',{staticClass:"form-check-label p-0"},[_vm._v("\n                  Eu \"CONCORDO\" com os "),_c('a',{attrs:{"href":_vm.lpUrl+'/termos-e-condicoes/',"target":"_blank"}},[_vm._v("Termos e condições")]),_vm._v(" e "),_c('a',{attrs:{"href":_vm.lpUrl+'/politica-de-privacidade/',"target":"_blank"}},[_vm._v("Política de privacidade")]),_vm._v(" da IOUU.\n                ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":!_vm.enabled || !_vm.EmailConfirmado}},[_vm._v("Continuar")])])])]):_vm._e(),_vm._v(" "),(!_vm.visivel)?_c('div',{staticClass:"row justify-content-center d-flex align-items-center aviso"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 text-center"},[_c('h2',[_vm._v("Qual perfil deseja criar?")]),_vm._v(" "),_c('div',{staticClass:"align-self-center"},[_c('a',{staticClass:"btn btn-lg btn-primary",attrs:{"href":_vm.lpUrl+'/tipo-de-emprestimo/'}},[_c('span',[_vm._v("Empréstimo")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",on:{"click":function($event){_vm.visivel = !_vm.visivel}}},[_c('span',[_vm._v("Investimento")])])])])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-lg-10 d-flex flex-column align-items-center"},[_c('h1',[_vm._v("Crie sua conta")]),_vm._v(" "),_c('p',[_vm._v("\n              Não se preocupe. Você não está assumindo nenhum compromisso neste momento.\n              "),_c('br'),_vm._v("Suas informações serão usadas apenas para analisarmos o seu perfil\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.\n            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validacao"},[_c('i',{staticClass:"invalido fas fa-exclamation-circle",attrs:{"hidden":"","id":"IconeInvalido"}}),_vm._v(" "),_c('i',{staticClass:"valido fas fa-check",attrs:{"hidden":"","id":"IconeValido"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/aHm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types_js__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lpUrl: "https://iouu.com.br"
    };
  },

  methods: {
    Logout: function Logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    Home: function Home() {
      sessionStorage.removeItem("redirectINV");
      this.$router.push('/');
    }
  }, beforeCreate: function beforeCreate() {

    window.document.title = 'Dashboard IOUU';
  }
});

/***/ }),

/***/ "/j53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletAddCash_vue__ = __webpack_require__("HGJr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2558043c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletAddCash_vue__ = __webpack_require__("4bJZ");
function injectStyle (ssrContext) {
  __webpack_require__("VW/F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2558043c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletAddCash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2558043c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletAddCash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/j5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social"},[_c('a',{staticClass:"fa-stack fa",attrs:{"href":"https://www.facebook.com/IouuBrasil/","target":"_blank","title":"Facebook"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-facebook-f fa-stack-1x"})]),_vm._v(" "),_c('a',{staticClass:"fa-stack fa",attrs:{"href":"https://twitter.com/iouubrasil","target":"_blank","title":"Twitter"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-twitter fa-stack-1x"})]),_vm._v(" "),_c('a',{staticClass:"fa-stack fa",attrs:{"href":"https://www.linkedin.com/company/iouu","target":"_blank","Title":"Linkedin"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-linkedin-in fa-stack-1x"})]),_vm._v(" "),_c('a',{staticClass:"fa-stack fa",attrs:{"href":"https://vimeo.com/iouubrasil","target":"_blank","title":"Instagram"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-instagram fa-stack-1x"})]),_vm._v(" "),_c('a',{staticClass:"fa-stack fa",attrs:{"href":"https://www.instagram.com/iouubrasil/","target":"_blank","title":"Vimeo"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-vimeo-v fa-stack-1x"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/jo7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center user-profile ccbs"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[_c('h2',[_vm._v("Lista de CCB’s")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.reservas),function(pag,index){return _c('tr',{key:pag._id},[_c('th',{staticClass:"align-middle",attrs:{"scope":"row"}},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('span',{staticClass:"d-flex align-items-center"},[_c('img',{attrs:{"src":"/static/assets/images/ico-pdf.png","alt":"icone ccb"}}),_vm._v(" "),_c('small',[_vm._v(_vm._s(pag.CodigoBMP))])])]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('a',{staticClass:"btn btn-sm btn-link",attrs:{"href":_vm.CCB_URL+"/imprimirccb.aspx?code="+pag.CodigoBMP+"&copias=1","target":"_blank","title":"Visualizar CCB"}},[_vm._v("Visualizar")])])])}),0)])])]),_vm._v(" "),_c('aside',{staticClass:"col-12 col-md-4 text-center"},[_c('div',{staticClass:"box p-3 p-md-4"},[(_vm.passo == 1)?_c('form',[_c('h5',{staticClass:"text"},[_vm._v("Para assinar todas as CCB's clique no botão abaixo.")]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Por favor insira o token que foi enviado para o seu email para finalizar as assinaturas de suas CCB's.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.token),expression:"token"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Digite seu token aqui"},domProps:{"value":(_vm.token)},on:{"input":function($event){if($event.target.composing){ return; }_vm.token=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",on:{"click":function($event){$event.preventDefault();return _vm.AssinarCCB()}}},[_vm._v("Assinar")])]):_vm._e(),_vm._v(" "),(_vm.passo == 2)?_c('div',{staticClass:"box-confirm"},[_c('img',{attrs:{"src":"/static/assets/images/icon-success.svg","alt":"icone ok"}}),_vm._v(" "),_c('h5',[_vm._v("Sua CCB foi assinada com sucesso!")])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 pb-5 text-center"},[_c('img',{staticClass:"mb-4 icon-assinatura",attrs:{"src":"/static/assets/images/ico-assinatura-ccb.svg","alt":"icone assinatura"}}),_vm._v(" "),_c('h1',[_vm._v("Visualize e assine!")]),_vm._v(" "),_c('p',[_vm._v("Veja e assine as CCB's relativas a solicitação de empréstimo de sua empresa.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/kg9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container"},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":120,"width":120},on:{"animCreated":_vm.handleAnimation}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/mNV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/nly":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/o5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f31ba09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__("06gx");
function injectStyle (ssrContext) {
  __webpack_require__("MAPa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f31ba09"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f31ba09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/p5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"celular"}},[_vm._v("Telefone celular")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.celular),expression:"celular"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"},{name:"focus",rawName:"v-focus"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Celular","required":""},domProps:{"value":(_vm.celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.celular=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{staticClass:"float-left",attrs:{"for":"telefoneComercial"}},[_vm._v("Telefone comercial")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.telefoneComercial),expression:"telefoneComercial"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Telefone Comercial"},domProps:{"value":(_vm.telefoneComercial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.telefoneComercial=$event.target.value}}})]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Ótimo! Agora preciso do seu "),_c('strong',[_vm._v("número de celular")]),_vm._v(" e "),_c('strong',[_vm._v("telefone comercial")]),_vm._v(".")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/pfM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid login"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-5 col-lg-5 d-flex align-items-center flex-column info"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"ico-iouu",attrs:{"href":_vm.lpUrl,"target":"_blank","title":"IOUU"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('social-network')],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-7 col-lg-7 d-flex flex-column form"},[(!this.verifyIE11())?_c('header',{staticClass:"align-self-center align-self-md-end"},[_vm._v("\n        Não tem uma conta?\n        "),_c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":"criar-conta"}},[_vm._v("Criar conta")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[(this.verifyIE11())?_c('div',{staticClass:"col-12 col-md-8 col-lg-6 text-center browser-alert"},[_c('h3',[_vm._v("Melhore sua experiência")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),(!this.verifyIE11())?_c('div',{staticClass:"col-12 col-md-8 col-lg-5 text-center"},[_c('h2',[_c('span',{staticClass:"greeting"},[_vm._v(_vm._s(_vm.greeting)+" :)")]),_vm._v("Acesse sua conta")]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-justified align-self-center ",attrs:{"role":"group","aria-label":"Large button group"}},[_c('button',{staticClass:"btn btn-lg btn-secondary facebook",attrs:{"id":"fb-signin-button"},on:{"click":_vm.facebookLogin}},[_vm._m(3)]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"inputEmail"}},[_vm._v("Endereço de email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",attrs:{"id":"inputEmail","type":"email","autofocus":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('div',{staticClass:"password-field-container"},[_c('label',{staticClass:"float-left",attrs:{"for":"inputPassword"}},[_vm._v("Senha")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted float-right"},[_c('router-link',{attrs:{"to":"recuperar-senha","title":"Esqueceu sua senha?","tabindex":"-1"}},[_vm._v("Esqueceu sua senha?")])],1)]),_vm._v(" "),_c('password-field',{model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('div',{staticClass:"form-check text-left d-flex justify-content-left"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keepLogged),expression:"keepLogged"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.keepLogged)?_vm._i(_vm.keepLogged,null)>-1:(_vm.keepLogged)},on:{"change":function($event){var $$a=_vm.keepLogged,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.keepLogged=$$a.concat([$$v]))}else{$$i>-1&&(_vm.keepLogged=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.keepLogged=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_c('label',{staticClass:"form-check-label p-0"},[_vm._v("\n                Permanecer conectado\n              ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"id":"buttonLogin"}},[_vm._v("Entrar")])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-lg-10 d-flex flex-column align-items-center"},[_c('h1',[_vm._v("Acessar conta")]),_vm._v(" "),_c('p',[_vm._v("\n            Não se preocupe. Você não está assumindo nenhum compromisso neste momento.\n            "),_c('br'),_vm._v("Suas informações serão usadas apenas para analisarmos o seu perfil\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.\n          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Você está usando um navegador da Web que não suportamos."),_c('br'),_vm._v("\n            Experimente uma destas opções para ter uma melhor experiência na IOUU.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.mozilla.org/pt-BR/firefox/download/","target":"_blank","title":"Baixar última versão Mozilla Firefox"}},[_c('img',{attrs:{"src":"/static/assets/images/browser/firefox.png","alt":"Ícone Mozilla Firefox"}}),_vm._v(" "),_c('span',[_vm._v("Mozila Firefox")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.google.com/chrome/","target":"_blank","title":"Baixar última versão Google Chrome"}},[_c('img',{attrs:{"src":"/static/assets/images/browser/google-chrome.png","alt":"Ícone Google Chrome"}}),_vm._v(" "),_c('span',[_vm._v("Google Chrome")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.microsoft.com/pt-br/windows/microsoft-edge","target":"_blank","title":"Baixar última versão Microsoft Edge"}},[_c('img',{attrs:{"src":"/static/assets/images/browser/edge.png","alt":"Ícone Edge"}}),_vm._v(" "),_c('span',[_vm._v("Microsoft Edge")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fab fa-facebook-f"}),_vm._v(" Facebook")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-lg btn-secondary google",attrs:{"id":"gg-signin-button"}},[_c('span',[_c('i',{staticClass:"fab fa-google"}),_vm._v(" Google")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/pnt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    submitWithCorporateGroup: function submitWithCorporateGroup() {

      this.currentUser.Social.OutrosEmprestimos = true;

      this.$emit('on-submit', { Social: this.currentUser.Social });
    },
    submitWithoutCorporateGroup: function submitWithoutCorporateGroup() {

      this.currentUser.Social.OutrosEmprestimos = false;

      this.$emit('on-submit', { Social: this.currentUser.Social });
    }
  }
});

/***/ }),

/***/ "/rZg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlankLayout_vue__ = __webpack_require__("K7y6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44b31e23_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlankLayout_vue__ = __webpack_require__("axQb");
function injectStyle (ssrContext) {
  __webpack_require__("0ibb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44b31e23"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlankLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44b31e23_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlankLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/rcy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoEnvioComprovanteResidencia_vue__ = __webpack_require__("mmRC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d26900e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoEnvioComprovanteResidencia_vue__ = __webpack_require__("IISa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoEnvioComprovanteResidencia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d26900e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoEnvioComprovanteResidencia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/vPs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmacaoIdentidadePasso_vue__ = __webpack_require__("uw+F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53946da7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmacaoIdentidadePasso_vue__ = __webpack_require__("cea8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmacaoIdentidadePasso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53946da7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmacaoIdentidadePasso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/xRc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CCBLoan_vue__ = __webpack_require__("IL8g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5230e8bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CCBLoan_vue__ = __webpack_require__("443W");
function injectStyle (ssrContext) {
  __webpack_require__("XaRt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5230e8bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CCBLoan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5230e8bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CCBLoan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "06gx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container company-view"},[_c('div',{staticClass:"modal-header"},[_vm._t("header"),_vm._v(" "),_c('div',{staticClass:"float-right"},[_c('a',{staticClass:"btn-exit",on:{"click":function($event){return _vm.$emit('close')}}},[_c('img',{attrs:{"src":"/static/assets/images/ico-close.svg","alt":"Icone fechar"}})])])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",[_vm._v("\n\t\t\t\t\t\tdefault body\n\t\t\t\t\t")])],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0ACJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AddressForm__ = __webpack_require__("fs42");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { AddressForm: __WEBPACK_IMPORTED_MODULE_0__components_AddressForm__["a" /* default */] },
  props: {
    investor: { type: Object, required: true }
  },
  computed: {
    address: function address() {
      var address = this.investor.Endereco || {};
      return {
        zipcode: address.Cep,
        neighborhood: address.Bairro,
        complement: address.Complemento,
        street: address.Logradouro,
        number: address.Numero,
        state: address.Uf,
        city: address.Cidade
      };
    }
  },
  methods: {
    handleSubmit: function handleSubmit(formData) {
      this.$emit('submit', {
        Endereco: {
          Cep: formData.zipcode,
          Bairro: formData.neighborhood,
          Complemento: formData.complement,
          Logradouro: formData.street,
          Numero: formData.number,
          Uf: formData.state,
          Cidade: formData.city
        }
      });
    }
  }
});

/***/ }),

/***/ "0Do8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0KSN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		data: {
			required: true,
			type: Array
		}
	},
	extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
	mounted: function mounted() {
		// Overwriting base render method with actual data.
		this.renderChart({
			labels: this.data.map(function (item) {
				return item.label;
			}),
			datasets: [{
				label: 'Faturamento',
				fill: false,
				backgroundColor: '#2F2F4F',
				data: this.data.map(function (item) {
					var value = item.value;
					return value;
				}).concat([0])
			}]
		}, {
			responsive: true,
			maintainAspectRatio: false,
			tooltips: {
				enabled: true,
				mode: 'single',
				callbacks: {
					label: function label(tooltipItems) {
						return 'R$ ' + tooltipItems.yLabel.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
					}
				}
			}
		});
	}
});

/***/ }),

/***/ "0KfO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Operacoes_Pagamento__ = __webpack_require__("D5Wh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Operacoes_Transferencia__ = __webpack_require__("O9NW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Operacoes_Deposito__ = __webpack_require__("ZKAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Operacoes_Extorno__ = __webpack_require__("a51p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Operacoes_Investimento__ = __webpack_require__("gCFQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		ComponentePagamento: __WEBPACK_IMPORTED_MODULE_0__Operacoes_Pagamento__["a" /* default */],
		ComponenteTransferencia: __WEBPACK_IMPORTED_MODULE_1__Operacoes_Transferencia__["a" /* default */],
		ComponenteDeposito: __WEBPACK_IMPORTED_MODULE_2__Operacoes_Deposito__["a" /* default */],
		ComponenteExtorno: __WEBPACK_IMPORTED_MODULE_3__Operacoes_Extorno__["a" /* default */],
		ComponenteInvestimento: __WEBPACK_IMPORTED_MODULE_4__Operacoes_Investimento__["a" /* default */]
	},

	props: {
		operacao: { type: Object }
	},

	data: function data() {
		return {
			alterado: false
		};
	}
});

/***/ }),

/***/ "0Nme":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0OJJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('p',[_vm._v("Comprovante de residência do(s) sócio(s) (validade de no máximo 3 meses)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0OZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showPassword: false
    };
  },

  props: ['value'],
  methods: {
    updateValue: function updateValue(value) {
      this.$emit('input', value);
    },
    toggleShowPassword: function toggleShowPassword() {
      this.showPassword = !this.showPassword;
    }
  }
});

/***/ }),

/***/ "0R8B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_0_vue_select___default.a
  },
  data: function data() {
    return {
      optionsMarital: [{ value: 1, label: 'Solteira(o)' }, { value: 2, label: 'Casada(o)' }, { value: 4, label: 'Divorciada(o)' }, { value: 5, label: 'Viúva(o)' }]
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = { Pessoal: this.currentUser.Pessoal };
      this.$emit('on-submit', newData);
    }
  },
  mounted: function mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");
  }
});

/***/ }),

/***/ "0c8x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0ibb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0ixW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationLayout_vue__ = __webpack_require__("uUwL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06e91b83_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationLayout_vue__ = __webpack_require__("I9Nb");
function injectStyle (ssrContext) {
  __webpack_require__("kbL5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06e91b83"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06e91b83_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0jXR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__("KFIQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04cdaa08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__("dCMv");
function injectStyle (ssrContext) {
  __webpack_require__("8dkd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04cdaa08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04cdaa08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0kls":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard"},[_c('div',{staticClass:"dashboard__complete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Em Construção")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "11Po":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Darf_vue__ = __webpack_require__("zGMT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1309c37e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Darf_vue__ = __webpack_require__("at0S");
function injectStyle (ssrContext) {
  __webpack_require__("gEyh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1309c37e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Darf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1309c37e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Darf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "138M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnderecoStep_vue__ = __webpack_require__("UdT0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_647ade70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnderecoStep_vue__ = __webpack_require__("1Ler");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnderecoStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_647ade70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnderecoStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "14kb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScholarityStep_vue__ = __webpack_require__("Iizq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51ef30db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScholarityStep_vue__ = __webpack_require__("pGKU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScholarityStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51ef30db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScholarityStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "17al":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactsStep_vue__ = __webpack_require__("S2Fg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a092d6d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactsStep_vue__ = __webpack_require__("gbsL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactsStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a092d6d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactsStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1EOR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__("5dBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_masker__ = __webpack_require__("7VWg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var social = this.currentUser.Social;
    return {
      hasOtherIncomeSources: true,
      extra: social && social.ValorOutraFonteRenda ? social.ValorOutraFonteRenda.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }) : null
    };
  },

  computed: {
    RendaValida: function RendaValida() {
      return parseFloat(this.extra) <= 0;
    }
  },
  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    noHaveOther: function noHaveOther() {
      if (document.getElementById("noOther").checked) {
        document.getElementById("extra").removeAttribute("required", "");
        this.hasOtherIncomeSources = false;
      } else {
        document.getElementById("extra").setAttribute("required", "");
        this.hasOtherIncomeSources = true;
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      if (this.hasOtherIncomeSources) {
        this.currentUser.Social.OutraFonteRenda = true;
        this.currentUser.Social.ValorOutraFonteRenda = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].unmaskMoney(this.extra));
      } else {
        this.currentUser.Social.OutraFonteRenda = false;
        this.currentUser.Social.ValorOutraFonteRenda = 0.0;
      }

      this.$emit('on-submit', { Social: this.currentUser.Social });
    }
  },
  mounted: function mounted() {
    if (!this.currentUser.Social.OutraFonteRenda) {
      document.getElementById('noOther').click();
    }
  }
});

/***/ }),

/***/ "1IUG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1L8O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationScreenForm_vue__ = __webpack_require__("40xQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99a904a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationScreenForm_vue__ = __webpack_require__("qSzJ");
function injectStyle (ssrContext) {
  __webpack_require__("U6Hp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-99a904a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationScreenForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99a904a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationScreenForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1LI0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{staticClass:"float-left"},[_vm._v("Lucro Mensal")]),_vm._v(" "),_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.lucroMensal),expression:"lucroMensal"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":"","placeholder":"R$"},domProps:{"value":(_vm.lucroMensal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lucroMensal=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":_vm.lucroValido}},[_vm._v("Próximo"),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Quanto sua empresa lucra por mês?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Ler":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-10 col-xl-10"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"cep"}},[_vm._v("CEP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cep),expression:"cep"},{name:"mask",rawName:"v-mask",value:('zipcode'),expression:"'zipcode'"},{name:"focus",rawName:"v-focus"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","pattern":"\\d{5}-?\\d{3}","placeholder":"CEP","required":""},domProps:{"value":(_vm.cep)},on:{"change":_vm.aoMudarCep,"input":function($event){if($event.target.composing){ return; }_vm.cep=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Endereço")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.logradouro),expression:"logradouro"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Logradouro","disabled":_vm.estaBuscandoEndereco,"required":""},domProps:{"value":(_vm.logradouro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.logradouro=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-2"},[_c('label',{attrs:{"for":"inputPassword4"}},[_vm._v("Número")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numero),expression:"numero"},{name:"mask",rawName:"v-mask",value:('integer'),expression:"'integer'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","pattern":"\\d+","title":"Números apenas","placeholder":"Nº","disabled":_vm.estaBuscandoEndereco,"required":""},domProps:{"value":(_vm.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numero=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"complemento"}},[_vm._v("Complemento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complemento),expression:"complemento"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Complemento","disabled":_vm.estaBuscandoEndereco},domProps:{"value":(_vm.complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.complemento=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"bairro"}},[_vm._v("Bairro")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bairro),expression:"bairro"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Bairro","disabled":_vm.estaBuscandoEndereco,"required":""},domProps:{"value":(_vm.bairro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bairro=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"estado"}},[_vm._v("Estado")]),_vm._v(" "),_c('at-select',{ref:"stateSelect",attrs:{"filterable":"","size":"large","placeholder":_vm.placeholderEstado,"disabled":_vm.estaEstadoDesabilitado},on:{"on-change":_vm.onUfChange},model:{value:(_vm.uf),callback:function ($$v) {_vm.uf=$$v},expression:"uf"}},_vm._l((_vm.estados),function(state,i){return _c('at-option',{key:("stateOptions" + i),attrs:{"value":state.uf}},[_vm._v(_vm._s(state.nome))])}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"cidade"}},[_vm._v("Cidade")]),_vm._v(" "),_c('at-select',{ref:"citySelect",attrs:{"filterable":"","size":"large","placeholder":_vm.placeholderCidade,"disabled":_vm.estaCidadeDesabilitado},model:{value:(_vm.cidade),callback:function ($$v) {_vm.cidade=$$v},expression:"cidade"}},_vm._l((_vm.cidades),function(city,i){return _c('at-option',{key:("cityOptions" + i),attrs:{"value":city.nome}},[_vm._v(_vm._s(city.nome))])}),1)],1)]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Qual é o seu endereço?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1SP8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10 col-xl-10"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-10 col-xl-10"},[_c('div',{staticClass:"tit text-center"},[_c('img',{staticStyle:{"margin-bottom":"40px","width":"60px"},attrs:{"src":"/static/assets/images/ico-complete.svg","alt":"icone arquivo"}}),_vm._v(" "),_c('h1',[_c('span',[_vm._v("Seu perfil de investimento é:")]),_vm._v(" "+_vm._s(_vm.suitability.Tipo)+"\n                ")]),_vm._v(" "),_c('div',[_c('p',{staticClass:"nome"},[_vm._v("\n                        Parabéns, "),_c('strong',[_vm._v(_vm._s(_vm.suitability.Nome))]),_vm._v(".\n                    ")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.texto)}}),_vm._v(" "),_c('p',{staticClass:"obs"},[_vm._v("\n                        Juntos vamos reinventar o sistema bancário ultrapassado e garantir um melhor negócio para todos.\n                    ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-lg btn-primary",attrs:{"to":"/investimentos/oportunidades","title":"Oportunidades abertas"}},[_vm._v("Oportunidades abertas "),_c('img',{attrs:{"src":"/static/assets/images/angle-right.svg"}})])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1St1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-7 text-center"},[_c('div',{staticClass:"tit"},[_c('p',[_vm._v("A(O) "),_c('strong',[_vm._v(_vm._s(_vm.razaoSocial))]),_vm._v(" possui inscrição estadual?")])]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.submitWithCorporateGroup}},[_vm._v("Sim")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.submitWithoutCorporateGroup}},[_vm._v("Não")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1UsZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-center suitability-link-container"},[_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":"/informacoes-adicionais/suitabilityVerify","title":"Preencher formulário de suitability"}},[_vm._v("Preencher Formulário de Suitability")])],1),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('img',{attrs:{"src":"/static/assets/images/ico-smile.svg","alt":"Icone feliz"}}),_vm._v(" "),_c('h1',[_vm._v("Cadastro Concluído com sucesso")]),_vm._v(" "),_c('p',[_vm._v("Agora, faremos uma análise e em até 24 horas você receberá uma resposta.")]),_vm._v(" "),_c('p',[_vm._v("Ah, não esqueça de preencher o formulário de suitability, ele é muito importante para mapear o seu perfil de investimento e indicarmos os produtos, serviços e operações mais adequadas às suas necessidades.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})]),_vm._v(" "),_c('p',{staticClass:"nome"},[_vm._v("Obrigado por nos escolher!")]),_vm._v(" "),_c('p',{staticClass:"obs"},[_vm._v("Juntos vamos reinventar o sistema bancário ultrapassado e garantir um melhor negócio para todos.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1g+n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TributationStep_vue__ = __webpack_require__("O6j8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7097e4dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TributationStep_vue__ = __webpack_require__("60mX");
function injectStyle (ssrContext) {
  __webpack_require__("VlBd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7097e4dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TributationStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7097e4dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TributationStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1gDh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoDadosBancarios_vue__ = __webpack_require__("vp1w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db5555f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoDadosBancarios_vue__ = __webpack_require__("E5c1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoDadosBancarios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db5555f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoDadosBancarios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1kkP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1mim":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NewModal_Modal__ = __webpack_require__("L6+9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_OpportunityCard__ = __webpack_require__("7Liv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_OpportunitiesList__ = __webpack_require__("oN8B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Pagination__ = __webpack_require__("cMGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_api_client_go__ = __webpack_require__("879M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_array_helper__ = __webpack_require__("rzJh");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */










/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			showCards: sessionStorage.getItem('showCards') == '' ? false : true,
			showModal: false,
			oportunidades: [],
			scoreFiltrado: [],
			filterOportunidades: [],
			filterAux: [],
			investidor: {},
			indexPage: 1,
			Paginas: 0,
			InvestorAprovado: false,
			oportunidadesEmBreve: false,
			temCadastroInvestidor: false,
			temSuitability: false,
			investidorAprovado: false,
			User: null,
			solicitacao: null,
			bloqueio: '',
			// Scores selecionados
			arrScore: ["AA", "A", "B", "C", "D", "E", "HR"],
			// Scores removidos
			arrFiltroScore: [],
			strScoreFilter: [{
				"score": "AA",
				"status": true
			}, {
				"score": "A",
				"status": true
			}, {
				"score": "B",
				"status": true
			}, {
				"score": "C",
				"status": true
			}, {
				"score": "D",
				"status": true
			}, {
				"score": "E",
				"status": true
			}, {
				"score": "HR",
				"status": true
			}]
		};
	},

	methods: {
		// Requests
		listaOportunidades: function listaOportunidades() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
				var _oportunidades, stringScore, resp, oportunidades, publicados;

				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;

								_this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["c" /* START_LOADING */]);

								stringScore = _this.arrScore.join("-");
								_context.next = 5;
								return __WEBPACK_IMPORTED_MODULE_12__utils_api_client_go__["a" /* default */].ListarOportunidades(_this.indexPage, stringScore);

							case 5:
								resp = _context.sent;

								_this.Paginas = resp.Paginas;
								oportunidades = _this.TrataOportunidades(resp.ItemListagemSolicitacoes);

								if (!(oportunidades == null)) {
									_context.next = 11;
									break;
								}

								_this.oportunidadesEmBreve = true;
								return _context.abrupt("return", []);

							case 11:

								// Ordena Publicados
								publicados = _this.pegaPublicados(oportunidades);

								oportunidades = _this.removePublicados(oportunidades);
								_this.porcentagemSort(publicados);
								(_oportunidades = oportunidades).unshift.apply(_oportunidades, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(publicados));

								_this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);

								return _context.abrupt("return", oportunidades);

							case 19:
								_context.prev = 19;
								_context.t0 = _context["catch"](0);

								console.log(_context.t0);
								_this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
								return _context.abrupt("return", []);

							case 24:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this, [[0, 19]]);
			}))();
		},
		pegaSolicitacao: function pegaSolicitacao(id) {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var resp, solicitacao;
				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.prev = 0;

								_this2.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["c" /* START_LOADING */]);
								_context2.next = 4;
								return __WEBPACK_IMPORTED_MODULE_12__utils_api_client_go__["a" /* default */].oportunidadePorId(id);

							case 4:
								resp = _context2.sent;

								_this2.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);

								solicitacao = resp.data.Solicitacao;
								// Lista de espera

								solicitacao.ChamadaListaEspera ? solicitacao.ValorCaptado = solicitacao.Valor : '';
								// Encerrada
								solicitacao.Encerrado = solicitacao.StatusAnalise == "ENCERRADO" || _this2.diffDate(solicitacao.FimCaptacao) == "encerrado";
								// Score
								//solicitacao.Score = this.pegaScore(solicitacao)

								return _context2.abrupt("return", solicitacao);

							case 12:
								_context2.prev = 12;
								_context2.t0 = _context2["catch"](0);

								console.log(_context2.t0);
								_this2.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
								return _context2.abrupt("return", null);

							case 17:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this2, [[0, 12]]);
			}))();
		},


		// Interacao Modal
		setCards: function setCards() {
			sessionStorage.setItem('showCards', true);
			this.showCards = sessionStorage.getItem('showCards');
		},
		unsetCards: function unsetCards() {
			sessionStorage.setItem('showCards', '');
			this.showCards = sessionStorage.getItem('showCards');
		},
		mudarOportunidade: function mudarOportunidade(item) {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return _this3.pegaSolicitacao(item._id);

							case 2:
								_this3.solicitacao = _context3.sent;

								_this3.solicitacao.Garantia = item.Garantia;
								_this3.AbrirModal(true);

							case 5:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		AbrirModal: function AbrirModal(isAbrir) {
			// função de ajuste emergencial no css
			isAbrir ? document.querySelector('.main-content').style.zIndex = 10 : document.querySelector('.main-content').style.zIndex = 2;

			if (document.getElementsByTagName("main").length > 0) {
				if (isAbrir) document.getElementsByTagName("main")[0].style.zIndex = "50";else document.getElementsByTagName("main")[0].style.zIndex = "0";
			}

			this.showModal = isAbrir;
		},
		voltar: function voltar() {
			var _this4 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_this4.AbrirModal(false);
								_context4.next = 3;
								return _this4.listaOportunidades();

							case 3:
								_this4.oportunidades = _context4.sent;

							case 4:
							case "end":
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))();
		},


		// Filtro de oportunidade
		scoreAll: function scoreAll(e) {
			var _this5 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
				var score;
				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								// FILTRO DE TODOS OS SCORES
								_this5.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["c" /* START_LOADING */]);

								for (score in _this5.strScoreFilter) {
									// Seleciona ou nao os checkbox das cores do filtros
									_this5.$refs[_this5.strScoreFilter[score].score].checked = e.target.checked;
									// salva guarda os scores
									if (e.target.checked) {
										_this5.arrFiltroScore = [];
										_this5.arrScore.push(_this5.$refs[_this5.strScoreFilter[score].score].id);
									} else {
										_this5.arrFiltroScore.push(_this5.$refs[_this5.strScoreFilter[score].score].id);
										_this5.arrScore = [];
									}
								}
								// Verifica qual valor
								// Se false - zera o filtro
								// Se true - volta todos os filtros
								_this5.arrFiltroScore = [];

								if (!e.target.checked) {
									_context5.next = 9;
									break;
								}

								_context5.next = 6;
								return _this5.listaOportunidades();

							case 6:
								_this5.oportunidades = _context5.sent;
								_context5.next = 10;
								break;

							case 9:
								_this5.oportunidades = [];

							case 10:

								_this5.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);

							case 11:
							case "end":
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		scoreClick: function scoreClick(e, scoreValue) {
			var _this6 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
				var publicados;
				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								//Filtro individual
								publicados = [];

								if (e.target.checked) {
									_this6.arrFiltroScore = _this6.arrFiltroScore.filter(function (elemento) {
										return elemento != scoreValue;
									});
									_this6.arrScore.push(scoreValue);
								} else {
									_this6.arrFiltroScore.push(scoreValue);
									_this6.arrScore = _this6.arrScore.filter(function (elemento) {
										return elemento != scoreValue;
									});
								}

								if (!(_this6.arrFiltroScore.length < 7)) {
									_context6.next = 8;
									break;
								}

								_context6.next = 5;
								return _this6.listaOportunidades();

							case 5:
								_this6.oportunidades = _context6.sent;
								_context6.next = 9;
								break;

							case 8:
								_this6.oportunidades = [];

							case 9:
							case "end":
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))();
		},

		// Paginacao
		paginacao: function paginacao(rota) {
			var _this7 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								_this7.indexPage = rota + 1;
								_context7.next = 3;
								return _this7.listaOportunidades();

							case 3:
								_this7.oportunidades = _context7.sent;

							case 4:
							case "end":
								return _context7.stop();
						}
					}
				}, _callee7, _this7);
			}))();
		},

		// Tratativa de dados
		TrataOportunidades: function TrataOportunidades(oportunidades) {
			for (var i = 0; i < oportunidades.length; i++) {
				var oportunidade = oportunidades[i];
				// Lista de espera
				oportunidade.ChamadaListaEspera ? oportunidade.ValorCaptado = oportunidade.Valor : '';
				// Encerrada
				oportunidade.Encerrado = oportunidade.StatusAnalise == "ENCERRADO" || this.diffDate(oportunidade.FimCaptacao) == "encerrado";
				// Score
				oportunidade.Score = this.pegaScore(oportunidade);
			}
			return oportunidades;
		},
		pegaScore: function pegaScore(item) {
			if (item.Score === "AA" || item.Score === "HR") {
				return item.Score;
			} else if (typeof item.Score != "undefined") {
				var spliter = item.Score.split("");
				return spliter[0];
			}
			return 'excessao';
		},
		removePublicados: function removePublicados(arr) {
			var remove = [];
			for (var index = 0; index < arr.length; index++) {
				arr[index].StatusAnalise == 'PUBLICADO' && this.diffDate(arr[index].FimCaptacao) != "encerrado" ? remove.unshift(index) : '';
			}
			remove.forEach(function (element) {
				arr.splice(element, 1);
			});
			return arr;
		},
		pegaPublicados: function pegaPublicados(arr) {
			var publicado = [];
			for (var i = 0; i < arr.length; i++) {
				if (arr[i].StatusAnalise == 'PUBLICADO' && this.diffDate(arr[i].FimCaptacao) != "encerrado") {
					var porcentagem = arr[i].ValorCaptado / arr[i].Valor * 100;
					publicado.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, arr[i], { porcentagem: porcentagem }));
				}
			}
			return publicado;
		},
		porcentagemSort: function porcentagemSort(arr) {
			var swapped = void 0;
			do {
				swapped = false;
				for (var i = 0; i < arr.length - 1; i++) {
					if (arr[i].porcentagem > arr[i + 1].porcentagem) {
						var temp = arr[i];
						arr[i] = arr[i + 1];
						arr[i + 1] = temp;
						swapped = true;
					}
				}
			} while (swapped);
			return arr;
		},


		// Metodos Modal
		diffDate: function diffDate(d2) {
			var miliSecs = new Date(d2) - new Date();

			var diffDays = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(miliSecs / 1000 / 60 / 60 / 24) + 1;

			if (diffDays <= 0) return "encerrado";

			return diffDays + " dias";
		},
		ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
			var s = String(id);
			while (s.length < (qtd || 2)) {
				s = "0" + s;
			}
			return s;
		},
		formatarScore: function formatarScore(score) {
			if (score.length > 1 && !isNaN(score[1])) {
				return score[0];
			}

			return score;
		},
		formatarTipoEmprestimo: function formatarTipoEmprestimo(tipoEmprestimo) {
			if (tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2") {
				return "Impacto";
			}

			var splitedTipoEmprestimo = tipoEmprestimo.split('-');

			if (splitedTipoEmprestimo.length > 1) {
				if (splitedTipoEmprestimo[1] == "ccb") return splitedTipoEmprestimo[1].toUpperCase();

				return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
			}

			return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);
		},
		money: function money(n) {
			var c = 2,
			    d = ",",
			    t = ".",
			    s = n < 0 ? "-" : "",
			    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
			    j = (j = i.length) > 3 ? j % 3 : 0;
			return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
		},
		inteiro: function inteiro(n) {
			return parseInt(n = Math.abs(Number(n) || 0).toFixed(2));
		},
		levantado: function levantado(oportunidade) {
			var val = oportunidade.ValorCaptado / oportunidade.Valor * 100 || 0.00;
			return val < 100.00 ? val : 100.00;
		},
		faltam: function faltam(oportunidade) {
			var val = oportunidade.Valor - oportunidade.ValorCaptado;
			return val >= 0 ? val : 0;
		},
		valor: function valor(_valor) {
			if (_valor == null || _valor == undefined) _valor = 0;
			return this.money(_valor);
		},
		templateRender: function templateRender(item) {
			if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item.InicioCaptacao) === "object") {
				item.InicioCaptacao = item.InicioCaptacao.toISOString();
			}
			var separete = item.InicioCaptacao.split("T");
			var spliter = separete[0].split("-");

			// Verifica qual é o template do perfil da empresa que sera renderizado
			// novo perfil a partir de 08/2018
			if (parseInt(spliter[0]) == 2018 && parseInt(spliter[1]) >= 8 || parseInt(spliter[0]) > 2018) {
				return '/investimentos/oportunidades/perfil-empresa/' + item._id + "#" + this.indexPage;
			}

			return '/investimentos/oportunidades/perfil-empresa-old/' + item._id + "#" + this.indexPage;
		},
		lowerCase: function lowerCase(texto) {
			if (texto == null || texto == undefined) return "";

			if (texto == "AA" || texto == "HR") return texto.toLowerCase();

			return texto.substr(0, 1).toLowerCase();
		},
		InvestidorBloqueado: function InvestidorBloqueado() {
			if (this.investidor == null || this.investidor.Bloqueio == null || this.investidor.Bloqueio.FimBloqueio == null) return false;

			var FimBloqueio = new Date(this.investidor.Bloqueio.FimBloqueio);

			return FimBloqueio > new Date();
		},

		//tagueamento GA
		taggingGA: function taggingGA() {
			this.$ga.page({
				page: '/oportunidades',
				title: 'Oportunidades'
			});
		}
	},
	components: {
		Modal: __WEBPACK_IMPORTED_MODULE_6__components_NewModal_Modal__["a" /* default */],
		OpportunityCard: __WEBPACK_IMPORTED_MODULE_7__components_OpportunityCard__["a" /* default */],
		OpportunitiesList: __WEBPACK_IMPORTED_MODULE_8__components_OpportunitiesList__["a" /* default */],
		Pagination: __WEBPACK_IMPORTED_MODULE_9__components_Pagination__["a" /* default */]
	},
	created: function () {
		var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
			var _this8 = this;

			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
				while (1) {
					switch (_context8.prev = _context8.next) {
						case 0:
							_context8.next = 2;
							return this.listaOportunidades();

						case 2:
							this.oportunidades = _context8.sent;


							try {
								document.querySelector('.main-content').style.zIndex = 2;
							} catch (e) {
								console.log(e);
							}

							this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["c" /* START_LOADING */]);

							this.User = this.$store.state.currentUser;

							this.temSuitability = this.User.hassuitability == undefined ? false : this.User.hassuitability;
							this.temCadastroInvestidor = this.User.hasinvestor == undefined ? false : this.User.hasinvestor;

							if (this.User.investor == null) this.investidorAprovado = false;else this.investidorAprovado = this.User.investor.Status == "APROVADO" && this.temCadastroInvestidor;

							__WEBPACK_IMPORTED_MODULE_11__utils_api_client__["a" /* default */].getInvestor().then(function (investor) {
								_this8.bloqueio = investor.Bloqueio;
								_this8.investidor = investor;
								_this8.InvestorAprovado = investor.Status == "APROVADO";
								_this8.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
							}).catch(function () {
								return _this8.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
							});

							//tagueamento GA
							_context8.next = 12;
							return this.taggingGA();

						case 12:
						case "end":
							return _context8.stop();
					}
				}
			}, _callee8, this);
		}));

		function created() {
			return _ref.apply(this, arguments);
		}

		return created;
	}()
});

/***/ }),

/***/ "1ogn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListOpportunities_vue__ = __webpack_require__("1mim");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_949e6046_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListOpportunities_vue__ = __webpack_require__("tFiN");
function injectStyle (ssrContext) {
  __webpack_require__("PGCd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-949e6046"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListOpportunities_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_949e6046_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListOpportunities_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "22Qi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CadastrarSenhaUsuario_vue__ = __webpack_require__("zGJ0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2088eab0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CadastrarSenhaUsuario_vue__ = __webpack_require__("HLY0");
function injectStyle (ssrContext) {
  __webpack_require__("Z477")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2088eab0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CadastrarSenhaUsuario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2088eab0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CadastrarSenhaUsuario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "27B6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2ElW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('a',{attrs:{"href":_vm.lpUrl,"target":"blank","title":"Ir para site principal"}},[_c('i',{staticClass:"ico-iouu logotipo",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center cta"},[_c('span',[_vm._m(0),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.cdi)+" do CDI")])]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":"#cta"}},[_vm._v("Comece a investir")])])]),_vm._v(" "),_c('main',[_c('router-view')],1),_vm._v(" "),_c('footer',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row menu-footer"},[_c('div',{staticClass:"col-12 col-md-9"},[_c('nav',{staticClass:"nav"},[_c('a',{staticClass:"nav-link",attrs:{"href":_vm.lpUrl,"title":"Ir para o site"}},[_vm._v("Ir para o site")]),_vm._v(" "),_c('a',{staticClass:"nav-link",attrs:{"href":_vm.lpUrl+'/quem-somos/',"title":"Quem somos"}},[_vm._v("Quem somos")]),_vm._v(" "),_c('a',{staticClass:"nav-link",attrs:{"href":_vm.lpUrl+'/emprestimos/',"title":"Empréstimos"}},[_vm._v("Empréstimos")]),_vm._v(" "),_c('a',{staticClass:"nav-link",attrs:{"href":_vm.lpUrl,"title":"Investimentos"}},[_vm._v("Investimentos")]),_vm._v(" "),_c('a',{staticClass:"nav-link",attrs:{"href":"https://blog.iouu.com.br","title":"Blog"}},[_vm._v("Blog")]),_vm._v(" "),_c('a',{staticClass:"nav-link",attrs:{"href":_vm.lpUrl+'/termos-e-condicoes/',"title":"Temos e condições"}},[_vm._v("Temos e condições")]),_vm._v(" "),_c('a',{staticClass:"nav-link",attrs:{"href":_vm.lpUrl+'/politica-de-privacidade/',"title":"Política de privacidade"}},[_vm._v("Política de privacidade")])])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_vm._v("Retorno potencial no ano "),_c('i',{staticClass:"far fa-question-circle",attrs:{"data-toggle":"tooltip","title":"Considerando o retorno médio dos empréstimos em curso (CDI) até o mês de abril/2018."}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-3 text-center text-md-right"},[_c('div',{staticClass:"footer__social"},[_c('a',{staticClass:"fa-stack fa-1x",attrs:{"href":"https://www.facebook.com/IouuBrasil/","target":"_blank","title":"Facebook"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-facebook-f fa-stack-1x"})]),_vm._v(" "),_c('a',{staticClass:"fa-stack fa-1x",attrs:{"href":"https://twitter.com/iouubrasil","target":"_blank","title":"Twitter"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-twitter fa-stack-1x"})]),_vm._v(" "),_c('a',{staticClass:"fa-stack fa-1x",attrs:{"href":"https://www.linkedin.com/company/iouu","target":"_blank","title":"Linkedin"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-linkedin-in fa-stack-1x"})]),_vm._v(" "),_c('a',{staticClass:"fa-stack fa-1x",attrs:{"href":"https://vimeo.com/iouubrasil","target":"_blank","title":"Instagram"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-instagram fa-stack-1x"})]),_vm._v(" "),_c('a',{staticClass:"fa-stack fa-1x",attrs:{"href":"https://www.instagram.com/iouubrasil/","target":"_blank","title":"Vimeo"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-vimeo-v fa-stack-1x"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('i',{staticClass:"ico-iouu logotipo",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',[_vm._v("© 2019 - IOUU TODOS OS DIREITOS RESERVADOS.")]),_vm._v(" "),_c('small',[_vm._v("IOUU.com.br pertence à IOUU Tecnologia e Serviços Financeiros - Epp (“IOUU”).")]),_vm._v(" "),_c('small',[_vm._v("A IOUU não é uma instituição financeira e não realiza operações de financiamento, investimentos ou quaisquer outras operações privativas de instituições financeiras.")]),_vm._v(" "),_c('small',[_vm._v("A IOUU é uma plataforma digital que atua como correspondente bancário para facilitar o processo de contratação de empréstimos.")]),_vm._v(" "),_c('small',[_vm._v("Como correspondente bancário, seguimos as diretrizes do Banco Central do Brasil, nos termos da Resolução nº. 3.954, de 24 de fevereiro de 2011.")]),_vm._v(" "),_c('small',[_vm._v("Somos correspondentes bancários das seguintes instituições: Parati Crédito, Financiamento e Investimento S/A (Ouvidoria da Instituição Financeira: 0800 723 4787) e Money Plus SCMEPP LTDA (“BMP Money Plus”) (Ouvidoria da Instituição Financeira: 0800 601 52 89).")]),_vm._v(" "),_c('small',[_vm._v("IOUU Tecnologia e Serviços Financeiros Ltda - Epp. é uma sociedade limitada registrada sob o CNPJ/MF 26.484.548/0001-48, com sede na Av. Paulista, 807, 23º andar, Conjunto: 2315 - Bela Vista, São Paulo - SP, 01310-300.")]),_vm._v(" "),_c('small',[_vm._v("Os correspondentes bancários são empresas contratadas por instituições financeiras e demais instituições autorizadas pelo Banco Central do Brasil para a prestação de serviços de atendimento aos clientes e usuários dessas instituições. Entre os correspondentes mais conhecidos encontram-se as lotéricas e o banco postal.")]),_vm._v(" "),_c('small',[_vm._v("Informações adicionais - Custo Efetivo Total: CET mínimo de 1,3% ao mês e máximo de 7,5% ao mês. Exemplo - Empréstimo de R$ 100.000,00 para pagar em 2 anos (24 meses) – Total de 24 parcelas de R$ 5.349,40. Valor total a pagar igual a R$ 128.385,60 com uma taxa de juros de 1,81% ao mês (24,01% ao ano). CET de 2,1% ao mês (28,27% ao ano).")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"id-001","tabindex":"-1","role":"dialog","aria-labelledby":"id-001","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"id-001"}},[_vm._v("Quais serviços a IOUU oferece para os investidores?")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("A IOUU fornece uma plataforma que conecta os investidores (pessoa física e jurídica) a Micro, Pequenas e Médias empresas, além de micro e nano empreendedores de baixa renda, utilizando tecnologias inovadoras para analisar as\n                        solicitações de empréstimo de forma rápida, online, sem burocracias e com baixa taxa de juros. Dessa forma, criamos uma oportunidade para investidores decidirem para quem e quando querem emprestar e em trocar receber\n                        rentabilidades justas.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"id-002","tabindex":"-1","role":"dialog","aria-labelledby":"id-002","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"id-002"}},[_vm._v("Qual o valor mínimo de investimento?")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("Os limites de investimento variam conforme a modalidade escolhida:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Investimento Coletivo: a partir de "),_c('strong',[_vm._v("R$ 2.000,00")]),_vm._v(";")]),_vm._v(" "),_c('li',[_vm._v("Investimento de Impacto: a partir de "),_c('strong',[_vm._v("R$ 500,00")]),_vm._v(";")]),_vm._v(" "),_c('li',[_vm._v("Investimento Social: a partir de "),_c('strong',[_vm._v("R$ 100,00")]),_vm._v(".")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"id-003","tabindex":"-1","role":"dialog","aria-labelledby":"id-003","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"id-003"}},[_vm._v("Quanto custa investir na IOUU?")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("Não existe custo algum para investir na oportunidades oferecidas pela plataforma da IOUU.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"id-004","tabindex":"-1","role":"dialog","aria-labelledby":"id-004","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"id-004"}},[_vm._v("Qual o procedimento em caso de atraso da parcela mensal?")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("Para transmitir mais segurança aos investidores e estabelecer um processo transparente com os tomadores de empréstimo, a IOUU tem um processo para tratar as situações de inadimplência. Confira como ele funciona "),_c('a',{attrs:{"href":"http://bit.ly/2PYsEn8","target":"_blank"}},[_vm._v("acessando este link")]),_vm._v(".")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"id-005","tabindex":"-1","role":"dialog","aria-labelledby":"id-005","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"id-005"}},[_vm._v("Qual a garantia que receberei meu investimento de volta?")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("Assim como em qualquer investimento, não existe garantia de retorno e as taxas de rendimento são anunciadas com base na premissa de que os empréstimos sejam pagos em dia pelos Tomadores, havendo risco de o retorno ser inferior ao projetado ou até mesmo de não haver retorno, em caso de inadimplemento pelo Tomador. O que fazemos aqui na IOUU é mitigarmos esse risco de inadimplência ao máximos com técnicas inovadoras de análise preditiva e de crédito.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"id-006","tabindex":"-1","role":"dialog","aria-labelledby":"id-006","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"id-006"}},[_vm._v("A IOUU é um banco ou instituição financeira?")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("Não, a IOUU atua como correspondente bancário que utliza as mais modernas tecnologias para conectar empreendedores e investidores, garantindo assim, um melhor negócio para todos.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2KSD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletHeader_vue__ = __webpack_require__("y/il");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303ce802_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletHeader_vue__ = __webpack_require__("K51t");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303ce802_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2YDi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewLogin_vue__ = __webpack_require__("aqVo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1e576c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewLogin_vue__ = __webpack_require__("LKP0");
function injectStyle (ssrContext) {
  __webpack_require__("DenK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1e576c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1e576c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2YlQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AceiteConfirmacao_vue__ = __webpack_require__("hrnj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9d22758_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AceiteConfirmacao_vue__ = __webpack_require__("CR9D");
function injectStyle (ssrContext) {
  __webpack_require__("Yefk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e9d22758"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AceiteConfirmacao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9d22758_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AceiteConfirmacao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2ad2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploadComprovanteEnderecoStep_vue__ = __webpack_require__("ObKo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81e9d3c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploadComprovanteEnderecoStep_vue__ = __webpack_require__("vd++");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploadComprovanteEnderecoStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81e9d3c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploadComprovanteEnderecoStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2cBF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_string_helper__ = __webpack_require__("65ha");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_1_vue_select___default.a
  },
  data: function data() {
    var endereco = this.currentUser.Pessoal.Endereco;
    return {
      cep: endereco ? endereco.Cep : null,
      logradouro: endereco ? endereco.Logradouro : null,
      numero: endereco ? endereco.Numero : null,
      complemento: endereco ? endereco.Complemento : null,
      bairro: endereco ? endereco.Bairro : null,
      uf: endereco ? endereco.Uf : null,
      cidade: endereco ? endereco.Cidade : null,
      estados: [],
      cidades: []
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  computed: {
    estaCidadeDesabilitado: function estaCidadeDesabilitado() {
      return this.cidades.length == 0;
    }
  },
  methods: {
    aoMudarCep: function aoMudarCep(e) {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskZipcode(e.target.value).length < 8) return;
      this.estaBuscandoEndereco = true;
      __WEBPACK_IMPORTED_MODULE_2__utils_hub_consulta_client__["a" /* default */].pegarCeps(e.target.value).then(function (endereco) {
        _this.logradouro = endereco.logradouro;
        _this.bairro = endereco.bairro;
        _this.uf = endereco.uf;
        _this.cidade = endereco.localidade;
      }).catch(function () {});
    },
    onUfChange: function onUfChange() {
      var _this2 = this;

      this.cidades = [];
      if (!this.uf) {
        this.cidade = '';
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2__utils_hub_consulta_client__["a" /* default */].pegarCidades(this.uf).then(function (cidades) {
        _this2.cidades = cidades;
        _this2.$refs.citySelect.$el.children[0].children[2].required = true;

        if (_this2.cidade) {
          _this2.setCity();
        }
      });
    },
    setCity: function setCity() {
      var _this3 = this;

      var city = this.cidades.find(function (city) {
        return __WEBPACK_IMPORTED_MODULE_3__utils_string_helper__["a" /* default */].removeAccents(city.nome.toUpperCase()) == __WEBPACK_IMPORTED_MODULE_3__utils_string_helper__["a" /* default */].removeAccents(_this3.cidade.toUpperCase());
      });
      if (!city) {
        this.cidade = '';
      } else {
        // When the city state is seted before cities is populated the component doesn't show
        // the selected city.
        this.cidade = '';
        setTimeout(function () {
          return _this3.cidade = city.nome;
        }, 100);
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      this.currentUser.Pessoal.Endereco.Cep = this.cep;
      this.currentUser.Pessoal.Endereco.Logradouro = this.logradouro;
      this.currentUser.Pessoal.Endereco.Numero = this.numero;
      this.currentUser.Pessoal.Endereco.Complemento = this.complemento;
      this.currentUser.Pessoal.Endereco.Bairro = this.bairro;
      this.currentUser.Pessoal.Endereco.Uf = this.uf;
      this.currentUser.Pessoal.Endereco.Cidade = this.cidade;

      this.$emit('on-submit', { Pessoal: this.currentUser.Pessoal });
    }
  },
  created: function created() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_2__utils_hub_consulta_client__["a" /* default */].pegarCeps(this.cep).then(function (endereco) {
      _this4.logradouro = endereco.logradouro;
      _this4.bairro = endereco.bairro;
      _this4.uf = endereco.uf;
      _this4.cidade = endereco.localidade;
    }).catch(function () {});

    __WEBPACK_IMPORTED_MODULE_2__utils_hub_consulta_client__["a" /* default */].pegarEstados().then(function (estados) {
      _this4.estados = estados;
      // When the city state is seted before cities is populated the component doesn't show
      // the selected city.
      var uf = _this4.uf;
      var city = _this4.cidade;
      _this4.uf = '';
      _this4.$refs.ufSelect.$el.children[0].children[2].required = true;

      setTimeout(function () {
        _this4.uf = uf;
        _this4.cidade = city;
      }, 100);
    });
  }
});

/***/ }),

/***/ "2dw2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2fUy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2ghZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lottie_web__ = __webpack_require__("tgCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lottie_web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lottie_web__);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    options: {
      type: Object,
      required: true
    },
    height: Number,
    width: Number
  },
  data: function data() {
    return {
      style: {
        width: this.width ? this.width + 'px' : '100%',
        height: this.height ? this.height + 'px' : '100%',
        overflow: 'hidden',
        margin: '0 auto'
      }
    };
  },
  mounted: function mounted() {
    this.anim = __WEBPACK_IMPORTED_MODULE_0_lottie_web___default.a.loadAnimation({
      container: this.$refs.lavContainer,
      renderer: 'svg',
      // loop: this.options.loop !== false,
      loop: true,
      // autoplay: this.options.autoplay !== false,
      autoplay: true,
      animationData: this.options.animationData,
      rendererSettings: this.options.rendererSettings
    });
    this.$emit('animCreated', this.anim);
  }
});

/***/ }),

/***/ "2gzv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive d-none d-sm-block"},[_c('table',{staticClass:"table table-hover"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((this.oportunidatesAux),function(item){return _c('tr',{key:item._id,class:'rating-' + _vm.lowerCase(item.Score)},[_c('th',{staticClass:"rating align-middle",attrs:{"scope":"row"}},[_c('span',{staticClass:"circle score"},[_vm._v(_vm._s(_vm.formatarScore(item.Score)))])]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('a',{staticClass:"btn btn-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.mudarOportunidade(item);}}},[_vm._v(_vm._s(_vm.ajustIdOportunidade(item.IdOportunidade,5)))])]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.Empresa.NomeFantasia))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm.formatarTipoEmprestimo(item.TipoEmprestimo)))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("R$ "+_vm._s(_vm.money(item.Valor)))]),_vm._v(" "),(item.TipoEmprestimo != 'emprestimo-ccb')?_c('td',{staticClass:"align-middle"},[_vm._v(" "+_vm._s(_vm.valor(item.Rendimento))+" a.a.")]):_vm._e(),_vm._v(" "),(item.TipoEmprestimo == 'emprestimo-ccb')?_c('td',{staticClass:"align-middle"},[_vm._v(" "+_vm._s(_vm.valor(item.Ccb.TaxaBrutaRendimento))+"% CDI")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:('width: ' + _vm.inteiro(_vm.levantado(item)) + '%'),attrs:{"role":"progressbar","aria-valuenow":"0","aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"progress-value"},[_vm._v(_vm._s(_vm.money(_vm.levantado(item)))+"%")])])]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("Faltam:\n                        "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.money(_vm.faltam(item))))])])]),_vm._v(" "),(!item.Encerrado)?_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm.diffDate(item.FimCaptacao))+" ")]):_c('td',{staticClass:"align-middle"},[_vm._v("encerrado ")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[(!item.Encerrado && item.TipoEmprestimo != 'emprestimo-ccb')?_c('a',{staticClass:"btn btn-primary",attrs:{"title":"Investir"},on:{"click":function($event){return _vm.mudarOportunidade(item);}}},[_vm._v(_vm._s((item.Valor - (item.ValorCaptado == undefined ? 0 :item.ValorCaptado) ) > 0 ? 'Investir' : 'Lista de Espera'))]):_vm._e(),_vm._v(" "),(!item.Encerrado && item.TipoEmprestimo == 'emprestimo-ccb')?_c('a',{staticClass:"btn btn-primary",attrs:{"title":"Investir"},on:{"click":function($event){return _vm.mudarOportunidade(item);}}},[_vm._v("Investir")]):_vm._e(),_vm._v(" "),(item.Encerrado)?_c('a',{staticClass:"btn btn-secondary",staticStyle:{"font-weight":"bold"},attrs:{"title":"Investir"},on:{"click":function($event){return _vm.mudarOportunidade(item);}}},[_vm._v("ENCERRADO")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(item.TipoEmprestimo != 'emprestimo-ccb' && !_vm.InvestidorBloqueado)?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":_vm.templateRender(item),"title":"Exibir detalhes"}},[_vm._v("Exibir detalhes")]):(!_vm.InvestidorBloqueado)?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":'/investimentos/oportunidades/'+item._id+'/perfil-ccb',"title":"Exibir detalhes"}},[_vm._v("Exibir detalhes")]):_vm._e()],1)])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"width":"80","scope":"col"}},[_vm._v("Score")]),_vm._v(" "),_c('th',{attrs:{"width":"100","scope":"col"}},[_vm._v("ID")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Empresa")]),_vm._v(" "),_c('th',{attrs:{"width":"120","scope":"col"}},[_vm._v("Tipo")]),_vm._v(" "),_c('th',{attrs:{"width":"185","scope":"col"}},[_vm._v("Valor solicitado")]),_vm._v(" "),_c('th',{attrs:{"width":"130","scope":"col"}},[_vm._v("Rendimento")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("% Levantado")]),_vm._v(" "),_c('th',{attrs:{"width":"100","scope":"col"}},[_vm._v("Término")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Ações")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2ha3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2j2J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('p',[_vm._v("Por favor, nos forneça o contrato social com a última alteração")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2j8w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('updateUser');
  }
});

/***/ }),

/***/ "2jPX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataInscricaoEstadualStep_vue__ = __webpack_require__("cssz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b40e81da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataInscricaoEstadualStep_vue__ = __webpack_require__("csXd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataInscricaoEstadualStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b40e81da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataInscricaoEstadualStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2yOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"logo",attrs:{"href":"https://iouu.com.br","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("xhIC"),"alt":"logo IOUU"}})]),_vm._v(" "),_c('div',{staticClass:"image"},[_c('img',{staticClass:"imagem",attrs:{"src":__webpack_require__("hPZq"),"alt":"imagem login"}}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":__webpack_require__("98U6"),"alt":"icone"}}),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',{staticClass:"txt"},[_vm._v("\n          Transparência é o que faz a plataforma funcionar de maneira rápida,\n          simples e responsável.\n        ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2yUf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2zIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "34Te":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wallet"},[(_vm.renderizado)?_c('div',[_c('div',{staticClass:"row align-items-center wallet__tit-page tit_page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-4 col-md-4 col-lg-4"},[_c('div',{staticClass:"back back-hide float-right"},[_c('router-link',{attrs:{"to":"/investimentos/carteira-investimento","title":"Voltar"}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar")])],1)])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('WalletErenderizadoxtratoFiltro',{attrs:{"detalhesOportunidade":_vm.detalhesOportunidade},on:{"filtrar":_vm.filtrarExtrato}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"box-border wallet__extrato"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"accordion",class:(_vm.loadingList) ? 'loading-accordion' : '',attrs:{"id":"accordion"}},[(_vm.loadingList)?[_c('div',{staticClass:"loader"})]:[_c('WalletExtratoLista',{attrs:{"operacoes":_vm.Operacoes,"detalhesOportunidade":_vm.detalhesOportunidade}})]],2),_vm._v(" "),_c('Pagination',{attrs:{"paginasTotais":this.Paginas,"paginaAtual":this.PaginaAtual,"navigate":_vm.mudarPagina}})],1)])])],1):_c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard"},[_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-8 col-md-8 col-lg-8"},[_c('h1',[_vm._v("Histórico")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wallet__extrato--tit"},[_c('h2',[_vm._v("Minhas transações")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard__complete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Histórico - Carteira Virtual")]),_vm._v(" "),_c('div',{staticClass:"loading-animation"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3AXq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPage_vue__ = __webpack_require__("xX/1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_542202a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPage_vue__ = __webpack_require__("2ElW");
function injectStyle (ssrContext) {
  __webpack_require__("WHFU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-542202a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_542202a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Esd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Lo/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "3RxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps"},[_c('header',{staticClass:"d-flex"},[_c('a',{staticClass:"left",attrs:{"href":_vm.lpUrl,"target":"blank"}},[_c('i',{staticClass:"ico-iouu logotipo",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("FNzu"),"alt":"Foto Liza"}}),_vm._v(" "),_c('a',{staticClass:"right",attrs:{"href":"#","title":"Sair"},on:{"click":_vm.Logout}},[_c('i',{staticClass:"ico-exit"}),_vm._v(" Sair\n    ")])]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Vbq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    var social = this.currentUser.Social;
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: social.ArquivoIdentidade || [null]
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.arquivos.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.arquivos, index, null);
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do documento de identidade é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {

        this.currentUser.Social.ArquivoIdentidade = this.arquivosRecebidos;

        this.$emit('on-submit', { Social: this.currentUser.Social });
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "3cNw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAntecipationReceivables_vue__ = __webpack_require__("3yE6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bad4b98a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAntecipationReceivables_vue__ = __webpack_require__("SQI8");
function injectStyle (ssrContext) {
  __webpack_require__("GfAA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bad4b98a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAntecipationReceivables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bad4b98a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAntecipationReceivables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3lTO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3m2+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SocialNetwork__ = __webpack_require__("TYgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PasswordField__ = __webpack_require__("i7i+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_hub_consulta_client_js__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_api_user__ = __webpack_require__("VEmD");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lpUrl: "https://iouu.com.br",
      enabled: false,
      EmailConfirmado: false,
      password: '',
      email: '',
      name: '',
      user: {}
    };
  },

  components: {
    SocialNetwork: __WEBPACK_IMPORTED_MODULE_3__components_SocialNetwork__["a" /* default */], PasswordField: __WEBPACK_IMPORTED_MODULE_5__components_PasswordField__["a" /* default */]
  },
  created: function created() {

    var email = this.getQueryString('email').toLowerCase();
    var name = this.getQueryString('name').toLowerCase();

    this.email = email;
    this.name = name;

    console.log(email);

    this.emailValidate(email);

    this.user = this.getUser(email);
    console.log('f ', this.user);
  },

  methods: {
    getUser: function getUser(email) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__services_api_user__["a" /* default */].GetUserByEmail(email);

              case 2:
                return _context.abrupt('return', _context.sent);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    emailValidate: function emailValidate(email) {
      var _this2 = this;

      email = email.toLowerCase().trim();

      __WEBPACK_IMPORTED_MODULE_6__utils_hub_consulta_client_js__["a" /* default */].theCheckerPost(email).then(function (resposta) {

        if (resposta == "Entregável") _this2.EmailConfirmado = true;else _this2.$Notify.error("Email informado é inválido!");
      }).catch(function (resposta) {

        _this2.EmailConfirmado = true;
      });
    },
    getQueryString: function getQueryString(name) {
      var url = window.location.href;

      name = name.replace(/[\[\]]/g, '\\$&');

      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');

      var resp = regex.exec(url);

      if (!resp) return null;

      if (!resp[2]) return '';

      return decodeURIComponent(resp[2].replace(/\+/g, ' '));
    },
    passwordIsValid: function passwordIsValid() {

      if (this.password.length < 6) {

        this.$Notify.error("A senha deve conter mais de 6 digitos!");
        $("#inputPassword").addClass("animated shake");
        $("#inputPassword").addClass("emailinvalido");

        return false;
      } else {
        $("#inputPassword").removeClass("animated");
        $("#inputPassword").removeClass("shake");
        $("#inputPassword").removeClass("emailinvalido");

        return true;
      }
    },
    signUp: function signUp() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var email, name;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this3.passwordIsValid()) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                email = _this3.getQueryString('email').toLowerCase();
                name = _this3.getQueryString('name');


                _this3.$store.dispatch('signup', { name: name, email: email, password: _this3.password }).then(function () {
                  var now = new Date();

                  mixpanel.people.set({
                    'USER_ID': _this3.user.id,
                    'sign_up_date': now,
                    'email': email,
                    'name': name,
                    'Tipo': 'Investidor'
                  });

                  mixpanel.identify(currentUser._id);

                  mixpanel.track("NEW_PASSWORD", {
                    timestamp: now
                  });

                  console.log('mix ', mixpanel);

                  _this3.$router.push("/investimentos/oportunidades/");
                }).catch(function (error) {
                  var errorMessages = error.response.data.Msg;

                  _this3.$Notify.error(errorMessages);
                });

                // CADASTRA CONTATO EM ACTIVE CAMPAIN
                __WEBPACK_IMPORTED_MODULE_6__utils_hub_consulta_client_js__["a" /* default */].CadastrarActive(email);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }
});

/***/ }),

/***/ "3mVv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioContratoSocialPasso_vue__ = __webpack_require__("7H1d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224e58cb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioContratoSocialPasso_vue__ = __webpack_require__("2j2J");
function injectStyle (ssrContext) {
  __webpack_require__("/nly")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-224e58cb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioContratoSocialPasso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224e58cb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioContratoSocialPasso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3yE6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NewModal_Modal__ = __webpack_require__("L6+9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_OpportunityCard__ = __webpack_require__("7Liv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_OpportunitiesList__ = __webpack_require__("oN8B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Pagination__ = __webpack_require__("cMGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_api_client_go__ = __webpack_require__("879M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_array_helper__ = __webpack_require__("rzJh");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */










/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			showCards: sessionStorage.getItem('showCards') == '' ? false : true,
			showModal: false,
			oportunidades: [],
			scoreFiltrado: [],

			filterOportunidades: [],
			filterAux: [],
			investidor: {},
			indexPage: 1,
			Paginas: 0,
			InvestorAprovado: false,
			oportunidadesEmBreve: false,
			temCadastroInvestidor: false,
			temSuitability: false,
			investidorAprovado: false,
			User: null,

			solicitacao: null,
			bloqueio: '',
			// Scores selecionados
			arrScore: ["AA", "A", "B", "C", "D", "E", "HR"],
			// Scores removidos
			arrFiltroScore: [],
			strScoreFilter: [{
				"score": "AA",
				"status": true
			}, {
				"score": "A",
				"status": true
			}, {
				"score": "B",
				"status": true
			}, {
				"score": "C",
				"status": true
			}, {
				"score": "D",
				"status": true
			}, {
				"score": "E",
				"status": true
			}, {
				"score": "HR",
				"status": true
			}]
		};
	},

	methods: {
		// Requests
		listaOportunidades: function listaOportunidades() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
				var _oportunidades, stringScore, resp, oportunidades, publicados;

				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;

								_this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["c" /* START_LOADING */]);

								stringScore = _this.arrScore.join("-");
								_context.next = 5;
								return __WEBPACK_IMPORTED_MODULE_12__utils_api_client_go__["a" /* default */].ListarAntecipados(_this.indexPage, stringScore);

							case 5:
								resp = _context.sent;

								_this.Paginas = resp.Paginas;
								oportunidades = _this.TrataOportunidades(resp.ItemListagemSolicitacoes);

								if (!(oportunidades == null)) {
									_context.next = 11;
									break;
								}

								_this.oportunidadesEmBreve = true;
								return _context.abrupt("return", []);

							case 11:

								// Ordena Publicados
								publicados = _this.pegaPublicados(oportunidades);

								oportunidades = _this.removePublicados(oportunidades);
								_this.porcentagemSort(publicados);
								(_oportunidades = oportunidades).unshift.apply(_oportunidades, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(publicados));

								_this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);

								return _context.abrupt("return", oportunidades);

							case 19:
								_context.prev = 19;
								_context.t0 = _context["catch"](0);

								console.log(_context.t0);
								_this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
								return _context.abrupt("return", []);

							case 24:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this, [[0, 19]]);
			}))();
		},
		pegaSolicitacao: function pegaSolicitacao(id) {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var resp, solicitacao;
				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.prev = 0;

								_this2.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["c" /* START_LOADING */]);
								_context2.next = 4;
								return __WEBPACK_IMPORTED_MODULE_12__utils_api_client_go__["a" /* default */].oportunidadePorId(id);

							case 4:
								resp = _context2.sent;

								_this2.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);

								solicitacao = resp.data.Solicitacao;


								if (solicitacao.IdOportunidade == 14644) solicitacao.PrazoDias = 14;

								// Lista de espera
								solicitacao.ChamadaListaEspera ? solicitacao.ValorCaptado = solicitacao.Valor : '';
								// Encerrada
								solicitacao.Encerrado = solicitacao.StatusAnalise == "ENCERRADO" || _this2.diffDate(solicitacao.FimCaptacao) == "encerrado";
								// Score
								solicitacao.Score = _this2.pegaScore(solicitacao);

								return _context2.abrupt("return", solicitacao);

							case 14:
								_context2.prev = 14;
								_context2.t0 = _context2["catch"](0);

								console.log(_context2.t0);
								_this2.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
								return _context2.abrupt("return", null);

							case 19:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, _this2, [[0, 14]]);
			}))();
		},


		// Interacao Modal
		setCards: function setCards() {
			sessionStorage.setItem('showCards', true);
			this.showCards = sessionStorage.getItem('showCards');
		},
		unsetCards: function unsetCards() {
			sessionStorage.setItem('showCards', '');
			this.showCards = sessionStorage.getItem('showCards');
		},
		mudarOportunidade: function mudarOportunidade(item) {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return _this3.pegaSolicitacao(item._id);

							case 2:
								_this3.solicitacao = _context3.sent;

								_this3.AbrirModal(true);

							case 4:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		AbrirModal: function AbrirModal(isAbrir) {
			// função de ajuste emergencial no css
			isAbrir ? document.querySelector('.main-content').style.zIndex = 10 : document.querySelector('.main-content').style.zIndex = 2;

			if (document.getElementsByTagName("main").length > 0) {
				if (isAbrir) document.getElementsByTagName("main")[0].style.zIndex = "50";else document.getElementsByTagName("main")[0].style.zIndex = "0";
			}

			this.showModal = isAbrir;
		},
		voltar: function voltar() {
			var _this4 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_this4.AbrirModal(false);
								_context4.next = 3;
								return _this4.listaOportunidades();

							case 3:
								_this4.oportunidades = _context4.sent;

							case 4:
							case "end":
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))();
		},


		// Filtro de oportunidade
		scoreAll: function scoreAll(e) {
			var _this5 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
				var score;
				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								// FILTRO DE TODOS OS SCORES
								_this5.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["c" /* START_LOADING */]);

								for (score in _this5.strScoreFilter) {
									// Seleciona ou nao os checkbox das cores do filtros
									_this5.$refs[_this5.strScoreFilter[score].score].checked = e.target.checked;
									// salva guarda os scores
									if (e.target.checked) {
										_this5.arrFiltroScore = [];
										_this5.arrScore.push(_this5.$refs[_this5.strScoreFilter[score].score].id);
									} else {
										_this5.arrFiltroScore.push(_this5.$refs[_this5.strScoreFilter[score].score].id);
										_this5.arrScore = [];
									}
								}
								// Verifica qual valor
								// Se false - zera o filtro
								// Se true - volta todos os filtros
								_this5.arrFiltroScore = [];

								if (!e.target.checked) {
									_context5.next = 9;
									break;
								}

								_context5.next = 6;
								return _this5.listaOportunidades();

							case 6:
								_this5.oportunidades = _context5.sent;
								_context5.next = 10;
								break;

							case 9:
								_this5.oportunidades = [];

							case 10:

								_this5.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);

							case 11:
							case "end":
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		scoreClick: function scoreClick(e, scoreValue) {
			var _this6 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
				var publicados;
				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								//Filtro individual
								publicados = [];

								if (e.target.checked) {
									_this6.arrFiltroScore = _this6.arrFiltroScore.filter(function (elemento) {
										return elemento != scoreValue;
									});
									_this6.arrScore.push(scoreValue);
								} else {
									_this6.arrFiltroScore.push(scoreValue);
									_this6.arrScore = _this6.arrScore.filter(function (elemento) {
										return elemento != scoreValue;
									});
								}

								if (!(_this6.arrFiltroScore.length < 7)) {
									_context6.next = 8;
									break;
								}

								_context6.next = 5;
								return _this6.listaOportunidades();

							case 5:
								_this6.oportunidades = _context6.sent;
								_context6.next = 9;
								break;

							case 8:
								_this6.oportunidades = [];

							case 9:
							case "end":
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))();
		},

		// Paginacao
		paginacao: function paginacao(rota) {
			var _this7 = this;

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
				return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								_this7.indexPage = rota + 1;
								_context7.next = 3;
								return _this7.listaOportunidades();

							case 3:
								_this7.oportunidades = _context7.sent;

							case 4:
							case "end":
								return _context7.stop();
						}
					}
				}, _callee7, _this7);
			}))();
		},

		// Tratativa de dados
		TrataOportunidades: function TrataOportunidades(oportunidades) {
			for (var i = 0; i < oportunidades.length; i++) {
				var oportunidade = oportunidades[i];
				// Lista de espera
				oportunidade.ChamadaListaEspera ? oportunidade.ValorCaptado = oportunidade.Valor : '';
				// Encerrada
				oportunidade.Encerrado = oportunidade.StatusAnalise == "ENCERRADO" || this.diffDate(oportunidade.FimCaptacao) == "encerrado";
				// Score
				oportunidade.Score = this.pegaScore(oportunidade);
			}
			return oportunidades;
		},
		pegaScore: function pegaScore(item) {
			if (item.Score === "AA" || item.Score === "HR") {
				return item.Score;
			} else if (typeof item.Score != "undefined") {
				var spliter = item.Score.split("");
				return spliter[0];
			}
			return 'excessao';
		},
		removePublicados: function removePublicados(arr) {
			var remove = [];
			for (var index = 0; index < arr.length; index++) {
				arr[index].StatusAnalise == 'PUBLICADO' && this.diffDate(arr[index].FimCaptacao) != "encerrado" ? remove.unshift(index) : '';
			}
			remove.forEach(function (element) {
				arr.splice(element, 1);
			});
			return arr;
		},
		pegaPublicados: function pegaPublicados(arr) {
			var publicado = [];
			for (var i = 0; i < arr.length; i++) {
				if (arr[i].StatusAnalise == 'PUBLICADO' && this.diffDate(arr[i].FimCaptacao) != "encerrado") {
					var porcentagem = arr[i].ValorCaptado / arr[i].Valor * 100;
					publicado.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, arr[i], { porcentagem: porcentagem }));
				}
			}
			return publicado;
		},
		porcentagemSort: function porcentagemSort(arr) {
			var swapped = void 0;
			do {
				swapped = false;
				for (var i = 0; i < arr.length - 1; i++) {
					if (arr[i].porcentagem > arr[i + 1].porcentagem) {
						var temp = arr[i];
						arr[i] = arr[i + 1];
						arr[i + 1] = temp;
						swapped = true;
					}
				}
			} while (swapped);
			return arr;
		},


		// Metodos Modal
		diffDate: function diffDate(d2) {
			var miliSecs = new Date(d2) - new Date();

			var diffDays = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(miliSecs / 1000 / 60 / 60 / 24) + 1;

			if (diffDays <= 0) return "encerrado";

			return diffDays + " dias";
		},
		ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
			var s = String(id);
			while (s.length < (qtd || 2)) {
				s = "0" + s;
			}
			return s;
		},
		formatarScore: function formatarScore(score) {
			if (score.length > 1 && !isNaN(score[1])) {
				return score[0];
			}

			return score;
		},
		formatarTipoEmprestimo: function formatarTipoEmprestimo(tipoEmprestimo) {
			if (tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2") {
				return "Impacto";
			}

			var splitedTipoEmprestimo = tipoEmprestimo.split('-');

			if (splitedTipoEmprestimo.length > 1) {
				if (splitedTipoEmprestimo[1] == "ccb") return splitedTipoEmprestimo[1].toUpperCase();

				return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
			}

			return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);
		},
		money: function money(n) {
			var c = 2,
			    d = ",",
			    t = ".",
			    s = n < 0 ? "-" : "",
			    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
			    j = (j = i.length) > 3 ? j % 3 : 0;
			return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
		},
		inteiro: function inteiro(n) {
			return parseInt(n = Math.abs(Number(n) || 0).toFixed(2));
		},
		levantado: function levantado(oportunidade) {
			var val = oportunidade.ValorCaptado / oportunidade.Valor * 100 || 0.00;
			return val < 100.00 ? val : 100.00;
		},
		faltam: function faltam(oportunidade) {
			var val = oportunidade.Valor - oportunidade.ValorCaptado;
			return val >= 0 ? val : 0;
		},
		valor: function valor(_valor) {
			if (_valor == null || _valor == undefined) _valor = 0;
			return this.money(_valor);
		},
		templateRender: function templateRender(item) {
			if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item.InicioCaptacao) === "object") {
				item.InicioCaptacao = item.InicioCaptacao.toISOString();
			}
			var separete = item.InicioCaptacao.split("T");
			var spliter = separete[0].split("-");

			// Verifica qual é o template do perfil da empresa que sera renderizado
			// novo perfil a partir de 08/2018
			if (parseInt(spliter[0]) == 2018 && parseInt(spliter[1]) >= 8 || parseInt(spliter[0]) > 2018) {
				return '/investimentos/oportunidades/perfil-empresa/' + item._id + "#" + this.indexPage;
			}

			return '/investimentos/oportunidades/perfil-empresa-old/' + item._id + "#" + this.indexPage;
		},
		lowerCase: function lowerCase(texto) {
			if (texto == null || texto == undefined) return "";

			if (texto == "AA" || texto == "HR") return texto.toLowerCase();

			return texto.substr(0, 1).toLowerCase();
		},
		InvestidorBloqueado: function InvestidorBloqueado() {
			if (this.investidor == null || this.investidor.Bloqueio == null || this.investidor.Bloqueio.FimBloqueio == null) return false;

			var FimBloqueio = new Date(this.investidor.Bloqueio.FimBloqueio);

			return FimBloqueio > new Date();
		},


		//tagueamento GA
		taggingGA: function taggingGA() {
			this.$ga.page({
				page: '/antecipacao/ ',
				title: 'Antecipacao'
			});
		}
	},
	components: {
		Modal: __WEBPACK_IMPORTED_MODULE_6__components_NewModal_Modal__["a" /* default */],
		OpportunityCard: __WEBPACK_IMPORTED_MODULE_7__components_OpportunityCard__["a" /* default */],
		OpportunitiesList: __WEBPACK_IMPORTED_MODULE_8__components_OpportunitiesList__["a" /* default */],
		Pagination: __WEBPACK_IMPORTED_MODULE_9__components_Pagination__["a" /* default */]
	},
	created: function () {
		var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
			var _this8 = this;

			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
				while (1) {
					switch (_context8.prev = _context8.next) {
						case 0:
							_context8.next = 2;
							return this.listaOportunidades();

						case 2:
							this.oportunidades = _context8.sent;


							try {
								document.querySelector('.main-content').style.zIndex = 2;
							} catch (e) {
								console.log(e);
							}

							this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["c" /* START_LOADING */]);

							this.User = this.$store.state.currentUser;

							this.temSuitability = this.User.hassuitability == undefined ? false : this.User.hassuitability;
							this.temCadastroInvestidor = this.User.hasinvestor == undefined ? false : this.User.hasinvestor;

							if (this.User.investor == null) this.investidorAprovado = false;else this.investidorAprovado = this.User.investor.Status == "APROVADO" && this.temCadastroInvestidor;

							__WEBPACK_IMPORTED_MODULE_11__utils_api_client__["a" /* default */].getInvestor().then(function (investor) {
								_this8.bloqueio = investor.Bloqueio;
								_this8.investidor = investor;
								_this8.InvestorAprovado = investor.Status == "APROVADO";
								_this8.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
							}).catch(function () {
								return _this8.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
							});

							//tagueamento GA
							_context8.next = 12;
							return this.taggingGA();

						case 12:
						case "end":
							return _context8.stop();
					}
				}
			}, _callee8, this);
		}));

		function created() {
			return _ref.apply(this, arguments);
		}

		return created;
	}()
});

/***/ }),

/***/ "40xQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_hub_consulta_client_js__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__ = __webpack_require__("Du/2");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      alreadyAccount: "Já tenho uma conta",
      titleForm: "Inicie seu cadastro para ver as oportunidades de investimento",
      newAccount: {
        fullname: "",
        email: "",
        tel: "",
        password: ""
      },
      allowTerms: false,
      emailDeliverable: false,
      hasError: {
        name: false,
        email: false,
        password: false
      },
      disable: false
    };
  },

  methods: {
    createAccount: function createAccount() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var valid;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.disable = true;
                _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["c" /* START_LOADING */]);
                _context.next = 4;
                return _this.validadeFields();

              case 4:
                valid = _context.sent;

                if (valid) _this.$emit('newAccount', _this.newAccount);
                _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    validadeFields: function validadeFields() {

      if (!this.validateName()) return;
      if (!this.validateEmail()) return;
      if (!this.validatePassword()) return;

      var validEmail = this.emailDeliverable;
      if (!validEmail) {
        this.hasError.email = true;
        this.$Notify.error('O e-mail informado é inválido!');
        return false;
      }

      var aggredTerms = this.allowTerms;
      if (!aggredTerms) this.$Notify.error('É necessário concordar com os termos de uso para continuar o cadastro!');

      return validEmail && aggredTerms;
    },
    validateName: function validateName() {
      var fullname = this.newAccount.fullname;

      var hasName = fullname.trim().length > 0;
      var isFullName = fullname.split(' ')[1] ? fullname.split(' ')[1].length > 1 : false;

      if (!hasName) {
        this.hasError.name = true;
        this.$Notify.error('É necessário informar o nome completo!');
        return false;
      }

      if (!isFullName) {
        this.hasError.name = true;
        this.$Notify.error('É necessário informar o nome completo!');
        return false;
      }

      this.hasError.name = false;
      return true;
    },
    validateEmail: function validateEmail() {
      var email = this.newAccount.email;

      var hasEmail = email.trim().length > 0;
      var hasEmailBody = email.includes("@");

      if (!hasEmail) {
        this.hasError.email = true;
        this.$Notify.error('Campo de email é obrigatório!');
        return false;
      }

      if (!hasEmailBody) {
        this.hasError.email = true;
        this.$Notify.error('Campo de email está no formato incorreto!');
        return false;
      }

      this.hasError.email = false;
      return true;
    },
    validatePassword: function validatePassword() {
      var password = this.newAccount.password;

      var hasPassword = password.trim().length >= 6;

      if (!hasPassword) {
        this.hasError.password = true;
        this.$Notify.error('O campo de senha deve conter pelo menos 6 dígitos!');
        return false;
      }

      this.hasError.password = false;
      return true;
    },
    isEmailDeliverable: function isEmailDeliverable() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var email;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                email = _this2.newAccount.email;

                __WEBPACK_IMPORTED_MODULE_2__utils_hub_consulta_client_js__["a" /* default */].theCheckerPost(email).then(function (resposta) {
                  if (resposta == "Entregável") {
                    _this2.$Notify.info('Email validado com sucesso!');
                    _this2.emailDeliverable = true;
                  } else {
                    _this2.hasError.email = true;
                    _this2.emailDeliverable = false;
                    _this2.$Notify.error('Email informado é inválido!');
                  }
                }).catch(function (resposta) {
                  // Para eventuais problemas no HUB ou THE CHECKER, o email sempre será validado
                  console.log("RESPOSTA ERRO: " + resposta);
                  _this2.emailDeliverable = true;
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    videoask: function videoask() {
      window.VIDEOASK_EMBED_CONFIG = {
        "kind": "widget",
        "url": "https://www.videoask.com/fwvmh15n8",
        "options": {
          "widgetType": "VideoThumbnailWindowTall",
          "text": "Olá, bem vindo(a)! 👋",
          "backgroundColor": "#00D9C5",
          "position": "bottom-right"
        }
      };
      var script = document.createElement("script");
      script.src = "https://www.videoask.com/embed/embed.js";
      document.getElementsByTagName("body")[0].appendChild(script);
    }
  },

  created: function created() {
    this.videoask();
  }
});

/***/ }),

/***/ "415U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"NaturezaOcupacao"}},[_vm._v("\n            Natureza Ocupação\n          ")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.currentUser.Pessoal.NaturezaOcupacao),callback:function ($$v) {_vm.$set(_vm.currentUser.Pessoal, "NaturezaOcupacao", $$v)},expression:"currentUser.Pessoal.NaturezaOcupacao"}},_vm._l((_vm.occupations),function(occupation,index){return _c('at-option',{key:("occupationsOptions" + index),attrs:{"value":occupation.value}},[_vm._v(_vm._s(occupation.label))])}),1)],1),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Natureza da Ocupação")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "43e/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finishedLoading)?_c('div',{staticClass:"col-12 col-lg-8"},[_c('section',[_c('div',{staticClass:"tit"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"rating float-right"},[_c('strong',[_vm._v("\n                    Score da operação\n                    "),_c('span',{staticClass:"circle score"}),_vm._v("\n                    "+_vm._s(_vm.score)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Valor Solicitado\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.money(_vm.solicitacao.ValorSolicitado))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Valor Aprovado\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.money(_vm.solicitacao.Valor))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Duração\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        "+_vm._s(_vm.prazo)+" meses\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Valor da parcela\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.valorParcela)+"\n                    ")])])]),_vm._v(" "),(_vm.solicitacao.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Juros\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        "+_vm._s(_vm.taxaJuros)+"% a.m.\n                    ")])])]):_vm._e(),_vm._v(" "),(_vm.solicitacao.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Taxa total efetiva\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.taxaTotal)+"% a.a.\n                    ")])])]):_vm._e(),_vm._v(" "),(_vm.solicitacao.TaxaIouu != undefined && _vm.solicitacao.TaxaIouu != 0)?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Taxa IOUU")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.solicitacao.TaxaIouu == undefined ?"-":_vm.money(_vm.solicitacao.TaxaIouu)))])])]):_vm._e(),_vm._v(" "),(_vm.solicitacao.TaxaIouu != undefined && _vm.solicitacao.TaxaIouu != 0)?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor Liquido")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.solicitacao.ValorLiquido == undefined ?"-":_vm.money(_vm.solicitacao.ValorLiquido)))])])]):_vm._e()])]),_vm._v(" "),_c('section',[_c('h3',[_vm._v("\n            Captação de recursos (investidores)\n        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"box no-color"},[_c('label',[_vm._v("\n                        Inicio/Término\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        "+_vm._s(_vm.dataInicio)+" - "+_vm._s(_vm.dataFim)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"box no-color"},[_c('label',[_vm._v("\n                        Total de Investidores\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        "+_vm._s(_vm.investidores)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"box no-color"},[_c('label',[_vm._v("\n                        Valor total captado\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.valorCaptado)+"\n                        "),_c('span',{staticClass:"percent"},[_vm._v("\n                            "+_vm._s(_vm.percentValorCaptado)+"%\n                        ")])])])])])]),_vm._v(" "),_c('section',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.razaoSocial))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("CPF/CNPJ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formattedCnpj))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Nome do responsável")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.nomeResponsavel))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Nome fantasia")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.razaoSocial))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Telefone comercial")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.telefone))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('label',[_vm._v("Endereço")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.Endereco))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 col-xl-4"},[_c('label',[_vm._v("\n                    Email\n                ")]),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(_vm.email)+"\n                ")])])])]),_vm._v(" "),_c('section',[_c('h4',[_vm._v("\n            Sobre a empresa\n        ")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.sobreEmpresa)}})]),_vm._v(" "),_c('section',[_c('h3',[_vm._v("\n            Documentos\n        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('a',{staticClass:"docs",attrs:{"href":_vm.lpUrl+'/termos-e-condicoes/'}},[_vm._v("\n                    Termos e Condições\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('a',{staticClass:"docs",attrs:{"href":_vm.lpUrl+'/politica-de-privacidade/'}},[_vm._v("\n                    Politica de Privacidade\n                ")])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left"},[_c('h3',[_vm._v("\n                    Dados financeiros \n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('div',{staticClass:"float-left"},[_c('h3',[_vm._v("\n                    Dados da Empresa\n                ")])]),_vm._v(" "),_c('div',{staticClass:"float-right"}),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Empresa\n                    "),_c('span',[_vm._v("(Razão social)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "443W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.finishedLoading),expression:"finishedLoading"}],staticClass:"user-profile ccbs"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 tit_page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"back float-right text-right"},[_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"back"},[_vm._v(" ")]),_vm._v(" "),_c('span',[_vm._v("Voltar")])])])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row ccbs__title"},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v(_vm._s((_vm.solicitacao.Empresa.NomeFantasia == undefined || _vm.solicitacao.Empresa.NomeFantasia == "")? _vm.solicitacao.Empresa.RazaoSocial : _vm.solicitacao.Empresa.NomeFantasia))])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row ccbs__info"},[_c('div',{staticClass:"col-12 col-md-7 col-lg-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Valor solicitado")]),_vm._v(" "),_c('span',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.solicitacao.Valor)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Duração")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.Prazo)+" Meses")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Valor total do empréstimo")]),_vm._v(" "),_c('span',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.solicitacao.Prazo*_vm.solicitacao.ValorParcela)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Valor da parcela")]),_vm._v(" "),_c('span',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.solicitacao.ValorParcela)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Juros")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatCurrency(_vm.solicitacao.TaxaJuros))+"% a.m. ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Taxa total efetiva")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatCurrency(_vm.solicitacao.CustoEfetivoTotalaa))+"% a.a.")])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Início / Término")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.toLocaleDateString(_vm.solicitacao.InicioCaptacao))+" - "+_vm._s(_vm.toLocaleDateString(_vm.solicitacao.FimCaptacao)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Total de investidores")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.QuantidadeReservasInvestimento))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Valor total captado")]),_vm._v(" "),_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-8"},[_c('span',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.solicitacao.ValorCaptado)))])]),_vm._v(" "),_c('div',{staticClass:"col-4 text-right"},[_c('span',{staticClass:"text-success"},[_vm._v(_vm._s(_vm.formatCurrency((_vm.solicitacao.ValorCaptado/_vm.solicitacao.Valor) * 100))+"%")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.reservas),function(pag,index){return _c('tr',{key:pag._id},[_c('th',{staticClass:"align-middle",attrs:{"scope":"row"}},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('span',{staticClass:"d-flex align-items-center"},[_c('img',{attrs:{"src":"/static/assets/images/ico-pdf.png","alt":"icone ccb"}}),_vm._v(" "),_c('small',[_vm._v(_vm._s(pag.CodigoBMP))])])]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('a',{staticClass:"btn btn-sm btn-link",attrs:{"href":_vm.CCB_URL+"/imprimirccb.aspx?code="+pag.CodigoBMP+"&copias=1","target":"_blank","title":"Visualizar CCB"}},[_vm._v("Visualizar")])])])}),0)])])])])]),_vm._v(" "),_c('aside',{staticClass:"col-12 col-md-5 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3 p-md-4"},[(_vm.passo!= 4)?_c('div',{staticClass:"box-form"},[_c('img',{staticClass:"ico-atencao",attrs:{"src":"/static/assets/images/ico-atencao-ccb.svg","alt":"icone atenção"}}),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.Nome())+", falta assinar sua CCB")]),_vm._v(" "),_c('ul',{staticClass:"list-group"},[_c('h4',[_vm._v("Confirmação dos assinantes")]),_vm._v(" "),_vm._l((_vm.solicitacao.Empresa.Socios),function(soc,index){return _c('li',{staticClass:"list-group-item d-flex justify-content-between align-items-center"},[_c('span',{staticClass:"socio"},[_vm._v(_vm._s(soc.Nome)),_c('small',[_vm._v(" "),(_vm.VerificaAssinou(soc) != 'ok')?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.ReenviarEmail(soc)}}},[_vm._v("Reenviar email")]):_vm._e()])]),_vm._v(" "),_c('span',{class:"sing sing-"+ _vm.VerificaAssinou(soc)})])}),_vm._v(" "),_vm._l((_vm.solicitacao.Empresa.Avalistas),function(soc,index){return _c('li',{staticClass:"list-group-item d-flex justify-content-between align-items-center"},[_c('span',{staticClass:"socio"},[_vm._v(_vm._s(soc.Nome)),_c('small',[_vm._v(" "),(_vm.VerificaAssinou(soc) != 'ok')?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.ReenviarEmail(soc)}}},[_vm._v("Reenviar email")]):_vm._e()])]),_vm._v(" "),_c('span',{class:"sing sing-"+ _vm.VerificaAssinou(soc)})])})],2),_vm._v(" "),(this.passo == 1)?_c('form',[(!_vm.AssinaturaAssinantesOK())?_c('span',{staticClass:"text"},[_vm._v("Só é possível assinar quando todos os sócios/avalistas validarem o token enviado por email.")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"disabled":!_vm.AssinaturaAssinantesOK()},on:{"click":function($event){$event.preventDefault();_vm.passo = 2;}}},[_vm._v("Assinar")])]):_vm._e(),_vm._v(" "),(this.passo == 2)?_c('form',[_c('span',{staticClass:"text"},[_vm._v("Por favor insira sua senha no campo abaixo para finalizar a assinatura de sua CCB.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control form-control-lg",attrs:{"type":"password","placeholder":"Sua senha aqui"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",on:{"click":function($event){$event.preventDefault();return _vm.ValidarSenha()}}},[_vm._v("Assinar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-link btn-block",on:{"click":function($event){$event.preventDefault();_vm.passo = _vm.passo-1}}},[_vm._v("Cancelar")])]):_vm._e(),_vm._v(" "),(this.passo == 3)?_c('form',[_c('span',{staticClass:"text"},[_vm._v("Por favor insira o token que foi enviado para o seu celular para finalizar a assinatura de sua CCB.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.smsToken),expression:"smsToken"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Digite seu token aqui"},domProps:{"value":(_vm.smsToken)},on:{"input":function($event){if($event.target.composing){ return; }_vm.smsToken=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",on:{"click":function($event){$event.preventDefault();return _vm.ValidarToken()}}},[_vm._v("Validar Token")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-link btn-block",on:{"click":function($event){$event.preventDefault();_vm.passo = _vm.passo-1}}},[_vm._v("Cancelar")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.passo== 4)?_c('div',{staticClass:"box-confirm"},[_c('img',{attrs:{"src":"/static/assets/images/icon-success.svg","alt":"icone ok"}}),_vm._v(" "),_c('h5',[_vm._v("Obrigado, "+_vm._s(_vm.Nome())+".")]),_vm._v(" "),_c('p',[_vm._v("As CCB’s foram assinadas com sucesso!")])]):_vm._e()])])])]),_vm._v(" "),(!_vm.finishedLoading)?_c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard"},[_vm._m(3)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("Assinatura CCB")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt-2 mb-3"},[_c('h3',[_vm._v("Captação de recursos (investidores)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Lista de CCB’s")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard__complete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Carregando as CCBs...")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Anj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var social = this.currentUser.Social;
    return {
      Facebook: social ? social.Facebook : null,
      Linkedin: social ? social.Linkedin : null
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      this.currentUser.Social.Facebook = this.Facebook;
      this.currentUser.Social.Linkedin = this.Linkedin;

      this.$emit('on-submit', { Social: this.currentUser.Social });
    }
  },
  created: function created() {
    if (!this.currentUser.Social) this.currentUser.Social = {};
  }
});

/***/ }),

/***/ "4Hrp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_array_helper__ = __webpack_require__("rzJh");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            Loan: null,
            Diferenca: 0,
            Aguarde: '',
            AprovadoCliente: false
        };
    },

    methods: {
        formatted: function formatted(doc) {
            doc = doc.replace(/\D/g, '');

            if (doc.length > 12) return __WEBPACK_IMPORTED_MODULE_6__utils_masker__["a" /* default */].maskCnpj(doc);

            return __WEBPACK_IMPORTED_MODULE_6__utils_masker__["a" /* default */].maskCpf(doc);
        },
        formatenome: function formatenome(nome) {
            nome = nome != null ? nome.trim() : "";
            if (nome.indexOf(" ") != -1) {
                nome = nome.split(" ")[0];
                return nome.substring(0, 1).toUpperCase() + nome.substring(1);
            }

            return nome.substring(0, 1).toUpperCase() + nome.substring(1);
        },

        /*lowerCase(texto) {
          if (texto == null || texto == undefined || texto == "") return "";
           if (texto == "AA" || texto == "HR") return texto.toLowerCase();
           return texto[0].toLowerCase();
        },*/
        ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
            var s = String(id);

            if (id == undefined || id == 0) return "";

            while (s.length < (qtd || 2)) {
                s = "0" + s;
            }
            return "#" + s;
        },
        documentos: function documentos(type, id) {
            return "/emprestimos/pre-aprovado-detalhes?type=" + type + "&id=" + id;
        },
        Detalhes: function Detalhes(type, id) {
            return "/emprestimos/detalhes-do-emprestimo?type=" + type + "&id=" + id;
        },


        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/emprestimos/pre-aprovado',
                title: 'Pré Aprovado'
            });
        }
    },
    computed: {
        //Retorna os dados do usuário que está acessando em um objeto 'User'
        User: function User() {
            return this.$store.state.currentUser;
        }
        /*Show: function() {
            const query = this.$route.query;
             if(query.detalhe == '1')
                return false;
             return true;
        }*/
    },
    components: { Modal: __WEBPACK_IMPORTED_MODULE_3__components_Modal__["a" /* default */] },
    beforeCreate: function beforeCreate() {
        var _this = this;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);
        var query = this.$route.query;
        /*if(query.detalhe == null) {
            this.show = false
        }*/
        //Retorna o empréstimo de acordo com o ID em um objeto emprestimo
        __WEBPACK_IMPORTED_MODULE_5__utils_api_client__["a" /* default */].GetMeuEmprestimo(query.id).then(function (response) {
            _this.Loan = response;
            //Tratamento de usuários que já estavam no banco antes da atualização dos status
            if (_this.Loan[0].AprovadoCliente == undefined && _this.Loan[0].StatusAnalise == "APROVADO") {
                _this.AprovadoCliente = true;
            }

            if (_this.Loan[0].FinishedDate != undefined && (_this.Loan[0].StatusAnalise != "NEGADO" || _this.Loan[0].StatusAnalise != "NEGADO_" || _this.Loan[0].Status != "NEGADO")) {
                var miliSecs = new Date(_this.Loan[0].FinishedDate) - new Date();
                var diffDays = -1 * __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(miliSecs / 1000 / 60 / 60 / 24);
                //Modifica a animação de acordo com a data de Criação da proposta (Prazo de 48 horas)
                if (_this.Loan[0].StatusAguarde == '25%') {
                    _this.Diferenca = diffDays;

                    if (diffDays == 1) _this.Aguarde = '50%';else if (diffDays > 1) _this.Aguarde = '75%';else _this.Aguarde = '25%';
                }
            } else if (_this.Loan[0].StatusAguarde != '100%' && (_this.Loan[0].StatusAnalise != "NEGADO" || _this.Loan[0].StatusAnalise != "NEGADO_" || _this.Loan[0].Status != "NEGADO")) {
                _this.Aguarde = '75%';
            }

            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
        }).catch(function () {
            return _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    },
    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this2.taggingGA();

                        case 2:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    }
});

/***/ }),

/***/ "4MNs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_wallet__ = __webpack_require__("c/xH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_pdf_helper__ = __webpack_require__("WTek");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      investor: null,
      tranferencia: null,
      detalhesOperacao: null,
      type: "teste",
      loading: false,
      loadingTransaction: false,
      loadingBank: false,
      ted: "0,00",
      currentPage: 0,
      pageCount: 0
    };
  },


  methods: {
    FV: function FV(rate, periods, payment, value, type) {
      // Credits: algorithm inspired by Apache OpenOffice

      // Initialize type
      type = typeof type === 'undefined' ? 0 : type;

      // Evaluate rate (TODO: replace with secure expression evaluator)
      rate = eval(rate);

      // Return future value
      var result;
      if (rate === 0) {
        result = value + payment * periods;
      } else {
        var term = Math.pow(1 + rate, periods);
        if (type === 1) {
          result = value * term + payment * (1 + rate) * (term - 1.0) / rate;
        } else {
          result = value * term + payment * (term - 1) / rate;
        }
      }

      // result = Math.round(result * 100) / 100;

      return -result;
    },
    IPMT: function IPMT(rate, period, periods, present, future, type) {
      // Credits: algorithm inspired by Apache OpenOffice

      // Initialize type
      type = typeof type === 'undefined' ? 0 : type;

      // Initialize future
      future = typeof future === 'undefined' ? 0 : future;

      // Evaluate rate and periods (TODO: replace with secure expression evaluator)
      rate = eval(rate);
      periods = eval(periods);

      // Compute payment
      var payment = this.PMT(rate, periods, present, future, type);

      // Compute interest
      var interest;
      if (period === 1) {
        if (type === 1) {
          interest = 0;
        } else {
          interest = -present;
        }
      } else {
        if (type === 1) {
          interest = this.FV(rate, period - 2, payment, present, 1) - payment;
        } else {
          interest = this.FV(rate, period - 1, payment, present, 0);
        }
      }

      var result = interest * rate;
      // result = Math.round(result * 100) / 100;

      // Return interest
      return interest * rate;
    },
    PMT: function PMT(rate, periods, present, future, type) {
      // Credits: algorithm inspired by Apache OpenOffice

      // Initialize type
      type = typeof type === 'undefined' ? 0 : type;

      // Initialize future
      future = 0;

      // Evaluate rate (TODO: replace with secure expression evaluator)
      rate = eval(rate);

      // Return payment
      var result;
      if (rate === 0) {
        result = (present + future) / periods;
      } else {
        var term = Math.pow(1 + rate, periods);
        if (type === 1) {
          result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
        } else {
          result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
        }
      }

      // result = Math.round(result * 100) / 100;

      return -result;
    },
    formatCurrency: function formatCurrency(value) {
      if (value != null) return "R$ " + value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });

      return 0;
    },
    formatReal: function formatReal(num) {
      var real = void 0;
      real = parseFloat(num.replace(/[^\d]+/g, '')) / 100;
      return real;
    },
    formatDate: function formatDate(date) {

      var spliter = date.split("T");
      var newDate = spliter[0].split('-');
      var time = spliter[1].split(':');

      return newDate[2] + '/' + newDate[1] + '/' + newDate[0];
    },
    savePdf: function savePdf() {
      __WEBPACK_IMPORTED_MODULE_6__utils_pdf_helper__["a" /* default */].Save('cupom', this.idComprovante);
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_6__utils_pdf_helper__["a" /* default */].Print('cupom', this.idComprovante);
    },
    getIndiceFatura: function getIndiceFatura(indice) {
      return indice != null ? indice + 1 : "";
    }
  },
  computed: {

    idComprovante: function idComprovante() {
      return this.$route.params.id;
    },
    dataOperacao: function dataOperacao() {
      if (this.detalhesOperacao && this.detalhesOperacao.Data) return this.formatDate(this.detalhesOperacao.Data);
      return "";
    },
    nomeEmpresa: function nomeEmpresa() {
      if (this.detalhesOperacao && this.detalhesOperacao.Detalhes && this.detalhesOperacao.Detalhes.Pagamento && this.detalhesOperacao.Detalhes.Pagamento.NomeEmpresa) return this.detalhesOperacao.Detalhes.Pagamento.NomeEmpresa;
      return "";
    },
    recebimentoParcela: function recebimentoParcela() {
      if (this.detalhesOperacao && this.detalhesOperacao.Detalhes && this.detalhesOperacao.Detalhes.Pagamento) return this.detalhesOperacao.Detalhes.Pagamento.IndiceParcela + ' / ' + this.detalhesOperacao.Detalhes.Pagamento.Prazo;
    },
    valorPrincipal: function valorPrincipal() {
      if (this.detalhesOperacao.Detalhes.Pagamento.Ipmt && this.detalhesOperacao.Detalhes.Pagamento.Multa) {
        return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.ValorBruto - this.detalhesOperacao.Detalhes.Pagamento.Ipmt - this.detalhesOperacao.Detalhes.Pagamento.Multa);
      } else if (!this.detalhesOperacao.Detalhes.Pagamento.Multa && !this.detalhesOperacao.Detalhes.Pagamento.Ipmt) {
        return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.ValorBruto);
      } else if (!this.detalhesOperacao.Detalhes.Pagamento.Ipmt) {
        return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.ValorBruto - this.detalhesOperacao.Detalhes.Pagamento.Multa);
      }
      return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.ValorBruto - this.detalhesOperacao.Detalhes.Pagamento.Ipmt);
    },
    juros: function juros() {
      if (this.detalhesOperacao && this.detalhesOperacao.Detalhes && this.detalhesOperacao.Detalhes.Pagamento && this.detalhesOperacao.Detalhes.Pagamento.Ipmt) return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.Ipmt);else return this.formatCurrency(0);
    },
    multa: function multa() {
      if (this.detalhesOperacao && this.detalhesOperacao.Detalhes && this.detalhesOperacao.Detalhes.Pagamento && this.detalhesOperacao.Detalhes.Pagamento.Multa) return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.Multa);else return this.formatCurrency(0);
    },
    valorBruto: function valorBruto() {
      if (this.detalhesOperacao && this.detalhesOperacao.Detalhes && this.detalhesOperacao.Detalhes.Pagamento) return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.ValorBruto);
    },
    ir: function ir() {
      if (this.detalhesOperacao && this.detalhesOperacao.Detalhes && this.detalhesOperacao.Detalhes.Pagamento && this.detalhesOperacao.Detalhes.Pagamento.Ir) return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.Ir);else return this.formatCurrency(0);
    },
    documento: function documento() {
      if (this.detalhesOperacao && this.detalhesOperacao.Detalhes && this.detalhesOperacao.Detalhes.Pagamento) return __WEBPACK_IMPORTED_MODULE_5__utils_masker__["a" /* default */].maskCnpj(this.detalhesOperacao.Detalhes.Pagamento.DocumentoEmpresa);
    },
    valorLiquido: function valorLiquido() {
      return this.formatCurrency(this.detalhesOperacao.Valor);
    },


    CalcLiquid: function CalcLiquid() {
      var ipmt = void 0,
          RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
          IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
          Prazo = this.transferencia.SolicitacaoID.Prazo,
          Valor = this.transferencia.ReservaInvestimentoID.Valor,
          aliqIR = void 0,
          Ir = void 0;

      ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
      ipmt = Math.round(ipmt * 100) / 100;

      if (IndiceFatura >= 1 && IndiceFatura < 6) aliqIR = 0.225;else if (IndiceFatura >= 6 && IndiceFatura < 12) aliqIR = 0.2;else if (IndiceFatura >= 12 && IndiceFatura < 24) aliqIR = 0.175;else aliqIR = 0.15;

      Ir = ipmt * aliqIR;

      return this.formatCurrency(this.transferencia.Valor - Ir);
    },
    CalcIR: function CalcIR() {
      var ipmt = void 0,
          RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
          IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
          Prazo = this.transferencia.SolicitacaoID.Prazo,
          Valor = this.transferencia.ReservaInvestimentoID.Valor,
          aliqIR = void 0;

      ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
      ipmt = Math.round(ipmt * 100) / 100;

      if (IndiceFatura >= 1 && IndiceFatura < 6) aliqIR = 0.225;else if (IndiceFatura >= 6 && IndiceFatura < 12) aliqIR = 0.2;else if (IndiceFatura >= 12 && IndiceFatura < 24) aliqIR = 0.175;else aliqIR = 0.15;

      return this.formatCurrency(ipmt * aliqIR);
    },
    CalcJuros: function CalcJuros() {
      var ipmt = void 0,
          RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
          IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
          Prazo = this.transferencia.SolicitacaoID.Prazo,
          Valor = this.transferencia.ReservaInvestimentoID.Valor;

      ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
      ipmt = Math.round(ipmt * 100) / 100;

      console.log(this.transferencia);

      return this.formatCurrency(ipmt);
    },

    CalcMulta: function CalcMulta() {
      if (this.transferencia.Juros != undefined && this.transferencia.Juros > 0) return this.transferencia.Juros;

      return 0;
    },
    CalcCapital: function CalcCapital() {
      var ipmt = void 0,
          RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
          IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
          Prazo = this.transferencia.SolicitacaoID.Prazo,
          Valor = this.transferencia.ReservaInvestimentoID.Valor;

      ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
      ipmt = Math.round(ipmt * 100) / 100;

      if (this.transferencia.Ipmt > 0) ipmt = this.transferencia.Ipmt;

      if (this.transferencia.Juros == undefined || this.transferencia.Juros == null) this.transferencia.Juros = 0;

      return this.formatCurrency(this.transferencia.Valor - this.transferencia.Juros - ipmt);
    },
    DocumentoEmpresa: function DocumentoEmpresa() {
      return __WEBPACK_IMPORTED_MODULE_5__utils_masker__["a" /* default */].maskCpf(this.transferencia.SolicitacaoID.Documento);
    },
    valor: function valor() {
      return this.formatCurrency(this.transferencia.Valor);
    },
    impostoRenda: function impostoRenda() {
      return this.formatCurrency(this.transferencia.IR);
    },
    valorComTed: function valorComTed() {
      return this.formatCurrency(this.transferencia.Valor - this.formatReal(this.ted));
    },
    nome: function nome() {
      return this.investor.NomeCompleto;
    },
    nomeBanco: function nomeBanco() {
      if (this.investor != null && this.investor.DadosBancarios != null && this.bank != null) return this.bank.length > 0 ? this.bank[0].nome : 'Outro - Codigo do banco: ' + this.investor.DadosBancarios.CodigoBanco;

      return "";
    },
    tipoConta: function tipoConta() {
      if (this.transferencia != null && this.transferencia.DadosBancarios != null) return this.transferencia.DadosBancarios.TipoConta === 1 ? "Conta Corrente" : "Conta Poupança";
      return "";
    },
    NumeroConta: function NumeroConta() {
      if (this.transferencia != null && this.transferencia.DadosBancarios != null) return this.transferencia.DadosBancarios.Conta;
      return "";
    },
    agencia: function agencia() {

      if (this.transferencia != null && this.transferencia.DadosBancarios != null) return this.transferencia.DadosBancarios.Agencia;
      return "";
    },
    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/carteira-investimento/comprovante/pagamento/:id',
        title: 'ComprovantePagamento'
      });
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:

              _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__services_api_wallet__["a" /* default */].GetDetalhesOperacao(_this.$route.params.id);

            case 3:
              _ref = _context.sent;
              data = _ref.data;


              if (data) {

                _this.detalhesOperacao = data;

                console.log("Detalhes");
                console.log(_this.detalhesOperacao);
              } else {
                console.warn("error request");
              }

              _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
              //tagueamento GA
              _context.next = 9;
              return _this.taggingGA();

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "4O7e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("96tf");



var _this = this;


var BASE_URI_GO_API = "https://api.iouu.com.br" + '/api/v1';

var GetListagemSolicitacoesProcesso = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(pagina) {
        var quantidade;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        quantidade = 10;
                        _context.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/central-cobranca/lista/' + quantidade + '/' + pagina);

                    case 4:
                        return _context.abrupt('return', _context.sent);

                    case 7:
                        _context.prev = 7;
                        _context.t0 = _context['catch'](0);
                        throw new Error('Erro ao carregar listagem das solicita\xE7\xF5es');

                    case 10:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this, [[0, 7]]);
    }));

    return function GetListagemSolicitacoesProcesso(_x) {
        return _ref.apply(this, arguments);
    };
}();
var GetTotalSolicitacoesProcesso = function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.prev = 0;
                        _context2.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/central-cobranca/total');

                    case 3:
                        return _context2.abrupt('return', _context2.sent);

                    case 6:
                        _context2.prev = 6;
                        _context2.t0 = _context2['catch'](0);
                        throw new Error('Erro ao carregar total dos status de solicita\xE7\xF5es');

                    case 9:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this, [[0, 6]]);
    }));

    return function GetTotalSolicitacoesProcesso() {
        return _ref2.apply(this, arguments);
    };
}();
var GetDetalheSolicitacaoProcesso = function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(solicitacaoID) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.prev = 0;
                        _context3.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/central-cobranca/detalhe/solicitacao/' + solicitacaoID);

                    case 3:
                        return _context3.abrupt('return', _context3.sent);

                    case 6:
                        _context3.prev = 6;
                        _context3.t0 = _context3['catch'](0);
                        throw new Error('Erro ao carregar detalhe da solicita\xE7\xE3o');

                    case 9:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this, [[0, 6]]);
    }));

    return function GetDetalheSolicitacaoProcesso(_x2) {
        return _ref3.apply(this, arguments);
    };
}();
var GetDetalheNotificacoesProcesso = function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(solicitacaoID) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.prev = 0;
                        _context4.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/central-cobranca/detalhe/notificacoes/' + solicitacaoID);

                    case 3:
                        return _context4.abrupt('return', _context4.sent);

                    case 6:
                        _context4.prev = 6;
                        _context4.t0 = _context4['catch'](0);
                        throw new Error('Erro ao carregar detalhe das notifica\xE7\xF5es');

                    case 9:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, _this, [[0, 6]]);
    }));

    return function GetDetalheNotificacoesProcesso(_x3) {
        return _ref4.apply(this, arguments);
    };
}();

var GetListagemSolicitacoesProcessoFiltro = function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(pagina, status) {
        var quantidade;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.prev = 0;
                        quantidade = 10;
                        _context5.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/central-cobranca/lista/' + quantidade + '/' + pagina + '/' + status);

                    case 4:
                        return _context5.abrupt('return', _context5.sent);

                    case 7:
                        _context5.prev = 7;
                        _context5.t0 = _context5['catch'](0);
                        throw new Error('Erro ao carregar listagem das solicita\xE7\xF5es');

                    case 10:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, _this, [[0, 7]]);
    }));

    return function GetListagemSolicitacoesProcessoFiltro(_x4, _x5) {
        return _ref5.apply(this, arguments);
    };
}();

/* harmony default export */ __webpack_exports__["a"] = ({ GetListagemSolicitacoesProcesso: GetListagemSolicitacoesProcesso, GetTotalSolicitacoesProcesso: GetTotalSolicitacoesProcesso, GetDetalheSolicitacaoProcesso: GetDetalheSolicitacaoProcesso, GetDetalheNotificacoesProcesso: GetDetalheNotificacoesProcesso, GetListagemSolicitacoesProcessoFiltro: GetListagemSolicitacoesProcessoFiltro });

/***/ }),

/***/ "4Rqm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4VZC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HasBankDebtStep_vue__ = __webpack_require__("ZA0D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6349aa9b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HasBankDebtStep_vue__ = __webpack_require__("L9k6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HasBankDebtStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6349aa9b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HasBankDebtStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4WV/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal__ = __webpack_require__("/o5o");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Modal: __WEBPACK_IMPORTED_MODULE_1__components_Modal__["a" /* default */] },

  data: function data() {
    var investor = this.investor;
    return {
      showModal: false,
      rendaMensal: investor.RendaMensal ? investor.RendaMensal.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }) : null,
      patrimonio: investor.Patrimonio ? investor.Patrimonio.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }) : null,
      pessoaPoliticamenteExposta: investor.PessoaPoliticamenteExposta
    };
  },

  props: {
    investor: { type: Object, required: true }
  },
  methods: {
    validaRenda: function validaRenda(e) {
      if (__WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].formatReal(e.target.value) <= 0) {
        this.rendaMensal = '';
      }
    },
    submit: function submit() {
      this.$emit('submit', {
        RendaMensal: __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].formatReal(this.rendaMensal),
        Patrimonio: __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].formatReal(this.patrimonio),
        PessoaPoliticamenteExposta: this.pessoaPoliticamenteExposta
      });
    },
    closeModal: function closeModal() {
      this.showModal = false;
    }
  }
});

/***/ }),

/***/ "4XQ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StepBackButton__ = __webpack_require__("g50h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AdditionalInformationPersonalLoan_FullNameStep__ = __webpack_require__("WfA/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AdditionalInformationPersonalLoan_ContactsStep_vue__ = __webpack_require__("17al");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AdditionalInformationPersonalLoan_OccupationKindStep_vue__ = __webpack_require__("Z20F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AdditionalInformationPersonalLoan_BaseSalaryStep_vue__ = __webpack_require__("TeIP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AdditionalInformationPersonalLoan_AdditionalIncomeStep_vue__ = __webpack_require__("szOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AdditionalInformationPersonalLoan_MaritalStatusStep_vue__ = __webpack_require__("uQ9E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AdditionalInformationPersonalLoan_NationalityStep_vue__ = __webpack_require__("HvRq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AdditionalInformationPersonalLoan_GenreStep_vue__ = __webpack_require__("JKi6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AdditionalInformationPersonalLoan_CityStep_vue__ = __webpack_require__("UgkD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AdditionalInformationPersonalLoan_ScholarityStep_vue__ = __webpack_require__("14kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_AdditionalInformationPersonalLoan_AddressStep_vue__ = __webpack_require__("CD5J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_AdditionalInformationPersonalLoan_AddressConfirmationStep_vue__ = __webpack_require__("u6H3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_AdditionalInformationPersonalLoan_IdentificationDocumentStep_vue__ = __webpack_require__("Uj+a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_AdditionalInformationPersonalLoan_IdentificationPhotoStep_vue__ = __webpack_require__("wWmm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AdditionalInformationPersonalLoan_AddressDocumentStep__ = __webpack_require__("y2QI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_AdditionalInformationPersonalLoan_PaymentDocumentStep__ = __webpack_require__("V1Hz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_AdditionalInformationPersonalLoan_BankDocumentStep__ = __webpack_require__("UmGH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_AdditionalInformationPersonalLoan_FinishedStep__ = __webpack_require__("ZLtj");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// COMPONENTS STEPS



















var components = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
  'step-back-button': __WEBPACK_IMPORTED_MODULE_3__components_StepBackButton__["a" /* default */],
  'full-name-step': __WEBPACK_IMPORTED_MODULE_5__components_AdditionalInformationPersonalLoan_FullNameStep__["a" /* default */],
  'contacts-step': __WEBPACK_IMPORTED_MODULE_6__components_AdditionalInformationPersonalLoan_ContactsStep_vue__["a" /* default */],
  'occupation-kind-step': __WEBPACK_IMPORTED_MODULE_7__components_AdditionalInformationPersonalLoan_OccupationKindStep_vue__["a" /* default */],
  'base-salary-step': __WEBPACK_IMPORTED_MODULE_8__components_AdditionalInformationPersonalLoan_BaseSalaryStep_vue__["a" /* default */],
  'additional-income-step': __WEBPACK_IMPORTED_MODULE_9__components_AdditionalInformationPersonalLoan_AdditionalIncomeStep_vue__["a" /* default */],
  'marital-status-step': __WEBPACK_IMPORTED_MODULE_10__components_AdditionalInformationPersonalLoan_MaritalStatusStep_vue__["a" /* default */],
  'nationality-step': __WEBPACK_IMPORTED_MODULE_11__components_AdditionalInformationPersonalLoan_NationalityStep_vue__["a" /* default */],
  'genre-step': __WEBPACK_IMPORTED_MODULE_12__components_AdditionalInformationPersonalLoan_GenreStep_vue__["a" /* default */],
  'city-step': __WEBPACK_IMPORTED_MODULE_13__components_AdditionalInformationPersonalLoan_CityStep_vue__["a" /* default */],
  'scholarity-step': __WEBPACK_IMPORTED_MODULE_14__components_AdditionalInformationPersonalLoan_ScholarityStep_vue__["a" /* default */],
  'address-step': __WEBPACK_IMPORTED_MODULE_15__components_AdditionalInformationPersonalLoan_AddressStep_vue__["a" /* default */],
  'address-confirmation-step': __WEBPACK_IMPORTED_MODULE_16__components_AdditionalInformationPersonalLoan_AddressConfirmationStep_vue__["a" /* default */],
  'identification-document-step': __WEBPACK_IMPORTED_MODULE_17__components_AdditionalInformationPersonalLoan_IdentificationDocumentStep_vue__["a" /* default */],
  'identification-photo-step': __WEBPACK_IMPORTED_MODULE_18__components_AdditionalInformationPersonalLoan_IdentificationPhotoStep_vue__["a" /* default */],
  'address-document-step': __WEBPACK_IMPORTED_MODULE_19__components_AdditionalInformationPersonalLoan_AddressDocumentStep__["a" /* default */],
  'payment-document-step': __WEBPACK_IMPORTED_MODULE_20__components_AdditionalInformationPersonalLoan_PaymentDocumentStep__["a" /* default */],
  'bank-document-step': __WEBPACK_IMPORTED_MODULE_21__components_AdditionalInformationPersonalLoan_BankDocumentStep__["a" /* default */],
  'finished-step': __WEBPACK_IMPORTED_MODULE_22__components_AdditionalInformationPersonalLoan_FinishedStep__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = ({
  /* eslint-disable */
  data: function data() {
    return {
      transitionName: 'slide-left',
      solicitacaoId: this.$route.params.id,
      currentUser: null
    };
  },

  components: components,
  computed: {
    currentStepComponent: function currentStepComponent() {
      if (this.currentUser !== null) {

        if (!this.currentUser.Status || this.currentUser.Status === "" || this.currentUser.Status == "LIZA") {
          this.currentUser.Status = "full-name";
        }

        return this.currentUser.Status + "-step";
      } else {
        return this.currentUser;
      }
    },
    progress: function progress() {
      var stepsAmount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(components).length;
      var currentStepNumber = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(components).indexOf(this.currentStepComponent) + 1;
      return Math.round(currentStepNumber * 100 / stepsAmount);
    },
    canGoPrevious: function canGoPrevious() {
      if (!this.currentUser) {
        return false;
      }

      var stepsThatCantGoBack = ['full-name', 'finished', 'cancelado'];
      return !stepsThatCantGoBack.includes(this.currentUser.Status);
    }
  },
  methods: {
    updateUser: function updateUser(newData) {
      var _this = this;

      newData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(newData, { StepType: 'next' });
      this.transitionName = 'slide-left';

      //ApiClient.put_GO(`solicitacoes/${this.solicitacaoId}/personal-loan-informations`, {data: newData})
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].put('solicitacoes/' + this.solicitacaoId + '/personal-loan-informations', { data: newData }).then(function (response) {
        console.log("updateUser", response);
        _this.currentUser = response.data;
      }).catch(function () {
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
      });
    },
    onPrevious: function onPrevious() {
      var _this2 = this;

      this.transitionName = 'slide-right';

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);
      // ApiClient.put_GO(`solicitacoes/${this.solicitacaoId}/personal-loan-informations`, {data: {StepType: 'previous'}})
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].put('solicitacoes/' + this.solicitacaoId + '/personal-loan-informations', { data: { StepType: 'previous' } }).then(function (response) {
        console.log("onPrevious", response);
        _this2.currentUser = response.data;
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
      }).catch(function () {
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
      });
    },
    handleLoadingToggle: function handleLoadingToggle(isLoading) {
      if (isLoading) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);
      } else {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
      }
    }
  },
  created: function created() {
    var _this3 = this;

    var solicitacaoId = this.$route.params.id;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);
    // ApiClient.get_GO(`solicitacoes/${solicitacaoId}`)
    __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get('solicitacoes/' + solicitacaoId).then(function (response) {
      _this3.currentUser = response.data;
      _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
    }).catch(function (error) {
      window.error = error;
      if (error.response && error.response.status == 404) {
        _this3.$router.push('/not-found');
      }

      if (error.response && error.response.status == 401) {
        window.location.href = "#/";
      }
      _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
    });
  },
  beforeUpdate: function beforeUpdate() {
    this.$Loading.update(this.progress);
  }
});

/***/ }),

/***/ "4bJZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wallet"},[_c('div',{staticClass:"row align-items-center wallet__tit-page tit_page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-4 col-md-4 col-lg-4"},[_c('div',{staticClass:"back back-hide float-right"},[_c('router-link',{attrs:{"to":"/investimentos/carteira-investimento","title":"Voltar"}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"funds-transfer__actions box-border"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('form',[_c('fieldset',[_c('h2',[_vm._v("Digite quanto você quer incluir em sua Carteira Virtual")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueSaqueDate),expression:"valueSaqueDate"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"type":"tel","placeholder":"R$ 100,00"},domProps:{"value":(_vm.valueSaqueDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valueSaqueDate=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"disabled":""}},[_vm._v("Confirmar")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"","title":"Cancelar"}},[_vm._v("Cancelar")])],1)])])]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-8 col-md-8 col-lg-8 d-flex align-items-center"},[_c('h1',[_vm._v("Adicionar fundos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center",staticStyle:{"display":"none"}},[_c('div',{staticClass:"col-12 col-md-12 col-lg-7"},[_c('div',{staticClass:"row align-items-center comprovante"},[_c('div',{staticClass:"col-12 col-md-6 d-flex justify-content-sm-center justify-content-md-end"},[_c('div',{staticClass:"coupon",attrs:{"id":"cupom"}},[_c('div',{staticClass:"coupon__head"}),_vm._v(" "),_c('div',{staticClass:"coupon__body"},[_c('img',{attrs:{"src":"/static/assets/images/logotipo-iouu.png","width":"70","alt":"Logotipo IOUU"}}),_vm._v(" "),_c('p',{staticClass:"id"},[_vm._v("COMPROVANTE 0000")]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                                            EFETUADO EM: "),_c('span',[_vm._v("00/00/0000")])]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Para: "),_c('span',[_vm._v("Alexsander Macedo")])]),_vm._v(" "),_c('li',[_vm._v("CPF: "),_c('span',[_vm._v("000.000.000-00")])]),_vm._v(" "),_c('li',[_vm._v("Carteria virutal: "),_c('span',[_vm._v("100001")])]),_vm._v(" "),_c('li',[_vm._v("Valor do depósito: "),_c('span',[_vm._v("R$ 500,00")])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"obs"},[_vm._v("\n                                                    O depósito será confirmado somente após a aprovação do pagamento. Prazo para confirmação de pagamento de boleto é de até 72 horas.\n                                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"coupon__foot"})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"wallet__description"},[_c('h2',[_vm._v("Depósito em carteira virtual")]),_vm._v(" "),_c('div',[_c('p',[_c('strong',{staticClass:"text-black-50"},[_vm._v("Deposito para:")]),_vm._v(" "),_c('span',{staticClass:"text-dark"},[_vm._v("Alexsander Macedo")]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v("049.070.089.61")])]),_vm._v(" "),_c('p',[_c('strong',{staticClass:"text-black-50"},[_vm._v("Valor do depósito:")]),_vm._v(" "),_c('span',{staticClass:"text-success"},[_vm._v("R$ 500,00")])]),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/ico-boleto.svg","width":"52px","alt":"Icone Boleto"}}),_vm._v(" "),_c('a',{staticClass:"btn btn-primary btn-lg",attrs:{"href":"#"}},[_vm._v("Gerar Boleto")]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("\n                                            O depósito será confirmado somente após a aprovação do pagamento. Prazo para confirmação de pagamento de boleto é de até 72 horas.\n                                        ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary btn-lg",attrs:{"title":"Imprimir boleto"}},[_c('i',{staticClass:"fas fa-print"}),_vm._v(" Imprimir comprovante")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary btn-lg",attrs:{"title":"Salvar comprovante"}},[_c('i',{staticClass:"fas fa-download"}),_vm._v(" Salvar comprovante")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4xPj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api_client_go__ = __webpack_require__("879M");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      numeroCelular: this.solicitacao.Celular,
      newCellphone: this.solicitacao.Celular,
      tokenConfirmacao: null,
      isTokenValid: null,
      isCellphoneFieldVisible: false,
      sendSmsAttempt: 1
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    showCellphoneField: function showCellphoneField(e) {
      e.preventDefault();
      this.isCellphoneFieldVisible = true;
    },
    updateCellphone: function updateCellphone() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].put('solicitacoes/' + this.solicitacao._id, { data: { Celular: this.newCellphone } }).then(function () {
        console.log("Funcionou");
        _this.numeroCelular = _this.newCellphone;
        _this.isCellphoneFieldVisible = false;
        _this.$Message.info("Seu número foi atualizado");
      }).catch(function () {
        _this.isCellphoneFieldVisible = false;
        _this.$Message.error("Houve um problema ao tentar atualizar o número");
      });
    },
    handleTokenKeyUp: function handleTokenKeyUp() {
      var _this2 = this;

      if (this.tokenConfirmacao.length == 6) {
        __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].post('checar-token-sms', { data: { TokenConfirmacao: this.tokenConfirmacao, SolicitacaoId: this.solicitacao._id } }).then(function () {
          _this2.isTokenValid = true;
        }).catch(function () {
          _this2.isTokenValid = false;
        });
      } else {
        this.isTokenValid = null;
      }
    },
    resendToken: function resendToken(e) {
      var _this3 = this;

      e.preventDefault();
      this.sendSmsAttempt += 1;
      __WEBPACK_IMPORTED_MODULE_1__utils_api_client_go__["a" /* default */].post('solicitacoes/gerar-token', { data: { solicitacaoId: this.solicitacao._id } }).then(function () {
        _this3.$Message.info("Um novo SMS foi enviado para o seu celular.");
      }).catch(function () {
        _this3.$Message.error("Houve um problema ao tentar enviar o SMS.");
      });
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      this.$emit('on-submit', {
        TokenConfirmacao: this.tokenConfirmacao
      });
    }
  },
  created: function created() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_1__utils_api_client_go__["a" /* default */].post('/solicitacoes/gerar-token', { data: { solicitacaoId: this.solicitacao._id } }).then(function () {
      _this4.$Message.info("Um novo SMS foi enviado para o seu celular.");
    }).catch(function () {
      _this4.$Message.error("Houve um problema ao tentar enviar o SMS.");
    });
  }
});

/***/ }),

/***/ "5+9B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('p',[_vm._v("Agora, precisamos dos extratos bancários dos últimos 4 meses")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "50/t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileEdit_vue__ = __webpack_require__("Elxy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ddc9e8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileEdit_vue__ = __webpack_require__("ljZJ");
function injectStyle (ssrContext) {
  __webpack_require__("SCgy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ddc9e8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ddc9e8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "53Yj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            lpUrl: "https://iouu.com.br",
            finishedLoading: false,
            solicitacao: null
        };
    },

    props: ['id'],
    computed: {
        getId: function getId() {
            return this.id;
        },

        formattedCnpj: function formattedCnpj() {
            return __WEBPACK_IMPORTED_MODULE_2__utils_masker__["a" /* default */].maskCnpj(this.solicitacao.Documento);
        },
        score: function score() {
            return this.solicitacao.Score;
        },
        valor: function valor() {
            if (!this.solicitacao) return null;
            return this.formatCurrency(this.solicitacao.Valor);
        },
        prazo: function prazo() {
            return this.solicitacao.Prazo;
        },
        valorTotal: function valorTotal() {
            if (this.solicitacao.ValorParcela === 0 || this.solicitacao.ValorParcela === undefined) {
                return this.formatCurrency(this.solicitacao.Valor);
            } else {
                return this.formatCurrency(this.solicitacao.ValorParcela * this.solicitacao.Prazo);
            }
        },
        valorParcela: function valorParcela() {

            if (this.solicitacao.ValorParcela === 0 || this.solicitacao.ValorParcela === undefined) {
                return this.formatCurrency(this.solicitacao.Valor / this.solicitacao.Prazo);
            } else {
                return this.formatCurrency(this.solicitacao.ValorParcela);
            }
        },
        taxaJuros: function taxaJuros() {
            return this.formatCurrency(this.solicitacao.TaxaJuros);
        },
        taxaTotal: function taxaTotal() {
            return this.formatCurrency(this.solicitacao.RetornoBrutoAnual);
        },
        dataInicio: function dataInicio() {
            return this.formatData(this.solicitacao.InicioCaptacao);
        },
        dataFim: function dataFim() {
            return this.formatData(this.solicitacao.FimCaptacao);
        },
        email: function email() {
            return this.solicitacao.Email;
        },
        nomeResponsavel: function nomeResponsavel() {
            return this.solicitacao.Nome;
        },
        Endereco: function Endereco() {

            if (this.solicitacao.Impacto == undefined) {
                return this.solicitacao.Social.Endereco.Cidade;
            } else {
                return this.solicitacao.Impacto.Cidade + "/" + this.solicitacao.Impacto.UF;
            }
        },
        telefone: function telefone() {

            if (this.solicitacao.TelefoneComercial == "" || this.solicitacao.TelefoneComercial == undefined) {
                return this.solicitacao.Social.Telefone;
            } else {
                return this.solicitacao.TelefoneComercial;
            }
        },
        valorCaptado: function valorCaptado() {
            return this.formatCurrency(this.solicitacao.ValorCaptado);
        },
        investidores: function investidores() {
            return this.solicitacao.QuantidadeReservasInvestimento;
        },
        percentValorCaptado: function percentValorCaptado() {
            if (this.solicitacao.ValorCaptado === 0 || this.solicitacao.ValorCaptado === undefined) {
                return this.formatCurrency(0);
            } else {
                return this.formatCurrency(this.solicitacao.ValorCaptado * 100 / this.solicitacao.Valor);
            }
        },

        // Dados exclusivos de impacto
        razaoSocial: function razaoSocial() {
            // console.log(this.solicitacao.Impacto )
            if (this.solicitacao.Impacto == undefined) {
                // console.log("oi")
                //Validação de tipo de pessoa - Física ou Jurídica
                if (this.solicitacao.TipoPessoa == "pessoa fisica") {
                    return this.solicitacao.Social.NomeCompleto;
                }

                if (this.solicitacao.TipoPessoa == "pessoa juridica") {
                    return this.solicitacao.Social.RazaoSocial;
                }
            } else {
                // console.log(this.solicitacao.Impacto )
                return this.solicitacao.Impacto.NomeEmpresa;
            }
        },
        breveDescricao: function breveDescricao() {

            if (this.solicitacao.Impacto == undefined) {
                return this.solicitacao.Social.InformacaoInstitucional;
            } else {
                return this.solicitacao.Impacto.InformacaoResumida;
            }
        },
        sobreEmpresa: function sobreEmpresa() {

            if (this.solicitacao.Impacto == undefined) {
                return this.solicitacao.Social.InformacaoInstitucional;
            } else {
                return this.solicitacao.Impacto.InformacaoInstitucional;
            }
        }

    },
    methods: {
        money: function money(n) {
            var c = 2,
                d = ",",
                t = ".",
                s = n < 0 ? "-" : "",
                i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        },
        formatCurrency: function formatCurrency(value) {
            if (value !== undefined) {
                return value.toLocaleString('pt-BR', {
                    minimumFractionDigits: "2",
                    maximumFractionDigits: 2
                });
            }
        },
        formatData: function formatData(data) {
            var date = new Date(data);
            return date.toLocaleDateString('pt-BR');
        },
        formatAdress: function formatAdress(obj) {

            var logra = obj.Logradouro;
            var num = obj.Numero;
            var comp = "";
            if (obj.Complemento !== undefined) {
                comp = obj.Complemento;
            }
            var bairro = obj.Bairro;
            var cep = obj.Cep;
            var city = obj.Cidade;
            var uf = obj.Uf;

            var adress = logra + ", " + num + " - " + comp + ", " + bairro + " - " + cep + ", " + city + "/" + uf;

            return adress;
        }
    },
    created: function created() {
        var _this = this;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["c" /* START_LOADING */]);

        __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getLoanRequest(this.getId).then(function (response) {
            _this.solicitacao = response;

            _this.finishedLoading = true;
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["d" /* STOP_LOADING */]);
        }).catch(function () {
            _this.finishedLoading = true;
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    }
});

/***/ }),

/***/ "55Fs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finishedLoading)?_c('div',{staticClass:"row content"},[_c('div',{staticClass:"col-12 align-self-center text-center"},[_c('div',{staticClass:"item__tit animate"},[_c('h1',{staticClass:"animated bounceIn"},[_vm._v("Olá, "+_vm._s(_vm.firstName)+"!")]),_vm._v(" "),_c('p',{staticClass:"animated bounceIn"},[_vm._v("Vou te ajudar na sua simulação. Que tipo de empréstimo deseja?")])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-10 animate"},[_c('ul',{staticClass:"row justify-content-center"},[_c('li',{staticClass:"col-12 col-md-4 animated fadeInDown"},[_c('a',{staticClass:"simulacao",attrs:{"href":"/#/tipo-de-emprestimo/simulacao?type=EMPCOL","title":"Empréstimo coletivo"}},[_vm._v("Empréstimo coletivo")]),_vm._v(" "),_c('a',{staticClass:"saiba-mais",attrs:{"href":_vm.lpUrl+'/lp/emprestimo-coletivo/',"title":"Saiba mais sobre Empréstimo coletivo","target":"_blank","rel":"product"}},[_vm._v("Saiba mais")])]),_vm._v(" "),_c('li',{staticClass:"col-12 col-md-4 animated fadeInDown"},[_c('a',{staticClass:"simulacao",attrs:{"href":"/#/tipo-de-emprestimo/simulacao?type=EMPIMP2","title":"Empréstimo de impacto"}},[_vm._v("Empréstimo de impacto")]),_vm._v(" "),_c('a',{staticClass:"saiba-mais",attrs:{"href":_vm.lpUrl+'/lp/emprestimo-de-impacto/',"title":"Saiba mais sobre Empréstimo de impacto","target":"_blank","rel":"product"}},[_vm._v("Saiba mais")])]),_vm._v(" "),_c('li',{staticClass:"col-12 col-md-4 animated fadeInDown",staticStyle:{"display":"none"}},[_c('a',{staticClass:"simulacao",attrs:{"href":"/#/tipo-de-emprestimo/solicitar-emprestimo?type=EMPSOC","title":"Empréstimo social"}},[_vm._v("Empréstimo social")]),_vm._v(" "),_c('a',{staticClass:"saiba-mais",attrs:{"href":_vm.lpUrl+'/lp/emprestimo-social/',"title":"Saiba mais sobre Empréstimo Social","target":"_blank","rel":"product"}},[_vm._v("Saiba mais")])]),_vm._v(" "),_c('li',{staticClass:"col-12 col-md-4 animated fadeInDown",staticStyle:{"display":"none"}},[_c('a',{staticClass:"simulacao",attrs:{"href":_vm.LIZA_URL+'/base.html?valor=&pagina=emprestimo-pessoal&url=emp_pessoal',"title":"Empréstimo pessoal"}},[_vm._v("Empréstimo pessoal")]),_vm._v(" "),_c('a',{staticClass:"saiba-mais",attrs:{"href":_vm.lpUrl+'/lp/emprestimo-pessoal/',"title":"Saiba mais sobre Empréstimo pessoal","target":"_blank","rel":"product"}},[_vm._v("Saiba mais")])]),_vm._v(" "),_c('li',{staticClass:"col-12 col-md-4 animated fadeInDown",staticStyle:{"display":"none"}},[_c('a',{staticClass:"simulacao",attrs:{"href":_vm.LIZA_URL+'/base.html?valor=&pagina=veiculo-em-garantia&url=emp_veiculo',"title":"Veículo em Garantia"}},[_vm._v("Veículo em Garantia")]),_vm._v(" "),_c('a',{staticClass:"saiba-mais",attrs:{"href":_vm.lpUrl+'/lp/veiculo-em-garantia/',"title":"Saiba mais sobre Veículo em Garantia","target":"_blank","rel":"product"}},[_vm._v("Saiba mais")])]),_vm._v(" "),_c('li',{staticClass:"col-12 col-md-4 animated fadeInDown",staticStyle:{"display":"none"}},[_c('a',{staticClass:"simulacao",attrs:{"href":_vm.LIZA_URL+'/base.html?valor=&pagina=imovel-em-garantia&url=emp_imovel',"title":"Imóvel em Garantia"}},[_vm._v("Imóvel em Garantia")]),_vm._v(" "),_c('a',{staticClass:"saiba-mais",attrs:{"href":_vm.lpUrl+'/lp/imovel-em-garantia/',"title":"Saiba mais sobre Imóvel em Garantia","target":"_blank","rel":"product"}},[_vm._v("Saiba mais")])])])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "55Sw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5AFV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Fz8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5KuI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CriarContaConvidado_vue__ = __webpack_require__("Lhjm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ccfb16a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CriarContaConvidado_vue__ = __webpack_require__("/MnN");
function injectStyle (ssrContext) {
  __webpack_require__("7D6a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ccfb16a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CriarContaConvidado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ccfb16a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CriarContaConvidado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5RJK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Tlp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tit_page d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"d-flex align-items-start justify-content-lg-end mob"},[_vm._m(0),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/investimentos/estatisticas/"}},[_vm._v("Minhas estatísticas")])],1),_vm._v(" "),(_vm.showMeInfo())?_c('li',[_c('router-link',{attrs:{"to":"/investimentos/estatisticas/estatisticas-da-plataforma/investidores"}},[_vm._v("Estatísticas da plataforma")])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"back"},[_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"back"},[_vm._v(" ")]),_vm._v(" "),_c('span',[_vm._v("Voltar")])])])]),_vm._v(" "),_c('div',{staticClass:"menu-mob"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/investimentos/estatisticas/"}},[_vm._v("Minhas estatísticas")])],1),_vm._v(" "),(_vm.showMeInfo())?_c('li',[_c('router-link',{attrs:{"to":"/investimentos/estatisticas/estatisticas-da-plataforma/investidores"}},[_vm._v("Estatísticas da plataforma")])],1):_vm._e()])]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("Estatísticas "),_c('span',{staticClass:"separador"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Tm8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioFaturamentoPasso_vue__ = __webpack_require__("/2VA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb5c622e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioFaturamentoPasso_vue__ = __webpack_require__("wlqh");
function injectStyle (ssrContext) {
  __webpack_require__("9inP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eb5c622e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioFaturamentoPasso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb5c622e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioFaturamentoPasso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5lAD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"row wallet__filter"},[_c('div',{staticClass:"col-12 col-md-5 col-lg-5"},[_c('div',{staticClass:"row no-gutters wallet__filter--date"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"inicio"}},[_vm._v("Início")]),_vm._v(" "),_c('i',{staticClass:"ico-calendar"}),_vm._v(" "),_c('datetime',{staticClass:"theme-iouu",attrs:{"placeholder":"__/__/____","input-class":"form-control form-control-lg","type":"text","format":"dd/MM/yyyy"},model:{value:(_vm.filtro.dataIni),callback:function ($$v) {_vm.$set(_vm.filtro, "dataIni", $$v)},expression:"filtro.dataIni"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"fim"}},[_vm._v("Fim")]),_vm._v(" "),_c('i',{staticClass:"ico-calendar"}),_vm._v(" "),_c('datetime',{staticClass:"theme-iouu",attrs:{"placeholder":"__/__/____","input-class":"form-control form-control-lg","type":"text","format":"dd/MM/yyyy"},model:{value:(_vm.filtro.dataFim),callback:function ($$v) {_vm.$set(_vm.filtro, "dataFim", $$v)},expression:"filtro.dataFim"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 col-lg-3 wallet__filter--search"},[_c('label',{attrs:{"for":"busca"}}),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"id":"search","type":"button"},on:{"click":_vm.enviarFiltro}},[_vm._v("Procurar")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5obF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masker__ = __webpack_require__("7VWg");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            valor: null,
            prazo: '12',
            faturamento: null,
            enabled: true,
            type: this.$route.query.type,
            simulator: {}
        };
    },

    methods: {
        getType: function getType() {
            var tipo = void 0;

            switch (this.type) {
                case 'EMPPES':
                    tipo = '1';
                    break;

                case 'EMPVEI':
                    tipo = '2';
                    break;

                case 'EMIMB':
                    tipo = '3';
                    break;

                default:
                    tipo = '0';
                    break;
            }

            return tipo;
        },
        isValid: function isValid() {
            return this.valor != null && this.faturamento != null;
        },
        getSimulation: function getSimulation() {
            var _this = this;

            var vr = this.arrumaValor(this.valor),
                n = this.arrumaValor(this.prazo),
                fat = this.arrumaValor(this.faturamento),
                tipo = this.getType();

            if (parseFloat(vr) <= 1000 || parseFloat(fat) <= 1000) {
                this.$Notify.error('O valores devem ser superiores a R$ 1.000,00');
            } else {
                __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client__["a" /* default */].simulator(vr, n, fat, tipo).then(function (data) {
                    _this.simulator = data.data;
                    localStorage.setItem('simulatorData', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.simulator));
                    localStorage.setItem('loansValue', parseFloat(vr).toFixed(2));
                    localStorage.setItem('fat', parseFloat(fat).toFixed(2));
                    localStorage.setItem('n', n);
                    _this.$router.push('/tipo-de-emprestimo/simulacao-emprestimo?type=' + _this.type);
                });
            }
        },
        arrumaValor: function arrumaValor(value) {
            return typeof value == "string" ? __WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].unmaskMoney(value).toString() : value.toString();
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/tipo-de-emprestimo/simulacao',
                title: 'simulacao'
            });
        }
    },
    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this2.taggingGA();

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    }
});

/***/ }),

/***/ "5s8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInformationLayout_vue__ = __webpack_require__("EOg2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224aad96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInformationLayout_vue__ = __webpack_require__("kceo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInformationLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224aad96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInformationLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6+EH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploadPjDeclaracaoMeiStep_vue__ = __webpack_require__("iWrZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ad295b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploadPjDeclaracaoMeiStep_vue__ = __webpack_require__("s7tP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploadPjDeclaracaoMeiStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ad295b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploadPjDeclaracaoMeiStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "60mX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("\n      Por favor, nos diga, qual o regime tributário da empresa?\n      "),_c('a',{staticClass:"infos",attrs:{"href":"https://ajuda.iouu.com.br/hc/pt-br/articles/360006040833","target":"_blank"}},[_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Dúvidas? Clique aqui!"}},[_c('i',{staticClass:"fas fa-info-circle"})])],1)])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-9 col-xl-9"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('ul',{staticClass:"list-group"},[_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.regimeTributario),expression:"regimeTributario",modifiers:{"number":true}}],staticClass:"form-check-input",attrs:{"type":"radio","name":"RegimeTributario","id":"SIMEI","value":"1","required":""},domProps:{"checked":_vm._q(_vm.regimeTributario,_vm._n("1"))},on:{"change":function($event){_vm.regimeTributario=_vm._n("1")}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"mei"}},[_vm._v("MEI")])])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.regimeTributario),expression:"regimeTributario",modifiers:{"number":true}}],staticClass:"form-check-input",attrs:{"type":"radio","name":"RegimeTributario","id":"SimplesNascional","value":"2","required":""},domProps:{"checked":_vm._q(_vm.regimeTributario,_vm._n("2"))},on:{"change":function($event){_vm.regimeTributario=_vm._n("2")}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"me"}},[_vm._v("Simples Nacional")])])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.regimeTributario),expression:"regimeTributario",modifiers:{"number":true}}],staticClass:"form-check-input",attrs:{"type":"radio","name":"RegimeTributario","id":"SimplesNascional","value":"3","required":""},domProps:{"checked":_vm._q(_vm.regimeTributario,_vm._n("3"))},on:{"change":function($event){_vm.regimeTributario=_vm._n("3")}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"me"}},[_vm._v("Lucro Presumido")])])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.regimeTributario),expression:"regimeTributario",modifiers:{"number":true}}],staticClass:"form-check-input",attrs:{"type":"radio","name":"RegimeTributario","id":"SimplesNascional","value":"5","required":""},domProps:{"checked":_vm._q(_vm.regimeTributario,_vm._n("5"))},on:{"change":function($event){_vm.regimeTributario=_vm._n("5")}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"me"}},[_vm._v("Lucro Real")])])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.regimeTributario),expression:"regimeTributario",modifiers:{"number":true}}],staticClass:"form-check-input",attrs:{"type":"radio","name":"RegimeTributario","id":"SimplesNascional","value":"4","required":""},domProps:{"checked":_vm._q(_vm.regimeTributario,_vm._n("4"))},on:{"change":function($event){_vm.regimeTributario=_vm._n("4")}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"me"}},[_vm._v("Lucro Arbitrado")])])])])]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "65ha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var StringHelper = function () {
  function StringHelper() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, StringHelper);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(StringHelper, null, [{
    key: 'removeAccents',
    value: function removeAccents(string) {
      return string.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    }
  }, {
    key: 'titleize',
    value: function titleize(string) {
      if (string == undefined || string == null) return null;
      string = string.trim();
      return string.split(' ').map(function (word) {
        return word[0].toUpperCase() + word.slice(1, word.length);
      }).join(' ');
    }
  }]);

  return StringHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (StringHelper);

/***/ }),

/***/ "68Qy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statistics statistics__intern"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center statistics__intro hide-mobile"},[_vm._m(1),_vm._v(" "),(this.Renderizou == true)?_c('div',{staticClass:"col-12 text-center"},[_c('h4',[_vm._v("Dados atualizados em "+_vm._s(_vm.Atualizacao(this.Estatisticas.Created)))])]):_vm._e()]),_vm._v(" "),(this.Renderizou == true)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 hide-mobile"},[_c('div',{staticClass:"statistics__numbers p-4 mt-4 mb-4"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12 col-md-6 d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"text"},[_vm._v("Total de investimentos")]),_vm._v(" "),_c('div',{staticClass:"numbers"},[_c('span',{staticClass:"text-back"},[_vm._v("R$")]),_vm._v(" "),_c('span',{staticClass:"number-front"},[_vm._v(_vm._s(_vm.money(this.Estatisticas.TotalInvestimentos)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"text"},[_vm._v("Retorno anual médio para investidores")]),_vm._v(" "),_c('div',{staticClass:"numbers"},[_c('span',{staticClass:"text-back"},[_vm._v("%")]),_vm._v(" "),_c('span',{staticClass:"number-front"},[_vm._v(_vm._s(_vm.money(this.Estatisticas.RetornoAnualMedio)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('div',{staticClass:"statistics__numbers--item p-3 p-md-4"},[_c('label',[_vm._v("Valor médio investido")]),_vm._v(" "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.ValorMedioConta)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('div',{staticClass:"statistics__numbers--item p-3 p-md-4"},[_c('label',[_vm._v("Número de investidores")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(this.Estatisticas.NumeroInvestidoresAtivos))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('div',{staticClass:"statistics__numbers--item p-3 p-md-4"},[_c('label',[_vm._v("Idade média do investidor")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(this.Estatisticas.IdadeMedia))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row justify-content-center mt-5 mb-5 statistics__graphics hide-mobile"},[_c('div',{staticClass:"col-12 col-md-9"},[(this.Renderizou == true)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 text-center"},[_c('h3',[_vm._v("Tipo de investidor")]),_vm._v(" "),_c('canvas',{attrs:{"id":"GraficoTipoInvestidor","width":"269px","height":"180px"}}),_vm._v(" "),_c('ul',{staticClass:"legend legend-doughnutchart-tipo",staticStyle:{"margin-top":"10%"}},[_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Investidores individuais ("+_vm._s(_vm.porcentagem(this.Estatisticas.PorcentagemInvestidoresIndividuais))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Investidores institucionais ("+_vm._s(_vm.porcentagem(this.Estatisticas.PorcentagemInvestidoresInstitucionais))+"%)")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 text-center"},[_c('h3',[_vm._v("Gênero")]),_vm._v(" "),_c('canvas',{attrs:{"id":"GraficoGenero","width":"269px","height":"180px"}}),_vm._v(" "),_c('ul',{staticClass:"legend legend-doughnutchart-genero",staticStyle:{"margin-top":"10%"}},[_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Feminino ("+_vm._s(_vm.porcentagem(this.Estatisticas.PorcentagemMulheres))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Masculino ("+_vm._s(_vm.porcentagem(this.Estatisticas.PorcentagemHomens))+"%)")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 text-center"},[_c('h3',[_vm._v("Idade")]),_vm._v(" "),_c('canvas',{attrs:{"id":"GraficoIdade","width":"269px","height":"180px"}}),_vm._v(" "),_c('ul',{staticClass:"legend legend-doughnutchart-idade",staticStyle:{"margin-top":"10%"}},[_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("18-24 ("+_vm._s(_vm.porcentagem(this.Estatisticas.PorcentagemIdade[0]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("25-34 ("+_vm._s(_vm.porcentagem(this.Estatisticas.PorcentagemIdade[1]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("35-49 ("+_vm._s(_vm.porcentagem(this.Estatisticas.PorcentagemIdade[2]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("50-64 ("+_vm._s(_vm.porcentagem(this.Estatisticas.PorcentagemIdade[3]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("65+ ("+_vm._s(_vm.porcentagem(this.Estatisticas.PorcentagemIdade[4]))+"%)")])])])])]):_vm._e()])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row align-items-center mt-4 mb-4 statistics__intern--investor hide-mobile"},[(this.Renderizou == true)?_c('div',{staticClass:"col-12 col-md-6 investor__map"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 754.457 788.396"}},[_c('g',{attrs:{"id":"brasil-regioes","data-name":"brasil-regioes","stroke":"#ffffff","transform":"translate(-288.475 -2498.475)"}},[_c('a',[_c('path',{class:_vm.DensidadeInvestidores('norte'),attrs:{"id":"norte","d":"M372.34,50.37l1.68-.45.43.4.84,2.3-1,1.11-.69.17h0l-.45-.34L372,51.68l.07-.89Zm4.42,19.28-1.13,1.12.08.71.41.26,1.77-.19,1-.51,1-1.46-.05-.6-.45.65-.47.11-1.26-.24Zm4.13-1.9.1-.52-.18-.35-1.27.1-.73,1v.57l.79.23Zm-7.3-18V49l-.88-.33-.89.18-.26.84.77.5ZM369,83.11l-.15-.23-.45-.35-1.05-.17-1.05.52-1.05,1.05.19.22h.6l2.39-.71h0l.43-.1Zm-5,2.66L363.76,87l1.56.7.61,0,.51.26,1.71-1.47,1.08-.34,2-1.63-.09-.14-.81-.69L369,83.52l-2.39.92-1.94.4Zm42.6,16.34.1-.6-.19-1.21h-1.36l-.88,1.27.83.8,1.05.19h0ZM374.33,73.85l-.3-.13-.9,1.25-.72,4-.89,1,.3.48,1.21.32h0l.59-.86,1-.41.32-.89-.6-1.89,0-2.51Zm.65,2.22.17,1.69.83.3,1.67-1.13,2-2,0-.9-.54-.69-.25-.12-2.49.93-1.18,1.33Zm22.4,33,0-.75-.19-.1-1.08.33-1.06,1.75.35,1.07.85.36h0l.36-.38ZM350,106.63l1.6-.37,5-3.35.79-.73,1.35-2.06,1.12-.68.86-3.07,1.11-2.22-.73-2.39-2.9.2-2.32,1.49L354.55,95l-.87,2.61.2,2.37-.15.5-.91.88-2.36.48-.26.21.09,1.82-1.11,2.28.76.51Zm39.4-19.74-3.74.46-7.3-1.79-3.5-.53-1.34.13-1.36.5-1,.58-1.35,1.35-.9,2-.36,1.7.91,2.19,1.29.22.46.42-.56.06-1.78-.6-.35-.76-.74.77-.35,5.14.19,1.07.95.72,1.23.13,1.32-.44-.08.57-.94.76-1.79-.36-.62.38-.53,2.79.21,1.8,1.08,1.62,1.12,1,.23.42.25,1.87.82.62,3.24.57,4.24-1.27.81-.73,3.82,1.66.72-.41.34-.82-.42-1.25.23-.28.62,1.55.73.61,1.86-1.2.66-1.15,2.05.32,3.43-.53,4.58-2h0l.5-.46,1.4-3.54,2-2.62-.24-1.2.36-.7,1.31-.69.87-3.35.36-2.68L405,90l.71-.75,0-1.25-.64-.47-6.56-.86-2.84-.83-2.92-.3-2.19.38-1.16.63Zm-44.15,22.4.6-.74,2.57-.41,1.05-.48.29-.35-.88-.87-.79-.39-2.39.89-.61,1,.2.3,0,1Zm.53-3.74-.55-.71-3.61,1.62-.43.4.07.36.56.19,2.53-.92,1.42-.74Zm12.34-3,1.7-.45.62-.66.9-2.77V97.1l-.32-.44-.24.3-.05,1.31-.43,1.26-1.81,1.64-.55,1v.36l.18,0Zm11.75-21.77-.23.29.05.39,1,1.66.85.72.62.14h0l1-.4-.24-2.11-.29-.44-1.88-.85Zm13.82,2.68h0l-1.3,1,.2.53,2.29.9,1.18-.32,2.89-.29.89-.78-.05-.62-.54-1-1.67-.63-2,0Zm-16.51,9.06-.7-.14-.73.28-2.62,1.72L362,97.18l-.2.94.15.42L363.75,97l1.64-2.22,1.58-.45Zm-.45,2.38-1.2,0-.79,1.52.07.23.46.12h0l1.35-.48Zm-4.77,17.2v.62l1.7,1.76.76.28.7-.46.89.52.66.12-.31-1.51-3.1-1.34Zm15.33-32-1.92,0-1.53.42v1.26l.39,1.1.29.26.8.16,2.48-.08,1.05.25h0l1.32,1.15,1.11-.5,1.8-2.52,2.59-1.4.19-1-.69-.69-.78-.26-4.88.61ZM368,90.34l-.27-.88-.72-.19-.89.21-1.68,3,3-1.42Zm-1.38-1.21,1.06-.17.25-.35.24-.64,0-1-2.39,1.87,0,.19.9.07Zm-3.54,10.59.8-.72.11-1.13.95-.31.41-.46-.73,0h0l-.91.15L362,98.91l-.47.64-.28.84.17.18ZM364,92l.82-.64.91-2-2.51,1.48-.25.51.08.77h0Zm-3.59-5.45-.77,1.56-1.21,1.73-.55.37-.13.62.28.19h0l2.24-1.48L362,87.9l.41-1,.2-1.51-1.47.54Zm3.07,1.29-1.34,1.83-.33,2.06.55.2,1.08-2.26,1.57-.65v-.25l-1.3-.89Zm78.68,157-.83-.45-1-.3-1.8.22-.72-.19-1.36-2-1-2.91-2.17-1.64-.13-1.67,1.66-1.83-.09-.54-3.93-2-.63-1.05-.06-1.68-.75-1.61-.95-.7-2.11-.29-.2-.43.27-.71L429,222.5l-.37-1.32.74-2.71.68-1.45.58-.56,1.36-.55,3.43-.35-.4-1.37.65-3.29-.08-1.77-1.82-1.24-4.33,1-2.17,1.36L425,207.14l-.92-.86-3-4.21-.89.07-.86-1.46.63-1.21-.11-.89-.25-.35-1.39-.25-.43.28-2-1.34.18-.72,1.78-.68,1.78-2.06.25-1.61-.29-1,.32-2.4,1.79-6.23v-.44l-.68-1.15-.23-1.09.21-3.77-.65-1.52-.47-3.54-.85-1.05-3.45-1.44-1.23,0-.29-.33-.08-1-.6-.7-1.76-.29-1,.52-1.42-.08-2.82-1.54-.88-.05-2,.54-2.66,1.87-.53.65h0l-.5-.08,14.9-12,2.38.23,1.18-.93,1.57-2.2.44-1.17,1.57-1.18.63-2.92,1.13-.46,2.47-2.35.48-1.23.29-1.92,1.62-4.75,2-1.56,1.5-1.79.84-1.47.47-1.3-.19-1.84.8-.82-1.05-1.6,3.73-3.13-.13-1.66.5-2.41,1.76-1.59.37-.72.91-3.06.08-1.63-.43-.54-1,.17-.28-.5.05-.63,1.16-.15.58-.75.71-4.45-.16-1.4.47-1,.78-.46-.63-1.64-.6.63-1.49.5.76-1.85.31-1.6-3.57,1.25-1.92-.14-.26-.38-.86.51.61-1-.47-1.7-.46-.66-2.54.26-.41-.44.23-1.35-.39-.23L429,97l-.93.52,0-.6.5-.31-.53-2.17-1.67.79-1.66-.72-.62-1-1.2-.66-2.31-.26-.45.19-.17.43.13,1.21.14.3,1,.5.11.38-.2.57L419.78,95,419,93.54l-.28-.15-.64.19-.37.79-.82.59-1.08.16.32-.68-.1-.57-.4-.46-.47.07-3,2.12-1.12-1.16-.37.09L407.86,97l-1.19,1.83,0,.69.69,1.41-1.08,3.14-1-.11-.67-.39-.52.3-.3,2.46.32.21,3.55-.47,1.05.33-3.56.51-.63,1,.36.76.05.75-1.21-.6L402,106.52l-.62.46-.8-.5-.53.47-1.38,2.29L397.15,111l-.89,1.37-1.25.16.41-.33.26-.53-.51-.37-.24-.76-.69.4-.91,1.63.29.23h0l.73-.44.59.17-.52.07-.59.35-.77.06-.27.27-1.14,1.58L390.51,118l-1.56,3v1.42l-.89,1.2.32-2.5-.59-1.44v-.89l.85-1,.46-1.08.24-1.52,2.07-4.08-.06-.76-.78-.07-1.76.52-1,.6-1,1-1.08.42-3.21.42-1.77-1.07-.78-.2-4.14,1-1.35.91-1,.18-.48,0-.33-.29.62-.6-.34-.57-2-.64-1.64-.09L367,114.22v.44l.93,2.13,1,1.27-.26.3-1.21-.87.09-.8-.84-1.22-1.45-.74-.83,1.21-.35,4.25.23.69,1.21,1.05.78.25.35.65-.53-.5-.75-.16-1.13-.76-.53-1.14-.41-2.36.75-.56.26-2-2.57-2.49-.11-.45-2.34-1.2-2.6,4.27-.12.53.44,2.72,1,1.16-.93-.63-.49-.65-.69-3,.62-2.4,2.31-3.86.89.53L360,111l2.16,1,.94-.14,1.28.31,1.84.53.88.53.48-.14,1.86-1.86.13-.48-.3-1.66-1.34-1.36-.82-1.62-.33-1.64.52-2.61L366.93,98l-.42-.21-1.1-.06-1.14.28-.21.41.25.68-.67.73-2.12,1-.68.52-.54,1-3.2,1.86-1.87.82-1.52.35-3.32,2.37-1.15.58-1.09.43-.6-.13L347,109h-1l-.88,1-.63.2-.3-.37.62-.5v-.67l-.13-.47-.89-.67-6.54,1.08,0-.59,1.57-.6.64,0,1.62-.73.37-.54,3.43-1.6.67.15.85.8.5.18,1.41-.17,1.31-1.13.17-.53-.29-1.61.53-.75-1-.06-.78.34-1.32.12-2.82-.69h0l2.8.68,1.32-.12.78-.34.95.06h0l1-.13,2-1.83-.17-1.82.36-2.43,3-3.5.85-.66,1.14-1.89,1-2.25,1.48-1.7.76-.91,1.36-.07,2.11-3,1.47-.53.95.09.71-.46,3-3.55,2-3.77,2.18-1.42,1.19-2.13,5.09-4.11.17-.74-.12-.6-.28-.24-1.06.43-1.81.15.39-.33,1.75-.44,1.31-1,.16-3.37-.78-2.69-1.31-.86-2.82-1-3.31.08-1-.35-3.36-5.07-2.7-9.05-2.74-6.13-.67-3.92-.21-8L362.7,22l-.38.1-.33.49-.44-.32,0-1.6-.53-1.2-.92-1.25L358.92,17l-3.42-2.45-.18.33.07,1.31,1.7,4.86-.9-1.38-.56-1.48-1.06.59-.47.93L352,20.83l-.64,1.68-1.81,1.57-.85,1.21-.23,1.17-3.65,5.86-.74.2-1.12,1.31-.11,1.85-3.17,6.58.2.55-.38,1-1.77,2.33-1.8,1.11-1.69,1.52-.93.49h-.62l-1-.17-.51-.51-2.4.17.2-.88-1.48-1.32-.33,0L327,47l-1.74,1-1.09.12-2.75-1-.7-.95-.84.29-1.75,1.19-.36.77-2.8,1.8-3.33-.76-2.28-.79-.85-.72-.35-.91-.83-.23-1.49.06-.35-1,.3-.18v-.82l-1-.3-.36.22,0,0-.44.29-1-.07-1.59-1.71-11.77,2.36-2.38-1.12-.84-.77-.72-.19-.31.17-.29,1.12-1.32,1.47-.5,1.7,1.25.64,2.1,2.53,0,2.31-1,.88-1,.14L280,53.21l-2.27-.3-.87.35H276l-.79-.29-1.7.4L273,54l-1.63-.25-2.06-.49-.74-.45-.37-1-.42-.11-2.14,1.14-.65-.47-.88.12-1.47,1.11L262.2,55,261,56.51l-.5.25-1.18.11-2-.4-3.37,1.64-.55,1.54-1.9,0-2.67-1-1.43,1.65-1.81.37.54,1.82-.82,1.07-2.75-.23-.47.82-1.39.72-.93-.29-.45-.4,0-.49-.44-.59-.74-.31v0l-4.29-1.05-2.68-2.78-1.48-1.94-2.18-.75-.46-.51.67-1.18-1.84-.3-.12-.75.47-5.21-.14-.69-.91-.2-1.59-1.05V44.88l-.51-1.79-1-1.89.09-2.7.32-2.6.91-2.81,1.49-2.44-.06-2.2-.28-.4.73-1.52,1.9-1.43,1.53-3-.2-1.57-2.37-3.47V16l.89-1.45-1.84-1.11-2.38-.82-1.64.22-1.63-.41-.06-.85,1.26-.7.73-1.4.68-5-.49-1.39-1.05-.81L220.1.94,218.71.51,218,.74l-1.07,1-3.62.1-.81-.33L211,1.4l-.65.19,1.19.36,1.22,3.6-1.13,1.74-1.11,1-1.88.91-.75.13-.6,1.13-.09.72-.9,1.14-2.8.4-2.36-.19-3.07,1.84L198,15.78l-.69.86-1.12.07-1.17-.23-1,.25L192.68,18l-1,.22-1.14-.36-1.05.3-.81.73-.6.17-3.95-1.35-.76,0-1.57,1.1-1,1.11-2,.05-.47.28L178,22l.85,2.8-.1.85L178,26.79l-1.53.69-.72-.11-1.07-.58-4-4.63-1.47-.94-1.32-.14-.62,1.58-.53.14-.61-.15-1.33-1.22-.47-.05-3.22-.17-1,.41-.75.66-1,.08-.55-.36-.55-1.95-.62-1.22-1.94-.6-1.36-.1-3.44.51-.61-.09-1-1.75-1.13-.67-.91-.07-.3.33,0,.85.26.4,1.15.66.3,1,1.07,1.83,2.85,2.82L153.8,25l1.87,2,.08,1-.8,1.5.47,3.77.74,2.08,2,3.59.74,1.79-.12,1.5L157.94,44l.2.6,3.35.71,3.8-.14,3.41.23.3.23L168.77,48l-.3.46h0l-.31,1.25-2.31.3-1,.37L162.79,52l-1.35.4-1.76,0-1.05.43-.78.93,0,1.31-.44,2.69-.56.83-2.39,1.67-2.06-.55L150.3,60.9l-1,1.63-1.62,1.06-.94.29-1-.56-3,1.8-1.53.36-.52.38-.46,2.34-.42.67-.55.18-1-.18-.47.23-1,1.17-.23,1.31-.57.92-1.34.73L134,73l-.38-1,1.13-1.73,0-1L134,68.17l-.57-.3-2.22.11-2.13,1.18-1.73,1.72-2.33,1-2.53-.21-.8-.28-8.41-7.15-3.25.76-.2-1.79.5-3.67L110.12,58l-.67-1.8-.75-1.32-1.64-2-1.18-2.61-1.31-.47L102,51.17l-1.28,1.26-.32.85-2,2.12L96.79,56H96l-.67-.35-.88-1.34-.62-1.54-1.45-.4-1,2,.39,1.22.8.14.46.67-19.27-.06-2.88-.88-2.31.6-1.34.59-1,0,.06,10,3.62-.09,2.83.61,1.52-.53,1.17.61.58.54,1.38,2.13-.3,1.75.5,1.71-1.29.43-1.23-.11-2.72-1.78-3.55.93L67.05,74l-3.94.27-.2,11.66,2,2.3,3.07,2.38,1.72.6.38.41.53,1.8-.66,1.41,0,.5,1.5,2.78,1.32,1.07-.13.26,1,5-1.17,3L65.68,145l-1.18,5,.11.4-.47.79-.58.41-2.87-.08-1.63-1.31,0-1.2-.32-.54L57,148.37l-1.11.75-1.34.24-.65-.54-2.16-.2-1.1.62L50,150.7l-1.32,1.61-3.37-.38-1.85.36-1.51.78-4.25,1.24L36.2,154l-2.45.43-3.58,2.77-1.68.94-1.43.11-.79.37-.44,1.42-1.17,1.05-2.22,1.25L18.74,164l-.74.76-.31,2.34L17,169.18l.29,1.34-.3,1.76-.42,1-.93,1.27-1.3,1.33-1.2,2.22-.39,1.21,1.76,4.54-.08,1-1,1.58-.48.3-2.28.24-5,3.52-1.23,1.41-.71,3,.07.66h0L5,197.15l.22,1.36-.5.4-3.05.4v1.33L1.18,202,.55,202l0,.37,2.2,1.92.37.67,2.14.94.2.42-.07.68-.41.52-.82-.1.08,1.19,1.9,1.09L7,211.39l1,3.67,2,1.55.93,2.41,1.14,1.14.92.2.78.44,1.7,3,.84.45.69.92.22,1.24-.3,1.22-.9,1.24-2.52,2.29-.27.57,7.43.19,5.68,1.27,1.1.65.78,2L27.94,237l.15.45,1.26.71.25.5.22.84-.55,1.84,2.11,0,11.94-.16,1.83-1,.66-1.1,2-.68L49.87,236l1.62-1,3-2.62,1.18-.2-.49,1.15-1,1.2.26.89-.07,2.38-.47.72-.06,1.11,0,17.78,1.66-1.17,1.42,1.45,1.7.68,2.77-.62,3.6-1.86,2.3.17.67.59,5.16-.38,5.31.47,3.6.78,1.37-.2-.08,2.14,1,0,2-.52.85-.7L91,256.93l2.47-3.53.37-.87.64-.46.68-.26,2.4-.05.77.13,1.19.76.62-.28.44-1.2,1.46-1.86,2.11-1,1.94-1.31.06-.57,1.55-.18.66.18,1.68-.87,2.9-2.83,2.12-1.61,1.59-.67.3-.48h0l1.5-.49h1.71l5.68-1.8,5.25-.08,2.21,1h.57l.85-1,.06-.52,1.1-1,1,.38,1.18,2.21-.54,1.67.09,1.55.42.9.24,1.51-.36,1.49-1.05,1.07-.39,1.38-.63.51.06,2.32.76,2.19,1.18,2,.21,1.68L136.51,260l.17,1.68,1.28,3.51,1.38.4.85,1.54-.63,1.55.27.65.67.32.49-1.17.89.9.85,3.76.39.35,2.75.29.3.2.83,1.74,1.91,1,1.6.5.3,2,1.2,1.21.77.43,3.1.29,2.17.51.31.3,1.45.17.91-.86,1.16-.54,2,.17,3.17,1.6.88,1.35,1.43.81,1.24,0,1.79-1.14,1,.4.29,1.41.87,1.48,1.54,1,2,1.7,1.29-.6.67.62v.4l4.12,1.84,1.83-.08.88-.33,1.58.53.44,1.9,1.31,1.47,2,1.48.52,1.37.49.16,3.42-.66.26.3,1.33.43,7.17-1,1.29,1.45,2.62,1.57.75,0,1.49-1.45,4.17-2.6.52-2.48,1.45-3.83.94-1.09,1.66-.54.44-.42.59-.85.52-2.28,1.68-2,.57-2.27.07-1.73-.58-1.51,0-2.08-1.55-3.38-.92,0-.58-.52-.44-3.29.14-1.34,1.38-1.09,1.42-1.77.17-.76-1.43-3.64-1.08-.44-1.12-.11-3.55.09-1.24-1.12.25-.57-17.38-.05.91-9.11-1.52-2.79-.27-1.78,0-.81,1-3.57-.39-1.95,1-1.69-.84-2.3-.16-1.41-.26-.62-.79-.48-.06-.35,1.31-5.05.77-1.44-.61-1.26-1.42-1h0l48.45-.33,1.23-.74,1.2-5.28,1.4-4.28-.47-2-.67-1.39-.1-.86.43-.86.87-.65,1.21-1.84.28-1-.35-.85.06-.77.2-.62,1.19-1.2,1.19,1.08L255,204.2l.4,1.78,1.39,4,1.35,2,.78,1.65-.24,2.47.49,2.42.73,2.23,1.56,1.12,3,2.8,3.42,1.72.23,1,0,1.11.24.51,1,.4.83-.18,1.65.46.56.73.2,1.1.35.31,1.39-.45,3.74,1.51,34.48,2.45,63.78,3.52h0l-.66,1-.57,1.91L374,243l-.45,3.18-.44.86-.37.27-2,5.36-.54,3,0,3-1.9,6.06.06.87,1.41,1.36-.17.88-.83.9-.05.51,1.12,2.28-.48,3.35v1.59l.53.59.44,3.09-.75,2.8,1,3.38,1,.52.81,0,.34-.46.2-1.9.67-1.25,1.83-2.11.57-.3,0,1.73-1.24,1.9-.52,2.37,2.43.4,2.23,1.05,4,.4,3.13,1.73,4.12,1.45.64-.23,1.65-6,1.49-2.42,1.2-1,1.16,1.33,1.06,1.9,1.12,3.75.62,3.14,1.15,0,.76-.76.3-1,.57-.55,2.8.35,4.59-.54.22.75-.57,1.58,3.17,1.49,3.4.69.7-.08.51-3.34.56,0,1.53,2.65.47.24L421,293l2.55-2.11,4.59-1h1.57l2.59-1.11L434,287.4l5.43-1.44-.05-.92,1.38-2.41,0-1.07-.17-.43-.42-.25-1.06-.24-.95-.67-.36-1.27.05-3,.19-.86,2-1.69,1.16-.42,1-.72-.3-.65-.59-.52-.93-.29-1,.18-.36-.33-.09-.51.44-1,2.07-.82.56-.46-.05-.77-1.89-1-3.64-.68-1.88-2-.24-.93.51-1.18,1-.73,1.54-3.53.92-.62,1-.27.36-.4-1.3-1.83.19-.37,3.25-2.66,3.87-2,.57-.48.22-1-2.28-.87Z","transform":"translate(293 2502) scale(1.2)"},on:{"mouseup":function($event){return _vm.Zoom('norte')},"mouseover":function($event){return _vm.MostraInvestidores('Norte')},"mouseout":function($event){return _vm.EscondeInvestidores('Norte')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('AC'),staticStyle:{"display":"none"},attrs:{"id":"ac","d":"M31.125,238.614l-2.107-.041.547-1.833-.213-.841-.253-.5-1.266-.709-.142-.456.273-1.165-.78-1.975-1.1-.648-5.672-1.266-7.435-.192.273-.567,2.522-2.289.9-1.246.294-1.215-.223-1.246-.689-.922-.841-.446-1.7-2.988-.78-.446-.912-.192-1.145-1.145-.932-2.411-2.026-1.55-.993-3.667L5.844,207l-1.9-1.094-.081-1.185.82.1L5.1,204.3l.071-.679-.2-.425-2.147-.942-.365-.669-2.2-1.914.041-.375.628-.051.506-1.337-.01-1.327,3.049-.4.506-.4-.223-1.367-1.185-1.59h0l18.181,7.576,23.965,5.733,12.3,3.18L84.8,223.674l28.877,12.286h0l3.008,1.276h0l-.3.486-1.59.669L112.673,240l-2.9,2.826-1.671.871-.669-.182-1.55.182-.051.567-1.945,1.317-2.107,1-1.459,1.854-.446,1.2-.618.284-1.185-.76-.77-.132-2.4.051-.689.263-.638.456-.365.871-2.471,3.525-3.819,1.266-.851.7-1.965.517-1.043.03.081-2.137-1.378.2-3.6-.78-5.308-.476-5.156.385-.669-.587-2.3-.172-3.606,1.854-2.765.628-1.7-.679-1.418-1.459-1.661,1.175.041-17.776.051-1.114.476-.719.071-2.38-.263-.891.982-1.2.486-1.155-1.175.2-3.008,2.623-1.621,1.023-2.087,2.411-1.975.679-.658,1.094-1.833,1Z","transform":"translate(289 2504) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('AM'),staticStyle:{"display":"none"},attrs:{"id":"am","d":"M168.178,47.551l.729.79.76.344.618.01,1.145-.425.638.111.061.972,1.226,1.185.982.375.891-.213,1.378.111,1.975.962.5.669-.922,3.363-.719,1.519,2.765,3.788,1.681,4.821.192,2.289.881,1.134.051.456-1.641,1.479.365,1.61.669,1.6-.78,3.079-.577.972.294,5.044.891,2.2,1.236.851.587.912,1.145,4.386-.061.587-1.155,1.337-1.864-.334-.142,1.155,5.075,4.477.527.041,1.985,1.327,1.5,1.671,1.053,2.066.537.071,1.357-.425,2.39,1.053-.446-2.137.76-2.319.253-1.752-.375-1.823.831-3.008,1.033-1.276,1.3-.7,2.117-.719.557-.9,1.621-.061,2.866.942,1.894,2.066.932,2.542,1.843.233,1.266-.466,1.428-1.428,2.056-.557.425-.4.02-.537-1.155-1.428-.233-.739.111-.669,1.165-2.674.071-1.145,1.681-3.069,2.36-3.3-.03-.689,18.728.071h0l.405,4.923-.436,1.469.182,2.3.243.689,1.722.861.182.415-.354.7-.051,2.137,1.854,2.016.365.192.709-.182,1.864,1.246.557,1.854.04.942.3.456,4.7,3.819,4.639,2.573.638.912,1.367,1.1,1.9.679,2.4,1.327,2.289.658,1.378.152,1.337.831.081.618,1.286,1.357,2.735,1.459,1.114,2.2,1.894.8.861-.618,1.4-.354.192.486-.132.79,1.833,1.692-30.285,65.068-.79,1.327-1.469,1.145-.587.983-.03,1.145.831,2.36.385.577,1.084.588,1.6,1.58.648,1.276.152,1.985.577.577h0l-1.2,1.215-.2.618-.061.77.344.851-.273,1.023-1.215,1.843-.871.648-.425.861.1.861.669,1.388.466,1.965-1.4,4.274-1.2,5.287-1.226.739-48.467.324h0l.041-.709-.365-.385-1.408-.284-1.945,1.094-.547,1.762-.689.192-3.282-1.5-.689-2.917-.628-.2-.993.132-.466-.213-1.266-3.312-2.573-.993-1.347-1.286-.81-1.935-.456-.5-2.178-1.145-10.929.061-1.4,2.593-1.742.506.091,1.185-.263.223-2.512.537-1.205,1.61-.051.679.912.709.172.456-.365,1.033-.82,1.165-2.087,1.226-.111,1.833.243,1.479-3.92-.466-2.157.385-1.215,1.084-1.813-.1-.851-.557-.466-.02-1.773,1.276-.537.851.263,1.773-2.573,3.2-.689.081-.689-.537-.648-2.289-.385-.091-1.864,1.033-1.317,1.226-1.388.4-.78-.132-1.094.506-.415.537-.132.729-1.236.8-.375.02-2.34-2.36-.729-.375-2.907.334-4.011-.263.162,1.307-.152.567-1.57,1.833-1.945.587-3.3,2.593h0L84.757,225.545,57.976,211.193l-12.3-3.18-23.965-5.733L3.534,194.7h0l-.071-.658.709-2.958,1.236-1.418,4.983-3.515,2.289-.243.476-.3.993-1.58.081-1.043-1.762-4.548.385-1.205,1.2-2.218,1.3-1.337.932-1.266.425-.993.3-1.762-.294-1.337.679-2.066.314-2.34.739-.76L22.15,161.5l2.218-1.246,1.165-1.053.446-1.418.79-.375L28.2,157.3l1.671-.942,3.586-2.765,2.451-.436,1.529.294,4.244-1.236,1.519-.78,1.843-.365,3.373.385,1.317-1.61.638-1.469,1.1-.618,2.168.2.648.547,1.337-.243,1.114-.75,1.732.122.314.537-.02,1.2,1.631,1.307,2.866.081.587-.405.466-.79-.111-.4,1.185-4.983,6.786-37.649,1.175-2.958-1-5.024.122-.263-1.317-1.064-1.5-2.785-.041-.5.658-1.408-.527-1.8-.375-.405-1.722-.6-3.069-2.38-1.965-2.309.2-11.658,3.94-.263,1.773-1.185L72.076,71l2.715,1.783,1.236.111,1.286-.436-.5-1.712L77.12,69l-1.388-2.127-.577-.547-1.165-.608-1.529.537-2.826-.618-3.616.091L65.958,55.7l.972.041,1.337-.587,2.309-.608,2.877.881,19.275.061-.466-.669-.8-.142-.385-1.215.962-1.955,1.448.405.618,1.54.881,1.337.669.355.841.01,1.631-.618,1.965-2.117.324-.851,1.276-1.256,2.583-1.408,1.307.466,1.185,2.613L108.408,54l.75,1.317.669,1.8.233,1.57-.5,3.677.2,1.783,3.241-.76,8.417,7.151.8.284,2.532.213,2.33-1.013,1.722-1.722,2.137-1.175,2.218-.111.567.294.78,1.094-.02.982-1.124,1.722.375.993.587.273,1.347-.729.567-.922.233-1.307,1.013-1.175.476-.233,1.013.182.557-.182.415-.669.466-2.34.517-.375,1.529-.365,2.968-1.793.983.557.942-.294,1.621-1.053,1.033-1.631,2.137-1.226,2.056.557,2.39-1.671.557-.831.446-2.694-.03-1.307.78-.932,1.043-.425,1.762-.02,1.357-.4,2.087-1.621.972-.375,2.309-.3Z","transform":"translate(291 2502) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('RO'),staticStyle:{"display":"none"},attrs:{"id":"ro","d":"M188.553,292.3l-1.307-1.469-.446-1.9-1.58-.527-.871.324-1.833.081-4.122-1.833-.01-.405-.669-.618-1.286.6-2.006-1.7-1.54-.983-.871-1.479-.284-1.408-1.053-.4-1.793,1.134-1.236-.03-1.428-.81-.881-1.347-3.17-1.6-1.985-.172-1.155.547-.912.861-1.448-.172-.314-.3-2.168-.517-3.1-.284-.77-.436-1.2-1.205-.3-2-1.6-.5-1.914-.982-.831-1.742-.294-.2-2.755-.284-.385-.355-.851-3.758-.891-.9-.486,1.175-.669-.324-.273-.648.628-1.55-.851-1.54-1.378-.4-1.276-3.515-.172-1.681,1.57-2.948-.213-1.681-1.175-2-.76-2.188-.061-2.32.628-.506.385-1.388,1.053-1.064.365-1.489-.243-1.509-.425-.9-.091-1.55.547-1.671-1.185-2.208-1.033-.385-1.1.993-.061.517-.851.972h-.577l-2.208-1.033-5.247.081-5.682,1.8-1.712-.01-1.5.486h0l-3.008-1.276h0l3.3-2.593,1.945-.587,1.57-1.833.152-.567-.162-1.307,4.011.263,2.907-.334.729.375,2.34,2.36.375-.02,1.236-.8.132-.729.415-.537,1.094-.506.78.132,1.388-.395,1.317-1.226,1.864-1.033.385.091.648,2.289.689.537.689-.081,2.573-3.2-.263-1.773.537-.851,1.773-1.276.466.02.851.557,1.813.1L149,221.775l2.157-.385,3.92.466-.243-1.479.111-1.833,2.087-1.226.82-1.165.365-1.033-.172-.456-.912-.709.051-.679,1.205-1.61,2.512-.537.263-.223-.091-1.185,1.742-.506,1.4-2.593,10.929-.061,2.178,1.145.456.5.81,1.935,1.347,1.286,2.573.993,1.266,3.312.466.213.993-.132.628.2.689,2.917,3.282,1.5.689-.192.547-1.762,1.945-1.094,1.408.284.365.385-.041.709h0l1.418.983.608,1.256-.77,1.438-1.307,5.054.061.355.79.476.263.618.152,1.408.841,2.3-.952,1.691.385,1.955-1.013,3.565-.03.81.273,1.783,1.519,2.785-.912,9.116,17.381.051-.243.567,1.236,1.124,3.545-.091,1.124.111,1.084.436,1.428,3.636-.172.76-1.418,1.773-1.378,1.094-.142,1.337.436,3.292.587.517.912-.03,1.55,3.383-.041,2.076.587,1.509-.071,1.732-.567,2.269-1.681,2.036-.527,2.279-.587.851-.436.415-1.661.537-.942,1.094-1.448,3.829-.527,2.482-4.163,2.6-1.489,1.448h0l-.75-.041-2.623-1.57-1.286-1.448-7.171.972-1.337-.436-.253-.3-3.424.668-.486-.162-.527-1.367Z","transform":"translate(293 2504) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('RR'),staticStyle:{"display":"none"},attrs:{"id":"rr","d":"M236.045,62.452l1.621,17.189h0l-18.728-.071.03.689-2.36,3.3-1.681,3.069-.071,1.145-1.165,2.674-.111.668.233.739,1.155,1.428-.02.537-.425.4-2.056.557L211.037,96.2l-1.266.466-1.843-.233L207,93.892,205.1,91.826l-2.866-.942-1.621.061-.557.9-2.117.719-1.3.7L195.61,94.54l-.831,3.008.375,1.823-.253,1.752-.76,2.32.446,2.137-2.39-1.053-1.357.425-.537-.071-1.053-2.066-1.5-1.671-1.985-1.327-.527-.041L180.164,95.3l.142-1.155,1.864.334,1.155-1.337.061-.587-1.145-4.386-.587-.912-1.236-.851-.891-2.2-.294-5.044.577-.972.78-3.079-.669-1.6-.365-1.61,1.641-1.479-.051-.456-.881-1.134-.192-2.289-1.681-4.821-2.765-3.788.719-1.519.922-3.363-.5-.669-1.975-.962-1.378-.111-.891.213-.982-.375-1.226-1.185-.061-.972-.638-.111-1.145.425-.618-.01-.76-.344-.729-.79h0l.3-.466.233-2.309-.3-.223-3.413-.233-3.8.142-3.353-.709-.2-.608.81-1.783.122-1.5-.739-1.793-1.965-3.586-.739-2.087-.476-3.768.8-1.5-.081-.972L151.7,24.743l-2.188-1.074-2.846-2.816-1.074-1.833-.294-.972-1.155-.658-.253-.4.03-.851.294-.334.912.071,1.134.669.952,1.752.618.091,3.434-.506,1.367.1,1.935.6.618,1.215.557,1.955.547.355.972-.081.75-.658.962-.405,3.221.162.476.051L164,22.4l.608.152.527-.142.618-1.58,1.327.142,1.469.942,3.981,4.629,1.064.577.719.111,1.529-.689.75-1.145.1-.851-.841-2.8.365-1.762.466-.284,1.955-.051,1.023-1.114,1.57-1.1.76.051,3.95,1.357.6-.172.81-.729,1.043-.3,1.145.355,1.043-.213,1.357-1.3,1.013-.253,1.165.233,1.124-.071.689-.861.051-1.367,3.069-1.833,2.36.192,2.8-.4.9-1.145.091-.719.6-1.134L206.55,9l1.874-.912,1.114-1.053,1.124-1.732L209.446,1.7l-1.185-.365.648-.182,1.448.071.81.324,3.616-.1,1.074-.962.75-.223L218,.687l.537,1.327,1.053.81.486,1.388-.679,4.963-.729,1.4-1.266.709.061.841,1.631.415,1.641-.223,2.38.82,1.843,1.114-.891,1.448-.01,1.165,2.37,3.464.2,1.57L225.1,24.854l-1.9,1.428-.729,1.519.273.4.061,2.2-1.489,2.441-.912,2.806-.314,2.6-.091,2.7.993,1.894.517,1.783-.01,1.418,1.59,1.043.912.2.132.689-.466,5.216.122.75,1.833.294-.669,1.185.466.506,2.178.75,1.479,1.945L231.76,61.4Z","transform":"translate(294 2500) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('PA'),staticStyle:{"display":"none"},attrs:{"id":"pa","d":"M373.051,237.987l-63.781-3.525-34.479-2.451-3.738-1.509-1.388.456-.354-.314-.2-1.1-.557-.729-1.651-.456-.831.172-.962-.4-.233-.506.041-1.114-.233-.952-3.424-1.722-3.039-2.8-1.56-1.124-.729-2.228-.486-2.421.233-2.471-.78-1.651-1.347-1.955-1.388-4-.4-1.783-2.482-4.112-1.2-1.094h0l-.577-.567-.152-1.985-.648-1.276-1.61-1.58-1.084-.587-.375-.577-.841-2.37.03-1.145.587-.982,1.469-1.145.79-1.327,30.285-65.068-1.833-1.692.132-.79-.192-.486-1.408.355-.861.618-1.894-.79-1.114-2.2-2.725-1.469-1.286-1.357-.081-.608-1.337-.831-1.388-.152-2.279-.658-2.411-1.327-1.9-.679-1.367-1.1-.638-.912-4.639-2.573-4.7-3.819-.3-.446-.04-.942-.557-1.854-1.864-1.246-.709.192-.365-.2-1.854-2.006.051-2.137.355-.7-.182-.415-1.712-.861-.243-.689-.182-2.3.436-1.469-.405-4.923h0l-1.61-17.189h0l.76.324.436.587-.02.486.456.405.932.284L238.8,63.3l.476-.82,2.745.233.82-1.064L242.3,59.82l1.813-.365,1.428-1.651,2.674,1.023,1.9.03.547-1.54,3.373-1.641,2,.4,1.175-.111.5-.253,1.215-1.5.405-1.418,1.479-1.114.871-.111.658.466,2.137-1.145.415.111.375,1,.739.456,2.056.486,1.631.253.567-.608,1.692-.4.79.284.831-.01.871-.344,2.269.3,4.73,1.4.972-.142,1.013-.881-.03-2.309-2.1-2.532-1.256-.638.5-1.7,1.327-1.469.284-1.124.314-.172.719.192.841.77,2.38,1.124,11.77-2.36,1.59,1.712,1.033.061.446-.294h0l.628.577.375,2.33-.628,1.317-.253,4.6.243,1.459.314.547,1.185.02,1.094-.294,3.434.375,1.307.5,1.955,1.064.679.81.5,1.3,1.205.122,1.155.851.81.993.851.273,1.347-.142.385-.425.952-.142,2.877,2.694.689-.03.5,1.2-.689.233-.192.729.77,2.866,2.046,2.289,2.6.739.172.334-.435,3.18.192,2.137.679,1.529.628.567.6,1.833-.132,1.6,1.519,3.525.831.192.79-.365,2.968,3.322L335.1,91.22l.415.952.962.192.334.476.314,1.6-.213.7.111,1.317,1.894,1.408.436,1.519,1.469,1.043,2.826.689,1.317-.122.78-.344.952.061h0l-.537.75.294,1.61-.172.537-1.307,1.124-1.408.172-.506-.182-.851-.8-.669-.152-3.424,1.6-.375.547-1.621.729-.638-.02-1.57.6.04.587,6.543-1.074.891.669.132.466v.669l-.628.506.3.365.638-.2.871-1.013,1.033-.01.537-.273.608.122,1.084-.425,1.155-.577,3.322-2.37,1.519-.354,1.864-.82,3.2-1.864.547-1.013.679-.527,2.117-1.023.668-.729-.253-.679.213-.415,1.145-.284,1.1.061.415.213.385,3.849-.527,2.613.334,1.641.82,1.621L366,108.317l.3,1.661-.122.476-1.864,1.864-.476.132-.881-.527-1.843-.527-1.276-.314-.942.142-2.158-1.053-.263-1.134-.891-.537-2.309,3.869-.618,2.4.689,3.008.486.648.932.628-1.023-1.155-.436-2.725.122-.527,2.6-4.274,2.34,1.2.111.456,2.563,2.482-.253,2.046-.75.557.405,2.36.527,1.145,1.134.76.75.152.527.5-.344-.648-.78-.243-1.215-1.053-.223-.689.344-4.254.831-1.205,1.448.739.841,1.215-.091.8,1.215.871.253-.294-1.013-1.276-.932-2.127v-.446l2.289-2.35,1.641.091,1.955.648.344.567-.618.6.324.284.486.03,1.043-.172,1.347-.912,4.143-.972.78.2,1.762,1.074,3.211-.425,1.084-.415,1.033-1.023.993-.6,1.762-.517.78.071.061.76-2.066,4.072-.243,1.519-.466,1.084-.841,1.043-.01.891.587,1.438-.324,2.5.891-1.205.01-1.418,1.56-3.039,1.145-3.231,1.134-1.58.273-.273.77-.051.587-.354,1.843-.233.891-1.367,1.529-1.712,1.378-2.289.527-.466.8.5.628-.466,1.641,2.37,1.205.6-.051-.75-.355-.76.628-1.023,3.555-.517-1.043-.324-3.555.466-.314-.213.294-2.461.517-.294.679.385,1.033.111,1.084-3.14-.689-1.408.03-.689,1.185-1.833,2.877-2.512.365-.081,1.124,1.155,2.968-2.117.466-.071.405.456.1.577-.324.679,1.084-.162.82-.587.365-.79.638-.192.284.152.75,1.408,1.347,1.215.2-.567-.111-.385-.972-.5-.142-.294-.132-1.215.172-.425.446-.192,2.309.263,1.2.658.628,1.033,1.651.719,1.671-.79.537,2.168-.506.314-.03.6.932-.527,1.175-2.38.385.233-.233,1.347.415.446,2.542-.263.456.658.466,1.7-.608.962.861-.506.263.375,1.914.142,3.576-1.256-.314,1.6-.76,1.854,1.489-.5.6-.628.638,1.641h0l-.78.456-.476,1.043.162,1.4L436.761,109l-.577.75-1.155.152-.051.628.273.5,1-.162.436.537-.081,1.631-.912,3.059-.365.719-1.762,1.59-.506,2.411.132,1.661-3.727,3.13,1.053,1.6-.8.82.182,1.843-.466,1.3-.841,1.469-1.5,1.783-1.985,1.56-1.621,4.75-.294,1.924-.476,1.226-2.471,2.35-1.134.466-.628,2.917-1.57,1.185-.436,1.165-1.57,2.2-1.185.932-2.38-.233-14.9,11.982.5.081h0l2.319.82,1.894-.243,1.307.122,1.033,1.681.4.314.881.142,1.276,1.185-.04.638-.375.679-.729.375-.983.071-.294.284.091,1.428,1.023,1.357-.932,2.785-.648.486-1.479.466-.253.466.294,1.215-.193,1.357-1.317.152-1.529,1.357-.861,1.286.152,1.529-.243.506-2.532,1.215-3.454,1.155-2.5,1.8-.192.354.436,2.218.061,2.7-1.3,2.127-1.428,1.7-.152.577.172.891.6.972,1.692,1.762.76.324.152.3-.669,4.092-1.783,5.216-1.094.82-1.722,3.282-.182,1-.952,1.56-.749.861-1.064.162-1.388.932-1.043,1.945-1.226,1.7-1.2,1.1-1.165,1.6-1.145,4.517-1.621,3.707ZM394.483,106l-4.578,1.985-3.434.527-2.046-.314-.658,1.145-1.864,1.205-.729-.618-.618-1.55-.233.284.425,1.246-.344.82-.719.415-3.819-1.661-.81.729-4.244,1.276-3.241-.577-.82-.618-.243-1.874-.233-.415-1.124-1.033-1.074-1.621-.213-1.8.527-2.785.628-.385,1.783.365.942-.76.081-.567-1.317.436-1.236-.132L364.32,99l-.182-1.064.344-5.145.739-.77.355.76,1.783.608.557-.061-.466-.425-1.286-.223-.912-2.188.365-1.7.9-2,1.347-1.347.972-.577,1.357-.5,1.337-.132,3.5.527,7.3,1.793,3.748-.466.111-.3,1.155-.628,2.188-.375,2.927.294,2.836.831,6.563.861.638.476-.051,1.246-.709.75-.689,1.519-.365,2.684-.871,3.343-1.307.689-.355.7.233,1.205L396.388,102l-1.408,3.545-.5.456Zm-47.818-.172-.76-.517,1.114-2.279-.091-1.813.253-.213,2.36-.486.912-.871.152-.506-.2-2.37.871-2.613,1.276-1.509,2.32-1.489,2.907-.2.729,2.39-1.114,2.218-.861,3.079-1.114.679-1.357,2.056-.79.729-5,3.353-1.6.365Zm28.847-23.2-1.043-.253-2.482.081-.8-.162-.294-.263-.385-1.1.01-1.256,1.529-.425,1.914.041,2.218-1.307,4.872-.608.78.263.689.689-.182,1.033-2.593,1.408-1.8,2.512-1.114.506-1.317-1.155Zm4.852,0,1.884-1.215,2.006.03,1.671.628.537,1,.051.628-.891.78-2.887.284-1.185.324-2.289-.9-.2-.537,1.307-1.023Zm-17.2,4.447-.506-.263-.618.04-1.56-.7.213-1.175.648-.932,1.945-.405,2.39-.912,1.337.081.81.689.091.132-1.955,1.631-1.084.344Zm9.541-9.815-.831-.3-.172-1.681.152-.608,1.185-1.327,2.482-.932.253.122.537.689.041.9-1.975,2.016ZM358.7,97.743l-.142-.415.192-.942,1.053-2.846,2.623-1.712.729-.284.7.142-.162,1.813-1.58.446-1.641,2.218Zm11.051-17.8-1.205-.314-.3-.486.891-.972.719-4,.9-1.246.294.132.071.324-.02,2.512.608,1.894-.324.891-1.043.405-.587.861Zm-15,10.321-.273-.192.122-.618.557-.365,1.205-1.732.77-1.56.739-.669,1.469-.547-.2,1.509-.405,1.013-1.742,1.681-2.238,1.479ZM368.8,83.147,368.189,83l-.851-.719-.972-1.661-.051-.385.233-.294.82-.587,1.874.851.294.436.243,2.117-.983.4ZM363.347,114.1l-.658-.111-.891-.527-.7.466-.76-.284-1.7-1.762v-.618l1.3-.01,3.1,1.337Zm-21.423-5.611.041-1.043-.2-.3.608-1,2.39-.891.79.385.881.871-.294.355-1.043.476-2.573.415-.6.739Zm12.864-6.776-.182-.03.01-.355.547-.952,1.813-1.641.425-1.256.051-1.317.243-.3.324.446v1.529l-.9,2.765-.628.658-1.7.456Zm6.381-10.028,1.671-3,.891-.213.719.192.273.881-.587.719ZM392.994,110.9l-.851-.355-.344-1.074,1.053-1.742,1.084-.334.192.1-.02.75-.75,2.269-.365.385ZM359.083,91.179l-.547-.2.324-2.066,1.347-1.833.233.041,1.307.891-.01.253-1.57.648Zm2.259,5.095.729.03-.405.456-.952.314-.111,1.134-.8.719-1.712.851-.162-.182.273-.841.476-.638,1.752-1.692.912-.152Zm-22.851,10.342-.557-.192-.071-.355.436-.405,3.606-1.621.547.709-.01.2-1.418.739Zm64.349-4.842-1.043-.192-.831-.8.881-1.266,1.357-.01.192,1.205-.1.6-.456.466ZM365.11,82.631l-2.39.709-.6.01-.182-.213,1.043-1.053,1.053-.517,1.053.172.446.344.152.233-.152.213-.425.1Zm-5.338,8.7-.081-.77.253-.506,2.512-1.479-.912,2.026-.82.638-.952.091Zm2.168,4.588-.456-.122-.071-.233.79-1.519,1.205.02-.122,1.367-1.347.486Zm28.4,16.034-.284-.233.912-1.621.689-.405.233.76.517.375-.263.527-.436.344-.638-.182-.729.436Zm-27-23.62-.9-.071.02-.192,2.39-1.864.041.972-.233.638-.253.344-1.064.172Zm68.329,10.352-.385-.537.192-.77,1.033-.922.253.152.233,1.773Z","transform":"translate(296 2502) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('AP'),staticStyle:{"display":"none"},attrs:{"id":"ap","d":"M345.821,101.068l-.952-.061-.78.344-1.317.122-2.826-.689-1.469-1.043-.436-1.519-1.894-1.408-.111-1.317.213-.7-.314-1.6-.334-.476-.962-.192-.415-.952.081-2.461-2.968-3.322-.79.365-.831-.192L328.2,82.441l.132-1.6-.6-1.833-.628-.567-.679-1.529-.192-2.137.436-3.18-.172-.334-2.6-.739-2.046-2.289-.77-2.866.192-.729.689-.233-.5-1.2-.689.03L317.9,60.542l-.952.142-.385.425-1.347.142-.851-.273-.81-.993-1.155-.851-1.205-.122-.5-1.3-.679-.81-1.955-1.064-1.307-.5-3.434-.375-1.094.294-1.185-.02-.314-.547-.243-1.459.253-4.6.628-1.317-.375-2.33-.628-.577h0l.355-.213,1,.3-.01.82-.294.182.344.982,1.489-.061.831.233.355.912.851.719,2.279.79,3.332.76,2.8-1.8.355-.77,1.752-1.185.841-.294.7.952,2.745.952,1.094-.122,1.742-1.023.122-.425.324.03,1.479,1.317-.2.881,2.4-.172.517.506.962.172.628-.01.922-.486,1.692-1.519,1.8-1.114,1.773-2.33.375-1.013-.2-.547,3.17-6.584.111-1.843,1.124-1.317.739-.192,3.646-5.865.233-1.165.851-1.215,1.813-1.57.638-1.681,2.137-1.155.476-.932,1.053-.587.567,1.479.891,1.378-1.692-4.862-.071-1.307.182-.334,3.413,2.451,1.155,1.226L356.871,19l.527,1.205.03,1.6.446.314.324-.486.385-.1.213.405.213,7.992.669,3.92,2.745,6.128,2.694,9.055,3.363,5.064,1.023.355,3.312-.081,2.816.952,1.307.861.78,2.684-.162,3.373-1.307.972-1.752.436-.385.334,1.813-.152,1.053-.425.284.233.122.6-.172.739-5.095,4.112-1.185,2.127-2.178,1.428-1.965,3.768-2.948,3.545-.709.466-.952-.091-1.469.527L358.6,83.879h0l-1.357.071-.76.912h0L355,86.563l-.982,2.249-1.134,1.894-.851.658-3.049,3.494-.365,2.431.172,1.823-1.975,1.833-.993.122Zm23.661-47.6-.456-.334-1.114-1.884.071-.891.233-.415,1.681-.456.436.4.841,2.3-1,1.114-.689.172ZM372,71.309l-.405-.253-.081-.719,1.124-1.114.891-.152,1.266.243.466-.111.446-.648.051.6-.983,1.459-1,.506Zm3.484-2.907-.79-.233V67.6l.729-1.053,1.266-.1.182.355-.1.517Zm-7.283-18.657-.77-.506.263-.841.891-.172.871.324.01.739Z","transform":"translate(297 2500) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}})]),_vm._v(" "),_c('a',[_c('path',{class:_vm.DensidadeInvestidores('nordeste'),attrs:{"id":"nordeste","d":"M448.34,104.82l-.21,0,1-3.63.3.09,0,.24-.41,3.1ZM558.76,287.47l.37.74-.16.65-1.07,1.05-.75.42.23,1.21h0l2.93-2.33.05-.54-.83-1.06ZM458.69,105l-.08-.61.81-1.13.85,0,.69.42.1.35-.19.36-1.73,1.11Zm4,4.7-.29-.3.06-.54,1.08-.9.48.07.51.87-.14.61-.41-.17Zm2.78,21.06.54-1.55-.42-1.09.13-.66.93-1.26.55-.19.05,2.38-.22,1.35-.81.61-.69,1.21Zm53.09.05-.2.13-.32-.6-1-.87-2.27-.51-.7.23-1.33-.12-1.12-.34.13-.32-.52-.51-1.48-.88-.74-.13-.08,0,.09-.37-.58-.11-1.69.39.68.47-.27.91-2.49-.66-1.61.09-.34,0-.57-.77-1.18.19-2.53-.59L496.52,125l-1.28-1.31-1.42,0-2.17-1.4-1.06-.11-2.66-1.07-1.8-.38-2.45-.08-.62.23.47,2.44-4.1-.44-2.61,1-.87-.34-4.26,5-.26-.3.6-.52-.22-.84-1.16.31-.46.82-.74-.12,0-.73,3.26-1.77,1.43-1.9.2-.45-.08-1.65-.46-.12-.66.13-1.69.93-1.13.12-1.16.71-1,6.41-.9,1.16-2.15,1.6-.69,1.22-2,1.73,0-1.46.44-.18,2.06-2.17,0-.34h0l-.88-.23-.22-.35.63-3.56,1.18-2.38-.07-.78,1.17-1.51,1-.92,1-.2.27-1.24-.53-1.92-.88-.82-.84,0-1.77,1.7-.61,1-.1-.67.39-.9,2.21-2.77.11-1-.78-2.43-1.6-.68-.87.45-1.65-1.78.14-1.22-.58-.8-1.27.61-.1.37-.6-.59,1.15-1.55.36-.21-.05-.93L459.72,107l-2.16-.6-1.06.26-1.34,1.44-.14.61.48,1-1,1-.59.14-.48-.12-.26-.34-.08-2.74.27-1,.88-.93v-.59l-.4-1h-.46l-.5,1.56-1.22,2.06,0-.56-.68-.7,1.44-1.73-.5-.7-1.71-.53-.86,0-.08.95-.29.5-1,0-.62-3-.78,1.38-1.2-.12-.46-1.87-1.36-1-.58.54-.35.76.06.54-.24.25h-.64l-.78.45-.47,1,.16,1.4-.72,4.44-.58.75-1.15.15,0,.63.27.5,1-.16.44.54-.08,1.63-.92,3.06-.36.72-1.76,1.59-.51,2.41.13,1.66-3.72,3.13,1,1.6-.8.82.18,1.84-.47,1.3-.84,1.47-1.5,1.78-2,1.56-1.62,4.75-.3,1.93-.47,1.22L423.5,147l-1.14.47-.63,2.92-1.57,1.18-.43,1.17-1.57,2.2-1.19.93-2.38-.23-14.9,12,.5.08.54-.65,2.65-1.88,2-.53.87.06,2.82,1.53,1.42.09,1-.53,1.76.29.6.7.08,1.05.29.32,1.23,0,3.45,1.46.85,1,.47,3.54.65,1.52-.21,3.77.23,1.09.69,1.15v.44l-1.79,6.24-.32,2.39.29,1-.26,1.61-1.77,2.07-1.78.67-.18.72,2,1.34.43-.27,1.39.24.25.35.11.89-.62,1.2.85,1.46L421,202l3,4.2.92.86,2.3,3.06,2.18-1.36,4.33-1,1.82,1.23.08,1.78-.65,3.29.4,1.37-3.43.35-1.36.55L430,217l-.7,1.45-.74,2.71.37,1.33L426.29,225l-.27.72.2.43,2.11.28.95.7.76,1.61.06,1.68.63,1.06,3.93,2,.08.54-1.66,1.83.14,1.67,2.16,1.64,1,2.9,1.37,2,.72.18,1.8-.2,1,.29.83.46.62.83,1.3.67,2.34.94-.22,1-.57.48-3.87,2.05-3.25,2.65-.19.38,1.3,1.82-.35.38-1,.28-.91.61-1.54,3.53-1,.74-.51,1.17.24.94,1.88,2L440,266l1.9,1,0,.77-.57.46-2.07.83-.42,1,.09.51.36.33,1-.18.93.29.59.53.29.64-1,.73-1.16.42-2,1.69-.19.87-.06,2.95.35,1.28.95.66,1.48.5.17.42,0,1.09-1.38,2.41,0,.94,2.75,2.49,0,.38L440.77,290l-.49,2.55.11.34,1.65.85-.06.95-.23.38-1.61,1.05L438.92,300l-.05,1.57.63,3.56,1.71,3.5,3.25,2.66.05.46-.72,1.44-.1.68.68,1.74.24,1.29-.26.78-1.5,2,.52,2.44-1.44,3.47.41.24,1.35-.93.7-1,.73-.13,2.16.39,1.05-.78,1.88-2.62,1,.16,1.45-.53,1.83-1.57,1-1.2,2.05-.41,3.41-1.89.65-1.12,4.32-3.07,3.88-1.6,1.81.08,1.21.5,2.21,0,2.31.53.87.47-1.31,2.77-.14.9.27,1.52.61.5,5.4,1.49.65-.18.82-1.14,1.9-.91,1.79-.25,2.77.76,1.11.55,4.41,3.67,1-.18,2.2,1.64,2.58,1.24.94.22.51-.21,1.55,1.25,4.45-1.24.39.18,6.6,6.28.44,4,.58-.21,2.64.45,1.49-.5,1.34-1,2,.14,2.77.57,2.3,1.09,2.22.61,2.14,0,2.87,2.5.74.38.9.07.79,1,.42,1.18-1.48,3.12-5,4.28-.16,2.68.57,1v.43l-1,.72-2.5-.24-.83.89-.83,3.34-.54,4.46.23.25.34-.18.2-.46.66-.24.58,1.24-.23,1.53.16.52,4.18,3.09.54,1.05v.54l-.69,1.37.36.84h0l.31.53,8.2,5.21.57-2.07,2.76-3.94,1-.64,1.83-.68,2.27-3-.9-1.73-.4-4.48.09-2.36,1.08-3.77.16-2.9.47-1,1.37-6.74,2.24-6.74-1-3.47-.88-6.49-.19-4.6-.79-2.89-.2-2.5.51-1.83.75-5.5,1-2.64.07-1.79-.26-.54-.83.61.48,2.24-1.23,1.74-.6-.46.14-1.15.58.23.56-.5-.58-3.49,1-2.54-.33-1-.3-.3-.06-.63.23-.42-.24-.54-.76-.22-.37.73.37-2.55.21-.4,1.13.33-.9.08-.13,1.08.42.4.81.23-.26.36v.68l.64,0,.69-1.59-.11-1.15-.16-.2-.77.07-.16-.78.2-.85.35-.68,1.27-1,.25-1.85,1.23-1.16.46-1.83-1.16-.27-.38.16-.46-.24-1-1.71.89-1.31,0,.4-.32.14-.11.32.5,1.76.57.3.55-.39.51-.88.47-2.36.37-.61.69.76.44,1.32,1.89.25.46,2-.15,1.11-.37.15-.3,1.45h.88l2.48-1.28,5.1-5.81,1-2.36,3.88-5.26,4.13-8.94-.36-.42-.65,0,.06-.18,1.22-.63.26-.52-.28-.73.26-1.1.49-.51.45-1.14-.1-.69.82.37-.37,1.06-.32.43-.41.13-.49,1.42.3.47.79-.15.94-2.06.87-1.17.27-1.79-1.15-.63-.2-.69,1,.17.38.68.53.35,1.29-2.12.53-2-.24-.24H583.4l-.35-1.17,1-.17,1.07,1.85L585,256.1l.32,0,1.57-2.24,1-.9,4.63-3,2.41-.76h0l1.34-1.81,1-2,3.37-2.92,3.08-4.64,3.63-3.62L612,229l2.81-5-.27-.21h0l.27.21,3.3-9.06,2-6.46-.19-1.08-.27-.5-.71-.38V206l.11-.56,1.28-1.74-.55-1.24-.89-.23h0l.95,0,.36-.61.28-5.25-.6-1v-2l-.52,1.51-.59.75,0-.89.38-.45.18-.95-.06-.65-1.47-4.45-.09-2.43h0l-.22-1.53-1-2.73-.73-.55-.21-1.7-1.5-5.44,0-.76-.51-1.82-2.34-4.8-.65-.95-1-.83-2-.87-1.29,0-4.56-.93-2.36.74-2.57.24-2.92-.53-3.37.33-1.34-.51-1.71-1.77-1.23-.41h-3.17l-.88-.76-.47-.77h0l-.5-1.37-.8-.68-2.4-.93-1.17,0-1.51-.83-1.06-1-1.48-2-4.21-3.12-3-3.85-1.24-.62L561.86,142l-2.6-.73-3-2.14L554,136.78l-1.22-.2-4.88-3L546.4,133l-4.18-2.21-2-1.52-2.15-1.13-7.5-.8-2.1.67-2.92.43-6.83.23-.66.82.41.66,0,.63-.2.14","transform":"translate(280 2498) scale(1.23 1.22)"},on:{"mouseup":function($event){return _vm.Zoom('nordeste')},"mouseover":function($event){return _vm.MostraInvestidores('Nordeste')},"mouseout":function($event){return _vm.EscondeInvestidores('Nordeste')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('TO'),staticStyle:{"display":"none"},attrs:{"id":"to","d":"M434.518,283.624l-5.429,1.438-1.762,1.357-2.593,1.114h-1.57l-4.588,1.013-2.552,2.107-1.8.912-.466-.243-1.529-2.654-.557-.03-.517,3.342-.7.081-3.393-.689-3.17-1.489.567-1.58-.223-.75-4.588.537-2.8-.344-.567.547-.3,1.013-.76.76-1.155-.051-.618-3.14-1.124-3.758-1.053-1.9-1.165-1.327-1.2.983-1.489,2.421-1.651,6.017-.638.233-4.122-1.448-3.13-1.732-3.981-.405-2.228-1.043-2.431-.405.527-2.37,1.236-1.9.03-1.732-.567.3-1.833,2.117-.669,1.246-.2,1.9-.344.456h0l-.81-.02-.972-.517-.993-3.383.75-2.8-.446-3.089-.527-.587-.01-1.59.476-3.353-1.114-2.279.051-.506.831-.9.162-.881-1.408-1.357-.061-.871,1.9-6.067.041-2.988.547-3.008,1.965-5.358.375-.273.436-.861.446-3.18,1.114-1.266.567-1.914.658-1.033h0l1.641-3.738,1.145-4.507,1.165-1.6,1.205-1.114,1.226-1.7,1.043-1.945,1.388-.932,1.064-.162.739-.861.952-1.56.182-1,1.722-3.282,1.1-.81,1.783-5.216.669-4.092-.152-.3-.75-.324-1.692-1.762-.608-.962-.162-.891.142-.577,1.428-1.712,1.307-2.127-.061-2.7-.436-2.208.192-.355,2.5-1.8,3.454-1.155,2.532-1.226.243-.506-.152-1.529.871-1.286,1.529-1.357,1.307-.152.192-1.357-.294-1.215.253-.466,1.479-.466.648-.486.942-2.785-1.033-1.357-.091-1.418.294-.284.983-.081.729-.375.375-.669.03-.648-1.276-1.185-.881-.142-.4-.314-1.033-1.681-1.307-.122-1.894.253-2.32-.82h0l.537-.648,2.654-1.874,1.985-.537.881.051,2.816,1.54,1.418.081.962-.527,1.762.294.6.7.081,1.043.284.324,1.236.03,3.444,1.448.851,1.043.476,3.545.648,1.519-.213,3.768.233,1.094.679,1.145-.01.446-1.793,6.229-.314,2.4.284,1.013-.253,1.61-1.773,2.066-1.783.679-.182.719,1.965,1.337.425-.273,1.388.243.253.355.111.891-.628,1.205.861,1.459.891-.071,3.039,4.214.922.861,2.309,3.059,2.168-1.357,4.325-.952,1.823,1.236.081,1.773-.648,3.292.4,1.367-3.434.355-1.357.547-.577.557-.689,1.448-.739,2.715.375,1.317-2.664,2.583-.263.709.2.425,2.107.294.952.7.75,1.61.061,1.681.628,1.053,3.93,1.975.091.537-1.661,1.833.132,1.671,2.168,1.641,1,2.907,1.357,2.026.719.182,1.8-.213,1.013.3.831.446.618.831,1.3.668h0l2.978.213h0l-.7.658-.223.993-.567.476-3.869,2.046-3.251,2.654-.192.375,1.307,1.823-.365.4-1.023.273-.912.618-1.54,3.535-1.023.729-.506,1.175.233.932,1.884,1.975,3.636.679,1.894,1,.051.77-.567.456-2.066.82-.436.972.091.507.355.334,1.043-.182.932.294.587.517.294.648-.972.719-1.165.425-1.975,1.692-.192.861-.051,2.958.355,1.266.952.668,1.064.243.415.253.172.425.051,1.074-1.378,2.411Z","transform":"translate(300 2505) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('MA'),staticStyle:{"display":"none"},attrs:{"id":"ma","d":"M459.663,129.572l-.041.334-2.066,2.178-.436.172-.04,1.459,2-1.722.689-1.226,2.147-1.6.9-1.155,1.043-6.412,1.165-.709,1.124-.122,1.691-.932.658-.132.466.122.081,1.651-.2.456-1.438,1.894L464.15,125.6l-.03.729.739.122.456-.82,1.165-.314.223.841-.6.517.253.3,4.264-5.034.871.334,2.613-.942,4.092.436-.466-2.441.618-.233,2.451.081,1.8.385,2.664,1.064,1.053.111,2.178,1.4,1.418.03,1.276,1.317,1.914,1.337,2.532.587,1.175-.192.567.77.344.051,1.611-.091,2.492.669.263-.912-.679-.476,1.692-.385.577.111-.091.425h0l-.466,1.448.233.729.638.547-.385,1.55-1.813,2.3-4.183,4.021-3.363.466-.81-.162-2.958,3.444.041,1.823-.891,1.854-1.914,1.874-.831,2.005-.648.172-.78,1.064.365,1.945,1.246.841.385,1.3-.284,1.479-1.155,2.907,1.6,2.846.557,3.018-.111,2.461-.213.557-4.153,4.477-.172,2.512.122,2.137.517,2.33,1.8,2.066,1.631.922.172.506.132.851-.4,2.228-.294.446-.121,1.226-.507,1.479-1.226,1.327-2.32.294-.658-.284-.841.041-2.461.871-1.54.111-2.532-1.843-1.023-.213-1.479.192-1.023.608-1.134.263-.233-.3-.851.243-.507.223-1.924,1.935.01.466-.638.881-2.036,2.026-2.37.922-2.907,2.593-1.347.537-1.064.041-1.722,1.55-1.094.365-2.644.324-2.755.77-2.158,1.975-.993,3.008-.4,3.008-.638,2.35-1.469,2.775-.3.223-.344.831-.132,1.54-1.215,2.512L438.9,220.62l-.739,2.026.719,1.965.476,3.221,1.752,3.1-.041.527-.77,1.418-.132,6.442L439,241.8l-.263,1.074-.051,1.945h0l-1.3-.669-.618-.831-.831-.456-1-.294-1.8.2-.719-.182-1.367-2.026-1-2.9-2.157-1.641-.142-1.671,1.661-1.833-.081-.537-3.93-1.975-.628-1.064-.061-1.681-.76-1.61-.952-.7-2.107-.284-.2-.425.263-.719,2.664-2.573-.375-1.327.739-2.715.7-1.448.577-.557,1.357-.547,3.434-.355-.4-1.367.648-3.292-.081-1.783-1.823-1.226-4.325.952-2.178,1.357-2.3-3.059-.922-.861-3.039-4.2-.891.071-.851-1.459.618-1.205-.111-.891-.253-.344-1.388-.243-.425.273-1.955-1.347.182-.719,1.783-.668,1.772-2.066.253-1.61-.284-1.013.314-2.39,1.793-6.239.01-.436-.689-1.155-.233-1.094.213-3.768-.648-1.519-.476-3.535-.851-1.043-3.444-1.459-1.236-.02-.284-.324-.081-1.043-.6-.7-1.762-.294-.972.527-1.418-.091-2.816-1.529-.871-.061-1.985.537L395.4,165.54l-.537.648h0l-.5-.081,14.9-11.982,2.38.233,1.185-.932,1.57-2.2.436-1.165,1.57-1.185.628-2.917,1.134-.466,2.471-2.35.476-1.226.294-1.924,1.621-4.75,1.985-1.56,1.5-1.783.841-1.469.466-1.3-.182-1.843.8-.82-1.053-1.6,3.727-3.13-.132-1.661.506-2.411,1.762-1.59.365-.719.912-3.059.081-1.631-.436-.537-1,.162-.273-.5.051-.628,1.155-.152.577-.75.719-4.447-.162-1.4.476-1.043.78-.456h.638l.243-.243-.061-.547.344-.76.587-.537,1.357.993.456,1.864,1.205.122.78-1.378.618,2.968,1,.041.294-.5.071-.952.861-.041,1.712.537.506.7-1.448,1.722.679.709.02.557,1.226-2.066.5-1.56h.456l.405,1.033v.587l-.881.932-.273,1,.081,2.745.263.334.476.122.587-.142.972-.942-.476-1.013.142-.608,1.337-1.448,1.064-.253,2.157.6,1.519-1.124.051.932-.365.213-1.145,1.55.6.587.1-.375,1.266-.608.587.8-.142,1.226,1.651,1.773.871-.446,1.6.679.78,2.431-.111.962-2.218,2.765-.385.9.1.669.608-1.043,1.773-1.7.841-.03.881.82.527,1.914-.273,1.246-.983.192-1.043.922-1.175,1.509.071.78-1.175,2.38-.628,3.565.213.344.881.233Zm.527.456-.061-.8.537-1.55-.415-1.084.132-.669.922-1.256.557-.192.051,2.38-.223,1.357-.81.608Zm-6.381-26.092-.446-.466-.081-.608.81-1.134.851-.03.689.425.1.344-.192.365Zm3.545,4.234-.294-.3.061-.537,1.074-.9.486.071.506.861-.142.618-.405-.172ZM443.011,103.3l-.213-.051.962-3.626.3.091.03.233-.415,3.1Z","transform":"translate(301 2503) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('PI'),staticStyle:{"display":"none"},attrs:{"id":"pi","d":"M506.842,127.2l1.327.122.7-.233,2.269.517,1,.861.324.608h0l-.111.81-1.1,1.874-1.6,2-.182,1.479.294,1.307,1.823,4.781,3.191,6.5.446,1.752,1.378,1.611-.02.77-.749,1.378.8,3.92-.486,1.621,1.013,2.036.608,3.029-.6,1.6-.81.587.932.7.111.385.952,8.265-.243.456.77,2.6,1.064,5.267,1.023,2.7,1.327.658,2.593.476.78,1.175-.01.7-1.519,2.279-1.155,3.15.081.982.689.689-.061,1.337h0l-1.813.162-.527.334-.111.456.061.962.608,1.145-.071,2.218,1.641,1.6.294.547-.061,2.3-.75,1.783-3.94,3.92-.982.284-2.32,1.347-.547.881-2,1.732-2.654,1.286h0l-.456,1.175-1.519,2.33-1.064.679-.8-.182-2.026.385.111,2.431-1.884,1.823-.324-.051-.628-.628-2.188-.01-.831.993-.78.365-2.765.344-1.529,1.357-.831,1.236-1.722.1-1.5.648-3.039.111-.831-.284-.192-.284.132-.668-1.732-.993-1.347-.4-1.408.557-2.158.436-.324-.182-.415-.942-1.519-.466-1.975.02-3.282,1.671-.061.942,2.269,4.5.122,1.165-.294,2.6-.253.922-.729.871-2.988,5.115-3.008,2.451-1.367.425-1.5-.537-1.357-.172-2.228.76-1.185.9-.679.881-1.155.385-.76,1.469-.334.213-2.137-.182-1.823.527-4.234-1.874-1.793-2.522-.537-2.238L445,246.03l-1.459-1.357-2.36.02h0l-2.978-.213h0l.051-1.945.263-1.074,1.165-2.482.132-6.442.77-1.418.03-.517-1.752-3.1-.476-3.231-.709-1.965.739-2.026,1.722-1.418,1.215-2.512.132-1.529.344-.841.3-.213,1.459-2.775.638-2.35.4-3.008.993-3.018,2.157-1.975,2.755-.77,2.644-.314,1.084-.375,1.722-1.55,1.064-.041,1.357-.527,2.9-2.6,2.37-.922,2.036-2.026.638-.881v-.466l1.924-1.945.506-.223.851-.243.233.3,1.134-.263,1.013-.608,1.479-.192,1.023.213,2.542,1.843,1.529-.1,2.471-.871.841-.04.658.284,2.309-.294,1.226-1.327.506-1.479.122-1.226.294-.446.395-2.228-.132-.861-.172-.506-1.631-.922-1.8-2.056-.517-2.33-.111-2.137L483.2,170l4.153-4.487.213-.557.1-2.461-.557-3.018-1.6-2.836,1.155-2.907.284-1.489-.385-1.286-1.246-.851-.355-1.945.78-1.064.648-.172.831-2.006,1.914-1.874.891-1.854-.041-1.813,2.958-3.454.82.162,3.353-.466L501.3,131.6l1.813-2.3.4-1.55-.648-.537-.223-.729.466-1.459h0l.739.122,1.489.881.516.517-.132.314Z","transform":"translate(302 2503) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('AL'),staticStyle:{"display":"none"},attrs:{"id":"al","d":"M562.219,230.7l-.2-.739-1.438-.79-.456.091-1.033-.294-.547-1.418h0l1.337-1.084.648-1.1,2.2-.77,2.411-3.332.091-.7.831-.608,1.013,1.236,1.692.3,1.094-.122,2.583,2.046,1.924,2.147,1.8,1.064,1.935.486,2.532-.658,3.181.294,1.185-.111,1.884-1.074,1.175.051,1.833-1.124,2.208-2.319.121-.456,1.57-1.256,2.026-.243,2.269.861,2.593-1.307,1.489-.192,1.945.82,2.937.273.273.213h0l-2.816,5.024-4.609,5.2-3.626,3.626-3.079,4.639-3.373,2.917-1.013,2.056-1.337,1.813h0l-.608-1.327-3.636-2.259-.466-.03-1.681-.8-1.783-1.469-1.317-2.482-5.49-3.11-3.727-.962Z","transform":"translate(304 2508) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('BA'),staticStyle:{"display":"none"},attrs:{"id":"ba","d":"M529.042,367.531l-.365-.841.689-1.367-.01-.537-.537-1.053-4.183-3.089-.152-.517.223-1.53-.577-1.246-.658.243-.2.456-.344.182-.223-.253.537-4.457.831-3.343.831-.891,2.5.243,1.033-.719v-.425l-.567-1.033.162-2.684,5.024-4.274,1.489-3.12-.425-1.185-.79-1.033-.9-.061-.739-.385-2.866-2.5-2.147.02-2.218-.608-2.3-1.094-2.765-.567-2.005-.142-1.337,1-1.489.506-2.644-.456-.577.213-.446-4.011-6.6-6.28-.385-.182-4.447,1.246-1.55-1.256-.517.213-.942-.223-2.573-1.236-2.2-1.641-.993.182-4.406-3.677-1.114-.547-2.765-.76-1.793.253-1.9.912-.82,1.134-.648.182-5.4-1.489-.618-.5-.263-1.519.142-.9,1.307-2.775-.871-.466-2.309-.527-2.208-.041-1.215-.506-1.813-.081-3.879,1.6-4.315,3.069-.648,1.124-3.413,1.894-2.046.405-.962,1.2-1.833,1.57-1.448.527-1.013-.152-1.874,2.613-1.053.78-2.158-.385-.729.132-.7,1.013-1.357.932-.405-.243L437.6,319.1l-.517-2.441h0l1.5-2,.253-.78-.233-1.286-.679-1.742.1-.679.719-1.438-.051-.466-3.251-2.654-1.712-3.5-.628-3.565.051-1.57,1.215-3.879,1.611-1.043.233-.385.061-.952-1.651-.851-.111-.334.486-2.552,1.448-1.074-.02-.375-2.755-2.492h0l-.041-.942,1.378-2.411-.041-1.084-.172-.425-1.479-.5-.952-.658-.355-1.276.061-2.958.192-.861,1.975-1.692,1.155-.425.972-.729-.294-.638-.587-.527-.932-.294-1.043.182-.355-.334-.091-.506.425-.972,2.066-.831.567-.456-.041-.77-1.9-.993-3.626-.679-1.884-1.985-.233-.932.506-1.175,1.023-.739,1.54-3.525.912-.618,1.023-.273.355-.385-1.307-1.823.193-.375,3.251-2.654,3.869-2.046.567-.476.223-.993.7-.658h0l2.36-.02,1.459,1.357.668,1.053.537,2.238,1.783,2.522,4.234,1.884,1.823-.527,2.137.182.334-.213.76-1.469,1.155-.375.679-.881,1.185-.9,2.238-.76,1.347.172,1.5.537,1.367-.425,3.008-2.451,2.988-5.115.729-.871.243-.932.3-2.593L474,234.843l-2.269-4.487.051-.942,3.282-1.671,1.975-.02,1.519.466.415.942.324.182,2.147-.436,1.408-.547,1.347.385,1.732,1-.132.658.193.294.831.284,3.039-.111,1.489-.648,1.722-.1.831-1.236,1.53-1.357,2.765-.344.78-.365.82-.993,2.2.01.628.638.314.051,1.884-1.833-.1-2.431,2.016-.385.8.182,1.063-.669,1.519-2.34.466-1.165h0l.9.405,1.175-.273,2.228.294,2.856,1.408.446.517-.061,2.765.729,1.965,2.238.922.274,2.026-.932,1.7,1.854.628.972-.223.831-.932,2.907-.891.78-3.626.506-.881.76-.162.79.537.638.051,2.421-1.033,1.114-1.256.172-.6-.253-1.378.294-.253,2.269-.456.78-2.076,1.671-.446,2.563-1.479.6-.1,1.509.567.841,1.459,1.378.82,2.39.79,3.028.405,1.6,1.165.547,1.671.4.273.436-.152.294-1.773.436-.446,1.013-.01.456.324.02.638-.628.891.456.841.507.375,2.127.871.02.952,1.236,3.089h0l.547,1.418,1.033.294.456-.091,1.448.8.2.729h0l-.679,1.175.213,2.168,1.3,2.532,2.016,1.975.76,1.165-.081,3.16-.669,1.641-.091.891.77,2.785-.3.587-.7.557-2.583,1.013-1.145-.76-1.732-.01-.324.3-.6,1.6.02.78.962,1.621,1.114.669.527,1.509,1.448,1.529.152.4-.132,1.438-.344.4.122.425.6.527,1.955.932.486.719.547.344,1.57.648,2.927-.891h0l.648-.02.365.415-4.133,8.944-3.879,5.257-1.043,2.36-5.095,5.814-2.482,1.276-.881-.01.3-1.448.375-.152.142-1.114-.456-1.955-1.894-.253-.436-1.317-.689-.76-.375.608-.466,2.36-.506.881-.557.385-.567-.294-.5-1.762.111-.324.314-.132-.03-.4-.881,1.307.942,1.712.466.233.375-.152,1.165.263-.466,1.833-1.226,1.165-.253,1.843-1.266.983-.355.679-.2.851.182.861-1.367-.4-.213.4-.365,2.552.365-.729.76.213.243.547-.233.415.061.628.3.3.334,1.013-1.053,2.542.577,3.484-.557.5-.577-.223-.142,1.145.6.466,1.226-1.742-.476-2.238.831-.618.253.547-.061,1.783-.972,2.644-.75,5.5-.516,1.833.2,2.5.79,2.887.192,4.6.881,6.493,1,3.464-2.238,6.746-1.367,6.736-.476,1.023-.162,2.9-1.074,3.768-.091,2.36.4,4.477.9,1.732-2.269,3.018-1.833.679-.952.648-2.755,3.94-.577,2.066h0l-8.194-5.206-.314-.537Zm22.567-79.005-.233-1.215.75-.415,1.074-1.053.162-.648-.375-.739.77.142.831,1.063-.051.537-2.927,2.33Zm-2.563,6.938-.638-.03.01-.679.263-.365-.81-.223-.425-.405.132-1.084,1.894-.152.162.2.111,1.145Z","transform":"translate(302 2506) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('PB'),staticStyle:{"display":"none"},attrs:{"id":"pb","d":"M611.468,199.718l-2.532-2.087-.831-.263-2.684-.213-2.34,1.084-1.5,1.3-.456,1.823L599.2,202.4l-2.036.456-1.155-.02v.608l-.81.537-2.208.294-3.93-.263-1.631.891-.557.648-1.843.1-.9.7-.547.77.4.739.01.547-.405.486-1.8,1.55-1.357.162-1.671.851-1.621-.8-.962-.952-.354-2.269.243-.5-.182-.3-1.155-.324-.446.294-1.529.253.04-.456,2.563-2.674.172-.436-.729-1.894-.04-.476.375-.79,3.039-1.084.111-.3-.506-1.408-3.545-1.945-1.5.415-2.249,1.276-.942,1.529-1.5.881-1.063.314-2.735,1.9-1.54,1.661-1.651.233-2.664.983-.78-.334.051-.689-.638-1.256-.385-.081-.942.739-1.529.324-1-.334-1.418-1.935-.405-.091h0l-.172-.253,1.205-1.134L554,196.011l-.344-1.205-.7-.081-1.256-.9.02-1.681-.354-.729-.587-.294-.243-.415.122-.942.172-.385,1.1-.638.669-1.327-.527-1.327,1.043-3.039.851-1.165.081-.547h0l.577-.466,1.955,1.661.912.425,2.917.618,1.175-1.145,3.272-1.681.831-.719.1-1.053.415-.962,3.221-1.226,1.448-.122,3.3-1.053.648.081.537.446.01,1.205-3.028,3.251-.446.972-.385,1.762-.415.385-.861.253-.213.314-.081,1.742,3.576.527.324.233.314,1.4.294.233,3.191-1.276,1.793-.081,1.975.3.9,1.185-.527,1.56.841.75,2.38-.942.506-.75.557-1.226-.476-.952-.162-1.438.486-.6,1.023.324-.537-1.55-.729-.79.314-1.5,1.844-1.367,1.4-.051.425.395-.1,1.013.628.5,3.464.405.537.355,5.905-.4,2.2.3,2.492,1.114,1.053-.405,3.545.213.942-.243h0l.091,2.431,1.469,4.447.061.648-.182.952-.375.456-.03.891.588-.75.517-1.519.01,2.006.6,1.023-.273,5.247-.365.608Z","transform":"translate(304 2506) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('PE'),staticStyle:{"display":"none"},attrs:{"id":"pe","d":"M559.173,227.867l-1.236-3.079-.01-.952-2.137-.871-.506-.375-.456-.841.618-.9-.02-.628-.456-.324-1.013.01-.436.446-.294,1.762-.435.152-.4-.263-.547-1.671-1.6-1.165-3.029-.405-2.39-.78-1.367-.82-.841-1.459-1.509-.567-.6.111-2.563,1.479-1.671.446-.78,2.076-2.259.456-.294.253.253,1.378-.172.6-1.114,1.256-2.421,1.043-.648-.061-.78-.537-.77.172-.506.881-.78,3.616-2.907.891-.831.932-.972.233-1.864-.628.932-1.7L520.106,226l-2.239-.922-.729-1.965.061-2.765-.446-.517-2.846-1.4-2.228-.294-1.175.263-.912-.405h0l2.654-1.286,2-1.732.547-.881,2.32-1.347.982-.284,3.94-3.92.75-1.783.061-2.3-.294-.547-1.641-1.6.071-2.218-.608-1.145-.061-.962.111-.456.527-.334,1.813-.162h0l4.993.2.9.243,1.651-.192,2.168-.81,1.307-.1,3.12.425,2.887,1.924,1.854.841.466,1,1.023,1.084,1.377.486.79.577.638,1.661,1.671-.051,1.56-2.319,1.084-.841,1.611-.5h0l.405.091,1.418,1.935,1,.334,1.529-.324.942-.739.385.081.638,1.256-.051.689.78.334,2.664-.983,1.651-.233,1.54-1.661,2.735-1.9,1.064-.314,1.5-.881.942-1.529,2.249-1.276,1.5-.415,3.545,1.945.507,1.408-.111.3-3.039,1.084-.375.79.04.476.729,1.894-.172.436-2.563,2.674-.041.456,1.53-.253.446-.294,1.155.324.182.3-.243.5.355,2.269.962.952,1.621.8,1.671-.851,1.357-.162,1.8-1.55.405-.486-.01-.547-.395-.739.547-.77.9-.7,1.843-.1.557-.648,1.631-.891,3.93.263,2.208-.294.81-.537v-.608l1.155.02,2.036-.456,1.924-1.043.456-1.823,1.5-1.3,2.34-1.084,2.684.213.831.263L612,199.466h0l.891.233.557,1.236-1.286,1.742-.111.557.01.486.709.375.274.506.192,1.074-1.985,6.462-3.292,9.065h0l-.273-.213-2.937-.273-1.945-.82-1.489.192-2.593,1.307-2.269-.861-2.026.243-1.57,1.256-.122.456-2.208,2.32-1.833,1.124-1.175-.051-1.884,1.074-1.185.111-3.181-.294-2.532.658-1.935-.486-1.8-1.064-1.924-2.147-2.583-2.046-1.094.122-1.691-.3-1.013-1.236-.831.608-.091.7-2.411,3.332-2.2.77-.648,1.1Z","transform":"translate(303 2506) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('CE'),staticStyle:{"display":"none"},attrs:{"id":"ce","d":"M574.9,157.519l-4.953,1.611-2.644,2.036-3.342,6.776-.851,1.134-.881.577-.658,1.692.152.75-1.418,2.471-1.479,1.529-.577,1.114-1.043.263-.79-.517-.517.071-.851.891-1.428,2.279-.344,2,.648.172.668-.385h0l-.081.547-.851,1.165-1.043,3.039.527,1.327-.669,1.327-1.1.638-.172.385-.121.942.243.415.587.294.355.729-.02,1.681,1.256.9.7.081.344,1.205-1.631,3.535-1.205,1.134.172.253h0l-1.611.5-1.084.841-1.56,2.32-1.671.051-.638-1.661-.79-.577-1.378-.486-1.023-1.084-.466-1-1.854-.841-2.887-1.924-3.12-.425-1.307.1-2.168.81-1.651.192-.9-.243-4.994-.2h0l.061-1.337-.689-.689-.081-.982,1.155-3.15,1.519-2.279.01-.7-.78-1.175-2.593-.476-1.327-.658-1.023-2.7-1.064-5.267-.77-2.6.243-.456-.952-8.265-.111-.385-.932-.7.81-.587.6-1.6-.608-3.029-1.013-2.036.486-1.621-.8-3.92.749-1.378.02-.77-1.378-1.61-.446-1.752-3.191-6.5-1.823-4.781-.294-1.307.182-1.479,1.6-2,1.1-1.874.111-.81h0l.192-.142-.041-.628-.405-.669.658-.82,6.827-.223,2.927-.436,2.1-.669,7.5.8,2.147,1.134,1.965,1.519,4.173,2.208,1.479.527,4.882,3.039,1.226.2,2.249,2.32,3.029,2.137,2.6.729,2.471,2.947,1.236.618,3,3.859,4.214,3.12,1.479,2.026,1.053,1,1.519.831,1.165.03,2.4.932.8.679Z","transform":"translate(303 2504) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('RN'),staticStyle:{"display":"none"},attrs:{"id":"rn","d":"M610.285,183.507l-.942.243-3.545-.213-1.053.405-2.492-1.114-2.2-.3-5.905.4-.537-.355-3.464-.405-.628-.5.1-1.013-.425-.4-1.4.051-1.844,1.367-.314,1.5.729.79.537,1.55-1.023-.324-.486.6.162,1.438.476.952-.557,1.226-.506.75-2.38.942-.841-.75.527-1.56-.9-1.185-1.975-.3-1.793.081-3.191,1.276-.294-.233-.314-1.4-.324-.233-3.576-.527.081-1.742.213-.314.861-.253.415-.385.385-1.762.446-.972,3.029-3.251-.01-1.205-.537-.446-.648-.081-3.3,1.053-1.448.122-3.221,1.226-.415.962-.1,1.053-.831.719-3.272,1.681-1.175,1.145-2.917-.618-.912-.425-1.955-1.661-.577.466h0l-.668.385-.648-.172.344-2,1.428-2.279.851-.891.517-.071.79.517,1.043-.263.577-1.114,1.479-1.529,1.418-2.471-.152-.75.658-1.692.881-.577.851-1.134,3.342-6.776,2.644-2.036,4.953-1.61h0l.476.77.871.76,3.17-.01,1.236.415,1.712,1.773,1.337.506L586.5,161l2.917.527,2.573-.243,2.36-.739,4.558.932,1.286.04,1.975.871,1.033.831.648.952,2.34,4.8.506,1.813-.041.76,1.5,5.449.213,1.7.729.547.972,2.725Z","transform":"translate(304 2505) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('SE'),staticStyle:{"display":"none"},attrs:{"id":"se","d":"M570.355,262.356l-2.937.9-1.57-.648-.547-.344-.486-.729-1.945-.932-.608-.527-.121-.415.344-.4.132-1.438-.152-.4-1.448-1.529-.527-1.509-1.1-.679-.972-1.621-.02-.78.6-1.6.324-.3,1.722.01,1.145.76,2.583-1,.7-.557.3-.587-.77-2.785.081-.891.669-1.641.081-3.15-.76-1.165-2.016-1.975-1.286-2.532-.223-2.168.679-1.165h0l6.543,3.018,3.727.962,5.49,3.11,1.317,2.482,1.783,1.469,1.681.8.466.03,3.636,2.259.608,1.327h0l-2.411.77-4.629,2.978-.982.9-1.57,2.238-.324-.02.111-1.114-1.064-1.843-1,.162.344,1.175H577.2l.233.243-.527,2-1.286,2.117-.537-.355-.375-.679-1-.162.2.689,1.145.628-.263,1.793-.871,1.165-.942,2.056-.79.152-.3-.466.486-1.418.415-.132.314-.436.375-1.053-.82-.375.1.689-.456,1.145-.486.506-.263,1.1.284.729-.263.527Z","transform":"translate(304 2507) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}})]),_vm._v(" "),_c('a',[_c('path',{class:_vm.DensidadeInvestidores('centro-oeste'),attrs:{"id":"centro-oeste","d":"M494.292,337.84l-.826-2.121.123-.826.888-1.751-.062-.58-3.958-3.231-2.1-4.267-.764-4.341.062-1.911,1.467-4.723,1.961-1.27.284-.469.074-1.159-2.01-1.036-.123-.407.592-3.107,1.763-1.307-.025-.469-3.354-3.033-6.609,1.751-2.146,1.652-3.157,1.356h-1.911l-5.586,1.233-3.107,2.565-2.195,1.11-.567-.3-1.862-3.231-.678-.037-.629,4.069-.851.1-4.131-.838L451,309.455l.69-1.924-.271-.913-5.586.654-3.4-.419-.691.666-.37,1.233-.925.925-1.406-.062-.752-3.823-1.369-4.575-1.282-2.318-1.418-1.615-1.455,1.2-1.813,2.947-2.01,7.325-.777.284-5.019-1.763-3.81-2.109-4.846-.493-2.713-1.27-2.959-.493.641-2.885,1.5-2.318.037-2.109-.691.37-2.232,2.577-.814,1.517-.247,2.318-.419.555-.987-.025-1.184-.629-1.208-4.119.913-3.4L403.586,291l-.641-.715-.012-1.936.58-4.082-1.356-2.774.062-.617,1.011-1.1.2-1.073-1.714-1.652-.074-1.06,2.318-7.386.049-3.638.666-3.662,2.392-6.523.456-.333.53-1.048.543-3.872,1.356-1.541.691-2.331.8-1.258-77.648-4.291-41.975-2.984-4.55-1.837-1.689.555-.432-.395-.247-1.332-.666-.888-2.01-.555-1.011.21-1.172-.493-.284-.6.049-1.356-.284-1.159-4.168-2.1-3.7-3.391-1.887-1.369-.9-2.713-.592-2.959.284-3.009-.949-2-1.628-2.38-1.689-4.883-.493-2.17-3.021-5.006-1.443-1.332-1.455,1.48-.247.752-.074.937.419,1.036-.333,1.245-1.48,2.244-1.061.789-.518,1.048.123,1.048.814,1.689.567,2.392-1.7,5.2-1.455,6.437-1.492.9-59,.395,1.726,1.2.74,1.529-.937,1.751-1.591,6.153.074.432.962.58.321.752.185,1.714,1.023,2.8-1.159,2.059.469,2.38-1.233,4.34-.037.986.333,2.17,1.85,3.391-1.11,11.1,21.16.062-.3.69,1.5,1.369,4.316-.111,1.369.136,1.319.53,1.739,4.427-.21.925-1.726,2.158-1.677,1.332-.173,1.628.53,4.008.715.629,1.11-.037,1.887,4.119-.049,2.528.715,1.837-.086,2.109-.691,2.762-2.047,2.479-.641,2.774-.715,1.036-.53.506-2.022.654-1.147,1.332-1.763,4.661-.641,3.021-5.068,3.169-1.813,1.763,1.319,1.11,3.835,1.282,1.776,3.613-.8,1.578-.752.678-.321,1.307.6,2.429,3.255,6.56.432,9.31-6.018.074,6.622,7.559,1.295,15.6,33.121,1.332.469-.2.493-.74,1.184-.074.062,2.331-.419,2.195-1.406,1.344-1.085,2.022.234,4.513.752,2.183L254.06,389l.37,1.381.37.395,2.331.937,2.491,1.739.555.863,1.443.839.641.062,1.578-.777,3.009,2.651-.666.875.395.986.814.826h0l-.037,2.355,3.81,7.214-.814,1.43-3.983,12.738.912.16.345,2.626-1.381.074-6.634,14.082,5.179,4.76-.937,1.085-4.969,2.836.432,2.257,1.492,2.491.974,2.306.789,4.02.6-.8.53.111.937,1.184.062,2.133.814,2.873-.74,7.436-1.208,1.8-.74,1.751.53,2.935-1.122,8.965,3.083,1.085,1.1-.641,2.454.16.592,1.122,4.513.875,4.267-.284,3.157.6,2.146.851,1.332-.2,2.121-1,1.233.74,2.676-3.379,1.9-.407.691,1.837,3.033,2.417,2.257.358,1.862-.382,2.676.321,2.035,2.244.2,2.664.469.986,1.936,1.344-.025,1.985-.728,1.677.062.888.74,3.379,1.1,2.429v3.539l.111.543.789.974-.629,1.652.284,3.046,1.11,1.172.395.863.58,5.265,1.245.8,2.91.567,3.181-.53,2.047-.6.839-.925,4.92-2.429,4.2,2.331,3.144,2.873,2.935-1.924.444-1.011,1.936-9.766.407-.432,1.369-.395,2.047-1.245.826-.838,1.788-4.39L345.963,508l1.147-2.873,1.369-1.011,6.671-2.8,1.036-1.332.912-1.9,1.554-1.406,9.322-5.586,2.4-2.306,1.554-3.009,2.133-2.084.493-1.492,1.776-1.27.345-1.492-.432-1.048,2.466-2.787,1.492-2.885.1-1.171-.382-2.38.284-.469,1.184-.641,3.194-4.488.2-3.613.764-2.072,1.245-.37.9-.8,2.454-3.3,1.5-1.27.58-.271,1.628-.049,1.85-.962.345-.493.493-3.033.382-3.231-.728-3.958,1.221-5.154.715-.308h0l1.06.567.444-.284.012-.419-.691-.752.7-2.343,2.022-2.59,1.159-.912.555-.173,1.036.2,1.011-.345,1.036-1.6-.074-1.233,1.492-3.033,1.739-2.59,2.75-.666,3.058-1.184,4.575.764,3.934-2.022,1.874.37,1.615,1.751h.407l3.588-3.6,5.093-3.255,2.478,1.1,4.76-.2,1.825.345,2.158-.012.715-.111.678-.592,5.364,2.294.863.949,6.03-3.379.592-1.381,1.06-1.11,1.43-.247,3.81-2.54-1.467-4.267.629-2.331.9-1.11.21-.875-.222-1.233-.58-.752-1.948-.7-1.11.58-1.344-1.369.53-2.639,4-3.712,2.861-3.342v-.74l-2.035-5.623-1.751-1.27-1.048-.419-1.048-1.492.506-1.813,1.282-1.541.839-1.961-.382-1.936.654-1.874h0l1.566-.148,2.824-1.862,4.143-1.11.654-.654-.851-5.253-.654-.234-.518-.752-.049-2.343.9-.863.7-1.159-.6-1.43-.888-.123.888-3.921.456-.345,1.443-.284,3.428,1.406.493-.16.7-.666-.715-4.649,1.443-1.837,2.984,1.825,1.11,2.17,3.983.419,1.233-1.245,1.825-2.429.308-.949Z","transform":"translate(333.844 2544.673)"},on:{"mouseup":function($event){return _vm.Zoom('centro-oeste')},"mouseover":function($event){return _vm.MostraInvestidores('Centro-oeste')},"mouseout":function($event){return _vm.EscondeInvestidores('Centro-oeste')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('MS'),staticStyle:{"display":"none"},attrs:{"id":"ms","d":"M360.651,400.682l-.405,2.492-.284.405-1.519.79-1.337.041-.476.223-1.236,1.043-2.016,2.715-.739.658-1.023.3-.628,1.7-.162,2.968-2.623,3.687-.972.527-.233.385.314,1.955-.081.962L346,423.907l-2.026,2.289.354.861-.284,1.226-1.459,1.043-.405,1.226-1.752,1.712-1.276,2.471-1.975,1.894-7.657,4.588-1.276,1.155-.75,1.56-.851,1.094h0l-5.48,2.3-1.124.831-.942,2.36.02,1.165-1.469,3.606-.679.689L315.294,457l-1.124.324-.334.354-1.59,8.022-.365.831-2.411,1.58h0l-2.583-2.36-3.454-1.914-4.041,2-.689.76-1.681.5-2.613.436-2.39-.466-1.023-.658-.476-4.325-.324-.709-.912-.962-.233-2.5.517-1.357-.648-.8-.091-.446v-2.907l-.9-2-.608-2.775-.051-.729.6-1.378.02-1.631-1.59-1.1-.385-.81-.162-2.188-1.671-1.843-2.2-.263-1.529.314-1.854-.294L276,435.707l-.567-1.509-1.56.334-2.2,2.775-1.013-.608-1.742.82-1.094.162-1.762-.7-2.593-.5-3.5.233L256.263,436l-.486-.922-2.016-.132-.9.527-2.532-.891.922-7.364-.436-2.411.608-1.438.993-1.479.608-6.108-.669-2.36-.051-1.752-.77-.972-.436-.091-.5.658-.648-3.3-.8-1.894-1.226-2.046-.355-1.854,4.082-2.33.77-.891-4.254-3.91,5.449-11.567,1.134-.061-.284-2.157-.75-.132,3.272-10.463.668-1.175-3.13-5.925.03-1.935h0l.709.2,1.033,1.114,2.178,1.54,5.692-2,2.076-2.026,2.046-2.988.091-1.185,1.418-1.469,2.623.03,1.58-.223.78.344,1.681-.517,1.367-1.266,2.046-.5,1.286.2.77,1.165,2.826,1.266,2.654.476.658.355.273.871.79,1.033,3.069,1.175,1.276,1.124,1.256.577,4.578-.638,1.276-.81.5-.861,1.448-.618,2.471.071,1.611,1.053.3,1.388.243.253,1,.041,2.157-.891,1.023.061,5.692-6.087,1.357-.132-1.246,6.7-1.823.709-1.681,2.866-.192.466.152.537,1.317.111,1.762,1.286,4.68.274.577-.577,2.694-.081.881.081,1.185.577,1.57-.314h0l.192,1.793-.263,2.613.233,1.124.284.415.669.192,1.155-.679,2.279.912.081.425-1.327,1.783L331,376.16l-.263.851.132.334,3.849.709,2.816-.162,2.735,1.7,1.155.172,1.459.719.679.618,3.11,1.58.689.861,3.393,1.357,1.509.041,1.924.436,1.641,1.57,3.191.618,2.694,2.269.243.456h0l-.588.253-1,4.234.6,3.251Z","transform":"translate(297 2511) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('MT'),staticStyle:{"display":"none"},attrs:{"id":"mt","d":"M207.4,297.6l1.489-1.448,4.163-2.6.527-2.482,1.448-3.829.942-1.094,1.661-.537.436-.415.587-.851.527-2.279,1.681-2.036.567-2.269.071-1.732-.587-1.509.041-2.076-1.55-3.383-.912.03-.587-.517-.436-3.292.142-1.337,1.378-1.094,1.418-1.773.172-.76-1.428-3.636-1.084-.436-1.124-.111-3.545.091-1.236-1.124.243-.567-17.381-.051.912-9.116-1.519-2.785-.273-1.783.03-.81,1.013-3.565-.385-1.955.952-1.692-.841-2.3-.152-1.408-.263-.618-.79-.476-.061-.355,1.307-5.054.77-1.438-.608-1.256-1.418-.982h0l48.467-.324,1.226-.739,1.2-5.287,1.4-4.274-.466-1.965-.669-1.388-.1-.861.425-.861.871-.648,1.215-1.843.273-1.023-.344-.851.061-.77.2-.618,1.2-1.215h0l1.185,1.094,2.482,4.112.405,1.783,1.388,4.011,1.337,1.955.78,1.641-.233,2.471.486,2.431.739,2.228,1.55,1.124,3.039,2.785,3.424,1.722.233.952-.041,1.114.233.5.962.405.831-.172,1.651.456.547.729.2,1.094.355.324,1.388-.456,3.738,1.509,34.479,2.451,63.781,3.525h0l-.658,1.033-.567,1.914-1.114,1.266-.446,3.18-.436.861-.375.273-1.965,5.358-.547,3.008-.041,2.988-1.9,6.067.061.871L367,264.186l-.162.881-.831.9-.051.506,1.114,2.279-.476,3.353.01,1.59.527.587.446,3.089-.75,2.8.993,3.383.972.517.81.02h0l.081.638-.273,1.145-.982.871-.355.912.162,2.755-.4,1.084-2.026,3.211-1.043,2.664-1.226.79.122,5.247-1.621,3.13-.587,2.775.486,1.155.01.81-1.185,2.907-.851,2.968L358.51,318.6l-1.226.739-1.246-.689-1.084.263-1.671,1.023-1.945,1.965-.385.749-.648,4.153-.719.972-2.006,4.244-.324.284-2.755.871-2.684.132-1.418,2.654-1.773.983-.081,1.56-.831,1.448-1.3,1.053-.506,1.023L335.578,344l-1.266,2.046-1.945,1.793-2.046.851-.709.78-.385,2.948-2.583,3.9-.405,3.454.162.719,1.428,2.218.182,3.474.962,2.228h0l-1.57.314-1.185-.577-.881-.081-2.694.081-.577.577-4.68-.273-1.762-1.286-1.317-.111-.152-.537.192-.466,1.681-2.866,1.823-.709,1.246-6.7-1.357.132L312.049,362l-1.023-.061-2.157.891-1-.041-.243-.253-.3-1.388-1.61-1.053-2.471-.071-1.448.618-.5.861-1.276.81-4.578.638-1.256-.577-1.276-1.124-3.069-1.175-.79-1.033-.273-.871-.658-.355-2.654-.476-2.826-1.266-.77-1.165-1.286-.2-2.046.5-1.367,1.266-1.681.517-.78-.344-1.58.223-2.623-.03-1.418,1.469-.091,1.185-2.046,2.988-2.076,2.026-5.692,2L257,364.958l-1.033-1.114-.709-.2h0l-.668-.679-.324-.81.547-.719-2.471-2.178-1.3.638-.527-.051-1.185-.689-.456-.709-2.046-1.428-1.914-.77-.3-.324-.3-1.134-.233-2.968-.618-1.793-.192-3.707.891-1.661,1.155-1.1.344-1.8-.051-1.914-.972.061-.405.608-.385.162-27.206-1.094-1.064-12.813-5.439-6.209,4.943-.061-.355-7.647-2.674-5.389-.5-2,.263-1.074.618-.557.658-1.3-1.459-2.968-3.15-1.053Z","transform":"translate(297 2508) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('GO'),staticStyle:{"display":"none"},attrs:{"id":"go","d":"M418.163,334.867l-.881-1.023.213-2.471.6-1.205-.061-2.238-1.854-2.006-12.1-.01-.385,3.778-.932,1.854.527,3.3,14.879.02h0l-.537,1.54.314,1.59-.689,1.611-1.053,1.266-.415,1.489.861,1.226.861.344,1.438,1.043,1.671,4.619v.608l-2.35,2.745L414.983,356l-.436,2.168,1.1,1.124.912-.476,1.6.577.476.618.182,1.013-.172.719-.739.912-.517,1.914,1.205,3.5-3.13,2.087-1.175.2-.871.912-.486,1.134-4.953,2.775-.709-.78-4.406-1.884-.557.486-.587.091-1.773.01-1.5-.284-3.91.162-2.036-.9-4.183,2.674-2.947,2.958h-.334l-1.327-1.438-1.54-.3-3.231,1.661L375.187,377l-2.512.972-2.259.547-1.428,2.127-1.226,2.492.061,1.013-.851,1.317-.831.284-.851-.162-.456.142-.952.75-1.661,2.127-.577,1.924.567.618-.01.344-.365.233-.871-.466h0l-.243-.456-2.694-2.269-3.191-.618-1.641-1.57-1.924-.435-1.509-.041-3.393-1.357-.689-.861-3.11-1.58-.679-.618-1.459-.719-1.155-.172-2.735-1.7-2.816.162-3.849-.709-.132-.334.263-.851.577-1.185,1.327-1.783-.081-.425-2.279-.912-1.155.679-.668-.193-.284-.415-.233-1.124.263-2.613-.192-1.793h0l-.962-2.228-.182-3.474-1.428-2.218-.162-.719.405-3.454,2.583-3.9.385-2.948.709-.78,2.046-.851,1.945-1.793,1.266-2.046.334-1.975.506-1.023,1.3-1.053.831-1.448.081-1.56,1.772-.983,1.418-2.654,2.684-.132,2.755-.871.324-.284,2.006-4.244.719-.972.648-4.153.385-.75,1.945-1.965,1.671-1.023,1.084-.263,1.246.689,1.226-.739,1.408-1.448.851-2.968,1.185-2.907-.01-.81-.486-1.155.587-2.775,1.621-3.13-.122-5.247,1.226-.79,1.043-2.664,2.026-3.211.4-1.084-.162-2.755.355-.912.983-.871.273-1.145-.081-.638h0l.344-.456.2-1.9.669-1.246,1.833-2.117.567-.3-.03,1.732-1.236,1.9-.527,2.37,2.431.405,2.228,1.043,3.981.405,3.13,1.732,4.122,1.448.638-.233,1.651-6.017,1.489-2.421,1.2-.983,1.165,1.327,1.053,1.9,1.124,3.758.618,3.14,1.155.051.76-.76.3-1.013.567-.547,2.8.344,4.588-.537.223.75-.567,1.58,3.17,1.489,3.393.689.7-.081.517-3.342.557.03,1.53,2.654.466.243,1.8-.912,2.552-2.107,4.588-1.013h1.57l2.593-1.114,1.762-1.357,5.429-1.438h0l2.755,2.492.02.385-1.448,1.074-.486,2.552.1.334,1.651.851-.061.952-.233.385-1.611,1.043-1.205,3.879-.051,1.57.628,3.565,1.722,3.5,3.251,2.654.051.476-.729,1.438-.1.679.679,1.742.233,1.3-.253.78-1.5,2h0l-1.013,1.023-3.272-.344-.912-1.783-2.451-1.5L429.6,314.7l.587,3.819-.577.547-.405.132-2.816-1.155-1.185.233-.375.284-.729,3.221.729.1.5,1.175-.577.952-.739.709.041,1.924.425.618.537.192.7,4.315-.537.537-3.4.912-2.32,1.529Z","transform":"translate(299 2510) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('DF'),staticStyle:{"display":"none"},attrs:{"id":"df","d":"M417.169,334.245l-14.879-.02-.527-3.3.932-1.854.385-3.778,12.1.01,1.854,2.006.061,2.238-.6,1.205-.213,2.471Z","transform":"translate(300 2510) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}})]),_vm._v(" "),_c('a',[_c('path',{class:_vm.DensidadeInvestidores('sudeste'),attrs:{"id":"sudeste","d":"M365.761,421.916l-.493,3.033-.345.493-1.85.962-1.615.049-.58.284-1.5,1.258-2.454,3.3-.9.789-1.245.37-.765,2.072-.2,3.613-3.206,4.489-1.184.641-.284.481.382,2.38-.086,1.159-1.492,2.885-2.466,2.787.432,1.036-.345,1.5-1.776,1.27-.493,1.492-2.133,2.084-1.554,3-2.4,2.306-9.322,5.6-1.554,1.406-.9,1.9-1.036,1.332,4.008-2.824,4.723.8,4.945-.136,4.045.358,1.492-.764.419-.74.9-.456,1.443.358,1.825.974,3.12.567,3.255,1.344,1.628.16,1.319-.666,3.181-.012.962,1.233,2.158,1.036,4.328.986.777.629.888,1.628,2.121.086.518-.419,2.035.173.814.666,6.548.16,3.662-1.06,1.393,1.911,4.427,3.49,1.1,2.17.025,3.379-.481.715-.21,1,.469,2.269,1.6,1.874-.1,2.17-.444.678,1.837,3.712,1.492,1.406.826.358.617.839-.074,1.1,1.134,2.429.74.37.308.543-.308,1.295-1.578,2.614.407,2.516.74.481,1.245.259,2.935-.148,4.2-.654.617.469,1.948-.234,1.961.16,1.985,1.566-.173.493-1.1.814-.851,4.069.432.962,1.307.653.814-1.048,1.356-3.416.937-.21,2.639.715-.493,2.4.9,4.069,1.751.7.2,1.64h0l1.307-1.825,1.628-1.048.765-1.615v-.937l-1.147.444-.814-.074-1.11-.53.543-.765.826-.1,2.873-2.417,5.549-3.958,2.368-.654,4.008-2.4,4.032-3.7.382-1.43,1.171-1.011,9.4-5.228.37-.752-.321-.925,1.023-1.517,1.443,1.048.592,1.5-.715.58.616.148,1.615-.7,1.492-2.651.617-.629,2.133-1.011,1.628-.419,1.06-.185,3.847.617,1.652.358.863.789,1.726-.321.395-.518-.616-1.911-.049-1.184.345-.543,2.775-.863,3.971-1.911.937-.789-.333-.271.53-.8,1.825-1.369,1.307,1.011,2.084-.518.06-.2,1.728-.207,1.159.21,1.418-1.332-1.319-1.245-2.7-.16.234-2.343.419-1.122,3.884-.986,1.184-1.307,1.11-.518h.592L496.062,483l.863.062,1.27-.395,1.677-1.973,3.465-.839,1.726.616,3.12,1.911-3.194.728-3.934-.271-.469.333.086.962h0l1.8-.555,9.914-1.319,1.936.037,2.01-.629.727-.641-.308-1.2-1.7-1.443-.382-.974.321-.851,3.44-1.418.962.222.111.765-.826,1.788-1.27,1.825.074.839.6.469,2.947.567,7.14-.863,8.077.21,2.244-.629.9-1.825.234-2-.382-1.467.136-2.047,4.316-4.55,3.49-2.121,7.362-2.392,3.8-2.158.617-.838-1.406-8.36.271-2.627,1.159-1.985.1-1.566-.044-.03.353-1.376,1.961-2.491.518-1.541.074-1.714.987-1.517,2.294-.814.3.333,4.254-4.735,2.392-5.228-1.665-.641.358-1.578,1.085.16,1.023.839.949-1.813,1.208-4.686,2.059-4.106.678-.74,3.391-1.714,1.837-3.921.382-3.046-.888-7.584-.148-4.427.382-3.527,1.147-4.131-9.988-6.338-.37-.654m0,0-.432-1.023.838-1.665-.012-.654-.654-1.282-5.105-3.773-.185-.629.271-1.862-.715-1.517-.789.3-.247.555-.432.234-.271-.308.654-5.426,1.011-4.069,1.011-1.085,3.058.3,1.258-.876v-.518l-.691-1.258.185-3.268,6.116-5.2,1.813-3.8-.518-1.443-.962-1.258-1.1-.086-.9-.469-3.49-3.046-2.614.037-2.7-.752-2.787-1.332-3.366-.69-2.454-.185-1.628,1.221-1.813.617-3.218-.555-.7.259-.543-4.883-8.04-7.645-.469-.222-5.413,1.517-1.887-1.529-.629.259-1.147-.271-3.12-1.5-2.676-2-1.208.222-5.364-4.489-1.356-.666-3.366-.925-2.183.321-2.318,1.1-1,1.381-.789.21-6.572-1.8-.752-.617-.321-1.837.185-1.1,1.591-3.379-1.048-.567-2.811-.654-2.688-.037-1.48-.617-2.22-.111-4.711,1.948-5.265,3.736-.789,1.369-4.156,2.294-2.491.506-1.171,1.443-2.232,1.911-1.763.654-1.221-.185-2.281,3.169-1.282.95-2.627-.469-.888.16-.863,1.233-1.652,1.122-.493-.284,1.763-4.242-.629-2.972-1.233,1.245-3.983-.419-1.11-2.17-2.984-1.825-1.443,1.837.715,4.649-.7.666-.493.16-3.428-1.406-1.443.284-.456.345-.888,3.921.888.123.6,1.43-.7,1.159-.9.863.049,2.343.518.752.654.234.851,5.253-.654.654-4.143,1.11-2.824,1.862-1.566.148-.654,1.874.382,1.936-.839,1.961L434.6,347.9l-.506,1.813,1.048,1.492,1.048.419,1.751,1.27,2.035,5.623v.74L437.12,362.6l-4,3.712-.53,2.639,1.344,1.369,1.11-.58,1.948.7.58.752.222,1.233-.21.876-.9,1.11-.629,2.331,1.467,4.266-3.81,2.54-1.43.247-1.061,1.11-.592,1.381-6.03,3.379-.863-.949-5.364-2.294-.678.592-.715.111-2.158.012L413,386.8l-4.76.2-2.479-1.1-5.093,3.255-3.588,3.6h-.407L395.059,391l-1.874-.37-3.934,2.022-4.575-.765-3.058,1.184-2.75.666-1.739,2.59-1.492,3.033.074,1.233-1.036,1.6-1.011.345-1.036-.2-.555.173-1.159.913-2.022,2.59-.7,2.343.691.752-.012.419-.444.284-1.06-.567-.715.308-1.221,5.154.728,3.958-.382,3.231m128.6,64.689Zm4.069-1.948.53.863-3.033.617-.506-.432h-.58l-.481.9-.826-1.2,2.6-1.911ZM477.085,498.2l.16,3.588-.567.395-1.9-.8-1.43.222-.6-.469.123-.962,1.171-.8,1.344-2.281.888.308Z","transform":"translate(364.616 2570.098)"},on:{"mouseup":function($event){return _vm.Zoom('sudeste')},"mouseover":function($event){return _vm.MostraInvestidores('Sudeste')},"mouseout":function($event){return _vm.EscondeInvestidores('Sudeste')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('SP'),staticStyle:{"display":"none"},attrs:{"id":"sp","d":"M405.863,489.38l-.162-1.347-1.438-.577-.739-3.343.405-1.975-2.168-.587-.77.172-1.114,2.806-.669.861-1.074-.537-.355-.79.7-3.342.9-.669.142-.405-1.631-1.286-1.61-.132-1.6.192-.506-.385-3.454.537-2.411.122-1.023-.213-.608-.4-.334-2.066,1.3-2.147.253-1.063-.253-.446-.608-.3-.932-2,.061-.9-.506-.689-.679-.294-1.226-1.155-1.509-3.049.365-.557.081-1.783-1.317-1.54-.385-1.864.172-.82.4-.587-.02-2.775-.9-1.783L377,449.4l-1.145-1.57-3.008.871-5.378-.132-.669-.547-1.671-.142-.425.344-1.742-.071-.729-1.337-.638-.517-3.555-.81-1.773-.851-.79-1.013-2.613.01-1.084.547-1.337-.132-2.674-1.1-2.563-.466-1.5-.8-1.185-.294-.739.375-.344.608-1.226.628-3.322-.294-4.062.111-3.879-.658-3.292,2.32h0l.851-1.094.739-1.56,1.276-1.155,7.657-4.6,1.975-1.894,1.276-2.461L341.18,430l.405-1.226,1.459-1.043.284-1.236-.354-.851L345,423.36l1.226-2.37.071-.952-.314-1.955.233-.4.972-.527,2.633-3.687.162-2.968.628-1.7,1.023-.3.739-.648,2.016-2.715,1.236-1.033.476-.233,1.327-.04,1.519-.79.284-.405.405-2.492h0L360.871,399l2.178-1.124,1.945-.375,1.448-1.712,1.519-.618.76.142,1.752,1.57,2.583.081,4.345.972,1.692-.365,1.641.223,2.026-.6,2.208,1.438,1.692.8-.132.932.334,1.438,1.226,2.117.638.03.547-.324.679-.952.415-1.145.263-.192.557.051.365.4.253.972.01,2.816,1.216.537.415-.456-.273-2.573.5-1.205.456-.486,8.285-.679,1.023-1.266,1.519,1.479,1.134.435,2.816-.7.446-1-.2-.466.314-.618,2.411-.111,1.681.79.861-.648,1.327-.294,3.3,3.393.2,1.053-.577,1.023-.294,2.4.587.618,1.914,1.226.405,1.57-.061.567-1.54,2.056-.182,1.965.8.75.314.618.375,2.238,1.317,1.823.841,2.016-.03.861,1.631-.051.79-.314.284-.365,1.013-.051,3.748,1.337.233.375-.051,1.286-.709,2.208-1.884,2.755.263,2.978-.193,3.494-.537,1.58.729,1.621,1.8,1.256,1.833.841.517,1.742-1.226.709,2.046,3.353,1.145.253,2.036-.243.182.537,3.667-1.013.567.425,1.327-.324.76-.993.051-.851-.243-.243.172-2.33,1.205-.334.091.354-.354.5.01.486,2.37.081,2.421-.253,1.813-.679,1.246-1.256,1.955-1.033,2.238-.223,1.256-.739h0l1.286.547.567,1.185,1.246,1.61,1.793.4,3.191-.537,1.722.01.76,1.661-1.671,2.178-1.519.719-2.806.365-.506-.152L459,448.368l-1.1,1.165-1.1,3.545.051.415,1.651,1.752.486.263h0l-.061.2-1.712.425-1.074-.831-1.5,1.124-.435.658.273.223-.77.648-3.262,1.57-2.279.709-.284.446.041.972.506,1.57-.324.425-1.418.263-.709-.648-1.357-.294-3.16-.506-.871.152-1.337.344-1.752.831-.507.517-1.226,2.178-1.327.577-.506-.122.587-.476-.486-1.236-1.185-.861-.841,1.246.263.76-.3.618-7.718,4.295-.962.831-.314,1.175-3.312,3.039-3.292,1.975-1.945.537-4.558,3.251-2.36,1.985-.679.081-.446.628.912.436.669.061.942-.365v.77l-.628,1.327-1.337.861-1.074,1.5Zm44.881-23.306-1.56-.658-1.175.182-.5-.385.1-.79.962-.658,1.1-1.874.729.253.669.658.132,2.948-.466.324Z","transform":"translate(300 2512.098) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('RJ'),staticStyle:{"display":"none"},attrs:{"id":"rj","d":"M468.787,451.042l-.071-.79.385-.273,3.231.223,2.623-.6-2.563-1.57-1.418-.506-2.846.689-1.378,1.621-1.043.324-.709-.051-1.367-2.178h-.486l-.912.425-.972,1.074-3.191.81-.344.922-.192,1.924,2.218.132,1.084,1.023-1.165,1.094-.952-.172-1.438.172h0l-.486-.263-1.651-1.752-.051-.415,1.1-3.545,1.1-1.165,2.38-1.023.506.152,2.806-.365,1.519-.719,1.671-2.178-.76-1.661-1.722-.01-3.191.537-1.793-.4-1.246-1.61-.567-1.185-1.286-.547h0l.689-.5,2.451-.75,2.948-1.357,2.613-.172.506.273,1.742-.78,1.064-.78,4.143-1.813.527-.071.365.314,3.241-.071,1.266-.172,1.651-.952.577-.061,2.563.273.5.172-.02.476,1.4-.2,9.633-4.588,2.563-1,.213-.527-.284-.618-1.459-.132.091-.76,1.914-3.758,2.39-6.118-.739-.719.567-.5,1.256-.273,2.563-2.39h0l1.955.77.679,4.771,2.532,1.145,4.386,1.023,3.029-.375,1.641,1.074h0l-.081,1.286-.952,1.631-.223,2.157,1.155,6.867-.506.689-3.12,1.773-6.047,1.965-2.866,1.742-3.545,3.738-.111,1.681.314,1.205-.193,1.641-.739,1.5-1.843.517-6.634-.172-5.865.709-2.421-.466-.5-.385-.061-.689,1.043-1.5.679-1.469-.091-.628-.79-.182-2.826,1.165-.263.7.314.8,1.4,1.185.253.983-.6.527-1.651.517-1.59-.03-8.144,1.084-1.479.456Zm-5.176,2.016-.679-.983,2.137-1.57,1.884.952.436.709-2.492.506-.415-.354h-.476l-.4.739Z","transform":"translate(302 2512.098) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('MG'),staticStyle:{"display":"none"},attrs:{"id":"mg","d":"M529.938,366.368l-.922-.557-2.573-.82-1.6.081-1.094.324-.851.618-2.208.294-1.357-.132,1.692,2.3-.02.82-1.145-.111-1.064-.75-.314.02-2.2,1.327-1.185,1.955.3.709,1.347.679.527.669-.03,1.945-.3,1.56.213.415,1.327.354.172,1.742-.324.425-.962.243-.982-.03-.81-.354-1.5.091-.436.557.5.719.77.284.456-.294.527.091L517,382.827l1.286,2.846.294,2.461-.547,3.008L516.3,393.26l-1.256.871-.263.446-.243,1.742-.891,2.319-1.124,1.286-.983,3.282-.557.324-5.216-.03-1.742,2.087-.162.425.6,3.16-.577,1.317-.446,2.37.294.142h0l-2.563,2.38-1.256.273-.567.506.749.709L497.708,423l-1.925,3.758-.091.76,1.459.132.294.618-.213.527-2.563.993-9.633,4.588-1.388.2.02-.466-.5-.172-2.563-.273-.577.061-1.641.952-1.266.162-3.241.081-.365-.324-.517.081-4.153,1.8-1.063.78-1.732.78-.506-.284-2.623.172-2.948,1.357-2.451.75-.689.5h0l-1.266.739-2.228.223-1.955,1.033-1.246,1.256-1.813.679-2.411.253-2.37-.081-.01-.5.355-.5-.091-.355-1.205.334-.182,2.33.243.233-.051.851-.76.993-1.317.324-.577-.436-3.657,1.013-.192-.537-2.036.243-1.134-.253-2.056-3.353,1.236-.719-.527-1.732-1.823-.841-1.813-1.246-.719-1.631.537-1.58.192-3.494-.263-2.978,1.884-2.755.709-2.208.051-1.286-.233-.375-3.748-1.337-1.013.051-.284.365-.79.314-1.631.051.03-.861-.841-2.016-1.317-1.813-.375-2.238-.314-.628-.8-.75.192-1.965,1.54-2.056.061-.567-.405-1.57-1.9-1.226-.587-.618.294-2.4.577-1.023-.2-1.053-3.312-3.393-1.317.294-.861.648-1.671-.79-2.411.111-.314.618.2.466-.446,1-2.816.689-1.124-.436-1.529-1.469-1.023,1.266-8.285.689-.466.486-.486,1.205.273,2.573-.415.446-1.205-.527-.01-2.816-.253-.972-.365-.4-.567-.051-.263.192-.415,1.145-.679.952-.547.324-.628-.02-1.226-2.127-.334-1.438.142-.922-1.7-.8-2.208-1.438-2.016.6-1.641-.223-1.692.355-4.345-.972-2.583-.081-1.752-1.57-.76-.142-1.519.618-1.448,1.712-1.945.375-2.178,1.124-1.236,1.145h0l.314-2.654-.6-3.251,1-4.234.587-.253h0l.871.466.365-.233.01-.344-.567-.618.577-1.924,1.661-2.127.952-.749.456-.142.851.162.831-.284.851-1.317-.061-1.013,1.226-2.492,1.428-2.127,2.259-.547,2.512-.972,3.758.628,3.231-1.661,1.54.3,1.327,1.438h.334l2.947-2.958,4.183-2.674,2.036.9,3.91-.162,1.5.284,1.773-.01.587-.091.557-.486,4.406,1.884.709.78,4.953-2.775.486-1.134.871-.912,1.175-.2,3.13-2.087-1.205-3.5.517-1.914.739-.912.172-.719-.182-1.013-.476-.618-1.6-.577-.912.476-1.1-1.124.436-2.168,3.282-3.049,2.35-2.745v-.608l-1.671-4.619-1.438-1.043-.861-.344L415.34,342l.415-1.489,1.053-1.266.689-1.611-.314-1.59.537-1.54,1.286-.122,2.32-1.529,3.4-.912.537-.537-.7-4.315-.537-.192-.425-.618-.041-1.924.739-.709.577-.952-.5-1.175-.729-.1.729-3.221.375-.284,1.185-.233,2.816,1.155.405-.132.577-.547-.587-3.819,1.185-1.509,2.451,1.5.912,1.783,3.272.344,1.013-1.023h0l.517,2.441-1.448,3.484.405.233,1.357-.922.709-1.013.729-.132,2.157.385,1.053-.78,1.874-2.6,1,.152,1.448-.537,1.833-1.57.962-1.185,2.046-.415,3.413-1.884.648-1.124,4.325-3.069,3.869-1.6,1.823.091,1.215.506,2.208.03,2.309.537.861.466L472,309.7l-.152.9.263,1.509.618.506,5.4,1.479.648-.172.82-1.134,1.9-.9,1.793-.263,2.765.76,1.114.547,4.406,3.687.993-.182,2.2,1.641,2.563,1.236.942.223.517-.213,1.55,1.256,4.447-1.246.385.182,6.6,6.28.446,4.011.577-.213,2.644.456,1.489-.506,1.337-1,2.016.152,2.765.567,2.289,1.094,2.218.618,2.147-.03,2.867,2.5.739.385.9.071.79,1.033.425,1.185-1.489,3.12-5.024,4.274-.152,2.684.567,1.033v.425l-1.033.719-2.512-.243-.831.891-.831,3.342-.537,4.457.223.253.354-.192.2-.456.648-.243.587,1.246-.223,1.529.152.517,4.193,3.1.537,1.053.01.537-.689,1.367Z","transform":"translate(301 2510) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('ES'),staticStyle:{"display":"none"},attrs:{"id":"es","d":"M501.9,412.242l-.294-.142.446-2.37.577-1.317-.6-3.16.162-.425,1.742-2.087,5.216.03.557-.324.982-3.282,1.124-1.286.891-2.32.243-1.742.263-.446,1.256-.871,1.732-2.117.547-3.008-.294-2.461-1.286-2.846-1.114-1.286-.527-.091-.456.294-.77-.284-.5-.719.436-.557,1.5-.091.81.355.982.03.962-.243.324-.425-.172-1.742-1.327-.355-.213-.415.3-1.56.03-1.945-.527-.668-1.347-.679-.3-.709,1.185-1.955,2.2-1.327.314-.02,1.063.75,1.145.111.02-.82-1.692-2.3,1.357.132,2.208-.294.851-.618,1.094-.324,1.6-.081,2.573.82.922.557h0l.3.537,8.2,5.206h0l-.942,3.393-.314,2.9.122,3.636.729,6.229-.314,2.5-1.509,3.221-2.785,1.408-.557.608-1.692,3.373-.993,3.849-.78,1.489-.841-.689-.891-.132-.294,1.3,1.367.527-1.965,4.295-3.494,3.889-.243-.273-1.884.669-.81,1.246-.061,1.408-.425,1.266-1.611,2.046-.294,1.145h0l-1.641-1.074-3.029.375-4.4-1.023-2.532-1.145-.679-4.771Z","transform":"translate(303 2511) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}})]),_vm._v(" "),_c('a',[_c('path',{class:_vm.DensidadeInvestidores('sul'),attrs:{"id":"sul","d":"M407.062,585.392l1.282-2.318,4.624-5.475,3.453-3.157,5.093-3.749,2.022-.8,1.134-2.047-1.43-1.023-.222-3,.321-.407,1.134,1.455-.259,1.2.444.937.419.123,2.109-5.771.641-4.945,1.06-2.885-1.122-2.318-.382-2.38.7-.925-.7-3.194.419-4.735,1.467-.777.53.345.58-.074-.123-1.073-.432-.888-.949.629-.53-.247-.382-.678-.321-7.226-.937-.9-.123-.53.2-2.861,1.245-2.824-.691-1.172-2.109-2.047L424.5,516.3l.025-1.381,1.011,3.12,1.208.592,1.85-1.406.086-.481-.629-2.035.47-1.591h.06l.247-.851-.185-1.467-3.638.247.247-.555,2.984-.7,1.529-.949,1.9-3.428,1.2-.839-.333-.592-2.627-.74-1.726.308-1.985-.691-.419-.456.222-1.11.555-.148.974.666,3.058.654.37-.123.9-1.184-.641-.986.345-1.147.666-.456.7.21.419.481,1.073.025,1.1-.6,1.739-.345-1.776,1.171-.333,2.392.678.148.752-1.825,1.665-1.258-.2-1.628-1.751-.715-.9-4.069.493-2.4-2.639-.715-.937.21-1.356,3.4-.8,1.048-1.319-.654-.432-.962.851-4.069,1.1-.8.173-.506-1.985-1.554-1.961-.16-1.948.234-.617-.481-4.217.654-2.935.148-1.245-.259-.74-.469-.395-2.516,1.566-2.627.308-1.295-.308-.543-.74-.358-1.134-2.429.062-1.1-.617-.839-.826-.345-1.492-1.418-1.837-3.7.444-.691.1-2.17-1.6-1.862-.469-2.269.2-1,.481-.715-.012-3.379-1.1-2.17-4.427-3.49-1.393-1.911-3.662,1.048-6.548-.16-.814-.666-2.035-.185-.518.419-2.133-.086-.875-1.628-.777-.629-4.328-.986-2.158-1.036-.962-1.233-3.181.012-1.319.666-1.615-.16-3.255-1.344-3.107-.567-1.825-.962-1.443-.358-.9.456-.432.74-1.492.764-4.032-.358-4.945.136-4.723-.8-4.02,2.824-6.671,2.8-1.369,1.011-1.147,2.873.025,1.418-1.788,4.39-.826.838-2.047,1.245-1.369.395-.407.432-1.936,9.766-.444,1.011L319.66,472.4l-.974.666-.814,1.307.382,1.973,1.036,1.085.259,1.258-1.578,2.935.308,2.836-1.554,3.724-1.11,4.489-.025,1.529.6.925-.074.419-1.5,2.688L313.3,499.8l-.814,1.936.345,2.713,1.011-.074,1.8,1.332,1.319-1.11,1.356-.53,2.614.136,1.344-1.393,4.217,2.922,1.221,3.551-.025,3.194,3.12,5.154.266,1.467h-.02l-1.184,2.158.049,3.144-.506,3.958.715,4.008-.9,2.577-1.788,3.613h0l-.356-.444-2.848.9-1.245,1.665-.826.481-.617-.012-2.589,2.9-1.492.7-3.3.727-3.009,1.393-1.64.21-.358-.247-.062-.444-.407.049-1.628,2.91-.185,1.307-2.183,2.232-3.046.493-2.725,1.418-1.011,1.122-.123,1.134-1.295,1.319-3.44,1.171-1.011,1.184-1.332.469-.432.407.062.444L292,563.061l.259.715-.58,1.578L291,564.38l-1.936-.222-1.147.358-1.652,2.589-.629,1.591-1.048,1.418-2.01,2.22-2.022,1.06-.382.456-.123.752-2.417,5.2-1.689.506-1.48,1.048-1.011,1.319-.21,1.369-.777,1.751-6.72,7.99-1.134,1.233-.789.321-1.591.086-1.011.555-.74,1.542-.136,2.269-3.107,3.416-1.282.888-1.048.271.6.271.2,1.122.8.592,3.9-.173.715.592,1.369-.025,1.27-1.2.074-1.184,1.406-1.677,2.651-.259,2.343.173,3.317,2.725,2.158,2.6,2.688,2.54,2.922,2.183,4.5,5.29.481,1.233-.493,1.578-.123,3.526,3.292-.148,3.194-2.762.826-2.207.863-.1,3.12,2.614,1.369,1.837,2.355,4.575,2.676,1.7,2.17-.16,2.133,2.047,1.134.579,4.094.567,2.343,2.663.173,2.1,1.541.962,1.874,2.01,2.343,1.862,1.788-.259,2.947,1.492.826.728,2.54,2.762,1.517,2.5.53,1.455.123,1.961,1.492,2,2.861,2.774,2.774.74,1.319.765,1.8,2.035-2.836,3.157-1.023,1.924-3.5,2.935-.777,1.529-.185,1.319.567,5.241-.641,5.265.247.567,2.392,1.369.444-.012,2.676-1.961,9.606-9.285,2.072-3.107,2.479-5.537,2.38-8.484,2.861-5.574,2.627-2.035-.185-1.122-1.6-.777-.839.173-.53-.74.308-1.862,1.171-.69-.308-1.258-.592-1.023.136-2.17,2.91-1.6,1.2-2.8.123-2.8.654-1.961.888-.654,5.043-1.936.752-1.948,1.985-.789.888-.863-.271-.641.062-2.331,1.739-4.032.037-1.689.654-.814.555.481.58,1.578.037.875-.321.3.592.456.222-.95-.469-3.736.912-3.132.7-1-1.541-2.6-.543-2.775.752-3.342.789.851-.148.7.493,1.788.9,1.554.74.592,1.282-.407,1.011,1.1-.123,2.109,1,.543.654-.062.419-1.985,2.479-.493,1.862.025.432-.247.173-.7-.21-.481.321-.851.826.037,1.171,1.5.123.543-.58,3.8-.53.518-.456-.037-.616-.986-.691.839.259,2.811-.58,3.391-.9,1.332-3.379,1.961-.592.7-.629,2.553.358,1.726-.432.321-.333-1.023-.912-.37-1.936.086-.247,1.689.284,2.589-.222,1.147-.456,1.825-1.147,1.566-1.295,1.036-1.258.234-.555-.234-.925.851-3.514,4.575-1.011.839-3.182,1.739-1.258-.049-.691-.715-1.245-.493-1.147.21-.123.518,1.455,2.109-.419,2.688-.8,1.948.222.53,3.823-5.315,7.51-4.538,8.028-7.349,6.708-8.212,7.768-12.923,5.191-14.3,4.809-8.681,1.726-2.133h0m22.64-68.24.8,1.295-1.06,1.628-.888,2.528-2.306-2.491,3.144-3.009Zm2.17,26.228.814,1.159-.666,3.157-1.011,1.06-.728,1.5.247,1.443-1.418.949h0l-.185-.58.308-2.158.937-2.96-.493-1.455.2-1.258,1.726-.937Z","transform":"translate(348.42 2601.685)"},on:{"mouseup":function($event){return _vm.Zoom('sul')},"mouseover":function($event){return _vm.MostraInvestidores('Sul')},"mouseout":function($event){return _vm.EscondeInvestidores('Sul')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('PR'),staticStyle:{"display":"none"},attrs:{"id":"pr","d":"M398.226,500.42l-5.307-.03-.334.446-1.762.243-.77-.071-.111-.4-1.59.577-1.367,1.448L383.59,504.8l-1.459-.162-1.246-.628-3.17-2.633-1.043-.4-.77-.01-2.877.739-2.36.172-.82-.03-1.438-.77-1.124.142-1.55.658-.6,1.489-.739.881-1.894.993-3.616-.415-2.026,1.165-.729.78-.7,1.61.861,3.028-.881.871-.932.02-.76.385-.172.5-1.347-1.914-4.3.132-3.808-.436-1.6-1.2-.162-.415-1.043-.638-4.315-.365-5.358-1.7-2.37.577-2.725-.03-2.046-1.428-.324-.517-1.074-.243-.537-.01-.719.375-3.677-.02h0l-.223-1.226-2.563-4.234.02-2.623-1-2.917-3.464-2.4-1.1,1.145-2.147-.111-1.114.436-1.084.912-1.479-1.094-.831.061-.284-2.228.669-1.59,1.084-1.286,1.236-2.208.061-.344-.5-.76.02-1.256.912-3.687,1.276-3.059-.253-2.33,1.3-2.411-.213-1.033-.851-.891-.314-1.621.669-1.074.8-.547h0l2.411-1.58.365-.831,1.59-8.022.334-.355,1.124-.324,1.681-1.023.679-.689,1.469-3.606-.02-1.165.942-2.36,1.124-.831,5.48-2.3h0l3.3-2.32,3.879.658,4.062-.111,3.312.294,1.226-.628.354-.608.739-.375,1.185.294,1.5.79,2.552.466,2.674,1.1,1.327.132,1.084-.547,2.613-.01.79,1.013,1.773.851,3.555.81.638.517.719,1.337,1.752.071.425-.344,1.671.152.669.547,5.378.132,3.008-.861,1.145,1.57,3.636,2.866.9,1.783.01,2.775-.4.587-.162.82.385,1.864,1.317,1.529-.081,1.783-.365.567,1.509,3.039,1.226,1.165.679.284.506.689-.051.9.932,2,.608.294.253.446-.253,1.064-1.286,2.157.324,2.066.608.385,1.023.213,2.411-.121,3.464-.537.506.4,1.6-.193,1.61.132,1.631,1.276-.142.415-.9.658-.7,3.342.355.79,1.084.537.658-.861,1.114-2.8.77-.172,2.168.587-.405,1.975.739,3.342,1.438.587.162,1.337h0l-1.367,1.033-.618,1.5-.557-.122.273-1.965,1.459-.962-1.428.284-.9.5-.881-.02-.344-.4-.577-.172-.547.375-.284.942.527.81-.739.972-.3.1-2.512-.537-.8-.547-.456.122-.182.912.344.375,1.631.567,1.418-.253,2.158.608.273.486-.982.689L399.2,496.9l-1.256.78-2.451.577-.2.456,2.988-.2.152,1.205Z","transform":"translate(298 2515) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('SC'),staticStyle:{"display":"none"},attrs:{"id":"sc","d":"M380.395,559.027l-.456.03-1.185-.861-.739-.932-1.61-.638-1.5.831-.01.972.284.983-.273.2-1.823-1.185.041-1.428,1.3-1.712,1.2-.2.537-1.327.375-1.57-.223-2.218.739-1.884,1.286-.425,2.107-1.6-.891-2.37-3.393-.344-2.137.405-6.776-1.074-1.175-.547-2.2-2.694-.5-1.5-1.651-2.238-3.069-3.535-1.59-1-.719.03-1.388-1.57-5.632-3.586-1.833.344-.091.486-1.621-.192-1.013-2.471-2.5-1.408-2.3-.942-2.826.162-1.56-.182-2.623.415-1.935-1.165-2.6.365-1.651-.993-3.12.03.152-.942-1.367-.587-.567.82-3.3,1.175-3.565-.395h0l1.469-2.968.739-2.117-.587-3.292.415-3.251-.041-2.583.972-1.773h0l3.677.02.719-.385.537.01,1.074.243.314.517,2.056,1.428,2.714.03,2.37-.587,5.358,1.7,4.315.365,1.033.638.172.415,1.59,1.2,3.819.425,4.3-.132,1.347,1.924.182-.506.75-.385.932-.02.881-.871-.861-3.029.7-1.6.729-.79,2.026-1.155,3.616.405,1.894-.982.739-.881.6-1.5,1.55-.658,1.124-.142,1.438.77.82.03,2.36-.172,2.877-.739.76.01,1.053.405,3.16,2.634,1.246.628,1.459.162,3.393-2.157,1.367-1.448,1.58-.577.122.4.77.071,1.762-.233.334-.446,5.308.03h0l-.4,1.337.517,1.671-.071.4-1.519,1.155-.993-.486-.831-2.563-.02,1.134.6,2.755,1.732,1.681.567.962-1.023,2.32-.162,2.35.1.436.77.739.263,5.936.314.557.436.2.78-.517.355.729.1.881-.476.061-.436-.284-1.205.638-.344,3.889.577,2.624-.577.76.314,1.955.922,1.9-.871,2.37-.527,4.062-1.732,4.74-.344-.1-.365-.77.213-.982-.932-1.2-.263.334.182,2.461,1.175.841-.932,1.681-1.661.658-4.183,3.079-2.836,2.593-3.8,4.5-1.053,1.9Zm18.11-26.892-.152-.476.253-1.773.77-2.431-.405-1.2.162-1.033,1.418-.77.223.061.669.952-.547,2.593-.831.871-.6,1.236.2,1.185-1.165.78Zm-.456-24.684-1.894-2.046,2.583-2.471.253.041.658,1.063-.871,1.337Z","transform":"translate(298 2515) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInvestidoresEstado('RS'),staticStyle:{"display":"none"},attrs:{"id":"rs","d":"M323.1,640.328l-.365.01-1.965-1.124-.2-.466.527-4.325-.466-4.3.152-1.084.638-1.256,2.877-2.411.841-1.58,2.33-2.593-1.479-1.671-1.084-.628-2.279-.608-2.35-2.279-1.226-1.641-.1-1.611-.436-1.2-1.246-2.056-2.087-2.269-.679-.6-2.421-1.226-1.469.213-1.924-1.529-1.54-1.651-1.266-.79-.142-1.722-1.924-2.188-3.363-.466-.932-.476-1.752-1.681-1.783.132-2.2-1.4-1.935-3.758-1.124-1.509-2.563-2.147-.709.081-.679,1.813-2.623,2.269-2.7.122.1-2.9.405-1.3-.4-1.013-3.7-4.345-2.4-1.793L273.26,577.3l-1.773-2.137-2.725-2.239-1.924-.142-2.178.213-1.155,1.377-.061.972-1.043.982-1.124.02-.587-.486-3.2.142-.658-.486-.162-.922-.5-.223.861-.223,1.053-.729,2.552-2.806.111-1.864.608-1.266.831-.456,1.307-.071.648-.263.932-1.013,5.52-6.563.638-1.438.172-1.124.831-1.084,1.215-.861,1.388-.415,1.985-4.274.1-.618.314-.375,1.661-.871,1.651-1.823.861-1.165.517-1.307,1.357-2.127.942-.294,1.59.182.557.8.476-1.3-.213-.588-1.367-.831-.051-.365.355-.334,1.094-.385.831-.972,2.826-.962,1.063-1.084.1-.932.831-.922,2.238-1.165,2.5-.405,1.793-1.833.152-1.074,1.337-2.39.334-.041.051.365.294.2,1.347-.172,2.471-1.144,2.715-.6,1.226-.577,2.127-2.38.506.01.679-.4,1.023-1.367,2.34-.739.3.385h0l3.565.4,3.3-1.165.567-.82,1.367.588-.152.932,3.12-.03,1.651,1,2.593-.375,1.945,1.165,2.613-.415,1.56.182,2.836-.162,2.289.932,2.512,1.418,1.013,2.471,1.611.192.091-.486,1.833-.354,5.632,3.586,1.388,1.57.719-.03,1.58.993,3.069,3.535,1.661,2.239.486,1.5,2.2,2.694,1.185.557,6.776,1.074,2.137-.405,3.393.344.891,2.37-2.107,1.6-1.286.415-.739,1.884.223,2.218-.385,1.58-.527,1.317-1.2.2-1.307,1.712-.03,1.428,1.823,1.185.273-.2-.284-.982.01-.972,1.509-.831,1.6.648.739.922,1.185.861.456-.03h0l-1.418,1.752-3.95,7.131-4.264,11.749-6.381,10.615-5.51,6.746-6.594,6.037-6.168,3.727-3.14,4.365-.182-.435.658-1.6.344-2.208-1.2-1.732.1-.425.942-.172,1.023.405.567.588,1.033.041,2.613-1.428.831-.689,2.887-3.758.76-.7.456.193,1.033-.193,1.064-.851.942-1.286.375-1.5.182-.942-.233-2.127.2-1.388,1.59-.071.75.3.273.841.355-.263-.294-1.418.517-2.1.486-.577,2.775-1.611.739-1.094.476-2.785-.213-2.309.567-.689.506.81.375.03.436-.425.476-3.12-.1-.446-.962-1.236-.679-.031-.263.7.172.4-.142.577-.355.2-1.529-.02-2.036.405-.344,1.631-.537.051-.82-.446.1-1.732-.831-.9-1.053.334-.608-.486-.739-1.276-.405-1.469.122-.577-.648-.7-.618,2.745.446,2.279,1.266,2.137-.577.82-.75,2.573.385,3.069-.182.78-.486-.375.263-.243-.03-.719-.476-1.3-.456-.4-.537.668-.03,1.388-1.428,3.312-.051,1.914.223.527-.729.709-1.631.648-.618,1.6-4.143,1.59-.729.537-.537,1.611-.1,2.3-.983,2.3-2.39,1.317-.111,1.783.486.841.253,1.033-.962.567-.253,1.529.436.608.689-.142,1.317.638.152.922-2.157,1.671-2.35,4.578-1.955,6.969-2.036,4.548-1.7,2.552-7.89,7.627Z","transform":"translate(298 2515) scale(1.2)"},on:{"click":function($event){return _vm.zoomOut()}}})])]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresNorte",attrs:{"x":"270","y":"180","fill":"white"},on:{"mouseover":function($event){return _vm.MostraInvestidores('Norte')}}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresRegiao[0]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresNordeste",attrs:{"x":"610","y":"260","fill":"white"},on:{"mouseover":function($event){return _vm.MostraInvestidores('Nordeste')}}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresRegiao[1]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresCentro-oeste",attrs:{"x":"370","y":"400","fill":"white"},on:{"mouseover":function($event){return _vm.MostraInvestidores('Centro-oeste')}}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresRegiao[2]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresSudeste",attrs:{"x":"540","y":"500","fill":"white"},on:{"mouseover":function($event){return _vm.MostraInvestidores('Sudeste')}}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresRegiao[3]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresSul",attrs:{"x":"420","y":"650","fill":"white"},on:{"mouseover":function($event){return _vm.MostraInvestidores('Sul')}}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresRegiao[4]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNorte",attrs:{"x":"130","y":"335","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[0]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNorte",attrs:{"x":"260","y":"220","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[2]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNorte",attrs:{"x":"290","y":"380","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[20]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNorte",attrs:{"x":"330","y":"100","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[21]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNorte",attrs:{"x":"515","y":"220","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[13]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNorte",attrs:{"x":"545","y":"100","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[3]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNorte",attrs:{"x":"620","y":"360","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[26]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNordeste",attrs:{"x":"330","y":"170","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[9]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNordeste",attrs:{"x":"400","y":"220","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[16]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNordeste",attrs:{"x":"470","y":"170","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[5]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNordeste",attrs:{"x":"540","y":"174","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[19]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNordeste",attrs:{"x":"550","y":"210","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[14]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNordeste",attrs:{"x":"515","y":"235","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[15]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNordeste",attrs:{"x":"550","y":"265","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[1]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNordeste",attrs:{"x":"520","y":"288","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[24]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoNordeste",attrs:{"x":"410","y":"330","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[4]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoCentro-oeste",attrs:{"x":"400","y":"380","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[11]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoCentro-oeste",attrs:{"x":"380","y":"170","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[12]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoCentro-oeste",attrs:{"x":"560","y":"260","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[8]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoCentro-oeste",attrs:{"x":"610","y":"220","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[6]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoSudeste",attrs:{"x":"300","y":"300","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[25]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoSudeste",attrs:{"x":"570","y":"210","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[7]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoSudeste",attrs:{"x":"520","y":"290","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[18]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoSudeste",attrs:{"x":"450","y":"180","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[10]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoSul",attrs:{"x":"420","y":"220","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[23]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoSul",attrs:{"x":"330","y":"290","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[22]))]),_vm._v(" "),_c('text',{staticClass:"QuantidadeInvestidoresEstadoSul",attrs:{"x":"380","y":"130","fill":"white"}},[_vm._v(_vm._s(this.Estatisticas.InvestidoresEstado[17]))])]),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),_vm._m(3)]),_vm._v(" "),(this.Renderizou == true)?_c('div',{staticClass:"row mt-4 mb-4 statistics__intern--investor"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row no-gutters border box rounded"},[_c('div',{staticClass:"col-12 col-md-4 p-3 p-md-4"},[_c('h3',{staticClass:"pb-3"},[_vm._v("Investimentos por tipo")]),_vm._v(" "),_c('canvas',{staticStyle:{"margin-top":"5%"},attrs:{"id":"GraficoInvestimentoTipo","hidden":"","width":"269px","height":"180px"}}),_vm._v(" "),_c('ul',{staticClass:"circle score",attrs:{"id":"ListaTipos"}},[_c('li',[_c('span',[_vm._v("Empréstimo coletivo")]),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosTipoValores[0])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosTipoQuantidades[0]))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Empréstimo de impacto")]),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosTipoValores[1])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosTipoQuantidades[1]))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Empréstimo social")]),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosTipoValores[2])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosTipoQuantidades[2]))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 p-3 p-md-4 border-center"},[_c('h3',{staticClass:"pb-3"},[_vm._v("Investimentos por score")]),_vm._v(" "),_c('canvas',{staticStyle:{"margin-top":"5%","margin-bottom":"5%"},attrs:{"id":"GraficoInvestimentoScore","hidden":"","width":"269px","height":"180px"}}),_vm._v(" "),_c('ul',{staticClass:"rating score",attrs:{"id":"ListaScores"}},[_c('li',[_vm._m(4),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosScoreValores[0])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosScoreQuantidades[0]))])]),_vm._v(" "),_c('li',[_vm._m(5),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosScoreValores[1])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosScoreQuantidades[1]))])]),_vm._v(" "),_c('li',[_vm._m(6),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosScoreValores[2])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosScoreQuantidades[2]))])]),_vm._v(" "),_c('li',[_vm._m(7),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosScoreValores[3])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosScoreQuantidades[3]))])]),_vm._v(" "),_c('li',[_vm._m(8),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosScoreValores[4])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosScoreQuantidades[4]))])]),_vm._v(" "),_c('li',[_vm._m(9),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosScoreValores[5])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosScoreQuantidades[5]))])]),_vm._v(" "),_c('li',[_vm._m(10),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosScoreValores[6])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosScoreQuantidades[6]))])]),_vm._v(" "),_c('li',[_vm._m(11),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosScoreValores[7])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosScoreQuantidades[7]))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 p-3 p-md-4"},[_c('h3',{staticClass:"pb-3"},[_vm._v("Total de investimentos")]),_vm._v(" "),_c('canvas',{staticStyle:{"margin-top":"5%"},attrs:{"id":"GraficoTotalInvestimentos","hidden":"","width":"269px","height":"180px"}}),_vm._v(" "),_c('ul',{staticClass:"values",attrs:{"id":"ListaPeriodos"}},[_c('li',[_c('span',[_vm._v("Atual "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Investimentos com pagamentos pendentes a receber que estão em dia."}},[_c('i',{staticClass:"fas fa-info-circle",staticStyle:{"font-size":"14px"}})])],1),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosPeriodoValores[0])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosPeriodoQuantidades[0]))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Período de carência \n                                "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Corresponde ao período compreendido entre a concessão do empréstimo e o pagamento da primeira amortização + juros."}},[_c('i',{staticClass:"fas fa-info-circle",staticStyle:{"font-size":"14px"}})])],1),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosPeriodoValores[1])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosPeriodoQuantidades[1]))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("1-15 dias de atraso \n                                "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Seus investimentos que estão com 1 a 15 dias de atraso."}},[_c('i',{staticClass:"fas fa-info-circle",staticStyle:{"font-size":"14px"}})])],1),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosPeriodoValores[2])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosPeriodoQuantidades[2]))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("16-30 dias de atraso \n                                "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Seus investimentos que estão com 16 a 30 dias de atraso."}},[_c('i',{staticClass:"fas fa-info-circle",staticStyle:{"font-size":"14px"}})])],1),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosPeriodoValores[3])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosPeriodoQuantidades[3]))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("31 a 60 dias de atraso \n                                "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Seus investimentos que estão com 31 a 60 dias de atraso."}},[_c('i',{staticClass:"fas fa-info-circle",staticStyle:{"font-size":"14px"}})])],1),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosPeriodoValores[4])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosPeriodoQuantidades[4]))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("+60 dias de atraso \n                                "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Os pagamentos para estes empréstimos estão com mais de 60 dias de atraso. Existe uma expectativa razoável de que o mutuário será capaz de trazer o empréstimo de volta ao status atual."}},[_c('i',{staticClass:"fas fa-info-circle",staticStyle:{"font-size":"14px"}})])],1),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.InvestimentosPeriodoValores[5])))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.InvestimentosPeriodoQuantidades[5]))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Total")]),_vm._v(" "),(_vm.valor == 'por valores')?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatisticas.TotalInvestimentosPeriodoValor)))]):_c('span',[_vm._v(_vm._s(this.Estatisticas.TotalInvestimentosQuantidade))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex flex-column justify-content-center border-top p-4 p-md-5"},[_c('div',{staticClass:"d-flex justify-content-center  pb-2"},[_c('div',{staticClass:"form-check pr-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valor),expression:"valor"}],staticClass:"option-input radio",attrs:{"id":"valor","type":"radio","name":"tipo","checked":""},domProps:{"value":'por valores',"checked":_vm._q(_vm.valor,'por valores')},on:{"click":function($event){return _vm.EscondeGraficos()},"change":function($event){_vm.valor='por valores'}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor"}},[_vm._v("Por valores")])]),_vm._v(" "),_c('div',{staticClass:"form-check pr-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valor),expression:"valor"}],staticClass:"option-input radio",attrs:{"id":"num","type":"radio","name":"tipo"},domProps:{"value":'por números',"checked":_vm._q(_vm.valor,'por números')},on:{"click":function($event){return _vm.EscondeGraficos()},"change":function($event){_vm.valor='por números'}}}),_vm._v(" "),_c('label',{attrs:{"for":"num"}},[_vm._v("Por números")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valor),expression:"valor"}],staticClass:"option-input radio",attrs:{"id":"graf","type":"radio","name":"tipo"},domProps:{"value":'por gráficos',"checked":_vm._q(_vm.valor,'por gráficos')},on:{"click":function($event){return _vm.MostraGraficos()},"change":function($event){_vm.valor='por gráficos'}}}),_vm._v(" "),_c('label',{attrs:{"for":"graf"}},[_vm._v("Por gráficos")])])]),_vm._v(" "),_vm._m(12)])])])]):_vm._e(),_vm._v(" "),(this.Renderizou == true)?_c('div',{staticClass:"row justify-content-center statistics__intern--data mt-5 mb-5"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-9"},[_c('div',{staticClass:"row text-center"},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v(_vm._s(_vm.money(this.Estatisticas.RetornoMedioCdi))+"%")]),_vm._v(" "),_c('label',[_vm._v("retorno médio (CDI)")]),_vm._v(" "),_c('p',[_vm._v("Retorno médio dos empréstimos em curso (CDI).")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v(_vm._s(_vm.money(this.Estatisticas.CreditoVencido))+"%")]),_vm._v(" "),_c('label',[_vm._v("crédito vencido")]),_vm._v(" "),_c('p',[_vm._v("% de capital em atraso há mais de 60 dias e que está em processo de recuperação.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v(_vm._s(_vm.money(this.Estatisticas.RetornoMedioCdiReal))+"%")]),_vm._v(" "),_c('label',[_vm._v("retorno médio real(CDI)")]),_vm._v(" "),_c('p',[_vm._v("Retorno médio dos empréstimos em curso descontando a % de crédito vencido.")])])])])]):_vm._e(),_vm._v(" "),(this.Renderizou == true)?_c('div',{staticClass:"row justify-content-center statistics__intern--data mt-5 mb-5"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-9"},[_c('div',{staticClass:"row text-center"},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v(_vm._s(_vm.money(this.Estatisticas.RentabilidadeAcumuladaBruta))+"%")]),_vm._v(" "),_c('label',[_vm._v("rentabilidade acomuludada bruta")]),_vm._v(" "),_c('p',[_vm._v("Rentabilidade acumulada bruta dos empréstimos realizados desde o lançamento (12 meses).")])]),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v(_vm._s(_vm.money(this.Estatisticas.RentabilidadeAcumuladaBruta))+"%")]),_vm._v(" "),_c('label',[_vm._v("Rentabilidade acumulada ajustada")]),_vm._v(" "),_c('p',[_vm._v("Rentabilidade acumulada bruta descontando a % de crédito perdido.")])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row show-mobile"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n                Para ter acesso completo as estátisticas da plataforma acesse a partir de um desktop ou notebook.\n            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-10 col-lg-9 text-center"},[_c('p',[_vm._v("Descubra mais informações sobre os investidores da IOUU e entenda como eles causam impacto social e econômico na sociedade através da plataforma.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"investor__map--legend"},[_c('h3',[_vm._v("Investidores por região")]),_vm._v(" "),_c('ul',{staticClass:"legend legend-map-investor"},[_c('li',{staticClass:"item-01"},[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("0 ~ 100")])]),_vm._v(" "),_c('li',{staticClass:"item-02"},[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("100 ~ 250")])]),_vm._v(" "),_c('li',{staticClass:"item-03"},[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("250 ~ 500")])]),_vm._v(" "),_c('li',{staticClass:"item-04"},[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("500 ~ 1000")])]),_vm._v(" "),_c('li',{staticClass:"item-05"},[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("1000 ~ 5000")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"border rounded"},[_c('div',{staticClass:" p-3 p-md-4"},[_c('h3',{staticClass:"pb-3"},[_vm._v("Investimentos e Reinvestimentos na plataforma")]),_vm._v(" "),_c('canvas',{attrs:{"id":"GraficoReinvestimento","width":"269px","height":"180px"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 border-top p-4 text-center"},[_c('span',{staticClass:"small"},[_vm._v("Representação gráfica do total de investimentos realizados pelo total de capital reeinvestido na plataforma. \n                        Qualquer informação histórica contida nesta informação estatística não é indicativa de desempenho futuro")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-aa"}),_vm._v(" AA")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-a"}),_vm._v(" A")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-b"}),_vm._v(" B")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-c"}),_vm._v(" C")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-d"}),_vm._v(" D")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-e"}),_vm._v(" E")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-hr"}),_vm._v(" HR")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot",staticStyle:{"background-color":"#52b3d9"}}),_vm._v(" Social")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('span',{staticClass:"small"},[_vm._v("Nada contido nas informações é ou deve ser considerado como garantia, promessa ou representação, expressa ou implícita, quanto ao desempenho futuro de quaisquer empréstimos. \n                            Qualquer informação histórica contida nesta informação estatística não é indicativa de desempenho futuro.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Rentabilidade dos empréstimos em curso")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Acumulada desde o lançamento")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v("00,00%")]),_vm._v(" "),_c('label',[_vm._v("débito podre")]),_vm._v(" "),_c('p',[_vm._v("% de crédito perdido.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6USw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b09a0440_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SolicitacaoNegada_vue__ = __webpack_require__("Pscd");
function injectStyle (ssrContext) {
  __webpack_require__("VeJy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b09a0440"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b09a0440_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SolicitacaoNegada_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6WvZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_c('div',{staticClass:"tit"},[_c('h1',[_vm._v("Sua solicitação foi cancelada")]),_vm._v(" "),_c('p',[_vm._v("Você será redirecionado de volta para o site em instantes...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Yc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__("5dBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_session_manager__ = __webpack_require__("J7hJ");







var BASE_URI = "https://server-app.iouu.com.br/api/v1";
var BASE_URI_GO = "https://api.iouu.com.br" + '/api/v1';

var ApiClient = function () {
  function ApiClient() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ApiClient);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ApiClient, null, [{
    key: "request",
    value: function request() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_5_axios___default()(this._prepareOptions(options));
    }
  }, {
    key: "request_GO",
    value: function request_GO() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_5_axios___default()(this._prepareOptions_GO(options));
    }
  }, {
    key: "get",
    value: function get(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(options, { url: url, method: "get" }));
    }
  }, {
    key: "get_GO",
    value: function get_GO(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request_GO(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(options, { url: url, method: "get" }));
    }
  }, {
    key: "post",
    value: function post(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(options, { url: url, method: "post" }));
    }
  }, {
    key: "put",
    value: function put(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(options, { url: url, method: "put" }));
    }
  }, {
    key: "put_GO",
    value: function put_GO(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request_GO(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(options, { url: url, method: "put" }));
    }
  }, {
    key: "delete",
    value: function _delete(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(options, { url: url, method: "delete" }));
    }
  }, {
    key: "post_GO",
    value: function post_GO(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request_GO(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(options, { url: url, method: "post" }));
    }
  }, {
    key: "getUser",
    value: function getUser() {

      // var usr = localStorage.getItem("usr");

      // if(usr != undefined && usr != ""){

      //   return  new Promise(
      //     // a função resolve() é chamada com a capacidade para resolver ou 
      //     // rejeitar a promise
      //     function(resolve, reject) {       

      //           resolve(JSON.parse(usr))
      //     });
      // }


      return this.request({ url: "usuario", method: "GET" }).then(function (response) {
        //localStorage.setItem("usr",JSON.stringify(response.data))

        return response.data;
      });
    }
  }, {
    key: "putInvitedCodeUser",
    value: function putInvitedCodeUser(code) {
      return this.request({
        url: "usuario/code/friend",
        method: "POST",
        data: {
          Code: code
        }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "postInviteFriendMail",
    value: function postInviteFriendMail(data) {
      return this.request({
        url: "invited/members",
        method: "POST",
        data: {
          convites: data
        }
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getConvitesEnviados",
    value: function getConvitesEnviados(userId) {
      return this.request({
        url: "convites/enviados/" + userId,
        method: "GET"
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getFindInviteCode",
    value: function getFindInviteCode(code) {
      return this.request({
        url: "usuario/find/code/" + code,
        method: "GET"
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getGoogleToken",
    value: function getGoogleToken(code) {
      return this.request({
        url: "contact/google/token?code=" + code,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "updateUserInvestor",
    value: function updateUserInvestor() {

      return this.request({ url: "user-investidor", method: "PUT" }).then(function (response) {
        localStorage.setItem("usr", "");
        return response;
      });
    }
  }, {
    key: "getLoanRequest",
    value: function getLoanRequest(id) {
      return this.request({ url: "solicitacoes/" + id, method: "GET" }).then(function (response) {
        var loanRequest = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, response.data);

        if (loanRequest.Empresa) {
          if (loanRequest.Empresa.DataFundacao) {
            loanRequest.Empresa.DataFundacao = new Date(loanRequest.Empresa.DataFundacao);
          }
          if (loanRequest.Empresa.DataConsultaEndividamento) {
            loanRequest.Empresa.DataConsultaEndividamento = new Date(loanRequest.Empresa.DataConsultaEndividamento);
          }
        }
        if (loanRequest.InicioCaptacao) {
          loanRequest.InicioCaptacao = new Date(loanRequest.InicioCaptacao);
        }
        if (loanRequest.FimCaptacao) {
          // loanRequest.FimCaptacaoText = loanRequest.FimCaptacao;
          loanRequest.FimCaptacao = new Date(loanRequest.FimCaptacao);
        }
        return loanRequest;
      });
    }
  }, {
    key: "getInvestor",
    value: function getInvestor() {
      return this.request({ url: "informacoes-investidor", method: "GET" }).then(function (response) {
        var investor = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, response.data);

        if (investor.DataNascimento) investor.DataNascimento = new Date(investor.DataNascimento);
        if (investor.RgDataEmissao) investor.RgDataEmissao = new Date(investor.RgDataEmissao);

        return investor;
      });
    }
  }, {
    key: "updateInvestorInformation",
    value: function updateInvestorInformation(stepType, data) {
      var parsedData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ StepType: stepType }, data);

      if (parsedData.DataNascimento) parsedData.DataNascimento = new Date(parsedData.DataNascimento.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"));
      if (parsedData.RgDataEmissao) parsedData.RgDataEmissao = new Date(parsedData.RgDataEmissao.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"));

      return this.request({ url: "informacoes-investidor", method: "PUT", data: parsedData }).then(function (response) {
        var investor = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, response.data);

        if (investor.DataNascimento) investor.DataNascimento = new Date(investor.DataNascimento);
        if (investor.RgDataEmissao) investor.RgDataEmissao = new Date(investor.RgDataEmissao);

        return investor;
      });
    }
  }, {
    key: "getReservaSolicitacao",
    value: function getReservaSolicitacao(id) {
      return this.request({
        url: "reserva/solicitacao/" + id,
        method: 'GET'
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getInvestmentReservation",
    value: function getInvestmentReservation(_ref) {
      var loanRequestId = _ref.loanRequestId;

      return this.request({
        url: "solicitacoes/" + loanRequestId + "/reserva-investimento",
        method: 'GET'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        if (error.response && error.response.status == 404) {
          return null;
        } else {
          throw error;
        }
      });
    }
  }, {
    key: "createInvestmentReservation",
    value: function createInvestmentReservation(_ref2) {
      var loanRequestId = _ref2.loanRequestId,
          investmentReservation = _ref2.investmentReservation,
          _ref2$listaEspera = _ref2.listaEspera,
          listaEspera = _ref2$listaEspera === undefined ? null : _ref2$listaEspera;

      return this.request({
        url: "solicitacoes/" + loanRequestId + "/reserva-investimento",
        method: 'POST',
        data: {
          Valor: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(investmentReservation.Valor),
          ReInvestimento: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(investmentReservation.ReInvestimento),
          listaEspera: listaEspera
        } }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "updateInvestmentReservation",
    value: function updateInvestmentReservation(investmentReservation) {
      return this.request({
        url: "reserva-investimentos/" + investmentReservation._id,
        method: 'PUT',
        data: {
          Valor: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(investmentReservation.Valor),
          ReInvestimento: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(investmentReservation.ReInvestimento)
        } }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "cancelInvestmentReservation",
    value: function cancelInvestmentReservation(investmentReservationID, motivo) {

      console.log("cancelInvestmentReservation", investmentReservationID, motivo);
      return this.request({
        url: "reserva-investimentos-CANCEL/" + investmentReservationID,
        method: 'POST',
        data: {
          Motivo: motivo
        } }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "inviteFriend",
    value: function inviteFriend(to, msg, name) {

      return this.request({
        url: 'invite/friend',
        method: 'POST',
        data: {
          to: to,
          msg: msg,
          name: name
        }
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "inviteCompany",
    value: function inviteCompany(to, msg, name, contact, phone) {

      return this.request({
        url: 'invite/company',
        method: 'POST',
        data: {
          to: to,
          msg: msg,
          name: name,
          contact: contact,
          phone: phone
        }
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "alterarSenha",
    value: function alterarSenha(data) {
      var senhaNova = data.senhaNova;
      var senhaAtual = data.senhaAtual;
      var id = data.id;

      return this.request({
        url: "profile/alterarSenha",
        method: 'POST',
        data: {
          senha: senhaNova,
          senhaAtual: senhaAtual,
          id: id
        } }).then(function (response) {

        localStorage.setItem("usr", "");
        return response;
      });
    }
  }, {
    key: "cadastrarSenha",
    value: function cadastrarSenha(data) {
      var senhaNova = data.senhaNova;
      var id = data.id;

      return this.request({
        url: "profile/cadastrarSenha",
        method: 'POST',
        data: {
          senha: senhaNova,
          id: id
        } }).then(function (response) {

        localStorage.setItem("usr", "");
        return response;
      });
    }
  }, {
    key: "criarnovasenha",
    value: function criarnovasenha(data) {
      var password = data.password;
      var id = data.id;
      var token = data.token;

      return this.request({
        url: 'criarsenha',
        method: 'POST',
        data: {
          password: password,
          id: id,
          token: token
        } }).then(function (response) {

        localStorage.setItem("usr", "");
        return response.data;
      });
    }
  }, {
    key: "validateToken",
    value: function validateToken() {
      return this.request({ url: "validar-token", method: "GET" }).then(function () {
        return true;
      }).catch(function () {
        return false;
      });
    }
  }, {
    key: "_prepareOptions",
    value: function _prepareOptions(givenOptions) {
      if (!givenOptions.headers) {
        givenOptions.headers = {};
      }
      if (!givenOptions.headers["Accept"]) {
        givenOptions.headers["Accept"] = 'application/json';
      }
      if (!givenOptions.headers["Content-Type"]) {
        givenOptions.headers["Content-Type"] = 'application/json';
      }

      var accessToken = __WEBPACK_IMPORTED_MODULE_6__utils_session_manager__["a" /* default */].getAuthToken();

      if (accessToken) {
        givenOptions.headers = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(givenOptions.headers, {
          Authorization: "" + accessToken
        });
      }

      givenOptions.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(givenOptions.data);
      givenOptions.url = BASE_URI + "/" + givenOptions.url;
      return givenOptions;
    }
  }, {
    key: "_prepareOptions_GO",
    value: function _prepareOptions_GO(givenOptions) {
      if (!givenOptions.headers) {
        givenOptions.headers = {};
      }
      if (!givenOptions.headers["Accept"]) {
        givenOptions.headers["Accept"] = 'application/json';
      }
      if (!givenOptions.headers["Content-Type"]) {
        givenOptions.headers["Content-Type"] = 'application/json';
      }

      var accessToken = __WEBPACK_IMPORTED_MODULE_6__utils_session_manager__["a" /* default */].getAuthToken();

      if (accessToken) {
        givenOptions.headers = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(givenOptions.headers, {
          Authorization: "Bearer " + accessToken
        });
      }

      givenOptions.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(givenOptions.data);
      givenOptions.url = BASE_URI_GO + "/" + givenOptions.url;
      return givenOptions;
    }
  }, {
    key: "getOpportunities",
    value: function getOpportunities() {
      return this.request({ url: "investimentos/oportunidades", method: "GET" }).then(function (response) {

        var oportunidades = response.data;

        //Ajustar ordem das das oportunidades (mais recente antes)
        // oportunidades = oportunidades.sort(function(a, b){return  (new Date(b.InicioCaptacao)) - (new Date(a.InicioCaptacao))});

        return oportunidades;
      });
    }
  }, {
    key: "getMeusEmprestimos",
    value: function getMeusEmprestimos() {
      return this.request({
        url: "emprestimos/meus",
        method: "GET"
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getInfosMyCCBs",
    value: function getInfosMyCCBs() {
      return this.request({
        url: "investimentos/meus/ccbs",
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "GetMeuEmprestimo",
    value: function GetMeuEmprestimo(id) {
      return this.request({ url: "emprestimos/pre-aprovado/" + id, method: "GET" }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "VerificaSenha",
    value: function VerificaSenha(dado) {
      var password = dado.password;
      var id = dado.id;

      return this.request({
        url: 'emprestimos/verifica-senha',
        method: 'POST',
        data: {
          password: password,
          id: id
        } }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "atualizaStatus",
    value: function atualizaStatus(id, status, motivo) {
      return this.request({
        url: 'empretimos/atualiza-status',
        method: 'POST',
        data: {
          id: id,
          status: status,
          motivo: motivo
        }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "AlteraStatusNotificacao",
    value: function AlteraStatusNotificacao(IDUsuario, IDProposta, status) {
      return this.request({
        url: 'empretimos/atualiza-status-notificacao',
        method: 'POST',
        data: {
          UserId: IDUsuario,
          PropostaId: IDProposta,
          status: status
        }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getDocumentos",
    value: function getDocumentos(type, id) {
      return this.request({ url: "documentos/" + type + "/" + id, method: "GET" }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getDocumentosSolicitacao",
    value: function getDocumentosSolicitacao(id) {
      return this.request({
        url: "doc/solicitacao/" + id,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "postDocumentosSolicitacao",
    value: function postDocumentosSolicitacao(id, idSolicitacao, arquivos) {
      return this.request({
        url: "newdoc/solicitacao",
        method: "POST",
        data: {
          id: id,
          solicitacaoId: idSolicitacao,
          arquivos: arquivos
        }
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "createDocumentos",
    value: function createDocumentos(operationType, mongoFieldName, id, nomeArquivoSelecionado, arquivos) {

      return this.request({
        url: "documentos/create",
        method: "POST",
        data: {
          operationType: operationType,
          mongoFieldName: mongoFieldName,
          id: id,
          nomeArquivoSelecionado: nomeArquivoSelecionado,
          arquivos: arquivos
        } }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "postComprovanteFatura",
    value: function postComprovanteFatura(id, mongoFieldName, arquivos) {
      return this.request({
        url: "FaturaTomador/comprovante",
        method: "POST",
        data: {
          id: id,
          mongoFieldName: mongoFieldName,
          arquivos: arquivos
        }
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getLoanImpact",
    value: function getLoanImpact() {
      return this.request({
        url: "impacto",
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getCountLoanImpactInvestors",
    value: function getCountLoanImpactInvestors(id) {
      return this.request({
        url: "impacto/qtdeInvestidor/" + id,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getCountCcbInvestors",
    value: function getCountCcbInvestors(id) {
      return this.request({
        url: "ccb/qtdeInvestidor/" + id,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getLoanImpactById",
    value: function getLoanImpactById(id) {
      return this.request({
        url: "impacto/" + id,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getValorCaptadoLoanImpact",
    value: function getValorCaptadoLoanImpact(solicitacaoId) {
      return this.request({
        url: "impacto/valorCaptado/" + solicitacaoId,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "postApoiarLoanImpact",
    value: function postApoiarLoanImpact(solicitacaoId, valor, valueReinv, anonimo, exibirQuantia) {
      return this.request({
        url: "impacto/apoiar",
        method: "POST",
        data: {
          solicitacaoId: solicitacaoId,
          valor: valor,
          reinvestimento: valueReinv,
          anonimo: anonimo,
          exibirQuantia: exibirQuantia
        }
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "postInvestirCcb",
    value: function postInvestirCcb(solicitacaoId, valor) {
      return this.request({
        url: "ccb/investir",
        method: "POST",
        data: {
          solicitacaoId: solicitacaoId,
          valor: valor
        }
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getInvestidorLoanImpact",
    value: function getInvestidorLoanImpact(solicitacaoId) {
      return this.request({
        url: "impacto/investidor/" + solicitacaoId,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getInvestidorCcb",
    value: function getInvestidorCcb(solicitacaoId) {
      return this.request({
        url: "ccb/investidor/" + solicitacaoId,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getCcbInvestidores",
    value: function getCcbInvestidores(solicitacaoId) {

      return this.request({
        url: "ccb/assinatura/investidores/" + solicitacaoId,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getFaturas",
    value: function getFaturas(solicitacaoId) {
      return this.request({
        url: "FaturaTomador/solicitacao/" + solicitacaoId,
        method: "GET"
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getNotificationsUser",
    value: function getNotificationsUser(userId) {
      return this.request({
        url: "user/notifications/" + userId,
        method: "GET"
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "changeStatusNotification",
    value: function changeStatusNotification(id, status) {
      return this.request({
        url: "notifications/status/update",
        method: "POST",
        data: {
          id: id,
          status: status
        }
      }).then(function (reponse) {

        localStorage.setItem("usr", "");
        return reponse;
      });
    }
  }, {
    key: "getListaInvestidoresLoanImpact",
    value: function getListaInvestidoresLoanImpact(solicitacaoId) {
      return this.request({
        url: "impacto/investidores/" + solicitacaoId,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getCcbById",
    value: function getCcbById(id) {
      return this.request({
        url: "ccb/" + id,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getInfosMyInvestments",
    value: function getInfosMyInvestments() {
      return this.request({
        url: "investimentos/meus",
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getInfosMyInvestmentsSolicitacoes",
    value: function getInfosMyInvestmentsSolicitacoes(reservaInvestimentoId) {
      return this.request({
        url: "investimentos/meus/solicitacoes/" + reservaInvestimentoId,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getMyAvalibleMoney",
    value: function getMyAvalibleMoney() {
      return this.request({
        url: "investimentos/meus/money",
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "updateProfile",
    value: function updateProfile(data) {

      localStorage.setItem("usr", "");

      return this.request({ url: "profile/updateProfile", method: "PUT", data: data }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getLoansByDocuments",
    value: function getLoansByDocuments(document, tipo) {
      return this.request({
        url: "solicitacoes/documentos/" + document + "/" + tipo,
        method: 'GET'
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "createSolicitation",
    value: function createSolicitation(data) {
      return this.request({
        url: "solicitacoes/created",
        method: "POST",
        data: data
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "userNotificationInvestor",
    value: function userNotificationInvestor(id, options) {
      localStorage.setItem("usr", "");
      return this.request({
        url: "user/notifications",
        method: "POST",
        data: {
          id: id,
          options: options
        }
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "createNotificationsInvestor",
    value: function createNotificationsInvestor(id) {
      localStorage.setItem("usr", "");
      return this.request({
        url: "user/create/notifications",
        method: "POST",
        data: {
          id: id
        }
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getAllWallet",
    value: function getAllWallet(id) {
      return this.request({
        url: "wallet/loans/" + id,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getCarteiraExtrato",
    value: function getCarteiraExtrato(pagina) {
      return this.request_GO({
        url: "wallet/extrato/pagina/" + pagina,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getCarteiraItem",
    value: function getCarteiraItem(id) {
      return this.request_GO({
        url: "wallet/operacao/detalhe/" + id,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getCarteiraExtratoComFiltro",
    value: function getCarteiraExtratoComFiltro(dIni, dFim, pagina) {
      return this.request_GO({
        url: "wallet/extrato/periodo/" + dIni + "/" + dFim + "/pagina/" + pagina,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getCarteiraOperacao",
    value: function getCarteiraOperacao(id) {
      return this.request_GO({
        url: "wallet/operacao/" + id
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getWalletSlice",
    value: function getWalletSlice(id, pagina) {
      return this.request({
        url: "wallet/loans/" + id + "/" + pagina,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getWalletBank",
    value: function getWalletBank(code) {
      return this.request({
        url: "wallet/bank/" + code,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "postTransferencia",
    value: function postTransferencia(id, idInvestor, carteira, password) {
      return this.request({
        url: "wallet/new",
        method: "POST",
        data: {
          id: id,
          idInvestor: idInvestor,
          carteira: carteira,
          password: password
        }
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getComprovante",
    value: function getComprovante(idComprovante) {
      return this.request({
        url: "wallet/comprovante/" + idComprovante,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }]);

  return ApiClient;
}();

/* harmony default export */ __webpack_exports__["a"] = (ApiClient);

/***/ }),

/***/ "6qZ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var patrimonioLiquido = this.solicitacao.Empresa.PatrimonioLiquido;
    return {
      razaoSocial: this.solicitacao.Empresa.RazaoSocial,
      patrimonioLiquido: patrimonioLiquido ? patrimonioLiquido.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }) : null
    };
  },

  computed: {
    patrimonioValido: function patrimonioValido() {
      return parseFloat(this.patrimonioLiquido) <= 0;
    }
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = {
        Empresa: {
          PatrimonioLiquido: __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].formatReal(this.patrimonioLiquido)
        }
      };
      this.$emit('on-submit', newData);
    }
  }
});

/***/ }),

/***/ "6vG/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "6wUF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    var pessoal = this.currentUser.Pessoal;
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: pessoal.ArquivosIdentidade || [null]
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.arquivos.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.arquivos, index, null);
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do documento de identidade é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {

        this.currentUser.Pessoal.ArquivosIdentidade = this.arquivosRecebidos;

        this.$emit('on-submit', { Pessoal: this.currentUser.Pessoal });
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "768j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "79P2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7D6a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7H1d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: this.solicitacao.ArquivosContratoSocial || []
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do contrato social é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {
        var newData = {
          ArquivosContratoSocial: this.arquivosRecebidos
        };
        this.$emit('on-submit', newData);
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "7Liv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpportunityCard_vue__ = __webpack_require__("+2NR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_934b79e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpportunityCard_vue__ = __webpack_require__("tAXx");
function injectStyle (ssrContext) {
  __webpack_require__("vmUM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-934b79e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpportunityCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_934b79e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpportunityCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7M7n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var lucroMensal = this.solicitacao.Empresa.LucroMensal;
    return {
      lucroMensal: lucroMensal ? lucroMensal.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }) : null
    };
  },

  computed: {
    lucroValido: function lucroValido() {
      return parseFloat(this.lucroMensal) <= 0;
    }
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = {
        Empresa: {
          LucroMensal: __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].formatReal(this.lucroMensal)
        }
      };
      this.$emit('on-submit', newData);
    }
  }
});

/***/ }),

/***/ "7VWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__("5dBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_string_mask__ = __webpack_require__("lYdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_string_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_string_mask__);





var Masker = function () {
  function Masker() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Masker);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Masker, null, [{
    key: 'maskMoney',
    value: function maskMoney(value) {
      if (value == null) return null;
      if (value.toString().indexOf('.') == value.length - 2) {
        value = value.replace(/\D/g, '');
        value = value.substr(0, value.length - 2) + '.' + value.substr(value.length - 2, value.length) + '0';
      }
      var number = value.replace(/\D/g, '');
      var mask = new __WEBPACK_IMPORTED_MODULE_3_string_mask___default.a('#.##0,00', { reverse: true });
      var result = mask.apply(number);
      result = result.replace(/^0+(\d+,.*)/, '$1');
      return result;
    }
  }, {
    key: 'unmaskMoney',
    value: function unmaskMoney(value) {
      if (value === null || value === undefined) return null;
      if (value.indexOf(',') == value.length - 2) {
        value = value.replace(/\D/g, '');
        value = value.substr(0, value.length - 2) + ',' + value.substr(value.length - 2, value.length);
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(value.toString().replace(/(\d{1,3})\.?/g, '$1').replace(',', '.'));
    }
  }, {
    key: 'maskInteger',
    value: function maskInteger(value) {
      return value.replace(/\D/, '');
    }
  }, {
    key: 'maskPhone',
    value: function maskPhone(value) {
      if (value == null) return null;
      var number = value.replace(/\D/g, '');
      var mask = new __WEBPACK_IMPORTED_MODULE_3_string_mask___default.a('(00) 90000-0000');
      return mask.apply(number);
    }
  }, {
    key: 'maskDate',
    value: function maskDate(value) {
      if (value == null) return null;
      var number = value.replace(/\D/g, '');
      var mask = new __WEBPACK_IMPORTED_MODULE_3_string_mask___default.a('90/90/9900');
      return mask.apply(number);
    }
  }, {
    key: 'maskIsoDate',
    value: function maskIsoDate(value) {
      if (value == null) return null;
      var dateOfTime = value.split("T");
      var dateOutTime = dateOfTime[0];
      var date = dateOutTime.split("-").reverse().join();
      var number = date.replace(/\D/g, '');
      var mask = new __WEBPACK_IMPORTED_MODULE_3_string_mask___default.a('90/90/9900');
      return mask.apply(number);
    }
  }, {
    key: 'maskZipcode',
    value: function maskZipcode(value) {
      if (value == null) return null;
      var number = value.replace(/\D/g, '');
      var mask = new __WEBPACK_IMPORTED_MODULE_3_string_mask___default.a('00000-000');
      return mask.apply(number);
    }
  }, {
    key: 'unmaskZipcode',
    value: function unmaskZipcode(value) {
      return value.replace(/\D/, '');
    }
  }, {
    key: 'maskRg',
    value: function maskRg(value) {
      if (value == null) return null;
      return value; //.replace(/[^.-\dxX]/, "")
    }
  }, {
    key: 'unmaskRg',
    value: function unmaskRg(value) {
      if (value === null || value === undefined) return null;
      return value.toString(); //.replace(/(\D)/g, '')
    }
  }, {
    key: 'maskCpf',
    value: function maskCpf(value) {
      if (value == null) return null;
      var number = value.replace(/\D/g, '');
      var mask = new __WEBPACK_IMPORTED_MODULE_3_string_mask___default.a('000.000.000-00');
      return mask.apply(number);
    }
  }, {
    key: 'unmaskCpf',
    value: function unmaskCpf(value) {
      if (value === null || value === undefined) return null;
      return value.toString().replace(/(\D)/g, '');
    }
  }, {
    key: 'maskCnpj',
    value: function maskCnpj(value) {
      if (value == null) return null;
      var number = value.replace(/\D/g, '');
      var mask = new __WEBPACK_IMPORTED_MODULE_3_string_mask___default.a('00.000.000/0000-00');
      return mask.apply(number);
    }
  }, {
    key: 'unmaskCnpj',
    value: function unmaskCnpj(value) {
      if (value === null || value === undefined) return null;
      return value.toString().replace(/(\D)/g, '');
    }
  }, {
    key: 'maskBankAccount',
    value: function maskBankAccount(value) {
      if (value == null) return null;
      var maskedValue = value.replace(/\D/g, '');
      if (maskedValue.length > 1) {
        var mask = new __WEBPACK_IMPORTED_MODULE_3_string_mask___default.a('#0-0', { reverse: true });
        maskedValue = mask.apply(maskedValue);
      }
      return maskedValue;
    }
  }, {
    key: 'maskBankAccountBb',
    value: function maskBankAccountBb(value) {
      if (value == null) return null;
      var maskedValue = value.replace(/-/g, '');
      if (maskedValue.length > 1) {
        var mask = new __WEBPACK_IMPORTED_MODULE_3_string_mask___default.a('#0-A', { reverse: true });
        maskedValue = mask.apply(maskedValue);
      }
      return maskedValue;
    }
  }, {
    key: 'formatReal',
    value: function formatReal(num) {
      var real = void 0;
      real = parseFloat(num.replace(/[^\d]+/g, '')) / 100;
      return real;
    }
  }]);

  return Masker;
}();

/* harmony default export */ __webpack_exports__["a"] = (Masker);

/***/ }),

/***/ "7XGb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__ = __webpack_require__("Du/2");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			investmentConfirmed: false,
			modalVisible: false,
			response: false,
			modalInfoAdicional: false,
			exibirQuantia: true,
			anonimo: false,
			finalizado: false,
			temCadastroInvestidor: false,
			temSuitability: false,
			investidorAprovado: false,
			emBreveNovosInvestimentosImpacto: false,
			qtdeInvestidores: 0,
			index: 0,
			listImpacts: {},
			selectedItem: {},
			sDisponivel: 0,
			showInputInvestment: true,
			showInputSaldo: false,
			valorReinvestimento: 0,
			valorInv: 0
		};
	},


	computed: {
		canInvest: function canInvest() {
			return this.temCadastroInvestidor && this.temSuitability && this.investidorAprovado;
		},

		User: function User() {
			return this.$store.state.currentUser;
		}
	},

	methods: {
		OpenModal: function OpenModal(isAbrir) {
			this.showModal = isAbrir;

			if (isAbrir) document.getElementsByTagName("main")[0].style.zIndex = "50";else document.getElementsByTagName("main")[0].style.zIndex = "0";
		},
		calcValorRestante: function calcValorRestante(impact) {

			return impact.Valor - impact.ValorCaptado;
		},
		calcPercValorRestante: function calcPercValorRestante(impact) {
			return impact.ValorCaptado * 100 / impact.Valor;
		},
		formatCurrency: function formatCurrency(value) {
			if (!value) value = 0;
			return value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
		},
		countInvestor: function countInvestor(index, solicitacaoId) {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getCountLoanImpactInvestors(solicitacaoId).then(function (response) {
				_this.listImpacts[index].QtdeInvestidores = response.data;
				_this.$forceUpdate();
			});
		},
		showModal: function showModal(item) {

			if (document.getElementsByTagName("main").length > 0) {
				document.getElementsByTagName("main")[0].style.zIndex = "50";
			}
			this.selectedItem = item;
			this.valorInv = item.ReservaInvestimento.Valor;
			this.modalVisible = true;
			this.modalInfoAdicional = false;
			this.showInputSaldo = false;
			this.showInputInvestment = true;
		},
		closeModal: function closeModal() {

			if (document.getElementsByTagName("main").length > 0) {
				document.getElementsByTagName("main")[0].style.zIndex = "0";
			}

			this.modalVisible = false;
			this.modalInfoAdicional = false;
			this.finalizado = false;
			this.showInputSaldo = false;
			this.showInputInvestment = true;
		},
		dataLonga: function dataLonga(data) {
			var date = new Date(data);
			date.setHours(date.getHours() + date.getTimezoneOffset() / 60); //ajustando para o horário gravado no banco
			var options = { year: "numeric", month: "long", day: "numeric" };
			return date.toLocaleDateString("pt-BR", options);
		},
		ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
			var s = String(id);

			while (s.length < (qtd || 2)) {
				s = "0" + s;
			}

			return s;
		},
		getValorCaptado: function getValorCaptado(index, solicitacaoId) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getValorCaptadoLoanImpact(solicitacaoId).then(function (response) {
				if (response.data.length > 0) {
					// this.listImpacts[index].ValorCaptado = response.data[0].Total;

					_this2.listImpacts[index].ValorRestante = _this2.listImpacts[index].Valor - _this2.listImpacts[index].ValorCaptado;

					_this2.listImpacts[index].PercValorRestante = _this2.listImpacts[index].ValorCaptado * 100 / _this2.listImpacts[index].Valor;
				}

				_this2.$forceUpdate();
			});
		},
		getInvestidor: function getInvestidor(index, solicitacaoId) {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getInvestidorLoanImpact(solicitacaoId).then(function (response) {
				if (response.data != null && response.data.Status != 0) {
					_this3.listImpacts[index].JaInvestiu = true;

					_this3.listImpacts[index].ReservaInvestimento = response.data;
					_this3.listImpacts[index].ReservaInvestimento.Valor += ",00";
				} else {
					_this3.listImpacts[index].JaInvestiu = false;
				}

				_this3.$forceUpdate();
			});
		},
		diffDate: function diffDate(d1, d2) {
			var date1, date2;

			if (d1 == "") {
				date1 = new Date();
			} else {
				date1 = new Date(d1);
				date1.setHours(date1.getHours() + date1.getTimezoneOffset() / 60);
			}

			if (d2 == "") {
				date2 = new Date();
			} else {
				date2 = new Date(d2);
				date2.setHours(date2.getHours() + date2.getTimezoneOffset() / 60);
			}

			var timeDiff = date2.getTime() - date1.getTime();
			var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

			if (diffDays < 0) return "Encerrado";
			if (diffDays == 0) return "Finaliza hoje*";

			return "Finaliza em " + diffDays + " dias*";
		},
		ShowSaldo: function ShowSaldo() {

			if (!this.ValidarInvestimento()) {
				return false;
			}

			var value = 0;
			if (typeof this.valueToInvest === 'string') {
				var inv = this.valueToInvest.replace(/[^a-zA-Z0-9 ]/g, "");
				value = parseFloat(inv / 100);
			}

			if (this.sDisponivel > 0) {
				if (this.sDisponivel > value) {
					this.valorReinvestimento = this.money(value || 0);
				} else {
					this.valorReinvestimento = this.money(this.sDisponivel || 0);
				}

				this.showInputInvestment = false;
				this.showInputSaldo = true;
				return true;
			}

			this.proximoPasso();
			return true;
		},
		InvestidorBloqueado: function InvestidorBloqueado() {

			if (this.$store.state.currentUser == null || this.$store.state.currentUser.investor == null || this.$store.state.currentUser.investor.Bloqueio == null || this.$store.state.currentUser.investor.Bloqueio.FimBloqueio == null) return false;

			var FimBloqueio = new Date(this.$store.state.currentUser.investor.Bloqueio.FimBloqueio);

			return FimBloqueio > new Date();
		},
		NaoUsarSaldo: function NaoUsarSaldo() {

			this.valorReinvestimento = 0;
			this.proximoPasso();

			return false;
		},
		ValidarInvestimento: function ValidarInvestimento() {

			var value = 0;
			if (typeof this.valorInv === 'string') {
				var inv = this.valorInv.replace(/[^a-zA-Z0-9 ]/g, "");
				value = parseFloat(inv / 100);
			}

			if (value == 0 || isNaN(value)) {
				this.$Notify.error({
					title: "Desculpe",
					message: "Por favor, insira um valor."
				});

				return false;
			}

			if (value < 100 || isNaN(value)) {
				this.$Notify.error({
					title: "Desculpe",
					message: "O valor mínimo de aporte é de R$ 100,00."
				});

				return false;
			}

			if (value % 100 != 0 || isNaN(value)) {
				this.$Notify.error({
					title: "Desculpe",
					message: "O valor deve ser multiplo de R$ 100."
				});

				return false;
			}

			if (value > this.selectedItem.Valor) {
				this.$Notify.error({
					title: "Desculpe",
					message: "O valor de aporte é maior que o solicitado."
				});

				return false;
			}

			if (this.selectedItem.Valor - this.selectedItem.ValorCaptado > 0 && value > this.selectedItem.Valor - this.selectedItem.ValorCaptado) {
				this.$Notify.error({
					title: "Desculpe",
					message: "O valor de aporte é maior que o disponível."
				});

				return false;
			}

			return true;
		},
		UsarSaldo: function UsarSaldo() {

			var valor = 0;

			if (typeof this.valorReinvestimento === 'string') {
				var reInv = this.valorReinvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
				valor = parseFloat(reInv / 100);
			}

			var errorMessages;

			if (valor < 0) {

				errorMessages = ["Insira um valor para o reinvestimento."];
				this.$Notify.error(__WEBPACK_IMPORTED_MODULE_5__utils_array_helper__["a" /* default */].toSentence(errorMessages));

				return false;
			}

			if (valor > this.sDisponivel) {

				errorMessages = ["Saldo indisponível para o reinvestimento. Valor máximo: R$ " + this.formatCurrency(this.sDisponivel)];
				this.$Notify.error(__WEBPACK_IMPORTED_MODULE_5__utils_array_helper__["a" /* default */].toSentence(errorMessages));

				return false;
			}

			var inv = this.valorInv.replace(/[^a-zA-Z0-9 ]/g, "");
			var valorInv = parseFloat(inv) / 100;

			if (valor > valorInv) {

				errorMessages = ["O valor deve ser menor ou igual ao investido : R$ " + this.formatCurrency(valorInv)];
				this.$Notify.error(__WEBPACK_IMPORTED_MODULE_5__utils_array_helper__["a" /* default */].toSentence(errorMessages));

				return false;
			}

			this.proximoPasso();
			return false;
		},
		proximoPasso: function proximoPasso() {
			this.closeModal();
			this.modalInfoAdicional = true;

			if (document.getElementsByTagName("main").length > 0) {
				document.getElementsByTagName("main")[0].style.zIndex = "50";
			}
		},
		apoiar: function apoiar(solicitacaoId, valueToInvest) {
			var _this4 = this;

			this.closeModal();
			this.modalInfoAdicional = true;

			if (document.getElementsByTagName("main").length > 0) {
				document.getElementsByTagName("main")[0].style.zIndex = "50";
			}

			var value = 0;
			if (typeof this.valorInv === 'string') {
				var inv = this.valorInv.replace(/[^a-zA-Z0-9 ]/g, "");
				value = parseFloat(inv / 100);
			}

			var valor = 0;
			if (typeof this.valorReinvestimento === 'string') {
				var reInv = this.valorReinvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
				valor = parseFloat(reInv / 100);

				if (valor > value) {
					valor = value;
				}
			}

			__WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].postApoiarLoanImpact(solicitacaoId, value, valor, this.anonimo, this.exibirQuantia).then(function () {
				_this4.finalizado = true;

				setTimeout(function () {
					_this4.get();
				}, 500);
			});
		},
		validaStatusInvestimento: function validaStatusInvestimento(index) {
			var resultDt = this.diffDate(new Date(), this.listImpacts[index].FimCaptacao);

			if (resultDt == "ENCERRADO" || this.listImpacts[index].ValorCaptado >= this.listImpacts[index].Valor) return false;

			return true;
		},
		Nome: function Nome() {
			var nome = "";

			if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
				nome = this.User.username;
			} else {
				nome = this.User.name;
			}
			nome = nome.trim();
			var primeiroNome = nome.split(" ")[0];
			return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
		},
		AtualizarSaldo: function AtualizarSaldo() {
			var _this5 = this;

			__WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getMyAvalibleMoney().then(function (item) {

				item.data.credito = item.data.credito.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
				var credito = parseFloat(item.data.credito);

				item.data.debito = item.data.debito.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
				var debito = parseFloat(item.data.debito);

				_this5.sDisponivel = credito - debito;
				_this5.sDisponivel = parseFloat(_this5.sDisponivel.toFixed(2));

				if (_this5.sDisponivel < 0.01) {
					_this5.sDisponivel = 0;
				}
			});
		},
		get: function get() {
			var _this6 = this;

			__WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getLoanImpact().then(function (response) {
				_this6.listImpacts = response.data;

				if (_this6.listImpacts.length > 0) {
					for (var i = 0; i < _this6.listImpacts.length; i++) {
						_this6.listImpacts[i].JaInvestiu = false;
						_this6.listImpacts[i].PermiteAporte = _this6.validaStatusInvestimento(i);

						// this.listImpacts[i].QtdeInvestidores = 0;
						// this.listImpacts[i].ValorCaptado = 0;
						_this6.listImpacts[i].PercValorRestante = 0;
						_this6.listImpacts[i].ValorRestante = _this6.listImpacts[i].Valor;
						_this6.listImpacts[i].ReservaInvestimento = {};
						_this6.listImpacts[i].ReservaInvestimento.Valor = "";

						_this6.getInvestidor(i, _this6.listImpacts[i]._id);
						_this6.getValorCaptado(i, _this6.listImpacts[i]._id);
						_this6.countInvestor(i, _this6.listImpacts[i]._id);

						if (_this6.listImpacts[i].Impacto == null) {
							_this6.listImpacts[i].Impacto = {};
						}
					}

					_this6.AtualizarSaldo();

					_this6.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["d" /* STOP_LOADING */]);
				} else {
					_this6.emBreveNovosInvestimentosImpacto = true;
				}

				_this6.response = true;
			});
		},

		//tagueamento GA
		taggingGA: function taggingGA() {
			this.$ga.page({
				page: '/investimento-de-impacto/',
				title: 'InvestimentodeImpacto'
			});
		}
	},
	beforeCreated: function beforeCreated() {
		this.$store.dispatch('updateUser');
	},
	created: function created() {
		var _this7 = this;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_this7.temSuitability = _this7.$store.state.currentUser.hassuitability;
							_this7.temCadastroInvestidor = _this7.$store.state.currentUser.hasinvestor;
							_this7.investidorAprovado = _this7.$store.state.currentUser.investor != null && _this7.$store.state.currentUser.investor.Status == "APROVADO" && _this7.temCadastroInvestidor;

							_this7.get();

							//tagueamento GA
							_context.next = 6;
							return _this7.taggingGA();

						case 6:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this7);
		}))();
	},


	watch: {},

	components: {
		Modal: __WEBPACK_IMPORTED_MODULE_2__components_Modal__["a" /* default */]
	}
});

/***/ }),

/***/ "7XyA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: this.solicitacao.ArquivosComprovanteEndereco || []
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do comprovamente de endereço é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {
        var newData = {
          ArquivosComprovanteEndereco: this.arquivosRecebidos
        };
        this.$emit('on-submit', newData);
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "7YgM":
/***/ (function(module, exports) {

module.exports = {"name":"dashboard","version":"1.0.0","description":"A Vue.js project","author":"IOUU","private":true,"scripts":{"dev":"node build/dev-server.js","start":"npm run dev","build":"node build/build.js","testBuild":"node build/buildTest.js","devBuild":"node build/buildDev.js","unit":"cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit && npm run e2e"},"dependencies":{"@sentry/browser":"^5.29.2","@sentry/tracing":"^5.29.2","@sentry/vue":"^5.29.1","ajv-keywords":"^3.4.0","at-ui":"^1.3.0","at-ui-style":"^1.5.0","axios":"^0.19.0","babel-polyfill":"^6.26.0","bootstrap":"^4.5.2","bourbon":">=5.0.0-beta.8","bourbon-neat":"^2.1.0","chart.js":"^2.7.2","es6-promise":"^4.1.1","html2canvas":"^1.0.0-rc.5","jquery":"^3.5.1","jspdf":"^1.5.3","lodash.clonedeep":"^4.5.0","lottie-web":"^5.1.20","luxon":"^1.2.1","merge":"^1.2.0","node-sass":"6.0","npm":"^6.10.2","popper.js":"^1.16.1","rollup-plugin-json":"^3.1.0","sass-loader":"^6.0.6","string-mask":"^0.3.0","sweetalert2":"^8.12.1","vue":"^2.5.2","vue-analytics":"^5.22.1","vue-awesome-swiper":"^3.1.2","vue-chartjs":"^3.1.0","vue-datetime":"^1.0.0-beta.3","vue-headful":"^1.0.0","vue-input-tag":"^1.0.4","vue-lottie":"^0.2.1","vue-meta":"^1.5.0","vue-multiselect":"^2.1.0","vue-resource":"^1.5.1","vue-router":"^3.0.1","vue-select":"^2.4.0","vue-social-sharing":"^2.3.3","vue-the-mask":"^0.11.1","vue2-slot-calendar":"^2.1.4","vuejs-countdown":"^0.2.1","vuex":"^3.0.1","weekstart":"^1.0.0"},"devDependencies":{"autoprefixer":"^7.1.2","babel-core":"^6.26.3","babel-eslint":"^7.1.1","babel-loader":"^7.1.1","babel-plugin-istanbul":"^5.2.0","babel-plugin-transform-runtime":"^6.22.0","babel-preset-env":"^1.7.0","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chai":"^4.1.2","chalk":"^2.0.1","chromedriver":"^2.27.2","connect-history-api-fallback":"^1.3.0","copy-webpack-plugin":"^4.0.1","cross-env":"^5.0.1","cross-spawn":"^5.0.1","css-loader":"^3.1.0","eventsource-polyfill":"^0.9.6","express":"^4.14.1","extract-text-webpack-plugin":"^3.0.0","file-loader":"^1.1.4","friendly-errors-webpack-plugin":"^1.6.1","html-webpack-plugin":"^2.30.1","http-proxy-middleware":"^0.18.0","inject-loader":"^3.0.0","karma":"^4.2.0","karma-coverage":"^1.1.2","karma-mocha":"^1.3.0","karma-phantomjs-launcher":"^1.0.2","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.3.1","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.31","karma-webpack":"^2.0.2","mocha":"^6.2.0","nightwatch":"^1.1.13","opn":"^5.1.0","optimize-css-assets-webpack-plugin":"^3.2.0","ora":"^1.2.0","portfinder":"^1.0.13","rimraf":"^2.6.0","selenium-server":"^3.0.1","semver":"^5.3.0","shelljs":"^0.7.6","sinon":"^4.0.0","sinon-chai":"^2.8.0","url-loader":"^2.1.0","vue-loader":"^13.3.0","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.5.2","webpack":"^3.6.0","webpack-bundle-analyzer":"^3.3.2","webpack-dev-middleware":"^1.12.0","webpack-hot-middleware":"^2.18.2","webpack-merge":"^4.1.0"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),

/***/ "7a+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FilesInput__ = __webpack_require__("/7yn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Modal: __WEBPACK_IMPORTED_MODULE_1__components_Modal__["a" /* default */], FilesInput: __WEBPACK_IMPORTED_MODULE_2__components_FilesInput__["a" /* default */] },
    data: function data() {
        return {
            response: false,
            showModal: false,
            submitted: false,
            created: {},
            arquivosIdentidade: {},
            arquivosComprovanteResidencia: {},
            tipoArquivoSelecionado: "",
            /* eslint-disable */
            uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
            acceptedFormats: 'application/pdf, image/jpeg, image/png',
            files: [null]
        };
    },

    methods: {
        formatDate: function formatDate(documento) {
            var data = void 0;
            documento.DataEnvio == null ? data = documento.MetaDados.UltimaModificacao : data = documento.DataEnvio;
            var dataForm = new Date(data);
            var dia = dataForm.getDate();

            if (dia.toString().length == 1) dia = "0" + dia;

            var mes = dataForm.getMonth() + 1;

            if (mes.toString().length == 1) mes = "0" + mes;

            var ano = dataForm.getFullYear();

            if (isNaN(parseInt(ano)) || isNaN(parseInt(mes)) || isNaN(parseInt(dia))) {

                return this.formatDate(this.created);
            }

            return dia + "/" + mes + "/" + ano;
        },
        exibeModal: function exibeModal(arquivo, tipoArquivoSelecionado, campoNome) {
            this.files = [null];
            this.submitted = false;
            this.showModal = true;

            this.tipoArquivoSelecionado = tipoArquivoSelecionado;
            this.nomeArquivoSelecionado = arquivo.Nome;
            this.campoArquivoMongodb = campoNome;

            if (document.getElementsByTagName("main").length > 0) {
                document.getElementsByTagName("main")[0].style.zIndex = "50";
            }
        },
        onFilesChanged: function onFilesChanged(updatedFiles) {
            this.files = updatedFiles;
        },
        removeFile: function removeFile(index) {
            this.files.splice(index, 1);
        },
        clearFile: function clearFile(index) {
            this.$set(this.files, index, null);
        },
        validate: function validate() {
            if (this.receivedFiles.length > 0) {
                return { isValid: true, errors: [] };
            } else {
                return { isValid: false, errors: ['O envio do documento de identidade é obrigatório'] };
            }
        },
        submit: function submit() {
            this.submitted = true;

            __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].createDocumentos(this.getType, this.campoArquivoMongodb, this.getId, this.nomeArquivoSelecionado, this.receivedFiles).then(function () {});
        },
        closeModal: function closeModal() {
            var _this = this;

            this.showModal = false;

            __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getDocumentos(this.getType, this.getId).then(function (response) {
                _this.arquivosComprovanteResidencia = response.data.ArquivosComprovanteResidencia;
                _this.arquivosIdentidade = response.data.ArquivosIdentidade;
                _this.created = response.data.Created;
                _this.response = true;
            });
            if (document.getElementsByTagName("main").length > 0) {
                document.getElementsByTagName("main")[0].style.zIndex = "0";
            }
        },
        nomeArquivo: function nomeArquivo(arquivo) {
            if (arquivo.length > 22) {
                var extensao = arquivo.substr(arquivo.lastIndexOf("."));
                var nome = arquivo.substr(0, arquivo.lastIndexOf("."));

                return nome.substr(0, 15) + "..." + extensao;
            }

            return arquivo;
        }
    },
    props: ['type', 'id'],

    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getDocumentos(this.getType, this.getId).then(function (response) {
            // console.log(JSON.stringify(response,null,2))
            _this2.arquivosComprovanteResidencia = response.data.ArquivosComprovanteResidencia;
            _this2.arquivosIdentidade = response.data.ArquivosIdentidade;
            _this2.created = response.data.Created;
            _this2.response = true;
        });
    },


    computed: {
        getType: function getType() {
            return this.type;
        },
        getId: function getId() {
            return this.id;
        },
        receivedFiles: function receivedFiles() {
            return this.files.filter(function (file) {
                return file != null && file != undefined;
            });
        }
    }
});

/***/ }),

/***/ "7tYq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentosEmprestimoColetivo_vue__ = __webpack_require__("jzDM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_861429fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentosEmprestimoColetivo_vue__ = __webpack_require__("DYmT");
function injectStyle (ssrContext) {
  __webpack_require__("O2Lg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-861429fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentosEmprestimoColetivo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_861429fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentosEmprestimoColetivo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "84kS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		items: { required: true, type: Array },
		tipo: { required: true, type: String }
	},
	methods: {
		logout: function logout() {
			this.$store.dispatch('logout');
			this.$router.push('/login');
		},
		HideMobMenu: function HideMobMenu(status) {
			var menu = document.getElementsByClassName('collapsed-menu');

			if (status == true && menu.length >= 1) {
				menu[0].classList.remove("show");
			}
		}
	}
});

/***/ }),

/***/ "879M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_session_manager__ = __webpack_require__("J7hJ");






// const BASE_URI = '/api/v1'
/* eslint-disable */
var BASE_URI_GO = "https://api.iouu.com.br" + '/api/v1';
var OPEN_URI_GO = "https://api.iouu.com.br";

var ApiClientGo = function () {
  function ApiClientGo() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ApiClientGo);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ApiClientGo, null, [{
    key: "request",
    value: function request() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_4_axios___default()(this._prepareOptions(options));
    }
  }, {
    key: "request_GO",
    value: function request_GO() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_4_axios___default()(this._prepareOptions_GO(options));
    }
  }, {
    key: "get",
    value: function get(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(options, { url: url, method: "get" }));
    }
  }, {
    key: "get_GO",
    value: function get_GO(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request_GO(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(options, { url: url, method: "get" }));
    }
  }, {
    key: "post",
    value: function post(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(options, { url: url, method: "post" }));
    }
  }, {
    key: "put",
    value: function put(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(options, { url: url, method: "put" }));
    }
  }, {
    key: "put_GO",
    value: function put_GO(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request_GO(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(options, { url: url, method: "put" }));
    }
  }, {
    key: "delete",
    value: function _delete(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.request(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(options, { url: url, method: "delete" }));
    }
  }, {
    key: "_prepareOptions",
    value: function _prepareOptions(givenOptions) {
      if (!givenOptions.headers) {
        givenOptions.headers = {};
      }
      if (!givenOptions.headers["Accept"]) {
        givenOptions.headers["Accept"] = 'application/json';
      }
      if (!givenOptions.headers["Content-Type"]) {
        givenOptions.headers["Content-Type"] = 'application/json';
      }

      givenOptions.url = OPEN_URI_GO + "/" + givenOptions.url;
      return givenOptions;
    }
  }, {
    key: "_prepareOptions_GO",
    value: function _prepareOptions_GO(givenOptions) {
      if (!givenOptions.headers) {
        givenOptions.headers = {};
      }
      if (!givenOptions.headers["Accept"]) {
        givenOptions.headers["Accept"] = 'application/json';
      }
      if (!givenOptions.headers["Content-Type"]) {
        givenOptions.headers["Content-Type"] = 'application/json';
      }

      var accessToken = __WEBPACK_IMPORTED_MODULE_5__utils_session_manager__["a" /* default */].getAuthToken();

      if (accessToken) {
        givenOptions.headers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(givenOptions.headers, {
          Authorization: "Bearer " + accessToken
        });
      }

      givenOptions.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(givenOptions.data);
      givenOptions.url = BASE_URI_GO + "/" + givenOptions.url;
      return givenOptions;
    }
  }, {
    key: "gerarEstatistica",
    value: function gerarEstatistica(id) {
      return this.request_GO({
        url: "GetEstatisticas/" + id,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "gerarEstatisticaPlataformaInvestidores",
    value: function gerarEstatisticaPlataformaInvestidores(tipo) {
      return this.request_GO({
        url: "GetEstatisticasPlataformaInvestidores/" + tipo,
        method: "GET",
        data: tipo
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getInfoDarf",
    value: function getInfoDarf(idTransacao) {
      return this.request_GO({
        url: "GetInfoDarf/" + idTransacao,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "getInforme",
    value: function getInforme() {
      return this.request_GO({
        url: "investidor/informe",
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "atualizarContaBancaria",
    value: function atualizarContaBancaria(documento) {
      return this.request_GO({
        url: "alterarConta/" + documento,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "tabelaValoresInvestidores",
    value: function tabelaValoresInvestidores(solicitacaoId, reservaId) {
      return this.request_GO({
        url: "tabela/price/alongamento/" + solicitacaoId + "/" + reservaId,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "oportunidadePorId",
    value: function oportunidadePorId(id) {
      return this.request_GO({
        url: "solicitacoes/" + id,
        method: "GET"
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: "ListarOportunidades",
    value: function ListarOportunidades(pagina, scores) {
      return this.request_GO({
        url: "solicitacoes/listar/" + pagina + "/" + scores,
        method: "GET"
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getLoanRequest",
    value: function getLoanRequest(solicitacaoId) {
      return this.request_GO({
        url: "solicitacoes/detalhes/" + solicitacaoId,
        method: "GET"
      }).then(function (response) {
        var loanRequest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, response.data.Solicitacao);

        if (loanRequest.Empresa) {
          if (loanRequest.Empresa.DataFundacao) {
            loanRequest.Empresa.DataFundacao = new Date(loanRequest.Empresa.DataFundacao);
          }
          if (loanRequest.Empresa.DataConsultaEndividamento) {
            loanRequest.Empresa.DataConsultaEndividamento = new Date(loanRequest.Empresa.DataConsultaEndividamento);
          }
        }
        if (loanRequest.InicioCaptacao) {
          loanRequest.InicioCaptacao = new Date(loanRequest.InicioCaptacao);
        }
        if (loanRequest.FimCaptacao) {
          // loanRequest.FimCaptacaoText = loanRequest.FimCaptacao;
          loanRequest.FimCaptacao = new Date(loanRequest.FimCaptacao);
        }
        return loanRequest;
      });
    }
  }, {
    key: "ListarAntecipados",
    value: function ListarAntecipados(pagina, scores) {
      return this.request_GO({
        url: "solicitacoes/listar/" + pagina + "/score/" + scores + "/produto/empres",
        method: "GET"
      }).then(function (response) {
        console.log(response);
        return response.data;
      });
    }
  }, {
    key: "sign_up",
    value: function sign_up(_ref) {
      var name = _ref.name,
          email = _ref.email,
          password = _ref.password,
          CodigoConvidado = _ref.CodigoConvidado,
          _ref$tipo = _ref.tipo,
          tipo = _ref$tipo === undefined ? null : _ref$tipo;

      return __WEBPACK_IMPORTED_MODULE_4_axios___default()({
        url: OPEN_URI_GO + "/sign_up",
        method: "POST",
        headers: {
          provider: "iouu",
          token: "e3eb9b7ab88facd2a7ec805a3bbcee2aff81733b"
        },
        data: { name: name, email: email, password: password, CodigoConvidado: CodigoConvidado, tipo: tipo }
      });
    }
  }, {
    key: "sign_in",
    value: function sign_in(_ref2) {
      var email = _ref2.email,
          password = _ref2.password;

      var formData = new FormData();
      formData.append('email', email);
      formData.append('password', password);
      return __WEBPACK_IMPORTED_MODULE_4_axios___default()({
        url: OPEN_URI_GO + "/sign_in",
        method: "POST",
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      });
    }
  }, {
    key: "CheckCampanhaReinvestimentoMultiplo",
    value: function CheckCampanhaReinvestimentoMultiplo(valor) {
      return this.request_GO({
        url: "investidor/valida-multiplo-campanha/" + valor,
        method: "GET"
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return ApiClientGo;
}();

/* harmony default export */ __webpack_exports__["a"] = (ApiClientGo);

/***/ }),

/***/ "89ll":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SocialNetworkDashboard__ = __webpack_require__("eye1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SideMenu__ = __webpack_require__("a1CX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Invite_Friend__ = __webpack_require__("XZRT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Invite_Company__ = __webpack_require__("VCVs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Alerts__ = __webpack_require__("MGb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__package_json__ = __webpack_require__("7YgM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__package_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */










/* harmony default export */ __webpack_exports__["a"] = ({
	metaInfo: {
		htmlAttrs: {
			lang: 'pt-br'
		},
		bodyAttrs: {
			class: 'bg-light'
		}
	},
	data: function data() {
		return {
			version: __WEBPACK_IMPORTED_MODULE_8__package_json___default.a.version,
			menuItems: [{}, { iconClass: "ico-gra-4", title: "Meus investimentos", path: "/investimentos/meus-investimentos" }, { iconClass: "ico-ps", title: "Oportunidades", path: "/investimentos/oportunidades" }, { iconClass: "ico-imp", title: "Investimentos sociais", path: "/investimentos/investimento-de-impacto" }, { iconClass: "ico-ps", title: "Antecipação de Recebíveis", path: "/investimentos/antecipacao" }, { iconClass: "ico-lib", title: "Meu histórico", path: "/investimentos/historico" }, { iconClass: "ico-ct-4", title: "Carteira virtual", path: "/investimentos/carteira-investimento" },
			//  {iconClass: "ico-gra-3", title: "Estatísticas", path: "/investimentos/estatisticas"},
			// {iconClass: "ico-ct-2", title: "Portfólios", path: "/investimentos/portfolios"},
			{ iconClass: "ico-din", title: "Central de cobranças", path: "/investimentos/central-de-cobranca" }],
			// ajudaMenu: {iconClass: "ico-ch", title: "Perguntas e respostas", url: "http://ajuda.iouu.com.br" },
			InvestorAprovado: false,
			TemInvestimento: false,
			showModal: false,
			from: "ENV",
			modalStep: 1,
			auxModalStep: 1
		};
	},

	components: {
		SideMenu: __WEBPACK_IMPORTED_MODULE_1__components_SideMenu__["a" /* default */],
		SocialNetwork: __WEBPACK_IMPORTED_MODULE_0__components_SocialNetworkDashboard__["a" /* default */],
		Modal: __WEBPACK_IMPORTED_MODULE_4__components_Modal__["a" /* default */],
		Friend: __WEBPACK_IMPORTED_MODULE_5__components_Invite_Friend__["a" /* default */],
		Company: __WEBPACK_IMPORTED_MODULE_6__components_Invite_Company__["a" /* default */],
		Alerts: __WEBPACK_IMPORTED_MODULE_7__components_Alerts__["a" /* default */]
	},
	methods: {
		Investidor: function Investidor() {
			window.variavel = this;
			if (this.User.hasinvestor == undefined) return false;

			return this.User.hasinvestor;
		},
		Suitability: function Suitability() {
			if (this.User.hassuitability == undefined) return false;

			return this.User.hassuitability;
		},
		Logout: function Logout() {
			this.$store.dispatch('logout');
			this.$router.push('/login');
		},
		Nome: function Nome() {
			var nome = "",
			    letra = "";
			if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
				nome = this.User.username;
			} else {
				nome = this.User.name;
			}

			if (nome != undefined) nome = nome.trim();

			var primeiroNome = nome.split(" ")[0];

			if (primeiroNome != undefined) return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);

			return "";
		},

		// METHOD TO SHOW MOBILE MENU
		ShowMobMenu: function ShowMobMenu(status) {
			var menu = document.getElementsByClassName('collapsed-menu');

			if (status == true && menu.length >= 1) {
				menu[0].classList.add("show");
			}
		},
		finishInvite: function finishInvite() {
			this.modalStep = 3;
		},
		activeButton: function activeButton(name) {
			var buttonName = name;

			if (buttonName === "person") {
				document.getElementsByClassName('invited-person')[0].classList.add('active');
				document.getElementsByClassName('invited-company')[0].classList.remove('active');
			} else {
				document.getElementsByClassName('invited-person')[0].classList.remove('active');
				document.getElementsByClassName('invited-company')[0].classList.add('active');
			}
		},
		LetraNome: function LetraNome() {

			var nome = this.Nome();

			if (nome != null && nome != undefined && nome.length > 0) return nome[0].toUpperCase();

			return "";
		},
		InvestidorComInvestimento: function InvestidorComInvestimento() {
			return this.User.hasinvestments;
		},
		ResetMenuSelecionado: function ResetMenuSelecionado() {
			var menuSelecionado = void 0;
			var url = window.location.href.split("/");
			url[url.length - 2] == 'investimentos' ? menuSelecionado = url[url.length - 1] : menuSelecionado = url[url.length - 2];

			document.querySelectorAll(".at-menu__item-link").forEach(function (item) {
				item.classList.remove("router-link-exact-active");
				item.classList.remove("router-link-active");
			});

			document.querySelectorAll(".at-menu__item").forEach(function (item) {
				item.classList.remove("at-menu__item--active");
			});

			var elementoMenu = void 0;
			switch (menuSelecionado) {
				case 'meus-investimentos':
					elementoMenu = document.querySelectorAll('.ico-gra-4')[1].parentElement;
					break;
				case 'oportunidades':
					elementoMenu = document.querySelectorAll('.ico-ps')[1].parentElement;
					break;
				case 'antecipacao':
					elementoMenu = document.querySelectorAll('.ico-gra')[1].parentElement;
					break;
				case 'investimento-de-impacto':
					elementoMenu = document.querySelectorAll('.ico-imp')[1].parentElement;
					break;
				case 'carteira-investimento':
					elementoMenu = document.querySelectorAll('.ico-ct-4')[2].parentElement;
					break;
				default:
					elementoMenu = null;
					break;
			}

			if (elementoMenu != null) {
				elementoMenu.classList.add("router-link-exact-active");
				elementoMenu.classList.add("router-link-active");
			}
		}
	},
	computed: {
		User: function User() {
			return this.$store.state.currentUser;
		}
	},
	created: function created() {
		var _this = this;

		this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["c" /* START_LOADING */]);
		__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getInvestor().then(function (investor) {
			_this.InvestorAprovado = investor.Status == "APROVADO";
			_this.menuItems.push(_this.ajudaMenu);
			_this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
		}).catch(function () {
			return _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
		});
	},
	beforeCreate: function beforeCreate() {
		window.document.title = 'Dashboard IOUU';
	},
	updated: function updated() {
		this.ResetMenuSelecionado();
	}
});

/***/ }),

/***/ "8BAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    setTimeout(function () {
      window.location.href = "https://iouu.com.br";
    }, 5000);
  }
});

/***/ }),

/***/ "8IUl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "8P55":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8TPV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client_go__ = __webpack_require__("879M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jspdf__ = __webpack_require__("l9mu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_html2canvas__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dadosUsuario: {},
      DadosInvestidor: {
        InvestidorNome: "",
        InvestidorCpf: "",
        ValorJuros: 0,
        ValorPrincipal2019: 0,
        ValorPrincipal2020: 0
      },
      Rendimentos: [],
      Bens: [],
      BaseRequest: {}
    };
  },

  methods: {
    getInforme: function getInforme() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__utils_api_client_go__["a" /* default */].getInforme();

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    downloadPdf: function downloadPdf(dados) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var dadosEnvio, html, iframe;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dadosEnvio = {
                  NomeCompleto: dados.InvestidorNome,
                  CPF: dados.InvestidorCpf,
                  Bens: [],
                  Rendimentos: []
                };
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client__["a" /* default */].downloadPdf(dadosEnvio);

              case 3:
                html = _context2.sent;
                iframe = document.createElement('iframe');

                iframe.className = "report-informe-investimento";
                document.body.appendChild(iframe);
                iframe.contentWindow.document.open();
                iframe.contentWindow.document.write(html.data);
                iframe.contentWindow.document.close();

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getPdf: function getPdf(cpf) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var dadosInforme, iframe;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client__["a" /* default */].getPdf(cpf);

              case 2:
                dadosInforme = _context3.sent;


                _this3.DadosInvestidor.InvestidorNome = _this3.dadosUsuario.investor.NomeCompleto;
                _this3.DadosInvestidor.InvestidorCpf = _this3.dadosUsuario.investor.Cpf;
                _this3.DadosInvestidor.ValorJuros = dadosInforme.data.ValorJuros;
                _this3.DadosInvestidor.ValorPrincipal2019 = dadosInforme.data.ValorPrincipal2019;
                _this3.DadosInvestidor.ValorPrincipal2020 = dadosInforme.data.ValorPrincipal2020;
                _this3.BaseRequest = _this3.DadosInvestidor;

                iframe = document.createElement('iframe');

                iframe.className = "report-informe-investimento";
                document.body.appendChild(iframe);
                iframe.contentWindow.document.open();
                iframe.contentWindow.document.write(_this3.DadosInvestidor);
                iframe.contentWindow.document.close();

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    cpfFormater: function cpfFormater(cpf) {
      return cpf.slice(0, 3) + "." + cpf.slice(3, 6) + "." + cpf.slice(6, 9) + "-" + cpf.slice(9, 12);
    },
    cnpjFormater: function cnpjFormater(cnpj) {
      cnpj = cnpj.replace(/\D/g, "");
      return cnpj.slice(0, 2) + "." + cnpj.slice(2, 5) + "." + cnpj.slice(5, 8) + "/" + cnpj.slice(8, 12) + "-" + cnpj.slice(12, 14);
    },
    formatValue: function formatValue(value) {
      if (typeof value == 'undefined') {
        return 0;
      }
      var stringValue = (Math.floor(value * 100) / 100).toString();
      var comma = stringValue.indexOf(".");
      if (comma == -1) {
        stringValue = stringValue + ".00";
      } else if (comma == stringValue.length - 2) {
        stringValue = stringValue + "0";
      }
      return stringValue;
    },
    formatResposta: function formatResposta(rendimentos, valores) {
      var resposta = [];
      for (var i = 0; i < rendimentos.Empresas.length; i++) {
        var respLocal = {
          Nome: "",
          Cnpj: "",
          Descricao: "",
          Valor: ""
        };

        respLocal.Nome = rendimentos.Empresas[i];
        respLocal.Cnpj = this.cnpjFormater(rendimentos.Cnpj[i]);
        respLocal.Descricao = "Juros sobre empréstimo cedido";
        respLocal.Valor = this.formatValue(valores[rendimentos.IDS[i]]);

        if (respLocal.Valor != "0.00") resposta.push(respLocal);
      }
      return resposta;
    },


    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/informe-rendimento',
        title: 'Report Yield'
      });
    }
  },
  created: function created() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var cpf;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              _this4.dadosUsuario = _this4.$store.state.currentUser;
              cpf = _this4.dadosUsuario.investor.Cpf.replace('.', '').replace('.', '').replace('-', '');
              _context4.next = 5;
              return _this4.getPdf(cpf);

            case 5:
              _context4.next = 10;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);

              __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire("Novo por aqui?", "Voce não possui recebimentos no ano de 2020, clique no botao para voltar a pagina de investimentos").then(function (result) {
                _this4.$router.push("/investimentos/meus-investimentos");
              });

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 7]]);
    }))();
  }
});

/***/ }),

/***/ "8XXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid login"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"ico-iouu",attrs:{"href":_vm.lpUrl,"target":"_blank","title":"IOUU"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('social-network')],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-7 d-flex flex-column form"},[_c('header',{staticClass:"align-self-center align-self-md-end"},[_vm._v("\n          Já tem uma conta?\n          "),_c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":"login"}},[_vm._v("Entrar")])],1),_vm._v(" "),_c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-5 text-center"},[_c('h2',[_vm._v("Perdeu sua senha?")]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Digite seu endereço de e-mail abaixo\npara recuperar sua senha.")]),_vm._v(" "),_c('form',{attrs:{"id":"form-recuperar-senha"},on:{"submit":function($event){$event.preventDefault();return _vm.sendResePasswordtEmail($event)}}},[_c('div',{staticClass:"form-group text-left "},[_c('label',{attrs:{"for":"email"}},[_vm._v("Endereço de email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",attrs:{"type":"email","autofocus":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Enviar")])]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"login"}},[_vm._v("Voltar para entrar")])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-lg-10 d-flex flex-column align-items-center"},[_c('h1',[_vm._v("Recuperar senha")]),_vm._v(" "),_c('p',[_vm._v("\n              Não se preocupe. Você não está assumindo nenhum compromisso neste momento.\n              "),_c('br'),_vm._v("Suas informações serão usadas apenas para analisarmos o seu perfil\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.\n            ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8dEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoConfirmacaoCadastro_vue__ = __webpack_require__("bBKy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fba5d53a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoConfirmacaoCadastro_vue__ = __webpack_require__("Cgk/");
function injectStyle (ssrContext) {
  __webpack_require__("WuKC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fba5d53a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoConfirmacaoCadastro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fba5d53a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoConfirmacaoCadastro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8dK4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8dkd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8fww":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"funds-transfer"},[_c('div',{staticClass:"row align-items-center funds-transfer__tit-page tit_page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12  col-md-6 col-lg-4"},[_c('div',{staticClass:"back back-hide float-md-right"},[(_vm.step === 1)?_c('router-link',{attrs:{"to":"/investimentos/carteira-investimento","title":"Voltar"}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar")]):_c('a',{attrs:{"title":"voltar"},on:{"click":function($event){return _vm.backStep()}}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 col-lg-4"},[(_vm.loading)?_c('div',{staticClass:"funds-transfer__infos box-border"},[_c('div',{staticClass:"funds-transfer__infos--cash"},[_c('label',[_vm._v("Valor disponível para saque")]),_vm._v(" "),_c('span',[_vm._v("R$ "+_vm._s(_vm.Saldo == 0 ? _vm.formatCurrency(_vm.Saldo) : _vm.formatCurrency(Math.floor(_vm.Saldo * 100) / 100)))])]),_vm._v(" "),_c('hr',{staticClass:"divier"}),_vm._v(" "),_c('div',{staticClass:"funds-transfer__infos--account"},[_c('label',[_vm._v("Nome do banco")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.nomeBanco()))])]),_vm._v(" "),_c('div',{staticClass:"funds-transfer__infos--account"},[_c('label',[_vm._v("Tipo de conta")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.tipoConta(this.dadosBanco.DadosBancarios.TipoConta)))])]),_vm._v(" "),_c('div',{staticClass:"funds-transfer__infos--account"},[_c('label',{attrs:{"for":""}},[_vm._v("Agencia")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.dadosBanco.DadosBancarios.Agencia))])]),_vm._v(" "),_c('div',{staticClass:"funds-transfer__infos--account"},[_c('label',{attrs:{"for":""}},[_vm._v("Número da conta")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.dadosBanco.DadosBancarios.Conta))])]),_vm._v(" "),_c('hr',{staticClass:"divier"}),_vm._v(" "),_c('div',{staticClass:"funds-transfer__infos--link"},[_c('router-link',{attrs:{"to":"/investimentos/perfil/editar-perfil?to=bank","title":"Alterar conta bancária"}},[_c('i',{staticClass:"ico-inst"}),_vm._v(" Alterar conta bancária")])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 col-lg-8"},[_c('div',{staticClass:"funds-transfer__actions box-border"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-6 col-xl-5"},[(_vm.step === 1)?_c('form',{attrs:{"action":""}},[_c('fieldset',[_c('h2',[_vm._v("Qual o valor que deseja sacar?")]),_vm._v(" "),_c('label',{attrs:{"for":"valor"}},[_vm._v("Digite quanto você quer transferir:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueSaqueDate),expression:"valueSaqueDate"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"type":"tel","placeholder":"R$ 00,00"},domProps:{"value":(_vm.valueSaqueDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valueSaqueDate=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("\n                                    Saldo disponível para transferência: "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.Saldo == 0 ? _vm.formatCurrency(_vm.Saldo) : _vm.formatCurrency(Math.floor(_vm.Saldo * 100) / 100)))]),_c('br'),_vm._v("\n                                    Não há custo para sua transferência, a operação será finalizada em até 3 dias uteis: "),_c('strong',[_vm._v("R$ 0,00")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"disabled":!_vm.isValidValue()},on:{"click":_vm.validateValue}},[_vm._v("Próximo")])])]):(_vm.step === 2)?_c('form',[_c('fieldset',[_c('h2',[_vm._v("Transferir quando?")]),_vm._v(" "),_c('datetime',{staticClass:"theme-iouu",attrs:{"placeholder":"__/__/____","min-datetime":_vm.mindate,"input-class":"form-control form-control-lg","type":"text","format":"dd/MM/yyyy"},model:{value:(_vm.dataText),callback:function ($$v) {_vm.dataText=$$v},expression:"dataText"}}),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("\n                                    As transferências serão efetivas em até dois dias úteis da data de solicitação.\n                                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"disabled":!_vm.isValidDate()},on:{"click":_vm.validateDate}},[_vm._v("Próximo")])],1)]):(_vm.step === 3)?_c('form',[_c('fieldset',[_c('h2',[_vm._v("Confirmar transferência")]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Transferir em "+_vm._s(_vm.formatDate(_vm.dataText)))]),_vm._v(" "),_c('div',[_c('p',[_c('strong',[_vm._v("Valor solicitado")]),_vm._v(" "),_c('span',{staticClass:"text-secondary"},[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.formatReal(this.valueSaqueDate))))])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Custo de transferência")]),_vm._v(" "),_c('span',{staticClass:"text-danger"},[_vm._v("R$ "+_vm._s(_vm.formatCurrency(this.ted)))])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Valor total da transferência")]),_vm._v(" "),_c('span',{staticClass:"text-primary"},[_vm._v("R$ "+_vm._s(_vm.calcTotalTransfer(this.valueSaqueDate)))])])]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("\n                                    Transferência para o Banco: "+_vm._s(_vm.nomeBanco())),_c('br'),_vm._v("\n                                    Agência: "+_vm._s(this.dadosBanco.DadosBancarios.Agencia)+" - "+_vm._s(_vm.tipoConta(this.dadosBanco.DadosBancarios.TipoConta))+" : "+_vm._s(this.dadosBanco.DadosBancarios.Conta)+"\n                                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg btn-block",on:{"click":_vm.confirmTransfer}},[_vm._v("Sim, transferir")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/investimentos/carteira-investimento"}},[_vm._v("Cancelar")])],1)]):(_vm.step === 4)?_c('form',[_c('fieldset',[_c('h2',[_vm._v(_vm._s(this.investor.NomeCompleto)+", falta só mais um passo!")]),_vm._v(" "),_c('label',{attrs:{"for":"senha"}},[_vm._v("Por favor insira sua senha no campo abaixo para finalizar seu pedido de transferência.")]),_vm._v(" "),_c('password-field',{model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg btn-block",class:{'btn-loading' : _vm.isLoading},attrs:{"disabled":!_vm.password || _vm.isLoading},on:{"click":_vm.validatePassword}},[(_vm.isLoading)?_c('span',[_vm._v("Loading")]):_c('span',[_vm._v("Autorizar")])]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/investimentos/carteira-investimento"}},[_vm._v("Cancelar")])],1)]):_vm._e()])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-6 col-lg-8"},[_c('h1',[_vm._v("Transferência")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8knn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8n8l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finishedLoading)?_c('div',{staticClass:"list-view"},[(_vm.showModal)?_c('Modal',{attrs:{"solicitacaoProps":_vm.solicitacao,"investidor":_vm.currentUser.investor,"usuario":_vm.currentUser,"valorInicial":_vm.selected,"reservaInvestimento":_vm.investmentReservation},on:{"close":function (alterado){ return _vm.voltar(alterado); }}}):_vm._e(),_vm._v(" "),(_vm.solicitacao != null)?_c('div',{staticClass:"row company-view",class:_vm.scoreClass},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("Oportunidade "),_c('span',[_vm._v("id#"+_vm._s(_vm.id))])])]),_vm._v(" "),_c('div',{staticClass:"back float-right"},[_c('router-link',{attrs:{"to":'/investimentos/oportunidades'+_vm.voltarLink(),"title":"Voltar"}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('hr',{staticClass:"divider"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-8"},[_c('div',{staticClass:"tit"},[_c('div',{staticClass:"float-left"},[_c('h2',[_vm._v(_vm._s(_vm.nomeFantasia))]),_vm._v(" "),_c('span',[_vm._v("CNPJ: "+_vm._s(_vm.formattedCnpj))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.formatarTipoEmprestimo(_vm.loanType)))])]),_vm._v(" "),_c('div',{staticClass:"rating float-left float-md-right"},[_c('strong',[_vm._v("\n                  Score da operação\n                  "),_c('span',{staticClass:"circle score"}),_vm._v(" \n                  "+_vm._s(_vm.score)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('section',[_c('at-tabs',[_c('at-tab-pane',{attrs:{"label":"Fotos","name":"name1","icon":"icon-camera"}},[_c('carousel',{attrs:{"pictures":_vm.pictures}})],1),_vm._v(" "),(_vm.vimeoVideoUrl !== '')?_c('at-tab-pane',{attrs:{"label":"Vídeo","name":"name2","icon":"icon-video"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"src":_vm.vimeoVideoUrl,"webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})])])])]):_vm._e()],1),_vm._v(" "),_c('div'),_vm._v(" "),_c('h4',{staticStyle:{"margin-top":"30px"}},[_vm._v("Descrição breve sobre a empresa")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.companyDescription)}})],1),_vm._v(" "),_c('section',[_c('h3',[_vm._v("Dados da empresa")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.razaoSocial))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("CPF/CNPJ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formattedCnpj))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Nome do responsável")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.nomeSolicitante))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Nome fantasia")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.nomeFantasia))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Telefone comercial")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.telefoneComercial))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Data de fundação")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.dataFundacao))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Número de funcionários")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.quantidadeEmpregados)+" empregados")])]),_vm._v(" "),(_vm.nomeGrupoEconomico)?_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Nome do grupo ecônomico")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.nomeGrupoEconomico))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('label',[_vm._v("Endereço")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.address))])]),_vm._v(" "),(_vm.site)?_c('div',{staticClass:"col-12 col-lg-5"},[_c('label',[_vm._v("Site")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.site))])]):_vm._e(),_vm._v(" "),(_vm.companyFacebook || _vm.companyTwitter || _vm.companyLinkedin || _vm.companyInstagram || _vm.companyVimeo)?_c('div',{staticClass:"col-12 col-lg-7"},[_c('label',[_vm._v("Redes Sociais")]),_vm._v(" "),_c('span',[(_vm.companyFacebook)?_c('a',{staticClass:"fab fa-facebook-square",attrs:{"href":_vm.companyFacebook}}):_vm._e(),_vm._v(" "),(_vm.companyTwitter)?_c('a',{staticClass:"fab fa-twitter",attrs:{"href":_vm.companyTwitter}}):_vm._e(),_vm._v(" "),(_vm.companyLinkedin)?_c('a',{staticClass:"fab fa-linkedin-in",attrs:{"href":_vm.companyLinkedin}}):_vm._e(),_vm._v(" "),(_vm.companyInstagram)?_c('a',{staticClass:"fab fa-instagram",attrs:{"href":_vm.companyInstagram}}):_vm._e(),_vm._v(" "),(_vm.companyVimeo)?_c('a',{staticClass:"fab fa-vimeo-v",attrs:{"href":_vm.companyVimeo}}):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.formatoInvestimento)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-secondary",attrs:{"role":"alert"}},[_c('strong',[_vm._v("Formato do Investimento:")]),_vm._v(" "+_vm._s(_vm.formatoInvestimento)+"\n                  ")])]):_vm._e()]),_vm._v(" "),_c('iframe',{staticStyle:{"border":"0","border-radius":"5px"},attrs:{"src":_vm.mapUrl,"width":"100%","height":"280","frameborder":"0","allowfullscreen":""}}),_vm._v(" "),_c('div',[_c('h4',[_vm._v("Motivo da solicitação do empréstimo")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.motivoSolicitacao))])]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("Garantias oferecidas")]),_vm._v(" "),(_vm.id == 22647)?_c('img',{staticClass:"selo-garantia",attrs:{"src":"/static/assets/images/selo-garantia-bndes.png","title":"Oportunidade com garantia pelo tomador e indicada pelo canal BNDES"}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.garantiasOferecidas))])])]),_vm._v(" "),_c('section',[_c('h3',[_vm._v("Análise sobre a empresa")]),_vm._v(" "),(_vm.showMeInfo())?_c('div',{staticClass:"em-analise",domProps:{"innerHTML":_vm._s(_vm.analiseEmpresa)}}):_vm._e()])]),_vm._v(" "),_c('aside',{staticClass:"col-12 col-md-4 col-lg-4"},[_c('investment-reservation-form',{ref:"investForm",attrs:{"loan-request":_vm.solicitacao,"investment-confirmed":this.investmentConfirmed},on:{"submit":_vm.submitInvestment}})],1),_vm._v(" "),(_vm.showMeInfo())?_c('div',{staticClass:"col-12 indices"},[_c('div',{staticClass:"divider-block"}),_vm._v(" "),_c('section',{staticClass:"row indices__tipo"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-4"},[_c('div',{staticClass:"porte"},[_c('label',[_vm._v("Porte da empresa")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.porteEmpresa))])])]),_vm._v(" "),(_vm.validacaoSetor(this.solicitacao.Empresa))?_c('div',{staticClass:"col-12 col-md-12 col-lg-8 indices__tipo-setor"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12 col-md-4 col-lg-3 setor"},[_c('label',[_vm._v("Setor da empresa")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.Setor))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 col-lg-9 risco"},[_c('label',[_vm._v("Risco de crédito do setor*")]),_vm._v(" "),_c('div',{staticClass:"row row no-gutters"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-5"},[_c('p',[_vm._v("Pontuação do setor:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),_c('strong',[_vm._v(_vm._s(_vm.PontuacaoSetor))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-7 col-lg-7"},[_c('p',[_vm._v("Prob. Média de Inadimplência:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),_c('strong',[_vm._v(_vm._s(_vm.InadimplenciaSetor)+"%")])])])])])]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("* A probabilidade média associada a classe de risco de crédito para esse segmento é de: "+_vm._s(_vm.InadimplenciaSetor)+"%. Para cada 100 empresas\n\t\t\t\t\t\t\t\t\tsituadas na mesma classe de risco de crédito desse segmento, "+_vm._s(_vm.InadimplenciaSetor)+" poderão apresentar um dos eventos que caracterizam\n\t\t\t\t\t\t\t\t\tinadimplência para o modelo.")])]):_vm._e()]),_vm._v(" "),_c('nav',[_c('div',{staticClass:"nav nav-tabs",attrs:{"id":"nav-tab","role":"tablist"}},[_c('a',{staticClass:"nav-item nav-link active",attrs:{"id":"ind-fin-tab","data-toggle":"tab","href":"#nav-indf","role":"tab","aria-controls":"nav-indf","aria-selected":"true"}},[_vm._v("Índices financeiros")]),_vm._v(" "),(_vm.verificaValoresIndices(this.solicitacao.Empresa.IndicesFinanceiros))?_c('a',{staticClass:"nav-item nav-link",attrs:{"id":"ind-cont-tab","data-toggle":"tab","href":"#nav-indc","role":"tab","aria-controls":"nav-indc","aria-selected":"false"}},[_vm._v("Índices complementares")]):_vm._e(),_vm._v(" "),(this.solicitacao.Empresa.Socios && this.solicitacao.Empresa.Socios.length > 0)?_c('a',{staticClass:"nav-item nav-link",attrs:{"id":"inf-socios-tab","data-toggle":"tab","href":"#nav-info","role":"tab","aria-controls":"nav-info","aria-selected":"false"}},[_vm._v("Informações sobre sócios")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab-content",attrs:{"id":"nav-tabContent"}},[_c('div',{staticClass:"tab-pane fade show active",attrs:{"id":"nav-indf","role":"tabpanel","aria-labelledby":"ind-fin-tab"}},[_c('section',{staticClass:"indices__financeiros"},[_c('div',{staticClass:"row indices__financeiros--valores"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Faturamento anual")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.faturamentoAnual))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Lucro líquido mensal")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.lucroLiquido))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-6"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Endividamento")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.divida))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Data base da consulta")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.dataConsultaEndividamento))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-6"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Negativações")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.negativacoes))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_vm._m(1),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.atrasos))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-12"},[_c('div',{staticClass:"box box_chart"},[_c('h2',[_vm._v("Faturamento dos últimos 12 meses")]),_vm._v(" "),_c('bar-chart',{attrs:{"data":_vm.chartData}})],1)]),_vm._v(" "),( _vm.verificaValoresVertical(this.solicitacao.Empresa.Balancos))?_c('div',{staticClass:"col-12 col-lg-12"},[_c('div',{staticClass:"box box_chart"},[_c('h2',[_vm._v("\n                          Análise vertical\n                          "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"A Análise Vertical (AV) é também conhecida como Análise de Estrutura, é utilizado para identificar a porcentagem de participação de determinado indicador no resultado, permitindo que sejam feitas comparações caso existam dois ou mais períodos."}},[_c('i',{staticClass:"fas fa-info-circle"})])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"box box_chart text-center",staticStyle:{"margin-bottom":"20px"}},[(this.solicitacao.Empresa.Mes1 == '' || this.solicitacao.Empresa.Mes1 == undefined)?_c('h4',[_vm._v(_vm._s(this.solicitacao.Empresa.Ano1))]):_c('h4',[_vm._v(_vm._s(this.solicitacao.Empresa.Mes1)+"/"+_vm._s(this.solicitacao.Empresa.Ano1))]),_vm._v(" "),_c('div',{staticClass:"box_chart-row"},[_c('div',{staticClass:"box_chart-col col-one"},[_c('div',{style:(_vm.blockHight(_vm.Balanco.ano1.AtivoCirculante))},[_c('span',{staticClass:"rounded-circle"},[_vm._v(_vm._s(_vm.Balanco.ano1.AtivoCirculante)+"%")])]),_vm._v(" "),_c('div',{style:(_vm.blockHight(_vm.Balanco.ano1.AtivoNCirculante))},[_c('span',{staticClass:"rounded-circle"},[_vm._v(_vm._s(_vm.Balanco.ano1.AtivoNCirculante)+"%")])])]),_vm._v(" "),_c('div',{staticClass:"box_chart-col col-two"},[_c('div',{style:(_vm.blockHight(_vm.Balanco.ano1.PassivoCirculante))},[_c('span',{staticClass:"rounded-circle"},[_vm._v(_vm._s(_vm.Balanco.ano1.PassivoCirculante)+"%")])]),_vm._v(" "),_c('div',{style:(_vm.blockHight(_vm.Balanco.ano1.PassivoNCirculante))},[_c('span',{staticClass:"rounded-circle"},[_vm._v(_vm._s(_vm.Balanco.ano1.PassivoNCirculante)+"%")])]),_vm._v(" "),_c('div',{style:(_vm.blockHight(_vm.Balanco.ano1.PatrimonioLiquido))},[_c('span',{staticClass:"rounded-circle"},[_vm._v(_vm._s(_vm.Balanco.ano1.PatrimonioLiquido)+"%")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"box box_chart text-center",staticStyle:{"margin-bottom":"20px"}},[(this.solicitacao.Empresa.Mes2 == '' || this.solicitacao.Empresa.Mes2 == undefined)?_c('h4',[_vm._v(_vm._s(this.solicitacao.Empresa.Ano2))]):_c('h4',[_vm._v(_vm._s(this.solicitacao.Empresa.Mes2)+"/"+_vm._s(this.solicitacao.Empresa.Ano2))]),_vm._v(" "),_c('div',{staticClass:"box_chart-row"},[_c('div',{staticClass:"box_chart-col col-one"},[_c('div',{style:(_vm.blockHight(_vm.Balanco.ano2.AtivoCirculante))},[_c('span',{staticClass:"rounded-circle"},[_vm._v(_vm._s(_vm.Balanco.ano2.AtivoCirculante)+"%")])]),_vm._v(" "),_c('div',{style:(_vm.blockHight(_vm.Balanco.ano2.AtivoNCirculante))},[_c('span',{staticClass:"rounded-circle"},[_vm._v(_vm._s(_vm.Balanco.ano2.AtivoNCirculante)+"%")])])]),_vm._v(" "),_c('div',{staticClass:"box_chart-col col-two"},[_c('div',{style:(_vm.blockHight(_vm.Balanco.ano2.PassivoCirculante))},[_c('span',{staticClass:"rounded-circle"},[_vm._v(_vm._s(_vm.Balanco.ano2.PassivoCirculante)+"%")])]),_vm._v(" "),_c('div',{style:(_vm.blockHight(_vm.Balanco.ano2.PassivoNCirculante))},[_c('span',{staticClass:"rounded-circle"},[_vm._v(_vm._s(_vm.Balanco.ano2.PassivoNCirculante)+"%")])]),_vm._v(" "),_c('div',{style:(_vm.blockHight(_vm.Balanco.ano2.PatrimonioLiquido))},[_c('span',{staticClass:"rounded-circle"},[_vm._v(_vm._s(_vm.Balanco.ano2.PatrimonioLiquido)+"%")])])])])])])]),_vm._v(" "),_vm._m(2)])]):_vm._e(),_vm._v(" "),(_vm.verificaValoresVertical(this.solicitacao.Empresa.Balancos))?_c('div',{staticClass:"col-12 col-lg-12"},[_c('div',{staticClass:"box box_chart"},[_c('h2',[_vm._v("\n                          Análise horizontal\n                          "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"A Análise Horizontal (AH) verifica a evolução de um elemento (Balanço Patrimonial), se baseia na comparação entre resultados de um mesmo indicador em relação a períodos anteriores."}},[_c('i',{staticClass:"fas fa-info-circle"})])],1),_vm._v(" "),_c('bar-chart-env',{attrs:{"data":_vm.DadosGrafico()}}),_vm._v(" "),_vm._m(3)],1)]):_vm._e()]),_vm._v(" "),(this.solicitacao.Empresa.Demonstrativos && _vm.Demonstrativos(this.solicitacao).length > 0)?_c('h4',[_vm._v("Demostrativos financeiros")]):_vm._e(),_vm._v(" "),(_vm.Demonstrativos(this.solicitacao).length > 0)?_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}}),_vm._v(" "),(this.solicitacao.Empresa.Mes1 == '' || this.solicitacao.Empresa.Mes1 == undefined)?_c('th',{attrs:{"scope":"col"}},[_vm._v("\n                          "+_vm._s(this.solicitacao.Empresa.Ano1)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),_c('span',[_vm._v(_vm._s(this.solicitacao.Empresa.PeriodoAnaliseAnterior))])]):_c('th',{attrs:{"scope":"col"}},[_vm._v("\n                          "+_vm._s(this.solicitacao.Empresa.Mes1)+"/"+_vm._s(this.solicitacao.Empresa.Ano1)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),_c('span',[_vm._v(_vm._s(this.solicitacao.Empresa.PeriodoAnaliseAnterior))])]),_vm._v(" "),(this.solicitacao.Empresa.Mes2 == '' || this.solicitacao.Empresa.Mes2 == undefined)?_c('th',{attrs:{"scope":"col"}},[_vm._v("\n                          "+_vm._s(this.solicitacao.Empresa.Ano2)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),_c('span',[_vm._v(_vm._s(this.solicitacao.Empresa.PeriodoAnaliseAtual))])]):_c('th',{attrs:{"scope":"col"}},[_vm._v("\n                          "+_vm._s(this.solicitacao.Empresa.Mes2)+"/"+_vm._s(this.solicitacao.Empresa.Ano2)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),_c('span',[_vm._v(_vm._s(this.solicitacao.Empresa.PeriodoAnaliseAtual))])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.Demonstrativos(this.solicitacao)),function(demo){return _c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("\n                         "+_vm._s(demo.Tipo)+"\n                        ")]),_vm._v(" "),_c('td',[_vm._v("\n                          "+_vm._s(_vm.formatDemos(demo.Tipo, demo.ValorAno1, demo.Unidade))+"\n                         ")]),_vm._v(" "),_c('td',[_c('i',{class:_vm.classIndice(demo)}),_vm._v("\n                          "+_vm._s(_vm.formatDemos(demo.Tipo, demo.ValorAno2, demo.Unidade))+"\n                          ")])])}),0),_vm._v(" "),_vm._m(4)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"nav-indc","role":"tabpanel","aria-labelledby":"ind-cont-tab"}},_vm._l((_vm.IndicesComplementares(this.solicitacao)),function(indices,index){return (indices.Dados)?_c('section',{staticClass:"indices__complementares"},[_c('div',{staticClass:"box"},[_c('h3',{staticClass:"box--title"},[_vm._v(_vm._s(indices.Grupo))]),_vm._v(" "),_vm._l((indices.Dados),function(indice,i){return _c('div',{staticClass:"row no-gutters indices__complementares--item"},[_c('div',{staticClass:"col-12 col-md-4 percentual text-center"},[_c('h5',[_vm._v(_vm._s(indice.Tipo))]),_vm._v(" "),_c('ul',[_c('li',[(_vm.solicitacao.Empresa.Mes1 == '' || _vm.solicitacao.Empresa.Mes1 == undefined)?_c('label',[_vm._v(_vm._s(_vm.solicitacao.Empresa.Ano1))]):_c('label',[_vm._v(_vm._s(_vm.solicitacao.Empresa.Mes1)+"/"+_vm._s(_vm.solicitacao.Empresa.Ano1))]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.formatCurrency(indice.ValorAno1)))])]),_vm._v(" "),_c('li',[(_vm.solicitacao.Empresa.Mes2 == '' || _vm.solicitacao.Empresa.Mes2 == undefined)?_c('label',[_vm._v(_vm._s(_vm.solicitacao.Empresa.Ano2))]):_c('label',[_vm._v(_vm._s(_vm.solicitacao.Empresa.Mes2)+"/"+_vm._s(_vm.solicitacao.Empresa.Ano2))]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.formatCurrency(indice.ValorAno2)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 entry"},[_c('span',{class:_vm.classBullet(indice.Status)},[_c('p',{staticClass:"tolkitBullet",style:(_vm.colorBullet(indice.Status))},[_vm._v(_vm._s(_vm.textBullet(indice.Status)))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(indice.Descricao))])])])})],2)]):_vm._e()}),0),_vm._v(" "),(this.solicitacao.Empresa.Socios && this.solicitacao.Empresa.Socios.length > 0)?_c('div',{staticClass:"tab-pane fade",attrs:{"id":"nav-info","role":"tabpanel","aria-labelledby":"inf-socios-tab"}},[_c('section',{staticClass:"indices__socios"},[_c('div',{staticClass:"box"},[_c('h3',{staticClass:"box--title"},[_vm._v("Capital")]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('ul',{staticClass:"row no-gutters text-center"},[_c('li',{staticClass:"col-12 col-md-3"},[_c('strong',[_vm._v("Capital social:")]),_vm._v(" R$ "+_vm._s(_vm.capitalSocial))]),_vm._v(" "),_c('li',{staticClass:"col-12 col-md-3"},[_c('strong',[_vm._v("Realizado:")]),_vm._v(" R$ "+_vm._s(_vm.capitalRealizado))]),_vm._v(" "),_c('li',{staticClass:"col-12 col-md-3"},[_c('strong',[_vm._v("Controle:")]),_vm._v(" "+_vm._s(_vm.Controle))]),_vm._v(" "),_c('li',{staticClass:"col-12 col-md-3"},[_c('strong',[_vm._v("Natureza:")]),_vm._v(" "+_vm._s(_vm.Natureza))])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('h3',{staticClass:"box--title"},[_vm._v("Quadro social")]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"indices__socios-items"},_vm._l((this.solicitacao.Empresa.Socios),function(socio){return _c('div',{staticClass:"indices__socios--item"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12 col-md-5 col-lg-4 col-xl-3 text-md-right"},[_c('p',[_c('span',[_vm._v(_vm._s(socio.Nome))]),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(socio.TipoSocio)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-7 col-lg-8 col-xl-9"},[(socio.DataEntrada)?_c('p',[_c('strong',[_vm._v("Entrada:")]),_vm._v(" "+_vm._s(_vm.startDate(socio.DataEntrada)))]):_vm._e(),_vm._v(" "),_c('p',[_c('strong',[_vm._v("% Capital Total:")]),_vm._v(" "+_vm._s(socio.ParticipacaoCapital))]),_vm._v(" "),_vm._m(5,true),_c('div',{staticClass:"noBorder",domProps:{"innerHTML":_vm._s(socio.Observacao)}}),_vm._v(" "),_c('p')])])])}),0)])])]):_vm._e()])]):_c('no-data-profile',{attrs:{"Msg":this.showMeMsg}}),_vm._v(" "),_c('div',{staticClass:"myDiv"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"d-flex flex-row align-items-center"},[_c('div',{staticClass:"empresa"},[_c('h2',[_vm._v(_vm._s(_vm.nomeFantasia))]),_vm._v(" "),_c('span',[_vm._v("CNPJ: "+_vm._s(_vm.formattedCnpj))])]),_vm._v(" "),_c('div',{staticClass:"rating"},[_c('span',{staticClass:"circle score"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.score))])]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('label',[_vm._v("Valor solicitado")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.valor))])]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('label',[_vm._v("Duração esperada")]),_vm._v(" "),(this.solicitacao.PrazoDias > 0)?_c('p',[_vm._v(_vm._s(this.solicitacao.PrazoDias)+" dias")]):_c('p',[_vm._v(_vm._s(_vm.prazo)+" meses")])]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('label',[_vm._v("Retorno CDI")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.cdi)+"%")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex mob",staticStyle:{"padding-top":"5px","padding-bottom":"5px"}},[(!this.solicitacao.Encerrado)?_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"label"},[_vm._v("Encerra em:")]),_vm._v(" "),_c('div',{staticClass:"countdown"},[_c('countdown-custom',{attrs:{"end":_vm.finishedDate(this.solicitacao.FimCaptacao)}})],1)]):_vm._e(),_vm._v(" "),(!_vm.hasInvestor && !_vm.hasSuitability && !_vm.isInvestorApproved)?_c('div',{staticClass:"notFinished"},[_c('a',{staticClass:"btn alert-warning",attrs:{"href":"/#/informacoes-adicionais/investidor"}},[_vm._v("\n                    Complete seu cadastro\n                  ")])]):_vm._e(),_vm._v(" "),(this.solicitacao.Encerrado)?_c('div',{staticClass:"finished"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"disabled":"disabled"}},[_vm._v("Encerrado")])]):(_vm.hasInvestor && _vm.hasSuitability && _vm.isInvestorApproved && (_vm.investmentReservation == null || _vm.investmentReservation.Status == 0) && _vm.solicitacao.Valor > _vm.solicitacao.ValorCaptado && !this.solicitacao.ChamadaListaEspera)?_c('form',{staticClass:"d-flex align-itens-center",on:{"submit":function($event){$event.preventDefault();}}},[(this.solicitacao.InvestimentoMaximo <= 0)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investirMenu),expression:"investirMenu"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],attrs:{"type":"text","placeholder":_vm.InvestimentoMinimo},domProps:{"value":(_vm.investirMenu)},on:{"input":function($event){if($event.target.composing){ return; }_vm.investirMenu=$event.target.value}}}):_c('at-select',{staticClass:"upper--select",attrs:{"size":"large","placeholder":"Selecione"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((_vm.valuesModal),function(option){return _c('at-option',{key:option,attrs:{"value":option}},[_vm._v(_vm._s(option))])}),1),_vm._v(" "),(this.InvestidorBloqueado())?_c('button',{staticClass:"btn btn-danger",staticStyle:{"cursor":"not-allowed"},attrs:{"disabled":""}},[_vm._v("Bloqueado")]):_vm._e(),_vm._v(" "),(!this.InvestidorBloqueado())?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.submitInvestment();}}},[_vm._v("Investir")]):_vm._e()],1):_vm._e()])])])],1)])]):_vm._e()],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Empresa\n                    "),_c('span',[_vm._v("(Razão social)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Atrasos/restritivos\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"),_c('span',[_vm._v("(90 dias)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ul',{staticClass:"box_chart-legenda"},[_c('li',[_c('span',{staticClass:"color"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Ativo Circulante")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"color"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Ativo não Circulante")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"color"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Passivo Circulante")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"color"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Passivo não Circulante")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"color"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Patrimônio Líquido")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ul',{staticClass:"box_chart-legenda"},[_c('li',[_c('span',{staticClass:"color"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Ativo Circulante")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"color"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Ativo não Circulante")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"color"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Passivo Circulante")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"color"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Passivo não Circulante")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"color"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Patrimônio Líquido")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"3"}},[_c('p',[_c('strong',[_vm._v("Observações:")]),_vm._v(" Os valores demonstrados e calculados são baseados nas demonstrações contábeis fornecidas pelo solicitante do empréstimo, sendo essas demonstrações de responsabilidade dos sócios e do contador da empresa.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Observações:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8sjP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex app-wrapper"},[(_vm.showModal)?_c('modal',{staticClass:"modal-invited",on:{"close":function($event){_vm.showModal = false}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"tit float-left"},[_c('h2',[_c('i',{staticClass:"icon icon-airplane xl"}),_vm._v("\n            Enviar Convite\n          ")])])]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('section',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-3"},[_c('a',{staticClass:"btn btn-primary invited-company",attrs:{"href":"#"},on:{"click":function($event){_vm.modalStep = 2, _vm.activeButton('company'), _vm.auxModalStep = 2}}},[_vm._v("\n                Convidar empresa\n              ")])])]),_vm._v(" "),_c('section',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("\n                  Convite por email\n                ")]),_vm._v(" "),(_vm.modalStep === 1)?_c('friend',{on:{"finished":function($event){return _vm.finishInvite()}}}):(_vm.modalStep === 2)?_c('company',{on:{"finished":function($event){return _vm.finishInvite()}}}):(_vm.modalStep === 3)?_c('div',{staticClass:"success d-flex flex-column justify-content-center align-items-center"},[_c('i',{staticClass:"icon icon-success xll"}),_vm._v(" "),_c('h3',[_vm._v("\n                  Seu convite foi enviado com sucesso!\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":"javascript:;"},on:{"click":function($event){$event.preventDefault();_vm.modalStep = _vm.auxModalStep}}},[_vm._v("\n                  enviar novamente\n                ")])]):_vm._e()],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal modal__bootstrap fade",attrs:{"id":"modalMotivo","tabindex":"-1","role":"dialog","aria-labelledby":"modalMotivo","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal__bootstrap-body"},[_c('div',[_c('h2',[_vm._v("Ir para investimentos")]),_vm._v(" "),_c('img',{staticClass:"image",attrs:{"src":"/static/assets/images/tomador.svg","alt":""}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-secondary",attrs:{"data-dismiss":"modal","aria-label":"Close"}},[_vm._v("Continuar em empréstimo")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-lg btn-primary",attrs:{"to":"/investimentos/oportunidades","data-dismiss":"modal"}},[_vm._v("Ir para Investimentos "),_c('img',{attrs:{"src":"/static/assets/images/seta-modal.svg","width":"16"}})])],1)])])])]),_vm._v(" "),_c('SideMenu',{attrs:{"items":_vm.menuItems,"tipo":'emprestimos'}}),_vm._v(" "),_c('div',{staticClass:"bg"}),_vm._v(" "),_c('div',{staticClass:"wrapper d-flex flex-column"},[_c('header',{staticClass:"head row d-flex justify-content-between"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-12 col-md-6 col-lg-7 "},[_c('div',{staticClass:"d-flex justify-content-between util mob"},[_c('div',{staticClass:"mob-menu"},[_c('a',{staticClass:"btn",on:{"click":function($event){return _vm.ShowMobMenu(true);}}},[_c('i',{staticClass:"fas fa-bars"})])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"mob-profile"},[_c('alerts',{attrs:{"from":_vm.from,"tipoUsuario":"emprestimos"}}),_vm._v(" "),_c('div',{staticClass:"user"},[_c('at-dropdown',{attrs:{"placement":"bottom-right"}},[_c('router-link',{attrs:{"to":{ path: '/emprestimos/perfil/configuracoes' },"tag":"div"}},[_c('div',{staticClass:"no-image rounded-circle"},[_vm._v(_vm._s(_vm.LetraNome()))])])],1),_vm._v(" "),_c('div',{staticClass:"exit"},[_c('a',{attrs:{"href":"#","title":"Sair"},on:{"click":_vm.Logout}},[_c('i',{staticClass:"ico-exit"})])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end util"},[_c('alerts',{attrs:{"from":_vm.from,"tipoUsuario":"emprestimos"}}),_vm._v(" "),_c('div',{staticClass:"user"},[_c('at-dropdown',{attrs:{"placement":"bottom-right"}},[_c('div',{staticClass:"no-image rounded-circle"},[_vm._v(_vm._s(_vm.LetraNome()))]),_vm._v(" "),_c('span',[_vm._v("Olá, "),_c('strong',[_vm._v(_vm._s(_vm.Nome()))]),_vm._v(" "),_c('i',{staticClass:"icon icon-chevron-down"})]),_vm._v(" "),_c('at-dropdown-menu',{attrs:{"slot":"menu"},slot:"menu"},[_c('at-dropdown-item',[_c('router-link',{attrs:{"to":{ path: '/emprestimos/notificacoes' },"tag":"div"}},[_vm._v("Minhas Notificações")])],1),_vm._v(" "),_c('at-dropdown-item',[_c('router-link',{attrs:{"to":{ path: '/emprestimos/meus-emprestimos' },"tag":"div"}},[_vm._v("Meus Empréstimos")])],1),_vm._v(" "),_c('at-dropdown-item',[_c('router-link',{attrs:{"to":{ path: '/emprestimos/historico' },"tag":"div"}},[_vm._v("Meu Histórico")])],1),_vm._v(" "),_c('at-dropdown-item',{attrs:{"divided":""}},[_c('router-link',{attrs:{"to":{ path: '/emprestimos/perfil/dados-pessoais' },"tag":"div"}},[_vm._v("Meu perfil")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"exit"},[_c('a',{attrs:{"href":"#","title":"Sair"},on:{"click":_vm.Logout}},[_c('i',{staticClass:"ico-exit"}),_vm._v(" Sair")])])],1)])]),_vm._v(" "),_c('main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('footer',{staticClass:"d-flex justify-content-between"},[_c('div',[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"}),_vm._v(" "),_c('span',[_vm._v("V - "+_vm._s(_vm.version)+" © 2020 - IOUU. TODOS OS DIREITOS RESERVADOS.")])])]),_vm._v(" "),_c('social-network')],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal__bootstrap-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Você está prestes a ir para a área de "),_c('strong',[_vm._v("Investidores")]),_vm._v("."),_c('br'),_vm._v("A partir da área de investimentos não é possível solicitar empréstimo, nem acompanhar o processo de soliticação de empréstimo."),_c('br'),_vm._v("Tem certeza que deseja mudar de ambiente?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-12 col-md-6 col-lg-5 iouu"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})]),_vm._v(" "),_c('p',[_c('span',[_vm._v("Seja bem-vindo à plataforma IOUU")]),_vm._v("\n\n\n            Esse é seu dashboard. Aqui você poderá acompanhar o status\n            de sua soliticação de empréstimo, emitir seus boletos e ficar por dentro\n            das novidades da IOUU.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mob-logo"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8taH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Lottie_vue__ = __webpack_require__("uQpZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_animacoes_loading_iouu_json__ = __webpack_require__("YGw8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_animacoes_loading_iouu_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_animacoes_loading_iouu_json__);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'Lottie': __WEBPACK_IMPORTED_MODULE_0__Lottie_vue__["a" /* default */]
  },
  data: function data() {
    return {
      defaultOptions: { animationData: __WEBPACK_IMPORTED_MODULE_1__assets_animacoes_loading_iouu_json__ },
      animationSpeed: 10
    };
  },

  methods: {
    handleAnimation: function handleAnimation(anim) {
      this.anim = anim;
    }
  }
});

/***/ }),

/***/ "8xPM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmConstrucao_vue__ = __webpack_require__("ZQ8o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5cf1b68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmConstrucao_vue__ = __webpack_require__("0kls");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmConstrucao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5cf1b68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmConstrucao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "95hC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array_helper__ = __webpack_require__("rzJh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    loanRequest: {
      required: true
    },
    investmentConfirmed: {
      required: true,
      type: Boolean
    },
    sDisponivel: {
      required: true,
      type: Number
    },
    investimentValue: {
      required: true,
      type: String
    },
    AlterarValor: {
      required: true,
      type: Number
    }
  },
  data: function data() {
    return {
      values: [],
      selected: "",
      created: false,
      totalLiquidoIR: 0,
      totalRetornoBruto: 0,
      valorInvestimento: this.investimentValue,
      valorReinvestimento: undefined,
      valorParcela: 0,
      impostoRendaTotalFormatado: 0,
      retornoBrutoFormatado: 0,
      retornoLiquidoFormatado: 0,
      investment: {},
      showQueueForm: false,
      liberaFormValor: false,
      indiceShowForm: this.AlterarValor,
      carregado: false
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    var solicitacaoId = this.$route.params.id;

    __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getInvestmentReservation({
      loanRequestId: solicitacaoId
    }).then(function (investmentReservation) {
      _this.investment = investmentReservation;

      if (_this.investment != null) _this.valorInvestimento = _this.formatCurrency(_this.investment.Valor);

      var investVal = _this.investimentValue.replace(/[^\d]+/g, '');
      investVal = parseInt(investVal / 100);

      _this.sDisponivel > investVal ? _this.valorReinvestimento = _this.formatCurrency(investVal) : _this.valorReinvestimento = _this.formatCurrency(_this.sDisponivel);

      _this.AjustaTela();

      _this.CalculaInformacoesGerais();

      if (_this.sDisponivel <= 0 && _this.AlterarValor > 1) {
        _this.VerificaSaldo();
      }

      _this.carregado = true;
    }).catch(function (error) {
      console.log('error', error);
    });
  },
  created: function created() {
    if (!this.created) {
      this.values = [];
      var valorSelect = 0;
      var valorRestante = this.loanRequest.Valor - this.loanRequest.ValorCaptado;
      var quantidade = this.loanRequest.InvestimentoMaximo / this.loanRequest.InvestimentoMinimo;

      for (var i = 1; i <= quantidade && valorRestante > valorSelect; i++) {
        this.values.push("R$ " + (this.loanRequest.InvestimentoMinimo * i).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }));
        valorSelect = this.loanRequest.InvestimentoMinimo * i;
      }

      if (this.investmentConfirmed) {
        for (var _i = 1; _i <= quantidade; _i++) {
          this.values.push("R$ " + (this.loanRequest.InvestimentoMinimo * _i).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }));
        }
      }

      this.created = true;
    }
  },

  computed: {

    User: function User() {
      return this.$store.state.currentUser;
    },
    minPercentToQueue: function minPercentToQueue() {
      return this.$config.investment.minPercentToQueue;
    },
    valueToInvest: function valueToInvest() {
      if (this.investment) return this.formatCurrency(this.investment.Valor);

      return 0;
    },
    valueToInvestNaoFormatado: function valueToInvestNaoFormatado() {
      if (this.investment) return this.investment.Valor;

      return 0;
    },
    retornoBrutoMensal: function retornoBrutoMensal() {
      return this.loanRequest.RetornoBrutoMensal;
    },
    retornoBrutoAnual: function retornoBrutoAnual() {
      return this.loanRequest.RetornoBrutoAnual;
    },
    taxaInternaRetorno: function taxaInternaRetorno() {
      return this.loanRequest.TaxaInternaRetorno;
    },
    taxaTotalEfetiva: function taxaTotalEfetiva() {
      return this.loanRequest.TaxaTotalEfetiva;
    },
    prazo: function prazo() {
      return this.loanRequest.Prazo;
    },
    investmentId: function investmentId() {
      return this.investment ? this.investment._id : 0;
    },
    currentUser: function currentUser() {
      return this.$store.state.currentUser;
    },
    hasInvestor: function hasInvestor() {
      return this.currentUser.hasinvestor;
    },
    hasSuitability: function hasSuitability() {
      return this.currentUser.hassuitability;
    },
    isInvestorApproved: function isInvestorApproved() {
      return this.hasInvestor && this.currentUser.investor != null && this.currentUser.investor.Status == 'APROVADO';
    },
    canInvest: function canInvest() {
      return this.hasInvestor && this.hasSuitability && this.isInvestorApproved;
    },
    reachedValuePercentage: function reachedValuePercentage() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.loanRequest.ValorCaptado * 100 / this.loanRequest.Valor);
    },
    startedQueue: function startedQueue() {
      return this.reachedValuePercentage >= this.minPercentToQueue;
    },
    shouldShowQueueNotification: function shouldShowQueueNotification() {
      return this.startedQueue && !this.showQueueForm && !this.investmentConfirmed;
    },
    shouldShowReservationForm: function shouldShowReservationForm() {
      return !this.investmentConfirmed && (!this.startedQueue || this.showQueueForm);
    },
    investorSuitability: function investorSuitability() {
      return this.canInvest ? this.$store.state.currentUser.suitability.Tipo : null;
    },
    isSuitable: function isSuitable() {
      return this.loanRequest.PerfisAptos.includes(this.investorSuitability);
    },
    retornoBruto: function retornoBruto() {
      var interest = Math.pow(1 + this.taxaTotalEfetiva / 100, this.prazo) - 1;
      var interestValue = __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].unmaskMoney(this.valueToInvest) * interest;
      return __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].unmaskMoney(this.valueToInvest) + interestValue;
    },
    impostoRendaTotal: function impostoRendaTotal() {
      var years = Math.round(this.prazo / 12);
      var interest = Math.pow(1 + this.loanRequest.TaxaImpostoRenda / 100, years) - 1;
      var gainValue = this.retornoBruto - __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].unmaskMoney(this.valueToInvest);
      return gainValue * interest;
    }
  },
  methods: {
    TemLimitadorMaximoInvestimento: function TemLimitadorMaximoInvestimento(InvestimentoMaximo) {
      if (InvestimentoMaximo !== 0 && InvestimentoMaximo !== null && InvestimentoMaximo !== undefined) {
        return true;
      }
      return false;
    },
    MostrarRelatorio: function MostrarRelatorio() {

      if (document.getElementById("valor") !== undefined) {

        document.getElementById("valor").addEventListener("keyup", function () {
          if (!document.getElementsByClassName("at-collapse__item")[0].classList.contains('at-collapse__item--active')) {
            document.getElementsByClassName("at-collapse__item")[0].classList.add("at-collapse__item--active");
            document.getElementsByClassName("at-collapse__item")[0].classList.add("keyPress");
            document.getElementsByClassName("at-collapse__body")[0].removeAttribute("style");
          }
        });
      }

      // if(document.getElementsByClassName("at-collapse__header").length > 0 ){
      //       document.getElementsByClassName("at-collapse__header").addEventListener("click", () => {
      //         if(document.getElementsByClassName("at-collapse__item")[0].classList.contains('keyPress')) {
      //           document.getElementsByClassName("at-collapse__item")[0].classList.remove("keyPress");
      //           setTimeout(() => {
      //             console.log("setTime");
      //             document.getElementsByClassName("at-collapse__item")[0].classList.remove("at-collapse__item--active");
      //             document.getElementsByClassName("at-collapse__body")[0].setAttribute("style", "display: none;");
      //           }, 100);
      //         }
      //       })
      // }
    },
    CalculaInformacoesGerais: function CalculaInformacoesGerais() {

      var valor;
      if (document.getElementById("valor") == undefined) {
        valor = "0,00";
      } else {
        valor = document.getElementById("valor").value;
      }
      valor = valor.replace(/[^0-9]/g, "");
      valor = valor.substring(0, valor.length - 2) + "." + valor.substring(valor.length - 2);

      var novoValor = parseFloat(valor);
      this.valorParcela = -this.PMT(this.loanRequest.RetornoBrutoMensal / 100, this.prazo, novoValor);
      this.retornoBrutoFormatado = this.RetornoBruto(this.prazo, this.loanRequest.RetornoBrutoMensal / 100, novoValor);
      this.impostoRendaTotalFormatado = this.ImpostoRendaTotal(this.prazo, this.loanRequest.RetornoBrutoMensal / 100, novoValor);
      this.retornoLiquidoFormatado = this.RetornoTotalLiquido();
    },
    formatCurrencyInv: function formatCurrencyInv() {

      if (document.getElementById("valor") != undefined) {
        var valor = document.getElementById("valor").value;

        if (valor == "") valor = "0,00";
        valor = valor.replace(/[^0-9]/g, "");
        valor = valor.substring(0, valor.length - 2) + "." + valor.substring(valor.length - 2);

        var novoValor = parseFloat(valor);
        return novoValor.toLocaleString('pt-BR', {
          minimumFractionDigits: "2",
          maximumFractionDigits: 2
        });
      }

      return this.valorInvestimento;
    },
    InvestidorBloqueado: function InvestidorBloqueado() {

      if (this.currentUser.investor == null || this.currentUser.investor.Bloqueio == null || this.currentUser.investor.Bloqueio.FimBloqueio == null) return false;

      var FimBloqueio = new Date(this.currentUser.investor.Bloqueio.FimBloqueio);

      return FimBloqueio > new Date();
    },
    formatCurrency: function formatCurrency(value) {

      if (!isNaN(parseFloat(value)) && isFinite(value)) return value.toLocaleString('pt-BR', {
        minimumFractionDigits: "2",
        maximumFractionDigits: 2
      });else {
        value = 0;
      }
      return value.toLocaleString('pt-BR', {
        minimumFractionDigits: "2",
        maximumFractionDigits: 2
      });;
    },
    submit: function submit() {
      var value = this.valorReinvestimento;
      if (value.indexOf(',') == value.length - 2) {
        value = value.replace(/\D/g, '');
        value = value.substr(0, value.length - 2) + ',' + value.substr(value.length - 2, value.length);
      }
      var val = __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].unmaskMoney(this.valorInvestimento);
      var valReInv = __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].unmaskMoney(value);

      if (this.loanRequest.InvestimentoMinimo == 0) {
        this.loanRequest.InvestimentoMinimo = 500;
      }

      if (val < this.loanRequest.InvestimentoMinimo || val % this.loanRequest.InvestimentoMinimo != 0) {

        this.$Notify.error("Valor deve ser de pelo menos R$ " + this.formatCurrency(this.loanRequest.InvestimentoMinimo) + " e deve ser multiplo de R$ " + this.formatCurrency(this.loanRequest.InvestimentoMinimo));
      }

      if (val > this.loanRequest.InvestimentoMaximo && this.loanRequest.InvestimentoMaximo != null && this.loanRequest.InvestimentoMaximo != 0) {
        this.$Notify.error("Valor deve ser menor que R$ " + this.formatCurrency(this.loanRequest.InvestimentoMaximo));
      }

      if (valReInv > val) {
        valReInv = val;
      } else {
        this.$emit('submit', {
          _id: this.investment != null ? this.investment._id : null,
          Valor: val,
          ReInvestimento: valReInv
        });
        this.indiceShowForm = 3; //enviar para investimento realizado com sucesso
        this.liberaFormValor = false;
      }
    },
    ValidarInvestimento: function ValidarInvestimento() {

      var value = 0;
      if (this.selected != null && this.selected != "") {
        value = this.selected.trim().replace("R$", "");
        value = value.replace(".", "");
        this.valorInvestimento = value;
      }
      if (typeof this.valorInvestimento === 'string') {
        var inv = this.valorInvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
        value = parseFloat(inv / 100);
      }

      if (value == 0 || isNaN(value)) {
        this.$Notify.error({
          title: "Desculpe",
          message: "Por favor, insira um valor."
        });

        return false;
      }

      if (value < this.loanRequest.InvestimentoMinimo || isNaN(value)) {
        this.$Notify.error({
          title: "Desculpe",
          message: "O valor mínimo de aporte é de R$ " + this.formatCurrency(this.loanRequest.InvestimentoMinimo)
        });

        return false;
      }
      if (value > this.loanRequest.InvestimentoMaximo && this.loanRequest.InvestimentoMaximo !== 0 || isNaN(value)) {
        this.$Notify.error({
          title: "Desculpe",
          message: "O valor máximo de aporte é de R$ " + this.formatCurrency(this.loanRequest.InvestimentoMaximo)
        });

        return false;
      }

      if (value % this.loanRequest.InvestimentoMinimo != 0 || isNaN(value)) {
        this.$Notify.error({
          title: "Desculpe",
          message: "O valor deve ser multiplo de R$ " + this.formatCurrency(this.loanRequest.InvestimentoMinimo)
        });

        return false;
      }

      if (this.investment != null && this.investment.Valor > 0) {

        if (value > this.loanRequest.Valor) {
          this.$Notify.error({
            title: "Desculpe",
            message: "O valor de aporte é maior que o solicitado."
          });

          return false;
        }

        if (value > this.loanRequest.Valor - this.loanRequest.ValorCaptado + this.investment.Valor) {
          this.$Notify.error({
            title: "Desculpe",
            message: "O valor de aporte é maior que o disponível."
          });

          return false;
        }
      } else {

        if (value > this.loanRequest.Valor) {
          this.$Notify.error({
            title: "Desculpe",
            message: "O valor de aporte é maior que o solicitado."
          });

          return false;
        }

        if (this.loanRequest.Valor - this.loanRequest.ValorCaptado > 0 && value > this.loanRequest.Valor - this.loanRequest.ValorCaptado) {
          this.$Notify.error({
            title: "Desculpe",
            message: "O valor de aporte é maior que o disponível."
          });

          return false;
        }
      }

      return true;
    },
    VerificaSaldo: function VerificaSaldo() {
      if (!this.ValidarInvestimento()) {
        return false;
      }

      var value = 0;
      if (this.selected != null && this.selected != "") {
        value = this.selected.trim().replace("R$", "");
        value = value.replace(".", "");
        this.valorInvestimento = value;
      }
      if (typeof this.valorInvestimento === 'string') {
        var inv = this.valorInvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
        value = parseFloat(inv / 100);
      }

      if (this.sDisponivel > 0) {

        if (this.sDisponivel > value) {
          this.valorReinvestimento = this.formatCurrency(value || 0);
        } else {
          this.valorReinvestimento = this.formatCurrency(this.sDisponivel || 0);
        }

        this.indiceShowForm = 2;
        return true;
      }

      //console.log(this.investimentValue)

      //this.valorInvestimento = this.investimentValue;
      this.submit();
      return true;
    },
    NaoUsarSaldo: function NaoUsarSaldo() {

      //console.log(this.investimentValue)

      //this.valorInvestimento = this.investimentValue;
      this.valorReinvestimento = 0;
      this.submit();
      return false;
    },
    UsarSaldo: function UsarSaldo() {

      //console.log(this.investimentValue)

      //this.valorInvestimento = this.investimentValue;
      var valor = 0;

      if (typeof this.valorReinvestimento === 'string') {

        var reInv = this.valorReinvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
        valor = parseFloat(reInv / 100);
      }

      if (valor < 0) {

        var errorMessages = ["Insira um valor para o reinvestimento."];
        this.$Notify.error(__WEBPACK_IMPORTED_MODULE_3__utils_array_helper__["a" /* default */].toSentence(errorMessages));

        return false;
      }

      if (valor > this.sDisponivel) {

        var errorMessages = ["Saldo indisponível para o reinvestimento. Valor máximo: R$ " + this.formatCurrency(this.sDisponivel)];
        this.$Notify.error(__WEBPACK_IMPORTED_MODULE_3__utils_array_helper__["a" /* default */].toSentence(errorMessages));

        return false;
      }

      var val = __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].unmaskMoney(this.valorInvestimento);

      if (valor > val) {

        errorMessages = ["O valor deve ser menor ou igual ao investido : R$ " + this.formatCurrency(val)];
        this.$Notify.error(__WEBPACK_IMPORTED_MODULE_3__utils_array_helper__["a" /* default */].toSentence(errorMessages));

        return false;
      }

      this.submit();
      return false;
    },
    AjustaTela: function AjustaTela() {

      if (this.shouldShowQueueNotification) {
        this.indiceShowForm = 0; // mostra a lista de espera
      }

      if (this.investmentConfirmed) {
        console.log("index: ", this.AlterarValor);
        this.indiceShowForm = this.AlterarValor;
        this.recalcValues();
      }
    },
    FV: function FV(rate, periods, payment, value, type) {
      // Credits: algorithm inspired by Apache OpenOffice

      // Initialize type
      type = typeof type === 'undefined' ? 0 : type;

      // Evaluate rate (TODO: replace with secure expression evaluator)
      rate = eval(rate);

      // Return future value
      var result;
      if (rate === 0) {
        result = value + payment * periods;
      } else {
        var term = Math.pow(1 + rate, periods);
        if (type === 1) {
          result = value * term + payment * (1 + rate) * (term - 1.0) / rate;
        } else {
          result = value * term + payment * (term - 1) / rate;
        }
      }

      // result = Math.round(result * 100) / 100;

      return -result;
    },
    IPMT: function IPMT(rate, period, periods, present, future, type) {
      // Credits: algorithm inspired by Apache OpenOffice

      // Initialize type
      type = typeof type === 'undefined' ? 0 : type;

      // Initialize future
      future = typeof future === 'undefined' ? 0 : future;

      // Evaluate rate and periods (TODO: replace with secure expression evaluator)
      rate = eval(rate);
      periods = eval(periods);

      // Compute payment
      var payment = this.PMT(rate, periods, present, future, type);

      // Compute interest
      var interest;
      if (period === 1) {
        if (type === 1) {
          interest = 0;
        } else {
          interest = -present;
        }
      } else {
        if (type === 1) {
          interest = this.FV(rate, period - 2, payment, present, 1) - payment;
        } else {
          interest = this.FV(rate, period - 1, payment, present, 0);
        }
      }

      var result = interest * rate;
      // result = Math.round(result * 100) / 100;

      // Return interest
      return interest * rate;
    },
    PMT: function PMT(rate, periods, present, future, type) {
      // Credits: algorithm inspired by Apache OpenOffice

      // Initialize type
      type = typeof type === 'undefined' ? 0 : type;

      // Initialize future
      future = 0;

      // Evaluate rate (TODO: replace with secure expression evaluator)
      rate = eval(rate);

      // Return payment
      var result;
      if (rate === 0) {
        result = (present + future) / periods;
      } else {
        var term = Math.pow(1 + rate, periods);
        if (type === 1) {
          result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
        } else {
          result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
        }
      }

      // result = Math.round(result * 100) / 100;

      return -result;
    },
    ImpostoRendaTotal: function ImpostoRendaTotal(totalParcelas, taxa, totalInvestido) {
      var sum = 0;

      for (var periodo = 1; periodo <= totalParcelas; periodo++) {
        var aliqIR = 0;
        var IR = 0;
        var ipmt = -this.IPMT(taxa, periodo, totalParcelas, totalInvestido);

        ipmt = Math.round(ipmt * 100) / 100;

        if (periodo >= 1 && periodo < 6) aliqIR = 0.225;else if (periodo >= 6 && periodo < 12) aliqIR = 0.2;else if (periodo >= 12 && periodo < 24) aliqIR = 0.175;else aliqIR = 0.15;

        IR = ipmt * aliqIR;
        IR = Math.round(IR * 100) / 100;

        sum += IR;
      }

      this.totalLiquidoIR = sum;

      return sum;
    },
    RetornoTotalLiquido: function RetornoTotalLiquido() {
      return this.totalRetornoBruto - this.totalLiquidoIR;
    },
    RetornoBruto: function RetornoBruto(parcelas) {
      this.totalRetornoBruto = parcelas * this.valorParcela;

      return this.totalRetornoBruto;
    },
    Nome: function Nome() {
      var nome = "",
          letra = "";
      if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
        nome = this.User.username;
      } else {
        nome = this.User.name;
      }
      nome = nome.trim();
      var primeiroNome = nome.split(" ")[0];
      return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
    },
    recalcValues: function recalcValues() {
      this.values = [];
      var quantidade = this.loanRequest.InvestimentoMaximo / this.loanRequest.InvestimentoMinimo;
      for (var i = 1; i <= quantidade; i++) {
        this.values.push("R$ " + (this.loanRequest.InvestimentoMinimo * i).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }));
      }
    }
  }
});

/***/ }),

/***/ "96/U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      optionsNacionality: [{ value: 1, label: "Brasileira" }, { value: 2, label: "Estrangeira" }]
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = { Pessoal: this.currentUser.Pessoal };
      this.$emit('on-submit', newData);
    }
  },
  mounted: function mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");
  }
});

/***/ }),

/***/ "96tf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_session_manager__ = __webpack_require__("J7hJ");



var _this = this;




var AxiosAuthGet = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(uri) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
                            method: 'GET',
                            url: uri,
                            headers: {
                                Authorization: "Bearer " + __WEBPACK_IMPORTED_MODULE_3__utils_session_manager__["a" /* default */].getAuthToken()
                            }
                        });

                    case 3:
                        return _context.abrupt("return", _context.sent);

                    case 6:
                        _context.prev = 6;
                        _context.t0 = _context["catch"](0);
                        return _context.abrupt("return", _context.t0);

                    case 9:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee, _this, [[0, 6]]);
    }));

    return function AxiosAuthGet(_x) {
        return _ref.apply(this, arguments);
    };
}();

var AxiosAuthPost = function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(uri, data) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.prev = 0;
                        _context2.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
                            method: 'POST',
                            url: uri,
                            data: data,
                            headers: {
                                Authorization: "Bearer " + __WEBPACK_IMPORTED_MODULE_3__utils_session_manager__["a" /* default */].getAuthToken()
                            }
                        });

                    case 3:
                        return _context2.abrupt("return", _context2.sent);

                    case 6:
                        _context2.prev = 6;
                        _context2.t0 = _context2["catch"](0);
                        return _context2.abrupt("return", _context2.t0);

                    case 9:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2, _this, [[0, 6]]);
    }));

    return function AxiosAuthPost(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();

var AxiosAuthPut = function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(uri, data) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
                            method: 'PUT',
                            url: uri,
                            data: data,
                            headers: {
                                Authorization: "Bearer " + __WEBPACK_IMPORTED_MODULE_3__utils_session_manager__["a" /* default */].getAuthToken()
                            }
                        });

                    case 2:
                        return _context3.abrupt("return", _context3.sent);

                    case 3:
                    case "end":
                        return _context3.stop();
                }
            }
        }, _callee3, _this);
    }));

    return function AxiosAuthPut(_x4, _x5) {
        return _ref3.apply(this, arguments);
    };
}();

var AxiosAuthDelete = function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(uri, data) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
                            method: 'DELETE',
                            url: uri,
                            data: data,
                            headers: {
                                Authorization: "Bearer " + __WEBPACK_IMPORTED_MODULE_3__utils_session_manager__["a" /* default */].getAuthToken()
                            }
                        });

                    case 2:
                        return _context4.abrupt("return", _context4.sent);

                    case 3:
                    case "end":
                        return _context4.stop();
                }
            }
        }, _callee4, _this);
    }));

    return function AxiosAuthDelete(_x6, _x7) {
        return _ref4.apply(this, arguments);
    };
}();

/* harmony default export */ __webpack_exports__["a"] = ({ AxiosAuthGet: AxiosAuthGet, AxiosAuthPost: AxiosAuthPost, AxiosAuthPut: AxiosAuthPut, AxiosAuthDelete: AxiosAuthDelete });

/***/ }),

/***/ "98U6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "9CDi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PasswordField__ = __webpack_require__("i7i+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client_js__ = __webpack_require__("pk4i");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            cdi: '384,07%',
            name: '',
            email: '',
            password: '',
            enabled: false,
            visivel: false,
            EmailConfirmado: true,
            msg: ''
        };
    },

    components: {
        PasswordField: __WEBPACK_IMPORTED_MODULE_2__components_PasswordField__["a" /* default */]
    },
    metaInfo: {
        title: 'Seja um investidor IOUU'
    },
    methods: {
        validateName: function validateName() {
            if (this.name[0] == " ") {
                this.name = "";
                return;
            }

            var splitText = this.name.split(' ');
            var upperCaseText = '';

            for (var i = 0; i < splitText.length; i++) {
                if (splitText[i] != "") {
                    if (i > 0) upperCaseText += " ";

                    upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
                } else if (i > 0) upperCaseText += " ";
            }

            this.name = upperCaseText;
        },

        ValidarEmail: function ValidarEmail() {
            var _this = this;

            this.EmailConfirmado = true;
            this.msg = "";
            //Chama API que faz a Pré Validação do Email para verificar se a ortografia esta correta
            if (this.email != "") {
                __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client_js__["a" /* default */].PreValidacaoEmail(this.email).then(function (resposta) {

                    //Sintaxe do Email Inválida
                    if (resposta.Msg == "Email Inválido") {
                        _this.EmailConfirmado = false;
                        _this.msg = "Digite um email válido!";
                    }

                    //Sintaxe do Email Correta
                    else {
                            //Chama API que verifica se este usuário já está cadastrado
                            __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client_js__["a" /* default */].ExisteUsuario(_this.email).then(function (resposta) {
                                if (resposta.Msg == "Existe") {
                                    _this.EmailConfirmado = false;
                                    _this.msg = "Esse email já foi cadastrado no sistema!";
                                } else {
                                    //Chamar API que faz a validação do Email
                                    __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client_js__["a" /* default */].theCheckerPost(_this.email).then(function (resposta) {

                                        if (resposta == "Entregável") {
                                            //Executa se o email for válido
                                            _this.EmailConfirmado = true;
                                            _this.msg = "Email Validado com Sucesso!";
                                        }

                                        if (resposta == "Inválido") {
                                            //Executa se o email for inválido
                                            _this.EmailConfirmado = false;
                                            _this.msg = "Email Inválido!";
                                        }
                                    }).catch(function () {
                                        _this.EmailConfirmado = true;
                                        _this.msg = "Email Validado com Sucesso!";
                                    }); //Fim Validação TheChecker
                                }
                            }).catch(function () {
                                _this.EmailConfirmado = true;
                                _this.msg = "Email Validado com Sucesso!";
                            }); //Fim Existe Usuário
                        }
                }).catch(function () {
                    _this.EmailConfirmado = true;
                    _this.msg = "Email Validado com Sucesso!";
                }); //Fim Validação Email
            }
        },
        signUp: function signUp() {
            var _this2 = this;

            this.$store.dispatch('signup', { name: this.name, email: this.email, password: this.password }).then(function () {
                _this2.$router.push("/cadastro-concluido-com-sucesso");
            }).catch(function (error) {
                var errorMessages = error.response.data.errors.map(function (error) {
                    return error.detail;
                });
                alert(errorMessages);
            });

            // CADASTRA CONTATO EM ACTIVE CAMPAIN
            __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client_js__["a" /* default */].CadastrarActive(this.email);
        },


        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/landing-page/invista-com-alta-rentabilidade/ ',
                title: 'Invista com alta rentabilidade'
            });
        }
    },
    created: function created() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (_this3.$route.query.name) _this3.name = _this3.$route.query.name;

                            if (_this3.$route.query.email) _this3.email = _this3.$route.query.email;

                            if (_this3.$route.query.v) _this3.visivel = true;

                            //tagueamento GA
                            _context.next = 5;
                            return _this3.taggingGA();

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this3);
        }))();
    }
});

/***/ }),

/***/ "9IsA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoricProfile_vue__ = __webpack_require__("Ci7f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcbfa3aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoricProfile_vue__ = __webpack_require__("UQZc");
function injectStyle (ssrContext) {
  __webpack_require__("C0U1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bcbfa3aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoricProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcbfa3aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoricProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9Kqi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPageInvistaIouu_vue__ = __webpack_require__("CNYh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60758d80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPageInvistaIouu_vue__ = __webpack_require__("qOVB");
function injectStyle (ssrContext) {
  __webpack_require__("5AFV")
  __webpack_require__("syAn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60758d80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPageInvistaIouu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60758d80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPageInvistaIouu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9OQo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9QUb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_map__ = __webpack_require__("nSPF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FileInput__ = __webpack_require__("TxlB");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FileInput: __WEBPACK_IMPORTED_MODULE_1__components_FileInput__["a" /* default */] },
  props: {
    files: { required: true, type: Array },
    accept: { required: true, type: String },
    uploadEndpoint: { required: true, type: String }
  },
  computed: {
    currentFiles: function currentFiles() {
      return this.files.length > 0 ? this.files : [null];
    }
  },
  methods: {
    addFile: function addFile(e) {
      e.preventDefault();
      this.$emit('files-changed', this.currentFiles.concat(null));
    },
    removeFile: function removeFile(index) {
      this.$emit('files-changed', this.currentFiles.filter(function (file, i) {
        return i != index;
      }));
    },
    clearFile: function clearFile(index) {
      var updatedFiles = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_map___default()(this.currentFiles, function (file, i) {
        return i != index ? file : null;
      });
      this.$emit('files-changed', updatedFiles);
    },
    onUploaded: function onUploaded(uploadedFile, index, response) {
      var updatedFiles = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_map___default()(this.currentFiles, function (file, i) {
        return i != index ? file : uploadedFile;
      });
      this.$emit('files-changed', updatedFiles, { uploadResponse: response });
    }
  }
});

/***/ }),

/***/ "9SNY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9cDm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    submitWithCorporateGroup: function submitWithCorporateGroup() {
      this.$emit('on-submit', { Empresa: { SociosTemFinanciamento: true } });
    },
    submitWithoutCorporateGroup: function submitWithoutCorporateGroup() {
      this.$emit('on-submit', { Empresa: { SociosTemFinanciamento: false } });
    }
  }
});

/***/ }),

/***/ "9inP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9jnU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"image"},[_c('img',{staticClass:"imagem",attrs:{"src":__webpack_require__("QLn5"),"alt":"imagem login"}}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":__webpack_require__("98U6"),"alt":"icone"}}),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',{staticClass:"txt"},[_vm._v(_vm._s(_vm.titleBox))]),_vm._v(" "),_c('p',{staticClass:"txt"},[_vm._v(_vm._s(_vm.subtitleBox))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.txtBox))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"logo",attrs:{"href":"https://iouu.com.br","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("xhIC"),"alt":"logo IOUU"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9otY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('focus', {
  inserted: function inserted(el) {
    el.focus();
  }
});

/***/ }),

/***/ "9ryf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInformationSocial_vue__ = __webpack_require__("MC8o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fae67a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInformationSocial_vue__ = __webpack_require__("S4Dl");
function injectStyle (ssrContext) {
  __webpack_require__("U7Yf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fae67a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInformationSocial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fae67a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInformationSocial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9vKK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderPage)?_c('main',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 espera text-center"},[_c('h1',[_vm._v(_vm._s(_vm.nome)+", aguarde...")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("Estamos analisando a sua solicitação")]),_vm._v(" "),_c('p',[_vm._v("Em breve você saberá se pode tomar um empréstimo através da IOUU.")])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg"},[_c('div',{staticClass:"relogio"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9xri":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',[_vm._v("CEP")]),_vm._v(" "),_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.currentUser.Pessoal.Endereco.Cep),expression:"currentUser.Pessoal.Endereco.Cep"},{name:"mask",rawName:"v-mask",value:('zipcode'),expression:"'zipcode'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":"","pattern":"\\d{5}-?\\d{3}","placeholder":"_____-___","title":"_____-___"},domProps:{"value":(_vm.currentUser.Pessoal.Endereco.Cep)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentUser.Pessoal.Endereco, "Cep", $event.target.value)}}})]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("CEP")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A+FD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInformationPersonalLoan_vue__ = __webpack_require__("4XQ/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_488c32da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInformationPersonalLoan_vue__ = __webpack_require__("Ppvw");
function injectStyle (ssrContext) {
  __webpack_require__("QiR8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-488c32da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInformationPersonalLoan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_488c32da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInformationPersonalLoan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A0NO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Comprovante de Renda")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Extrato Bancário")]),_vm._v(" dos últimos 4 meses")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A1Xl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacoesPjRedesSociaisStep_vue__ = __webpack_require__("4Anj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1538f02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacoesPjRedesSociaisStep_vue__ = __webpack_require__("xIqt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacoesPjRedesSociaisStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1538f02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacoesPjRedesSociaisStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A9uG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/estatisticas/estatisticas-da-plataforma',
                title: 'Estatisticas da plataforma'
            });
        }
    },
    beforeCreate: function beforeCreate() {
        this.$store.dispatch('updateUser');
    },
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (_this.$store.state.currentUser.investor != null) {
                                if (typeof _this.$store.state.currentUser.investor.Bloqueio != 'undefined') window.location.href = "#/";
                            }
                            //tagueamento GA
                            _context.next = 3;
                            return _this.taggingGA();

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ "ABW/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CCBProfile_vue__ = __webpack_require__("CN8O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_713c4bec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CCBProfile_vue__ = __webpack_require__("i2jq");
function injectStyle (ssrContext) {
  __webpack_require__("Navj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-713c4bec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CCBProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_713c4bec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CCBProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AD6r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationScreenBanner_vue__ = __webpack_require__("UsP9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04806deb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationScreenBanner_vue__ = __webpack_require__("9jnU");
function injectStyle (ssrContext) {
  __webpack_require__("ZxHV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04806deb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationScreenBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04806deb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationScreenBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AEKb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AFB7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AJ+A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ALTj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AgAG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("96tf");



var _this = this;



var BASE_URI_GO_API = "https://pay.iouu.com.br" + '/api/v1';

var CreateBoleto = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(IDReserva) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthPost(BASE_URI_GO_API + '/ABC/investidor/criar', { IDReserva: IDReserva });

          case 2:
            return _context.abrupt('return', _context.sent);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function CreateBoleto(_x) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({ CreateBoleto: CreateBoleto });

/***/ }),

/***/ "AoJG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NomeCompletoStep_vue__ = __webpack_require__("c6zp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b149e9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NomeCompletoStep_vue__ = __webpack_require__("/Fak");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NomeCompletoStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b149e9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NomeCompletoStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Awsi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_client_go__ = __webpack_require__("879M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_BarChartInvestimentos__ = __webpack_require__("Levr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { BarChart: __WEBPACK_IMPORTED_MODULE_5__components_charts_BarChartInvestimentos__["a" /* default */] },
    data: function data() {
        return {
            Estatisticas: null,
            User: null,
            valor: "por valores",
            Criou: false,
            RegiaoZoom: "",
            ClickZoom: false,
            Renderizou: false
        };
    },

    methods: {
        money: function money(n) {
            var c = 2,
                d = ",",
                t = ".",
                s = n < 0 ? "-" : "",
                i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        },
        porcentagem: function porcentagem(n) {
            var c = 1,
                d = ",",
                t = ".",
                s = n < 0 ? "-" : "",
                i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        },
        Atualizacao: function Atualizacao(data) {

            var Data = void 0;
            var Ano = void 0;
            var Mes = void 0;
            var Dia = void 0;

            var meses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

            Data = data.split("-");
            Ano = Data[0];
            Mes = parseInt(Data[1]);
            Dia = Data[2].split("T");

            return Dia[0] + " de " + meses[Mes - 1] + " de " + Ano;
        },
        DensidadeInvestidores: function DensidadeInvestidores(Regiao) {

            if (Regiao == "norte") {

                if (this.Estatisticas.InvestidoresRegiao[0] >= 0 && this.Estatisticas.InvestidoresRegiao[0] <= 100) {
                    return "item-01";
                } else if (this.Estatisticas.InvestidoresRegiao[0] >= 101 && this.Estatisticas.InvestidoresRegiao[0] <= 250) {
                    return "item-02";
                } else if (this.Estatisticas.InvestidoresRegiao[0] >= 251 && this.Estatisticas.InvestidoresRegiao[0] <= 500) {
                    return "item-03";
                } else if (this.Estatisticas.InvestidoresRegiao[0] >= 501 && this.Estatisticas.InvestidoresRegiao[0] <= 1000) {
                    return "item-04";
                } else {
                    return "item-05";
                }
            } else if (Regiao == "nordeste") {

                if (this.Estatisticas.InvestidoresRegiao[1] >= 0 && this.Estatisticas.InvestidoresRegiao[1] <= 100) {
                    return "item-01";
                } else if (this.Estatisticas.InvestidoresRegiao[1] >= 101 && this.Estatisticas.InvestidoresRegiao[1] <= 250) {
                    return "item-02";
                } else if (this.Estatisticas.InvestidoresRegiao[1] >= 251 && this.Estatisticas.InvestidoresRegiao[1] <= 500) {
                    return "item-03";
                } else if (this.Estatisticas.InvestidoresRegiao[1] >= 501 && this.Estatisticas.InvestidoresRegiao[1] <= 1000) {
                    return "item-04";
                } else {
                    return "item-05";
                }
            } else if (Regiao == "centro-oeste") {

                if (this.Estatisticas.InvestidoresRegiao[2] >= 0 && this.Estatisticas.InvestidoresRegiao[2] <= 100) {
                    return "item-01";
                } else if (this.Estatisticas.InvestidoresRegiao[2] >= 101 && this.Estatisticas.InvestidoresRegiao[2] <= 250) {
                    return "item-02";
                } else if (this.Estatisticas.InvestidoresRegiao[2] >= 251 && this.Estatisticas.InvestidoresRegiao[2] <= 500) {
                    return "item-03";
                } else if (this.Estatisticas.InvestidoresRegiao[2] >= 501 && this.Estatisticas.InvestidoresRegiao[2] <= 1000) {
                    return "item-04";
                } else {
                    return "item-05";
                }
            } else if (Regiao == "sudeste") {

                if (this.Estatisticas.InvestidoresRegiao[3] >= 0 && this.Estatisticas.InvestidoresRegiao[3] <= 100) {
                    return "item-01";
                } else if (this.Estatisticas.InvestidoresRegiao[3] >= 101 && this.Estatisticas.InvestidoresRegiao[3] <= 250) {
                    return "item-02";
                } else if (this.Estatisticas.InvestidoresRegiao[3] >= 251 && this.Estatisticas.InvestidoresRegiao[3] <= 500) {
                    return "item-03";
                } else if (this.Estatisticas.InvestidoresRegiao[3] >= 501 && this.Estatisticas.InvestidoresRegiao[3] <= 1000) {
                    return "item-04";
                } else {
                    return "item-05";
                }
            } else {

                if (this.Estatisticas.InvestidoresRegiao[4] >= 0 && this.Estatisticas.InvestidoresRegiao[4] <= 100) {
                    return "item-01";
                } else if (this.Estatisticas.InvestidoresRegiao[4] >= 101 && this.Estatisticas.InvestidoresRegiao[4] <= 250) {
                    return "item-02";
                } else if (this.Estatisticas.InvestidoresRegiao[4] >= 251 && this.Estatisticas.InvestidoresRegiao[4] <= 500) {
                    return "item-03";
                } else if (this.Estatisticas.InvestidoresRegiao[4] >= 501 && this.Estatisticas.InvestidoresRegiao[4] <= 1000) {
                    return "item-04";
                } else {
                    return "item-05";
                }
            }
        },
        DensidadeInvestidoresEstado: function DensidadeInvestidoresEstado(Estado) {
            var densidade = 0;
            var estados = ["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO"];

            densidade = this.Estatisticas.InvestidoresEstado[estados.indexOf(Estado)];

            if (densidade >= 0 && densidade <= 100) {
                return "item-01";
            } else if (densidade >= 101 && densidade <= 250) {
                return "item-02";
            } else if (densidade >= 251 && densidade <= 500) {
                return "item-03";
            } else if (densidade >= 501 && densidade <= 1000) {
                return "item-04";
            } else if (densidade >= 1001 && densidade <= 5000) {
                return "item-05";
            }
        },
        CriaGrafico: function CriaGrafico() {

            //Gráfico Por Gênero
            new Chart(document.getElementById("GraficoGenero"), {
                type: 'doughnut',
                data: {
                    labels: ["Masculino", "Feminino"],
                    datasets: [{
                        label: ["Teste"],
                        backgroundColor: ["#F53A33", "#3B0030"],
                        data: [this.Estatisticas.PorcentagemHomens, this.Estatisticas.PorcentagemMulheres],
                        borderWidth: [0, 0]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function label(tooltipItems, data) {
                                return (data.labels[tooltipItems.index] + ' - ' + data.datasets[0].data[tooltipItems.index].toLocaleString('pt-BR', { minimumFractionDigits: "1", maximumFractionDigits: 1, style: 'currency', currency: 'BRL' }) + " %").replace("R$", "");
                            }
                        }
                    },
                    responsive: true,
                    legend: {
                        position: "bottom",
                        display: false,
                        labels: {
                            padding: 30
                        }
                    },
                    cutoutPercentage: 55
                }
            });

            //Gráfico por Faixa de Idade
            new Chart(document.getElementById("GraficoIdade"), {
                type: 'doughnut',
                data: {
                    labels: ["18-24", "25-34", "35-49", "50-64", "65+"],
                    datasets: [{
                        label: ["Teste"],
                        backgroundColor: ["#FEDD55", "#FF9130", "#F53A33", "#3B0030", "#128C87"],
                        data: [this.Estatisticas.PorcentagemIdade[0], this.Estatisticas.PorcentagemIdade[1], this.Estatisticas.PorcentagemIdade[2], this.Estatisticas.PorcentagemIdade[3], this.Estatisticas.PorcentagemIdade[4]],
                        borderWidth: [0, 0, 0, 0, 0]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function label(tooltipItems, data) {
                                return (data.labels[tooltipItems.index] + ' - ' + data.datasets[0].data[tooltipItems.index].toLocaleString('pt-BR', { minimumFractionDigits: "1", maximumFractionDigits: 1, style: 'currency', currency: 'BRL' }) + " %").replace("R$", "");
                            }
                        }
                    },
                    responsive: true,
                    legend: {
                        position: "bottom",
                        display: false,
                        labels: {
                            padding: 30
                        }
                    },
                    cutoutPercentage: 55
                }
            });

            //Gráfico por Tipo de investidor
            new Chart(document.getElementById("GraficoTipoInvestidor"), {
                type: 'doughnut',
                data: {
                    labels: ["Investidores individuais", "Investidores institucionais"],
                    datasets: [{
                        label: ["Teste"],
                        backgroundColor: ["#3B0030", "#F53A33"],
                        data: [this.Estatisticas.PorcentagemInvestidoresIndividuais, this.Estatisticas.PorcentagemInvestidoresInstitucionais],
                        borderWidth: [0, 0]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function label(tooltipItems, data) {
                                return (data.labels[tooltipItems.index] + ' - ' + data.datasets[0].data[tooltipItems.index].toLocaleString('pt-BR', { minimumFractionDigits: "1", maximumFractionDigits: 1, style: 'currency', currency: 'BRL' }) + " %").replace("R$", "");
                            }
                        }
                    },
                    responsive: true,
                    legend: {
                        position: "bottom",
                        display: false,
                        labels: {
                            padding: 30
                        }
                    },
                    cutoutPercentage: 55
                }
            });

            //Gráfico de Investimentos por Reinvestimentos
            new Chart(document.getElementById("GraficoReinvestimento"), {
                type: "bar",
                data: {
                    labels: [],
                    datasets: [{
                        label: "Investimentos",
                        backgroundColor: ["#323271"],
                        data: [this.Estatisticas.TotalInvestimentos]
                    }, {
                        label: "ReInvestimento",
                        backgroundColor: ["#41D3BD"],
                        data: [this.Estatisticas.TotalReinvestimentos]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function label(tooltipItems, data) {

                                return data.datasets[tooltipItems.datasetIndex].label + ' - R$ ' + tooltipItems.yLabel.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
                            }
                        }
                    },
                    legend: {
                        display: true,
                        position: "bottom",
                        labels: {
                            padding: 25
                        }
                    },
                    title: {
                        display: false,
                        text: 'Investimentos'
                    },
                    responsive: true,
                    scales: {
                        xAxes: [{
                            gridLines: {
                                display: false
                            },
                            barPercentage: 1,
                            categoryPercentage: 0.3
                        }],
                        yAxes: [{
                            gridLines: {
                                display: true
                            },
                            ticks: {
                                beginAtZero: true,
                                callback: function callback(label, index, labels) {
                                    if (label == '0') {
                                        return '0';
                                    }
                                    return 'R$ ' + label.toLocaleString('pt-BR', { minimumFractionDigits: "0", maximumFractionDigits: 2 });
                                }
                            }
                        }]
                    }
                }
            });

            //Gráfico por tipo de investimento
            new Chart(document.getElementById("GraficoInvestimentoTipo"), {
                type: 'doughnut',
                data: {
                    labels: ["Empréstimo Coletivo", "Empréstimo de Impacto", "Empréstimo Social"],
                    datasets: [{
                        backgroundColor: ["#BF112E", "#02173E", "#13A399"],
                        data: [this.Estatisticas.InvestimentosTipoValores[0], this.Estatisticas.InvestimentosTipoValores[1], this.Estatisticas.InvestimentosTipoValores[2]],
                        borderWidth: [0, 0, 0]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function label(tooltipItems, data) {
                                return data.labels[tooltipItems.index] + ' - ' + data.datasets[0].data[tooltipItems.index].toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2, style: 'currency', currency: 'BRL' });
                            }
                        }
                    },
                    responsive: true,
                    legend: {
                        position: "bottom"
                        // labels:{
                        //     padding: 30
                        // }
                    },
                    cutoutPercentage: 55
                }
            });

            //Gráfico por Score
            new Chart(document.getElementById("GraficoInvestimentoScore"), {
                type: 'doughnut',
                data: {
                    labels: ["AA", "A", "B", "C", "D", "E", "HR", "Social"],
                    datasets: [{
                        backgroundColor: ["#C1CF2E", "#2DC2BF", "#6FC30D", "#F04887", "#FFB928", "#FD615D", "#B61843", "#52B3D9"],
                        data: [this.Estatisticas.InvestimentosScoreValores[0], this.Estatisticas.InvestimentosScoreValores[1], this.Estatisticas.InvestimentosScoreValores[2], this.Estatisticas.InvestimentosScoreValores[3], this.Estatisticas.InvestimentosScoreValores[4], this.Estatisticas.InvestimentosScoreValores[5], this.Estatisticas.InvestimentosScoreValores[6], this.Estatisticas.InvestimentosScoreValores[7]],
                        borderWidth: [0, 0, 0, 0, 0, 0, 0, 0]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function label(tooltipItems, data) {
                                return data.labels[tooltipItems.index] + ' - ' + data.datasets[0].data[tooltipItems.index].toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2, style: 'currency', currency: 'BRL' });
                            }
                        }
                    },
                    responsive: true,
                    legend: {
                        position: "bottom"
                        // labels:{
                        //     padding: 30
                        // }
                    },
                    cutoutPercentage: 55
                }
            });

            //Gráfico por Total Investimentos
            new Chart(document.getElementById("GraficoTotalInvestimentos"), {
                type: 'doughnut',
                data: {
                    labels: ["Atual", "Período de Carência", "1-15 dias de atraso", "16-30 dias de atraso", "31-60 dias de atraso", "+60 dias de atraso"],
                    datasets: [{
                        backgroundColor: ["#C1CF2E", "#2DC2BF", "#6FC30E", "#F04887", "#FFB928", "#FD615D", "#B61843", "#52B3D9"],
                        data: [this.Estatisticas.InvestimentosPeriodoValores[0], this.Estatisticas.InvestimentosPeriodoValores[1], this.Estatisticas.InvestimentosPeriodoValores[2], this.Estatisticas.InvestimentosPeriodoValores[3], this.Estatisticas.InvestimentosPeriodoValores[4], this.Estatisticas.InvestimentosPeriodoValores[5]],
                        borderWidth: [0, 0, 0, 0, 0, 0, 0, 0]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function label(tooltipItems, data) {
                                return data.labels[tooltipItems.index] + ' - ' + data.datasets[0].data[tooltipItems.index].toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2, style: 'currency', currency: 'BRL' });
                            }
                        }
                    },
                    responsive: true,
                    legend: {
                        position: "bottom"
                        // labels:{
                        //     padding: 30
                        // }
                    },
                    cutoutPercentage: 55
                }
            });
        },
        MostraGraficos: function MostraGraficos() {
            $("#GraficoInvestimentoTipo").removeAttr("hidden");
            $("#GraficoInvestimentoScore").removeAttr("hidden");
            $("#GraficoTotalInvestimentos").removeAttr("hidden");

            $("#ListaTipos").hide();
            $("#ListaScores").hide();
            $("#ListaPeriodos").hide();
        },
        EscondeGraficos: function EscondeGraficos() {
            $("#GraficoInvestimentoTipo").attr("hidden", "hidden");
            $("#GraficoInvestimentoScore").attr("hidden", "hidden");
            $("#GraficoTotalInvestimentos").attr("hidden", "hidden");

            $("#ListaTipos").show();
            $("#ListaScores").show();
            $("#ListaPeriodos").show();
        },
        MostraInvestidores: function MostraInvestidores(regiao) {
            $(".QuantidadeInvestidores" + regiao).fadeIn(150);
        },
        EscondeInvestidores: function EscondeInvestidores(regiao) {
            $(".QuantidadeInvestidores" + regiao).fadeOut(150);
        },
        Zoom: function Zoom(regiao) {

            if (!this.ClickZoom) {
                this.ClickZoom = true;
                this.RegiaoZoom = regiao;

                if (regiao == "norte") {
                    $("#sudeste").removeClass("sudeste").fadeOut(500);
                    $("#nordeste").removeClass("nordeste").fadeOut(500);
                    $("#centro-oeste").removeClass("centro-oeste").fadeOut(500);
                    $("#sul").removeClass("sul").fadeOut(500);

                    $("#norte").removeClass("norte").addClass("norte-grande");
                    $("#ac").fadeIn(500);
                    $("#ac").removeClass("ac-pequeno").addClass("ac-grande");
                    $("#am").fadeIn(500);
                    $("#am").removeClass("am-pequeno").addClass("am-grande");
                    $("#ro").fadeIn(500);
                    $("#ro").removeClass("ro-pequeno").addClass("ro-grande");
                    $("#rr").fadeIn(500);
                    $("#rr").removeClass("rr-pequeno").addClass("rr-grande");
                    $("#pa").fadeIn(500);
                    $("#pa").removeClass("pa-pequeno").addClass("pa-grande");
                    $("#ap").fadeIn(500);
                    $("#ap").removeClass("ap-pequeno").addClass("ap-grande");
                    $("#to").fadeIn(500);
                    $("#to").removeClass("to-pequeno").addClass("to-grande");

                    $(".QuantidadeInvestidoresEstadoNorte").fadeIn(1000);
                } else if (regiao == "nordeste") {
                    $("#norte").removeClass("norte").fadeOut(500);
                    $("#sudeste").removeClass("sudeste").fadeOut(500);
                    $("#centro-oeste").removeClass("centro-oeste").fadeOut(500);
                    $("#sul").removeClass("sul").fadeOut(500);

                    $("#nordeste").removeClass("nordeste").addClass("nordeste-grande");
                    $("#ma").fadeIn(500);
                    $("#ma").removeClass("ma-pequeno").addClass("ma-grande");
                    $("#pi").fadeIn(500);
                    $("#pi").removeClass("pi-pequeno").addClass("pi-grande");
                    $("#ce").fadeIn(500);
                    $("#ce").removeClass("ce-pequeno").addClass("ce-grande");
                    $("#rn").fadeIn(500);
                    $("#rn").removeClass("rn-pequeno").addClass("rn-grande");
                    $("#pb").fadeIn(500);
                    $("#pb").removeClass("pb-pequeno").addClass("pb-grande");
                    $("#pe").fadeIn(500);
                    $("#pe").removeClass("pe-pequeno").addClass("pe-grande");
                    $("#al").fadeIn(500);
                    $("#al").removeClass("al-pequeno").addClass("al-grande");
                    $("#se").fadeIn(500);
                    $("#se").removeClass("se-pequeno").addClass("se-grande");
                    $("#ba").fadeIn(500);
                    $("#ba").removeClass("ba-pequeno").addClass("ba-grande");

                    $(".QuantidadeInvestidoresEstadoNordeste").fadeIn(1000);
                } else if (regiao == "centro-oeste") {
                    $("#norte").removeClass("norte").fadeOut(500);
                    $("#nordeste").removeClass("nordeste").fadeOut(500);
                    $("#sudeste").removeClass("sudeste").fadeOut(500);
                    $("#sul").removeClass("sul").fadeOut(500);

                    $("#centro-oeste").removeClass("centro-oeste").addClass("centro-oeste-grande");
                    $("#ms").fadeIn(500);
                    $("#ms").removeClass("ms-pequeno").addClass("ms-grande");
                    $("#mt").fadeIn(500);
                    $("#mt").removeClass("mt-pequeno").addClass("mt-grande");
                    $("#df").fadeIn(500);
                    $("#df").removeClass("df-pequeno").addClass("df-grande");
                    $("#go").fadeIn(500);
                    $("#go").removeClass("go-pequeno").addClass("go-grande");

                    $(".QuantidadeInvestidoresEstadoCentro-oeste").fadeIn(1000);
                } else if (regiao == "sudeste") {
                    $("#norte").removeClass("norte").fadeOut(500);
                    $("#nordeste").removeClass("nordeste").fadeOut(500);
                    $("#centro-oeste").removeClass("centro-oeste").fadeOut(500);
                    $("#sul").removeClass("sul").fadeOut(500);

                    $("#sudeste").removeClass("sudeste").addClass("sudeste-grande");
                    $("#sp").fadeIn(500);
                    $("#sp").removeClass("sp-pequeno").addClass("sp-grande");
                    $("#es").fadeIn(500);
                    $("#es").removeClass("es-pequeno").addClass("es-grande");
                    $("#rj").fadeIn(500);
                    $("#rj").removeClass("rj-pequeno").addClass("rj-grande");
                    $("#mg").fadeIn(500);
                    $("#mg").removeClass("mg-pequeno").addClass("mg-grande");

                    $(".QuantidadeInvestidoresEstadoSudeste").fadeIn(1000);
                } else if (regiao == "sul") {
                    $("#norte").removeClass("norte").fadeOut(500);
                    $("#nordeste").removeClass("nordeste").fadeOut(500);
                    $("#centro-oeste").removeClass("centro-oeste").fadeOut(500);
                    $("#sudeste").removeClass("sudeste").fadeOut(500);

                    $("#sul").removeClass("sul").addClass("sul-grande");
                    $("#pr").fadeIn(500);
                    $("#pr").removeClass("pr-pequeno").addClass("pr-grande");
                    $("#sc").fadeIn(500);
                    $("#sc").removeClass("sc-pequeno").addClass("sc-grande");
                    $("#rs").fadeIn(500);
                    $("#rs").removeClass("rs-pequeno").addClass("rs-grande");

                    $(".QuantidadeInvestidoresEstadoSul").fadeIn(1000);
                }
            }
        },
        zoomOut: function zoomOut() {
            $("#norte").fadeIn(500);
            $("#nordeste").fadeIn(500);
            $("#centro-oeste").fadeIn(500);
            $("#sudeste").fadeIn(500);
            $("#sul").fadeIn(500);

            this.ClickZoom = false;

            if (this.RegiaoZoom == "norte") {
                //Região Norte
                $("#norte").removeClass("norte-grande").addClass("norte");

                $("#ac").removeClass("ac-grande").addClass("ac-pequeno");
                $("#ac").fadeOut(500);
                $("#am").removeClass("am-grande").addClass("am-pequeno");
                $("#am").fadeOut(500);
                $("#ro").removeClass("ro-grande").addClass("ro-pequeno");
                $("#ro").fadeOut(500);
                $("#rr").removeClass("rr-grande").addClass("rr-pequeno");
                $("#rr").fadeOut(500);
                $("#pa").removeClass("pa-grande").addClass("pa-pequeno");
                $("#pa").fadeOut(500);
                $("#ap").removeClass("ap-grande").addClass("ap-pequeno");
                $("#ap").fadeOut(500);
                $("#to").removeClass("to-grande").addClass("to-pequeno");
                $("#to").fadeOut(500);

                $(".QuantidadeInvestidoresEstadoNorte").fadeOut(300);
            } else if (this.RegiaoZoom == "nordeste") {
                //Região Nordeste
                $("#nordeste").removeClass("nordeste-grande").addClass("nordeste");

                // $("#to").removeClass("to-grande").addClass("to-pequeno")
                // $("#to").fadeOut(500)
                $("#ma").removeClass("ma-grande").addClass("ma-pequeno");
                $("#ma").fadeOut(500);
                $("#pi").removeClass("pi-grande").addClass("pi-pequeno");
                $("#pi").fadeOut(500);
                $("#ce").removeClass("ce-grande").addClass("ce-pequeno");
                $("#ce").fadeOut(500);
                $("#rn").removeClass("rn-grande").addClass("rn-pequeno");
                $("#rn").fadeOut(500);
                $("#pb").removeClass("pb-grande").addClass("pb-pequeno");
                $("#pb").fadeOut(500);
                $("#pe").removeClass("pe-grande").addClass("pe-pequeno");
                $("#pe").fadeOut(500);
                $("#al").removeClass("al-grande").addClass("al-pequeno");
                $("#al").fadeOut(500);
                $("#se").removeClass("se-grande").addClass("se-pequeno");
                $("#se").fadeOut(500);
                $("#ba").removeClass("ba-grande").addClass("ba-pequeno");
                $("#ba").fadeOut(500);

                $(".QuantidadeInvestidoresEstadoNordeste").fadeOut(300);
            } else if (this.RegiaoZoom == "centro-oeste") {
                //Região Centro-Oeste
                $("#centro-oeste").removeClass("centro-oeste-grande").addClass("centro-oeste");

                $("#ms").removeClass("ms-grande").addClass("ms-pequeno");
                $("#ms").fadeOut(500);
                $("#mt").removeClass("mt-grande").addClass("mt-pequeno");
                $("#mt").fadeOut(500);
                $("#df").removeClass("df-grande").addClass("df-pequeno");
                $("#df").fadeOut(500);
                $("#go").removeClass("go-grande").addClass("go-pequeno");
                $("#go").fadeOut(500);

                $(".QuantidadeInvestidoresEstadoCentro-oeste").fadeOut(300);
            } else if (this.RegiaoZoom == "sudeste") {
                //Região Sudeste
                $("#sudeste").removeClass("sudeste-grande").addClass("sudeste");

                $("#sp").removeClass("sp-grande").addClass("sp-pequeno");
                $("#sp").fadeOut(500);
                $("#es").removeClass("es-grande").addClass("es-pequeno");
                $("#es").fadeOut(500);
                $("#rj").removeClass("rj-grande").addClass("rj-pequeno");
                $("#rj").fadeOut(500);
                $("#mg").removeClass("mg-grande").addClass("mg-pequeno");
                $("#mg").fadeOut(500);

                $(".QuantidadeInvestidoresEstadoSudeste").fadeOut(300);
            } else if (this.RegiaoZoom == "sul") {
                //Região sul
                $("#sul").removeClass("sul-grande").addClass("sul");

                $("#pr").removeClass("pr-grande").addClass("pr-pequeno");
                $("#pr").fadeOut(500);
                $("#sc").removeClass("sc-grande").addClass("sc-pequeno");
                $("#sc").fadeOut(500);
                $("#rs").removeClass("rs-grande").addClass("rs-pequeno");
                $("#rs").fadeOut(500);

                $(".QuantidadeInvestidoresEstadoSul").fadeOut(300);
            }
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/estatisticas/estatisticas-da-plataforma/investidores',
                title: 'Estatisticas investidores'
            });
        }
    },
    updated: function updated() {

        if (!this.Criou) {
            this.CriaGrafico();
            this.Criou = true;
        }
    },
    beforeCreate: function beforeCreate() {
        var _this = this;

        this.$store.dispatch('updateUser');

        this.User = this.$store.state.currentUser;
        // HubClient.GerarEstatistica()
        __WEBPACK_IMPORTED_MODULE_3__utils_api_client_go__["a" /* default */].gerarEstatisticaPlataformaInvestidores("investidores").then(function (resposta) {

            _this.Estatisticas = resposta.data;

            _this.Renderizou = true;

            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    },
    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (_this2.$store.state.currentUser.investor != null) {
                                if (typeof _this2.$store.state.currentUser.investor.Bloqueio != 'undefined') window.location.href = "#/";
                            }
                            //tagueamento GA
                            _context.next = 3;
                            return _this2.taggingGA();

                        case 3:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    }
});

/***/ }),

/***/ "B+ee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit page"},[_c('h1',[_vm._v("Declaração de IRPF")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B5tC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        operacao: { type: Object }
    },

    computed: {
        valorPrincipal: function valorPrincipal() {
            if (this.operacao.Detalhes.Pagamento.Ipmt && this.operacao.Detalhes.Pagamento.Multa) return this.operacao.Detalhes.Pagamento.ValorBruto - this.operacao.Detalhes.Pagamento.Ipmt - this.operacao.Detalhes.Pagamento.Multa;else if (this.operacao.Detalhes.Pagamento.Ipmt && !this.operacao.Detalhes.Pagamento.Multa) return this.operacao.Detalhes.Pagamento.ValorBruto - this.operacao.Detalhes.Pagamento.Ipmt;else if (this.operacao.Detalhes.Pagamento.Multa && !this.operacao.Detalhes.Pagamento.Ipmt) return this.operacao.Detalhes.Pagamento.ValorBruto - this.operacao.Detalhes.Pagamento.Multa;else return this.operacao.Detalhes.Pagamento.ValorBruto;
        },
        juros: function juros() {
            return this.operacao.Detalhes.Pagamento.Ipmt;
        },
        valorBruto: function valorBruto() {
            return this.operacao.Detalhes.Pagamento.ValorBruto;
        },
        ir: function ir() {
            return this.operacao.Detalhes.Pagamento.Ir;
        },
        valorLiquido: function valorLiquido() {
            return this.operacao.Valor;
        },
        multa: function multa() {
            return this.operacao.Detalhes.Pagamento.Multa;
        },
        transacao: function transacao() {
            return this.operacao.id;
        },
        fatura: function fatura() {
            return this.operacao.Detalhes.Pagamento.FaturaId;
        },
        idOportunidade: function idOportunidade() {
            return this.operacao.Detalhes.Pagamento.IdOportunidade;
        },
        aliquota: function aliquota() {
            var ir = parseFloat(this.operacao.Detalhes.Pagamento.Ir);
            var juros = parseFloat(this.operacao.Detalhes.Pagamento.Ipmt);
            var multa = parseFloat(this.operacao.Detalhes.Pagamento.Multa);
            //calculo para operações SEM pagamento de multa
            if (ir && juros && !multa) {
                var aliquota = parseFloat(Math.round(ir / juros * 1000) / 10).toFixed(1);

                switch (true) {
                    case aliquota < 1:
                        return 0;
                    case aliquota > 14 && aliquota < 16:
                        return 15.0;
                    case aliquota > 17 && aliquota < 18:
                        return 17.5;
                    case aliquota > 19 && aliquota < 21:
                        return 20.0;
                    case aliquota > 21.5:
                        return 22.5;
                }
                //calculo para operações com pagamento de multa    
            } else if (multa) {
                var _aliquota = parseFloat(Math.round(ir / (juros + multa) * 1000) / 10).toFixed(1);

                switch (true) {
                    case _aliquota < 1:
                        return 0;
                    case _aliquota > 14 && _aliquota < 16:
                        return 15.0;
                    case _aliquota > 17 && _aliquota < 18:
                        return 17.5;
                    case _aliquota > 19 && _aliquota < 21:
                        return 20.0;
                    case _aliquota > 21.5:
                        return 22.5;
                }
            } else if (!juros) {
                return 0;
            } else {
                return this.operacao.Detalhes.Pagamento.AliqIr;
            }
        },
        parcela: function parcela() {
            return this.operacao.Detalhes.Pagamento.IndiceParcela;
        },
        prazo: function prazo() {
            return this.operacao.Detalhes.Pagamento.Prazo;
        },
        nomeEmpresa: function nomeEmpresa() {
            var NomeEmpresa = this.operacao.Detalhes.Pagamento.NomeEmpresa;

            return NomeEmpresa;
        },
        documento: function documento() {
            var DocumentoEmpresa = this.operacao.Detalhes.Pagamento.DocumentoEmpresa;

            return DocumentoEmpresa || "";
        }
    },

    methods: {
        formatDocument: function formatDocument(doc) {

            if (doc.length > 11) {
                return __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].maskCnpj(doc);
            } else {
                return __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].maskCpf(doc);
            }
        },
        formatarDinheiro: function formatarDinheiro(value) {

            if (value != null) {

                if (typeof value == "string") value = parseFloat(value);

                var options = {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                };

                return value.toLocaleString('pt-BR', options);
            }

            return 0;
        }
    }
});

/***/ }),

/***/ "B5xB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BABd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_investiment__ = __webpack_require__("/4fP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_iouuPay__ = __webpack_require__("AgAG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_pay_client__ = __webpack_require__("f6VA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import MarketingDrip from '../services/api/marketing';









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            Valor: 0,
            ValorReinv: 0.0,
            InvestidorId: "",
            reservaId: "",
            solicitacao: null,
            score: null,
            submit: false,
            TipoUser: '',
            investimentos: '',
            suitability: '',
            investidor: '',
            sexo: '',
            estadoCivil: ''
        };
    },

    methods: {
        FormatCurrency: function FormatCurrency(value) {
            if (value != null) return "R$ " + value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });

            return 0;
        },
        ScoreClass: function ScoreClass(score) {
            if (score == null || score == undefined) return "";
            return 'rating-' + score.toLowerCase();
        },
        Score: function Score(score) {
            if (score == null || score == undefined) return "";

            if (score == "AA" || score == "HR") return score;

            return score.substr(0, 1);
        },
        NomeTomador: function NomeTomador() {
            return this.solicitacao.Empresa.NomeFantasia + ' - ' + __WEBPACK_IMPORTED_MODULE_8__utils_masker__["a" /* default */].maskCnpj(this.solicitacao.Documento);
        },
        TipoInvestimento: function TipoInvestimento() {
            switch (this.solicitacao.CodProduto) {
                case "EMPCOL":
                    return "Empréstimo Coletivo";
                case "EMPIMP2":
                    return "Empréstimo Impacto";
                case "EMPIMP":
                    return "Empréstimo Impacto";
                default:
                    return "";
            }
        },
        Redirect: function Redirect(type) {
            if (type === "lista") {
                this.$router.push("/investimentos/oportunidades");
            } else {
                this.$router.push('/investimentos/oportunidades/perfil-empresa/' + this.solicitacao._id);
            }
        },
        GeraSwal: function GeraSwal(titulo, msg) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a.fire({
                title: titulo,
                text: msg,
                type: 'info',
                confirmButtonColor: '#40CD28',
                confirmButtonText: 'OK'
            }).then(function (result) {
                if (result.value) {
                    _this.$router.push('/investimentos/oportunidades/perfil-empresa/' + _this.solicitacao._id);
                }
            });
        },
        GeraSwalSocial: function GeraSwalSocial(titulo, msg) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a.fire({
                title: titulo,
                text: msg,
                type: 'info',
                confirmButtonColor: '#40CD28',
                confirmButtonText: 'OK'
            }).then(function (result) {
                if (result.value) {
                    _this2.$router.push('/investimentos/investimento-de-impacto/perfil-social-new/' + _this2.solicitacao._id);
                }
            });
        },
        SubmitInvestment: function SubmitInvestment() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var dataVencimento, investmentReservation, priceCents, boleto, titulo, msg, reserva, _reserva, boletoInvestidor, reservaID;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this3.submit) {
                                    _context.next = 45;
                                    break;
                                }

                                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);

                                _this3.submit = true;

                                dataVencimento = new Date();

                                dataVencimento.setDate(dataVencimento.getDate() + 1);

                                investmentReservation = {
                                    Valor: _this3.Valor,
                                    ReInvestimento: _this3.ValorReinv,
                                    Boleto: {}
                                };
                                priceCents = (_this3.Valor - _this3.ValorReinv) * 100;
                                boleto = {
                                    Boleto: {
                                        due_date: dataVencimento,
                                        email: _this3.$store.state.currentUser.email,
                                        items: [{
                                            description: "Oportunidade: #" + _this3.solicitacao.IdOportunidade + " " + _this3.solicitacao.Empresa.NomeFantasia,
                                            quantity: 1,
                                            price_cents: parseInt(priceCents.toFixed(2))
                                        }]
                                    }
                                };

                                if (!(_this3.solicitacao.TipoEmprestimo == "emprestimo-social")) {
                                    _context.next = 15;
                                    break;
                                }

                                titulo = 'Investimento confirmado com sucesso!', msg = "Você será redirecionado para a página de perfil da empresa.";
                                _context.next = 12;
                                return __WEBPACK_IMPORTED_MODULE_2__services_api_investiment__["a" /* default */].CreateReservation(_this3.solicitacao._id, investmentReservation);

                            case 12:
                                reserva = _context.sent;

                                _this3.GeraSwalSocial(titulo, msg);
                                return _context.abrupt('return');

                            case 15:
                                titulo = 'Não foi possível gerar seu boleto', msg = "Você será redirecionado para a página de perfil da empresa. Entre em contato com nossos atendentes para gerar uma segunda via.";
                                _context.prev = 16;
                                _context.next = 19;
                                return __WEBPACK_IMPORTED_MODULE_2__services_api_investiment__["a" /* default */].CreateReservation(_this3.solicitacao._id, investmentReservation);

                            case 19:
                                _reserva = _context.sent;

                                if (true) {
                                    _context.next = 26;
                                    break;
                                }

                                _context.next = 23;
                                return __WEBPACK_IMPORTED_MODULE_3__services_api_iouuPay__["a" /* default */].CreateBoleto(_reserva.data._id);

                            case 23:
                                _context.t0 = _context.sent;
                                _context.next = 29;
                                break;

                            case 26:
                                _context.next = 28;
                                return __WEBPACK_IMPORTED_MODULE_2__services_api_investiment__["a" /* default */].CreateBoleto(_reserva.data._id, boleto);

                            case 28:
                                _context.t0 = _context.sent;

                            case 29:
                                boletoInvestidor = _context.t0;

                                if (true) {
                                    _context.next = 36;
                                    break;
                                }

                                reservaID = {
                                    reservaID: _reserva.data._id
                                };
                                _context.next = 34;
                                return __WEBPACK_IMPORTED_MODULE_2__services_api_investiment__["a" /* default */].CreateInvestDepositRecord(reservaID);

                            case 34:
                                _context.next = 36;
                                return __WEBPACK_IMPORTED_MODULE_2__services_api_investiment__["a" /* default */].CreateInvestDebtRecord(reservaID);

                            case 36:

                                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                if (boletoInvestidor.statusText == "OK" || typeof boletoInvestidor.data != "undefined") {
                                    _this3.$router.push('/investimentos/finalizar-investimento?id=' + _reserva.data._id);

                                    // if(process.env.NODE_ENV === "production") {
                                    //     let now = new Date();

                                    //     _dcq.push(
                                    //         [
                                    //             "track", this.solicitacao.Empresa.NomeFantasia + " (ID: #" + this.solicitacao.IdOportunidade + ")",
                                    //             { 
                                    //                 occurred_at: now,
                                    //                 value: this.Valor
                                    //             }
                                    //         ]
                                    //     );

                                    //     var properties = {
                                    //         "subscribers": [{
                                    //             "email": this.User.email,
                                    //             "time_zone": "America/Sao_Paulo",
                                    //             "user_id": this.User._id,
                                    //             "first_name": this.User.first_name,
                                    //             "last_name": this.User.last_name,
                                    //             "phone": this.User.investor.TelefoneFixo,
                                    //             "city": this.User.investor.Endereco.Cidade,
                                    //             "state": this.User.investor.Endereco.Uf,
                                    //             "tags": ["Investidor (Cliente)"],
                                    //             "custom_fields": {
                                    //                 "Tipo": this.TipoUser,
                                    //                 "Perfil_Suitability": this.User.suitability.Tipo,
                                    //                 "Preencheu_Suitability": this.suitability,
                                    //                 "Investidor": this.investidor,
                                    //                 "Tem_Investimentos": this.investimentos,
                                    //                 "Sexo": this.sexo,
                                    //                 "Estado_Civil": this.estadoCivil,
                                    //                 "Renda_Mensal": this.User.investor.RendaMensal,
                                    //                 "Patrimonio_Declarado": this.User.investor.Patrimonio
                                    //             }
                                    //         }]
                                    //     }

                                    //     await MarketingDrip.DripSubscribers(properties);

                                    //     console.log("DRIP ", _dcq)
                                    // }

                                    _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                } else if (typeof _reserva.data == "undefined") {
                                    titulo = 'Não foi possível gerar sua reserva';
                                    msg = "Você será redirecionado para a página de perfil da empresa. Caso o erro persista entre em contato com nossos atendentes.";
                                    _this3.GeraSwal(titulo, msg);
                                } else {
                                    _this3.GeraSwal(titulo, msg);
                                    _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                }

                                _context.next = 45;
                                break;

                            case 40:
                                _context.prev = 40;
                                _context.t1 = _context['catch'](16);

                                try {
                                    titulo = _context.t1.response.data.errors[0].detail;
                                } catch (err) {
                                    titulo = 'Não foi possível gerar sua reserva';
                                }

                                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);

                                _this3.GeraSwal(titulo, msg);

                            case 45:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3, [[16, 40]]);
            }))();
        },


        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/oportunidades/confirmacao/:id',
                title: 'Checkout'
            });
        }
    },
    created: function created() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _this4.User = _this4.$store.state.currentUser;

                            if (_this4.User.tipo.length > 1) {
                                _this4.TipoUser = 'Investidor e Tomador';
                            } else if (_this4.User.tipo[0] === 'INV') {
                                _this4.TipoUser = 'Investidor';
                            } else {
                                _this4.TipoUser = 'Tomador';
                            }

                            _this4.User.hassuitability === true ? _this4.suitability = 'Verdadeiro' : _this4.suitability = 'Falso';
                            _this4.User.hasinvestor === true ? _this4.investidor = 'Verdadeiro' : _this4.investidor = 'Falso';
                            _this4.User.hasinvestments === true ? _this4.investimentos = 'Verdadeiro' : _this4.investimentos = 'Falso';
                            if (_this4.User.investor.Sexo === 1) {
                                _this4.sexo = 'M';
                            } else if (_this4.User.investor.Sexo === 2) {
                                _this4.sexo = 'F';
                            }

                            if (_this4.User.investor.EstadoCivil === 1) {
                                _this4.estadoCivil = 'Solteiro (a)';
                            } else if (_this4.User.investor.EstadoCivil === 2) {
                                _this4.estadoCivil = 'Casado (a)';
                            } else if (_this4.User.investor.EstadoCivil === 3) {
                                _this4.estadoCivil = 'Divorciado (a)';
                            } else if (_this4.User.investor.EstadoCivil === 4) {
                                _this4.estadoCivil = 'Viúvo (a)';
                            } else if (_this4.User.investor.EstadoCivil === 5) {
                                _this4.estadoCivil = 'União Estável';
                            }

                            //tagueamento GA
                            _context2.next = 9;
                            return _this4.taggingGA();

                        case 9:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this4);
        }))();
    },
    beforeMount: function beforeMount() {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var preInv;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _this5.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);

                            preInv = JSON.parse(localStorage.getItem("pre_investimento"));

                            if (!(preInv == null)) {
                                _context3.next = 6;
                                break;
                            }

                            _this5.$router.push("/investimentos/oportunidades");
                            _context3.next = 22;
                            break;

                        case 6:
                            _this5.ValorReinv = preInv.ValorReinvestimento;
                            _this5.Valor = preInv.Valor;
                            _this5.InvestidorId = preInv.InvestidorId;
                            console.log("CHECK..", preInv);
                            _context3.prev = 10;
                            _context3.next = 13;
                            return __WEBPACK_IMPORTED_MODULE_5__utils_api_client__["a" /* default */].getLoanRequest(preInv.SolicitacaoId);

                        case 13:
                            _this5.solicitacao = _context3.sent;

                            _this5.score = _this5.Score(_this5.solicitacao.Score);
                            _this5.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            _context3.next = 22;
                            break;

                        case 18:
                            _context3.prev = 18;
                            _context3.t0 = _context3['catch'](10);

                            console.log(_context3.t0);
                            _this5.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);

                        case 22:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this5, [[10, 18]]);
        }))();
    }
});

/***/ }),

/***/ "BCWH":
/***/ (function(module, exports) {

//
//
//
//

/***/ }),

/***/ "BEui":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_InformationSuitability__ = __webpack_require__("nyYf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_hub_consulta_client_js__ = __webpack_require__("pk4i");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






var components = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4__components_InformationSuitability__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            suitability: null,
            texto: ""
        };
    },

    computed: {},
    methods: {
        Preencher: function Preencher() {
            this.$router.push({ path: '/informacoes-adicionais/suitability' });
        },
        Oportunidades: function Oportunidades() {

            this.$router.push({ path: '/investimentos/meus-investimentos' });
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/informacoes-adicionais/suitabilityVerify',
                title: 'Suitability Verify'
            });
        }
    },
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            _this.$Loading.update(0);
                            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);

                            // ATUALIZA TAG NO ACTIVE CAMPAIN ...
                            __WEBPACK_IMPORTED_MODULE_7__utils_hub_consulta_client_js__["a" /* default */].AtualizarActive(_this.$store.state.currentUser.email, "usuario-cadastro-investidor-incompleto");

                            __WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].get('suitabilityVerify').then(function (response) {

                                if (response.data != null) {
                                    _this.suitability = response.data;

                                    if (_this.suitability.Tipo == "Conservador") {
                                        _this.texto = 'Verificamos que voc\xEA busca rendimentos modestos, o investidor conservador possui a seguranc\u0327a como refere\u0302ncia para as suas aplicac\u0327o\u0303es, assumindo os menores riscos possi\u0301veis. Em raza\u0303o da sua baixa tolera\u0302ncia ao risco, mante\u0301m em sua carteira percentual reduzido de produtos de renda varia\u0301vel, dando prefere\u0302ncia aos produtos de renda fixa.\n                                    <br>Dessa forma, esteja ciente dos riscos e benef\xEDcios de investir atrav\xE9s do empr\xE9stimo coletivo (peer-to-peer lending).\n                                    <br>Esperamos que este seja o come\xE7o de uma parceria de muito sucesso entre voc\xEA e a IOUU.';
                                    }
                                    if (_this.suitability.Tipo == "Moderado") {
                                        _this.texto = 'Voc\xEA procura equilibrar rentabilidade com risco. \xC9 um investidor que prefere a seguran\xE7a da renda fixa, mas tamb\xE9m aplica parte de seus recursos em renda vari\xE1vel, visando retornos acima da m\xE9dia do mercado. Por isso, ficamos felizes em informar que voc\xEA j\xE1 pode come\xE7ar seus investimentos conosco. Esperamos que este seja o come\xE7o de uma parceria de muito sucesso entre voc\xEA e a IOUU.';
                                    }

                                    if (_this.suitability.Tipo == "Arrojado") {
                                        _this.texto = 'Voc\xEA busca sempre alta rentabilidade, mesmo que corra riscos de perder parte do patrim\xF4nio. Assume posi\xE7\xF5es mais concentradas e especulativas como forma de alcan\xE7ar um maior retorno.\n                                    <br>Voc\xEA tem cie\u0302ncia dos riscos e benef\xEDcios de investir atr\xE1ves do empr\xE9stimo coletivo (peer-to-peer lending).\n                                    <br>Esperamos que este seja o come\xE7o de uma parceria de muito sucesso entre voc\xEA e a IOUU.';
                                    }

                                    if (_this.suitability.Tipo == "Super agressivo" || _this.suitability.Tipo == "Agressivo") {
                                        _this.texto = 'Voc\xEA possui total conhecimento e amplo domi\u0301nio dos produtos de investimento. Voc\xEA busca retornos muito expressivos no curto prazo, suportando quaisquer riscos.\n                                    <br>Voc\xEA tem cie\u0302ncia dos riscos e benef\xEDcios de investir atr\xE1ves do empr\xE9stimo coletivo (peer-to-peer lending).\n                                    <br>Esperamos que este seja o come\xE7o de uma parceria de muito sucesso entre voc\xEA e a IOUU.';
                                    }
                                } else {
                                    _this.Preencher();
                                }
                                _this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            }).catch(function () {
                                return _this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            });

                            //tagueamento GA
                            _context.next = 6;
                            return _this.taggingGA();

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ "BOQj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"nomeCompleto"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Documento),expression:"Documento"},{name:"mask",rawName:"v-mask",value:('cnpj'),expression:"'cnpj'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":"","disabled":""},domProps:{"value":(_vm.Documento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Documento=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',[_vm._v("Razão Social")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.razaoSocial),expression:"razaoSocial"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":""},domProps:{"value":(_vm.razaoSocial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.razaoSocial=$event.target.value}}})]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Informações da empresa")]),_vm._v(" "),_c('p',[_vm._v("Agora, por favor, confirme alguns dados sobre a sua empresa.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BbvO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinishInvestment_vue__ = __webpack_require__("TDCC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3102956_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishInvestment_vue__ = __webpack_require__("CXq+");
function injectStyle (ssrContext) {
  __webpack_require__("VeFN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e3102956"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinishInvestment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3102956_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishInvestment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bc9P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CriarContaSenha_vue__ = __webpack_require__("3m2+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_377a3d9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CriarContaSenha_vue__ = __webpack_require__("d/g1");
function injectStyle (ssrContext) {
  __webpack_require__("0Nme")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-377a3d9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CriarContaSenha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_377a3d9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CriarContaSenha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BdGU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecuperarSenha_vue__ = __webpack_require__("b4aJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfd54e1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecuperarSenha_vue__ = __webpack_require__("8XXs");
function injectStyle (ssrContext) {
  __webpack_require__("AJ+A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bfd54e1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecuperarSenha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfd54e1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecuperarSenha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bfri":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_InformationSuitability__ = __webpack_require__("nyYf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_StepBackButton__ = __webpack_require__("g50h");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







var components = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({ StepBackButton: __WEBPACK_IMPORTED_MODULE_9__components_StepBackButton__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_5__components_InformationSuitability__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            transitionName: 'slide-left',
            suitabilityId: "",
            suitability: null,
            validationErrors: []
        };
    },

    components: components,
    computed: {
        currentStepComponent: function currentStepComponent() {

            return this.suitability ? this.suitability.Status + '-step' : null;
        },
        progress: function progress() {

            var stepsAmount = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__components_InformationSuitability__["a" /* default */]).length;
            var currentStepNumber = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__components_InformationSuitability__["a" /* default */]).indexOf(this.currentStepComponent) + 1;
            return Math.round(currentStepNumber * 100 / stepsAmount);
        },
        canGoPrevious: function canGoPrevious() {
            if (!this.suitability) return false;

            return this.suitability.Status != "inicio-questionario" && this.suitability.Status != "confirmacao";
        }
    },
    methods: {
        atualizarSolicitacao: function atualizarSolicitacao(data) {
            var _this = this;

            data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(data, { step_type: 'next' });
            this.transitionName = 'slide-left';

            if (data.Aceite != undefined && data.Aceite != null) {
                this.ConsultarTipoInvestidor(data);
            } else {
                this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["c" /* START_LOADING */]);

                // console.log("mandou",this.suitabilityId);
                __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].put('suitability/' + this.suitabilityId + '/investidor', { data: data }).then(function (response) {
                    _this.suitability = response.data;
                    _this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["d" /* STOP_LOADING */]);window.scrollTo(0, 0);
                }).catch(function (error) {

                    _this.validationErrors = error.response.data.errors;
                    var errorMessages = _this.validationErrors.map(function (error) {
                        return error.detail;
                    });
                    _this.$Notify.error(__WEBPACK_IMPORTED_MODULE_7__utils_array_helper__["a" /* default */].toSentence(errorMessages));
                    _this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["d" /* STOP_LOADING */]);window.scrollTo(0, 0);
                });

                this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["d" /* STOP_LOADING */]);
            }
        },
        onPrevious: function onPrevious() {
            var _this2 = this;

            this.transitionName = 'slide-right';

            this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["c" /* START_LOADING */]);
            __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].put('suitability/' + this.suitabilityId + '/investidor', { data: { step_type: 'previous' } }).then(function (response) {
                _this2.suitability = response.data;
                window.scrollTo(0, 0);
                _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["d" /* STOP_LOADING */]);
            }).catch(function () {
                _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["d" /* STOP_LOADING */]);window.scrollTo(0, 0);
            });

            this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["d" /* STOP_LOADING */]);
        },
        handleLoadingToggle: function handleLoadingToggle(isLoading) {
            //  console.log("handleLoadingToggle");
            if (isLoading) {
                this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["c" /* START_LOADING */]);
            } else {
                this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["d" /* STOP_LOADING */]);
            }
        },
        ConsultarTipoInvestidor: function ConsultarTipoInvestidor(data) {
            var _this3 = this;

            // console.log("ConsultarTipoInvestidor");

            __WEBPACK_IMPORTED_MODULE_8__utils_hub_consulta_client__["a" /* default */].obterPerfilInvestidor(this.suitabilityId).then(function (responsePerfil) {
                //    console.log("obterPerfilInvestidor",responsePerfil);

                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["c" /* START_LOADING */]);

                __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].put('suitability/' + _this3.suitabilityId + '/investidor', { data: data }).then(function (response) {

                    // console.log("resposta",response);
                    _this3.suitability = response.data;
                    _this3.suitability.Nome = responsePerfil.data.Nome;
                    _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["d" /* STOP_LOADING */]);
                }).catch(function (error) {

                    // console.log("erro",error);
                    _this3.validationErrors = error.response.data.errors;
                    var errorMessages = _this3.validationErrors.map(function (error) {
                        return error.detail;
                    });
                    _this3.$Notify.error(__WEBPACK_IMPORTED_MODULE_7__utils_array_helper__["a" /* default */].toSentence(errorMessages));
                    _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["d" /* STOP_LOADING */]);
                });
                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["d" /* STOP_LOADING */]);

                //Atualiza o usuário
                _this3.$store.dispatch('updateUser').then().catch(function (error) {
                    var errorMessages = error.response.data.errors.map(function (error) {
                        return error.detail;
                    });
                    _this3.$Notify.error(__WEBPACK_IMPORTED_MODULE_7__utils_array_helper__["a" /* default */].toSentence(errorMessages));
                });
            }).catch(function (error) {

                console.log("erro ao obterPerfilInvestidor");
            });
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/informacoes-adicionais/suitability',
                title: 'Suitability'
            });
        }
    },
    created: function created() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var urlArray;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (_this4.$store.state.currentUser.hassuitability) {
                                urlArray = window.location.toString().split('/');

                                window.location = urlArray[0] + "//" + urlArray[2];
                            }
                            __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].get('suitability').then(function (response) {
                                _this4.suitability = response.data;
                                _this4.suitabilityId = _this4.suitability.insertedIds[0];
                                _this4.suitability.Status = "inicio-questionario";
                                _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            }).catch(function (err) {
                                _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            });

                            //tagueamento GA
                            _context.next = 4;
                            return _this4.taggingGA();

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this4);
        }))();
    },
    beforeUpdate: function beforeUpdate() {
        this.$Loading.update(this.progress);
    }
});

/***/ }),

/***/ "Bt+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import * as mutationTypes from '@/store/mutation-types.js'
// import SessionManager from '@/utils/session-manager'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: {
        email: "",
        password: ""
      }
    };
  },

  methods: {
    handleSubmit: function handleSubmit(event) {
      event.preventDefault();
      this.$emit("userData", this.user);
    },
    handleLoginWithFacebook: function handleLoginWithFacebook() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit('facebook');

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleLoginWithGmail: function handleLoginWithGmail() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$emit('gmail');

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleModal: function handleModal() {
      this.$emit("setOpenModal");
    }
  }
});

/***/ }),

/***/ "C0U1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CBCL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"collapsed-menu d-flex flex-column",on:{"click":function($event){return _vm.HideMobMenu(true)}}},[_c('div',{staticClass:"menu-section"},[_c('div',{staticClass:"top"},[_c('i',{staticClass:"icon ico-iouu"}),_c('span'),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.HideMobMenu(true)}}})]),_vm._v(" "),_c('ul',_vm._l((_vm.items),function(item,i){return _c('li',{key:("item" + i),staticClass:"menu-item"},[(item.path != null)?_c('div',[(!item.modal)?_c('router-link',{attrs:{"to":item.path,"active-class":"active","title":item.title}},[_c('i',{staticClass:"menu-item-icon",class:item.iconClass}),_vm._v(" "),_c('span',{staticClass:"menu-item-title"},[_vm._v(_vm._s(item.title))])]):_vm._e(),_vm._v(" "),(item.modal)?_c('a',{attrs:{"href":"#","active-class":"active","data-toggle":"modal","title":item.title,"data-target":"#modalMotivo"}},[_c('i',{staticClass:"menu-item-icon",class:item.iconClass}),_vm._v(" "),_c('span',{staticClass:"menu-item-title"},[_vm._v(_vm._s(item.title))])]):_vm._e()],1):_vm._e(),_vm._v(" "),(item.url != null)?_c('div',[_c('a',{attrs:{"href":item.url,"target":"_black","active-class":"active","title":item.title}},[_c('i',{staticClass:"menu-item-icon",class:item.iconClass}),_vm._v(" "),_c('span',{staticClass:"menu-item-title"},[_vm._v(_vm._s(item.title))])])]):_vm._e()])}),0)]),_vm._v(" "),_c('div',{staticClass:"menu-default align-items-end"},[_c('ul',{staticClass:"menu-item"},[_c('li',[_c('a',{attrs:{"href":'/#/emprestimos/meus-emprestimos',"title":"Quero empréstimo"}},[_c('i',{staticClass:"ico-din-3"}),_vm._v(" "),_c('span',[_vm._v("Quero empréstimo")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":'/#/'+_vm.tipo+'/perfil/dados-pessoais',"title":"Meu Perfil"}},[_c('i',{staticClass:"ico-user"}),_vm._v(" "),_c('span',[_vm._v("Meu Perfil")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","title":"Sair"},on:{"click":_vm.logout}},[_c('i',{staticClass:"ico-exit"}),_vm._v(" "),_c('span',[_vm._v("Sair")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"target":"_blank","href":"http://ajuda.iouu.com.br","title":"Central de Ajuda"}},[_c('i',{staticClass:"ico-ch"}),_vm._v(" "),_c('span',[_vm._v("Central de Ajuda")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CD5J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressStep_vue__ = __webpack_require__("ev1W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_634111a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressStep_vue__ = __webpack_require__("9xri");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_634111a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CN8O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_BarChart__ = __webpack_require__("gxv5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Carousel__ = __webpack_require__("mfOW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CompanyProfile_InvestmentReservationForm__ = __webpack_require__("yyPQ");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import ArrayHelper from '@/utils/array-helper'

// import Promise from 'promise'

/* harmony default export */ __webpack_exports__["a"] = ({
	components: { BarChart: __WEBPACK_IMPORTED_MODULE_3__components_charts_BarChart__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_4__components_Carousel__["a" /* default */], InvestmentReservationForm: __WEBPACK_IMPORTED_MODULE_7__components_CompanyProfile_InvestmentReservationForm__["a" /* default */] },
	data: function data() {
		return {
			solicitacao: {},
			renderizar: false,
			temCadastroInvestidor: false,
			temSuitability: false,
			investidorAprovado: false,
			qtdeInvestidores: 0,
			valueToInvest: "",
			ccbAberta: true
		};
	},


	computed: {
		scoreClass: function scoreClass() {
			if (!this.solicitacao.Score) {
				return "";
			}

			return "rating-" + this.solicitacao.Score.replace(/\d/, '').toLowerCase();
		},
		canInvest: function canInvest() {
			return this.temCadastroInvestidor && this.temSuitability && this.investidorAprovado;
		},
		facebookLink: function facebookLink() {
			if (this.solicitacao.Ccb.RedesSociais.Facebook.indexOf("http") < 0) return 'http://' + this.solicitacao.Ccb.RedesSociais.Facebook;

			return this.solicitacao.Ccb.RedesSociais.Facebook;
		},
		instagramLink: function instagramLink() {
			if (this.solicitacao.Ccb.RedesSociais.Instagram.indexOf("http") < 0) return 'http://' + this.solicitacao.Ccb.RedesSociais.Instagram;

			return this.solicitacao.Ccb.RedesSociais.Instagram;
		},
		twitterLink: function twitterLink() {
			if (this.solicitacao.Ccb.RedesSociais.Twitter.indexOf("http") < 0) return 'http://' + this.solicitacao.Ccb.RedesSociais.Twitter;

			return this.solicitacao.Ccb.RedesSociais.Twitter;
		},
		vimeoLink: function vimeoLink() {
			if (this.solicitacao.Ccb.RedesSociais.Vimeo.indexOf("http") < 0) return 'http://' + this.solicitacao.Ccb.RedesSociais.Vimeo;

			return this.solicitacao.Ccb.RedesSociais.Vimeo;
		},
		formatoInvestimento: function formatoInvestimento() {
			return this.solicitacao.FormatoInvestimento;
		}
	},
	methods: {
		//tagueamento GA
		taggingGA: function taggingGA() {
			this.$ga.page({
				page: '/cadastrar-senha',
				title: 'CadastrarSenha'
			});
		},
		validaStatusInvestimento: function validaStatusInvestimento() {
			var resultDt = this.diffDate(new Date(), this.solicitacao.FimCaptacao);

			if (resultDt == "ENCERRADO" || this.solicitacao.ValorCaptado >= this.solicitacao.Valor) return false;

			return true;
		},
		investir: function investir(solicitacaoId, valueToInvest) {
			var _this = this;

			var value = __WEBPACK_IMPORTED_MODULE_5__utils_masker__["a" /* default */].unmaskMoney(valueToInvest);

			if (value == 0 || isNaN(value)) {
				this.$Notify.error({
					title: "Desculpe",
					message: "Por favor, insira um valor."
				});

				return;
			}

			if (value < 20000 || isNaN(value)) {
				this.$Notify.error({
					title: "Desculpe",
					message: "O valor mínimo de investimento em CCB é de R$ 20.000,00."
				});

				return;
			}

			if (value > this.solicitacao.Valor - this.solicitacao.ValorCaptado) {
				this.$Notify.error({
					title: "Desculpe",
					message: "O valor de investimento é maior do que o disponível."
				});

				return;
			}

			this.solicitacao.JaInvestiu = true;

			this.$forceUpdate();

			__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].postInvestirCcb(solicitacaoId, value).then(function () {
				_this.finalizado = true;

				setTimeout(function () {
					// this.get(this.id);
					// this.getCountInvestidores(this.id);
				}, 500);
			});
		},
		calcPercValorRestante: function calcPercValorRestante() {
			return this.solicitacao.ValorCaptado * 100 / this.solicitacao.Valor;
		},
		calcValorRestante: function calcValorRestante() {
			return this.solicitacao.Valor - this.solicitacao.ValorCaptado;
		},
		formatMongoDate: function formatMongoDate(dt) {
			var date = new Date(dt);

			var day = date.getDate();
			var month = date.getMonth() + 1;
			var year = date.getFullYear();

			day = day > 9 ? day : '0' + day;
			month = month > 9 ? month : '0' + month;

			return day + '/' + month + '/' + year;
		},
		formatarCnpj: function formatarCnpj(cnpj) {
			return __WEBPACK_IMPORTED_MODULE_5__utils_masker__["a" /* default */].maskCnpj(cnpj);
		},
		formatarTipoEmprestimo: function formatarTipoEmprestimo(tipoEmprestimo) {
			var splitedTipoEmprestimo = tipoEmprestimo.split('-');
			if (splitedTipoEmprestimo.length > 1) {
				return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
			}

			return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);
		},
		ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
			var s = String(id);
			while (s.length < (qtd || 2)) {
				s = "0" + s;
			}
			return s;
		},
		formatCurrency: function formatCurrency(value) {
			return value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
		},
		diffDate: function diffDate(d1, d2) {
			var date1, date2;

			if (d1 == "") {
				date1 = new Date();
			} else {
				date1 = new Date(d1);
				date1.setHours(date1.getHours() + date1.getTimezoneOffset() / 60);
			}

			if (d2 == "") {
				date2 = new Date();
			} else {
				date2 = new Date(d2);
				date2.setHours(date2.getHours() + date2.getTimezoneOffset() / 60);
			}

			var timeDiff = date2.getTime() - date1.getTime();
			var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

			if (diffDays < 0) return "Encerrado";
			if (diffDays == 0) return "Finaliza hoje*";

			return "Finaliza em " + diffDays + " dias*";
		},
		get: function get(id) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getCcbById(id).then(function (response) {
				_this2.solicitacao = response.data;
				_this2.ccbAberta = _this2.validaStatusInvestimento();
				_this2.renderizar = true;

				_this2.$forceUpdate();
			});
		},
		getCountInvestidores: function getCountInvestidores(id) {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getCountCcbInvestors(id).then(function (response) {
				_this3.qtdeInvestidores = response.data;
				_this3.renderizar = true;

				_this3.$forceUpdate();
			});
		},
		dataLonga: function dataLonga(data) {
			var date = new Date(data);
			date.setHours(date.getHours() + date.getTimezoneOffset() / 60); //ajustando para o horário gravado no banco
			var options = { year: "numeric", month: "long", day: "numeric" };
			return date.toLocaleDateString("pt-BR", options);
		},
		calcDiasRestantes: function calcDiasRestantes() {
			return this.diffDate(new Date(), this.solicitacao.FimCaptacao);
		},
		getInvestidor: function getInvestidor(solicitacaoId) {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getInvestidorCcb(solicitacaoId).then(function (response) {
				if (response.data != null && response.data.Status != 0) {
					_this4.solicitacao.JaInvestiu = true;
					_this4.solicitacao.ReservaInvestimento = response.data;
					_this4.solicitacao.ReservaInvestimento.Valor += ",00";
				} else {
					_this4.solicitacao.JaInvestiu = false;
				}

				_this4.$forceUpdate();
			});
		}
	},
	beforeCreate: function beforeCreate() {
		this.$store.dispatch('updateUser');
	},
	created: function created() {
		var _this5 = this;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_this5.solicitacaoId = _this5.$route.params.id;

							_this5.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types_js__["c" /* START_LOADING */]);

							if (typeof _this5.$store.state.currentUser.investor.Bloqueio != 'undefined') {
								window.location.href = "#/";
							}

							//ajuste modal
							if (document.getElementsByTagName("main").length > 0) document.getElementsByTagName("main")[0].style.zIndex = "0";

							_this5.id = _this5.$route.params.id;

							_this5.temSuitability = _this5.$store.state.currentUser.hassuitability == undefined ? false : _this5.$store.state.currentUser.hassuitability;
							_this5.temCadastroInvestidor = _this5.$store.state.currentUser.hasinvestor == undefined ? false : _this5.$store.state.currentUser.hasinvestor;

							if (_this5.$store.state.currentUser.investor == null) _this5.investidorAprovado = false;else _this5.investidorAprovado = _this5.$store.state.currentUser.investor.Status == "APROVADO" && _this5.temCadastroInvestidor;

							_this5.get(_this5.id);
							_this5.getCountInvestidores(_this5.id);
							_this5.getInvestidor(_this5.id);

							//tagueamento GA
							_context.next = 13;
							return _this5.taggingGA();

						case 13:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this5);
		}))();
	}
});

/***/ }),

/***/ "CNYh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PasswordField__ = __webpack_require__("i7i+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client_js__ = __webpack_require__("pk4i");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import ApiClient from '@/utils/api-client'
// import ArrayHelper from '@/utils/array-helper'



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            cdi: '384,07%',
            name: '',
            email: '',
            password: '',
            enabled: false,
            visivel: false,
            EmailConfirmado: true,
            msg: ''
        };
    },

    components: {
        PasswordField: __WEBPACK_IMPORTED_MODULE_2__components_PasswordField__["a" /* default */]
    },
    metaInfo: {
        title: 'Seja um investidor IOUU'
    },
    methods: {
        validateName: function validateName() {
            if (this.name[0] == " ") {
                this.name = "";
                return;
            }

            var splitText = this.name.split(' ');
            var upperCaseText = '';

            for (var i = 0; i < splitText.length; i++) {
                if (splitText[i] != "") {
                    if (i > 0) upperCaseText += " ";

                    upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
                } else if (i > 0) upperCaseText += " ";
            }

            this.name = upperCaseText;
        },

        ValidarEmail: function ValidarEmail() {
            var _this = this;

            this.EmailConfirmado = true;
            this.msg = "";
            //Chama API que faz a Pré Validação do Email para verificar se a ortografia esta correta
            if (this.email != "") {
                __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client_js__["a" /* default */].PreValidacaoEmail(this.email).then(function (resposta) {

                    //Sintaxe do Email Inválida
                    if (resposta.Msg == "Email Inválido") {
                        _this.EmailConfirmado = false;
                        _this.msg = "Digite um email válido!";
                    }

                    //Sintaxe do Email Correta
                    else {
                            //Chama API que verifica se este usuário já está cadastrado
                            __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client_js__["a" /* default */].ExisteUsuario(_this.email).then(function (resposta) {
                                if (resposta.Msg == "Existe") {
                                    _this.EmailConfirmado = false;
                                    _this.msg = "Esse email já foi cadastrado no sistema!";
                                } else {
                                    //Chamar API que faz a validação do Email
                                    __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client_js__["a" /* default */].theCheckerPost(_this.email).then(function (resposta) {

                                        if (resposta == "Entregável") {
                                            //Executa se o email for válido
                                            _this.EmailConfirmado = true;
                                            _this.msg = "Email Validado com Sucesso!";
                                        }

                                        if (resposta == "Inválido") {
                                            //Executa se o email for inválido
                                            _this.EmailConfirmado = false;
                                            _this.msg = "Email Inválido!";
                                        }
                                    }).catch(function () {
                                        _this.EmailConfirmado = true;
                                        _this.msg = "Email Validado com Sucesso!";
                                    }); //Fim Validação TheChecker
                                }
                            }).catch(function () {
                                _this.EmailConfirmado = true;
                                _this.msg = "Email Validado com Sucesso!";
                            }); //Fim Existe Usuário
                        }
                }).catch(function () {
                    _this.EmailConfirmado = true;
                    _this.msg = "Email Validado com Sucesso!";
                }); //Fim Validação Email
            }
        },
        signUp: function signUp() {
            var _this2 = this;

            this.$store.dispatch('signup', { name: this.name, email: this.email, password: this.password }).then(function () {
                _this2.$router.push("/cadastro-concluido-com-sucesso");
            }).catch(function (error) {
                var errorMessages = error.response.data.errors.map(function (error) {
                    return error.detail;
                });
                alert(errorMessages);
            });

            // CADASTRA CONTATO EM ACTIVE CAMPAIN
            __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client_js__["a" /* default */].CadastrarActive(this.email);
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/landing-page/seja-um-investidor-iouu/ ',
                title: 'Seja um investidor IOUU'
            });
        }
    },
    created: function created() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (_this3.$route.query.name) _this3.name = _this3.$route.query.name;

                            if (_this3.$route.query.email) _this3.email = _this3.$route.query.email;

                            if (_this3.$route.query.v) _this3.visivel = true;

                            //tagueamento GA
                            _context.next = 5;
                            return _this3.taggingGA();

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this3);
        }))();
    }
});

/***/ }),

/***/ "CR9D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10 col-xl-10"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-10 col-xl-10"},[_vm._m(0),_vm._v(" "),_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"card",staticStyle:{"width":"30rem","margin":"0 auto 30px auto"}},[_c('div',{staticClass:"card-body text-center"},[_c('p',{staticClass:"card-text"},[_vm._v("Confirmo que as informações fornecidas são verdadeiras e que devo atualizá-las caso haja alterações e sempre que for solicitado.")]),_vm._v(" "),_c('div',{staticClass:"form-check d-flex justify-content-center"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Aceite),expression:"Aceite"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"chkAceite"},domProps:{"checked":Array.isArray(_vm.Aceite)?_vm._i(_vm.Aceite,null)>-1:(_vm.Aceite)},on:{"change":function($event){var $$a=_vm.Aceite,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.Aceite=$$a.concat([$$v]))}else{$$i>-1&&(_vm.Aceite=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.Aceite=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":_vm.verificaPreenchimento()}},[_vm._v("Submeter respostas "),_c('i',{staticClass:"fas fa-check"})])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('img',{staticStyle:{"margin-bottom":"40px","width":"60px"},attrs:{"src":"/static/assets/images/ico-file.svg","alt":"icone arquivo"}}),_vm._v(" "),_c('h1',[_vm._v("Confirmação do seu Perfil de Investimento")]),_vm._v(" "),_c('p',[_vm._v("Se houver diferença entre o nível de capacidade de risco (item 1) e tolerância ao risco (item 2), o menor resultado entre eles será considerado como o seu Perfil de Risco.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"form-check-label",attrs:{"for":"chkAceite"}},[_c('strong',[_vm._v("ACEITAR")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CVSu":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgOCAxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgOCAxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8cG9seWxpbmUgY2xhc3M9InN0MCIgcG9pbnRzPSIxLjksMS4xIDcsNiAxLjksMTAuOSAJIi8+CjwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "CXq+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finshedLoading)?_c('div',{staticClass:"row finish-investment"},[(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"tit_page"},[_c('h2',[_vm._v("\n                            Pagamento\n                        ")]),_vm._v(" "),_c('div',{staticClass:"cliearfix"}),_vm._v(" "),_c('hr',{staticClass:"divider"})])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"bordered"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"70"}},[_vm._v("\n                                        Score\n                                    ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"120"}},[_vm._v("\n                                        ID\n                                    ")]),_vm._v(" "),_c('th',{staticClass:"align-middle",attrs:{"scope":"col"}},[_vm._v("\n                                        Tomador\n                                    ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"150"}},[_vm._v("\n                                        Rendimento\n                                    ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n                                        Valor do investimento\n                                    ")])])]),_vm._v(" "),_c('tbody',[(_vm.solicitacao != null)?_c('tr',{staticClass:"rating-aa",class:this.ScoreClass(this.score)},[_c('td',{staticClass:"rating align-middle text-center"},[_c('span',{staticClass:"circle side-circle"}),_vm._v(" "+_vm._s(_vm.score)+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        "+_vm._s(_vm.idOportunidade)+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("\n                                        "+_vm._s(_vm.NomeTomador)+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        "+_vm._s(_vm.Rendimento)+"% a.a\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        "+_vm._s(_vm.formatCurrency(this.reserva.Valor))+"\n                                    ")])]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-12 col-lg-offset-5 col-lg-10"},[_c('div',{staticClass:"td-total"},[_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"align-middle"},[_vm._v("\n                                            Total à Pagar:\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-right"},[_vm._v("\n                                            "+_vm._s(_vm.ValorBoleto)+"\n                                        ")])])])])])])])])])]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"white col-12 col-lg-6 col-xl-6"},[_c('div',{staticClass:"box-col box-col-table"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"align-middle text-left",attrs:{"scope":"col","width":"350"}},[_vm._v("\n                                    "+_vm._s(_vm.idOportunidade)+" - "+_vm._s(_vm.NomeTomador)+"\n                                ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-right",attrs:{"scope":"col"}},[_vm._v("\n                                    "+_vm._s(_vm.formatCurrency(this.reserva.Valor))+"\n                                ")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                    Total à Pagar\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-right"},[_vm._v("\n                                    "+_vm._s(_vm.ValorBoleto)+"\n                                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-img-top card-background",class:this.ScoreClass(this.score)},[_c('div',{staticClass:"badge badge-id"},[_vm._v("ID: "+_vm._s(_vm.idOportunidade))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.NomeTomador))]),_vm._v(" "),_c('div',{staticClass:"rating"},[_c('span',{staticClass:"circle"},[_vm._v(_vm._s(_vm.score))])])]),_vm._v(" "),_c('div',{staticClass:"card-body",class:this.ScoreClass(this.score)},[_c('dt',[_vm._v("Valor Investimento")]),_vm._v(" "),_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm.formatCurrency(this.reserva.Valor)))]),_vm._v(" "),_c('dd',[_c('p',{staticClass:"small"},[_vm._v("Total à Pagar:\n                                "),_c('strong',[_vm._v(_vm._s(_vm.ValorBoleto))])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer d-flex justify-content-between"},[_c('div',{staticClass:"tax"},[_c('strong',[_vm._v("Rendimento")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.Rendimento)+"% a.a")])])])])]),_vm._v(" "),_c('div',{staticClass:"gray col-12 col-lg-6 col-xl-6"},[_c('div',{staticClass:"box-col box-col-list"},[_c('ul',[_c('li',[_vm._v("\n                            Dados do investidor\n                        ")]),_vm._v(" "),_c('li',[_vm._v("\n                            "+_vm._s(_vm.NomeCompleto)+"\n                        ")]),_vm._v(" "),_c('li',[_vm._v("\n                            "+_vm._s(_vm.FormatedAddress)+"\n                        ")]),_vm._v(" "),_c('li',[_vm._v("\n                            "+_vm._s(_vm.Cep)+"\n                        ")]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/investimentos/perfil/editar-perfil"}},[_vm._v("\n                                Alterar endereço do investidor\n                            ")])],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"ticket-payment"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6 col-lg-3 total-value"},[_c('h5',[_vm._v("\n                        Total à Pagar: "+_vm._s(_vm.ValorBoleto)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-3"},[(_vm.feat_abc != 'true' && this.reserva.Status == 1)?_c('a',{staticClass:"btn btn-primary btn-submit",attrs:{"href":this.reserva.Boleto.secure_url,"target":"_blank","disabled":_vm.verificaBoleto()}},[_vm._v("\n                        pagar boleto\n                    ")]):(this.boleto.Status == 'pending')?_c('a',{staticClass:"btn btn-primary btn-submit",attrs:{"href":_vm.boletoUrl,"target":"_blank","disabled":_vm.verificaBoleto()}},[_vm._v("\n                        pagar boleto\n                    ")]):_vm._e(),_vm._v(" "),(_vm.verificaBoleto())?_c('p',{staticClass:"small"},[_vm._v("*Boleto pago")]):_vm._e()]),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_vm._m(4)],1):(_vm.finshedLoadingNot)?_c('div',{staticClass:"d-flex justify-content-center align-items-center fish-investiment"},[_vm._m(5)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"tit_page"},[_c('h1',[_vm._v("\n                Pagamento\n            ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('hr',{staticClass:"divider"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sec_tit text-left"},[_c('h2',[_vm._v("\n                    Forma de pagamento\n                    "),_c('span',[_vm._v("\n                        BOLETO BANCÁRIO\n                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6 col-lg-4"},[_c('p',[_c('i',{staticClass:"icon icon-printer-2 xl"}),_vm._v("\n                        Imprima o boleto e "),_c('span',[_vm._v(" pague no banco ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4"},[_c('p',[_c('i',{staticClass:"icon icon-gedgets xl"}),_vm._v(" "),_c('span',[_vm._v(" ou pague pela internet ")]),_vm._v(" utilizando o código de barras do boleto\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4"},[_c('p',[_c('i',{staticClass:"icon icon-calendar-2 xl"}),_vm._v("\n                        o prazo de validade do boleto é de "),_c('span',[_vm._v(" 1 dia útil ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-3"},[_c('p',[_vm._v("\n                        Pagamento seguro "),_c('span',[_vm._v("IOUU")]),_vm._v(" "),_c('i',{staticClass:"icon icon-lock-2 md"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('ul',{staticClass:"footer-note"},[_vm._v("\n            Importante:\n            "),_c('li',[_c('p',[_c('i',{staticClass:"fas fa-circle"}),_vm._v("\n                    Caso o seu computador tenha um programa anti pop-up, será preciso desativá-lo antes de finalizar seu investimento e imprimir o boleto ou pagar pelo internet banking;\n                ")])]),_vm._v(" "),_c('li',[_c('p',[_c('i',{staticClass:"fas fa-circle"}),_vm._v("\n                Não faça depósito ou transferência entre contas. O boleto não é enviado pelos Correios. Imprima-o e pague-o no banco ou pela internet;\n                ")])]),_vm._v(" "),_c('li',[_c('p',[_c('i',{staticClass:"fas fa-circle"}),_vm._v("\n                Se o boleto não for pago até a data de vencimento, a reserva de investimento será automaticamente cancelada;\n                ")])]),_vm._v(" "),_c('li',[_c('p',[_c('i',{staticClass:"fas fa-circle"}),_vm._v("\n                    A confirmação do seu investimento pago com boleto bancário começa a contar três dias depois do pagamento do boleto, tempo necessário para que a instituição bancária confirme o pagamento.\n                ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("\n                Finalização de pagamento\n            ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cd2i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPageInvista_vue__ = __webpack_require__("9CDi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a27f89_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPageInvista_vue__ = __webpack_require__("yex4");
function injectStyle (ssrContext) {
  __webpack_require__("tz5f")
  __webpack_require__("27B6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52a27f89"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPageInvista_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a27f89_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPageInvista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cenr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preapproved_vue__ = __webpack_require__("4Hrp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad4c8ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preapproved_vue__ = __webpack_require__("WQsj");
function injectStyle (ssrContext) {
  __webpack_require__("OjIE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ad4c8ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preapproved_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad4c8ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preapproved_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cgk/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_vm._m(0),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"card",staticStyle:{"width":"40rem","margin":"0 auto 30px auto"}},[_c('div',{staticClass:"card-body text-center"},[_c('p',{staticClass:"card-text"},[_vm._v("Confirmo que as informações e documentos fornecidos são verdadeiros e concordo expressamente com o inteiro teor dos "),_c('a',{attrs:{"href":_vm.lpUrl+'/termos-de-uso-e-condicoes-para-investidores/',"title":"Termos e Condições para investidores"}},[_vm._v("Termos e Condições Para Investidores")]),_vm._v(" e "),_c('a',{attrs:{"href":_vm.lpUrl+'/politica-de-privacidade/',"title":"Política de Privacidade"}},[_vm._v("Politica de Privacidade")]),_vm._v(", ficando desde já obrigado e sujeito aos direitos e obrigações oriundos dos instrumentos.")]),_vm._v(" "),_c('div',{staticClass:"form-check d-flex justify-content-center"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.acceptContract),expression:"acceptContract"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"exampleCheck1"},domProps:{"checked":Array.isArray(_vm.acceptContract)?_vm._i(_vm.acceptContract,null)>-1:(_vm.acceptContract)},on:{"change":function($event){var $$a=_vm.acceptContract,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.acceptContract=$$a.concat([$$v]))}else{$$i>-1&&(_vm.acceptContract=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.acceptContract=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":!_vm.acceptContract}},[_vm._v("Enviar "),_c('i',{staticClass:"fas fa-check"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('img',{staticStyle:{"margin-bottom":"40px","width":"60px"},attrs:{"src":"/static/assets/images/ico-file.svg","alt":"icone arquivo"}}),_vm._v(" "),_c('h1',[_vm._v("Confirmação do cadastro de investidor")]),_vm._v(" "),_c('p',[_vm._v("Esse é o último passo do seu cadastro de investidor. Caso queira, pode voltar e corrigir os dados informados anteriormente antes de clicar em enviar.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleCheck1"}},[_c('strong',[_vm._v("CONFIRMO E CONCORDO")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ch5J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_map__ = __webpack_require__("nSPF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_assets_images_bancos_ico_bb_png__ = __webpack_require__("yoNT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_assets_images_bancos_ico_bb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_assets_images_bancos_ico_bb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_assets_images_bancos_ico_caixa_png__ = __webpack_require__("MaQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_assets_images_bancos_ico_caixa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_assets_images_bancos_ico_caixa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_assets_images_bancos_ico_itau_png__ = __webpack_require__("XG7f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_assets_images_bancos_ico_itau_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_assets_images_bancos_ico_itau_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_assets_images_bancos_ico_bradesco_png__ = __webpack_require__("3Lo/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_assets_images_bancos_ico_bradesco_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_assets_images_bancos_ico_bradesco_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_assets_images_bancos_ico_santander_png__ = __webpack_require__("Qwbv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_assets_images_bancos_ico_santander_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_assets_images_bancos_ico_santander_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_assets_images_bancos_ico_neon_png__ = __webpack_require__("6vG/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_assets_images_bancos_ico_neon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_assets_images_bancos_ico_neon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_assets_images_bancos_ico_inter_png__ = __webpack_require__("YZjq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_assets_images_bancos_ico_inter_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_assets_images_bancos_ico_inter_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_assets_images_bancos_ico_pagseguro_png__ = __webpack_require__("Tn66");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_assets_images_bancos_ico_pagseguro_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_assets_images_bancos_ico_pagseguro_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_assets_images_bancos_ico_nubank_png__ = __webpack_require__("Mw2E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_assets_images_bancos_ico_nubank_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__static_assets_images_bancos_ico_nubank_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_assets_images_bancos_ico_sicredi_png__ = __webpack_require__("tcXY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_assets_images_bancos_ico_sicredi_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__static_assets_images_bancos_ico_sicredi_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_assets_images_bancos_ico_brb_png__ = __webpack_require__("xIpc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_assets_images_bancos_ico_brb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__static_assets_images_bancos_ico_brb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_assets_images_bancos_ico_sicoob_png__ = __webpack_require__("m//o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_assets_images_bancos_ico_sicoob_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__static_assets_images_bancos_ico_sicoob_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_assets_images_bancos_ico_viacredi_png__ = __webpack_require__("rhLV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_assets_images_bancos_ico_viacredi_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__static_assets_images_bancos_ico_viacredi_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_assets_images_bancos_ico_barisul_png__ = __webpack_require__("GDvA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_assets_images_bancos_ico_barisul_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__static_assets_images_bancos_ico_barisul_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_assets_images_bancos_ico_original_png__ = __webpack_require__("Qj3b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_assets_images_bancos_ico_original_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__static_assets_images_bancos_ico_original_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_assets_images_bancos_ico_stone_svg__ = __webpack_require__("togB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_assets_images_bancos_ico_stone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__static_assets_images_bancos_ico_stone_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_es6_promise__ = __webpack_require__("hKoQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_the_mask__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






















var Moip = window.Moip;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      bankCode: this.bankData.bankCode ? this.bankData.bankCode : '001',
      agency: this.bankData.agency,
      agencyDigit: this.bankData.agency,
      account: this.bankData.account,
      accountType: this.bankData.accountType,
      banks: [],
      selectedBank: { codigo: '001', nome: 'Banco do Brasil S.A.', logo: __WEBPACK_IMPORTED_MODULE_2__static_assets_images_bancos_ico_bb_png___default.a, agencia: '####-#', conta: '########-#', placeholderAgencia: "0000-0", placeholderConta: "00000000-0" },
      mainBanks: [{ codigo: '001', nome: 'Banco do Brasil S.A.', logo: __WEBPACK_IMPORTED_MODULE_2__static_assets_images_bancos_ico_bb_png___default.a, agencia: '####-#', conta: '########-#', placeholderAgencia: "0000-0", placeholderConta: "00000000-0" }, { codigo: '033', nome: 'Banco Santander (Brasil) S.A.', logo: __WEBPACK_IMPORTED_MODULE_6__static_assets_images_bancos_ico_santander_png___default.a, agencia: '####', conta: '########-#', placeholderAgencia: "0000", placeholderConta: "0000000-0" }, { codigo: '104', nome: 'Caixa Econômica Federal', logo: __WEBPACK_IMPORTED_MODULE_3__static_assets_images_bancos_ico_caixa_png___default.a, agencia: '####', conta: '#############-#', placeholderAgencia: "0000", placeholderConta: "XXXX 000000000-0" }, { codigo: '237', nome: 'Banco Bradesco S.A.', logo: __WEBPACK_IMPORTED_MODULE_5__static_assets_images_bancos_ico_bradesco_png___default.a, agencia: '####-#', conta: '#######-#', placeholderAgencia: "0000-0", placeholderConta: "0000000-0" }, { codigo: '341', nome: 'Itaú Unibanco S.A.', logo: __WEBPACK_IMPORTED_MODULE_4__static_assets_images_bancos_ico_itau_png___default.a, agencia: '####', conta: '#####-#', placeholderAgencia: "0000", placeholderConta: "00000-0" }, { codigo: '041', nome: 'Banco Banrisul', logo: __WEBPACK_IMPORTED_MODULE_15__static_assets_images_bancos_ico_barisul_png___default.a, agencia: '####', conta: '#########-#', placeholderAgencia: "0000", placeholderConta: "000000000-0" }, { codigo: '748', nome: 'Sicredi', logo: __WEBPACK_IMPORTED_MODULE_11__static_assets_images_bancos_ico_sicredi_png___default.a, agencia: '####', conta: '######', placeholderAgencia: "0000", placeholderConta: "000000" }, { codigo: '756', nome: 'Sicoob', logo: __WEBPACK_IMPORTED_MODULE_13__static_assets_images_bancos_ico_sicoob_png___default.a, agencia: '####', conta: '#########-#', placeholderAgencia: "0000", placeholderConta: "000000000-0" }, { codigo: '077', nome: 'Banco Intermedium S.A.', logo: __WEBPACK_IMPORTED_MODULE_8__static_assets_images_bancos_ico_inter_png___default.a, agencia: '####', conta: '#########-#', placeholderAgencia: "0000", placeholderConta: "000000000-0" }, { codigo: '070', nome: 'BRB', logo: __WEBPACK_IMPORTED_MODULE_12__static_assets_images_bancos_ico_brb_png___default.a, agencia: '####', conta: '#########-#', placeholderAgencia: "0000", placeholderConta: "000000000-0" }, { codigo: '085', nome: 'Via Credi', logo: __WEBPACK_IMPORTED_MODULE_14__static_assets_images_bancos_ico_viacredi_png___default.a, agencia: '####', conta: '###########-#', placeholderAgencia: "0000", placeholderConta: "00000000000-0" }, { codigo: '655', nome: 'Banco Neon', logo: __WEBPACK_IMPORTED_MODULE_7__static_assets_images_bancos_ico_neon_png___default.a, agencia: '####', conta: '#######-#', placeholderAgencia: "0000", placeholderConta: "0000000-0" }, { codigo: '260', nome: 'NuBank', logo: __WEBPACK_IMPORTED_MODULE_10__static_assets_images_bancos_ico_nubank_png___default.a, agencia: '####', conta: '#######-#', placeholderAgencia: "0000", placeholderConta: "0000000-0" }, { codigo: '290', nome: 'PagSeguro', logo: __WEBPACK_IMPORTED_MODULE_9__static_assets_images_bancos_ico_pagseguro_png___default.a, agencia: '####', conta: '########-#', placeholderAgencia: "0000", placeholderConta: "00000000-0" }, { codigo: '212', nome: 'Banco Original', logo: __WEBPACK_IMPORTED_MODULE_16__static_assets_images_bancos_ico_original_png___default.a, agencia: '####', conta: '#####-#', placeholderAgencia: "0000", placeholderConta: "00000-0" }, { codigo: '197', nome: 'Stone Pagamentos S.A.', logo: __WEBPACK_IMPORTED_MODULE_17__static_assets_images_bancos_ico_stone_svg___default.a, agencia: '####', conta: '#######-#', placeholderAgencia: "0000", placeholderConta: "0000000-0" }]
    };
  },

  directives: { mask: __WEBPACK_IMPORTED_MODULE_20_vue_the_mask__["mask"] },
  props: {
    bankData: { required: true, type: Object }
  },
  computed: {
    isOtherBank: {
      get: function get() {
        var _this = this;

        return this.mainBanks.find(function (bank) {
          return bank.codigo == _this.bankCode;
        }) == null;
      },
      set: function set() {
        this.bankCode = '';
      }
    }
  },
  methods: {
    aoMudarEhOutroBanco: function aoMudarEhOutroBanco() {
      this.bankCode = '';
    },
    submeterSemConta: function submeterSemConta() {
      var newData = {
        bankData: null,
        hasNoAccount: true
      };
      this.$emit('submit', newData);
    },
    trimBankAccountStart: function trimBankAccountStart(account, maxNumCount) {
      var splitedAccount = account.split("-");

      var len = splitedAccount.length > 1 ? splitedAccount[0].length + splitedAccount[1].length : splitedAccount[0].length;

      console.log('Len: ' + len);

      var zeroCount = maxNumCount - len;
      var leftZero = '';

      for (var i = 0; i <= zeroCount; i++) {
        leftZero += '0';
      }

      var result = leftZero + account;
      console.log("leftZero + account: " + result);

      if (splitedAccount.length <= 1) {
        var hifen = result.length;

        result = result.slice(0, hifen - 1) + '-' + result.slice(hifen - 1);
        console.log('result: ' + result);
      }

      return result;
    },
    trimBankAgencyStart: function trimBankAgencyStart(agency, maxNumCount) {
      var splitedAgency = agency.split("-");

      var len = splitedAgency.length > 1 ? splitedAgency[0].length + splitedAgency[1].length : splitedAgency[0].length;

      console.log('Len: ' + len);

      var zeroCount = maxNumCount - len;
      var leftZero = '';

      for (var i = 0; i <= zeroCount; i++) {
        leftZero += '0';
      }

      var result = leftZero + agency;
      console.log("leftZero + agency: " + result);

      if (maxNumCount === 4 && splitedAgency.length <= 1) {
        var hifen = result.length;

        result = result.slice(0, hifen - 1) + '-' + result.slice(hifen - 1);
        console.log('result: ' + result);
      }

      return result;
    },
    validate: function validate() {
      var _this2 = this;

      var agencyCheckNumber = '';

      if (this.bankCode == '001' || this.bankCode == '237') {
        // if(this.agency.split("-").length == 1) {
        //   var len = this.agency.length;
        //   this.agency = this.agency.slice(0, len - 1) + '-' + this.agency.slice(len - 1);
        // }

        // //banco do brasil e bradesco possuem dígito na agência

        this.agency = this.trimBankAgencyStart(this.agency, 4);
        agencyCheckNumber = this.agency.split("-")[1];
      } else this.agency = this.trimBankAgencyStart(this.agency, 3);

      if (this.bankCode == '748') {
        var accountNumberDigit = this.account[this.account.length - 1];
      }

      if (this.bankCode == '001' || this.bankCode == '033') this.account = this.trimBankAccountStart(this.account, 8);else if (this.bankCode == '237') this.account = this.trimBankAccountStart(this.account, 7);else if (this.bankCode == '341') this.account = this.trimBankAccountStart(this.account, 5);else this.account = this.trimBankAccountStart(this.account, 11);

      console.log("AG ", agencyCheckNumber);

      return new __WEBPACK_IMPORTED_MODULE_18_es6_promise___default.a(function (resolve) {
        Moip.BankAccount.validate({
          bankNumber: _this2.bankCode,
          agencyNumber: _this2.agency.split("-")[0],
          agencyCheckNumber: agencyCheckNumber,
          accountNumber: _this2.account.split("-")[0],
          accountCheckNumber: accountNumberDigit ? accountNumberDigit : _this2.account.split("-")[1],
          valid: function valid() {
            resolve({ isValid: true, errors: [] });
          },
          invalid: function invalid(data) {
            var errors = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_map___default()(data.errors, function (error) {
              return error.description;
            });
            resolve({ isValid: false, errors: errors });
          }
        });
      });
    },
    submit: function submit() {
      var _this3 = this;

      this.validate().then(function (validation) {
        if (validation.isValid) {
          var newData = {
            bankCode: _this3.bankCode,
            agency: _this3.agency,
            account: _this3.account,
            accountType: _this3.accountType,
            hasNoAccount: false
          };

          _this3.$emit('submit', newData);
        } else {
          _this3.$Notify.error({
            title: "Dados Inválidos",
            message: validation.errors.map(function (error) {
              return error.replace(/\.\s([A-Z])/, function (match, cg1) {
                return ', ' + cg1.toLowerCase();
              });
            }).join(' ')
          });
        }
      });
    }
  },
  watch: {
    bankCode: function bankCode(newValue) {
      var Bank = this.mainBanks.filter(function (bank) {
        return newValue == bank.codigo;
      });
      console.log(Bank[0].agencia);
      this.agency = '';
      this.account = '';
      this.selectedBank = Bank[0];
    }
  },
  beforeCreate: function beforeCreate() {
    var _this4 = this;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_19__store_mutation_types_js__["c" /* START_LOADING */]);
    __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarBancos().then(function (banks) {
      _this4.banks = banks;
      _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_19__store_mutation_types_js__["d" /* STOP_LOADING */]);
      _this4.banks = _this4.mainBanks;
      if (_this4.bankData.bankCode) {
        _this4.selectedBank = _this4.banks.filter(function (bank) {
          return bank.codigo == _this4.bankData.bankCode;
        })[0];
      }
    }).catch(function (error) {
      console.log("Error", error);
      _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_19__store_mutation_types_js__["d" /* STOP_LOADING */]);
    });
  }
});

/***/ }),

/***/ "Ci7f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_client_go__ = __webpack_require__("879M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_Calculos__ = __webpack_require__("SuNK");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






/* harmony default export */ __webpack_exports__["a"] = ({
	mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_Calculos__["a" /* default */]],
	components: {},
	data: function data() {
		return {
			ccbUrl: "https://bmpdigital.moneyp.com.br/",
			carregado: false,
			ReservaInvestimento: {
				SolicitacaoId: {}
			},
			reservaInvId: {},
			valorParcela: 0,
			faturas: null
		};
	},


	computed: {
		id: function id() {
			return this.ajustIdOportunidade(this.ReservaInvestimento.SolicitacaoId.IdOportunidade, 5);
		},
		CalcularValor: function CalcularValor() {
			return this.ReservaInvestimento.SolicitacaoId.ValorParcela == 0 ? this.formatCurrency(this.ReservaInvestimento.SolicitacaoId.Valor / this.ReservaInvestimento.SolicitacaoId.Prazo) : this.formatCurrency(this.ReservaInvestimento.SolicitacaoId.ValorParcela);
		},
		companyFacebook: function companyFacebook() {
			return this.ReservaInvestimento.SolicitacaoId.Empresa.Facebook;
		},
		companyTwitter: function companyTwitter() {
			return this.ReservaInvestimento.SolicitacaoId.Empresa.Twitter;
		},
		companyLinkedin: function companyLinkedin() {
			return this.ReservaInvestimento.SolicitacaoId.Empresa.Linkedin;
		},
		companyInstagram: function companyInstagram() {
			return this.ReservaInvestimento.SolicitacaoId.Empresa.Instagram;
		},
		companyVimeo: function companyVimeo() {
			return this.ReservaInvestimento.SolicitacaoId.Empresa.Vimeo;
		}
	},
	methods: {
		formatarTipoEmprestimo: function formatarTipoEmprestimo(tipoEmprestimo) {
			if (tipoEmprestimo == "emprestimo-ccb") {
				return "Empréstimo CCB";
			}
			if (tipoEmprestimo == "emprestimo-coletivo") {
				return "Empréstimo Coletivo";
			}

			if (tipoEmprestimo == "emprestimo-de-impacto" || tipoEmprestimo == "emprestimo-de-impacto2") {
				return "Empréstimo de Impacto";
			}

			if (tipoEmprestimo == "veiculo-em-garantia") {
				return "Empréstimo com Garantia Veicular";
			}

			if (tipoEmprestimo == "imovel-em-garantia") {
				return "Empréstimo com Garantia Imobiliária";
			}

			if (tipoEmprestimo == "antecipacao-recebiveis") {
				return "Antecipação de Recebíveis";
			}

			return tipoEmprestimo;
		},
		ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
			var s = String(id);
			while (s.length < (qtd || 2)) {
				s = "0" + s;
			}
			return s;
		},
		formatCurrency: function formatCurrency(value) {
			if (value == null || value == undefined) {
				return parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
			}

			return value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
		},
		formatInt: function formatInt(value) {
			if (value == null || value == undefined) {
				return parseInt(0).toLocaleString('pt-BR', { minimumFractionDigits: "0", maximumFractionDigits: 0 });
			}
			return value.toLocaleString('pt-BR', { minimumFractionDigits: "0", maximumFractionDigits: 0 });
		},
		formatarCnpj: function formatarCnpj(cnpj) {
			return __WEBPACK_IMPORTED_MODULE_6__utils_masker__["a" /* default */].maskCnpj(cnpj);
		},
		getFaturaStatusClass: function getFaturaStatusClass(boleto) {
			var cls = void 0;
			var stringDate = boleto.Boleto.due_date;
			var spliter = stringDate.split("-");
			var boletoDate = new Date(spliter[0], spliter[1] - 1, spliter[2], 23, 59, 59);
			var today = new Date();
			var status = boleto.StatusBoleto;

			if (boletoDate < today && status !== "paid") {
				// Vencido
				cls = "vc";
			} else if (status === "" || status === undefined) {
				// Sem status
				cls = "ds";
			} else if (status === "pending") {
				// A vencer
				cls = "av";
			} else if (status === "paid") {
				// Quitado
				cls = "qt";
			}

			return cls;
		},
		formatDate: function formatDate(date) {
			var dateArray = date.split('-');
			var day = dateArray[2];
			var month = dateArray[1];
			var year = dateArray[0];

			return day + "/" + month + "/" + year;
		},
		lowerCase: function lowerCase(texto) {
			if (texto == null || texto == undefined || texto == "") return "a";

			if (texto == "AA" || texto == "HR") return texto.toLowerCase();

			return texto.substr(0, 1).toLowerCase();
		},
		formatData: function formatData(data) {
			var date = new Date(data);
			return date.toLocaleDateString('pt-BR');
		},

		//tagueamento GA
		taggingGA: function taggingGA() {
			this.$ga.page({
				page: '/historico/historico-de-investimento/:id',
				title: 'HistoricoInvestimento'
			});
		}
	},
	created: function created() {
		var _this = this;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_this.reservaInvId = _this.$route.params.id;

							if (window.location.href.indexOf("dashboard-app") != -1) _this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["c" /* START_LOADING */]);
							__WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getReservaSolicitacao(_this.$route.params.id).then(function (loanRequest) {
								_this.ReservaInvestimento = loanRequest;
								_this.carregado = true;
								if (_this.ReservaInvestimento.SolicitacaoId.RetornoBrutoMensal == undefined) {
									_this.ReservaInvestimento.SolicitacaoId.RetornoBrutoMensal = 0;
								}
								return '';
							}).then(function () {
								return __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getFaturas(_this.ReservaInvestimento.SolicitacaoId._id);
							}).then(function (faturas) {
								var valorParcela = void 0;
								if (_this.ReservaInvestimento.SolicitacaoId.Alongamento) {
									return __WEBPACK_IMPORTED_MODULE_3__utils_api_client_go__["a" /* default */].tabelaValoresInvestidores(_this.ReservaInvestimento.SolicitacaoId._id, _this.ReservaInvestimento._id).then(function (resp) {
										for (var i = 0; i < faturas.length; i++) {
											faturas[i] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, faturas[i], { valorParcela: resp.data.tabela.TabelaPrice[i].Parcela.toFixed(2) });
										}
										_this.faturas = faturas;
										_this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
										return '';
									}).catch(function (e) {
										console.log(e);
										_this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
									});
								} else {
									valorParcela = _this.PMT(_this.ReservaInvestimento.Valor, _this.ReservaInvestimento.SolicitacaoId.RetornoBrutoMensal / 100, _this.ReservaInvestimento.SolicitacaoId.Prazo);
									for (var i = 0; i < faturas.length; i++) {
										faturas[i] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, faturas[i], { valorParcela: valorParcela });
									}
									_this.faturas = faturas;
									_this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
									return '';
								}
							}).catch(function () {
								_this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
							});

							//tagueamento GA
							_context.next = 5;
							return _this.taggingGA();

						case 5:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this);
		}))();
	}
});

/***/ }),

/***/ "Coh1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CrJb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var pessoal = this.currentUser.Pessoal;
    return {
      fullName: pessoal ? pessoal.NomeCompleto : null
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    validate: function validate() {
      if (this.fullName.indexOf(" ") > 0 && this.currentUser.Pessoal.NomeCompletoMae.indexOf(" ") > 0) {
        return { isValid: true, errors: ['É obrigatório o envio do nome completo'] };
      } else {
        return { isValid: false, errors: ['É obrigatório o envio do nome completo'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var validation = this.validate();

      if (validation.isValid) {
        this.currentUser.Pessoal.NomeCompleto = this.fullName;
        this.$emit('on-submit', { Pessoal: this.currentUser.Pessoal });
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_0__utils_array_helper__["a" /* default */].toSentence(validation.errors)
        });
      }
    },
    AlterarNome: function AlterarNome(event) {

      var texto = event.target.value;

      var textoFinal = "";
      texto = texto.toLowerCase();

      if (texto.length > 0) {
        textoFinal = texto.substr(0, 1).toUpperCase();

        for (var i = 1; i < texto.length; i++) {
          if (texto.substr(i - 1, 1) == " ") {
            textoFinal += texto.substr(i, 1).toUpperCase();
          } else {
            textoFinal += texto.substr(i, 1);
          }
        }
      }

      event.target.value = textoFinal;
    }
  },
  created: function created() {
    if (!this.currentUser.Pessoal) this.currentUser.Pessoal = {};
  }
});

/***/ }),

/***/ "CuWB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"celular"}},[_vm._v("Número de funcionários")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.QuantidadeEmpregados),expression:"QuantidadeEmpregados",modifiers:{"number":true}},{name:"mask",rawName:"v-mask",value:('integer'),expression:"'integer'"},{name:"focus",rawName:"v-focus"}],staticClass:"form-control form-control-lg",attrs:{"type":"text"},domProps:{"value":(_vm.QuantidadeEmpregados)},on:{"input":function($event){if($event.target.composing){ return; }_vm.QuantidadeEmpregados=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Quantos funcionários a empresa possui?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D5Wh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagamento_vue__ = __webpack_require__("B5tC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7d6578_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagamento_vue__ = __webpack_require__("xx6E");
function injectStyle (ssrContext) {
  __webpack_require__("79P2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a7d6578"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagamento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7d6578_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagamento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DC4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentIndex: 0,
      transitionName: 'slide-left'
    };
  },

  props: {
    pictures: { type: Array, required: true }
  },
  computed: {
    currentPicture: function currentPicture() {
      return this.pictures[this.currentIndex];
    },
    canGoPrevious: function canGoPrevious() {
      return this.currentIndex > 0;
    },
    canGoNext: function canGoNext() {
      return this.currentIndex < this.pictures.length - 1;
    }
  },
  methods: {
    goPrevious: function goPrevious() {
      this.transitionName = 'slide-right';
      if (this.canGoPrevious) this.currentIndex -= 1;
    },
    goNext: function goNext() {
      this.transitionName = 'slide-left';
      if (this.canGoNext) this.currentIndex += 1;
    }
  }
});

/***/ }),

/***/ "DJzd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_for_each__ = __webpack_require__("mKqZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_for_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_for_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AdditionalInformationPeerToPeer_GuarantorsStep_PersonFields__ = __webpack_require__("Sv9X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AdditionalInformationPeerToPeer_GuarantorsStep_CompanyFields__ = __webpack_require__("whwM");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var COMPANY_TYPE_MEI = 1;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PersonFields: __WEBPACK_IMPORTED_MODULE_4__components_AdditionalInformationPeerToPeer_GuarantorsStep_PersonFields__["a" /* default */], CompanyFields: __WEBPACK_IMPORTED_MODULE_5__components_AdditionalInformationPeerToPeer_GuarantorsStep_CompanyFields__["a" /* default */] },
  data: function data() {
    var partners = this.solicitacao.Empresa.Avalistas || [];
    return {
      showPartnerType: false,
      avalistas: partners.map(function (partner) {
        return {
          Tipo: partner.Tipo,
          Nome: partner.Nome,
          Cpf: partner.Cpf,
          DataNascimento: partner.DataNascimento ? new Date(partner.DataNascimento).toLocaleDateString("pt-BR") : null,
          Escolaridade: partner.Escolaridade,
          EstadoCivil: partner.EstadoCivil,
          Celular: partner.Celular,
          Email: partner.Email,
          Site: partner.Site,
          Facebook: partner.Facebook,
          Linkedin: partner.Linkedin,
          NomeConjuge: partner.NomeConjuge,
          CpfConjuge: partner.CpfConjuge,
          CelularConjuge: partner.CelularConjuge,
          EmailConjuge: partner.EmailConjuge,
          EscolaridadeConjuge: partner.EscolaridadeConjuge,
          DataNascimentoConjuge: partner.DataNascimentoConjuge ? new Date(partner.DataNascimentoConjuge).toLocaleDateString("pt-BR") : null,
          RazaoSocial: partner.RazaoSocial,
          Cnpj: partner.Cnpj
        };
      }),
      isMei: this.solicitacao.Empresa.TipoEmpresa == COMPANY_TYPE_MEI,
      errors: []
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  computed: {
    stepTitle: function stepTitle() {
      if (this.avalistas.length == 1) {
        return "Os dados do avalista abaixo estão corretos?";
      } else {
        return "Os dados dos avalistas abaixo estão corretos?";
      }
    }
  },
  methods: {
    validate: function validate() {
      var hasEmptyFields = false;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_for_each___default()(this.avalistas, function (partner) {
        if (partner.Tipo == 1 && (partner.Nome == null || partner.Cpf == null || partner.Escolaridade == null, partner.EstadoCivil == null)) {
          hasEmptyFields = true;
        }
        if (partner.Tipo == 2 && (!partner.RazaoSocial || !partner.Cnpj)) {
          hasEmptyFields = true;
        }
      });

      var errors = hasEmptyFields ? ["Nessa etapa é obrigatório o preenchimento de todos as informações solicitadas"] : [];
      return { isValid: !hasEmptyFields, errors: errors };
    },
    onSubmit: function onSubmit(e) {
      var _this = this;

      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {
        //Trecho de código para atualizar os socios na parte de avalistas

        this.solicitacao.Empresa.Socios.filter(function (socio) {
          if (socio.EstadoCivil === 2 || socio.EstadoCivil === 5) return true;else return false;
        }).map(function (socio) {
          _this.avalistas.filter(function (avalista) {
            if (socio.Cpf == avalista.CpfConjuge && avalista.CpfConjuge == socio.Cpf || socio.Email == avalista.EmailConjuge && avalista.EmailConjuge == socio.Email) return true;else return false;
          }).map(function (avalista) {
            var dataNascAvalista = null;
            var dataNascAvalistaConjuge = null;

            if (avalista.DataNascimento !== null && avalista.DataNascimento !== undefined) {
              dataNascAvalista = new Date(avalista.DataNascimento.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"));
            }

            if (avalista.DataNascimentoConjuge !== null && avalista.DataNascimentoConjuge !== undefined) {
              dataNascAvalistaConjuge = new Date(avalista.DataNascimentoConjuge.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"));
            }
            var indexSocios = _this.solicitacao.Empresa.Socios.indexOf(socio);

            _this.solicitacao.Empresa.Socios[indexSocios].Nome = avalista.NomeConjuge;
            _this.solicitacao.Empresa.Socios[indexSocios].DataNascimento = dataNascAvalistaConjuge;
            _this.solicitacao.Empresa.Socios[indexSocios].Cpf = __WEBPACK_IMPORTED_MODULE_2__utils_masker__["a" /* default */].unmaskCpf(avalista.CpfConjuge);
            _this.solicitacao.Empresa.Socios[indexSocios].EstadoCivil = avalista.EstadoCivil;
            _this.solicitacao.Empresa.Socios[indexSocios].Escolaridade = avalista.EscolaridadeConjuge;
            _this.solicitacao.Empresa.Socios[indexSocios].Celular = avalista.CelularConjuge;
            _this.solicitacao.Empresa.Socios[indexSocios].Email = avalista.EmailConjuge;
            _this.solicitacao.Empresa.Socios[indexSocios].NomeConjuge = avalista.Nome;
            _this.solicitacao.Empresa.Socios[indexSocios].CpfConjuge = __WEBPACK_IMPORTED_MODULE_2__utils_masker__["a" /* default */].unmaskCpf(avalista.Cpf);
            _this.solicitacao.Empresa.Socios[indexSocios].DataNascimentoConjuge = dataNascAvalista;
            _this.solicitacao.Empresa.Socios[indexSocios].CelularConjuge = avalista.Celular;
            _this.solicitacao.Empresa.Socios[indexSocios].EmailConjuge = avalista.Email;
            _this.solicitacao.Empresa.Socios[indexSocios].EscolaridadeConjuge = avalista.Escolaridade;
          });
        });

        var newData = {
          Empresa: {
            Avalistas: this.avalistas.map(function (avalista) {
              var dataNascAvalista = null;
              var dataNascAvalistaConjuge = null;

              if (avalista.DataNascimento !== null && avalista.DataNascimento !== undefined) {
                dataNascAvalista = new Date(avalista.DataNascimento.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"));
              }

              if (avalista.DataNascimentoConjuge !== null && avalista.DataNascimentoConjuge !== undefined) {
                dataNascAvalistaConjuge = new Date(avalista.DataNascimentoConjuge.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"));
              }
              if (avalista.Tipo == 1) {
                return {
                  Tipo: avalista.Tipo,
                  Nome: avalista.Nome,
                  DataNascimento: dataNascAvalista,
                  Cpf: __WEBPACK_IMPORTED_MODULE_2__utils_masker__["a" /* default */].unmaskCpf(avalista.Cpf),
                  Escolaridade: avalista.Escolaridade,
                  EstadoCivil: avalista.EstadoCivil,
                  Celular: avalista.Celular,
                  Email: avalista.Email,
                  Facebook: avalista.Facebook,
                  Linkedin: avalista.Linkedin,
                  NomeConjuge: avalista.EstadoCivil === 2 || avalista.EstadoCivil === 5 ? avalista.NomeConjuge : "",
                  CpfConjuge: avalista.EstadoCivil === 2 || avalista.EstadoCivil === 5 ? avalista.CpfConjuge : "",
                  DataNascimentoConjuge: avalista.EstadoCivil === 2 || avalista.EstadoCivil === 5 ? dataNascAvalistaConjuge : null,
                  EmailConjuge: avalista.EstadoCivil === 2 || avalista.EstadoCivil === 5 ? avalista.EmailConjuge : "",
                  CelularConjuge: avalista.EstadoCivil === 2 || avalista.EstadoCivil === 5 ? avalista.CelularConjuge : "",
                  EscolaridadeConjuge: avalista.EstadoCivil === 2 || avalista.EstadoCivil === 5 ? avalista.EscolaridadeConjuge : 0
                };
              } else {
                return {
                  Tipo: avalista.Tipo,
                  RazaoSocial: avalista.RazaoSocial,
                  Cnpj: avalista.Cnpj,
                  Site: avalista.Site,
                  Celular: avalista.Celular,
                  Email: avalista.Email,
                  Facebook: avalista.Facebook,
                  Linkedin: avalista.Linkedin
                };
              }
            }),
            Socios: this.solicitacao.Empresa.Socios
          }
        };

        this.$emit("on-submit", newData);
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_3__utils_array_helper__["a" /* default */].toSentence(validation.errors)
        });
      }
    },
    addPartner: function addPartner(partnerType) {
      this.avalistas.push({ Tipo: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(partnerType) });
      this.showPartnerType = false;
    },
    removePartner: function removePartner(index) {
      this.avalistas.splice(index, 1);
    }
  }
});

/***/ }),

/***/ "DQzD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_masker__ = __webpack_require__("7VWg");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('mask', {
  bind: function bind(el, binding) {
    var maskType = binding.value.replace(/(?:^|-)(\w)/g, function (match, cg1) {
      return cg1.toUpperCase();
    });
    var maskFunction = __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */]['mask' + maskType];
    if (!maskFunction) throw Error('[DIRECTIVE V-MASK] There is no mask called ' + binding.value);

    el.value = maskFunction(el.value);

    var inputHandler = function inputHandler(e) {
      if (!e.isTrusted) return;

      el.value = maskFunction(el.value);
      el.dispatchEvent(new Event('input'));
    };
    el.onblur = function (e) {
      e.target.value = maskFunction(e.target.value);
    };

    el.onkeydown = function (e) {
      if (!e.isTrusted) return;

      if (['delete', 'backspace'].includes(e.key.toLocaleLowerCase())) {
        e.target.oninput = null;
      } else {
        e.target.oninput = inputHandler;
      }
    };

    el.oninput = inputHandler;
  },
  componentUpdated: function componentUpdated(el, binding, vnode) {

    var maskType = binding.value.replace(/(?:^|-)(\w)/g, function (match, cg1) {
      return cg1.toUpperCase();
    });
    var maskFunction = __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */]['mask' + maskType];
    if (!maskFunction) throw Error('[DIRECTIVE V-MASK] There is no mask called ' + binding.value);

    var unmaskFunction = __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */]['unmask' + maskType];
    if (!unmaskFunction) return;
    // When the value is different the oninput is already taking care of it.
    if (unmaskFunction(vnode.elm.value) == unmaskFunction(el.value)) {
      el.value = maskFunction(el.value);
    }
  }
});

/***/ }),

/***/ "DVKY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row user-profile"},[_c('div',{staticClass:"col-12 tit_page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"back float-right text-right"},[_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"back"},[_vm._v(" ")]),_vm._v(" "),_c('span',[_vm._v("Voltar")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('hr',{staticClass:"divider"})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-2 text-center d-border"},[_c('div',{staticClass:"profile-image rounded-circle",staticStyle:{"background":"-webkit-gradient(linear, right bottom, left top, from(#434371), to(#0f8b8d))"}},[_c('div',{staticClass:"d-flex justify-content-center align-items-center flex-column"},[_c('a',{staticClass:"btn btn-link",staticStyle:{"font-size":"60px"}},[_vm._v(_vm._s(_vm.PrimeiraLetra()))])])]),_vm._v(" "),_c('div',{staticClass:"profile-options"},[_c('ul',[_c('li',[_c('router-link',{staticClass:"d-flex justify-content-between",attrs:{"to":"dados-pessoais"}},[_c('span',[_vm._v("\n                              Dados Pessoais\n                          ")]),_vm._v(" "),_c('i',{staticClass:"icon md icon-go-2"})])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"d-flex justify-content-between",attrs:{"to":"configuracoes"}},[_c('span',[_vm._v("\n                              Configurações\n                          ")]),_vm._v(" "),_c('i',{staticClass:"icon md icon-go-2"})])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"d-flex justify-content-between",attrs:{"to":"documentos"}},[_c('span',[_vm._v("\n                              Documentos\n                          ")]),_vm._v(" "),_c('i',{staticClass:"icon md icon-go-2"})])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"d-flex justify-content-between",attrs:{"to":"/investimentos/minhas-ccbs"}},[_c('span',[_vm._v("Formalizações")]),_vm._v(" "),_c('i',{staticClass:"icon md icon-go-2"})])],1),_vm._v(" "),_c('li',{staticStyle:{"display":"none"}},[_c('router-link',{staticClass:"d-flex justify-content-between",attrs:{"to":"historico"}},[_c('span',[_vm._v("\n                              Histórico\n                          ")]),_vm._v(" "),_c('i',{staticClass:"icon md icon-go-2"})])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-10"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("Meu Perfil")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DVzr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_vm._m(0),_vm._v(" "),_c('form',{staticClass:"text-center",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.files,"accept":_vm.acceptedFormats,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('i'),_vm._v(" "),_c('h2',[_vm._v("Documentos")]),_vm._v(" "),_c('p',[_vm._v("Documento de Identidade - CNH ou RG"),_c('br'),_vm._v("(Frente e Verso)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo"),_c('img',{attrs:{"src":"/static/assets/images/angle-right.svg"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DYmT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"back float-right"},[_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar\n\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"box-td"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),(_vm.response)?_c('tbody',[(_vm.ArquivosComprovanteEndereco.length <= 0)?_c('tr',[_vm._m(2),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        Comprovante de endereço\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        -\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(_vm.ArquivosComprovanteEndereco, 'Comprovante de Endereço', 'ArquivosComprovanteEndereco')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.ArquivosComprovanteEndereco),function(documento){return _c('tr',{key:documento.Nome},[_c('td',{staticClass:"align-middle text-left"},[(documento.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(documento.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("                        \n                                        "+_vm._s(_vm.nomeArquivo(documento.MetaDados.NomeArquivo))+" \n                                        "),(documento.Status == '' || documento.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(documento.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        Comprovante de endereço\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        "+_vm._s(_vm.formatDate(documento.DataEnvio))+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(documento.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(documento, 'Comprovante de Endereço', 'ArquivosComprovanteEndereco')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + documento.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])])])}),_vm._v(" "),(_vm.ArquivosFaturamento.length <= 0)?_c('tr',[_vm._m(3),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        Contrato Social\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        -\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(_vm.ArquivosFaturamento, 'Faturamento', 'ArquivosFaturamento')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.ArquivosFaturamento),function(documento){return _c('tr',{key:documento.Nome},[_c('td',{staticClass:"align-middle text-left"},[(documento.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(documento.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("                        \n                                        "+_vm._s(_vm.nomeArquivo(documento.MetaDados.NomeArquivo))+" \n                                        "),(documento.Status == '' || documento.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(documento.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        Faturamento\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        "+_vm._s(_vm.formatDate(documento.DataEnvio))+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(documento.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(documento, 'Faturamento', 'ArquivosFaturamento')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + documento.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])])])}),_vm._v(" "),(_vm.ArquivosContratoSocial.length <= 0)?_c('tr',[_vm._m(4),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        Contrato Social\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        -\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(_vm.ArquivosContratoSocial, 'Contrato Social', 'ArquivosContratoSocial')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.ArquivosContratoSocial),function(documento){return _c('tr',{key:documento.Nome},[(_vm.ArquivosContratoSocial.length > 0)?_c('td',{staticClass:"align-middle text-left"},[(documento.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(documento.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("                        \n                                        "+_vm._s(_vm.nomeArquivo(documento.MetaDados.NomeArquivo))+" \n                                        "),(documento.Status == '' || documento.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(documento.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        Contrato Social\n                                    ")]),_vm._v(" "),(_vm.ArquivosContratoSocial.length > 0)?_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        "+_vm._s(_vm.formatDate(documento.DataEnvio))+"\n                                    ")]):_vm._e(),_vm._v(" "),(_vm.ArquivosContratoSocial.length > 0)?_c('td',{staticClass:"align-middle text-center"},[(documento.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(documento, 'Contrato Social', 'ArquivosContratoSocial')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + documento.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])]):_vm._e()])}),_vm._v(" "),(_vm.ArquivosUltimosExtratosBancarios.length <= 0)?_c('tr',[_vm._m(5),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        Extratos Bancários\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        -\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(_vm.ArquivosUltimosExtratosBancarios, 'Extratos Bancários', 'ArquivosUltimosExtratosBancarios')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.ArquivosUltimosExtratosBancarios),function(documento){return _c('tr',{key:documento.Nome},[_c('td',{staticClass:"align-middle text-left"},[(documento.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(documento.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("                        \n                                        "+_vm._s(_vm.nomeArquivo(documento.MetaDados.NomeArquivo))+" \n                                        "),(documento.Status == '' || documento.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(documento.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        Extratos Bancários\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        "+_vm._s(_vm.formatDate(documento.DataEnvio))+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(documento.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(documento, 'Extratos Bancários', 'ArquivosUltimosExtratosBancarios')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + documento.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])])])}),_vm._v(" "),(_vm.ArquivosIrpf.length <= 0)?_c('tr',[_vm._m(6),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        IRPF\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        -\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(_vm.ArquivosIrpf, 'IRPF', 'ArquivosIrpf')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.ArquivosIrpf),function(documento){return _c('tr',{key:documento.Nome},[_c('td',{staticClass:"align-middle text-left"},[(documento.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(documento.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("                        \n                                        "+_vm._s(_vm.nomeArquivo(documento.MetaDados.NomeArquivo))+" \n                                        "),(documento.Status == '' || documento.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(documento.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        IRPF\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        "+_vm._s(_vm.formatDate(documento.DataEnvio))+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(documento.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(documento, 'IRPF', 'ArquivosIrpf')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + documento.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])])])}),_vm._v(" "),(_vm.ArquivosIdentidade.length <= 0)?_c('tr',[_vm._m(7),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        Identidade\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        -\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(_vm.ArquivosIdentidade, 'Identidade', 'ArquivosIdentidade')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.ArquivosIdentidade),function(documento){return _c('tr',{key:documento.Nome},[_c('td',{staticClass:"align-middle text-left"},[(documento.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(documento.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("                        \n                                        "+_vm._s(_vm.nomeArquivo(documento.MetaDados.NomeArquivo))+" \n                                        "),(documento.Status == '' || documento.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(documento.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        Identidade\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        "+_vm._s(_vm.formatDate(documento.DataEnvio))+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(documento.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(documento, 'Identidade', 'ArquivosIdentidade')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + documento.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])])])}),_vm._v(" "),(_vm.ArquivosBalancoEDre.length <= 0)?_c('tr',[_vm._m(8),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                         Balanço e DRE\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        -\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(_vm.ArquivosIdentidade, 'Balanço e DRE', 'ArquivosBalancoEDre')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.ArquivosBalancoEDre),function(documento){return _c('tr',{key:documento.Nome},[_c('td',{staticClass:"align-middle text-left"},[(documento.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(documento.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("                        \n                                        "+_vm._s(_vm.nomeArquivo(documento.MetaDados.NomeArquivo))+" \n                                        "),(documento.Status == '' || documento.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(documento.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        Balanço e DRE\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        "+_vm._s(_vm.formatDate(documento.DataEnvio))+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(documento.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(documento, 'Balanço e DRE', 'ArquivosBalancoEDre')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + documento.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])])])})],2):_vm._e()]),_vm._v(" "),(_vm.renderOutros)?_c('div',{staticClass:"float-left others"},[_c('h4',[_vm._v("Outros Documentos")])]):_vm._e(),_vm._v(" "),(_vm.renderOutros)?_c('table',{staticClass:"table"},[_vm._m(9),_vm._v(" "),_vm._l((_vm.outros),function(outro){return (_vm.renderOutros)?_c('tbody',{key:outro._id},[(outro.Documento.length <= 0)?_c('tr',[_vm._m(10,true),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        "+_vm._s(outro.NomeDocumento)+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        -\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_c('a',{staticClass:"td-link",on:{"click":function($event){return _vm.exibeModalOutros(outro._id, outro.NomeDocumento)}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]),_vm._v(" "),_vm._m(11,true)])]):(outro.Documento.length > 0)?_vm._l((outro.Documento),function(doc){return _c('tr',{key:doc.Nome},[_c('td',{staticClass:"align-middle text-left"},[(doc.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(doc.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("                        \n                                        "+_vm._s(_vm.nomeArquivo(doc.MetaDados.NomeArquivo))+" \n                                        "),(doc.Status == '' || doc.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(doc.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                       "+_vm._s(outro.NomeDocumento)+"\n                                  ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        "+_vm._s(_vm.formatDate(doc.DataEnvio))+"\n                                  ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(doc.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModalOutros(outro._id, outro.NomeDocumento)}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + doc.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])])])}):_vm._e()],2):_vm._e()})],2):_vm._e()]),_vm._v(" "),(_vm.showModal)?_c('modal',{staticClass:"modal-invited",on:{"close":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"tit float-left"},[_c('h2',{staticStyle:{"padding-right":"50px"}},[_c('i',{staticClass:"icon icon-airplane xl"}),_vm._v("\n                                Enviar "+_vm._s(_vm.tipoArquivoSelecionado)+"\n                            ")])])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-x":"auto"},attrs:{"slot":"body"},slot:"body"},[(_vm.submitted)?_c('div',{staticClass:"success d-flex flex-column justify-content-center align-items-center"},[_c('i',{staticClass:"icon icon-success xll"}),_vm._v(" "),_c('h3',[_vm._v("Documento enviado com sucesso!")])]):_c('div',[_c('files-input',{attrs:{"files":_vm.files,"accept":_vm.acceptedFormats,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"float-md-right"},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"color":"#fff !important"},on:{"click":function($event){return _vm.submit()}}},[_vm._v("Enviar Documentos")])])],1),_vm._v(" "),_c('br')])]):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("Documentos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"align-middle text-left",attrs:{"scope":"col"}},[_vm._v("\n                                        Nome\n                                    ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-left",attrs:{"scope":"col"}},[_vm._v("\n                                        Documento\n                                    ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n                                        Enviado\n                                    ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n                                         \n                                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"align-middle text-left"},[_c('i',{staticClass:"icon icon-doc-atencao md"}),_vm._v("                        \n                                        Arquivo não enviado\n                                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"align-middle text-left"},[_c('i',{staticClass:"icon icon-doc-atencao md"}),_vm._v("                        \n                                        Arquivo não enviado\n                                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"align-middle text-left"},[_c('i',{staticClass:"icon icon-doc-atencao md"}),_vm._v("                        \n                                        Arquivo não enviado\n                                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"align-middle text-left"},[_c('i',{staticClass:"icon icon-doc-atencao md"}),_vm._v("                        \n                                        Arquivo não enviado\n                                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"align-middle text-left"},[_c('i',{staticClass:"icon icon-doc-atencao md"}),_vm._v("                        \n                                        Arquivo não enviado\n                                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"align-middle text-left"},[_c('i',{staticClass:"icon icon-doc-atencao md"}),_vm._v("                        \n                                        Arquivo não enviado\n                                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"align-middle text-left"},[_c('i',{staticClass:"icon icon-doc-atencao md"}),_vm._v("                        \n                                        Arquivo não enviado\n                                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"align-middle text-left",attrs:{"scope":"col"}},[_vm._v("\n                                        Nome\n                                    ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-left",attrs:{"scope":"col"}},[_vm._v("\n                                        Documento\n                                    ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n                                        Enviado\n                                    ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n                                         \n                                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"align-middle text-left"},[_c('i',{staticClass:"icon icon-doc-atencao md"}),_vm._v(" "),_c('span',{staticClass:"badge badge-danger"},[_vm._v("enviar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"td-link"},[_c('span',[_vm._v("-")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DdtL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      this.$emit('on-submit', {});
    }
  }
});

/***/ }),

/***/ "DenK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DfF0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__("5dBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_masker__ = __webpack_require__("7VWg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var pessoal = this.currentUser.Pessoal;
    return {
      salario: pessoal && pessoal.Salario ? pessoal.Salario.toLocaleString('pr-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }) : null
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      this.currentUser.Pessoal.Salario = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].unmaskMoney(this.salario));

      var newData = { Pessoal: this.currentUser.Pessoal };
      this.$emit('on-submit', newData);
    }
  }
});

/***/ }),

/***/ "Dho/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dl1J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo"),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('p',[_vm._v("Documento de identidade (RG ou CNH) do(s) sócio(s)/avalista(s)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DqOP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_wallet__ = __webpack_require__("c/xH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Wallet_WalletHeader_vue__ = __webpack_require__("2KSD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Wallet_WalletExtratoLista_vue__ = __webpack_require__("HodG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pagination__ = __webpack_require__("cMGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_api_client__ = __webpack_require__("6Yc5");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            Saldo: 0,
            Operacoes: null,
            PaginaAtual: 1,
            Paginas: 0,
            showModal: false,
            loadingList: false
        };
    },


    components: {
        WalletHeader: __WEBPACK_IMPORTED_MODULE_4__components_Wallet_WalletHeader_vue__["a" /* default */],
        WalletExtratoLista: __WEBPACK_IMPORTED_MODULE_5__components_Wallet_WalletExtratoLista_vue__["a" /* default */],
        Loading: __WEBPACK_IMPORTED_MODULE_3__components_Loading__["a" /* default */],
        Pagination: __WEBPACK_IMPORTED_MODULE_6__components_Pagination__["a" /* default */]
    },

    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            _this.listarOperacoes();

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },


    computed: {

        renderizado: function renderizado() {

            return this.Operacoes != null;
        }

    },

    methods: {
        voltar: function voltar() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.AbrirModal(false);
                                _context2.next = 3;
                                return _this2.listarOperacoes();

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        listarOperacoes: function listarOperacoes() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:

                                _this3.loadingList = true;

                                _context3.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_2__services_api_wallet__["a" /* default */].GetExtratoPaginadoWallet(1);

                            case 3:
                                _ref = _context3.sent;
                                data = _ref.data;


                                _this3.loadingList = false;

                                if (data) {

                                    _this3.Saldo = data.Saldo;
                                    _this3.Paginas = data.Paginas;
                                    _this3.Operacoes = data.Operacoes;
                                } else {
                                    console.warn("error request");
                                }

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        mudarPagina: function mudarPagina(pagina) {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var _ref2, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:

                                _this4.loadingList = true;

                                _context4.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_2__services_api_wallet__["a" /* default */].GetExtratoPaginadoWallet(pagina);

                            case 3:
                                _ref2 = _context4.sent;
                                data = _ref2.data;


                                _this4.loadingList = false;

                                _this4.PaginaAtual = pagina;
                                _this4.Operacoes = data.Operacoes;

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        }
    }
});

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return START_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STOP_LOADING; });
var LOGIN = "LOGIN";
var UPDATE_USER = "UPDATE_USER";
var LOGOUT = "LOGOUT";
var START_LOADING = "START_LOADING";
var STOP_LOADING = "STOP_LOADING";

/***/ }),

/***/ "Du6A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DvuM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dzg6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChartInvestment_vue__ = __webpack_require__("c5M2");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChartInvestment_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E5c1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_vm._m(0),_vm._v(" "),_c('bank-data-form',{attrs:{"bank-data":_vm.bankData},on:{"submit":_vm.handleSubmit}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_c('div',{staticClass:"tit text-center"},[_c('h2',[_vm._v("Dados bancários")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E9B0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_vm._m(0),_vm._v(" "),_c('address-form',{attrs:{"address":_vm.address},on:{"submit":_vm.handleSubmit}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_c('div',{staticClass:"tit text-center"},[_c('h2',[_vm._v("Endereço")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EDzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NaturezaOcupacaoStep_vue__ = __webpack_require__("x6II");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19a62a43_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NaturezaOcupacaoStep_vue__ = __webpack_require__("FOcS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NaturezaOcupacaoStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19a62a43_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NaturezaOcupacaoStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EGk3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SocialNetworkDashboard__ = __webpack_require__("eye1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SideMenu__ = __webpack_require__("a1CX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Invite_Friend__ = __webpack_require__("XZRT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Invite_Company__ = __webpack_require__("VCVs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Alerts__ = __webpack_require__("MGb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__package_json__ = __webpack_require__("7YgM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__package_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */










/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: {
    htmlAttrs: {
      lang: 'pt-br'
    },
    bodyAttrs: {
      class: 'bg-light'
    }
  },
  data: function data() {
    return {
      version: __WEBPACK_IMPORTED_MODULE_8__package_json___default.a.version,
      menuItems: [
      //  {iconClass: "ico-din-2", title: "Quero Investir", path: "/investimentos/oportunidades/", title2: "Quero Investir", modal:true},
      { iconClass: "ico-din-3", title: "Meus Empréstimos", path: "/emprestimos/meus-emprestimos" }, { iconClass: "ico-din-5", title: "Solicitar Empréstimo", url: "https://emprestimos.iouu.com.br/pedido" },
      //  {iconClass: "ico-lib", title: "Meu Histórico", path: "/emprestimos/historico"},
      { iconClass: "ico-ch", title: "Perguntas e Respostas", url: "http://ajuda.iouu.com.br" }],
      showModal: false,
      modalStep: 1,
      auxModalStep: 1,
      model: {
        User: {}
      },
      from: "EMP",
      userId: null
    };
  },

  components: {
    SideMenu: __WEBPACK_IMPORTED_MODULE_1__components_SideMenu__["a" /* default */],
    SocialNetwork: __WEBPACK_IMPORTED_MODULE_0__components_SocialNetworkDashboard__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_4__components_Modal__["a" /* default */],
    Friend: __WEBPACK_IMPORTED_MODULE_5__components_Invite_Friend__["a" /* default */],
    Company: __WEBPACK_IMPORTED_MODULE_6__components_Invite_Company__["a" /* default */],
    Alerts: __WEBPACK_IMPORTED_MODULE_7__components_Alerts__["a" /* default */]
  },
  methods: {
    Logout: function Logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },

    // METHOD TO SHOW MOBILE MENU
    ShowMobMenu: function ShowMobMenu(status) {
      var menu = document.getElementsByClassName('collapsed-menu');

      if (status == true && menu.length >= 1) {
        menu[0].classList.add("show");
      }
    },
    finishInvite: function finishInvite() {
      this.modalStep = 3;
    },
    activeButton: function activeButton(name) {
      var buttonName = name;

      if (buttonName === "person") {
        document.getElementsByClassName('invited-person')[0].classList.add('active');
        document.getElementsByClassName('invited-company')[0].classList.remove('active');
      } else {
        document.getElementsByClassName('invited-person')[0].classList.remove('active');
        document.getElementsByClassName('invited-company')[0].classList.add('active');
      }
    },
    Nome: function Nome() {
      var nome = "",
          letra = "";
      if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
        nome = this.User.username;
      } else {
        nome = this.User.name;
      }
      nome = nome.trim();
      var primeiroNome = nome.split(" ")[0];

      return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
    },
    LetraNome: function LetraNome() {

      var nome = this.Nome();

      if (nome != null && nome != undefined && nome.length > 0) return nome[0].toUpperCase();

      return "";
    }
  },
  computed: {
    User: function User() {
      return this.$store.state.currentUser;
    }
  },
  beforeCreate: function beforeCreate() {}
});

/***/ }),

/***/ "EM27":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ENCI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"s-abrir-conta"},[_c('div',{staticClass:"container-new"},[_c('RegistrationScreenBanner'),_vm._v(" "),_c('RegistrationScreenForm',{on:{"newAccount":_vm.createNewAccountInRepository}})],1)]),_vm._v(" "),_c('FooterNewLogin')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ENmc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            to: "",
            company: "",
            msg: "",
            contact: "",
            phone: "",
            submited: false
        };
    },

    methods: {
        submit: function submit() {
            var _this = this;

            this.submited = true;

            if (!this.isNullOrEmpty(this.to) && !this.isNullOrEmpty(this.msg) && !this.isNullOrEmpty(this.company) && !this.isNullOrEmpty(this.contact)) {
                __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].inviteCompany(this.to, this.msg, this.company, this.contact, this.phone).then(function (result) {
                    if (result.status == 200) {
                        _this.$emit("finished");
                    } else {
                        _this.$emit("finished");
                    }
                }).catch(function () {});
            }
        },
        isNullOrEmpty: function isNullOrEmpty(value) {
            if (value == null || value == '') return true;

            return false;
        }
    }
});

/***/ }),

/***/ "EOg2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types_js__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lpUrl: "https://iouu.com.br"
    };
  },

  methods: {
    Logout: function Logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    Home: function Home() {
      sessionStorage.removeItem("redirectINV");
      this.$router.push('/investimentos/meus-investimentos');
    }
  }, beforeCreate: function beforeCreate() {

    window.document.title = 'Dashboard IOUU';
  }
});

/***/ }),

/***/ "ERbv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EbAF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploadExtratosStep_vue__ = __webpack_require__("azB1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a48975_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploadExtratosStep_vue__ = __webpack_require__("A0NO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploadExtratosStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a48975_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploadExtratosStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Elxy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_map__ = __webpack_require__("nSPF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_assets_images_bancos_ico_bb_png__ = __webpack_require__("yoNT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_assets_images_bancos_ico_bb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_assets_images_bancos_ico_bb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_assets_images_bancos_ico_caixa_png__ = __webpack_require__("MaQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_assets_images_bancos_ico_caixa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_assets_images_bancos_ico_caixa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_assets_images_bancos_ico_itau_png__ = __webpack_require__("XG7f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_assets_images_bancos_ico_itau_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_assets_images_bancos_ico_itau_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_assets_images_bancos_ico_bradesco_png__ = __webpack_require__("3Lo/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_assets_images_bancos_ico_bradesco_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_assets_images_bancos_ico_bradesco_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_assets_images_bancos_ico_santander_png__ = __webpack_require__("Qwbv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_assets_images_bancos_ico_santander_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_assets_images_bancos_ico_santander_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_assets_images_bancos_ico_neon_png__ = __webpack_require__("6vG/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_assets_images_bancos_ico_neon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_assets_images_bancos_ico_neon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_assets_images_bancos_ico_inter_png__ = __webpack_require__("YZjq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_assets_images_bancos_ico_inter_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_assets_images_bancos_ico_inter_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_es6_promise__ = __webpack_require__("hKoQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_api_client_go__ = __webpack_require__("879M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_BankDataForm__ = __webpack_require__("pVr/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_string_helper__ = __webpack_require__("65ha");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_masker__ = __webpack_require__("7VWg");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

















var Moip = window.Moip;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BankDataForm: __WEBPACK_IMPORTED_MODULE_14__components_BankDataForm__["a" /* default */]
  },
  data: function data() {
    return {
      investorProfile: {},
      renderize: false,
      bankRenderizer: false,
      fullNameError: false,
      states: [{ uf: "AC", nome: "Acre" }, { uf: "AL", nome: "Alagoas" }, { uf: "AP", nome: "Amapá" }, { uf: "AM", nome: "Amazonas" }, { uf: "BA", nome: "Bahia" }, { uf: "CE", nome: "Ceará" }, { uf: "DF", nome: "Distrito Federal" }, { uf: "ES", nome: "Espírito Santo" }, { uf: "GO", nome: "Goiás" }, { uf: "MA", nome: "Maranhão" }, { uf: "MT", nome: "Mato Grosso" }, { uf: "MS", nome: "Mato Grosso do Sul" }, { uf: "MG", nome: "Minas Gerais" }, { uf: "PA", nome: "Pará" }, { uf: "PB", nome: "Paraíba" }, { uf: "PR", nome: "Paraná" }, { uf: "PE", nome: "Pernambuco" }, { uf: "PI", nome: "Piauí" }, { uf: "RJ", nome: "Rio de Janeiro" }, { uf: "RN", nome: "Rio Grande do Norte" }, { uf: "RS", nome: "Rio Grande do Sul" }, { uf: "RO", nome: "Rondônia" }, { uf: "RR", nome: "Roraima" }, { uf: "SC", nome: "Santa Catarina" }, { uf: "SP", nome: "São Paulo" }, { uf: "SE", nome: "Sergipe" }, { uf: "TO", nome: "Tocantins" }],
      cities: [],
      banks: [],
      agencia: "",
      mainBanks: [{
        codigo: "001",
        nome: "Banco do Brasil S.A.",
        logo: __WEBPACK_IMPORTED_MODULE_3__static_assets_images_bancos_ico_bb_png___default.a
      }, { codigo: "104", nome: "Caixa Econômica Federal", logo: __WEBPACK_IMPORTED_MODULE_4__static_assets_images_bancos_ico_caixa_png___default.a }, { codigo: "341", nome: "Itaú Unibanco S.A.", logo: __WEBPACK_IMPORTED_MODULE_5__static_assets_images_bancos_ico_itau_png___default.a }, { codigo: "237", nome: "Banco Bradesco S.A.", logo: __WEBPACK_IMPORTED_MODULE_6__static_assets_images_bancos_ico_bradesco_png___default.a }, {
        codigo: "033",
        nome: "Banco Santander (Brasil) S.A.",
        logo: __WEBPACK_IMPORTED_MODULE_7__static_assets_images_bancos_ico_santander_png___default.a
      }, { codigo: "735", nome: "Banco Neon", logo: __WEBPACK_IMPORTED_MODULE_8__static_assets_images_bancos_ico_neon_png___default.a }, { codigo: "077", nome: "Banco Intermedium S.A.", logo: __WEBPACK_IMPORTED_MODULE_9__static_assets_images_bancos_ico_inter_png___default.a }]
    };
  },

  computed: {
    isOtherBank: {
      get: function get() {
        var _this = this;

        return this.mainBanks.find(function (bank) {
          return bank.codigo == _this.investorProfile.DadosBancarios.CodigoBanco;
        }) == null;
      },
      set: function set() {
        this.investorProfile.DadosBancarios.CodigoBanco = "";
      }
    }
  },
  methods: {
    handleZipcodeChange: function handleZipcodeChange(e) {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_17__utils_masker__["a" /* default */].unmaskZipcode(e.target.value).length < 8) return;

      __WEBPACK_IMPORTED_MODULE_16__utils_hub_consulta_client__["a" /* default */].pegarCeps(e.target.value).then(function (endereco) {
        _this2.investorProfile.Endereco.Logradouro = endereco.logradouro;
        _this2.investorProfile.Endereco.Bairro = endereco.bairro;
        _this2.investorProfile.Endereco.Uf = endereco.uf;
        _this2.investorProfile.Endereco.Cidade = endereco.localidade;

        _this2.cities = [];
        _this2.getCities();
      }).catch(function () {});
    },
    updateProfile: function updateProfile() {
      var _this3 = this;

      if (!this.validationNames()) return;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_13__store_mutation_types_js__["c" /* START_LOADING */]);

      this.validate().then(function (validation) {
        if (validation.isValid) {
          _this3.investorProfile.DataNascimento = _this3.investorProfile.DataNascimentoExibicao;
          _this3.investorProfile.RgDataEmissao = _this3.investorProfile.RgDataEmissaoExibicao;

          __WEBPACK_IMPORTED_MODULE_11__utils_api_client__["a" /* default */].updateProfile(_this3.investorProfile).then(function (result) {
            _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_13__store_mutation_types_js__["d" /* STOP_LOADING */]);
            _this3.$Notify.info('Informações atualizadas com sucesso.');
            __WEBPACK_IMPORTED_MODULE_12__utils_api_client_go__["a" /* default */].atualizarContaBancaria(_this3.investorProfile.Cpf).then();
          });
        } else {
          _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_13__store_mutation_types_js__["d" /* STOP_LOADING */]);

          _this3.$Notify.error({
            title: "Dados Bancários Inválidos",
            message: validation.errors.map(function (error) {
              return error.replace(/\.\s([A-Z])/, function (match, cg1) {
                return ", " + cg1.toLowerCase();
              });
            }).join(' ')
          });
        }
      });
    },
    validateFullName: function validateFullName() {
      if (this.investorProfile.NomeCompleto[0] == " ") {
        this.investorProfile.NomeCompleto = "";
        return;
      }

      var splitText = this.investorProfile.NomeCompleto.split(" ");
      var upperCaseText = "";

      for (var i = 0; i < splitText.length; i++) {
        if (splitText[i] != "") {
          if (i > 0) upperCaseText += " ";

          upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
        } else if (i > 0) upperCaseText += " ";
      }

      this.investorProfile.NomeCompleto = upperCaseText;
    },
    validateFathersName: function validateFathersName() {
      if (this.investorProfile.NomePai[0] == " ") {
        this.investorProfile.NomePai = "";
        return;
      }

      var splitText = this.investorProfile.NomePai.split(' ');
      var upperCaseText = '';

      for (var i = 0; i < splitText.length; i++) {
        if (splitText[i] != "") {
          if (i > 0) upperCaseText += " ";

          upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
        } else if (i > 0) upperCaseText += " ";
      }

      this.investorProfile.NomePai = upperCaseText;
    },
    validateMothersName: function validateMothersName() {
      if (this.investorProfile.NomeMae[0] == " ") {
        this.investorProfile.NomeMae = "";
        return;
      }

      var splitText = this.investorProfile.NomeMae.split(' ');
      var upperCaseText = '';

      for (var i = 0; i < splitText.length; i++) {
        if (splitText[i] != "") {
          if (i > 0) upperCaseText += " ";

          upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
        } else if (i > 0) upperCaseText += " ";
      }

      this.investorProfile.NomeMae = upperCaseText;
    },
    validationNames: function validationNames() {
      var splited = this.clearSplitNames(this.investorProfile.NomeCompleto.split(" "));

      if (splited.length <= 1) {
        this.$Notify.error("Preencha o seu nome completo.");
        return false;
      }

      return true;
    },
    clearSplitNames: function clearSplitNames(splitName) {
      var cleanSplit = new Array();

      for (var i = 0; i < splitName.length; i++) {
        if (splitName[i] != "") cleanSplit.push(splitName[i]);
      }

      return cleanSplit;
    },
    onUfChange: function onUfChange() {
      this.cities = [];

      if (!this.investorProfile.Endereco.Uf) {
        this.investorProfile.Endereco.Cidade = "";
        return;
      }

      this.getCities();
    },
    getCities: function getCities() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_16__utils_hub_consulta_client__["a" /* default */].pegarCidades(this.investorProfile.Endereco.Uf).then(function (cities) {
        _this4.cities = cities;

        if (_this4.investorProfile.Endereco.Cidade) {
          _this4.setCity();
        }

        var vm = _this4;
        vm.$refs.citySelect.$el.children[0].children[2].required = true;
        vm.$refs.nationalitySelect.$el.children[0].children[2].required = true;
        vm.$refs.placeOfBirthSelect.$el.children[0].children[2].required = true;
      });
    },
    setCity: function setCity() {
      var vm = this;
      var city = vm.cities.find(function (city) {
        return __WEBPACK_IMPORTED_MODULE_15__utils_string_helper__["a" /* default */].removeAccents(city.nome.toUpperCase()) == __WEBPACK_IMPORTED_MODULE_15__utils_string_helper__["a" /* default */].removeAccents(vm.investorProfile.Endereco.Cidade.toUpperCase());
      });

      vm.investorProfile.Endereco.Cidade = "";

      if (city) {
        setTimeout(function () {
          vm.investorProfile.Endereco.Cidade = city.nome;
        }, 100);
      }
    },
    aoMudarEhOutroBanco: function aoMudarEhOutroBanco() {
      this.investorProfile.DadosBancarios.CodigoBanco = "";
    },
    submeterSemConta: function submeterSemConta() {
      var newData = {
        bankData: null,
        hasNoAccount: true
      };
      this.$emit("submit", newData);
    },
    trimBankAccountStart: function trimBankAccountStart(account, maxNumCount) {
      var splitedAccount = account.split("-");

      var len = splitedAccount.length > 1 ? splitedAccount[0].length + splitedAccount[1].length : splitedAccount[0].length;

      var zeroCount = maxNumCount - len;
      var leftZero = "";

      for (var i = 0; i <= zeroCount; i++) {
        leftZero += "0";
      }

      var result = leftZero + account;
      console.log("leftZero + account: " + result);

      return leftZero + account;
    },
    validate: function validate() {
      var _this5 = this;

      var agencyCheckNumber = '';

      if (this.investorProfile.DadosBancarios.CodigoBanco == '001' || this.investorProfile.DadosBancarios.CodigoBanco == '237') {
        if (this.investorProfile.DadosBancarios.Agencia.split("-").length == 1) {
          var len = this.investorProfile.DadosBancarios.Agencia.length;
          this.investorProfile.DadosBancarios.Agencia = this.investorProfile.DadosBancarios.Agencia.slice(0, len - 1) + '-' + this.investorProfile.DadosBancarios.Agencia.slice(len - 1);
        }

        //banco do brasil e bradesco possuem dígito na agência
        agencyCheckNumber = this.investorProfile.DadosBancarios.Agencia.split("-")[1];
      }

      //banco do brasil e bradesco possuem dígito na agência
      agencyCheckNumber = this.investorProfile.DadosBancarios.CodigoBanco == "001" || this.investorProfile.DadosBancarios.CodigoBanco == "237" ? this.investorProfile.DadosBancarios.Agencia.split("-")[1] : "";

      if (this.investorProfile.DadosBancarios.CodigoBanco == "001" || this.investorProfile.DadosBancarios.CodigoBanco == "033") this.investorProfile.DadosBancarios.Conta = this.trimBankAccountStart(this.investorProfile.DadosBancarios.Conta, 8);else if (this.investorProfile.DadosBancarios.CodigoBanco == "237") this.investorProfile.DadosBancarios.Conta = this.trimBankAccountStart(this.investorProfile.DadosBancarios.Conta, 7);else if (this.investorProfile.DadosBancarios.CodigoBanco == "341") this.investorProfile.DadosBancarios.Conta = this.trimBankAccountStart(this.investorProfile.DadosBancarios.Conta, 5);

      return new __WEBPACK_IMPORTED_MODULE_10_es6_promise___default.a(function (resolve) {
        Moip.BankAccount.validate({
          bankNumber: _this5.investorProfile.DadosBancarios.CodigoBanco,
          agencyNumber: _this5.investorProfile.DadosBancarios.Agencia.split("-")[0],
          agencyCheckNumber: agencyCheckNumber,
          accountNumber: _this5.investorProfile.DadosBancarios.Conta.split("-")[0],
          accountCheckNumber: _this5.investorProfile.DadosBancarios.Conta.split("-")[1],
          valid: function valid() {
            resolve({ isValid: true, errors: [] });
          },
          invalid: function invalid(data) {
            var errors = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_map___default()(data.errors, function (error) {
              return error.description;
            });
            resolve({ isValid: false, errors: errors });
          }
        });
      });
    },

    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: 'perfil/editar-perfil',
        title: 'Editar'
      });
    }
  },
  created: function created() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this6.$route.query.to === "bank") {
                setTimeout(function () {
                  $("html, body").animate({ scrollTop: $(document).height() - $(window).height() });
                }, 100);
              }

              //tagueamento GA
              _context.next = 3;
              return _this6.taggingGA();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this6);
    }))();
  },
  beforeCreate: function beforeCreate() {
    var _this7 = this;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_13__store_mutation_types_js__["c" /* START_LOADING */]);

    __WEBPACK_IMPORTED_MODULE_11__utils_api_client__["a" /* default */].getInvestor().then(function (investor) {
      _this7.banks = [];

      __WEBPACK_IMPORTED_MODULE_16__utils_hub_consulta_client__["a" /* default */].pegarBancos().then(function (banks) {
        var vm = _this7;
        _this7.banks = banks;

        _this7.bankRenderizer = true;
      });

      _this7.investorProfile = investor;
      _this7.agencia = _this7.investorProfile.DadosBancarios.Agencia;
      _this7.investorProfile.DataNascimentoExibicao = _this7.investorProfile.DataNascimento.toLocaleDateString("pt-BR");
      _this7.investorProfile.RgDataEmissaoExibicao = _this7.investorProfile.RgDataEmissao.toLocaleDateString("pt-BR");

      if (_this7.investorProfile.Nacionalidade !== 1 && _this7.investorProfile.Nacionalidade !== 2 && _this7.investorProfile.Nacionalidade !== 3) {
        _this7.investorProfile.Nacionalidade = "";
      }

      var possuiEstadoOndeNasceu = false;
      for (var i = 0; i < _this7.states.length; i++) {
        if (_this7.investorProfile.Naturalidade == _this7.states[i].nome) {
          possuiEstadoOndeNasceu = true;
          break;
        }
      }

      if (!possuiEstadoOndeNasceu) _this7.investorProfile.Naturalidade = "";

      if (_this7.investorProfile.RendaMensal.toString().indexOf(".") < 0) _this7.investorProfile.RendaMensal += ",00";

      if (_this7.investorProfile.Patrimonio.toString().indexOf(".") < 0) _this7.investorProfile.Patrimonio += ",00";

      _this7.getCities();

      _this7.renderize = true;

      _this7.$store.commit(__WEBPACK_IMPORTED_MODULE_13__store_mutation_types_js__["d" /* STOP_LOADING */]);
    }).catch(function () {
      return _this7.$store.commit(__WEBPACK_IMPORTED_MODULE_13__store_mutation_types_js__["d" /* STOP_LOADING */]);
    });
  }
});

/***/ }),

/***/ "EoRA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuarantorsStep_vue__ = __webpack_require__("DJzd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9931f794_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuarantorsStep_vue__ = __webpack_require__("iTlq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuarantorsStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9931f794_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuarantorsStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EqLn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documentos_vue__ = __webpack_require__("t2i1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b76bd72a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Documentos_vue__ = __webpack_require__("kDcK");
function injectStyle (ssrContext) {
  __webpack_require__("gqJL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b76bd72a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documentos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b76bd72a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Documentos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EqSw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 margin"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"small-space"},[_c('h3',[_vm._v("Contratos")]),_vm._v(" "),_c('div',{staticClass:"row docs"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('a',{staticClass:"btn btn-link d-flex justify-content-start align-items-center",attrs:{"href":_vm.siteEndPoint+'/termos/',"target":"_blank"}},[_c('i',{staticClass:"icon icon-pdf-3 xll"}),_vm._v(" "),_c('span',[_vm._v("Termos e condições gerais de uso")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('a',{staticClass:"btn btn-link d-flex justify-content-start align-items-center",attrs:{"href":_vm.siteEndPoint+'/politica-de-privacidade/',"target":"_blank"}},[_c('i',{staticClass:"icon icon-pdf-3 xll"}),_vm._v(" "),_c('span',[_vm._v("Políticas de privacidade")])])])])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col sub-tit"},[_c('h3',[_vm._v("Documentos envidados por você"),(_vm.mostraDocsEnviados())?_c('a',{staticClass:"reenviar",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.documentos()}}},[_vm._v("Reenviar Documentos")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row docs d-flex justify-content-center align-items-center"},[_vm._l((this.investidores.ArquivosIdentidade),function(item){return _c('div',{staticClass:"col-12 col-lg-6 col-xl-4",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"box-doc"},[_c('i',{staticClass:"icon icon-jpg-2 lg"}),_vm._v(" "),_c('div',{staticClass:"doc-text"},[_c('h5',[_vm._v("\n                                    Documento de Identidade\n                                ")]),_vm._v(" "),_c('p',[_vm._v("Arquivo: "),_c('span',[_vm._v(" "+_vm._s(_vm.nomeArquivo(item.MetaDados ? item.MetaDados.NomeArquivo : item.NomeArquivo)))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-start align-items-center"},[_c('p',[_vm._v("\n                                        \n                                        Enviado em "+_vm._s(_vm.formatDate(item.MetaDados ? item.MetaDados.DataUltimaModificacao : item.DataUltimaModificacao))+"\n                                    ")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.hubEndPoint+'/file/'+item.Nome,"target":"_blank"}},[_vm._v("\n                                        Visualizar\n                                    ")])])])])])}),_vm._v(" "),_vm._l((this.investidores.ArquivosComprovanteResidencia),function(item){return _c('div',{staticClass:"col-12 col-lg-6 col-xl-4",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"box-doc"},[_c('i',{staticClass:"icon icon-jpg-2 lg"}),_vm._v(" "),_c('div',{staticClass:"doc-text"},[_c('h5',[_vm._v("\n                                    Comprovante de residência\n                                ")]),_vm._v(" "),_c('p',[_vm._v("Arquivo: "),_c('span',[_vm._v(" "+_vm._s(_vm.nomeArquivo(item.MetaDados ? item.MetaDados.NomeArquivo : item.NomeArquivo)))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-start align-items-center"},[_c('p',[_vm._v("Enviado em "+_vm._s(_vm.formatDate(item.MetaDados ? item.MetaDados.DataUltimaModificacao : item.DataUltimaModificacao)))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.hubEndPoint+'/file/'+item.Nome,"target":"_blank"}},[_vm._v("\n                                        Visualizar\n                                    ")])])])])])}),_vm._v(" "),_vm._l((this.investidores.ExtratoBancario),function(item){return _c('div',{staticClass:"col-12 col-lg-6 col-xl-4",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"box-doc"},[_c('i',{staticClass:"icon icon-jpg-2 lg"}),_vm._v(" "),_c('div',{staticClass:"doc-text"},[_c('h5',[_vm._v("\n                                    Extrato bancario\n                                ")]),_vm._v(" "),_c('p',[_vm._v("Arquivo: "),_c('span',[_vm._v(" "+_vm._s(_vm.nomeArquivo(item.MetaDados ? item.MetaDados.NomeArquivo : item.NomeArquivo)))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-start align-items-center"},[_c('p',[_vm._v("Enviado em "+_vm._s(_vm.formatDate(item.MetaDados ? item.MetaDados.DataUltimaModificacao : item.DataUltimaModificacao)))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.hubEndPoint+'/file/'+item.Nome,"target":"_blank"}},[_vm._v("\n                                        Visualizar\n                                    ")])])])])])})],2),_vm._v(" "),_c('div',{staticClass:"row docs justify-content-center align-items-center"},[_vm._l((this.investidores.ImpostoRenda),function(item){return _c('div',{staticClass:"col-12 col-lg-6 col-xl-4",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"box-doc"},[_c('i',{staticClass:"icon icon-jpg-2 lg"}),_vm._v(" "),_c('div',{staticClass:"doc-text"},[_c('h5',[_vm._v("\n                                    Imposto de Renda\n                                ")]),_vm._v(" "),_c('p',[_vm._v("Arquivo: "),_c('span',[_vm._v(" "+_vm._s(_vm.nomeArquivo(item.MetaDados ? item.MetaDados.NomeArquivo : item.NomeArquivo)))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-start align-items-center"},[_c('p',[_vm._v("Enviado em "+_vm._s(_vm.formatDate(item.MetaDados ? item.MetaDados.DataUltimaModificacao : item.DataUltimaModificacao)))]),_vm._v(" "),_c('a',{attrs:{"href":item.UrlTemporario}},[_vm._v("\n                                        Visualizar\n                                    ")])])])])])}),_vm._v(" "),_vm._l((this.investidores.ContratoSocial),function(item){return _c('div',{staticClass:"col-12 col-lg-6 col-xl-4",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"box-doc"},[_c('i',{staticClass:"icon icon-jpg-2 lg"}),_vm._v(" "),_c('div',{staticClass:"doc-text"},[_c('h5',[_vm._v("\n                                    Contrato social\n                                ")]),_vm._v(" "),_c('p',[_vm._v("Arquivo: "),_c('span',[_vm._v(" "+_vm._s(_vm.nomeArquivo(item.MetaDados ? item.MetaDados.NomeArquivo : item.NomeArquivo)))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-start align-items-center"},[_c('p',[_vm._v("Enviado em "+_vm._s(_vm.formatDate(item.MetaDados ? item.MetaDados.DataUltimaModificacao : item.DataUltimaModificacao)))]),_vm._v(" "),_c('a',{attrs:{"href":item.UrlTemporario}},[_vm._v("\n                                        Visualizar\n                                    ")])])])])])}),_vm._v(" "),_vm._l((this.investidores.Dre),function(item){return _c('div',{staticClass:"col-12 col-lg-6 col-xl-4",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"box-doc"},[_c('i',{staticClass:"icon icon-jpg-2 lg"}),_vm._v(" "),_c('div',{staticClass:"doc-text"},[_c('h5',[_vm._v("\n                                    DRE \n                                ")]),_vm._v(" "),_c('p',[_vm._v("Arquivo: "),_c('span',[_vm._v(" "+_vm._s(_vm.nomeArquivo(item.MetaDados ? item.MetaDados.NomeArquivo : item.NomeArquivo)))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-start align-items-center"},[_c('p',[_vm._v("Enviado em "+_vm._s(_vm.formatDate(item.MetaDados ? item.MetaDados.DataUltimaModificacao : item.DataUltimaModificacao)))]),_vm._v(" "),_c('a',{attrs:{"href":item.UrlTemporario}},[_vm._v("\n                                        Visualizar\n                                    ")])])])])])})],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"no-space"},[_c('div',{staticClass:"tit"},[_c('h2',{staticClass:"space"},[_vm._v("Documentos")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Eqk4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedesSocaisStep_vue__ = __webpack_require__("G18G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6feec7ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedesSocaisStep_vue__ = __webpack_require__("yNFo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedesSocaisStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6feec7ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedesSocaisStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EtEi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row finish-investment"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row btn-container"},[_c('div',{staticClass:"col-lg-4 col-xl-4 col-ms-12 col-12 container-back"},[_c('a',{staticClass:"btn btn-back",attrs:{"target":"_blank"},on:{"click":function($event){return _vm.Redirect('lista')}}},[_vm._v("\n                    Ver Outras Oportunidades\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-xl-4 col-ms-12 col-12 container-submit"},[_c('button',{staticClass:"btn btn-submit",attrs:{"id":"buttonSubmit","target":"_blank"},on:{"click":_vm.SubmitInvestment}},[_vm._v("\n                   CONFIRMAR INVESTIMENTO\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"white col-12 col-lg-12 col-xl-12"},[_c('div',{staticClass:"box-col-table"},[_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.solicitacao != null)?_c('tr',{class:_vm.ScoreClass(this.score)},[_c('td',{staticClass:"rating align-middle text-center"},[_c('span',{staticClass:"circle side-circle"}),_vm._v(" "+_vm._s(_vm.score)+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                    "+_vm._s(_vm.solicitacao.IdOportunidade)+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                    "+_vm._s(_vm.TipoInvestimento())+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                    "+_vm._s(_vm.NomeTomador())+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                    "+_vm._s(_vm.solicitacao.Rendimento)+"% a.a\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                    "+_vm._s(_vm.FormatCurrency(this.Valor))+" "),_c('i',{staticClass:"far fa-edit clk",on:{"click":function($event){return _vm.Redirect('perfil')}}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-img-top card-background",class:_vm.ScoreClass(this.score)},[_c('div',{staticClass:"badge badge-id"},[_vm._v("ID: "+_vm._s(_vm.solicitacao.IdOportunidade))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.NomeTomador()))]),_vm._v(" "),_c('div',{staticClass:"rating"},[_c('span',{staticClass:"circle"},[_vm._v(_vm._s(_vm.score))])])]),_vm._v(" "),_c('div',{staticClass:"card-body",class:_vm.ScoreClass(this.score)},[_c('dd',{staticClass:"cat"},[_vm._v(_vm._s(_vm.TipoInvestimento()))]),_vm._v(" "),_c('dt',[_vm._v("Valor à Pagar")]),_vm._v(" "),_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm.FormatCurrency(this.Valor - this.ValorReinv)))]),_vm._v(" "),(_vm.FormatCurrency(this.ValorReinv)!='0,00')?_c('dt',[_vm._v("Valor Reinvestido")]):_vm._e(),_vm._v(" "),(_vm.FormatCurrency(this.ValorReinv)!='0,00')?_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm.FormatCurrency(this.ValorReinv)))]):_vm._e(),_vm._v(" "),_c('dd',[_c('p',{staticClass:"small"},[_vm._v("Total investido:\n                                "),_c('strong',[_vm._v(_vm._s(_vm.FormatCurrency(this.Valor)))])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer d-flex justify-content-between"},[_c('div',{staticClass:"tax"},[_c('strong',[_vm._v("Rendimento")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.solicitacao.Rendimento)+"% a.a")])]),_vm._v(" "),_c('div',{staticClass:"links"},[_c('a',{staticClass:"btn btn-outline-primary btn-block",attrs:{"title":"+ detalhes"},on:{"click":function($event){return _vm.Redirect('perfil')}}},[_vm._v("+ detalhes")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row paymentBox"},[_c('div',{staticClass:"col-lg-5 col-xl-5 col-ms-6 col-12"},[_c('div',{staticClass:"gray paymentBox_table box-col-list"},[_c('table',{staticClass:"table"},[(_vm.FormatCurrency(this.ValorReinv)!='0,00')?_c('thead',[_c('tr',[_c('th',{staticClass:"paymentBox-tit align-middle text-left",attrs:{"scope":"col"}},[_vm._v("\n                                    Reinvestimento\n                                ")]),_vm._v(" "),_c('th',{staticClass:"paymentBox-tit align-middle text-right",attrs:{"scope":"col"}},[_vm._v("\n                                    "+_vm._s(_vm.FormatCurrency(this.ValorReinv))+"\n                                ")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"paymentBox-tit align-middle text-left",attrs:{"scope":"col"}},[_vm._v("\n                                    Valor do boleto\n                                ")]),_vm._v(" "),_c('th',{staticClass:"paymentBox-tit align-middle text-right",attrs:{"scope":"col"}},[_vm._v("\n                                    "+_vm._s(_vm.FormatCurrency(this.Valor - this.ValorReinv))+"\n                                ")])])]):_vm._e(),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"paymentBox-contt align-middle text-left"},[_vm._v("\n                                    Total investido\n                                ")]),_vm._v(" "),_c('td',{staticClass:"total-value paymentBox-contt align-middle text-right"},[_vm._v("\n                                    "+_vm._s(_vm.FormatCurrency(this.Valor))+"\n                                ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row btn-container"},[_c('div',{staticClass:"col-lg-4 col-xl-4 col-ms-12 col-12 container-back"},[_c('a',{staticClass:"btn btn-back",attrs:{"target":"_blank"},on:{"click":function($event){return _vm.Redirect('lista')}}},[_vm._v("\n                    Ver Outras Oportunidades\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-xl-4 col-ms-12 col-12 container-submit"},[_c('a',{staticClass:"btn btn-submit",attrs:{"target":"_blank"},on:{"click":_vm.SubmitInvestment}},[_vm._v("\n                    CONFIRMAR INVESTIMENTO\n                ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"tit_page"},[_c('h1',[_vm._v("\n                Confirmação de investimento\n            ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('hr',{staticClass:"divider"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"80"}},[_vm._v("\n                                    Score\n                                ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"80"}},[_vm._v("\n                                    ID\n                                ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"200"}},[_vm._v("\n                                    Tipo\n                                ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n                                    Tomador\n                                ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"120"}},[_vm._v("\n                                    Rendimento\n                                ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"200"}},[_vm._v("\n                                    Valor Investimento\n                                ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EvQh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_loansProfiles_DetalhesColetivo__ = __webpack_require__("cSwh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_loansProfiles_DetalhesImpacto__ = __webpack_require__("luuY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_loansProfiles_DetalhesCcb__ = __webpack_require__("xCYr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_api_faturaTomador__ = __webpack_require__("rvI3");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			finishedLoading: false,
			faturas: null,
			solicitacao: null,
			solicitacaoId: this.$route.query.id,
			type: this.$route.query.type
		};
	},

	components: {
		DetalhesColetivo: __WEBPACK_IMPORTED_MODULE_4__components_loansProfiles_DetalhesColetivo__["a" /* default */],
		DetalhesImpacto: __WEBPACK_IMPORTED_MODULE_5__components_loansProfiles_DetalhesImpacto__["a" /* default */],
		DetalhesCcb: __WEBPACK_IMPORTED_MODULE_6__components_loansProfiles_DetalhesCcb__["a" /* default */]
	},
	computed: {
		id: function id() {
			return this.ajustIdOportunidade(this.solicitacao.IdOportunidade);
		},
		Document: function Document() {
			return this.formatDocument(this.solicitacao.Documento);
		},
		scoreClass: function scoreClass() {
			if (!this.solicitacao.Score) return "";
			return "rating-" + this.solicitacao.Score.replace(/\d/, '').toLowerCase();
		},
		boletos: function boletos() {
			return this.solicitacao.GerouBoletosPagamento;
		}
	},
	methods: {
		ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
			var s = String(id);
			while (s.length < (qtd || 2)) {
				s = "0" + s;
			}
			return s;
		},
		formatDocument: function formatDocument(doc) {
			return __WEBPACK_IMPORTED_MODULE_7__utils_masker__["a" /* default */].maskCnpj(doc);
		},
		formatDate: function formatDate(date) {
			var dateArray = date.split('-');
			var day = dateArray[2];
			var month = dateArray[1];
			var year = dateArray[0];

			return day + "/" + month + "/" + year;
		},
		getFaturaStatusClass: function getFaturaStatusClass(boleto) {
			var cls = void 0;
			var stringDate = boleto.Boleto.due_date;
			var spliter = stringDate.split("-");
			var boletoDate = new Date(spliter[0], spliter[1] - 1, spliter[2], 23, 59, 59);
			var today = new Date();
			var status = boleto.StatusBoleto;

			//console.log("boleto: ", boletoDate)
			//console.log("hoje: ", today)

			if (status === "" || status === undefined) {
				// Sem status
				cls = "ds";
			} else if (boletoDate < today && status !== "paid") {
				// Vencido
				cls = "vc";
			} else if (status === "pending") {
				// A vencer
				cls = "av";
			} else if (status === "paid") {
				// Quitado
				cls = "qt";
			}

			return cls;
		},
		getFaturaTomador: function getFaturaTomador() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var _ref, data;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return __WEBPACK_IMPORTED_MODULE_8__services_api_faturaTomador__["a" /* default */].GetFaturasTomador(_this.solicitacaoId);

							case 2:
								_ref = _context.sent;
								data = _ref.data;


								if (data) {

									_this.faturas = data;
								}

							case 5:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},


		//tagueamento GA
		taggingGA: function taggingGA() {
			this.$ga.page({
				page: '/detalhes-do-emprestimo',
				title: 'Detalhes do empréstimo'
			});
		}
	},
	created: function created() {
		var _this2 = this;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:

							_this2.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["c" /* START_LOADING */]);

							_context2.next = 3;
							return _this2.getFaturaTomador();

						case 3:

							__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getLoanRequest(_this2.solicitacaoId).then(function (response) {
								_this2.solicitacao = response;

								_this2.finishedLoading = true;
								_this2.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
							}).catch(function () {
								_this2.finishedLoading = true;
								_this2.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
							});

							//tagueamento GA
							_context2.next = 6;
							return _this2.taggingGA();

						case 6:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, _this2);
		}))();
	}
});

/***/ }),

/***/ "F46k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"EstadoCivil"}},[_vm._v("\n          Estado Civil\n          ")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","placeholder":"Selecione..."},model:{value:(_vm.currentUser.Pessoal.EstadoCivil),callback:function ($$v) {_vm.$set(_vm.currentUser.Pessoal, "EstadoCivil", $$v)},expression:"currentUser.Pessoal.EstadoCivil"}},_vm._l((_vm.optionsMarital),function(marital,index){return _c('at-option',{key:("maritalOptions" + index),attrs:{"value":marital.value}},[_vm._v(_vm._s(marital.label))])}),1)],1),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Estado Civil")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F5/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-7 text-center"},[_c('div',{staticClass:"tit"},[_c('p',[_vm._v("A(O) "),_c('strong',[_vm._v(_vm._s(_vm.razaoSocial))]),_vm._v(" pertence a um grupo econômico?")])]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.submitWithCorporateGroup}},[_vm._v("Sim")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.submitWithoutCorporateGroup}},[_vm._v("Não")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F9uD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.IdOportunidade!= 0)?_c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_c('iframe',{attrs:{"src":'https://robinacademia.com/p.ashx?o=90&e=1&t='+this.IdOportunidade,"height":"1","width":"1","frameborder":"0"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('img',{attrs:{"src":"/static/assets/images/ico-smile.svg","alt":"Icone feliz"}}),_vm._v(" "),_c('h1',[_vm._v("Cadastro Concluído com sucesso!")]),_vm._v(" "),_c('p',[_vm._v("Recebemos sua solicitação de empréstimo com sucesso."),_c('br'),_vm._v("Em até "),_c('b',[_vm._v("72 horas úteis")]),_vm._v(", você receberá uma resposta."),_c('br'),_vm._v("Você poderá acompanhar a sua solicitação de empréstimo pela área do cliente ou por e-mail")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})]),_vm._v(" "),_c('p',{staticClass:"nome"},[_vm._v("Obrigado por escolher nos escolher!")]),_vm._v(" "),_c('p',{staticClass:"obs"},[_vm._v("Juntos vamos reinventar o sistema bancário ultrapassado e garantir um melhor negócio para todos.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FC0f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var faturamentoMensal = this.solicitacao.Empresa.FaturamentoMensal;
    return {
      faturamentoMensal: faturamentoMensal ? faturamentoMensal.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }) : null
    };
  },

  computed: {
    faturamentoValido: function faturamentoValido() {
      return parseFloat(this.faturamentoMensal) <= 0;
    }
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = {
        Empresa: {
          FaturamentoMensal: __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].formatReal(this.faturamentoMensal)
        }
      };
      this.$emit('on-submit', newData);
    }
  }
});

/***/ }),

/***/ "FGQr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("96tf");



var _this = this;


var BASE_URI_GO_API = "https://api.iouu.com.br" + '/api/v1';

var GetReservaId = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(solicitacaoID) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/reserva/solicitacao/' + solicitacaoID);

                    case 3:
                        return _context.abrupt('return', _context.sent);

                    case 6:
                        _context.prev = 6;
                        _context.t0 = _context['catch'](0);
                        throw new Error('Erro ao carregar detalhe das notifica\xE7\xF5es');

                    case 9:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this, [[0, 6]]);
    }));

    return function GetReservaId(_x) {
        return _ref.apply(this, arguments);
    };
}();

var GetBoletoInvestidor = function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/reserva/boleto/' + id);

                    case 2:
                        return _context2.abrupt('return', _context2.sent);

                    case 3:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this);
    }));

    return function GetBoletoInvestidor(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

/* harmony default export */ __webpack_exports__["a"] = ({ GetReservaId: GetReservaId, GetBoletoInvestidor: GetBoletoInvestidor });

/***/ }),

/***/ "FJeV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploadFotoIdentificacaoStep_vue__ = __webpack_require__("bHNz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2411276_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploadFotoIdentificacaoStep_vue__ = __webpack_require__("OAMV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploadFotoIdentificacaoStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2411276_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploadFotoIdentificacaoStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FNzu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/liza.685fb13.jpg";

/***/ }),

/***/ "FOKo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletExtratoListaItem_vue__ = __webpack_require__("oG/H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09d08598_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletExtratoListaItem_vue__ = __webpack_require__("eSYy");
function injectStyle (ssrContext) {
  __webpack_require__("3lTO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09d08598"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletExtratoListaItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09d08598_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletExtratoListaItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FOcS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"NaturezaOcupacao"}},[_vm._v("\n            Natureza Ocupação\n          ")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.currentUser.Social.NaturezaOcupacao),callback:function ($$v) {_vm.$set(_vm.currentUser.Social, "NaturezaOcupacao", $$v)},expression:"currentUser.Social.NaturezaOcupacao"}},_vm._l((_vm.occupations),function(occupation,index){return _c('at-option',{key:("occupationsOptions" + index),attrs:{"value":occupation.value}},[_vm._v(_vm._s(occupation.label))])}),1)],1),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Natureza da Ocupação")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FRb7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__ = __webpack_require__("65ha");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      zipcode: this.address.zipcode,
      neighborhood: this.address.neighborhood,
      complement: this.address.complement,
      street: this.address.street,
      number: this.address.number,
      state: this.address.state,
      city: this.address.city,
      isSearchingAddress: false,
      isSearchingStates: false,
      statePlaceholder: 'Carregando',
      states: [],
      cities: []
    };
  },

  props: {
    address: { required: true, type: Object }
  },
  computed: {
    estaCidadeDesabilitado: function estaCidadeDesabilitado() {
      return this.isSearchingAddress || this.cities.length == 0;
    },
    estaEstadoDesabilitado: function estaEstadoDesabilitado() {
      return this.isSearchingAddress || this.isSearchingStates;
    },
    cityPlaceholder: function cityPlaceholder() {
      if ((this.isSearchingAddress || this.cities.length == 0) && typeof this.state != 'undefined') {
        return 'Carregando';
      } else {
        return 'Cidade';
      }
    }
  },
  methods: {
    handleZipcodeChange: function handleZipcodeChange(e) {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskZipcode(e.target.value).length < 8) return;
      this.isSearchingAddress = true;
      __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarCeps(e.target.value).then(function (endereco) {
        _this.street = endereco.logradouro;
        _this.neighborhood = endereco.bairro;
        _this.state = endereco.uf;
        _this.city = endereco.localidade;

        _this.isSearchingAddress = false;

        if (_this.states == '' && typeof endereco.uf != 'undefined') {
          _this.states = [{ uf: endereco.uf }];
          _this.isSearchingStates = false;
          _this.statePlaceholder = 'Estado';
          setTimeout(function () {
            _this.state = endereco.uf;
          }, 100);
        }
      }).catch(function () {
        _this.isSearchingAddress = false;
      });
    },
    onUfChange: function onUfChange() {
      var _this2 = this;

      if (!this.state) {
        this.city = '';
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarCidades(this.state).then(function (cities) {
        _this2.cities = cities;
        if (_this2.city) {
          _this2.setCity();
        }
      });
    },
    setCity: function setCity() {
      var _this3 = this;

      var city = this.cities.find(function (city) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__["a" /* default */].removeAccents(city.nome.toUpperCase()) == __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__["a" /* default */].removeAccents(_this3.city.toUpperCase());
      });
      if (!city) {
        this.city = '';
      } else {
        // When the city state is seted before cities is populated the component doesn't show
        // the selected city.
        this.city = '';
        setTimeout(function () {
          return _this3.city = city.nome;
        }, 100);
      }
    },
    submit: function submit() {
      if (this.city != undefined && this.state != undefined) {
        var newData = {
          zipcode: __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskZipcode(this.zipcode),
          street: this.street,
          number: this.number,
          complement: this.complement,
          neighborhood: this.neighborhood,
          state: this.state,
          city: this.city
        };
        this.$emit('submit', newData);
      }
    }
  },
  created: function created() {
    var _this4 = this;

    this.isSearchingStates = true;
    __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarEstados().then(function (states) {
      _this4.states = states;

      _this4.statePlaceholder = 'Estado';
      _this4.isSearchingStates = false;
      // When the city state is seted before cities is populated the component doesn't show
      // the selected city.
      var state = _this4.state;
      var city = _this4.city;
      _this4.state = '';
      setTimeout(function () {
        _this4.state = state;
        _this4.city = city;
      }, 100);
    });
  },
  mounted: function mounted() {
    this.$refs.stateSelect.$el.children[0].children[2].required = true;
    this.$refs.citySelect.$el.children[0].children[2].required = true;
  }
});

/***/ }),

/***/ "FZfk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FbpO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposito operacao row"},[_c('div',{staticClass:"col-12 col-md-7 sep"},[_c('table',{staticClass:"info"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Valor")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("R$ "+_vm._s(_vm.formatarDinheiro(_vm.valor)))])])])])]),_vm._v(" "),_c('div',{staticClass:"detalhes col-12 col-md-5"},[_c('div',{staticClass:"options"},[_c('p',[_vm._v("\n                ID da Transação\n                "),_c('strong',[_vm._v("\n                    "+_vm._s(_vm.transacao)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('a',{staticClass:"btn btn-success",attrs:{"href":_vm.boletoUrl,"target":"_blank"}},[_c('i',{staticClass:"fas fa-barcode"}),_vm._v(" Visualizar boleto")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("\n                    Detalhes de Recebimento\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FgIv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"btn btn-lg btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('h1',[_vm._v("Falta pouco!")]),_vm._v(" "),_c('p',[_vm._v("Para finalizar, precisamos validar as informações que você nos forneceu através de alguns comprovantes.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fh4h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletReceipt_vue__ = __webpack_require__("xTBZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305fd075_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletReceipt_vue__ = __webpack_require__("sPfU");
function injectStyle (ssrContext) {
  __webpack_require__("5Fz8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-305fd075"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletReceipt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305fd075_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletReceipt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fm9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_api_faturaTomador__ = __webpack_require__("rvI3");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Modal: __WEBPACK_IMPORTED_MODULE_5__components_Modal__["a" /* default */], FilesInput: __WEBPACK_IMPORTED_MODULE_6__components_FilesInput__["a" /* default */] },
    data: function data() {
        return {
            finishedLoading: false,
            faturas: null,
            solicitacao: null,
            solicitacaoId: this.$route.query.id,
            showModal: false,
            submitted: false,
            files: [null],
            idBoleto: "",
            /* eslint-disable */
            uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
            acceptedFormats: 'application/pdf, image/jpeg, image/png'
        };
    },

    computed: {
        id: function id() {
            return this.ajustIdOportunidade(this.solicitacao.IdOportunidade);
        },
        Document: function Document() {
            return this.formatDocument(this.solicitacao.Documento);
        },
        receivedFiles: function receivedFiles() {
            return this.files.filter(function (file) {
                return file != null && file != undefined;
            });
        }
    },
    methods: {
        ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
            var s = String(id);
            while (s.length < (qtd || 2)) {
                s = "0" + s;
            }
            return s;
        },
        formatDocument: function formatDocument(doc) {
            return __WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].maskCnpj(doc);
        },
        formatDate: function formatDate(date) {
            var dateArray = date.split('-');
            var day = dateArray[2];
            var month = dateArray[1];
            var year = dateArray[0];

            return day + "/" + month + "/" + year;
        },
        getFaturaStatusClass: function getFaturaStatusClass(boleto) {
            var cls = void 0;
            var stringDate = boleto.Boleto.due_date;
            var spliter = stringDate.split("-");
            var boletoDate = new Date(spliter[0], spliter[1] - 1, spliter[2], 23, 59, 59);
            var today = new Date();
            var status = boleto.StatusBoleto;

            if (status === "" || status === undefined) {
                // Sem status
                cls = "ds";
            } else if (boletoDate < today && status !== "paid") {
                // Vencido
                cls = "vc";
            } else if (status === "pending") {
                // A vencer
                cls = "av";
            } else if (status === "paid") {
                // Quitado
                cls = "qt";
            }

            return cls;
        },
        getFaturaStatusText: function getFaturaStatusText(boleto) {
            var txt = void 0;
            var stringDate = boleto.Boleto.due_date;
            var spliter = stringDate.split("-");
            var boletoDate = new Date(spliter[0], spliter[1] - 1, spliter[2], 23, 59, 59);
            var today = new Date();
            var status = boleto.StatusBoleto;

            if (status === "" || status === undefined || status === "pending") {
                txt = "A vencer";
            } else if (boletoDate < today && status !== "paid") {
                txt = "Atrasado";
            } else if (status === "paid") {
                txt = "Pago";
            } else if (status === 'canceled') {
                txt = "Cancelado";
            }

            return txt;
        },
        exibeModal: function exibeModal(id, campo) {
            this.files = [null];
            this.submitted = false;
            this.showModal = true;

            this.idBoleto = id;
            this.campoMongo = campo;

            if (document.getElementsByTagName("main").length > 0) {
                document.getElementsByTagName("main")[0].style.zIndex = "50";
            }
        },
        closeModal: function closeModal() {
            var _this = this;

            this.showModal = false;

            __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getFaturas(this.solicitacaoId).then(function (response) {
                _this.faturas = response;
            });

            if (document.getElementsByTagName("main").length > 0) {
                document.getElementsByTagName("main")[0].style.zIndex = "0";
            }
        },
        onFilesChanged: function onFilesChanged(updatedFiles) {
            this.files = updatedFiles;
        },
        getComprovanteUrl: function getComprovanteUrl(obj) {
            var url = void 0;

            if (obj.length > 0) {
                url = obj[obj.length - 1].Nome;
            }

            return "https://hub-app.iouu.com.br" + "/file/" + url;
        },
        verifyCanceled: function verifyCanceled(status) {
            if (status === "canceled") {
                return "cld";
            }
        },
        submit: function submit() {
            this.submitted = true;

            __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].postComprovanteFatura(this.idBoleto, this.campoMongo, this.receivedFiles).then(function () {});
        },
        getFaturaTomador: function getFaturaTomador() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_7__services_api_faturaTomador__["a" /* default */].GetFaturasTomador(_this2.solicitacaoId);

                            case 2:
                                _ref = _context.sent;
                                data = _ref.data;


                                if (data) {

                                    _this2.faturas = data;
                                }

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/emprestimos/boletos',
                title: 'Todos os Boletos'
            });
        }
    },
    created: function created() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["c" /* START_LOADING */]);

                            _context2.next = 3;
                            return _this3.getFaturaTomador();

                        case 3:

                            __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getLoanRequest(_this3.solicitacaoId).then(function (response) {
                                _this3.solicitacao = response;
                                _this3.finishedLoading = true;
                                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            }).catch(function () {
                                _this3.finishedLoading = true;
                                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            });

                            _context2.next = 6;
                            return _this3.taggingGA();

                        case 6:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this3);
        }))();
    }
});

/***/ }),

/***/ "FpaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion",attrs:{"id":"accordion"}},_vm._l((_vm.operacoes),function(op,index){return _c('item',{key:index,attrs:{"index":index,"item":op}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fzm+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"login",attrs:{"to":"/escolher-conta"},on:{"click":_vm.handleModal}},[_c('img',{attrs:{"src":__webpack_require__("u9Ef"),"alt":"icone login"}}),_vm._v("\n        Criar nova conta\n    ")]),_vm._v(" "),_c('h1',[_vm._v("Acesse sua conta")])]),_vm._v(" "),_c('form',{staticClass:"form",attrs:{"id":"form-contato"},on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"login"}},[_vm._v("Login")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],staticClass:"js-input",attrs:{"type":"text","name":"login","id":"login"},domProps:{"value":(_vm.user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"senha"}},[_vm._v("Senha")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],staticClass:"js-input password",attrs:{"type":"password","name":"senha","id":"senha","onmouseover":"this.type='text'","onmouseout":"this.type='password'"},domProps:{"value":(_vm.user.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":__webpack_require__("LQU4"),"alt":"icone senha"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('a',{attrs:{"href":"https://dashboard-app.iouu.com.br/#/recuperar-senha"}},[_c('img',{attrs:{"src":__webpack_require__("UOOV"),"alt":"icone cadeado"}}),_vm._v("\n        Esqueci minha senha")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn",attrs:{"type":"submit"}},[_vm._v("\n        Acessar minha conta\n        "),_c('img',{attrs:{"src":__webpack_require__("RYdq"),"alt":"icone seta"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G18G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var social = this.currentUser.Social;
    return {
      Facebook: social ? social.Socio.Facebook : null,
      Linkedin: social ? social.Socio.Linkedin : null
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      this.currentUser.Social.Socio.Facebook = this.Facebook;
      this.currentUser.Social.Socio.Linkedin = this.Linkedin;

      this.$emit('on-submit', { Social: this.currentUser.Social });
    }
  },
  created: function created() {
    if (!this.currentUser.Social) this.currentUser.Social = {};
  }
});

/***/ }),

/***/ "G6tb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacoesSocioStep_vue__ = __webpack_require__("KqKg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7374c269_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacoesSocioStep_vue__ = __webpack_require__("KdVt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacoesSocioStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7374c269_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacoesSocioStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GDvA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ico-barisul.ea5d5a9.png";

/***/ }),

/***/ "GV5C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-7 text-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.submitWithCorporateGroup}},[_vm._v("Sim")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.submitWithoutCorporateGroup}},[_vm._v("Não")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('p',[_vm._v("Os sócios da empresa possuem algum financiamento já contratado?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GYq5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GYzd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GZwC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GcYk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"back float-right"},[_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar\n\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"box-td"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),(_vm.response)?_c('tbody',[_vm._l((_vm.ArquivosIdentidade),function(documento){return _c('tr',{key:documento.Nome},[_c('td',{staticClass:"align-middle text-left"},[(documento.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(documento.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("                        \n                                    "+_vm._s(_vm.nomeArquivo(documento.MetaDados.NomeArquivo))+" \n                                    "),(documento.Status == '' || documento.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(documento.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                    Identidade\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                    "+_vm._s(_vm.formatDate(documento.DataEnvio))+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(documento.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(documento, 'Identidade', 'Pessoal.ArquivosIdentidade')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + documento.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])])])}),_vm._v(" "),_vm._l((_vm.ArquivoFotoIdentificacao),function(documento){return _c('tr',{key:documento.Nome},[_c('td',{staticClass:"align-middle text-left"},[(documento.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(documento.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("                        \n                                    "+_vm._s(_vm.nomeArquivo(documento.MetaDados.NomeArquivo))+" \n                                    "),(documento.Status == '' || documento.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(documento.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                    Foto de Identificação\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                    "+_vm._s(_vm.formatDate(documento.DataEnvio))+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(documento.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(documento, 'Foto de Identificação', 'Pessoal.ArquivoFotoIdentificacao')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + documento.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])])])}),_vm._v(" "),_vm._l((_vm.ArquivoComprovanteEndereco),function(documento){return _c('tr',{key:documento.Nome},[_c('td',{staticClass:"align-middle text-left"},[(documento.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(documento.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("                        \n                                    "+_vm._s(_vm.nomeArquivo(documento.MetaDados.NomeArquivo))+" \n                                    "),(documento.Status == '' || documento.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(documento.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                    Comprovante de Endereço\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                    "+_vm._s(_vm.formatDate(documento.DataEnvio))+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(documento.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(documento, 'Comprovante de Endereço', 'Pessoal.ArquivoComprovanteEndereco')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + documento.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])])])}),_vm._v(" "),_vm._l((_vm.ArquivoHolerite),function(documento){return _c('tr',{key:documento.Nome},[_c('td',{staticClass:"align-middle text-left"},[(documento.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(documento.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("                        \n                                    "+_vm._s(_vm.nomeArquivo(documento.MetaDados.NomeArquivo))+" \n                                    "),(documento.Status == '' || documento.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(documento.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                    Holerite\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                    "+_vm._s(_vm.formatDate(documento.DataEnvio))+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(documento.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(documento, 'Holerite', 'Pessoal.ArquivoHolerite')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + documento.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])])])}),_vm._v(" "),_vm._l((_vm.ArquivoExtratoBancario),function(documento){return _c('tr',{key:documento.Nome},[_c('td',{staticClass:"align-middle text-left"},[(documento.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(documento.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("                        \n                                    "+_vm._s(_vm.nomeArquivo(documento.MetaDados.NomeArquivo))+" \n                                    "),(documento.Status == '' || documento.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(documento.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                    Extrato Bancário\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                    \n                                     "+_vm._s(_vm.formatDate(documento.DataEnvio))+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(documento.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(documento, 'Extrato Bancário', 'Pessoal.ArquivoExtratoBancario')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + documento.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])])])})],2):_vm._e()])]),_vm._v(" "),(_vm.showModal)?_c('modal',{staticClass:"modal-invited",on:{"close":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"tit float-left"},[_c('h2',{staticStyle:{"padding-right":"50px"}},[_c('i',{staticClass:"icon icon-airplane xl"}),_vm._v("\n                            Enviar "+_vm._s(_vm.tipoArquivoSelecionado)+"\n                        ")])])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-x":"auto"},attrs:{"slot":"body"},slot:"body"},[(_vm.submitted)?_c('div',{staticClass:"success d-flex flex-column justify-content-center align-items-center"},[_c('i',{staticClass:"icon icon-success xll"}),_vm._v(" "),_c('h3',[_vm._v("Documento enviado com sucesso!")])]):_c('div',[_c('files-input',{attrs:{"files":_vm.files,"accept":_vm.acceptedFormats,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"float-md-right"},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"color":"#fff !important"},on:{"click":function($event){return _vm.submit()}}},[_vm._v("Enviar Documentos")])])],1),_vm._v(" "),_c('br')])]):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("Documentos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"align-middle text-left",attrs:{"scope":"col"}},[_vm._v("\n                                    Nome\n                                ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-left",attrs:{"scope":"col"}},[_vm._v("\n                                    Documento\n                                ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n                                    Enviado\n                                ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n                                     \n                                ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GfAA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GtH2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeadLoansLayout_vue__ = __webpack_require__("O2ge");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4032304_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeadLoansLayout_vue__ = __webpack_require__("LmXV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeadLoansLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4032304_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeadLoansLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gu0g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletHistorico_vue__ = __webpack_require__("Iej9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87f374ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletHistorico_vue__ = __webpack_require__("34Te");
function injectStyle (ssrContext) {
  __webpack_require__("2dw2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-87f374ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletHistorico_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87f374ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletHistorico_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GzgH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H9vF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_wallet_index_js__ = __webpack_require__("c/xH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api_investor_index_js__ = __webpack_require__("mHLF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SimpleLoader__ = __webpack_require__("uRog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_charts_BarChartInvestimentos__ = __webpack_require__("Levr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_mutation_types_js__ = __webpack_require__("Du/2");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



// import MarketingDrip from '../services/api/marketing';






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { BarChart: __WEBPACK_IMPORTED_MODULE_7__components_charts_BarChartInvestimentos__["a" /* default */], Loading: __WEBPACK_IMPORTED_MODULE_5__components_SimpleLoader__["a" /* default */] },
  ready: function ready() {
    this.legendMarkup = this._chart.generateLegend();
  },
  data: function data() {
    return {

      Pendente: 0,
      PorcentagemRetorno: 0,
      InvTotal: 0,
      Saldo: 0,
      RendimentoTotal: 0,
      IdInvestidor: 0,
      InvestimentoTotal: 0,
      RetornoTotal: 0,
      Pago: 0,
      Infos: {},
      // renderizou:false,
      loading: true,
      legendMarkup: "",
      DadosLegenda: [],
      Credito: 0,
      Debito: 0,
      TipoUser: '',
      investimentos: '',
      suitability: '',
      investidor: '',
      sexo: '',
      estadoCivil: '',
      perfilSuitability: ''
    };
  },

  methods: {
    // Requisição para trazer extrato com saldo
    extratoCarteira: function extratoCarteira() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var tempJuros, tempPeso, count, _ref, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tempJuros = 0.0, tempPeso = 0.0, count = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__services_api_wallet_index_js__["a" /* default */].GetExtratoSolicitacao();

              case 3:
                _ref = _context2.sent;
                data = _ref.data;

                if (!(data === undefined)) {
                  _context2.next = 15;
                  break;
                }

                _this.loading = false;
                _this.RetornoTotal = 0.00;
                _this.Saldo = 0.00;
                _this.InvestimentoTotal = 0.00;
                _this.Pago = 0.00;
                _this.PorcentagemRetorno = 0.00;
                return _context2.abrupt('return');

              case 15:
                if (!(data.Operacoes === undefined)) {
                  _context2.next = 24;
                  break;
                }

                _this.loading = false;
                _this.Infos = data;
                _this.Saldo = data.Saldo;
                _context2.next = 21;
                return _this.idInvestidor(data.UserId);

              case 21:
                _this.PorcentagemRetorno = (_this.RetornoTotal - _this.InvestimentoTotal) * 100 / _this.InvestimentoTotal;
                _context2.next = 31;
                break;

              case 24:
                _this.Infos = data;
                _this.Saldo = data.Saldo;
                _context2.next = 28;
                return _this.idInvestidor(data.UserId);

              case 28:
                _this.PorcentagemRetorno = (_this.RetornoTotal - _this.InvestimentoTotal) * 100 / _this.InvestimentoTotal;
                _this.Infos.Operacoes.forEach(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(item) {
                    var valorParcela, with2Decimals;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (item.Tipo === "INVESTIMENTO") {

                              if (item.Detalhes.Investimento.SolicitacaoId != "") {
                                valorParcela = _this.PMT(item.Detalhes.Investimento.RetornoBrutoMensal, item.Detalhes.Investimento.Prazo, item.Detalhes.Investimento.Valor);
                                with2Decimals = (item.Detalhes.Investimento.Prazo * valorParcela * -(item.Valor / item.Detalhes.Investimento.Valor)).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];


                                _this.Infos = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data);
                                _this.RetornoTotal += parseFloat(with2Decimals);

                                tempPeso += item.Detalhes.Investimento.Valor;
                                tempJuros += item.Detalhes.Investimento.Valor * item.Detalhes.Investimento.RetornoBrutoMensal;
                                count++;
                              }

                              _this.InvestimentoTotal += item.Valor * -1;
                            }

                            if (item.Tipo === "ESTORNO") {

                              _this.InvestimentoTotal += item.Valor * -1;
                              _this.RetornoTotal += item.Valor * -1;
                              count--;
                            }

                            if (item.Tipo === "PAGAMENTO") {

                              _this.Pago += item.Valor;
                            }

                          case 3:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }());

                if (count > 0) _this.PorcentagemRetorno = tempJuros / tempPeso;else _this.PorcentagemRetorno = 0;

              case 31:

                if (_this.User.tipo.length > 1) {
                  _this.TipoUser = 'Investidor e Tomador';
                } else if (_this.User.tipo[0] === 'INV') {
                  _this.TipoUser = 'Investidor';
                } else {
                  _this.TipoUser = 'Tomador';
                }

                if (_this.InvestimentoTotal === 0) {
                  _this.RetornoTotal = 0;
                }

                // AJUSTE TOTAL INVESTIDO (DATA LAKE: 10/11/2020)

                // this.InvestimentoTotal = totalInvestido

                _this.User.hassuitability === true ? _this.suitability = 'Verdadeiro' : _this.suitability = 'Falso';
                _this.User.hasinvestor === true ? _this.investidor = 'Verdadeiro' : _this.investidor = 'Falso';
                _this.User.hasinvestments === true ? _this.investimentos = 'Verdadeiro' : _this.investimentos = 'Falso';
                if (_this.User.investor.Sexo === 1) {
                  _this.sexo = 'M';
                } else if (_this.User.investor.Sexo === 2) {
                  _this.sexo = 'F';
                }

                if (_this.User.investor.EstadoCivil === 1) {
                  _this.estadoCivil = 'Solteiro (a)';
                } else if (_this.User.investor.EstadoCivil === 2) {
                  _this.estadoCivil = 'Casado (a)';
                } else if (_this.User.investor.EstadoCivil === 3) {
                  _this.estadoCivil = 'Divorciado (a)';
                } else if (_this.User.investor.EstadoCivil === 4) {
                  _this.estadoCivil = 'Viúvo (a)';
                } else if (_this.User.investor.EstadoCivil === 5) {
                  _this.estadoCivil = 'União Estável';
                }

                if (_this.User.suitability !== null) {
                  _this.perfilSuitability = _this.User.suitability.Tipo;
                } else {
                  _this.perfilSuitability = '';
                }

              case 39:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    idInvestidor: function idInvestidor(userId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref3, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_api_investor_index_js__["a" /* default */].GetInvestor(userId);

              case 2:
                _ref3 = _context3.sent;
                data = _ref3.data;


                _this2.IdInvestidor = data._id;
                _this2.reservaInvestimentoPendente(data._id);
                return _context3.abrupt('return', data._id);

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    reservaInvestimentoPendente: function reservaInvestimentoPendente(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var teste, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_api_investor_index_js__["a" /* default */].GetReservaPendente(id);

              case 2:
                teste = _context4.sent;
                data = teste.data;

                if (data) {
                  data.forEach(function (item) {
                    _this3.Pendente += item.Valor;
                  });
                } else _this3.Pendente = 0;
                _this3.loading = false;

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    Investidor: function Investidor() {

      window.variavel = this;
      if (this.User.hasinvestor == undefined) return false;

      return this.User.hasinvestor;
    },
    Nome: function Nome() {
      var nome = "",
          letra = "";
      if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
        nome = this.User.username;
      } else {
        nome = this.User.name;
      }
      nome = nome.trim();

      var primeiroNome = nome.split(" ")[0];

      return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
    },
    formatCurrency: function formatCurrency(value) {
      if (value != null) return value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });

      return 0;
    },
    DataGrafico: function DataGrafico() {
      var _this4 = this;

      var DadosGrafico = Array();

      DadosGrafico.push({ label: "AA", value: 0, color: "#C1CF2E", percent: 0 });
      DadosGrafico.push({ label: "A", value: 0, color: "#2DC2BF", percent: 0 });
      DadosGrafico.push({ label: "B", value: 0, color: "#6FC30D", percent: 0 });
      DadosGrafico.push({ label: "C", value: 0, color: "#F04887", percent: 0 });
      DadosGrafico.push({ label: "D", value: 0, color: "#FFB928", percent: 0 });
      DadosGrafico.push({ label: "E", value: 0, color: "#FD615D", percent: 0 });
      DadosGrafico.push({ label: "HR", value: 0, color: "#B61843", percent: 0 });
      DadosGrafico.push({ label: "Social", value: 0, color: "#52B3D9", percent: 0 });

      var total = 0;

      this.Infos.Operacoes.forEach(function (item) {
        if (item.Detalhes.Investimento.SolicitacaoId !== null && item.Tipo === "INVESTIMENTO" && _this4.InvestimentoTotal > 0) {

          var cor = "";
          var score = "";

          if (item.Detalhes.Investimento.Score === "" || item.Detalhes.Investimento.Score === undefined) {
            score = "Social";
          } else if (item.Detalhes.Investimento.Score === "AA") {
            score = "AA";
          } else if (item.Detalhes.Investimento.Score[0] === "A") {
            score = "A";
          } else if (item.Detalhes.Investimento.Score[0] === "B") {
            score = "B";
          } else if (item.Detalhes.Investimento.Score[0] === "C") {
            score = "C";
          } else if (item.Detalhes.Investimento.Score[0] === "D") {
            score = "D";
          } else if (item.Detalhes.Investimento.Score[0] == "E") {
            score = "E";
          } else if (item.Detalhes.Investimento.Score === "HR") {
            score = "HR";
          }

          var indice = DadosGrafico.map(function (e) {
            return e.label;
          }).indexOf(score);
          DadosGrafico[indice].value += item.Valor * -1;
          total += item.Valor * -1;
        }
      });

      DadosGrafico.forEach(function (item) {
        if (item.value === 0 && total === 0) {
          item.percent = item.value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
        } else {
          item.percent = (item.value / total * 100).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
        }
      });

      this.DadosLegenda = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, DadosGrafico);

      return DadosGrafico;
    },
    PMT: function PMT(taxa, prazo, valor) {
      var parcela;

      taxa = taxa / 100;
      parcela = valor * taxa * Math.pow(1 + taxa, prazo) / (Math.pow(1 + taxa, prazo) - 1);

      return parcela;
    },


    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/investimentos/meus-investimentos',
        title: 'HomeInvestidor'
      });
    }
  },
  computed: {
    User: function User() {
      return this.$store.state.currentUser;
    },
    Receber: function Receber() {

      var receber = this.RetornoTotal - this.Pago;
      if (receber < 0) receber = 0;

      return receber;
    }
  },
  created: function created() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this5.extratoCarteira();

            case 2:
              _context5.next = 4;
              return _this5.taggingGA();

            case 4:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});

/***/ }),

/***/ "HAXa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"d-flex justify-content-center"},[_c('Loading')],1):_c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"row align-items-center dashboard__header"},[_c('div',{staticClass:"col-12 col-lg-7"},[_c('span',[_vm._v("Conta investidor - "+_vm._s(_vm.Nome()))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-6"},[_c('div',{staticClass:"item"},[_c('h2',[_vm._v("R$ "+_vm._s(this.formatCurrency(this.InvestimentoTotal)))]),_vm._v(" "),_c('small',[_vm._v("Investimento total")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-6"},[_c('div',{staticClass:"item"},[_c('h2',[_vm._v("R$ "+_vm._s(this.formatCurrency(this.RetornoTotal)))]),_vm._v(" "),_c('small',[_vm._v("Rendimento total")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-5 text-center text-md-right"},[(false)?_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/investimentos/carteira-investimento/adicionar-fundos","title":"Adicionar fundos"}},[_c('i',{staticClass:"ico-din-4"}),_vm._v(" Adicionar fundos")]):_vm._e(),_vm._v(" "),(false)?_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"","title":"Reinvestir fundos"}},[_vm._v("Resgatar fundos")]):_vm._e()],1)]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-7 dashboard__chart"},[_c('h1',[_vm._v("Meus investimentos "),_c('router-link',{attrs:{"to":{ name: 'Histórico' },"title":"Exibir detalhes"}},[_vm._v("Exibir detalhes")])],1),_vm._v(" "),(_vm.Infos.Operacoes)?_c('div',{staticClass:"box box_chart",staticStyle:{"margin-top":"45px"}},[_c('bar-chart',{attrs:{"data":_vm.DataGrafico()}}),_vm._v(" "),_c('ul',{staticClass:"dashboard__chart--scores"},_vm._l((this.DadosLegenda),function(item){return _c('li',{key:item},[_c('label',[_vm._v(_vm._s(item.label)+" ")]),_vm._v(" "),_c('span',{style:('background-color:'+ item.color +';')},[_vm._v(_vm._s(item.percent)+"%")])])}),0)],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-5"},[_c('div',{staticClass:"row dashboard__infos"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-12"},[_c('div',{staticClass:"box"},[_c('span',[_vm._v("Disponível para saque")]),_vm._v(" "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.Saldo == 0 ? this.formatCurrency(_vm.Saldo) : this.formatCurrency(Math.floor(_vm.Saldo * 100) / 100)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-12"},[_c('div',{staticClass:"box"},[_c('span',[_vm._v("Pendente")]),_vm._v(" "),_c('strong',[_vm._v("R$ "+_vm._s(this.formatCurrency(this.Pendente)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-12"},[_c('div',{staticClass:"box"},[_c('span',[_vm._v("A receber")]),_vm._v(" "),_c('strong',{staticClass:"float-right"},[_vm._v("R$ "+_vm._s(this.formatCurrency(this.Receber)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-12"},[_c('div',{staticClass:"box"},[_c('span',[_vm._v("Estimativa de retorno")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(this.formatCurrency(this.PorcentagemRetorno))+"% a.m.")])])])])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('ul',{staticClass:"row dashboard__links"},[_c('li',{staticClass:"col-12 col-md-4 col-lg-4"},[_c('div',{staticClass:"item"},[_c('router-link',{attrs:{"to":"/investimentos/carteira-investimento","title":"Minha carteira de investimentos"}},[_c('i',{staticClass:"icon icon-wallet"}),_vm._v("\n              Minha carteira de investimentos\n            ")])],1)]),_vm._v(" "),_c('li',{staticClass:"col-12 col-md-4 col-lg-4"},[_c('div',{staticClass:"item"},[_c('router-link',{attrs:{"to":{ name: 'Oportunidades' },"title":"Ver oportunidades"}},[_c('i',{staticClass:"icon icon-listing"}),_vm._v("\n              Ver oportunidades\n            ")])],1)]),_vm._v(" "),_c('li',{staticClass:"col-12 col-md-4 col-lg-4"},[_c('div',{staticClass:"item"},[_c('router-link',{attrs:{"to":{ name: 'Histórico' },"title":"Histórico de investimentos"}},[_c('i',{staticClass:"icon icon-historic"}),_vm._v("\n              Histórico de investimentos\n            ")])],1)])])]),_vm._v(" "),_c('div',[(_vm.loading)?_c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard"},[_c('div',{staticClass:"dashboard__complete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('div',[_c('h1',[_vm._v("Meus investimentos")]),_vm._v(" "),(!_vm.Investidor())?_c('p',[_vm._v(_vm._s(_vm.Nome())+", você ainda não "),_c('strong',[_vm._v("completou seu cadastro")]),_vm._v(". Assim que concluir, você poderá escolher as empresas, montar seu portfólio e fazer o seu investimento!")]):_vm._e(),_vm._v(" "),(!_vm.Investidor())?_c('router-link',{staticClass:"btn btn-lg btn-primary",attrs:{"to":"/informacoes-adicionais/investidor","title":"Completar cadastro"}},[_vm._v("Completar cadastro")]):_vm._e()],1)])])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HGJr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/carteira-investimento/adicionar-fundos',
                title: 'AdicionarFundos'
            });
        }
    },
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.taggingGA();

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ "HGb0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EscolaridadeStep_vue__ = __webpack_require__("JV4v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a617f70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EscolaridadeStep_vue__ = __webpack_require__("Sg4x");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EscolaridadeStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a617f70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EscolaridadeStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HLY0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid login"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"ico-iouu",attrs:{"href":_vm.lpUrl,"target":"_blank","title":"IOUU"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('social-network')],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-7 d-flex flex-column form"},[_c('header',{staticClass:"align-self-center align-self-md-end"},[_vm._v("\n      Já tem uma conta?\n        "),_c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":"login"}},[_vm._v("Entrar")])],1),_vm._v(" "),_c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-5 text-center"},[_c('h2',[_vm._v("Cadastrar senha")]),_vm._v(" "),_c('form',{attrs:{"id":"form-cadastrarSenha"},on:{"submit":function($event){$event.preventDefault();return _vm.signUp($event)}}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","name":"firtname","autofocus":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Endereço de email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",attrs:{"type":"email","placeholder":"Endereço de email do usuário…","readonly":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Senha")]),_vm._v(" "),_c('password-field',{model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('div',{staticClass:"form-check text-left d-flex justify-content-center"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enabled),expression:"enabled"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.enabled)?_vm._i(_vm.enabled,null)>-1:(_vm.enabled)},on:{"change":function($event){var $$a=_vm.enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.enabled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.enabled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.enabled=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_c('div',[_c('label',{staticClass:"form-check-label"},[_vm._v("\n                  Eu \"CONCORDO\" com os "),_c('a',{attrs:{"href":_vm.lpUrl+'/termos-e-condicoes/',"target":"_blank"}},[_vm._v("Termos e condições")]),_vm._v(" e "),_c('a',{attrs:{"href":_vm.lpUrl+'/politica-de-privacidade/',"target":"_blank"}},[_vm._v("Política de privacidade")]),_vm._v(" da IOUU.\n                ")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":!_vm.enabled}},[_vm._v("Continuar")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-lg-10 d-flex flex-column align-items-center"},[_c('h1',[_vm._v("Cadastrar senha")]),_vm._v(" "),_c('p',[_vm._v("\n            Não se preocupe. Você não está assumindo nenhum compromisso neste momento.\n            "),_c('br'),_vm._v("Suas informações serão usadas paenas para analisarmos o seu perfil\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            O empréstimo só acontece se você receber uma proposta, aprová-la e fizer o upload da documentação pedida no site.\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HNV6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid login"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"ico-iouu",attrs:{"href":_vm.lpUrl,"target":"_blank","title":"IOUU"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('social-network')],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-7 d-flex flex-column form"},[_c('header',{staticClass:"align-self-center align-self-md-end"},[_vm._v("\n        Já tem uma conta?\n          "),_c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":"login"}},[_vm._v("Entrar")])],1),_vm._v(" "),(_vm.visivel)?_c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-5 text-center"},[_c('h2',[_vm._v("Criar uma conta")]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-justified align-self-center ",attrs:{"role":"group","aria-label":"Large button group"}}),_vm._v(" "),_c('form',{attrs:{"id":"form-criarConta"},on:{"submit":function($event){$event.preventDefault();return _vm.signUp($event)}}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","name":"firtname","autofocus":""},domProps:{"value":(_vm.name)},on:{"keyup":function($event){return _vm.validateName()},"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Endereço de email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",attrs:{"type":"email","id":"Email"},domProps:{"value":(_vm.email)},on:{"focusout":_vm.ValidarEmail,"focusin":_vm.RetirarAnimacao,"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Senha")]),_vm._v(" "),_c('password-field',{model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('div',{staticClass:"form-check text-left d-flex justify-content-center"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enabled),expression:"enabled"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.enabled)?_vm._i(_vm.enabled,null)>-1:(_vm.enabled)},on:{"change":function($event){var $$a=_vm.enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.enabled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.enabled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.enabled=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_c('label',{staticClass:"form-check-label p-0"},[_vm._v("\n                  Eu \"CONCORDO\" com os "),_c('a',{attrs:{"href":_vm.lpUrl+'/termos-e-condicoes/',"target":"_blank"}},[_vm._v("Termos e condições")]),_vm._v(" e "),_c('a',{attrs:{"href":_vm.lpUrl+'/politica-de-privacidade/',"target":"_blank"}},[_vm._v("Política de privacidade")]),_vm._v(" da IOUU.\n                ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":!_vm.enabled || !_vm.EmailConfirmado}},[_vm._v("Continuar")])])])]):_vm._e(),_vm._v(" "),(!_vm.visivel)?_c('div',{staticClass:"row justify-content-center d-flex align-items-center aviso"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 text-center"},[_c('h2',[_vm._v("Qual perfil deseja criar?")]),_vm._v(" "),_c('div',{staticClass:"align-self-center"},[_c('a',{staticClass:"btn btn-lg btn-primary",attrs:{"href":'https://emprestimos.iouu.com.br/pedido'}},[_c('span',[_vm._v("Empréstimo")])]),_vm._v(" "),_c('router-link',{staticClass:"login",attrs:{"to":"/criar-conta"}},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_c('span',[_vm._v("Investimento")])])])],1)])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-lg-10 d-flex flex-column align-items-center"},[_c('h1',[_vm._v("Crie sua conta")]),_vm._v(" "),_c('p',[_vm._v("\n              Não se preocupe. Você não está assumindo nenhum compromisso neste momento.\n              "),_c('br'),_vm._v("Suas informações serão usadas apenas para analisarmos o seu perfil\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.\n            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validacao"},[_c('i',{staticClass:"invalido fas fa-exclamation-circle",attrs:{"hidden":"","id":"IconeInvalido"}}),_vm._v(" "),_c('i',{staticClass:"valido fas fa-check",attrs:{"hidden":"","id":"IconeValido"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HULF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoConcluido_vue__ = __webpack_require__("2j8w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69bdaa06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoConcluido_vue__ = __webpack_require__("1UsZ");
function injectStyle (ssrContext) {
  __webpack_require__("fjsE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69bdaa06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoConcluido_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69bdaa06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoConcluido_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HUZC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TIPO_EMPRESA_OUTRO = 7;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      razaoSocial: this.solicitacao.Empresa.RazaoSocial,
      tipoEmpresa: this.solicitacao.Empresa.TipoEmpresa,
      tipoEmpresaOutro: this.solicitacao.Empresa.TipoEmpresaOutro
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  computed: {
    ehOutro: function ehOutro() {
      return this.tipoEmpresa == TIPO_EMPRESA_OUTRO;
    }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var tipoEmpresa = this.tipoEmpresa;
      var newData = { Empresa: { TipoEmpresa: tipoEmpresa } };
      if (tipoEmpresa == TIPO_EMPRESA_OUTRO) {
        newData.Empresa.TipoEmpresaOutro = this.tipoEmpresaOutro;
      } else {
        newData.Empresa.TipoEmpresaOutro = null;
      }
      this.$emit('on-submit', newData);
    }
  }
});

/***/ }),

/***/ "HVFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoanSimulation_vue__ = __webpack_require__("+AAn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62159d02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoanSimulation_vue__ = __webpack_require__("vKqp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoanSimulation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62159d02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoanSimulation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Haba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hd66":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoundingDateStep_vue__ = __webpack_require__("f43E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f9ef64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoundingDateStep_vue__ = __webpack_require__("WhUV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoundingDateStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f9ef64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoundingDateStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HdDW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Edite sua informação pessoal")]),_vm._v(" "),_c('p',[_vm._v("Olá "+_vm._s(_vm.firstName)+", para que você se torne um investidor, precisamos primeiramente que preencha as informaçõs abaixo:")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_vm._m(0),_vm._v(" "),_c('form',{attrs:{"id":"form-cadastro-investidor"},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-12"},[_c('label',[_vm._v("E-mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",attrs:{"name":"email","type":"text","required":"","placeholder":"E-mail","disabled":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-9"},[_c('label',{attrs:{"for":"nome"}},[_vm._v("Nome Completo *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fullName),expression:"fullName"}],staticClass:"form-control form-control-lg",style:([ _vm.fullNameError ? { 'border-color': 'red'} : { 'border-color': 'none' } ]),attrs:{"tabindex":"1","name":"firstname","id":"nome","type":"text","required":"","placeholder":"Nome Completo"},domProps:{"value":(_vm.fullName)},on:{"keyup":function($event){return _vm.validateFullName()},"input":function($event){if($event.target.composing){ return; }_vm.fullName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-3"},[_c('label',[_vm._v("Sexo *")]),_vm._v(" "),_c('at-select',{ref:"sexSelect",staticClass:"focus-select",attrs:{"tabindex":"2","name":"gender","placeholder":"Selecione","size":"large"},model:{value:(_vm.sex),callback:function ($$v) {_vm.sex=$$v},expression:"sex"}},_vm._l((_vm.sexOptions),function(sex,i){return _c('at-option',{key:("sexOptions" + i),attrs:{"value":sex.value}},[_vm._v(_vm._s(sex.label))])}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',[_vm._v("Estado civil *")]),_vm._v(" "),_c('at-select',{ref:"maritalSelect",staticClass:"focus-select",attrs:{"tabindex":"3","placeholder":"Selecione","size":"large","required":"true"},model:{value:(_vm.maritalStatus),callback:function ($$v) {_vm.maritalStatus=$$v},expression:"maritalStatus"}},_vm._l((_vm.maritalStatusOptions),function(maritalStatus,i){return _c('at-option',{key:("maritalStatusOptions" + i),attrs:{"value":maritalStatus.value,"selected":i === 0}},[_vm._v(_vm._s(maritalStatus.label))])}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"nomeMae"}},[_vm._v("Nome da mãe *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mothersName),expression:"mothersName"}],staticClass:"form-control form-control-lg",attrs:{"tabindex":"4","id":"nomeMae","type":"text","required":"","placeholder":"Nome da mãe"},domProps:{"value":(_vm.mothersName)},on:{"keyup":function($event){return _vm.validateMothersName()},"input":function($event){if($event.target.composing){ return; }_vm.mothersName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"nomePai"}},[_vm._v("Nome do pai *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fathersName),expression:"fathersName"}],staticClass:"form-control form-control-lg",attrs:{"tabindex":"5","id":"nomePai","type":"text","required":"","placeholder":"Nome do pai"},domProps:{"value":(_vm.fathersName)},on:{"keyup":function($event){return _vm.validateFathersName()},"input":function($event){if($event.target.composing){ return; }_vm.fathersName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',[_vm._v("Telefone fixo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"tabindex":"6","name":"phone","type":"text","placeholder":"Telefone fixo"},domProps:{"value":(_vm.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',[_vm._v("Telefone celular *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cellphoneNumber),expression:"cellphoneNumber"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"tabindex":"7","name":"mobilephone","type":"text","required":"","placeholder":"Telefone celular"},domProps:{"value":(_vm.cellphoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cellphoneNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"cpf"}},[_vm._v("CPF *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cpf),expression:"cpf"},{name:"mask",rawName:"v-mask",value:('cpf'),expression:"'cpf'"}],staticClass:"form-control form-control-lg",attrs:{"tabindex":"8","id":"cpf","type":"text","required":"","placeholder":"CPF"},domProps:{"value":(_vm.cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cpf=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"nacionalidade"}},[_vm._v("Nacionalidade *")]),_vm._v(" "),_c('at-select',{ref:"nationalitySelect",staticClass:"focus-select",attrs:{"tabindex":"9","placeholder":"Selecione","size":"large","required":"true"},model:{value:(_vm.nationality),callback:function ($$v) {_vm.nationality=$$v},expression:"nationality"}},_vm._l((_vm.nationalityOptions),function(nationality,i){return _c('at-option',{key:("nationalityOptions" + i),attrs:{"value":nationality.value}},[_vm._v(_vm._s(nationality.label))])}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"naturalidade"}},[_vm._v("Estado onde nasceu *")]),_vm._v(" "),_c('at-select',{ref:"placeOfBirthSelect",staticClass:"focus-select",attrs:{"tabindex":"10","id":"naturalidade","size":"large","filterable":"","placeholder":"Selecione"},model:{value:(_vm.placeOfBirth),callback:function ($$v) {_vm.placeOfBirth=$$v},expression:"placeOfBirth"}},[_c('at-option',{attrs:{"value":""}},[_vm._v("Selecione")]),_vm._v(" "),_c('at-option',{attrs:{"value":"Exterior"}},[_vm._v("--Exterior--")]),_vm._v(" "),_vm._l((_vm.birthStatesOptions),function(state,i){return _c('at-option',{key:("birthStatesOptions" + i),attrs:{"value":state.nome}},[_vm._v(_vm._s(state.nome))])})],2)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"naturalidadeCidade"}},[_vm._v("\n            Cidade onde nasceu *\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cityOfBirth),expression:"cityOfBirth"}],staticClass:"form-control form-control-lg",attrs:{"tabindex":"11","id":"cityOfBirth","type":"text","required":"","placeholder":"Cidade onde Nasceu"},domProps:{"value":(_vm.cityOfBirth)},on:{"keyup":function($event){return _vm.validateBornCity()},"input":function($event){if($event.target.composing){ return; }_vm.cityOfBirth=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"dataNascimento"}},[_vm._v("Data de Nascimento *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.birthDate),expression:"birthDate"},{name:"mask",rawName:"v-mask",value:('date'),expression:"'date'"}],staticClass:"form-control form-control-lg",attrs:{"tabindex":"12","format":"dd/MM/yyyy","type":"text","required":"","placeholder":"dd/mm/aaaa"},domProps:{"value":(_vm.birthDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.birthDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-3"},[_c('label',{attrs:{"for":"rg"}},[_vm._v("RG / RNE *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rgNumber),expression:"rgNumber"},{name:"mask",rawName:"v-mask",value:('rg'),expression:"'rg'"}],staticClass:"form-control form-control-lg",attrs:{"tabindex":"13","id":"rg","type":"text","required":"","placeholder":"RG"},domProps:{"value":(_vm.rgNumber)},on:{"keyup":function($event){return _vm.validateRgNumber()},"input":function($event){if($event.target.composing){ return; }_vm.rgNumber=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-3"},[_c('label',{attrs:{"for":"orgao-emissor"}},[_vm._v("Orgão emissor *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rgIssuer),expression:"rgIssuer"}],staticClass:"form-control form-control-lg",attrs:{"tabindex":"14","id":"orgao-emissor","type":"text","required":"","placeholder":"Orgão emissor"},domProps:{"value":(_vm.rgIssuer)},on:{"keyup":function($event){return _vm.validateRgIssuer()},"input":function($event){if($event.target.composing){ return; }_vm.rgIssuer=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-3"},[_c('label',{attrs:{"for":"rg-issuer-state"}},[_vm._v("Estado Emissor *")]),_vm._v(" "),_c('at-select',{ref:"rgIssuerStateSelect",staticClass:"focus-select",attrs:{"tabindex":"15","id":"rg-issuer-state","filterable":"","size":"large","placeholder":"Selecione"},on:{"click":function($event){return _vm.rgIssuerStateClear()}},model:{value:(_vm.rgIssuerState),callback:function ($$v) {_vm.rgIssuerState=$$v},expression:"rgIssuerState"}},[_c('at-option',{attrs:{"value":""}},[_vm._v("Selecione")]),_vm._v(" "),_vm._l((_vm.states),function(state,i){return _c('at-option',{key:("stateOptions" + i),attrs:{"value":state.uf}},[_vm._v(_vm._s(state.uf))])})],2)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-3"},[_c('label',{attrs:{"for":"data-emissao"}},[_vm._v("Data de emissão *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rgIssueDate),expression:"rgIssueDate"},{name:"mask",rawName:"v-mask",value:('date'),expression:"'date'"}],staticClass:"form-control form-control-lg",attrs:{"tabindex":"16","id":"data-emissao","format":"dd/MM/yyyy","type":"text","required":"","placeholder":"dd/mm/aaaa"},domProps:{"value":(_vm.rgIssueDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rgIssueDate=$event.target.value}}})])]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h2',[_vm._v("Informações pessoais")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":"static/assets/images/angle-right.svg"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HodG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletExtratoLista_vue__ = __webpack_require__("eOfs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_062823ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletExtratoLista_vue__ = __webpack_require__("FpaI");
function injectStyle (ssrContext) {
  __webpack_require__("GZwC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletExtratoLista_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_062823ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletExtratoLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HvRq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NationalityStep_vue__ = __webpack_require__("96/U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e6cdaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NationalityStep_vue__ = __webpack_require__("coxy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NationalityStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e6cdaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NationalityStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I3I/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"gray","min-height":"100%"}},[_c('button',{staticStyle:{"position":"absolute","right":"30px","top":"15px","padding":"5px","border-radius":"5px","border-width":"0px","background-color":"#fff","color":"#555"},on:{"click":function($event){return _vm.downloadPdf(_vm.BaseRequest)}}},[_vm._v("Download PDF")]),_vm._v(" "),_c('div',{staticClass:"informe-rendimento",staticStyle:{"background-color":"gray","display":"flex","justify-content":"center","padding":"1% 0","font-weight":"300","min-height":"100%"}},[_c('main',{staticStyle:{"width":"900px","padding":"5%"}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('section',{staticStyle:{"margin-bottom":"3%"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"info",staticStyle:{"margin":"50px 0px"}},[_c('div',{staticClass:"item",staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"flex":"2"}},[_vm._v("Nome Completo")]),_vm._v(" "),_c('label',{staticStyle:{"align-items":"right"}},[_c('strong',[_vm._v(_vm._s(_vm.DadosInvestidor.InvestidorNome))])])]),_vm._v(" "),_c('div',{staticClass:"item",staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"flex":"2"}},[_vm._v("CPF")]),_vm._v(" "),_c('label',{staticStyle:{"align-items":"right"}},[_c('strong',[_vm._v(_vm._s(_vm.DadosInvestidor.InvestidorCpf))])])])])]),_vm._v(" "),_c('section',{staticStyle:{"margin-bottom":"3%"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"rendimento",staticStyle:{"margin":"50px 0px","margin-bottom":"0px"}},[_c('div',{staticClass:"item",staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"flex":"3"}},[_vm._v("Situação em 31.12.2019")]),_vm._v(" "),_c('label',{staticStyle:{"align-items":"right"}},[_c('strong',[_vm._v(_vm._s(_vm.DadosInvestidor.ValorPrincipal2019))])])]),_vm._v(" "),_c('div',{staticClass:"item",staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"flex":"3"}},[_vm._v("Situação em 31.12.2020")]),_vm._v(" "),_c('label',{staticStyle:{"align-items":"right"}},[_c('strong',[_vm._v(_vm._s(_vm.DadosInvestidor.ValorPrincipal2020))])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"rendimento",staticStyle:{"margin":"50px 0px","margin-bottom":"0px"}},[_c('div',{staticClass:"item",staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"flex":"3"}},[_vm._v("Valor")]),_vm._v(" "),_c('label',{staticStyle:{"align-items":"right"}},[_c('strong',[_vm._v(_vm._s(_vm.DadosInvestidor.ValorJuros))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticStyle:{"margin-bottom":"3%"}},[_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticStyle:{"flex":"2"}},[_c('img',{attrs:{"src":"data:image/png;base64, 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\n","alt":"Logo da iouu"}})]),_vm._v(" "),_c('div',{staticStyle:{"align-items":"right"}},[_c('label',[_vm._v("Informe de Rendimentos Finaceiros")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_vm._v("Imposto de Renda - Pessoa Física")])])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px 0px"}},[_c('label',[_c('strong',[_vm._v("\n              Ano Calendário 2020\n            ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"margin-bottom":"3%"}},[_c('div',{staticClass:"title",staticStyle:{"margin":"50px 0px","border-bottom":"#d3d3d3 solid 2px"}},[_c('label',{staticStyle:{"margin":"0px"}},[_vm._v("Identificação da fonte pagadora")])]),_vm._v(" "),_c('div',{staticClass:"info",staticStyle:{"margin":"50px 0px"}},[_c('div',{staticClass:"item",staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"flex":"2"}},[_vm._v("Nome empresarial")]),_vm._v(" "),_c('label',{staticStyle:{"color":"#3b46c4","align-items":"right"}},[_c('strong',[_vm._v("IOUU Tecnologia e Serviços Ltda.")])])]),_vm._v(" "),_c('div',{staticClass:"item",staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"flex":"2"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('label',{staticStyle:{"align-items":"right"}},[_c('strong',[_vm._v("26.484.548/0001-48")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title",staticStyle:{"margin":"50px 0px","border-bottom":"#d3d3d3 solid 2px"}},[_c('label',{staticStyle:{"margin":"0px"}},[_vm._v("Pessoa física beneficiária dos rendimentos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title",staticStyle:{"display":"flex","margin":"50px 0px","border-bottom":"#d3d3d3 solid 2px"}},[_c('label',{staticStyle:{"flex":"3"}},[_vm._v("Bens e Direitos")]),_vm._v(" "),_c('label',{staticStyle:{"align-items":"right"}},[_vm._v("Valores em R$")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title",staticStyle:{"display":"flex","margin":"50px 0px","border-bottom":"#d3d3d3 solid 2px"}},[_c('label',{staticStyle:{"flex":"3"}},[_vm._v("Rendimentos sujeitos à tributação exclusiva/definitiva")]),_vm._v(" "),_c('label',{staticStyle:{"align-items":"right"}},[_vm._v("Valores em R$")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I3SD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacoesPjEnderecoStep_vue__ = __webpack_require__("QXUg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e28f4d24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacoesPjEnderecoStep_vue__ = __webpack_require__("yhcd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacoesPjEnderecoStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e28f4d24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacoesPjEnderecoStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I9Nb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex app-wrapper"},[(_vm.showModal)?_c('modal',{staticClass:"modal-invited",on:{"close":function($event){_vm.showModal = false}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"tit float-left"},[_c('h2',[_c('i',{staticClass:"icon icon-airplane xl"}),_vm._v("\n\t\t\tEnviar Convite\n\t\t")])])]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('section',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-3"},[_c('a',{staticClass:"btn btn-primary invited-company",attrs:{"href":"#"},on:{"click":function($event){_vm.modalStep = 2, _vm.activeButton('company'), _vm.auxModalStep = 2}}},[_vm._v("\n\t\t\t\tConvidar empresa\n\t\t\t")])])]),_vm._v(" "),_c('section',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("\n\t\t\t\tConvite por email\n\t\t\t\t")]),_vm._v(" "),(_vm.modalStep === 1)?_c('friend',{on:{"finished":function($event){return _vm.finishInvite()}}}):(_vm.modalStep === 2)?_c('company',{on:{"finished":function($event){return _vm.finishInvite()}}}):(_vm.modalStep === 3)?_c('div',{staticClass:"success d-flex flex-column justify-content-center align-items-center"},[_c('i',{staticClass:"icon icon-success xll"}),_vm._v(" "),_c('h3',[_vm._v("\n\t\t\t\tSeu convite foi enviado com sucesso!\n\t\t\t\t")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":"javascript:;"},on:{"click":function($event){$event.preventDefault();_vm.modalStep = _vm.auxModalStep}}},[_vm._v("\n\t\t\t\tenviar novamente\n\t\t\t\t")])]):_vm._e()],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal modal__bootstrap fade",attrs:{"id":"modalMotivo","tabindex":"-1","role":"dialog","aria-labelledby":"modalMotivo","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal__bootstrap-body"},[_c('div',[_c('h2',[_vm._v("Ir para empréstimos")]),_vm._v(" "),_c('img',{staticClass:"image",attrs:{"src":"/static/assets/images/investidor.svg","alt":""}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-secondary",attrs:{"data-dismiss":"modal","aria-label":"Close"}},[_vm._v("Continuar em Investimentos")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-lg btn-primary",attrs:{"to":"/emprestimos/meus-emprestimos","data-dismiss":"modal"}},[_vm._v("Solicitar um empréstimo "),_c('img',{attrs:{"src":"/static/assets/images/seta-modal.svg","width":"16"}})])],1)])])])]),_vm._v(" "),_c('SideMenu',{attrs:{"items":_vm.menuItems,"tipo":'investimentos'}}),_vm._v(" "),_c('div',{staticClass:"bg"}),_vm._v(" "),_c('div',{staticClass:"wrapper d-flex flex-column"},[_c('header',{staticClass:"head row d-flex justify-content-between"},[_c('div',{staticClass:"col-12 col-md-5 col-lg-5 iouu",class:{mobHide: !_vm.InvestidorComInvestimento()}},[_vm._m(2),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-5 col-lg-7"},[_c('div',{staticClass:"d-flex justify-content-between util mob",class:{resetPad: !_vm.InvestidorComInvestimento()}},[_c('div',{staticClass:"mob-menu"},[_c('a',{staticClass:"btn",on:{"click":function($event){return _vm.ShowMobMenu(true);}}},[_c('i',{staticClass:"fas fa-bars"})])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"mob-profile"},[_c('alerts',{attrs:{"from":_vm.from,"tipoUsuario":"investimentos"}}),_vm._v(" "),_c('div',{staticClass:"user"},[_c('at-dropdown',{attrs:{"placement":"bottom-right"}},[_c('router-link',{attrs:{"to":{ path: '/investimentos/perfil/configuracoes' },"tag":"div"}},[_c('div',{staticClass:"no-image rounded-circle"},[_vm._v(_vm._s(_vm.LetraNome()))])])],1),_vm._v(" "),_c('div',{staticClass:"exit"},[_c('a',{attrs:{"href":"#","title":"Sair"},on:{"click":_vm.Logout}},[_c('i',{staticClass:"ico-exit"})])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end util"},[_c('div',{staticClass:"invite"}),_vm._v(" "),_c('alerts',{attrs:{"from":_vm.from,"tipoUsuario":'investimentos'}}),_vm._v(" "),_c('div',{staticClass:"user"},[_c('at-dropdown',{attrs:{"placement":"bottom-right"}},[_c('div',{staticClass:"no-image rounded-circle"},[_vm._v(_vm._s(_vm.LetraNome()))]),_vm._v(" "),_c('span',[_vm._v("Olá, "),_c('strong',[_vm._v(_vm._s(_vm.Nome()))]),_vm._v(" "),_c('i',{staticClass:"icon icon-chevron-down"})]),_vm._v(" "),_c('at-dropdown-menu',{attrs:{"slot":"menu"},slot:"menu"},[_c('at-dropdown-item',[_c('router-link',{attrs:{"to":{ path: '/investimentos/notificacoes' },"tag":"div"}},[_vm._v("Minhas Notificações")])],1),_vm._v(" "),_c('at-dropdown-item',[_c('router-link',{attrs:{"to":{ path: '/investimentos/meus-investimentos' },"tag":"div"}},[_vm._v("Meus Investimentos")])],1),_vm._v(" "),_c('at-dropdown-item',[_c('router-link',{attrs:{"to":{ path: '/investimentos/historico' },"tag":"div"}},[_vm._v("Meu Histórico")])],1),_vm._v(" "),_c('at-dropdown-item',{attrs:{"divided":""}},[_c('router-link',{attrs:{"to":{ path: '/investimentos/perfil/dados-pessoais' },"tag":"div"}},[_vm._v("Meu Perfil")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"checkout",staticStyle:{"display":"none"}},[_c('at-dropdown',{attrs:{"placement":"bottom-right"}},[_c('i',{staticClass:"ico-ct-4 align-middle"}),_vm._v(" "),_c('span',{staticClass:"checkout-number"},[_vm._v("3")]),_vm._v(" "),_c('at-dropdown-menu',{attrs:{"slot":"menu"},slot:"menu"},[_c('at-dropdown-item',[_c('div',{staticClass:"drop-checkout-header"},[_c('i',{staticClass:"icon icon-wallet-2 xl"}),_vm._v(" "),_c('span',[_vm._v("Carteira de investimentos")])])]),_vm._v(" "),_c('at-dropdown-item',[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("Score")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("ID")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("Valor do investimento")])])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"rating-aa"},[_c('td',{staticClass:"rating align-middle text-center"},[_c('span',{staticClass:"box rounded-circle"})]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("00001")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("R$ 5.000,00")])]),_vm._v(" "),_c('tr',{staticClass:"rating-a"},[_c('td',{staticClass:"rating align-middle text-center"},[_c('span',{staticClass:"box rounded-circle"})]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("00001")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("R$ 5.000,00")])]),_vm._v(" "),_c('tr',{staticClass:"rating-b"},[_c('td',{staticClass:"rating align-middle text-center"},[_c('span',{staticClass:"box rounded-circle"})]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("00001")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("R$ 5.000,00")])])]),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"3"}},[_c('span',[_vm._v("Valor total de investimentos:")]),_vm._v(" "),_c('strong',[_vm._v("R$ 12.000,00")])])])])])]),_vm._v(" "),_c('at-dropdown-item',{attrs:{"divide":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-7"},[_c('router-link',{staticClass:"my-wallet",attrs:{"to":"/carteira-investimento"}},[_vm._v("Ver minha carteira de investimentos")])],1),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('router-link',{staticClass:"btn btn-primary finish",attrs:{"to":"/finalizar-investimento"}},[_vm._v("Finalizar")])],1)])])],1)],1)],1),_vm._v(" "),(_vm.InvestorAprovado)?_c('div',{staticClass:"news"},[_vm._m(5)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"exit"},[_c('a',{attrs:{"href":"#","title":"Sair"},on:{"click":_vm.Logout}},[_c('i',{staticClass:"ico-exit"}),_vm._v(" Sair")])])],1)])]),_vm._v(" "),(!_vm.InvestidorComInvestimento() )?_c('div',{staticClass:"row block-responses"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-4 col-xl-4"},[(!_vm.InvestorAprovado)?_c('p',{staticClass:"user"},[_c('span',[_vm._v(_vm._s(_vm.Nome())+",")]),_vm._v("\n\t\t\t\tSeu perfil está quase completo\n\t\t\t")]):_vm._e(),_vm._v(" "),(!_vm.InvestorAprovado && (!_vm.Investidor() || !_vm.Suitability()))?_c('p',{staticClass:"response"},[_vm._v("\n\t\t\t\tJá confirmamos sua conta na IOUU e para você começar a investir, basta concluir seu cadastro de investidor e preencher o formulário de suitability.\n\t\t\t")]):_vm._e(),_vm._v(" "),(!_vm.InvestorAprovado && _vm.Investidor() && _vm.Suitability())?_c('p',{staticClass:"response"},[_vm._v("\n\t\t\t\tAgora estamos analisando suas informações e retornaremos em até 1 dia útil.\n\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.InvestorAprovado)?_c('p',{staticClass:"user"},[_c('span',[_vm._v(_vm._s(_vm.Nome())+",")]),_vm._v("\n\t\t\t\tSeu perfil está completo.\n\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.InvestorAprovado)?_c('p',{staticClass:"response"},[_vm._v("\n\t\t\t\tAgora você já pode investir nas oportunidades em aberto.\n\t\t\t")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-8 col-xl-8 steps"},[_c('ul',{staticClass:"d-flex justify-content-end"},[_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('li',{staticClass:"step"},[_c('i',{staticClass:"ico",class:_vm.Investidor() ? (this.InvestorAprovado ? ' ico__ok': ' ico__ok next') : ' ico ico__investidor'}),_vm._v(" "),_c('p',[_vm._v("Cadastro de Investidor")]),_vm._v(" "),_c('span',[(!_vm.Investidor())?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":"/informacoes-adicionais/investidor","title":"Preencher formulário"}},[_vm._v("Preencher")]):_vm._e(),_vm._v(" "),(!this.InvestorAprovado && _vm.Investidor())?_c('span',{staticClass:"btn btn-sm btn-primary",staticStyle:{"cursor":"default"}},[_vm._v("Em analise")]):_vm._e()],1)]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('li',{staticClass:"step "},[_c('i',{staticClass:"ico",class:_vm.Suitability() ? ' ico__ok' : ' ico ico__formulario'}),_vm._v(" "),_c('p',[_vm._v("Formulário de suitability")]),_vm._v(" "),_c('span',[(!_vm.Suitability())?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":"/informacoes-adicionais/suitabilityVerify","title":"Preencher formulário"}},[_vm._v("Preencher")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"badge badge-warning",staticStyle:{"display":"none"}},[_vm._v("Em analise")])],1)]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('li',{staticClass:"step "},[_c('i',{staticClass:"ico ico__investir next"}),_vm._v(" "),_c('p',[_vm._v("Apoiar primeiro projeto")]),_vm._v(" "),(this.InvestorAprovado)?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":{ name: 'Oportunidades' },"title":"Oportunidades"}},[_vm._v("Oportunidades")]):_vm._e()],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('at-menu',{attrs:{"router":"","mode":"horizontal"}},[_c('at-menu-item',{attrs:{"to":{ name: 'Investimentos' }}},[_c('i',{staticClass:"ico-gra-4"}),_vm._v("Meus investimentos")]),_vm._v(" "),_c('at-menu-item',{attrs:{"to":{ name: 'Oportunidades' }}},[_c('i',{staticClass:"ico-ps"}),_vm._v("Oportunidades")]),_vm._v(" "),_c('at-menu-item',{attrs:{"to":{ name: 'Antecipacao' }}},[_c('i',{staticClass:"ico-gra"}),_vm._v("Antecipação")]),_vm._v(" "),_c('at-menu-item',{attrs:{"to":{ name: 'InvestimentodeImpacto' }}},[_c('i',{staticClass:"ico-imp"}),_vm._v("Investimento Social")]),_vm._v(" "),_c('at-menu-item',{attrs:{"to":{ name: 'CarteiraInvestimento' }}},[_c('i',{staticClass:"ico-ct-4"}),_vm._v("Carteira Virtual")])],1)],1)]),_vm._v(" "),_c('main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('footer',{staticClass:"d-flex justify-content-between"},[_c('div',[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"}),_vm._v(" "),_c('span',[_vm._v("V - "+_vm._s(_vm.version)+" - © 2020 - IOUU. TODOS OS DIREITOS RESERVADOS.")])])]),_vm._v(" "),_c('social-network')],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal__bootstrap-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Você está prestes a ir para a área de "),_c('strong',[_vm._v("Solicitação de empréstimos")]),_vm._v(". Tem certeza que deseja mudar de ambiente?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_vm._v("Seja bem-vindo à plataforma IOUU")]),_vm._v(" Esse é seu dashboard. Aqui você poderá criar seu portfólio de investimentos, acompanhar seus ganhos e ficar por dentro das novidades da IOUU.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mob-logo"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"beamerTrigger"},[_c('i',{staticClass:"fas fa-fire"}),_vm._v(" Novidades")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"step"},[_c('i',{staticClass:"ico ico__ok"}),_vm._v(" "),_c('p',[_vm._v("Sua conta na IOUU está OK!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"align-self-center"},[_c('div',{staticClass:"div"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"align-self-center "},[_c('div',{staticClass:"div"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"align-self-center"},[_c('div',{staticClass:"div"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IISa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_vm._m(0),_vm._v(" "),_c('form',{staticClass:"text-center",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.files,"accept":_vm.acceptedFormats,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('i'),_vm._v(" "),_c('h2',[_vm._v("Documentos")]),_vm._v(" "),_c('p',[_vm._v("Comprovante de Residência"),_c('br'),_vm._v("(Máximo 3 meses atrás)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo"),_c('img',{attrs:{"src":"/static/assets/images/angle-right.svg"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IL4q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoInformacoesPessoais_vue__ = __webpack_require__("VUcS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da73066_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoInformacoesPessoais_vue__ = __webpack_require__("HdDW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoInformacoesPessoais_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da73066_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoInformacoesPessoais_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IL8g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__ = __webpack_require__("Du/2");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            CCB_URL: "https://bmpdigital.moneyp.com.br/",
            solicitacao: {
                Empresa: {
                    Socios: {},
                    Avalistas: {}
                }
            },
            reservas: {},
            socios: {},
            passo: 1,
            password: '',
            id: '',
            smsToken: '',
            tentativas: 3,
            IP: '',
            finishedLoading: false
        };
    },

    computed: {

        User: function User() {
            return this.$store.state.currentUser;
        }
    },
    methods: {
        formatarTipoEmprestimo: function formatarTipoEmprestimo(tipoEmprestimo) {
            if (tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2") {
                return "Impacto";
            }

            var splitedTipoEmprestimo = tipoEmprestimo.split('-');

            if (splitedTipoEmprestimo.length > 1) {
                return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
            }

            return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);
        },
        ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
            var s = String(id);
            while (s.length < (qtd || 2)) {
                s = "0" + s;
            }
            return s;
        },
        formatCurrency: function formatCurrency(value) {
            if (value == null || value == undefined) return parseFloat(0).toLocaleString('pt-BR', {
                minimumFractionDigits: "2",
                maximumFractionDigits: 2
            });

            return value.toLocaleString('pt-BR', {
                minimumFractionDigits: "2",
                maximumFractionDigits: 2
            });
        },
        toLocaleDateString: function toLocaleDateString(value) {
            if (value != undefined) {
                return value.toLocaleDateString('pt-BR');
            }

            return "";
        },
        Nome: function Nome() {
            var nome = "",
                letra = "";
            if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
                nome = this.User.username;
            } else {
                nome = this.User.name;
            }
            nome = nome.trim();
            var primeiroNome = nome.split(" ")[0];
            return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
        },
        VerificaAssinou: function VerificaAssinou(soc) {

            return soc.Assinou ? 'ok' : 'no';
        },
        ReenviarEmail: function ReenviarEmail(soc) {
            var _this = this;

            console.log(soc);
            __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get_GO('out/reenviarEmailSocioCCB/' + soc.Token).then(function (token) {

                _this.$Notify.success("Email enviado!");
            }).catch(function (ex) {});
        },
        ValidarSenha: function ValidarSenha() {
            var _this2 = this;

            this.id = this.User._id;
            __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].VerificaSenha(this).then(function () {

                _this2.passo = 3;
                _this2.password = '';

                //Chama a api para enviar o token sms para o cliente
                __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].post('enviar-token-sms', { data: { SolicitacaoId: _this2.solicitacao._id, AttemptNumber: 1, ConfirmaCliente: true } }).then(function () {
                    _this2.$Notify.info("SMS enviado com sucesso!");
                    _this2.tentativas = 3;
                }).catch(function () {
                    _this2.$Notify.error("Erro ao enviar o token SMS! Por favor verificar o número de celular!");
                });
            }).catch(function () {
                //Verificação do password
                _this2.password = '';
                _this2.tentativas--;
                if (_this2.tentativas == 0) {
                    _this2.$router.push("/login");
                    _this2.$Notify.error("Erro: Você excedeu o número de tentativas limite!");
                }
                if (_this2.tentativas != 0) _this2.$Notify.error("Erro: Senha Inválida! Tentativas restantes: " + _this2.tentativas);
            });
        },
        ValidarToken: function ValidarToken() {
            var _this3 = this;

            //Chama a api para checkar se o token informado é válido
            __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].post('checar-token-sms', { data: { TokenConfirmacao: this.smsToken, SolicitacaoId: this.solicitacao._id } }).then(function () {

                _this3.sms = true;
                _this3.passo = 4;

                __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get_GO('out/atualizaSolicitacaoCCBsAssinadas/' + _this3.solicitacao._id + '/' + _this3.IP).then().catch(function (ex) {});
            }).catch(function (erro) {

                _this3.tentativas--;
                if (_this3.tentativas == 0) {
                    _this3.$router.push("/login");
                    _this3.$Notify.error("Erro: Você excedeu o número de tentativas limite!");
                }
                if (_this3.tentativas != 0) _this3.$Notify.error("Erro: Token Inválido! Tentativas restantes: " + _this3.tentativas);
            });
        },
        AssinaturaAssinantesOK: function AssinaturaAssinantesOK() {

            if (this.solicitacao.Empresa.Socios != undefined) {
                for (var i = 0; i < this.solicitacao.Empresa.Socios.length; i++) {

                    if (this.solicitacao.Empresa.Socios[i].Assinou != true) {
                        return false;
                    }
                }
            }

            if (this.solicitacao.Empresa.Avalistas != undefined) {
                for (var i = 0; i < this.solicitacao.Empresa.Avalistas.length; i++) {

                    if (this.solicitacao.Empresa.Socios[i].Assinou != true) {
                        return false;
                    }
                }
            }

            return true;
        },
        getClientAddress: function getClientAddress() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client__["a" /* default */].getIP().then(function (ip) {
                _this4.IP = ip;

                console.log(_this4.IP);
            });
        },


        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/emprestimos/formalizar-ccb/:id',
                title: 'CCB Loan'
            });
        }
    },
    created: function created() {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var x;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            if (window.location.href.indexOf("dashboard-app") != -1) _this5.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);

                            _this5.getClientAddress();

                            _this5.solicitacaoId = _this5.$route.params.id;

                            x = __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getLoanRequest(_this5.solicitacaoId).then(function (loanRequest) {
                                _this5.solicitacao = loanRequest;

                                if (_this5.solicitacao.CCBsAssinaturas == true) _this5.passo = 4;
                            });


                            x.then(function () {

                                var email1 = _this5.solicitacao.Email.trim().toLowerCase();
                                var email2 = _this5.$store.state.currentUser.email.trim().toLowerCase();

                                if (email1 != email2) {
                                    //permissão de visualização somente para o dono da solicitação ( 11/12/2018 - Victor Narcizo)
                                    window.location.href = "#/";
                                    return;
                                }
                                _this5.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                _this5.finishedLoading = true;
                            }).catch(function () {
                                _this5.finishedLoading = true;
                                _this5.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            });

                            __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getCcbInvestidores(_this5.solicitacaoId).then(function (reservas) {
                                _this5.reservas = reservas.data;
                            });

                            //tagueamento GA
                            _context.next = 8;
                            return _this5.taggingGA();

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this5);
        }))();
    }
});

/***/ }),

/***/ "IOZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row form-container justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-10 col-xl-10"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-center suitability-link-container"},[_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":"/informacoes-adicionais/investidor","title":"Preencher formulário investidor"}},[_vm._v("Entendi, quero completar meu cadastro")])],1),_vm._v(" "),_c('div',{staticClass:"text-center suitability-link-container"},[_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":"/investimentos/oportunidades/","title":"Preencher formulário investidor"}},[_vm._v("Primeiro, quero ver as oportunidades")])],1),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('img',{attrs:{"src":"/static/assets/images/ico-smile.svg","alt":"Icone feliz"}}),_vm._v(" "),_c('h1',[_vm._v("O 1º passo para você fazer parte da IOUU foi concluído com sucesso! ")]),_vm._v(" "),_c('p',[_vm._v("O próximo passo é completar o "),_c('b',[_vm._v("cadastro de investidor")]),_vm._v(", preencher o formulário de suitability e aguardar o processo de análise e aprovação para  começar a investir nas oportunidades da plataforma.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('a',{staticClass:"link logo",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})]),_vm._v(" "),_c('p',{staticClass:"obs"},[_vm._v("Juntos vamos reinventar o sistema bancário ultrapassado e garantir um melhor negócio para todos.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IPRP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankDebtValueStep_vue__ = __webpack_require__("ZMX0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19e47f64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankDebtValueStep_vue__ = __webpack_require__("+TVj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankDebtValueStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19e47f64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankDebtValueStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_api_client_go__ = __webpack_require__("879M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_session_manager__ = __webpack_require__("J7hJ");


var _mutations;








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  // Need to see how to get env vars here.
  // strict: process.env.NODE_ENV !== 'production',
  state: {
    isLoggedIn: __WEBPACK_IMPORTED_MODULE_6__utils_session_manager__["a" /* default */].getAuthToken() != null && __WEBPACK_IMPORTED_MODULE_6__utils_session_manager__["a" /* default */].getAuthToken() != undefined,
    currentUser: __WEBPACK_IMPORTED_MODULE_6__utils_session_manager__["a" /* default */].getCurrentUser(),
    isLoading: false
  },
  actions: {
    login: function login(_ref, _ref2) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;
      var email = _ref2.email,
          password = _ref2.password,
          keepLogged = _ref2.keepLogged;

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* START_LOADING */]);
      return __WEBPACK_IMPORTED_MODULE_5__utils_api_client_go__["a" /* default */].sign_in({ email: email, password: password }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_6__utils_session_manager__["a" /* default */].setLoggedIn({ token: response.data.Authorization, keepLogged: keepLogged });
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* LOGIN */]);
        return dispatch('updateUser');
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* STOP_LOADING */]);
      }).catch(function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* STOP_LOADING */]);
        throw error;
      });
    },
    loginPreview: function loginPreview(_ref3, _ref4) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;
      var email = _ref4.email,
          password = _ref4.password,
          keepLogged = _ref4.keepLogged;

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* START_LOADING */]);
      return __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].post('sign_in_preview', { data: { email: email, password: password } }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_6__utils_session_manager__["a" /* default */].setLoggedIn({ token: response.headers.authorization, keepLogged: keepLogged });
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* LOGIN */]);
        return dispatch('updateUser');
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* STOP_LOADING */]);
      }).catch(function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* STOP_LOADING */]);
        throw error;
      });
    },
    loginWithToken: function loginWithToken(_ref5, _ref6) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;
      var token = _ref6.token;

      __WEBPACK_IMPORTED_MODULE_6__utils_session_manager__["a" /* default */].setLoggedIn({ token: token, user: {}, keepLogged: false });
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* LOGIN */]);
      return dispatch('updateUser');
    },
    updateUser: function updateUser(_ref7) {
      var commit = _ref7.commit;

      // commit(mutationTypes.START_LOADING)


      return __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getUser().then(function (user) {
        __WEBPACK_IMPORTED_MODULE_6__utils_session_manager__["a" /* default */].updateCurrentUser(user);
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* UPDATE_USER */], user);
        // commit(mutationTypes.STOP_LOADING)
      }).catch(function (error) {
        // commit(mutationTypes.STOP_LOADING)
        throw error;
      });
    },
    logout: function logout(_ref8) {
      var commit = _ref8.commit;

      __WEBPACK_IMPORTED_MODULE_6__utils_session_manager__["a" /* default */].setLoggedOut();
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* LOGOUT */]);
    },
    signup: function signup(_ref9, _ref10) {
      var commit = _ref9.commit,
          dispatch = _ref9.dispatch;
      var name = _ref10.name,
          email = _ref10.email,
          password = _ref10.password,
          CodigoConvidado = _ref10.CodigoConvidado;

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* START_LOADING */]);
      return __WEBPACK_IMPORTED_MODULE_5__utils_api_client_go__["a" /* default */].sign_up({ name: name, email: email, password: password, CodigoConvidado: CodigoConvidado }).then(function () {
        return dispatch('login', { email: email, password: password, keepLogged: false });
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* STOP_LOADING */]);
      }).catch(function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* STOP_LOADING */]);
        throw error;
      });
    },
    signup_lead: function signup_lead(_ref11, _ref12) {
      var commit = _ref11.commit,
          dispatch = _ref11.dispatch;
      var name = _ref12.name,
          email = _ref12.email,
          password = _ref12.password,
          tipo = _ref12.tipo;

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* START_LOADING */]);
      return __WEBPACK_IMPORTED_MODULE_5__utils_api_client_go__["a" /* default */].sign_up({ name: name, email: email, password: password, CodigoConvidado: CodigoConvidado, tipo: tipo }).then(function () {
        return dispatch('login', { email: email, password: password, keepLogged: false });
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* STOP_LOADING */]);
      }).catch(function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* STOP_LOADING */]);
        throw error;
      });
    },
    socialNetworkLogin: function socialNetworkLogin(_ref13, _ref14) {
      var commit = _ref13.commit,
          dispatch = _ref13.dispatch;
      var provider = _ref14.provider,
          receivedData = _ref14.receivedData,
          errorMessage = _ref14.errorMessage;

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* START_LOADING */]);
      return __WEBPACK_IMPORTED_MODULE_5__utils_api_client_go__["a" /* default */].get('oauth/' + provider + '/callback/' + receivedData).then(function (response) {
        var Authorization = response.data.Authorization;
        __WEBPACK_IMPORTED_MODULE_6__utils_session_manager__["a" /* default */].setLoggedIn({ token: Authorization });
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* LOGIN */]);
        return null;
      }).then(function () {
        return document.location.reload(true);
      }).catch(function (error) {
        errorMessage("Usuário ainda não registrado.");
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* STOP_LOADING */]);
        throw error;
      });
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* LOGIN */], function (state) {
    state.isLoggedIn = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* UPDATE_USER */], function (state, user) {
    state.currentUser = user;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* LOGOUT */], function (state) {
    state.isLoggedIn = false;
    state.currentUser = null;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* START_LOADING */], function (state) {
    state.isLoading = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* STOP_LOADING */], function (state) {
    state.isLoading = false;
  }), _mutations)
}));

/***/ }),

/***/ "Iej9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_wallet__ = __webpack_require__("c/xH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Wallet_WalletExtratoLista_vue__ = __webpack_require__("HodG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Wallet_WalletExtratoFiltro_vue__ = __webpack_require__("fRhB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pagination__ = __webpack_require__("cMGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_api_client__ = __webpack_require__("6Yc5");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            loadingList: false,
            Operacoes: null,
            Paginas: 1,
            PaginaAtual: 1,
            Filtro: {
                dataIni: '',
                dataFim: ''
            },
            showModal: false,
            operacaoDetalhes: {}
        };
    },


    components: {
        WalletExtratoLista: __WEBPACK_IMPORTED_MODULE_4__components_Wallet_WalletExtratoLista_vue__["a" /* default */],
        WalletExtratoFiltro: __WEBPACK_IMPORTED_MODULE_5__components_Wallet_WalletExtratoFiltro_vue__["a" /* default */],
        Pagination: __WEBPACK_IMPORTED_MODULE_6__components_Pagination__["a" /* default */],
        Loading: __WEBPACK_IMPORTED_MODULE_3__components_Loading__["a" /* default */]
    },

    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _ref, data, Operacoes, Paginas;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_7__utils_api_client__["a" /* default */].getCarteiraExtrato(1);

                        case 2:
                            _ref = _context.sent;
                            data = _ref.data;
                            Operacoes = data.Operacoes, Paginas = data.Paginas;


                            _this.PaginaAtual = 1;
                            _this.Paginas = Paginas;
                            _this.Operacoes = Operacoes;

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },


    computed: {

        renderizado: function renderizado() {

            return this.Operacoes != null;
        }

    },

    methods: {
        filtrarExtrato: function filtrarExtrato(filtro) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var dataIni, dataFim, _ref2, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                dataIni = filtro.dataIni, dataFim = filtro.dataFim;

                                if (!(!dataIni.includes('/') || !dataFim.includes('/'))) {
                                    _context2.next = 3;
                                    break;
                                }

                                return _context2.abrupt('return', _this2.Filtro = { dataIni: '', dataFim: '' });

                            case 3:

                                _this2.Filtro = filtro;

                                _context2.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_7__utils_api_client__["a" /* default */].getCarteiraExtratoComFiltro(dataIni, dataFim, 0);

                            case 6:
                                _ref2 = _context2.sent;
                                data = _ref2.data;


                                _this2.PaginaAtual = 1;
                                _this2.Operacoes = data.Operacoes;

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        mudarPagina: function mudarPagina(pagina) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var _Filtro, dataIni, dataFim, temFiltro, _ref3, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _Filtro = _this3.Filtro, dataIni = _Filtro.dataIni, dataFim = _Filtro.dataFim;
                                temFiltro = dataIni != '' || dataFim != '';

                                // $(".collapse").collapse("hide");
                                // $(".active").removeClass("active");

                                _this3.loadingList = true;

                                if (!temFiltro) {
                                    _context3.next = 9;
                                    break;
                                }

                                _context3.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_7__utils_api_client__["a" /* default */].getCarteiraExtratoComFiltro(dataIni, dataFim, pagina);

                            case 6:
                                _context3.t0 = _context3.sent;
                                _context3.next = 12;
                                break;

                            case 9:
                                _context3.next = 11;
                                return __WEBPACK_IMPORTED_MODULE_7__utils_api_client__["a" /* default */].getCarteiraExtrato(pagina);

                            case 11:
                                _context3.t0 = _context3.sent;

                            case 12:
                                _ref3 = _context3.t0;
                                data = _ref3.data;

                                _this3.loadingList = false;

                                _this3.PaginaAtual = pagina;
                                _this3.Operacoes = data.Operacoes;

                            case 17:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    }

});

/***/ }),

/***/ "Iizq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      degrees: [{ value: 1, label: 'Ensino Fundamental Incompleto' }, { value: 2, label: 'Ensino Fundamental Completo' }, { value: 3, label: 'Ensino Médio Incompleto' }, { value: 5, label: 'Ensino Médio Completo' }, { value: 6, label: 'Ensino Superior Incompleto' }, { value: 7, label: 'Ensino Superior Completo' }, { value: 8, label: 'Pós – graduação' }]
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      this.$emit('on-submit', { Pessoal: this.currentUser.Pessoal });
    }
  },
  mounted: function mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");
  }
});

/***/ }),

/***/ "IymS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  date: function date() {
    return {
      solicitacaoId: 0,
      IdOportunidade: 0
    };
  },
  created: function created() {
    var _this = this;

    sessionStorage.removeItem("redirectINV");

    this.solicitacaoId = this.$route.params.id;

    __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getLoanRequest(this.solicitacaoId).then(function (loanRequest) {
      _this.IdOportunidade = loanRequest.IdOportunidade;
    });
  }
});

/***/ }),

/***/ "J0Dh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J7Vl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J7hJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



var TOKEN_KEY = 'auth_token';
var CURRENT_USER_KEY = 'current_user';

var SessionManager = function () {
  function SessionManager() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SessionManager);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SessionManager, null, [{
    key: 'getAuthToken',
    value: function getAuthToken() {
      return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
    }
  }, {
    key: 'getCurrentUser',
    value: function getCurrentUser() {
      var user = sessionStorage.getItem(CURRENT_USER_KEY) || localStorage.getItem(CURRENT_USER_KEY);
      return JSON.parse(user);
    }
  }, {
    key: 'updateCurrentUser',
    value: function updateCurrentUser(newUser) {
      if (sessionStorage.getItem(CURRENT_USER_KEY)) {
        sessionStorage.setItem(CURRENT_USER_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newUser));
      } else {
        localStorage.setItem(CURRENT_USER_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newUser));
      }
    }
  }, {
    key: 'setLoggedIn',
    value: function setLoggedIn(_ref) {
      var token = _ref.token,
          _ref$keepLogged = _ref.keepLogged,
          keepLogged = _ref$keepLogged === undefined ? false : _ref$keepLogged;

      if (keepLogged) {
        localStorage.setItem(TOKEN_KEY, token);
      } else {
        sessionStorage.setItem(TOKEN_KEY, token);
      }
    }
  }, {
    key: 'setLoggedOut',
    value: function setLoggedOut() {
      sessionStorage.removeItem(TOKEN_KEY);
      sessionStorage.removeItem(CURRENT_USER_KEY);

      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(CURRENT_USER_KEY);
    }
  }]);

  return SessionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (SessionManager);

/***/ }),

/***/ "JBiP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"Site"}},[_vm._v("Site")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Site),expression:"Site"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: iouu.com.br"},domProps:{"value":(_vm.Site)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Site=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Facebook")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Facebook),expression:"Facebook"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: www.facebook.com/IouuBrasil/"},domProps:{"value":(_vm.Facebook)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Facebook=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Linkedin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Linkedin),expression:"Linkedin"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: www.linkedin.com/company/iouu/"},domProps:{"value":(_vm.Linkedin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Linkedin=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Para nos conhecermos melhor, nos informe o seu site e as redes socias da sua empresa:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JDlu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JIu8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    submitWithCorporateGroup: function submitWithCorporateGroup() {
      this.$emit('on-submit', { Empresa: { EmpresaTemFinanciamento: true } });
    },
    submitWithoutCorporateGroup: function submitWithoutCorporateGroup() {
      this.$emit('on-submit', { Empresa: { EmpresaTemFinanciamento: false } });
    }
  }
});

/***/ }),

/***/ "JKi6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenreStep_vue__ = __webpack_require__("bojV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fbb795c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GenreStep_vue__ = __webpack_require__("r6Tt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenreStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fbb795c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GenreStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JQcD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

	props: {
		solicitacao: { required: true, type: Object }
	},
	methods: {
		onSubmit: function onSubmit(e) {
			e.preventDefault();

			var newData = {
				StatusAguarde: "25%",
				AprovadoCliente: false,
				NegadoCliente: false
			};

			this.$emit('on-submit', newData);
		}
	}
});

/***/ }),

/***/ "JSut":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__ = __webpack_require__("Du/2");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            CCB_URL: "https://bmpdigital.moneyp.com.br/",
            ReservaInvestimento: {},
            reservas: {},
            socios: {},
            passo: 1,
            password: '',
            id: '',
            smsToken: '',
            tentativas: 3,
            carregado: false,
            valorMensal: 0,
            IP: '',
            existesenha: true,
            ccb: false
        };
    },

    computed: {

        User: function User() {
            return this.$store.state.currentUser;
        }
    },

    methods: {
        formattedCnpj: function formattedCnpj() {
            return __WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].maskCnpj(this.ReservaInvestimento.SolicitacaoId.Documento);
        },
        formatarTipoEmprestimo: function formatarTipoEmprestimo(tipoEmprestimo) {
            if (tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2") {
                return "Impacto";
            }

            var splitedTipoEmprestimo = tipoEmprestimo.split('-');

            if (splitedTipoEmprestimo.length > 1) {
                return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
            }

            return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);
        },
        ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
            var s = String(id);
            while (s.length < (qtd || 2)) {
                s = "0" + s;
            }
            return s;
        },
        formatCurrency: function formatCurrency(value) {
            if (value == null || value == undefined) return parseFloat(0).toLocaleString('pt-BR', {
                minimumFractionDigits: "2",
                maximumFractionDigits: 2
            });

            return value.toLocaleString('pt-BR', {
                minimumFractionDigits: "2",
                maximumFractionDigits: 2
            });
        },
        toLocaleDateString: function toLocaleDateString(value) {
            if (value != undefined) {

                if (typeof value == "string") {
                    value = new Date(value);
                }

                return value.toLocaleDateString('pt-BR');
            }

            return "";
        },
        Nome: function Nome() {
            var nome = "",
                letra = "";
            if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
                nome = this.User.username;
            } else {
                nome = this.User.name;
            }

            this.existesenha = this.User.HasPass;
            nome = nome.trim();
            var primeiroNome = nome.split(" ")[0];
            return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
        },
        ValidarSenha: function ValidarSenha() {
            var _this = this;

            this.id = this.User._id;
            __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].VerificaSenha(this).then(function () {

                console.log('out/atualizaCCbsInvestidoresAssinatura/' + _this.$route.params.id + '/' + _this.IP);

                __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get_GO('out/atualizaCCbsInvestidoresAssinatura/' + _this.$route.params.id + '/' + _this.IP).then(function (token) {
                    _this.passo = 3;
                    _this.password = '';
                }).catch(function (ex) {});
            }).catch(function () {
                //Verificação do password
                _this.password = '';
                _this.tentativas--;
                if (_this.tentativas == 0) {
                    _this.$router.push("/login");
                    _this.$Notify.error("Erro: Você excedeu o número de tentativas limite!");
                }
                if (_this.tentativas != 0) _this.$Notify.error("Erro: Senha Inválida! Tentativas restantes: " + _this.tentativas);
            });
        },
        CadastrarSenha: function CadastrarSenha() {
            this.$router.push("/investimentos/perfil/dados-pessoais");
        },
        PMT: function PMT(rate, periods, present, future, type) {
            // Credits: algorithm inspired by Apache OpenOffice

            // Initialize type
            type = typeof type === 'undefined' ? 0 : type;

            // Initialize future
            future = 0;

            // Evaluate rate (TODO: replace with secure expression evaluator)
            rate = eval(rate);

            // Return payment
            var result;
            if (rate === 0) {
                result = (present + future) / periods;
            } else {
                var term = Math.pow(1 + rate, periods);
                if (type === 1) {
                    result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
                } else {
                    result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
                }
            }

            // result = Math.round(result * 100) / 100;

            return -result;
        },
        getClientAddress: function getClientAddress() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client__["a" /* default */].getIP().then(function (ip) {
                _this2.IP = ip;
            });
        },


        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/cadastrar-senha',
                title: 'CadastrarSenha'
            });
        }
    },
    created: function created() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            _this3.reservaInvId = _this3.$route.params.id;

                            if (window.location.href.indexOf("dashboard-app") != -1) _this3.getClientAddress();
                            _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["c" /* START_LOADING */]);

                            __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getInfosMyInvestmentsSolicitacoes(_this3.$route.params.id).then(function (loanRequest) {
                                _this3.ccb = loanRequest.data.ccb;
                                _this3.ReservaInvestimento = loanRequest.data.dados.filter(function (item) {
                                    return item._id == _this3.reservaInvId;
                                })[0];
                                _this3.carregado = true;

                                if (_this3.ReservaInvestimento.SolicitacaoId.RetornoBrutoMensal == undefined) {
                                    _this3.ReservaInvestimento.SolicitacaoId.RetornoBrutoMensal = 0;
                                }

                                _this3.valorMensal = -_this3.PMT(_this3.ReservaInvestimento.SolicitacaoId.RetornoBrutoMensal / 100, _this3.ReservaInvestimento.SolicitacaoId.Prazo, _this3.ReservaInvestimento.Valor);

                                if (_this3.ReservaInvestimento.AssinouCCB == true) {
                                    _this3.passo = 3;
                                }
                                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            }).catch(function () {
                                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            });

                            //tagueamento GA
                            _context.next = 6;
                            return _this3.taggingGA();

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this3);
        }))();
    }
});

/***/ }),

/***/ "JV4v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      degrees: [{ value: 1.0, label: 'Ensino Fundamental Incompleto' }, { value: 2.0, label: 'Ensino Fundamental Completo' }, { value: 3.0, label: 'Ensino Médio Incompleto' }, { value: 5.0, label: 'Ensino Médio Completo' }, { value: 6.0, label: 'Ensino Superior Incompleto' }, { value: 7.0, label: 'Ensino Superior Completo' }, { value: 8.0, label: 'Pós – graduação' }]
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      this.$emit('on-submit', { Social: this.currentUser.Social });
    }
  },
  mounted: function mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");
  }
});

/***/ }),

/***/ "Jbu1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyProfile_vue__ = __webpack_require__("fYP8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa34682_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyProfile_vue__ = __webpack_require__("8n8l");
function injectStyle (ssrContext) {
  __webpack_require__("4Rqm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fa34682"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa34682_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ji9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"back float-right"},[_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._m(1)])])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),(_vm.width > 1100)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 d-flex justify-content-between align-items-center"},[_c('h2',[_vm._v("Solicitações")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"font-weight-bold pr-2"},[_vm._v("Filtros")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.statusOption),function(item){return _c('option',{key:item,domProps:{"value":item.value}},[_vm._v(_vm._s(item.label))])}),0)])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"d-flex justify-content-center"},[_c('Loading')],1):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 table-responsive"},[_c('table',{staticClass:"table table-hover"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.solicitacoes.SolicitacaoProcesso),function(item,index){return _c('tr',{key:(item + index)},[_c('td',[_vm._v("#"+_vm._s(item.OportunidadeID))]),_vm._v(" "),_c('td',{staticClass:"d-flex justify-content-center"},[_c('span',{class:'circle ' + 'status-' + _vm.abreviaStatus(item.StatusAtraso)})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.NomeEmpresa ? item.NomeEmpresa : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.ValorInvestido ? _vm.formatarDinheiro(item.ValorInvestido) : _vm.formatarDinheiro(0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formataData(item.DataInvestimento)))]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{name: 'VisualizarStatusCobranca', query: { id: item.SolicitacaoID }},"title":"Mais detalhes","append":""}},[_vm._v("Mais detalhes")])],1)])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"paginacao"},[_c('Pagination',{attrs:{"paginasTotais":this.Paginas,"paginaAtual":this.indexPage,"navigate":function (rota){ return this$1.paginacao(rota-1); }}})],1)]),_vm._v(" "),_c('aside',{staticClass:"col-12 col-md-4 col-lg-4"},[(_vm.loadingAux)?_c('div',{staticClass:"border rounded p-4"},[_c('Loading')],1):_c('div',{staticClass:"border rounded p-4"},[_c('ul',[_c('li',{staticClass:"header d-flex justify-content-between align-items-center"},[_c('h3',[_vm._v("Total de solicitações")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.total.TotalSolicitacoes ? parseInt(_vm.total.TotalSolicitacoes) : 0))])]),_vm._v(" "),_vm._l((_vm.total.TotalStatus),function(item){return _c('li',{key:item.Status,staticClass:"list d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{class:'circle ' + 'status-' + _vm.abreviaStatus(item.Status)}),_vm._v("\n                                    "+_vm._s(item.Status ? item.Status == '15 dias' ? '1 a 15 dias' : item.Status : "")+"\n                                    ")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(item.Total ? parseInt(item.Total) : 0))])])}),_vm._v(" "),_c('li',{staticClass:"total d-flex justify-content-between align-items-center"},[_c('span',[_vm._v("Total")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.total.TotalSolicitacoes ? parseInt(_vm.total.TotalSolicitacoes) : 0))])])],2)])])]):_c('div',{staticClass:"row show-mobile"},[_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n                    Para ter acesso completo a central de cobranças da plataforma, acesse a partir de um desktop ou notebook.\n                ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("Central de cobranças")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{attrs:{"src":"/static/assets/images/ico-back.svg"}}),_vm._v(" Voltar")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col","width":"100"}},[_vm._v("ID")]),_vm._v(" "),_c('th',{attrs:{"scope":"col","width":"70"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"scope":"col","width":"35%"}},[_vm._v("Empresa")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Valor investido")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Data do invest.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JmiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposito operacao row"},[_c('div',{staticClass:"col-12 col-md-7 sep"},[_c('table',{staticClass:"info"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Valor")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("R$ "+_vm._s(_vm.formatarDinheiro(_vm.valor)))])])])])]),_vm._v(" "),_c('div',{staticClass:"detalhes col-12 col-md-5"},[_c('div',{staticClass:"options"},[_c('p',[_vm._v("\n                ID da Transação\n                "),_c('strong',[_vm._v("\n                    "+_vm._s(_vm.transacao)+"\n                ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("\n                    Detalhes da Transferencia\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JrBI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var accountant = this.solicitacao.Empresa.Contador;
    return {
      nomeCompleto: accountant ? accountant.NomeCompleto : null,
      email: accountant ? accountant.Email : null,
      telefone: accountant ? accountant.Telefone : null
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      this.$emit('on-submit', {
        Empresa: {
          Contador: {
            NomeCompleto: this.nomeCompleto,
            Email: this.email,
            Telefone: this.telefone
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "Jt5P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JybC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyFields_vue__ = __webpack_require__("ytGx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d3708bb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyFields_vue__ = __webpack_require__("KuZh");
function injectStyle (ssrContext) {
  __webpack_require__("y2LK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d3708bb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyFields_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d3708bb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyFields_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JzvJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_c('div',{staticClass:"tit"},[_c('img',{attrs:{"src":"/static/assets/images/ico-smile.svg","alt":"Icone feliz"}}),_vm._v(" "),_c('h1',[_vm._v("Cadastro Concluído com sucesso!")]),_vm._v(" "),_c('p',[_vm._v("Recebemos sua solicitação de empréstimo com sucesso."),_c('br'),_vm._v("Em até "),_c('b',[_vm._v("72 horas úteis")]),_vm._v(", você receberá uma resposta."),_c('br'),_vm._v("Você poderá acompanhar a sua solicitação de empréstimo pela área do cliente ou por e-mail")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})]),_vm._v(" "),_c('p',{staticClass:"nome"},[_vm._v("Obrigado por escolher nos escolher!")]),_vm._v(" "),_c('p',{staticClass:"obs"},[_vm._v("Juntos vamos reinventar o sistema bancário ultrapassado e garantir um melhor negócio para todos.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K51t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wallet__infos"},[_c('div',{staticClass:"row align-items-center no-gutters"},[_c('div',{staticClass:"col-12 col-md-7 col-lg-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 col-lg-4"},[_c('div',{staticClass:"wallet__infos--pad"},[_c('span',[_vm._v("Saldo disponível:")]),_vm._v(" "),_c('strong',{staticClass:"saldo"},[_vm._v(_vm._s(_vm.formatadoSaldo)+" ")]),_vm._v(" "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Saldo disponível para saque!"}},[_c('i',{staticClass:"fas fa-info-circle"})])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-5 col-lg-4 sep"},[_c('span',[_vm._v("Transferir saldo para")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/investimentos/carteira-investimento/transferir-fundos","title":"Transferir saldo para conta bancária"}},[_vm._v("\n                Conta bancária\n            ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"saldo":"","to":"/investimentos/oportunidades","title":"Reinvestir saldo"}},[_c('i',{staticClass:"ico-din-5"}),_vm._v(" "),_c('span',[_vm._v("Reinvestir")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K7y6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "KF9i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KFIQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Pagination__ = __webpack_require__("cMGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
				data: function data() {
								return {
												notificacoes: [],
												notificationsAux: null,
												finishedLoading: false,
												statusGo: false,
												indexPage: 1
								};
				},

				computed: {
								pags: function pags() {
												var pagsRelative = (this.notificacoes.length / 10).toString().split('.');
												return parseInt(pagsRelative[1]) <= 4 ? Math.round(this.notificacoes.length / 10 + 1) : Math.round(this.notificacoes.length / 10);
								}
				},
				components: {
								Pagination: __WEBPACK_IMPORTED_MODULE_1__components_Pagination__["a" /* default */]
				},
				methods: {
								IsInvestidor: function IsInvestidor() {
												return document.URL.indexOf("investimentos") != -1;
								},
								formatUrl: function formatUrl(url) {
												var urlForm = void 0;

												if (url.indexOf("/") !== 0) {
																urlForm = url.replace(/^/gm, "/");
												} else {
																urlForm = url;
												}

												return urlForm;
								},
								verifyStatus: function verifyStatus(status) {
												var bgClass = void 0;
												switch (status) {
																case 'Publicado':
																				bgClass = 'bg-primary';
																				break;

																case 'Atencao':
																				bgClass = 'bg-warning';
																				break;

																case 'Atrasado':
																				bgClass = 'bg-danger';
																				break;

																case 'Visualizado':
																				bgClass = 'bg-success';
																				break;
												}

												return bgClass;
								},
								changeStatus: function changeStatus(id, url) {
												var _this = this;

												var status = "Visualizado";

												if (!this.statusGo) {
																__WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].changeStatusNotification(id, status).then(function (response) {
																				if (response.status === 200) {
																								_this.Atualizar(url);
																				}
																});
												}
								},
								pagination: function pagination(index) {
												var numberPage = index * 10;
												var aux = [];
												var counter = 0;

												this.indexPage = index + 1;

												for (var i = numberPage; i < this.notificacoes.length; i++) {
																if (counter < 10) {

																				//Não mostrando notificações que estão "Deletadas" para o cliente. As mesmas se encontram no banco com o status deletado.
																				if (this.notificacoes[i].Status != "Deletado") {
																								aux.push(this.notificacoes[i]);
																				}

																				counter++;
																} else {
																				break;
																}
												}

												this.notificationsAux = aux;
								},
								activePagination: function activePagination(index) {
												return this.indexPage === index;
								},
								goPrevious: function goPrevious(index) {
												var ind = index === 2 ? 0 : index - 2;

												this.pagination(ind);
								},
								goNext: function goNext(index) {
												var ind = index;
												this.pagination(ind);
								},
								convertDate: function convertDate(dateCreate, dateUpdate, status) {
												var today = new Date();
												var timeStampToday = Math.round(today.getTime() / 1000);
												var h = today.getHours();
												var m = today.getMinutes();
												var s = today.getSeconds();
												var arrayDate = __WEBPACK_IMPORTED_MODULE_3__utils_masker__["a" /* default */].maskIsoDate(dateCreate).split('/');
												var arrayDateUP = __WEBPACK_IMPORTED_MODULE_3__utils_masker__["a" /* default */].maskIsoDate(dateUpdate).split('/');
												var objDate = new Date(arrayDate[2], arrayDate[1] - 1, arrayDate[0], h, m, s);
												var timeStampDate = Math.round(objDate.getTime() / 1000);
												var hours = (timeStampToday - timeStampDate) / 3600;
												var days = parseInt(hours / 24);
												var msg = void 0;

												if (status === 'Visualizado') {
																msg = 'Enviado em ' + arrayDate[0] + '/' + arrayDate[1] + '/' + arrayDate[2] + ' - Visualizado em  ' + arrayDateUP[0] + '/' + arrayDateUP[1] + '/' + arrayDateUP[2];
												} else if (days <= 0) {
																msg = 'Enviado Hoje';
												} else if (days <= 4) {
																msg = 'Enviado h\xE1 ' + days + ' dias - ' + arrayDate[0] + '/' + arrayDate[1] + '/' + arrayDate[2];
												} else {
																msg = 'Enviado em: ' + arrayDate[0] + '/' + arrayDate[1] + '/' + arrayDate[2];
												}

												return msg;
								},
								Atualizar: function Atualizar(url) {
												var _this2 = this;

												// PROMISES FOR GET USER ID TO GET NOTIFICATIONS FROM USER
												__WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getUser().then(function (user) {
																__WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getNotificationsUser(user._id).then(function (notifications) {
																				_this2.notificacoes = notifications;

																				notifications.forEach(function (value) {
																								if (value.Status !== 'Visualizado') {
																												_this2.hasNotify = true;
																												return true;
																								}
																				});

																				if (_this2.notificacoes.length <= 0) {
																								_this2.hasNotify = false;
																				}

																				_this2.$router.push(_this2.formatUrl(url));
																				_this2.finishedLoading = true;
																});
												}).catch(function () {
																_this2.finishedLoading = true;
												});
								}
				},
				beforeCreate: function beforeCreate() {
								var _this3 = this;

								this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["c" /* START_LOADING */]);

								// PROMISES FOR GET USER ID TO GET NOTIFICATIONS FROM USER
								__WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getUser().then(function (user) {
												__WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getNotificationsUser(user._id).then(function (notifications) {
																_this3.notificacoes = notifications;

																_this3.pagination(0);
																_this3.finishedLoading = true;
																_this3.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
												});
								}).catch(function () {
												_this3.finishedLoading = true;
												_this3.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
								});
				}
});

/***/ }),

/***/ "KHP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-5"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valor),expression:"valor"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg dinheiro campos",attrs:{"type":"tel","id":"txtValor","placeholder":"Ex. R$ 70.000"},domProps:{"value":(_vm.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valor=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"slider"},[_c('at-slider',{attrs:{"min":6,"max":36,"step":6},model:{value:(_vm.prazo),callback:function ($$v) {_vm.prazo=$$v},expression:"prazo"}})],1),_vm._v(" "),_c('span',{staticClass:"parcelas"},[_vm._v(_vm._s(this.prazo))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.faturamento),expression:"faturamento"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg dinheiro campos",attrs:{"type":"tel","id":"txtFaturamento","placeholder":"Ex. R$ 100.000"},domProps:{"value":(_vm.faturamento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.faturamento=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"type":"button","id":"btnSimular","disabled":!_vm.isValid()},on:{"click":function($event){return _vm.getSimulation()}}},[_vm._v("Simular empréstimo")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Simulação de empréstimo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label",attrs:{"for":"txtValor"}},[_c('span',{staticClass:"badge badge-pill badge-primary"},[_vm._v("1")]),_vm._v(" Qual o valor do empréstimo?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label",attrs:{"for":"ddlPrazo"}},[_c('span',{staticClass:"badge badge-pill badge-primary"},[_vm._v("2")]),_vm._v(" Qual a quantidade de parcelas?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label",attrs:{"for":"txtFaturamento"}},[_c('span',{staticClass:"badge badge-pill badge-primary"},[_vm._v("3")]),_vm._v(" Quanto sua empresa faturou nos últimos 12 meses?")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KNDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: this.solicitacao.ArquivosIdentidade || [null]
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.arquivos.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.arquivos, index, null);
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do documento de identidade de ao menos um avalista é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {
        var newData = {
          ArquivosIdentidade: this.arquivosRecebidos
        };
        this.$emit('on-submit', newData);
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "KQg6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finishedLoading)?_c('div',{staticClass:"col-12 col-md-10 col-lg-8"},[_c('div',{attrs:{"id":"emprestimo-coletivo"}},[_c('div',{staticClass:"text-center sub-title"},[_c('p',[_vm._v(_vm._s(_vm.firstName)+", preencha todas as informações abaixo. Todos os campos são obrigatórios.")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form"},[_c('label',{attrs:{"for":"nome"}},[_vm._v("Nome completo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"nome","placeholder":"Nome completo","required":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Email ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"E-mail","required":"","disabled":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form"},[_c('label',{attrs:{"for":""}},[_vm._v("CNPJ")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('cnpj'),expression:"'cnpj'"},{name:"model",rawName:"v-model",value:(_vm.document),expression:"document"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"CNPJ","required":"required"},domProps:{"value":(_vm.document)},on:{"input":function($event){if($event.target.composing){ return; }_vm.document=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Possui restrição?")]),_vm._v(" "),_c('at-select',{ref:"restricao",attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.restricao),callback:function ($$v) {_vm.restricao=$$v},expression:"restricao"}},_vm._l((_vm.temRestricao),function(option,index){return _c('at-option',{key:("temRestricaoOptions" + index),attrs:{"value":option.value}},[_vm._v(_vm._s(option.label))])}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Possuí garantia?")]),_vm._v(" "),_c('at-select',{ref:"garantia",attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.garantia),callback:function ($$v) {_vm.garantia=$$v},expression:"garantia"}},_vm._l((_vm.temGarantia),function(option,index){return _c('at-option',{key:("temGarantiasOptions" + index),attrs:{"value":option.value}},[_vm._v(_vm._s(option.label))])}),1)],1)]),_vm._v(" "),(_vm.garantia == 'sim')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Informe a garantia")]),_vm._v(" "),_c('at-select',{ref:"garantiaDatalhe",attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.garantiaDetalhe),callback:function ($$v) {_vm.garantiaDetalhe=$$v},expression:"garantiaDetalhe"}},_vm._l((_vm.garantias),function(garantia,index){return _c('at-option',{key:("garantiasOptions" + index),attrs:{"value":garantia.value}},[_vm._v(_vm._s(garantia.value))])}),1)],1)]):_vm._e(),_vm._v(" "),(_vm.garantiaDetalhe === 'Outros' && _vm.garantia === 'sim')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Informa o tipo de garantia")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.garantiaOutros),expression:"garantiaOutros"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Informe a garantia","required":""},domProps:{"value":(_vm.garantiaOutros)},on:{"input":function($event){if($event.target.composing){ return; }_vm.garantiaOutros=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Valor solicitado")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex.: R$ 7.000,00","required":""},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Prazo")]),_vm._v(" "),_c('at-select',{ref:"prazo",attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.prazo),callback:function ($$v) {_vm.prazo=$$v},expression:"prazo"}},_vm._l((_vm.prazos),function(prazo,index){return _c('at-option',{key:("prazosOptions" + index),attrs:{"value":prazo.value}},[_vm._v(_vm._s(prazo.label))])}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Motivo do empréstimo")]),_vm._v(" "),_c('at-select',{ref:"motivo",attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.motivo),callback:function ($$v) {_vm.motivo=$$v},expression:"motivo"}},_vm._l((_vm.motivoEmp),function(motivo,index){return _c('at-option',{key:("motivoOptions" + index),attrs:{"value":motivo.value}},[_vm._v(_vm._s(motivo.value))])}),1)],1)]),_vm._v(" "),(_vm.motivo == 'Outros')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Finalidade")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motivoDetalhe),expression:"motivoDetalhe"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Informe o motivo","required":""},domProps:{"value":(_vm.motivoDetalhe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motivoDetalhe=$event.target.value}}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"checkbox"},[_c('div',{staticClass:"form-check d-flex"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.aceite),expression:"aceite"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"chkTermos"},domProps:{"checked":Array.isArray(_vm.aceite)?_vm._i(_vm.aceite,null)>-1:(_vm.aceite)},on:{"change":function($event){var $$a=_vm.aceite,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.aceite=$$a.concat([$$v]))}else{$$i>-1&&(_vm.aceite=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.aceite=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_c('label',{attrs:{"for":"form-check-label"}},[_vm._v("Declaro que li e aceito os termos acima")])]),_vm._v(" "),_c('div',{staticClass:"form-check d-flex"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.acordos),expression:"acordos"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"chkPolitica"},domProps:{"checked":Array.isArray(_vm.acordos)?_vm._i(_vm.acordos,null)>-1:(_vm.acordos)},on:{"change":function($event){var $$a=_vm.acordos,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.acordos=$$a.concat([$$v]))}else{$$i>-1&&(_vm.acordos=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.acordos=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_c('label',{attrs:{"for":"form-check-label"}},[_vm._v("Declaro que estou de acordo com os\n                        "),_c('a',{attrs:{"href":_vm.lpUrl+'/termos-de-uso-e-condicoes-para-empresa-tomadora/',"target":"_blank"}},[_vm._v("Termos de Uso")]),_vm._v(" e com a\n                        "),_c('a',{attrs:{"href":_vm.lpUrl+'/politica-de-privacidade/',"target":"_blank"}},[_vm._v("Politica de Privacidade")])])])])])]),_vm._v(" "),_c('div',{staticClass:"bt text-center"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":!_vm.aceite || !_vm.acordos || !_vm.isValid() || !_vm.isValidMotivo() || !_vm.isValidGarantia() || !_vm.isValidGarantiaOutros()},on:{"click":_vm.onSubmit}},[_vm._v("Continuar")])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h5',[_vm._v("Por último, precisamos que você:")]),_vm._v(" "),_c('ul',[_c('li',[_c('img',{attrs:{"src":"/static/assets/images/checked.svg","width":"18"}}),_vm._v(" "),_c('span',{attrs:{"id":"autorizacaoCPF_CNPJ"}},[_vm._v(" Autorize o banco parceiro a consultar seu CPF/CNPJ.")])]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/checked.svg","width":"18"}}),_vm._v(" "),_c('span',[_vm._v(" Autorize o banco parceiro a compartilhar as suas informações com a IOUU.")])]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/checked.svg","width":"18"}}),_vm._v(" "),_c('span',[_vm._v(" Declare que as informações que forneceu são verdadeiras.")])]),_vm._v(" "),_c('li',{attrs:{"id":"autorizacaoPPE"}},[_c('img',{attrs:{"src":"/static/assets/images/checked.svg","width":"18"}}),_vm._v(" "),_c('span',[_vm._v(" Confirme que não é Pessoa Exposta politicamente.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 terms"},[_c('strong',[_vm._v("Para isso leia o termo abaixo e selecione os itens de confirmação ao final da página")]),_vm._v(" "),_c('div',{staticClass:"textarea"},[_c('div',{staticClass:"rolbar"},[_c('p',[_vm._v("\n                    ESTOU CIENTE E AUTORIZO, neste ato que o(s) Banco(s) parceiro(s) tenha(m) acesso/consulte(m) os meus dados de depósitos e\n                    aplicações em outras instituições financeiras; as informações a meu respeito constantes no cadastro\n                    dos órgãos de proteção ao crédito tais como SPC e Serasa, bem como todas e quaisquer demais informações\n                    registradas no Sistema de Informações de Crédito do Banco Central (SCR), nos termos do artigo 1º\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  § 3º, V da Lei Complementar nº 105/01 segundo a qual não configura quebra de sigilo bancário a revelação\n                    de informações sigilosas com o expresso consentimento do interessado.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    AUTORIZO expressamente a Instituição Financeira a divulgar, compartilhar e trocar informações a meu respeito com a IOUU Tecnologia e Serviços\n                    Financeiros LTDA - Epp ou qualquer outro terceiro a ela ligado ou relacionado, para fins de registro,\n                    análise de risco de crédito e qualquer outra finalidade, incluindo, mas não limitado a oferta de\n                    produtos da IOUU Tecnologia e Serviços Financeiros LTDA - Epp ou do respectivo terceiro.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    DECLARO não ser ou ter como meus representantes, familiares ou outras pessoas de meu relacionamento próximo\n                    qualquer pessoa exposta politicamente (PEP) (pessoas que desempenhem ou desempenharam, nos últimos\n                    cinco anos, no Brasil ou no exterior, cargos, empregos e/ou funções públicas relevantes), conforme\n                    definição pela circular nº 3.461 de 24.07.2009 do Banco Central do Brasil\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                   DECLARO serem inteiramente\n                    verdadeiras as informações pessoais fornecidas à Instituição Financeira por meio de meu cadastro\n                    neste SITE e estar ciente de que estas informações condicionaram a avaliação da viabilidade do Empréstimo \n                ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KRMA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KTci":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUCq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ka4v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',{staticClass:"container"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KcDe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"files-list files-list--margin row justify-content-center"},_vm._l((_vm.currentFiles),function(file,i){return _c('div',{staticClass:"list col-12 col-md-4"},[_c('file-input',{key:("files" + i),attrs:{"accept":_vm.accept,"uploadEndpoint":_vm.uploadEndpoint,"file":file},on:{"uploaded":function (uploadedFile, requestResponse) { return _vm.onUploaded(uploadedFile, i, requestResponse); },"file-cleared":function($event){return _vm.clearFile(i)}}}),_vm._v(" "),_c('div',{staticClass:"file text-center"},[(_vm.currentFiles.length > 1)?_c('a',{staticClass:"icon icon-minus-circle remove",attrs:{"title":"Remover Arquivo"},on:{"click":function($event){return _vm.removeFile(i)}}},[_c('span',[_vm._v("Remover arquivo")])]):_vm._e()])],1)}),0),_vm._v(" "),_c('div',{staticClass:"btns text-center"},[_c('button',{staticClass:"btn btn-lg btn-link",attrs:{"title":"Adicionar mais arquivo"},on:{"click":_vm.addFile}},[_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon icon-plus-circle add-icon"},[_c('span',[_vm._v("Adicionar mais arquivo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KdVt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"nomeCompleto"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Nome),expression:"Nome"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":"","disabled":""},domProps:{"value":(_vm.Nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Nome=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',[_vm._v("Cpf")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Cpf),expression:"Cpf"},{name:"mask",rawName:"v-mask",value:('cpf'),expression:"'cpf'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":""},domProps:{"value":(_vm.Cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Cpf=$event.target.value}}})]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Informações do sócio")]),_vm._v(" "),_c('p',[_vm._v("Agora, por favor, forneça alguns dados sobre você.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KeQ3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kgxv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finishedLoading)?_c('div',{staticClass:"col-12 col-lg-8"},[_c('section',[_c('div',{staticClass:"tit"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"rating float-right"},[_c('strong',[_vm._v("\n                    Score da operação\n                    "),_c('span',{staticClass:"circle score"}),_vm._v("\n                    "+_vm._s(_vm.score)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Valor Solicitado\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.valor)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Duração\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        "+_vm._s(_vm.prazo)+" meses\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-12 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Valor total do empréstimo\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.valorTotal)+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Valor da parcela\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.parcela)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Juros\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        "+_vm._s(_vm.taxaJuros)+"% a.m.\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-12 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Taxa total efetiva\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.taxaTotal)+"% a.a.\n                    ")])])])])]),_vm._v(" "),_c('section',[_c('h3',[_vm._v("\n            Captação de recursos (investidores)\n        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"box no-color"},[_c('label',[_vm._v("\n                        Inicio/Término\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        "+_vm._s(_vm.dataInicio)+" - "+_vm._s(_vm.dataFim)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"box no-color"},[_c('label',[_vm._v("\n                        Total de Investidores\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        "+_vm._s(_vm.investidores)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"box no-color"},[_c('label',[_vm._v("\n                        Valor total captado\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.valorCaptado)+"\n                        "),_c('span',{staticClass:"percent"},[_vm._v("\n                            "+_vm._s(_vm.percentValorCaptado)+"%\n                        ")])])])])])]),_vm._v(" "),_c('section',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.razaoSocial))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("CPF/CNPJ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formattedCnpj))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Nome do responsável")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.nomeResponsavel))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Nome fantasia")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.razaoSocial))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Telefone comercial")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.telefone))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('label',[_vm._v("Endereço")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.Endereco))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 col-xr-4"},[_c('label',[_vm._v("Site")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.site))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 col-xl-4"},[_c('label',[_vm._v("\n                    Email\n                ")]),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(_vm.email)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-12 col-xr-4"},[_c('label',[_vm._v("Redes Sociais")]),_vm._v(" "),_c('span',{staticClass:"social-links"},[(_vm.facebook)?_c('a',{staticClass:"fab fa-facebook-square",attrs:{"href":_vm.facebook,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.twitter)?_c('a',{staticClass:"fab fa-twitter",attrs:{"href":_vm.twitter,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.linkdin)?_c('a',{staticClass:"fab fa-linkedin-in",attrs:{"href":_vm.linkdin,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.instagram)?_c('a',{staticClass:"fab fa-instagram",attrs:{"href":_vm.instagram,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.vimeo)?_c('a',{staticClass:"fab fa-vimeo-v",attrs:{"href":_vm.vimeo,"target":"_blank"}}):_vm._e()])])])]),_vm._v(" "),_c('section',[_c('h4',[_vm._v("\n            Sobre a empresa\n        ")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.sobreEmpresa)}})]),_vm._v(" "),_c('section',[_c('h3',[_vm._v("\n            Documentos\n        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('a',{staticClass:"docs",attrs:{"href":_vm.lpUrl+'/termos-e-condicoes/'}},[_vm._v("\n                    Termos e Condições\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('a',{staticClass:"docs",attrs:{"href":_vm.lpUrl+'/politica-de-privacidade/'}},[_vm._v("\n                    Politica de Privacidade\n                ")])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left"},[_c('h3',[_vm._v("\n                    Dados financeiros\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('div',{staticClass:"float-left"},[_c('h3',[_vm._v("\n                    Dados da Empresa\n                ")])]),_vm._v(" "),_c('div',{staticClass:"float-right"}),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Empresa\n                    "),_c('span',[_vm._v("(Razão social)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KqKg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var solicitacao = this.currentUser;
    return {
      Nome: solicitacao ? solicitacao.Social.NomeCompleto : null,
      Cpf: solicitacao ? solicitacao.Social.Socio.Cpf : null
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    validarCpf: function validarCpf(strCPF) {
      var Soma;
      var Resto;
      Soma = 0;
      if (strCPF == "00000000000") return false;

      for (var i = 1; i <= 9; i++) {
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      }Resto = Soma * 10 % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return false;

      Soma = 0;
      for (var _i = 1; _i <= 10; _i++) {
        Soma = Soma + parseInt(strCPF.substring(_i - 1, _i)) * (12 - _i);
      }Resto = Soma * 10 % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11))) return false;
      return true;
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      if (this.validarCpf(__WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskCpf(this.Cpf))) {
        this.currentUser.Social.Socio.Cpf = __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskCpf(this.Cpf);

        this.$emit('on-submit', { Social: this.currentUser.Social });
      } else {
        this.$Notify.error("O CPF não é valido, favor tentar novamente!");
      }
    }
  },
  created: function created() {
    if (!this.currentUser) this.currentUser = {};
  }
});

/***/ }),

/***/ "KuZh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-8"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Razão Social")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.RazaoSocial),expression:"partner.RazaoSocial"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":"","placeholder":"Razão Social"},domProps:{"value":(_vm.partner.RazaoSocial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "RazaoSocial", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"inputPassword4"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Cnpj),expression:"partner.Cnpj"},{name:"mask",rawName:"v-mask",value:('cnpj'),expression:"'cnpj'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":"","placeholder":"CNPJ"},domProps:{"value":(_vm.partner.Cnpj)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Cnpj", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"Celular"}},[_vm._v("Celular")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Celular),expression:"partner.Celular"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"","required":""},domProps:{"value":(_vm.partner.Celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Celular", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-8"},[_c('label',{attrs:{"for":"Email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Email),expression:"partner.Email"}],staticClass:"form-control form-control-lg",attrs:{"type":"email","placeholder":"","required":""},domProps:{"value":(_vm.partner.Email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"Site"}},[_vm._v("Site")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Site),expression:"partner.Site"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: iouu.com.br"},domProps:{"value":(_vm.partner.Site)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Site", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"Facebook"}},[_vm._v("Facebook")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Facebook),expression:"partner.Facebook"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: facebook.com/IouuBrasil/"},domProps:{"value":(_vm.partner.Facebook)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Facebook", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"Linkedin"}},[_vm._v("Linkedin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Linkedin),expression:"partner.Linkedin"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: linkedin.com/company/iouu/"},domProps:{"value":(_vm.partner.Linkedin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Linkedin", $event.target.value)}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L/O1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletDetalhes_vue__ = __webpack_require__("0KfO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec9cc3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletDetalhes_vue__ = __webpack_require__("nYQX");
function injectStyle (ssrContext) {
  __webpack_require__("Coh1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ec9cc3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletDetalhes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec9cc3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletDetalhes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L12T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finishedLoading)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12"},[_vm._m(1),_vm._v(" "),_c('section',{staticClass:"small-space"},[_c('h3',[_vm._v("\n                 Notificações por e-mail\n             ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('form',{staticClass:"notify"},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"investidor"}},[_vm._v("\n                                 investidor\n                             ")]),_vm._v(" "),_c('span',{staticClass:"big"},[_vm._v("\n                                 Aviso de novas oportunidades\n                             ")]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"box-radio"},[_vm._v("\n                                     Receber\n                                     "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.EmailOportunidades),expression:"EmailOportunidades"}],ref:"EmailOportunidades",staticClass:"form-check-input",attrs:{"type":"radio","id":"OportunidadesTrue","value":"true"},domProps:{"checked":_vm._q(_vm.EmailOportunidades,"true")},on:{"change":function($event){_vm.EmailOportunidades="true"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"box-radio"},[_vm._v("\n                                     Não Receber\n                                     "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.EmailOportunidades),expression:"EmailOportunidades"}],ref:"EmailOportunidades",staticClass:"form-check-input",attrs:{"type":"radio","id":"OportunidadesFalse","value":"false"},domProps:{"checked":_vm._q(_vm.EmailOportunidades,"false")},on:{"change":function($event){_vm.EmailOportunidades="false"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('form',{staticClass:"notify"},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"investidor"}},[_vm._v("\n                                 Repagamento\n                             ")]),_vm._v(" "),_c('span',{staticClass:"big"},[_vm._v("\n                                 Notificação de repagamentos dos investimentos\n                             ")]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"box-radio"},[_vm._v("\n                                     Receber\n                                     "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.EmailRepagamento),expression:"EmailRepagamento"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"EmailRepagamentoTrue","value":"true"},domProps:{"checked":_vm._q(_vm.EmailRepagamento,"true")},on:{"change":function($event){_vm.EmailRepagamento="true"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"box-radio"},[_vm._v("\n                                     Não Receber\n                                     "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.EmailRepagamento),expression:"EmailRepagamento"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"EmailRepagamentoFalse","value":"false"},domProps:{"checked":_vm._q(_vm.EmailRepagamento,"false")},on:{"change":function($event){_vm.EmailRepagamento="false"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('form',{staticClass:"notify"},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"investidor"}},[_vm._v("\n                                 Newsletter\n                             ")]),_vm._v(" "),_c('span',{staticClass:"big"},[_vm._v("\n                                 Resumo mensal com novidades, notícias, material, etc\n                             ")]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"box-radio"},[_vm._v("\n                                     Receber\n                                     "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.EmailNewsletter),expression:"EmailNewsletter"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"EmailNewsletterTrue","value":"true"},domProps:{"checked":_vm._q(_vm.EmailNewsletter,"true")},on:{"change":function($event){_vm.EmailNewsletter="true"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"box-radio"},[_vm._v("\n                                     Não Receber\n                                     "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.EmailNewsletter),expression:"EmailNewsletter"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"EmailNewsletterFalse","value":"false"},domProps:{"checked":_vm._q(_vm.EmailNewsletter,"false")},on:{"change":function($event){_vm.EmailNewsletter="false"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])])])])])]),_vm._v(" "),_c('section',{staticClass:"small-space"},[_c('h3',[_vm._v("\n                 Notificações por SMS\n             ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('form',{staticClass:"notify"},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"investidor"}},[_vm._v("\n                                 investidor\n                             ")]),_vm._v(" "),_c('span',{staticClass:"big"},[_vm._v("\n                                 Aviso de novas oportunidades\n                             ")]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"box-radio"},[_vm._v("\n                                     Receber\n                                     "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SmsOportunidades),expression:"SmsOportunidades"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"SmsOportunidadesTrue","value":"true"},domProps:{"checked":_vm._q(_vm.SmsOportunidades,"true")},on:{"change":function($event){_vm.SmsOportunidades="true"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"box-radio"},[_vm._v("\n                                     Não Receber\n                                     "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SmsOportunidades),expression:"SmsOportunidades"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"SmsOportunidadesFalse","value":"false"},domProps:{"checked":_vm._q(_vm.SmsOportunidades,"false")},on:{"change":function($event){_vm.SmsOportunidades="false"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('form',{staticClass:"notify"},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"investidor"}},[_vm._v("\n                                 Repagamento\n                             ")]),_vm._v(" "),_c('span',{staticClass:"big"},[_vm._v("\n                                 Notificação de repagamentos dos investimentos\n                             ")]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"box-radio"},[_vm._v("\n                                     Receber\n                                     "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SmsRepagamento),expression:"SmsRepagamento"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"SmsRepagamentoTrue","value":"true"},domProps:{"checked":_vm._q(_vm.SmsRepagamento,"true")},on:{"change":function($event){_vm.SmsRepagamento="true"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"box-radio"},[_vm._v("\n                                     Não Receber\n                                     "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SmsRepagamento),expression:"SmsRepagamento"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"SmsRepagamentoTrue","value":"false"},domProps:{"checked":_vm._q(_vm.SmsRepagamento,"false")},on:{"change":function($event){_vm.SmsRepagamento="false"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])])])])])]),_vm._v(" "),_c('section',{staticClass:"no-space"},[_c('h3',[_vm._v("\n                 Notificações por WhatsApp\n             ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('form',{staticClass:"notify"},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"investidor"}},[_vm._v("\n                                 investidor\n                             ")]),_vm._v(" "),_c('span',{staticClass:"big"},[_vm._v("\n                                 Aviso de novas oportunidades\n                             ")]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"box-radio"},[_vm._v("\n                                     Receber\n                                     "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.WhatsOportunidates),expression:"WhatsOportunidates"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"WhatsOportunidatesTrue","value":"true"},domProps:{"checked":_vm._q(_vm.WhatsOportunidates,"true")},on:{"change":function($event){_vm.WhatsOportunidates="true"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"box-radio"},[_vm._v("\n                                     Não Receber\n                                     "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.WhatsOportunidates),expression:"WhatsOportunidates"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"WhatsOportunidatesFalse","value":"false"},domProps:{"checked":_vm._q(_vm.WhatsOportunidates,"false")},on:{"change":function($event){_vm.WhatsOportunidates="false"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('form',{staticClass:"notify"},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"investidor"}},[_vm._v("\n                                 Repagamento\n                             ")]),_vm._v(" "),_c('span',{staticClass:"big"},[_vm._v("\n                                 Notificação de repagamentos dos investimentos\n                             ")]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"box-radio"},[_vm._v("\n                                     Receber\n                                     "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.WhatsRepagamento),expression:"WhatsRepagamento"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"WhatsOportunidatesTrue","value":"true"},domProps:{"checked":_vm._q(_vm.WhatsRepagamento,"true")},on:{"change":function($event){_vm.WhatsRepagamento="true"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"box-radio"},[_vm._v("\n                                     Não Receber\n                                     "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.WhatsRepagamento),expression:"WhatsRepagamento"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"WhatsOportunidatesFalse","value":"false"},domProps:{"checked":_vm._q(_vm.WhatsRepagamento,"false")},on:{"change":function($event){_vm.WhatsRepagamento="false"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 bts"},[_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"button"},on:{"click":_vm.EnviarDados}},[_vm._v("\n                             Atualizar\n                         ")])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard",staticStyle:{"display":"none !important"}},[_c('div',{staticClass:"dashboard__complete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Em Construção")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"no-space"},[_c('div',{staticClass:"tit"},[_c('h2',[_vm._v("\n                    Configurações\n                 ")]),_vm._v(" "),_c('p',[_vm._v("\n                     Selecione abaixo as configurações do seu perfil na IOUU\n                 ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L3io":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block__nodata"},[_c('div',{staticClass:"block__nodata--info"},[(_vm.Msg === 1)?_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/assets/images/ico-datainfo.svg","alt":"icone informação"}}),_vm._v(" "),_vm._m(0)]):(_vm.Msg === 2)?_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/assets/images/ico-dataprot.svg","alt":"icone proteção"}}),_vm._v(" "),_vm._m(1)]):_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/assets/images/ico-dataprot.svg","alt":"icone proteção"}}),_vm._v(" "),_vm._m(2),_vm._v(" "),(this.faltaCompletar)?_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/informacoes-adicionais/investidor"}},[_vm._v("Completar cadastro")]):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n                Dados disponíveis somente para investidores"),_c('br'),_vm._v("\n                que aportaram nessa oportunidade.\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n                Seu cadastro possui uma aprovação pendente"),_c('br'),_vm._v("\n                Aguarde a confirmação de nosso pessoal para o acesso\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n                Para visualizar todos os"),_c('br'),_vm._v("\n                dados, complete seu cadastro e aguarde aprovação.\n            ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L6+9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__("ebT2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05ae413f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__("Nalz");
function injectStyle (ssrContext) {
  __webpack_require__("XxMF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05ae413f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05ae413f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L9k6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-7 text-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.submitWithBankDebt}},[_vm._v("Sim")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.submitWithoutBankDebt}},[_vm._v("Não")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('p',[_vm._v("Vocês possuem alguma dívida bancária?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LB2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_api_wallet__ = __webpack_require__("c/xH");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			investidor: null,
			solicitacaoID: "",
			response: false,
			exibirQuantia: true,
			anonimo: false,
			modalInfoAdicional: false,
			finalizado: true,
			temCadastroInvestidor: false,
			temSuitability: false,
			investidorAprovado: false,
			permiteAporte: false,
			qtdeInvestidores: 0,
			valueToInvest: 2000,
			valorCaptado: 0,
			id: 0,
			impact: {},
			ReservaInvestimento: {},
			valorInv: null,
			valorReinvestimento: 0,
			sDisponivel: 0,
			showInputInvestment: false,
			showInputSaldo: true,
			values: [],
			selected: ""
		};
	},


	computed: {
		dataInicio: function dataInicio() {
			return this.impact.InicioCaptacao.toLocaleDateString('pt-BR');
		},
		canInvest: function canInvest() {
			return this.temCadastroInvestidor && this.temSuitability && this.investidorAprovado;
		},

		User: function User() {
			return this.$store.state.currentUser;
		}
	},

	methods: {
		calcValorRestante: function calcValorRestante(impact) {
			return impact.Valor - impact.ValorCaptado;
		},
		calcPercValorRestante: function calcPercValorRestante(impact) {
			return impact.ValorCaptado * 100 / impact.Valor;
		},
		calcDiasRestantes: function calcDiasRestantes() {
			return this.diffDate(new Date(), this.impact.FimCaptacao);
		},
		formatMongoDate: function formatMongoDate(dt) {
			var date = new Date(dt);

			var day = date.getDate();
			var month = date.getMonth() + 1;
			var year = date.getFullYear();

			day = day > 9 ? day : '0' + day;
			month = month > 9 ? month : '0' + month;

			return day + '/' + month + '/' + year;
		},
		diffDate: function diffDate(d1, d2) {
			var date1, date2;

			if (d1 == "") {
				date1 = new Date();
			} else {
				date1 = new Date(d1);
				date1.setHours(date1.getHours() + date1.getTimezoneOffset() / 60);
			}

			if (d2 == "") {
				date2 = new Date();
			} else {
				date2 = new Date(d2);
				date2.setHours(date2.getHours() + date2.getTimezoneOffset() / 60);
			}

			var timeDiff = date2.getTime() - date1.getTime();
			var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

			if (diffDays < 0) return "Encerrado";
			if (diffDays == 0) return "Finaliza hoje*";

			return "Finaliza em " + diffDays + " dias*";
		},
		formatCurrency: function formatCurrency(value) {

			if (value == null || value == undefined) return parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });

			return value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
		},
		money: function money(n) {

			var c = 2,
			    d = ",",
			    t = ".",
			    s = n < 0 ? "-" : "",
			    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
			    j = (j = i.length) > 3 ? j % 3 : 0;
			return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
		},
		showModal: function showModal(item) {
			this.selectedItem = item;
			this.modalVisible = true;
			this.modalInfoAdicional = false;
			this.showInputSaldo = false;
			this.showInputInvestment = false;
		},
		closeModal: function closeModal() {
			this.modalVisible = false;
			this.modalInfoAdicional = false;
			this.finalizado = false;
			this.showInputSaldo = false;
			this.showInputInvestment = false;
		},
		dataLonga: function dataLonga(data) {
			var date = new Date(data);
			date.setHours(date.getHours() + date.getTimezoneOffset() / 60); //ajustando para o horário gravado no banco
			var options = { year: "numeric", month: "long", day: "numeric" };
			return date.toLocaleDateString("pt-BR", options);
		},
		ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
			var s = String(id);

			while (s.length < (qtd || 2)) {
				s = "0" + s;
			}

			return s;
		},
		getValorCaptado: function getValorCaptado(solicitacaoId) {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].getValorCaptadoLoanImpact(solicitacaoId).then(function (response) {
				_this.valorCaptado = response.data[0].Total;
			});
		},
		InvestidorBloqueado: function InvestidorBloqueado() {

			if (this.$store.state.currentUser == null || this.$store.state.currentUser.investor == null || this.$store.state.currentUser.investor.Bloqueio == null || this.$store.state.currentUser.investor.Bloqueio.FimBloqueio == null) return false;

			var FimBloqueio = new Date(this.$store.state.currentUser.investor.Bloqueio.FimBloqueio);

			return FimBloqueio > new Date();
		},
		getInvestidor: function getInvestidor(solicitacaoId) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].getInvestidorLoanImpact(solicitacaoId).then(function (response) {
				if (response.data != null && response.data.Status != 0) {
					_this2.impact.JaInvestiu = true;
					_this2.impact.ReservaInvestimento = response.data;
					_this2.impact.ReservaInvestimento.Valor += ",00";

					_this2.valorInv = _this2.impact.ReservaInvestimento.Valor;
				} else {
					_this2.impact.JaInvestiu = false;
				}

				_this2.$forceUpdate();
			});
		},
		ShowSaldo: function ShowSaldo() {

			if (!this.ValidarInvestimento()) {
				return false;
			}

			var value = 0;
			if (typeof this.valueToInvest === 'string') {
				var inv = this.valueToInvest.replace(/[^a-zA-Z0-9 ]/g, "");
				value = parseFloat(inv / 100);
			}

			if (this.sDisponivel > 0) {
				if (this.sDisponivel > value) {
					this.valorReinvestimento = this.money(value || 0);
				} else {
					this.valorReinvestimento = this.money(this.sDisponivel || 0);
				}

				this.showInputInvestment = false;
				this.showInputSaldo = true;
				return true;
			}

			this.proximoPasso();
			return true;
		},
		NaoUsarSaldo: function NaoUsarSaldo() {

			this.valorReinvestimento = 0;
			this.proximoPasso();

			return false;
		},
		ValidarInvestimento: function ValidarInvestimento() {

			var value = 0;
			if (typeof this.valorInv === 'string') {
				var inv = this.valorInv.replace(/[^a-zA-Z0-9 ]/g, "");
				value = parseFloat(inv / 100);
			}

			if (value == 0 || isNaN(value)) {
				this.$Notify.error({
					title: "Desculpe",
					message: "Por favor, insira um valor."
				});

				return false;
			}

			if (value < 100 || isNaN(value)) {
				this.$Notify.error({
					title: "Desculpe",
					message: "O valor mínimo de aporte é de R$ 100,00."
				});

				return false;
			}

			if (value % 100 != 0 || isNaN(value)) {
				this.$Notify.error({
					title: "Desculpe",
					message: "O valor deve ser multiplo de R$ 100."
				});

				return false;
			}

			if (value > this.impact.Valor) {
				this.$Notify.error({
					title: "Desculpe",
					message: "O valor de aporte é maior que o solicitado."
				});

				return false;
			}

			if (this.impact.Valor - this.impact.ValorCaptado > 0 && value > this.impact.Valor - this.impact.ValorCaptado) {
				this.$Notify.error({
					title: "Desculpe",
					message: "O valor de aporte é maior que o disponível."
				});

				return false;
			}

			return true;
		},
		UsarSaldo: function UsarSaldo() {

			var valor = this.selected.replace("R$", "").trim();
			// valor = valor.replace(",", "")
			// valor = valor.trim()
			// valor = parseFloat(valor/100)
			this.valorReinvestimento = valor;

			var valorInvestimento = 0;
			if (typeof this.valorReinvestimento === 'string') {
				var reInvestimento = this.valorReinvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
				valorInvestimento = parseFloat(reInvestimento / 100);
			}

			var errorMessages;
			if (valorInvestimento <= 0) {
				errorMessages = ["Insira um valor para o reinvestimento."];
				this.$Notify.error(__WEBPACK_IMPORTED_MODULE_6__utils_array_helper__["a" /* default */].toSentence(errorMessages));
				return false;
			}

			if (valorInvestimento > this.sDisponivel) {
				errorMessages = ["Saldo indisponível para o reinvestimento. Valor máximo: R$ " + this.formatCurrency(this.sDisponivel)];
				this.$Notify.error(__WEBPACK_IMPORTED_MODULE_6__utils_array_helper__["a" /* default */].toSentence(errorMessages));
				return false;
			}

			if (valorInvestimento < 15) {
				errorMessages = ["Valor mínimo para investimento: R$ 15,00 "];
				this.$Notify.error(__WEBPACK_IMPORTED_MODULE_6__utils_array_helper__["a" /* default */].toSentence(errorMessages));
				return false;
			}

			if (valorInvestimento > 50) {
				errorMessages = ["Valor máximo para investimento: R$ 50,00 "];
				this.$Notify.error(__WEBPACK_IMPORTED_MODULE_6__utils_array_helper__["a" /* default */].toSentence(errorMessages));
				return false;
			}

			this.valorInv = this.valorReinvestimento;
			this.proximoPasso();
			return false;
		},
		proximoPasso: function proximoPasso() {

			this.closeModal();
			this.modalInfoAdicional = true;

			if (document.getElementsByTagName("main").length > 0) {
				document.getElementsByTagName("main")[0].style.zIndex = "50";
			}

			this.checkout();
		},
		checkout: function checkout() {
			// let erro = this.validacao()
			// if(erro){
			// 	this.$Notify.error(erro)
			// }else{
			var investimento = this.formataInvestimento(this.valorInv, this.valorReinvestimento);
			var data = this.formataStorage(this.investidor._id, this.solicitacaoID, investimento);
			localStorage.setItem("pre_investimento", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data));
			this.$router.push("/investimentos/oportunidades/confirmacao/" + this.solicitacaoID);
			// }
		},
		formataInvestimento: function formataInvestimento(valorInvestimento, valorReinvestimento) {
			var Valor = void 0,
			    ReInvestimento = void 0;
			typeof valorInvestimento == 'string' ? Valor = __WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].unmaskMoney(valorInvestimento) : Valor = valorInvestimento / 100;
			//Envia valor de reinvestimento
			typeof valorReinvestimento == 'string' ? ReInvestimento = __WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].unmaskMoney(valorReinvestimento) : ReInvestimento = valorReinvestimento;
			return { Valor: Valor, ReInvestimento: ReInvestimento };
		},
		formataStorage: function formataStorage(idInvestidor, idSolicitacao, investimento) {
			return {
				"InvestidorId": idInvestidor,
				"SolicitacaoId": idSolicitacao,
				"Valor": investimento.Valor,
				"ValorReinvestimento": investimento.ReInvestimento
			};
		},
		apoiar: function apoiar(solicitacaoId, valueToInvest) {
			var _this3 = this;

			this.closeModal();
			this.modalInfoAdicional = true;

			if (document.getElementsByTagName("main").length > 0) {
				document.getElementsByTagName("main")[0].style.zIndex = "50";
			}

			var value = 0;
			if (typeof this.valorInv === 'string') {
				var inv = this.valorInv.replace(/[^a-zA-Z0-9 ]/g, "");
				value = parseFloat(inv / 100);
			}

			var valor = 0;
			if (typeof this.valorReinvestimento === 'string') {
				var reInv = this.valorReinvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
				valor = parseFloat(reInv / 100);

				if (valor > value) {
					valor = value;
				}
			}

			__WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].postApoiarLoanImpact(solicitacaoId, value, valor, this.anonimo, this.exibirQuantia).then(function () {
				_this3.finalizado = true;

				setTimeout(function () {
					_this3.get(_this3.id);
				}, 500);
			});
		},
		getListaInvestidores: function getListaInvestidores(id) {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].getListaInvestidoresLoanImpact(id).then(function (response) {
				var vm = _this4;

				vm.impact.ListaInvestidores = response.data;
				_this4.$forceUpdate();
			});
		},
		validaStatusInvestimento: function validaStatusInvestimento() {
			var resultDt = this.diffDate(new Date(), this.impact.FimCaptacao);

			if (resultDt == "ENCERRADO" || this.impact.ValorCaptado >= this.impact.Valor) return false;

			return true;
		},
		get: function get(id) {
			var _this5 = this;

			__WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].getLoanImpactById(id).then(function (response) {
				_this5.impact = response.data;

				_this5.values = [];
				var valorSelect = 0;
				var valorRestante = _this5.impact.Valor - _this5.impact.ValorCaptado;
				var quantidade = _this5.impact.InvestimentoMaximo / _this5.impact.InvestimentoMinimo;

				for (var i = 0; valorRestante > valorSelect && _this5.impact.InvestimentoMaximo - 5 >= valorSelect; i++) {

					_this5.values.push("R$ " + (15 + 5 * i).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }));
					valorSelect = _this5.impact.InvestimentoMinimo + 5 * i;
				}

				_this5.impact.JaInvestiu = false;
				_this5.impact.ReservaInvestimento = {};
				_this5.impact.ReservaInvestimento.Valor = "";
				_this5.permiteAporte = _this5.validaStatusInvestimento();

				__WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].getCountLoanImpactInvestors(_this5.id).then(function (response) {
					_this5.qtdeInvestidores = response.data;
					_this5.response = true;

					_this5.getValorCaptado(_this5.id);
					_this5.getInvestidor(_this5.id);
					_this5.getListaInvestidores(_this5.id);

					if (_this5.impact.Impacto == null) {
						_this5.impact.Impacto = {};
					}
					_this5.$forceUpdate();
				});

				_this5.AtualizarSaldo();
			});
		},
		getSaldo: function getSaldo() {
			var _this6 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var _ref, data;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_this6.$store.commit(__WEBPACK_IMPORTED_MODULE_7__store_mutation_types_js__["c" /* START_LOADING */]);
								_context.prev = 1;
								_context.next = 4;
								return __WEBPACK_IMPORTED_MODULE_8__services_api_wallet__["a" /* default */].GetSaldoWallet();

							case 4:
								_ref = _context.sent;
								data = _ref.data;

								_this6.sDisponivel = data.Saldo;
								_context.next = 12;
								break;

							case 9:
								_context.prev = 9;
								_context.t0 = _context['catch'](1);

								_this6.sDisponivel = 0.00;

							case 12:
								_this6.$store.commit(__WEBPACK_IMPORTED_MODULE_7__store_mutation_types_js__["d" /* STOP_LOADING */]);
								return _context.abrupt('return', _this6.sDisponivel);

							case 14:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this6, [[1, 9]]);
			}))();
		},
		AtualizarSaldo: function AtualizarSaldo() {
			this.getSaldo();
			// ApiClient.getMyAvalibleMoney()
			// 	.then(item => {

			// 		item.data.credito = (item.data.credito).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
			// 		var credito =  parseFloat(item.data.credito) ;

			// 		item.data.debito = (item.data.debito).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
			// 		var debito =  parseFloat(item.data.debito) ;

			// 		this.sDisponivel = credito - debito;
			// 		this.sDisponivel = parseFloat(this.sDisponivel.toFixed(2));

			// 		if(this.sDisponivel < 0.01)
			// 		{
			// 			this.sDisponivel = 0;
			// 		}

			// 	});
		},
		Nome: function Nome() {
			var nome = "";

			if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
				nome = this.User.username;
			} else {
				nome = this.User.name;
			}
			nome = nome.trim();
			var primeiroNome = nome.split(" ")[0];
			return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
		},

		//tagueamento GA
		taggingGA: function taggingGA() {
			this.$ga.page({
				page: '/investimento-de-impacto/perfil-impacto/:id',
				title: 'Impacto'
			});
		}
	},
	beforeCreated: function beforeCreated() {
		this.$store.dispatch('updateUser');
	},
	created: function created() {
		var _this7 = this;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_this7.id = _this7.$route.params.id;
							_this7.solicitacaoID = _this7.id;

							if (_this7.$store.state.currentUser.investor != null) {
								if (typeof _this7.$store.state.currentUser.investor.Bloqueio != 'undefined') window.location.href = "#/";
							}

							_this7.temSuitability = _this7.$store.state.currentUser.hassuitability;
							_this7.temCadastroInvestidor = _this7.$store.state.currentUser.hasinvestor;
							_this7.investidorAprovado = _this7.$store.state.currentUser.investor != null && _this7.$store.state.currentUser.investor.Status == "APROVADO" && _this7.temCadastroInvestidor;
							_this7.investidor = _this7.$store.state.currentUser.investor;

							_this7.get(_this7.id);

							//tagueamento GA
							_context2.next = 10;
							return _this7.taggingGA();

						case 10:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, _this7);
		}))();
	},


	components: {
		Modal: __WEBPACK_IMPORTED_MODULE_5__components_Modal__["a" /* default */]
	}
});

/***/ }),

/***/ "LCIj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid login"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"ico-iouu",attrs:{"href":_vm.lpUrl,"target":"_blank","title":"IOUU"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('social-network')],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-7 d-flex flex-column form"},[_c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-5 text-center"},[_c('h2',[_vm._v("Seja bem-vindo(a)")]),_vm._v(" "),_c('span',{staticClass:"other"},[_vm._v("Crie uma senha para começar a usar a plataforma.")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Senha")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control form-control-lg",attrs:{"type":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"confirmarpassword"}},[_vm._v("Confirmar senha")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmarpassword),expression:"confirmarpassword"}],staticClass:"form-control form-control-lg",attrs:{"type":"password"},domProps:{"value":(_vm.confirmarpassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmarpassword=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-check text-left d-flex justify-content-center"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enabled),expression:"enabled"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.enabled)?_vm._i(_vm.enabled,null)>-1:(_vm.enabled)},on:{"change":function($event){var $$a=_vm.enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.enabled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.enabled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.enabled=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_c('div',[_c('label',{staticClass:"form-check-label"},[_vm._v("\n    \t\t\t\t      Eu \"CONCORDO\" com os "),_c('a',{attrs:{"href":_vm.lpUrl+'/termos-e-condicoes',"target":"_blank"}},[_vm._v("Termos e condições")]),_vm._v(" e "),_c('a',{attrs:{"href":_vm.lpUrl+'/politica-de-privacidade',"target":"_blank"}},[_vm._v("Política de privacidade")]),_vm._v(" da IOUU.\n    \t\t\t\t    ")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":!_vm.enabled}},[_vm._v("Cadastrar")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-lg-10 d-flex flex-column align-items-center"},[_c('h1',[_vm._v("Crie sua conta")]),_vm._v(" "),_c('p',[_vm._v("\n            Não se preocupe. Você não está assumindo nenhum compromisso neste momento.\n            "),_c('br'),_vm._v("Suas informações serão usadas apenas para analisarmos o seu perfil.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            O empréstimo só acontece se você solicitar uma proposta, aprová-la e fizer o upload da documentação pedida no site.\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LKP0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.openModal)?_c('div',[_c('ModalRegistration',{on:{"setCloseOpenModal":_vm.setOpenModal}})],1):_vm._e(),_vm._v(" "),(_vm.loading)?_c('Loading'):_c('section',{staticClass:"s-abrir-conta page-login"},[_c('div',{staticClass:"container-new"},[_c('LoginBanner'),_vm._v(" "),_c('FormNewLogin',{on:{"userData":_vm.getUserData,"facebook":_vm.facebookLogin,"gmail":_vm.googleLogin,"setOpenModal":_vm.setOpenModal}})],1)]),_vm._v(" "),_c('FooterNewLogin')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LL4/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CadastrarSenha_vue__ = __webpack_require__("RSNq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3e8e1bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CadastrarSenha_vue__ = __webpack_require__("LCIj");
function injectStyle (ssrContext) {
  __webpack_require__("obLK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a3e8e1bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CadastrarSenha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3e8e1bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CadastrarSenha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LQU4":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNy41NDU0NUMxIDcuNTQ1NDUgNC4yNzI3MyAxIDEwIDFDMTUuNzI3MyAxIDE5IDcuNTQ1NDUgMTkgNy41NDU0NUMxOSA3LjU0NTQ1IDE1LjcyNzMgMTQuMDkwOSAxMCAxNC4wOTA5QzQuMjcyNzMgMTQuMDkwOSAxIDcuNTQ1NDUgMSA3LjU0NTQ1WiIgc3Ryb2tlPSIjMDBEOUM1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOS45OTk0NyA5Ljk5OTkxQzExLjM1NTEgOS45OTk5MSAxMi40NTQgOC45MDA5NyAxMi40NTQgNy41NDUzN0MxMi40NTQgNi4xODk3NiAxMS4zNTUxIDUuMDkwODIgOS45OTk0NyA1LjA5MDgyQzguNjQzODYgNS4wOTA4MiA3LjU0NDkyIDYuMTg5NzYgNy41NDQ5MiA3LjU0NTM3QzcuNTQ0OTIgOC45MDA5NyA4LjY0Mzg2IDkuOTk5OTEgOS45OTk0NyA5Ljk5OTkxWiIgc3Ryb2tlPSIjMDBEOUM1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "Levr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChartInvestimentos_vue__ = __webpack_require__("nu1q");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChartInvestimentos_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lhjm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SocialNetwork__ = __webpack_require__("TYgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PasswordField__ = __webpack_require__("i7i+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_hub_consulta_client_js__ = __webpack_require__("pk4i");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lpUrl: "https://iouu.com.br",
      name: '',
      email: '',
      password: '',
      CodConvite: '',
      enabled: false,
      visivel: false
    };
  },

  components: {
    SocialNetwork: __WEBPACK_IMPORTED_MODULE_3__components_SocialNetwork__["a" /* default */], PasswordField: __WEBPACK_IMPORTED_MODULE_5__components_PasswordField__["a" /* default */]
  },
  methods: {
    ValidarEmail: function ValidarEmail() {
      var _this = this;

      //Chama API que faz a Pré Validação do Email para verificar se a ortografia esta correta
      if (this.email != "") {
        __WEBPACK_IMPORTED_MODULE_6__utils_hub_consulta_client_js__["a" /* default */].PreValidacaoEmail(this.email).then(function (resposta) {

          //Sintaxe do Email Inválida
          if (resposta.Msg == "Email Inválido") {
            $("#IconeInvalido").removeAttr("hidden");
            $("#Email").addClass("animated shake");
            $("#Email").addClass("emailinvalido");
            $("#IconeInvalido").addClass("animated shake");
            _this.EmailConfirmado = false;
            _this.$Notify.error("Digite um email válido!");
          }

          //Sintaxe do Email Correta
          else {
              //Chama API que verifica se este usuário já está cadastrado
              __WEBPACK_IMPORTED_MODULE_6__utils_hub_consulta_client_js__["a" /* default */].ExisteUsuario(_this.email).then(function (resposta) {
                if (resposta.Msg == "Existe") {
                  _this.$Notify.info("Esse email já foi cadastrado no sistema!");
                  $("#IconeInvalido").removeAttr("hidden");
                  $("#Email").addClass("animated shake");
                  $("#Email").addClass("emailinvalido");
                  $("#IconeInvalido").addClass("animated shake");
                  _this.EmailConfirmado = false;
                } else {
                  //Chamar API que faz a validação do Email
                  __WEBPACK_IMPORTED_MODULE_6__utils_hub_consulta_client_js__["a" /* default */].theCheckerPost(_this.email).then(function (resposta) {

                    if (resposta == "Entregável") {
                      //Executa se o email for válido
                      $("#IconeValido").removeAttr("hidden");
                      $("#Email").addClass("emailvalido");
                      _this.EmailConfirmado = true;
                      _this.$Notify.success("Email Validado com Sucesso!");

                      console.log("resposta: ", resposta);
                    }

                    if (resposta == "Inválido") {
                      //Executa se o email for inválido
                      $("#IconeInvalido").removeAttr("hidden");
                      $("#Email").addClass("animated shake");
                      $("#Email").addClass("emailinvalido");
                      $("#IconeInvalido").addClass("animated shake");
                      _this.EmailConfirmado = false;
                      _this.$Notify.error("Email Inválido!");
                    }
                  }).catch(function () {
                    $("#IconeValido").removeAttr("hidden");
                    $("#Email").addClass("emailvalido");
                    _this.EmailConfirmado = true;
                    _this.$Notify.success("Email Validado com Sucesso!");
                  }); //Fim Validação TheChecker
                }
              }).catch(function () {
                $("#IconeValido").removeAttr("hidden");
                $("#Email").addClass("emailvalido");
                _this.EmailConfirmado = true;
                _this.$Notify.success("Email Validado com Sucesso!");
              }); //Fim Existe Usuário
            }
        }).catch(function () {
          $("#IconeValido").removeAttr("hidden");
          $("#Email").addClass("emailvalido");
          _this.EmailConfirmado = true;
          _this.$Notify.success("Email Validado com Sucesso!");
        }); //Fim Validação Email
      }
    },
    RetirarAnimacao: function RetirarAnimacao() {
      $("#Email").removeClass("animated");
      $("#Email").removeClass("shake");
      $("#Email").removeClass("emailinvalido");
      $("#Email").removeClass("emailvalido");

      $("#IconeInvalido").removeClass("animated");
      $("#IconeInvalido").removeClass("shake");
      $("#IconeInvalido").attr({ "hidden": "hidden" });

      $("#IconeValido").attr({ "hidden": "hidden" });
    },

    linkEmprestimo: function linkEmprestimo() {
      this.$router.push("/tipo-de-emprestimo");
    },
    validateName: function validateName() {
      if (this.name[0] == " ") {
        this.name = "";
        return;
      }

      var splitText = this.name.split(' ');
      var upperCaseText = '';

      for (var i = 0; i < splitText.length; i++) {
        if (splitText[i] != "") {
          if (i > 0) upperCaseText += " ";

          upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
        } else if (i > 0) upperCaseText += " ";
      }

      this.name = upperCaseText;
    },
    signUp: function signUp() {
      var _this2 = this;

      this.$store.dispatch('signup', { name: this.name, email: this.email, password: this.password, CodigoConvidado: this.CodConvite }).then(function () {
        _this2.$router.push("/");
      }).catch(function (error) {
        var errorMessages = error.response.data.errors.map(function (error) {
          return error.detail;
        });
        _this2.$Notify.error(__WEBPACK_IMPORTED_MODULE_4__utils_array_helper__["a" /* default */].toSentence(errorMessages));
      });

      // CADASTRA CONTATO EM ACTIVE CAMPAIN
      __WEBPACK_IMPORTED_MODULE_6__utils_hub_consulta_client_js__["a" /* default */].CadastrarActive(this.email);
    },
    facebookLogin: function facebookLogin(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get('oauth/facebook/url').then(function (response) {
        window.location.href = response.data.loginUrl;
      });
    },
    googleLogin: function googleLogin(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get('oauth/google/url').then(function (response) {
        window.location.href = response.data.loginUrl;
      });
    },
    linkedinLogin: function linkedinLogin(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get('oauth/linkedin/url').then(function (response) {
        window.location.href = response.data.loginUrl;
      });
    },


    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/criar-conta/ref/:id',
        title: 'Criar conta convidado'
      });
    }
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:

              if (_this3.$route.params.id) _this3.CodConvite = _this3.$route.params.id;

              if (_this3.$route.query.name) _this3.name = _this3.$route.query.name;

              if (_this3.$route.query.email) _this3.email = _this3.$route.query.email;

              if (_this3.$route.query.v) _this3.visivel = true;

              //let ckeditor = document.createElement('script');    
              //ckeditor.setAttribute('src',"https://widget.thechecker.co/pk_qktgpfq5ccfgna4nd1ciw.js");
              //document.body.appendChild(ckeditor);

              //tagueamento GA
              _context.next = 6;
              return _this3.taggingGA();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),

/***/ "LmM6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__focus__ = __webpack_require__("9otY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mask__ = __webpack_require__("DQzD");



/***/ }),

/***/ "LmXV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps"},[_c('header',{staticClass:"d-flex"},[_c('a',{staticClass:"left",attrs:{"href":_vm.lpUrl,"target":"blank"}},[_c('i',{staticClass:"ico-iouu logotipo",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("FNzu"),"alt":"Foto Liza"}}),_vm._v(" "),_c('a',{staticClass:"right",attrs:{"href":_vm.lpUrl,"title":"Sair"}},[_c('i',{staticClass:"ico-exit"}),_vm._v(" Sair\n    ")])]),_vm._v(" "),_c('main',{staticClass:"container"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LqmW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_array_helper__ = __webpack_require__("rzJh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			response: false,
			exibirQuantia: true,
			anonimo: false,
			modalInfoAdicional: false,
			finalizado: false,
			temCadastroInvestidor: false,
			temSuitability: false,
			investidorAprovado: false,
			permiteAporte: false,
			qtdeInvestidores: 0,
			valueToInvest: 2000,
			valorCaptado: 0,
			id: 0,
			impact: {},
			ReservaInvestimento: {},
			valorInv: null,
			valorReinvestimento: 0,
			sDisponivel: 0,
			showInputInvestment: true,
			showInputSaldo: false
		};
	},


	computed: {
		dataInicio: function dataInicio() {
			return this.impact.InicioCaptacao.toLocaleDateString('pt-BR');
		},
		canInvest: function canInvest() {
			return this.temCadastroInvestidor && this.temSuitability && this.investidorAprovado;
		},

		User: function User() {
			return this.$store.state.currentUser;
		}
	},

	methods: {
		calcValorRestante: function calcValorRestante(impact) {
			return impact.Valor - impact.ValorCaptado;
		},
		calcPercValorRestante: function calcPercValorRestante(impact) {
			return impact.ValorCaptado * 100 / impact.Valor;
		},
		calcDiasRestantes: function calcDiasRestantes() {
			return this.diffDate(new Date(), this.impact.FimCaptacao);
		},
		formatMongoDate: function formatMongoDate(dt) {
			var date = new Date(dt);

			var day = date.getDate();
			var month = date.getMonth() + 1;
			var year = date.getFullYear();

			day = day > 9 ? day : '0' + day;
			month = month > 9 ? month : '0' + month;

			return day + '/' + month + '/' + year;
		},
		diffDate: function diffDate(d1, d2) {
			var date1, date2;

			if (d1 == "") {
				date1 = new Date();
			} else {
				date1 = new Date(d1);
				date1.setHours(date1.getHours() + date1.getTimezoneOffset() / 60);
			}

			if (d2 == "") {
				date2 = new Date();
			} else {
				date2 = new Date(d2);
				date2.setHours(date2.getHours() + date2.getTimezoneOffset() / 60);
			}

			var timeDiff = date2.getTime() - date1.getTime();
			var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

			if (diffDays < 0) return "Encerrado";
			if (diffDays == 0) return "Finaliza hoje*";

			return "Finaliza em " + diffDays + " dias*";
		},
		formatCurrency: function formatCurrency(value) {

			if (value == null || value == undefined) return parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });

			return value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
		},
		money: function money(n) {

			var c = 2,
			    d = ",",
			    t = ".",
			    s = n < 0 ? "-" : "",
			    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
			    j = (j = i.length) > 3 ? j % 3 : 0;
			return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
		},
		showModal: function showModal(item) {
			this.selectedItem = item;
			this.modalVisible = true;
			this.modalInfoAdicional = false;
			this.showInputSaldo = false;
			this.showInputInvestment = true;
		},
		closeModal: function closeModal() {
			this.modalVisible = false;
			this.modalInfoAdicional = false;
			this.finalizado = false;
			this.showInputSaldo = false;
			this.showInputInvestment = true;
		},
		dataLonga: function dataLonga(data) {
			var date = new Date(data);
			date.setHours(date.getHours() + date.getTimezoneOffset() / 60); //ajustando para o horário gravado no banco
			var options = { year: "numeric", month: "long", day: "numeric" };
			return date.toLocaleDateString("pt-BR", options);
		},
		ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
			var s = String(id);

			while (s.length < (qtd || 2)) {
				s = "0" + s;
			}

			return s;
		},
		getValorCaptado: function getValorCaptado(solicitacaoId) {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getValorCaptadoLoanImpact(solicitacaoId).then(function (response) {
				_this.valorCaptado = response.data[0].Total;
			});
		},
		InvestidorBloqueado: function InvestidorBloqueado() {

			if (this.$store.state.currentUser == null || this.$store.state.currentUser.investor == null || this.$store.state.currentUser.investor.Bloqueio == null || this.$store.state.currentUser.investor.Bloqueio.FimBloqueio == null) return false;

			var FimBloqueio = new Date(this.$store.state.currentUser.investor.Bloqueio.FimBloqueio);

			return FimBloqueio > new Date();
		},
		getInvestidor: function getInvestidor(solicitacaoId) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getInvestidorLoanImpact(solicitacaoId).then(function (response) {
				if (response.data != null && response.data.Status != 0) {
					_this2.impact.JaInvestiu = true;
					_this2.impact.ReservaInvestimento = response.data;
					_this2.impact.ReservaInvestimento.Valor += ",00";

					_this2.valorInv = _this2.impact.ReservaInvestimento.Valor;
				} else {
					_this2.impact.JaInvestiu = false;
				}

				_this2.$forceUpdate();
			});
		},
		ShowSaldo: function ShowSaldo() {

			if (!this.ValidarInvestimento()) {
				return false;
			}

			var value = 0;
			if (typeof this.valueToInvest === 'string') {
				var inv = this.valueToInvest.replace(/[^a-zA-Z0-9 ]/g, "");
				value = parseFloat(inv / 100);
			}

			if (this.sDisponivel > 0) {
				if (this.sDisponivel > value) {
					this.valorReinvestimento = this.money(value || 0);
				} else {
					this.valorReinvestimento = this.money(this.sDisponivel || 0);
				}

				this.showInputInvestment = false;
				this.showInputSaldo = true;
				return true;
			}

			this.proximoPasso();
			return true;
		},
		NaoUsarSaldo: function NaoUsarSaldo() {

			this.valorReinvestimento = 0;
			this.proximoPasso();

			return false;
		},
		ValidarInvestimento: function ValidarInvestimento() {

			var value = 0;
			if (typeof this.valorInv === 'string') {
				var inv = this.valorInv.replace(/[^a-zA-Z0-9 ]/g, "");
				value = parseFloat(inv / 100);
			}

			if (value == 0 || isNaN(value)) {
				this.$Notify.error({
					title: "Desculpe",
					message: "Por favor, insira um valor."
				});

				return false;
			}

			if (value < 100 || isNaN(value)) {
				this.$Notify.error({
					title: "Desculpe",
					message: "O valor mínimo de aporte é de R$ 100,00."
				});

				return false;
			}

			if (value % 100 != 0 || isNaN(value)) {
				this.$Notify.error({
					title: "Desculpe",
					message: "O valor deve ser multiplo de R$ 100."
				});

				return false;
			}

			if (value > this.impact.Valor) {
				this.$Notify.error({
					title: "Desculpe",
					message: "O valor de aporte é maior que o solicitado."
				});

				return false;
			}

			if (this.impact.Valor - this.impact.ValorCaptado > 0 && value > this.impact.Valor - this.impact.ValorCaptado) {
				this.$Notify.error({
					title: "Desculpe",
					message: "O valor de aporte é maior que o disponível."
				});

				return false;
			}

			return true;
		},
		UsarSaldo: function UsarSaldo() {

			var valor = 0;

			if (typeof this.valorReinvestimento === 'string') {
				var reInv = this.valorReinvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
				valor = parseFloat(reInv / 100);
			}

			var errorMessages;

			if (valor < 0) {

				errorMessages = ["Insira um valor para o reinvestimento."];
				this.$Notify.error(__WEBPACK_IMPORTED_MODULE_5__utils_array_helper__["a" /* default */].toSentence(errorMessages));

				return false;
			}

			if (valor > this.sDisponivel) {

				errorMessages = ["Saldo indisponível para o reinvestimento. Valor máximo: R$ " + this.formatCurrency(this.sDisponivel)];
				this.$Notify.error(__WEBPACK_IMPORTED_MODULE_5__utils_array_helper__["a" /* default */].toSentence(errorMessages));

				return false;
			}

			var inv = this.valorInv.replace(/[^a-zA-Z0-9 ]/g, "");
			var valorInv = parseFloat(inv) / 100;

			if (valor > valorInv) {

				errorMessages = ["O valor deve ser menor ou igual ao investido : R$ " + this.formatCurrency(valorInv)];
				this.$Notify.error(__WEBPACK_IMPORTED_MODULE_5__utils_array_helper__["a" /* default */].toSentence(errorMessages));

				return false;
			}

			this.proximoPasso();
			return false;
		},
		proximoPasso: function proximoPasso() {

			this.closeModal();
			this.modalInfoAdicional = true;

			if (document.getElementsByTagName("main").length > 0) {
				document.getElementsByTagName("main")[0].style.zIndex = "50";
			}
		},
		apoiar: function apoiar(solicitacaoId, valueToInvest) {
			var _this3 = this;

			this.closeModal();
			this.modalInfoAdicional = true;

			if (document.getElementsByTagName("main").length > 0) {
				document.getElementsByTagName("main")[0].style.zIndex = "50";
			}

			var value = 0;
			if (typeof this.valorInv === 'string') {
				var inv = this.valorInv.replace(/[^a-zA-Z0-9 ]/g, "");
				value = parseFloat(inv / 100);
			}

			var valor = 0;
			if (typeof this.valorReinvestimento === 'string') {
				var reInv = this.valorReinvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
				valor = parseFloat(reInv / 100);

				if (valor > value) {
					valor = value;
				}
			}

			__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].postApoiarLoanImpact(solicitacaoId, value, valor, this.anonimo, this.exibirQuantia).then(function () {
				_this3.finalizado = true;

				setTimeout(function () {
					_this3.get(_this3.id);
				}, 500);
			});
		},
		getListaInvestidores: function getListaInvestidores(id) {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getListaInvestidoresLoanImpact(id).then(function (response) {
				var vm = _this4;

				vm.impact.ListaInvestidores = response.data;
				_this4.$forceUpdate();
			});
		},
		validaStatusInvestimento: function validaStatusInvestimento() {
			var resultDt = this.diffDate(new Date(), this.impact.FimCaptacao);

			if (resultDt == "ENCERRADO" || this.impact.ValorCaptado >= this.impact.Valor) return false;

			return true;
		},
		get: function get(id) {
			var _this5 = this;

			__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getLoanImpactById(id).then(function (response) {
				_this5.impact = response.data;

				_this5.impact.JaInvestiu = false;
				_this5.impact.ReservaInvestimento = {};
				_this5.impact.ReservaInvestimento.Valor = "";
				_this5.permiteAporte = _this5.validaStatusInvestimento();

				__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getCountLoanImpactInvestors(_this5.id).then(function (response) {
					_this5.qtdeInvestidores = response.data;
					_this5.response = true;

					_this5.getValorCaptado(_this5.id);
					_this5.getInvestidor(_this5.id);
					_this5.getListaInvestidores(_this5.id);

					if (_this5.impact.Impacto == null) {
						_this5.impact.Impacto = {};
					}
					_this5.$forceUpdate();
				});

				_this5.AtualizarSaldo();
			});
		},
		AtualizarSaldo: function AtualizarSaldo() {
			var _this6 = this;

			__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getMyAvalibleMoney().then(function (item) {

				item.data.credito = item.data.credito.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
				var credito = parseFloat(item.data.credito);

				item.data.debito = item.data.debito.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
				var debito = parseFloat(item.data.debito);

				_this6.sDisponivel = credito - debito;
				_this6.sDisponivel = parseFloat(_this6.sDisponivel.toFixed(2));

				if (_this6.sDisponivel < 0.01) {
					_this6.sDisponivel = 0;
				}
			});
		},
		Nome: function Nome() {
			var nome = "";

			if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
				nome = this.User.username;
			} else {
				nome = this.User.name;
			}
			nome = nome.trim();
			var primeiroNome = nome.split(" ")[0];
			return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
		},

		//tagueamento GA
		taggingGA: function taggingGA() {
			this.$ga.page({
				page: '/investimento-de-impacto/perfil-impacto/:id',
				title: 'Impacto'
			});
		}
	},
	beforeCreated: function beforeCreated() {
		this.$store.dispatch('updateUser');
	},
	created: function created() {
		var _this7 = this;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_this7.id = _this7.$route.params.id;

							if (_this7.$store.state.currentUser.investor != null) {
								if (typeof _this7.$store.state.currentUser.investor.Bloqueio != 'undefined') window.location.href = "#/";
							}

							_this7.temSuitability = _this7.$store.state.currentUser.hassuitability;
							_this7.temCadastroInvestidor = _this7.$store.state.currentUser.hasinvestor;
							_this7.investidorAprovado = _this7.$store.state.currentUser.investor != null && _this7.$store.state.currentUser.investor.Status == "APROVADO" && _this7.temCadastroInvestidor;

							_this7.get(_this7.id);

							//tagueamento GA
							_context.next = 8;
							return _this7.taggingGA();

						case 8:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this7);
		}))();
	},


	components: {
		Modal: __WEBPACK_IMPORTED_MODULE_4__components_Modal__["a" /* default */]
	}
});

/***/ }),

/***/ "LsEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finishedLoading)?_c('div',{staticClass:"col-12 col-md-8 col-lg-8"},[_c('section',[_c('div',{staticClass:"tit"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"rating float-right"},[_c('strong',[_vm._v("\n                    Score da operação\n                    "),_c('span',{staticClass:"circle score"}),_vm._v("\n                    "+_vm._s(_vm.score)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Valor Solicitado\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s((_vm.solicitacao.ValorSolicitado != undefined && _vm.solicitacao.ValorSolicitado != 0)? _vm.money(_vm.solicitacao.ValorSolicitado): _vm.valor)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Valor Aprovado\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.valor)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Duração\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        "+_vm._s(_vm.prazo)+" meses\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Valor da parcela\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.parcela)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Valor total do empréstimo\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.valorTotal)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Juros\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        "+_vm._s(_vm.taxaJuros)+"% a.m.\n                    ")])])]),_vm._v(" "),(_vm.taxaTotal != 0 && _vm.taxaTotal != undefined)?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("\n                        Taxa total efetiva\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.taxaTotal)+"% a.a.\n                    ")])])]):_vm._e(),_vm._v(" "),(_vm.solicitacao.CustoEfetivoTotalam != undefined && _vm.solicitacao.CustoEfetivoTotalam != 0)?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Custo Efetivo Total")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.solicitacao.CustoEfetivoTotalam == undefined ?"-":_vm.money(_vm.solicitacao.CustoEfetivoTotalam) + "% a.m."))])])]):_vm._e(),_vm._v(" "),(_vm.solicitacao.CustoEfetivoTotalaa != undefined && _vm.solicitacao.CustoEfetivoTotalaa != 0)?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Custo Efetivo Total")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.solicitacao.CustoEfetivoTotalaa == undefined ?"-":_vm.money(_vm.solicitacao.CustoEfetivoTotalaa) + "% a.a."))])])]):_vm._e(),_vm._v(" "),(_vm.solicitacao.Iof != undefined && _vm.solicitacao.Iof != 0)?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("IOF")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.solicitacao.Iof == undefined ?"-":_vm.money(_vm.solicitacao.Iof)))])])]):_vm._e(),_vm._v(" "),(_vm.solicitacao.TaxaIouu != undefined && _vm.solicitacao.TaxaIouu != 0)?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Taxa IOUU")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.solicitacao.TaxaIouu == undefined ?"-":_vm.money(_vm.solicitacao.TaxaIouu)))])])]):_vm._e(),_vm._v(" "),(_vm.solicitacao.TaxaParceira != undefined && _vm.solicitacao.TaxaParceira != 0)?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Taxa Instituição Financeira")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.solicitacao.TaxaParceira == undefined ?"-":_vm.money(_vm.solicitacao.TaxaParceira)))])])]):_vm._e(),_vm._v(" "),(_vm.solicitacao.ValorLiquido != undefined && _vm.solicitacao.ValorLiquido != 0)?_c('div',{staticClass:"col-12 col-md-12 col-lg-12"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor Liquido a Receber")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.money(_vm.solicitacao.ValorLiquido)))])])]):_vm._e()])]),_vm._v(" "),_c('section',[_c('h3',[_vm._v("\n            Captação de recursos (investidores)\n        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"box no-color"},[_c('label',[_vm._v("\n                        Inicio/Término\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        "+_vm._s(_vm.dataInicio)+" - "+_vm._s(_vm.dataFim)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"box no-color"},[_c('label',[_vm._v("\n                        Total de Investidores\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        "+_vm._s(_vm.investidores)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"box no-color"},[_c('label',[_vm._v("\n                        Valor total captado\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        R$ "+_vm._s(_vm.valorCaptado)+"\n                        "),_c('span',{staticClass:"percent"},[_vm._v("\n                            "+_vm._s(_vm.percentValorCaptado)+"%\n                        ")])])])])])]),_vm._v(" "),_c('section',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.razaoSocial))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("CPF/CNPJ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formattedCnpj))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Nome do responsável")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.nomeResponsavel))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Nome fantasia")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.nomeFantasia))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Telefone comercial")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.telefone))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Data de fundação")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.dataFuncadao))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Número de funcionários")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.numeroEmpregados)+" empregados")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Nome do grupo ecônomico")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.grupoEconomico))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('label',[_vm._v("Endereço")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.Endereco))])]),_vm._v(" "),(_vm.solicitacao.Empresa.Site != '')?_c('div',{staticClass:"col-12 col-lg-6 col-xr-4"},[_c('label',[_vm._v("Site")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.site))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 col-xl-4"},[_c('label',[_vm._v("\n                    Email\n                ")]),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(_vm.email)+"\n                ")])]),_vm._v(" "),(_vm.solicitacao.Empresa.Instagram != '' || _vm.solicitacao.Empresa.Facebook != '' || _vm.solicitacao.Empresa.Linkedin != '' || _vm.solicitacao.Empresa.Twitter != '' || _vm.solicitacao.Empresa.Vimeo != '')?_c('div',{staticClass:"col-12 col-lg-12 col-xr-4"},[_c('label',[_vm._v("Redes Sociais")]),_vm._v(" "),_c('span',{staticClass:"social-links"},[(_vm.facebook)?_c('a',{staticClass:"fab fa-facebook-square",attrs:{"href":_vm.facebook,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.twitter)?_c('a',{staticClass:"fab fa-twitter",attrs:{"href":_vm.twitter,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.linkdin)?_c('a',{staticClass:"fab fa-linkedin-in",attrs:{"href":_vm.linkdin,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.instagram)?_c('a',{staticClass:"fab fa-instagram",attrs:{"href":_vm.instagram,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.vimeo)?_c('a',{staticClass:"fab fa-vimeo-v",attrs:{"href":_vm.vimeo,"target":"_blank"}}):_vm._e()])]):_vm._e()])]),_vm._v(" "),_c('section',[_c('h4',[_vm._v("\n            Descrição breve sobre a empresa\n        ")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.breveDescricao)}})]),_vm._v(" "),_c('section',[_c('h4',[_vm._v("\n            Sobre a empresa\n        ")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.sobreEmpresa)}})]),_vm._v(" "),_c('section',[_c('h3',[_vm._v("\n            Documentos\n        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-6"},[_c('a',{staticClass:"docs",attrs:{"target":"_blank","href":_vm.lpUrl+'/termos-e-condicoes/'}},[_vm._v("\n                    Termos e Condições\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-6"},[_c('a',{staticClass:"docs",attrs:{"target":"_blank","href":_vm.lpUrl+'/politica-de-privacidade/'}},[_vm._v("\n                    Politica de Privacidade\n                ")])]),_vm._v(" "),(this.solicitacao.UrlCCB || this.solicitacao.CCBsAssinaturas == true)?_c('div',{staticClass:"col-6 col-md-6 col-lg-6",staticStyle:{"padding-top":"5px"}},[(this.solicitacao.UrlCCB)?_c('a',{staticClass:"docs",attrs:{"target":"_blank","href":this.solicitacao.UrlCCB}},[_vm._v("\n                    CCB\n                ")]):_vm._e(),_vm._v(" "),(this.solicitacao.CCBsAssinaturas == true)?_c('a',{staticClass:"docs",attrs:{"target":"_blank","href":"/#/emprestimos/formalizar-ccb/" + this.solicitacao._id}},[_vm._v("\n                    CCBs\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(this.solicitacao.UrlEndosso)?_c('div',{staticClass:"col-12 col-md-6 col-lg-6"},[_c('a',{staticClass:"docs",attrs:{"target":"_blank","href":this.solicitacao.UrlEndosso}},[_vm._v("\n                    Endosso\n                ")])]):_vm._e()])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left"},[_c('h3',[_vm._v("\n                    Dados financeiros \n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('div',{staticClass:"float-left"},[_c('h3',[_vm._v("\n                    Dados da Empresa\n                ")])]),_vm._v(" "),_c('div',{staticClass:"float-right"}),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Empresa\n                    "),_c('span',[_vm._v("(Razão social)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LvM3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        operacao: { type: Object }
    },

    created: function created() {

        console.log(this.operacao);
    },


    computed: {
        valor: function valor() {
            return this.operacao.Valor;
        },
        transacao: function transacao() {
            return this.operacao.id;
        },
        boletoUrl: function boletoUrl() {
            return 'https://faturas.iugu.com/' + this.operacao.Detalhes.Deposito.BoletoId;
        },
        idOportunidade: function idOportunidade() {
            return this.operacao.Detalhes.Investimento.IdOportunidade;
        },
        nomeEmpresa: function nomeEmpresa() {
            var NomeEmpresa = this.operacao.Detalhes.Investimento.NomeEmpresa;

            return NomeEmpresa;
        },
        documento: function documento() {
            var Documento = this.operacao.Detalhes.Investimento.Documento;

            return Documento || "";
        }
    },

    methods: {
        formatDocument: function formatDocument(doc) {

            if (doc.length > 11) {
                return __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].maskCnpj(doc);
            } else {
                return __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].maskCpf(doc);
            }
        },
        formatarDinheiro: function formatarDinheiro(value) {

            if (value != null) {

                if (typeof value == "string") value = parseFloat(value);

                var options = {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                };

                return value.toLocaleString('pt-BR', options);
            }

            return 0;
        }
    }
});

/***/ }),

/***/ "M+3+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466eef64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("MyhZ");
function injectStyle (ssrContext) {
  __webpack_require__("J0Dh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-466eef64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466eef64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAPa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MC8o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StepBackButton__ = __webpack_require__("g50h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AdditionalInformationSocial_NomeCompletoStep_vue__ = __webpack_require__("AoJG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AdditionalInformationSocial_TelefonesStep_vue__ = __webpack_require__("+aTz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AdditionalInformationSocial_NaturezaOcupacaoStep_vue__ = __webpack_require__("EDzU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AdditionalInformationSocial_RendaExtraStep_vue__ = __webpack_require__("w2yp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AdditionalInformationSocial_OutrosEmprestimosStep_vue__ = __webpack_require__("txFT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AdditionalInformationSocial_InformacoesSocioStep_vue__ = __webpack_require__("G6tb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AdditionalInformationSocial_NascionalidadeStep_vue__ = __webpack_require__("j1qf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AdditionalInformationSocial_EstadoCivilStep_vue__ = __webpack_require__("uZqD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AdditionalInformationSocial_EscolaridadeStep_vue__ = __webpack_require__("HGb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AdditionalInformationSocial_RedesSocaisStep_vue__ = __webpack_require__("Eqk4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_AdditionalInformationSocial_EnderecoStep_vue__ = __webpack_require__("138M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_AdditionalInformationSocial_InformacoesPjInstitucionalStep_vue__ = __webpack_require__("ijQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_AdditionalInformationSocial_InformacoesPjEnderecoStep_vue__ = __webpack_require__("I3SD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_AdditionalInformationSocial_InformacoesPjRedesSociaisStep_vue__ = __webpack_require__("A1Xl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AdditionalInformationSocial_InformacaoInstitucionalStep_vue__ = __webpack_require__("sug5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_AdditionalInformationSocial_FileUploadIndentidadeStep_vue__ = __webpack_require__("gnDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_AdditionalInformationSocial_FileUploadFotoIdentificacaoStep_vue__ = __webpack_require__("FJeV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_AdditionalInformationSocial_FileUploadComprovanteEnderecoStep_vue__ = __webpack_require__("2ad2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_AdditionalInformationSocial_FileUploadDeclaracaoIRStep_vue__ = __webpack_require__("mpAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_AdditionalInformationSocial_FileUploadExtratosStep_vue__ = __webpack_require__("EbAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_AdditionalInformationSocial_FileUploadPjDeclaracaoMeiStep_vue__ = __webpack_require__("6+EH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_AdditionalInformationSocial_FileUploadPjCertificadoMeiStep_vue__ = __webpack_require__("Uwq0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_AdditionalInformationSocial_FinishedStep_vue__ = __webpack_require__("QmXc");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// COMPONENTS STEPS - EMPRESTIMO SOCIAL
























var components = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
  'step-back-button': __WEBPACK_IMPORTED_MODULE_3__components_StepBackButton__["a" /* default */],
  'nome-completo-step': __WEBPACK_IMPORTED_MODULE_5__components_AdditionalInformationSocial_NomeCompletoStep_vue__["a" /* default */],
  'telefones-step': __WEBPACK_IMPORTED_MODULE_6__components_AdditionalInformationSocial_TelefonesStep_vue__["a" /* default */],
  'natureza-ocupacao-step': __WEBPACK_IMPORTED_MODULE_7__components_AdditionalInformationSocial_NaturezaOcupacaoStep_vue__["a" /* default */],
  'renda-extra-step': __WEBPACK_IMPORTED_MODULE_8__components_AdditionalInformationSocial_RendaExtraStep_vue__["a" /* default */],
  'outros-emprestimos-step': __WEBPACK_IMPORTED_MODULE_9__components_AdditionalInformationSocial_OutrosEmprestimosStep_vue__["a" /* default */],
  'informacoes-socio-step': __WEBPACK_IMPORTED_MODULE_10__components_AdditionalInformationSocial_InformacoesSocioStep_vue__["a" /* default */],
  'nascionalidade-step': __WEBPACK_IMPORTED_MODULE_11__components_AdditionalInformationSocial_NascionalidadeStep_vue__["a" /* default */],
  'estado-civil-step': __WEBPACK_IMPORTED_MODULE_12__components_AdditionalInformationSocial_EstadoCivilStep_vue__["a" /* default */],
  'escolaridade-step': __WEBPACK_IMPORTED_MODULE_13__components_AdditionalInformationSocial_EscolaridadeStep_vue__["a" /* default */],
  'redes-sociais-step': __WEBPACK_IMPORTED_MODULE_14__components_AdditionalInformationSocial_RedesSocaisStep_vue__["a" /* default */],
  'endereco-step': __WEBPACK_IMPORTED_MODULE_15__components_AdditionalInformationSocial_EnderecoStep_vue__["a" /* default */],
  'informacoes-pj-institucional-step': __WEBPACK_IMPORTED_MODULE_16__components_AdditionalInformationSocial_InformacoesPjInstitucionalStep_vue__["a" /* default */],
  'informacoes-pj-endereco-step': __WEBPACK_IMPORTED_MODULE_17__components_AdditionalInformationSocial_InformacoesPjEnderecoStep_vue__["a" /* default */],
  'informacoes-pj-redes-sociais-step': __WEBPACK_IMPORTED_MODULE_18__components_AdditionalInformationSocial_InformacoesPjRedesSociaisStep_vue__["a" /* default */],
  'informacao-institucional-step': __WEBPACK_IMPORTED_MODULE_19__components_AdditionalInformationSocial_InformacaoInstitucionalStep_vue__["a" /* default */],
  'file-upload-identidade-step': __WEBPACK_IMPORTED_MODULE_20__components_AdditionalInformationSocial_FileUploadIndentidadeStep_vue__["a" /* default */],
  'file-upload-foto-identificacao-step': __WEBPACK_IMPORTED_MODULE_21__components_AdditionalInformationSocial_FileUploadFotoIdentificacaoStep_vue__["a" /* default */],
  'file-upload-comprovante-endereco-step': __WEBPACK_IMPORTED_MODULE_22__components_AdditionalInformationSocial_FileUploadComprovanteEnderecoStep_vue__["a" /* default */],
  'file-upload-declaracao-ir-step': __WEBPACK_IMPORTED_MODULE_23__components_AdditionalInformationSocial_FileUploadDeclaracaoIRStep_vue__["a" /* default */],
  'file-upload-extratos-step': __WEBPACK_IMPORTED_MODULE_24__components_AdditionalInformationSocial_FileUploadExtratosStep_vue__["a" /* default */],
  'file-upload-pj-declaracao-mei-step': __WEBPACK_IMPORTED_MODULE_25__components_AdditionalInformationSocial_FileUploadPjDeclaracaoMeiStep_vue__["a" /* default */],
  'file-upload-pj-certificado-mei-step': __WEBPACK_IMPORTED_MODULE_26__components_AdditionalInformationSocial_FileUploadPjCertificadoMeiStep_vue__["a" /* default */],
  'finished-step': __WEBPACK_IMPORTED_MODULE_27__components_AdditionalInformationSocial_FinishedStep_vue__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = ({
  /* eslint-disable */
  data: function data() {
    return {
      transitionName: 'slide-left',
      solicitacaoId: this.$route.params.id,
      currentUser: null
    };
  },

  components: components,
  computed: {
    currentStepComponent: function currentStepComponent() {
      if (this.currentUser !== null) {

        if (!this.currentUser.Status || this.currentUser.Status === "" || this.currentUser.Status == "LIZA" || this.currentUser.Status == "PREAPROVADO") {
          this.currentUser.Status = "nome-completo";
        }

        return this.currentUser.Status + "-step";
      } else {
        return this.currentUser;
      }
    },
    progress: function progress() {
      var stepsAmount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(components).length;
      var currentStepNumber = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(components).indexOf(this.currentStepComponent) + 1;
      return Math.round(currentStepNumber * 100 / stepsAmount);
    },
    canGoPrevious: function canGoPrevious() {
      if (!this.currentUser) {
        return false;
      }

      var stepsThatCantGoBack = ['nome-completo', 'finished', 'cancelado'];
      return !stepsThatCantGoBack.includes(this.currentUser.Status);
    }
  },
  methods: {
    handleLoadingToggle: function handleLoadingToggle(isLoading) {
      if (isLoading) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);
      } else {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
      }
    },

    updateUser: function updateUser(newData) {
      var _this = this;

      newData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(newData, { StepType: 'next' });
      this.transitionName = 'slide-left';

      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].put_GO('solicitacoes/' + this.solicitacaoId + '/emprestimo-social-informacoes', { data: newData }).then(function (response) {

        //console.log("updateUser",response)
        _this.currentUser = response.data;
      }).catch(function () {
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
      });
    },
    onPrevious: function onPrevious() {
      var _this2 = this;

      this.transitionName = 'slide-right';

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].put_GO('solicitacoes/' + this.solicitacaoId + '/emprestimo-social-informacoes', { data: { StepType: 'previous' } }).then(function (response) {

        //console.log("onPrevious",response)
        _this2.currentUser = response.data;
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
      }).catch(function () {
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
      });
    }
  },
  created: function created() {
    var _this3 = this;

    var solicitacaoId = this.$route.params.id;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);
    __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get_GO('solicitacoes/' + solicitacaoId).then(function (response) {
      _this3.currentUser = response.data;
      _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
    }).catch(function (error) {
      window.error = error;
      if (error.response && error.response.status == 404) {
        _this3.$router.push('/not-found');
      }

      if (error.response && error.response.status == 401) {
        window.location.href = "#/";
      }
      _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
    });
  },
  beforeUpdate: function beforeUpdate() {
    this.$Loading.update(this.progress);
  }
});

/***/ }),

/***/ "MGb7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alerts_vue__ = __webpack_require__("wVEN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67e1d960_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alerts_vue__ = __webpack_require__("VmH5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alerts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67e1d960_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alerts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MHaR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MNyK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81ed38b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpportunitiesLayout_vue__ = __webpack_require__("UZUo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81ed38b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpportunitiesLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MO9q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MYhY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_172df5da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyLoansLayout_vue__ = __webpack_require__("55Sw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_172df5da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyLoansLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MZu1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__ = __webpack_require__("Du/2");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            CCB_URL: "https://bmpdigital.moneyp.com.br/",
            passo: 1,
            lista: [],
            token: '',
            reservas: {}
        };
    },


    methods: {
        AssinarCCB: function AssinarCCB() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get_GO('out/verificarTokenParaEmailConfirmacao/' + this.$route.params.id + '/' + this.token).then(function (token) {
                console.log(token);
                if (token.data == "ok") {
                    _this.passo = 2;
                } else {
                    _this.$Notify.error("Erro: Token inválido!");
                }
            }).catch(function (ex) {

                _this.$Notify.error("Erro: Token inválido!");
            });
        },
        getClientAddress: function getClientAddress() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client__["a" /* default */].getIP().then(function (ip) {
                _this2.IP = ip;

                console.log(_this2.IP);
            });
        },


        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/cadastrar-senha',
                title: 'CadastrarSenha'
            });
        }
    },

    created: function created() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            if (window.location.href.indexOf("dashboard-app") != -1) _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);

                            _this3.getClientAddress();

                            __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get_GO('out/solicitacaoTokenCCB/' + _this3.$route.params.id).then(function (sol) {
                                sol = sol.data;

                                __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get_GO('out/reservasInvestimentoSolicitacao/' + sol._id).then(function (reserva) {
                                    _this3.reservas = reserva.data;
                                }).catch(function (ex) {
                                    console.log("erro  ", ex);
                                });

                                var tokenEmail = "";
                                if (sol != null && sol != undefined && sol.Empresa != null) {
                                    if (sol.Empresa.Socios != null && sol.Empresa.Socios != undefined) {
                                        for (var i = 0; i < sol.Empresa.Socios.length; i++) {
                                            if (sol.Empresa.Socios[i].Token == _this3.$route.params.id) {
                                                if (sol.Empresa.Socios[i].Assinou == true) {
                                                    _this3.passo = 2;
                                                }
                                                tokenEmail = sol.Empresa.Socios[i].TokenEmail;
                                                break;
                                            }
                                        }
                                    }

                                    if (sol.Empresa.Avalistas != null && sol.Empresa.Avalistas != undefined && _this3.passo == 1) {
                                        for (var i = 0; i < sol.Empresa.Avalistas.length; i++) {
                                            if (sol.Empresa.Avalistas[i].Token == _this3.$route.params.id) {
                                                if (sol.Empresa.Avalistas[i].Assinou == true) {
                                                    _this3.passo = 2;
                                                }
                                                tokenEmail = sol.Empresa.Avalistas[i].TokenEmail;
                                                break;
                                            }
                                        }
                                    }
                                }

                                if (_this3.passo == 1 && tokenEmail == "") {

                                    //Enviar Email para o cliente
                                    __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get_GO('out/criarTokenParaEmailConfirmacao/' + _this3.$route.params.id).then(function (sol) {
                                        _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                    }).catch(function (ex) {
                                        console.log("erro ", ex);
                                        _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                    });

                                    _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                } else {
                                    _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                }
                            }).catch(function (ex) {
                                console.log("erro ", ex);
                                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            });

                            //tagueamento GA
                            _context.next = 5;
                            return _this3.taggingGA();

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this3);
        }))();
    }
});

/***/ }),

/***/ "MaQY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "MtJj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    var social = this.currentUser.Social;
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: social.ArquivoDeclaracaoIRPF || [null]
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.arquivos.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.arquivos, index, null);
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio da Declaração de IRPF é obrigatória'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {

        this.currentUser.Social.ArquivoDeclaracaoIRPF = this.arquivosRecebidos;

        this.$emit('on-submit', { Social: this.currentUser.Social });
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "Mw2E":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ico-nubank.6366235.png";

/***/ }),

/***/ "MwoO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposito operacao row"},[_c('div',{staticClass:"col-12 col-md-7 sep"},[_c('table',{staticClass:"info"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Valor")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("R$ "+_vm._s(_vm.formatarDinheiro(_vm.valor)))])])])])]),_vm._v(" "),_c('div',{staticClass:"detalhes col-12 col-md-5"},[_c('div',{staticClass:"options"},[_c('p',[_vm._v("\n                ID da Transação\n                "),_c('strong',[_vm._v("\n                    "+_vm._s(_vm.transacao)+"\n                ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("\n                    Detalhes do Estorno\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MyhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-div"},[_c('router-view'),_vm._v(" "),(_vm.isLoading)?_c('loading'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N6hl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__("5dBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masker__ = __webpack_require__("7VWg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
    metaInfo: {
        htmlAttrs: {
            lang: 'pt-br'
        },
        bodyAttrs: {
            class: 'solicita-emprestimo'
        }
    },
    data: function data() {
        return {
            lpUrl: "https://iouu.com.br",
            faturamento: localStorage.getItem('fat') ? localStorage.getItem('fat').toLocaleString('pr-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }) : '',
            value: localStorage.getItem('loansValue') ? localStorage.getItem('loansValue').replace('.', ',').toLocaleString('pr-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }) : '',
            prazo: localStorage.getItem('n') ? parseInt(localStorage.getItem('n')) : '',
            motivo: '',
            phone: '',
            garantia: '',
            document: '',
            restricao: '',
            garantiaDetalhe: '',
            garantiaOutros: '',
            motivoDetalhe: '',
            aceite: false,
            acordos: false,
            type: this.$route.query.type,
            user: null,
            finishedLoading: false,
            hasLoan: null,
            prazos: [{
                value: 6,
                label: '6 meses'
            }, {
                value: 12,
                label: '12 meses'
            }, {
                value: 24,
                label: '24 meses'
            }, {
                value: 30,
                label: '30 meses'
            }, {
                value: 36,
                label: '36 meses'
            }],
            temGarantia: [{
                value: 'sim',
                label: 'Sim'
            }, {
                value: 'nao',
                label: 'Não'
            }],
            temRestricao: [{
                value: 'sim',
                label: 'Sim'
            }, {
                value: 'nao',
                label: 'Não'
            }],
            garantias: [{
                value: 'Imóveis',
                label: 'Imóveis'
            }, {
                value: 'Recebíveis',
                label: 'Recebíveis'
            }, {
                value: 'Veículos',
                label: 'Veículos'
            }, {
                value: 'Máquinas',
                label: 'Máquinas'
            }, {
                value: 'Equipamentos',
                label: 'Equipamentos'
            }, {
                value: 'Outros',
                label: 'Outros'
            }],
            motivoEmp: [{
                value: 'Expansão da empresa'
            }, {
                value: 'Capital de Giro'
            }, {
                value: 'Compra de estoque'
            }, {
                value: 'Refinanciamento de dívida'
            }, {
                value: 'Aquisição de máquinas e equipamentos'
            }, {
                value: 'Outros'
            }]

        };
    },

    computed: {
        firstName: function firstName() {
            if (this.user.name) {
                return this.getFirstName(this.user.name);
            } else {
                return this.getFirstName(this.user.username);
            }
        },
        name: function name() {
            var n = void 0;

            if (this.user.name) {
                n = this.user.name;
            } else {
                n = this.user.username;
            }

            return n;
        },
        email: function email() {
            return this.user.email;
        }
    },
    methods: {
        getFirstName: function getFirstName(name) {
            var firstName = name.split(" ");

            return firstName[0];
        },
        isValid: function isValid() {
            return this.name != '' && this.document != '' && this.motivo != '' && this.garantia != '' && this.restricao != '' && this.value != '' && this.faturamento != '';
        },
        isValidMotivo: function isValidMotivo() {
            if (this.motivo === "Outros") {
                return this.motivoDetalhe != '';
            } else {
                return true;
            }
        },
        isValidGarantia: function isValidGarantia() {
            if (this.garantia === "sim") {
                return this.garantiaDetalhe != '';
            } else {
                return true;
            }
        },
        isValidGarantiaOutros: function isValidGarantiaOutros() {
            if (this.garantiaDetalhe === "Outros" && this.garantia === 'sim') {
                return this.garantiaOutros != '';
            } else {
                return true;
            }
        },
        validarCNPJ: function validarCNPJ(cnpj) {
            cnpj = cnpj.replace(/[^\d]+/g, '');

            if (cnpj == '') return false;

            if (cnpj.length != 14) return false;

            // Elimina CNPJs invalidos conhecidos
            if (cnpj == "00000000000000" || cnpj == "11111111111111" || cnpj == "22222222222222" || cnpj == "33333333333333" || cnpj == "44444444444444" || cnpj == "55555555555555" || cnpj == "66666666666666" || cnpj == "77777777777777" || cnpj == "88888888888888" || cnpj == "99999999999999") return false;

            // Valida DVs
            var tamanho = cnpj.length - 2;
            var numeros = cnpj.substring(0, tamanho);
            var digitos = cnpj.substring(tamanho);
            var soma = 0;
            var pos = tamanho - 7;
            for (var i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) pos = 9;
            }
            var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0)) return false;

            tamanho = tamanho + 1;
            numeros = cnpj.substring(0, tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (var _i = tamanho; _i >= 1; _i--) {
                soma += numeros.charAt(tamanho - _i) * pos--;
                if (pos < 2) pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1)) return false;

            return true;
        },
        formatReal: function formatReal(num) {
            var real = void 0;
            real = parseFloat(num.replace(/[^\d]+/g, '')) / 100;
            return real;
        },
        verifyLastLoan: function verifyLastLoan(date) {
            var today = new Date();
            var timeStampToday = Math.round(today.getTime() / 1000);
            var h = today.getHours();
            var m = today.getMinutes();
            var s = today.getSeconds();
            var arrayDate = __WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].maskIsoDate(date).split('/');
            var objDate = new Date(arrayDate[2], arrayDate[1] - 1, arrayDate[0], h, m, s);
            var timeStampDate = Math.round(objDate.getTime() / 1000);
            var hours = (timeStampToday - timeStampDate) / 3600;
            var days = parseInt(hours / 24);
            var month = parseInt(days / 30);

            if (month >= 3) {
                return true;
            } else {
                return false;
            }
        },
        typeLoan: function typeLoan(type) {
            var tipo = void 0;

            switch (type) {
                case 'EMPPES':
                    tipo = 'emprestimo-pessoal';
                    break;

                case 'EMPVEI':
                    tipo = 'emprestimo-veicular';
                    break;

                case 'EMIMB':
                    tipo = 'emprestimo-imobiliario';
                    break;

                case 'EMPIMP':
                    tipo = 'emprestimo-de-impacto';
                    break;

                //Novo impacto - semelhante ao coletivo
                case 'EMPIMP2':
                    tipo = 'emprestimo-de-impacto2';
                    break;

                //Novo Social, semelhante ao impacto antigo
                case 'EMPSOC':
                    tipo = 'emprestimo-social';
                    break;

                default:
                    tipo = 'emprestimo-coletivo';
                    break;
            }

            return tipo;
        },
        onSubmit: function onSubmit(e) {
            var _this = this;

            e.preventDefault();
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["c" /* START_LOADING */]);
            if (!this.validarCNPJ(__WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].unmaskCnpj(this.document))) {
                console.log("CNPJ inválido!");
                this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
                this.$Notify.error('CNPJ inválido! Por favor, digite um CNPJ válido.');
            } else {
                __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getLoansByDocuments(__WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].unmaskCnpj(this.document), this.typeLoan(this.type)).then(function (response) {
                    _this.hasLoan = response;

                    //Verifica se existe solicitações com o CNPJ informado
                    if (response.data.length > 0) {
                        //Se existir Verifica de a última feita já está encerrada
                        if (_this.hasLoan.data[0].StatusAnalise !== "ENCERRADO" && _this.hasLoan.data.length > 0) {
                            console.log("Solicitação ja existe");
                            var verify = _this.verifyLastLoan(_this.hasLoan.data[0].Created);
                            if (!verify) {
                                console.log("resp3");
                                _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                _this.$Notify.error('Esté CNPJ já possui uma solicitação anterior inferior a 3 meses');
                            } else {
                                // console.log("Criar SOlicitação")
                                _this.postLoan();
                            }
                        } else {
                            // console.log("Criar Solicitação")
                            _this.postLoan();
                        }
                    } else {
                        // console.log("Criar Solicitação")
                        _this.postLoan();
                    }
                });
            }
        },
        postLoan: function postLoan() {
            var _this2 = this;

            var data = {
                'Nome': this.name,
                'Email': this.email,
                'Documento': __WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].unmaskCnpj(this.document),
                'Restricao': this.restricao,
                'Garantia': this.garantia,
                'TipoGarantia': this.garantiaDetalhe === 'Outros' ? this.garantiaOutros : this.garantiaDetalhe,
                'Valor': this.formatReal(this.value),
                'Prazo': parseInt(this.prazo),
                'Motivo': this.motivo === 'Outros' ? this.motivoDetalhe : this.motivo,
                'tipoEmprestimo': this.typeLoan(this.type),
                'CodProduto': this.type,
                'Faturamento': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.faturamento),
                'Status': 'LIZA'
            };

            console.log("resp6");

            if (data.Valor <= 1000) {
                console.log("resp7");
                this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
                this.$Notify.error('O valor do emprestimo deve ser superior a R$ 1.000,00');
            } else {
                __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].createLoans(data).then(function (response) {

                    console.log(response);

                    if (response.status !== 200) {
                        console.log("resp8");
                        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
                        _this2.$Notify.error('Ocorreu um erro inesperado tente novamente!');
                    } else {
                        console.log("resp9");
                        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
                        window.location = "https://liza-app.iouu.com.br" + '/espera.html?' + _this2.typeLoan(_this2.type) + '|' + response.data.Msg;
                    }
                });
            }
        }
    },
    beforeCreate: function beforeCreate() {
        var _this3 = this;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["c" /* START_LOADING */]);

        __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getUser().then(function (response) {
            _this3.user = response;

            _this3.finishedLoading = true;

            _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
        }).catch(function () {
            _this3.finishedLoading = true;
            _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    }
});

/***/ }),

/***/ "N8Y7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caixa-campo-arquivo text-center",on:{"click":_vm.openFilesDialog}},[_c('input',{ref:"fileField",staticClass:"campo-arquivo",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.onFileChange}}),_vm._v(" "),(_vm.showPreview)?_c('div',[_c('span',{staticClass:"icon icon-file"}),_vm._v(" "),_c('a',{attrs:{"href":_vm.file.UrlTemporario}},[_vm._v(_vm._s(_vm.file.MetaDados.NomeArquivo))]),_vm._v(" "),_c('a',{staticClass:"icon icon-x-circle",on:{"click":function($event){return _vm.$emit('file-cleared')}}})]):_c('div',[_c('span',{staticClass:"icon icon-upload"}),_vm._v(" "),_c('span',{staticClass:"txt"},[_vm._v("Enviar arquivo")]),_vm._v(" "),_c('at-progress',{attrs:{"percent":_vm.progress}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NAvN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatisticsPlatform_vue__ = __webpack_require__("A9uG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a972335_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatisticsPlatform_vue__ = __webpack_require__("RQlP");
function injectStyle (ssrContext) {
  __webpack_require__("NdEU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a972335"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatisticsPlatform_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a972335_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatisticsPlatform_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_browser__ = __webpack_require__("AHhf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_tracing__ = __webpack_require__("D3zA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__("LmM6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_meta__ = __webpack_require__("p3jY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_at_ui__ = __webpack_require__("yweG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_at_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_at_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_at_ui_style__ = __webpack_require__("KF9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_at_ui_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_at_ui_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_datetime__ = __webpack_require__("QEVx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_datetime_dist_vue_datetime_css__ = __webpack_require__("suTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_styles_base_base_scss__ = __webpack_require__("PmR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_styles_base_base_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_styles_base_base_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_fonts_fontawesome_web_css_fontawesome_all_min_css__ = __webpack_require__("Y8LY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_fonts_fontawesome_web_css_fontawesome_all_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_fonts_fontawesome_web_css_fontawesome_all_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_fonts_font_iouu_css__ = __webpack_require__("aC0Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_fonts_font_iouu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_fonts_font_iouu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_css_bootstrap_min_css__ = __webpack_require__("a0pE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_css_animate_min_css__ = __webpack_require__("AFB7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_css_loaders_min_css__ = __webpack_require__("GYzd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_css_loaders_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_css_loaders_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_styles_iouu_skin_scss__ = __webpack_require__("uxLS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_styles_iouu_skin_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_styles_iouu_skin_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_analytics__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_meta___default.a);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_at_ui___default.a);

// Date time plugin


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_datetime___default.a);











__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_analytics___default.a, {
  id: "UA-84567200-1"
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
var DashboardPlugins = {
  install: function install(Vue) {
    Vue.prototype.$config = {
      investment: {
        minPercentToQueue: 100
      },
      googleApi: {
        googleMapsKey: "AIzaSyC9YU8ifbsf9Ta6ZmpsVwIJfcXqKj4t_M8"
      }
    };
    var originalNotify = Vue.prototype.$Notify;
    var notificationTypes = ["success", "error", "warning", "info"];
    Vue.prototype.$Notify = {};

    notificationTypes.forEach(function (notificationType) {
      Vue.prototype.$Notify[notificationType] = function (methodOptions) {
        var overridedOptions = typeof methodOptions == "string" ? { message: methodOptions } : methodOptions;
        overridedOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ duration: 5000 }, overridedOptions);
        originalNotify[notificationType](overridedOptions);
      };
    });
  }
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(DashboardPlugins);

if (true) {
  __WEBPACK_IMPORTED_MODULE_2__sentry_browser__["a" /* init */]({
    Vue: __WEBPACK_IMPORTED_MODULE_1_vue__["default"],
    dsn: "https://ed8982bade3d4868bb84d23e9547064e@o493101.ingest.sentry.io/5561553",
    autoSessionTracking: true,
    integrations: [new __WEBPACK_IMPORTED_MODULE_3__sentry_tracing__["a" /* Integrations */].BrowserTracing()],
    environment: "production",

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0
  });
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
});

/***/ }),

/***/ "NaGo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Nalz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__container"},[_c('div',{staticClass:"company"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"p-relative p-r-60 p-575-r-70",class:'rating-'+ _vm.caixaBaixa(_vm.solicitacao.Score)},[(_vm.solicitacao.Garantia == 'Sim')?_c('img',{staticClass:"selo-garantia-bndes",attrs:{"src":"/static/assets/images/selo-garantia.png","title":"Oportunidade com garantia pelo tomador e indicada pelo canal BNDES"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"header__title rating"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.solicitacao.Empresa.NomeFantasia)+"\n\t\t\t\t\t\t"),_c('span',{staticClass:"header__title__bullet bullet"}),_vm._v(" "),_c('span',{staticClass:"header__title__score score"},[_vm._v(_vm._s(_vm.solicitacao.Score))])])]),_vm._v(" "),_c('div',[_c('small',{staticClass:"header__id"},[_c('strong',[_vm._v("\n\t\t\t\t\t\t\tID#"+_vm._s(_vm.ajustIdOportunidade(_vm.solicitacao.IdOportunidade,5))+"\n\t\t\t\t\t\t")]),_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.formatarTipoEmprestimo(_vm.solicitacao.TipoEmprestimo))+"\n\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"header__box"},[_c('div',{staticClass:"header__box__info"},[_c('span',[_vm._v("Cidade/UF: "),_c('span',{staticClass:"header__box__value"},[_vm._v(_vm._s(_vm.cidadeUf(_vm.solicitacao.Empresa.Endereco)))])])]),_vm._v(" "),_c('div',{staticClass:"header__box__info"},[_c('span',[_c('img',{attrs:{"src":"/static/assets/images/ico_investidores.svg","alt":"Icone investidor"}}),_vm._v(" "),_c('span',{staticClass:"header__box__value"},[_vm._v(_vm._s(_vm.solicitacao.QuantidadeReservasInvestimento)+" Investidores")])])])])]),_vm._v(" "),_c('Simulation',{attrs:{"valor":_vm.valor,"solicitacao":_vm.solicitacao}})],1),_vm._v(" "),_c('div',{staticClass:"investment"},[_c('div',{staticClass:"btn"},[_c('a',{staticClass:"btn__exit",on:{"click":function($event){return _vm.$emit('close', _vm.alterado)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-8748.215 -19729.99 17.204 17.205"}},[_c('g',{attrs:{"id":"Group_284","data-name":"Group 284","transform":"translate(-8748.225 -19730)"}},[_c('line',{staticClass:"cls-1",attrs:{"id":"Line_57","data-name":"Line 57","x1":"15.224","y2":"15.224","transform":"translate(1 1)"}}),_vm._v(" "),_c('line',{staticClass:"cls-1",attrs:{"id":"Line_58","data-name":"Line 58","x1":"15.224","y1":"15.224","transform":"translate(1 1)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('div',{staticClass:"info__values"},[_c('div',[_c('small',[_vm._v("Valor Solicitado")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formataValor(_vm.solicitacao.Valor)))])]),_vm._v(" "),_c('div',[_c('small',[_vm._v("Valor total do empréstimo")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.totalEmprestimos))])])]),_vm._v(" "),_c('div',{staticClass:"info__values"},[_c('div',[_c('small',[_vm._v("Valor da parcela")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formataValor(_vm.solicitacao.ValorParcela)))])]),_vm._v(" "),_c('div',[_c('small',[_vm._v("Duração esperada")]),_vm._v(" "),(_vm.solicitacao.PrazoDias > 1)?_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.solicitacao.PrazoDias)+" dias")]):_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.solicitacao.Prazo)+" meses")])])]),_vm._v(" "),(_vm.verificaProduto(_vm.solicitacao.CodProduto))?_c('div',{staticClass:"info__percentage"},[_c('div',{staticClass:"info__percentage__values"},[_c('div',[_c('small',[_vm._v("Retorno Bruto Anual")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.RetornoBrutoAnual)+"% a.a.")])]),_vm._v(" "),_c('div',[_c('small',[_vm._v("Retorno Bruto Mensal")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.RetornoBrutoMensal)+"% a.m.")])]),_vm._v(" "),_c('div',[_c('small',[_vm._v("Retorno Estimado Anual")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.CDI)+"% CDI")])])]),_vm._v(" "),_vm._m(0)]):_c('div',{staticClass:"info__percentage"},[_c('div',{staticClass:"info__percentage__values"},[(!this.antecipacaoGambiarra)?_c('div',[_c('small',[_vm._v("Retorno Líquido Anual")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.RetornoBrutoAnual)+"% a.a.")])]):_vm._e(),_vm._v(" "),(this.antecipacaoGambiarra)?_c('div',[_c('small',[_vm._v("Retorno Bruto final do período")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.taxaGambiarra)+"%")])]):_c('div',[_c('small',[_vm._v("Retorno Líquido Mensal")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.RetornoBrutoMensal)+"% a.m.")])]),_vm._v(" "),(this.antecipacaoGambiarra)?_c('div',[_c('small',[_vm._v("Retorno Esperado no período")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.CDIGambiarra)+"% CDI")])]):_c('div',[_c('small',[_vm._v("Retorno Estimado Anual")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.CDI)+"% CDI")])])]),_vm._v(" "),(!this.antecipacaoGambiarra)?_c('div',{staticClass:"info__percentage__footer"},[_c('small',[_vm._v("* A taxa de juros acima já é líquida de Imposto de Renda.")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"gathered"},[_c('div',{staticClass:"gathered__header"},[_c('span',[_vm._v("Levantado: "+_vm._s(_vm.formataPorcentagem(_vm.solicitacao.Valor, _vm.solicitacao.ValorCaptado, _vm.solicitacao.ChamadaListaEspera))+"%")]),_vm._v(" "),_c('span',[_vm._v("Faltam:\n\t\t\t\t\t\t"),_c('strong',[_vm._v(_vm._s(_vm.valorRestante(_vm.solicitacao.Valor, _vm.solicitacao.ValorCaptado, _vm.solicitacao.ChamadaListaEspera)))])])]),_vm._v(" "),_c('div',{staticClass:"gathered__bar"},[_c('div',{staticClass:"gathered__bar__progress",style:('width: '+_vm.formataPorcentagem(_vm.solicitacao.Valor, _vm.solicitacao.ValorCaptado, _vm.solicitacao.ChamadaListaEspera)+'%')}),_vm._v(" "),_c('span',{staticClass:"gathered__bar__value"},[_vm._v(_vm._s(_vm.formataPorcentagem(_vm.solicitacao.Valor, _vm.solicitacao.ValorCaptado, _vm.solicitacao.ChamadaListaEspera))+" %")])]),_vm._v(" "),_c('div',{staticClass:"gathered__info"},[_c('span',[_vm._v("Início da captação:\n\t\t\t\t\t\t"),_c('strong',[_vm._v(_vm._s(_vm.formataData(_vm.solicitacao.InicioCaptacao, true)))])]),_vm._v(" "),_c('span',[_vm._v("Expira em:\n\t\t\t\t\t\t"),_c('strong',[_vm._v(_vm._s(_vm.formataData(_vm.solicitacao.FimCaptacao, true)))])])])]),_vm._v(" "),_c('Investment',{attrs:{"solicitacao":_vm.solicitacao,"investidor":_vm.investidor,"usuario":_vm.usuario,"valorInicial":_vm.valorInicial},on:{"updateSolicitacao":function (solicitacao){ return _vm.AtualizaSolicitacao(solicitacao); },"updateValor":function (valor){ return _vm.AtualizaValor(valor); },"close":function (alterado){ return _vm.$emit('close', alterado); }}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info__percentage__footer"},[_c('small',[_vm._v("* A taxa de juros acima é igual ao seu Retorno Bruto "),_c('br'),_vm._v(" (Retorno antes do desconto de IR).")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Navj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NdEU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NfYE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Documento de identidade")]),_vm._v(" "),_c('p',[_vm._v("Envie uma cópia de um dos documentos de identidade "),_c('strong',[_vm._v("(RG ou CNH)")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NtoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_client_go__ = __webpack_require__("879M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SocialNetwork__ = __webpack_require__("TYgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PasswordField__ = __webpack_require__("i7i+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_session_manager__ = __webpack_require__("J7hJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_analytics__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
  data: function data() {
    return {
      lpUrl: "https://iouu.com.br",
      email: '',
      password: '',
      keepLogged: false
      // User: {},
      // TipoUser: '',
      // suitability: '',
      // investidor: '',
      // investimentos: ''
    };
  },

  components: {
    SocialNetwork: __WEBPACK_IMPORTED_MODULE_5__components_SocialNetwork__["a" /* default */], PasswordField: __WEBPACK_IMPORTED_MODULE_7__components_PasswordField__["a" /* default */]
  },
  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    greeting: function greeting() {
      var currentHours = new Date().getHours();
      if (currentHours < 12) {
        return "Bom dia";
      } else if (currentHours < 18) {
        return "Boa tarde";
      } else {
        return "Boa noite";
      }
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:

              _this.fbLoadSDK(document, 'script', 'facebook-jssdk');
              _this.ggLoadSDK(document, 'script', 'google-jssdk');
              setTimeout(function () {
                _this.fbStartServices();
                _this.ggStartServices();
              }, 3000);

              // this.User = this.$store.state.currentUser

              _this.$store.commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types_js__["d" /* STOP_LOADING */]);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    googleLogin: function googleLogin() {

      var scope = this;

      this.$gAuth.signIn().then(function (GoogleUser) {

        scope.$store.dispatch('socialNetworkLogin', {
          provider: 'google',
          receivedData: GoogleUser.Zi.access_token,
          errorMessage: scope.$Notify.error
        });
      }).catch(function (error) {
        console.log('Sign-in error', error);
      });
    },
    fbLoadSDK: function fbLoadSDK(d, s, id) {
      var js,
          fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },
    ggLoadSDK: function ggLoadSDK(d, s, id) {
      var js,
          fjs = document.getElementsByTagName(s)[0];
      if (document.getElementById(id)) return;
      js = document.createElement(s);js.id = id;
      js.src = "https://apis.google.com/js/platform.js?onload=renderButton";
      fjs.parentNode.insertBefore(js, fjs);
    },
    fbStartServices: function fbStartServices() {
      FB.init({
        appId: '144107022958731',
        cookie: true,
        xfbml: true,
        version: 'v4.0'
      });
    },
    ggStartServices: function ggStartServices() {
      var scope = this;
      gapi.load('auth2', function () {
        gapi.auth2.init({
          client_id: '765138997021-b6kbuu7rdc6im5f75d3qjasjsfrq2tep.apps.googleusercontent.com',
          cookiepolicy: 'single_host_origin',
          scope: 'profile'
        }).attachClickHandler(document.getElementById('gg-signin-button'), {}, function (googleUser) {
          scope.$store.dispatch('socialNetworkLogin', { provider: 'google', receivedData: googleUser.getAuthResponse().id_token, errorMessage: scope.$Notify.error });
        }, function (error) {
          console.log('Sign-in error', error);
        });
      });
    },
    facebookLogin: function facebookLogin(e) {
      e.preventDefault();
      var scope = this;
      FB.login(function (response) {
        if (response.status === 'connected') {
          scope.$store.dispatch('socialNetworkLogin', { provider: 'facebook', receivedData: response.authResponse.accessToken, errorMessage: scope.$Notify.error });
        } else {
          console.log("Não Loggado");
        }
      }, { scope: 'public_profile,email' });
    },
    login: function login() {
      var _this2 = this;

      this.email = this.email.toLowerCase().trim();

      this.$store.dispatch('login', { email: this.email, password: this.password, keepLogged: this.keepLogged }).then(function (resp) {
        var urlParams = '';
        // var now = new Date();
        sessionStorage.removeItem("redirectINV");

        _this2.$ga.set({ userId: _this2.email });

        for (var key in _this2.$route.query) {
          if (_this2.$route.query.hasOwnProperty(key)) {
            if (key == "redirected_from") urlParams = _this2.$route.query[key];else urlParams = urlParams + "&" + key + "=" + _this2.$route.query[key];
          }
        }

        if (_this2.$route.query.loansId !== undefined && _this2.$route.query.loansId !== "" && _this2.$route.query.loadnId !== null) {
          _this2.$router.push('/informacoes-adicionais/emprestimo-coletivo/' + _this2.$route.query.loansId);
        } else if (urlParams != '') {
          _this2.$router.push(urlParams);
        } else {
          _this2.$router.push("/");
        }
      }).catch(function (error) {
        if (error.response.data.Msg) {
          _this2.$Notify.error(error.response.data.Msg);
        } else {
          _this2.$Notify.error("Tivemos um erro inesperado, tente novamente mais tarde");
          // const errorMessages = error.response.data.errors.map(error => error.detail)
          // this.$Notify.error(ArrayHelper.toSentence(errorMessages))
        }
      });
    },
    verifyIE11: function verifyIE11() {
      return !window.ActiveXObject && "ActiveXObject" in window;
    },

    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/login',
        title: 'Login'
      });
    }
  }
}, 'created', function created() {
  var _this3 = this;

  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this3.taggingGA();

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this3);
  }))();
}));

/***/ }),

/***/ "NxGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__("8taH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00db97f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__("/kg9");
function injectStyle (ssrContext) {
  __webpack_require__("Z5hq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00db97f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00db97f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O2Lg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O2ge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types_js__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lpUrl: "https://iouu.com.br"
    };
  },

  methods: {
    Logout: function Logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    Home: function Home() {
      sessionStorage.removeItem("redirectINV");
      this.$router.push('/emprestimos/meus-emprestimos');
    }
  }, beforeCreate: function beforeCreate() {

    window.document.title = 'Dashboard IOUU';
  }
});

/***/ }),

/***/ "O63G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_hub_consulta_client_js__ = __webpack_require__("pk4i");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/*eslint-disable*/
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      transitionName: 'slide-left',
      investor: null,
      render: true,
      renderLoad: true,
      renderSuccess: false,
      renderDanger: false,
      renderDenied: false,
      name: '',
      email: '',
      loansId: '',
      url: '',
      hasAccount: false
    };
  },

  methods: {
    callLead: function callLead() {
      var _this = this;

      // Teste query serasa
      //?event=PROPOSAL_ACCEPTED&authenticationCode=5a380375e0fce-1513620400554-tgdmt5xz3zh-B0569A7929900C999063641BC8E9176C

      if (this.$route.query.authenticationCode !== "" && this.$route.query.authenticationCode !== undefined && this.$route.query.authenticationCode !== null) {
        __WEBPACK_IMPORTED_MODULE_2__utils_hub_consulta_client_js__["a" /* default */].LeadSerasa(this.$route.query.authenticationCode).then(function (response) {
          if (response !== undefined && response !== null && response.data !== "" && response.data.Msg !== "possui solicitacao") {
            console.log(response.data);
            _this.email = response.data.Email;
            _this.name = response.data.Nome;
            _this.loansId = response.data.SolicitacaoID;
            _this.hasUser(_this.email);
            _this.Success();
          } else if (response !== undefined && response.data.Msg === "possui solicitacao") {
            _this.Denied();
          } else {
            _this.Danger();
          }
        }).catch(function (error) {
          console.log(error);
          _this.Danger();
        });
      } else {
        this.Danger();
      }
    },
    hasUser: function hasUser(email) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__utils_hub_consulta_client_js__["a" /* default */].ExisteUsuario(this.email).then(function (resp) {
        if (resp.Msg === "Existe") {
          _this2.hasAccount = true;
        }
      });
    },
    Success: function Success() {
      this.render = true;
      this.renderLoad = false;
      this.renderSuccess = true;
    },
    Danger: function Danger() {
      this.render = true;
      this.renderLoad = false;
      this.renderDanger = true;
    },
    Denied: function Denied() {
      this.render = true;
      this.renderLoad = false;
      this.renderDenied = true;
    },


    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/call/serasa/ ',
        title: 'Lead Confirm'
      });
    }
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this3.callLead();

              //tagueamento GA
              _context.next = 3;
              return _this3.taggingGA();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),

/***/ "O6j8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      regimeTributario: this.solicitacao.Empresa.RegimeTributario
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var regimeTributario = this.regimeTributario;
      var newData = { Empresa: { RegimeTributario: regimeTributario } };

      this.$emit('on-submit', newData);
    }
  }
});

/***/ }),

/***/ "O9NW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transferencia_vue__ = __webpack_require__("as+3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_572b5f95_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transferencia_vue__ = __webpack_require__("JmiU");
function injectStyle (ssrContext) {
  __webpack_require__("J7Vl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-572b5f95"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transferencia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_572b5f95_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transferencia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OAMV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Foto de Identificação")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OANR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_array_helper__ = __webpack_require__("rzJh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            emprestimos: null,
            emprestimosEmBreve: false,
            investimentos: '',
            suitability: '',
            investidor: ''
        };
    },

    methods: {
        AjustaLink: function AjustaLink(item) {
            if (item.TipoEmprestimo == "emprestimo-de-impacto2") {
                return "/informacoes-adicionais/emprestimo-coletivo/" + item._id;
            }

            return "/informacoes-adicionais/" + item.TipoEmprestimo + "/" + item._id;
        },
        AjustaData: function AjustaData(date) {
            return new Date(date).toLocaleDateString('pt-BR');
        },
        AjustaStatus: function AjustaStatus(item) {
            if (item.TipoEmprestimo.indexOf("coletivo") > 0 || item.TipoEmprestimo.indexOf("impacto2") > 0 || item.TipoEmprestimo.indexOf("social") > 0) {
                if (item.Status == "finished" && (item.StatusAnalise == undefined || item.StatusAnalise == "")) {
                    return "Processando";
                }

                if (item.StatusAnalise != null && item.StatusAnalise != undefined && item.StatusAnalise != "") {
                    return item.StatusAnalise.substring(0, 1) + item.StatusAnalise.toLowerCase().substring(1).replace("_", "");
                }

                if (item.Status == "NEGADO") {
                    return item.Status.substring(0, 1) + item.Status.toLowerCase().substring(1).replace("_", "");
                }

                return "Incompleto";
            } else {
                if (item.TipoEmprestimo.indexOf("pessoal") > 0) {
                    if (item.Status == "finished" && (item.StatusAnalise == undefined || item.StatusAnalise == "")) {
                        return "Processando";
                    }

                    if (item.StatusAnalise == "NOVERDE") {
                        return "Processando";
                    }

                    if (item.StatusAnalise != undefined && item.StatusAnalise != "") {
                        return item.StatusAnalise.substring(0, 1) + item.StatusAnalise.toLowerCase().substring(1).replace("_", "");
                    }

                    return "Incompleto";
                } else if (item.TipoEmprestimo.indexOf("impacto") > 0 || item.TipoEmprestimo.indexOf("social") > 0) {
                    if (item.Status == "finished" && (item.StatusAnalise == undefined || item.StatusAnalise == "")) {
                        return "Processando";
                    }

                    if (item.StatusAnalise != undefined && item.StatusAnalise != "") {
                        return item.StatusAnalise.substring(0, 1) + item.StatusAnalise.toLowerCase().substring(1).replace("_", "");
                    }

                    return "Processando";
                } else {
                    return "Processando";
                }
            }
        },
        formatted: function formatted(doc) {
            doc = doc.replace(/\D/g, '');

            if (doc.length > 12) return __WEBPACK_IMPORTED_MODULE_5__utils_masker__["a" /* default */].maskCnpj(doc);

            return __WEBPACK_IMPORTED_MODULE_5__utils_masker__["a" /* default */].maskCpf(doc);
        },
        Nome: function Nome(item) {

            var nome = item.Nome != null ? item.Nome.trim() : "";
            if (nome.indexOf(" ") != -1) {
                nome = nome.split(" ")[0];
                return nome.substring(0, 1).toUpperCase() + nome.substring(1);
            }

            return nome.substring(0, 1).toUpperCase() + nome.substring(1);
        },
        formatarTipoEmprestimo: function formatarTipoEmprestimo(tipoEmprestimo) {

            if (tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2") {
                return "Impacto";
            }

            tipoEmprestimo = tipoEmprestimo.toLowerCase().replace("-de", "");
            var splitedTipoEmprestimo = tipoEmprestimo.split('-');

            if (tipoEmprestimo.indexOf("emprestimo") > -1) {
                if (splitedTipoEmprestimo.length > 1) {
                    return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
                }

                return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);
            }

            if (splitedTipoEmprestimo.length > 2) {
                return splitedTipoEmprestimo[2][0].toUpperCase() + splitedTipoEmprestimo[2].substr(1) + "-" + splitedTipoEmprestimo[0][0].toUpperCase() + splitedTipoEmprestimo[0].substr(1, 2);
            }
        },
        formatarScore: function formatarScore(score) {

            if (score == null) return "-";

            if (score.length > 1 && !isNaN(score[1])) {
                return score[0];
            }

            return score == "" ? "-" : score;
        },
        money: function money(n) {
            var c = 2,
                d = ",",
                t = ".",
                s = n < 0 ? "-" : "",
                i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        },
        lowerCase: function lowerCase(texto) {
            if (texto == null || texto == undefined || texto == "") return "";

            if (texto == "AA" || texto == "HR") return texto.toLowerCase();

            return texto[0].toLowerCase();
        },
        ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
            var s = String(id);

            if (id == undefined || id == 0) return "";

            while (s.length < (qtd || 2)) {
                s = "0" + s;
            }
            return "#" + s;
        },
        inteiro: function inteiro(n) {
            return parseInt(n = Math.abs(Number(n) || 0).toFixed(2));
        },
        Redirecionar: function Redirecionar(item) {

            /* if(item.TipoEmprestimo == 'emprestimo-coletivo' && AjustaStatus(item) =='Em análise'){
                window.location.href = "#"+  documentos('EMPCOL', item._id)
              }
               if(item.TipoEmprestimo == 'emprestimo-pessoal' && AjustaStatus(item) =='Em análise'){
             
              window.location.href = "#"+  documentos('EMPPES', item._id)
              }
               if(item.TipoEmprestimo == 'emprestimo-coletivo' && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO')){
             
              window.location.href = "#"+   Detalhes('EMPCOL', item._id)
              }
               if(item.TipoEmprestimo == 'emprestimo-de-impacto' && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO')){
                 
                  window.location.href = "#"+   Detalhes('EMPIMP', item._id)
              }
               if(item.TipoEmprestimo == 'emprestimo-ccb' && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO')){
                  
                  window.location.href = "#"+  Detalhes('EMPCCB', item._id)
              }*/

        },
        documentos: function documentos(type, id) {
            return "/emprestimos/pre-aprovado?type=" + type + "&id=" + id;
        },
        DocumentosFaltantes: function DocumentosFaltantes(type, id) {
            return "/emprestimos/documentos?type=" + type + "&id=" + id;
        },
        Detalhes: function Detalhes(type, id) {
            return "/emprestimos/detalhes-do-emprestimo?type=" + type + "&id=" + id;
        },
        AssinaturaCCB: function AssinaturaCCB(id) {
            return "/emprestimos/formalizar-ccb/" + id;
        },


        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/emprestimos/meus-emprestimos',
                title: 'Meus Emprestimos'
            });
        }
    },
    computed: {
        User: function User() {
            return this.$store.state.currentUser;
        }
    },
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            if (_this.User.tipo.length > 1) {
                                _this.TipoUser = 'Investidor e Tomador';
                            } else if (_this.User.tipo[0] === 'INV') {
                                _this.TipoUser = 'Investidor';
                            } else {
                                _this.TipoUser = 'Tomador';
                            }

                            _this.User.hassuitability === true ? _this.suitability = 'Verdadeiro' : _this.suitability = 'Falso';
                            _this.User.hasinvestor === true ? _this.investidor = 'Verdadeiro' : _this.investidor = 'Falso';
                            _this.User.hasinvestments === true ? _this.investimentos = 'Verdadeiro' : _this.investimentos = 'Falso';

                            mixpanel.people.set({
                                'USER_ID': _this.User._id,
                                'email': _this.User.email,
                                'name': _this.User.name,
                                'Tipo': _this.TipoUser,
                                'TipoInvestidor': _this.User.suitability.Tipo,
                                'PreencheuSuitability': _this.suitability,
                                'Investidor': _this.investidor,
                                'TemInvestimentos': _this.investimentos
                            });

                            //tagueamento GA
                            _context.next = 7;
                            return _this.taggingGA();

                        case 7:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    components: { Modal: __WEBPACK_IMPORTED_MODULE_2__components_Modal__["a" /* default */] },
    beforeCreate: function beforeCreate() {
        var _this2 = this;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["c" /* START_LOADING */]);

        __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getMeusEmprestimos().then(function (emprestimos) {
            _this2.emprestimos = emprestimos;
            var hasAnalisys = false;
            var idAnalisys = void 0;
            if (_this2.emprestimos == null || _this2.emprestimos.length == 0) {

                _this2.emprestimosEmBreve = true;
            }
            window.emprestimo = _this2.emprestimos;

            _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
        }).catch(function () {
            return _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    }
});

/***/ }),

/***/ "OFhL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"EstadoCivil"}},[_vm._v("\n          Estado Civil\n          ")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","placeholder":"Selecione..."},model:{value:(_vm.currentUser.Social.EstadoCivil),callback:function ($$v) {_vm.$set(_vm.currentUser.Social, "EstadoCivil", $$v)},expression:"currentUser.Social.EstadoCivil"}},_vm._l((_vm.optionsMarital),function(marital,index){return _c('at-option',{key:("maritalOptions" + index),attrs:{"value":marital.value}},[_vm._v(_vm._s(marital.label))])}),1)],1),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Estado Civil")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OOMu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid login"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"ico-iouu",attrs:{"href":_vm.lpUrl,"target":"_blank","title":"IOUU"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('social-network')],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-7 d-flex flex-column form"},[_c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-5 text-center"},[_c('h2',[_vm._v("Nova senha")]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Cadastre sua senha")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.setNewPassword($event)}}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Nova senha")]),_vm._v(" "),_c('password-field',{model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Cadastrar senha")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-lg-10 d-flex flex-column align-items-center"},[_c('h1',[_vm._v("Cadastrar nova senha")]),_vm._v(" "),_c('p',[_vm._v("\n            Não se preocupe. Você não está assumindo nenhum compromisso neste momento.\n            "),_c('br'),_vm._v("Suas informações serão usadas apenas para analisarmos o seu perfil\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OORf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioBalancoDrePasso_vue__ = __webpack_require__("ijyF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_905a1658_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioBalancoDrePasso_vue__ = __webpack_require__("uLuI");
function injectStyle (ssrContext) {
  __webpack_require__("FZfk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-905a1658"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioBalancoDrePasso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_905a1658_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioBalancoDrePasso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OQDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Simulation_vue__ = __webpack_require__("xOzg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7704ddc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Simulation_vue__ = __webpack_require__("jv9o");
function injectStyle (ssrContext) {
  __webpack_require__("TNSU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7704ddc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Simulation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7704ddc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Simulation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OUpg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankDataStep_vue__ = __webpack_require__("UqtQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bed88ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankDataStep_vue__ = __webpack_require__("Vtov");
function injectStyle (ssrContext) {
  __webpack_require__("5RJK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3bed88ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankDataStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bed88ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankDataStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OV8Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__ = __webpack_require__("Du/2");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            investidores: {},
            /* eslint-disable */
            hubEndPoint: "https://hub-app.iouu.com.br",
            siteEndPoint: "https://iouu.com.br",
            url: '/static/termos/',
            docLinks: [{
                "name": "Termos e condições gerais de uso",
                "link": "Termos_e_Condicoes.pdf"
            }, {
                "name": "Políticas de privacidade",
                "link": "Politica_de_Privacidade.pdf"
            }]
        };
    },

    methods: {
        formatDate: function formatDate(data) {
            var dataForm = new Date(data);
            var dia = dataForm.getDate();
            if (dia.toString().length == 1) dia = "0" + dia;
            var mes = dataForm.getMonth() + 1;
            if (mes.toString().length == 1) mes = "0" + mes;
            var ano = dataForm.getFullYear();
            return dia + "/" + mes + "/" + ano;
        },
        documentos: function documentos() {
            this.$router.push('../documentos?type=INV&id=' + this.$store.state.currentUser.investor._id);
        },
        mostraDocsEnviados: function mostraDocsEnviados() {

            return (this.investidores.Dre != undefined && this.investidores.Dre.length > 0 || this.investidores.ContratoSocial != undefined && this.investidores.ContratoSocial.length > 0 || this.investidores.ImpostoRenda != undefined && this.investidores.ImpostoRenda.length > 0 || this.investidores.ExtratoBancario != undefined && this.investidores.ExtratoBancario.length > 0 || this.investidores.ArquivosComprovanteResidencia != undefined && this.investidores.ArquivosComprovanteResidencia.length > 0 || this.investidores.ArquivosIdentidade != undefined && this.investidores.ArquivosIdentidade.length > 0) && this.investidores.StatusDocumentos != "APROVADO";
        },
        removerArquivosInvisiveis: function removerArquivosInvisiveis(itens) {
            var retorno;
            if (Array.isArray(itens)) {
                retorno = itens.filter(function (item) {
                    return item.Exibir != false;
                });

                return retorno;
            }

            return {};
        },
        nomeArquivo: function nomeArquivo(arquivo) {
            if (arquivo.length > 22) {
                var extensao = arquivo.substr(arquivo.lastIndexOf("."));
                var nome = arquivo.substr(0, arquivo.lastIndexOf("."));

                return nome.substr(0, 15) + "..." + extensao;
            }

            return arquivo;
        },


        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: 'perfil/documentos',
                title: 'Documentos'
            });
        }
    },
    beforeCreate: function beforeCreate() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["c" /* START_LOADING */]);
                            _context.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getInvestor().then(function (investor) {
                                _this.investidores = investor;

                                _this.investidores.Dre = _this.investidores.Dre || {};

                                _this.investidores.ContratoSocial = _this.removerArquivosInvisiveis(_this.investidores.ContratoSocial);
                                _this.investidores.ImpostoRenda = _this.removerArquivosInvisiveis(_this.investidores.ImpostoRenda);
                                _this.investidores.ExtratoBancario = _this.removerArquivosInvisiveis(_this.investidores.ExtratoBancario);
                                _this.investidores.ArquivosComprovanteResidencia = _this.removerArquivosInvisiveis(_this.investidores.ArquivosComprovanteResidencia);
                                _this.investidores.ArquivosIdentidade = _this.removerArquivosInvisiveis(_this.investidores.ArquivosIdentidade);

                                _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            }).catch(function () {
                                return _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            });

                        case 3:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _this2.taggingGA();

                        case 2:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    }
});

/***/ }),

/***/ "ObKo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    var social = this.currentUser.Social;
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: social.ArquivoComprovanteEndereco || [null]
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.arquivos.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.arquivos, index, null);
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do comprovande de endereço é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {

        this.currentUser.Social.ArquivoComprovanteEndereco = this.arquivosRecebidos;

        this.$emit('on-submit', { Social: this.currentUser.Social });
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "OjIE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ojov":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgdmlld0JveD0iMCAwIDYwIDYwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTtzdHJva2U6I2NjYztzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93LWxlZnQ8L3RpdGxlPjxwb2x5bGluZSBjbGFzcz0iY2xzLTEiIHBvaW50cz0iNDUgNTkgMTUgMzAgNDUgMSIvPjwvc3ZnPg=="

/***/ }),

/***/ "OkiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CriarConta_vue__ = __webpack_require__("anEX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0def148b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CriarConta_vue__ = __webpack_require__("HNV6");
function injectStyle (ssrContext) {
  __webpack_require__("9SNY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0def148b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CriarConta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0def148b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CriarConta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OrXT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllTickets_vue__ = __webpack_require__("Fm9E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf34eeba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllTickets_vue__ = __webpack_require__("luJi");
function injectStyle (ssrContext) {
  __webpack_require__("xMmZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cf34eeba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllTickets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf34eeba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllTickets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Oz9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      progress: 0
    };
  },

  props: {
    accept: { required: false, type: String },
    uploadEndpoint: { required: true, type: String },
    file: { type: Object }
  },
  computed: {
    showPreview: function showPreview() {
      return this.file != null && this.file !== undefined;
    }
  },
  methods: {
    openFilesDialog: function openFilesDialog(e) {
      if (e.target.classList.contains('botao-remover')) return e.stopPropagation();

      this.$refs.fileField.click();
    },
    onFileChange: function onFileChange(e) {
      var _this = this;

      var file = e.target.files[0];
      var formData = new FormData();
      formData.append("file", file);
      var dataAtual = new Date();

      return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: this.uploadEndpoint,
        method: 'POST',
        data: formData,
        onUploadProgress: function onUploadProgress(progressEvent) {
          if (file === undefined) {
            _this.progress = 0;
          } else {
            _this.progress = Math.round(progressEvent.loaded * 100 / progressEvent.total);
          }
        }
      }).then(function (response) {
        var formattedFile = {
          Nome: response.data.name,
          UrlTemporario: response.data.tempUrl,
          DataEnvio: dataAtual,
          MetaDados: {
            UltimaModificacao: dataAtual,
            DataUltimaModificacao: dataAtual,
            NomeArquivo: file.name,
            Tamanho: file.size,
            Tipo: file.type
          },
          Share: response.data.share,
          Directory: response.data.directory
        };
        _this.$emit('uploaded', formattedFile, response);
        _this.progress = 0;
      });
    }
  }
});

/***/ }),

/***/ "P/F8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',[_c('div',{staticClass:"form-group"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Foto de Identificação")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P9Vy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreapprovedDetails_vue__ = __webpack_require__("PlEe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c633646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreapprovedDetails_vue__ = __webpack_require__("rxd5");
function injectStyle (ssrContext) {
  __webpack_require__("KeQ3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c633646"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreapprovedDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c633646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreapprovedDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PGCd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PGe6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"lavContainer",style:(_vm.style)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PIau":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PTxu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__ = __webpack_require__("plnP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59173109_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__ = __webpack_require__("5Tlp");
function injectStyle (ssrContext) {
  __webpack_require__("M+3+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59173109"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59173109_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PW/k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pck/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pdnp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PlEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_api_bndes__ = __webpack_require__("lhu4");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            emprestimo: null,
            id: '',
            concordo: false,
            aceite: null,
            confirmasenha: false,
            sms: false,
            smsToken: '',
            rejeita: false,
            checkmotivo: false,
            prazo: false,
            parcela: false,
            juros: false,
            condicoes: false,
            outros: false,
            motivo: '',
            password: '',
            tentativas: 3,
            status: ''
        };
    },

    methods: {
        ConfirmaSenha: function ConfirmaSenha(e) {
            var _this = this;

            var query = this.$route.query;
            this.id = this.User._id;
            __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].VerificaSenha(this).then(function () {
                //Chama a api para enviar o token sms para o cliente
                __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].post('enviar-token-sms', { data: { SolicitacaoId: _this.emprestimo[0]._id, AttemptNumber: 2, ConfirmaCliente: true } }).then(function () {
                    _this.$Notify.info("SMS enviado com sucesso!");
                    _this.confirmasenha = true;
                    _this.tentativas = 3;
                }).catch(function () {
                    _this.$Notify.error("Erro ao enviar o token SMS! Por favor verificar o número de celular!");
                });
            }).catch(function () {
                //Verificação do password
                _this.password = '';
                _this.tentativas--;
                if (_this.tentativas == 0) {
                    _this.$router.push("/login");
                    _this.$Notify.error("Erro: Você excedeu o número de tentativas limite!");
                }
                if (_this.tentativas != 0) _this.$Notify.error("Erro: Senha Inválida! Tentativas restantes: " + _this.tentativas);
            });
        },
        RecusaEmprestimo: function RecusaEmprestimo(e) {
            var _this2 = this;

            //Função que trata da negação do cliente
            this.checkmotivo = true;
            this.status = "Negado cliente";

            var motivo = "";
            if (this.prazo) motivo = motivo + " Prazo";
            if (this.parcela) motivo = motivo + " Parcela";
            if (this.juros) motivo = motivo + " Juros";
            if (this.condicoes) motivo = motivo + " Parcela";
            if (this.outros) motivo = motivo + " Outros:" + this.motivo;

            var query = this.$route.query;
            __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].atualizaStatus(query.id, this.status, motivo).then(function () {
                //Chama a api para "deletar" a notificação de "solicitação aprovada"
                __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].AlteraStatusNotificacao(_this2.User._id, query.id, "Deletado").then(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                    var resposta;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return __WEBPACK_IMPORTED_MODULE_7__services_api_bndes__["a" /* default */].AtualizaPropostaBndes({ data: { SolicitacaoId: _this2.emprestimo[0]._id, Status: 'CANCELADA' } });

                                case 2:
                                    resposta = _context.sent;


                                    _this2.$Notify.info("Proposta Negada!");

                                case 4:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))).catch(function () {
                    _this2.$Notify.error("Erro ao Negar a Proposta!");
                });
            });
        },
        CheckSms: function CheckSms(e) {
            var _this3 = this;

            //Chama a api para checkar se o token informado é válido
            __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].post('checar-token-sms', { data: { TokenConfirmacao: this.smsToken, SolicitacaoId: this.emprestimo[0]._id } }).then(function () {
                //Fazer a checkagem do Token de sms e então ... -->
                _this3.sms = true;
                _this3.status = "Aprovado cliente";
                var query = _this3.$route.query;
                __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].atualizaStatus(query.id, _this3.status, " ").then(function () {
                    //Chama a api para "deletar" a notificação de "solicitação aprovada"
                    __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].AlteraStatusNotificacao(_this3.id, query.id, "Deletado").then(function () {
                        _this3.$Notify.info("Proposta Aprovada com Sucesso!");
                    });
                });
            }).catch(function () {
                _this3.tentativas--;
                if (_this3.tentativas == 0) {
                    _this3.$router.push("/login");
                    _this3.$Notify.error("Erro: Você excedeu o número de tentativas limite!");
                }
                if (_this3.tentativas != 0) _this3.$Notify.error("Erro: Token Inválido! Tentativas restantes: " + _this3.tentativas);
            });
        },
        Total: function Total(prazo, valor) {
            return prazo * valor;
        },
        VerificaStatus: function VerificaStatus(emprestimo) {
            if (emprestimo.StatusAnalise == "Aprovado cliente") {
                this.sms = true;
                this.aceite = true;
                this.confirmasenha = true;
            } else if (emprestimo.StatusAnalise == "Negado cliente") {
                this.aceite = true;
                this.rejeita = true;
                this.checkmotivo = true;
            }

            return true;
        },
        formatted: function formatted(doc) {
            doc = doc.replace(/\D/g, '');

            if (doc.length > 12) return __WEBPACK_IMPORTED_MODULE_5__utils_masker__["a" /* default */].maskCnpj(doc);

            return __WEBPACK_IMPORTED_MODULE_5__utils_masker__["a" /* default */].maskCpf(doc);
        },
        formatenome: function formatenome(nome) {
            nome = nome != null ? nome.trim() : "";
            if (nome.indexOf(" ") != -1) {
                nome = nome.split(" ")[0];
                return nome.substring(0, 1).toUpperCase() + nome.substring(1);
            }

            return nome.substring(0, 1).toUpperCase() + nome.substring(1);
        },
        formatarScore: function formatarScore(score) {

            if (score == null) return "-";

            if (score.length > 1 && !isNaN(score[1])) {
                return score[0];
            }

            return score == "" ? "-" : score;
        },
        money: function money(n) {
            var c = 2,
                d = ",",
                t = ".",
                s = n < 0 ? "-" : "",
                i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        },
        lowerCase: function lowerCase(texto) {
            if (texto == null || texto == undefined || texto == "") return "";

            if (texto == "AA" || texto == "HR") return texto.toLowerCase();

            return texto[0].toLowerCase();
        },
        ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
            var s = String(id);

            if (id == undefined || id == 0) return "";

            while (s.length < (qtd || 2)) {
                s = "0" + s;
            }
            return "#" + s;
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/emprestimos/pre-aprovado-detalhes',
                title: 'pre-aprovado-detalhes'
            });
        }
    },
    computed: {
        //Retorna os dados do usuário que está acessando em um objeto 'User'
        User: function User() {
            return this.$store.state.currentUser;
        }
    },
    components: { Modal: __WEBPACK_IMPORTED_MODULE_2__components_Modal__["a" /* default */] },
    beforeCreate: function beforeCreate() {
        var _this4 = this;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["c" /* START_LOADING */]);
        var query = this.$route.query;
        //Retorna o empréstimo de acordo com o ID em um objeto 'emprestimo'
        __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].GetMeuEmprestimo(query.id).then(function (response) {
            _this4.emprestimo = response;
            window.emprestimo = _this4.emprestimo;
            _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
        }).catch(function () {
            return _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    },
    created: function created() {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _this5.taggingGA();

                        case 2:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this5);
        }))();
    }
});

/***/ }),

/***/ "PmR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ppvw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center personalLoan-steps"},[(_vm.canGoPrevious)?_c('step-back-button',{on:{"click":this.onPrevious}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c(_vm.currentStepComponent,{tag:"component",staticClass:"form-container",attrs:{"current-user":_vm.currentUser},on:{"on-submit":this.updateUser,"loading-toggle":_vm.handleLoadingToggle}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PrXe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pscd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container padding-top"},[_c('div',{staticClass:"row justify-content-center entry waiting"},[_c('div',{staticClass:"col-12 text-center"},[_c('div',{staticClass:"svg"},[_c('img',{attrs:{"src":"/static/assets/images/ico-negado.svg","width":"100","alt":"Icone crédito negado."}})]),_vm._v(" "),_c('h1',[_vm._v("Sua solicitação de crédito não foi aprovada.")]),_vm._v(" "),_c('p',[_vm._v("Infelizmente neste momento não poderemos ajudá-lo com seu pedido de empréstimo.")]),_vm._v(" "),_c('a',{staticClass:"btn btn-lg btn-link",attrs:{"data-toggle":"modal","data-target":"#modalMotivo"}},[_vm._v("Por que não consegui? "),_c('i',{staticClass:"fa fa-chevron-right"})])])])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-9"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-8 col-lg-8 text-center tit"},[_c('h3',[_vm._v("Enquanto isso, esperamos que alguma dessas opções possam ajudar você e a sua empresa")])])]),_vm._v(" "),_c('div',{staticClass:"carousel slide",attrs:{"id":"carousel","data-ride":"carousel"}},[_c('ol',{staticClass:"carousel-indicators"},[_c('li',{staticClass:"active",attrs:{"data-target":"#carousel","data-slide-to":"0"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#carousel","data-slide-to":"1"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#carousel","data-slide-to":"2"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#carousel","data-slide-to":"3"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#carousel","data-slide-to":"4"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-inner"},[_c('div',{staticClass:"carousel-item active"},[_c('h5',[_vm._v("Como funciona as solicitações de empréstimo e sua análise pela IOUU?")]),_vm._v(" "),_c('p',[_vm._v("A IOUU trabalha na geração de crédito saudável e produtivo, ou seja, aquele destinado ao fomento da economia do país, ao crescimento de uma empresa ou atividade profissional e a inclusão financeira...")]),_vm._v(" "),_c('a',{staticClass:"btn btn-lg btn-primary",attrs:{"href":"http://blog.iouu.com.br/como-funciona-as-solicitacoes-de-emprestimo-e-sua-analise-pela-iouu/","target":"_blank"}},[_vm._v("Ler artigo")])]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('h5',[_vm._v("Como um bom site pode ajudar seu negócio a vender mais?")]),_vm._v(" "),_c('p',[_vm._v("Você quer vender mais pela internet, não é mesmo? Então, não é a só falta de capital de giro que pode minar seu negócio. Para que seu sonho se trone realidade...")]),_vm._v(" "),_c('a',{staticClass:"btn btn-lg btn-primary",attrs:{"href":"http://blog.iouu.com.br/como-um-bom-site-pode-ajudar-seu-negocio-a-vender-mais-2/","target":"_blank"}},[_vm._v("Ler artigo")])]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('h5',[_vm._v("Como fazer a gestão de fluxo de caixa do seu negócio?")]),_vm._v(" "),_c('p',[_vm._v("Para que uma empresa esteja sempre à frente dos seus concorrentes é preciso ficar de olho nas últimas novidades, fazer uso de ferramentas financeiras e da tecnologia...")]),_vm._v(" "),_c('a',{staticClass:"btn btn-lg btn-primary",attrs:{"href":"http://blog.iouu.com.br/como-fazer-a-gestao-de-fluxo-de-caixa-do-seu-negocio/","target":"_blank"}},[_vm._v("Ler artigo")])]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('h5',[_vm._v("3 dicas imperdíveis para conseguir empréstimo para micro empresa!")]),_vm._v(" "),_c('p',[_vm._v("Devido a crise econômica, o crédito fica cada vez mais caro e escasso, mas isso não deve impedir que você consiga uma maneira para investir na melhoria e crescimento do negócio...")]),_vm._v(" "),_c('a',{staticClass:"btn btn-lg btn-primary",attrs:{"href":"http://blog.iouu.com.br/3-dicas-imperdiveis-para-conseguir-emprestimo-para-micro-empresa/","target":"_blank"}},[_vm._v("Ler artigo")])]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('h5',[_vm._v("Dificuldades financeiras na sua empresa? Saiba como reverter")]),_vm._v(" "),_c('p',[_vm._v("Quando a palavra crise entra no vocabulário empresarial os sinônimos logo começam a aparecer: demissões, corte de gastos, redução das bonificações, vendas de imóveis e até mesmo falência...")]),_vm._v(" "),_c('a',{staticClass:"btn btn-lg btn-primary",attrs:{"href":"http://blog.iouu.com.br/dificuldades-financeiras-na-sua-empresa-saiba-como-reverter/","target":"_blank"}},[_vm._v("Ler artigo")])])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-prev",attrs:{"href":"#carousel","role":"button","data-slide":"prev"}},[_c('span',{staticClass:"fa fa-angle-left",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-next",attrs:{"href":"#carousel","role":"button","data-slide":"next"}},[_c('span',{staticClass:"fa fa-angle-right",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modalMotivo","tabindex":"-1","role":"dialog","aria-labelledby":"modalMotivo","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('h2',[_vm._v("Alguns motivos do porquê não foi possível ter crédito na IOUU")]),_vm._v(" "),_c('p',[_vm._v("Nosso motor de crédito automátizado fez uma análise baseada nos dados fornecidos e dados colhidos em outras fontes publicas e privadas e infelizmente, neste momento, não conseguiremos dar andamento à sua solicitação de empréstimo.")]),_vm._v(" "),_c('p',[_vm._v("Como temos um produto bastante inovador, a todo o momento estamos calibrando nosso motor de crédito para que possamos apoiar cada vez mais empresas como a sua.")]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-chevron-right"}),_vm._v(" Para uma explicação mais detalhada, fizemos um post "),_c('a',{attrs:{"href":"http://blog.iouu.com.br/como-funciona-as-solicitacoes-de-emprestimo-e-sua-analise-pela-iouu/","target":"_blank"}},[_vm._v("listando os possíveis motivos da não aprovação do pedido")]),_vm._v(".")]),_vm._v(" "),_c('h4',[_vm._v("Agradecemos a sua confiança. Você pode fazer um novo pedido em 90 dias (três meses).")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q7y8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"Salary"}},[_vm._v("Salário")]),_vm._v(" "),_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.salario),expression:"salario"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"R$","required":""},domProps:{"value":(_vm.salario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.salario=$event.target.value}}})]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Salário Base")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QAi+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvestmentReservationDataModal_vue__ = __webpack_require__("95hC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_623b61b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvestmentReservationDataModal_vue__ = __webpack_require__("xXoT");
function injectStyle (ssrContext) {
  __webpack_require__("2yUf")
  __webpack_require__("whVA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-623b61b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvestmentReservationDataModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_623b61b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvestmentReservationDataModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QBtY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HasAccountantStep_vue__ = __webpack_require__("eQY7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8eb2a56e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HasAccountantStep_vue__ = __webpack_require__("su++");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HasAccountantStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8eb2a56e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HasAccountantStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QEur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel"},[_c('transition',{attrs:{"name":"slide-right","mode":"out-in"}},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('img',{staticClass:"item",attrs:{"src":_vm.currentPicture}})])]),_vm._v(" "),(_vm.canGoPrevious)?_c('a',{staticClass:"previous-button",attrs:{"role":"button"},on:{"click":function($event){$event.preventDefault();return _vm.goPrevious($event)}}},[_c('i',{staticClass:"carousel-control-prev-icon fas fa-angle-left",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])]):_vm._e(),_vm._v(" "),(_vm.canGoNext)?_c('a',{staticClass:"next-button",attrs:{"role":"button"},on:{"click":function($event){$event.preventDefault();return _vm.goNext($event)}}},[_c('i',{staticClass:"carousel-control-next-icon fas fa-angle-right",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QFX9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QLn5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-login.9fa27bb.png";

/***/ }),

/***/ "QR4F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QXUg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__ = __webpack_require__("65ha");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var endereco = this.currentUser.Social.Endereco;
    return {
      cep: endereco ? endereco.Cep : null,
      logradouro: endereco ? endereco.Logradouro : null,
      numero: endereco ? endereco.Numero : null,
      complemento: endereco ? endereco.Complemento : null,
      bairro: endereco ? endereco.Bairro : null,
      uf: endereco ? endereco.Uf : null,
      cidade: endereco ? endereco.Cidade : null,
      estaBuscandoEndereco: false,
      estaBuscandoCidades: false,
      estados: [],
      cidades: []
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  computed: {
    estaCidadeDesabilitado: function estaCidadeDesabilitado() {
      return this.estaBuscandoEndereco || this.cidades.length == 0;
    }
  },
  methods: {
    aoMudarCep: function aoMudarCep(e) {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskZipcode(e.target.value).length < 8) return;
      this.estaBuscandoEndereco = true;
      __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarCeps(e.target.value).then(function (endereco) {
        _this.logradouro = endereco.logradouro;
        _this.bairro = endereco.bairro;
        _this.uf = endereco.uf;
        _this.cidade = endereco.localidade;

        _this.estaBuscandoEndereco = false;
      }).catch(function () {
        _this.estaBuscandoEndereco = false;
      });
    },
    onUfChange: function onUfChange() {
      var _this2 = this;

      this.cidades = [];
      if (!this.uf) {
        this.cidade = '';
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarCidades(this.uf).then(function (cidades) {
        _this2.cidades = cidades;
        if (_this2.cidade) {
          _this2.setCity();
        }
      });
    },
    setCity: function setCity() {
      var _this3 = this;

      var city = this.cidades.find(function (city) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__["a" /* default */].removeAccents(city.nome.toUpperCase()) == __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__["a" /* default */].removeAccents(_this3.cidade.toUpperCase());
      });
      if (!city) {
        this.cidade = '';
      } else {
        // When the city state is seted before cities is populated the component doesn't show
        // the selected city.
        this.cidade = '';
        setTimeout(function () {
          return _this3.cidade = city.nome;
        }, 100);
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      this.currentUser.Social.Endereco.Cep = __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskZipcode(this.cep);
      this.currentUser.Social.Endereco.Logradouro = this.logradouro;
      this.currentUser.Social.Endereco.Numero = this.numero;
      this.currentUser.Social.Endereco.Complemento = this.complemento;
      this.currentUser.Social.Endereco.Bairro = this.bairro;
      this.currentUser.Social.Endereco.Uf = this.uf;
      this.currentUser.Social.Endereco.Cidade = this.cidade;

      this.$emit('on-submit', { Social: this.currentUser.Social });
    }
  },
  created: function created() {
    var _this4 = this;

    if (!this.currentUser.Social) this.currentUser.Social = {};

    __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarEstados().then(function (estados) {
      _this4.estados = estados;
      // When the city state is seted before cities is populated the component doesn't show
      // the selected city.
      var uf = _this4.uf;
      var city = _this4.cidade;
      _this4.uf = '';
      setTimeout(function () {
        _this4.uf = uf;
        _this4.cidade = city;
      }, 100);
    });
  }
});

/***/ }),

/***/ "QiR8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qj3b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ico-original.b639e55.png";

/***/ }),

/***/ "QmXc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinishedStep_vue__ = __webpack_require__("mnSO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53c9ace8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishedStep_vue__ = __webpack_require__("F9uD");
function injectStyle (ssrContext) {
  __webpack_require__("+m4H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53c9ace8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinishedStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53c9ace8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishedStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Qwbv":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Qxnd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R97G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInformationConstrucao_vue__ = __webpack_require__("+hsU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_109abb44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInformationConstrucao_vue__ = __webpack_require__("ZQ+y");
function injectStyle (ssrContext) {
  __webpack_require__("KTci")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-109abb44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInformationConstrucao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_109abb44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInformationConstrucao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RHgc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"Nascionalidade"}},[_vm._v("Nascionalidade")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","required":"required","placeholder":"Selecione..."},model:{value:(_vm.currentUser.Social.Nascionalidade),callback:function ($$v) {_vm.$set(_vm.currentUser.Social, "Nascionalidade", $$v)},expression:"currentUser.Social.Nascionalidade"}},_vm._l((_vm.optionsNacionality),function(nacionality,index){return _c('at-option',{key:("nacionalityOptions" + index),attrs:{"value":nacionality.value}},[_vm._v(_vm._s(nacionality.label))])}),1)],1),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Nascionalidade")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RK/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportYield_vue__ = __webpack_require__("8TPV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b4b02bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportYield_vue__ = __webpack_require__("I3I/");
function injectStyle (ssrContext) {
  __webpack_require__("+oIw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportYield_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b4b02bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportYield_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RQlP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/investimentos/estatisticas/estatisticas-da-plataforma/investidores"}},[_vm._v("Desempenho dos investidores")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/investimentos/estatisticas/estatisticas-da-plataforma/emprestimos"}},[_vm._v("Estatísticas de empréstimos")])],1)])])]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 text-center"},[_c('img',{attrs:{"src":"/static/assets/images/ico-estatisticas.svg","alt":"icone estatísticas"}}),_vm._v(" "),_c('p',[_vm._v("As estatísticas da plataforma fornecem informações importantes sobre investimentos e empréstimos para você explorar.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RQxD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Certificado do MEI")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RSNq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SocialNetwork__ = __webpack_require__("TYgC");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lpUrl: "https://iouu.com.br",
      password: '',
      confirmarpassword: '',
      id: '',
      token: '',
      enabled: false
    };
  },

  components: {
    SocialNetwork: __WEBPACK_IMPORTED_MODULE_3__components_SocialNetwork__["a" /* default */]
  },
  methods: {
    login: function login(e) {
      var _this = this;

      e.preventDefault();
      var query = this.$route.query;

      if (this.password == '' || this.confirmarpassword == '') {
        this.$Notify.error("Erro: Ambos os campos devem ser preenchidos com valores!");
      } else if (this.password.length < 6) {
        this.$Notify.error("Erro: A senha deve conter no mínimo 6 caracteres!");
      } else if (this.password != this.confirmarpassword) {
        this.$Notify.error("Erro: As senhas devem ser iguais!");
      } else {
        //alterar senha do usuário por ID.
        this.id = query.token;
        this.token = query.tk;

        var dados = this;

        __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].criarnovasenha(dados).then(function () {
          _this.$router.push("/login");
          _this.$Notify.info('Sua senha foi atualizada com sucesso.');
        }).catch(function (error) {
          if (error != "") {
            _this.$router.push("/recuperar-senha");
            _this.$Notify.error("Erro: Este link expirou! Solicite outro! ");
          }
        });
      }
    },
    facebookLogin: function facebookLogin(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get('oauth/facebook/url').then(function (response) {
        window.location.href = response.data.loginUrl;
      });
    },
    googleLogin: function googleLogin(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get('oauth/google/url').then(function (response) {
        window.location.href = response.data.loginUrl;
      });
    },
    linkedinLogin: function linkedinLogin(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get('oauth/linkedin/url').then(function (response) {
        window.location.href = response.data.loginUrl;
      });
    },
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/cadastrar-senha',
        title: 'CadastrarSenha'
      });
    }
  },

  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.taggingGA();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),

/***/ "RYEp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmCadastroInvestor_vue__ = __webpack_require__("qgnJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a4f04b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmCadastroInvestor_vue__ = __webpack_require__("IOZz");
function injectStyle (ssrContext) {
  __webpack_require__("Pck/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a4f04b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmCadastroInvestor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a4f04b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmCadastroInvestor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RYdq":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNkgxMSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTYgMUwxMSA2TDYgMTEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "Rabh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    var pessoal = this.currentUser.Pessoal;
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: pessoal.ArquivoComprovanteEndereco || [null]
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.arquivos.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.arquivos, index, null);
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do comprovande de endereço é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {

        this.currentUser.Pessoal.ArquivoComprovanteEndereco = this.arquivosRecebidos;

        this.$emit('on-submit', { Pessoal: this.currentUser.Pessoal });
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "RnOA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',{staticClass:"open-modal"},[_c('div',{staticClass:"overlay"}),_vm._v(" "),_c('modalRegister',{staticClass:"box"},[_c('div',{staticClass:"close-modal",on:{"click":_vm.closeModal}},[_c('div',[_c('span',[_c('img',{attrs:{"src":"https://www.iouu.com.br/hubfs/raw_assets/public/IOUU_November2020/images/close-blue.svg","alt":"Close Icon","title":"Close Icon"}})])])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('span',[_c('h2',[_vm._v("O que deseja?")]),_vm._v(" "),_c('p',[_vm._v("Conectamos empresas à procura de crédito com investidores com dinheiro para emprestar.")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{staticClass:"btn",attrs:{"target":"_blank","href":"https://dashboard-app.iouu.com.br/?__hstc=45338044.f24ee702a737cb6e1fa1f448473525de.1606915619443.1608212397141.1608224135495.4&__hssc=45338044.1.1608224135495&__hsfp=2008320709#/criar-conta","rel":"noopener"}},[_vm._v("\n              Quero Investir\n            ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"btn",attrs:{"target":"_blank","href":"https://emprestimos.iouu.com.br/pedido","rel":"noopener"}},[_vm._v("\n              Quero Empréstimo\n            ")])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S2Fg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pessoal: this.currentUser.Pessoal
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = { Pessoal: this.pessoal };
      this.$emit('on-submit', newData);
    }
  }
});

/***/ }),

/***/ "S4Dl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center personalLoan-steps"},[(_vm.canGoPrevious)?_c('step-back-button',{on:{"click":this.onPrevious}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c(_vm.currentStepComponent,{tag:"component",staticClass:"form-container",attrs:{"current-user":_vm.currentUser},on:{"on-submit":this.updateUser,"loading-toggle":_vm.handleLoadingToggle}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SCgy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SDSr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('on-submit', {retentar: true})}}},[_vm._v("Tentar Novamente")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('on-submit', {retentar: false})}}},[_vm._v("Desistir")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('p',[_vm._v("Você não acertou perguntas o suficiente, gostaria de tentar novamente?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SQI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-info"},[(_vm.oportunidadesEmBreve)?_c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(!_vm.oportunidadesEmBreve)?_c('div',{staticClass:"row list-view"},[(_vm.showModal)?_c('Modal',{attrs:{"solicitacaoProps":_vm.solicitacao,"investidor":_vm.investidor,"usuario":_vm.User},on:{"close":function($event){return _vm.voltar()}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 tit_page"},[_c('div',{staticClass:"row align-items-center"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 float-right text-lg-right"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 control-group"},[_c('strong',[_vm._v("Score: ")]),_vm._v(" "),_c('label',{staticClass:"control control-aa control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tAA\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"AA",attrs:{"id":"AA","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreClick($event, 'AA')}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})]),_vm._v(" "),_c('label',{staticClass:"control control-a control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"A",attrs:{"id":"A","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreClick($event, 'A')}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})]),_vm._v(" "),_c('label',{staticClass:"control control-b control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tB\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"B",attrs:{"id":"B","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreClick($event, 'B')}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})]),_vm._v(" "),_c('label',{staticClass:"control control-c control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tC\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"C",attrs:{"id":"C","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreClick($event, 'C')}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})]),_vm._v(" "),_c('label',{staticClass:"control control-d control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tD\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"D",attrs:{"id":"D","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreClick($event, 'D')}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})]),_vm._v(" "),_c('label',{staticClass:"control control-e control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tE\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"E",attrs:{"id":"E","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreClick($event, 'E')}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})]),_vm._v(" "),_c('label',{staticClass:"control control-hr control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tHR\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"HR",attrs:{"id":"HR","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreClick($event, 'HR')}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})]),_vm._v(" "),_c('label',{staticClass:"control control-todos control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tTodos\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"all",attrs:{"id":"all","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreAll($event)}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-2 d-flex justify-content-end align-items-center display"},[_c('span',[_vm._v("Exibir como")]),_vm._v(" "),_c('ul',{staticClass:"display-loans"},[_c('li',{staticClass:"display-loan grid"},[_c('label',{attrs:{"for":"grid"}},[_c('input',{attrs:{"type":"radio","name":"loans","id":"grid","value":"grid"},domProps:{"checked":_vm.showCards},on:{"click":_vm.setCards}}),_vm._v(" "),_c('svg',{attrs:{"viewBox":"0 0 19.2 19.2"}},[_c('g',{attrs:{"transform":"translate(0.6 0.6)"}},[_c('path',{attrs:{"d":"M81.548,8.138a.334.334,0,0,1-.31.31H74.41a.334.334,0,0,1-.31-.31V1.31A.334.334,0,0,1,74.41,1h6.828a.334.334,0,0,1,.31.31Z","transform":"translate(-74.1 -1)"}}),_c('path',{attrs:{"d":"M115.548,8.138a.334.334,0,0,1-.31.31H108.41a.334.334,0,0,1-.31-.31V1.31a.334.334,0,0,1,.31-.31h6.828a.334.334,0,0,1,.31.31Z","transform":"translate(-97.548 -1)"}}),_c('path',{attrs:{"d":"M81.548,42.138a.334.334,0,0,1-.31.31H74.41a.334.334,0,0,1-.31-.31V35.31a.334.334,0,0,1,.31-.31h6.828a.334.334,0,0,1,.31.31Z","transform":"translate(-74.1 -24.448)"}}),_c('path',{attrs:{"d":"M115.548,42.138a.334.334,0,0,1-.31.31H108.41a.334.334,0,0,1-.31-.31V35.31a.334.334,0,0,1,.31-.31h6.828a.334.334,0,0,1,.31.31Z","transform":"translate(-97.548 -24.448)"}})])])])]),_vm._v(" "),_c('li',{staticClass:"display-loan list"},[_c('label',{attrs:{"for":"list"}},[_c('input',{attrs:{"type":"radio","name":"loans","id":"list","value":"list"},domProps:{"checked":_vm.showCards==''},on:{"click":_vm.unsetCards}}),_vm._v(" "),_c('svg',{attrs:{"viewBox":"0 0 19.2 19.2"}},[_c('g',{attrs:{"transform":"translate(0.6 0.6)"}},[_c('rect',{attrs:{"width":"18","height":"4.345","transform":"translate(0)"}}),_c('rect',{attrs:{"width":"18","height":"4.345","transform":"translate(0 6.828)"}}),_c('rect',{attrs:{"width":"18","height":"4.345","transform":"translate(0 13.655)"}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),(_vm.showCards)?_c('div',{staticClass:"view"},[_c('div',{staticClass:"row cards"},_vm._l((this.oportunidades),function(item,index){return _c('div',{key:item._id,class:'column rating-' + _vm.lowerCase(item.Score)},[_c('opportunityCard',{attrs:{"index":index,"item":item,"mudarOportunidade":_vm.mudarOportunidade,"ajustIdOportunidade":_vm.ajustIdOportunidade,"formatarScore":_vm.formatarScore,"formatarTipoEmprestimo":_vm.formatarTipoEmprestimo,"money":_vm.money,"inteiro":_vm.inteiro,"levantado":_vm.levantado,"faltam":_vm.faltam,"diffDate":_vm.diffDate,"valor":_vm.valor,"templateRender":_vm.templateRender}})],1)}),0)]):_vm._e(),_vm._v(" "),(!_vm.showCards)?_c('opportunitiesList',{attrs:{"oportunidatesAux":_vm.oportunidades,"mudarOportunidade":_vm.mudarOportunidade,"ajustIdOportunidade":_vm.ajustIdOportunidade,"formatarScore":_vm.formatarScore,"formatarTipoEmprestimo":_vm.formatarTipoEmprestimo,"money":_vm.money,"inteiro":_vm.inteiro,"levantado":_vm.levantado,"faltam":_vm.faltam,"diffDate":_vm.diffDate,"valor":_vm.valor,"templateRender":_vm.templateRender,"lowerCase":_vm.lowerCase,"InvestidorBloqueado":_vm.InvestidorBloqueado()}}):_vm._e(),_vm._v(" "),_c('Pagination',{attrs:{"paginasTotais":this.Paginas,"paginaAtual":this.indexPage,"navigate":function (rota){ return this$1.paginacao(rota-1); }}})],1)],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard__complete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Em breve novas oportunidades")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-4 float-left"},[_c('h1',[_vm._v("Antecipação de Recebíveis")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SUhN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SVqm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"Celular text-left"}},[_vm._v("Celular")]),_vm._v(" "),_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.celular),expression:"celular"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"(__) _____-____","title":"(__) _____-____","pattern":"(\\(\\d{2}\\)|\\d{2})\\s?\\d{5}[ -]?\\d{4}","required":""},domProps:{"value":(_vm.celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.celular=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',[_vm._v("Telefone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.telefone),expression:"telefone"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"(__) _____-____","title":"(__) _____-____","pattern":"(\\(\\d{2}\\)|\\d{2})\\s?\\d{4,5}[ -]?\\d{4}"},domProps:{"value":(_vm.telefone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.telefone=$event.target.value}}})]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Contatos Pessoal")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SZ4o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row form-container justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-10 col-xl-10"},[(_vm.canGoPrevious)?_c('step-back-button',{on:{"click":this.onPrevious}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[(_vm.investor)?_c(_vm.currentStepComponent,{tag:"component",attrs:{"investor":_vm.investor},on:{"submit":this.updateInvestor}}):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Sg4x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"Escolaridade"}},[_vm._v("\n            Escolaridade\n          ")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.currentUser.Social.Escolaridade),callback:function ($$v) {_vm.$set(_vm.currentUser.Social, "Escolaridade", $$v)},expression:"currentUser.Social.Escolaridade"}},_vm._l((_vm.degrees),function(degree,index){return _c('at-option',{key:("degreesOptions" + index),attrs:{"value":degree.value}},[_vm._v(_vm._s(degree.label))])}),1)],1),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Escolaridade")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SgFN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CanceledStep_vue__ = __webpack_require__("8BAa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74eeaa45_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CanceledStep_vue__ = __webpack_require__("6WvZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CanceledStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74eeaa45_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CanceledStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sixp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_countdownCustom_vue__ = __webpack_require__("xt6L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9c6212_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_countdownCustom_vue__ = __webpack_require__("jr5H");
function injectStyle (ssrContext) {
  __webpack_require__("alcn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_countdownCustom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9c6212_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_countdownCustom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SkR5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',[_c('div',{staticClass:"form-group"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Comprovante de Renda")]),_vm._v(" "),_c('p',[_vm._v("Envie uma cópia do seu "),_c('strong',[_vm._v("Holerite")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SoQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetWorthStep_vue__ = __webpack_require__("6qZ1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ebc99b5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NetWorthStep_vue__ = __webpack_require__("zWtS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetWorthStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ebc99b5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NetWorthStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SrdJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyTypeStep_vue__ = __webpack_require__("HUZC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40f3540d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyTypeStep_vue__ = __webpack_require__("ZypF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyTypeStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40f3540d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyTypeStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SuNK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        retornoBruto: function retornoBruto(porcentagem, investido) {
            return porcentagem * investido;
        },
        retornoLiquido: function retornoLiquido(bruto, IRTotal) {
            return bruto - IRTotal;
        },
        GerarCalculos: function GerarCalculos(valorFinanciado, taxaMensal, meses) {
            var tabela = [],
                total = {};
            var valorParcela = this.PMT(valorFinanciado, taxaMensal, meses);
            for (var i = 1; i <= meses; i++) {
                var juros = this.valorJuros(valorFinanciado, taxaMensal);
                var IR = this.valorIR(i, juros);
                var amortizado = this.valorAmortizado(valorParcela, juros);
                var parcelaLiquida = valorParcela - IR;
                total = this.contarTaxas({ juros: juros, IR: IR }, total);
                valorFinanciado = valorFinanciado - amortizado;

                var itemTabela = this.formatarCalcJson({ juros: juros, IR: IR, amortizado: amortizado, parcelaLiquida: parcelaLiquida, valorFinanciado: valorFinanciado, parcela: i });

                tabela = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(tabela), [itemTabela]);
            }
            total = this.formatarCalcJson(total);

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ tabela: tabela }, total, { valorParcela: valorParcela });
        },
        PMT: function PMT(valorFinanciado, taxaMensal, meses) {
            var dividendo = Math.pow(taxaMensal + 1, meses) * taxaMensal;
            var divisor = Math.pow(taxaMensal + 1, meses) - 1;
            return divisor != 0 ? valorFinanciado * (dividendo / divisor) : valorFinanciado / meses;
        },
        valorJuros: function valorJuros(valorRestante, taxaMensal) {
            return valorRestante * taxaMensal;
        },
        valorAmortizado: function valorAmortizado(valorParcela, juros) {
            return valorParcela - juros;
        },
        valorIR: function valorIR(mes, juros) {
            var IR = 0.15;
            if (mes > 0 && mes <= 6) IR = 0.225;
            if (mes > 6 && mes <= 12) IR = 0.2;
            if (mes > 12 && mes <= 24) IR = 0.175;
            return IR * juros;
        },
        formatarCalcJson: function formatarCalcJson(obj) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
                key == 'parcela' ? '' : obj[key] = obj[key].toFixed(2);
            });
            return obj;
        },
        contarTaxas: function contarTaxas(obj, countObj) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
                typeof countObj[key] == 'undefined' ? countObj[key] = 0 : '';
                typeof countObj[key] == 'number' ? countObj[key] = countObj[key] + obj[key] : countObj[key] = parseFloat(countObj[key]) + parseFloat(obj[key]);
            });
            return countObj;
        }
    }
});

/***/ }),

/***/ "Susk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalRegistration_vue__ = __webpack_require__("kJx+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cad24a86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalRegistration_vue__ = __webpack_require__("RnOA");
function injectStyle (ssrContext) {
  __webpack_require__("1kkP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cad24a86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalRegistration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cad24a86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalRegistration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sv9X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonFields_vue__ = __webpack_require__("uaHA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72980023_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonFields_vue__ = __webpack_require__("X5Ct");
function injectStyle (ssrContext) {
  __webpack_require__("VSjf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72980023"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonFields_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72980023_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonFields_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T+5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8"},[_c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("O endereço da(o) "),_c('strong',[_vm._v(_vm._s(_vm.razaoSocial))]),_vm._v(" está correto?")])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-10 col-xl-10"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"cep"}},[_vm._v("CEP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cep),expression:"cep"},{name:"mask",rawName:"v-mask",value:('zipcode'),expression:"'zipcode'"},{name:"focus",rawName:"v-focus"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","pattern":"\\d{5}-?\\d{3}","placeholder":"CEP","required":""},domProps:{"value":(_vm.cep)},on:{"change":_vm.aoMudarCep,"input":function($event){if($event.target.composing){ return; }_vm.cep=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Endereço")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.logradouro),expression:"logradouro"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Logradouro","disabled":_vm.estaBuscandoEndereco,"required":""},domProps:{"value":(_vm.logradouro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.logradouro=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-2"},[_c('label',{attrs:{"for":"inputPassword4"}},[_vm._v("Número")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numero),expression:"numero"},{name:"mask",rawName:"v-mask",value:('integer'),expression:"'integer'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","pattern":"\\d+","title":"Números apenas","placeholder":"Nº","disabled":_vm.estaBuscandoEndereco,"required":""},domProps:{"value":(_vm.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numero=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"complemento"}},[_vm._v("Complemento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complemento),expression:"complemento"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Complemento","disabled":_vm.estaBuscandoEndereco},domProps:{"value":(_vm.complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.complemento=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"bairro"}},[_vm._v("Bairro")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bairro),expression:"bairro"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Bairro","disabled":_vm.estaBuscandoEndereco,"required":""},domProps:{"value":(_vm.bairro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bairro=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"estado"}},[_vm._v("Estado")]),_vm._v(" "),_c('at-select',{ref:"stateSelect",attrs:{"filterable":"","size":"large","placeholder":_vm.placeholderEstado,"disabled":_vm.estaEstadoDesabilitado},on:{"on-change":_vm.onUfChange},model:{value:(_vm.uf),callback:function ($$v) {_vm.uf=$$v},expression:"uf"}},_vm._l((_vm.estados),function(state,i){return _c('at-option',{key:("stateOptions" + i),attrs:{"value":state.uf}},[_vm._v(_vm._s(state.nome))])}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"cidade"}},[_vm._v("Cidade")]),_vm._v(" "),_c('at-select',{ref:"citySelect",attrs:{"filterable":"","size":"large","placeholder":_vm.placeholderCidade,"disabled":_vm.estaCidadeDesabilitado},model:{value:(_vm.cidade),callback:function ($$v) {_vm.cidade=$$v},expression:"cidade"}},_vm._l((_vm.cidades),function(city,i){return _c('at-option',{key:("cityOptions" + i),attrs:{"value":city.nome}},[_vm._v(_vm._s(city.nome))])}),1)],1)]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T1H7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-container"},[_c('input',{staticClass:"form-control form-control-lg",attrs:{"id":"inputPassword","type":_vm.showPassword ? 'text' : 'password'},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"show-password-toggler fa",class:_vm.showPassword ? 'fa-eye' : 'fa-eye-slash',attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.toggleShowPassword(this)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T3gA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api_client__ = __webpack_require__("6Yc5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        Msg: {
            require: true,
            type: Number
        }
    },
    data: function data() {
        return {
            faltaCompletar: true
        };
    },
    created: function created() {

        if (this.$store.state.currentUser != null && this.$store.state.currentUser.investor != null) if (this.$store.state.currentUser.investor.Status == "APROVADO" || this.$store.state.currentUser.investor.Status == "NEGADO" || this.$store.state.currentUser.investor.Status == "NEGADO_") this.faltaCompletar = false;
    }
});

/***/ }),

/***/ "T73t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-10 col-xl-10"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"informacaoInstitucional"}},[_vm._v("Sobre a minha empresa")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.informacaoInstitucional),expression:"informacaoInstitucional"}],staticClass:"form-control form-control-lg",attrs:{"rows":"5","placeholder":"Como começou a empresa? Quais os produtos/serviços que a empresa oferece? A quanto tempo está nessa mesma localização? O imóvel que a empresa se encontra é próprio ou alugado? Quais as projeções futuras? Informações sobre os sócios: Experiência na área, formação, etc.","required":""},domProps:{"value":(_vm.informacaoInstitucional)},on:{"input":function($event){if($event.target.composing){ return; }_vm.informacaoInstitucional=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Conte-nos um pouco mais sobre a sua empresa")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T9Bt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.IdOportunidade!= 0)?_c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_c('iframe',{attrs:{"src":'https://robinacademia.com/p.ashx?o=90&e=1&t='+this.IdOportunidade,"height":"1","width":"1","frameborder":"0"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('img',{attrs:{"src":"/static/assets/images/ico-smile.svg","alt":"Icone feliz"}}),_vm._v(" "),_c('h1',[_vm._v("Cadastro Concluído com sucesso!")]),_vm._v(" "),_c('p',[_vm._v("Recebemos sua solicitação de empréstimo com sucesso."),_c('br'),_vm._v("Em até "),_c('b',[_vm._v("72 horas úteis")]),_vm._v(", você receberá uma resposta."),_c('br'),_vm._v("Você poderá acompanhar a sua solicitação de empréstimo pela área do cliente ou por e-mail")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})]),_vm._v(" "),_c('p',{staticClass:"nome"},[_vm._v("Obrigado por escolher nos escolher!")]),_vm._v(" "),_c('p',{staticClass:"obs"},[_vm._v("Juntos vamos reinventar o sistema bancário ultrapassado e garantir um melhor negócio para todos.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TDCC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_reservaInvestimento__ = __webpack_require__("FGQr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_masker__ = __webpack_require__("7VWg");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showModal: false,
            investor: null,
            endereco: null,
            finshedLoading: false,
            reservaId: "",
            reserva: null,
            boleto: null,
            solicitacao: null,
            finshedLoadingNot: false,
            errorLoading: false,
            score: null,
            feat_abc: "false"
        };
    },

    computed: {
        NomeCompleto: function NomeCompleto() {
            return this.investor.NomeCompleto;
        },
        FormatedAddress: function FormatedAddress() {

            if (this.endereco == undefined) return "";

            return this.endereco.Logradouro + ', ' + this.endereco.Numero + ',\n                        ' + this.endereco.Complemento + ' - ' + this.endereco.Bairro + ' ' + this.endereco.Cidade + ' -\n                        ' + this.endereco.Uf;
        },
        Cep: function Cep() {
            if (this.endereco == undefined) return "";
            return 'CEP ' + this.endereco.Cep;
        },
        ValorBoleto: function ValorBoleto() {
            if (!this.reserva.ReInvestimento) this.reserva.ReInvestimento = 0;
            return this.formatCurrency(this.reserva.Valor - this.reserva.ReInvestimento);
        },
        NomeTomador: function NomeTomador() {
            return this.solicitacao.Empresa.NomeFantasia;
        },
        idOportunidade: function idOportunidade() {
            return 'ID#' + this.solicitacao.IdOportunidade;
        },
        Rendimento: function Rendimento() {
            return this.solicitacao.Rendimento;
        },
        boletoUrl: function boletoUrl() {
            return "https://pay.iouu.com.br" + '/boleto/investidor/' + this.boleto._id;
        }
    },
    components: { Modal: __WEBPACK_IMPORTED_MODULE_5__components_Modal__["a" /* default */] },
    methods: {
        BoletoPDF: function BoletoPDF(pdf) {
            var bin = atob(pdf);

            // Embed the PDF into the HTML page and show it to the user
            var obj = document.createElement('object');
            obj.style.width = '100%';
            obj.style.height = '842pt';
            obj.type = 'application/pdf';
            obj.data = 'data:application/pdf;base64,' + pdf;
            document.body.appendChild(obj);

            // Insert a link that allows the user to download the PDF file
            var link = document.createElement('a');
            link.innerHTML = 'Download PDF file';
            link.download = 'file.pdf';
            link.href = 'data:application/octet-stream;base64,' + pdf;
            document.body.appendChild(link);
            return 'rating-' + score.toLowerCase();
        },
        ScoreClass: function ScoreClass(score) {
            // let score = this.score
            if (score == null || score == undefined) return "";
            return 'rating-' + score.toLowerCase();
        },
        Score: function Score(score) {
            if (score == null || score == undefined) return "";

            if (score == "AA" || score == "HR") return score;

            return score.substr(0, 1);
        },
        formatCurrency: function formatCurrency(value) {
            if (value != null) return "R$ " + value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });

            return 0;
        },
        verificaBoleto: function verificaBoleto() {
            return this.reserva.StatusBoleto === "paid" ? true : false;
        },


        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/finalizar-investimento',
                title: 'Finalizar investimento'
            });
        }
    },
    beforeCreate: function beforeCreate() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var reservaid, resp;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["c" /* START_LOADING */]);
                            reservaid = _this.$route.query.id;

                            localStorage.removeItem("pre_investimento");

                            _context2.prev = 3;
                            _context2.next = 6;
                            return __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getInvestor();

                        case 6:
                            _this.investor = _context2.sent;

                            _this.endereco = _this.investor.Endereco;

                            _context2.next = 10;
                            return __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getReservaSolicitacao(reservaid);

                        case 10:
                            _this.reserva = _context2.sent;
                            _context2.next = 13;
                            return __WEBPACK_IMPORTED_MODULE_3__services_api_reservaInvestimento__["a" /* default */].GetBoletoInvestidor(reservaid);

                        case 13:
                            resp = _context2.sent;

                            _this.boleto = resp.data;
                            if (_this.reserva.Boleto) {
                                _this.score = _this.Score(_this.reserva.SolicitacaoId.Score);
                                _this.solicitacao = _this.reserva.SolicitacaoId;
                                _this.finshedLoading = true;
                            } else {
                                setTimeout(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    _context.next = 2;
                                                    return __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getReservaSolicitacao(reservaid);

                                                case 2:
                                                    _this.reserva = _context.sent;

                                                    _this.solicitacao = _this.reserva.SolicitacaoId;
                                                    _this.finshedLoading = true;

                                                case 5:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, _this);
                                })), 2000);
                            }

                            _context2.next = 21;
                            break;

                        case 18:
                            _context2.prev = 18;
                            _context2.t0 = _context2['catch'](3);

                            _this.finshedLoadingNot = true;

                        case 21:

                            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);

                        case 22:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this, [[3, 18]]);
        }))();
    },
    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return _this2.taggingGA();

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this2);
        }))();
    }
});

/***/ }),

/***/ "TNSU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TNve":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OauthCallback_vue__ = __webpack_require__("BCWH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OauthCallback_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OauthCallback_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273f289a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OauthCallback_vue__ = __webpack_require__("Haba");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OauthCallback_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273f289a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OauthCallback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TYZs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api_investiment__ = __webpack_require__("/4fP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api_wallet__ = __webpack_require__("c/xH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_api_client_go__ = __webpack_require__("879M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_date_helper__ = __webpack_require__("Td74");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__ = __webpack_require__("Du/2");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            // navegacao
            aba: 0,

            // valoresde inputs
            valorSelecionado: '0',
            reinvestimento: '0',
            motivo: '',
            valores: null,

            // estado para if
            cancelado: false,
            listaEspera: null,

            // objetos para consulta de dados
            reservaInvestimento: null,
            saldo: 0,
            modal: false,

            nomeUsuario: ''
        };
    },

    props: {
        valorInicial: { type: String },
        solicitacao: { type: Object },
        investidor: { type: Object },
        usuario: { type: Object },
        atualizaSolicitacao: { type: Function }
    },
    computed: {
        valor: function valor() {
            var valor = void 0;
            this.valorSelecionado ? valor = this.valorSelecionado.replace('R$', '') : valor = (this.solicitacao.InvestimentoMinimo * 100).toString();
            this.aba != 5 ? this.$emit('updateValor', valor) : '';
            return __WEBPACK_IMPORTED_MODULE_6__utils_masker__["a" /* default */].unmaskMoney(valor) * 100;
        },
        valorReinvestimento: function valorReinvestimento() {
            var valor = this.reinvestimento;
            if (valor == this.valor) valor = valor / 100;
            if (valor.toString().indexOf(",") > 0) {
                var arrReinv = valor.split(",");
                var stringReinv = (arrReinv[0] + arrReinv[1]).replace(".", "");
                valor = parseInt(stringReinv) / 100;
            }
            return valor;
        },
        reservaStatus: function reservaStatus() {
            return this.reservaInvestimento ? this.reservaInvestimento.Status : 0;
        },
        cancelavel: function cancelavel() {
            if (this.reservaInvestimento) return this.reservaInvestimento.StatusBoleto == 'paid' || this.reservaInvestimento.Valor == this.reservaInvestimento.ReInvestimento ? false : true;
            return true;
        },
        investimentoMaximo: function investimentoMaximo() {
            var InvestimentoMaximo = this.solicitacao.InvestimentoMaximo;
            var valorRestante = this.solicitacao.Valor - this.solicitacao.ValorCaptado;
            if (this.solicitacao.ChamadaListaEspera) {
                if (!InvestimentoMaximo) InvestimentoMaximo = this.solicitacao.Valor;
            } else {
                if (InvestimentoMaximo && InvestimentoMaximo > valorRestante) InvestimentoMaximo = valorRestante;
            }
            return InvestimentoMaximo;
        }
    },
    methods: {
        // Metodos externos 
        getSaldo: function getSaldo() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["c" /* START_LOADING */]);
                                _context.prev = 1;
                                _context.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_5__services_api_wallet__["a" /* default */].GetSaldoWallet();

                            case 4:
                                _ref = _context.sent;
                                data = _ref.data;

                                _this.saldo = data.Saldo;
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](1);

                                _this.saldo = 0.00;

                            case 12:
                                _this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                return _context.abrupt('return', _this.saldo);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[1, 9]]);
            }))();
        },
        getReserva: function getReserva(id) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var resp;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;

                                _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["c" /* START_LOADING */]);
                                _context2.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_7__utils_api_client__["a" /* default */].getInvestmentReservation({ loanRequestId: id });

                            case 4:
                                resp = _context2.sent;

                                _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                return _context2.abrupt('return', resp);

                            case 9:
                                _context2.prev = 9;
                                _context2.t0 = _context2['catch'](0);

                                _this2.$Notify.error(_context2.t0);
                                _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                return _context2.abrupt('return', _context2.t0);

                            case 14:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[0, 9]]);
            }))();
        },
        criarInvestimento: function criarInvestimento(idSolicitacao, investimento, listaEspera) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var resp;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;

                                if (typeof idSolicitacao === "undefined") idSolicitacao = _this3.$route.params.id;
                                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["c" /* START_LOADING */]);
                                _context3.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_4__services_api_investiment__["a" /* default */].CreateReservation(idSolicitacao, investimento, listaEspera);

                            case 5:
                                resp = _context3.sent;

                                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                return _context3.abrupt('return', resp);

                            case 10:
                                _context3.prev = 10;
                                _context3.t0 = _context3['catch'](0);
                                _context3.next = 14;
                                return _this3.getReserva(_this3.solicitacao._id);

                            case 14:
                                _this3.reservaInvestimento = _context3.sent;

                                _this3.aba = _this3.redirecionaAba(_this3.solicitacao, _this3.reservaStatus, new Date());
                                _this3.$Notify.error(_context3.t0.response.data.errors[0].detail);
                                // this.$emit('close', true)
                                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                return _context3.abrupt('return', _context3.t0);

                            case 19:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3, [[0, 10]]);
            }))();
        },
        cancelarInvestimento: function cancelarInvestimento(id, motivo) {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var resp;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.prev = 0;

                                _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["c" /* START_LOADING */]);
                                _context4.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_4__services_api_investiment__["a" /* default */].DeleteReservation(id, motivo);

                            case 4:
                                resp = _context4.sent;

                                _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                return _context4.abrupt('return', resp);

                            case 9:
                                _context4.prev = 9;
                                _context4.t0 = _context4['catch'](0);

                                _this4.$Notify.error(_context4.t0);
                                _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                return _context4.abrupt('return', _context4.t0);

                            case 14:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4, [[0, 9]]);
            }))();
        },

        // Ações
        abaCampanhaReinvestimento: function abaCampanhaReinvestimento() {

            this.aba = 7;
        },
        proximoPasso: function proximoPasso() {

            this.modal = true;
        },
        submeterInvestimento: function submeterInvestimento() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var erro;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                erro = _this5.validacao();

                                if (erro != '') {
                                    _this5.$Notify.error(erro);
                                } else {
                                    if (_this5.saldo > 0) {
                                        _this5.saldo > _this5.valor / 100 ? _this5.reinvestimento = _this5.formataValor(_this5.valor / 100) : _this5.reinvestimento = _this5.formataValor(Math.floor(_this5.saldo * 100) / 100);
                                        _this5.aba = 2;
                                    } else if (_this5.listaEspera) {
                                        _this5.reinvestimento = 0;
                                    } else {
                                        _this5.checkout();
                                    }
                                }

                                _this5.modal = false;

                            case 3:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        },
        submeterReinvestimento: function submeterReinvestimento() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var erro, investimento, resp, solicitacao;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                erro = _this6.validacao();

                                if (!(erro != '')) {
                                    _context6.next = 5;
                                    break;
                                }

                                _this6.$Notify.error(erro);
                                _context6.next = 18;
                                break;

                            case 5:
                                investimento = _this6.formataInvestimento(_this6.valor, _this6.valorReinvestimento);

                                if (!(investimento.Valor == investimento.ReInvestimento || _this6.listaEspera)) {
                                    _context6.next = 17;
                                    break;
                                }

                                _context6.next = 9;
                                return _this6.criarInvestimento(_this6.solicitacao._id, investimento, _this6.listaEspera);

                            case 9:
                                resp = _context6.sent;
                                solicitacao = _this6.atualizaValor(_this6.solicitacao, resp.data.Valor);

                                _this6.$emit('updateSolicitacao', solicitacao);

                                _this6.saldo = _this6.atualizaSaldo(_this6.saldo, resp.data);

                                _this6.reservaInvestimento = resp.data;

                                _this6.aba = 5;
                                _context6.next = 18;
                                break;

                            case 17:
                                _this6.checkout();

                            case 18:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this6);
            }))();
        },
        submeterCampanhaReinvestimento: function submeterCampanhaReinvestimento() {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
                var erro, investimento, resp, solicitacao;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return _this7.validacaoCampanhaReinvestimento();

                            case 2:
                                erro = _context7.sent;

                                if (!(erro != '')) {
                                    _context7.next = 7;
                                    break;
                                }

                                _this7.$Notify.error(erro);
                                _context7.next = 19;
                                break;

                            case 7:
                                investimento = _this7.formataInvestimento(_this7.valor, _this7.valorReinvestimento);


                                investimento.Valor = investimento.ReInvestimento;
                                investimento.CampanhaReinvestimento = true;

                                _context7.next = 12;
                                return _this7.criarInvestimento(_this7.solicitacao._id, investimento, _this7.listaEspera);

                            case 12:
                                resp = _context7.sent;
                                solicitacao = _this7.atualizaValor(_this7.solicitacao, resp.data.Valor);

                                _this7.$emit('updateSolicitacao', solicitacao);
                                _this7.$emit('updateValor', investimento.Valor);

                                _this7.saldo = _this7.atualizaSaldo(_this7.saldo, resp.data);

                                _this7.reservaInvestimento = resp.data;

                                _this7.aba = 5;

                            case 19:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this7);
            }))();
        },
        submeterLista: function submeterLista() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _this8.listaEspera = true;
                                _this8.aba = 1;

                            case 2:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this8);
            }))();
        },
        submeterCancelamento: function submeterCancelamento() {
            var _this9 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
                var hoje, resp, solicitacao;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (!(_this9.motivo == '')) {
                                    _context9.next = 4;
                                    break;
                                }

                                _this9.$Notify.error("Preencha um motivo para o cancelamento");
                                _context9.next = 13;
                                break;

                            case 4:
                                hoje = new Date();
                                _context9.next = 7;
                                return _this9.cancelarInvestimento(_this9.reservaInvestimento._id, { motivo: _this9.motivo });

                            case 7:
                                resp = _context9.sent;
                                solicitacao = _this9.atualizaValor(_this9.solicitacao, resp.Valor * -1);

                                _this9.$emit('updateSolicitacao', solicitacao);

                                _this9.saldo = _this9.atualizaSaldo(_this9.saldo, resp);

                                _this9.reservaInvestimento = null;
                                _this9.cancelado = true;

                            case 13:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this9);
            }))();
        },
        submeterMotivo: function submeterMotivo() {
            this.aba = 3;
        },
        checkout: function checkout() {
            var erro = this.validacao();
            if (erro) {
                this.$Notify.error(erro);
            } else {
                if (typeof this.solicitacao._id === "undefined") this.solicitacao._id = this.$route.params.id;
                console.log(this.$route.params.id);
                var investimento = this.formataInvestimento(this.valor, this.valorReinvestimento);
                var data = this.formataStorage(this.investidor._id, this.solicitacao._id, investimento);
                localStorage.setItem("pre_investimento", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
                // ajuste emergencial css
                document.querySelector('.main-content').style.zIndex = 2;
                this.$router.push("/investimentos/oportunidades/confirmacao/" + this.solicitacao._id);
            }
        },
        zerarReinvestimento: function zerarReinvestimento() {
            this.reinvestimento = 0;
            this.listaEspera ? this.submeterReinvestimento() : this.checkout();
        },
        sairCancelamento: function sairCancelamento() {
            this.aba = 5;
        },
        perfilEmpresa: function perfilEmpresa() {
            // ajuste emergencial css
            document.querySelector('.main-content').style.zIndex = 2;

            window.location.href.includes('perfil-empresa') ? window.location.reload() : this.$router.push("/investimentos/oportunidades/perfil-empresa/" + this.solicitacao._id);
        },

        // Servicos
        atualizaValor: function atualizaValor(solicitacao, valor) {
            solicitacao.ChamadaListaEspera || solicitacao.Valor == solicitacao.ValorCaptado ? '' : solicitacao.ValorCaptado = solicitacao.ValorCaptado + valor;
            return solicitacao;
        },
        atualizaSaldo: function atualizaSaldo(saldo, reserva) {
            return reserva.Status == 0 ? saldo + reserva.ReInvestimento : saldo - reserva.ReInvestimento;
        },
        formataStorage: function formataStorage(idInvestidor, idSolicitacao, investimento) {
            return {
                "InvestidorId": idInvestidor,
                "SolicitacaoId": idSolicitacao,
                "Valor": investimento.Valor,
                "ValorReinvestimento": investimento.ReInvestimento
            };
        },
        formataInvestimento: function formataInvestimento(valorInvestimento, valorReinvestimento) {
            var Valor = void 0,
                ReInvestimento = void 0;
            typeof valorInvestimento == 'string' ? Valor = __WEBPACK_IMPORTED_MODULE_6__utils_masker__["a" /* default */].unmaskMoney(valorInvestimento) : Valor = valorInvestimento / 100;
            //Envia valor de reinvestimento
            typeof valorReinvestimento == 'string' ? ReInvestimento = __WEBPACK_IMPORTED_MODULE_6__utils_masker__["a" /* default */].unmaskMoney(valorReinvestimento) : ReInvestimento = valorReinvestimento;
            return { Valor: Valor, ReInvestimento: ReInvestimento };
        },
        formataValor: function formataValor(valor) {
            var valorRestante = (valor * 100).toFixed();
            if (valorRestante < 10) return valor;
            return __WEBPACK_IMPORTED_MODULE_6__utils_masker__["a" /* default */].maskMoney(valorRestante.toString());
        },
        validacao: function validacao() {
            var _formataInvestimento = this.formataInvestimento(this.valor, this.valorReinvestimento),
                Valor = _formataInvestimento.Valor,
                ReInvestimento = _formataInvestimento.ReInvestimento;

            var error = '';

            error = this.aviso(this.usuario, this.investidor);

            this.valorMaximo(Valor, this.investimentoMaximo) ? '' : error = 'Valor limite para essa oportunidade ultrapassado';
            this.valorMinimo(Valor, ReInvestimento, this.solicitacao) ? '' : error = 'Valor de investimento deve ser maior que o valor mínimo';
            this.valorMultiplo(Valor, this.solicitacao) ? '' : error = 'Valor de investimento deve ser múltiplo do valor mínimo';

            this.valorBoleto(Valor, ReInvestimento) ? '' : error = 'Valor de reinvestimento deve ser R$ 1,00 menor ou igual que o valor de investimento';
            this.reinvestimentoMaximo(Valor, ReInvestimento) ? '' : error = 'Valor de reinvestimento não pode ser maior que o valor de investimento';
            this.saldoReinvestimento(this.saldo, ReInvestimento) ? '' : error = 'Saldo insuficiente para reinvestimento desejado';

            this.reinvestimentoInicial = false;
            return error;
        },
        validacaoCampanhaReinvestimento: function validacaoCampanhaReinvestimento() {
            var _this10 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
                var _formataInvestimento2, Valor, ReInvestimento, error;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _formataInvestimento2 = _this10.formataInvestimento(_this10.valor, _this10.valorReinvestimento), Valor = _formataInvestimento2.Valor, ReInvestimento = _formataInvestimento2.ReInvestimento;


                                Valor = ReInvestimento;

                                error = '';


                                _this10.solicitacao.InvestimentoMinimo = 50.00;

                                error = _this10.aviso(_this10.usuario, _this10.investidor);

                                _this10.valorMaximo(Valor, _this10.saldo) ? '' : error = 'Valor limite para essa oportunidade ultrapassado';
                                _this10.valorMinimo(Valor, ReInvestimento, _this10.solicitacao) ? '' : error = 'Valor de investimento deve ser maior que o valor mínimo';

                                _this10.valorBoleto(Valor, ReInvestimento) ? '' : error = 'Valor de reinvestimento deve ser R$ 1,00 menor ou igual que o valor de investimento';
                                _this10.reinvestimentoMaximo(Valor, ReInvestimento) ? '' : error = 'Valor de reinvestimento não pode ser maior que o valor de investimento';
                                _this10.saldoReinvestimento(_this10.saldo, ReInvestimento) ? '' : error = 'Saldo insuficiente para reinvestimento desejado';
                                _this10.valorInteiro(ReInvestimento) ? '' : error = 'Valor investido não pode conter centavos.';
                                _context10.next = 13;
                                return _this10.valorMultiploCampanha(ReInvestimento);

                            case 13:
                                if (!_context10.sent) {
                                    _context10.next = 17;
                                    break;
                                }

                                '';
                                _context10.next = 18;
                                break;

                            case 17:
                                error = 'Valor investido deve ser múltiplo de R$ 50,00.';

                            case 18:

                                _this10.reinvestimentoInicial = false;
                                return _context10.abrupt('return', error);

                            case 20:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this10);
            }))();
        },
        aviso: function aviso(usuario, investidor) {
            var mensagem = '';
            this.investidorAprovado(investidor) ? '' : mensagem = 'Falta pouco! Seu cadastro de investidor está em análise, retornaremos em até 1 dia útil.';
            this.suitabilityCompleto(usuario) ? '' : mensagem = 'Complete seu formulário de suitability antes de investir';
            this.investidorCompleto(usuario) ? '' : mensagem = 'Complete seu cadastro de investidor antes de investir';
            this.bloqueado(investidor) ? mensagem = 'Cadastro bloqueado, entre em contato conosco para mais informações' : '';
            return mensagem;
        },

        // Servicos de Validacao
        bloqueado: function bloqueado(investidor) {
            if (investidor == null || investidor.Bloqueio == undefined) return false;

            var FimBloqueio = new Date(this.investidor.Bloqueio.FimBloqueio);

            return FimBloqueio.setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0);
        },
        suitabilityCompleto: function suitabilityCompleto(usuario) {
            return usuario.hassuitability == undefined ? false : usuario.hassuitability;
        },
        investidorCompleto: function investidorCompleto(usuario) {
            return usuario.hasinvestor == undefined ? false : usuario.hasinvestor;
        },
        investidorAprovado: function investidorAprovado(investidor) {
            return investidor != null && investidor.Status == "APROVADO" ? true : false;
        },
        valorInteiro: function valorInteiro(valor) {

            var valorStr = valor.toString();

            if (!valorStr.includes(".")) {
                return true;
            }

            var decimal = valorStr.split(".")[1];

            return decimal !== '00' ? false : true;
        },
        valorMaximo: function valorMaximo(valor, InvestimentoMaximo) {
            return valor <= InvestimentoMaximo;
        },
        valorMinimo: function valorMinimo(valor, reinvestimento, solicitacao) {
            var resp = false;
            if ((valor - reinvestimento >= 1 || valor == reinvestimento) && solicitacao.InvestimentoMinimo <= valor) resp = true;
            return resp;
        },
        valorBoleto: function valorBoleto(valor, reinvestimento) {
            var resp = false;
            valor - reinvestimento >= 1 || valor == reinvestimento ? resp = true : '';
            return resp;
        },
        valorMultiplo: function valorMultiplo(valor, solicitacao) {
            var resp = false;
            if (valor % solicitacao.InvestimentoMinimo == 0) resp = true;
            return resp;
        },
        valorMultiploCampanha: function valorMultiploCampanha(valor) {
            var _this11 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11() {
                var validoBackend;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_8__utils_api_client_go__["a" /* default */].CheckCampanhaReinvestimentoMultiplo(valor);

                            case 2:
                                validoBackend = _context11.sent;
                                return _context11.abrupt('return', validoBackend ? valor % 50 == 0 : false);

                            case 4:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, _this11);
            }))();
        },
        reinvestimentoMaximo: function reinvestimentoMaximo(valor, reinvestimento) {
            var resp = false;
            reinvestimento <= valor ? resp = true : '';
            return resp;
        },
        saldoReinvestimento: function saldoReinvestimento(saldo, reinvestimento) {
            var resp = false;
            reinvestimento <= saldo ? resp = true : '';
            return resp;
        },

        // Metodos para renderizacao
        geraValoresInvestimentos: function geraValoresInvestimentos(solicitacao, InvestimentoMaximo) {
            var valores = [];
            var numeroValores = Math.floor(InvestimentoMaximo / solicitacao.InvestimentoMinimo);
            for (var i = 1; i <= numeroValores; i++) {
                var valor = i * solicitacao.InvestimentoMinimo;
                valor = this.formataValor(valor);
                valores = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(valores), [valor]);
            }
            return valores;
        },
        redirecionaAba: function redirecionaAba(solicitacao, reservaStatus, hoje) {
            var status = 1;
            var fimCaptacao = new Date(solicitacao.FimCaptacao);
            // Lista de espera
            solicitacao.Valor == solicitacao.ValorCaptado || solicitacao.ChamadaListaEspera ? status = 4 : '';
            // Reservado
            if (reservaStatus == 1 || reservaStatus == 2) {
                status = 5;
                this.$emit('updateValor', this.formataValor(this.reservaInvestimento.Valor));
            }
            // Encerrado
            solicitacao.Encerrado || fimCaptacao.setHours(0, 0, 0, 0) < hoje.setHours(0, 0, 0, 0) ? status = 6 : '';
            return status;
        }
    },

    created: function created() {
        var _this12 = this;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12() {
            var hoje;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            // ajuste emergencial
                            if (typeof _this12.solicitacao._id == 'undefined') _this12.solicitacao._id = _this12.solicitacao.id;

                            _this12.nomeUsuario = _this12.usuario.name.split(' ')[0];

                            _context12.next = 4;
                            return _this12.getReserva(_this12.solicitacao._id);

                        case 4:
                            _this12.reservaInvestimento = _context12.sent;
                            hoje = new Date();

                            _this12.aba = _this12.redirecionaAba(_this12.solicitacao, _this12.reservaStatus, hoje);
                            _this12.valores = _this12.geraValoresInvestimentos(_this12.solicitacao, _this12.investimentoMaximo);
                            if (_this12.aba != 5) {
                                _this12.valorInicial ? _this12.valorSelecionado = _this12.valorInicial.replace('R$ ', '') : _this12.valorSelecionado = _this12.valores[0];
                            }

                            _context12.next = 11;
                            return _this12.getSaldo();

                        case 11:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12);
        }))();
    }
});

/***/ }),

/***/ "TYgC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35d3fb08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialNetwork_vue__ = __webpack_require__("wOxi");
function injectStyle (ssrContext) {
  __webpack_require__("0Do8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35d3fb08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35d3fb08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialNetwork_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TbH6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer-login"},[_c('div',{staticClass:"rodape"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"txtsm"},[_vm._v("©2020 IOUU - Todos os direitos reservados")]),_vm._v(" "),_c('div',{staticClass:"contacts"},[_c('b',[_vm._v("Contatos:")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"contact-link",attrs:{"href":"mailto:meajuda@iouu.com.br","target":"_blank"}},[_c('svg',{staticClass:"bi bi-envelope",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z"}})]),_vm._v(" \n            meajuda@iouu.com.br\n          ")])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"contact-link",attrs:{"href":"https://wa.me/551148580862","target":"_blank"}},[_c('svg',{staticClass:"bi bi-whatsapp",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"}})]),_vm._v(" \n            +55 (11) 4858-0862\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Td74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




var dateHelper = function () {
    function dateHelper() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, dateHelper);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(dateHelper, null, [{
        key: "parseIntDate",
        value: function parseIntDate(date) {
            var aux = date.split("/").reverse();
            var arrayDate = [];

            for (var value in aux) {
                arrayDate.push(parseInt(aux[value]));
            }

            return arrayDate;
        }
        // recebe data no formato yyyy-mm-dd e retorna dd MM yyyy

    }, {
        key: "formataDataString",
        value: function formataDataString(dataIso) {
            var data = new Date(dataIso);
            var mes = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
            return data.getDate() + ' ' + mes[data.getMonth()] + ' ' + data.getFullYear();
        }
        // recebe duas datas no formato yyyy-mm-dd

    }, {
        key: "comparaDataString",
        value: function comparaDataString(data, hoje) {
            var separador = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '-';
        }
    }]);

    return dateHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (dateHelper);

/***/ }),

/***/ "Tdp/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statistics"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center statistics__intro hide-mobile"},[_vm._m(1),_vm._v(" "),(this.Renderizou == true)?_c('div',{staticClass:"col-12 text-center"},[_c('h4',[_vm._v("Dados atualizados em "+_vm._s(_vm.Atualizacao(this.Estatistica.Created)))])]):_vm._e()]),_vm._v(" "),(this.Renderizou == true)?_c('div',{staticClass:"row hide-mobile"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"statistics__numbers p-4 mt-4 mb-4"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12 col-md-6 d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"text"},[_vm._v("Valor total em solicitações de empréstimos")]),_vm._v(" "),_c('div',{staticClass:"numbers"},[_c('span',{staticClass:"text-back"},[_vm._v("R$")]),_vm._v(" "),_c('span',{staticClass:"number-front"},[_vm._v(_vm._s(_vm.money(this.Estatistica.TotalEmprestimos)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 d-flex justify-content-center align-items-center"},[_c('span',{staticClass:"text"},[_vm._v("Total emprestado")]),_vm._v(" "),_c('div',{staticClass:"numbers"},[_c('span',{staticClass:"text-back"},[_vm._v("R$")]),_vm._v(" "),_c('span',{staticClass:"number-front"},[_vm._v(_vm._s(_vm.money(this.Estatistica.TotalInvestido)))])])])])])])]):_vm._e(),_vm._v(" "),(this.Renderizou == true)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4"},[_c('div',{staticClass:"statistics__numbers--item p-3 p-md-4 mb-4"},[_c('label',[_vm._v("Número de solicitações")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(this.Estatistica.NumeroSolicitacoes))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('div',{staticClass:"statistics__numbers--item p-3 p-md-4 mb-4"},[_c('label',[_vm._v("Valor médio do empréstimo")]),_vm._v(" "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.ValorMedioEmprestimo)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('div',{staticClass:"statistics__numbers--item p-3 p-md-4"},[_c('label',[_vm._v("Faturamento médio dos solicitantes")]),_vm._v(" "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.FaturamentoMedioSolicitantes)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('div',{staticClass:"statistics__numbers--item p-3 p-md-4 mb-4"},[_c('label',[_vm._v("Número de empréstimos realizados")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(this.Estatistica.NumeroEmprestimosRealizados))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('div',{staticClass:"statistics__numbers--item p-3 p-md-4"},[_c('label',[_vm._v("Valor médio do empréstimo realizado")]),_vm._v(" "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.ValorMedioEmprestimoRealizado)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('div',{staticClass:"statistics__numbers--item p-3 p-md-4"},[_c('label',[_vm._v("Spread médio")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.money(this.Estatistica.SpreadMedio))+" %")])])])]):_vm._e(),_vm._v(" "),(this.Renderizou == true)?_c('div',{staticClass:"row justify-content-center mt-5 mb-5 hide-mobile"},[_c('div',{staticClass:"col-12 col-md-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 text-center"},[_c('h3',[_vm._v("Propósito")]),_vm._v(" "),_c('canvas',{staticStyle:{"margin-top":"10%","margin-bottom":"10%"},attrs:{"id":"GraficoProposito","width":"269px","height":"180px"}}),_vm._v(" "),_c('ul',{staticClass:"legend legend-doughnutchart-proposito"},[_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Expansão da empresa ("+_vm._s(_vm.porcentagem(this.Estatistica.Proposito[0]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Capital de giro ("+_vm._s(_vm.porcentagem(this.Estatistica.Proposito[1]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Compra de estoque ("+_vm._s(_vm.porcentagem(this.Estatistica.Proposito[2]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Refinanciamento de dívidas ("+_vm._s(_vm.porcentagem(this.Estatistica.Proposito[3]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Aquisição de máquinas e equipamentos ("+_vm._s(_vm.porcentagem(this.Estatistica.Proposito[4]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet",staticStyle:{"background-color":"#2DC2BF"}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Outros ("+_vm._s(_vm.porcentagem(this.Estatistica.Proposito[5]))+"%)")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 text-center"},[_c('h3',[_vm._v("Idade das Empresas")]),_vm._v(" "),_c('canvas',{staticStyle:{"margin-top":"10%","margin-bottom":"10%"},attrs:{"id":"GraficoIdade","width":"269px","height":"180px"}}),_vm._v(" "),_c('ul',{staticClass:"legend legend-doughnutchart-proposito"},[_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Até 1 ano ("+_vm._s(_vm.porcentagem(this.Estatistica.Idade[0]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("de 2 a 3 anos ("+_vm._s(_vm.porcentagem(this.Estatistica.Idade[1]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("de 4 a 5 anos ("+_vm._s(_vm.porcentagem(this.Estatistica.Idade[2]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("de 6 a 7 anos ("+_vm._s(_vm.porcentagem(this.Estatistica.Idade[3]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("de 8 a 9 anos ("+_vm._s(_vm.porcentagem(this.Estatistica.Idade[4]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet",staticStyle:{"background-color":"#2DC2BF"}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Acima de 10 anos ("+_vm._s(_vm.porcentagem(this.Estatistica.Idade[5]))+"%)")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 text-center"},[_c('h3',[_vm._v("Tipo do empréstimo")]),_vm._v(" "),_c('canvas',{staticStyle:{"margin-top":"10%","margin-bottom":"10%"},attrs:{"id":"GraficoTipoEmprestimo","width":"269px","height":"180px"}}),_vm._v(" "),_c('ul',{staticClass:"legend legend-doughnutchart-tipo-loan"},[_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Empréstimo Coletivo ("+_vm._s(_vm.porcentagem(this.Estatistica.TipoEmprestimo[0]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Empréstimo de Impacto ("+_vm._s(_vm.porcentagem(this.Estatistica.TipoEmprestimo[1]))+"%)")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Empréstimo Social ("+_vm._s(_vm.porcentagem(this.Estatistica.TipoEmprestimo[2]))+"%)")])])])])])])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),(this.Renderizou == true)?_c('div',{staticClass:"row justify-content-center statistics__intern--data mt-5 mb-5"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-10"},[_c('div',{staticClass:"row text-center"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v(_vm._s(this.Estatistica.IdadeMediaEmpresas)+" anos")]),_vm._v(" "),_c('label',[_vm._v("de atividades")]),_vm._v(" "),_c('p',[_vm._v("As empresas que se financiam atravéz da IOUU, têm em média "+_vm._s(this.Estatistica.IdadeMediaEmpresas)+" anos de atividade.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.ReceitaMediaEmpresas)))]),_vm._v(" "),_c('label',[_vm._v("de receita")]),_vm._v(" "),_c('p',[_vm._v("Valor de receita anual média das empresas que obtém um empréstimo através da IOUU.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v(_vm._s(_vm.money(this.Estatistica.AutonomiaFinanceira))+"%")]),_vm._v(" "),_c('label',[_vm._v("autonomia financeira")]),_vm._v(" "),_c('p',[_vm._v("Em média, "+_vm._s(_vm.money(this.Estatistica.AutonomiaFinanceira))+"% dos ativos das empresas são financiados com capital próprio.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 text-center p-4"},[_c('p',{staticClass:"small"},[_vm._v("Última atualização: "+_vm._s(_vm.Atualizacao(this.Estatistica.Created)))])])])])]):_vm._e(),_vm._v(" "),(this.Renderizou == true)?_c('div',{staticClass:"row statistics__intern--investor mt-5 mb-4 hide-mobile"},[_vm._m(3)]):_vm._e(),_vm._v(" "),(this.Renderizou == true)?_c('div',{staticClass:"row mt-5 mb-4 hide-mobile"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row align-items-center"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-5 d-flex justify-content-end"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"form-check pr-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Valor),expression:"Valor"}],staticClass:"option-input radio",attrs:{"id":"valor","type":"radio","name":"tipo"},domProps:{"value":true,"checked":true,"checked":_vm._q(_vm.Valor,true)},on:{"click":function($event){return _vm.EscondeGrafico('GraficoEmprestimosRealizadosPorcentagem', 'GraficoEmprestimosRealizados')},"change":function($event){_vm.Valor=true}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor"}},[_vm._v("Por montante")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Valor),expression:"Valor"}],staticClass:"option-input radio",attrs:{"id":"num","type":"radio","name":"tipo"},domProps:{"checked":_vm._q(_vm.Valor,null)},on:{"click":function($event){return _vm.EscondeGrafico('GraficoEmprestimosRealizados', 'GraficoEmprestimosRealizadosPorcentagem')},"change":function($event){_vm.Valor=null}}}),_vm._v(" "),_c('label',{attrs:{"for":"num"}},[_vm._v("Por percentual")])])])])]),_vm._v(" "),_c('div',{staticClass:"row statistics__intern--table"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover"},[_vm._m(5),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Empréstimo coletivo")]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.EmprestimosOriginados[0])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.EmprestimosOriginadosPorcentagem[0]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Repagamento[0])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.RepagamentoPorcentagem[0]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.PagamentosPendentes[0])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.PagamentosPendentesPorcentagem[0]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atual[0])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.AtualPorcentagem[0]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Carencia[0])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.CarenciaPorcentagem[0]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atraso15[0])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.Atraso15Porcentagem[0]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atraso30[0])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.Atraso30Porcentagem[0]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atraso60[0])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.Atraso60Porcentagem[0]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atraso61[0])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.Atraso61Porcentagem[0]))+" %")])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Empréstimo de impacto")]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.EmprestimosOriginados[1])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.EmprestimosOriginadosPorcentagem[1]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Repagamento[1]))+" ")]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.RepagamentoPorcentagem[1]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.PagamentosPendentes[1])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.PagamentosPendentesPorcentagem[1]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atual[1])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.AtualPorcentagem[1]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Carencia[1])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.CarenciaPorcentagem[1]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atraso15[1])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.Atraso15Porcentagem[1]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atraso30[1])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.Atraso30Porcentagem[1]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atraso60[1])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.Atraso60Porcentagem[1]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atraso61[1])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.Atraso61Porcentagem[1]))+" %")])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Empréstimo social")]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.EmprestimosOriginados[2])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.EmprestimosOriginadosPorcentagem[2]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Repagamento[2])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.RepagamentoPorcentagem[2]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.PagamentosPendentes[2])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.PagamentosPendentesPorcentagem[2]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atual[2])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.AtualPorcentagem[2]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Carencia[2])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.CarenciaPorcentagem[2]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atraso15[2])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.Atraso15Porcentagem[2]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atraso30[2])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.Atraso30Porcentagem[2]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atraso60[2])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.Atraso60Porcentagem[2]))+" %")])]),_vm._v(" "),_c('td',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.Atraso61[2])))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.Atraso61Porcentagem[2]))+" %")])])])]),_vm._v(" "),_c('tfoot',[_c('th',[_vm._v("Total")]),_vm._v(" "),_c('th',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.TotalEmprestimosOriginados)))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.TotalEmprestimosOriginadosPorcentagem))+" %")])]),_vm._v(" "),_c('th',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.TotalRepagamento)))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.TotalRepagamentoPorcentagem))+" %")])]),_vm._v(" "),_c('th',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.TotalPagamentosPendentes)))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.TotalPagamentosPendentesPorcentagem))+" %")])]),_vm._v(" "),_c('th',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.TotalAtual)))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.TotalAtualPorcentagem))+" %")])]),_vm._v(" "),_c('th',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.TotalCarencia)))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.TotalCarenciaPorcentagem))+" %")])]),_vm._v(" "),_c('th',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.TotalAtraso15)))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.TotalAtraso15Porcentagem))+" %")])]),_vm._v(" "),_c('th',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.TotalAtraso30)))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.TotalAtraso30Porcentagem))+" %")])]),_vm._v(" "),_c('th',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.TotalAtraso60)))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.TotalAtraso60Porcentagem))+" %")])]),_vm._v(" "),_c('th',[(this.Valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(this.Estatistica.TotalAtraso61)))]):_c('span',[_vm._v(_vm._s(_vm.porcentagem(this.Estatistica.TotalAtraso61Porcentagem))+" %")])])])])])])])])]):_vm._e(),_vm._v(" "),(this.Renderizou == true)?_c('div',{staticClass:"row mt-5 mb-4 hide-mobile"},[_c('div',{staticClass:"col-12"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"row statistics__intern--table"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-score table-hover rating"},[_vm._m(7),_vm._v(" "),_c('tbody',[_c('tr',[_vm._m(8),_vm._v(" "),_c('td',[_vm._v("0,50%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaPorcentagem[0]))+"%")])]),_vm._v(" "),_c('tr',[_vm._m(9),_vm._v(" "),_c('td',[_vm._v("1,50%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaPorcentagem[1]))+"%")])]),_vm._v(" "),_c('tr',[_vm._m(10),_vm._v(" "),_c('td',[_vm._v("3,00%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaPorcentagem[2]))+"%")])]),_vm._v(" "),_c('tr',[_vm._m(11),_vm._v(" "),_c('td',[_vm._v("5,00%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaPorcentagem[3]))+"%")])]),_vm._v(" "),_c('tr',[_vm._m(12),_vm._v(" "),_c('td',[_vm._v("10,00%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaPorcentagem[4]))+"%")])]),_vm._v(" "),_c('tr',[_vm._m(13),_vm._v(" "),_c('td',[_vm._v("30,00%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaPorcentagem[5]))+"%")])]),_vm._v(" "),_c('tr',[_vm._m(14),_vm._v(" "),_c('td',[_vm._v("50,00%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaPorcentagem[6]))+"%")])])])]),_vm._v(" "),_vm._m(15)])])])])]):_vm._e(),_vm._v(" "),(this.Renderizou == true)?_c('div',{staticClass:"box hide-mobile"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"d-flex align-items-start flex-column box-item"},[_vm._m(16),_vm._v(" "),_c('div',{staticClass:"foot align-self-end"},[_c('div',{staticClass:"row no-gutters align-items-center"},[_c('div',{staticClass:"col-12 foot-item"},[_c('div',{staticClass:"p-3 p-md-4 text-center"},[_c('p',{staticClass:"small"},[_vm._v("\n                                        Em 2018 as maiores taxas de inadimplência foram registradas "+_vm._s(this.Estatistica.PrimeiroMaior.Estado)+" ("+_vm._s(_vm.money(this.Estatistica.PrimeiroMaior.Valor))+"%) "),(this.Estatistica.SegundoMaior.Valor != -1.0)?_c('span',[_vm._v("e "+_vm._s(this.Estatistica.SegundoMaior.Estado)+" ("+_vm._s(_vm.money(this.Estatistica.SegundoMaior.Valor))+"%)")]):_vm._e(),(this.Estatistica.PrimeiroMenor.Valor != 100.0)?_c('span',[_vm._v(",\ne as menores taxas, "+_vm._s(this.Estatistica.PrimeiroMenor.Estado)+" ("+_vm._s(_vm.money(this.Estatistica.PrimeiroMenor.Valor))+"%) "),(this.Estatistica.SegundoMenor.Valor != 100.0)?_c('span',[_vm._v("e "+_vm._s(this.Estatistica.SegundoMenor.Estado)+" ("+_vm._s(_vm.money(this.Estatistica.SegundoMenor.Valor))+"%)")]):_vm._e()]):_vm._e(),_vm._v(".\n                                    ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"p-3 p-md-4 loan__map box-item"},[_c('h4',[_vm._v("Taxa de inadimplencia por estado")]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 620.918 647.783"}},[_c('g',{attrs:{"id":"brasil-estados","data-name":"mapa brasil estados","stroke":"#ffffff","transform":"translate(-886.639 -2076.652)"}},[_c('path',{class:_vm.DensidadeInadimpleciaEstado('AC'),attrs:{"id":"ac","d":"M31.125,238.614l-2.107-.041.547-1.833-.213-.841-.253-.5-1.266-.709-.142-.456.273-1.165-.78-1.975-1.1-.648-5.672-1.266-7.435-.192.273-.567,2.522-2.289.9-1.246.294-1.215-.223-1.246-.689-.922-.841-.446-1.7-2.988-.78-.446-.912-.192-1.145-1.145-.932-2.411-2.026-1.55-.993-3.667L5.844,207l-1.9-1.094-.081-1.185.82.1L5.1,204.3l.071-.679-.2-.425-2.147-.942-.365-.669-2.2-1.914.041-.375.628-.051.506-1.337-.01-1.327,3.049-.4.506-.4-.223-1.367-1.185-1.59h0l18.181,7.576,23.965,5.733,12.3,3.18L84.8,223.674l28.877,12.286h0l3.008,1.276h0l-.3.486-1.59.669L112.673,240l-2.9,2.826-1.671.871-.669-.182-1.55.182-.051.567-1.945,1.317-2.107,1-1.459,1.854-.446,1.2-.618.284-1.185-.76-.77-.132-2.4.051-.689.263-.638.456-.365.871-2.471,3.525-3.819,1.266-.851.7-1.965.517-1.043.03.081-2.137-1.378.2-3.6-.78-5.308-.476-5.156.385-.669-.587-2.3-.172-3.606,1.854-2.765.628-1.7-.679-1.418-1.459-1.661,1.175.041-17.776.051-1.114.476-.719.071-2.38-.263-.891.982-1.2.486-1.155-1.175.2-3.008,2.623-1.621,1.023-2.087,2.411-1.975.679-.658,1.094-1.833,1Z","transform":"translate(886.901 2079.395)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-AC')},"mouseout":function($event){return _vm.EscondeEstado('EST-AC')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('AL'),attrs:{"id":"al","d":"M562.219,230.7l-.2-.739-1.438-.79-.456.091-1.033-.294-.547-1.418h0l1.337-1.084.648-1.1,2.2-.77,2.411-3.332.091-.7.831-.608,1.013,1.236,1.692.3,1.094-.122,2.583,2.046,1.924,2.147,1.8,1.064,1.935.486,2.532-.658,3.181.294,1.185-.111,1.884-1.074,1.175.051,1.833-1.124,2.208-2.319.121-.456,1.57-1.256,2.026-.243,2.269.861,2.593-1.307,1.489-.192,1.945.82,2.937.273.273.213h0l-2.816,5.024-4.609,5.2-3.626,3.626-3.079,4.639-3.373,2.917-1.013,2.056-1.337,1.813h0l-.608-1.327-3.636-2.259-.466-.03-1.681-.8-1.783-1.469-1.317-2.482-5.49-3.11-3.727-.962Z","transform":"translate(894.095 2079.739)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-AL')},"mouseout":function($event){return _vm.EscondeEstado('EST-AL')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('AM'),attrs:{"id":"am","d":"M168.178,47.551l.729.79.76.344.618.01,1.145-.425.638.111.061.972,1.226,1.185.982.375.891-.213,1.378.111,1.975.962.5.669-.922,3.363-.719,1.519,2.765,3.788,1.681,4.821.192,2.289.881,1.134.051.456-1.641,1.479.365,1.61.669,1.6-.78,3.079-.577.972.294,5.044.891,2.2,1.236.851.587.912,1.145,4.386-.061.587-1.155,1.337-1.864-.334-.142,1.155,5.075,4.477.527.041,1.985,1.327,1.5,1.671,1.053,2.066.537.071,1.357-.425,2.39,1.053-.446-2.137.76-2.319.253-1.752-.375-1.823.831-3.008,1.033-1.276,1.3-.7,2.117-.719.557-.9,1.621-.061,2.866.942,1.894,2.066.932,2.542,1.843.233,1.266-.466,1.428-1.428,2.056-.557.425-.4.02-.537-1.155-1.428-.233-.739.111-.669,1.165-2.674.071-1.145,1.681-3.069,2.36-3.3-.03-.689,18.728.071h0l.405,4.923-.436,1.469.182,2.3.243.689,1.722.861.182.415-.354.7-.051,2.137,1.854,2.016.365.192.709-.182,1.864,1.246.557,1.854.04.942.3.456,4.7,3.819,4.639,2.573.638.912,1.367,1.1,1.9.679,2.4,1.327,2.289.658,1.378.152,1.337.831.081.618,1.286,1.357,2.735,1.459,1.114,2.2,1.894.8.861-.618,1.4-.354.192.486-.132.79,1.833,1.692-30.285,65.068-.79,1.327-1.469,1.145-.587.983-.03,1.145.831,2.36.385.577,1.084.588,1.6,1.58.648,1.276.152,1.985.577.577h0l-1.2,1.215-.2.618-.061.77.344.851-.273,1.023-1.215,1.843-.871.648-.425.861.1.861.669,1.388.466,1.965-1.4,4.274-1.2,5.287-1.226.739-48.467.324h0l.041-.709-.365-.385-1.408-.284-1.945,1.094-.547,1.762-.689.192-3.282-1.5-.689-2.917-.628-.2-.993.132-.466-.213-1.266-3.312-2.573-.993-1.347-1.286-.81-1.935-.456-.5-2.178-1.145-10.929.061-1.4,2.593-1.742.506.091,1.185-.263.223-2.512.537-1.205,1.61-.051.679.912.709.172.456-.365,1.033-.82,1.165-2.087,1.226-.111,1.833.243,1.479-3.92-.466-2.157.385-1.215,1.084-1.813-.1-.851-.557-.466-.02-1.773,1.276-.537.851.263,1.773-2.573,3.2-.689.081-.689-.537-.648-2.289-.385-.091-1.864,1.033-1.317,1.226-1.388.4-.78-.132-1.094.506-.415.537-.132.729-1.236.8-.375.02-2.34-2.36-.729-.375-2.907.334-4.011-.263.162,1.307-.152.567-1.57,1.833-1.945.587-3.3,2.593h0L84.757,225.545,57.976,211.193l-12.3-3.18-23.965-5.733L3.534,194.7h0l-.071-.658.709-2.958,1.236-1.418,4.983-3.515,2.289-.243.476-.3.993-1.58.081-1.043-1.762-4.548.385-1.205,1.2-2.218,1.3-1.337.932-1.266.425-.993.3-1.762-.294-1.337.679-2.066.314-2.34.739-.76L22.15,161.5l2.218-1.246,1.165-1.053.446-1.418.79-.375L28.2,157.3l1.671-.942,3.586-2.765,2.451-.436,1.529.294,4.244-1.236,1.519-.78,1.843-.365,3.373.385,1.317-1.61.638-1.469,1.1-.618,2.168.2.648.547,1.337-.243,1.114-.75,1.732.122.314.537-.02,1.2,1.631,1.307,2.866.081.587-.405.466-.79-.111-.4,1.185-4.983,6.786-37.649,1.175-2.958-1-5.024.122-.263-1.317-1.064-1.5-2.785-.041-.5.658-1.408-.527-1.8-.375-.405-1.722-.6-3.069-2.38-1.965-2.309.2-11.658,3.94-.263,1.773-1.185L72.076,71l2.715,1.783,1.236.111,1.286-.436-.5-1.712L77.12,69l-1.388-2.127-.577-.547-1.165-.608-1.529.537-2.826-.618-3.616.091L65.958,55.7l.972.041,1.337-.587,2.309-.608,2.877.881,19.275.061-.466-.669-.8-.142-.385-1.215.962-1.955,1.448.405.618,1.54.881,1.337.669.355.841.01,1.631-.618,1.965-2.117.324-.851,1.276-1.256,2.583-1.408,1.307.466,1.185,2.613L108.408,54l.75,1.317.669,1.8.233,1.57-.5,3.677.2,1.783,3.241-.76,8.417,7.151.8.284,2.532.213,2.33-1.013,1.722-1.722,2.137-1.175,2.218-.111.567.294.78,1.094-.02.982-1.124,1.722.375.993.587.273,1.347-.729.567-.922.233-1.307,1.013-1.175.476-.233,1.013.182.557-.182.415-.669.466-2.34.517-.375,1.529-.365,2.968-1.793.983.557.942-.294,1.621-1.053,1.033-1.631,2.137-1.226,2.056.557,2.39-1.671.557-.831.446-2.694-.03-1.307.78-.932,1.043-.425,1.762-.02,1.357-.4,2.087-1.621.972-.375,2.309-.3Z","transform":"translate(886.943 2077.522)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-AM')},"mouseout":function($event){return _vm.EscondeEstado('EST-AM')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('AP'),attrs:{"id":"ap","d":"M345.821,101.068l-.952-.061-.78.344-1.317.122-2.826-.689-1.469-1.043-.436-1.519-1.894-1.408-.111-1.317.213-.7-.314-1.6-.334-.476-.962-.192-.415-.952.081-2.461-2.968-3.322-.79.365-.831-.192L328.2,82.441l.132-1.6-.6-1.833-.628-.567-.679-1.529-.192-2.137.436-3.18-.172-.334-2.6-.739-2.046-2.289-.77-2.866.192-.729.689-.233-.5-1.2-.689.03L317.9,60.542l-.952.142-.385.425-1.347.142-.851-.273-.81-.993-1.155-.851-1.205-.122-.5-1.3-.679-.81-1.955-1.064-1.307-.5-3.434-.375-1.094.294-1.185-.02-.314-.547-.243-1.459.253-4.6.628-1.317-.375-2.33-.628-.577h0l.355-.213,1,.3-.01.82-.294.182.344.982,1.489-.061.831.233.355.912.851.719,2.279.79,3.332.76,2.8-1.8.355-.77,1.752-1.185.841-.294.7.952,2.745.952,1.094-.122,1.742-1.023.122-.425.324.03,1.479,1.317-.2.881,2.4-.172.517.506.962.172.628-.01.922-.486,1.692-1.519,1.8-1.114,1.773-2.33.375-1.013-.2-.547,3.17-6.584.111-1.843,1.124-1.317.739-.192,3.646-5.865.233-1.165.851-1.215,1.813-1.57.638-1.681,2.137-1.155.476-.932,1.053-.587.567,1.479.891,1.378-1.692-4.862-.071-1.307.182-.334,3.413,2.451,1.155,1.226L356.871,19l.527,1.205.03,1.6.446.314.324-.486.385-.1.213.405.213,7.992.669,3.92,2.745,6.128,2.694,9.055,3.363,5.064,1.023.355,3.312-.081,2.816.952,1.307.861.78,2.684-.162,3.373-1.307.972-1.752.436-.385.334,1.813-.152,1.053-.425.284.233.122.6-.172.739-5.095,4.112-1.185,2.127-2.178,1.428-1.965,3.768-2.948,3.545-.709.466-.952-.091-1.469.527L358.6,83.879h0l-1.357.071-.76.912h0L355,86.563l-.982,2.249-1.134,1.894-.851.658-3.049,3.494-.365,2.431.172,1.823-1.975,1.833-.993.122Zm23.661-47.6-.456-.334-1.114-1.884.071-.891.233-.415,1.681-.456.436.4.841,2.3-1,1.114-.689.172ZM372,71.309l-.405-.253-.081-.719,1.124-1.114.891-.152,1.266.243.466-.111.446-.648.051.6-.983,1.459-1,.506Zm3.484-2.907-.79-.233V67.6l.729-1.053,1.266-.1.182.355-.1.517Zm-7.283-18.657-.77-.506.263-.841.891-.172.871.324.01.739Z","transform":"translate(890.768 2077.091)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-AP')},"mouseout":function($event){return _vm.EscondeEstado('EST-AP')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('BA'),attrs:{"id":"ba","d":"M529.042,367.531l-.365-.841.689-1.367-.01-.537-.537-1.053-4.183-3.089-.152-.517.223-1.53-.577-1.246-.658.243-.2.456-.344.182-.223-.253.537-4.457.831-3.343.831-.891,2.5.243,1.033-.719v-.425l-.567-1.033.162-2.684,5.024-4.274,1.489-3.12-.425-1.185-.79-1.033-.9-.061-.739-.385-2.866-2.5-2.147.02-2.218-.608-2.3-1.094-2.765-.567-2.005-.142-1.337,1-1.489.506-2.644-.456-.577.213-.446-4.011-6.6-6.28-.385-.182-4.447,1.246-1.55-1.256-.517.213-.942-.223-2.573-1.236-2.2-1.641-.993.182-4.406-3.677-1.114-.547-2.765-.76-1.793.253-1.9.912-.82,1.134-.648.182-5.4-1.489-.618-.5-.263-1.519.142-.9,1.307-2.775-.871-.466-2.309-.527-2.208-.041-1.215-.506-1.813-.081-3.879,1.6-4.315,3.069-.648,1.124-3.413,1.894-2.046.405-.962,1.2-1.833,1.57-1.448.527-1.013-.152-1.874,2.613-1.053.78-2.158-.385-.729.132-.7,1.013-1.357.932-.405-.243L437.6,319.1l-.517-2.441h0l1.5-2,.253-.78-.233-1.286-.679-1.742.1-.679.719-1.438-.051-.466-3.251-2.654-1.712-3.5-.628-3.565.051-1.57,1.215-3.879,1.611-1.043.233-.385.061-.952-1.651-.851-.111-.334.486-2.552,1.448-1.074-.02-.375-2.755-2.492h0l-.041-.942,1.378-2.411-.041-1.084-.172-.425-1.479-.5-.952-.658-.355-1.276.061-2.958.192-.861,1.975-1.692,1.155-.425.972-.729-.294-.638-.587-.527-.932-.294-1.043.182-.355-.334-.091-.506.425-.972,2.066-.831.567-.456-.041-.77-1.9-.993-3.626-.679-1.884-1.985-.233-.932.506-1.175,1.023-.739,1.54-3.525.912-.618,1.023-.273.355-.385-1.307-1.823.193-.375,3.251-2.654,3.869-2.046.567-.476.223-.993.7-.658h0l2.36-.02,1.459,1.357.668,1.053.537,2.238,1.783,2.522,4.234,1.884,1.823-.527,2.137.182.334-.213.76-1.469,1.155-.375.679-.881,1.185-.9,2.238-.76,1.347.172,1.5.537,1.367-.425,3.008-2.451,2.988-5.115.729-.871.243-.932.3-2.593L474,234.843l-2.269-4.487.051-.942,3.282-1.671,1.975-.02,1.519.466.415.942.324.182,2.147-.436,1.408-.547,1.347.385,1.732,1-.132.658.193.294.831.284,3.039-.111,1.489-.648,1.722-.1.831-1.236,1.53-1.357,2.765-.344.78-.365.82-.993,2.2.01.628.638.314.051,1.884-1.833-.1-2.431,2.016-.385.8.182,1.063-.669,1.519-2.34.466-1.165h0l.9.405,1.175-.273,2.228.294,2.856,1.408.446.517-.061,2.765.729,1.965,2.238.922.274,2.026-.932,1.7,1.854.628.972-.223.831-.932,2.907-.891.78-3.626.506-.881.76-.162.79.537.638.051,2.421-1.033,1.114-1.256.172-.6-.253-1.378.294-.253,2.269-.456.78-2.076,1.671-.446,2.563-1.479.6-.1,1.509.567.841,1.459,1.378.82,2.39.79,3.028.405,1.6,1.165.547,1.671.4.273.436-.152.294-1.773.436-.446,1.013-.01.456.324.02.638-.628.891.456.841.507.375,2.127.871.02.952,1.236,3.089h0l.547,1.418,1.033.294.456-.091,1.448.8.2.729h0l-.679,1.175.213,2.168,1.3,2.532,2.016,1.975.76,1.165-.081,3.16-.669,1.641-.091.891.77,2.785-.3.587-.7.557-2.583,1.013-1.145-.76-1.732-.01-.324.3-.6,1.6.02.78.962,1.621,1.114.669.527,1.509,1.448,1.529.152.4-.132,1.438-.344.4.122.425.6.527,1.955.932.486.719.547.344,1.57.648,2.927-.891h0l.648-.02.365.415-4.133,8.944-3.879,5.257-1.043,2.36-5.095,5.814-2.482,1.276-.881-.01.3-1.448.375-.152.142-1.114-.456-1.955-1.894-.253-.436-1.317-.689-.76-.375.608-.466,2.36-.506.881-.557.385-.567-.294-.5-1.762.111-.324.314-.132-.03-.4-.881,1.307.942,1.712.466.233.375-.152,1.165.263-.466,1.833-1.226,1.165-.253,1.843-1.266.983-.355.679-.2.851.182.861-1.367-.4-.213.4-.365,2.552.365-.729.76.213.243.547-.233.415.061.628.3.3.334,1.013-1.053,2.542.577,3.484-.557.5-.577-.223-.142,1.145.6.466,1.226-1.742-.476-2.238.831-.618.253.547-.061,1.783-.972,2.644-.75,5.5-.516,1.833.2,2.5.79,2.887.192,4.6.881,6.493,1,3.464-2.238,6.746-1.367,6.736-.476,1.023-.162,2.9-1.074,3.768-.091,2.36.4,4.477.9,1.732-2.269,3.018-1.833.679-.952.648-2.755,3.94-.577,2.066h0l-8.194-5.206-.314-.537Zm22.567-79.005-.233-1.215.75-.415,1.074-1.053.162-.648-.375-.739.77.142.831,1.063-.051.537-2.927,2.33Zm-2.563,6.938-.638-.03.01-.679.263-.365-.81-.223-.425-.405.132-1.084,1.894-.152.162.2.111,1.145Z","transform":"translate(892.418 2079.68)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-BA')},"mouseout":function($event){return _vm.EscondeEstado('EST-BA')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('CE'),attrs:{"id":"ce","d":"M574.9,157.519l-4.953,1.611-2.644,2.036-3.342,6.776-.851,1.134-.881.577-.658,1.692.152.75-1.418,2.471-1.479,1.529-.577,1.114-1.043.263-.79-.517-.517.071-.851.891-1.428,2.279-.344,2,.648.172.668-.385h0l-.081.547-.851,1.165-1.043,3.039.527,1.327-.669,1.327-1.1.638-.172.385-.121.942.243.415.587.294.355.729-.02,1.681,1.256.9.7.081.344,1.205-1.631,3.535-1.205,1.134.172.253h0l-1.611.5-1.084.841-1.56,2.32-1.671.051-.638-1.661-.79-.577-1.378-.486-1.023-1.084-.466-1-1.854-.841-2.887-1.924-3.12-.425-1.307.1-2.168.81-1.651.192-.9-.243-4.994-.2h0l.061-1.337-.689-.689-.081-.982,1.155-3.15,1.519-2.279.01-.7-.78-1.175-2.593-.476-1.327-.658-1.023-2.7-1.064-5.267-.77-2.6.243-.456-.952-8.265-.111-.385-.932-.7.81-.587.6-1.6-.608-3.029-1.013-2.036.486-1.621-.8-3.92.749-1.378.02-.77-1.378-1.61-.446-1.752-3.191-6.5-1.823-4.781-.294-1.307.182-1.479,1.6-2,1.1-1.874.111-.81h0l.192-.142-.041-.628-.405-.669.658-.82,6.827-.223,2.927-.436,2.1-.669,7.5.8,2.147,1.134,1.965,1.519,4.173,2.208,1.479.527,4.882,3.039,1.226.2,2.249,2.32,3.029,2.137,2.6.729,2.471,2.947,1.236.618,3,3.859,4.214,3.12,1.479,2.026,1.053,1,1.519.831,1.165.03,2.4.932.8.679Z","transform":"translate(893.451 2078.527)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-CE')},"mouseout":function($event){return _vm.EscondeEstado('EST-CE')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('DF'),attrs:{"id":"df","d":"M417.169,334.245l-14.879-.02-.527-3.3.932-1.854.385-3.778,12.1.01,1.854,2.006.061,2.238-.6,1.205-.213,2.471Z","transform":"translate(892.075 2081.101)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-DF')},"mouseout":function($event){return _vm.EscondeEstado('EST-DF')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('ES'),attrs:{"id":"es","d":"M501.9,412.242l-.294-.142.446-2.37.577-1.317-.6-3.16.162-.425,1.742-2.087,5.216.03.557-.324.982-3.282,1.124-1.286.891-2.32.243-1.742.263-.446,1.256-.871,1.732-2.117.547-3.008-.294-2.461-1.286-2.846-1.114-1.286-.527-.091-.456.294-.77-.284-.5-.719.436-.557,1.5-.091.81.355.982.03.962-.243.324-.425-.172-1.742-1.327-.355-.213-.415.3-1.56.03-1.945-.527-.668-1.347-.679-.3-.709,1.185-1.955,2.2-1.327.314-.02,1.063.75,1.145.111.02-.82-1.692-2.3,1.357.132,2.208-.294.851-.618,1.094-.324,1.6-.081,2.573.82.922.557h0l.3.537,8.2,5.206h0l-.942,3.393-.314,2.9.122,3.636.729,6.229-.314,2.5-1.509,3.221-2.785,1.408-.557.608-1.692,3.373-.993,3.849-.78,1.489-.841-.689-.891-.132-.294,1.3,1.367.527-1.965,4.295-3.494,3.889-.243-.273-1.884.669-.81,1.246-.061,1.408-.425,1.266-1.611,2.046-.294,1.145h0l-1.641-1.074-3.029.375-4.4-1.023-2.532-1.145-.679-4.771Z","transform":"translate(893.361 2081.603)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-ES')},"mouseout":function($event){return _vm.EscondeEstado('EST-ES')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('GO'),attrs:{"id":"go","d":"M418.163,334.867l-.881-1.023.213-2.471.6-1.205-.061-2.238-1.854-2.006-12.1-.01-.385,3.778-.932,1.854.527,3.3,14.879.02h0l-.537,1.54.314,1.59-.689,1.611-1.053,1.266-.415,1.489.861,1.226.861.344,1.438,1.043,1.671,4.619v.608l-2.35,2.745L414.983,356l-.436,2.168,1.1,1.124.912-.476,1.6.577.476.618.182,1.013-.172.719-.739.912-.517,1.914,1.205,3.5-3.13,2.087-1.175.2-.871.912-.486,1.134-4.953,2.775-.709-.78-4.406-1.884-.557.486-.587.091-1.773.01-1.5-.284-3.91.162-2.036-.9-4.183,2.674-2.947,2.958h-.334l-1.327-1.438-1.54-.3-3.231,1.661L375.187,377l-2.512.972-2.259.547-1.428,2.127-1.226,2.492.061,1.013-.851,1.317-.831.284-.851-.162-.456.142-.952.75-1.661,2.127-.577,1.924.567.618-.01.344-.365.233-.871-.466h0l-.243-.456-2.694-2.269-3.191-.618-1.641-1.57-1.924-.435-1.509-.041-3.393-1.357-.689-.861-3.11-1.58-.679-.618-1.459-.719-1.155-.172-2.735-1.7-2.816.162-3.849-.709-.132-.334.263-.851.577-1.185,1.327-1.783-.081-.425-2.279-.912-1.155.679-.668-.193-.284-.415-.233-1.124.263-2.613-.192-1.793h0l-.962-2.228-.182-3.474-1.428-2.218-.162-.719.405-3.454,2.583-3.9.385-2.948.709-.78,2.046-.851,1.945-1.793,1.266-2.046.334-1.975.506-1.023,1.3-1.053.831-1.448.081-1.56,1.772-.983,1.418-2.654,2.684-.132,2.755-.871.324-.284,2.006-4.244.719-.972.648-4.153.385-.75,1.945-1.965,1.671-1.023,1.084-.263,1.246.689,1.226-.739,1.408-1.448.851-2.968,1.185-2.907-.01-.81-.486-1.155.587-2.775,1.621-3.13-.122-5.247,1.226-.79,1.043-2.664,2.026-3.211.4-1.084-.162-2.755.355-.912.983-.871.273-1.145-.081-.638h0l.344-.456.2-1.9.669-1.246,1.833-2.117.567-.3-.03,1.732-1.236,1.9-.527,2.37,2.431.405,2.228,1.043,3.981.405,3.13,1.732,4.122,1.448.638-.233,1.651-6.017,1.489-2.421,1.2-.983,1.165,1.327,1.053,1.9,1.124,3.758.618,3.14,1.155.051.76-.76.3-1.013.567-.547,2.8.344,4.588-.537.223.75-.567,1.58,3.17,1.489,3.393.689.7-.081.517-3.342.557.03,1.53,2.654.466.243,1.8-.912,2.552-2.107,4.588-1.013h1.57l2.593-1.114,1.762-1.357,5.429-1.438h0l2.755,2.492.02.385-1.448,1.074-.486,2.552.1.334,1.651.851-.061.952-.233.385-1.611,1.043-1.205,3.879-.051,1.57.628,3.565,1.722,3.5,3.251,2.654.051.476-.729,1.438-.1.679.679,1.742.233,1.3-.253.78-1.5,2h0l-1.013,1.023-3.272-.344-.912-1.783-2.451-1.5L429.6,314.7l.587,3.819-.577.547-.405.132-2.816-1.155-1.185.233-.375.284-.729,3.221.729.1.5,1.175-.577.952-.739.709.041,1.924.425.618.537.192.7,4.315-.537.537-3.4.912-2.32,1.529Z","transform":"translate(891.08 2080.479)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-GO')},"mouseout":function($event){return _vm.EscondeEstado('EST-GO')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('MA'),attrs:{"id":"ma","d":"M459.663,129.572l-.041.334-2.066,2.178-.436.172-.04,1.459,2-1.722.689-1.226,2.147-1.6.9-1.155,1.043-6.412,1.165-.709,1.124-.122,1.691-.932.658-.132.466.122.081,1.651-.2.456-1.438,1.894L464.15,125.6l-.03.729.739.122.456-.82,1.165-.314.223.841-.6.517.253.3,4.264-5.034.871.334,2.613-.942,4.092.436-.466-2.441.618-.233,2.451.081,1.8.385,2.664,1.064,1.053.111,2.178,1.4,1.418.03,1.276,1.317,1.914,1.337,2.532.587,1.175-.192.567.77.344.051,1.611-.091,2.492.669.263-.912-.679-.476,1.692-.385.577.111-.091.425h0l-.466,1.448.233.729.638.547-.385,1.55-1.813,2.3-4.183,4.021-3.363.466-.81-.162-2.958,3.444.041,1.823-.891,1.854-1.914,1.874-.831,2.005-.648.172-.78,1.064.365,1.945,1.246.841.385,1.3-.284,1.479-1.155,2.907,1.6,2.846.557,3.018-.111,2.461-.213.557-4.153,4.477-.172,2.512.122,2.137.517,2.33,1.8,2.066,1.631.922.172.506.132.851-.4,2.228-.294.446-.121,1.226-.507,1.479-1.226,1.327-2.32.294-.658-.284-.841.041-2.461.871-1.54.111-2.532-1.843-1.023-.213-1.479.192-1.023.608-1.134.263-.233-.3-.851.243-.507.223-1.924,1.935.01.466-.638.881-2.036,2.026-2.37.922-2.907,2.593-1.347.537-1.064.041-1.722,1.55-1.094.365-2.644.324-2.755.77-2.158,1.975-.993,3.008-.4,3.008-.638,2.35-1.469,2.775-.3.223-.344.831-.132,1.54-1.215,2.512L438.9,220.62l-.739,2.026.719,1.965.476,3.221,1.752,3.1-.041.527-.77,1.418-.132,6.442L439,241.8l-.263,1.074-.051,1.945h0l-1.3-.669-.618-.831-.831-.456-1-.294-1.8.2-.719-.182-1.367-2.026-1-2.9-2.157-1.641-.142-1.671,1.661-1.833-.081-.537-3.93-1.975-.628-1.064-.061-1.681-.76-1.61-.952-.7-2.107-.284-.2-.425.263-.719,2.664-2.573-.375-1.327.739-2.715.7-1.448.577-.557,1.357-.547,3.434-.355-.4-1.367.648-3.292-.081-1.783-1.823-1.226-4.325.952-2.178,1.357-2.3-3.059-.922-.861-3.039-4.2-.891.071-.851-1.459.618-1.205-.111-.891-.253-.344-1.388-.243-.425.273-1.955-1.347.182-.719,1.783-.668,1.772-2.066.253-1.61-.284-1.013.314-2.39,1.793-6.239.01-.436-.689-1.155-.233-1.094.213-3.768-.648-1.519-.476-3.535-.851-1.043-3.444-1.459-1.236-.02-.284-.324-.081-1.043-.6-.7-1.762-.294-.972.527-1.418-.091-2.816-1.529-.871-.061-1.985.537L395.4,165.54l-.537.648h0l-.5-.081,14.9-11.982,2.38.233,1.185-.932,1.57-2.2.436-1.165,1.57-1.185.628-2.917,1.134-.466,2.471-2.35.476-1.226.294-1.924,1.621-4.75,1.985-1.56,1.5-1.783.841-1.469.466-1.3-.182-1.843.8-.82-1.053-1.6,3.727-3.13-.132-1.661.506-2.411,1.762-1.59.365-.719.912-3.059.081-1.631-.436-.537-1,.162-.273-.5.051-.628,1.155-.152.577-.75.719-4.447-.162-1.4.476-1.043.78-.456h.638l.243-.243-.061-.547.344-.76.587-.537,1.357.993.456,1.864,1.205.122.78-1.378.618,2.968,1,.041.294-.5.071-.952.861-.041,1.712.537.506.7-1.448,1.722.679.709.02.557,1.226-2.066.5-1.56h.456l.405,1.033v.587l-.881.932-.273,1,.081,2.745.263.334.476.122.587-.142.972-.942-.476-1.013.142-.608,1.337-1.448,1.064-.253,2.157.6,1.519-1.124.051.932-.365.213-1.145,1.55.6.587.1-.375,1.266-.608.587.8-.142,1.226,1.651,1.773.871-.446,1.6.679.78,2.431-.111.962-2.218,2.765-.385.9.1.669.608-1.043,1.773-1.7.841-.03.881.82.527,1.914-.273,1.246-.983.192-1.043.922-1.175,1.509.071.78-1.175,2.38-.628,3.565.213.344.881.233Zm.527.456-.061-.8.537-1.55-.415-1.084.132-.669.922-1.256.557-.192.051,2.38-.223,1.357-.81.608Zm-6.381-26.092-.446-.466-.081-.608.81-1.134.851-.03.689.425.1.344-.192.365Zm3.545,4.234-.294-.3.061-.537,1.074-.9.486.071.506.861-.142.618-.405-.172ZM443.011,103.3l-.213-.051.962-3.626.3.091.03.233-.415,3.1Z","transform":"translate(891.979 2078.183)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-MA')},"mouseout":function($event){return _vm.EscondeEstado('EST-MA')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('MG'),attrs:{"id":"mg","d":"M529.938,366.368l-.922-.557-2.573-.82-1.6.081-1.094.324-.851.618-2.208.294-1.357-.132,1.692,2.3-.02.82-1.145-.111-1.064-.75-.314.02-2.2,1.327-1.185,1.955.3.709,1.347.679.527.669-.03,1.945-.3,1.56.213.415,1.327.354.172,1.742-.324.425-.962.243-.982-.03-.81-.354-1.5.091-.436.557.5.719.77.284.456-.294.527.091L517,382.827l1.286,2.846.294,2.461-.547,3.008L516.3,393.26l-1.256.871-.263.446-.243,1.742-.891,2.319-1.124,1.286-.983,3.282-.557.324-5.216-.03-1.742,2.087-.162.425.6,3.16-.577,1.317-.446,2.37.294.142h0l-2.563,2.38-1.256.273-.567.506.749.709L497.708,423l-1.925,3.758-.091.76,1.459.132.294.618-.213.527-2.563.993-9.633,4.588-1.388.2.02-.466-.5-.172-2.563-.273-.577.061-1.641.952-1.266.162-3.241.081-.365-.324-.517.081-4.153,1.8-1.063.78-1.732.78-.506-.284-2.623.172-2.948,1.357-2.451.75-.689.5h0l-1.266.739-2.228.223-1.955,1.033-1.246,1.256-1.813.679-2.411.253-2.37-.081-.01-.5.355-.5-.091-.355-1.205.334-.182,2.33.243.233-.051.851-.76.993-1.317.324-.577-.436-3.657,1.013-.192-.537-2.036.243-1.134-.253-2.056-3.353,1.236-.719-.527-1.732-1.823-.841-1.813-1.246-.719-1.631.537-1.58.192-3.494-.263-2.978,1.884-2.755.709-2.208.051-1.286-.233-.375-3.748-1.337-1.013.051-.284.365-.79.314-1.631.051.03-.861-.841-2.016-1.317-1.813-.375-2.238-.314-.628-.8-.75.192-1.965,1.54-2.056.061-.567-.405-1.57-1.9-1.226-.587-.618.294-2.4.577-1.023-.2-1.053-3.312-3.393-1.317.294-.861.648-1.671-.79-2.411.111-.314.618.2.466-.446,1-2.816.689-1.124-.436-1.529-1.469-1.023,1.266-8.285.689-.466.486-.486,1.205.273,2.573-.415.446-1.205-.527-.01-2.816-.253-.972-.365-.4-.567-.051-.263.192-.415,1.145-.679.952-.547.324-.628-.02-1.226-2.127-.334-1.438.142-.922-1.7-.8-2.208-1.438-2.016.6-1.641-.223-1.692.355-4.345-.972-2.583-.081-1.752-1.57-.76-.142-1.519.618-1.448,1.712-1.945.375-2.178,1.124-1.236,1.145h0l.314-2.654-.6-3.251,1-4.234.587-.253h0l.871.466.365-.233.01-.344-.567-.618.577-1.924,1.661-2.127.952-.749.456-.142.851.162.831-.284.851-1.317-.061-1.013,1.226-2.492,1.428-2.127,2.259-.547,2.512-.972,3.758.628,3.231-1.661,1.54.3,1.327,1.438h.334l2.947-2.958,4.183-2.674,2.036.9,3.91-.162,1.5.284,1.773-.01.587-.091.557-.486,4.406,1.884.709.78,4.953-2.775.486-1.134.871-.912,1.175-.2,3.13-2.087-1.205-3.5.517-1.914.739-.912.172-.719-.182-1.013-.476-.618-1.6-.577-.912.476-1.1-1.124.436-2.168,3.282-3.049,2.35-2.745v-.608l-1.671-4.619-1.438-1.043-.861-.344L415.34,342l.415-1.489,1.053-1.266.689-1.611-.314-1.59.537-1.54,1.286-.122,2.32-1.529,3.4-.912.537-.537-.7-4.315-.537-.192-.425-.618-.041-1.924.739-.709.577-.952-.5-1.175-.729-.1.729-3.221.375-.284,1.185-.233,2.816,1.155.405-.132.577-.547-.587-3.819,1.185-1.509,2.451,1.5.912,1.783,3.272.344,1.013-1.023h0l.517,2.441-1.448,3.484.405.233,1.357-.922.709-1.013.729-.132,2.157.385,1.053-.78,1.874-2.6,1,.152,1.448-.537,1.833-1.57.962-1.185,2.046-.415,3.413-1.884.648-1.124,4.325-3.069,3.869-1.6,1.823.091,1.215.506,2.208.03,2.309.537.861.466L472,309.7l-.152.9.263,1.509.618.506,5.4,1.479.648-.172.82-1.134,1.9-.9,1.793-.263,2.765.76,1.114.547,4.406,3.687.993-.182,2.2,1.641,2.563,1.236.942.223.517-.213,1.55,1.256,4.447-1.246.385.182,6.6,6.28.446,4.011.577-.213,2.644.456,1.489-.506,1.337-1,2.016.152,2.765.567,2.289,1.094,2.218.618,2.147-.03,2.867,2.5.739.385.9.071.79,1.033.425,1.185-1.489,3.12-5.024,4.274-.152,2.684.567,1.033v.425l-1.033.719-2.512-.243-.831.891-.831,3.342-.537,4.457.223.253.354-.192.2-.456.648-.243.587,1.246-.223,1.529.152.517,4.193,3.1.537,1.053.01.537-.689,1.367Z","transform":"translate(891.523 2080.844)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-MG')},"mouseout":function($event){return _vm.EscondeEstado('EST-MG')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('MS'),attrs:{"id":"ms","d":"M360.651,400.682l-.405,2.492-.284.405-1.519.79-1.337.041-.476.223-1.236,1.043-2.016,2.715-.739.658-1.023.3-.628,1.7-.162,2.968-2.623,3.687-.972.527-.233.385.314,1.955-.081.962L346,423.907l-2.026,2.289.354.861-.284,1.226-1.459,1.043-.405,1.226-1.752,1.712-1.276,2.471-1.975,1.894-7.657,4.588-1.276,1.155-.75,1.56-.851,1.094h0l-5.48,2.3-1.124.831-.942,2.36.02,1.165-1.469,3.606-.679.689L315.294,457l-1.124.324-.334.354-1.59,8.022-.365.831-2.411,1.58h0l-2.583-2.36-3.454-1.914-4.041,2-.689.76-1.681.5-2.613.436-2.39-.466-1.023-.658-.476-4.325-.324-.709-.912-.962-.233-2.5.517-1.357-.648-.8-.091-.446v-2.907l-.9-2-.608-2.775-.051-.729.6-1.378.02-1.631-1.59-1.1-.385-.81-.162-2.188-1.671-1.843-2.2-.263-1.529.314-1.854-.294L276,435.707l-.567-1.509-1.56.334-2.2,2.775-1.013-.608-1.742.82-1.094.162-1.762-.7-2.593-.5-3.5.233L256.263,436l-.486-.922-2.016-.132-.9.527-2.532-.891.922-7.364-.436-2.411.608-1.438.993-1.479.608-6.108-.669-2.36-.051-1.752-.77-.972-.436-.091-.5.658-.648-3.3-.8-1.894-1.226-2.046-.355-1.854,4.082-2.33.77-.891-4.254-3.91,5.449-11.567,1.134-.061-.284-2.157-.75-.132,3.272-10.463.668-1.175-3.13-5.925.03-1.935h0l.709.2,1.033,1.114,2.178,1.54,5.692-2,2.076-2.026,2.046-2.988.091-1.185,1.418-1.469,2.623.03,1.58-.223.78.344,1.681-.517,1.367-1.266,2.046-.5,1.286.2.77,1.165,2.826,1.266,2.654.476.658.355.273.871.79,1.033,3.069,1.175,1.276,1.124,1.256.577,4.578-.638,1.276-.81.5-.861,1.448-.618,2.471.071,1.611,1.053.3,1.388.243.253,1,.041,2.157-.891,1.023.061,5.692-6.087,1.357-.132-1.246,6.7-1.823.709-1.681,2.866-.192.466.152.537,1.317.111,1.762,1.286,4.68.274.577-.577,2.694-.081.881.081,1.185.577,1.57-.314h0l.192,1.793-.263,2.613.233,1.124.284.415.669.192,1.155-.679,2.279.912.081.425-1.327,1.783L331,376.16l-.263.851.132.334,3.849.709,2.816-.162,2.735,1.7,1.155.172,1.459.719.679.618,3.11,1.58.689.861,3.393,1.357,1.509.041,1.924.436,1.641,1.57,3.191.618,2.694,2.269.243.456h0l-.588.253-1,4.234.6,3.251Z","transform":"translate(890.088 2081.454)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-MS')},"mouseout":function($event){return _vm.EscondeEstado('EST-MS')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('MT'),attrs:{"id":"mt","d":"M207.4,297.6l1.489-1.448,4.163-2.6.527-2.482,1.448-3.829.942-1.094,1.661-.537.436-.415.587-.851.527-2.279,1.681-2.036.567-2.269.071-1.732-.587-1.509.041-2.076-1.55-3.383-.912.03-.587-.517-.436-3.292.142-1.337,1.378-1.094,1.418-1.773.172-.76-1.428-3.636-1.084-.436-1.124-.111-3.545.091-1.236-1.124.243-.567-17.381-.051.912-9.116-1.519-2.785-.273-1.783.03-.81,1.013-3.565-.385-1.955.952-1.692-.841-2.3-.152-1.408-.263-.618-.79-.476-.061-.355,1.307-5.054.77-1.438-.608-1.256-1.418-.982h0l48.467-.324,1.226-.739,1.2-5.287,1.4-4.274-.466-1.965-.669-1.388-.1-.861.425-.861.871-.648,1.215-1.843.273-1.023-.344-.851.061-.77.2-.618,1.2-1.215h0l1.185,1.094,2.482,4.112.405,1.783,1.388,4.011,1.337,1.955.78,1.641-.233,2.471.486,2.431.739,2.228,1.55,1.124,3.039,2.785,3.424,1.722.233.952-.041,1.114.233.5.962.405.831-.172,1.651.456.547.729.2,1.094.355.324,1.388-.456,3.738,1.509,34.479,2.451,63.781,3.525h0l-.658,1.033-.567,1.914-1.114,1.266-.446,3.18-.436.861-.375.273-1.965,5.358-.547,3.008-.041,2.988-1.9,6.067.061.871L367,264.186l-.162.881-.831.9-.051.506,1.114,2.279-.476,3.353.01,1.59.527.587.446,3.089-.75,2.8.993,3.383.972.517.81.02h0l.081.638-.273,1.145-.982.871-.355.912.162,2.755-.4,1.084-2.026,3.211-1.043,2.664-1.226.79.122,5.247-1.621,3.13-.587,2.775.486,1.155.01.81-1.185,2.907-.851,2.968L358.51,318.6l-1.226.739-1.246-.689-1.084.263-1.671,1.023-1.945,1.965-.385.749-.648,4.153-.719.972-2.006,4.244-.324.284-2.755.871-2.684.132-1.418,2.654-1.773.983-.081,1.56-.831,1.448-1.3,1.053-.506,1.023L335.578,344l-1.266,2.046-1.945,1.793-2.046.851-.709.78-.385,2.948-2.583,3.9-.405,3.454.162.719,1.428,2.218.182,3.474.962,2.228h0l-1.57.314-1.185-.577-.881-.081-2.694.081-.577.577-4.68-.273-1.762-1.286-1.317-.111-.152-.537.192-.466,1.681-2.866,1.823-.709,1.246-6.7-1.357.132L312.049,362l-1.023-.061-2.157.891-1-.041-.243-.253-.3-1.388-1.61-1.053-2.471-.071-1.448.618-.5.861-1.276.81-4.578.638-1.256-.577-1.276-1.124-3.069-1.175-.79-1.033-.273-.871-.658-.355-2.654-.476-2.826-1.266-.77-1.165-1.286-.2-2.046.5-1.367,1.266-1.681.517-.78-.344-1.58.223-2.623-.03-1.418,1.469-.091,1.185-2.046,2.988-2.076,2.026-5.692,2L257,364.958l-1.033-1.114-.709-.2h0l-.668-.679-.324-.81.547-.719-2.471-2.178-1.3.638-.527-.051-1.185-.689-.456-.709-2.046-1.428-1.914-.77-.3-.324-.3-1.134-.233-2.968-.618-1.793-.192-3.707.891-1.661,1.155-1.1.344-1.8-.051-1.914-.972.061-.405.608-.385.162-27.206-1.094-1.064-12.813-5.439-6.209,4.943-.061-.355-7.647-2.674-5.389-.5-2,.263-1.074.618-.557.658-1.3-1.459-2.968-3.15-1.053Z","transform":"translate(889.393 2079.438)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-MT')},"mouseout":function($event){return _vm.EscondeEstado('EST-MT')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('PA'),attrs:{"id":"pa","d":"M373.051,237.987l-63.781-3.525-34.479-2.451-3.738-1.509-1.388.456-.354-.314-.2-1.1-.557-.729-1.651-.456-.831.172-.962-.4-.233-.506.041-1.114-.233-.952-3.424-1.722-3.039-2.8-1.56-1.124-.729-2.228-.486-2.421.233-2.471-.78-1.651-1.347-1.955-1.388-4-.4-1.783-2.482-4.112-1.2-1.094h0l-.577-.567-.152-1.985-.648-1.276-1.61-1.58-1.084-.587-.375-.577-.841-2.37.03-1.145.587-.982,1.469-1.145.79-1.327,30.285-65.068-1.833-1.692.132-.79-.192-.486-1.408.355-.861.618-1.894-.79-1.114-2.2-2.725-1.469-1.286-1.357-.081-.608-1.337-.831-1.388-.152-2.279-.658-2.411-1.327-1.9-.679-1.367-1.1-.638-.912-4.639-2.573-4.7-3.819-.3-.446-.04-.942-.557-1.854-1.864-1.246-.709.192-.365-.2-1.854-2.006.051-2.137.355-.7-.182-.415-1.712-.861-.243-.689-.182-2.3.436-1.469-.405-4.923h0l-1.61-17.189h0l.76.324.436.587-.02.486.456.405.932.284L238.8,63.3l.476-.82,2.745.233.82-1.064L242.3,59.82l1.813-.365,1.428-1.651,2.674,1.023,1.9.03.547-1.54,3.373-1.641,2,.4,1.175-.111.5-.253,1.215-1.5.405-1.418,1.479-1.114.871-.111.658.466,2.137-1.145.415.111.375,1,.739.456,2.056.486,1.631.253.567-.608,1.692-.4.79.284.831-.01.871-.344,2.269.3,4.73,1.4.972-.142,1.013-.881-.03-2.309-2.1-2.532-1.256-.638.5-1.7,1.327-1.469.284-1.124.314-.172.719.192.841.77,2.38,1.124,11.77-2.36,1.59,1.712,1.033.061.446-.294h0l.628.577.375,2.33-.628,1.317-.253,4.6.243,1.459.314.547,1.185.02,1.094-.294,3.434.375,1.307.5,1.955,1.064.679.81.5,1.3,1.205.122,1.155.851.81.993.851.273,1.347-.142.385-.425.952-.142,2.877,2.694.689-.03.5,1.2-.689.233-.192.729.77,2.866,2.046,2.289,2.6.739.172.334-.435,3.18.192,2.137.679,1.529.628.567.6,1.833-.132,1.6,1.519,3.525.831.192.79-.365,2.968,3.322L335.1,91.22l.415.952.962.192.334.476.314,1.6-.213.7.111,1.317,1.894,1.408.436,1.519,1.469,1.043,2.826.689,1.317-.122.78-.344.952.061h0l-.537.75.294,1.61-.172.537-1.307,1.124-1.408.172-.506-.182-.851-.8-.669-.152-3.424,1.6-.375.547-1.621.729-.638-.02-1.57.6.04.587,6.543-1.074.891.669.132.466v.669l-.628.506.3.365.638-.2.871-1.013,1.033-.01.537-.273.608.122,1.084-.425,1.155-.577,3.322-2.37,1.519-.354,1.864-.82,3.2-1.864.547-1.013.679-.527,2.117-1.023.668-.729-.253-.679.213-.415,1.145-.284,1.1.061.415.213.385,3.849-.527,2.613.334,1.641.82,1.621L366,108.317l.3,1.661-.122.476-1.864,1.864-.476.132-.881-.527-1.843-.527-1.276-.314-.942.142-2.158-1.053-.263-1.134-.891-.537-2.309,3.869-.618,2.4.689,3.008.486.648.932.628-1.023-1.155-.436-2.725.122-.527,2.6-4.274,2.34,1.2.111.456,2.563,2.482-.253,2.046-.75.557.405,2.36.527,1.145,1.134.76.75.152.527.5-.344-.648-.78-.243-1.215-1.053-.223-.689.344-4.254.831-1.205,1.448.739.841,1.215-.091.8,1.215.871.253-.294-1.013-1.276-.932-2.127v-.446l2.289-2.35,1.641.091,1.955.648.344.567-.618.6.324.284.486.03,1.043-.172,1.347-.912,4.143-.972.78.2,1.762,1.074,3.211-.425,1.084-.415,1.033-1.023.993-.6,1.762-.517.78.071.061.76-2.066,4.072-.243,1.519-.466,1.084-.841,1.043-.01.891.587,1.438-.324,2.5.891-1.205.01-1.418,1.56-3.039,1.145-3.231,1.134-1.58.273-.273.77-.051.587-.354,1.843-.233.891-1.367,1.529-1.712,1.378-2.289.527-.466.8.5.628-.466,1.641,2.37,1.205.6-.051-.75-.355-.76.628-1.023,3.555-.517-1.043-.324-3.555.466-.314-.213.294-2.461.517-.294.679.385,1.033.111,1.084-3.14-.689-1.408.03-.689,1.185-1.833,2.877-2.512.365-.081,1.124,1.155,2.968-2.117.466-.071.405.456.1.577-.324.679,1.084-.162.82-.587.365-.79.638-.192.284.152.75,1.408,1.347,1.215.2-.567-.111-.385-.972-.5-.142-.294-.132-1.215.172-.425.446-.192,2.309.263,1.2.658.628,1.033,1.651.719,1.671-.79.537,2.168-.506.314-.03.6.932-.527,1.175-2.38.385.233-.233,1.347.415.446,2.542-.263.456.658.466,1.7-.608.962.861-.506.263.375,1.914.142,3.576-1.256-.314,1.6-.76,1.854,1.489-.5.6-.628.638,1.641h0l-.78.456-.476,1.043.162,1.4L436.761,109l-.577.75-1.155.152-.051.628.273.5,1-.162.436.537-.081,1.631-.912,3.059-.365.719-1.762,1.59-.506,2.411.132,1.661-3.727,3.13,1.053,1.6-.8.82.182,1.843-.466,1.3-.841,1.469-1.5,1.783-1.985,1.56-1.621,4.75-.294,1.924-.476,1.226-2.471,2.35-1.134.466-.628,2.917-1.57,1.185-.436,1.165-1.57,2.2-1.185.932-2.38-.233-14.9,11.982.5.081h0l2.319.82,1.894-.243,1.307.122,1.033,1.681.4.314.881.142,1.276,1.185-.04.638-.375.679-.729.375-.983.071-.294.284.091,1.428,1.023,1.357-.932,2.785-.648.486-1.479.466-.253.466.294,1.215-.193,1.357-1.317.152-1.529,1.357-.861,1.286.152,1.529-.243.506-2.532,1.215-3.454,1.155-2.5,1.8-.192.354.436,2.218.061,2.7-1.3,2.127-1.428,1.7-.152.577.172.891.6.972,1.692,1.762.76.324.152.3-.669,4.092-1.783,5.216-1.094.82-1.722,3.282-.182,1-.952,1.56-.749.861-1.064.162-1.388.932-1.043,1.945-1.226,1.7-1.2,1.1-1.165,1.6-1.145,4.517-1.621,3.707ZM394.483,106l-4.578,1.985-3.434.527-2.046-.314-.658,1.145-1.864,1.205-.729-.618-.618-1.55-.233.284.425,1.246-.344.82-.719.415-3.819-1.661-.81.729-4.244,1.276-3.241-.577-.82-.618-.243-1.874-.233-.415-1.124-1.033-1.074-1.621-.213-1.8.527-2.785.628-.385,1.783.365.942-.76.081-.567-1.317.436-1.236-.132L364.32,99l-.182-1.064.344-5.145.739-.77.355.76,1.783.608.557-.061-.466-.425-1.286-.223-.912-2.188.365-1.7.9-2,1.347-1.347.972-.577,1.357-.5,1.337-.132,3.5.527,7.3,1.793,3.748-.466.111-.3,1.155-.628,2.188-.375,2.927.294,2.836.831,6.563.861.638.476-.051,1.246-.709.75-.689,1.519-.365,2.684-.871,3.343-1.307.689-.355.7.233,1.205L396.388,102l-1.408,3.545-.5.456Zm-47.818-.172-.76-.517,1.114-2.279-.091-1.813.253-.213,2.36-.486.912-.871.152-.506-.2-2.37.871-2.613,1.276-1.509,2.32-1.489,2.907-.2.729,2.39-1.114,2.218-.861,3.079-1.114.679-1.357,2.056-.79.729-5,3.353-1.6.365Zm28.847-23.2-1.043-.253-2.482.081-.8-.162-.294-.263-.385-1.1.01-1.256,1.529-.425,1.914.041,2.218-1.307,4.872-.608.78.263.689.689-.182,1.033-2.593,1.408-1.8,2.512-1.114.506-1.317-1.155Zm4.852,0,1.884-1.215,2.006.03,1.671.628.537,1,.051.628-.891.78-2.887.284-1.185.324-2.289-.9-.2-.537,1.307-1.023Zm-17.2,4.447-.506-.263-.618.04-1.56-.7.213-1.175.648-.932,1.945-.405,2.39-.912,1.337.081.81.689.091.132-1.955,1.631-1.084.344Zm9.541-9.815-.831-.3-.172-1.681.152-.608,1.185-1.327,2.482-.932.253.122.537.689.041.9-1.975,2.016ZM358.7,97.743l-.142-.415.192-.942,1.053-2.846,2.623-1.712.729-.284.7.142-.162,1.813-1.58.446-1.641,2.218Zm11.051-17.8-1.205-.314-.3-.486.891-.972.719-4,.9-1.246.294.132.071.324-.02,2.512.608,1.894-.324.891-1.043.405-.587.861Zm-15,10.321-.273-.192.122-.618.557-.365,1.205-1.732.77-1.56.739-.669,1.469-.547-.2,1.509-.405,1.013-1.742,1.681-2.238,1.479ZM368.8,83.147,368.189,83l-.851-.719-.972-1.661-.051-.385.233-.294.82-.587,1.874.851.294.436.243,2.117-.983.4ZM363.347,114.1l-.658-.111-.891-.527-.7.466-.76-.284-1.7-1.762v-.618l1.3-.01,3.1,1.337Zm-21.423-5.611.041-1.043-.2-.3.608-1,2.39-.891.79.385.881.871-.294.355-1.043.476-2.573.415-.6.739Zm12.864-6.776-.182-.03.01-.355.547-.952,1.813-1.641.425-1.256.051-1.317.243-.3.324.446v1.529l-.9,2.765-.628.658-1.7.456Zm6.381-10.028,1.671-3,.891-.213.719.192.273.881-.587.719ZM392.994,110.9l-.851-.355-.344-1.074,1.053-1.742,1.084-.334.192.1-.02.75-.75,2.269-.365.385ZM359.083,91.179l-.547-.2.324-2.066,1.347-1.833.233.041,1.307.891-.01.253-1.57.648Zm2.259,5.095.729.03-.405.456-.952.314-.111,1.134-.8.719-1.712.851-.162-.182.273-.841.476-.638,1.752-1.692.912-.152Zm-22.851,10.342-.557-.192-.071-.355.436-.405,3.606-1.621.547.709-.01.2-1.418.739Zm64.349-4.842-1.043-.192-.831-.8.881-1.266,1.357-.01.192,1.205-.1.6-.456.466ZM365.11,82.631l-2.39.709-.6.01-.182-.213,1.043-1.053,1.053-.517,1.053.172.446.344.152.233-.152.213-.425.1Zm-5.338,8.7-.081-.77.253-.506,2.512-1.479-.912,2.026-.82.638-.952.091Zm2.168,4.588-.456-.122-.071-.233.79-1.519,1.205.02-.122,1.367-1.347.486Zm28.4,16.034-.284-.233.912-1.621.689-.405.233.76.517.375-.263.527-.436.344-.638-.182-.729.436Zm-27-23.62-.9-.071.02-.192,2.39-1.864.041.972-.233.638-.253.344-1.064.172Zm68.329,10.352-.385-.537.192-.77,1.033-.922.253.152.233,1.773Z","transform":"translate(889.924 2077.458)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-PA')},"mouseout":function($event){return _vm.EscondeEstado('EST-PA')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('PB'),attrs:{"id":"pb","d":"M611.468,199.718l-2.532-2.087-.831-.263-2.684-.213-2.34,1.084-1.5,1.3-.456,1.823L599.2,202.4l-2.036.456-1.155-.02v.608l-.81.537-2.208.294-3.93-.263-1.631.891-.557.648-1.843.1-.9.7-.547.77.4.739.01.547-.405.486-1.8,1.55-1.357.162-1.671.851-1.621-.8-.962-.952-.354-2.269.243-.5-.182-.3-1.155-.324-.446.294-1.529.253.04-.456,2.563-2.674.172-.436-.729-1.894-.04-.476.375-.79,3.039-1.084.111-.3-.506-1.408-3.545-1.945-1.5.415-2.249,1.276-.942,1.529-1.5.881-1.063.314-2.735,1.9-1.54,1.661-1.651.233-2.664.983-.78-.334.051-.689-.638-1.256-.385-.081-.942.739-1.529.324-1-.334-1.418-1.935-.405-.091h0l-.172-.253,1.205-1.134L554,196.011l-.344-1.205-.7-.081-1.256-.9.02-1.681-.354-.729-.587-.294-.243-.415.122-.942.172-.385,1.1-.638.669-1.327-.527-1.327,1.043-3.039.851-1.165.081-.547h0l.577-.466,1.955,1.661.912.425,2.917.618,1.175-1.145,3.272-1.681.831-.719.1-1.053.415-.962,3.221-1.226,1.448-.122,3.3-1.053.648.081.537.446.01,1.205-3.028,3.251-.446.972-.385,1.762-.415.385-.861.253-.213.314-.081,1.742,3.576.527.324.233.314,1.4.294.233,3.191-1.276,1.793-.081,1.975.3.9,1.185-.527,1.56.841.75,2.38-.942.506-.75.557-1.226-.476-.952-.162-1.438.486-.6,1.023.324-.537-1.55-.729-.79.314-1.5,1.844-1.367,1.4-.051.425.395-.1,1.013.628.5,3.464.405.537.355,5.905-.4,2.2.3,2.492,1.114,1.053-.405,3.545.213.942-.243h0l.091,2.431,1.469,4.447.061.648-.182.952-.375.456-.03.891.588-.75.517-1.519.01,2.006.6,1.023-.273,5.247-.365.608Z","transform":"translate(893.992 2079.172)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-PB')},"mouseout":function($event){return _vm.EscondeEstado('EST-PB')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('PE'),attrs:{"id":"pe","d":"M559.173,227.867l-1.236-3.079-.01-.952-2.137-.871-.506-.375-.456-.841.618-.9-.02-.628-.456-.324-1.013.01-.436.446-.294,1.762-.435.152-.4-.263-.547-1.671-1.6-1.165-3.029-.405-2.39-.78-1.367-.82-.841-1.459-1.509-.567-.6.111-2.563,1.479-1.671.446-.78,2.076-2.259.456-.294.253.253,1.378-.172.6-1.114,1.256-2.421,1.043-.648-.061-.78-.537-.77.172-.506.881-.78,3.616-2.907.891-.831.932-.972.233-1.864-.628.932-1.7L520.106,226l-2.239-.922-.729-1.965.061-2.765-.446-.517-2.846-1.4-2.228-.294-1.175.263-.912-.405h0l2.654-1.286,2-1.732.547-.881,2.32-1.347.982-.284,3.94-3.92.75-1.783.061-2.3-.294-.547-1.641-1.6.071-2.218-.608-1.145-.061-.962.111-.456.527-.334,1.813-.162h0l4.993.2.9.243,1.651-.192,2.168-.81,1.307-.1,3.12.425,2.887,1.924,1.854.841.466,1,1.023,1.084,1.377.486.79.577.638,1.661,1.671-.051,1.56-2.319,1.084-.841,1.611-.5h0l.405.091,1.418,1.935,1,.334,1.529-.324.942-.739.385.081.638,1.256-.051.689.78.334,2.664-.983,1.651-.233,1.54-1.661,2.735-1.9,1.064-.314,1.5-.881.942-1.529,2.249-1.276,1.5-.415,3.545,1.945.507,1.408-.111.3-3.039,1.084-.375.79.04.476.729,1.894-.172.436-2.563,2.674-.041.456,1.53-.253.446-.294,1.155.324.182.3-.243.5.355,2.269.962.952,1.621.8,1.671-.851,1.357-.162,1.8-1.55.405-.486-.01-.547-.395-.739.547-.77.9-.7,1.843-.1.557-.648,1.631-.891,3.93.263,2.208-.294.81-.537v-.608l1.155.02,2.036-.456,1.924-1.043.456-1.823,1.5-1.3,2.34-1.084,2.684.213.831.263L612,199.466h0l.891.233.557,1.236-1.286,1.742-.111.557.01.486.709.375.274.506.192,1.074-1.985,6.462-3.292,9.065h0l-.273-.213-2.937-.273-1.945-.82-1.489.192-2.593,1.307-2.269-.861-2.026.243-1.57,1.256-.122.456-2.208,2.32-1.833,1.124-1.175-.051-1.884,1.074-1.185.111-3.181-.294-2.532.658-1.935-.486-1.8-1.064-1.924-2.147-2.583-2.046-1.094.122-1.691-.3-1.013-1.236-.831.608-.091.7-2.411,3.332-2.2.77-.648,1.1Z","transform":"translate(893.464 2079.424)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-PE')},"mouseout":function($event){return _vm.EscondeEstado('EST-PE')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('PI'),attrs:{"id":"pi","d":"M506.842,127.2l1.327.122.7-.233,2.269.517,1,.861.324.608h0l-.111.81-1.1,1.874-1.6,2-.182,1.479.294,1.307,1.823,4.781,3.191,6.5.446,1.752,1.378,1.611-.02.77-.749,1.378.8,3.92-.486,1.621,1.013,2.036.608,3.029-.6,1.6-.81.587.932.7.111.385.952,8.265-.243.456.77,2.6,1.064,5.267,1.023,2.7,1.327.658,2.593.476.78,1.175-.01.7-1.519,2.279-1.155,3.15.081.982.689.689-.061,1.337h0l-1.813.162-.527.334-.111.456.061.962.608,1.145-.071,2.218,1.641,1.6.294.547-.061,2.3-.75,1.783-3.94,3.92-.982.284-2.32,1.347-.547.881-2,1.732-2.654,1.286h0l-.456,1.175-1.519,2.33-1.064.679-.8-.182-2.026.385.111,2.431-1.884,1.823-.324-.051-.628-.628-2.188-.01-.831.993-.78.365-2.765.344-1.529,1.357-.831,1.236-1.722.1-1.5.648-3.039.111-.831-.284-.192-.284.132-.668-1.732-.993-1.347-.4-1.408.557-2.158.436-.324-.182-.415-.942-1.519-.466-1.975.02-3.282,1.671-.061.942,2.269,4.5.122,1.165-.294,2.6-.253.922-.729.871-2.988,5.115-3.008,2.451-1.367.425-1.5-.537-1.357-.172-2.228.76-1.185.9-.679.881-1.155.385-.76,1.469-.334.213-2.137-.182-1.823.527-4.234-1.874-1.793-2.522-.537-2.238L445,246.03l-1.459-1.357-2.36.02h0l-2.978-.213h0l.051-1.945.263-1.074,1.165-2.482.132-6.442.77-1.418.03-.517-1.752-3.1-.476-3.231-.709-1.965.739-2.026,1.722-1.418,1.215-2.512.132-1.529.344-.841.3-.213,1.459-2.775.638-2.35.4-3.008.993-3.018,2.157-1.975,2.755-.77,2.644-.314,1.084-.375,1.722-1.55,1.064-.041,1.357-.527,2.9-2.6,2.37-.922,2.036-2.026.638-.881v-.466l1.924-1.945.506-.223.851-.243.233.3,1.134-.263,1.013-.608,1.479-.192,1.023.213,2.542,1.843,1.529-.1,2.471-.871.841-.04.658.284,2.309-.294,1.226-1.327.506-1.479.122-1.226.294-.446.395-2.228-.132-.861-.172-.506-1.631-.922-1.8-2.056-.517-2.33-.111-2.137L483.2,170l4.153-4.487.213-.557.1-2.461-.557-3.018-1.6-2.836,1.155-2.907.284-1.489-.385-1.286-1.246-.851-.355-1.945.78-1.064.648-.172.831-2.006,1.914-1.874.891-1.854-.041-1.813,2.958-3.454.82.162,3.353-.466L501.3,131.6l1.813-2.3.4-1.55-.648-.537-.223-.729.466-1.459h0l.739.122,1.489.881.516.517-.132.314Z","transform":"translate(892.537 2078.521)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-PI')},"mouseout":function($event){return _vm.EscondeEstado('EST-PI')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('PR'),attrs:{"id":"pr","d":"M398.226,500.42l-5.307-.03-.334.446-1.762.243-.77-.071-.111-.4-1.59.577-1.367,1.448L383.59,504.8l-1.459-.162-1.246-.628-3.17-2.633-1.043-.4-.77-.01-2.877.739-2.36.172-.82-.03-1.438-.77-1.124.142-1.55.658-.6,1.489-.739.881-1.894.993-3.616-.415-2.026,1.165-.729.78-.7,1.61.861,3.028-.881.871-.932.02-.76.385-.172.5-1.347-1.914-4.3.132-3.808-.436-1.6-1.2-.162-.415-1.043-.638-4.315-.365-5.358-1.7-2.37.577-2.725-.03-2.046-1.428-.324-.517-1.074-.243-.537-.01-.719.375-3.677-.02h0l-.223-1.226-2.563-4.234.02-2.623-1-2.917-3.464-2.4-1.1,1.145-2.147-.111-1.114.436-1.084.912-1.479-1.094-.831.061-.284-2.228.669-1.59,1.084-1.286,1.236-2.208.061-.344-.5-.76.02-1.256.912-3.687,1.276-3.059-.253-2.33,1.3-2.411-.213-1.033-.851-.891-.314-1.621.669-1.074.8-.547h0l2.411-1.58.365-.831,1.59-8.022.334-.355,1.124-.324,1.681-1.023.679-.689,1.469-3.606-.02-1.165.942-2.36,1.124-.831,5.48-2.3h0l3.3-2.32,3.879.658,4.062-.111,3.312.294,1.226-.628.354-.608.739-.375,1.185.294,1.5.79,2.552.466,2.674,1.1,1.327.132,1.084-.547,2.613-.01.79,1.013,1.773.851,3.555.81.638.517.719,1.337,1.752.071.425-.344,1.671.152.669.547,5.378.132,3.008-.861,1.145,1.57,3.636,2.866.9,1.783.01,2.775-.4.587-.162.82.385,1.864,1.317,1.529-.081,1.783-.365.567,1.509,3.039,1.226,1.165.679.284.506.689-.051.9.932,2,.608.294.253.446-.253,1.064-1.286,2.157.324,2.066.608.385,1.023.213,2.411-.121,3.464-.537.506.4,1.6-.193,1.61.132,1.631,1.276-.142.415-.9.658-.7,3.342.355.79,1.084.537.658-.861,1.114-2.8.77-.172,2.168.587-.405,1.975.739,3.342,1.438.587.162,1.337h0l-1.367,1.033-.618,1.5-.557-.122.273-1.965,1.459-.962-1.428.284-.9.5-.881-.02-.344-.4-.577-.172-.547.375-.284.942.527.81-.739.972-.3.1-2.512-.537-.8-.547-.456.122-.182.912.344.375,1.631.567,1.418-.253,2.158.608.273.486-.982.689L399.2,496.9l-1.256.78-2.451.577-.2.456,2.988-.2.152,1.205Z","transform":"translate(890.8 2082.589)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-PR')},"mouseout":function($event){return _vm.EscondeEstado('EST-PR')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('RJ'),attrs:{"id":"rj","d":"M468.787,451.042l-.071-.79.385-.273,3.231.223,2.623-.6-2.563-1.57-1.418-.506-2.846.689-1.378,1.621-1.043.324-.709-.051-1.367-2.178h-.486l-.912.425-.972,1.074-3.191.81-.344.922-.192,1.924,2.218.132,1.084,1.023-1.165,1.094-.952-.172-1.438.172h0l-.486-.263-1.651-1.752-.051-.415,1.1-3.545,1.1-1.165,2.38-1.023.506.152,2.806-.365,1.519-.719,1.671-2.178-.76-1.661-1.722-.01-3.191.537-1.793-.4-1.246-1.61-.567-1.185-1.286-.547h0l.689-.5,2.451-.75,2.948-1.357,2.613-.172.506.273,1.742-.78,1.064-.78,4.143-1.813.527-.071.365.314,3.241-.071,1.266-.172,1.651-.952.577-.061,2.563.273.5.172-.02.476,1.4-.2,9.633-4.588,2.563-1,.213-.527-.284-.618-1.459-.132.091-.76,1.914-3.758,2.39-6.118-.739-.719.567-.5,1.256-.273,2.563-2.39h0l1.955.77.679,4.771,2.532,1.145,4.386,1.023,3.029-.375,1.641,1.074h0l-.081,1.286-.952,1.631-.223,2.157,1.155,6.867-.506.689-3.12,1.773-6.047,1.965-2.866,1.742-3.545,3.738-.111,1.681.314,1.205-.193,1.641-.739,1.5-1.843.517-6.634-.172-5.865.709-2.421-.466-.5-.385-.061-.689,1.043-1.5.679-1.469-.091-.628-.79-.182-2.826,1.165-.263.7.314.8,1.4,1.185.253.983-.6.527-1.651.517-1.59-.03-8.144,1.084-1.479.456Zm-5.176,2.016-.679-.983,2.137-1.57,1.884.952.436.709-2.492.506-.415-.354h-.476l-.4.739Z","transform":"translate(892.762 2082.214)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-RJ')},"mouseout":function($event){return _vm.EscondeEstado('EST-RJ')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('RN'),attrs:{"id":"rn","d":"M610.285,183.507l-.942.243-3.545-.213-1.053.405-2.492-1.114-2.2-.3-5.905.4-.537-.355-3.464-.405-.628-.5.1-1.013-.425-.4-1.4.051-1.844,1.367-.314,1.5.729.79.537,1.55-1.023-.324-.486.6.162,1.438.476.952-.557,1.226-.506.75-2.38.942-.841-.75.527-1.56-.9-1.185-1.975-.3-1.793.081-3.191,1.276-.294-.233-.314-1.4-.324-.233-3.576-.527.081-1.742.213-.314.861-.253.415-.385.385-1.762.446-.972,3.029-3.251-.01-1.205-.537-.446-.648-.081-3.3,1.053-1.448.122-3.221,1.226-.415.962-.1,1.053-.831.719-3.272,1.681-1.175,1.145-2.917-.618-.912-.425-1.955-1.661-.577.466h0l-.668.385-.648-.172.344-2,1.428-2.279.851-.891.517-.071.79.517,1.043-.263.577-1.114,1.479-1.529,1.418-2.471-.152-.75.658-1.692.881-.577.851-1.134,3.342-6.776,2.644-2.036,4.953-1.61h0l.476.77.871.76,3.17-.01,1.236.415,1.712,1.773,1.337.506L586.5,161l2.917.527,2.573-.243,2.36-.739,4.558.932,1.286.04,1.975.871,1.033.831.648.952,2.34,4.8.506,1.813-.041.76,1.5,5.449.213,1.7.729.547.972,2.725Z","transform":"translate(894.02 2078.934)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-RN')},"mouseout":function($event){return _vm.EscondeEstado('EST-RN')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('RO'),attrs:{"id":"ro","d":"M188.553,292.3l-1.307-1.469-.446-1.9-1.58-.527-.871.324-1.833.081-4.122-1.833-.01-.405-.669-.618-1.286.6-2.006-1.7-1.54-.983-.871-1.479-.284-1.408-1.053-.4-1.793,1.134-1.236-.03-1.428-.81-.881-1.347-3.17-1.6-1.985-.172-1.155.547-.912.861-1.448-.172-.314-.3-2.168-.517-3.1-.284-.77-.436-1.2-1.205-.3-2-1.6-.5-1.914-.982-.831-1.742-.294-.2-2.755-.284-.385-.355-.851-3.758-.891-.9-.486,1.175-.669-.324-.273-.648.628-1.55-.851-1.54-1.378-.4-1.276-3.515-.172-1.681,1.57-2.948-.213-1.681-1.175-2-.76-2.188-.061-2.32.628-.506.385-1.388,1.053-1.064.365-1.489-.243-1.509-.425-.9-.091-1.55.547-1.671-1.185-2.208-1.033-.385-1.1.993-.061.517-.851.972h-.577l-2.208-1.033-5.247.081-5.682,1.8-1.712-.01-1.5.486h0l-3.008-1.276h0l3.3-2.593,1.945-.587,1.57-1.833.152-.567-.162-1.307,4.011.263,2.907-.334.729.375,2.34,2.36.375-.02,1.236-.8.132-.729.415-.537,1.094-.506.78.132,1.388-.395,1.317-1.226,1.864-1.033.385.091.648,2.289.689.537.689-.081,2.573-3.2-.263-1.773.537-.851,1.773-1.276.466.02.851.557,1.813.1L149,221.775l2.157-.385,3.92.466-.243-1.479.111-1.833,2.087-1.226.82-1.165.365-1.033-.172-.456-.912-.709.051-.679,1.205-1.61,2.512-.537.263-.223-.091-1.185,1.742-.506,1.4-2.593,10.929-.061,2.178,1.145.456.5.81,1.935,1.347,1.286,2.573.993,1.266,3.312.466.213.993-.132.628.2.689,2.917,3.282,1.5.689-.192.547-1.762,1.945-1.094,1.408.284.365.385-.041.709h0l1.418.983.608,1.256-.77,1.438-1.307,5.054.061.355.79.476.263.618.152,1.408.841,2.3-.952,1.691.385,1.955-1.013,3.565-.03.81.273,1.783,1.519,2.785-.912,9.116,17.381.051-.243.567,1.236,1.124,3.545-.091,1.124.111,1.084.436,1.428,3.636-.172.76-1.418,1.773-1.378,1.094-.142,1.337.436,3.292.587.517.912-.03,1.55,3.383-.041,2.076.587,1.509-.071,1.732-.567,2.269-1.681,2.036-.527,2.279-.587.851-.436.415-1.661.537-.942,1.094-1.448,3.829-.527,2.482-4.163,2.6-1.489,1.448h0l-.75-.041-2.623-1.57-1.286-1.448-7.171.972-1.337-.436-.253-.3-3.424.668-.486-.162-.527-1.367Z","transform":"translate(888.344 2079.571)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-RO')},"mouseout":function($event){return _vm.EscondeEstado('EST-RO')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('RR'),attrs:{"id":"rr","d":"M236.045,62.452l1.621,17.189h0l-18.728-.071.03.689-2.36,3.3-1.681,3.069-.071,1.145-1.165,2.674-.111.668.233.739,1.155,1.428-.02.537-.425.4-2.056.557L211.037,96.2l-1.266.466-1.843-.233L207,93.892,205.1,91.826l-2.866-.942-1.621.061-.557.9-2.117.719-1.3.7L195.61,94.54l-.831,3.008.375,1.823-.253,1.752-.76,2.32.446,2.137-2.39-1.053-1.357.425-.537-.071-1.053-2.066-1.5-1.671-1.985-1.327-.527-.041L180.164,95.3l.142-1.155,1.864.334,1.155-1.337.061-.587-1.145-4.386-.587-.912-1.236-.851-.891-2.2-.294-5.044.577-.972.78-3.079-.669-1.6-.365-1.61,1.641-1.479-.051-.456-.881-1.134-.192-2.289-1.681-4.821-2.765-3.788.719-1.519.922-3.363-.5-.669-1.975-.962-1.378-.111-.891.213-.982-.375-1.226-1.185-.061-.972-.638-.111-1.145.425-.618-.01-.76-.344-.729-.79h0l.3-.466.233-2.309-.3-.223-3.413-.233-3.8.142-3.353-.709-.2-.608.81-1.783.122-1.5-.739-1.793-1.965-3.586-.739-2.087-.476-3.768.8-1.5-.081-.972L151.7,24.743l-2.188-1.074-2.846-2.816-1.074-1.833-.294-.972-1.155-.658-.253-.4.03-.851.294-.334.912.071,1.134.669.952,1.752.618.091,3.434-.506,1.367.1,1.935.6.618,1.215.557,1.955.547.355.972-.081.75-.658.962-.405,3.221.162.476.051L164,22.4l.608.152.527-.142.618-1.58,1.327.142,1.469.942,3.981,4.629,1.064.577.719.111,1.529-.689.75-1.145.1-.851-.841-2.8.365-1.762.466-.284,1.955-.051,1.023-1.114,1.57-1.1.76.051,3.95,1.357.6-.172.81-.729,1.043-.3,1.145.355,1.043-.213,1.357-1.3,1.013-.253,1.165.233,1.124-.071.689-.861.051-1.367,3.069-1.833,2.36.192,2.8-.4.9-1.145.091-.719.6-1.134L206.55,9l1.874-.912,1.114-1.053,1.124-1.732L209.446,1.7l-1.185-.365.648-.182,1.448.071.81.324,3.616-.1,1.074-.962.75-.223L218,.687l.537,1.327,1.053.81.486,1.388-.679,4.963-.729,1.4-1.266.709.061.841,1.631.415,1.641-.223,2.38.82,1.843,1.114-.891,1.448-.01,1.165,2.37,3.464.2,1.57L225.1,24.854l-1.9,1.428-.729,1.519.273.4.061,2.2-1.489,2.441-.912,2.806-.314,2.6-.091,2.7.993,1.894.517,1.783-.01,1.418,1.59,1.043.912.2.132.689-.466,5.216.122.75,1.833.294-.669,1.185.466.506,2.178.75,1.479,1.945L231.76,61.4Z","transform":"translate(888.752 2076.913)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-RR')},"mouseout":function($event){return _vm.EscondeEstado('EST-RR')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('RS'),attrs:{"id":"rs","d":"M323.1,640.328l-.365.01-1.965-1.124-.2-.466.527-4.325-.466-4.3.152-1.084.638-1.256,2.877-2.411.841-1.58,2.33-2.593-1.479-1.671-1.084-.628-2.279-.608-2.35-2.279-1.226-1.641-.1-1.611-.436-1.2-1.246-2.056-2.087-2.269-.679-.6-2.421-1.226-1.469.213-1.924-1.529-1.54-1.651-1.266-.79-.142-1.722-1.924-2.188-3.363-.466-.932-.476-1.752-1.681-1.783.132-2.2-1.4-1.935-3.758-1.124-1.509-2.563-2.147-.709.081-.679,1.813-2.623,2.269-2.7.122.1-2.9.405-1.3-.4-1.013-3.7-4.345-2.4-1.793L273.26,577.3l-1.773-2.137-2.725-2.239-1.924-.142-2.178.213-1.155,1.377-.061.972-1.043.982-1.124.02-.587-.486-3.2.142-.658-.486-.162-.922-.5-.223.861-.223,1.053-.729,2.552-2.806.111-1.864.608-1.266.831-.456,1.307-.071.648-.263.932-1.013,5.52-6.563.638-1.438.172-1.124.831-1.084,1.215-.861,1.388-.415,1.985-4.274.1-.618.314-.375,1.661-.871,1.651-1.823.861-1.165.517-1.307,1.357-2.127.942-.294,1.59.182.557.8.476-1.3-.213-.588-1.367-.831-.051-.365.355-.334,1.094-.385.831-.972,2.826-.962,1.063-1.084.1-.932.831-.922,2.238-1.165,2.5-.405,1.793-1.833.152-1.074,1.337-2.39.334-.041.051.365.294.2,1.347-.172,2.471-1.144,2.715-.6,1.226-.577,2.127-2.38.506.01.679-.4,1.023-1.367,2.34-.739.3.385h0l3.565.4,3.3-1.165.567-.82,1.367.588-.152.932,3.12-.03,1.651,1,2.593-.375,1.945,1.165,2.613-.415,1.56.182,2.836-.162,2.289.932,2.512,1.418,1.013,2.471,1.611.192.091-.486,1.833-.354,5.632,3.586,1.388,1.57.719-.03,1.58.993,3.069,3.535,1.661,2.239.486,1.5,2.2,2.694,1.185.557,6.776,1.074,2.137-.405,3.393.344.891,2.37-2.107,1.6-1.286.415-.739,1.884.223,2.218-.385,1.58-.527,1.317-1.2.2-1.307,1.712-.03,1.428,1.823,1.185.273-.2-.284-.982.01-.972,1.509-.831,1.6.648.739.922,1.185.861.456-.03h0l-1.418,1.752-3.95,7.131-4.264,11.749-6.381,10.615-5.51,6.746-6.594,6.037-6.168,3.727-3.14,4.365-.182-.435.658-1.6.344-2.208-1.2-1.732.1-.425.942-.172,1.023.405.567.588,1.033.041,2.613-1.428.831-.689,2.887-3.758.76-.7.456.193,1.033-.193,1.064-.851.942-1.286.375-1.5.182-.942-.233-2.127.2-1.388,1.59-.071.75.3.273.841.355-.263-.294-1.418.517-2.1.486-.577,2.775-1.611.739-1.094.476-2.785-.213-2.309.567-.689.506.81.375.03.436-.425.476-3.12-.1-.446-.962-1.236-.679-.031-.263.7.172.4-.142.577-.355.2-1.529-.02-2.036.405-.344,1.631-.537.051-.82-.446.1-1.732-.831-.9-1.053.334-.608-.486-.739-1.276-.405-1.469.122-.577-.648-.7-.618,2.745.446,2.279,1.266,2.137-.577.82-.75,2.573.385,3.069-.182.78-.486-.375.263-.243-.03-.719-.476-1.3-.456-.4-.537.668-.03,1.388-1.428,3.312-.051,1.914.223.527-.729.709-1.631.648-.618,1.6-4.143,1.59-.729.537-.537,1.611-.1,2.3-.983,2.3-2.39,1.317-.111,1.783.486.841.253,1.033-.962.567-.253,1.529.436.608.689-.142,1.317.638.152.922-2.157,1.671-2.35,4.578-1.955,6.969-2.036,4.548-1.7,2.552-7.89,7.627Z","transform":"translate(890.199 2083.594)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-RS')},"mouseout":function($event){return _vm.EscondeEstado('EST-RS')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('SC'),attrs:{"id":"sc","d":"M380.395,559.027l-.456.03-1.185-.861-.739-.932-1.61-.638-1.5.831-.01.972.284.983-.273.2-1.823-1.185.041-1.428,1.3-1.712,1.2-.2.537-1.327.375-1.57-.223-2.218.739-1.884,1.286-.425,2.107-1.6-.891-2.37-3.393-.344-2.137.405-6.776-1.074-1.175-.547-2.2-2.694-.5-1.5-1.651-2.238-3.069-3.535-1.59-1-.719.03-1.388-1.57-5.632-3.586-1.833.344-.091.486-1.621-.192-1.013-2.471-2.5-1.408-2.3-.942-2.826.162-1.56-.182-2.623.415-1.935-1.165-2.6.365-1.651-.993-3.12.03.152-.942-1.367-.587-.567.82-3.3,1.175-3.565-.395h0l1.469-2.968.739-2.117-.587-3.292.415-3.251-.041-2.583.972-1.773h0l3.677.02.719-.385.537.01,1.074.243.314.517,2.056,1.428,2.714.03,2.37-.587,5.358,1.7,4.315.365,1.033.638.172.415,1.59,1.2,3.819.425,4.3-.132,1.347,1.924.182-.506.75-.385.932-.02.881-.871-.861-3.029.7-1.6.729-.79,2.026-1.155,3.616.405,1.894-.982.739-.881.6-1.5,1.55-.658,1.124-.142,1.438.77.82.03,2.36-.172,2.877-.739.76.01,1.053.405,3.16,2.634,1.246.628,1.459.162,3.393-2.157,1.367-1.448,1.58-.577.122.4.77.071,1.762-.233.334-.446,5.308.03h0l-.4,1.337.517,1.671-.071.4-1.519,1.155-.993-.486-.831-2.563-.02,1.134.6,2.755,1.732,1.681.567.962-1.023,2.32-.162,2.35.1.436.77.739.263,5.936.314.557.436.2.78-.517.355.729.1.881-.476.061-.436-.284-1.205.638-.344,3.889.577,2.624-.577.76.314,1.955.922,1.9-.871,2.37-.527,4.062-1.732,4.74-.344-.1-.365-.77.213-.982-.932-1.2-.263.334.182,2.461,1.175.841-.932,1.681-1.661.658-4.183,3.079-2.836,2.593-3.8,4.5-1.053,1.9Zm18.11-26.892-.152-.476.253-1.773.77-2.431-.405-1.2.162-1.033,1.418-.77.223.061.669.952-.547,2.593-.831.871-.6,1.236.2,1.185-1.165.78Zm-.456-24.684-1.894-2.046,2.583-2.471.253.041.658,1.063-.871,1.337Z","transform":"translate(890.957 2083.347)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-SC')},"mouseout":function($event){return _vm.EscondeEstado('EST-SC')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('SE'),attrs:{"id":"se","d":"M570.355,262.356l-2.937.9-1.57-.648-.547-.344-.486-.729-1.945-.932-.608-.527-.121-.415.344-.4.132-1.438-.152-.4-1.448-1.529-.527-1.509-1.1-.679-.972-1.621-.02-.78.6-1.6.324-.3,1.722.01,1.145.76,2.583-1,.7-.557.3-.587-.77-2.785.081-.891.669-1.641.081-3.15-.76-1.165-2.016-1.975-1.286-2.532-.223-2.168.679-1.165h0l6.543,3.018,3.727.962,5.49,3.11,1.317,2.482,1.783,1.469,1.681.8.466.03,3.636,2.259.608,1.327h0l-2.411.77-4.629,2.978-.982.9-1.57,2.238-.324-.02.111-1.114-1.064-1.843-1,.162.344,1.175H577.2l.233.243-.527,2-1.286,2.117-.537-.355-.375-.679-1-.162.2.689,1.145.628-.263,1.793-.871,1.165-.942,2.056-.79.152-.3-.466.486-1.418.415-.132.314-.436.375-1.053-.82-.375.1.689-.456,1.145-.486.506-.263,1.1.284.729-.263.527Z","transform":"translate(894.093 2079.881)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-SE')},"mouseout":function($event){return _vm.EscondeEstado('EST-SE')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('SP'),attrs:{"id":"sp","d":"M405.863,489.38l-.162-1.347-1.438-.577-.739-3.343.405-1.975-2.168-.587-.77.172-1.114,2.806-.669.861-1.074-.537-.355-.79.7-3.342.9-.669.142-.405-1.631-1.286-1.61-.132-1.6.192-.506-.385-3.454.537-2.411.122-1.023-.213-.608-.4-.334-2.066,1.3-2.147.253-1.063-.253-.446-.608-.3-.932-2,.061-.9-.506-.689-.679-.294-1.226-1.155-1.509-3.049.365-.557.081-1.783-1.317-1.54-.385-1.864.172-.82.4-.587-.02-2.775-.9-1.783L377,449.4l-1.145-1.57-3.008.871-5.378-.132-.669-.547-1.671-.142-.425.344-1.742-.071-.729-1.337-.638-.517-3.555-.81-1.773-.851-.79-1.013-2.613.01-1.084.547-1.337-.132-2.674-1.1-2.563-.466-1.5-.8-1.185-.294-.739.375-.344.608-1.226.628-3.322-.294-4.062.111-3.879-.658-3.292,2.32h0l.851-1.094.739-1.56,1.276-1.155,7.657-4.6,1.975-1.894,1.276-2.461L341.18,430l.405-1.226,1.459-1.043.284-1.236-.354-.851L345,423.36l1.226-2.37.071-.952-.314-1.955.233-.4.972-.527,2.633-3.687.162-2.968.628-1.7,1.023-.3.739-.648,2.016-2.715,1.236-1.033.476-.233,1.327-.04,1.519-.79.284-.405.405-2.492h0L360.871,399l2.178-1.124,1.945-.375,1.448-1.712,1.519-.618.76.142,1.752,1.57,2.583.081,4.345.972,1.692-.365,1.641.223,2.026-.6,2.208,1.438,1.692.8-.132.932.334,1.438,1.226,2.117.638.03.547-.324.679-.952.415-1.145.263-.192.557.051.365.4.253.972.01,2.816,1.216.537.415-.456-.273-2.573.5-1.205.456-.486,8.285-.679,1.023-1.266,1.519,1.479,1.134.435,2.816-.7.446-1-.2-.466.314-.618,2.411-.111,1.681.79.861-.648,1.327-.294,3.3,3.393.2,1.053-.577,1.023-.294,2.4.587.618,1.914,1.226.405,1.57-.061.567-1.54,2.056-.182,1.965.8.75.314.618.375,2.238,1.317,1.823.841,2.016-.03.861,1.631-.051.79-.314.284-.365,1.013-.051,3.748,1.337.233.375-.051,1.286-.709,2.208-1.884,2.755.263,2.978-.193,3.494-.537,1.58.729,1.621,1.8,1.256,1.833.841.517,1.742-1.226.709,2.046,3.353,1.145.253,2.036-.243.182.537,3.667-1.013.567.425,1.327-.324.76-.993.051-.851-.243-.243.172-2.33,1.205-.334.091.354-.354.5.01.486,2.37.081,2.421-.253,1.813-.679,1.246-1.256,1.955-1.033,2.238-.223,1.256-.739h0l1.286.547.567,1.185,1.246,1.61,1.793.4,3.191-.537,1.722.01.76,1.661-1.671,2.178-1.519.719-2.806.365-.506-.152L459,448.368l-1.1,1.165-1.1,3.545.051.415,1.651,1.752.486.263h0l-.061.2-1.712.425-1.074-.831-1.5,1.124-.435.658.273.223-.77.648-3.262,1.57-2.279.709-.284.446.041.972.506,1.57-.324.425-1.418.263-.709-.648-1.357-.294-3.16-.506-.871.152-1.337.344-1.752.831-.507.517-1.226,2.178-1.327.577-.506-.122.587-.476-.486-1.236-1.185-.861-.841,1.246.263.76-.3.618-7.718,4.295-.962.831-.314,1.175-3.312,3.039-3.292,1.975-1.945.537-4.558,3.251-2.36,1.985-.679.081-.446.628.912.436.669.061.942-.365v.77l-.628,1.327-1.337.861-1.074,1.5Zm44.881-23.306-1.56-.658-1.175.182-.5-.385.1-.79.962-.658,1.1-1.874.729.253.669.658.132,2.948-.466.324Z","transform":"translate(891.094 2082.001)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-SP')},"mouseout":function($event){return _vm.EscondeEstado('EST-SP')}}}),_vm._v(" "),_c('path',{class:_vm.DensidadeInadimpleciaEstado('TO'),attrs:{"id":"to","d":"M434.518,283.624l-5.429,1.438-1.762,1.357-2.593,1.114h-1.57l-4.588,1.013-2.552,2.107-1.8.912-.466-.243-1.529-2.654-.557-.03-.517,3.342-.7.081-3.393-.689-3.17-1.489.567-1.58-.223-.75-4.588.537-2.8-.344-.567.547-.3,1.013-.76.76-1.155-.051-.618-3.14-1.124-3.758-1.053-1.9-1.165-1.327-1.2.983-1.489,2.421-1.651,6.017-.638.233-4.122-1.448-3.13-1.732-3.981-.405-2.228-1.043-2.431-.405.527-2.37,1.236-1.9.03-1.732-.567.3-1.833,2.117-.669,1.246-.2,1.9-.344.456h0l-.81-.02-.972-.517-.993-3.383.75-2.8-.446-3.089-.527-.587-.01-1.59.476-3.353-1.114-2.279.051-.506.831-.9.162-.881-1.408-1.357-.061-.871,1.9-6.067.041-2.988.547-3.008,1.965-5.358.375-.273.436-.861.446-3.18,1.114-1.266.567-1.914.658-1.033h0l1.641-3.738,1.145-4.507,1.165-1.6,1.205-1.114,1.226-1.7,1.043-1.945,1.388-.932,1.064-.162.739-.861.952-1.56.182-1,1.722-3.282,1.1-.81,1.783-5.216.669-4.092-.152-.3-.75-.324-1.692-1.762-.608-.962-.162-.891.142-.577,1.428-1.712,1.307-2.127-.061-2.7-.436-2.208.192-.355,2.5-1.8,3.454-1.155,2.532-1.226.243-.506-.152-1.529.871-1.286,1.529-1.357,1.307-.152.192-1.357-.294-1.215.253-.466,1.479-.466.648-.486.942-2.785-1.033-1.357-.091-1.418.294-.284.983-.081.729-.375.375-.669.03-.648-1.276-1.185-.881-.142-.4-.314-1.033-1.681-1.307-.122-1.894.253-2.32-.82h0l.537-.648,2.654-1.874,1.985-.537.881.051,2.816,1.54,1.418.081.962-.527,1.762.294.6.7.081,1.043.284.324,1.236.03,3.444,1.448.851,1.043.476,3.545.648,1.519-.213,3.768.233,1.094.679,1.145-.01.446-1.793,6.229-.314,2.4.284,1.013-.253,1.61-1.773,2.066-1.783.679-.182.719,1.965,1.337.425-.273,1.388.243.253.355.111.891-.628,1.205.861,1.459.891-.071,3.039,4.214.922.861,2.309,3.059,2.168-1.357,4.325-.952,1.823,1.236.081,1.773-.648,3.292.4,1.367-3.434.355-1.357.547-.577.557-.689,1.448-.739,2.715.375,1.317-2.664,2.583-.263.709.2.425,2.107.294.952.7.75,1.61.061,1.681.628,1.053,3.93,1.975.091.537-1.661,1.833.132,1.671,2.168,1.641,1,2.907,1.357,2.026.719.182,1.8-.213,1.013.3.831.446.618.831,1.3.668h0l2.978.213h0l-.7.658-.223.993-.567.476-3.869,2.046-3.251,2.654-.192.375,1.307,1.823-.365.4-1.023.273-.912.618-1.54,3.535-1.023.729-.506,1.175.233.932,1.884,1.975,3.636.679,1.894,1,.051.77-.567.456-2.066.82-.436.972.091.507.355.334,1.043-.182.932.294.587.517.294.648-.972.719-1.165.425-1.975,1.692-.192.861-.051,2.958.355,1.266.952.668,1.064.243.415.253.172.425.051,1.074-1.378,2.411Z","transform":"translate(891.58 2079.001)"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-TO')},"mouseout":function($event){return _vm.EscondeEstado('EST-TO')}}})]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-AC","x":"60","y":"240","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-AC')},"mouseout":function($event){return _vm.EscondeEstado('EST-AC')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[0]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-AL","x":"580","y":"240","fill":"black"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-AL')},"mouseout":function($event){return _vm.EscondeEstado('EST-AC')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[1]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-AM","x":"140","y":"160","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-AM')},"mouseout":function($event){return _vm.EscondeEstado('EST-AC')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[2]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-AP","x":"340","y":"70","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-AP')},"mouseout":function($event){return _vm.EscondeEstado('EST-AC')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[3]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-BA","x":"500","y":"290","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-BA')},"mouseout":function($event){return _vm.EscondeEstado('EST-AC')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[4]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-CE","x":"540","y":"170","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-CE')},"mouseout":function($event){return _vm.EscondeEstado('EST-AC')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[5]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-DF","x":"400","y":"320","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-DF')},"mouseout":function($event){return _vm.EscondeEstado('EST-AC')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[6]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-ES","x":"540","y":"410","fill":"black"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-ES')},"mouseout":function($event){return _vm.EscondeEstado('EST-AC')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[7]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-GO","x":"380","y":"340","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-GO')},"mouseout":function($event){return _vm.EscondeEstado('EST-GO')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[8]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-MA","x":"450","y":"160","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-MA')},"mouseout":function($event){return _vm.EscondeEstado('EST-MA')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[9]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-MG","x":"460","y":"380","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-MG')},"mouseout":function($event){return _vm.EscondeEstado('EST-MG')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[10]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-MS","x":"300","y":"410","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-MS')},"mouseout":function($event){return _vm.EscondeEstado('EST-MS')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[11]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-MT","x":"280","y":"290","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-MT')},"mouseout":function($event){return _vm.EscondeEstado('EST-MT')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[12]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-PA","x":"330","y":"160","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-PA')},"mouseout":function($event){return _vm.EscondeEstado('EST-PA')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[13]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-PB","x":"590","y":"200","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-PB')},"mouseout":function($event){return _vm.EscondeEstado('EST-PB')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[14]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-PE","x":"590","y":"220","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-PE')},"mouseout":function($event){return _vm.EscondeEstado('EST-PE')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[15]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-PI","x":"490","y":"210","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-PI')},"mouseout":function($event){return _vm.EscondeEstado('EST-PI')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[16]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-PR","x":"340","y":"490","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-PR')},"mouseout":function($event){return _vm.EscondeEstado('EST-PR')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[17]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-RJ","x":"520","y":"450","fill":"black"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-RJ')},"mouseout":function($event){return _vm.EscondeEstado('EST-RJ')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[18]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-RN","x":"590","y":"180","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-RN')},"mouseout":function($event){return _vm.EscondeEstado('EST-RN')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[19]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-RO","x":"160","y":"260","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-RO')},"mouseout":function($event){return _vm.EscondeEstado('EST-RR')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[20]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-RR","x":"190","y":"60","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-RR')},"mouseout":function($event){return _vm.EscondeEstado('EST-RR')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[21]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-RS","x":"320","y":"570","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-RS')},"mouseout":function($event){return _vm.EscondeEstado('EST-RS')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[22]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-SC","x":"370","y":"535","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-SC')},"mouseout":function($event){return _vm.EscondeEstado('EST-SC')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[23]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-SE","x":"580","y":"265","fill":"black"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-SE')},"mouseout":function($event){return _vm.EscondeEstado('EST-SE')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[24]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-SP","x":"390","y":"450","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-SP')},"mouseout":function($event){return _vm.EscondeEstado('EST-SP')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[25]))+"%")]),_vm._v(" "),_c('text',{staticClass:"EscondeEstado",staticStyle:{"font-size":"14px"},attrs:{"id":"EST-TO","x":"395","y":"250","fill":"white"},on:{"mouseover":function($event){return _vm.MostraEstado('EST-TO')},"mouseout":function($event){return _vm.EscondeEstado('EST-TO')}}},[_vm._v(_vm._s(_vm.money(this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[26]))+"%")])]),_vm._v(" "),_vm._m(17)])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row show-mobile"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n                    Para ter acesso completo as estátisticas da plataforma acesse a partir de um desktop ou notebook.\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-10 col-lg-8 text-center"},[_c('p',[_vm._v("Conhecer as empresas que solicitam empréstimos é fundamental para gerar confiança, tornar o processo transparente e cada vez mais seguro para todos os investidores.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Estátisticas das empresas financiadas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"border rounded p-4"},[_c('h3',{staticClass:"pb-4"},[_vm._v("Empréstimos realizados")]),_vm._v(" "),_c('canvas',{attrs:{"id":"GraficoEmprestimosRealizados","width":"269px","height":"100px"}}),_vm._v(" "),_c('canvas',{attrs:{"hidden":"","id":"GraficoEmprestimosRealizadosPorcentagem","width":"269px","height":"100px"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-7"},[_c('h3',[_vm._v("Detalhes de desempenho de empréstimos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Empréstimos originados")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Repagamento")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Pagamentos pendentes")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Atual")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Período de carência")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("1-15 dias de atraso")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("16-30 dias de atraso")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("31-60 dias de atraso")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("+ 60 dias de atraso")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Taxa de inadimplência real e prevista por faixa de risco para o departamento de finanças empresariais")]),_vm._v(" "),_c('p',[_vm._v("A tabela define a estimativa da IOUU de dívidas incobráveis combinadas por classificação de risco em um portfólio totalmente diversificado e a compara com os resultados das plataformas até o momento.\nAs taxas definidas abaixo são as perdas de capital e são uma combinação do número de empréstimos que podem entrar em default e do montante do capital em aberto na inadimplência.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticStyle:{"text-align":"left"},attrs:{"scope":"col"}},[_vm._v("Score")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Previsão %")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Atual %")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"scope":"row"}},[_c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-aa"}),_vm._v(" AA")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"scope":"row"}},[_c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-a"}),_vm._v(" A")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"scope":"row"}},[_c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-b"}),_vm._v(" B")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"scope":"row"}},[_c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-c"}),_vm._v(" C")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"scope":"row"}},[_c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-d"}),_vm._v(" D")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"scope":"row"}},[_c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-e"}),_vm._v(" E")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"scope":"row"}},[_c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-hr"}),_vm._v(" HR")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center p-4"},[_c('p',{staticClass:"smal"},[_vm._v("Previsão estimada de acordo com estudos internos.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3 p-md-4 w-100 mb-auto"},[_c('h4',[_vm._v("Taxa de inadimplência por região")]),_vm._v(" "),_c('canvas',{staticStyle:{"margin-top":"10%"},attrs:{"id":"GraficoTaxaInadimplencia","width":"269px","height":"200px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loan__map--legend"},[_c('ul',{staticClass:"legend legend-map-loan"},[_c('li',{staticClass:"item-01"},[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("1-2%")])]),_vm._v(" "),_c('li',{staticClass:"item-02"},[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("2-3%")])]),_vm._v(" "),_c('li',{staticClass:"item-03"},[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("3-4%")])]),_vm._v(" "),_c('li',{staticClass:"item-04"},[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("4-5%")])]),_vm._v(" "),_c('li',{staticClass:"item-05"},[_c('span',{staticClass:"bullet"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("+5%")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TeIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseSalaryStep_vue__ = __webpack_require__("DfF0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24b965fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseSalaryStep_vue__ = __webpack_require__("Q7y8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseSalaryStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24b965fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseSalaryStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TjVs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tjzq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactsStep_vue__ = __webpack_require__("g6u7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f65e4cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactsStep_vue__ = __webpack_require__("/p5B");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactsStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f65e4cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactsStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tm7c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoanAlerts_vue__ = __webpack_require__("/aHm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bd132a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoanAlerts_vue__ = __webpack_require__("3RxM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoanAlerts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bd132a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoanAlerts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tn66":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ico-pagseguro.5b79517.png";

/***/ }),

/***/ "To2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wallet_vue__ = __webpack_require__("DqOP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df48cd1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wallet_vue__ = __webpack_require__("qTZk");
function injectStyle (ssrContext) {
  __webpack_require__("KRMA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7df48cd1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wallet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df48cd1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wallet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tt3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoanSolicitationBeta_vue__ = __webpack_require__("kltP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b2b15d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoanSolicitationBeta_vue__ = __webpack_require__("tFCg");
function injectStyle (ssrContext) {
  __webpack_require__("qiTp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoanSolicitationBeta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b2b15d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoanSolicitationBeta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Twgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__("l8Bu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_608be596_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__("DVKY");
function injectStyle (ssrContext) {
  __webpack_require__("p7hj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-608be596"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_608be596_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tx/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"historic__pagination"},_vm._l((this.Pages),function(item){return _c('ul',{staticClass:"pagination"},[(item.route == null)?_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link"},[_vm._v(_vm._s(item.display))])]):(_vm.paginaAtual == item.display)?_c('li',{staticClass:"page-item pg-active"},[_c('a',{staticClass:"page-link"},[_vm._v(_vm._s(item.display)+"\n                "),_c('span',{staticClass:"sr-only"},[_vm._v("(current)")])])]):_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.navigate(item.route);}}},[_vm._v(_vm._s(item.display))])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TxlB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileInput_vue__ = __webpack_require__("Oz9E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84691d56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileInput_vue__ = __webpack_require__("N8Y7");
function injectStyle (ssrContext) {
  __webpack_require__("m1Vc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84691d56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84691d56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tywc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U6Hp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U7Yf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UAl2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HasCorporateGroupStep_vue__ = __webpack_require__("lMR3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c665d1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HasCorporateGroupStep_vue__ = __webpack_require__("F5/f");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HasCorporateGroupStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c665d1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HasCorporateGroupStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UG21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PassoInformacoesPessoais__ = __webpack_require__("IL4q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PassoEndereco__ = __webpack_require__("jUzo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PassoOutrasInformacoes__ = __webpack_require__("psaY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PassoDadosBancarios__ = __webpack_require__("1gDh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PassoEnvioIdentidade__ = __webpack_require__("rMFz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PassoEnvioComprovanteResidencia__ = __webpack_require__("/rcy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PassoComoNosConheceu__ = __webpack_require__("mVKm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PassoConfirmacaoCadastro__ = __webpack_require__("8dEU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PassoConcluido__ = __webpack_require__("HULF");










var steps = {
  'informacoes-pessoais': __WEBPACK_IMPORTED_MODULE_0__PassoInformacoesPessoais__["a" /* default */],
  'endereco': __WEBPACK_IMPORTED_MODULE_1__PassoEndereco__["a" /* default */],
  'outras-informacoes': __WEBPACK_IMPORTED_MODULE_2__PassoOutrasInformacoes__["a" /* default */],
  'dados-bancarios': __WEBPACK_IMPORTED_MODULE_3__PassoDadosBancarios__["a" /* default */],
  'envio-identidade': __WEBPACK_IMPORTED_MODULE_4__PassoEnvioIdentidade__["a" /* default */],
  'envio-comprovante-residencia': __WEBPACK_IMPORTED_MODULE_5__PassoEnvioComprovanteResidencia__["a" /* default */],
  'como-nos-conheceu': __WEBPACK_IMPORTED_MODULE_6__PassoComoNosConheceu__["a" /* default */],
  'confirmacao-cadastro': __WEBPACK_IMPORTED_MODULE_7__PassoConfirmacaoCadastro__["a" /* default */],
  'cadastro-concluido': __WEBPACK_IMPORTED_MODULE_8__PassoConcluido__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (steps);

/***/ }),

/***/ "UOOV":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxNyAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjMzMzMgOC41MDQzOUgyLjY2NjY3QzEuNzQ2MTkgOC41MDQzOSAxIDkuMjUwNTkgMSAxMC4xNzExVjE2LjAwNDRDMSAxNi45MjQ5IDEuNzQ2MTkgMTcuNjcxMSAyLjY2NjY3IDE3LjY3MTFIMTQuMzMzM0MxNS4yNTM4IDE3LjY3MTEgMTYgMTYuOTI0OSAxNiAxNi4wMDQ0VjEwLjE3MTFDMTYgOS4yNTA1OSAxNS4yNTM4IDguNTA0MzkgMTQuMzMzMyA4LjUwNDM5WiIgc3Ryb2tlPSIjODE4NDk1IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00LjMzMzk5IDguNTA0MlY1LjE3MDg2QzQuMzMyOTUgNC4xMzc1NyA0LjcxNTg5IDMuMTQwNzUgNS40MDg0NiAyLjM3MzkyQzYuMTAxMDQgMS42MDcwOSA3LjA1Mzg0IDEuMTI0OTUgOC4wODE5MSAxLjAyMTFDOS4xMDk5NyAwLjkxNzI2IDEwLjEzOTkgMS4xOTkxMiAxMC45NzE5IDEuODExOTZDMTEuODAzOCAyLjQyNDggMTIuMzc4NCAzLjMyNDkgMTIuNTg0IDQuMzM3NTMiIHN0cm9rZT0iIzgxODQ5NSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "UQZc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.carregado)?_c('section',{staticClass:"row company-view"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"float-md-left"},[_c('h1',[_vm._v("Histórico de investimento "),_c('span',[_vm._v("id#"+_vm._s(this.id))])])]),_vm._v(" "),_c('div',{staticClass:"mob"},[_c('span',{staticClass:"float-left"},[_vm._v("id#"+_vm._s(this.id))]),_vm._v(" "),_c('div',{staticClass:"back float-right"},[_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar")])])]),_vm._v(" "),_c('div',{staticClass:"back back-hide float-md-right"},[_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{class:'row rating-'+_vm.lowerCase(this.ReservaInvestimento.SolicitacaoId.Score)},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"tit"},[_c('div',{staticClass:"float-md-left"},[_c('h2',[_vm._v(_vm._s(this.ReservaInvestimento.SolicitacaoId.Empresa.RazaoSocial)+"\n\t\t\t\t\t\t\t\t"+_vm._s(this.ReservaInvestimento.SolicitacaoId.Impacto != null ?this.ReservaInvestimento.SolicitacaoId.Impacto.NomeEmpresa:"")+"\n\t\t\t\t\t\t\t\t"+_vm._s(this.ReservaInvestimento.SolicitacaoId.Ccb != null ?this.ReservaInvestimento.SolicitacaoId.Ccb.RazaoSocial:"")+"\n\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',[_vm._v("CNPJ: "+_vm._s(_vm.formatarCnpj(this.ReservaInvestimento.SolicitacaoId.Documento)))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.formatarTipoEmprestimo(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo)))])]),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto')?_c('div',{staticClass:"rating  float-md-right"},[_c('strong',[_vm._v("Score da operação "),_c('span',{staticClass:"circle score"}),_vm._v(" "+_vm._s(this.ReservaInvestimento.SolicitacaoId.Score))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('section',{staticClass:"col-12 col-md-7 col-lg-8"},[_c('div',{class:'row rating-'+_vm.lowerCase(this.ReservaInvestimento.SolicitacaoId.Score)},[_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor investido")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(this.ReservaInvestimento.Valor)))])])]),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Retorno Bruto Anual")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatCurrency(this.ReservaInvestimento.SolicitacaoId.RetornoBrutoAnual))+"% a.a.")])])]):_vm._e(),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Retorno Bruto Mensal")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatCurrency(this.ReservaInvestimento.SolicitacaoId.RetornoBrutoMensal))+"% a.m.")])])]):_vm._e(),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Retorno Estimado do CDI")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatInt(this.ReservaInvestimento.SolicitacaoId.Cdi))+"%")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Prazo previsto")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.ReservaInvestimento.SolicitacaoId.Prazo)+" meses")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Data do investimento")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatData(this.ReservaInvestimento.Created)))])])])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('h4',[_vm._v("Captação de recursos")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Início")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatData(this.ReservaInvestimento.SolicitacaoId.InicioCaptacao)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Total de investidores")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.ReservaInvestimento.SolicitacaoId.QuantidadeReservasInvestimento))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor total captado")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(this.ReservaInvestimento.SolicitacaoId.ValorCaptado)))])])])])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('h4',[_vm._v("Dados do empréstimo")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor solicitado")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(this.ReservaInvestimento.SolicitacaoId.Valor)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Duração")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.ReservaInvestimento.SolicitacaoId.Prazo)+" meses")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor total do empréstimo")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(this.ReservaInvestimento.SolicitacaoId.ValorParcela == 0?_vm.formatCurrency(this.ReservaInvestimento.SolicitacaoId.Valor): _vm.formatCurrency(this.ReservaInvestimento.SolicitacaoId.ValorParcela *  this.ReservaInvestimento.SolicitacaoId.Prazo))+" ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor da parcela")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(this.ReservaInvestimento.SolicitacaoId.ValorParcela == 0? _vm.formatCurrency(this.ReservaInvestimento.SolicitacaoId.Valor/this.ReservaInvestimento.SolicitacaoId.Prazo) : _vm.formatCurrency(this.ReservaInvestimento.SolicitacaoId.ValorParcela)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Juros")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatCurrency(this.ReservaInvestimento.SolicitacaoId.TaxaJuros))+"% a.m.")])])]),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-6 col-lg-4",staticStyle:{"display":"none"}},[_vm._m(0)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('h4',[_vm._v("Dados da empresa")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(1),_vm._v(" "),_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(this.ReservaInvestimento.SolicitacaoId.Empresa.RazaoSocial)+"\n\t\t\t\t\t\t\t\t\t"+_vm._s(this.ReservaInvestimento.SolicitacaoId.Impacto != null ?this.ReservaInvestimento.SolicitacaoId.Impacto.NomeEmpresa:"")+"\n\t\t\t\t\t\t\t\t\t"+_vm._s(this.ReservaInvestimento.SolicitacaoId.Ccb != null ?this.ReservaInvestimento.SolicitacaoId.Ccb.RazaoSocial:"")+"\n\n\n\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("CPF/CNPJ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatarCnpj(this.ReservaInvestimento.SolicitacaoId.Documento)))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Nome do responsável")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.ReservaInvestimento.SolicitacaoId.Nome))])]),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Nome fantasia")]),_vm._v(" "),_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(this.ReservaInvestimento.SolicitacaoId.Empresa.NomeFantasia)+"\n\t\t\t\t\t\t\t\t\t"+_vm._s(this.ReservaInvestimento.SolicitacaoId.Ccb != null ?this.ReservaInvestimento.SolicitacaoId.Ccb.NomeFantasia:"")+"\n\n\t\t\t\t\t\t\t\t")])]):_vm._e(),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto'  && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Telefone comercial")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.ReservaInvestimento.SolicitacaoId.TelefoneComercial))])]):_vm._e(),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto'  && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Data de fundação")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatData(this.ReservaInvestimento.SolicitacaoId.Empresa.DataFundacao)))])]):_vm._e(),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Número de funcionários")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.ReservaInvestimento.SolicitacaoId.Empresa.QuantidadeEmpregados)+" empregados")])]):_vm._e(),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Nome do grupo ecônomico")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.ReservaInvestimento.SolicitacaoId.Empresa.NomeGrupoEconomico == ""?"Não pertence a nenhum grupo econômico":this.ReservaInvestimento.SolicitacaoId.Empresa.NomeGrupoEconomico))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('label',[_vm._v("Endereço")]),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo== 'emprestimo-coletivo' )?_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Cidade != "" ?(this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Logradouro + ' , ' + this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Numero + ' - ' +this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Complemento + ' , ' + this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Bairro + ' - ' + this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Cep + ' - ' + this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Cidade + ' / '+ this.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Uf): "")+"\n\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo== 'emprestimo-de-impacto'  || this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo == 'emprestimo-social' )?_c('span',[_vm._v("\t\n\t\t\t\t\t\t\t\t\t"+_vm._s(this.ReservaInvestimento.SolicitacaoId.Impacto != null && this.ReservaInvestimento.SolicitacaoId.Impacto.TituloCampanha != ""  ?(this.ReservaInvestimento.SolicitacaoId.Impacto.Cidade + ' / '+ this.ReservaInvestimento.SolicitacaoId.Impacto.UF): "")+"\n\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo== 'emprestimo-ccb' )?_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(this.ReservaInvestimento.SolicitacaoId.Ccb != null && this.ReservaInvestimento.SolicitacaoId.Ccb.RazaoSocial != ""  ?(this.ReservaInvestimento.SolicitacaoId.Ccb.Logradouro + ' , ' + this.ReservaInvestimento.SolicitacaoId.Ccb.Numero + '-' +this.ReservaInvestimento.SolicitacaoId.Ccb.Complemento + ' , ' + this.ReservaInvestimento.SolicitacaoId.Ccb.Bairro + ' - ' + this.ReservaInvestimento.SolicitacaoId.Ccb.Cep + ' - ' + this.ReservaInvestimento.SolicitacaoId.Ccb.Cidade + ' / '+ this.ReservaInvestimento.SolicitacaoId.Ccb.Uf): "")+"\n\t\t\t\t\t\t\t\t")]):_vm._e()]),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-lg-5"},[_c('label',[_vm._v("Site")]),_vm._v(" "),_c('span',[_c('a',{attrs:{"target":"_blank","href":this.ReservaInvestimento.SolicitacaoId.Empresa.Site}},[_vm._v(_vm._s(this.ReservaInvestimento.SolicitacaoId.Empresa.Site))])])]):_vm._e(),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-de-impacto' && this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-lg-7"},[_c('label',[_vm._v("Redes Sociais")]),_vm._v(" "),_c('span',[(_vm.companyFacebook)?_c('a',{staticClass:"fab fa-facebook-square",attrs:{"href":_vm.companyFacebook}}):_vm._e(),_vm._v(" "),(_vm.companyTwitter)?_c('a',{staticClass:"fab fa-twitter",attrs:{"href":_vm.companyTwitter}}):_vm._e(),_vm._v(" "),(_vm.companyLinkedin)?_c('a',{staticClass:"fab fa-linkedin-in",attrs:{"href":_vm.companyLinkedin}}):_vm._e(),_vm._v(" "),(_vm.companyInstagram)?_c('a',{staticClass:"fab fa-instagram",attrs:{"href":_vm.companyInstagram}}):_vm._e(),_vm._v(" "),(_vm.companyVimeo)?_c('a',{staticClass:"fab fa-vimeo-v",attrs:{"href":_vm.companyVimeo}}):_vm._e()])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('h5',[_vm._v("Descrição breve sobre a empresa")]),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.Impacto != null)?_c('p',{domProps:{"innerHTML":_vm._s(this.ReservaInvestimento.SolicitacaoId.Impacto.InformacaoResumida)}}):_vm._e(),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.Empresa != null)?_c('p',{domProps:{"innerHTML":_vm._s(this.ReservaInvestimento.SolicitacaoId.Empresa.InformacaoInstitucional)}}):_vm._e(),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.Ccb != null)?_c('p',{domProps:{"innerHTML":_vm._s(this.ReservaInvestimento.SolicitacaoId.Ccb.DescricaoEmpresa)}}):_vm._e()]),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo == 'emprestimo-de-impacto'  || this.ReservaInvestimento.SolicitacaoId.TipoEmprestimo == 'emprestimo-social')?_c('div',{staticClass:"entry"},[_c('h5',[_vm._v("Sobre a empresa")]),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.Impacto != null)?_c('p',{domProps:{"innerHTML":_vm._s(this.ReservaInvestimento.SolicitacaoId.Impacto.InformacaoInstitucional)}}):_vm._e()]):_vm._e(),_vm._v(" "),(this.ReservaInvestimento.UrlEndosso || this.ReservaInvestimento.UrlCCB || this.ReservaInvestimento.SolicitacaoId.CCBsAssinaturas == true )?_c('div',{staticClass:"entry"},[_c('h5',[_vm._v("Documentos")]),_vm._v(" "),_c('div',{staticClass:"row"},[(this.ReservaInvestimento.UrlEndosso)?_c('div',{staticClass:"col-12 col-lg-6"},[_c('a',{staticClass:"docs",attrs:{"href":this.ReservaInvestimento.UrlEndosso,"target":"_blank"}},[_vm._v("\n\t\t\t\t\t\t\t\t\tEndosso\n\t\t\t\t\t\t\t\t")])]):_vm._e(),_vm._v(" "),(this.ReservaInvestimento.UrlCCB  || this.ReservaInvestimento.SolicitacaoId.CCBsAssinaturas == true)?_c('div',{staticClass:"col-12 col-lg-6",staticStyle:{"padding-top":"5px"}},[(this.ReservaInvestimento.UrlCCB)?_c('a',{staticClass:"docs",attrs:{"href":this.ReservaInvestimento.UrlCCB,"target":"_blank"}},[_vm._v("\n\t\t\t\t\t\t\t\t\tCCB\n\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.CCBsAssinaturas == true)?_c('a',{staticClass:"docs",attrs:{"target":"_blank","href":_vm.ccbUrl+"/imprimirccb.aspx?code="+this.ReservaInvestimento.CodigoBMP+"&copias=1"}},[_vm._v("\n\t\t\t\t\t\t\t\t\tCCBs\n\t\t\t\t\t\t\t\t")]):_vm._e()]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('aside',{staticClass:"col-12 col-md-5 col-lg-4"},[_c('div',{staticClass:"box"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(3),_vm._v(" "),(this.ReservaInvestimento.SolicitacaoId.GerouBoletosPagamento)?_c('tbody',_vm._l((this.faturas),function(fatura,index){return _c('tr',{key:index},[_c('td',{staticClass:"align-middle"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(fatura.IndiceFatura + 1)+"\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tR$ "+_vm._s(_vm.formatCurrency(fatura.valorParcela))+"\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formatDate(fatura.Boleto.due_date))+"\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"status align-middle text-center",class:_vm.getFaturaStatusClass(fatura)},[_c('span',{staticClass:"sts md"})])])}),0):_vm._e(),_vm._v(" "),(!this.ReservaInvestimento.SolicitacaoId.GerouBoletosPagamento)?_c('tbody',_vm._l((this.ReservaInvestimento.SolicitacaoId.Prazo),function(n){return _c('tr',{key:n},[_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(n))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("R$  "+_vm._s(_vm.formatCurrency(_vm.valorParcela)))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("-")]),_vm._v(" "),_vm._m(4,true)])}),0):_vm._e()])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('label',[_vm._v("Taxa total efetiva")]),_vm._v(" "),_c('p',[_vm._v("3,13% a.m.-")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Empresa "),_c('span',[_vm._v("(Razão social)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('div',{staticClass:"float-left"},[_c('h4',[_vm._v("Pagamentos")])]),_vm._v(" "),_c('div',{staticClass:"legenda float-left float-md-right"},[_c('div',{staticClass:"title-lg status qt"},[_c('span',{staticClass:"sts sm"}),_vm._v(" "),_c('label',[_vm._v("Quitado")])]),_vm._v(" "),_c('div',{staticClass:"title-lg status vc"},[_c('span',{staticClass:"sts sm"}),_vm._v(" "),_c('label',[_vm._v("Vencido")])]),_vm._v(" "),_c('div',{staticClass:"title-lg status av"},[_c('span',{staticClass:"sts sm"}),_vm._v(" "),_c('label',[_vm._v("A vencer")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"align-middle",attrs:{"scope":"col","width":"40"}},[_vm._v("Parc.")]),_vm._v(" "),_c('th',{staticClass:"align-middle",attrs:{"scope":"col"}},[_vm._v("Valor")]),_vm._v(" "),_c('th',{staticClass:"align-middle",attrs:{"scope":"col"}},[_vm._v("Venc.")]),_vm._v(" "),_c('th',{staticClass:"align-middle",attrs:{"scope":"col"}},[_vm._v("Status")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"status av align-middle"},[_c('span',{staticClass:"sts md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UWMW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompaniesCorporateGroupStep_vue__ = __webpack_require__("sx5J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcdaf07c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompaniesCorporateGroupStep_vue__ = __webpack_require__("yGdU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompaniesCorporateGroupStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcdaf07c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompaniesCorporateGroupStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UZGm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UZUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UdT0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__ = __webpack_require__("65ha");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var endereco = this.currentUser.Social.Endereco;
    return {
      cep: endereco ? endereco.Cep : null,
      logradouro: endereco ? endereco.Logradouro : null,
      numero: endereco ? endereco.Numero : null,
      complemento: endereco ? endereco.Complemento : null,
      bairro: endereco ? endereco.Bairro : null,
      uf: endereco.uf,
      cidade: endereco ? endereco.Cidade : null,
      estaBuscandoEndereco: false,
      estaBuscandoEstados: false,
      placeholderEstado: 'Carregando',
      estados: [],
      cidades: []
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  computed: {
    estaCidadeDesabilitado: function estaCidadeDesabilitado() {
      return this.estaBuscandoEndereco || this.cidades.length == 0;
    },
    estaEstadoDesabilitado: function estaEstadoDesabilitado() {
      return this.estaBuscandoEndereco || this.estaBuscandoEstados;
    },
    placeholderCidade: function placeholderCidade() {
      if ((this.estaBuscandoEndereco || this.cidades.length == 0) && typeof this.uf != 'undefined') {
        return 'Carregando';
      } else {
        return 'Cidade';
      }
    }
  },
  methods: {
    aoMudarCep: function aoMudarCep(e) {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskZipcode(e.target.value).length < 8) return;
      this.estaBuscandoEndereco = true;
      __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarCeps(e.target.value).then(function (endereco) {
        _this.logradouro = endereco.logradouro;
        _this.bairro = endereco.bairro;
        _this.cidade = endereco.localidade;

        _this.estaBuscandoEndereco = false;

        if (_this.uf == '' && typeof endereco.uf != 'undefined') {
          _this.uf = [{ uf: endereco.uf }];
          _this.estaBuscandoEstado = false;
          _this.placeholderEstado = 'Estado';
          setTimeout(function () {
            _this.uf = endereco.uf;
          }, 100);
        }
      }).catch(function () {
        _this.estaBuscandoEndereco = false;
      });
    },
    onUfChange: function onUfChange() {
      var _this2 = this;

      this.cidades = [];
      if (!this.uf) {
        this.cidade = '';
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarCidades(this.uf).then(function (cidades) {
        _this2.cidades = cidades;
        if (_this2.cidade) {
          _this2.setCity();
        }
      });
    },
    setCity: function setCity() {
      var _this3 = this;

      var city = this.cidades.find(function (city) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__["a" /* default */].removeAccents(city.nome.toUpperCase()) == __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__["a" /* default */].removeAccents(_this3.cidade.toUpperCase());
      });
      if (!city) {
        this.cidade = '';
      } else {
        // When the city state is seted before cities is populated the component doesn't show
        // the selected city.
        this.cidade = '';
        setTimeout(function () {
          return _this3.cidade = city.nome;
        }, 100);
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      this.currentUser.Social.Endereco.Cep = __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskZipcode(this.cep);
      this.currentUser.Social.Endereco.Logradouro = this.logradouro;
      this.currentUser.Social.Endereco.Numero = this.numero;
      this.currentUser.Social.Endereco.Complemento = this.complemento;
      this.currentUser.Social.Endereco.Bairro = this.bairro;
      this.currentUser.Social.Endereco.Uf = this.uf;
      this.currentUser.Social.Endereco.Cidade = this.cidade;
      this.currentUser.Impacto.Cidade = this.cidade;
      this.currentUser.Impacto.UF = this.UF;

      this.$emit('on-submit', { Social: this.currentUser.Social });
    }
  },
  created: function created() {
    var _this4 = this;

    if (!this.currentUser.Social) this.currentUser.Social = {};
    __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarEstados().then(function (estados) {
      _this4.estados = estados;
      _this4.placeholderEstado = 'Estado';
      _this4.estaBuscandoEndereco = false;
      // When the city state is seted before cities is populated the component doesn't show
      // the selected city.
      var uf = _this4.uf;
      var city = _this4.cidade;
      _this4.uf = '';
      setTimeout(function () {
        _this4.uf = uf;
        _this4.cidade = city;
      }, 100);
    });
  },
  mounted: function mounted() {
    this.$refs.stateSelect.$el.children[0].children[2].required = true;
    this.$refs.citySelect.$el.children[0].children[2].required = true;
  }
});

/***/ }),

/***/ "Ug7t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Concluir")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('h1',[_vm._v("Chegamos ao fim!")]),_vm._v(" "),_c('p',[_vm._v("Você ainda pode voltar nos passos anteriores se precisar rever ou alterar algo.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UgkD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CityStep_vue__ = __webpack_require__("YYWc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0909eef0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CityStep_vue__ = __webpack_require__("uvE9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CityStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0909eef0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CityStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Uj+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdentificationDocumentStep_vue__ = __webpack_require__("6wUF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8436b64a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdentificationDocumentStep_vue__ = __webpack_require__("qtvW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdentificationDocumentStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8436b64a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdentificationDocumentStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UkDW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InscricaoEstadualStep_vue__ = __webpack_require__("iIp0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53117726_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InscricaoEstadualStep_vue__ = __webpack_require__("1St1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InscricaoEstadualStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53117726_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InscricaoEstadualStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UmGH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankDocumentStep_vue__ = __webpack_require__("eAvX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff896e14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankDocumentStep_vue__ = __webpack_require__("dtCG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankDocumentStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff896e14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankDocumentStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Unc7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialMediaStep_vue__ = __webpack_require__("VbOI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c684e4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialMediaStep_vue__ = __webpack_require__("JBiP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialMediaStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c684e4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialMediaStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UqtQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BankDataForm__ = __webpack_require__("pVr/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { BankDataForm: __WEBPACK_IMPORTED_MODULE_0__components_BankDataForm__["a" /* default */] },
  props: {
    solicitacao: { required: true, type: Object }
  },
  computed: {
    bankData: function bankData() {
      var bankData = this.solicitacao.Empresa.DadosBancarios || {};
      return {
        bankCode: bankData.CodigoBanco,
        agency: bankData.Agencia,
        account: bankData.Conta,
        accountType: bankData.TipoConta
      };
    }
  },
  methods: {
    handleSubmit: function handleSubmit(formData) {
      this.$emit('on-submit', {
        Empresa: {
          DadosBancarios: {
            CodigoBanco: formData.bankCode,
            Agencia: formData.agency,
            Conta: formData.account,
            TipoConta: formData.accountType
          },
          NaoTemContaBancaria: formData.hasNoAccount
        }
      });
    }
  }
});

/***/ }),

/***/ "UsP9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            titleBox: 'Rápido. Simples.',
            subtitleBox: 'Bom para você e para o mundo.',
            txtBox: 'Retornos de até 58,27% ao ano.'
        };
    }
});

/***/ }),

/***/ "Uwq0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploadPjCertificadoMeiStep_vue__ = __webpack_require__("yHxH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4518b476_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploadPjCertificadoMeiStep_vue__ = __webpack_require__("RQxD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploadPjCertificadoMeiStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4518b476_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploadPjCertificadoMeiStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V1Hz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentDocumentStep_vue__ = __webpack_require__("b56G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa606eaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentDocumentStep_vue__ = __webpack_require__("SkR5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentDocumentStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa606eaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentDocumentStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V7s3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.response)?_c('div',[_c('div',{staticClass:"row company-view"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("Investimento Social "),_c('span',[_vm._v("id#"+_vm._s(_vm.ajustIdOportunidade(_vm.impact.IdOportunidade, 5)))])])]),_vm._v(" "),_c('div',{staticClass:"back float-right"},[_c('router-link',{attrs:{"to":"/investimentos/investimento-de-impacto","title":"Voltar"}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-8"},[_c('div',{staticClass:"tit"},[_c('h2',[_vm._v(_vm._s(_vm.impact.Impacto.NomeEmpresa))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.impact.Nome)+" – "+_vm._s(_vm.impact.Impacto.Cidade)+" / "+_vm._s(_vm.impact.Impacto.UF))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.impact.Impacto.AreaEmpresa))])]),_vm._v(" "),_c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"src":_vm.impact.Impacto.VideoDetalhes,"allowfullscreen":""}})]),_vm._v(" "),_c('section',{staticClass:"entry"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor do Financiamento")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.impact.Valor)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Previsão de retorno do empréstimo")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.impact.Prazo)+" mês")])])])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.impact.Impacto.InformacaoInstitucional)}})]),_vm._v(" "),_c('section',{staticClass:"info-impact"},[_c('at-tabs',[_c('at-tab-pane',{attrs:{"label":"Campanha","name":"campanha"}},[_c('h3',[_vm._v("Palavras do(a) Empreendedor(a)")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.impact.Impacto.Campanha)}})])],1)],1)]),_vm._v(" "),_c('aside',{staticClass:"col-12 col-md-4 col-lg-4"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row no-gutters dates"},[_c('div',{staticClass:"col-12 col-sm-6"},[_c('img',{attrs:{"src":"/static/assets/images/ico-calendar_ok.svg"}}),_vm._v(" "),_c('label',[_vm._v("Início")]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.formatMongoDate(_vm.impact.InicioCaptacao)))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('img',{attrs:{"src":"/static/assets/images/ico-calendar_end.svg"}}),_vm._v(" "),_c('label',[_vm._v("Término")]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.formatMongoDate(_vm.impact.FimCaptacao)))])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('label',[_vm._v("Valor solicitado")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.impact.Valor)))])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 text-center"},[_c('label',[_vm._v("Duração esperada")]),_vm._v(" "),_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.impact.Prazo)+" Mês")])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-center"},[_c('label',[_vm._v("Taxa de Juros Mensal")]),_vm._v(" "),_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.impact.TaxaJuros))+" %")])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row no-gutters text-center"},[_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v(_vm._s(_vm.calcDiasRestantes()))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix itens"},[_c('span',{staticClass:"float-left"},[_vm._v("Levantado: "+_vm._s(_vm.formatCurrency(_vm.impact.ValorCaptado)))]),_vm._v(" "),_c('span',{staticClass:"float-right"},[_vm._v("Faltam: "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.calcValorRestante(_vm.impact))))])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:('width:' + _vm.calcPercValorRestante(_vm.impact) + '%'),attrs:{"role":"progressbar","aria-valuenow":"50","aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"progress-value"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.calcPercValorRestante(_vm.impact)))+"%")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"info__invest"},[_c('strong',[_vm._v(_vm._s(_vm.impact.QuantidadeReservasInvestimento))]),_vm._v(" investidores")])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row no-gutters text-center"},[(_vm.canInvest)?_c('div',{staticClass:"col-12 text-center"},[(!_vm.impact.JaInvestiu && _vm.showInputInvestment)?_c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.proximoPasso()}}},[(_vm.permiteAporte)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"valor"}},[_vm._v("Valor que deseja aportar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valorInv),expression:"valorInv"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"id":"valor","placeholder":'Investimento mínimo R$ '+ _vm.money(this.impact.InvestimentoMinimo)},domProps:{"value":(_vm.valorInv)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valorInv=$event.target.value}}})]):_vm._e(),_vm._v(" "),(this.InvestidorBloqueado())?_c('button',{staticClass:"btn btn-lg btn-danger btn-block",staticStyle:{"cursor":"not-allowed"},attrs:{"disabled":""}},[_vm._v("Bloqueado")]):_vm._e(),_vm._v(" "),(_vm.permiteAporte && !this.InvestidorBloqueado())?_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.ShowSaldo()}}},[_vm._v("Apoiar")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"small"})]):_vm._e(),_vm._v(" "),(_vm.canInvest && !_vm.impact.JaInvestiu)?_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInputSaldo),expression:"showInputSaldo"}]},[(_vm.permiteAporte)?_c('div',{staticClass:"reinvestir"},[_c('img',{attrs:{"src":"/static/assets/images/ico-reinvestir.svg","alt":"icone reinvestir"}}),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.Nome())+", essa oportunidade é somente para quem tem saldo na carteira. Gostaria de investir?\n\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('label',[_vm._v("Total disponível para investir")]),_vm._v(" "),_c('span',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(this.sDisponivel)))])]):_vm._e(),_vm._v(" "),(_vm.permiteAporte)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"valor"}},[_vm._v("Valor que dejesa utilizar")]),_vm._v(" "),_c('at-select',{attrs:{"size":"large","placeholder":"Selecione um valor ..."},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((_vm.values),function(option){return _c('at-option',{key:option,attrs:{"value":option}},[_vm._v(_vm._s(option))])}),1),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tO valor para reinvestimento não pode ser superior ao disponível em sua carteira virtual.\n\t\t\t\t\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.permiteAporte)?_c('button',{staticClass:"btn btn-primary btn-lg btn-block",on:{"click":function($event){$event.preventDefault();return _vm.UsarSaldo()}}},[_vm._v("Investir")]):_vm._e(),_vm._v(" "),(this.InvestidorBloqueado())?_c('button',{staticClass:"btn btn-lg btn-danger btn-block",staticStyle:{"cursor":"not-allowed"},attrs:{"disabled":""}},[_vm._v("Bloqueado")]):_vm._e(),_vm._v(" "),(!_vm.permiteAporte && !this.InvestidorBloqueado())?_c('button',{staticClass:"btn b tn-primary btn-lg btn-block",staticStyle:{"background-color":"gray"},attrs:{"type":"button"}},[_vm._v("Encerrado")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.impact.JaInvestiu)?_c('div',{staticStyle:{"width":"100%"}},[_vm._m(0)]):_vm._e()]):_c('div',{staticClass:"form-row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"alert alert_reserve alert-warning text-center",staticStyle:{"width":"100%"}},[_c('h2',[_vm._v("Falta pouco para você investir")]),_vm._v(" "),_c('div',[(_vm.temCadastroInvestidor && _vm.temSuitability && !_vm.investidorAprovado)?_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v("Agora estamos analisando suas informações e retornaremos em até 1 dia útil.")]):_c('p',[(!_vm.temCadastroInvestidor)?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/informacoes-adicionais/investidor"}},[_vm._v("Complete o cadastro de investidor")]):_vm._e(),_vm._v(" "),(!_vm.temSuitability)?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/informacoes-adicionais/suitability"}},[_vm._v("Preencha o formulário de suitability")]):_vm._e()],1)])])])])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert_reserve alert-warning text-center",staticStyle:{"width":"100%"}},[_c('h2',[_vm._v("Você já efetuou um aporte para este investimento.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VCVs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Company_vue__ = __webpack_require__("ENmc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19a7fc06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Company_vue__ = __webpack_require__("wkKs");
function injectStyle (ssrContext) {
  __webpack_require__("jLaj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19a7fc06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Company_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19a7fc06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Company_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VEmD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("96tf");



var _this = this;


var BASE_URI_GO_API = "https://api.iouu.com.br" + '/api/v1/usuario';

var GetUserByEmail = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/email/' + id);

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function GetUserByEmail(_x) {
        return _ref.apply(this, arguments);
    };
}();

/* harmony default export */ __webpack_exports__["a"] = ({ GetUserByEmail: GetUserByEmail });

/***/ }),

/***/ "VGSo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_123dc573_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnersLayout_vue__ = __webpack_require__("Ka4v");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_123dc573_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnersLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VJU9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformationSuitabilityVerify_vue__ = __webpack_require__("BEui");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395f809a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformationSuitabilityVerify_vue__ = __webpack_require__("w3wm");
function injectStyle (ssrContext) {
  __webpack_require__("ndya")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-395f809a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformationSuitabilityVerify_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395f809a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformationSuitabilityVerify_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VKi3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmprestimoColetivoForm_vue__ = __webpack_require__("N6hl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_621ad0f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmprestimoColetivoForm_vue__ = __webpack_require__("KQg6");
function injectStyle (ssrContext) {
  __webpack_require__("ALTj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-621ad0f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmprestimoColetivoForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_621ad0f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmprestimoColetivoForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VMi4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VR55":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex app-wrapper"},[(_vm.showModal)?_c('modal',{staticClass:"modal-invited",on:{"close":function($event){_vm.showModal = false}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"tit float-left"},[_c('h2',[_c('i',{staticClass:"icon icon-airplane xl"}),_vm._v("\n\t\t\tEnviar Convite\n\t\t")])])]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('section',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-3"},[_c('a',{staticClass:"btn btn-primary invited-company",attrs:{"href":"#"},on:{"click":function($event){_vm.modalStep = 2, _vm.activeButton('company'), _vm.auxModalStep = 2}}},[_vm._v("\n\t\t\t\tConvidar empresa\n\t\t\t")])])]),_vm._v(" "),_c('section',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("\n\t\t\t\tConvite por email\n\t\t\t\t")]),_vm._v(" "),(_vm.modalStep === 1)?_c('friend',{on:{"finished":function($event){return _vm.finishInvite()}}}):(_vm.modalStep === 2)?_c('company',{on:{"finished":function($event){return _vm.finishInvite()}}}):(_vm.modalStep === 3)?_c('div',{staticClass:"success d-flex flex-column justify-content-center align-items-center"},[_c('i',{staticClass:"icon icon-success xll"}),_vm._v(" "),_c('h3',[_vm._v("Seu convite foi enviado com sucesso!")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":"javascript:;"},on:{"click":function($event){$event.preventDefault();_vm.modalStep = _vm.auxModalStep}}},[_vm._v("enviar novamente")])]):_vm._e()],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal modal__bootstrap fade",attrs:{"id":"modalMotivo","tabindex":"-1","role":"dialog","aria-labelledby":"modalMotivo","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal__bootstrap-body"},[_c('div',[_c('h2',[_vm._v("Ir para empréstimos")]),_vm._v(" "),_c('img',{staticClass:"image",attrs:{"src":"/static/assets/images/investidor.svg","alt":""}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-secondary",attrs:{"data-dismiss":"modal","aria-label":"Close"}},[_vm._v("Continuar em Investimentos")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-lg btn-primary",attrs:{"to":"/emprestimos/meus-emprestimos","data-dismiss":"modal"}},[_vm._v("Solicitar um empréstimo "),_c('img',{attrs:{"src":"/static/assets/images/seta-modal.svg","width":"16"}})])],1)])])])]),_vm._v(" "),_c('SideMenu',{attrs:{"items":_vm.menuItems,"tipo":'investimentos'}}),_vm._v(" "),_c('div',{staticClass:"bg"}),_vm._v(" "),_c('div',{staticClass:"wrapper d-flex flex-column main-content"},[_c('header',{staticClass:"head row d-flex justify-content-between"},[_c('div',{staticClass:"col-12 col-md-5 col-lg-5 iouu",class:{mobHide: !_vm.InvestidorComInvestimento()}},[_vm._m(2),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-7 col-lg-7 "},[_c('div',{staticClass:"d-flex justify-content-between util mob",class:{resetPad: !_vm.InvestidorComInvestimento()}},[_c('div',{staticClass:"mob-menu"},[_c('a',{staticClass:"btn",on:{"click":function($event){return _vm.ShowMobMenu(true);}}},[_c('i',{staticClass:"fas fa-bars"})])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"mob-profile"},[_c('alerts',{attrs:{"from":_vm.from,"tipoUsuario":"investimentos"}}),_vm._v(" "),_c('div',{staticClass:"user"},[_c('at-dropdown',{attrs:{"placement":"bottom-right"}},[_c('router-link',{attrs:{"to":{ path: '/investimentos/perfil/configuracoes' },"tag":"div"}},[_c('div',{staticClass:"no-image rounded-circle"},[_vm._v(_vm._s(_vm.LetraNome()))])])],1),_vm._v(" "),_c('div',{staticClass:"exit"},[_c('a',{attrs:{"href":"#","title":"Sair"},on:{"click":_vm.Logout}},[_c('i',{staticClass:"ico-exit"})])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end util"},[_c('div',{staticClass:"invite"}),_vm._v(" "),_c('alerts',{attrs:{"from":_vm.from,"tipoUsuario":"investimentos"}}),_vm._v(" "),_c('div',{staticClass:"user"},[_c('at-dropdown',{attrs:{"placement":"bottom-right"}},[_c('div',{staticClass:"no-image rounded-circle"},[_vm._v(_vm._s(_vm.LetraNome()))]),_vm._v(" "),_c('span',[_vm._v("Olá, "),_c('strong',[_vm._v(_vm._s(_vm.Nome()))]),_vm._v(" "),_c('i',{staticClass:"icon icon-chevron-down"})]),_vm._v(" "),_c('at-dropdown-menu',{attrs:{"slot":"menu"},slot:"menu"},[_c('at-dropdown-item',[_c('router-link',{attrs:{"to":{ path: '/investimentos/notificacoes' },"tag":"div"}},[_vm._v("Minhas Notificações")])],1),_vm._v(" "),_c('at-dropdown-item',[_c('router-link',{attrs:{"to":{ path: '/investimentos/meus-investimentos' },"tag":"div"}},[_vm._v("Meus Investimentos")])],1),_vm._v(" "),_c('at-dropdown-item',[_c('router-link',{attrs:{"to":{ path: '/investimentos/historico' },"tag":"div"}},[_vm._v("Meu Histórico")])],1),_vm._v(" "),_c('at-dropdown-item',{attrs:{"divided":""}},[_c('router-link',{attrs:{"to":{ path: '/investimentos/perfil/dados-pessoais' },"tag":"div"}},[_vm._v("Meu Perfil")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"checkout",staticStyle:{"display":"none"}},[_c('at-dropdown',{attrs:{"placement":"bottom-right"}},[_c('i',{staticClass:"ico-ct-4 align-middle"}),_vm._v(" "),_c('span',{staticClass:"checkout-number"},[_vm._v("\n\t\t\t\t\t\t3\n\t\t\t\t\t")]),_vm._v(" "),_c('at-dropdown-menu',{attrs:{"slot":"menu"},slot:"menu"},[_c('at-dropdown-item',[_c('div',{staticClass:"drop-checkout-header"},[_c('i',{staticClass:"icon icon-wallet-2 xl"}),_vm._v(" "),_c('span',[_vm._v("\n\t\t\t\t\t\t\tCarteira de investimentos\n\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('at-dropdown-item',[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n\t\t\t\t\t\t\t\tScore\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n\t\t\t\t\t\t\t\tID\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n\t\t\t\t\t\t\t\tValor do investimento\n\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"rating-aa"},[_c('td',{staticClass:"rating align-middle text-center"},[_c('span',{staticClass:"box rounded-circle"})]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n\t\t\t\t\t\t\t\t00001\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n\t\t\t\t\t\t\t\tR$ 5.000,00\n\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('tr',{staticClass:"rating-a"},[_c('td',{staticClass:"rating align-middle text-center"},[_c('span',{staticClass:"box rounded-circle"})]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n\t\t\t\t\t\t\t\t00001\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n\t\t\t\t\t\t\t\tR$ 5.000,00\n\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('tr',{staticClass:"rating-b"},[_c('td',{staticClass:"rating align-middle text-center"},[_c('span',{staticClass:"box rounded-circle"})]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n\t\t\t\t\t\t\t\t00001\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n\t\t\t\t\t\t\t\tR$ 5.000,00\n\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"3"}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\tValor total de investimentos:\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('strong',[_vm._v("\n\t\t\t\t\t\t\t\t\tR$ 12.000,00\n\t\t\t\t\t\t\t\t")])])])])])]),_vm._v(" "),_c('at-dropdown-item',{attrs:{"divide":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-7"},[_c('router-link',{staticClass:"my-wallet",attrs:{"to":"/carteira-investimento"}},[_vm._v("\n\t\t\t\t\t\t\t\t\tVer minha carteira de investimentos\n\t\t\t\t\t\t\t\t")])],1),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('router-link',{staticClass:"btn btn-primary finish",attrs:{"to":"/finalizar-investimento"}},[_vm._v("\n\t\t\t\t\t\t\t\tfinalizar\n\t\t\t\t\t\t\t\t")])],1)])])],1)],1)],1),_vm._v(" "),(_vm.InvestorAprovado)?_c('div',{staticClass:"news"},[_vm._m(5)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"exit"},[_c('a',{attrs:{"href":"#","title":"Sair"},on:{"click":_vm.Logout}},[_c('i',{staticClass:"ico-exit"}),_vm._v(" Sair")])])],1)])]),_vm._v(" "),(!_vm.InvestidorComInvestimento() )?_c('div',{staticClass:"row block-responses"},[_c('div',{staticClass:"col-12 col-md-4 col-lg-4 col-xl-4"},[(!_vm.InvestorAprovado)?_c('p',{staticClass:"user"},[_c('span',[_vm._v(_vm._s(_vm.Nome())+",")]),_vm._v("\n\t\t\tSeu perfil está quase completo\n\t\t")]):_vm._e(),_vm._v(" "),(!_vm.InvestorAprovado && (!_vm.Investidor() || !_vm.Suitability()))?_c('p',{staticClass:"response"},[_vm._v("\n\t\t\tJá confirmamos sua conta na IOUU e para você começar a investir, basta concluir seu cadastro de investidor e preencher o formulário de suitability.\n\t\t")]):_vm._e(),_vm._v(" "),(!_vm.InvestorAprovado && _vm.Investidor() && _vm.Suitability())?_c('p',{staticClass:"response"},[_vm._v("\n\t\t\tAgora estamos analisando suas informações e retornaremos em até 1 dia útil.\n\t\t")]):_vm._e(),_vm._v(" "),(_vm.InvestorAprovado)?_c('p',{staticClass:"user"},[_c('span',[_vm._v(_vm._s(_vm.Nome())+",")]),_vm._v("\n\t\t\tSeu perfil está completo.\n\t\t")]):_vm._e(),_vm._v(" "),(_vm.InvestorAprovado)?_c('p',{staticClass:"response"},[_vm._v("\n\t\t\tAgora você já pode investir nas oportunidades em aberto.\n\t\t")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 col-lg-8 col-xl-8 steps"},[_c('ul',{staticClass:"d-flex justify-content-end"},[_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('li',{staticClass:"step"},[_c('i',{staticClass:"ico",class:_vm.Investidor() ? (this.InvestorAprovado ? ' ico__ok': ' ico__ok next') : ' ico ico__investidor'}),_vm._v(" "),_c('p',[_vm._v("Cadastro de Investidor")]),_vm._v(" "),_c('span',[(!_vm.Investidor())?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":"/informacoes-adicionais/investidor","title":"Preencher formulário"}},[_vm._v("Preencher")]):_vm._e(),_vm._v(" "),(!this.InvestorAprovado && _vm.Investidor())?_c('span',{staticClass:"btn btn-sm btn-primary",staticStyle:{"cursor":"default"}},[_vm._v("Em analise")]):_vm._e()],1)]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('li',{staticClass:"step "},[_c('i',{staticClass:"ico",class:_vm.Suitability() ? ' ico__ok' : ' ico ico__formulario'}),_vm._v(" "),_c('p',[_vm._v("Formulário de suitability")]),_vm._v(" "),_c('span',[(!_vm.Suitability())?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":"/informacoes-adicionais/suitabilityVerify","title":"Preencher formulário"}},[_vm._v("Preencher")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"badge badge-warning",staticStyle:{"display":"none"}},[_vm._v("Em analise")])],1)]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('li',{staticClass:"step "},[_c('i',{staticClass:"ico ico__investir next"}),_vm._v(" "),_c('p',[_vm._v("Apoiar primeiro projeto")]),_vm._v(" "),(this.InvestorAprovado)?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":{ name: 'Oportunidades' },"title":"Oportunidades"}},[_vm._v("Oportunidades")]):_vm._e()],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('at-menu',{attrs:{"router":"","mode":"horizontal"}},[_c('at-menu-item',{attrs:{"to":{ name: 'Investimentos' }}},[_c('i',{staticClass:"ico-gra-4"}),_vm._v("Meus investimentos")]),_vm._v(" "),_c('at-menu-item',{attrs:{"to":{ name: 'Oportunidades' }}},[_c('i',{staticClass:"ico-ps"}),_vm._v("Oportunidades")]),_vm._v(" "),_c('at-menu-item',{attrs:{"to":{ name: 'Antecipacao' }}},[_c('i',{staticClass:"ico-gra"}),_vm._v("Antecipação")]),_vm._v(" "),_c('at-menu-item',{attrs:{"to":{ name: 'InvestimentodeImpacto' }}},[_c('i',{staticClass:"ico-imp"}),_vm._v("Investimento Social")]),_vm._v(" "),_c('at-menu-item',{attrs:{"to":{ name: 'CarteiraInvestimento' }}},[_c('i',{staticClass:"ico-ct-4"}),_vm._v("Carteira Virtual")])],1)],1)]),_vm._v(" "),_c('main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('footer',{staticClass:"d-flex justify-content-between"},[_c('div',[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"}),_vm._v(" "),_c('span',[_vm._v("V - "+_vm._s(_vm.version)+" © 2020 - IOUU. TODOS OS DIREITOS RESERVADOS.")])])]),_vm._v(" "),_c('social-network')],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal__bootstrap-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Você está prestes a ir para a área de "),_c('strong',[_vm._v("Solicitação de empréstimos")]),_vm._v(". Tem certeza que deseja mudar de ambiente?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_vm._v("Seja bem-vindo à plataforma IOUU")]),_vm._v("\n\t\t\t\tEsse é seu dashboard. Aqui você poderá criar seu portfólio de investimentos, acompanhar seus ganhos e ficar por dentro das novidades da IOUU.\n\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mob-logo"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"beamerTrigger",attrs:{"title":"Novidades IOUU"}},[_c('i',{staticClass:"fas fa-fire"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"step"},[_c('i',{staticClass:"ico ico__ok"}),_vm._v(" "),_c('p',[_vm._v("Sua conta na IOUU está OK!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"align-self-center"},[_c('div',{staticClass:"div"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"align-self-center "},[_c('div',{staticClass:"div"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"align-self-center"},[_c('div',{staticClass:"div"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VSjf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VToR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailsLoans_vue__ = __webpack_require__("EvQh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_599be2c5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailsLoans_vue__ = __webpack_require__("iUw6");
function injectStyle (ssrContext) {
  __webpack_require__("TjVs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-599be2c5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailsLoans_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_599be2c5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailsLoans_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VUcS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__ = __webpack_require__("pk4i");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {

    var investor = this.investor;

    return {
      fullNameError: false,
      email: investor.Email,
      fullName: investor.NomeCompleto,
      sex: investor.Sexo,
      maritalStatus: investor.EstadoCivil,
      mothersName: investor.NomeMae,
      fathersName: investor.NomePai,
      phoneNumber: investor.TelefoneFixo || "",
      cellphoneNumber: investor.Celular,
      cpf: investor.Cpf,
      nationality: investor.Nacionalidade,
      placeOfBirth: investor.Naturalidade,
      cityOfBirth: investor.NaturalidadeCidade,
      birthDate: investor.DataNascimento ? investor.DataNascimento.toLocaleDateString('pt-BR') : null,
      rgNumber: investor.RgNumero,
      rgIssuer: investor.RgOrgaoEmissor,
      rgIssuerState: investor.RgEstadoEmissor,
      rgIssueDate: investor.RgDataEmissao ? investor.RgDataEmissao.toLocaleDateString('pt-BR') : null,

      sexOptions: [{ value: "", label: "Selecione" }, { value: 1, label: "Masculino" }, { value: 2, label: "Feminino" }],
      nationalityOptions: [{ value: "", label: "Selecione" }, { value: 1, label: "Brasileiro(a) Nato(a)" }, { value: 2, label: "Brasileiro(a) Naturalizado(a)" }, { value: 3, label: "Estrangeiro(a)" }],
      maritalStatusOptions: [{ value: "", label: "Selecione" }, { value: 1, label: "Solteiro(a)" }, { value: 2, label: "Casado(a)" }, { value: 3, label: "Divorciado(a)" }, { value: 4, label: "Viúvo(a)" }],
      birthStatesOptions: [],
      states: [],
      firstName: investor.NomeCompleto.split(' ')[0]
    };
  },

  props: {
    investor: { type: Object, required: true }
  },
  methods: {
    validateRgNumber: function validateRgNumber() {
      if (this.rgNumber[0] == " ") {
        this.rgNumber = "";
        return;
      }
    },
    validateRgIssuer: function validateRgIssuer() {
      if (this.rgIssuer[0] == " ") {
        this.rgIssuer = "";
        return;
      }
    },
    validateFullName: function validateFullName() {
      if (this.fullName[0] == " ") {
        this.fullName = "";
        return;
      }

      var splitText = this.fullName.split(' ');
      var upperCaseText = '';

      for (var i = 0; i < splitText.length; i++) {
        if (splitText[i] != "") {
          if (i > 0) upperCaseText += " ";

          upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
        } else if (i > 0) upperCaseText += " ";
      }

      this.fullName = upperCaseText;
    },
    validateFathersName: function validateFathersName() {
      if (this.fathersName[0] == " ") {
        this.fathersName = "";
        return;
      }

      var splitText = this.fathersName.split(' ');
      var upperCaseText = '';

      for (var i = 0; i < splitText.length; i++) {
        if (splitText[i] != "") {
          if (i > 0) upperCaseText += " ";

          upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
        } else if (i > 0) upperCaseText += " ";
      }

      this.fathersName = upperCaseText;
    },
    validateMothersName: function validateMothersName() {
      if (this.mothersName[0] == " ") {
        this.mothersName = "";
        return;
      }

      var splitText = this.mothersName.split(' ');
      var upperCaseText = '';

      for (var i = 0; i < splitText.length; i++) {
        if (splitText[i] != "") {
          if (i > 0) upperCaseText += " ";

          upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
        } else if (i > 0) upperCaseText += " ";
      }

      this.mothersName = upperCaseText;
    },
    validateBornCity: function validateBornCity() {
      if (this.cityOfBirth[0] == " ") {
        this.cityOfBirth = "";
        return;
      }

      var splitText = this.cityOfBirth.split(' ');
      var upperCaseText = '';

      for (var i = 0; i < splitText.length; i++) {
        if (splitText[i] != "") {
          if (i > 0) upperCaseText += " ";

          upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
        } else if (i > 0) upperCaseText += " ";
      }

      this.cityOfBirth = upperCaseText;
    },
    validationNames: function validationNames() {
      var splited = this.clearSplitNames(this.fullName.split(" "));

      if (splited.length <= 1) {
        this.$Notify.error("Preencha o seu nome completo.");
        //this.fullNameError = true;
        return false;
      }

      return true;
    },
    clearSplitNames: function clearSplitNames(splitName) {
      var cleanSplit = new Array();

      for (var i = 0; i < splitName.length; i++) {
        if (splitName[i] != "") cleanSplit.push(splitName[i]);
      }

      return cleanSplit;
    },
    submit: function submit() {
      if (!this.validationNames()) return;

      if (!this.isValidDate(this.birthDate)) {
        this.$Notify.error("A data de nascimento especificada é inválida.");
        return;
      }

      if (!this.isValidDate(this.rgIssueDate)) {
        this.$Notify.error("A data de emissão do RG especificada é inválida.");
        return;
      }

      if (this.sex === "") {
        this.$Notify.error("O campo sexo deve ser preenchido!");
        return;
      }

      if (this.maritalStatus === "") {
        this.$Notify.error("O campo estado civil deve ser preenchido!");
        return;
      }

      if (this.nationality === "") {
        this.$Notify.error("O campo nascionalidade deve ser preenchido!");
        return;
      }

      if (this.rgIssuerState != "" && this.sex != "" && this.maritalStatus != "" && this.nationality != "") {

        this.$emit('submit', {
          Email: this.email,
          NomeCompleto: this.fullName,
          Sexo: this.sex,
          EstadoCivil: this.maritalStatus,
          NomeMae: this.mothersName,
          NomePai: this.fathersName,
          TelefoneFixo: this.phoneNumber.length > 0 ? this.phoneNumber : null,
          Celular: this.cellphoneNumber,
          Cpf: __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskCpf(this.cpf),
          Nacionalidade: this.nationality,
          Naturalidade: this.placeOfBirth,
          NaturalidadeCidade: this.cityOfBirth,
          DataNascimento: this.birthDate,
          RgNumero: __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskRg(this.rgNumber),
          RgOrgaoEmissor: this.rgIssuer,
          RgEstadoEmissor: this.rgIssuerState,
          RgDataEmissao: this.rgIssueDate
        });
      }
    },
    isValidDate: function isValidDate(dateString) {
      var splittedDate = dateString.split("/");

      if (splittedDate.length == 3) {
        var day = parseInt(splittedDate[0]);
        var month = parseInt(splittedDate[1] - 1);
        var year = parseInt(splittedDate[2]);

        if (year <= 1900) return false;

        var dt = new Date(year, month, day);

        return dt.getMonth() == month && dt.getDate() == day && dt.getUTCFullYear() == year;
      }

      return false;
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarEstados().then(function (states) {
      _this.states = states;
      _this.birthStatesOptions = states;
      var rgIssuerState = _this.rgIssuerState;
      var placeOfBirth = _this.placeOfBirth;
      _this.rgIssuerState = '';
      _this.placeOfBirth = '';

      setTimeout(function () {
        _this.rgIssuerState = rgIssuerState;
        _this.placeOfBirth = placeOfBirth;
      }, 100);
    });
  },
  mounted: function mounted() {
    this.$refs.sexSelect.$el.children[0].children[2].required = true;
    this.$refs.rgIssuerStateSelect.$el.children[0].children[2].required = true;
    this.$refs.maritalSelect.$el.children[0].children[2].required = true;
    this.$refs.nationalitySelect.$el.children[0].children[2].required = true;
    this.$refs.placeOfBirthSelect.$el.children[0].children[2].required = true;

    if (this.sex == null) this.$refs.sexSelect.selectFirstOption();

    if (this.rgIssuerState == null) this.$refs.rgIssuerStateSelect.selectFirstOption();

    if (this.maritalStatus == null) this.$refs.maritalSelect.selectFirstOption();

    if (this.nationality == null) this.$refs.nationalitySelect.selectFirstOption();

    if (this.placeOfBirth == null) this.$refs.placeOfBirthSelect.selectFirstOption();
  }
});

/***/ }),

/***/ "VW/F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VY/Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VbOI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var Empresa = this.solicitacao.Empresa || {};
    return {
      Site: Empresa ? Empresa.Site : null,
      Facebook: Empresa ? Empresa.Facebook : null,
      Linkedin: Empresa ? Empresa.Linkedin : null
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      this.$emit('on-submit', {
        Empresa: {
          Site: this.Site,
          Facebook: this.Facebook,
          Linkedin: this.Linkedin
        }
      });
    }
  }
});

/***/ }),

/***/ "VeFN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VeJy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VlBd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VmH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finishedLoading)?_c('div',{staticClass:"alerts",class:{'hasNotify': _vm.hasNotify}},[_c('at-dropdown',{staticClass:"notifications",attrs:{"placement":"bottom-right"}},[_c('router-link',{attrs:{"to":{ path: '/'+_vm.tipoUsuario+'/notificacoes' },"title":"Ver todas as notificações"}},[_c('at-badge',{attrs:{"value":13,"dot":""}},[_c('i',{staticClass:"ico-al"})])],1),_vm._v(" "),(_vm.notificacoes !== null && _vm.hasNotify)?_c('at-dropdown-menu',{attrs:{"slot":"menu"},slot:"menu"},[_c('at-dropdown-item',[_c('router-link',{attrs:{"to":{ path: '/'+_vm.tipoUsuario+'/notificacoes' },"title":"Ver todas as notificações"}},[_c('h4',{staticClass:"float-left"},[_vm._v("Notificações")]),_vm._v(" "),_c('span',{staticClass:"float-right"},[_c('img',{attrs:{"src":"/static/assets/images/icon-go-2.svg","alt":""}})])])],1),_vm._v(" "),_vm._l((_vm.filterNotifications(_vm.notificacoes)),function(notificacao){return _c('at-dropdown-item',{key:notificacao._id},[_c('router-link',{attrs:{"to":_vm.formatUrl(notificacao.Url),"title":notificacao.Titulo,"event":''},nativeOn:{"click":function($event){$event.preventDefault();return _vm.changeStatus(notificacao._id, notificacao.Url)}}},[(notificacao.Tipo === 'Pagamento')?_c('span',{staticClass:"icon icon-coin rounded-circle",class:_vm.verifyStatus(notificacao.Status)}):(notificacao.Tipo === 'Solicitacao')?_c('span',{staticClass:"icon icon-doc rounded-circle",class:_vm.verifyStatus(notificacao.Status)}):(notificacao.Tipo === 'Boleto')?_c('span',{staticClass:"icon icon-bar rounded-circle",class:_vm.verifyStatus(notificacao.Status)}):_c('span',{staticClass:"icon icon-infos rounded-circle",class:_vm.verifyStatus(notificacao.Status)}),_vm._v(" "),_c('div',[_c('h5',[_vm._v(_vm._s(notificacao.Titulo))]),_vm._v(" "),_c('p',[_vm._v("\n                            "+_vm._s(notificacao.Descricao)+"\n                            "),_c('span',[_vm._v(_vm._s(_vm.convertDate(notificacao.Updated)))])])])])],1)}),_vm._v(" "),_c('at-dropdown-item',[_c('router-link',{attrs:{"to":{ path: '/'+_vm.tipoUsuario+'/notificacoes' },"title":"Ver todas as notificações"}},[_vm._v("Ver todas as notificações")])],1)],2):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VqRp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentosEmprestimoPessoal_vue__ = __webpack_require__("XqQ2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ff892cd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentosEmprestimoPessoal_vue__ = __webpack_require__("GcYk");
function injectStyle (ssrContext) {
  __webpack_require__("UZGm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ff892cd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentosEmprestimoPessoal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ff892cd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentosEmprestimoPessoal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vt9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[(_vm.canGoPrevious)?_c('step-back-button',{on:{"click":this.onPrevious}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c(_vm.currentStepComponent,{tag:"component",staticClass:"form-container",attrs:{"suitability":_vm.suitability,"validation-errors":_vm.validationErrors},on:{"on-previous":this.onPrevious,"on-submit":this.atualizarSolicitacao,"loading-toggle":_vm.handleLoadingToggle}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vtov":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('bank-data-form',{attrs:{"bank-data":_vm.bankData},on:{"submit":_vm.handleSubmit}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Já estamos terminando")]),_vm._v(" "),_c('p',[_vm._v("Agora vou precisar dos dados bancários de vocês.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vyqn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RegistrationScreenBanner__ = __webpack_require__("AD6r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RegistrationScreenForm__ = __webpack_require__("1L8O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FooterNewLogin__ = __webpack_require__("fsye");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      menuOpened: false,
      newUser: {}
    };
  },

  components: {
    RegistrationScreenBanner: __WEBPACK_IMPORTED_MODULE_3__components_RegistrationScreenBanner__["a" /* default */],
    RegistrationScreenForm: __WEBPACK_IMPORTED_MODULE_4__components_RegistrationScreenForm__["a" /* default */],
    FooterNewLogin: __WEBPACK_IMPORTED_MODULE_5__components_FooterNewLogin__["a" /* default */]
  },
  methods: {
    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/criar-conta',
        title: 'CriarConta'
      });
    },
    createNewAccountInRepository: function createNewAccountInRepository(value) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _newUser, Name, Password, Email, response, token, currentUser, now;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.newUser = value;

                _newUser = _this.newUser, Name = _newUser.fullname, Password = _newUser.password, Email = _newUser.email;
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.iouu.com.br" + '/new_sign_up', { Name: Name, Password: Password, Email: Email });

              case 5:
                response = _context.sent;
                token = response.data;


                _this.$store.dispatch('login', { email: Email, password: Password, keepLogged: true });
                _this.$ga.event('NewUser', 'start', 'Investidor');

                currentUser = response.data.user;
                now = new Date();


                mixpanel.people.set({
                  'USER_ID': currentUser.id,
                  'sign_up_date': now,
                  'email': Email,
                  'name': Name,
                  'Tipo': 'Investidor'
                });

                mixpanel.identify(currentUser.id);

                mixpanel.track("CREATE_ACCOUNT", {
                  timestamp: now
                });

                console.log('mix ', mixpanel);

                _this.$Notify.info('Conta criada com sucesso!');

                _this.$router.push("/cadastro-concluido-com-sucesso");
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](2);

                if (_context.t0.response.data.Msg) {
                  _this.$Notify.error(_context.t0.response.data.Msg);
                } else {
                  _this.$Notify.error("Tivemos um erro inesperado, tente novamente mais tarde");
                }

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 19]]);
      }))();
    }
  },
  created: function created() {
    //tagueamento GA
    this.taggingGA();
  }
});

/***/ }),

/***/ "W1wB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LizaStep_vue__ = __webpack_require__("Yw5R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f392df2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LizaStep_vue__ = __webpack_require__("rI+u");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LizaStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f392df2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LizaStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WHFU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WJfN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WNpg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-10 col-xl-10"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"zipcode"}},[_vm._v("CEP *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zipcode),expression:"zipcode"},{name:"mask",rawName:"v-mask",value:('zipcode'),expression:"'zipcode'"},{name:"focus",rawName:"v-focus"}],staticClass:"form-control form-control-lg",attrs:{"name":"zipcode","tabindex":"1","type":"text","pattern":"\\d{5}-?\\d{3}","placeholder":"CEP","required":""},domProps:{"value":(_vm.zipcode)},on:{"change":_vm.handleZipcodeChange,"input":function($event){if($event.target.composing){ return; }_vm.zipcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"street"}},[_vm._v("Endereço *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.street),expression:"street"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","tabindex":"2","placeholder":"Logradouro","disabled":_vm.isSearchingAddress,"required":""},domProps:{"value":(_vm.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.street=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-2"},[_c('label',{attrs:{"for":"inputPassword4"}},[_vm._v("Número *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.number),expression:"number",modifiers:{"number":true}},{name:"mask",rawName:"v-mask",value:('integer'),expression:"'integer'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","tabindex":"3","pattern":"\\d+","title":"Números apenas","placeholder":"Nº","disabled":_vm.isSearchingAddress,"required":""},domProps:{"value":(_vm.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.number=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"complement"}},[_vm._v("Complemento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complement),expression:"complement"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","tabindex":"4","placeholder":"Complemento","disabled":_vm.isSearchingAddress},domProps:{"value":(_vm.complement)},on:{"input":function($event){if($event.target.composing){ return; }_vm.complement=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"neighborhood"}},[_vm._v("Bairro *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.neighborhood),expression:"neighborhood"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","tabindex":"5","placeholder":"Bairro","disabled":_vm.isSearchingAddress,"required":""},domProps:{"value":(_vm.neighborhood)},on:{"input":function($event){if($event.target.composing){ return; }_vm.neighborhood=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"state"}},[_vm._v("Estado *")]),_vm._v(" "),_c('at-select',{ref:"stateSelect",staticClass:"focus-select",attrs:{"tabindex":"6","filterable":"","size":"large","disabled":_vm.estaEstadoDesabilitado,"placeholder":_vm.statePlaceholder,"required":""},on:{"on-change":_vm.onUfChange},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}},_vm._l((_vm.states),function(state,i){return _c('at-option',{key:("stateOptions" + i),attrs:{"value":state.uf}},[_vm._v(_vm._s(typeof state.nome=='undefined' ? state.uf : state.nome))])}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"city"}},[_vm._v("Cidade *")]),_vm._v(" "),_c('at-select',{ref:"citySelect",staticClass:"focus-select",attrs:{"tabindex":"7","filterable":"","size":"large","disabled":_vm.estaCidadeDesabilitado,"placeholder":_vm.cityPlaceholder,"required":""},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}},_vm._l((_vm.cities),function(city,i){return _c('at-option',{key:("cityOptions" + i),attrs:{"value":city.nome}},[_vm._v(_vm._s(city.nome))])}),1)],1)]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":"/static/assets/images/angle-right.svg"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WQsj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loans-details rating-b"},[_vm._l((this.Loan),function(item){return _c('div',{key:item._id,staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("\n                    Meus empréstimos\n                    "),_c('span',[_vm._v(_vm._s(_vm.ajustIdOportunidade(item.IdOportunidade, 5)))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.formatted(item.Documento)))])])]),_vm._v(" "),_c('div',{staticClass:"options float-right"},[_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"back"},[_vm._v(" ")]),_vm._v(" "),_c('span',[_vm._v("Voltar")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])}),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_vm._l((this.Loan),function(item){return _c('div',{key:item.IdOportunidade,staticClass:"row justify-content-center",staticStyle:{"height":"500px"}},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 align-self-center aguarde text-center"},[( _vm.Aguarde == '25%' )?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.formatenome(item.Nome))+", aguarde…")]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('h3',[_vm._v("Estamos analisando a sua solicitação")]),_vm._v(" "),_c('p',[_vm._v("Em breve você saberá se pode tomar um empréstimo através da IOUU.")])]):_vm._e(),_vm._v(" "),( _vm.Aguarde == '50%' )?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.formatenome(item.Nome))+", aguarde…")]),_vm._v(" "),_vm._m(1,true),_vm._v(" "),_c('h3',[_vm._v("Estamos analisando a sua solicitação")]),_vm._v(" "),_c('p',[_vm._v("Em breve você saberá se pode tomar um empréstimo através da IOUU.")])]):_vm._e(),_vm._v(" "),( (_vm.Aguarde == '75%' || (item.StatusAguarde == undefined && item.StatusAnalise == '' && item.Status == 'finished')) && (item.StatusAnalise != 'NEGADO' && item.StatusAnalise != 'NEGADO_' && item.Status != 'NEGADO'))?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.formatenome(item.Nome))+", aguarde…")]),_vm._v(" "),_vm._m(2,true),_vm._v(" "),_c('h3',[_vm._v("Estamos analisando a sua solicitação")]),_vm._v(" "),_c('p',[_vm._v("Em breve você saberá se pode tomar um empréstimo através da IOUU.")])]):_vm._e(),_vm._v(" "),(item.StatusAguarde == '100%' && (item.StatusAnalise != 'NEGADO' ))?_c('div',{attrs:{"id":"solicita"}},[_c('h2',[_vm._v(_vm._s(_vm.formatenome(item.Nome))+", solicitação aprovada!")]),_vm._v(" "),_vm._m(3,true),_vm._v(" "),_c('h3',[_vm._v("A análise de sua proposta está completa.")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-lg btn-success",attrs:{"to":_vm.documentos('EMPCOL', item._id),"title":"Ver detalhes da solicitação"}},[_vm._v("Ver detalhes da solicitação")])],1):_vm._e(),_vm._v(" "),(item.StatusAnalise == 'NEGADO' || item.StatusAnalise =='NEGADO_' || item.Status == 'NEGADO')?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.formatenome(item.Nome))+", solicitação negada!")]),_vm._v(" "),_vm._m(4,true),_vm._v(" "),(!item.NegadoCliente)?_c('h3',[_vm._v("A análise de sua proposta está completa.")]):_vm._e(),_vm._v(" "),(!item.NegadoCliente)?_c('p',[_vm._v("Infelizmente neste momento não poderemos ajudá-lo com seu pedido de empréstimo.")]):_vm._e(),_vm._v(" "),(item.NegadoCliente)?_c('p',[_vm._v("Obrigado "+_vm._s(_vm.formatenome(item.Nome))+", Estareamos a disposição a qualquer momento. ")]):_vm._e()]):_vm._e()])])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status"},[_c('div',{staticClass:"emoticon text-center",staticStyle:{"width":"25%"}},[_c('img',{attrs:{"src":"/static/assets/images/emoji-animado.gif","alt":"Emoji Animado"}})]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",staticStyle:{"width":"25%"},attrs:{"role":"progressbar","aria-valuenow":"25","aria-valuemin":"0","aria-valuemax":"100"}},[_vm._v("25%")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status"},[_c('div',{staticClass:"emoticon text-center",staticStyle:{"width":"50%"}},[_c('img',{attrs:{"src":"/static/assets/images/emoji-entediado.gif","alt":"Emoji entediado"}})]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",staticStyle:{"width":"50%"},attrs:{"role":"progressbar","aria-valuenow":"50","aria-valuemin":"0","aria-valuemax":"100"}},[_vm._v("50%")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status"},[_c('div',{staticClass:"emoticon text-center",staticStyle:{"width":"75%"}},[_c('img',{attrs:{"src":"/static/assets/images/emoji-ansioso.gif","alt":"Emoji ansioso"}})]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",staticStyle:{"width":"75%"},attrs:{"role":"progressbar","aria-valuenow":"75","aria-valuemin":"0","aria-valuemax":"100"}},[_vm._v("75%")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status"},[_c('div',{staticClass:"emoticon text-center",staticStyle:{"width":"100%"}},[_c('img',{attrs:{"src":"/static/assets/images/emoticon-feliz.svg","alt":"Emoji feliz"}})]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}},[_vm._v("100%")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status"},[_c('div',{staticClass:"emoticon text-center",staticStyle:{"width":"100%"}},[_c('img',{attrs:{"src":"/static/assets/images/emoticon-triste.svg","alt":"Emoji triste"}})]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}},[_vm._v("100%")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WSi1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"back float-right"},[_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar\n\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"box-td"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),(_vm.response)?_c('tbody',[_vm._l((_vm.arquivosIdentidade),function(identidade){return _c('tr',{key:identidade.Nome},[_c('td',{staticClass:"align-middle text-left"},[(identidade.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(identidade.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("                        \n                                        "+_vm._s(_vm.nomeArquivo(identidade.MetaDados.NomeArquivo))+" \n                                        "),(identidade.Status == '' || identidade.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(identidade.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        Identidade\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        "+_vm._s(_vm.formatDate(identidade))+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(identidade.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(identidade, 'Identidade', 'ArquivosIdentidade')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + identidade.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])])])}),_vm._v(" "),_vm._l((_vm.arquivosComprovanteResidencia),function(endereco){return _c('tr',{key:endereco.Nome},[_c('td',{staticClass:"align-middle text-left"},[(endereco.Status == 'APROVADO')?_c('i',{staticClass:"icon icon-doc-ok md"}):(endereco.Status != 'APROVADO')?_c('i',{staticClass:"icon icon-doc-atencao md"}):_vm._e(),_vm._v("  \n                                        "+_vm._s(_vm.nomeArquivo(endereco.MetaDados.NomeArquivo))+"\n                                        "),(endereco.Status == '' || endereco.Status == undefined)?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Em análise")]):(endereco.Status == 'REPROVADO')?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Reenviar")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-left"},[_vm._v("\n                                        Comprovante de Residência\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                        "+_vm._s(_vm.formatDate(endereco))+"\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(endereco.Status != 'APROVADO')?_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(endereco, 'Comprovante de Residência', 'ArquivosComprovanteResidencia')}}},[_c('i',{staticClass:"icon icon-send-file sm"}),_vm._v(" "),_c('span',[_vm._v("Enviar documento")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"td-link",attrs:{"href":_vm.uploadEndpoint + endereco.Nome,"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"}),_vm._v(" "),_c('span',[_vm._v("Visualizar")])])])])})],2):_vm._e()])])])])]),_vm._v(" "),(_vm.showModal)?_c('modal',{staticClass:"modal-invited",on:{"close":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"tit float-left"},[_c('h2',{staticStyle:{"padding-right":"50px"}},[_c('i',{staticClass:"icon icon-airplane xl"}),_vm._v(" Enviar "+_vm._s(_vm.tipoArquivoSelecionado))])])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-x":"auto"},attrs:{"slot":"body"},slot:"body"},[(_vm.submitted)?_c('div',{staticClass:"success d-flex flex-column justify-content-center align-items-center"},[_c('i',{staticClass:"icon icon-success xll"}),_vm._v(" "),_c('h3',[_vm._v("Documento enviado com sucesso!")])]):_c('div',[_c('files-input',{attrs:{"files":_vm.files,"accept":_vm.acceptedFormats,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"float-md-right"},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"color":"#fff !important"},on:{"click":function($event){return _vm.submit()}}},[_vm._v("Enviar Documentos")])])],1),_vm._v(" "),_c('br')])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("Documentos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"align-middle text-left",attrs:{"scope":"col"}},[_vm._v("\n                                        Nome\n                                    ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-left",attrs:{"scope":"col"}},[_vm._v("\n                                        Documento\n                                    ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n                                        Enviado\n                                    ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n                                         \n                                    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WTek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/* eslint-disable */
var pdf = function () {
  function pdf() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, pdf);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(pdf, null, [{
    key: "Save",
    value: function Save(dom, docName) {
      var pdf = new jsPDF();
      var obj = document.getElementById(dom);

      html2canvas(obj).then(function (canvas) {
        var img = canvas.toDataURL("image/png");
        pdf.addImage(img, 'JPEG', 40, 20);
        pdf.save("comprovante_" + docName + ".pdf");
      });
    }
  }, {
    key: "Print",
    value: function Print(dom, docName) {
      var obj = document.getElementById(dom);
      var w = window.open("", "_blank");

      html2canvas(obj).then(function (canvas) {
        var srcCanvas = canvas.toDataURL("image/png");
        var img = new Image();
        img.src = srcCanvas.toString();

        var html = "<html>\n            <head>\n                <title>Comprovante_" + docName + "</title>\n            </head>\n            <body style=\"text-align: center;\">\n              <img src=\"" + img.src + "\" style=\"display: inline-block;\" onload=\"print()\"/>\n            </body>\n          </html>";

        w.document.write(html);
      });
    }
  }]);

  return pdf;
}();

/* harmony default export */ __webpack_exports__["a"] = (pdf);

/***/ }),

/***/ "WW3i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WfA/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FullNameStep_vue__ = __webpack_require__("CrJb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a49a638_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FullNameStep_vue__ = __webpack_require__("zaBb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FullNameStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a49a638_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FullNameStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WfYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AdditionalInformationPeerToPeer__ = __webpack_require__("rSIk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_StepBackButton__ = __webpack_require__("g50h");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var components = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ StepBackButton: __WEBPACK_IMPORTED_MODULE_7__components_StepBackButton__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_4__components_AdditionalInformationPeerToPeer__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      transitionName: 'slide-left',
      solicitacaoId: this.$route.params.id,
      solicitacao: null
    };
  },

  components: components,
  computed: {
    currentStepComponent: function currentStepComponent() {
      var stepNames = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_4__components_AdditionalInformationPeerToPeer__["a" /* default */]);
      var currentStepName = this.solicitacao ? this.solicitacao.Status + '-step' : null;
      return stepNames.includes(currentStepName) ? currentStepName : 'nome-completo-step';
    },
    progress: function progress() {
      var stepsAmount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_4__components_AdditionalInformationPeerToPeer__["a" /* default */]).length;
      var currentStepNumber = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_4__components_AdditionalInformationPeerToPeer__["a" /* default */]).indexOf(this.currentStepComponent) + 1;
      return Math.round(currentStepNumber * 100 / stepsAmount);
    },
    canGoPrevious: function canGoPrevious() {
      if (!this.solicitacao) return false;

      var stepsThatCantGoBack = ['nome-completo', 'finished', 'cancelado'];
      return !stepsThatCantGoBack.includes(this.solicitacao.Status);
    }
  },
  methods: {
    atualizarSolicitacao: function atualizarSolicitacao(data) {
      var _this = this;

      data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(data, { StepType: 'next' });
      this.transitionName = 'slide-left';

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["c" /* START_LOADING */]);

      //console.log(data);
      // ApiClient.put_GO(`solicitacoes/${this.solicitacaoId}/emprestimo-coletivo-informacoes`, {data: data})
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].put('solicitacoes/' + this.solicitacaoId + '/emprestimo-coletivo-informacoes', { data: data }).then(function (response) {
        _this.solicitacao = response.data;

        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
      }).catch(function (error) {
        var errorMessages = error.response ? error.response.data.errors.map(function (error) {
          return error.detail;
        }) : error.message;
        _this.$Notify.error(__WEBPACK_IMPORTED_MODULE_6__utils_array_helper__["a" /* default */].toSentence(errorMessages));
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
      });
    },
    onPrevious: function onPrevious() {
      var _this2 = this;

      this.transitionName = 'slide-right';

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["c" /* START_LOADING */]);
      // ApiClient.put_GO(`solicitacoes/${this.solicitacaoId}/emprestimo-coletivo-informacoes`, {data: {StepType: 'previous'}})
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].put('solicitacoes/' + this.solicitacaoId + '/emprestimo-coletivo-informacoes', { data: { StepType: 'previous' } }).then(function (response) {
        _this2.solicitacao = response.data;
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
      }).catch(function () {
        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
      });
    },
    handleLoadingToggle: function handleLoadingToggle(isLoading) {
      if (isLoading) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["c" /* START_LOADING */]);
      } else {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
      }
    }
  },
  beforeCreate: function beforeCreate() {
    var _this3 = this;

    var solicitacaoId = this.$route.params.id;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["c" /* START_LOADING */]);

    // ApiClient.get_GO(`solicitacoes/${solicitacaoId}`)
    __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get('solicitacoes/' + solicitacaoId).then(function (response) {
      _this3.solicitacao = response.data;
      _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
      var email1 = _this3.solicitacao.Email.trim().toLowerCase();
      var email2 = _this3.$store.state.currentUser.email.trim().toLowerCase();

      // CADASTRAR TOMADORES NA LISTA ACTIVE CAMPAIN ...
      __WEBPACK_IMPORTED_MODULE_3__utils_hub_consulta_client__["a" /* default */].CadastrarTomadorActive(email1);
      // ----------------------------------

      if (email1 != email2) //permissão de visualização somente para o dono da solicitação ( 30/11/2018 - Victor Narcizo)
        window.location.href = "#/";
    }).catch(function (error) {
      window.error = error;
      if (error.response && error.response.status == 404) {
        _this3.$router.push('/not-found');
      }

      if (error.response && error.response.status == 401) {
        window.location.href = "#/";
      }

      _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
    });
  },
  beforeUpdate: function beforeUpdate() {
    this.$Loading.update(this.progress);
  }
});

/***/ }),

/***/ "WhUV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("A data de fundação da(o) "),_c('strong',[_vm._v(_vm._s(_vm.razaoSocial))]),_vm._v(" é essa mesmo que identificamos aqui?")])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"dataFundacao"}},[_vm._v("Data de fundação da empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataFundacao),expression:"dataFundacao"},{name:"mask",rawName:"v-mask",value:('date'),expression:"'date'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","pattern":"\\d{2}/\\d{2}/\\d{4}","placeholder":"Data de Fundação","required":""},domProps:{"value":(_vm.dataFundacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dataFundacao=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WuKC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WvzC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var solicitacao = this.currentUser;
    return {
      Documento: solicitacao ? solicitacao.Documento : null,
      razaoSocial: this.verificaRazaoSocial(solicitacao)
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    verificaRazaoSocial: function verificaRazaoSocial(solicitacao) {
      if (solicitacao) {
        if (solicitacao.ReceitaWs.DadosConsulta) {

          return solicitacao.ReceitaWs.DadosConsulta.nome;
        } else if (solicitacao.HubdoDesenvolvedor.DadosConsulta) {

          return solicitacao.HubdoDesenvolvedor.DadosConsulta.result.nome;
        } else if (solicitacao.Ph3a.DadosConsulta) {

          return solicitacao.Ph3a.DadosConsulta.Razaosocial;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      this.currentUser.Social.RazaoSocial = this.razaoSocial;
      this.currentUser.Impacto.NomeEmpresa = this.razaoSocial;

      this.$emit('on-submit', this.currentUser);
    }
  },
  created: function created() {
    if (!this.currentUser) this.currentUser = {};
  }
});

/***/ }),

/***/ "WzCu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19f8a6c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileHist_vue__ = __webpack_require__("hAj2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19f8a6c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileHist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X/+J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileDocs_vue__ = __webpack_require__("OV8Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fa082c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileDocs_vue__ = __webpack_require__("EqSw");
function injectStyle (ssrContext) {
  __webpack_require__("Pdnp")
  __webpack_require__("WJfN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fa082c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileDocs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fa082c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileDocs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X2/a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X5Ct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Nome),expression:"partner.Nome"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":"","placeholder":"Nome do Avalista"},domProps:{"value":(_vm.partner.Nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Nome", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"inputPassword4"}},[_vm._v("CPF")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Cpf),expression:"partner.Cpf"},{name:"mask",rawName:"v-mask",value:('cpf'),expression:"'cpf'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":"","pattern":"\\d{3}\\.\\d{3}\\.\\d{3}-\\d{2}","placeholder":"CPF"},domProps:{"value":(_vm.partner.Cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Cpf", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"DataNascimento"}},[_vm._v("Data de Nascimento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.DataNascimento),expression:"partner.DataNascimento"},{name:"mask",rawName:"v-mask",value:('date'),expression:"'date'"}],staticClass:"form-control form-control-lg",attrs:{"name":"DataNascimento","type":"text","placeholder":"__/__/____","required":""},domProps:{"value":(_vm.partner.DataNascimento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "DataNascimento", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"Celular"}},[_vm._v("Celular")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Celular),expression:"partner.Celular"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"name":"Celular","type":"text","placeholder":"","required":""},domProps:{"value":(_vm.partner.Celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Celular", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-8"},[_c('label',{attrs:{"for":"Email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Email),expression:"partner.Email"}],staticClass:"form-control form-control-lg",attrs:{"name":"Email","type":"email","placeholder":"","required":""},domProps:{"value":(_vm.partner.Email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"complemento"}},[_vm._v("Escolaridade")]),_vm._v(" "),_c('at-select',{attrs:{"size":"large","placeholder":"Escolaridade"},model:{value:(_vm.partner.Escolaridade),callback:function ($$v) {_vm.$set(_vm.partner, "Escolaridade", $$v)},expression:"partner.Escolaridade"}},_vm._l((_vm.optionsEscolaridade),function(escolaridade,escolaridadeIndex){return _c('at-option',{key:("escolaridadeOptions" + escolaridadeIndex),attrs:{"value":escolaridade.value}},[_vm._v(_vm._s(escolaridade.label))])}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"complemento"}},[_vm._v("Estado Cívil")]),_vm._v(" "),_c('at-select',{attrs:{"size":"large","placeholder":"Estado Cívil","disabled":_vm.partner.EstadoCivil === 2 || _vm.partner.EstadoCivil === 5},model:{value:(_vm.partner.EstadoCivil),callback:function ($$v) {_vm.$set(_vm.partner, "EstadoCivil", $$v)},expression:"partner.EstadoCivil"}},_vm._l((_vm.optionsMarital),function(marital,maritalIndex){return _c('at-option',{key:("maritalOptions" + maritalIndex),attrs:{"value":marital.value}},[_vm._v(_vm._s(marital.label))])}),1)],1),_vm._v(" "),(_vm.partner.EstadoCivil === 2 || _vm.partner.EstadoCivil === 5)?_c('div',{staticClass:"form-row noSpace col-12"},[_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"NomeConjuge"}},[_vm._v("Nome do cônjuge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.NomeConjuge),expression:"partner.NomeConjuge"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","name":"NomeConjuge","placeholder":"Nome do Cônjuge","required":""},domProps:{"value":(_vm.partner.NomeConjuge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "NomeConjuge", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"CpfConjuge"}},[_vm._v("Cpf do cônjuge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.CpfConjuge),expression:"partner.CpfConjuge"},{name:"mask",rawName:"v-mask",value:('cpf'),expression:"'cpf'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","pattern":"\\d{3}\\.\\d{3}\\.\\d{3}-\\d{2}","placeholder":"CPF do Cônjuge","required":""},domProps:{"value":(_vm.partner.CpfConjuge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "CpfConjuge", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"DataNascimentoConjugue"}},[_vm._v("Data de Nascimento do cônjuge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.DataNascimentoConjuge),expression:"partner.DataNascimentoConjuge"},{name:"mask",rawName:"v-mask",value:('date'),expression:"'date'"}],staticClass:"form-control form-control-lg",attrs:{"name":"DataNascimentoConjuge","type":"text","placeholder":"__/__/____","required":""},domProps:{"value":(_vm.partner.DataNascimentoConjuge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "DataNascimentoConjuge", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"CelularConjuge"}},[_vm._v("Celular do cônjuge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.CelularConjuge),expression:"partner.CelularConjuge"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"name":"CelularConjuge","type":"text","placeholder":"","required":""},domProps:{"value":(_vm.partner.CelularConjuge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "CelularConjuge", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-8"},[_c('label',{attrs:{"for":"EmailConjuge"}},[_vm._v("Email do cônjuge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.EmailConjuge),expression:"partner.EmailConjuge"}],staticClass:"form-control form-control-lg",attrs:{"name":"EmailConjuge","type":"text","placeholder":"","required":""},domProps:{"value":(_vm.partner.EmailConjuge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "EmailConjuge", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-12"},[_c('label',{attrs:{"for":"complemento"}},[_vm._v("Escolaridade do cônjuge")]),_vm._v(" "),_c('at-select',{attrs:{"size":"large","placeholder":"Escolaridade"},model:{value:(_vm.partner.EscolaridadeConjuge),callback:function ($$v) {_vm.$set(_vm.partner, "EscolaridadeConjuge", $$v)},expression:"partner.EscolaridadeConjuge"}},_vm._l((_vm.optionsEscolaridade),function(escolaridade,escolaridadeIndex){return _c('at-option',{key:("escolaridadeOptions" + escolaridadeIndex),attrs:{"value":escolaridade.value}},[_vm._v(_vm._s(escolaridade.label))])}),1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"Facebook"}},[_vm._v("Facebook")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Facebook),expression:"partner.Facebook"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: facebook.com/iouu"},domProps:{"value":(_vm.partner.Facebook)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Facebook", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"Linkedin"}},[_vm._v("Linkedin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Linkedin),expression:"partner.Linkedin"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: linkedin.com/in/iouu/"},domProps:{"value":(_vm.partner.Linkedin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Linkedin", $event.target.value)}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XG7f":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAIAAACzY+a1AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABGJJREFUeNrsmzFIG1EYx1VchLaDXURXpV2aVii6CFqnZFEooYsOgg4KSp2kQzuUdihOSgt2sOCQQpEg1MVMVcEl1iFtlwqOVVzq0Apd+9er4bx3Fy/Beu+S348M5vm80/fLe9/3vXvWJzrn6yDONDAEKAQUAgpRCCgEFAIKUQgoBBQCClEIKAQUAgpRCCgEFAIKUQgoBBQCClEIKAQUAgpRCCgEFAIKUQgoBBQCClEIKAQUAgpRCCgEFAIKUQgoBBQCClEIKAQUAgpRCCgEFAIKUQgoBBQCClEIKAQUAgpRCCgEFAIKUQgoBBQCClEINtN4xfcbSG63tRx5GvcPm1dzXe6W1pajweT2hd0i4Vb7fn/PN0/j97229a07NaFwMJm/f2/P07hTaDcVjo+sXdgtEl48eS+L7pbdvbZMtpeFNB7MTK6Y/kanp34fN6EwBmj9GEpvWuUPhWVw/dqfuZeLtvlDYXkhUBZt8xdBOhNTFP/kT/lUseXZqyEb/FWtQgUt5bSe6kV5v6bOwWFzBRd05hx1Yaihfzf3usR3v2w8Lr7VmLqnhWaJik4VLZ6M0ZSRyfb5FidBd7/bN+97KXU2C6S3S6mFpSSzsGyUKE6MrLljVYklUVFtOL1hSSQjnTmXMZYV25YXZ8v6ERT+XyrY3FKw1HSsgr+9ShZSJSl6tZ7lL7v/MpebZ3PuxwNjV1OoUdNRPVF4mSaUDpxOkZ8Dxjb3wck2d7f7rWciSomTqphBTnZVmJuZjoKiygMUXqZCJ51TpuersESyt3CSCqaCMpTTn015tlecoMhCagumPGUrTkl+O9gTCm1Ey2l/z1enuq+rARqrTN7M5EqNmKtChaoQzPBZCzTgj1kYPZLn609ZqCqNz4UOJ9PZKbS7t1hRGAFBQW7COGVTd6nbzZaX/w1xV6hGs10TrgJ/Qc+hggoPS/ImSxUGferNUfMdx51Ch9l44aZ2kMLBZN43+0VheXW6g2qGiq85fP7kUniLKjE995U/e7bI7Y2FsmjOG43d2ofnSlI0AxaWUkGTdSCZz2R73Z+DiZHcuF/INFdg38xoKL2pWzvPQ2TUqj0dexVqNH0fL0iecxIwk+1zupmy1Wd5cXY11/3ruOnGydP8fMhF72OuO6g4Kd6XjDQsn7YSvgpNVnNd5uD6ngcP87nRyzxOEbRO6BV5RLQ3I5WYkKl8iRU1ZJbkJvzRtNk3Dys7TFVDRcXo9FSYQdeITz8dK91TfeRmfSsRJqPRfUu7ca5mwz94RLCQ+g500OhrpB6NzSgTMYOZhtg9V/RWPRXGhtMbnlzD2aNR4NQX6uA+9Fbil9TVlMH63ldXKz6YNH/z/Sufl/WJzvm41PXF0XSOWQT1dB4Thul5ufeNitgohFjGQkAhCgGFgEJAIQoBhYBCQCEKAYWAQkAhCgGFgEJAIQoBhYBCQCEKAYWAQkAhCgGFgEJAIQoBhYBCQCEKAYWAQkAhCgGFgEJAIQrBNv4KMACFHdOLYbHfggAAAABJRU5ErkJggg=="

/***/ }),

/***/ "XXgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"step-back-button",attrs:{"title":"Voltar"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":__webpack_require__("Ojov"),"alt":"seta voltar"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XZRT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Friend_vue__ = __webpack_require__("uDCq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1abed7cf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Friend_vue__ = __webpack_require__("vnQG");
function injectStyle (ssrContext) {
  __webpack_require__("8knn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1abed7cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Friend_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1abed7cf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Friend_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XaRt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xadi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatisticsHome_vue__ = __webpack_require__("v9SY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1edf3ff9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatisticsHome_vue__ = __webpack_require__("XeEQ");
function injectStyle (ssrContext) {
  __webpack_require__("Tywc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1edf3ff9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatisticsHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1edf3ff9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatisticsHome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XeEQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.Renderizou)?_c('div',{staticClass:"statistics statistics__home"},[(this.Estatisticas == 'Não Possui Investimentos')?_c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(this.Estatisticas == 'Loading')?_c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard"},[_vm._m(1)]):_vm._e(),_vm._v(" "),_vm._m(2),_vm._v(" "),(this.Estatisticas == 'Possui Investimentos' && this.Renderizou == true && _vm.showMeInfo())?_c('div',{staticClass:"box mb-4"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12 col-md-7 col-lg-8 d-flex align-items-start flex-column box-left hide-mobile"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"foot align-self-end"},[_c('div',{staticClass:"row no-gutters align-items-center"},[(_vm.Renderizou == true)?_c('div',{staticClass:"col-12 col-md-6 foot-item"},[_c('div',{staticClass:"p-3 p-lg-6"},[_c('label',[_vm._v("Investimentos em empréstimos coletivos")]),_vm._v(" "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.money(_vm.TipoInvestimento.Coletivo.Valor)))])])]):_vm._e(),_vm._v(" "),(_vm.Renderizou == true)?_c('div',{staticClass:"col-12 col-md-6 foot-item"},[_c('div',{staticClass:"p-3 p-md-6"},[_c('label',[_vm._v("Investimentos em empréstimos de impacto")]),_vm._v(" "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.money(_vm.TipoInvestimento.Impacto.Valor)))])])]):_vm._e(),_vm._v(" "),(_vm.Renderizou == true)?_c('div',{staticClass:"col-12 col-md-6 foot-item lower-item"},[_c('div',{staticClass:"p-3 p-md-6"},[_c('label',[_vm._v("Investimentos em empréstimos antecipação")]),_vm._v(" "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.money(_vm.TipoInvestimento.Antecipacao.Valor)))])])]):_vm._e(),_vm._v(" "),(_vm.Renderizou == true)?_c('div',{staticClass:"col-12 col-md-6 foot-item lower-item"},[_c('div',{staticClass:"p-3 p-md-6"},[_c('label',[_vm._v("Investimentos em empréstimos sociais")]),_vm._v(" "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.money(_vm.TipoInvestimento.Social.Valor)))])])]):_vm._e()])])]),_vm._v(" "),(_vm.Renderizou == true)?_c('div',{staticClass:"col-12 col-md-5 col-lg-4 box-right"},[_c('div',{staticClass:"p-3 p-md-4"},[_c('h3',[_vm._v("Total de investimentos "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"São considerados apenas investimentos com oportunidades finalizadas, ou seja, as reservas de investimento somente são adicionadas após a oportunidade encerrada e o investimento confirmado."}},[_c('i',{staticClass:"fas fa-info-circle",staticStyle:{"font-size":"14px"}})]),_c('span',[_vm._v(_vm._s(_vm.Rendimento.TotalInvestimentos.Numero))])],1),_vm._v(" "),_c('ul',{staticClass:"values"},[_c('li',[_c('span',[_vm._v("Atual \n                                "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Investimentos com pagamentos pendentes a receber que estão em dia."}},[_c('i',{staticClass:"fas fa-info-circle",staticStyle:{"font-size":"14px"}})])],1),_vm._v(" "),(_vm.valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Rendimento.AReceber.Valor - _vm.ValorExpirados)))]):_c('span',[_vm._v(_vm._s(_vm.Rendimento.AReceber.Numero - _vm.Atrasados.Numero))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Período de carência \n                                "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Corresponde ao período compreendido entre a concessão do empréstimo e o pagamento da primeira amortização + juros."}},[_c('i',{staticClass:"fas fa-info-circle",staticStyle:{"font-size":"14px"}})])],1),_vm._v(" "),(_vm.valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Carencia.Valor)))]):_c('span',[_vm._v(_vm._s(_vm.Carencia.Numero))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("1-15 dias de atraso \n                                "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Seus investimentos que estão com 1 a 15 dias de atraso."}},[_c('i',{staticClass:"fas fa-info-circle",staticStyle:{"font-size":"14px"}})])],1),_vm._v(" "),(_vm.valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Atrasados.Reservas.Atrasados1.Valor)))]):_c('span',[_vm._v(_vm._s(_vm.Atrasados.Reservas.Atrasados1.Numero))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("16-30 dias de atraso \n                                "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Seus investimentos que estão com 16 a 30 dias de atraso."}},[_c('i',{staticClass:"fas fa-info-circle",staticStyle:{"font-size":"14px"}})])],1),_vm._v(" "),(_vm.valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Atrasados.Reservas.Atrasados2.Valor)))]):_c('span',[_vm._v(_vm._s(_vm.Atrasados.Reservas.Atrasados2.Numero))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("31 a 60 dias de atraso \n                                "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Seus investimentos que estão com 31 a 60 dias de atraso."}},[_c('i',{staticClass:"fas fa-info-circle",staticStyle:{"font-size":"14px"}})])],1),_vm._v(" "),(_vm.valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Atrasados.Reservas.Atrasados3.Valor)))]):_c('span',[_vm._v(_vm._s(_vm.Atrasados.Reservas.Atrasados3.Numero))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("+60 dias de atraso \n                                "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right","content":"Os pagamentos para estes empréstimos estão com mais de 60 dias de atraso. Existe uma expectativa razoável de que o mutuário será capaz de trazer o empréstimo de volta ao status atual."}},[_c('i',{staticClass:"fas fa-info-circle",staticStyle:{"font-size":"14px"}})])],1),_vm._v(" "),(_vm.valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Atrasados.Reservas.Expirado.Valor)))]):_c('span',[_vm._v(_vm._s(_vm.Atrasados.Reservas.Expirado.Numero))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Total")]),_vm._v(" "),(_vm.valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Atrasados.Valor + _vm.Rendimento.AReceber.Valor + _vm.Carencia.Valor - _vm.ValorExpirados)))]):_c('span',[_vm._v(_vm._s(_vm.Rendimento.AReceber.Numero + _vm.Carencia.Numero))])])])]),_vm._v(" "),_c('div',{staticClass:"foot"},[_c('div',{staticClass:"p-3 p-md-4"},[_c('h3',[_vm._v("Investimentos por Score "),_c('at-popover',{attrs:{"trigger":"hover","placement":"right"}})],1),_vm._v(" "),_c('ul',{staticClass:"rating score"},[_c('li',[_vm._m(4),_vm._v(" "),(_vm.valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Scores.AA.Valor)))]):_c('span',[_vm._v(_vm._s(_vm.Scores.AA.Numero))])]),_vm._v(" "),_c('li',[_vm._m(5),_vm._v(" "),(_vm.valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Scores.A.Valor)))]):_c('span',[_vm._v(_vm._s(_vm.Scores.A.Numero))])]),_vm._v(" "),_c('li',[_vm._m(6),_vm._v(" "),(_vm.valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Scores.B.Valor)))]):_c('span',[_vm._v(_vm._s(_vm.Scores.B.Numero))])]),_vm._v(" "),_c('li',[_vm._m(7),_vm._v(" "),(_vm.valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Scores.C.Valor)))]):_c('span',[_vm._v(_vm._s(_vm.Scores.C.Numero))])]),_vm._v(" "),_c('li',[_vm._m(8),_vm._v(" "),(_vm.valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Scores.D.Valor)))]):_c('span',[_vm._v(_vm._s(_vm.Scores.D.Numero))])]),_vm._v(" "),_c('li',[_vm._m(9),_vm._v(" "),(_vm.valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Scores.E.Valor)))]):_c('span',[_vm._v(_vm._s(_vm.Scores.E.Numero))])]),_vm._v(" "),_c('li',[_vm._m(10),_vm._v(" "),(_vm.valor)?_c('span',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Scores.HR.Valor)))]):_c('span',[_vm._v(_vm._s(_vm.Scores.HR.Numero))])])])]),_vm._v(" "),_c('div',{staticClass:"p-3 p-md-4"},[_c('div',{staticClass:"d-flex pt-4"},[_c('div',{staticClass:"form-check pr-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valor),expression:"valor"}],staticClass:"option-input radio",attrs:{"id":"valor","type":"radio","name":"tipo"},domProps:{"value":true,"checked":true,"checked":_vm._q(_vm.valor,true)},on:{"change":function($event){_vm.valor=true}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor"}},[_vm._v("Por valores")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valor),expression:"valor"}],staticClass:"option-input radio",attrs:{"id":"num","type":"radio","name":"tipo"},domProps:{"checked":_vm._q(_vm.valor,null)},on:{"change":function($event){_vm.valor=null}}}),_vm._v(" "),_c('label',{attrs:{"for":"num"}},[_vm._v("Por números")])])])])])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.Estatisticas == 'Possui Investimentos' && _vm.Renderizou == true && _vm.showMeInfo())?_c('div',{staticClass:"box mb-4"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-12 d-flex align-items-start flex-column box-item hide-mobile"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"foot align-self-end"},[_c('div',{staticClass:"row no-gutters align-items-center"},[(_vm.Renderizou == true)?_c('div',{staticClass:"col-12 col-md-3 foot-item"},[_c('div',{staticClass:"p-3 p-lg-3"},[_c('label',[_vm._v("Total Investido")]),_vm._v(" "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Rendimento.Investido.Valor)))])])]):_vm._e(),_vm._v(" "),(_vm.Renderizou == true)?_c('div',{staticClass:"col-12 col-md-3 foot-item"},[_c('div',{staticClass:"p-3 p-md-3"},[_c('label',[_vm._v("Rendimento Esperado")]),_vm._v(" "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Rendimento.TotalInvestimentos.Valor)))])])]):_vm._e(),_vm._v(" "),(_vm.Renderizou == true)?_c('div',{staticClass:"col-12 col-md-2 foot-item"},[_c('div',{staticClass:"p-3 p-md-3"},[_c('label',[_vm._v("Previsão a receber próximo mês")]),_vm._v(" "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.money(_vm.ProximoMes.Valor + _vm.EsteMes.Valor)))])])]):_vm._e(),_vm._v(" "),(_vm.Renderizou == true)?_c('div',{staticClass:"col-12 col-md-2 foot-item"},[_c('div',{staticClass:"p-3 p-md-3"},[_c('label',[_vm._v("Rendimento sobre CDI")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.CDI.toFixed(2))+"%")])])]):_vm._e(),_vm._v(" "),(_vm.Renderizou == true)?_c('div',{staticClass:"col-12 col-md-2 foot-item"},[_c('div',{staticClass:"p-3 p-md-3"},[_c('label',[_vm._v("Taxa interna de retorno (T.I.R.)")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.TIR.toFixed(2))+"%")])])]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(_vm.Estatisticas == 'Possui Investimentos' && _vm.Renderizou == true && _vm.showMeInfo())?_c('div',{staticClass:"box"},[_c('div',{staticClass:"row no-gutters"})]):_vm._e(),_vm._v(" "),(_vm.Estatisticas == 'Possui Investimentos' && _vm.Renderizou == true && _vm.showMeInfo())?_c('div',{staticClass:"mt-4 p-3 p-md-4 box box-item-full hide-mobile"},[_c('h4',[_vm._v("Rendimentos por investimento")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover"},[_vm._m(12),_vm._v(" "),_c('tbody',_vm._l((_vm.HistoricoReservas),function(Reserva){return _c('tr',{key:Reserva.IDOportunidade,on:{"click":function($event){return _vm.linkReserva(Reserva._id)}}},[_c('th',{staticClass:"text-secondary",staticStyle:{"cursor":"pointer"},attrs:{"scope":"row"}},[_c('at-popover',{attrs:{"trigger":"hover","placement":"top","content":_vm.NomeEmpresa(Reserva.NomeEmpresa)}},[_vm._v("\n                                "+_vm._s(_vm.ajustIdOportunidade(Reserva.IDOportunidade,5))+"\n                            ")])],1),_vm._v(" "),_c('td',{staticClass:"rating score"},[_c('span',{staticClass:"item"},[_c('i',{class:_vm.lowerCase(Reserva.Score)}),_vm._v(_vm._s(_vm.ajustaScore(Reserva.Score)))])]),_vm._v(" "),_c('td',[_c('div',[_vm._v("\n                                R$ "+_vm._s(_vm.money(Reserva.Valor))+" @ "+_vm._s(Reserva.TaxaRetornoAA)+"% a.a.\n                                "),_c('span',{staticClass:"grafico"},[_c('span',{staticClass:"grafico-bar",staticStyle:{"width":"100%"}}),_vm._v(" "),_c('span',{staticClass:"grafico-bar",style:(_vm.PorcentagemRendimento(Reserva.Valor , Reserva.TaxaRetornoAA))})])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Reserva.RendimentoCDI)+"% a.a.")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(Reserva.Created)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Reserva.Prazo)+" meses")]),_vm._v(" "),_c('td',[_c('span',{class:_vm.Status(Reserva.Status)},[_vm._v(_vm._s(_vm.TextoStatus(Reserva.Status)))])])])}),0),_vm._v(" "),_c('tfoot',[(!_vm.VisualizarTodos && _vm.AuxHistoricoReservas.length > 5)?_c('th',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('button',{staticClass:"btn btn-lg btn-link text-secondary",on:{"click":function($event){return _vm.MostraInvestimentos()}}},[_vm._v("Visualizar todos os investimentos")])]):_vm._e()])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard"},[(!_vm.showMeInfo())?_c('no-data-profile',{attrs:{"Msg":_vm.showMeMsg}}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard__complete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('div',[_c('h1',[_vm._v("Minhas estatísticas")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard__complete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('div',[_c('h1',[_vm._v("Carregando...")]),_vm._v(" "),_c('div',{staticClass:"loader"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row show-mobile"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n                Para ter acesso completo as estátisticas da plataforma acesse a partir de um desktop ou notebook.\n            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3 p-md-4 w-100 mb-auto"},[_c('h2',[_vm._v("Meus investimentos")]),_vm._v(" "),_c('ul',{staticClass:"nav nav-tabs",attrs:{"id":"myTab","role":"tablist"}},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"id":"home-tab","data-toggle":"tab","href":"#home","role":"tab","aria-controls":"home","aria-selected":"true"}},[_vm._v("Investimentos atrasados")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"id":"profile-tab","data-toggle":"tab","href":"#profile","role":"tab","aria-controls":"profile","aria-selected":"false"}},[_vm._v("Investimentos por score")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content",attrs:{"id":"myTabContent"}},[_c('div',{staticClass:"tab-pane fade pt-3 active show",attrs:{"id":"home","role":"tabpanel","aria-labelledby":"home-tab"}},[_c('canvas',{staticClass:"box box_chart",staticStyle:{"margin-top":"10%"},attrs:{"id":"GraficoInvestimentos"}})]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade pt-3",attrs:{"id":"profile","role":"tabpanel","aria-labelledby":"profile-tab"}},[_c('canvas',{staticStyle:{"margin-top":"10%"},attrs:{"id":"GraficoInvestimentosScores"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-aa"}),_vm._v(" AA")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-a"}),_vm._v(" A")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-b"}),_vm._v(" B")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-c"}),_vm._v(" C")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-d"}),_vm._v(" D")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-e"}),_vm._v(" E")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('i',{staticClass:"dot rating-hr"}),_vm._v(" HR")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3 p-md-4 w-100 mb-auto"},[_c('h4',{staticStyle:{"margin-bottom":"5%"}},[_vm._v("Rendimento Geral da Carteira")]),_vm._v(" "),_c('div',{staticClass:"tab-content",attrs:{"id":"myTabContent"}},[_c('div',{staticClass:"tab-pane fade pt-3 active show",attrs:{"id":"home","role":"tabpanel","aria-labelledby":"home-tab"}},[_c('canvas',{staticClass:"box box_chart",staticStyle:{"margin":"auto","max-height":"550px","width":"100%"},attrs:{"id":"GraficoRendimentoGeral"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticStyle:{"text-align":"left"},attrs:{"scope":"col"}},[_vm._v("ID")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Score")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Valor investido @ Retorno %")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Rendimento sobre CDI")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Data do invest.")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Duração")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XlwF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XqQ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FilesInput__ = __webpack_require__("/7yn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Modal: __WEBPACK_IMPORTED_MODULE_1__components_Modal__["a" /* default */], FilesInput: __WEBPACK_IMPORTED_MODULE_2__components_FilesInput__["a" /* default */] },
    data: function data() {
        return {
            response: false,
            showModal: false,
            submitted: false,
            created: {},
            ArquivosIdentidade: {},
            ArquivoFotoIdentificacao: {},
            ArquivoComprovanteEndereco: {},
            ArquivoHolerite: {},
            ArquivoExtratoBancario: {},
            tipoArquivoSelecionado: "",
            campoArquivoMongodb: "",
            nomeArquivoSelecionado: "",
            /* eslint-disable */
            uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
            acceptedFormats: 'application/pdf, image/jpeg, image/png',
            files: [null]
        };
    },

    methods: {
        formatDate: function formatDate(data) {
            var dataForm = new Date(data);
            var dia = dataForm.getDate();

            if (dia.toString().length == 1) dia = "0" + dia;

            var mes = dataForm.getMonth() + 1;

            if (mes.toString().length == 1) mes = "0" + mes;

            var ano = dataForm.getFullYear();

            if (isNaN(parseInt(ano)) || isNaN(parseInt(mes)) || isNaN(parseInt(dia))) {

                return this.formatDate(this.created);
            }

            return dia + "/" + mes + "/" + ano;
        },
        exibeModal: function exibeModal(arquivo, tipoArquivoSelecionado, campoNome) {
            this.files = [null];
            this.submitted = false;
            this.showModal = true;

            this.tipoArquivoSelecionado = tipoArquivoSelecionado;
            this.nomeArquivoSelecionado = arquivo.Nome;
            this.campoArquivoMongodb = campoNome;

            if (document.getElementsByTagName("main").length > 0) {
                document.getElementsByTagName("main")[0].style.zIndex = "50";
            }
        },
        onFilesChanged: function onFilesChanged(updatedFiles) {
            this.files = updatedFiles;
        },
        removeFile: function removeFile(index) {
            this.files.splice(index, 1);
        },
        clearFile: function clearFile(index) {
            this.$set(this.files, index, null);
        },
        validate: function validate() {
            if (this.receivedFiles.length > 0) {
                return { isValid: true, errors: [] };
            } else {
                return { isValid: false, errors: ['O envio do documento de identidade é obrigatório'] };
            }
        },
        submit: function submit() {
            this.submitted = true;
            __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].createDocumentos(this.getType, this.campoArquivoMongodb, this.getId, this.nomeArquivoSelecionado, this.receivedFiles).then(function () {});
        },
        closeModal: function closeModal() {
            var _this = this;

            this.showModal = false;

            __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getDocumentos(this.getType, this.getId).then(function (response) {
                _this.ArquivosIdentidade = response.data.ArquivosIdentidade;
                _this.ArquivoFotoIdentificacao = response.data.ArquivoFotoIdentificacao;
                _this.ArquivoComprovanteEndereco = response.data.ArquivoComprovanteEndereco;
                _this.ArquivoHolerite = response.data.ArquivoHolerite;
                _this.ArquivoExtratoBancario = response.data.ArquivoExtratoBancario;
                _this.created = response.data.Created;
                _this.response = true;
            });
            if (document.getElementsByTagName("main").length > 0) {
                document.getElementsByTagName("main")[0].style.zIndex = "0";
            }
        },
        nomeArquivo: function nomeArquivo(arquivo) {
            if (arquivo.length > 22) {
                var extensao = arquivo.substr(arquivo.lastIndexOf("."));
                var nome = arquivo.substr(0, arquivo.lastIndexOf("."));

                return nome.substr(0, 15) + "..." + extensao;
            }

            return arquivo;
        }
    },
    props: ['type', 'id'],

    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getDocumentos(this.getType, this.getId).then(function (response) {
            _this2.ArquivosIdentidade = response.data.ArquivosIdentidade;
            _this2.ArquivoFotoIdentificacao = response.data.ArquivoFotoIdentificacao;
            _this2.ArquivoComprovanteEndereco = response.data.ArquivoComprovanteEndereco;
            _this2.ArquivoHolerite = response.data.ArquivoHolerite;
            _this2.ArquivoExtratoBancario = response.data.ArquivoExtratoBancario;
            _this2.created = response.data.Created;
            _this2.response = true;
        });
    },


    computed: {
        getType: function getType() {
            return this.type;
        },
        getId: function getId() {
            return this.id;
        },
        receivedFiles: function receivedFiles() {
            return this.files.filter(function (file) {
                return file != null && file != undefined;
            });
        }
    }
});

/***/ }),

/***/ "Xwp5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NovoCadastroUsuario_vue__ = __webpack_require__("Vyqn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2abc4e2b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NovoCadastroUsuario_vue__ = __webpack_require__("ENCI");
function injectStyle (ssrContext) {
  __webpack_require__("nAhn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2abc4e2b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NovoCadastroUsuario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2abc4e2b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NovoCadastroUsuario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XxMF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XyBL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            lpUrl: "https://iouu.com.br",
            finishedLoading: false,
            solicitacao: null
        };
    },

    props: ['id'],
    computed: {
        getId: function getId() {
            return this.id;
        },

        formattedCnpj: function formattedCnpj() {
            return __WEBPACK_IMPORTED_MODULE_2__utils_masker__["a" /* default */].maskCnpj(this.solicitacao.Documento);
        },
        razaoSocial: function razaoSocial() {
            return this.solicitacao.Ccb.RazaoSocial;
        },
        nomeFantasia: function nomeFantasia() {
            return this.solicitacao.Ccb.NomeFantasia;
        },
        nomeResponsavel: function nomeResponsavel() {
            return this.solicitacao.Nome;
        },
        telefone: function telefone() {
            return this.solicitacao.TelefoneComercial;
        },
        sobreEmpresa: function sobreEmpresa() {
            return this.solicitacao.Ccb.DescricaoEmpresa;
        },
        scoreClass: function scoreClass() {
            if (!this.solicitacao.Score) return "";
            return "rating-" + this.solicitacao.Score.replace(/\d/, '').toLowerCase();
        },
        score: function score() {
            return this.solicitacao.Score;
        },
        valor: function valor() {
            if (!this.solicitacao) return null;
            return this.formatCurrency(this.solicitacao.Valor);
        },
        prazo: function prazo() {
            return this.solicitacao.Prazo;
        },
        parcela: function parcela() {
            return this.formatCurrency(this.solicitacao.ValorParcela);
        },
        valorTotal: function valorTotal() {
            if (this.solicitacao.ValorParcela == 0) {
                return this.formatCurrency(this.solicitacao.Valor);
            } else {
                return this.formatCurrency(this.solicitacao.ValorParcela * this.solicitacao.Prazo);
            }
        },
        taxaJuros: function taxaJuros() {
            return this.formatCurrency(this.solicitacao.TaxaJuros);
        },
        taxaTotal: function taxaTotal() {
            return this.formatCurrency(this.solicitacao.RetornoBrutoAnual);
        },
        dataInicio: function dataInicio() {
            return this.formatData(this.solicitacao.InicioCaptacao);
        },
        dataFim: function dataFim() {
            return this.formatData(this.solicitacao.FimCaptacao);
        },
        dataFuncadao: function dataFuncadao() {
            return this.formatData(this.solicitacao.Ccb.DataFundacao);
        },
        numeroEmpregados: function numeroEmpregados() {
            return this.solicitacao.Ccb.QuantidadeEmpregados;
        },
        grupoEconomico: function grupoEconomico() {
            return this.hasGroup(this.solicitacao.Ccb.NomeGrupoEconomico);
        },
        Endereco: function Endereco() {
            return this.formatAdress(this.solicitacao.Ccb.Endereco);
        },
        site: function site() {
            return this.solicitacao.Ccb.RedesSociais.Site;
        },
        facebook: function facebook() {
            return this.solicitacao.Ccb.RedesSociais.Facebook;
        },
        twitter: function twitter() {
            return this.solicitacao.Ccb.RedesSociais.Twitter;
        },
        instagram: function instagram() {
            return this.solicitacao.Ccb.RedesSociais.Instagram;
        },
        linkdin: function linkdin() {
            return this.solicitacao.Ccb.RedesSociais.Linkedin;
        },
        vimeo: function vimeo() {
            return this.solicitacao.Ccb.RedesSociais.Vimeo;
        },
        email: function email() {
            return this.solicitacao.Email;
        },
        valorCaptado: function valorCaptado() {
            return this.formatCurrency(this.solicitacao.ValorCaptado);
        },
        investidores: function investidores() {
            return this.solicitacao.QuantidadeReservasInvestimento;
        },
        percentValorCaptado: function percentValorCaptado() {
            if (this.solicitacao.ValorCaptado === 0 || this.solicitacao.ValorCaptado === undefined) {
                return this.formatCurrency(0);
            } else {
                return this.formatCurrency(this.solicitacao.ValorCaptado * 100 / this.solicitacao.Valor);
            }
        }
    },
    methods: {
        ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
            var s = String(id);
            while (s.length < (qtd || 2)) {
                s = "0" + s;
            }
            return s;
        },
        formatCurrency: function formatCurrency(value) {
            if (value !== undefined) {
                return value.toLocaleString('pt-BR', {
                    minimumFractionDigits: "2",
                    maximumFractionDigits: 2
                });
            }
        },
        formatData: function formatData(data) {
            var date = new Date(data);
            return date.toLocaleDateString('pt-BR');
        },
        hasGroup: function hasGroup(item) {
            var msg = void 0;

            if (item) {
                msg = "Pertence a um grupo econômico";
            } else {
                msg = "Não pertence a nenhum grupo econômico";
            }

            return msg;
        },
        formatAdress: function formatAdress(obj) {

            var logra = obj.Logradouro;
            var num = obj.Numero;
            var comp = obj.Complemento;
            var bairro = obj.Bairro;
            var cep = obj.Cep;
            var city = obj.Cidade;
            var uf = obj.Uf;

            var adress = logra + ", " + num + " - " + comp + ", " + bairro + " - " + cep + ", " + city + "/" + uf;

            return adress;
        }
    },
    created: function created() {
        var _this = this;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["c" /* START_LOADING */]);

        __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getLoanRequest(this.getId).then(function (response) {
            _this.solicitacao = response;

            _this.finishedLoading = true;
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["d" /* STOP_LOADING */]);
        }).catch(function () {
            _this.finishedLoading = true;
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    }
});

/***/ }),

/***/ "Y8LY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YGw8":
/***/ (function(module, exports) {

module.exports = {"v":"5.1.20","fr":60,"ip":9,"op":369,"w":500,"h":500,"nm":"IOUU","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"logotipo Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[250,250,0],"ix":2},"a":{"a":0,"k":[250,250,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-6.819,126.157],[6.82,126.157],[6.82,-126.157],[-6.819,-126.157]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.255000005984,0.827000038297,0.741000007181,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[492.894,123.085],"ix":2},"a":{"a":0,"k":[-0.286,-126.665],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833],"y":[0.833,0.833]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":291,"s":[100,100],"e":[100,0]},{"t":322}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":231,"s":[0],"e":[100]},{"t":232}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Barra Vertical - 2","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[236.111,6.944],[236.111,-6.944],[-236.111,-6.944],[-236.111,6.944]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.255000005984,0.827000038297,0.741000007181,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[486.374,368.962],"ix":2},"a":{"a":0,"k":[236.125,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833],"y":[0.833,0.833]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":264,"s":[100,100],"e":[0,100]},{"t":294}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":232,"s":[0],"e":[100]},{"t":233}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Barra Horizontal","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-6.945,126.157],[6.945,126.157],[6.945,-126.157],[-6.945,-126.157]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.255000005984,0.827000038297,0.741000007181,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[6.78,376.36],"ix":2},"a":{"a":0,"k":[-0.415,126.11],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833],"y":[0.833,0.833]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":233,"s":[100,100],"e":[100,0]},{"t":264}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":231,"s":[0],"e":[100]},{"t":232}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Barra Vertical - 1","np":2,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[2.253,2.165],[3.235,0],[2.241,-2.153],[0,-3.141],[-2.253,-2.164],[-3.236,0],[-2.241,2.154],[0,3.14]],"o":[[-2.241,-2.153],[-3.236,0],[-2.253,2.165],[0,3.14],[2.241,2.154],[3.235,0],[2.253,-2.164],[0,-3.141]],"v":[[8.253,-7.996],[0,-11.241],[-8.254,-7.996],[-11.649,0],[-8.254,7.996],[0,11.241],[8.253,7.996],[11.649,0]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.255000005984,0.827000038297,0.741000007181,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":164,"s":[434.99,320],"e":[434.99,292.666],"to":[0,-4.55559778213501],"ti":[0,4.55559778213501]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":197,"s":[434.99,292.666],"e":[434.99,292.666],"to":[0,0],"ti":[0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":342,"s":[434.99,292.666],"e":[434.99,262.666],"to":[0,-5],"ti":[0,5]},{"t":366}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":164,"s":[0],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":197,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":342,"s":[100],"e":[0]},{"t":366}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":".","np":2,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[2.871,-3.478],[4.929,0],[2.893,3.46],[0,0],[0,6.107],[0,0],[0,0],[0,0],[-6.928,-6.46],[-10.665,0],[-6.863,6.403],[0,11.891],[0,0]],"o":[[0,0],[0,6.108],[-2.853,3.456],[-4.931,0],[0,0],[-2.904,-3.473],[0,0],[0,0],[0,0],[0,11.817],[6.906,6.441],[10.667,0],[6.89,-6.423],[0,0],[0,0]],"v":[[15.95,-41.605],[15.95,3.781],[11.624,18.228],[0.059,23.364],[-11.57,18.221],[-11.571,18.221],[-15.949,3.781],[-15.949,-41.605],[-36.862,-41.605],[-36.862,4.354],[-26.421,31.898],[0.059,41.605],[26.479,31.956],[36.862,4.354],[36.862,-41.605]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.255000005984,0.827000038297,0.741000007181,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":147,"s":[361.137,290],"e":[361.137,289.187],"to":[0,-0.23603557050228],"ti":[0,0.30447718501091]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":148,"s":[361.137,289.187],"e":[361.137,262.188],"to":[0,-5.67503929138184],"ti":[0,4.39938116073608]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":181,"s":[361.137,262.188],"e":[361.137,262.188],"to":[0,-4.63541650772095],"ti":[0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":325,"s":[361.137,262.188],"e":[361.137,232.188],"to":[0,0],"ti":[0,0]},{"t":352}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":148,"s":[0],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":181,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":325,"s":[100],"e":[0]},{"t":352}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"U","np":2,"cix":2,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[2.871,-3.478],[4.929,0],[2.893,3.46],[0,0],[0,6.107],[0,0],[0,0],[0,0],[-6.928,-6.46],[-10.666,0],[-6.863,6.403],[0,11.891],[0,0]],"o":[[0,0],[0,6.108],[-2.853,3.456],[-4.931,0],[0,0],[-2.904,-3.473],[0,0],[0,0],[0,0],[0,11.817],[6.906,6.441],[10.667,0],[6.89,-6.423],[0,0],[0,0]],"v":[[15.95,-41.605],[15.95,3.781],[11.624,18.228],[0.059,23.364],[-11.57,18.221],[-11.571,18.221],[-15.949,3.781],[-15.949,-41.605],[-36.862,-41.605],[-36.862,4.354],[-26.421,31.898],[0.059,41.605],[26.479,31.956],[36.862,4.354],[36.862,-41.605]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.255000005984,0.827000038297,0.741000007181,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":130,"s":[258.138,290],"e":[258.138,262.188],"to":[0,0],"ti":[0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":164,"s":[258.138,262.188],"e":[258.138,262.188],"to":[0,0],"ti":[0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":310,"s":[258.138,262.188],"e":[258.138,232.188],"to":[0,0],"ti":[0,0]},{"t":338}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":131,"s":[0],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":164,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":310,"s":[100],"e":[0]},{"t":338}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"U","np":2,"cix":2,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[4.534,-4.756],[6.594,0],[4.517,4.743],[0,6.802],[-4.536,4.796],[-6.591,0],[-4.52,-4.78],[0,-6.804]],"o":[[-4.519,4.742],[-6.595,0],[-4.535,-4.755],[0,-6.804],[4.519,-4.78],[6.59,0],[4.535,4.796],[0,6.803]],"v":[[16.806,17.477],[0.06,24.623],[-16.686,17.476],[-23.52,0.058],[-16.683,-17.423],[0.06,-24.625],[16.803,-17.423],[23.639,0.058]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[8.628,8.098],[12.565,0],[8.607,-8.077],[0,-12.043],[-8.627,-8.097],[-12.566,0],[-8.609,8.077],[0,12.04]],"o":[[-8.609,-8.077],[-12.566,0],[-8.627,8.096],[0,12.041],[8.607,8.077],[12.565,0],[8.628,-8.099],[0,-12.04]],"v":[[31.907,-30.349],[0,-42.522],[-31.908,-30.349],[-44.908,0],[-31.908,30.349],[0,42.522],[31.907,30.349],[44.909,0]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.255000005984,0.827000038297,0.741000007181,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":112,"s":[150.668,290],"e":[150.668,261.271],"to":[0,-4.78816223144531],"ti":[0,4.78816223144531]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":145,"s":[150.668,261.271],"e":[150.668,261.271],"to":[0,0],"ti":[0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":298,"s":[150.668,261.271],"e":[150.668,231.271],"to":[0,-5],"ti":[0,5]},{"t":326}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":112,"s":[0],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":145,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":298,"s":[100],"e":[0]},{"t":326}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"O","np":4,"cix":2,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-10.456,41.204],[10.456,41.204],[10.456,-41.204],[-10.456,-41.204]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.255000005984,0.827000038297,0.741000007181,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":78,"s":[68.413,290],"e":[68.413,261.786],"to":[0,-4.7022500038147],"ti":[0,4.7022500038147]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":111,"s":[68.413,261.786],"e":[68.413,261.786],"to":[0,0],"ti":[0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":286,"s":[68.413,261.786],"e":[68.413,231.786],"to":[0,0],"ti":[0,0]},{"t":311}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":78,"s":[0],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":111,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":286,"s":[100],"e":[0]},{"t":311}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"I","np":2,"cix":2,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-6.819,126.157],[6.82,126.157],[6.82,-126.157],[-6.819,-126.157]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.255000005984,0.827000038297,0.741000007181,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[492.419,375.529],"ix":2},"a":{"a":0,"k":[-0.286,125.805],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833],"y":[0.833,0.833]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":51,"s":[100,0],"e":[100,100]},{"t":78}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":231,"s":[100],"e":[0]},{"t":233}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Barra Vertical - 2 - Entrada","np":2,"cix":2,"ix":9,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[236.111,6.944],[-236.111,6.944],[-236.111,-6.944],[236.111,-6.944]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.255000005984,0.827000038297,0.741000007181,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[15.102,368.925],"ix":2},"a":{"a":0,"k":[-235.574,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833],"y":[0.833,0.833]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":26,"s":[0,100],"e":[100,100]},{"t":51}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":231,"s":[100],"e":[0]},{"t":233}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Barra Horizontal - Entrada","np":2,"cix":2,"ix":10,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-6.945,126.157],[6.945,126.157],[6.945,-126.157],[-6.945,-126.157]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.255000005984,0.827000038297,0.741000007181,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[6.99,124.144],"ix":2},"a":{"a":0,"k":[-0.415,-126.216],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833],"y":[0.833,0.833]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":0,"s":[100,0],"e":[100,100]},{"t":25}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":231,"s":[100],"e":[0]},{"t":233}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Barra Vertical - 1 - Entrada","np":2,"cix":2,"ix":11,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0}],"markers":[]}

/***/ }),

/***/ "YLnY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api_client__ = __webpack_require__("6Yc5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            solicitacao: null,
            renderPage: false
        };
    },

    computed: {
        nome: function nome() {
            this.solicitacao.Nome = this.solicitacao.Nome.trim();
            var name = this.solicitacao.Nome.split(" ");
            var firstName = name[0];

            return firstName;
        }
    },
    beforeCreate: function beforeCreate() {
        var _this = this;

        var idSolicitacao = this.$route.query.id;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types_js__["c" /* START_LOADING */]);
        __WEBPACK_IMPORTED_MODULE_1__utils_api_client__["a" /* default */].getLoanRequest(idSolicitacao).then(function (response) {
            _this.solicitacao = response;
            _this.renderPage = true;
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types_js__["d" /* STOP_LOADING */]);
        }).catch(function () {
            return _this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    }
});

/***/ }),

/***/ "YQ7S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailConfirmation_vue__ = __webpack_require__("sngR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae877b5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailConfirmation_vue__ = __webpack_require__("/Cwo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailConfirmation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae877b5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailConfirmation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YYWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__ = __webpack_require__("65ha");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  /* eslint-disable */
  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_0_vue_select___default.a
  },
  data: function data() {
    var origem = this.currentUser.Pessoal;
    return {
      uf: origem ? origem.EstadoOrigem : null,
      cidade: origem ? origem.CidadeOrigem : "",
      estados: [],
      cidades: []
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  computed: {
    estaCidadeDesabilitado: function estaCidadeDesabilitado() {
      return this.cidades.length == 0;
    }
  },
  methods: {
    onUfChange: function onUfChange() {
      var _this = this;

      this.cidades = [];
      if (!this.uf) {
        this.cidade = '';
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarCidades(this.uf).then(function (cidades) {
        _this.cidades = cidades;
        _this.$refs.citySelect.$el.children[0].children[2].required = true;

        if (_this.cidade) {
          _this.setCity();
        }
      });
    },
    setCity: function setCity() {
      var _this2 = this;

      var city = this.cidades.find(function (city) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__["a" /* default */].removeAccents(city.nome.toUpperCase()) == __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__["a" /* default */].removeAccents(_this2.cidade.toUpperCase());
      });
      if (!city) {
        this.cidade = '';
      } else {
        // When the city state is seted before cities is populated the component doesn't show
        // the selected city.
        this.cidade = '';
        setTimeout(function () {
          return _this2.cidade = city.nome;
        }, 100);
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      this.currentUser.Pessoal.EstadoOrigem = this.uf;

      this.$emit('on-submit', { Pessoal: this.currentUser.Pessoal });
    }
  },
  created: function created() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarEstados().then(function (estados) {
      _this3.estados = estados;
      // When the city state is seted before cities is populated the component doesn't show
      // the selected city.
      var uf = _this3.uf;
      var city = _this3.cidade;
      _this3.uf = '';

      setTimeout(function () {
        _this3.uf = uf;
        _this3.cidade = city;
      }, 100);
    });
  },
  mounted: function mounted() {
    var _this4 = this;

    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");

    if (this.currentUser.Pessoal.CidadeOrigem) {
      setTimeout(function () {
        document.getElementsByClassName('at-select__input')[1].value = _this4.currentUser.Pessoal.CidadeOrigem;
      }, 1000);
    }
  }
});

/***/ }),

/***/ "YZc4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var social = this.currentUser.Social;
    return {
      celular: social.Celular !== "" ? social.Celular : this.currentUser.Celular,
      telefone: social ? social.Telefone : ""
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      this.currentUser.Social.Celular = this.celular;
      this.currentUser.Social.Telefone = this.telefone;

      var newData = { Social: this.currentUser.Social };
      this.$emit('on-submit', newData);
    }
  }
});

/***/ }),

/***/ "YZjq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_layouts_ApplicationLayout__ = __webpack_require__("0ixW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_layouts_InvestorLayout__ = __webpack_require__("vPU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_layouts_LoansLayout__ = __webpack_require__("vbUL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_layouts_PartnersLayout__ = __webpack_require__("VGSo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_layouts_LoanAlerts__ = __webpack_require__("Tm7c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_layouts_BlankLayout__ = __webpack_require__("/rZg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_layouts_LandingPage__ = __webpack_require__("3AXq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_NotFound__ = __webpack_require__("wkqA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Login__ = __webpack_require__("lmfZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_NovoCadastroUsuario__ = __webpack_require__("Xwp5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_CriarConta__ = __webpack_require__("OkiU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_CriarContaConvidado__ = __webpack_require__("5KuI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_CriarContaSenha__ = __webpack_require__("Bc9P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_EmailConfirmation__ = __webpack_require__("YQ7S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_CadastrarSenha__ = __webpack_require__("LL4/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_CadastrarSenhaUsuario__ = __webpack_require__("22Qi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_RecuperarSenha__ = __webpack_require__("BdGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_NovaSenha__ = __webpack_require__("rMKe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_OauthCallback__ = __webpack_require__("TNve");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_layouts_AdditionalInformationLayout__ = __webpack_require__("5s8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_layouts_AdditionalLoansLayout__ = __webpack_require__("+d5J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_AdditionalInformationPeerToPeer__ = __webpack_require__("kQYy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_AdditionalInformationPersonalLoan__ = __webpack_require__("A+FD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_AdditionalInformationConstrucao__ = __webpack_require__("R97G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_AdditionalInformationInvestor__ = __webpack_require__("yRdc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_InformationSuitability__ = __webpack_require__("uIh4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_InformationSuitabilityVerify__ = __webpack_require__("VJU9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_layouts_OpportunitiesLayout__ = __webpack_require__("MNyK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_SolicitacaoAnalise__ = __webpack_require__("xqTD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_SolicitacaoNegada__ = __webpack_require__("6USw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_SelectLoanType__ = __webpack_require__("xyjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_Simulation__ = __webpack_require__("nwlg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_LoanSimulation__ = __webpack_require__("HVFy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_LoanSolicitationBeta__ = __webpack_require__("Tt3P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_SelectArea__ = __webpack_require__("f14v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_AdditionalInformationSocial__ = __webpack_require__("9ryf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_HomeInvestor__ = __webpack_require__("lYzJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_ListOpportunities__ = __webpack_require__("1ogn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_ListAntecipationReceivables__ = __webpack_require__("3cNw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_ListHistoric__ = __webpack_require__("nvMk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_HistoricProfile__ = __webpack_require__("9IsA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_ListImpact__ = __webpack_require__("uK8N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_ImpactProfile__ = __webpack_require__("hE0e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_EmprestimoSocialNew__ = __webpack_require__("gGqV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_Checkout__ = __webpack_require__("y0cm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_CompanyProfile__ = __webpack_require__("Jbu1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_CompanyProfileOld__ = __webpack_require__("dzqL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_CCBProfile__ = __webpack_require__("ABW/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_CCBInvestor__ = __webpack_require__("dhL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_ConfirmCadastroInvestor__ = __webpack_require__("RYEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_CCBList__ = __webpack_require__("iR/L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_CCBLoan__ = __webpack_require__("/xRc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_CCBResponse__ = __webpack_require__("vh3o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_FinishInvestment__ = __webpack_require__("BbvO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__views_layouts_MyLoansLayout__ = __webpack_require__("MYhY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_MyLoans__ = __webpack_require__("ecPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__views_Preapproved__ = __webpack_require__("Cenr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__views_PreapprovedDetails__ = __webpack_require__("P9Vy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__views_DetailsLoans__ = __webpack_require__("VToR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__views_AllTickets__ = __webpack_require__("OrXT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__views_Profile__ = __webpack_require__("Twgf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__views_ProfileConf__ = __webpack_require__("zhCa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__views_ProfileNotific__ = __webpack_require__("c6lt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__views_ProfileDocs__ = __webpack_require__("X/+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__views_ProfileHist__ = __webpack_require__("WzCu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__views_ProfileEdit__ = __webpack_require__("50/t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__views_Documentos__ = __webpack_require__("EqLn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__views_Notifications__ = __webpack_require__("0jXR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__views_Wallet_Wallet_vue__ = __webpack_require__("To2E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__views_Wallet_WalletHistorico_vue__ = __webpack_require__("Gu0g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__views_WalletFundsTransfer__ = __webpack_require__("qJuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__views_WalletReceipt__ = __webpack_require__("Fh4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__views_WalletPagamento__ = __webpack_require__("dgb2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__views_WalletAddCash__ = __webpack_require__("/j53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__views_Statistics__ = __webpack_require__("PTxu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__views_StatisticsHome__ = __webpack_require__("Xadi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__views_StatisticsPlatform__ = __webpack_require__("NAvN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__views_StatisticsInvestor__ = __webpack_require__("loe/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__views_StatisticsLoan__ = __webpack_require__("l4O7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__views_Darf__ = __webpack_require__("11Po");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__views_CentralCobranca__ = __webpack_require__("chKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__views_CentralCobrancaView__ = __webpack_require__("pRyu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__views_layouts_LeadLoansLayout__ = __webpack_require__("GtH2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__views_ConfirmCadastroLead__ = __webpack_require__("mTyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__views_CriarContaLead__ = __webpack_require__("vrbk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__views_EmConstrucao__ = __webpack_require__("8xPM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__views_LandingPageInvista__ = __webpack_require__("Cd2i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__views_LandingPageInvistaIouu__ = __webpack_require__("9Kqi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__views_ReportYield__ = __webpack_require__("RK/L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__views_NewLogin_vue__ = __webpack_require__("2YDi");



// PARA RODAR NO LOCAL
// import InvestorLayoutDesign from '@/views/layouts/InvestorLayoutDesign'

// import NewInvestorLayout from '@/views/layouts/NewInvestorLayout'






// import Home from '@/views/Home'



//import LoginPreview from '@/views/LoginPreview'












//import AdditionalInformationPeerToPeerBeta from '@/views/AdditionalInformationPeerToPeerBeta'












//import Loans from '@/views/Loans'

// import InviteFriend from '@/views/InviteFriend'


// TEMPLATES INVESTIDORES


















// import InvestorWallet from '@/views/InvestorWallet'


// TEMPLATES EMPRESTIMOS
// import HomeLoans from '@/views/HomeLoans'









// TEMPLATES DE PERFIL









// TEMPLATES WALLET







// TEMPLATES STATISTICS






// DARF


// CENTRAL DE COBRANÇA



//Leads




//Em Construção


// Landing Pages





/**
 * New Page Login
 */


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [
    // {
    //     path: '/login',
    //     name: 'Login',
    //     component: Login,
    //     meta: { onlyNotAuthenticated: true }
    // },
    {
        path: '/login',
        name: 'NewLogin',
        component: __WEBPACK_IMPORTED_MODULE_91__views_NewLogin_vue__["a" /* default */]
    }, {
        path: '/escolher-conta',
        name: 'EscolherConta',
        component: __WEBPACK_IMPORTED_MODULE_12__views_CriarConta__["a" /* default */],
        meta: { onlyNotAuthenticated: true }
    },
    /*{
        path: '/LoginPreview/:id',
        name: 'LoginPreview',
        component: LoginPreview,
    },*/
    {
        path: '/criar-conta',
        name: 'CriarConta',
        component: __WEBPACK_IMPORTED_MODULE_11__views_NovoCadastroUsuario__["a" /* default */],
        meta: { onlyNotAuthenticated: true }
    }, {
        path: '/criar-senha',
        name: 'CriarSenha',
        component: __WEBPACK_IMPORTED_MODULE_14__views_CriarContaSenha__["a" /* default */],
        meta: { onlyNotAuthenticated: true }
    }, {
        path: '/criar-conta/ref/:id',
        name: 'Criar conta convidado',
        component: __WEBPACK_IMPORTED_MODULE_13__views_CriarContaConvidado__["a" /* default */],
        meta: { onlyNotAuthenticated: true }
    }, {
        path: '/criar-conta-lead/',
        name: 'Criar conta lead',
        component: __WEBPACK_IMPORTED_MODULE_86__views_CriarContaLead__["a" /* default */],
        meta: { onlyNotAuthenticated: true }
    }, {
        path: '/landing-page/invista-com-alta-rentabilidade',
        component: __WEBPACK_IMPORTED_MODULE_8__views_layouts_LandingPage__["a" /* default */],
        meta: { onlyNotAuthenticated: true },
        children: [{
            path: '',
            name: 'Invista com alta rentabilidade',
            component: __WEBPACK_IMPORTED_MODULE_88__views_LandingPageInvista__["a" /* default */]
        }]
    }, {
        path: '/landing-page/seja-um-investidor-iouu',
        component: __WEBPACK_IMPORTED_MODULE_8__views_layouts_LandingPage__["a" /* default */],
        meta: { onlyNotAuthenticated: true },
        children: [{
            path: '',
            name: 'Seja um investidor IOUU',
            component: __WEBPACK_IMPORTED_MODULE_89__views_LandingPageInvistaIouu__["a" /* default */]
        }]
    }, {
        path: '/call/serasa',
        name: 'Serasa',
        component: __WEBPACK_IMPORTED_MODULE_84__views_layouts_LeadLoansLayout__["a" /* default */],
        meta: { onlyNotAuthenticated: true },
        children: [{
            path: '',
            name: 'Lead Confirm',
            component: __WEBPACK_IMPORTED_MODULE_85__views_ConfirmCadastroLead__["a" /* default */]
        }]
    }, {
        path: '/confirmacao-email',
        name: 'EmailConfirmation',
        component: __WEBPACK_IMPORTED_MODULE_15__views_EmailConfirmation__["a" /* default */]
    }, {
        path: '/confirmacao-ccb/:id',
        component: __WEBPACK_IMPORTED_MODULE_21__views_layouts_AdditionalInformationLayout__["a" /* default */],
        children: [{
            path: '',
            name: 'CCBConfirmation',
            component: __WEBPACK_IMPORTED_MODULE_54__views_CCBResponse__["a" /* default */]
        }]

    }, {
        path: '/cadastro-concluido-com-sucesso',
        component: __WEBPACK_IMPORTED_MODULE_21__views_layouts_AdditionalInformationLayout__["a" /* default */],
        children: [{
            path: '',
            name: 'CadastroUserConcluidoInvestidor',
            component: __WEBPACK_IMPORTED_MODULE_51__views_ConfirmCadastroInvestor__["a" /* default */]
        }]

    }, {
        path: '/cadastrar-senha',
        name: 'CadastrarSenha',
        component: __WEBPACK_IMPORTED_MODULE_16__views_CadastrarSenha__["a" /* default */]
    }, {
        path: '/cadastrar-senha-do-usuario',
        name: 'CadastrarSenhaUsuario',
        component: __WEBPACK_IMPORTED_MODULE_17__views_CadastrarSenhaUsuario__["a" /* default */]
    }, {
        path: '/recuperar-senha',
        name: 'RecuperarSenha',
        component: __WEBPACK_IMPORTED_MODULE_18__views_RecuperarSenha__["a" /* default */]
    }, {
        path: '/nova-senha',
        name: 'NovaSenha',
        component: __WEBPACK_IMPORTED_MODULE_19__views_NovaSenha__["a" /* default */]
    }, {
        path: '/oauth/:provider/callback',
        name: 'OauthCallback',
        component: __WEBPACK_IMPORTED_MODULE_20__components_OauthCallback__["default"]
    }, {
        path: 'estatisticas',
        name: 'Estatísticas',
        component: __WEBPACK_IMPORTED_MODULE_87__views_EmConstrucao__["a" /* default */]
    }, {
        path: 'perguntas-respostas',
        name: 'PerguntaseRespostas',
        component: __WEBPACK_IMPORTED_MODULE_87__views_EmConstrucao__["a" /* default */]
    }, {
        path: '/carteira-investimento',
        nome: 'Carteira de Investimento',
        component: __WEBPACK_IMPORTED_MODULE_87__views_EmConstrucao__["a" /* default */]
    }, {
        path: '/informacoes-adicionais', // INFORMAÇÕES ADCIONAIS PARA EMPRESTIMOS
        component: __WEBPACK_IMPORTED_MODULE_22__views_layouts_AdditionalLoansLayout__["a" /* default */],
        meta: { onlyAuthenticated: true },
        children: [{
            path: 'selecionar-area',
            component: __WEBPACK_IMPORTED_MODULE_36__views_SelectArea__["a" /* default */]
        }, {
            path: 'emprestimo-pessoal/:id',
            component: __WEBPACK_IMPORTED_MODULE_24__views_AdditionalInformationPersonalLoan__["a" /* default */], //AdditionalInformationContrucao (testar em desenv 1.0.19),
            meta: { onlyAuthenticated: true }
        }, {
            path: 'emprestimo-coletivo/:id',
            component: __WEBPACK_IMPORTED_MODULE_23__views_AdditionalInformationPeerToPeer__["a" /* default */],
            meta: { onlyAuthenticated: true }
        }, {
            path: 'emprestimo-de-impacto2/:id',
            component: __WEBPACK_IMPORTED_MODULE_23__views_AdditionalInformationPeerToPeer__["a" /* default */],
            meta: { onlyAuthenticated: true }
        }, {
            path: 'emprestimo-de-impacto/:id',
            component: __WEBPACK_IMPORTED_MODULE_23__views_AdditionalInformationPeerToPeer__["a" /* default */],
            meta: { onlyAuthenticated: true }
        }, {
            path: 'emprestimo-social/:id',
            component: __WEBPACK_IMPORTED_MODULE_37__views_AdditionalInformationSocial__["a" /* default */],
            meta: { onlyAuthenticated: true }
        }, {
            path: 'imovel-em-garantia/:id',
            component: __WEBPACK_IMPORTED_MODULE_25__views_AdditionalInformationConstrucao__["a" /* default */]
        }, {
            path: 'veiculo-em-garantia/:id',
            component: __WEBPACK_IMPORTED_MODULE_25__views_AdditionalInformationConstrucao__["a" /* default */]
        }]
    }, {
        path: '/informacoes-adicionais', // INFORMAÇÕES ADCIONAIS PARA INVESTIDORES
        component: __WEBPACK_IMPORTED_MODULE_21__views_layouts_AdditionalInformationLayout__["a" /* default */],
        meta: { onlyAuthenticated: true },
        children: [{
            path: 'selecionar-area',
            component: __WEBPACK_IMPORTED_MODULE_36__views_SelectArea__["a" /* default */],
            meta: { onlyAuthenticated: true }
        }, {
            path: 'investidor',
            component: __WEBPACK_IMPORTED_MODULE_26__views_AdditionalInformationInvestor__["a" /* default */],
            meta: { onlyAuthenticated: true }
        }, {
            path: 'suitabilityVerify',
            component: __WEBPACK_IMPORTED_MODULE_28__views_InformationSuitabilityVerify__["a" /* default */],
            meta: { onlyAuthenticated: true }
        }, {
            path: 'suitability',
            component: __WEBPACK_IMPORTED_MODULE_27__views_InformationSuitability__["a" /* default */],
            meta: { onlyAuthenticated: true }
        }]
    }, {
        path: '/darf/:id/:idINV',
        component: __WEBPACK_IMPORTED_MODULE_7__views_layouts_BlankLayout__["a" /* default */],
        children: [{
            name: "DARF",
            path: '',
            component: __WEBPACK_IMPORTED_MODULE_81__views_Darf__["a" /* default */]
        }]
    }, {
        path: '/informe-rendimento',
        component: __WEBPACK_IMPORTED_MODULE_90__views_ReportYield__["a" /* default */],
        meta: { onlyAuthenticated: true }
    }, {
        path: '/investimentos',
        component: __WEBPACK_IMPORTED_MODULE_3__views_layouts_InvestorLayout__["a" /* default */],
        meta: { onlyAuthenticated: true },
        children: [{
            path: 'meus-investimentos',
            name: 'Investimentos',
            component: __WEBPACK_IMPORTED_MODULE_38__views_HomeInvestor__["a" /* default */],
            meta: { onlyAuthenticated: true }
        }, {
            path: 'investimento-de-impacto',
            component: __WEBPACK_IMPORTED_MODULE_29__views_layouts_OpportunitiesLayout__["a" /* default */],
            children: [{
                name: 'InvestimentodeImpacto',
                path: '',
                component: __WEBPACK_IMPORTED_MODULE_43__views_ListImpact__["a" /* default */]
            }, {
                path: 'perfil-impacto/:id',
                name: 'Impacto',
                component: __WEBPACK_IMPORTED_MODULE_44__views_ImpactProfile__["a" /* default */]
            }, {
                path: 'perfil-social-new/:id',
                name: 'Social',
                component: __WEBPACK_IMPORTED_MODULE_45__views_EmprestimoSocialNew__["a" /* default */]
            }]
        },
        // {
        //     name: 'Convidar amigo',
        //     path: 'convidar-amigo',
        //     component: InviteFriend,
        //     meta: { onlyAuthenticated: true }
        // },
        {
            path: 'portfolios',
            name: 'Portfólios',
            component: __WEBPACK_IMPORTED_MODULE_87__views_EmConstrucao__["a" /* default */]
        }, {
            path: 'historico',
            component: __WEBPACK_IMPORTED_MODULE_29__views_layouts_OpportunitiesLayout__["a" /* default */],
            children: [{
                name: 'Histórico',
                path: '',
                component: __WEBPACK_IMPORTED_MODULE_41__views_ListHistoric__["a" /* default */]
            }, {
                name: 'HistoricoInvestimento',
                path: 'historico-de-investimento/:id',
                component: __WEBPACK_IMPORTED_MODULE_42__views_HistoricProfile__["a" /* default */]
            }]
        },
        // Descomentar central de cobranca
        {
            path: 'central-de-cobranca',
            component: __WEBPACK_IMPORTED_MODULE_29__views_layouts_OpportunitiesLayout__["a" /* default */],
            children: [{
                name: 'Central de Cobrança',
                path: '',
                component: __WEBPACK_IMPORTED_MODULE_82__views_CentralCobranca__["a" /* default */]
            }, {
                name: 'VisualizarStatusCobranca',
                path: 'status-cobranca',
                component: __WEBPACK_IMPORTED_MODULE_83__views_CentralCobrancaView__["a" /* default */]
            }]
        }, {
            path: 'perguntas-respostas',
            name: 'PerguntaseRespostasInv',
            component: __WEBPACK_IMPORTED_MODULE_87__views_EmConstrucao__["a" /* default */]
        }, {
            path: 'oportunidades',
            component: __WEBPACK_IMPORTED_MODULE_29__views_layouts_OpportunitiesLayout__["a" /* default */],
            children: [{
                name: 'Oportunidades',
                path: '',
                component: __WEBPACK_IMPORTED_MODULE_39__views_ListOpportunities__["a" /* default */]
            }, {
                path: 'confirmacao/:id',
                name: 'Checkout',
                component: __WEBPACK_IMPORTED_MODULE_46__views_Checkout__["a" /* default */],
                meta: { onlyAuthenticated: true }
            }, {
                path: 'perfil-empresa/:id',
                name: 'Empresa novo',
                component: __WEBPACK_IMPORTED_MODULE_47__views_CompanyProfile__["a" /* default */],
                meta: { onlyAuthenticated: true }
            }, {
                path: 'perfil-empresa-old/:id',
                name: 'Empresa',
                component: __WEBPACK_IMPORTED_MODULE_48__views_CompanyProfileOld__["a" /* default */],
                meta: { onlyAuthenticated: true }
            }, {
                path: ':id/perfil-ccb',
                name: 'CCB',
                component: __WEBPACK_IMPORTED_MODULE_49__views_CCBProfile__["a" /* default */]
            }]
        }, {
            path: 'antecipacao',
            component: __WEBPACK_IMPORTED_MODULE_29__views_layouts_OpportunitiesLayout__["a" /* default */],
            children: [{
                name: 'Antecipacao',
                path: '',
                component: __WEBPACK_IMPORTED_MODULE_40__views_ListAntecipationReceivables__["a" /* default */]
            }, {
                path: 'confirmacao/:id',
                name: 'Checkout',
                component: __WEBPACK_IMPORTED_MODULE_46__views_Checkout__["a" /* default */],
                meta: { onlyAuthenticated: true }
            }, {
                path: 'perfil-empresa/:id',
                name: 'Empresa novo',
                component: __WEBPACK_IMPORTED_MODULE_47__views_CompanyProfile__["a" /* default */],
                meta: { onlyAuthenticated: true }
            }, {
                path: 'perfil-empresa-old/:id',
                name: 'Empresa',
                component: __WEBPACK_IMPORTED_MODULE_48__views_CompanyProfileOld__["a" /* default */],
                meta: { onlyAuthenticated: true }
            }, {
                path: ':id/perfil-ccb',
                name: 'CCB',
                component: __WEBPACK_IMPORTED_MODULE_49__views_CCBProfile__["a" /* default */]
            }]
        }, {
            path: 'estatisticas',
            component: __WEBPACK_IMPORTED_MODULE_29__views_layouts_OpportunitiesLayout__["a" /* default */],
            children: [{
                name: 'Estatisticas',
                path: '',
                component: __WEBPACK_IMPORTED_MODULE_76__views_Statistics__["a" /* default */],
                children: [{
                    path: '',
                    component: __WEBPACK_IMPORTED_MODULE_77__views_StatisticsHome__["a" /* default */]
                }]
            }, {
                path: 'estatisticas-da-plataforma',
                component: __WEBPACK_IMPORTED_MODULE_76__views_Statistics__["a" /* default */],
                children: [{
                    path: '',
                    component: __WEBPACK_IMPORTED_MODULE_78__views_StatisticsPlatform__["a" /* default */],

                    children: [{
                        path: 'investidores',
                        component: __WEBPACK_IMPORTED_MODULE_79__views_StatisticsInvestor__["a" /* default */]
                    }, {
                        path: 'emprestimos',
                        component: __WEBPACK_IMPORTED_MODULE_80__views_StatisticsLoan__["a" /* default */]
                    }]
                }]
            }]
        }, {
            path: 'carteira-investimento',
            component: __WEBPACK_IMPORTED_MODULE_29__views_layouts_OpportunitiesLayout__["a" /* default */],
            children: [{
                name: 'CarteiraInvestimento',
                path: '',
                component: __WEBPACK_IMPORTED_MODULE_70__views_Wallet_Wallet_vue__["a" /* default */]
            }, {
                path: 'historico',
                name: 'WalletHistorico',
                component: __WEBPACK_IMPORTED_MODULE_71__views_Wallet_WalletHistorico_vue__["a" /* default */]
            }, {
                path: 'transferir-fundos',
                name: 'Transferencia',
                component: __WEBPACK_IMPORTED_MODULE_72__views_WalletFundsTransfer__["a" /* default */]
            }, {
                path: 'comprovante/:id',
                name: 'Comprovante',
                component: __WEBPACK_IMPORTED_MODULE_73__views_WalletReceipt__["a" /* default */]
            }, {
                path: 'comprovante/pagamento/:id',
                name: 'ComprovantePagamento',
                component: __WEBPACK_IMPORTED_MODULE_74__views_WalletPagamento__["a" /* default */]
            }, {
                path: 'adicionar-fundos',
                name: 'AdicionarFundos',
                component: __WEBPACK_IMPORTED_MODULE_75__views_WalletAddCash__["a" /* default */]
            }]
        }, {
            path: 'finalizar-investimento',
            nome: 'Finalizar investimentos',
            component: __WEBPACK_IMPORTED_MODULE_55__views_FinishInvestment__["a" /* default */]
        }, {
            path: 'perfil',
            name: 'Perfil',
            component: __WEBPACK_IMPORTED_MODULE_62__views_Profile__["a" /* default */],
            children: [{
                path: 'dados-pessoais',
                name: 'Dados Pessoais',
                component: __WEBPACK_IMPORTED_MODULE_63__views_ProfileConf__["a" /* default */]
            }, {
                path: 'editar-perfil',
                name: 'Editar',
                component: __WEBPACK_IMPORTED_MODULE_67__views_ProfileEdit__["a" /* default */]
            }, {
                path: 'configuracoes',
                name: 'Configuracoes',
                component: __WEBPACK_IMPORTED_MODULE_64__views_ProfileNotific__["a" /* default */]
            }, {
                path: 'documentos',
                name: 'Documentos',
                component: __WEBPACK_IMPORTED_MODULE_65__views_ProfileDocs__["a" /* default */]
            }, {
                path: 'historico',
                name: 'Profile Histórico',
                component: __WEBPACK_IMPORTED_MODULE_66__views_ProfileHist__["a" /* default */]
            }]
        }, {
            path: 'minhas-ccbs',
            component: __WEBPACK_IMPORTED_MODULE_29__views_layouts_OpportunitiesLayout__["a" /* default */],
            meta: { onlyAuthenticated: true },
            children: [{
                path: '',
                name: 'MinhasCCBS',
                meta: { onlyAuthenticated: true },
                component: __WEBPACK_IMPORTED_MODULE_52__views_CCBList__["a" /* default */]
            }, {
                path: 'formalizar/:id',
                meta: { onlyAuthenticated: true },
                name: 'FormalizarCCB',
                component: __WEBPACK_IMPORTED_MODULE_50__views_CCBInvestor__["a" /* default */]

            }]
        }, {
            path: 'documentos',
            name: 'docsINV',
            meta: { onlyAuthenticated: true },
            component: __WEBPACK_IMPORTED_MODULE_68__views_Documentos__["a" /* default */]
        }, {
            path: 'atendimento',
            name: 'Atendimento',
            component: __WEBPACK_IMPORTED_MODULE_87__views_EmConstrucao__["a" /* default */]
        }, {
            path: 'notificacoes',
            name: 'Notificações Investidor',
            component: __WEBPACK_IMPORTED_MODULE_69__views_Notifications__["a" /* default */]
        }]
    }, {
        path: '/emprestimos',
        component: __WEBPACK_IMPORTED_MODULE_4__views_layouts_LoansLayout__["a" /* default */],
        children: [{
            path: '',
            component: __WEBPACK_IMPORTED_MODULE_56__views_layouts_MyLoansLayout__["a" /* default */],
            children: [{
                name: 'Meus Emprestimos',
                path: 'meus-emprestimos',
                component: __WEBPACK_IMPORTED_MODULE_57__views_MyLoans__["a" /* default */],
                meta: { onlyAuthenticated: true }
            }, {
                path: 'pre-aprovado-detalhes',
                component: __WEBPACK_IMPORTED_MODULE_59__views_PreapprovedDetails__["a" /* default */]
            }, {

                name: 'Pré Aprovado',
                path: "pre-aprovado",
                component: __WEBPACK_IMPORTED_MODULE_58__views_Preapproved__["a" /* default */]

            }, {
                path: 'detalhes-do-emprestimo',
                name: 'Detalhes do empréstimo',
                meta: { onlyAuthenticated: true },
                component: __WEBPACK_IMPORTED_MODULE_60__views_DetailsLoans__["a" /* default */]
            }, {
                path: 'formalizar-ccb/:id',
                meta: { onlyAuthenticated: true },
                component: __WEBPACK_IMPORTED_MODULE_53__views_CCBLoan__["a" /* default */]
            }, {
                path: 'boletos',
                name: 'Todos os Boletos',
                component: __WEBPACK_IMPORTED_MODULE_61__views_AllTickets__["a" /* default */]
            }, {
                path: 'solicitar-emprestimo',
                name: 'Solicitar Empréstimo',
                component: __WEBPACK_IMPORTED_MODULE_87__views_EmConstrucao__["a" /* default */]
            }, {
                path: 'historico',
                name: 'Histórico Empréstimo',
                component: __WEBPACK_IMPORTED_MODULE_87__views_EmConstrucao__["a" /* default */]
            }, {
                path: 'perfil',
                name: 'PerfilEMP',
                component: __WEBPACK_IMPORTED_MODULE_62__views_Profile__["a" /* default */],
                children: [{
                    path: 'dados-pessoais',
                    name: 'Dados Pesssoais EMP',
                    component: __WEBPACK_IMPORTED_MODULE_63__views_ProfileConf__["a" /* default */]
                }, {
                    path: 'configuracoes',
                    name: 'Configuracoes EMP',
                    component: __WEBPACK_IMPORTED_MODULE_87__views_EmConstrucao__["a" /* default */]
                }, {
                    path: 'documentos',
                    name: 'Documentos EMP',
                    component: __WEBPACK_IMPORTED_MODULE_65__views_ProfileDocs__["a" /* default */]
                }, {
                    path: 'historico',
                    name: 'Profile Histórico EMP',
                    component: __WEBPACK_IMPORTED_MODULE_66__views_ProfileHist__["a" /* default */]
                }]
            }, {
                path: 'documentos',
                name: 'docs',
                meta: { onlyAuthenticated: true },
                component: __WEBPACK_IMPORTED_MODULE_68__views_Documentos__["a" /* default */]
            }, {
                path: 'notificacoes',
                name: 'Notificações Emprestimo',
                component: __WEBPACK_IMPORTED_MODULE_69__views_Notifications__["a" /* default */]
            }]
        }]
    }, {
        path: '/solicitacao-em-analise',
        component: __WEBPACK_IMPORTED_MODULE_6__views_layouts_LoanAlerts__["a" /* default */],
        children: [{
            path: '',
            component: __WEBPACK_IMPORTED_MODULE_30__views_SolicitacaoAnalise__["a" /* default */],
            meta: { onlyAuthenticated: true }
        }]
    }, {
        path: '/solicitacao-negada',
        component: __WEBPACK_IMPORTED_MODULE_6__views_layouts_LoanAlerts__["a" /* default */],
        children: [{
            path: '',
            component: __WEBPACK_IMPORTED_MODULE_31__views_SolicitacaoNegada__["a" /* default */]

        }]
    }, {
        path: '/tipo-de-emprestimo',
        component: __WEBPACK_IMPORTED_MODULE_22__views_layouts_AdditionalLoansLayout__["a" /* default */],
        name: 'tipo-de-emprestimo',
        meta: { onlyAuthenticated: true },
        children: [{
            path: '',
            component: __WEBPACK_IMPORTED_MODULE_32__views_SelectLoanType__["a" /* default */]
        }, {
            path: 'simulacao',
            name: 'simulacao',
            component: __WEBPACK_IMPORTED_MODULE_33__views_Simulation__["a" /* default */]
        }, {
            path: 'simulacao-emprestimo',
            name: 'simulacao-emprestimo',
            component: __WEBPACK_IMPORTED_MODULE_34__views_LoanSimulation__["a" /* default */]
        }, {
            path: 'solicitar-emprestimo',
            name: 'solicitar-emprestimo',
            component: __WEBPACK_IMPORTED_MODULE_35__views_LoanSolicitationBeta__["a" /* default */]

        }]
    }, {
        path: '/parceiros',
        component: __WEBPACK_IMPORTED_MODULE_5__views_layouts_PartnersLayout__["a" /* default */],
        children: [{
            path: 'cadastro-investidor',
            component: __WEBPACK_IMPORTED_MODULE_26__views_AdditionalInformationInvestor__["a" /* default */]
        }]
    }, {
        path: '/preview/:id',
        component: __WEBPACK_IMPORTED_MODULE_47__views_CompanyProfile__["a" /* default */],
        meta: { onlyAuthenticated: true }
    }, {
        path: '/',
        component: __WEBPACK_IMPORTED_MODULE_2__views_layouts_ApplicationLayout__["a" /* default */],
        children: [{
            path: '',
            component: __WEBPACK_IMPORTED_MODULE_38__views_HomeInvestor__["a" /* default */],
            meta: { onlyAuthenticated: true }
        }]
    }, {
        path: '*',
        component: __WEBPACK_IMPORTED_MODULE_9__views_NotFound__["a" /* default */]
    }]
});

router.beforeEach(function (to, from, next) {
    if (to.query.auth_token) {
        router.app.$store.dispatch('loginWithToken', { token: to.query.auth_token });
        return next({ path: to.path });
    }
    if (to.matched.some(function (record) {
        return record.meta.onlyAuthenticated;
    }) && !router.app.$store.state.isLoggedIn) {
        return next({
            path: '/login',
            query: { redirected_from: to.fullPath }
        });
    } else if (to.matched.some(function (record) {
        return record.meta.onlyNotAuthenticated;
    }) && router.app.$store.state.isLoggedIn) {
        return next({ path: '/' });
    }

    next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YdGp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            filtro: {
                dataIni: '',
                dataFim: ''
            }
        };
    },

    methods: {
        formatarData: function formatarData(data) {

            if (!data.includes('/')) return '';

            data = new Date(data).toLocaleString('pt-BR', { timeZone: 'UTC' }).split(" ")[0];

            return data.replace(/[/]/g, '-');
        },
        enviarFiltro: function enviarFiltro() {

            this.filtro.dataIni = this.formatarData(this.filtro.dataIni);

            this.filtro.dataFim = this.formatarData(this.filtro.dataFim);

            this.$emit('filtrar', this.filtro);
        }
    }
});

/***/ }),

/***/ "Yefk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yw5R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    solicitacao: { required: true, type: Object }
  },
  created: function created() {
    var solicitacao = this.solicitacao;
    this.$emit('on-submit', solicitacao);
  }
});

/***/ }),

/***/ "Z20F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OccupationKindStep_vue__ = __webpack_require__("dTcB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_555e6263_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OccupationKindStep_vue__ = __webpack_require__("415U");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OccupationKindStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_555e6263_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OccupationKindStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z477":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z4cu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__ = __webpack_require__("65ha");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var endereco = this.solicitacao.Empresa.Endereco;
    return {
      razaoSocial: this.solicitacao.Empresa.RazaoSocial,
      cep: endereco ? endereco.Cep : null,
      logradouro: endereco ? endereco.Logradouro : null,
      numero: endereco ? endereco.Numero : null,
      complemento: endereco ? endereco.Complemento : null,
      bairro: endereco ? endereco.Bairro : null,
      uf: endereco ? endereco.Uf : null,
      cidade: endereco ? endereco.Cidade : null,
      estaBuscandoEndereco: false,
      estaBuscandoEstados: false,
      estados: [],
      cidades: []
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  computed: {
    estaCidadeDesabilitado: function estaCidadeDesabilitado() {
      return this.estaBuscandoEndereco || this.cidades.length == 0;
    },
    estaEstadoDesabilitado: function estaEstadoDesabilitado() {
      return this.estaBuscandoEndereco || this.estaBuscandoEstados;
    },
    placeholderCidade: function placeholderCidade() {
      if ((this.estaBuscandoEndereco || this.cidades.length == 0) && this.uf != null) {
        return 'Carregando';
      } else {
        return 'Cidade';
      }
    },
    placeholderEstado: function placeholderEstado() {
      if (this.estaBuscandoEndereco || this.estaBuscandoEstados) {
        return 'Carregando';
      } else {
        return 'Estado';
      }
    }
  },
  methods: {
    aoMudarCep: function aoMudarCep(e) {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskZipcode(e.target.value).length < 8) return;
      this.estaBuscandoEndereco = true;
      __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarCeps(e.target.value).then(function (endereco) {
        _this.bairro = endereco.bairro;
        _this.cidade = endereco.localidade;
        _this.logradouro = endereco.logradouro;

        _this.estaBuscandoEndereco = false;

        if (_this.uf == '' && typeof endereco.uf != 'undefined') {
          _this.uf = [{ uf: endereco.uf }];
          _this.estaBuscandoEstado = false;
          setTimeout(function () {
            _this.uf = endereco.uf;
          }, 100);
        }
      }).catch(function () {
        _this.estaBuscandoEndereco = false;
      });
    },
    onUfChange: function onUfChange() {
      var _this2 = this;

      this.cidades = [];
      if (!this.uf) {
        this.cidade = '';
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarCidades(this.uf).then(function (cidades) {
        _this2.cidades = cidades;
        if (_this2.cidade) {
          _this2.setCity();
        }
      });
    },
    setCity: function setCity() {
      var _this3 = this;

      var city = this.cidades.find(function (city) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__["a" /* default */].removeAccents(city.nome.toUpperCase()) == __WEBPACK_IMPORTED_MODULE_2__utils_string_helper__["a" /* default */].removeAccents(_this3.cidade.toUpperCase());
      });
      if (!city) {
        this.cidade = '';
      } else {
        // When the city state is seted before cities is populated the component doesn't show
        // the selected city.
        this.cidade = '';
        setTimeout(function () {
          return _this3.cidade = city.nome;
        }, 100);
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var newData = {
        Empresa: {
          Endereco: {
            Cep: __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskZipcode(this.cep),
            Logradouro: this.logradouro,
            Numero: this.numero,
            Complemento: this.complemento,
            Bairro: this.bairro,
            Uf: this.uf,
            Cidade: this.cidade
          }
        }
      };
      this.$emit('on-submit', newData);
    }
  },
  created: function created() {
    var _this4 = this;

    this.estaBuscandoEndereco = true;
    __WEBPACK_IMPORTED_MODULE_1__utils_hub_consulta_client__["a" /* default */].pegarEstados().then(function (estados) {
      _this4.estados = estados;
      _this4.estaBuscandoEndereco = false;
      // When the city state is seted before cities is populated the component doesn't show
      // the selected city.
      var uf = _this4.uf;
      var cidade = _this4.cidade;
      _this4.uf = '';
      setTimeout(function () {
        _this4.uf = uf;
        _this4.cidade = cidade;
      }, 100);
    });
  },
  mounted: function mounted() {
    this.$refs.stateSelect.$el.children[0].children[2].required = true;
    this.$refs.citySelect.$el.children[0].children[2].required = true;
  }
});

/***/ }),

/***/ "Z5hq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z8Vr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            lpUrl: "https://iouu.com.br",
            finishedLoading: false,
            solicitacao: null
        };
    },

    props: ['id'],
    computed: {
        getId: function getId() {
            return this.id;
        },

        formattedCnpj: function formattedCnpj() {
            return __WEBPACK_IMPORTED_MODULE_2__utils_masker__["a" /* default */].maskCnpj(this.solicitacao.Documento);
        },
        razaoSocial: function razaoSocial() {
            return this.solicitacao.Empresa.RazaoSocial;
        },
        nomeFantasia: function nomeFantasia() {
            return this.solicitacao.Empresa.NomeFantasia;
        },
        nomeResponsavel: function nomeResponsavel() {
            return this.solicitacao.Nome;
        },
        telefone: function telefone() {
            return this.solicitacao.TelefoneComercial;
        },
        breveDescricao: function breveDescricao() {
            return this.solicitacao.Empresa.InformacaoInstitucional;
        },
        sobreEmpresa: function sobreEmpresa() {
            return this.solicitacao.AnaliseEmpresa;
        },
        scoreClass: function scoreClass() {
            if (!this.solicitacao.Score) return "";
            return "rating-" + this.solicitacao.Score.replace(/\d/, '').toLowerCase();
        },
        score: function score() {
            return this.solicitacao.Score;
        },
        valor: function valor() {
            if (!this.solicitacao) return null;
            return this.formatCurrency(this.solicitacao.Valor);
        },
        prazo: function prazo() {
            return this.solicitacao.Prazo;
        },
        parcela: function parcela() {
            return this.formatCurrency(this.solicitacao.ValorParcela);
        },
        valorTotal: function valorTotal() {
            if (this.solicitacao.ValorParcela == 0) {
                return this.formatCurrency(this.solicitacao.Valor);
            } else {
                return this.formatCurrency(this.solicitacao.ValorParcela * this.solicitacao.Prazo);
            }
        },
        taxaJuros: function taxaJuros() {
            return this.formatCurrency(this.solicitacao.TaxaJuros);
        },
        taxaTotal: function taxaTotal() {
            return this.formatCurrency(this.solicitacao.RetornoBrutoAnual);
        },
        dataInicio: function dataInicio() {
            return this.formatData(this.solicitacao.InicioCaptacao);
        },
        dataFim: function dataFim() {
            return this.formatData(this.solicitacao.FimCaptacao);
        },
        dataFuncadao: function dataFuncadao() {
            return this.formatData(this.solicitacao.Empresa.DataFundacao);
        },
        numeroEmpregados: function numeroEmpregados() {
            return this.solicitacao.Empresa.QuantidadeEmpregados;
        },
        grupoEconomico: function grupoEconomico() {
            return this.hasGroup(this.solicitacao.Empresa.TemGrupoEconomico);
        },
        Endereco: function Endereco() {
            return this.formatAdress(this.solicitacao.Empresa.Endereco);
        },
        site: function site() {
            return this.solicitacao.Empresa.Site;
        },
        facebook: function facebook() {
            return this.solicitacao.Empresa.Facebook;
        },
        twitter: function twitter() {
            return this.solicitacao.Empresa.Twitter;
        },
        instagram: function instagram() {
            return this.solicitacao.Empresa.Instagram;
        },
        linkdin: function linkdin() {
            return this.solicitacao.Empresa.Linkedin;
        },
        vimeo: function vimeo() {
            return this.solicitacao.Empresa.Vimeo;
        },
        email: function email() {
            return this.solicitacao.Email;
        },
        valorCaptado: function valorCaptado() {
            return this.formatCurrency(this.solicitacao.ValorCaptado);
        },
        investidores: function investidores() {
            return this.solicitacao.QuantidadeReservasInvestimento;
        },
        percentValorCaptado: function percentValorCaptado() {
            if (this.solicitacao.ValorCaptado === 0 || this.solicitacao.ValorCaptado === undefined) {
                return this.formatCurrency(0);
            } else {
                return this.formatCurrency(this.solicitacao.ValorCaptado * 100 / this.solicitacao.Valor);
            }
        }
    },
    methods: {
        money: function money(n) {
            var c = 2,
                d = ",",
                t = ".",
                s = n < 0 ? "-" : "",
                i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        },
        ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
            var s = String(id);
            while (s.length < (qtd || 2)) {
                s = "0" + s;
            }
            return s;
        },
        formatCurrency: function formatCurrency(value) {
            if (value !== undefined) {
                return value.toLocaleString('pt-BR', {
                    minimumFractionDigits: "2",
                    maximumFractionDigits: 2
                });
            }
        },
        formatData: function formatData(data) {
            var date = new Date(data);
            return date.toLocaleDateString('pt-BR');
        },
        hasGroup: function hasGroup(item) {
            var msg = void 0;

            if (item) {
                msg = "Pertence a um grupo econômico";
            } else {
                msg = "Não pertence a nenhum grupo econômico";
            }

            return msg;
        },
        formatAdress: function formatAdress(obj) {

            var logra = obj.Logradouro;
            var num = obj.Numero;
            var comp = obj.Complemento;
            var bairro = obj.Bairro;
            var cep = obj.Cep;
            var city = obj.Cidade;
            var uf = obj.Uf;

            var adress = logra + ", " + num + " - " + comp + ", " + bairro + " - " + cep + ", " + city + "/" + uf;

            return adress;
        }
    },
    created: function created() {
        var _this = this;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["c" /* START_LOADING */]);

        __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getLoanRequest(this.getId).then(function (response) {
            _this.solicitacao = response;

            _this.finishedLoading = true;
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["d" /* STOP_LOADING */]);
        }).catch(function () {
            _this.finishedLoading = true;
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    }
});

/***/ }),

/***/ "ZA0D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    submitWithBankDebt: function submitWithBankDebt() {
      this.$emit('on-submit', { Empresa: { TemDividaBancaria: true } });
    },
    submitWithoutBankDebt: function submitWithoutBankDebt() {
      this.$emit('on-submit', { Empresa: { TemDividaBancaria: false } });
    }
  }
});

/***/ }),

/***/ "ZKAF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deposito_vue__ = __webpack_require__("hX1c");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004524ef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Deposito_vue__ = __webpack_require__("FbpO");
function injectStyle (ssrContext) {
  __webpack_require__("mOtU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-004524ef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deposito_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004524ef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Deposito_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZLtj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_025b6a08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishedStep_vue__ = __webpack_require__("JzvJ");
function injectStyle (ssrContext) {
  __webpack_require__("vA1A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-025b6a08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_025b6a08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishedStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZMX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var valorDividaBancaria = this.solicitacao.Empresa.ValorDividaBancaria;
    return {
      valorDividaBancaria: valorDividaBancaria ? valorDividaBancaria.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }) : null
    };
  },

  computed: {
    dividaValida: function dividaValida() {
      return parseFloat(this.valorDividaBancaria) <= 0;
    }
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = {
        Empresa: {
          ValorDividaBancaria: __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].formatReal(this.valorDividaBancaria)
        }
      };
      this.$emit('on-submit', newData);
    }
  }
});

/***/ }),

/***/ "ZQ+y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c(_vm.currentStepComponent,{tag:"component",staticClass:"form-container",on:{"loading-toggle":_vm.handleLoadingToggle}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZQ8o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "ZWEX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZdCC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      acceptedFormats: 'application/pdf, image/jpeg, image/png',
      files: this.investor.ArquivosIdentidade || [null]
    };
  },

  computed: {
    receivedFiles: function receivedFiles() {
      return this.files.filter(function (file) {
        return file != null && file != undefined;
      });
    }
  },
  props: {
    investor: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.files = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.files.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.files, index, null);
    },
    validate: function validate() {
      if (this.receivedFiles.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do documento de identidade é obrigatório'] };
      }
    },
    submit: function submit() {
      var validation = this.validate();

      if (validation.isValid) {
        var newData = {
          ArquivosIdentidade: this.receivedFiles
        };
        this.$emit('submit', newData);
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "ZeN0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__ = __webpack_require__("Du/2");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            CCB_URL: "https://bmpdigital.moneyp.com.br/",
            MeusInvestimentosAll: [],
            terminou: false
        };
    },

    computed: {
        pcScreen: function pcScreen() {
            return window.innerWidth > 1050;
        }
    },
    methods: {
        Status: function Status(status) {
            return status ? "deactivate" : "active";
        },
        VerificaAssintatura: function VerificaAssintatura(sol) {

            return sol.AssinouCCB == true ? "secondary" : "primary";
        },
        LinkCCB: function LinkCCB(sol) {

            return sol.AssinouCCB == true ? "https://bmpdigital.moneyp.com.br/" + "/imprimirccb.aspx?code=" + sol.CodigoBMP + "&copias=1" : "/investimentos/minhas-ccbs/formalizar/" + sol._id;
        },
        formatCurrency: function formatCurrency(value) {
            if (value != null) return value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });

            return 0;
        },
        formattedCnpj: function formattedCnpj(documento) {
            return __WEBPACK_IMPORTED_MODULE_2__utils_masker__["a" /* default */].maskCnpj(documento);
        },
        ObterNome: function ObterNome(solicitacao) {

            if (solicitacao.Empresa != null && solicitacao.Empresa.NomeFantasia != "") return solicitacao.Empresa.NomeFantasia;

            if (solicitacao.Impacto != null && solicitacao.Impacto.NomeFantasia != "") return solicitacao.Impact.NomeFantasia;

            if (solicitacao.Social != null && solicitacao.Social.RazaoSocial != "") return solicitacao.Social.RazaoSocial;

            if (solicitacao.Social != null && solicitacao.Social.NomeCompleto != "") return solicitacao.Social.NomeCompleto;
        },
        ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
            var s = String(id);

            while (s.length < (qtd || 2)) {
                s = "0" + s;
            }

            return s;
        },


        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/minhas-ccbs/',
                title: 'MinhasCCBS'
            });
        }
    },

    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (window.location.href.indexOf("dashboard-app") != -1) _this.moneyp = "digital";

                            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);
                            __WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].getInfosMyCCBs().then(function (infos) {
                                _this.MeusInvestimentosAll = infos.data.filter(function (item) {
                                    return item.SolicitacaoId.StatusAnalise == "ENCERRADO" && item.SolicitacaoId.CCBsAssinaturas == true;
                                });
                                _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            }).catch(function (error) {
                                console.log('error', error);
                                _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            });

                            //tagueamento GA
                            _context.next = 5;
                            return _this.taggingGA();

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ "ZqXk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      shouldShowTip: false,
      informacaoInstitucional: this.currentUser.Social.InformacaoInstitucional
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      this.currentUser.Social.InformacaoInstitucional = this.informacaoInstitucional;

      this.$emit('on-submit', { Social: this.currentUser.Social });
    }
  }
});

/***/ }),

/***/ "Zs6t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioDeclaracaoEndividamentoPasso_vue__ = __webpack_require__("ln6W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b9b4b62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioDeclaracaoEndividamentoPasso_vue__ = __webpack_require__("qYbp");
function injectStyle (ssrContext) {
  __webpack_require__("NaGo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b9b4b62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioDeclaracaoEndividamentoPasso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b9b4b62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioDeclaracaoEndividamentoPasso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZxHV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZypF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Por favor, selecione que tipo de empresa é a(o) "),_c('strong',[_vm._v(_vm._s(_vm.razaoSocial))]),_vm._v(":")])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('ul',{staticClass:"list-group"},[_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.tipoEmpresa),expression:"tipoEmpresa",modifiers:{"number":true}}],staticClass:"form-check-input",attrs:{"type":"radio","name":"TipoEmpresa","id":"mei","value":"1","required":""},domProps:{"checked":_vm._q(_vm.tipoEmpresa,_vm._n("1"))},on:{"change":function($event){_vm.tipoEmpresa=_vm._n("1")}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"mei"}},[_vm._v("MEI")])])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.tipoEmpresa),expression:"tipoEmpresa",modifiers:{"number":true}}],staticClass:"form-check-input",attrs:{"type":"radio","name":"TipoEmpresa","id":"me","value":"2","required":""},domProps:{"checked":_vm._q(_vm.tipoEmpresa,_vm._n("2"))},on:{"change":function($event){_vm.tipoEmpresa=_vm._n("2")}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"me"}},[_vm._v("ME")])])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.tipoEmpresa),expression:"tipoEmpresa",modifiers:{"number":true}}],staticClass:"form-check-input",attrs:{"type":"radio","name":"TipoEmpresa","id":"epp","value":"3","required":""},domProps:{"checked":_vm._q(_vm.tipoEmpresa,_vm._n("3"))},on:{"change":function($event){_vm.tipoEmpresa=_vm._n("3")}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"epp"}},[_vm._v("EPP")])])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.tipoEmpresa),expression:"tipoEmpresa",modifiers:{"number":true}}],staticClass:"form-check-input",attrs:{"type":"radio","name":"TipoEmpresa","id":"eireli","value":"4","required":""},domProps:{"checked":_vm._q(_vm.tipoEmpresa,_vm._n("4"))},on:{"change":function($event){_vm.tipoEmpresa=_vm._n("4")}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"eireli"}},[_vm._v("EIRELI")])])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.tipoEmpresa),expression:"tipoEmpresa",modifiers:{"number":true}}],staticClass:"form-check-input",attrs:{"type":"radio","name":"TipoEmpresa","id":"ltda","value":"5","required":""},domProps:{"checked":_vm._q(_vm.tipoEmpresa,_vm._n("5"))},on:{"change":function($event){_vm.tipoEmpresa=_vm._n("5")}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"ltda"}},[_vm._v("LTDA")])])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.tipoEmpresa),expression:"tipoEmpresa",modifiers:{"number":true}}],staticClass:"form-check-input",attrs:{"type":"radio","name":"TipoEmpresa","id":"sa","value":"6","required":""},domProps:{"checked":_vm._q(_vm.tipoEmpresa,_vm._n("6"))},on:{"change":function($event){_vm.tipoEmpresa=_vm._n("6")}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"sa"}},[_vm._v("S/A")])])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.tipoEmpresa),expression:"tipoEmpresa",modifiers:{"number":true}}],staticClass:"form-check-input",attrs:{"type":"radio","name":"TipoEmpresa","id":"outro","value":"7","required":""},domProps:{"checked":_vm._q(_vm.tipoEmpresa,_vm._n("7"))},on:{"change":function($event){_vm.tipoEmpresa=_vm._n("7")}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"outro"}},[_vm._v("Outro")])])])])]),_vm._v(" "),(_vm.ehOutro)?_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"dataFundacao"}},[_vm._v("Infome o tipo de empersa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoEmpresaOutro),expression:"tipoEmpresaOutro"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":""},domProps:{"value":(_vm.tipoEmpresaOutro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tipoEmpresaOutro=$event.target.value}}})]):_vm._e(),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a0pE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a1CX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__ = __webpack_require__("84kS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7da93c4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__ = __webpack_require__("CBCL");
function injectStyle (ssrContext) {
  __webpack_require__("PrXe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7da93c4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7da93c4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a51p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Extorno_vue__ = __webpack_require__("svYq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7eee59a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Extorno_vue__ = __webpack_require__("MwoO");
function injectStyle (ssrContext) {
  __webpack_require__("tg80")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7eee59a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Extorno_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7eee59a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Extorno_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a52A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finishedLoading)?_c('div',{staticClass:"col-12 col-md-10 col-lg-8"},[_c('form',[_c('div',{attrs:{"id":"emprestimo-impactol"}},[_c('div',{staticClass:"text-center sub-title"},[_c('p',[_vm._v(_vm._s(_vm.firstName)+", preencha todas as informações abaixo Todos os campos são obrigatórios..")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form"},[_c('label',{attrs:{"for":"nome"}},[_vm._v("Nome completo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"nome","placeholder":"Nome completo"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Email ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"E-mail","disabled":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Telefone de contato")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"(00) 00000-0000"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Para quem se destina o empréstimo")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.tipoPessoa),callback:function ($$v) {_vm.tipoPessoa=$$v},expression:"tipoPessoa"}},_vm._l((_vm.tipo),function(option,index){return _c('at-option',{key:("temTipo" + index),attrs:{"value":option.value}},[_vm._v(_vm._s(option.value))])}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.tipoPessoa !== '' && _vm.tipoPessoa === 'pessoa juridica')?_c('div',{staticClass:"col-12 col-md-6 form"},[_c('label',{attrs:{"for":""}},[_vm._v("CNPJ")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('cnpj'),expression:"'cnpj'"},{name:"model",rawName:"v-model",value:(_vm.document),expression:"document"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"CNPJ","required":"required"},domProps:{"value":(_vm.document)},on:{"input":function($event){if($event.target.composing){ return; }_vm.document=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.tipoPessoa !== '' && _vm.tipoPessoa === 'pessoa fisica')?_c('div',{staticClass:"col-12 col-md-6 form"},[_c('label',{attrs:{"for":""}},[_vm._v("CPF")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('cpf'),expression:"'cpf'"},{name:"model",rawName:"v-model",value:(_vm.document),expression:"document"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"CPF","required":"required"},domProps:{"value":(_vm.document)},on:{"input":function($event){if($event.target.composing){ return; }_vm.document=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Possui restrição?")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.restricao),callback:function ($$v) {_vm.restricao=$$v},expression:"restricao"}},_vm._l((_vm.temRestricao),function(option,index){return _c('at-option',{key:("temRestricaoOptions" + index),attrs:{"value":option.value}},[_vm._v(_vm._s(option.label))])}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Possuí garantia?")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.garantia),callback:function ($$v) {_vm.garantia=$$v},expression:"garantia"}},_vm._l((_vm.temGarantia),function(option,index){return _c('at-option',{key:("temGarantiasOptions" + index),attrs:{"value":option.value}},[_vm._v(_vm._s(option.label))])}),1)],1)]),_vm._v(" "),(_vm.garantia == 'sim')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Informe a garantia")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.garantiaDetalhe),callback:function ($$v) {_vm.garantiaDetalhe=$$v},expression:"garantiaDetalhe"}},_vm._l((_vm.garantias),function(garantia,index){return _c('at-option',{key:("garantiasOptions" + index),attrs:{"value":garantia.value}},[_vm._v(_vm._s(garantia.value))])}),1)],1)]):_vm._e(),_vm._v(" "),(_vm.garantiaDetalhe === 'Outros' && _vm.garantia === 'sim')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Informa o tipo de garantia")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.garantiaOutros),expression:"garantiaOutros"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Informe a garantia","required":""},domProps:{"value":(_vm.garantiaOutros)},on:{"input":function($event){if($event.target.composing){ return; }_vm.garantiaOutros=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Faturamento da empresa nos últimos 12 meses")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.faturamento),expression:"faturamento"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"R$ 00.000,00"},domProps:{"value":(_vm.faturamento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.faturamento=$event.target.value}}}),_vm._v(" "),(_vm.redirectInvestment != 'social')?_c('label',[(_vm.redirectInvestment == 'impact')?_c('a',{on:{"click":function($event){return _vm.changeType('EMPIMP2')}}},[_vm._v("\n                                  Sua empresa não se enquadra no empréstimo social\n                                  Clique aqui para acessar o emprestimo de impacto\n                              ")]):_vm._e(),_vm._v(" "),(_vm.redirectInvestment == 'collective')?_c('a',{on:{"click":function($event){return _vm.changeType('EMPCOL')}}},[_vm._v("\n                                  Sua empresa não se enquadra no empréstimo social\n                                  Clique aqui para acessar o emprestimo coletivo\n                              ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Valor solicitado")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex.: R$ 7.000,00"},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Prazo")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.prazo),callback:function ($$v) {_vm.prazo=$$v},expression:"prazo"}},_vm._l((_vm.prazos),function(prazo,index){return _c('at-option',{key:("prazosOptions" + index),attrs:{"value":prazo.value}},[_vm._v(_vm._s(prazo.label))])}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Motivo do empréstimo")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.motivo),callback:function ($$v) {_vm.motivo=$$v},expression:"motivo"}},_vm._l((_vm.motivoEmp),function(motivo,index){return _c('at-option',{key:("motivoOptions" + index),attrs:{"value":motivo.value}},[_vm._v(_vm._s(motivo.value))])}),1)],1)]),_vm._v(" "),(_vm.motivo == 'Outros')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 form"},[_c('label',{attrs:{"for":""}},[_vm._v("Finalidade")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motivoDetalhe),expression:"motivoDetalhe"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Informe o motivo"},domProps:{"value":(_vm.motivoDetalhe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motivoDetalhe=$event.target.value}}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"checkbox"},[_c('div',{staticClass:"form-check d-flex"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.aceite),expression:"aceite"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"chkTermos"},domProps:{"checked":Array.isArray(_vm.aceite)?_vm._i(_vm.aceite,null)>-1:(_vm.aceite)},on:{"change":function($event){var $$a=_vm.aceite,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.aceite=$$a.concat([$$v]))}else{$$i>-1&&(_vm.aceite=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.aceite=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_c('label',{attrs:{"for":"form-check-label"}},[_vm._v("Declaro que li e aceito os termos acima")])]),_vm._v(" "),_c('div',{staticClass:"form-check d-flex"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.acordos),expression:"acordos"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"chkPolitica"},domProps:{"checked":Array.isArray(_vm.acordos)?_vm._i(_vm.acordos,null)>-1:(_vm.acordos)},on:{"change":function($event){var $$a=_vm.acordos,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.acordos=$$a.concat([$$v]))}else{$$i>-1&&(_vm.acordos=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.acordos=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_c('label',{attrs:{"for":"form-check-label"}},[_vm._v("Declaro que estou de acordo com os \n                              "),_c('a',{attrs:{"href":_vm.lpUrl+'/termos-de-uso-e-condicoes-para-empresa-tomadora/',"target":"_blank"}},[_vm._v("Termos de Uso")]),_vm._v(" \n                              e com a "),_c('a',{attrs:{"href":_vm.lpUrl+'/politica-de-privacidade/',"target":"_blank"}},[_vm._v("Politica de Privacidade")])])])])])]),_vm._v(" "),_c('div',{staticClass:"bt text-center"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":!_vm.aceite || !_vm.acordos || !_vm.isValid() || !_vm.isValidMotivo() || !_vm.isValidGarantia() || !_vm.isValidGarantiaOutros() || _vm.redirectInvestment != 'social'},on:{"click":_vm.onSubmit}},[_vm._v("Continuar")])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h5',[_vm._v("Por último, precisamos que você:")]),_vm._v(" "),_c('ul',[_c('li',[_c('img',{attrs:{"src":"/static/assets/images/checked.svg","width":"18"}}),_c('span',{attrs:{"id":"autorizacaoCPF_CNPJ"}},[_vm._v(" Autorize o banco parceiro a consultar seu CPF/CNPJ.")])]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/checked.svg","width":"18"}}),_c('span',[_vm._v(" Autorize o banco parceiro a compartilhar as suas informações com a IOUU.")])]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/checked.svg","width":"18"}}),_c('span',[_vm._v(" Declare que as informações que forneceu são verdadeiras.")])]),_vm._v(" "),_c('li',{attrs:{"id":"autorizacaoPPE"}},[_c('img',{attrs:{"src":"/static/assets/images/checked.svg","width":"18"}}),_c('span',[_vm._v(" Confirme que não é Pessoa Exposta politicamente.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 terms"},[_c('strong',[_vm._v("Para isso leia o termo abaixo e selecione os itens de confirmação ao final da página")]),_vm._v(" "),_c('div',{staticClass:"textarea"},[_c('textarea',{attrs:{"spellcheck":"false","id":"termos","readonly":""}},[_vm._v("                              ESTOU CIENTE E AUTORIZO, neste ato que o(s) Banco(s) parceiro(s) tenha(m) acesso/consulte(m) os meus dados de depósitos e aplicações em outras instituições financeiras; as informações a meu respeito constantes no cadastro dos órgãos de proteção ao crédito tais como SPC e Serasa, bem como todas e quaisquer demais informações registradas no Sistema de Informações de Crédito do Banco Central (SCR), nos termos do artigo 1º, § 3º, V da Lei Complementar nº 105/01 segundo a qual não configura quebra de sigilo bancário a revelação de informações sigilosas com o expresso consentimento do interessado.\n                              AUTORIZO expressamente a Instituição Financeira a divulgar, compartilhar e trocar informações a meu respeito com a IOUU Tecnologia e Serviços Financeiros LTDA - Epp ou qualquer outro terceiro a ela ligado ou relacionado, para fins de registro, análise de risco de crédito e qualquer outra finalidade, incluindo, mas não limitado a oferta de produtos da IOUU Tecnologia e Serviços Financeiros LTDA - Epp ou do respectivo terceiro.\n                              DECLARO não ser ou ter como meus representantes, familiares ou outras pessoas de meu relacionamento próximo qualquer pessoa exposta politicamente (PEP) (pessoas que desempenhem ou desempenharam, nos últimos cinco anos, no Brasil ou no exterior, cargos, empregos e/ou funções públicas relevantes), conforme definição pela circular nº 3.461 de 24.07.2009 do Banco Central do Brasil.\n                              DECLARO serem inteiramente verdadeiras as informações pessoais fornecidas à Instituição Financeira por meio de meu cadastro neste SITE e estar ciente de que estas informações condicionaram a avaliação da viabilidade do Empréstimo.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aBmJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.carregado)?_c('div',{staticClass:"user-profile ccbs"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 tit_page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"back float-right text-right"},[_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"back"},[_vm._v(" ")]),_vm._v(" "),_c('span',[_vm._v("Voltar")])])])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row ccbs__title"},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v(_vm._s((_vm.ReservaInvestimento.SolicitacaoId.Empresa.NomeFantasia == undefined || _vm.ReservaInvestimento.SolicitacaoId.Empresa.NomeFantasia == "")? _vm.ReservaInvestimento.SolicitacaoId.Empresa.RazaoSocial : _vm.ReservaInvestimento.SolicitacaoId.Empresa.NomeFantasia))]),_vm._v(" "),_c('span',[_vm._v("CNPJ: "+_vm._s(_vm.formattedCnpj()))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.formatarTipoEmprestimo(_vm.ReservaInvestimento.SolicitacaoId.TipoEmprestimo)))])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row ccbs__info"},[_c('div',{staticClass:"col-12 col-md-7 col-lg-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Valor investido")]),_vm._v(" "),_c('span',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.ReservaInvestimento.Valor)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Valor de pagamento mensal")]),_vm._v(" "),_c('span',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.valorMensal)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Data do investimento")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.toLocaleDateString(_vm.ReservaInvestimento.Created)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("CDI")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatCurrency(_vm.ReservaInvestimento.SolicitacaoId.Cdi))+"%")])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Taxa total efetiva")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatCurrency(_vm.ReservaInvestimento.SolicitacaoId.CustoEfetivoTotalaa))+"% a.a.")])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Valor total solicitado")]),_vm._v(" "),_c('span',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.ReservaInvestimento.SolicitacaoId.Valor)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Duração")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.ReservaInvestimento.SolicitacaoId.Prazo)+" meses")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Data")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.toLocaleDateString(_vm.ReservaInvestimento.SolicitacaoId.InicioCaptacao)))])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-6 mt-2 mb-3"},[_c('label',[_vm._v("Empresa (Razão social)")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.ReservaInvestimento.SolicitacaoId.Empresa.RazaoSocial))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-3 mt-2 mb-3"},[_c('label',[_vm._v("CPF/CNPJ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formattedCnpj()))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-3 mt-2 mb-3"},[_c('label',[_vm._v("Nome do responsável")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.ReservaInvestimento.SolicitacaoId.Solicitante.NomeCompleto))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-6 mt-2 mb-3"},[_c('label',[_vm._v("Nome fantasia")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.ReservaInvestimento.SolicitacaoId.Empresa.NomeFantasia))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-6 mt-2 mb-3"},[_c('label',[_vm._v("Telefone comercial")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.ReservaInvestimento.SolicitacaoId.TelefoneComercial))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-3 mt-2 mb-3"},[_c('label',[_vm._v("Data de fundação")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.toLocaleDateString(_vm.ReservaInvestimento.SolicitacaoId.Empresa.DataFundacao)))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-3 mt-2 mb-3"},[_c('label',[_vm._v("Número de funcionários")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.ReservaInvestimento.SolicitacaoId.Empresa.QuantidadeEmpregados)+" empregados")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-6 mt-2 mb-3"},[_c('label',[_vm._v("Nome do grupo ecônomico")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.ReservaInvestimento.SolicitacaoId.Empresa.NomeGrupoEconomico))])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-2"},[_c('label',[_vm._v("Endereço")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Logradouro)+",\n                        "+_vm._s(_vm.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Numero)+"  \n                         "+_vm._s(_vm.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Complemento ? " - " + _vm.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Complemento : "")+"\n                        "+_vm._s(_vm.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Bairro ? ", " + _vm.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Bairro : "")+"  \n                        "+_vm._s(_vm.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Cep ? " - " + _vm.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Cep : "")+", \n                        "+_vm._s(_vm.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Cidade)+"/"+_vm._s(_vm.ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Uf)+" \n                    ")])])])]),_vm._v(" "),_c('aside',{staticClass:"col-12 col-md-5 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3 p-md-4"},[(this.passo != 3)?_c('div',{staticClass:"box-form"},[_c('img',{staticClass:"ico-atencao",attrs:{"src":"/static/assets/images/ico-atencao-ccb.svg","alt":"icone atenção"}}),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.Nome())+", falta assinar sua CCB")]),_vm._v(" "),_c('div',{staticClass:"box box-ccb p-2 d-flex justify-content-between align-items-center"},[_c('span',{staticClass:"m-1 d-flex align-items-center"},[_c('img',{attrs:{"src":"/static/assets/images/ico-pdf.png","alt":"icone ccb"}}),_vm._v(" "),_c('small',[_vm._v(_vm._s(this.ReservaInvestimento.CodigoBMP))])]),_vm._v(" "),_c('span',[_c('a',{staticClass:"btn btn-sm btn-link",attrs:{"href":_vm.CCB_URL+"/imprimirccb.aspx?code="+this.ReservaInvestimento.CodigoBMP+"&copias=1","target":"_blank","title":"Visualizar CCB"}},[_vm._v("Visualizar")])])]),_vm._v(" "),(!this.ccb)?_c('form',[_c('span',{staticClass:"text"},[_vm._v("Aguardando as assinaturas dos sócios e tomadores.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"disabled":"false"}},[_vm._v("Em aguardo")])]):_vm._e(),_vm._v(" "),(this.passo == 1 && this.ccb)?_c('form',[_c('button',{staticClass:"btn btn-lg btn-primary btn-block",on:{"click":function($event){$event.preventDefault();_vm.passo = 2;}}},[_vm._v("Assinar")])]):_vm._e(),_vm._v(" "),(this.passo == 2 && this.existesenha && this.ccb)?_c('form',[_c('span',{staticClass:"text"},[_vm._v("Por favor insira sua senha no campo abaixo para finalizar a assinatura de sua CCB.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control form-control-lg",attrs:{"type":"password","placeholder":"Sua senha aqui"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",on:{"click":function($event){$event.preventDefault();return _vm.ValidarSenha()}}},[_vm._v("Assinar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-link btn-block",on:{"click":function($event){$event.preventDefault();_vm.passo = _vm.passo-1}}},[_vm._v("Cancelar")])]):_vm._e(),_vm._v(" "),(this.passo == 2 && !this.existesenha && this.ccb)?_c('form',[_c('span',{staticClass:"text"},[_vm._v("Por favor entre no link abaixo para cadastrar uma senha.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",on:{"click":function($event){$event.preventDefault();return _vm.CadastrarSenha()}}},[_vm._v("Cadastrar senha")])]):_vm._e()]):_vm._e(),_vm._v(" "),(this.passo == 3)?_c('div',{staticClass:"box-confirm"},[_c('img',{attrs:{"src":"/static/assets/images/icon-success.svg","alt":"icone ok"}}),_vm._v(" "),_c('h5',[_vm._v("Obrigado, "+_vm._s(_vm.Nome())+".")]),_vm._v(" "),_c('p',[_vm._v("Sua CCB foi assinada com sucesso!")])]):_vm._e()])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("Formalizar CCB")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-6 col-lg-4 mt-2 mb-3"},[_c('div',{staticClass:"box p-3"},[_c('label',[_vm._v("Taxa interna de retorno")]),_vm._v(" "),_c('span',[_vm._v("35.5% a.a. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt-2 mb-3"},[_c('h3',[_vm._v("Dados do empréstimo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt-2 mb-3"},[_c('h3',[_vm._v("Dados da empresa")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aC0Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aPYQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.banks.length > 0)?_c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_c('h5',{staticStyle:{"text-align":"center","margin":"-30px auto 40px auto"}},[_vm._v("Os dados informados devem ser do titular da conta.")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-6"},[_c('at-select',{staticClass:"focus-select",attrs:{"size":"large","tabindex":"1","filterable":"","placeholder":"Banco"},model:{value:(_vm.bankCode),callback:function ($$v) {_vm.bankCode=$$v},expression:"bankCode"}},_vm._l((_vm.banks),function(banco,i){return _c('at-option',{key:("bankOptions" + i),attrs:{"value":banco.codigo}},[_vm._v(_vm._s(banco.nome))])}),1),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"agencia"}},[_vm._v("Agência *"),(_vm.selectedBank.codigo == '077')?_c('strong',{staticStyle:{"color":"#41d3bd"}},[_vm._v(" sem o digito 9")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agency),expression:"agency"},{name:"mask",rawName:"v-mask",value:(_vm.selectedBank.agencia),expression:"selectedBank.agencia"}],key:"agency",staticClass:"form-control form-control-lg",attrs:{"tabindex":"2","type":"text","placeholder":_vm.selectedBank.placeholderAgencia,"required":""},domProps:{"value":(_vm.agency)},on:{"input":function($event){if($event.target.composing){ return; }_vm.agency=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"inputPassword4"}},[_vm._v("Conta *"),(_vm.selectedBank.codigo == '104')?_c('strong',{staticStyle:{"color":"#41d3bd"}},[_vm._v(" (X: Operação)")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account),expression:"account"},{name:"mask",rawName:"v-mask",value:(_vm.selectedBank.conta),expression:"selectedBank.conta"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","tabindex":"3","placeholder":_vm.selectedBank.placeholderConta,"required":""},domProps:{"value":(_vm.account)},on:{"input":function($event){if($event.target.composing){ return; }_vm.account=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-12 align-self-center text-center"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('div',{staticClass:"checkContainer d-flex align-items-center",staticStyle:{"height":"25px"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.accountType),expression:"accountType",modifiers:{"number":true}}],staticClass:"form-check-input",attrs:{"tabindex":"4","type":"radio","name":"TipoConta","id":"cc","value":"1","required":""},domProps:{"checked":_vm._q(_vm.accountType,_vm._n("1"))},on:{"change":function($event){_vm.accountType=_vm._n("1")}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"cc"}},[_vm._v("Conta corrente")])])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('div',{staticClass:"checkContainer d-flex align-items-center",staticStyle:{"height":"25px"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.accountType),expression:"accountType",modifiers:{"number":true}}],staticClass:"form-check-input",attrs:{"tabindex":"5","type":"radio","name":"TipoConta","id":"cp","value":"2","required":""},domProps:{"checked":_vm._q(_vm.accountType,_vm._n("2"))},on:{"change":function($event){_vm.accountType=_vm._n("2")}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"cp"}},[_vm._v("Conta poupança")])])])])]),_vm._v(" "),_vm._m(0)],1)])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btns text-center"},[_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":"/static/assets/images/angle-right.svg"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aWzu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-8"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Razão Social")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.RazaoSocial),expression:"partner.RazaoSocial"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":"","placeholder":"Razão Social"},domProps:{"value":(_vm.partner.RazaoSocial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "RazaoSocial", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"inputPassword4"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Cnpj),expression:"partner.Cnpj"},{name:"mask",rawName:"v-mask",value:('cnpj'),expression:"'cnpj'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":"","placeholder":"CNPJ"},domProps:{"value":(_vm.partner.Cnpj)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Cnpj", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"Celular"}},[_vm._v("Celular")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Celular),expression:"partner.Celular"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":"","placeholder":""},domProps:{"value":(_vm.partner.Celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Celular", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-8"},[_c('label',{attrs:{"for":"Email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Email),expression:"partner.Email"}],staticClass:"form-control form-control-lg",attrs:{"type":"email","required":"","placeholder":""},domProps:{"value":(_vm.partner.Email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"Site"}},[_vm._v("Site")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Site),expression:"partner.Site"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: iouu.com.br"},domProps:{"value":(_vm.partner.Site)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Site", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"Facebook"}},[_vm._v("Facebook")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Facebook),expression:"partner.Facebook"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: facebook.com/IouuBrasil/"},domProps:{"value":(_vm.partner.Facebook)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Facebook", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"Linkedin"}},[_vm._v("Linkedin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Linkedin),expression:"partner.Linkedin"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: linkedin.com/company/iouu/"},domProps:{"value":(_vm.partner.Linkedin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Linkedin", $event.target.value)}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "alcn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "anEX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SocialNetwork__ = __webpack_require__("TYgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PasswordField__ = __webpack_require__("i7i+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_hub_consulta_client_js__ = __webpack_require__("pk4i");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





// import MarketingDrip from '../services/api/marketing';

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lpUrl: "https://iouu.com.br",
      name: '',
      email: '',
      password: '',
      enabled: false,
      visivel: false,
      EmailConfirmado: false
    };
  },

  components: {
    SocialNetwork: __WEBPACK_IMPORTED_MODULE_3__components_SocialNetwork__["a" /* default */], PasswordField: __WEBPACK_IMPORTED_MODULE_5__components_PasswordField__["a" /* default */]
  },
  methods: {
    passwordIsValid: function passwordIsValid() {

      if (this.password.length < 6) {

        this.$Notify.error("A senha deve conter mais de 6 digitos!");
        $("#inputPassword").addClass("animated shake");
        $("#inputPassword").addClass("emailinvalido");

        return false;
      } else {
        $("#inputPassword").removeClass("animated");
        $("#inputPassword").removeClass("shake");
        $("#inputPassword").removeClass("emailinvalido");

        return true;
      }
    },
    linkEmprestimo: function linkEmprestimo() {
      this.$router.push("https://emprestimos.iouu.com.br/pedido");
    },
    validateName: function validateName() {
      if (this.name[0] == " ") {
        this.name = "";
        return;
      }

      var splitText = this.name.split(' ');
      var upperCaseText = '';

      for (var i = 0; i < splitText.length; i++) {
        if (splitText[i] != "") {
          if (i > 0) upperCaseText += " ";

          upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
        } else if (i > 0) upperCaseText += " ";
      }

      this.name = upperCaseText;
    },

    ValidarEmail: function ValidarEmail() {
      var _this = this;

      //Chama API que faz a Pré Validação do Email para verificar se a ortografia esta correta
      if (this.email != "") {

        this.email = this.email.toLowerCase().trim();

        __WEBPACK_IMPORTED_MODULE_6__utils_hub_consulta_client_js__["a" /* default */].PreValidacaoEmail(this.email).then(function (resposta) {

          //Sintaxe do Email Inválida
          if (resposta.Msg == "Email Inválido") {
            $("#IconeInvalido").removeAttr("hidden");
            $("#Email").addClass("animated shake");
            $("#Email").addClass("emailinvalido");
            $("#IconeInvalido").addClass("animated shake");
            _this.EmailConfirmado = false;
            _this.$Notify.error("Digite um email válido!");
          }

          //Sintaxe do Email Correta
          else {
              //Chama API que verifica se este usuário já está cadastrado
              __WEBPACK_IMPORTED_MODULE_6__utils_hub_consulta_client_js__["a" /* default */].ExisteUsuario(_this.email).then(function (resposta) {
                if (resposta.Msg == "Existe") {
                  _this.$Notify.info("Esse email já foi cadastrado no sistema!");
                  $("#IconeInvalido").removeAttr("hidden");
                  $("#Email").addClass("animated shake");
                  $("#Email").addClass("emailinvalido");
                  $("#IconeInvalido").addClass("animated shake");
                  _this.EmailConfirmado = false;
                } else {
                  //Chamar API que faz a validação do Email
                  __WEBPACK_IMPORTED_MODULE_6__utils_hub_consulta_client_js__["a" /* default */].theCheckerPost(_this.email).then(function (resposta) {

                    if (resposta == "Entregável") {
                      //Executa se o email for válido
                      $("#IconeValido").removeAttr("hidden");
                      $("#Email").addClass("emailvalido");
                      _this.EmailConfirmado = true;
                      _this.$Notify.success("Email Validado com Sucesso!");
                    }

                    if (resposta == "Inválido") {
                      //Executa se o email for inválido
                      $("#IconeInvalido").removeAttr("hidden");
                      $("#Email").addClass("animated shake");
                      $("#Email").addClass("emailinvalido");
                      $("#IconeInvalido").addClass("animated shake");
                      _this.EmailConfirmado = false;
                      _this.$Notify.error("Email Inválido!");
                    }
                  }).catch(function () {
                    $("#IconeValido").removeAttr("hidden");
                    $("#Email").addClass("emailvalido");
                    _this.EmailConfirmado = true;
                    _this.$Notify.success("Email Validado com Sucesso!");
                  }); //Fim Validação TheChecker
                }
              }).catch(function () {
                $("#IconeValido").removeAttr("hidden");
                $("#Email").addClass("emailvalido");
                _this.EmailConfirmado = true;
                _this.$Notify.success("Email Validado com Sucesso!");
              }); //Fim Existe Usuário
            }
        }).catch(function () {
          $("#IconeValido").removeAttr("hidden");
          $("#Email").addClass("emailvalido");
          _this.EmailConfirmado = true;
          _this.$Notify.success("Email Validado com Sucesso!");
        }); //Fim Validação Email
      }
    },
    RetirarAnimacao: function RetirarAnimacao() {
      $("#Email").removeClass("animated");
      $("#Email").removeClass("shake");
      $("#Email").removeClass("emailinvalido");
      $("#Email").removeClass("emailvalido");

      $("#IconeInvalido").removeClass("animated");
      $("#IconeInvalido").removeClass("shake");
      $("#IconeInvalido").attr({ "hidden": "hidden" });

      $("#IconeValido").attr({ "hidden": "hidden" });
    },
    signUp: function signUp() {
      var _this2 = this;

      if (!this.passwordIsValid()) return;

      // if(process.env.NODE_ENV === "production") {
      //   this.Drip(this.name, this.email)
      //   console.log("DRIP")
      // }

      this.$store.dispatch('signup', { name: this.name, email: this.email, password: this.password }).then(function () {
        _this2.$ga.event('NewUser', 'start', 'Investidor');
        fbq('track', 'Lead');
        _this2.$router.push("/cadastro-concluido-com-sucesso");
      }).catch(function (error) {
        var errorMessages = error.response.data.errors.map(function (error) {
          return error.detail;
        });
        _this2.$Notify.error(__WEBPACK_IMPORTED_MODULE_4__utils_array_helper__["a" /* default */].toSentence(errorMessages));
      });

      // CADASTRA CONTATO EM ACTIVE CAMPAIN
      __WEBPACK_IMPORTED_MODULE_6__utils_hub_consulta_client_js__["a" /* default */].CadastrarActive(this.email);
    },
    facebookLogin: function facebookLogin(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get('oauth/facebook/url').then(function (response) {
        window.location.href = response.data.loginUrl;
      });
    },
    googleLogin: function googleLogin(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get('oauth/google/url').then(function (response) {
        window.location.href = response.data.loginUrl;
      });
    },
    linkedinLogin: function linkedinLogin(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].get('oauth/linkedin/url').then(function (response) {
        window.location.href = response.data.loginUrl;
      });
    },


    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/criar-conta',
        title: 'CriarConta'
      });
    }
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:

              if (_this3.$route.query.name) _this3.name = _this3.$route.query.name;

              if (_this3.$route.query.email) _this3.email = _this3.$route.query.email;

              if (_this3.$route.query.v) _this3.visivel = true;

              //tagueamento GA
              _context.next = 5;
              return _this3.taggingGA();

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),

/***/ "anOL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		data: {
			required: true,
			type: Array
		}
	},
	extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
	mounted: function mounted() {

		if (this.data != undefined) {
			this.renderChart({
				datasets: this.data.map(function (item) {
					return {
						label: item.label,
						fill: false,
						backgroundColor: item.color,
						data: [item.value]

					};
				})
			}, {
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					enabled: true,
					mode: 'single',
					callbacks: {
						label: function label(tooltipItems, data) {

							return data.datasets[tooltipItems.datasetIndex].label + "  " + tooltipItems.yLabel.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }) + "%"; //
						}
					}
				},
				legend: {
					position: 'bottom',
					display: false,
					labels: {
						padding: 15
					}
				},
				scales: {
					yAxes: [{
						display: true,
						ticks: {
							suggestedMin: 0, // minimum will be 0, unless there is a lower value.
							beginAtZero: true // minimum value will be 0.
						}
					}],
					xAxes: [{
						display: true,
						gridLines: {
							display: false
						}
					}]
				}
			});
		}
	},

	methods: {}
});

/***/ }),

/***/ "aqVo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_session_manager__ = __webpack_require__("J7hJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterNewLogin__ = __webpack_require__("fsye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormNewLogin__ = __webpack_require__("wLMa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_LoginBanner__ = __webpack_require__("zVRO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_NewModal_ModalRegistration__ = __webpack_require__("Susk");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: {
        email: "",
        password: ""
      },
      keepLogged: false,
      loading: true,
      openModal: false
    };
  },

  components: {
    FooterNewLogin: __WEBPACK_IMPORTED_MODULE_4__components_FooterNewLogin__["a" /* default */],
    FormNewLogin: __WEBPACK_IMPORTED_MODULE_5__components_FormNewLogin__["a" /* default */],
    LoginBanner: __WEBPACK_IMPORTED_MODULE_6__components_LoginBanner__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_7__components_Loading__["a" /* default */],
    ModalRegistration: __WEBPACK_IMPORTED_MODULE_8__components_NewModal_ModalRegistration__["a" /* default */]
  },
  methods: {
    getUserData: function getUserData(payload) {
      var _this = this;

      this.user.email = payload.email;
      this.user.password = payload.password;
      this.$store.dispatch("login", {
        email: this.user.email,
        password: this.user.password,
        keepLogged: true
      }).then(function (resp) {
        var urlParams = "";
        sessionStorage.removeItem("redirectINV");
        _this.$ga.set({ userId: _this.email });

        for (var key in _this.$route.query) {
          if (_this.$route.query.hasOwnProperty(key)) {
            if (key == "redirected_from") urlParams = _this.$route.query[key];else urlParams = urlParams + "&" + key + "=" + _this.$route.query[key];
          }
        }

        if (_this.$route.query.loansId !== undefined && _this.$route.query.loansId !== "" && _this.$route.query.loadnId !== null) {
          _this.$router.push("/informacoes-adicionais/emprestimo-coletivo/" + _this.$route.query.loansId);
        } else if (urlParams != "") {
          _this.$router.push(urlParams);
        } else {
          _this.$router.push("/");
        }
      }).catch(function (error) {
        if (error.response.data.Msg) {
          _this.$Notify.error(error.response.data.Msg);
        } else {
          _this.$Notify.error("Tivemos um erro inesperado, tente novamente mais tarde");
        }
      });
    },
    facebookLogin: function facebookLogin() {
      var scope = this;
      FB.login(function (response) {
        if (response.status === 'connected') {
          scope.$store.dispatch('socialNetworkLogin', { provider: 'facebook', receivedData: response.authResponse.accessToken, errorMessage: scope.$Notify.error });
          var urlParams = "";
          sessionStorage.removeItem("redirectINV");

          for (var key in scope.$route.query) {
            if (scope.$route.query.hasOwnProperty(key)) {
              if (key == "redirected_from") urlParams = scope.$route.query[key];else urlParams = urlParams + "&" + key + "=" + scope.$route.query[key];
            }
          }

          if (scope.$route.query.loansId !== undefined && scope.$route.query.loansId !== "" && scope.$route.query.loadnId !== null) {
            scope.$router.push("/informacoes-adicionais/emprestimo-coletivo/" + scope.$route.query.loansId);
          } else if (urlParams != "") {
            scope.$router.push(urlParams);
          } else {
            scope.$router.push("/");
          }
        } else {
          console.log("Não Loggado");
          if (error) {
            scope.$Notify.error(error);
          } else {
            scope.$Notify.error("Tivemos um erro inesperado, tente novamente mais tarde");
          }
        }
      }, { scope: 'public_profile,email' });
    },
    googleLogin: function googleLogin() {
      var scope = this;
      this.$gAuth.signIn().then(function (GoogleUser) {
        scope.$store.dispatch('socialNetworkLogin', {
          provider: 'google',
          receivedData: GoogleUser.Zi.access_token,
          errorMessage: scope.$Notify.error
        });
        var urlParams = "";
        sessionStorage.removeItem("redirectINV");

        for (var key in scope.$route.query) {
          if (scope.$route.query.hasOwnProperty(key)) {
            if (key == "redirected_from") urlParams = scope.$route.query[key];else urlParams = urlParams + "&" + key + "=" + scope.$route.query[key];
          }
        }

        if (scope.$route.query.loansId !== undefined && scope.$route.query.loansId !== "" && scope.$route.query.loadnId !== null) {
          scope.$router.push("/informacoes-adicionais/emprestimo-coletivo/" + scope.$route.query.loansId);
        } else if (urlParams != "") {
          scope.$router.push(urlParams);
        } else {
          scope.$router.push("/");
        }
      }).catch(function (error) {
        console.log('Sign-in error', error);
        if (error) {
          scope.$Notify.error(error);
        } else {
          scope.$Notify.error("Tivemos um erro inesperado, tente novamente mais tarde");
        }
      });
    },
    login: function login(event) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fbLoadSDK: function fbLoadSDK(d, s, id) {
      var js,
          fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },
    ggLoadSDK: function ggLoadSDK(d, s, id) {
      var js,
          fjs = document.getElementsByTagName(s)[0];
      if (document.getElementById(id)) return;
      js = document.createElement(s);js.id = id;
      js.src = "https://apis.google.com/js/platform.js?onload=renderButton";
      fjs.parentNode.insertBefore(js, fjs);
    },
    fbStartServices: function fbStartServices() {
      FB.init({
        appId: '144107022958731',
        cookie: true,
        xfbml: true,
        version: 'v4.0'
      });
    },
    ggStartServices: function ggStartServices() {
      var scope = this;
      gapi.load('auth2', function () {
        gapi.auth2.init({
          client_id: '765138997021-b6kbuu7rdc6im5f75d3qjasjsfrq2tep.apps.googleusercontent.com',
          cookiepolicy: 'single_host_origin',
          scope: 'profile'
        }).attachClickHandler(document.getElementById('gg-signin-button'), {}, function (googleUser) {
          scope.$store.dispatch('socialNetworkLogin', { provider: 'google', receivedData: googleUser.getAuthResponse().id_token, errorMessage: scope.$Notify.error });
        }, function (error) {
          console.log('Sign-in error', error);
        });
      });
    },
    setOpenModal: function setOpenModal() {
      this.openModal ? this.openModal = false : this.openModal = true;
    }
  },
  created: function created() {
    var _this3 = this;

    this.user.email = "";
    this.user.password = "";
    this.fbLoadSDK(document, 'script', 'facebook-jssdk');
    this.ggLoadSDK(document, 'script', 'google-jssdk');
    setTimeout(function () {
      _this3.fbStartServices();
      _this3.ggStartServices();
      _this3.loading = false;
    }, 3000);
  }
});

/***/ }),

/***/ "as+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_masker__ = __webpack_require__("7VWg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        operacao: { type: Object }
    },

    created: function created() {
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.operacao));
    },


    computed: {
        valor: function valor() {
            return this.operacao.Valor;
        },
        transacao: function transacao() {
            return this.operacao.id;
        }
    },

    methods: {
        formatDocument: function formatDocument(doc) {

            if (doc.length > 11) {
                return __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].maskCnpj(doc);
            } else {
                return __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].maskCpf(doc);
            }
        },
        formatarDinheiro: function formatarDinheiro(value) {

            if (value != null) {

                if (typeof value == "string") value = parseFloat(value);

                var options = {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                };

                return value.toLocaleString('pt-BR', options);
            }

            return 0;
        }
    }
});

/***/ }),

/***/ "at0S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row no-gutters justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-12 col-xl-9 d-flex justify-content-between align-items-center mt-4"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"d-flex",attrs:{"id":"sumir"}},[_vm._m(1),_vm._v(" "),(_vm.encontrado)?_c('button',{staticClass:"btn btn-secondary",attrs:{"onclick":"javascript: document.getElementById('sumir').style='display:none!important;'; window.print();"}},[_c('i',{staticClass:"fas fa-print"}),_vm._v("\n                IMPRIMIR\n            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),(_vm.encontrado)?_c('div',{staticClass:"col-12 col-md-12 col-lg-12 col-xl-9"},[_c('table',[_c('tbody',[_c('tr',[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(" "+_vm._s(_vm.getDataVencimento(this.PagAtual.Data)))])]),_vm._v(" "),_c('tr',[_vm._m(4),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(" "+_vm._s(_vm.formatCPF(this.infosDarf.Investidor.Cpf)))])]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('tr',[_c('td',{attrs:{"rowspan":"2"}},[_vm._m(6),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.infosDarf.Investidor.NomeCompleto)+" / "+_vm._s(this.infosDarf.Investidor.Celular)+" ")])]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_vm._m(8),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(_vm._s(_vm.getDataApuracao(this.PagAtual.Data))+" "+_vm._s(this.DataVencimento))])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"rowspan":"2"}},[_c('p',[_vm._v("#"+_vm._s(this.infosDarf.Solicitacao.IdOportunidade)+" - "+_vm._s(_vm.companyName(this.infosDarf.Solicitacao)))])]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(_vm._s(this.infosDarf.Valor))])]),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('tr',[_vm._m(12),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(_vm._s(this.infosDarf.Valor))])]),_vm._v(" "),_vm._m(13)])])]):_vm._e(),_vm._v(" "),(_vm.encontrado)?_c('div',{staticClass:"col-12 col-md-12 col-lg-12 col-xl-9"},[_c('table',[_c('tbody',[_c('tr',[_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(" "+_vm._s(_vm.getDataVencimento(this.PagAtual.Data)))])]),_vm._v(" "),_c('tr',[_vm._m(16),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(" "+_vm._s(_vm.formatCPF(this.infosDarf.Investidor.Cpf)))])]),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('tr',[_c('td',{attrs:{"rowspan":"2"}},[_vm._m(18),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.infosDarf.Investidor.NomeCompleto)+" / "+_vm._s(this.infosDarf.Investidor.Celular)+" ")])]),_vm._v(" "),_vm._m(19),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_vm._m(20),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(" "+_vm._s(this.DataVencimento))])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"rowspan":"2"}},[_c('p',[_vm._v("#"+_vm._s(this.infosDarf.Solicitacao.IdOportunidade)+" - "+_vm._s(_vm.companyName(this.infosDarf.Solicitacao)))])]),_vm._v(" "),_vm._m(21),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(_vm._s(this.infosDarf.Valor))])]),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_c('tr',[_vm._m(24),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(_vm._s(this.infosDarf.Valor))])]),_vm._v(" "),_vm._m(25)])])]):_vm._e(),_vm._v(" "),(_vm.Naoencontrado)?_c('div',{staticClass:"col-12 col-md-12 col-lg-12 col-xl-9 item-center-darf"},[_c('h1',[_vm._v("Darf não encontrada")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})]),_vm._v(" "),_c('h1',[_vm._v("GUIA RECOLHIMENTO DARF")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link",attrs:{"onclick":"javascript:history.go(-1);"}},[_c('i',{staticClass:"fas fa-angle-left"}),_vm._v("\n                Voltar\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"rowspan":"3"}},[_c('div',{staticClass:"item-header"},[_c('figure',[_c('img',{attrs:{"src":"/static/assets/images/brasao-br.png","alt":""}})]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("\n                                    MINISTÉRIO DA FAZENDA"),_c('br'),_vm._v("\n                                    SECRETARIA DA RECEITA FEDERAL\n                                ")]),_vm._v(" "),_c('strong',[_vm._v("Documento de Arrecadação de Receitas Federais")]),_vm._v(" "),_c('strong',[_vm._v("DARF")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("02")]),_vm._v(" "),_c('small',[_vm._v("PERÍODO DE APURAÇÃO")])]),_vm._v(" "),_c('span',[_vm._v("→")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("03")]),_vm._v(" "),_c('small',[_vm._v("NÚMERO DO CPF OU CNPJ")])]),_vm._v(" "),_c('span',[_vm._v("→")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("04")]),_vm._v(" "),_c('small',[_vm._v("CÓDIGO  DA  RECEITA")])]),_vm._v(" "),_c('span',[_vm._v("→")])])]),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v("8053")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"m-print"},[_c('strong',[_vm._v("01")]),_vm._v(" "),_c('small',[_vm._v("NOME / TELEFONE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("05")]),_vm._v(" "),_c('small',[_vm._v("NÚMERO  DE REFERÊNCIA")])]),_vm._v(" "),_c('span',[_vm._v("→")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("06")]),_vm._v(" "),_c('small',[_vm._v("DATA DE VENCIMENTO")])]),_vm._v(" "),_c('span',[_vm._v("→")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("07")]),_vm._v(" "),_c('small',[_vm._v("VALOR DO PRINCIPAL")])]),_vm._v(" "),_c('span',[_vm._v("→")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("08")]),_vm._v(" "),_c('small',[_vm._v("VALOR DA MULTA")])]),_vm._v(" "),_c('span',[_vm._v("→")])])]),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(" 0,00")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center align-middle atencao",attrs:{"rowspan":"4"}},[_c('strong',[_vm._v("ATENÇÃO")]),_vm._v(" "),_c('p',[_vm._v("É vedado o recolhimento de tributos administrados pela Secretaria da Receita Federal do Brasil (RFB) cujo valor total seja inferior a R$ 10,00. Ocorrendo tal situação, adicione esse valor  ao  tributo  de  mesmo  código  de  períodos  subseqüentes,  até que o total seja igual ou superior a R$ 10,00.")])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("09")]),_vm._v(" "),_c('small',[_vm._v("VALOR DOS JUROS E/OUENCARGOS DL - 1.025/69")])]),_vm._v(" "),_c('span',[_vm._v("→")])])]),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(" 0,00")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("10")]),_vm._v(" "),_c('small',[_vm._v("VALOR TOTAL")])]),_vm._v(" "),_c('span',[_vm._v("→")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"2","height":"100"}},[_c('span',{staticClass:"m-print"},[_c('strong',[_vm._v("11")]),_vm._v(" "),_c('small',[_vm._v("AUTENTICAÇÃO  BANCÁRIA  (Somente nas 1ª e 2ª vias)")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"rowspan":"3"}},[_c('div',{staticClass:"item-header"},[_c('figure',[_c('img',{attrs:{"src":"/static/assets/images/brasao-br.png","alt":""}})]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("\n                                    MINISTÉRIO DA FAZENDA"),_c('br'),_vm._v("\n                                    SECRETARIA DA RECEITA FEDERAL\n                                ")]),_vm._v(" "),_c('strong',[_vm._v("Documento de Arrecadação de Receitas Federais")]),_vm._v(" "),_c('strong',[_vm._v("DARF")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("02")]),_vm._v(" "),_c('small',[_vm._v("PERÍODO DE APURAÇÃO")])]),_vm._v(" "),_c('span',[_vm._v("→")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("03")]),_vm._v(" "),_c('small',[_vm._v("NÚMERO DO CPF OU CNPJ")])]),_vm._v(" "),_c('span',[_vm._v("→")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("04")]),_vm._v(" "),_c('small',[_vm._v("CÓDIGO  DA  RECEITA")])]),_vm._v(" "),_c('span',[_vm._v("→")])])]),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v("8053")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"m-print"},[_c('strong',[_vm._v("01")]),_vm._v(" "),_c('small',[_vm._v("NOME / TELEFONE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("05")]),_vm._v(" "),_c('small',[_vm._v("NÚMERO  DE REFERÊNCIA")])]),_vm._v(" "),_c('span',[_vm._v("→")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("06")]),_vm._v(" "),_c('small',[_vm._v("DATA DE VENCIMENTO")])]),_vm._v(" "),_c('span',[_vm._v("→")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("07")]),_vm._v(" "),_c('small',[_vm._v("VALOR DO PRINCIPAL")])]),_vm._v(" "),_c('span',[_vm._v("→")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("08")]),_vm._v(" "),_c('small',[_vm._v("VALOR DA MULTA")])]),_vm._v(" "),_c('span',[_vm._v("→")])])]),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(" 0,00")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center align-middle atencao",attrs:{"rowspan":"4"}},[_c('strong',[_vm._v("ATENÇÃO")]),_vm._v(" "),_c('p',[_vm._v("É vedado o recolhimento de tributos administrados pela Secretaria da Receita Federal do Brasil (RFB) cujo valor total seja inferior a R$ 10,00. Ocorrendo tal situação, adicione esse valor  ao  tributo  de  mesmo  código  de  períodos  subseqüentes,  até que o total seja igual ou superior a R$ 10,00.")])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("09")]),_vm._v(" "),_c('small',[_vm._v("VALOR DOS JUROS E/OUENCARGOS DL - 1.025/69")])]),_vm._v(" "),_c('span',[_vm._v("→")])])]),_vm._v(" "),_c('td',{staticClass:"align-middle align-right"},[_vm._v(" 0,00")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"item"},[_c('span',[_c('strong',[_vm._v("10")]),_vm._v(" "),_c('small',[_vm._v("VALOR TOTAL")])]),_vm._v(" "),_c('span',[_vm._v("→")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"2","height":"100"}},[_c('span',{staticClass:"m-print"},[_c('strong',[_vm._v("11")]),_vm._v(" "),_c('small',[_vm._v("AUTENTICAÇÃO  BANCÁRIA  (Somente nas 1ª e 2ª vias)")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aupi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png, application/x-ofx',
      arquivos: this.solicitacao.ArquivosUltimosExtratosBancarios || []
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio dos extratos dos últimos 4 meses é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {
        var newData = {
          ArquivosUltimosExtratosBancarios: this.arquivosRecebidos
        };
        this.$emit('on-submit', newData);
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "avqu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.response)?_c('div',[_c('div',{staticClass:"row company-view"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("Investimento Social "),_c('span',[_vm._v("id#"+_vm._s(_vm.ajustIdOportunidade(_vm.impact.IdOportunidade, 5)))])])]),_vm._v(" "),_c('div',{staticClass:"back float-right"},[_c('router-link',{attrs:{"to":"/investimentos/investimento-de-impacto","title":"Voltar"}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-8"},[_c('div',{staticClass:"tit"},[_c('h2',[_vm._v(_vm._s(_vm.impact.Impacto.NomeEmpresa))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.impact.Nome)+" – "+_vm._s(_vm.impact.Impacto.Cidade)+" / "+_vm._s(_vm.impact.Impacto.UF))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.impact.Impacto.AreaEmpresa))])]),_vm._v(" "),_c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"src":_vm.impact.Impacto.VideoDetalhes,"allowfullscreen":""}})]),_vm._v(" "),_c('section',{staticClass:"entry"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor do Financiamento")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.impact.Valor)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Previsão de retorno do empréstimo")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.impact.Prazo)+" meses")])])])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.impact.Impacto.InformacaoInstitucional)}})]),_vm._v(" "),_c('section',{staticClass:"info-impact"},[_c('at-tabs',[_c('at-tab-pane',{attrs:{"label":"Campanha","name":"campanha"}},[_c('h3',[_vm._v("Palavras do(a) Empreendedor(a)")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.impact.Impacto.Campanha)}})])],1)],1)]),_vm._v(" "),_c('aside',{staticClass:"col-12 col-md-4 col-lg-4"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row no-gutters dates"},[_c('div',{staticClass:"col-12 col-sm-6"},[_c('img',{attrs:{"src":"/static/assets/images/ico-calendar_ok.svg"}}),_vm._v(" "),_c('label',[_vm._v("Início")]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.formatMongoDate(_vm.impact.InicioCaptacao)))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('img',{attrs:{"src":"/static/assets/images/ico-calendar_end.svg"}}),_vm._v(" "),_c('label',[_vm._v("Término")]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.formatMongoDate(_vm.impact.FimCaptacao)))])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('label',[_vm._v("Valor solicitado")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.impact.Valor)))])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('label',[_vm._v("Duração esperada")]),_vm._v(" "),_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.impact.Prazo)+" Meses")])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row no-gutters text-center"},[_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v(_vm._s(_vm.calcDiasRestantes()))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix itens"},[_c('span',{staticClass:"float-left"},[_vm._v("Levantado: "+_vm._s(_vm.formatCurrency(_vm.impact.ValorCaptado)))]),_vm._v(" "),_c('span',{staticClass:"float-right"},[_vm._v("Faltam: "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.calcValorRestante(_vm.impact))))])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:('width:' + _vm.calcPercValorRestante(_vm.impact) + '%'),attrs:{"role":"progressbar","aria-valuenow":"50","aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"progress-value"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.calcPercValorRestante(_vm.impact)))+"%")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"info__invest"},[_c('strong',[_vm._v(_vm._s(_vm.impact.QuantidadeReservasInvestimento))]),_vm._v(" investidores")])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row no-gutters text-center"},[(_vm.canInvest)?_c('div',{staticClass:"col-12 text-center"},[(!_vm.impact.JaInvestiu && _vm.showInputInvestment)?_c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.proximoPasso()}}},[(_vm.permiteAporte)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"valor"}},[_vm._v("Valor que deseja aportar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valorInv),expression:"valorInv"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"id":"valor","placeholder":'Investimento mínimo R$ '+ _vm.money(this.impact.InvestimentoMinimo)},domProps:{"value":(_vm.valorInv)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valorInv=$event.target.value}}})]):_vm._e(),_vm._v(" "),(this.InvestidorBloqueado())?_c('button',{staticClass:"btn btn-lg btn-danger btn-block",staticStyle:{"cursor":"not-allowed"},attrs:{"disabled":""}},[_vm._v("Bloqueado")]):_vm._e(),_vm._v(" "),(_vm.permiteAporte && !this.InvestidorBloqueado())?_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.ShowSaldo()}}},[_vm._v("Apoiar")]):_vm._e(),_vm._v(" "),(!_vm.permiteAporte && !this.InvestidorBloqueado())?_c('button',{staticClass:"btn b tn-primary btn-lg btn-block",staticStyle:{"background-color":"gray"},attrs:{"type":"button"}},[_vm._v("Encerrado")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"small"})]):_vm._e(),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInputSaldo),expression:"showInputSaldo"}]},[_c('div',{staticClass:"reinvestir"},[_c('img',{attrs:{"src":"/static/assets/images/ico-reinvestir.svg","alt":"icone reinvestir"}}),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.Nome())+", você possuí saldo em sua Carteira virtual. Gostaria de reinvestir como parte do pagamento?\n\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('label',[_vm._v("Total disponível para reinvestir")]),_vm._v(" "),_c('span',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(this.sDisponivel)))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"valor"}},[_vm._v("Valor que dejesa utilizar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valorReinvestimento),expression:"valorReinvestimento"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"id":"valor","placeholder":'Investimento mínimo R$ 100,00'},domProps:{"value":(_vm.valorReinvestimento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valorReinvestimento=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tO valor para reinvestimento não pode ser superior ao disponível em sua carteira virtual.\n\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg btn-block",on:{"click":function($event){$event.preventDefault();return _vm.UsarSaldo()}}},[_vm._v("Sim, usar saldo disponível")]),_vm._v(" "),_c('a',{staticClass:"btn btn-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.NaoUsarSaldo()}}},[_vm._v("Não utilizar saldo disponível.")])]),_vm._v(" "),(_vm.impact.JaInvestiu)?_c('div',{staticStyle:{"width":"100%"}},[_vm._m(0)]):_vm._e()]):_c('div',{staticClass:"form-row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"alert alert_reserve alert-warning text-center",staticStyle:{"width":"100%"}},[_c('h2',[_vm._v("Falta pouco para você investir")]),_vm._v(" "),_c('div',[(_vm.temCadastroInvestidor && _vm.temSuitability && !_vm.investidorAprovado)?_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v("Agora estamos analisando suas informações e retornaremos em até 1 dia útil.")]):_c('p',[(!_vm.temCadastroInvestidor)?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/informacoes-adicionais/investidor"}},[_vm._v("Complete o cadastro de investidor")]):_vm._e(),_vm._v(" "),(!_vm.temSuitability)?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/informacoes-adicionais/suitability"}},[_vm._v("Preencha o formulário de suitability")]):_vm._e()],1)])])])])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert_reserve alert-warning text-center",staticStyle:{"width":"100%"}},[_c('h2',[_vm._v("Você já efetuou um aporte para este investimento.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "axQb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "azB1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    var social = this.currentUser.Social;
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: social.ArquivoExtratos || [null]
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.arquivos.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.arquivos, index, null);
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio dos Extratos Bancários é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {

        this.currentUser.Social.ArquivoExtratos = this.arquivosRecebidos;

        this.$emit('on-submit', { Social: this.currentUser.Social });
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "b4aJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_client_go__ = __webpack_require__("879M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SocialNetwork__ = __webpack_require__("TYgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_array_helper__ = __webpack_require__("rzJh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lpUrl: "https://iouu.com.br",
      email: ''
    };
  },

  components: {
    SocialNetwork: __WEBPACK_IMPORTED_MODULE_4__components_SocialNetwork__["a" /* default */]
  },
  methods: {
    sendResePasswordtEmail: function sendResePasswordtEmail() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__utils_api_client_go__["a" /* default */].post('send-reset-password-email', { data: { email: this.email } }).then(function () {
        _this.$Notify.info('Pronto, você vai receber um e-mail com as instruções para recuperar sua senha');
        _this.email = '';
      }).catch(function (error) {
        var errorMessages = error.response.data.errors.map(function (error) {
          return error.detail;
        });
        _this.$Notify.error(__WEBPACK_IMPORTED_MODULE_5__utils_array_helper__["a" /* default */].toSentence(errorMessages));
      });
    },

    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/recuperar-senha',
        title: 'Recuperar Senha'
      });
    }
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.taggingGA();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),

/***/ "b4kQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SocialNetwork__ = __webpack_require__("TYgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PasswordField__ = __webpack_require__("i7i+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lpUrl: "https://iouu.com.br",
      password: ''
    };
  },

  components: {
    SocialNetwork: __WEBPACK_IMPORTED_MODULE_3__components_SocialNetwork__["a" /* default */], PasswordField: __WEBPACK_IMPORTED_MODULE_5__components_PasswordField__["a" /* default */]
  },
  methods: {
    setNewPassword: function setNewPassword() {
      var _this = this;

      var query = this.$route.query;
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].put('update-password', { data: { email: query.email, token: query.token, password: this.password } }).then(function () {
        _this.$router.push("/login");
        _this.$Notify.info('Sua senha foi atualizada com sucesso.');
      }).catch(function (error) {
        var errorMessages = error.response.data.errors.map(function (error) {
          return error.detail;
        });
        _this.$Notify.error(__WEBPACK_IMPORTED_MODULE_4__utils_array_helper__["a" /* default */].toSentence(errorMessages));
      });
    },
    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/nova-senha',
        title: 'NovaSenha'
      });
    }
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.taggingGA();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),

/***/ "b56G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    var pessoal = this.currentUser.Pessoal;
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: pessoal.ArquivoHolerite || [null]
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.arquivos.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.arquivos, index, null);
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do Holerite é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {

        this.currentUser.Pessoal.ArquivoHolerite = this.arquivosRecebidos;

        this.$emit('on-submit', { Pessoal: this.currentUser.Pessoal });
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "bBKy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lpUrl: "https://iouu.com.br",
      acceptContract: null,
      options: {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      },
      lat: 0,
      long: 0
    };
  },

  methods: {
    getLocation: function getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.obterLocalizacao, null, this.options);
      }
    },
    obterLocalizacao: function obterLocalizacao(position) {
      this.lat = position.coords.latitude;
      this.long = position.coords.longitude;
    },
    submit: function submit() {
      this.$emit('submit', { AceitaContratoConfidencialidade: this.acceptContract, Latitude: this.lat, Longitude: this.long });
      this.$ga.event('NewUser', 'send', 'Investidor');
    },

    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/Informacoes-adicionais/investidor',
        title: 'ConfirmacaoDeCadastroInvestidor'
      });
    }
  },
  created: function created() {
    this.getLocation();

    //tagueamento GA
    this.taggingGA();
  }
});

/***/ }),

/***/ "bEzG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fbffa9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RetentativaConfirmacaoIdentidadePasso_vue__ = __webpack_require__("SDSr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fbffa9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RetentativaConfirmacaoIdentidadePasso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bHNz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    var social = this.currentUser.Social;
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: social.ArquivoFotoIdentificacao || [null]
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.arquivos.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.arquivos, index, null);
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio da foto de identificação é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {

        this.currentUser.Social.ArquivoFotoIdentificacao = this.arquivosRecebidos;

        this.$emit('on-submit', { Social: this.currentUser.Social });
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "bJJT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinanciamentosSociosStep_vue__ = __webpack_require__("9cDm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fda7614_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinanciamentosSociosStep_vue__ = __webpack_require__("GV5C");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinanciamentosSociosStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fda7614_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinanciamentosSociosStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bNNB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinaciamentosContratadosStep_vue__ = __webpack_require__("JIu8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7547202_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinaciamentosContratadosStep_vue__ = __webpack_require__("ttus");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinaciamentosContratadosStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7547202_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinaciamentosContratadosStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bPRD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "biR9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
    metaInfo: {
        htmlAttrs: {
            lang: 'pt-br'
        },
        bodyAttrs: {
            class: 'solicita-emprestimo'
        }
    },
    props: {
        changeType: { type: Function }
    },
    data: function data() {
        return {
            lpUrl: "https://iouu.com.br",
            faturamento: '',
            value: '',
            prazo: '',
            motivo: '',
            phone: '',
            garantia: '',
            tipoPessoa: '',
            document: '',
            restricao: '',
            garantiaDetalhe: '',
            garantiaOutros: '',
            motivoDetalhe: '',
            aceite: false,
            acordos: false,
            type: this.$route.query.type,
            user: null,
            finishedLoading: false,
            hasLoan: null,
            prazos: [{
                value: 6,
                label: '6 meses'
            }, {
                value: 12,
                label: '12 meses'
            }, {
                value: 24,
                label: '24 meses'
            }, {
                value: 30,
                label: '30 meses'
            }, {
                value: 36,
                label: '36 meses'
            }],
            temGarantia: [{
                value: 'sim',
                label: 'Sim'
            }, {
                value: 'nao',
                label: 'Não'
            }],
            temRestricao: [{
                value: 'sim',
                label: 'Sim'
            }, {
                value: 'nao',
                label: 'Não'
            }],
            garantias: [{
                value: 'Imóveis',
                label: 'Imóveis'
            }, {
                value: 'Recebíveis',
                label: 'Recebíveis'
            }, {
                value: 'Veículos',
                label: 'Veículos'
            }, {
                value: 'Máquinas',
                label: 'Máquinas'
            }, {
                value: 'Equipamentos',
                label: 'Equipamentos'
            }, {
                value: 'Outros',
                label: 'Outros'
            }],
            motivoEmp: [{
                value: 'Expansão da empresa'
            }, {
                value: 'Capital de Giro'
            }, {
                value: 'Compra de estoque'
            }, {
                value: 'Refinanciamento de dívida'
            }, {
                value: 'Aquisição de máquinas e equipamentos'
            }, {
                value: 'Outros'
            }],
            tipo: [{
                value: "pessoa fisica"
            }, {
                value: "pessoa juridica"
            }]

        };
    },

    computed: {
        firstName: function firstName() {
            if (this.user.name) {
                return this.getFirstName(this.user.name);
            } else {
                return this.getFirstName(this.user.username);
            }
        },
        name: function name() {
            var n = void 0;

            if (this.user.name) {
                n = this.user.name;
            } else {
                n = this.user.username;
            }

            return n;
        },
        email: function email() {
            return this.user.email;
        },
        redirectInvestment: function redirectInvestment() {
            var newFormat = this.faturamento.split('.').join("");
            newFormat = parseFloat(newFormat.split(',').join("."));
            if (newFormat > 360000) {
                return 'collective';
            }if (newFormat > 25000) {
                return 'impact';
            }
            return 'social';
        }
    },
    methods: {
        getFirstName: function getFirstName(name) {
            var firstName = name.split(" ");

            return firstName[0];
        },
        isValid: function isValid() {
            return this.name != '' && this.document != '' && this.motivo != '' && this.garantia != '' && this.restricao != '' && this.value != '' && this.faturamento != '';
        },
        isValidMotivo: function isValidMotivo() {
            if (this.motivo === "Outros") {
                return this.motivoDetalhe != '';
            } else {
                return true;
            }
        },
        isValidGarantia: function isValidGarantia() {
            if (this.garantia === "sim") {
                return this.garantiaDetalhe != '';
            } else {
                return true;
            }
        },
        isValidGarantiaOutros: function isValidGarantiaOutros() {
            if (this.garantiaDetalhe === "Outros" && this.garantia === 'sim') {
                return this.garantiaOutros != '';
            } else {
                return true;
            }
        },
        validarCNPJ: function validarCNPJ(cnpj) {
            cnpj = cnpj.replace(/[^\d]+/g, '');

            if (cnpj == '') return false;

            if (cnpj.length != 14) return false;

            // Elimina CNPJs invalidos conhecidos
            if (cnpj == "00000000000000" || cnpj == "11111111111111" || cnpj == "22222222222222" || cnpj == "33333333333333" || cnpj == "44444444444444" || cnpj == "55555555555555" || cnpj == "66666666666666" || cnpj == "77777777777777" || cnpj == "88888888888888" || cnpj == "99999999999999") return false;

            // Valida DVs
            var tamanho = cnpj.length - 2;
            var numeros = cnpj.substring(0, tamanho);
            var digitos = cnpj.substring(tamanho);
            var soma = 0;
            var pos = tamanho - 7;
            for (var i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) pos = 9;
            }
            var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0)) return false;

            tamanho = tamanho + 1;
            numeros = cnpj.substring(0, tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (var _i = tamanho; _i >= 1; _i--) {
                soma += numeros.charAt(tamanho - _i) * pos--;
                if (pos < 2) pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1)) return false;

            return true;
        },
        validarCpf: function validarCpf(strCPF) {
            var Soma;
            var Resto;
            Soma = 0;
            if (strCPF == "00000000000") return false;

            for (var i = 1; i <= 9; i++) {
                Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
            }Resto = Soma * 10 % 11;

            if (Resto == 10 || Resto == 11) Resto = 0;
            if (Resto != parseInt(strCPF.substring(9, 10))) return false;

            Soma = 0;
            for (var _i2 = 1; _i2 <= 10; _i2++) {
                Soma = Soma + parseInt(strCPF.substring(_i2 - 1, _i2)) * (12 - _i2);
            }Resto = Soma * 10 % 11;

            if (Resto == 10 || Resto == 11) Resto = 0;
            if (Resto != parseInt(strCPF.substring(10, 11))) return false;
            return true;
        },
        verifyLastLoan: function verifyLastLoan(date) {
            var today = new Date();
            var timeStampToday = Math.round(today.getTime() / 1000);
            var h = today.getHours();
            var m = today.getMinutes();
            var s = today.getSeconds();
            var arrayDate = __WEBPACK_IMPORTED_MODULE_3__utils_masker__["a" /* default */].maskIsoDate(date).split('/');
            var objDate = new Date(arrayDate[2], arrayDate[1] - 1, arrayDate[0], h, m, s);
            var timeStampDate = Math.round(objDate.getTime() / 1000);
            var hours = (timeStampToday - timeStampDate) / 3600;
            var days = parseInt(hours / 24);
            var month = parseInt(days / 30);

            if (month >= 3) {
                return true;
            } else {
                return false;
            }
        },
        formatReal: function formatReal(num) {
            var real = void 0;
            real = parseFloat(num.replace(/[^\d]+/g, '')) / 100;
            return real;
        },
        typeLoan: function typeLoan(type) {
            var tipo = void 0;

            switch (type) {
                case 'EMPPES':
                    tipo = 'emprestimo-pessoal';
                    break;

                case 'EMPVEI':
                    tipo = 'emprestimo-veicular';
                    break;

                case 'EMIMB':
                    tipo = 'emprestimo-imobiliario';
                    break;

                case 'EMPIMP':
                    tipo = 'emprestimo-de-impacto';
                    break;

                //Novo impacto - semelhante ao coletivo
                case 'EMPIMP2':
                    tipo = 'emprestimo-de-impacto2';
                    break;

                //Novo Social, semelhante ao impacto antigo
                case 'EMPSOC':
                    tipo = 'emprestimo-social';
                    break;

                default:
                    tipo = 'emprestimo-coletivo';
                    break;
            }

            return tipo;
        },
        onSubmit: function onSubmit(e) {
            var _this = this;

            e.preventDefault();

            this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["c" /* START_LOADING */]);
            console.log("1");
            if (this.tipoPessoa === "pessoa juridica") {
                console.log("2");
                if (!this.validarCNPJ(__WEBPACK_IMPORTED_MODULE_3__utils_masker__["a" /* default */].unmaskCnpj(this.document))) {
                    console.log("3");
                    this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
                    this.$Notify.error('CNPJ inválido! Por favor, digite um CNPJ válido.');
                } else {
                    __WEBPACK_IMPORTED_MODULE_1__utils_api_client__["a" /* default */].getLoansByDocuments(__WEBPACK_IMPORTED_MODULE_3__utils_masker__["a" /* default */].unmaskCnpj(this.document), this.typeLoan(this.type)).then(function (response) {

                        console.log("4");
                        _this.hasLoan = response;
                        if (_this.hasLoan.data.length > 0) {
                            var verify = _this.verifyLastLoan(_this.hasLoan.data[0].Created);
                            console.log("5");
                            if (!verify) {
                                console.log("6");
                                _this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                _this.$Notify.error('Esté CNPJ já possui uma solicitação anterior inferior a 3 meses');
                            } else {
                                console.log("7");
                                _this.postLoan();
                            }
                        } else {
                            console.log("8");
                            _this.postLoan();
                        }
                    });
                }
            } else {

                console.log("9");
                if (!this.validarCpf(__WEBPACK_IMPORTED_MODULE_3__utils_masker__["a" /* default */].unmaskCpf(this.document))) {
                    console.log("10");
                    this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
                    this.$Notify.error('Cpf inválido! Por favor, digite um Cpf válido.');
                } else {
                    __WEBPACK_IMPORTED_MODULE_1__utils_api_client__["a" /* default */].getLoansByDocuments(__WEBPACK_IMPORTED_MODULE_3__utils_masker__["a" /* default */].unmaskCnpj(this.document), this.typeLoan(this.type)).then(function (response) {

                        console.log("11");
                        _this.hasLoan = response;
                        if (_this.hasLoan.data.length > 0) {
                            console.log("12");
                            var verify = _this.verifyLastLoan(_this.hasLoan.data[0].Created);
                            if (!verify) {
                                console.log("13");
                                _this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                _this.$Notify.error('Esté Cpf já possui uma solicitação anterior inferior a 3 meses');
                            } else {
                                console.log("14");
                                _this.postLoan();
                            }
                        } else {
                            console.log("15");
                            _this.postLoan();
                        }
                    });
                }
            }
        },
        postLoan: function postLoan() {
            var _this2 = this;

            var data = {
                'Nome': this.name,
                'TipoPessoa': this.tipoPessoa,
                'Email': this.email,
                'Documento': this.tipoPessoa === "pessoa juridica" ? __WEBPACK_IMPORTED_MODULE_3__utils_masker__["a" /* default */].unmaskCnpj(this.document) : __WEBPACK_IMPORTED_MODULE_3__utils_masker__["a" /* default */].unmaskCpf(this.document),
                'Restricao': this.restricao,
                'Garantia': this.garantia,
                'TipoGarantia': this.garantiaDetalhe === 'Outros' ? this.garantiaOutros : this.garantiaDetalhe,
                'Valor': this.formatReal(this.value),
                'Prazo': parseInt(this.prazo),
                'Motivo': this.motivo === "Outros" ? this.motivoDetalhe : this.motivo,
                'TipoEmprestimo': this.typeLoan(this.type),
                'CodProduto': this.type,
                'Faturamento': this.formatReal(this.faturamento),
                'Celular': this.phone,
                'Status': 'LIZA'
            };

            console.log("16");

            if (data.Valor <= 500 || data.Valor > 5000) {
                console.log("17");
                this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
                this.$Notify.error('O valores devem ser superiores a R$ 500,00 e de no máximo R$ 5.000,00');
            } else {
                __WEBPACK_IMPORTED_MODULE_0__utils_hub_consulta_client__["a" /* default */].createLoans(data).then(function (response) {

                    console.log("18");
                    if (response.status !== 200) {
                        console.log("19");
                        _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
                        _this2.$Notify.error('Ocorreu um erro inesperado tente novamente!');
                    } else {

                        console.log("20");
                        if (_this2.typeLoan(_this2.type) == "emprestimo-social") {
                            _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            _this2.$router.push('/emprestimos/meus-emprestimos');
                        } else {
                            console.log("21");
                            _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            _this2.$router.push('/informacoes-adicionais/' + _this2.typeLoan(_this2.type) + '/' + response.data.Msg);
                        }
                    }
                });
            }
        }
    },
    beforeCreate: function beforeCreate() {
        var _this3 = this;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["c" /* START_LOADING */]);

        __WEBPACK_IMPORTED_MODULE_1__utils_api_client__["a" /* default */].getUser().then(function (response) {

            console.log(response);
            _this3.user = response;

            _this3.finishedLoading = true;

            _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
        }).catch(function () {
            _this3.finishedLoading = true;
            _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    }
});

/***/ }),

/***/ "bojV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      optionsGenre: [{ value: 1, label: "Masculino" }, { value: 2, label: "Feminino" }]
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = { Pessoal: this.currentUser.Pessoal };
      this.$emit('on-submit', newData);
    }
  },
  mounted: function mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");
  }
});

/***/ }),

/***/ "bzuE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hub */
/* unused harmony export api_go */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return red; });
/* eslint-disable */
var hub = "https://hub-app.iouu.com.br";
var api_go = "https://api.iouu.com.br";
var red = "https://server-app.iouu.com.br/api/v1";



/***/ }),

/***/ "c/xH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("96tf");



var _this = this;


var BASE_URI_GO_API = "https://api.iouu.com.br" + '/api/v1';

var GetExtratoWallet = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/wallet/extrato');

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function GetExtratoWallet() {
        return _ref.apply(this, arguments);
    };
}();

var GetExtratoSolicitacao = function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/wallet/extrato/solicitacao');

                    case 2:
                        return _context2.abrupt('return', _context2.sent);

                    case 3:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this);
    }));

    return function GetExtratoSolicitacao() {
        return _ref2.apply(this, arguments);
    };
}();

var GetTotalInvestido = function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/wallet/total/investido');

                    case 2:
                        return _context3.abrupt('return', _context3.sent);

                    case 3:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this);
    }));

    return function GetTotalInvestido() {
        return _ref3.apply(this, arguments);
    };
}();

var GetMeusInvestimentos = function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/investidor/meus-investimentos/' + id);

                    case 2:
                        return _context4.abrupt('return', _context4.sent);

                    case 3:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, _this);
    }));

    return function GetMeusInvestimentos(_x) {
        return _ref4.apply(this, arguments);
    };
}();

var GetExtratoPaginadoWallet = function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(pagina) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/wallet/extrato/pagina/' + pagina);

                    case 2:
                        return _context5.abrupt('return', _context5.sent);

                    case 3:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, _this);
    }));

    return function GetExtratoPaginadoWallet(_x2) {
        return _ref5.apply(this, arguments);
    };
}();

var GetDetalhesOperacao = function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(id) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        _context6.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/wallet/operacao/detalhe/' + id);

                    case 2:
                        return _context6.abrupt('return', _context6.sent);

                    case 3:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, _this);
    }));

    return function GetDetalhesOperacao(_x3) {
        return _ref6.apply(this, arguments);
    };
}();

var GetSaldoWallet = function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/wallet/saldo');

                    case 2:
                        return _context7.abrupt('return', _context7.sent);

                    case 3:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, _this);
    }));

    return function GetSaldoWallet() {
        return _ref7.apply(this, arguments);
    };
}();

var GetDadosBancariosWallet = function () {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(userId) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        _context8.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/investidor/userId/' + userId);

                    case 2:
                        return _context8.abrupt('return', _context8.sent);

                    case 3:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, _this);
    }));

    return function GetDadosBancariosWallet(_x4) {
        return _ref8.apply(this, arguments);
    };
}();

var CreateTransfer = function () {
    var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dadosSaque) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        _context9.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthPut(BASE_URI_GO_API + '/wallet/agendamento/saque', dadosSaque);

                    case 2:
                        return _context9.abrupt('return', _context9.sent);

                    case 3:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, _this);
    }));

    return function CreateTransfer(_x5) {
        return _ref9.apply(this, arguments);
    };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    GetExtratoWallet: GetExtratoWallet,
    GetExtratoSolicitacao: GetExtratoSolicitacao,
    GetMeusInvestimentos: GetMeusInvestimentos,
    GetExtratoPaginadoWallet: GetExtratoPaginadoWallet,
    GetDetalhesOperacao: GetDetalhesOperacao,
    GetSaldoWallet: GetSaldoWallet,
    GetDadosBancariosWallet: GetDadosBancariosWallet,
    CreateTransfer: CreateTransfer,
    GetTotalInvestido: GetTotalInvestido
});

/***/ }),

/***/ "c5M2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");

//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			opcoes: {
				responsive: true,
				maintainAspectRatio: false,
				scales: {
					yAxes: [{
						ticks: {
							callback: function callback(valor) {
								return 'R$ ' + valor;
							}
						}
					}]
				}
			}
		};
	},

	props: {
		parcelas: {
			required: true,
			type: Array
		},
		parcelasCDI: {
			required: true,
			type: Array
		}
	},
	extends: __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["b" /* Line */],
	watch: {
		dados: function dados() {
			this.renderLineChart();
		}
	},
	computed: {
		dados: function dados() {
			if (this.parcelas != undefined && this.parcelasCDI != undefined) {
				var labels = [];
				var data = [];
				var dataCDI = [];
				this.parcelas.map(function (item) {
					labels = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(labels), ["Mês " + item.mes]);
					data = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data), [item.valorAcumulativo]);
				});
				this.parcelasCDI.map(function (item) {
					dataCDI = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(dataCDI), [item.valorAcumulativo]);
				});
				return {
					labels: labels,
					// Estilo da linha
					datasets: [{
						label: 'IOUU',
						fill: false,
						borderColor: '#41D3BD',
						backgroundColor: '#41D3BD',
						pointBorderWidth: 3,
						pointBackgroundColor: '#41D3BD',
						data: data
					}, {
						label: 'CDB',
						fill: false,
						borderColor: '#6FC30D',
						backgroundColor: '#6FC30D',
						pointBorderWidth: 3,
						pointBackgroundColor: '#6FC30D',
						data: dataCDI
					}]
				};
			}
			return '';
		}
	},
	methods: {
		renderLineChart: function renderLineChart() {
			this.renderChart(this.dados, this.opcoes);
		}
	},
	mounted: function mounted() {
		this.renderLineChart();
	}
});

/***/ }),

/***/ "c6lt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileNotific_vue__ = __webpack_require__("qeVz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb42c440_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileNotific_vue__ = __webpack_require__("L12T");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileNotific_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb42c440_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileNotific_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c6zp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var social = this.currentUser.Social;
    return {
      fullName: social.NomeCompleto !== "" ? social.NomeCompleto : this.currentUser.Nome,
      birthDate: social.DataNascimento !== "" ? social.DataNascimento : this.currentUser.DataNascimento
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    validate: function validate() {
      if (this.fullName.indexOf(" ") > 0 && this.currentUser.Social.NomeCompletoMae.indexOf(" ") > 0) {
        return { isValid: true, errors: ['É obrigatório o envio do nome completo'] };
      } else {
        return { isValid: false, errors: ['É obrigatório o envio do nome completo'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var validation = this.validate();

      if (validation.isValid) {
        this.currentUser.Social.NomeCompleto = this.fullName;
        this.currentUser.Social.DataNascimento = this.birthDate;

        //console.log(this.currentUser.Social)

        this.$emit('on-submit', { Social: this.currentUser.Social });
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_0__utils_array_helper__["a" /* default */].toSentence(validation.errors)
        });
      }
    },
    AlterarNome: function AlterarNome(event) {

      var texto = event.target.value;

      var textoFinal = "";
      texto = texto.toLowerCase();

      if (texto.length > 0) {
        textoFinal = texto.substr(0, 1).toUpperCase();

        for (var i = 1; i < texto.length; i++) {
          if (texto.substr(i - 1, 1) == " ") {
            textoFinal += texto.substr(i, 1).toUpperCase();
          } else {
            textoFinal += texto.substr(i, 1);
          }
        }
      }

      event.target.value = textoFinal;
    }
  },
  created: function created() {
    if (!this.currentUser.Social) this.currentUser.Social = {};
  }
});

/***/ }),

/***/ "cGe7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__("5dBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_masker__ = __webpack_require__("7VWg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var pessoal = this.currentUser.Pessoal;
    return {
      hasOtherIncomeSources: true,
      extra: pessoal && pessoal.ValorOutraFonteRenda ? pessoal.ValorOutraFonteRenda.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }) : null
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    noHaveOther: function noHaveOther() {
      if (document.getElementById("noOther").checked) {
        document.getElementById("extra").removeAttribute("required", "");
        this.hasOtherIncomeSources = false;
      } else {
        document.getElementById("extra").setAttribute("required", "");
        this.hasOtherIncomeSources = true;
      }
    },
    checkVerify: function checkVerify() {},
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      if (this.hasOtherIncomeSources) {
        this.currentUser.Pessoal.OutraFonteRenda = true;
        this.currentUser.Pessoal.ValorOutraFonteRenda = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].unmaskMoney(this.extra));
      } else {
        this.currentUser.Pessoal.OutraFonteRenda = false;
        this.currentUser.Pessoal.ValorOutraFonteRenda = 0.0;
      }

      this.$emit('on-submit', { Pessoal: this.currentUser.Pessoal });
    }
  },
  mounted: function mounted() {
    if (!this.currentUser.Pessoal.OutraFonteRenda) {
      document.getElementById('noOther').click();
    }
  }
});

/***/ }),

/***/ "cMGX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("xJvq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b02683ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("Tx/w");
function injectStyle (ssrContext) {
  __webpack_require__("PIau")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b02683ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b02683ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cSwh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalhesColetivo_vue__ = __webpack_require__("Z8Vr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52f76cad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalhesColetivo_vue__ = __webpack_require__("LsEF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalhesColetivo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52f76cad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalhesColetivo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cea8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[(this.perguntas.length > 0)?_c('div',[(_vm.showQuestions)?_c('div',[_vm._m(0),_vm._v(" "),_c('form',_vm._l((_vm.perguntas),function(pergunta,indicePergunta){return (indicePergunta == _vm.perguntaAtual)?_c('div',[_c('div',{staticClass:"tit"},[_c('p',[_vm._v(_vm._s(indicePergunta + 1)+" - "+_vm._s(pergunta.Question))])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('ul',{staticClass:"list-group text-left"},_vm._l((pergunta.Answers),function(resposta){return _c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.respostas[indicePergunta]),expression:"respostas[indicePergunta]"}],staticClass:"form-check-input",attrs:{"name":("respostas[" + indicePergunta + "]"),"type":"radio"},domProps:{"value":resposta,"checked":_vm._q(_vm.respostas[indicePergunta],resposta)},on:{"click":function($event){_vm.perguntaAtual += 1},"change":function($event){return _vm.$set(_vm.respostas, indicePergunta, resposta)}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"resposta"}},[_vm._v("\n                        "+_vm._s(resposta)+"\n                      ")])])])])}),0)])])]):_vm._e()}),0)]):_c('p',[_vm._v("Aguarde um momento, estamos verificando suas respostas...")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('h1',[_vm._v("Antes de prosseguirmos, só preciso que responda algumas perguntas.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "chKG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CentralCobranca_vue__ = __webpack_require__("hHOV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f4565ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CentralCobranca_vue__ = __webpack_require__("Ji9x");
function injectStyle (ssrContext) {
  __webpack_require__("GzgH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f4565ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CentralCobranca_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f4565ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CentralCobranca_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cnLk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      shouldShowTip: false,
      informacaoInstitucional: this.solicitacao.Empresa.InformacaoInstitucional
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = {
        Empresa: {
          InformacaoInstitucional: this.informacaoInstitucional
        }
      };
      this.$emit('on-submit', newData);
    }
  }
});

/***/ }),

/***/ "coxy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"Nascionalidade"}},[_vm._v("Nascionalidade")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","required":"required","placeholder":"Selecione..."},model:{value:(_vm.currentUser.Pessoal.Nascionalidade),callback:function ($$v) {_vm.$set(_vm.currentUser.Pessoal, "Nascionalidade", $$v)},expression:"currentUser.Pessoal.Nascionalidade"}},_vm._l((_vm.optionsNacionality),function(nacionality,index){return _c('at-option',{key:("nacionalityOptions" + index),attrs:{"value":nacionality.value}},[_vm._v(_vm._s(nacionality.label))])}),1)],1),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Nascionalidade")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "csXd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{staticClass:"float-left",attrs:{"for":"valor-divida-bancaria"}},[_vm._v("Número")]),_vm._v(" "),_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"mask",rawName:"v-mask",value:('integer'),expression:"'integer'"},{name:"model",rawName:"v-model",value:(_vm.NumeroInscricaoEstadual),expression:"NumeroInscricaoEstadual"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"","required":""},domProps:{"value":(_vm.NumeroInscricaoEstadual)},on:{"input":function($event){if($event.target.composing){ return; }_vm.NumeroInscricaoEstadual=$event.target.value}}})]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Qual é o número da inscrição estadual da empresa?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cssz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var NumeroInscricaoEstadual = this.solicitacao.Empresa.NumeroInscricaoEstadual;
    return {
      NumeroInscricaoEstadual: NumeroInscricaoEstadual
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = {
        Empresa: {
          NumeroInscricaoEstadual: this.NumeroInscricaoEstadual
        }
      };
      this.$emit('on-submit', newData);
    }
  }
});

/***/ }),

/***/ "d/g1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid login"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"ico-iouu",attrs:{"href":_vm.lpUrl,"target":"_blank","title":"IOUU"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('social-network')],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-7 d-flex flex-column form"},[_c('header',{staticClass:"align-self-center align-self-md-end"},[_vm._v("\n        Já tem uma conta?\n        "),_c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":"login"}},[_vm._v("Entrar")])],1),_vm._v(" "),_c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-5 text-center"},[_c('h2',[_vm._v("Escolha uma senha")]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Insira uma senha para entrar.")]),_vm._v(" "),_c('form',{attrs:{"id":"form-criar-senha"},on:{"submit":function($event){$event.preventDefault();return _vm.signUp($event)}}},[_c('input',{attrs:{"id":"name","type":"hidden","name":"firstname"},domProps:{"value":this.name}}),_vm._v(" "),_c('input',{attrs:{"id":"email","type":"hidden","name":"email"},domProps:{"value":this.email}}),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Senha")]),_vm._v(" "),_c('password-field',{attrs:{"id":"Password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('div',{staticClass:"form-check text-left d-flex justify-content-center"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enabled),expression:"enabled"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.enabled)?_vm._i(_vm.enabled,null)>-1:(_vm.enabled)},on:{"change":function($event){var $$a=_vm.enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.enabled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.enabled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.enabled=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_c('label',{staticClass:"form-check-label p-0"},[_vm._v("\n                Eu \"CONCORDO\" com os "),_c('a',{attrs:{"href":_vm.lpUrl+'/termos-e-condicoes/',"target":"_blank"}},[_vm._v("Termos e condições")]),_vm._v(" e "),_c('a',{attrs:{"href":_vm.lpUrl+'/politica-de-privacidade/',"target":"_blank"}},[_vm._v("Política de privacidade")]),_vm._v(" da IOUU.\n              ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"submit","disabled":!_vm.enabled || !_vm.EmailConfirmado}},[_vm._v("Entrar")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-lg-10 d-flex flex-column align-items-center"},[_c('h1',[_vm._v("Existe uma maneira melhor de investir...")]),_vm._v(" "),_c('p',[_vm._v("\n            Você mesmo consegue administrar seus investimentos e escolher o melhor lugar para colocar o seu dinheiro. \n            Encontre a melhor oportunidade para seu crescimento.\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dCMv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finishedLoading)?_c('div',[_c('div',{staticClass:"notificacoes"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"float-left title"},[_c('h1',[_vm._v("Notificações")]),_vm._v(" "),(_vm.IsInvestidor())?_c('router-link',{staticClass:"btn btn-secondary",attrs:{"to":{path:'perfil/configuracoes'}}},[_vm._v("Editar suas Configurações")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"back float-right"},[_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar\n\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),(_vm.notificacoes.length > 0)?_c('div',{staticClass:"row list-notifications"},[_vm._l((_vm.notificationsAux),function(notificacao){return _c('div',{staticClass:"col-12"},[_c('router-link',{attrs:{"to":_vm.formatUrl(notificacao.Url),"title":notificacao.Titulo,"event":''},nativeOn:{"click":function($event){$event.preventDefault();return _vm.changeStatus(notificacao._id, notificacao.Url)}}},[_c('div',{staticClass:"item",class:_vm.verifyStatus(notificacao.Status)},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-5 col-lg-5 title"},[(notificacao.Tipo === 'Pagamento')?_c('span',{staticClass:"icon icon-coin rounded-circle",class:_vm.verifyStatus(notificacao.Status)}):(notificacao.Tipo === 'Solicitacao')?_c('span',{staticClass:"icon icon-doc rounded-circle",class:_vm.verifyStatus(notificacao.Status)}):(notificacao.Tipo === 'Boleto')?_c('span',{staticClass:"icon icon-bar rounded-circle",class:_vm.verifyStatus(notificacao.Status)}):_c('span',{staticClass:"icon icon-infos rounded-circle",class:_vm.verifyStatus(notificacao.Status)}),_vm._v(" "),_c('div',[_c('h5',[_vm._v(_vm._s(notificacao.Titulo))]),_vm._v(" "),_c('p',[_c('span',[_vm._v(_vm._s(_vm.convertDate(notificacao.Created,notificacao.Updated, notificacao.Status)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-7 col-lg-7"},[_c('div',{staticClass:"entry"},[_c('p',[_vm._v(_vm._s(notificacao.Descricao))])])])])])])],1)}),_vm._v(" "),_c('Pagination',{attrs:{"paginasTotais":this.pags,"paginaAtual":this.indexPage,"navigate":function (route){ return this$1.pagination(route-1); }}})],2):_c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard"},[_vm._m(0)])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard__complete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Você ainda não possui nenhuma notificação")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dEjR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dGg6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_centralCobranca__ = __webpack_require__("4O7e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_reservaInvestimento__ = __webpack_require__("FGQr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__ = __webpack_require__("Du/2");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// CODIGOS DE STATUS
// ed - em dia
// 15 - 15dias de atraso
// 30 - 30 dias de atraso
// 60 - 60 dias de atraso
// m60 - mais de 60 dias
// ngt - negativado
// cej - cobranca extra judicial
// cj - cobranca judicial
// rng - renegociada







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            regua: true,
            solicitacaoID: '',
            id: '',
            investidor: {},
            solicitacao: {},
            reserva: {},
            notificacoes: []
        };
    },

    methods: {
        abrirDoc: function abrirDoc(doc) {

            window.open("https://hub-app.iouu.com.br" + "/file/" + doc);
        },
        solicitacaoProcesso: function solicitacaoProcesso() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2__services_api_centralCobranca__["a" /* default */].GetDetalheSolicitacaoProcesso(_this.solicitacaoID);

                            case 2:
                                _ref = _context.sent;
                                data = _ref.data;


                                console.log("data --> ", data);

                                if (data) {

                                    _this.solicitacao = data;
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        notificacoesProcesso: function notificacoesProcesso() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _ref2, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2__services_api_centralCobranca__["a" /* default */].GetDetalheNotificacoesProcesso(_this2.solicitacaoID);

                            case 2:
                                _ref2 = _context2.sent;
                                data = _ref2.data;


                                console.log("notificacao --> ", data);

                                if (data) {

                                    _this2.notificacoes = data;
                                }

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        reservaId: function reservaId() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var _ref3, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_3__services_api_reservaInvestimento__["a" /* default */].GetReservaId(_this3.solicitacaoID);

                            case 2:
                                _ref3 = _context3.sent;
                                data = _ref3.data;


                                console.log("Reserva --> ", data);

                                if (data) {

                                    _this3.reserva = data;
                                }

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        abreviaStatus: function abreviaStatus(status) {

            switch (status) {
                case "Emdia":
                    return 'ed';
                case "15 dias":
                    return "15";
                case "Negativado":
                    return "ngt";
                case "Protesto":
                    return "pto";
                case "Cobrancaextrajudicial":
                    return "cej";
                case "Cobrancajudicial":
                    return "cj";
                case "Renegociada":
                    return "rng";
            }
        },
        formataStatus: function formataStatus(status) {

            switch (status) {
                case "Emdia":
                    return 'Em dia';
                case "15 dias":
                    return "1 a 15 dias";
                case "Negativado":
                    return "Negativado";
                case "Protesto":
                    return "Protesto";
                case "Cobrancaextrajudicial":
                    return "Cobrança extrajudicial";
                case "Cobrancajudicial":
                    return "Cobrança judicial";
                case "Renegociada":
                    return "Renegociada";
            }
        },
        formatarScore: function formatarScore(score) {

            if (score == null) return "-";

            if (score.length > 1 && !isNaN(score[1])) {
                return score[0];
            }

            return score == "" ? "-" : score;
        },
        formatarAtraso: function formatarAtraso(dataVenc) {
            if (dataVenc == '0001-01-02T00:00:00Z') {
                return 0;
            }

            var dataHoje = new Date();
            var vencimento = new Date(dataVenc);
            var atraso = void 0,
                diff = void 0;

            if (vencimento == null || vencimento > dataHoje) {
                atraso = 0;
            } else {
                diff = Math.abs(dataHoje.getTime() - vencimento.getTime());
                atraso = Math.ceil(diff / (1000 * 3600 * 24));
            }

            return atraso;
        },
        formatarPorcentagem: function formatarPorcentagem(dataVenc) {

            var dataHoje = new Date();
            var vencimento = new Date(dataVenc);
            var atraso = void 0,
                diff = void 0,
                porcentagem = void 0;

            if (dataVenc == '0001-01-02T00:00:00Z' || vencimento == null || vencimento > dataHoje) {
                porcentagem = 100;
            } else {

                diff = Math.abs(dataHoje.getTime() - vencimento.getTime());
                atraso = Math.ceil(diff / (1000 * 3600 * 24));

                porcentagem = 100 - atraso * 100 / 120;
            }
            return porcentagem;
        },
        isActive: function isActive(valor, dataVenc) {

            var atraso = this.formatarAtraso(dataVenc);

            if (valor <= atraso) return 'active';
        },
        formataEmprestimo: function formataEmprestimo(tipo) {

            if (tipo == "emprestimo-ccb") {
                return "Empréstimo CCB";
            }
            if (tipo == "emprestimo-coletivo") {
                return "Empréstimo Coletivo";
            }

            if (tipo == "emprestimo-de-impacto" || tipo == "emprestimo-de-impacto2") {
                return "Empréstimo de Impacto";
            }

            if (tipo == "veiculo-em-garantia") {
                return "Empréstimo com Garantia Veicular";
            }

            if (tipo == "imovel-em-garantia") {
                return "Empréstimo com Garantia Imobiliária";
            }

            if (tipo == "antecipacao-recebiveis") {
                return "Antecipação de Recebíveis";
            }
        },
        formatarCnpj: function formatarCnpj(cnpj) {

            return __WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].maskCnpj(cnpj);
        },
        formataData: function formataData(date) {

            var spliter = date.split("T");
            var newDate = spliter[0].split('-');
            var time = spliter[1].split(':');

            return newDate[2] + '/' + newDate[1] + '/' + newDate[0];
        },


        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/central-de-cobranca/status-cobranca',
                title: 'VisualizarStatusCobranca'
            });
        }
    },
    created: function created() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:

                            _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["c" /* START_LOADING */]);

                            _this4.solicitacaoID = _this4.$route.query.id;

                            _context4.next = 4;
                            return _this4.solicitacaoProcesso();

                        case 4:
                            _context4.next = 6;
                            return _this4.notificacoesProcesso();

                        case 6:
                            _context4.next = 8;
                            return _this4.reservaId();

                        case 8:

                            _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);

                            //tagueamento GA
                            _context4.next = 11;
                            return _this4.taggingGA();

                        case 11:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    }
});

/***/ }),

/***/ "dTcB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      occupations: [{ value: 1, label: 'Empregado Com carteira assinada' }, { value: 2, label: 'Autônomo/Profissional liberal' }, { value: 3, label: 'Empregado Sem carteira assinada' }, { value: 4, label: 'Empregador' }, { value: 5, label: 'Funcionário público' }, { value: 6, label: 'Aposentado/Pensionista' }, { value: 7, label: 'Empregado doméstico' }, { value: 8, label: 'Rentista' }, { value: 9, label: 'Estudante' }]
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = { Pessoal: this.currentUser.Pessoal };
      this.$emit('on-submit', newData);
    }
  },
  mounted: function mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");
  }
});

/***/ }),

/***/ "dck0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dgb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletPagamento_vue__ = __webpack_require__("4MNs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dff73ade_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletPagamento_vue__ = __webpack_require__("rDa/");
function injectStyle (ssrContext) {
  __webpack_require__("xjz2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dff73ade"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletPagamento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dff73ade_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletPagamento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dhL7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CCBInvestor_vue__ = __webpack_require__("JSut");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_016ccb08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CCBInvestor_vue__ = __webpack_require__("aBmJ");
function injectStyle (ssrContext) {
  __webpack_require__("oW/d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-016ccb08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CCBInvestor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_016ccb08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CCBInvestor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ds0P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var AvaliacaoRisco = this.suitability.AvaliacaoRisco;
    return {
      RendaFixa: AvaliacaoRisco ? AvaliacaoRisco.RendaFixa : null,
      FundosMultimercados: AvaliacaoRisco ? AvaliacaoRisco.FundosMultimercados : null,
      RendaVariavel: AvaliacaoRisco ? AvaliacaoRisco.RendaVariavel : null,
      FundosImobiliarios: AvaliacaoRisco ? AvaliacaoRisco.FundosImobiliarios : null,
      Derivativos: AvaliacaoRisco ? AvaliacaoRisco.Derivativos : null,
      ExpectativaAtrativos: AvaliacaoRisco ? AvaliacaoRisco.ExpectativaAtrativos : null,
      Conforto: AvaliacaoRisco ? AvaliacaoRisco.Conforto : null,
      Expectativa: AvaliacaoRisco ? AvaliacaoRisco.Expectativa : null,
      Formacao: AvaliacaoRisco ? AvaliacaoRisco.Formacao : null
    };
  },

  props: {
    suitability: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      this.$emit('on-submit', {
        AvaliacaoRisco: {
          RendaFixa: this.RendaFixa,
          FundosMultimercados: this.FundosMultimercados,
          RendaVariavel: this.RendaVariavel,

          FundosImobiliarios: this.FundosImobiliarios,
          Derivativos: this.Derivativos,
          ExpectativaAtrativos: this.ExpectativaAtrativos,
          Conforto: this.Conforto,
          Expectativa: this.Expectativa,
          Formacao: this.Formacao
        }
      });
    },
    verificaPreenchimento: function verificaPreenchimento() {
      var retorno = this.RendaFixa == null || this.FundosMultimercados == null || this.RendaVariavel == null;
      retorno = retorno || this.FundosImobiliarios == null || this.Derivativos == null || this.ExpectativaAtrativos == null || this.Conforto == null;
      retorno = retorno || this.Expectativa == null || this.Formacao == null;

      return retorno;
    }
  },
  mounted: function mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
});

/***/ }),

/***/ "dtCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',[_c('div',{staticClass:"form-group"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Comprovante de Renda")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Extrato Bancário")]),_vm._v(" dos últimos 90 dias")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dzqL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyProfileOld_vue__ = __webpack_require__("ia75");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47758d28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyProfileOld_vue__ = __webpack_require__("nsmI");
function injectStyle (ssrContext) {
  __webpack_require__("Qxnd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47758d28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyProfileOld_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47758d28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyProfileOld_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eAvX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    var pessoal = this.currentUser.Pessoal;
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: pessoal.ArquivoExtratoBancario || [null]
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.arquivos.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.arquivos, index, null);
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do Extrato é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {

        this.currentUser.Pessoal.ArquivoExtratoBancario = this.arquivosRecebidos;

        this.$emit('on-submit', { Pessoal: this.currentUser.Pessoal });
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "eOfs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WalletExtratoListaItem_vue__ = __webpack_require__("FOKo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        operacoes: { type: Array }
    },

    components: {
        'item': __WEBPACK_IMPORTED_MODULE_0__WalletExtratoListaItem_vue__["a" /* default */]
    },

    methods: {
        // async AbrirCollapse(id) {
        //     // 		// função de ajuste emergencial no css
        //     // 		isAbrir ? document.querySelector('.main-content').style.zIndex = 10 : document.querySelector('.main-content').style.zIndex = 2

        //     // 		if (document.getElementsByTagName("main").length > 0) {
        //     // 			if (isAbrir) document.getElementsByTagName("main")[0].style.zIndex = "50";
        //     // 			else document.getElementsByTagName("main")[0].style.zIndex = "0";
        //     // 		}

        //     //         this.showModal = isAbrir;

        //     //   let el = document.getElementById(`collapse${id}`);

        //     //   let classAct = el.classList.contains('collapse.show');

        //     //   if(classAct) el.classList.remove('collapse.show');

        //     //   else el.classList.add('collapse.show');

        //     let detalhesOperacao;

        //     $(".collapse").collapse("hide");
        //     $(".active").removeClass("active");
        //     $(`#collapse${id}`).collapse("toggle");

        //     if(id != this.lastID) {

        //         $(`#collapseLink${id}`).addClass("active");

        //         this.operacoes[id].loadingInformation = true;
        //         detalhesOperacao = await ApiClient.getCarteiraItem(this.operacoes[id].id);
        //         this.operacoes[id].loadingInformation = false;
        //         this.operacoes[id].Detalhes.Pagamento = detalhesOperacao.data.Detalhes.Pagamento;

        //         this.lastID = id;

        //     }


        // },
    }
});

/***/ }),

/***/ "eOnu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extra),expression:"extra"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"id":"extra","type":"text","placeholder":"R$","required":""},domProps:{"value":(_vm.extra)},on:{"input":function($event){if($event.target.composing){ return; }_vm.extra=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-check d-flex justify-content-center"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":"noOther"},on:{"click":_vm.noHaveOther}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"noOther"}},[_vm._v("Não possuo outra fonte de renda!")])]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Renda Adicional")]),_vm._v(" "),_c('p',[_vm._v("Você possui outra fonte de renda?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eOrP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eQY7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      razaoSocial: this.solicitacao.Empresa.RazaoSocial
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    submitWithAccountant: function submitWithAccountant() {
      this.$emit('on-submit', { Empresa: { TemContador: true } });
    },
    submitWithoutAccountant: function submitWithoutAccountant() {
      this.$emit('on-submit', { Empresa: { TemContador: false, Contador: null } });
    }
  }
});

/***/ }),

/***/ "eSYy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('a',{staticClass:"collapseLink item--head row align-items-center no-gutters",attrs:{"id":("collapseLink" + _vm.index)},on:{"click":function($event){return _vm.AbrirCollapse(_vm.index)}}},[_c('div',{staticClass:"col-12 col-md-8"},[_c('div',{staticClass:"date"},[_c('span',[_vm._v(_vm._s(_vm.dataDia))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.formatadoMesEAno))])]),_vm._v(" "),_c('div',{staticClass:"action"},[(_vm.registroCancelado)?_c('div',[_c('strike',[(_vm.tipo == 'PAGAMENTO')?[_c('span',[_vm._v(_vm._s(_vm.nomeEmpresa)+" - ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.tipo))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.descricao))])]:(_vm.tipo == 'EXTORNO')?[_c('span',[_vm._v(" ESTORNO ")]),_vm._v(" "),_c('small',[_vm._v(" Estorno de valor do investimento ")])]:(_vm.tipo == 'INVESTIMENTO' && _vm.descricao == 'Investimento realizado')?[_c('span',[_vm._v(" RESERVA DE INVESTIMENTO ")]),_vm._v(" "),_c('small',[_vm._v(" "+_vm._s(_vm.descricao)+" ")])]:[_c('span',[_vm._v(_vm._s(_vm.tipo))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.descricao))])]],2)],1):_c('div',[(_vm.tipo == 'PAGAMENTO')?[_c('span',[_vm._v(_vm._s(_vm.nomeEmpresa)+" - ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.tipo))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.descricao))])]:(_vm.tipo == 'EXTORNO')?[_c('span',[_vm._v(" ESTORNO ")]),_vm._v(" "),_c('small',[_vm._v(" Estorno de valor do investimento ")])]:(_vm.tipo == 'INVESTIMENTO' && _vm.descricao == 'Investimento realizado')?[_c('span',[_vm._v(" RESERVA DE INVESTIMENTO ")]),_vm._v(" "),_c('small',[_vm._v(" "+_vm._s(_vm.descricao)+" ")])]:[_c('span',[_vm._v(_vm._s(_vm.tipo))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.descricao))])]],2)])]),_vm._v(" "),(_vm.registroCancelado)?_c('div',{staticClass:"col-12 col-md-4 text-left text-md-right"},[_c('strike',[_c('span',{staticClass:"valor",class:_vm.classeItem},[_vm._v("R$ "+_vm._s(_vm.formatadoValor))])])],1):_c('div',{staticClass:"col-12 col-md-4 text-left text-md-right"},[_c('span',{staticClass:"valor",class:_vm.classeItem},[_vm._v("R$ "+_vm._s(_vm.formatadoValor))])])]),_vm._v(" "),_c('div',{staticClass:"collapse item--info",attrs:{"id":("collapse" + _vm.index)}},[_c('WalletDetalhe',{attrs:{"operacao":_vm.item}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eXr5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loanRequest != 'undefined' && _vm.carregado)?_c('div',[(!_vm.loanRequest.Encerrado)?_c('div',[(_vm.canInvest)?_c('div',[_c('div',{staticClass:"row no-gutters text-center"},[_c('div',{staticClass:"col-12 text-center"},[(this.indiceShowForm == 0)?_c('div',{staticClass:"alert alert_reserve alert-warning text-center",attrs:{"role":"alert"}},[_c('h2',[_vm._v("Tem interesse em investir nesta empresa?")]),_vm._v(" "),_c('div',[_vm._m(0),_vm._v(" "),_c('a',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.abreModal()}}},[_vm._v("LISTA DE ESPERA")])])]):_vm._e(),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(this.indiceShowForm == 1),expression:"this.indiceShowForm == 1"}]},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"valor"}},[_vm._v("Deseja investir nesta empresa?")]),_vm._v(" "),(!this.TemLimitadorMaximoInvestimento(_vm.loanRequest.InvestimentoMaximo))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valorInvestimento),expression:"valorInvestimento"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"id":"valor","placeholder":'Investimento mínimo de R$ ' + _vm.formatCurrency(_vm.loanRequest.InvestimentoMinimo)},domProps:{"value":(_vm.valorInvestimento)},on:{"keyup":function($event){return _vm.CalculaInformacoesGerais()},"click":function($event){return _vm.MostrarRelatorio()},"input":function($event){if($event.target.composing){ return; }_vm.valorInvestimento=$event.target.value}}}):_vm._e()])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(this.indiceShowForm == 1),expression:"this.indiceShowForm == 1"}]},[(this.InvestidorBloqueado())?_c('button',{staticClass:"btn btn-lg btn-danger btn-block",staticStyle:{"cursor":"not-allowed"},attrs:{"disabled":""}},[_vm._v("Bloqueado")]):_vm._e(),_vm._v(" "),(!this.InvestidorBloqueado())?_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"id":"btnInvestir"},on:{"click":function($event){$event.preventDefault();return _vm.abreModal()}}},[_vm._v(_vm._s(_vm.investmentId ? 'Alterar Valor' : 'Investir'))]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.indiceShowForm == 3),expression:"this.indiceShowForm == 3"}],staticClass:"confirm"},[_c('img',{attrs:{"src":"/static/assets/images/ico-confirm.svg","alt":"icone de confirmação"}}),_vm._v(" "),_c('p',[_vm._v("\n              Investimento registrado com sucesso.\n              "),_c('br'),_vm._v(" "),(this.Status==2)?_c('small',[_vm._v("\n                Parabéns, você entrou na lista de espera. Caso tenhamos alguma desistência, você será chamado para confirmar o seu investimento e receberá as instruções por e-mail.\n              ")]):(!_vm.investmentPaid)?_c('small',[_vm._v("\n                Pagamento já realizado! Seu investimento foi gerado com sucesso e enviado para o seu e-mail, assim como as informações referentes ao seu investimento.\n              ")]):_c('small',[_vm._v("\n                Seu boleto bancário já foi gerado com sucesso e enviado para o seu e-mail, assim como as informações referentes ao seu investimento.\n              ")]),_vm._v(" "),_c('span',[(_vm.investmentPaid)?_c('a',{staticClass:"btn btn-danger btn-lg btn-block",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.abreModal()}}},[_vm._v("Cancelar investimento")]):_vm._e()])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.indiceShowForm == 4),expression:"this.indiceShowForm == 4"}],staticClass:"confirm"},[_vm._m(1)]),_vm._v(" "),(_vm.verificaMsg2())?_c('p',{staticClass:"small"},[_vm._v("\n            **Ao confirmar o seu investimento, o boleto é gerado imediatamente e o pagamento do valor investido deve ser realizado em até 24 horas.\n          ")]):_c('p',{staticClass:"small"},[_vm._v("\n            **Caso você seja chamado pela lista de reserva, você receberá as instruções por e-mail e o pagamento do valor investido deve ser realizado em 24 horas.\n          ")])])])]):_c('div',{staticClass:"alert alert_reserve alert-warning text-center"},[_c('h2',[_vm._v("Falta pouco para você investir")]),_vm._v(" "),_c('div',[(_vm.hasInvestor && _vm.hasSuitability && !_vm.isInvestorApproved)?_c('p',[_vm._v("Agora estamos analisando suas informações e retornaremos em até 1 dia útil.")]):_c('p',[(!_vm.hasInvestor)?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/informacoes-adicionais/investidor"}},[_vm._v("Complete o cadastro de investidor")]):_vm._e(),_vm._v(" "),(!_vm.hasSuitability)?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/informacoes-adicionais/suitability"}},[_vm._v("Preencha o formulário de suitability")]):_vm._e()],1)])])]):_c('div',[_vm._m(2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"queue-message-paragraph"},[_c('strong',[_vm._v("Clique no botão")]),_vm._v(" abaixo e coloque sua oferta na lista de espera. Enquanto estamos esperando a transferência\n                de recursos você ainda pode ser um dos investidores.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n              Oportunidade encerrada:\n              "),_c('br'),_vm._v(" "),_c('small',[_vm._v("\n                Sua reserva de investimento foi realizada com sucesso. Efetue o pagamento do boleto enviado para o seu e-mail para confirmar o seu investimento ou clique abaixo para cancelar sua reserva.\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert_reserve alert-dark text-center",attrs:{"role":"alert"}},[_c('h2',{staticStyle:{"color":"#555"}},[_vm._v("Oportunidade encerrada")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ebT2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_date_helper__ = __webpack_require__("Td74");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Simulation__ = __webpack_require__("OQDv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Investment__ = __webpack_require__("sgy8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			valor: '0',
			alterado: false,
			solicitacao: this.solicitacaoProps,
			antecipacaoGambiarra: false,
			taxaGambiarra: 5.26,
			CDIGambiarra: 641.46
		};
	},

	components: {
		Simulation: __WEBPACK_IMPORTED_MODULE_4__Simulation__["a" /* default */],
		Investment: __WEBPACK_IMPORTED_MODULE_5__Investment__["a" /* default */]
	},
	props: {
		valorInicial: { type: String },
		solicitacaoProps: { type: Object },
		investidor: { type: Object },
		usuario: { type: Object }
	},
	computed: {
		totalEmprestimos: function totalEmprestimos() {
			return this.formataValor(this.solicitacao.Prazo * Math.floor(this.solicitacao.ValorParcela * 100) / 100);
		},
		CDI: function CDI() {
			return this.solicitacao.CDI != undefined ? this.solicitacao.CDI : this.solicitacao.Cdi;
		}
	},
	methods: {
		verificaProduto: function verificaProduto(produto) {

			if (produto != "EMPRES") {
				return true;
			}

			return false;
		},

		// Ação
		AtualizaSolicitacao: function AtualizaSolicitacao(atualizacao) {
			this.alterado = true;
			this.solicitacao = atualizacao;
		},
		AtualizaValor: function AtualizaValor(valor) {
			this.valor = valor;
		},

		// Metodos de formatacao
		caixaBaixa: function caixaBaixa(texto) {
			if (texto == null || texto == undefined) return "";

			if (texto == "AA" || texto == "HR") return texto.toLowerCase();

			return texto.substr(0, 1).toLowerCase();
		},
		formataPorcentagem: function formataPorcentagem(valor, valorCaptado, listaEspera) {
			// confere se solicitacao está em lista de espera
			listaEspera ? valorCaptado = valor : '';
			return (valorCaptado * 100 / valor).toFixed(2);
		},
		valorRestante: function valorRestante(valor, reservado, listaEspera) {
			var valorAdequado = (valor - reservado) * 100;
			return listaEspera ? 'R$ 0,00' : 'R$ ' + __WEBPACK_IMPORTED_MODULE_2__utils_masker__["a" /* default */].maskMoney(valorAdequado.toString());
		},
		formataValor: function formataValor(valor) {
			var valorAdequado = (valor * 100).toFixed();
			return 'R$ ' + __WEBPACK_IMPORTED_MODULE_2__utils_masker__["a" /* default */].maskMoney(valorAdequado.toString());
		},
		formataData: function formataData(data) {
			return __WEBPACK_IMPORTED_MODULE_3__utils_date_helper__["a" /* default */].formataDataString(data);
		},
		cidadeUf: function cidadeUf(endereco) {
			return endereco.Cidade + ' / ' + endereco.Uf;
		},
		ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
			var s = String(id);
			while (s.length < (qtd || 2)) {
				s = "0" + s;
			}
			return s;
		},
		formatarTipoEmprestimo: function formatarTipoEmprestimo(tipoEmprestimo) {

			if (tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2") {
				return "Impacto";
			}

			var splitedTipoEmprestimo = tipoEmprestimo.split('-');

			if (splitedTipoEmprestimo.length > 1) {
				if (splitedTipoEmprestimo[1] == "ccb") return splitedTipoEmprestimo[1].toUpperCase();

				return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
			}

			return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);
		}
	},
	created: function created() {
		if (this.solicitacaoProps._id === "5e9de72f796877415093cb1d" || this.solicitacaoProps._id === "5ea348604e46501f80f6641f") this.antecipacaoGambiarra = true;
	}
});

/***/ }),

/***/ "ecPH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyLoans_vue__ = __webpack_require__("OANR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60355961_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyLoans_vue__ = __webpack_require__("zdor");
function injectStyle (ssrContext) {
  __webpack_require__("2ha3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyLoans_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60355961_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyLoans_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eh7W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eiIm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstitutionalInformationStep_vue__ = __webpack_require__("cnLk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3528b8d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstitutionalInformationStep_vue__ = __webpack_require__("T73t");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstitutionalInformationStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3528b8d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstitutionalInformationStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ev1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var newData = {
        Pessoal: this.currentUser.Pessoal
      };
      this.$emit('on-submit', newData);
    }
  },
  created: function created() {
    if (!this.currentUser.Pessoal.Endereco) this.currentUser.Pessoal.Endereco = {};
  }
});

/***/ }),

/***/ "evNu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{staticClass:"float-left"},[_vm._v("Faturamento Mensal")]),_vm._v(" "),_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.faturamentoMensal),expression:"faturamentoMensal"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"R$","required":""},domProps:{"value":(_vm.faturamentoMensal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.faturamentoMensal=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":_vm.faturamentoValido}},[_vm._v("Próximo"),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Quanto sua empresa fatura por mês?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eye1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_563d31b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialNetworkDashboard_vue__ = __webpack_require__("/j5e");
function injectStyle (ssrContext) {
  __webpack_require__("EM27")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-563d31b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_563d31b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialNetworkDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f14v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectArea_vue__ = __webpack_require__("g1op");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b269b0c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectArea_vue__ = __webpack_require__("l16d");
function injectStyle (ssrContext) {
  __webpack_require__("AEKb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b269b0c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectArea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b269b0c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectArea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f3CH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_vm._m(0),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"rendaMensal"}},[_vm._v("Renda mensal aprox. (R$) *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rendaMensal),expression:"rendaMensal"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"tabindex":"1","id":"rendaMensal","type":"text","required":"","placeholder":"Renda mensal"},domProps:{"value":(_vm.rendaMensal)},on:{"keyup":_vm.validaRenda,"input":function($event){if($event.target.composing){ return; }_vm.rendaMensal=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"patriAprox"}},[_vm._v("Patrimônio aprox. (R$) *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.patrimonio),expression:"patrimonio"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"tabindex":"2","id":"patriAprox","type":"text","required":"","placeholder":"Patrimônio"},domProps:{"value":(_vm.patrimonio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.patrimonio=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-12 col-md-12 text-center",on:{"click":function($event){_vm.showModal = true}}},[_c('p',{staticClass:"link",staticStyle:{"color":"#41D3BD"}},[_vm._v("Você é uma Pessoa Politicamente Exposta?")])]),_vm._v(" "),(_vm.showModal)?_c('modal',{staticClass:"modal-invited",on:{"close":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h3',[_vm._v("\n\t\t\t\t\t\t\t\tO que é ser um PPE (Pessoa Politicamente Exposta - PPE)?\n\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("\n\t\t\t\t\t\t\t\tConsideram-se pessoas politicamente expostas os\n\t\t\t\t\t\t\t\tagentes públicos que desempenham ou tenham\n\t\t\t\t\t\t\t\tdesempenhado, nos cinco anos anteriores, no\n\t\t\t\t\t\t\t\tBrasil ou em países, territórios e dependências\n\t\t\t\t\t\t\t\testrangeiros, cargos, empregos ou funções\n\t\t\t\t\t\t\t\tpúblicas relevantes, assim como seus\n\t\t\t\t\t\t\t\trepresentantes, familiares e outras pessoas de\n\t\t\t\t\t\t\t\tseu relacionamento próximo, conforme definido\n\t\t\t\t\t\t\t\tpela ENCLA (Estratégia Nacional de Combate à\n\t\t\t\t\t\t\t\tCorrupção e à Lavagem de Dinheiro).\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("Fonte: "),_c('a',{staticClass:"link",attrs:{"href":"https://pt.wikipedia.org/wiki/Pessoas_politicamente_expostas","target":"_blank"}},[_vm._v("Pessoas politicamente expostas")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-12 align-self-center text-center",staticStyle:{"padding-bottom":"30px"}},[_c('div',{staticClass:"form-check form-check-inline"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pessoaPoliticamenteExposta),expression:"pessoaPoliticamenteExposta"}],staticClass:"form-check-input",attrs:{"tabindex":"3","type":"radio","name":"tipo_conta","id":"cc","required":""},domProps:{"value":true,"checked":_vm._q(_vm.pessoaPoliticamenteExposta,true)},on:{"change":function($event){_vm.pessoaPoliticamenteExposta=true}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pessoaPoliticamenteExposta),expression:"pessoaPoliticamenteExposta"}],staticClass:"form-check-input",attrs:{"tabindex":"4","type":"radio","name":"tipo_conta","id":"cp","required":""},domProps:{"value":false,"checked":_vm._q(_vm.pessoaPoliticamenteExposta,false)},on:{"change":function($event){_vm.pessoaPoliticamenteExposta=false}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_vm._m(2)])])])],1),_vm._v(" "),_vm._m(3)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h2',[_vm._v("Outras informações")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-check-label",attrs:{"for":"cc"}},[_c('strong',[_vm._v("Sim")]),_vm._v(", declaro ser PPE.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-check-label",attrs:{"for":"cp"}},[_c('strong',[_vm._v("Não")]),_vm._v(", declaro não ser PPE.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":"/static/assets/images/angle-right.svg"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f43E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var company = this.solicitacao.Empresa;
    window.company = company;
    return {
      razaoSocial: company ? company.RazaoSocial : null,
      dataFundacao: company ? new Date(company.DataFundacao).toLocaleDateString('pt-BR') : null
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      this.$emit('on-submit', {
        Empresa: {
          DataFundacao: new Date(this.dataFundacao.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"))
        }
      });
    }
  }
});

/***/ }),

/***/ "f6VA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_session_manager__ = __webpack_require__("J7hJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__("bzuE");








var PayClient = function () {
  function PayClient() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PayClient);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(PayClient, null, [{
    key: "request",
    value: function request() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_4_axios___default()(this._prepareOptions(options));
    }
  }, {
    key: "_prepareOptions",
    value: function _prepareOptions(givenOptions) {
      if (!givenOptions.headers) givenOptions.headers = {};

      if (!givenOptions.headers["Accept"]) givenOptions.headers["Accept"] = 'application/json';

      if (!givenOptions.headers["Content-Type"]) givenOptions.headers["Content-Type"] = 'application/json';

      var accessToken = __WEBPACK_IMPORTED_MODULE_5__utils_session_manager__["a" /* default */].getAuthToken();

      if (accessToken) {
        givenOptions.headers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(givenOptions.headers, {
          Authorization: "" + accessToken
        });
      }

      givenOptions.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(givenOptions.data);
      givenOptions.url = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* red */] + "/" + givenOptions.url;
      return givenOptions;
    }
  }, {
    key: "criarBoleto",
    value: function criarBoleto(id) {
      return this.request({
        url: "api/v1/ABC",
        method: "POST",
        data: { IDReserva: id }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return PayClient;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (PayClient);

/***/ }),

/***/ "f8wk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioComprovanteMeiStep_vue__ = __webpack_require__("zRgK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dec5a82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioComprovanteMeiStep_vue__ = __webpack_require__("zN5r");
function injectStyle (ssrContext) {
  __webpack_require__("dEjR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0dec5a82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioComprovanteMeiStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dec5a82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioComprovanteMeiStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fNRR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fRhB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletExtratoFiltro_vue__ = __webpack_require__("YdGp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f400bac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletExtratoFiltro_vue__ = __webpack_require__("5lAD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletExtratoFiltro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f400bac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletExtratoFiltro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fYP8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_client_go__ = __webpack_require__("879M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_charts_BarChart__ = __webpack_require__("gxv5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Carousel__ = __webpack_require__("mfOW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_CompanyProfile_InvestmentReservationForm__ = __webpack_require__("yyPQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_CompanyProfile_InvestmentReservationDataModal__ = __webpack_require__("QAi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuejs_countdown__ = __webpack_require__("xRvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuejs_countdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuejs_countdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_countdownCustom__ = __webpack_require__("Sixp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_NewModal_Modal__ = __webpack_require__("L6+9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_charts_BarChartAnaliseHorizontal__ = __webpack_require__("ve9m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_NoDataProfile__ = __webpack_require__("xalN");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















// import Promise from 'promise'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BarChart: __WEBPACK_IMPORTED_MODULE_6__components_charts_BarChart__["a" /* default */],
    Carousel: __WEBPACK_IMPORTED_MODULE_7__components_Carousel__["a" /* default */],
    InvestmentReservationForm: __WEBPACK_IMPORTED_MODULE_10__components_CompanyProfile_InvestmentReservationForm__["a" /* default */],
    InvestmentReservationDataModal: __WEBPACK_IMPORTED_MODULE_11__components_CompanyProfile_InvestmentReservationDataModal__["a" /* default */],
    Countdown: __WEBPACK_IMPORTED_MODULE_12_vuejs_countdown___default.a,
    countdownCustom: __WEBPACK_IMPORTED_MODULE_13__components_countdownCustom__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_14__components_NewModal_Modal__["a" /* default */],
    BarChartEnv: __WEBPACK_IMPORTED_MODULE_15__components_charts_BarChartAnaliseHorizontal__["a" /* default */],
    NoDataProfile: __WEBPACK_IMPORTED_MODULE_16__components_NoDataProfile__["a" /* default */]
  },
  data: function data() {
    return {
      valuesModal: [],
      selected: "",
      finishedLoading: false,
      boletoPago: false,
      solicitacao: {
        ValorCaptado: null,
        QuantidadeReservasInvestimento: null
      },
      investmentReservation: null,
      googleMapsKey: this.$config.googleApi.googleMapsKey,
      showQueueForm: false,
      minPercentToQueue: this.$config.investment.minPercentToQueue,
      investmentConfirmed: false,
      sDisponivel: 0,
      showModal: false,
      investirMenu: "",
      motivoCancelamento: "",
      nomesGrupos: [],
      balancosZerados: null,
      indexModal: 2,
      preview: false,
      showMeMsg: 1,
      listaEspera: null
    };
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.state.currentUser;
    },
    hasInvestor: function hasInvestor() {
      return this.currentUser.hasinvestor;
    },
    hasSuitability: function hasSuitability() {
      return this.currentUser.hassuitability;
    },
    isInvestorApproved: function isInvestorApproved() {
      return this.hasInvestor && this.currentUser.investor != null && this.currentUser.investor.Status == 'APROVADO';
    },

    id: function id() {
      return this.ajustIdOportunidade(this.solicitacao.IdOportunidade, 5);
    },
    company: function company() {
      return this.solicitacao.Empresa;
    },
    nomeFantasia: function nomeFantasia() {
      return this.company && this.company.NomeFantasia;
    },
    prazo: function prazo() {
      return this.solicitacao.Prazo;
    },
    valor: function valor() {
      return this.formatCurrency(this.solicitacao.Valor);
    },
    cdi: function cdi() {
      return parseInt(this.solicitacao.Cdi);
    },
    razaoSocial: function razaoSocial() {
      return this.company && this.company.RazaoSocial;
    },
    formattedCnpj: function formattedCnpj() {
      return __WEBPACK_IMPORTED_MODULE_8__utils_masker__["a" /* default */].maskCnpj(this.solicitacao.Documento);
    },
    loanType: function loanType() {
      return this.solicitacao.TipoEmprestimo;
    },
    scoreClass: function scoreClass() {
      if (!this.solicitacao.Score) return "";
      return "rating-" + this.solicitacao.Score.replace(/\d/, '').toLowerCase();
    },
    score: function score() {
      return this.solicitacao.Score;
    },
    companyDescription: function companyDescription() {
      return this.company && this.company.InformacaoInstitucional;
    },
    telefoneComercial: function telefoneComercial() {
      var v = this.solicitacao.TelefoneComercial;
      v = v.replace(/\D/g, "");

      if (v.length == 11) v = v.replace(/(\d\d)(\d)(\d\d\d\d)(\d\d\d\d)/, "($1) $2 $3-$4");else v = v.replace(/(\d\d)(\d\d\d\d)(\d\d\d\d)/, "($1) $2-$3");
      return v;
    },
    dataFundacao: function dataFundacao() {
      return this.company && this.company.DataFundacao ? this.company.DataFundacao.toLocaleDateString('pt-BR') : "";
    },
    quantidadeEmpregados: function quantidadeEmpregados() {
      return this.company && this.company.QuantidadeEmpregados;
    },
    nomeGrupoEconomico: function nomeGrupoEconomico() {
      if (!this.company) return null;
      return this.company.NomeGrupoEconomico != "" ? this.company.NomeGrupoEconomico : 'Não pertence a nenhum grupo econômico';
    },
    address: function address() {
      if (!this.company || this.company.Endereco === undefined) return null;
      var address = this.company.Endereco;
      var complement = this.company.Endereco.Complemento && this.company.Endereco.Complemento.length > 0 ? " - " + this.company.Endereco.Complemento : "";
      return address.Logradouro + ', ' + address.Numero + complement + ', ' + address.Bairro + ' - ' + address.Cep + ', ' + address.Cidade + '/' + address.Uf;
    },
    motivoSolicitacao: function motivoSolicitacao() {
      return this.solicitacao.Motivo;
    },
    garantiasOferecidas: function garantiasOferecidas() {

      return this.solicitacao.TipoGarantia != "" ? this.solicitacao.TipoGarantia : "Não possui nenhum tipo de garantia";
    },
    faturamentoAnual: function faturamentoAnual() {
      if (!this.solicitacao) return null;
      return this.formatCurrency(this.solicitacao.Faturamento);
    },
    lucroLiquido: function lucroLiquido() {
      if (!this.company) return null;
      return this.formatCurrency(this.company.LucroMensal);
    },
    divida: function divida() {
      return this.company.ValorDividaBancaria != 0 || this.company.ValorDividaBancaria != null ? "R$ " + this.formatCurrency(this.company.ValorDividaBancaria) : "Nada consta";
    },
    dataConsultaEndividamento: function dataConsultaEndividamento() {
      var date = this.company.DataConsultaEndividamentoTotal ? this.company.DataConsultaEndividamentoTotal : this.company.DataConsultaEndividamento;

      if (date !== undefined && date !== null && date !== "") {
        if (typeof date === "string") {
          var split = date.split("T");
          var dataString = split[0].split("-");

          return dataString[1] + ' / ' + dataString[0];
        } else {
          return date !== undefined ? (date.getMonth() + 1).toString().padStart(2, "0") + '/' + date.getFullYear() : "";
        }
      } else {
        return "";
      }
    },
    analiseEmpresa: function analiseEmpresa() {
      return this.solicitacao.AnaliseEmpresa;
    },
    nomeSolicitante: function nomeSolicitante() {
      return this.solicitacao.Solicitante.NomeCompleto;
    },
    chartData: function chartData() {
      if (!this.company.FaturamentoDozeMeses) {
        return null;
      } else {
        return this.company.FaturamentoDozeMeses.map(function (item) {
          return {
            label: item.Mes.slice(0, 3) + "/" + item.Ano.toString().slice(2, 4),
            value: item.Valor
          };
        });
      }
    },
    site: function site() {
      return this.company.Site;
    },
    mapUrl: function mapUrl() {
      return 'https://www.google.com/maps/embed/v1/place?key=' + this.googleMapsKey + '&q=' + this.address;
    },
    porteEmpresa: function porteEmpresa() {
      return this.solicitacao.Empresa.Porte ? this.solicitacao.Empresa.Porte : "Outros";
    },
    Balanco: function Balanco() {
      if (this.solicitacao.Empresa.Balancos !== undefined && this.solicitacao.Empresa.Balancos.length > 0) {

        var balanco = this.solicitacao.Empresa.Balancos.filter(function (array) {
          if (array.Tipo === "Ativo Circulante" || array.Tipo === "Ativo Não Circulante" || array.Tipo === "Passivo Circulante" || array.Tipo === "Passivo Não Circulante" || array.Tipo === "Patrimônio Líquido") {
            return array;
          }
        });

        //console.log(balanco.length)

        if (balanco.length >= 5) {
          var valores = {
            "ano1": {
              "AtivoCirculante": balanco[0].AVAno1 !== undefined ? balanco[0].AVAno1 : 0.00,
              "AtivoNCirculante": balanco[1].AVAno1 !== undefined ? balanco[1].AVAno1 : 0.00,
              "PassivoCirculante": balanco[2].AVAno1 !== undefined ? balanco[2].AVAno1 : 0.00,
              "PassivoNCirculante": balanco[3].AVAno1 !== undefined ? balanco[3].AVAno1 : 0.00,
              "PatrimonioLiquido": balanco[4].AVAno1 !== undefined ? balanco[4].AVAno1 : 0.00
            },
            "ano2": {
              "AtivoCirculante": balanco[0].AVAno2 !== undefined ? balanco[0].AVAno2 : 0.00,
              "AtivoNCirculante": balanco[1].AVAno2 !== undefined ? balanco[1].AVAno2 : 0.00,
              "PassivoCirculante": balanco[2].AVAno2 !== undefined ? balanco[2].AVAno2 : 0.00,
              "PassivoNCirculante": balanco[3].AVAno2 !== undefined ? balanco[3].AVAno2 : 0.00,
              "PatrimonioLiquido": balanco[4].AVAno2 !== undefined ? balanco[4].AVAno2 : 0.00
            }
          };
        }
      }

      // console.log("Balancos: ", balanco)
      // console.log("Valores: ", valores)

      return this.solicitacao.Empresa.Balancos && balanco.length >= 5 ? valores : null;
    },
    companyFacebook: function companyFacebook() {
      return this.solicitacao.Empresa.Facebook;
    },
    companyTwitter: function companyTwitter() {
      return this.solicitacao.Empresa.Twitter;
    },
    companyLinkedin: function companyLinkedin() {
      return this.solicitacao.Empresa.Linkedin;
    },
    companyInstagram: function companyInstagram() {
      return this.solicitacao.Empresa.Instagram;
    },
    companyVimeo: function companyVimeo() {
      return this.solicitacao.Empresa.Vimeo;
    },
    formatoInvestimento: function formatoInvestimento() {
      return this.solicitacao.FormatoInvestimento;
    },
    negativacoes: function negativacoes() {
      return this.solicitacao.Empresa.Negativacoes || "Nada consta";
    },
    atrasos: function atrasos() {
      return this.formatCurrency(this.solicitacao.Empresa.Atrasos) || "0,00";
    },
    pictures: function pictures() {
      return this.solicitacao.Empresa.Imagens;
    },
    vimeoVideoUrl: function vimeoVideoUrl() {
      return this.solicitacao.Empresa.VimeoVideoUrl;
    },
    capitalSocial: function capitalSocial() {
      //console.log(this.solicitacao.Empresa.CapitalSocial);
      return this.solicitacao.Empresa.CapitalSocial ? this.formatCurrency(this.solicitacao.Empresa.CapitalSocial) : 0.0;
    },
    capitalRealizado: function capitalRealizado() {
      return this.formatCurrency(+this.solicitacao.Empresa.CapitalRealizado) || 0.0;
    },
    Natureza: function Natureza() {
      return this.solicitacao.Empresa.Natureza || "Nada consta";
    },
    Controle: function Controle() {
      return this.solicitacao.Empresa.Controle || "Nada consta";
    },
    Setor: function Setor() {
      return this.solicitacao.Empresa.SetorEmpresa || "Nada consta";
    },
    PontuacaoSetor: function PontuacaoSetor() {
      return this.solicitacao.Empresa.PontuacaoSetor >= 0 ? this.solicitacao.Empresa.PontuacaoSetor : "";
    },
    InadimplenciaSetor: function InadimplenciaSetor() {
      return this.solicitacao.Empresa.ProbabilidadeMediaInadimplencia >= 0 ? this.solicitacao.Empresa.ProbabilidadeMediaInadimplencia : "";
    },
    InvestimentoMinimo: function InvestimentoMinimo() {
      return (this.solicitacao.InvestimentoMinimo && this.solicitacao.InvestimentoMinimo) > 0 ? this.formatCurrency(this.solicitacao.InvestimentoMinimo) : this.formatCurrency(1000);
    }
  },
  methods: {
    submitInvestment: function submitInvestment() {
      var valor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (valor) {
        this.selected = valor;
        // ajuste emergencial css
        document.querySelector('.main-content').style.zIndex = 10;
        this.showModal = true;
      } else if (this.selected || this.investmentReservation || this.solicitacao.ChamadaListaEspera || this.solicitacao.Valor == this.solicitacao.ValorCaptado) {
        // ajuste emergencial css
        document.querySelector('.main-content').style.zIndex = 10;
        this.showModal = true;
      } else {
        // this.$Notify.error('Valor de investimento inválido')
        this.showModal = true;
      }
    },
    voltar: function voltar() {
      var _this = this;

      var alterou = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // ajuste emergencial css
                alterou ? window.location.reload() : _this.showModal = false;
                document.querySelector('.main-content').style.zIndex = 2;

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    formatarTipoEmprestimo: function formatarTipoEmprestimo(tipoEmprestimo) {
      if (tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2") {
        return "Impacto";
      }

      var splitedTipoEmprestimo = tipoEmprestimo.split('-');

      if (splitedTipoEmprestimo.length > 1) {
        return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
      }

      return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);
    },
    Demonstrativos: function Demonstrativos(solicitacao) {
      var demonstrativos = [];

      if (solicitacao.Empresa.Demonstrativos && solicitacao.Empresa.Demonstrativos.length > 0) {
        demonstrativos = solicitacao.Empresa.Demonstrativos.filter(function (elem, i, array) {
          return elem.AdicionarPerfil;
        });
      }

      //console.log("demo: ", demonstrativos)

      return demonstrativos;
    },
    ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
      var s = String(id);
      while (s.length < (qtd || 2)) {
        s = "0" + s;
      }
      return s;
    },
    formatCurrency: function formatCurrency(value) {
      if (value == null || value == undefined) return parseFloat(0).toLocaleString('pt-BR', {
        minimumFractionDigits: "2",
        maximumFractionDigits: 2
      });

      return value.toLocaleString('pt-BR', {
        minimumFractionDigits: "2",
        maximumFractionDigits: 2
      });
    },
    formatDemos: function formatDemos(tipo, valor, unidade) {
      var val = void 0;
      var label = this.verificaIndice(tipo);

      if (unidade !== undefined && unidade !== null && unidade !== "") {
        val = this.formatCurrency(valor);
        if (unidade === "%" || unidade === "x") {
          return val + "" + unidade;
        } else {
          if (valor < 0) {
            val = valor * -1;
            return "- " + unidade + " " + this.formatCurrency(val);
          } else {
            val = this.formatCurrency(valor);
            return unidade + " " + this.formatCurrency(val);
          }
        }
      } else {
        if (label === "%") {
          val = this.formatCurrency(valor);
          return val + "" + label;
        } else {
          if (valor < 0) {
            val = valor * -1;
            return "- " + label + " " + this.formatCurrency(val);
          } else {
            val = this.formatCurrency(valor);
            return label + " " + this.formatCurrency(val);
          }
        }
      }
    },
    finishedDate: function finishedDate(date) {
      if (date) {
        var year = date.getFullYear();
        var day = date.getDate();
        var month = date.getMonth();
        var monthArray = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var endDate = monthArray[month] + " " + day.toString() + ", " + year.toString();
        return endDate;
      } else {
        return null;
      }
    },
    diffDate: function diffDate(d1, d2) {
      var miliSecs = 0;

      if (d1 == "") miliSecs = new Date(d2) - new Date();else miliSecs = new Date(d2) - new Date(d1);

      var diffDays = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(miliSecs / 1000 / 60 / 60 / 24);

      if (diffDays < 0) return "encerrado";
      if (diffDays == 0) return "hoje";

      return diffDays + " dias";
    },
    startDate: function startDate(date) {
      var spliter = date.split("T");

      spliter = spliter[0].split("-");

      //console.log(spliter)

      return spliter[1] + "/" + spliter[0];
    },
    validaStatusListaEspera: function validaStatusListaEspera(item) {
      var time = item.FimCaptacao.getTime();

      var resultDt = this.diffDate("", new Date(item.FimCaptacao.getTime() + 86400000));

      if (resultDt.toUpperCase() !== "ENCERRADO" && item.StatusAnalise !== "ENCERRADO" && item.ValorCaptado >= item.Valor) return true;

      return false;
    },
    blockHight: function blockHight(percent) {
      return 'height: ' + percent + '%;';
    },
    DadosGrafico: function DadosGrafico() {
      var Dados = [];
      // Indices do gráfico
      var labels = ["Ativo Circulante", "Ativo não Circulante", "Passivo Circulante", "Passivo não Circulante", "Patrimônio Líquido"];
      // Cores do gráfico
      var cores = ['#2980b9', '#e67e22', '#c0392b', '#27ae60', '#f1c40f'];
      // Valores da solicitacao
      var balancos = this.solicitacao.Empresa.Balancos.filter(function (array) {
        if (array.Tipo === "Ativo Circulante" || array.Tipo === "Ativo Não Circulante" || array.Tipo === "Passivo Circulante" || array.Tipo === "Passivo Não Circulante" || array.Tipo === "Patrimônio Líquido") {
          return array;
        }
      });

      if (this.solicitacao.Empresa.Balancos && balancos.length > 0) {
        for (var i = 0; i < 5; i++) {
          Dados.push({ label: labels[i], value: balancos[i].AH, color: cores[i], percent: balancos[i].AH });
        }
      }

      //console.log(Dados)

      return Dados;
    },
    verificaIndice: function verificaIndice(tipo) {
      // Verifica se possui % para setar o tipo de valor que sera mostrado
      // R$ ou %
      if (tipo.indexOf("%") != -1) {
        return "%";
      } else {
        return "R$";
      }
    },
    classIndice: function classIndice(demo) {
      // Verifica a seta do demonstrativo do ano 2
      // Se ocorreu um acréscimo ou decrescimo

      if (demo.Classificacao == undefined) {
        if (demo.ValorAno1 > demo.ValorAno2) {
          return "fas fa-caret-down";
        } else if (demo.ValorAno1 < demo.ValorAno2) {
          return "fas fa-caret-up";
        } else {
          return "";
        }
      } else {
        if (demo.Classificacao == "Negativo") {
          return "fas fa-caret-down";
        } else if (demo.Classificacao == "Positivo") {
          return "fas fa-caret-up";
        } else {
          return "";
        }
      }
    },
    IndicesComplementares: function IndicesComplementares(solicitacao) {

      // Verifica se possui o array de indices complementares
      var indices = solicitacao.Empresa.IndicesFinanceiros ? solicitacao.Empresa.IndicesFinanceiros : [];
      // array dos nomes dos grupos deo indices
      var nomeGrupos = [];
      // array informacoes dos grupos complementares indexadas

      // indice auxiliar
      var contador = 0;

      // popula o array com grupos com todos os nome dos grupos
      for (var indice in indices) {
        nomeGrupos.push(indices[indice].Grupo);
      }

      // filtra o array de grupos eliminando nomes repetidos
      nomeGrupos = nomeGrupos.filter(function (i, elem, array) {
        return array.indexOf(i) === elem;
      });

      // pegas os nomes dos grupos para poder renderizar nos blocos
      //this.nomesGrupos = Object.assign({},grupos);

      // monta o array de grupo com indice dos nomes dos grupos e dentro os arrays das informacoes relavantes do indices
      var grupo = new Array(nomeGrupos.length);

      for (var i = 0; i < nomeGrupos.length; i++) {
        grupo[i] = {};
        grupo[i].Grupo = nomeGrupos[i];

        for (var j = 0; j < indices.length; j++) {
          if (indices[j].AdicionarPerfil && nomeGrupos[i] == indices[j].Grupo) {

            if (grupo[i].Dados === undefined) {
              grupo[i].Dados = [];
            }

            grupo[i].Dados.push({
              "Tipo": indices[j].Tipo,
              "ValorAno1": indices[j].ValorAno1,
              "ValorAno2": indices[j].ValorAno2,
              "Descricao": indices[j].Descricao,
              "Status": indices[j].Status,
              "AdicionarPerfil": indices[j].AdicionarPerfil
            });
          }
        }
      }

      //console.log("=================")
      //console.log("grupo: ", grupo.length);
      //console.log("grp ", grupo);

      return grupo;
    },
    classBullet: function classBullet(status) {
      // Classes das bullets de cada um dos status do indice
      // Verde - success
      // Amarelo - alert
      // Vermelho - warning
      switch (status) {
        case "Verde":
          return "bullet bullet-success";

        case "Amarelo":
          return "bullet bullet-alert";

        case "Vermelho":
          return "bullet bullet-warning";

        default:
          return "bullet bullet-secondary";
      }
    },
    colorBullet: function colorBullet(status) {
      // Classes das bullets de cada um dos status do indice
      // Verde - success
      // Amarelo - alert
      // Vermelho - warning
      switch (status) {
        case "Verde":
          return "background-color: #00DFC1";

        case "Amarelo":
          return "background-color: #FFD858; width: 80px;";

        case "Vermelho":
          return "background-color: #FF5C5F";

        default:
          return "background-color: #fff";
      }
    },
    textBullet: function textBullet(status) {
      // Classes das bullets de cada um dos status do indice
      // Verde - success
      // Amarelo - alert
      // Vermelho - warning
      switch (status) {
        case "Verde":
          return "Índice Positivo";

        case "Amarelo":
          return "Alerta";

        case "Vermelho":
          return "Índice Negativo";
      }
    },
    verificaValoresVertical: function verificaValoresVertical(balanco) {
      if (balanco && balanco.length > 0) {
        var counter = 0;

        var b = balanco.filter(function (array) {
          if (array.Tipo === "Ativo Circulante" || array.Tipo === "Ativo Não Circulante" || array.Tipo === "Passivo Circulante" || array.Tipo === "Passivo Não Circulante" || array.Tipo === "Patrimônio Líquido") {
            return array;
          }
        });

        if (b.length < 5) {
          return false;
        }

        for (var i in b) {
          if (b[i].AVAno1 <= 0 && b[i].AVAno2 <= 0) {
            counter++;
          }
        }

        if (counter > 4) {
          return false;
        } else {
          return true;
        }
      }

      return false;
    },
    verificaValoresIndices: function verificaValoresIndices(indices) {
      var counter = 0;

      if (indices && indices.length > 0) {
        for (var i = 0; i < indices.length; i++) {
          if (indices[i].AdicionarPerfil !== true && indices[i].ValorAno1 <= 0 && indices[i].ValorAno2 <= 0) {
            counter++;
          }
        }

        if (counter > 20) {
          return false;
        } else {
          return true;
        }
      }

      return false;
    },
    InvestidorBloqueado: function InvestidorBloqueado() {

      if (this.currentUser.investor == null || this.currentUser.investor.Bloqueio == null || this.currentUser.investor.Bloqueio.FimBloqueio == null) return false;

      var FimBloqueio = new Date(this.currentUser.investor.Bloqueio.FimBloqueio);

      return FimBloqueio > new Date();
    },
    voltarLink: function voltarLink() {
      var separador = window.location.href.split("#");
      if (separador.length > 2) {
        return "#" + separador[2];
      }

      return "";
    },
    validacaoSetor: function validacaoSetor(empresa) {

      if (empresa && empresa.SetorEmpresa && empresa.PontuacaoSetor >= 0 && empresa.ProbabilidadeMediaInadimplencia >= 0) {
        return true;
      }

      return false;
    },
    showMeInfo: function showMeInfo() {
      // Verifica se o investidor tem acesso as informações detalhadas da empresa ou nao
      // Verifica cadastro completo
      var token = this.$route.params.id.substring(0, 5);

      var d = new Date();
      var y = d.getFullYear();

      if (this.$route.query.preview === 'adminiouu' + token + y) {
        return true;
      }

      if (this.hasInvestor && this.hasSuitability && this.currentUser.investor.Status == "APROVADO") {
        // Verifica status da oportunidade
        if (this.solicitacao.Encerrado) {
          // Verifica se o investidor tem investimento na oportunidade
          if (this.investmentConfirmed) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        this.showMeMsg = 2;
        return false;
      }
    },
    recalcValues: function recalcValues() {
      console.log("Entrou em recalcular valores");
      this.valuesModal = [];

      var valorSelect = 0;
      var valorRestante = this.solicitacao.Valor - this.solicitacao.ValorCaptado;
      var quantidade = this.solicitacao.InvestimentoMaximo / this.solicitacao.InvestimentoMinimo;

      for (var i = 1; i <= quantidade; i++) {
        this.valuesModal.push("R$ " + (this.solicitacao.InvestimentoMinimo * i).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }));
      }
    },


    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/oportunidades/perfil-empresa/:id',
        title: 'Empresa novo'
      });
    }
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('updateUser');
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var valorSelect, valorRestante, quantidade, i, _i;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              try {
                document.querySelector('.main-content').style.zIndex = 2;
              } catch (e) {
                console.log(e);
              }
              // BLOQUEIO ...
              if (_this2.$store.state.currentUser.investor) {
                if (typeof _this2.$store.state.currentUser.investor.Bloqueio !== 'undefined') {
                  window.location.href = "#/";
                }
              }

              // MODAL ...
              if (document.getElementsByTagName("main").length > 0) {
                document.getElementsByTagName("main")[0].style.zIndex = "2";
              }

              _context2.prev = 3;
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].getInvestmentReservation({
                loanRequestId: _this2.$route.params.id
              });

            case 6:
              _this2.investmentReservation = _context2.sent;
              _context2.next = 9;
              return __WEBPACK_IMPORTED_MODULE_4__utils_api_client_go__["a" /* default */].getLoanRequest(_this2.$route.params.id);

            case 9:
              _this2.solicitacao = _context2.sent;


              _this2.solicitacao._id = _this2.$route.params.id;
              _this2.solicitacao.ChamadaListaEspera ? _this2.solicitacao.ValorCaptado = _this2.solicitacao.Valor : '';

              if (_this2.investmentReservation !== null) {
                _this2.investmentConfirmed = true;

                if (_this2.investmentReservation.StatusBoleto === "paid") {
                  _this2.boletoPago = true;
                }
              }

              _this2.solicitacao.Encerrado = _this2.solicitacao.StatusAnalise == "ENCERRADO" || _this2.diffDate("", new Date(_this2.solicitacao.FimCaptacao.getTime())) == "encerrado";

              _this2.valuesModal = [];
              valorSelect = 0;
              valorRestante = _this2.solicitacao.Valor - (_this2.solicitacao.ValorCaptado == undefined ? 0 : _this2.solicitacao.ValorCaptado);
              quantidade = _this2.solicitacao.InvestimentoMaximo / _this2.solicitacao.InvestimentoMinimo;

              valorRestante == 0 ? _this2.listaEspera = true : '';

              for (i = 1; i <= quantidade && valorRestante > valorSelect; i++) {
                _this2.valuesModal.push("R$ " + (_this2.solicitacao.InvestimentoMinimo * i).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }));
                valorSelect = _this2.solicitacao.InvestimentoMinimo * i;
              }

              if (_this2.investmentConfirmed) {
                for (_i = 1; _i <= quantidade; _i++) {
                  _this2.valuesModal.push("R$ " + (_this2.solicitacao.InvestimentoMinimo * _i).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }));
                }
              }

              _this2.finishedLoading = true;
              _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
              _context2.next = 30;
              break;

            case 25:
              _context2.prev = 25;
              _context2.t0 = _context2['catch'](3);

              console.log(_context2.t0);
              _this2.finishedLoading = true;
              _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);

            case 30:
              _context2.next = 32;
              return _this2.taggingGA();

            case 32:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 25]]);
    }))();
  }
});

/***/ }),

/***/ "fZam":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepresentativeFullNameStep_vue__ = __webpack_require__("ysEb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7c14190_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepresentativeFullNameStep_vue__ = __webpack_require__("s5lK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepresentativeFullNameStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7c14190_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepresentativeFullNameStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fjsE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fkOh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-10 col-xl-10"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.informacaoInstitucional),expression:"informacaoInstitucional"}],staticClass:"form-control form-control-lg",attrs:{"rows":"5","placeholder":"Como começou a empresa? Quais os produtos/serviços que a empresa oferece? A quanto tempo está nessa mesma localização? O imóvel que a empresa se encontra é próprio ou alugado? Quais as projeções futuras? Informações sobre os sócios: Experiência na área, formação, etc.","required":""},domProps:{"value":(_vm.informacaoInstitucional)},on:{"input":function($event){if($event.target.composing){ return; }_vm.informacaoInstitucional=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"btn btn-lg btn-primary"},[_vm._v("\n            Próximo \n            "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Muito bem! Está quase acabando! "),_c('br'),_vm._v(" Agora conte-nos um pouco mais sobre você e seu negócio e como você pretende usar o empréstimo!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fs42":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressForm_vue__ = __webpack_require__("FRb7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4efd707a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressForm_vue__ = __webpack_require__("WNpg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4efd707a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fsye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterNewLogin_vue__ = __webpack_require__("ugvs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e221ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterNewLogin_vue__ = __webpack_require__("TbH6");
function injectStyle (ssrContext) {
  __webpack_require__("2zIB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33e221ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterNewLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e221ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterNewLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g1op":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import ApiClient from '../utils/api-client';

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    },

    methods: {
        Name: function Name() {
            var nome = "",
                firstName;

            if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
                nome = this.User.username;
            } else {
                nome = this.User.name;
            }

            nome = nome.trim();
            firstName = nome.split(" ");

            return firstName[0];
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/informacoes-adicionais/selecionar-area',
                title: 'Seleceionar area'
            });
        }
    },
    computed: {
        User: function User() {
            return this.$store.state.currentUser;
        }
    },

    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.taggingGA();

                        case 2:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ "g36g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_BarChartInvestimentos__ = __webpack_require__("Levr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pagination__ = __webpack_require__("cMGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__ = __webpack_require__("Du/2");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






/* harmony default export */ __webpack_exports__["a"] = ({
    components: { BarChart: __WEBPACK_IMPORTED_MODULE_3__components_charts_BarChartInvestimentos__["a" /* default */], Pagination: __WEBPACK_IMPORTED_MODULE_4__components_Pagination__["a" /* default */] },
    data: function data() {
        return {
            MeusInvestimentosAll: [],
            currentPage: 0,
            itensPorPage: 10,
            paginaTopo: 1,
            scoreFiltro: "",
            tipoEmprestimoFiltro: "",
            dataIni: null,
            dataFim: null,
            tiposEmprestimos: [{ value: "emprestimo-coletivo", name: "Empréstimo Coletivo" }, { value: "emprestimo-social", name: "Empréstimo Social" }],
            scoresArray: [{ value: "AA" }, { value: "A" }, { value: "B" }, { value: "C" }, { value: "D" }, { value: "E" }, { value: "HR" }]
        };
    },

    methods: {
        linkReserva: function linkReserva(id) {
            window.location.href = '/#/investimentos/historico/historico-de-investimento/' + id;
        },
        ObterNome: function ObterNome(solicitacao) {

            if (solicitacao.Empresa != null && solicitacao.Empresa.NomeFantasia != "") return solicitacao.Empresa.NomeFantasia;

            if (solicitacao.Impacto != null && solicitacao.Impacto.NomeFantasia != "") return solicitacao.Impact.NomeFantasia;

            if (solicitacao.Social != null && solicitacao.Social.RazaoSocial != "") return solicitacao.Social.RazaoSocial;

            if (solicitacao.Social != null && solicitacao.Social.NomeCompleto != "") return solicitacao.Social.NomeCompleto;
        },
        Buscar: function Buscar() {
            var _this = this;

            this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["c" /* START_LOADING */]);
            __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getInfosMyInvestments().then(function (infos) {
                var total = 0;
                var Investimentos = infos.data;
                _this.currentPage = 0;

                Investimentos = Investimentos.filter(function (item) {
                    return !(item.SolicitacaoId.StatusAnalise == "ENCERRADO" && item.Status == 2);
                });

                if (_this.tipoEmprestimoFiltro != "") {
                    Investimentos = Investimentos.filter(function (item) {
                        return item.SolicitacaoId.TipoEmprestimo == _this.tipoEmprestimoFiltro;
                    });
                }

                if (_this.dataIni != null && _this.dataIni != undefined && _this.dataIni != "") {
                    Investimentos = Investimentos.filter(function (item) {
                        var create = new Date(item.Created.split('T')[0]);
                        create.setHours(create.getHours() + 3);

                        var filtroInicio = new Date(_this.dataIni.split('T')[0]);
                        filtroInicio.setHours(filtroInicio.getHours() + 3);
                        filtroInicio.setHours(0);
                        return create >= filtroInicio;
                    });
                }

                if (_this.dataFim != null && _this.dataFim != undefined && _this.dataFim != "") {
                    Investimentos = Investimentos.filter(function (item) {

                        var create = new Date(item.Created.split('T')[0]);
                        create.setHours(create.getHours() + 3);
                        var filtroFim = new Date(_this.dataFim.split('T')[0]);
                        filtroFim.setHours(filtroFim.getHours() + 3);
                        filtroFim.setHours(23);
                        filtroFim.setMinutes(59);

                        return create <= filtroFim;
                    });
                }

                if (_this.scoreFiltro != "") {

                    if (_this.scoreFiltro == "AA" || _this.scoreFiltro == "HR") {
                        Investimentos = Investimentos.filter(function (item) {
                            return item.SolicitacaoId.Score == _this.scoreFiltro;
                        });
                    } else {
                        Investimentos = Investimentos.filter(function (item) {
                            return (item.SolicitacaoId.Score || "").length > 0 ? item.SolicitacaoId.Score[0] == _this.scoreFiltro : false;
                        });
                    }
                }

                _this.MeusInvestimentosAll = Investimentos;
                _this.paginaTopo = 1;
                _this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
            }).catch(function (error) {
                console.log('error', error);

                _this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
            });
        },
        VerifyCurrentPage: function VerifyCurrentPage(page) {
            return page == this.currentPage + 1;
        },
        Link: function Link(page) {
            return this.currentPage = page - 1;
        },
        MudarPagina: function MudarPagina(acao) {

            if (acao == "-") {

                if (this.currentPage - 1 >= 0) {
                    this.currentPage = this.currentPage - 1;
                    this.paginaTopo = this.currentPage + 1;
                }
            }
            if (acao == "+") {
                if (this.currentPage + 1 < this.Paginas.length) {
                    this.currentPage = this.currentPage + 1;
                    this.paginaTopo = this.currentPage + 1;
                }
            }
        },
        MudarPaginaNumero: function MudarPaginaNumero() {

            console.log(this.paginaTopo, this.paginaTopo - 1, this.Paginas.length);
            if (this.paginaTopo - 1 > this.Paginas.length - 1) {
                this.currentPage = this.Paginas.length - 1;
                this.paginaTopo = this.Paginas.length;
                return;
            }

            if (this.paginaTopo - 1 < 0) {
                this.currentPage = 0;
                this.paginaTopo = 1;
                return;
            }

            this.currentPage = this.paginaTopo - 1;
        },
        PaginaTopo: function PaginaTopo(event) {

            this.paginaTopo = parseInt(event.target.value);
        },
        selecionarTipoEmprestimo: function selecionarTipoEmprestimo(data) {
            this.tipoEmprestimoFiltro = data.target.value;
        },
        selecionarScore: function selecionarScore(data) {
            this.scoreFiltro = data.target.value;
        },
        formatCurrency: function formatCurrency(value) {
            if (value != null) return value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });

            return 0;
        },
        ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
            var s = String(id);

            while (s.length < (qtd || 2)) {
                s = "0" + s;
            }

            return s;
        },
        formatData: function formatData(data) {
            var date = new Date(data);
            return date.toLocaleDateString();
        },
        formatDataVencimento: function formatDataVencimento(data) {
            if (typeof data != "undefined" && data != "-") {
                var date = new Date(data);
                var day = date.getDate() + 1;
                var month = date.getMonth() + 1;
                month >= 10 ? '' : month = "0" + month;
                day >= 10 ? '' : day = "0" + day;
                return day + "/" + month + "/" + date.getFullYear();
            }
            return "-";
        },
        lowerCase: function lowerCase(texto) {
            if (texto == null || texto == undefined) return "";

            if (texto == "AA" || texto == "HR") return texto.toLowerCase();

            return texto.substr(0, 1).toLowerCase();
        },
        dataSort: function dataSort(arr) {
            var swapped = void 0;
            do {
                swapped = false;
                for (var i = 0; i < arr.length - 1; i++) {
                    if (arr[i].Created < arr[i + 1].Created) {
                        var temp = arr[i];
                        arr[i] = arr[i + 1];
                        arr[i + 1] = temp;
                        swapped = true;
                    }
                }
            } while (swapped);
            return arr;
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/historico/',
                title: 'Histórico'
            });
        }
    },
    computed: {
        User: function User() {
            return this.$store.state.currentUser;
        },
        CurrentPage: function CurrentPage() {
            return this.currentPage;
        },
        MeusInvestPG: function MeusInvestPG() {
            return this.MeusInvestimentosAll.slice(this.CurrentPage * this.itensPorPage, this.CurrentPage * this.itensPorPage + this.itensPorPage);
        },
        Paginas: function Paginas() {
            var pgs = Math.ceil(this.MeusInvestimentosAll.length / this.itensPorPage);

            var paginas = new Array();
            for (var i = 0; i < pgs; i++) {
                paginas.push(i + 1);
            }return paginas;
        },
        PaginasTotais: function PaginasTotais() {
            return Math.ceil(this.MeusInvestimentosAll.length / this.itensPorPage);
        }
    },
    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["c" /* START_LOADING */]);
                            __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getInfosMyInvestments().then(function (infos) {
                                var resposta = infos.data;
                                var total = 0;
                                _this2.dataSort(resposta);
                                resposta = resposta.filter(function (item) {
                                    return !(item.SolicitacaoId != null && item.SolicitacaoId.StatusAnalise == "ENCERRADO" && item.Status == 2);
                                });

                                _this2.MeusInvestimentosAll = resposta;
                                _this2.currentPage = 0;

                                _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            }).catch(function (error) {
                                console.log('error', error);

                                _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            });
                            //tagueamento GA
                            _context.next = 4;
                            return _this2.taggingGA();

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    }
});

/***/ }),

/***/ "g50h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a455180_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepBackButton_vue__ = __webpack_require__("XXgf");
function injectStyle (ssrContext) {
  __webpack_require__("JDlu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a455180"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a455180_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepBackButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g6u7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      celular: this.solicitacao.Celular,
      telefoneComercial: this.solicitacao.TelefoneComercial
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = { Celular: this.celular, TelefoneComercial: this.telefoneComercial };
      this.$emit('on-submit', newData);
    }
  }
});

/***/ }),

/***/ "gCFQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Investimento_vue__ = __webpack_require__("LvM3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1497149a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Investimento_vue__ = __webpack_require__("xbS8");
function injectStyle (ssrContext) {
  __webpack_require__("h7Lg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1497149a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Investimento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1497149a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Investimento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gEyh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gGqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmprestimoSocialNew_vue__ = __webpack_require__("LB2j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7457af7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmprestimoSocialNew_vue__ = __webpack_require__("V7s3");
function injectStyle (ssrContext) {
  __webpack_require__("XlwF")
  __webpack_require__("B5xB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7457af7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmprestimoSocialNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7457af7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmprestimoSocialNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gbsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"Celular text-left"}},[_vm._v("Celular")]),_vm._v(" "),_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.pessoal.Celular),expression:"pessoal.Celular"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"(__) _____-____","title":"(__) _____-____","pattern":"(\\(\\d{2}\\)|\\d{2})\\s?\\d{5}[ -]?\\d{4}","required":""},domProps:{"value":(_vm.pessoal.Celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.pessoal, "Celular", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',[_vm._v("Telefone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pessoal.Telefone),expression:"pessoal.Telefone"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"(__) _____-____","title":"(__) _____-____","pattern":"(\\(\\d{2}\\)|\\d{2})\\s?\\d{4,5}[ -]?\\d{4}"},domProps:{"value":(_vm.pessoal.Telefone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.pessoal, "Telefone", $event.target.value)}}})]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Contatos Pessoal")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "glKg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gnDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploadIndentidadeStep_vue__ = __webpack_require__("3Vbq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7f98c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploadIndentidadeStep_vue__ = __webpack_require__("NfYE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploadIndentidadeStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7f98c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploadIndentidadeStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gne+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FaturamentoMensalStep_vue__ = __webpack_require__("FC0f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdfb0616_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaturamentoMensalStep_vue__ = __webpack_require__("evNu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FaturamentoMensalStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdfb0616_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaturamentoMensalStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gqJL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gtE8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: this.solicitacao.ArquivosIrpf || [null]
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.arquivos.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.arquivos, index, null);
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do IRPF de ao menos um avalista é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {
        var newData = {
          ArquivosIrpf: this.arquivosRecebidos
        };
        this.$emit('on-submit', newData);
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "gxv5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChart_vue__ = __webpack_require__("0KSN");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h5MU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid login"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"ico-iouu",attrs:{"href":_vm.lpUrl,"target":"_blank","title":"IOUU"}})]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-7 d-flex flex-column form"},[_c('header',{staticClass:"align-self-center align-self-md-end"},[_vm._v("\n        Já tem uma conta?\n        "),_c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":"login"}},[_vm._v("Entrar")])],1),_vm._v(" "),_c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-5 text-center"},[_c('h2',[_vm._v("Criar uma conta")]),_vm._v(" "),_c('form',{attrs:{"id":"form-criarContaLead"},on:{"submit":function($event){$event.preventDefault();return _vm.signUp($event)}}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control form-control-lg",attrs:{"id":"Nome","name":"name","type":"text","autofocus":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Endereço de email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",attrs:{"type":"email","id":"Email","disabled":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Senha")]),_vm._v(" "),_c('password-field',{model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('div',{staticClass:"form-check text-left d-flex justify-content-center"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":"terms"},on:{"click":_vm.validateCampos}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_c('label',{staticClass:"form-check-label p-0"},[_vm._v("\n                Eu \"CONCORDO\" com os "),_c('a',{attrs:{"href":_vm.lpUrl+'/termos-e-condicoes/',"target":"_blank"}},[_vm._v("Termos e condições")]),_vm._v(" e "),_c('a',{attrs:{"href":_vm.lpUrl+'/politica-de-privacidade/',"target":"_blank"}},[_vm._v("Política de privacidade")]),_vm._v(" da IOUU.\n              ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":!_vm.enabled || !_vm.validate}},[_vm._v("Continuar")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center d-flex align-items-center"},[_c('div',{staticClass:"col-12 col-lg-10 d-flex flex-column align-items-center"},[_c('h1',[_vm._v("Crie sua conta")]),_vm._v(" "),_c('p',[_vm._v("\n            Não se preocupe. Você não está assumindo nenhum compromisso neste momento.\n            "),_c('br'),_vm._v("Suas informações serão usadas apenas para analisarmos o seu perfil\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.\n          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validacao"},[_c('i',{staticClass:"invalido fas fa-exclamation-circle",attrs:{"hidden":"","id":"IconeInvalido"}}),_vm._v(" "),_c('i',{staticClass:"valido fas fa-check",attrs:{"hidden":"","id":"IconeValido"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h7Lg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h9EJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmacaoTokenStep_vue__ = __webpack_require__("4xPj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f83260_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmacaoTokenStep_vue__ = __webpack_require__("xuWV");
function injectStyle (ssrContext) {
  __webpack_require__("X2/a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71f83260"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmacaoTokenStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f83260_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmacaoTokenStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hAj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard"},[_c('div',{staticClass:"dashboard__complete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Em Construção")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hE0e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImpactProfile_vue__ = __webpack_require__("LqmW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_967ccef4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImpactProfile_vue__ = __webpack_require__("avqu");
function injectStyle (ssrContext) {
  __webpack_require__("dck0")
  __webpack_require__("tpd9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-967ccef4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImpactProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_967ccef4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImpactProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hHOV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_centralCobranca__ = __webpack_require__("4O7e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SimpleLoader__ = __webpack_require__("uRog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pagination__ = __webpack_require__("cMGX");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            status: '',
            investidor: {},
            id: "",
            data: {},
            solicitacoes: {},
            total: {},
            width: 0,
            indexPage: 1,
            indexPageFiltro: 1,
            Paginas: 0,
            loading: true,
            loadingAux: true,
            statusOption: [{ value: "", label: "Selecione" }, { value: "Todos", label: "Todos" }, { value: "Emdia", label: "Em dia" }, { value: "Atrasada", label: "1 a 15 dias" }, { value: "Negativado", label: "Negativado" }, { value: "Protesto", label: "Protesto" }, { value: "Cobrancaextrajudicial", label: "Cobrança extrajudicial" }, { value: "Cobrancajudicial", label: "Cobrança judicial" }, { value: "Renegociada", label: "Renegociada" }]
        };
    },

    watch: {
        'status': function status() {

            this.indexPage = 1;

            this.filtroSolicitacoes(this.status);
        }
    },
    methods: {
        solicitacoesProcesso: function solicitacoesProcesso() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:

                                _this.id = _this.investidor._id;

                                _this.loading = true;

                                _context.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_2__services_api_centralCobranca__["a" /* default */].GetListagemSolicitacoesProcesso(_this.indexPage);

                            case 4:
                                _ref = _context.sent;
                                data = _ref.data;


                                console.log("dados --> ", data);

                                if (data) {

                                    _this.Paginas = data.Paginas;
                                    _this.solicitacoes = data;
                                    _this.loading = false;
                                }

                                return _context.abrupt('return', data);

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        dadosTotalSolicitacoes: function dadosTotalSolicitacoes() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _ref2, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2__services_api_centralCobranca__["a" /* default */].GetTotalSolicitacoesProcesso();

                            case 2:
                                _ref2 = _context2.sent;
                                data = _ref2.data;


                                console.log("dados --> ", data);

                                if (data) {

                                    _this2.total = data;
                                    _this2.loadingAux = false;
                                }
                                return _context2.abrupt('return', data);

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        filtroSolicitacoes: function filtroSolicitacoes(status) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var _ref3, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:

                                _this3.loading = true;

                                _context3.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_2__services_api_centralCobranca__["a" /* default */].GetListagemSolicitacoesProcessoFiltro(_this3.indexPage, status);

                            case 3:
                                _ref3 = _context3.sent;
                                data = _ref3.data;


                                console.log("dados --> ", data);

                                if (data) {

                                    _this3.Paginas = data.Paginas;
                                    _this3.solicitacoes = data;
                                    _this3.loading = false;
                                }

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        paginacao: function paginacao(rota) {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this4.indexPage = rota + 1;

                                if (!(_this4.status != 'Todos' && _this4.status)) {
                                    _context4.next = 6;
                                    break;
                                }

                                _context4.next = 4;
                                return _this4.filtroSolicitacoes(_this4.status);

                            case 4:
                                _context4.next = 8;
                                break;

                            case 6:
                                _context4.next = 8;
                                return _this4.solicitacoesProcesso();

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        formatarDinheiro: function formatarDinheiro(valor) {

            if (valor == undefined) return false;else if (valor == "") return false;

            valor = Number(valor);

            return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        formataData: function formataData(date) {

            var spliter = date.split("T");
            var newDate = spliter[0].split('-');
            var time = spliter[1].split(':');

            return newDate[2] + '/' + newDate[1] + '/' + newDate[0];
        },
        abreviaStatus: function abreviaStatus(status) {

            switch (status) {
                case "Emdia":
                    return 'ed';
                case "Em dia":
                    return 'ed';
                case "15 dias":
                    return "15";
                case "Negativado":
                    return "ngt";
                case "Protesto":
                    return "pto";
                case "Cobranca extrajudicial":
                    return "cej";
                case "Cobrancaextrajudicial":
                    return "cej";
                case "Cobranca judicial":
                    return "cj";
                case "Cobrancajudicial":
                    return "cj";
                case "Renegociada":
                    return "rng";
            }
        },


        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/central-de-cobranca/ ',
                title: 'Central de Cobrança'
            });
        }
    },
    components: {
        Loading: __WEBPACK_IMPORTED_MODULE_3__components_SimpleLoader__["a" /* default */],
        Pagination: __WEBPACK_IMPORTED_MODULE_6__components_Pagination__["a" /* default */]
    },
    created: function created() {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:

                            _this5.width = screen.width;

                            _this5.investidor = _this5.$store.state.currentUser;

                            _this5.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);

                            _context5.next = 5;
                            return _this5.solicitacoesProcesso();

                        case 5:
                            _context5.next = 7;
                            return _this5.dadosTotalSolicitacoes();

                        case 7:

                            _this5.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);

                            //tagueamento GA
                            _context5.next = 10;
                            return _this5.taggingGA();

                        case 10:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    }
});

/***/ }),

/***/ "hPZq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-conta.432fca8.png";

/***/ }),

/***/ "hVPI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("Page Not Found")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hX1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        operacao: { type: Object }
    },

    created: function created() {

        console.log(this.operacao);
    },


    computed: {
        valor: function valor() {
            return this.operacao.Valor;
        },
        transacao: function transacao() {
            return this.operacao.id;
        },
        boletoUrl: function boletoUrl() {
            return "https://pay.iouu.com.br" + '/boleto/investidor/' + this.operacao.Detalhes.Deposito.BoletoId;
        }
    },

    methods: {
        formatDocument: function formatDocument(doc) {

            if (doc.length > 11) {
                return __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].maskCnpj(doc);
            } else {
                return __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].maskCpf(doc);
            }
        },
        formatarDinheiro: function formatarDinheiro(value) {

            if (value != null) {

                if (typeof value == "string") value = parseFloat(value);

                var options = {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                };

                return value.toLocaleString('pt-BR', options);
            }

            return 0;
        }
    }
});

/***/ }),

/***/ "hpPs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10 col-xl-10"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-10 col-xl-10"},[_vm._m(1),_vm._v(" "),_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"item"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('table',{staticClass:"forms"},[_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.HorizonteInvestimento),expression:"HorizonteInvestimento"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"HorizonteInvestimento","id":"","value":"1"},domProps:{"checked":_vm._q(_vm.HorizonteInvestimento,"1")},on:{"change":function($event){_vm.HorizonteInvestimento="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.HorizonteInvestimento),expression:"HorizonteInvestimento"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"HorizonteInvestimento","id":"","value":"2"},domProps:{"checked":_vm._q(_vm.HorizonteInvestimento,"2")},on:{"change":function($event){_vm.HorizonteInvestimento="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.HorizonteInvestimento),expression:"HorizonteInvestimento"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"HorizonteInvestimento","id":"","value":"3"},domProps:{"checked":_vm._q(_vm.HorizonteInvestimento,"3")},on:{"change":function($event){_vm.HorizonteInvestimento="3"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(5)])])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('table',{staticClass:"forms"},[_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MomentoVida),expression:"MomentoVida"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"MomentoVida","id":"","value":"1"},domProps:{"checked":_vm._q(_vm.MomentoVida,"1")},on:{"change":function($event){_vm.MomentoVida="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MomentoVida),expression:"MomentoVida"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"MomentoVida","id":"","value":"2"},domProps:{"checked":_vm._q(_vm.MomentoVida,"2")},on:{"change":function($event){_vm.MomentoVida="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MomentoVida),expression:"MomentoVida"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"MomentoVida","id":"","value":"3"},domProps:{"checked":_vm._q(_vm.MomentoVida,"3")},on:{"change":function($event){_vm.MomentoVida="3"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(9)])])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('table',{staticClass:"forms"},[_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.DistribuicaoInvestimento),expression:"DistribuicaoInvestimento"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"DistribuicaoInvesimento","id":"","value":"1"},domProps:{"checked":_vm._q(_vm.DistribuicaoInvestimento,"1")},on:{"change":function($event){_vm.DistribuicaoInvestimento="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(11)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.DistribuicaoInvestimento),expression:"DistribuicaoInvestimento"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"DistribuicaoInvesimento","id":"","value":"2"},domProps:{"checked":_vm._q(_vm.DistribuicaoInvestimento,"2")},on:{"change":function($event){_vm.DistribuicaoInvestimento="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(12)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.DistribuicaoInvestimento),expression:"DistribuicaoInvestimento"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"DistribuicaoInvesimento","id":"","value":"3"},domProps:{"checked":_vm._q(_vm.DistribuicaoInvestimento,"3")},on:{"change":function($event){_vm.DistribuicaoInvestimento="3"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(13)])])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('table',{staticClass:"forms"},[_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SitucaoFinanceira),expression:"SitucaoFinanceira"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"SitucaoFinanceira","id":"","value":"1"},domProps:{"checked":_vm._q(_vm.SitucaoFinanceira,"1")},on:{"change":function($event){_vm.SitucaoFinanceira="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(15)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SitucaoFinanceira),expression:"SitucaoFinanceira"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"SitucaoFinanceira","id":"","value":"2"},domProps:{"checked":_vm._q(_vm.SitucaoFinanceira,"2")},on:{"change":function($event){_vm.SitucaoFinanceira="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(16)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SitucaoFinanceira),expression:"SitucaoFinanceira"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"SitucaoFinanceira","id":"","value":"3"},domProps:{"checked":_vm._q(_vm.SitucaoFinanceira,"3")},on:{"change":function($event){_vm.SitucaoFinanceira="3"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(17)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SitucaoFinanceira),expression:"SitucaoFinanceira"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"SitucaoFinanceira","id":"","value":"4"},domProps:{"checked":_vm._q(_vm.SitucaoFinanceira,"4")},on:{"change":function($event){_vm.SitucaoFinanceira="4"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(18)])])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._m(19),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('table',{staticClass:"forms"},[_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Patrimonio),expression:"Patrimonio"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Patrimonio","id":"","value":"1"},domProps:{"checked":_vm._q(_vm.Patrimonio,"1")},on:{"change":function($event){_vm.Patrimonio="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(20)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Patrimonio),expression:"Patrimonio"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Patrimonio","id":"","value":"2"},domProps:{"checked":_vm._q(_vm.Patrimonio,"2")},on:{"change":function($event){_vm.Patrimonio="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(21)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Patrimonio),expression:"Patrimonio"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Patrimonio","id":"","value":"3"},domProps:{"checked":_vm._q(_vm.Patrimonio,"3")},on:{"change":function($event){_vm.Patrimonio="3"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(22)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Patrimonio),expression:"Patrimonio"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Patrimonio","id":"","value":"4"},domProps:{"checked":_vm._q(_vm.Patrimonio,"4")},on:{"change":function($event){_vm.Patrimonio="4"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(23)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Patrimonio),expression:"Patrimonio"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Patrimonio","id":"","value":"5"},domProps:{"checked":_vm._q(_vm.Patrimonio,"5")},on:{"change":function($event){_vm.Patrimonio="5"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(24)])])])]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":_vm.verificaPreenchimento()}},[_vm._v("Próximo "),_c('img',{attrs:{"src":"/static/assets/images/angle-right.svg"}})])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Questionário")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h2',[_vm._v("1. Avaliação da capacidade de assumir riscos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("a.")]),_vm._v(" Horizonte de investimento: você pretende utilizar um percentual relevante dos seus investimentos no curto ou médio prazo?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Sim, pretendo utilizar um percentual relevante dos meus investimentos no curto prazo (até 1 ano).\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Sim, pretendo utilizar um percentual relevante dos meus investimentos no médio prazo (de 1 a 3 anos).\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Não tenho previsão de utilizar no curto e médio prazo.\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("b.")]),_vm._v(" Momento de vida: Qual das opções abaixo melhor define sua finalidade de investimento?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("Preservação de capital - O objetivo é obter um retorno suficiente para compensar a inflação, mantendo o valor real do capital constante, sem se expor a um nível de risco elevado.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("Geração de renda - O objetivo é obter um retorno constante como fonte de renda, gerando um rendimento regular, aceitando um nível de risco moderado.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("Aumento de capital - O objetivo é obter um retorno acima da inflação, resultando no aumento do capital investido, aceitando incorrer em alto nível de risco.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("c.")]),_vm._v(" Distribuição dos investimentos: Qual o percentual do seu patrimônio você pretende alocar os seus investimentos na IOUU?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("Mais de 25%.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("De 10% a 25%.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("Até 10%.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("d.")]),_vm._v(" Situação financeira: Qual sua renda mensal média declarada?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Até R$ 1.200,00.\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        De R$ 1.200,00 até R$ 4.000,00.\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        De R$ 4.001,00 até R$ 10.000,00.\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Acima de R$ 10.000,00.\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("e.")]),_vm._v(" Qual o valor total do seu patrimônio incluindo aplicações financeiras e outros bens (exceto imóvel que reside)?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Até R$ 50.000,00.\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                       De R$ 50.001,00 a R$ 200.000,00. \n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        De R$ 200.001,00 a R$ 500.000,00. \n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        De R$ 500.001,00 a R$ 1.000.000,00. \n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Acima de R$ 1.000.000,00. \n                                    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hrnj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var Aceite = this.suitability.Aceite;
    return {
      Aceite: Aceite
    };
  },

  props: {
    suitability: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      this.$emit('on-submit', {
        Aceite: this.Aceite
      });
    },
    verificaPreenchimento: function verificaPreenchimento() {

      return this.Aceite != true;
    }
  }
});

/***/ }),

/***/ "htp1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LucroMensalStep_vue__ = __webpack_require__("7M7n");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28ba2bf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LucroMensalStep_vue__ = __webpack_require__("1LI0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LucroMensalStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28ba2bf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LucroMensalStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i/t5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-9 col-xl-9"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-5"},[_c('label',[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nomeCompleto),expression:"nomeCompleto"}],attrs:{"type":"text","required":"","placeholder":"Nome Completo"},domProps:{"value":(_vm.nomeCompleto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nomeCompleto=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',[_vm._v("E-mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"email","required":"","placeholder":"E-mail"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-3"},[_c('label',[_vm._v("Telefone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.telefone),expression:"telefone"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],attrs:{"type":"text","required":"","placeholder":"Telefone"},domProps:{"value":(_vm.telefone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.telefone=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Certo, por favor, forneça os dados do seu contador")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i2jq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderizar)?_c('div',[(_vm.solicitacao != null)?_c('div',{staticClass:"row company-view ",class:_vm.scoreClass},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("Oportunidade "),_c('span',[_vm._v("id#"+_vm._s(_vm.solicitacao.IdOportunidade))])])]),_vm._v(" "),_c('div',{staticClass:"back float-right"},[_c('router-link',{attrs:{"to":"/investimentos/oportunidades","title":"Voltar"}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-8"},[_c('div',{staticClass:"tit"},[_c('div',{staticClass:"float-left"},[_c('h2',[_vm._v(_vm._s(_vm.solicitacao.Ccb.RazaoSocial))]),_vm._v(" "),_c('span',[_vm._v("CNPJ: "+_vm._s(_vm.formatarCnpj(_vm.solicitacao.Documento)))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.formatarTipoEmprestimo(_vm.solicitacao.TipoEmprestimo)))])]),_vm._v(" "),_c('div',{staticClass:"rating float-left float-md-right"},[_c('strong',[_vm._v("Score da operação "),_c('span',{staticClass:"circle score"}),_vm._v(_vm._s(_vm.solicitacao.Score))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('section',[_c('figure',{staticClass:"d-flex justify-content-center align-items-center"},[_c('img',{attrs:{"src":_vm.solicitacao.Ccb.ArquivoBanner,"height":"700"}})]),_vm._v(" "),_c('h4',[_vm._v("Descrição sobre a empresa")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.solicitacao.Ccb.DescricaoEmpresa)}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Dados da empresa")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-3"},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.Ccb.RazaoSocial))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("CPF/CNPJ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatarCnpj(_vm.solicitacao.Documento)))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Nome do responsável")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.Nome))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Nome fantasia")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.Ccb.NomeFantasia))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Telefone comercial")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.TelefoneComercial))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Data de fundação")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMongoDate(_vm.solicitacao.Ccb.DataFundacao)))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Número de funcionários")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.Ccb.QuantidadeEmpregados)+" empregados")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Nome do grupo ecônomico")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.Ccb.NomeGrupoEconomico))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Formato  do Investimeno")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.Ccb.FormatoInvestimento))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('label',[_vm._v("Endereço")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.Ccb.Endereco.Logradouro)+", "+_vm._s(_vm.solicitacao.Ccb.Endereco.Numero)+", "+_vm._s(_vm.solicitacao.Ccb.Endereco.Bairro)+" - "+_vm._s(_vm.solicitacao.Ccb.Endereco.Cep)+", "+_vm._s(_vm.solicitacao.Ccb.Endereco.Cidade)+"/"+_vm._s(_vm.solicitacao.Ccb.Endereco.Uf))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Site")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.Ccb.RedesSociais.Site))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Redes Sociais")]),_vm._v(" "),_c('span',[(_vm.solicitacao.Ccb.RedesSociais.Facebook)?_c('a',{staticClass:"fab fa-facebook-square",attrs:{"href":_vm.facebookLink}}):_vm._e(),_vm._v(" "),(_vm.solicitacao.Ccb.RedesSociais.Twitter)?_c('a',{staticClass:"fab fa-twitter",attrs:{"href":_vm.twitterLink}}):_vm._e(),_vm._v(" "),(_vm.solicitacao.Ccb.RedesSociais.Instagram)?_c('a',{staticClass:"fab fa-instagram",attrs:{"href":_vm.instagramLink}}):_vm._e(),_vm._v(" "),(_vm.solicitacao.Ccb.RedesSociais.Vimeo)?_c('a',{staticClass:"fab fa-vimeo-v",attrs:{"href":_vm.vimeoLink}}):_vm._e()])]),_vm._v(" "),(_vm.formatoInvestimento)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-secondary",attrs:{"role":"alert"}},[_c('strong',[_vm._v("Formato do Investimento:")]),_vm._v("  "+_vm._s(_vm.formatoInvestimento)+"\n\t\t\t\t\t\t\t\t")])]):_vm._e()]),_vm._v(" "),_c('h4',[_vm._v("Índices finaneiros")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-3"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Taxa bruta de rendimento")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.solicitacao.Ccb.TaxaBrutaRendimento)+"% do CDI")])])])]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("Motivo da solicitação do empréstimo")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.solicitacao.Motivo))])]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("Garantias oferecidas")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.solicitacao.Garantia))])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('aside',{staticClass:"col-12 col-lg-4"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row no-gutters dates"},[_c('div',{staticClass:"col-12 col-sm-6"},[_c('img',{attrs:{"src":"/static/assets/images/ico-calendar_ok.svg"}}),_vm._v(" "),_c('label',[_vm._v("Início")]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.formatMongoDate(_vm.solicitacao.InicioCaptacao)))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('img',{attrs:{"src":"/static/assets/images/ico-calendar_end.svg"}}),_vm._v(" "),_c('label',[_vm._v("Término")]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.formatMongoDate(_vm.solicitacao.FimCaptacao)))])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('label',[_vm._v("Valor solicitado")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.solicitacao.Valor)))])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-6 text-center"},[_c('label',[_vm._v("Rating")]),_vm._v(" "),_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.solicitacao.Score))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-6 text-center"},[_c('label',[_vm._v("Duração esperada")]),_vm._v(" "),(_vm.solicitacao.PrazoDias > 1)?_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.solicitacao.PrazoDias)+" Dias")]):_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.solicitacao.Prazo)+" Meses")])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row no-gutters text-center"},[_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v(_vm._s(_vm.calcDiasRestantes()))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix itens"},[_c('span',{staticClass:"float-left"},[_vm._v("Levantado: "+_vm._s(_vm.formatCurrency(_vm.solicitacao.ValorCaptado)))]),_vm._v(" "),_c('span',{staticClass:"float-right"},[_vm._v("Faltam: "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.calcValorRestante())))])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:('width:' + _vm.calcPercValorRestante() + '%;'),attrs:{"role":"progressbar","aria-valuenow":"50","aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"progress-value"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.calcPercValorRestante()))+"%")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"info__invest"},[_c('strong',[_vm._v(_vm._s(_vm.qtdeInvestidores))]),_vm._v(" investidores")])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),(_vm.canInvest)?_c('div',{staticClass:"row no-gutters text-center"},[(!_vm.solicitacao.JaInvestiu)?_c('div',{staticClass:"col-12 text-center"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.investir(_vm.solicitacao._id, _vm.valueToInvest)}}},[(_vm.ccbAberta)?_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueToInvest),expression:"valueToInvest"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"id":"valor","placeholder":'Investimento mínimo R$ '+_vm.formatCurrency(_vm.solicitacao.Valor)},domProps:{"value":(_vm.valueToInvest)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valueToInvest=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.ccbAberta)?_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"type":"submit"}},[_vm._v("Investir")]):_c('button',{staticClass:"btn btn-primary btn-lg btn-block",staticStyle:{"background-color":"gray"},attrs:{"type":"button"}},[_vm._v("Encerrado")])]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("** Ao chegar em 100% do valor solicitado, a solicitação é encerrada imediatamente e o pagamento do valor investido deve ser realizado em até 24 horas.\n\t\t\t\t\t\t\t\t")])]):_c('div',{staticClass:"confirm"},[_c('img',{attrs:{"src":"/static/assets/images/ico-confirm.svg","alt":"icone de confirmação"}}),_vm._v(" "),_vm._m(2)])]):_c('div',{staticClass:"form-row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"alert alert_reserve alert-warning text-center",staticStyle:{"width":"100%"}},[_c('h2',[_vm._v("Falta pouco para você investir")]),_vm._v(" "),_c('div',[(_vm.temCadastroInvestidor && _vm.temSuitability && !_vm.investidorAprovado)?_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v("Agora estamos analisando suas informações e retornaremos em até 1 dia útil.")]):_c('p',[(!_vm.temCadastroInvestidor)?_c('router-link',{staticStyle:{"font-size":"20px"},attrs:{"to":"/informacoes-adicionais/investidor"}},[_vm._v("Complete o cadastro de investidor")]):_vm._e(),_c('br'),_vm._v(" "),(!_vm.temSuitability)?_c('router-link',{staticStyle:{"font-size":"20px"},attrs:{"to":"/informacoes-adicionais/suitability"}},[_vm._v("Preencha o formulário de suitability")]):_vm._e()],1)])])])])])])])]):_vm._e()]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Empresa "),_c('span',[_vm._v("(Razão social)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Tipo de empréstimo")]),_vm._v(" "),_c('p',[_vm._v("CCB")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\tInvestimento registrado com sucesso."),_c('br'),_vm._v(" "),_c('small',[_vm._v("Você receberá um boleto por email para confirmar o pagamento. O seu pagamento pode ser confirmado em até 48 horas.\n\t\t\t\t\t\t\t\t\t")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i7i+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordField_vue__ = __webpack_require__("0OZz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2478564_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordField_vue__ = __webpack_require__("T1H7");
function injectStyle (ssrContext) {
  __webpack_require__("k0rk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c2478564"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2478564_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iIp0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      razaoSocial: this.solicitacao.Empresa.RazaoSocial
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    submitWithCorporateGroup: function submitWithCorporateGroup() {
      this.$emit('on-submit', { Empresa: { TemInscricaoEstadual: true } });
    },
    submitWithoutCorporateGroup: function submitWithoutCorporateGroup() {
      this.$emit('on-submit', { Empresa: { TemInscricaoEstadual: false } });
    }
  }
});

/***/ }),

/***/ "iR/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CCBList_vue__ = __webpack_require__("ZeN0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e5ff2a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CCBList_vue__ = __webpack_require__("+kyS");
function injectStyle (ssrContext) {
  __webpack_require__("8dK4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e5ff2a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CCBList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e5ff2a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CCBList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iTlq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v(_vm._s(_vm.stepTitle))]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-link",attrs:{"type":"button"},on:{"click":function($event){_vm.showPartnerType = true}}},[_c('span',{staticClass:"icon icon-plus-circle"}),_vm._v(" Adicionar avalista")])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-11 col-xl-11"},[_c('form',{on:{"submit":_vm.onSubmit}},[_vm._l((_vm.avalistas),function(avalista,index){return _c('div',{key:("partnerFields" + index),staticClass:"form-row"},[_c('div',{staticClass:"col-md-11"},[(avalista.Tipo == 2)?_c('company-fields',{attrs:{"partner":avalista}}):_c('person-fields',{attrs:{"partner":avalista}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-1 align-self-center text-center"},[(!_vm.isMei)?_c('a',{staticClass:"icon icon-minus-circle remove",attrs:{"title":"Remover avalista"},on:{"click":function($event){return _vm.removePartner(index)}}}):_vm._e()])])}),_vm._v(" "),_c('div',{staticClass:"btns text-center"},[(!_vm.isMei)?_c('button',{staticClass:"btn btn-lg btn-link",attrs:{"type":"button"},on:{"click":function($event){_vm.showPartnerType = true}}},[_c('span',{staticClass:"icon icon-plus-circle"}),_vm._v(" Adicionar avalista")]):_vm._e(),_vm._v(" "),(_vm.showPartnerType)?_c('at-select',{attrs:{"size":"large","placeholder":"Tipo de Avalista"},on:{"on-change":_vm.addPartner}},[_c('at-option',{attrs:{"value":"1"}},[_vm._v("Pessoa Física")]),_vm._v(" "),_c('at-option',{attrs:{"value":"2"}},[_vm._v("Pessoa Jurídica")])],1):_vm._e(),_vm._v(" "),_vm._m(0)],1)],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iUw6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finishedLoading)?_c('div',[(_vm.solicitacao != null)?_c('div',{staticClass:"row loans-details",class:_vm.scoreClass},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("\n\t\t\t\t\t\t\tMeus empréstimos\n\t\t\t\t\t\t\t"),_c('strong',[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.Document)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t#"+_vm._s(_vm.ajustIdOportunidade(_vm.id,5))+" \n\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"options float-right"},[_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"back"},[_vm._v("\n\t\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',[_vm._v("\n\t\t\t\t\t\t\t\tVoltar\n\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.type == 'EMPCOL')?_c('detalhes-coletivo',{attrs:{"id":_vm.solicitacaoId}}):_vm._e(),_vm._v(" "),(_vm.type == 'EMPIMP')?_c('detalhes-impacto',{attrs:{"id":_vm.solicitacaoId}}):_vm._e(),_vm._v(" "),(_vm.type == 'EMPSOC')?_c('detalhes-impacto',{attrs:{"id":_vm.solicitacaoId}}):_vm._e(),_vm._v(" "),(_vm.type == 'EMPCCB')?_c('detalhes-ccb',{attrs:{"id":_vm.solicitacaoId}}):_vm._e(),_vm._v(" "),(!_vm.boletos)?_c('aside',{staticClass:"col-12 col-md-4 col-lg-4"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.boletos)?_c('aside',{staticClass:"col-12 col-md-4 col-lg-4"},[_c('div',{staticClass:"box-td"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.faturas),function(fatura,index){return _c('tr',{key:index},[_c('td',{staticClass:"align-middle"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(fatura.IndiceFatura + 1)+"\n\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(fatura.Boleto.total)+"\n\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formatDate(fatura.Boleto.due_date))+"\n\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(fatura.HistoricoBoletos)?_c('a',{attrs:{"href":fatura.HistoricoBoletos[fatura.HistoricoBoletos.length - 1].secure_url,"target":"_blank"}},[_c('i',{staticClass:"fas fa-barcode"})]):_c('a',{attrs:{"href":fatura.Boleto.secure_url,"target":"_blank"}},[_c('i',{staticClass:"fas fa-barcode"})])]),_vm._v(" "),_c('td',{staticClass:"status align-middle text-center",class:_vm.getFaturaStatusClass(fatura)},[_c('span',{staticClass:"sts md"})])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('router-link',{staticClass:"btn btn-primary btn-block all-billets",attrs:{"to":'/emprestimos/boletos?id='+this.solicitacaoId,"title":"Visualizar todos os boletos"}},[_vm._v("\n\t\t\t\t\t\t\t\t\tVisualizar todos os boletos\n\t\t\t\t\t\t\t\t")])],1)])])]):_vm._e()],1)])]):_vm._e()]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row noTickets"},[_c('div',{staticClass:"tit text-center"},[_c('h2',[_vm._v("\n\t\t\t\t\t\t\t\tAguarde os boletos serem gerados!\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('i',{staticClass:"fas fa-barcode"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"float-left"},[_c('h6',[_c('i',{staticClass:"fas fa-barcode"}),_vm._v(" "),_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\tBoletos\n\t\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"float-right"},[_c('div',{staticClass:"title-lg status qt"},[_c('span',{staticClass:"sts sm"}),_vm._v(" "),_c('label',[_vm._v("Quitado")])]),_vm._v(" "),_c('div',{staticClass:"title-lg status vc"},[_c('span',{staticClass:"sts sm"}),_vm._v(" "),_c('label',[_vm._v("Vencido")])]),_vm._v(" "),_c('div',{staticClass:"title-lg status av"},[_c('span',{staticClass:"sts sm"}),_vm._v(" "),_c('label',[_vm._v("A vencer")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"align-middle",attrs:{"scope":"col","width":"38"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tParc.\n\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":""}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tValor\n\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"95"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tVenc.\n\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"50"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tBoleto\n\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"50"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tStatus\n\t\t\t\t\t\t\t\t\t\t")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iWKg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import ArrayHelper from '@/utils/array-helper'


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            senhaAtual: '',
            senhaNova: '',
            confirmacaoSenhaNova: '',
            id: '',
            existesenha: true
        };
    },

    methods: {
        Nome: function Nome() {
            var nome = "";

            if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
                nome = this.User.username;
            } else {
                nome = this.User.name;
            }

            nome = nome.trim();
            this.existesenha = this.User.HasPass;
            return nome;
        },
        Email: function Email() {
            var email = " ";

            if (this.User.email == undefined || this.User.email == null || this.User.email == "") {
                email = this.User.username;
            } else {
                email = this.User.email;
            }

            return email;
        },
        alterarSenha: function alterarSenha() {
            var _this = this;

            var data = this;

            data.id = this.User._id;

            if (data.senhaNova === '' || data.confirmacaoSenhaNova === '' || data.senhaAtual === '') this.$Notify.error('Preencha todos os campos de senha.');else if (data.senhaNova === data.confirmacaoSenhaNova) {

                __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].alterarSenha(data).then(function (result) {
                    if (result.status == 200) {
                        // sucesso
                        _this.$Notify.info('A sua senha foi atualizada com sucesso.');

                        data.senhaNova = '';
                        data.senhaAtual = '';
                        data.confirmacaoSenhaNova = '';
                    } else {
                        _this.$Notify.error(result.data.msg);
                    }
                }).catch(function () {
                    _this.$Notify.error('A senha atual não confere.');
                });
            } else {
                this.$Notify.error('As senhas não conferem.');
            }
        },
        cadastrarSenha: function cadastrarSenha() {
            var _this2 = this;

            var data = this;

            data.id = this.User._id;

            if (data.senhaNova === '' || data.confirmacaoSenhaNova === '') this.$Notify.error('Preencha todos os campos de senha.');else if (data.senhaNova === data.confirmacaoSenhaNova) {

                __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].cadastrarSenha(data).then(function (result) {
                    if (result.status == 200) {
                        // sucesso
                        _this2.$Notify.info('A sua senha foi atualizada com sucesso.');
                        _this2.$store.dispatch('updateUser');
                        _this2.existesenha = true;

                        data.senhaNova = '';
                        data.senhaAtual = '';
                        data.confirmacaoSenhaNova = '';
                    } else {
                        _this2.$Notify.error(result.data.msg);
                    }
                }).catch(function () {
                    _this2.$Notify.error('A senha atual não confere.');
                });
            } else {
                this.$Notify.error('As senhas não conferem.');
            }
        },
        IsInvestidor: function IsInvestidor() {
            return document.URL.indexOf("investimentos") != -1;
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/perfil/dados-pessoais',
                title: 'Dados Pessoais'
            });
        }
    },

    computed: {
        User: function User() {
            return this.$store.state.currentUser;
        }
    },
    created: function created() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this3.taggingGA();

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this3);
        }))();
    }
});

/***/ }),

/***/ "iWrZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    var social = this.currentUser.Social;
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: social.ArquivoDeclaracaoMei || [null]
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.arquivos.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.arquivos, index, null);
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio da Declaração do MEI é obrigatória'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {

        this.currentUser.Social.ArquivoDeclaracaoMei = this.arquivosRecebidos;

        this.$emit('on-submit', { Social: this.currentUser.Social });
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "ia75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_BarChart__ = __webpack_require__("gxv5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Carousel__ = __webpack_require__("mfOW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CompanyProfile_InvestmentReservationForm__ = __webpack_require__("yyPQ");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import Promise from 'promise'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { BarChart: __WEBPACK_IMPORTED_MODULE_5__components_charts_BarChart__["a" /* default */], Carousel: __WEBPACK_IMPORTED_MODULE_6__components_Carousel__["a" /* default */], InvestmentReservationForm: __WEBPACK_IMPORTED_MODULE_9__components_CompanyProfile_InvestmentReservationForm__["a" /* default */] },
  data: function data() {
    return {
      finishedLoading: false,
      solicitacao: {
        ValorCaptado: null,
        QuantidadeReservasInvestimento: null
      },
      investmentReservation: null,
      googleMapsKey: this.$config.googleApi.googleMapsKey,
      showQueueForm: false,
      minPercentToQueue: this.$config.investment.minPercentToQueue,
      investmentConfirmed: false,
      sDisponivel: 0
    };
  },


  computed: {
    id: function id() {
      return this.ajustIdOportunidade(this.solicitacao.IdOportunidade, 5);
    },
    company: function company() {
      return this.solicitacao.Empresa;
    },
    nomeFantasia: function nomeFantasia() {
      return this.company && this.company.NomeFantasia;
    },
    razaoSocial: function razaoSocial() {
      return this.company && this.company.RazaoSocial;
    },
    formattedCnpj: function formattedCnpj() {
      return __WEBPACK_IMPORTED_MODULE_7__utils_masker__["a" /* default */].maskCnpj(this.solicitacao.Documento);
    },
    loanType: function loanType() {
      return this.solicitacao.TipoEmprestimo;
    },
    scoreClass: function scoreClass() {
      if (!this.solicitacao.Score) return "";
      return "rating-" + this.solicitacao.Score.replace(/\d/, '').toLowerCase();
    },
    score: function score() {
      return this.solicitacao.Score;
    },
    companyDescription: function companyDescription() {
      return this.company && this.company.InformacaoInstitucional;
    },
    telefoneComercial: function telefoneComercial() {
      return this.solicitacao.TelefoneComercial;
    },
    dataFundacao: function dataFundacao() {
      return this.company && this.company.DataFundacao.toLocaleDateString('pt-BR');
    },
    quantidadeEmpregados: function quantidadeEmpregados() {
      return this.company && this.company.QuantidadeEmpregados;
    },
    nomeGrupoEconomico: function nomeGrupoEconomico() {
      if (!this.company) return null;
      return this.company.NomeGrupoEconomico != "" ? this.company.NomeGrupoEconomico : 'Não pertence a nenhum grupo econômico';
    },
    address: function address() {
      if (!this.company) return null;
      var address = this.company.Endereco;
      var complement = this.company.Endereco.Complemento && this.company.Endereco.Complemento.length > 0 ? " - " + this.company.Endereco.Complemento : "";
      return address.Logradouro + ', ' + address.Numero + complement + ', ' + address.Bairro + ' - ' + address.Cep + ', ' + address.Cidade + '/' + address.Uf;
    },
    motivoSolicitacao: function motivoSolicitacao() {
      return this.solicitacao.Motivo;
    },
    garantiasOferecidas: function garantiasOferecidas() {

      return this.solicitacao.TipoGarantia != "" ? this.solicitacao.TipoGarantia : "Não possui nenhum tipo de garantia";
    },
    faturamentoAnual: function faturamentoAnual() {
      if (!this.solicitacao) return null;
      return this.formatCurrency(this.solicitacao.Faturamento);
    },
    lucroLiquido: function lucroLiquido() {
      if (!this.company) return null;
      return this.formatCurrency(this.company.LucroMensal);
    },
    divida: function divida() {
      return this.company.ValorDividaBancaria != 0 ? "R$ " + this.formatCurrency(this.company.ValorDividaBancaria) : "Nada consta";
    },
    dataConsultaEndividamento: function dataConsultaEndividamento() {
      var date = this.company.DataConsultaEndividamento;

      return this.company.DataConsultaEndividamento ? (date.getMonth() + 1).toString().padStart(2, "0") + '/' + date.getFullYear() : "";
    },
    analiseEmpresa: function analiseEmpresa() {
      return this.solicitacao.AnaliseEmpresa;
    },
    nomeSolicitante: function nomeSolicitante() {
      return this.solicitacao.Solicitante.NomeCompleto;
    },
    chartData: function chartData() {
      return this.company.FaturamentoDozeMeses.map(function (item) {
        return {
          label: item.Mes.slice(0, 3) + "/" + item.Ano.toString().slice(2, 4),
          value: item.Valor
        };
      });
    },
    site: function site() {
      return this.company.Site;
    },
    mapUrl: function mapUrl() {
      return 'https://www.google.com/maps/embed/v1/place?q=' + this.address + '&key=' + this.googleMapsKey;
    },
    companyFacebook: function companyFacebook() {
      return this.solicitacao.Empresa.Facebook;
    },
    companyTwitter: function companyTwitter() {
      return this.solicitacao.Empresa.Twitter;
    },
    companyLinkedin: function companyLinkedin() {
      return this.solicitacao.Empresa.Linkedin;
    },
    companyInstagram: function companyInstagram() {
      return this.solicitacao.Empresa.Instagram;
    },
    companyVimeo: function companyVimeo() {
      return this.solicitacao.Empresa.Vimeo;
    },
    formatoInvestimento: function formatoInvestimento() {
      return this.solicitacao.FormatoInvestimento;
    },
    negativacoes: function negativacoes() {
      return this.solicitacao.Empresa.Negativacoes || "Nada consta";
    },
    atrasos: function atrasos() {
      return this.formatCurrency(this.solicitacao.Empresa.Atrasos) || "0,00";
    },
    pictures: function pictures() {
      return this.solicitacao.Empresa.Imagens;
    },
    vimeoVideoUrl: function vimeoVideoUrl() {
      return this.solicitacao.Empresa.VimeoVideoUrl;
    }
  },
  methods: {
    formatarTipoEmprestimo: function formatarTipoEmprestimo(tipoEmprestimo) {

      if (tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2") {
        return "Impacto";
      }

      var splitedTipoEmprestimo = tipoEmprestimo.split('-');

      if (splitedTipoEmprestimo.length > 1) {
        return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
      }

      return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);
    },
    ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
      var s = String(id);
      while (s.length < (qtd || 2)) {
        s = "0" + s;
      }
      return s;
    },
    submitInvestment: function submitInvestment(investmentReservation) {
      var _this = this;

      if (!investmentReservation._id && this.investmentReservation) investmentReservation._id = this.investmentReservation._id;

      if (investmentReservation._id) {
        __WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].updateInvestmentReservation(investmentReservation).then(function () {
          setTimeout(function () {
            return _this.updateLoanRequest();
          }, 500);
          _this.investmentConfirmed = true;
          _this.$store.dispatch('updateUser');
        }).catch(function (error) {
          var errorMessages = error.response ? error.response.data.errors.map(function (error) {
            return error.detail;
          }) : error.message;
          _this.$Notify.error(__WEBPACK_IMPORTED_MODULE_8__utils_array_helper__["a" /* default */].toSentence(errorMessages));
          _this.investmentConfirmed = false;
        });
      } else {

        __WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].createInvestmentReservation({
          loanRequestId: this.solicitacao._id,
          investmentReservation: investmentReservation
        }).then(function () {
          setTimeout(function () {
            return _this.updateLoanRequest();
          }, 500);
          _this.investmentConfirmed = true;
          _this.$store.dispatch('updateUser');
        }).catch(function (error) {
          var errorMessages = error.response ? error.response.data.errors.map(function (error) {
            return error.detail;
          }) : error.message;
          _this.$Notify.error(__WEBPACK_IMPORTED_MODULE_8__utils_array_helper__["a" /* default */].toSentence(errorMessages));
          _this.investmentConfirmed = false;
        });
      }
    },
    formatCurrency: function formatCurrency(value) {

      if (value == null || value == undefined) return parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });

      return value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
    },
    updateLoanRequest: function updateLoanRequest() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].getLoanRequest(this.solicitacaoId).then(function (loanRequest) {
        _this2.solicitacao = loanRequest;

        __WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].getInvestmentReservation({ loanRequestId: _this2.solicitacaoId }).then(function (investmentReservation) {
          _this2.investmentReservation = investmentReservation || { Valor: 0 };
        });
      });
    },
    voltarLink: function voltarLink() {
      var separador = window.location.href.split("#");
      if (separador.length > 2) {
        return "#" + separador[2];
      }

      return "";
    },
    diffDate: function diffDate(d1, d2) {
      var miliSecs = 0;

      if (d1 == "") miliSecs = new Date(d2) - new Date();else miliSecs = new Date(d2) - new Date(d1);

      var diffDays = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(miliSecs / 1000 / 60 / 60 / 24);

      if (diffDays < 0) return "encerrado";
      if (diffDays == 0) return "hoje";

      return diffDays + " dias";
    },


    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/oportunidades/perfil-empresa-old/:id',
        title: 'Empresa'
      });
    }
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('updateUser');
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var x;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this3.solicitacaoId = _this3.$route.params.id;

              if (typeof _this3.$store.state.currentUser.investor.Bloqueio != 'undefined') {
                window.location.href = "#/";
              }

              //ajuste modal
              if (document.getElementsByTagName("main").length > 0) document.getElementsByTagName("main")[0].style.zIndex = "0";

              _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);

              __WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].getInvestmentReservation({ loanRequestId: _this3.solicitacaoId }).then(function (investmentReservation) {
                _this3.investmentReservation = investmentReservation;
                if (investmentReservation != null) _this3.investmentConfirmed = true;

                __WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].getMyAvalibleMoney().then(function (item) {

                  item.data.credito = item.data.credito.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
                  var credito = parseFloat(item.data.credito);

                  item.data.debito = item.data.debito.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
                  var debito = parseFloat(item.data.debito);

                  _this3.sDisponivel = credito - debito;
                  _this3.sDisponivel = parseFloat(_this3.sDisponivel.toFixed(2));

                  if (_this3.sDisponivel < 0.01) {
                    _this3.sDisponivel = 0;
                  }

                  if (_this3.investmentReservation != null && _this3.investmentReservation.ReInvestimento > 0) {
                    _this3.sDisponivel += _this3.investmentReservation.ReInvestimento;
                  }
                });
              });

              x = __WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].getLoanRequest(_this3.solicitacaoId).then(function (loanRequest) {
                _this3.solicitacao = loanRequest;

                loanRequest.Encerrado = loanRequest.StatusAnalise == "ENCERRADO" || _this3.diffDate("", loanRequest.FimCaptacao) == "encerrado";

                _this3.solicitacao = loanRequest;
              });


              x.then(function () {
                _this3.finishedLoading = true;
                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
              }).catch(function () {
                _this3.finishedLoading = true;
                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
              });

              //tagueamento GA
              _context.next = 9;
              return _this3.taggingGA();

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),

/***/ "ib30":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_client_go__ = __webpack_require__("879M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_BarChartInvestimentos__ = __webpack_require__("Levr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { BarChart: __WEBPACK_IMPORTED_MODULE_5__components_charts_BarChartInvestimentos__["a" /* default */] },
    data: function data() {
        return {
            Estatistica: null,
            Criou: false,
            Valor: true,
            Renderizou: false
        };
    },

    methods: {
        money: function money(n) {
            var c = 2,
                d = ",",
                t = ".",
                s = n < 0 ? "-" : "",
                i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        },
        porcentagem: function porcentagem(n) {
            var c = 1,
                d = ",",
                t = ".",
                s = n < 0 ? "-" : "",
                i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        },
        Atualizacao: function Atualizacao(data) {

            var Data = void 0;
            var Ano = void 0;
            var Mes = void 0;
            var Dia = void 0;

            var meses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

            Data = data.split("-");
            Ano = Data[0];
            Mes = parseInt(Data[1]);
            Dia = Data[2].split("T");

            return Dia[0] + " de " + meses[Mes - 1] + " de " + Ano;
        },
        CriarGrafico: function CriarGrafico() {

            //Gráfico de Propósito
            new Chart(document.getElementById("GraficoProposito"), {
                type: 'doughnut',
                data: {
                    labels: ["Expansão da empresa", "Capital de giro", "Compra de estoque", "Refinanciamento de dívidas", "Aquisição de máquinas e equipamentos", "Outros"],
                    datasets: [{
                        label: ["Teste"],
                        backgroundColor: ["#CB4757", "#ED7112", "#F1CE30", "#3D9998", "#3B5E6E", "#2DC2BF"],
                        data: [this.Estatistica.Proposito[0], this.Estatistica.Proposito[1], this.Estatistica.Proposito[2], this.Estatistica.Proposito[3], this.Estatistica.Proposito[4], this.Estatistica.Proposito[5]],
                        borderWidth: [0, 0, 0, 0, 0, 0]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function label(tooltipItems, data) {
                                return (data.labels[tooltipItems.index] + ' - ' + data.datasets[0].data[tooltipItems.index].toLocaleString('pt-BR', { minimumFractionDigits: "1", maximumFractionDigits: 1, style: 'currency', currency: 'BRL' }) + " %").replace("R$", "");
                            }
                        }
                    },
                    responsive: true,
                    legend: {
                        position: "bottom",
                        display: false,
                        labels: {
                            padding: 30
                        }
                    },
                    cutoutPercentage: 55
                }
            });

            //Gráfico de Idade
            new Chart(document.getElementById("GraficoIdade"), {
                type: 'doughnut',
                data: {
                    labels: ["Até 1 ano", "de 2 a 3 anos", "de 4 a 5 anos", "de 6 a 7 anos", "de 8 a 9 anos", "Acima de 10 anos"],
                    datasets: [{
                        label: ["Teste"],
                        backgroundColor: ["#CB4757", "#ED7112", "#F1CE30", "#3D9998", "#3B5E6E", "#2DC2BF"],
                        data: [this.Estatistica.Idade[0], this.Estatistica.Idade[1], this.Estatistica.Idade[2], this.Estatistica.Idade[3], this.Estatistica.Idade[4], this.Estatistica.Idade[5]],
                        borderWidth: [0, 0, 0, 0, 0, 0]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function label(tooltipItems, data) {
                                return (data.labels[tooltipItems.index] + ' - ' + data.datasets[0].data[tooltipItems.index].toLocaleString('pt-BR', { minimumFractionDigits: "1", maximumFractionDigits: 1, style: 'currency', currency: 'BRL' }) + " %").replace("R$", "");
                            }
                        }
                    },
                    responsive: true,
                    legend: {
                        position: "bottom",
                        display: false,
                        labels: {
                            padding: 30
                        }
                    },
                    cutoutPercentage: 55
                }
            });

            //Gráfico de Tipo de do Empréstimo
            new Chart(document.getElementById("GraficoTipoEmprestimo"), {
                type: 'doughnut',
                data: {
                    labels: ["Empréstimo Coletivo", "Empréstimo de Impacto", "Empréstimo Social"],
                    datasets: [{
                        label: ["Teste"],
                        backgroundColor: ["#ED7112", "#F1CE30", "#3D9998"],
                        data: [this.Estatistica.TipoEmprestimo[0], this.Estatistica.TipoEmprestimo[1], this.Estatistica.TipoEmprestimo[2]],
                        borderWidth: [0, 0, 0]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function label(tooltipItems, data) {
                                return (data.labels[tooltipItems.index] + ' - ' + data.datasets[0].data[tooltipItems.index].toLocaleString('pt-BR', { minimumFractionDigits: "1", maximumFractionDigits: 1, style: 'currency', currency: 'BRL' }) + " %").replace("R$", "");
                            }
                        }
                    },
                    responsive: true,
                    legend: {
                        position: "bottom",
                        display: false,
                        labels: {
                            padding: 30
                        }
                    },
                    cutoutPercentage: 55
                }
            });

            //Gráfico de emrpéstimos Realizados
            var Contexto = document.getElementById('GraficoEmprestimosRealizados').getContext('2d');

            var Gradiente = Contexto.createLinearGradient(0, 0, 0, 600);
            Gradiente.addColorStop(0, '#61539D');
            Gradiente.addColorStop(1, '#474075');

            new Chart(Contexto, {
                type: "bar",
                data: {
                    labels: [this.Estatistica.EmprestimosRealizados[0].Label, this.Estatistica.EmprestimosRealizados[1].Label, this.Estatistica.EmprestimosRealizados[2].Label, this.Estatistica.EmprestimosRealizados[3].Label, this.Estatistica.EmprestimosRealizados[4].Label, this.Estatistica.EmprestimosRealizados[5].Label, this.Estatistica.EmprestimosRealizados[6].Label, this.Estatistica.EmprestimosRealizados[7].Label, this.Estatistica.EmprestimosRealizados[8].Label, this.Estatistica.EmprestimosRealizados[9].Label, this.Estatistica.EmprestimosRealizados[10].Label, this.Estatistica.EmprestimosRealizados[11].Label],
                    datasets: [{
                        // label: this.Estatistica.EmprestimosRealizados[0].Label,
                        backgroundColor: [Gradiente, Gradiente, Gradiente, Gradiente, Gradiente, Gradiente, Gradiente, Gradiente, Gradiente, Gradiente, Gradiente, Gradiente],
                        hoverBackgroundColor: Gradiente,
                        data: [this.Estatistica.EmprestimosRealizados[0].Valor, this.Estatistica.EmprestimosRealizados[1].Valor, this.Estatistica.EmprestimosRealizados[2].Valor, this.Estatistica.EmprestimosRealizados[3].Valor, this.Estatistica.EmprestimosRealizados[4].Valor, this.Estatistica.EmprestimosRealizados[5].Valor, this.Estatistica.EmprestimosRealizados[6].Valor, this.Estatistica.EmprestimosRealizados[7].Valor, this.Estatistica.EmprestimosRealizados[8].Valor, this.Estatistica.EmprestimosRealizados[9].Valor, this.Estatistica.EmprestimosRealizados[10].Valor, this.Estatistica.EmprestimosRealizados[11].Valor]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        displayColors: false,
                        callbacks: {
                            label: function label(tooltipItems, data) {

                                return '  R$ ' + tooltipItems.yLabel.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
                            }
                        }
                    },
                    legend: {
                        display: false,
                        position: "bottom",
                        labels: {
                            padding: 25
                        }
                    },
                    title: {
                        display: false,
                        text: 'Empréstimos Realizados'
                    },
                    responsive: true,
                    scales: {
                        xAxes: [{
                            gridLines: {
                                display: false
                            },
                            categoryPercentage: 1
                        }],
                        yAxes: [{
                            gridLines: {
                                display: true
                            },
                            ticks: {
                                beginAtZero: true,
                                callback: function callback(label, index, labels) {
                                    if (label == '0') {
                                        return '0';
                                    }
                                    return 'R$ ' + label.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
                                }
                            }
                        }]
                    }
                }
            });

            //Gráfico de Empréstimos Realizados Porcentagem
            var Contexto = document.getElementById('GraficoEmprestimosRealizadosPorcentagem').getContext('2d');

            var Gradiente = Contexto.createLinearGradient(0, 0, 0, 600);
            Gradiente.addColorStop(0, '#61539D');
            Gradiente.addColorStop(1, '#474075');

            new Chart(Contexto, {
                type: "bar",
                data: {
                    labels: [this.Estatistica.EmprestimosRealizadosPorcentagem[0].Label, this.Estatistica.EmprestimosRealizadosPorcentagem[1].Label, this.Estatistica.EmprestimosRealizadosPorcentagem[2].Label, this.Estatistica.EmprestimosRealizadosPorcentagem[3].Label, this.Estatistica.EmprestimosRealizadosPorcentagem[4].Label, this.Estatistica.EmprestimosRealizadosPorcentagem[5].Label, this.Estatistica.EmprestimosRealizadosPorcentagem[6].Label, this.Estatistica.EmprestimosRealizadosPorcentagem[7].Label, this.Estatistica.EmprestimosRealizadosPorcentagem[8].Label, this.Estatistica.EmprestimosRealizadosPorcentagem[9].Label, this.Estatistica.EmprestimosRealizadosPorcentagem[10].Label, this.Estatistica.EmprestimosRealizadosPorcentagem[11].Label],
                    datasets: [{
                        label: this.Estatistica.EmprestimosRealizadosPorcentagem[0].Label,
                        backgroundColor: [Gradiente, Gradiente, Gradiente, Gradiente, Gradiente, Gradiente, Gradiente, Gradiente, Gradiente, Gradiente, Gradiente, Gradiente],
                        hoverBackgroundColor: Gradiente,
                        data: [this.Estatistica.EmprestimosRealizadosPorcentagem[0].Valor, this.Estatistica.EmprestimosRealizadosPorcentagem[1].Valor, this.Estatistica.EmprestimosRealizadosPorcentagem[2].Valor, this.Estatistica.EmprestimosRealizadosPorcentagem[3].Valor, this.Estatistica.EmprestimosRealizadosPorcentagem[4].Valor, this.Estatistica.EmprestimosRealizadosPorcentagem[5].Valor, this.Estatistica.EmprestimosRealizadosPorcentagem[6].Valor, this.Estatistica.EmprestimosRealizadosPorcentagem[7].Valor, this.Estatistica.EmprestimosRealizadosPorcentagem[8].Valor, this.Estatistica.EmprestimosRealizadosPorcentagem[9].Valor, this.Estatistica.EmprestimosRealizadosPorcentagem[10].Valor, this.Estatistica.EmprestimosRealizadosPorcentagem[11].Valor]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        displayColors: false,
                        callbacks: {
                            label: function label(tooltipItems, data) {
                                return "  " + tooltipItems.yLabel.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }) + '% ';
                            }
                        }
                    },
                    legend: {
                        display: false,
                        position: "bottom",
                        labels: {
                            padding: 25
                        }
                    },
                    title: {
                        display: false,
                        text: 'Empréstimos Realizados'
                    },
                    responsive: true,
                    scales: {
                        xAxes: [{
                            gridLines: {
                                display: false
                            },
                            categoryPercentage: 1
                        }],
                        yAxes: [{
                            gridLines: {
                                display: true
                            },
                            ticks: {
                                beginAtZero: true,
                                max: 100,
                                callback: function callback(label, index, labels) {
                                    if (label == '0') {
                                        return '0';
                                    }
                                    return label + "%";
                                }
                            }
                        }]
                    }
                }
            });

            //Gráfico de Taxa de inadimplência por região
            new Chart(document.getElementById("GraficoTaxaInadimplencia"), {
                type: 'bar',
                data: {
                    labels: ["Norte", "Nordeste", "Centro-Oeste", "Sudeste", "Sul"],
                    datasets: [{
                        backgroundColor: ["#434371", "#434371", "#434371", "#434371", "#434371"],
                        data: [this.Estatistica.TaxaInadimplenciaRegiaoPorcentagem[0], this.Estatistica.TaxaInadimplenciaRegiaoPorcentagem[1], this.Estatistica.TaxaInadimplenciaRegiaoPorcentagem[2], this.Estatistica.TaxaInadimplenciaRegiaoPorcentagem[3], this.Estatistica.TaxaInadimplenciaRegiaoPorcentagem[4]]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        displayColors: false,
                        callbacks: {
                            label: function label(tooltipItems, data) {
                                return "  " + tooltipItems.yLabel.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }) + '% ';
                            }
                        }
                    },
                    legend: {
                        display: false,
                        position: "bottom",
                        labels: {
                            padding: 25
                        }
                    },
                    title: {
                        display: false,
                        text: 'Empréstimos Realizados'
                    },
                    responsive: true,
                    scales: {
                        xAxes: [{
                            gridLines: {
                                display: false
                            },
                            categoryPercentage: 1
                        }],
                        yAxes: [{
                            gridLines: {
                                display: true
                            },
                            ticks: {
                                beginAtZero: true,
                                callback: function callback(label, index, labels) {
                                    if (label == '0') {
                                        return '0';
                                    }
                                    return label.toLocaleString('pt-BR', { minimumFractionDigits: "1", maximumFractionDigits: 2 }) + "%";
                                }
                            }
                        }]
                    }
                }
            });
        },
        EscondeGrafico: function EscondeGrafico(EsconderID, MostrarID) {
            $("#" + EsconderID).attr("hidden", "hidden");
            $("#" + MostrarID).removeAttr("hidden");
        },
        DensidadeInadimpleciaEstado: function DensidadeInadimpleciaEstado(Estado) {
            var densidade = 0;
            var estados = ["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO"];

            densidade = this.Estatistica.TaxaInadimplenciaEstadoPorcentagem[estados.indexOf(Estado)];

            if (densidade >= 1.0 && densidade <= 2.0) {
                return "item-01";
            } else if (densidade > 2.0 && densidade <= 3.0) {
                return "item-02";
            } else if (densidade > 3.0 && densidade <= 4.0) {
                return "item-03";
            } else if (densidade > 4.0 && densidade <= 5.0) {
                return "item-04";
            } else if (densidade > 5.0) {
                return "item-05";
            } else {
                return "item-default";
            }
        },
        MostraEstado: function MostraEstado(id) {
            $("#" + id).removeClass("EscondeEstado");
            $("#" + id).addClass("MostraEstado");
        },
        EscondeEstado: function EscondeEstado(id) {
            $("#" + id).removeClass("MostraEstado");
            $("#" + id).addClass("EscondeEstado");
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/estatisticas/estatisticas-da-plataforma/emprestimos',
                title: 'Estatisticas emprestimos'
            });
        }
    },
    updated: function updated() {

        if (!this.Criou) {
            this.CriarGrafico();
            this.Criou = true;
        }
    },
    beforeCreate: function beforeCreate() {
        var _this = this;

        this.$store.dispatch('updateUser');

        this.User = this.$store.state.currentUser;
        // HubClient.GerarEstatisticaEmprestimo()
        __WEBPACK_IMPORTED_MODULE_3__utils_api_client_go__["a" /* default */].gerarEstatisticaPlataformaInvestidores("emprestimos").then(function (resposta) {

            _this.Estatistica = resposta.data;

            var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            var meses = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

            for (var indice = 0; indice < _this.Estatistica.EmprestimosRealizados.length; indice++) {

                var label = _this.Estatistica.EmprestimosRealizados[indice].Label;
                label = label.split("-");

                _this.Estatistica.EmprestimosRealizados[indice].Label = meses[months.indexOf(label[0])] + "-" + label[1];
            }

            _this.Renderizou = true;

            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    },
    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (_this2.$store.state.currentUser.investor != null) {
                                if (typeof _this2.$store.state.currentUser.investor.Bloqueio != 'undefined') window.location.href = "#/";
                            }
                            //tagueamento GA
                            _context.next = 3;
                            return _this2.taggingGA();

                        case 3:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    }
});

/***/ }),

/***/ "ijQB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacoesPjInstitucionalStep_vue__ = __webpack_require__("WvzC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_075975b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacoesPjInstitucionalStep_vue__ = __webpack_require__("BOQj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacoesPjInstitucionalStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_075975b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacoesPjInstitucionalStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ijyF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: this.solicitacao.ArquivosBalancoEDre || [],
      naoPossuiBalancoEDre: false
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0 || this.naoPossuiBalancoEDre) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do Balanço e DRE é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {
        var newData = {
          ArquivosBalancoEDre: this.arquivosRecebidos,
          NaoPossuiBalancoEDre: this.naoPossuiBalancoEDre
        };
        this.$emit('on-submit', newData);
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "j1qf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NascionalidadeStep_vue__ = __webpack_require__("kyNv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_063160da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NascionalidadeStep_vue__ = __webpack_require__("RHgc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NascionalidadeStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_063160da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NascionalidadeStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j435":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"row no-gutters dates"},[_c('div',{staticClass:"col-12 col-sm-6"},[_c('img',{attrs:{"src":"/static/assets/images/ico-calendar_ok.svg"}}),_vm._v(" "),_c('label',[_vm._v("Início")]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.inicioCaptacao))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('img',{attrs:{"src":"/static/assets/images/ico-calendar_end.svg"}}),_vm._v(" "),_c('label',[_vm._v("Término")]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.fimCaptacao))])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('label',[_vm._v("Valor solicitado")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("R$ "+_vm._s(_vm.valorSolicitacao))])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),(_vm.verificaProduto(_vm.loanRequest.CodProduto))?_c('div',{staticClass:"row no-gutters text-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-4"},[_c('label',[_vm._v("Retorno Bruto Anual")]),_vm._v(" "),_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.retornoBrutoAnual))+"% a.a.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-4"},[_c('label',[_vm._v("Retorno Bruto Mensal")]),_vm._v(" "),_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.retornoBrutoMensal))+"% a.m.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-4"},[_c('label',[_vm._v("Retorno Estimado Anual")]),_vm._v(" "),_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.formatInt(_vm.cdi||0))+"% CDI")])]),_vm._v(" "),_vm._m(0)]):_c('div',{staticClass:"row no-gutters text-center"},[(!this.antecipacaoGambiarra)?_c('div',{staticClass:"col-12 col-md-12 col-lg-4"},[_c('label',[_vm._v("Retorno Líquido Anual")]),_vm._v(" "),_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.retornoBrutoAnual))+"% a.a.")])]):_vm._e(),_vm._v(" "),(this.antecipacaoGambiarra)?_c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_c('label',[_vm._v("Retorno Final do Período")]),_vm._v(" "),_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(this.taxaGambiarra)+"%")])]):_c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_c('label',[_vm._v("Retorno Líquido Mensal")]),_vm._v(" "),_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.retornoBrutoMensal))+"% a.m.")])]),_vm._v(" "),(this.antecipacaoGambiarra)?_c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_c('label',[_vm._v("Retorno Esperado período")]),_vm._v(" "),_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.formatInt(this.CDIGambiarra||0))+"% CDI")])]):_c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_c('label',[_vm._v("Retorno Estimado Anual")]),_vm._v(" "),_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.formatInt(_vm.cdi||0))+"% CDI")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[(!this.antecipacaoGambiarra)?_c('p',{staticClass:"small "},[_vm._v("\n        * A taxa de juros acima já é líquida de Imposto de Renda\n      ")]):_vm._e()])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row no-gutters text-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_c('label',[_vm._v("Rating")]),_vm._v(" "),_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.score))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_c('label',[_vm._v("Duração esperada")]),_vm._v(" "),(this.loanRequest.PrazoDias > 1)?_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(this.loanRequest.PrazoDias)+" Dias")]):_c('span',{staticClass:"info bold"},[_vm._v(_vm._s(_vm.prazo)+" Meses")])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row no-gutters text-center"},[_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v("Finaliza em "+_vm._s(_vm.daysToFinish)+" dias*")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix itens"},[_c('span',{staticClass:"float-left"},[_vm._v("Levantado: "+_vm._s(_vm.formatCurrency(_vm.reachedValuePercentage))+"%")]),_vm._v(" "),_c('span',{staticClass:"float-right"},[_vm._v("Faltam: "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.missingValue))])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:(("width: " + _vm.reachedValuePercentageINT + "%;")),attrs:{"role":"progressbar","aria-valuenow":"50","aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"progress-value"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.reachedValuePercentage))+"%")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"info__invest"},[_c('strong',[_vm._v(_vm._s(_vm.countInvestmentReservations))]),_vm._v(" investidores")])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('investment-reservation-data',{ref:"investData",attrs:{"loan-request":_vm.loanRequest,"investmentConfirmed":this.investmentConfirmed},on:{"submit":function (data) { return _vm.$emit('submit', data); }}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('p',{staticClass:"small"},[_vm._v("\n        * A taxa de juros acima é igual ao seu Retorno Bruto"),_c('br'),_vm._v("(Retorno antes do desconto de IR).\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j5eA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[(_vm.canGoPrevious)?_c('step-back-button',{on:{"click":this.onPrevious}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[(_vm.solicitacao)?_c(_vm.currentStepComponent,{tag:"component",staticClass:"form-container",attrs:{"solicitacao":_vm.solicitacao},on:{"on-previous":this.onPrevious,"on-submit":this.atualizarSolicitacao,"loading-toggle":_vm.handleLoadingToggle}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jHEz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps"},[_c('header',{staticClass:"d-flex"},[_c('a',{staticClass:"left",attrs:{"href":_vm.lpUrl,"target":"blank"}},[_c('i',{staticClass:"ico-iouu logotipo",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("FNzu"),"alt":"Foto Liza"}}),_vm._v(" "),_c('a',{staticClass:"right c1",staticStyle:{"right":"90px"},attrs:{"href":"#","title":"Ir para Home"},on:{"click":_vm.Home}},[_c('i',{staticClass:"ico-home"}),_vm._v(" Ir para Home\n    ")]),_vm._v(" "),_c('a',{staticClass:"right",attrs:{"href":"#","title":"Sair"},on:{"click":_vm.Logout}},[_c('i',{staticClass:"ico-exit"}),_vm._v(" Sair\n    ")])]),_vm._v(" "),_c('main',{staticClass:"container"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jLaj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jNXd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmprestimoImpactoForm_vue__ = __webpack_require__("biR9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abfc7238_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmprestimoImpactoForm_vue__ = __webpack_require__("a52A");
function injectStyle (ssrContext) {
  __webpack_require__("PW/k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-abfc7238"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmprestimoImpactoForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abfc7238_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmprestimoImpactoForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jUzo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoEndereco_vue__ = __webpack_require__("0ACJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2638e4e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoEndereco_vue__ = __webpack_require__("E9B0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoEndereco_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2638e4e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoEndereco_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jr5H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"vuejs-countdown"},[(_vm.days > 0)?_c('li',[_c('p',{staticClass:"digit"},[_vm._v(_vm._s(_vm._f("twoDigits")(_vm.days)))]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.days > 1 ? 'Dias' : 'dia'))])]):_vm._e(),_vm._v(" "),_c('li',[_c('p',{staticClass:"digit"},[_vm._v(_vm._s(_vm._f("twoDigits")(_vm.hours)))]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.hours > 1 ? 'Horas' : 'Hora'))])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"digit"},[_vm._v(_vm._s(_vm._f("twoDigits")(_vm.minutes)))]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("Min.")])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"digit"},[_vm._v(_vm._s(_vm._f("twoDigits")(_vm.seconds)))]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("Seg.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "juYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmacaoEnvioPasso_vue__ = __webpack_require__("JQcD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18c83aae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmacaoEnvioPasso_vue__ = __webpack_require__("Ug7t");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmacaoEnvioPasso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18c83aae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmacaoEnvioPasso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jv9o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simulation"},[_c('div',{staticClass:"simulation__nav"},[_c('span',{class:{'active':this.aba==1},on:{"click":function($event){return _vm.mudarAba(1)}}},[_vm._v("\n                Resumo previsto do investimento\n            ")]),_vm._v(" "),(!this.antecipacaoGambiarra)?_c('span',{class:{'active':this.aba==2},on:{"click":function($event){return _vm.mudarAba(2)}}},[_vm._v("\n                IOUU x CDB\n            ")]):_vm._e(),_vm._v(" "),(!this.antecipacaoGambiarra)?_c('span',{class:{'active':this.aba==3},on:{"click":function($event){return _vm.mudarAba(3)}}},[_vm._v("\n                Repagamentos\n            ")]):_vm._e()]),_vm._v(" "),(_vm.aba==1)?_c('div',{staticClass:"summary"},[_c('div',{staticClass:"summary__value"},[_c('small',[_vm._v("Valor da oferta")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valorMascara),expression:"valorMascara"}],staticClass:"summaryInput",attrs:{"disabled":"","type":"text"},domProps:{"value":(_vm.valorMascara)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valorMascara=$event.target.value}}})]),_vm._v(" "),(this.antecipacaoGambiarra)?_c('div',{staticClass:"summary__tax"},[_c('div',{staticClass:"summary__tax__value"},[_c('div',[_c('small',[_vm._v("Retorno bruto final do período")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.taxaGambiarra)+"%")])]),_vm._v(" "),_c('div',[_c('small',[_vm._v("Retorno Esperado no período")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.CDIGambiarra)+"% CDI")])])])]):_c('div',{staticClass:"summary__tax"},[_c('div',{staticClass:"summary__tax__value"},[_c('div',[_c('small',[_vm._v("Taxa interna de retorno")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.RetornoBrutoMensal)+"% a.m.")])]),_vm._v(" "),_c('div',[_c('small',[_vm._v("Taxa total efetiva")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.solicitacao.RetornoBrutoAnual)+"% a.a.")])])]),_vm._v(" "),(_vm.verificaProduto(_vm.solicitacao.CodProduto))?_c('small',{staticClass:"summary__tax__footer"},[_vm._v("* A taxa de juros acima é igual ao seu Retorno Bruto (Retorno antes do desconto de IR).")]):_c('small',{staticClass:"summary__tax__footer"},[_vm._v("* A taxa de juros acima já é líquida de Imposto de Renda.")])]),_vm._v(" "),(!this.antecipacaoGambiarra)?_c('div',{staticClass:"summary__info"},[_c('div',{staticClass:"summary__info__title"},[_vm._v("\n                    Informações Gerais\n                ")]),_vm._v(" "),(_vm.verificaProduto(_vm.solicitacao.CodProduto))?_c('ul',{staticClass:"summary__info__table"},[_c('li',[_c('div',[_vm._v("Plano de pagamento")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.solicitacao.Prazo)+" parcelas² de R$ "+_vm._s(_vm.formataValor(_vm.valorParcela))+"³")])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Retorno Bruto")]),_vm._v(" "),_c('div',[_vm._v("R$ "+_vm._s(_vm.formataValor(_vm.valorBruto)))])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Imposto de renda total")]),_vm._v(" "),_c('div',[_vm._v("R$ "+_vm._s(_vm.formataValor(_vm.CalculosSimulados.IR)))])]),_vm._v(" "),_c('li',[_c('div',[_vm._v("Retorno líquido")]),_vm._v(" "),_c('div',[_vm._v("R$ "+_vm._s(_vm.formataValor(_vm.valorLiquido)))])])]):_c('ul',{staticClass:"summary__info__table"},[_c('li',[_c('div',[_vm._v("Plano de pagamento")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.solicitacao.Prazo)+" parcelas² de R$ "+_vm._s(_vm.formataValor(_vm.valorParcela))+"³")])]),_vm._v(" "),(_vm.verificaProduto(_vm.solicitacao.CodProduto))?_c('li',[_c('div',[_vm._v("Retorno Bruto")]),_vm._v(" "),_c('div',[_vm._v("R$ "+_vm._s(_vm.formataValor(_vm.valorBruto)))])]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('li',[_c('div',[_vm._v("Retorno líquido")]),_vm._v(" "),_c('div',[_vm._v("R$ "+_vm._s(_vm.formataValor(_vm.valorBruto)))])])]),_vm._v(" "),_vm._m(1)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.aba==2)?_c('div',{staticClass:"graph"},[_c('div',{staticClass:"graph__value"},[_c('span',[_vm._v("Valor da oferta")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valorMascara),expression:"valorMascara"}],staticClass:"simulatedVal",attrs:{"disabled":"","type":"text"},domProps:{"value":(_vm.valorMascara)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valorMascara=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"graph__draw"},[_c('Chart',{attrs:{"parcelas":_vm.parcelas,"parcelasCDI":_vm.parcelasCDI,"valor":_vm.valorFormatado,"width":840,"height":320}})],1),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.aba==3)?_c('div',{staticClass:"cashflow"},[_c('div',{staticClass:"cashflow__value"},[_c('span',[_vm._v("Valor da oferta")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valorMascara),expression:"valorMascara"}],attrs:{"disabled":"","placeholder":"R$ 2.000,00","type":"text"},domProps:{"value":(_vm.valorMascara)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valorMascara=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cashflow__table"},[_vm._m(3),_vm._v(" "),(_vm.verificaProduto(_vm.solicitacao.CodProduto))?_c('ul',{staticClass:"cashflow__table__content"},_vm._l((_vm.CalculosSimulados.tabela),function(item){return _c('li',{key:item.parcela},[_c('div',[_vm._v("Mês "+_vm._s(item.parcela))]),_vm._v(" "),_c('div',[_vm._v("R$ "+_vm._s(_vm.formataValor(item.parcelaLiquida)))]),_vm._v(" "),_c('div',[_vm._v("R$ "+_vm._s(_vm.formataValor(item.amortizado)))]),_vm._v(" "),_c('div',[_vm._v("R$ "+_vm._s(_vm.formataValor(item.juros)))]),_vm._v(" "),_c('div',[_vm._v("- R$ "+_vm._s(_vm.formataValor(item.IR)))]),_vm._v(" "),_c('div',[_vm._v("R$ "+_vm._s(_vm.formataValor(item.valorFinanciado)))])])}),0):_c('ul',{staticClass:"cashflow__table__content"},_vm._l((_vm.CalculosSimulados.tabela),function(item){return _c('li',{key:item.parcela},[_c('div',[_vm._v("Mês "+_vm._s(item.parcela))]),_vm._v(" "),_c('div',[_vm._v("R$ "+_vm._s(_vm.valorBrutoAmortizado(item.amortizado, item.juros)))]),_vm._v(" "),_c('div',[_vm._v("R$ "+_vm._s(_vm.formataValor(item.amortizado)))]),_vm._v(" "),_c('div',[_vm._v("R$ "+_vm._s(_vm.formataValor(item.juros)))]),_vm._v(" "),_c('div',[_vm._v("R$ 0")]),_vm._v(" "),_c('div',[_vm._v("R$ "+_vm._s(_vm.formataValor(item.valorFinanciado)))])])}),0)]),_vm._v(" "),_vm._m(4)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('div',[_vm._v("Imposto de renda total")]),_vm._v(" "),_c('div',[_vm._v("R$ 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary__info__footer"},[_c('span',[_vm._v("\n                        ² Pagamento da primeira parcela: aproximadamente 1 mês depois da assinatura dos contratos."),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"graph__footer"},[_vm._v("\n                *Valores aproximados em duas casas decimais para melhor visualização. "),_c('br'),_vm._v("\n                CDB de 100% do CDI (consulta: 27/08/2019) - Fonte: B3.\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cashflow__table__header"},[_c('div',[_vm._v("Mês")]),_vm._v(" "),_c('div',[_vm._v("Parcela Liquida")]),_vm._v(" "),_c('div',[_vm._v("Amortização")]),_vm._v(" "),_c('div',[_vm._v("Juros")]),_vm._v(" "),_c('div',[_vm._v("IR")]),_vm._v(" "),_c('div',[_vm._v("Saldo Devedor")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cashflow__footer"},[_c('span',[_vm._v("\n                    *Valores aproximados em duas casas decimais para melhor visualização. O fluxo de repagamentos é calculado pela Tabela Price, caracterizada por pagamentos mensais iguais embutindo uma amortização crescente e juros decrescente.\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jzDM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Modal: __WEBPACK_IMPORTED_MODULE_1__components_Modal__["a" /* default */], FilesInput: __WEBPACK_IMPORTED_MODULE_2__components_FilesInput__["a" /* default */] },
    data: function data() {
        return {
            response: false,
            showModal: false,
            submitted: false,
            created: {},
            ArquivosFaturamento: {},
            ArquivosContratoSocial: {},
            ArquivosUltimosExtratosBancarios: {},
            ArquivosIrpf: {},
            ArquivosIdentidade: {},
            ArquivosBalancoEDre: {},
            ArquivosComprovanteEndereco: {},
            tipoArquivoSelecionado: "",
            campoArquivoMongodb: "",
            nomeArquivoSelecionado: "",
            idArquivoSelecionado: "",
            /* eslint-disable */
            uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
            acceptedFormats: 'application/pdf, image/jpeg, image/png',
            files: [null],
            outros: [],
            renderOutros: false,
            OutrosModal: false
        };
    },

    methods: {
        formatDate: function formatDate(data) {
            var dataForm = new Date(data);
            var dia = dataForm.getDate();

            if (dia.toString().length == 1) dia = "0" + dia;

            var mes = dataForm.getMonth() + 1;

            if (mes.toString().length == 1) mes = "0" + mes;

            var ano = dataForm.getFullYear();

            if (isNaN(parseInt(ano)) || isNaN(parseInt(mes)) || isNaN(parseInt(dia))) {

                return this.formatDate(this.created);
            }

            return dia + "/" + mes + "/" + ano;
        },
        exibeModal: function exibeModal(arquivo, tipoArquivoSelecionado, campoNome) {
            this.files = [null];
            this.submitted = false;
            this.showModal = true;

            this.tipoArquivoSelecionado = tipoArquivoSelecionado;
            this.nomeArquivoSelecionado = arquivo.Nome;
            this.campoArquivoMongodb = campoNome;

            if (document.getElementsByTagName("main").length > 0) {
                document.getElementsByTagName("main")[0].style.zIndex = "50";
            }
        },
        exibeModalOutros: function exibeModalOutros(id, tipoArquivoSelecionado) {
            this.files = [null];
            this.submitted = false;
            this.showModal = true;
            this.OutrosModal = true;

            this.tipoArquivoSelecionado = tipoArquivoSelecionado;
            this.idArquivoSelecionado = id;

            if (document.getElementsByTagName("main").length > 0) {
                document.getElementsByTagName("main")[0].style.zIndex = "50";
            }
        },
        onFilesChanged: function onFilesChanged(updatedFiles) {
            this.files = updatedFiles;
        },
        removeFile: function removeFile(index) {
            this.files.splice(index, 1);
        },
        clearFile: function clearFile(index) {
            this.$set(this.files, index, null);
        },
        validate: function validate() {
            if (this.receivedFiles.length > 0) {
                return { isValid: true, errors: [] };
            } else {
                return { isValid: false, errors: ['O envio do documento de identidade é obrigatório'] };
            }
        },
        submit: function submit() {
            var validation = this.validate();

            if (validation.isValid) {
                this.submitted = true;
                if (this.OutrosModal) {
                    __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].postDocumentosSolicitacao(this.idArquivoSelecionado, this.getId, this.receivedFiles).then(function () {});
                } else {
                    __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].createDocumentos(this.getType, this.campoArquivoMongodb, this.getId, this.nomeArquivoSelecionado, this.receivedFiles).then(function () {});
                }
            } else {
                this.$Notify.error({
                    title: "Dados Inválidos",
                    message: __WEBPACK_IMPORTED_MODULE_3__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
            }
        },
        closeModal: function closeModal() {
            var _this = this;

            this.showModal = false;
            this.OutrosModal = false;

            __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getDocumentos(this.getType, this.getId).then(function (response) {
                _this.ArquivosFaturamento = response.data.ArquivosFaturamento;
                _this.ArquivosContratoSocial = response.data.ArquivosContratoSocial;
                _this.ArquivosUltimosExtratosBancarios = response.data.ArquivosUltimosExtratosBancarios;
                _this.ArquivosIrpf = response.data.ArquivosIrpf;
                _this.ArquivosIdentidade = response.data.ArquivosIdentidade;
                _this.ArquivosBalancoEDre = response.data.ArquivosBalancoEDre;
                _this.ArquivosComprovanteEndereco = response.data.ArquivosComprovanteEndereco;
                _this.created = response.data.Created;
                _this.response = true;
            });
            if (document.getElementsByTagName("main").length > 0) {
                document.getElementsByTagName("main")[0].style.zIndex = "0";
            }

            __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getDocumentosSolicitacao(this.getId).then(function (response) {
                _this.outros = response.data;

                if (_this.outros.length > 0) {
                    _this.renderOutros = true;
                }
            });
        },
        nomeArquivo: function nomeArquivo(arquivo) {
            if (arquivo.length > 22) {
                var extensao = arquivo.substr(arquivo.lastIndexOf("."));
                var nome = arquivo.substr(0, arquivo.lastIndexOf("."));

                return nome.substr(0, 15) + "..." + extensao;
            }

            return arquivo;
        }
    },
    props: ['type', 'id'],

    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getDocumentos(this.getType, this.getId).then(function (response) {
            _this2.ArquivosFaturamento = response.data.ArquivosFaturamento;
            _this2.ArquivosContratoSocial = response.data.ArquivosContratoSocial;
            _this2.ArquivosUltimosExtratosBancarios = response.data.ArquivosUltimosExtratosBancarios;
            _this2.ArquivosIrpf = response.data.ArquivosIrpf;
            _this2.ArquivosIdentidade = response.data.ArquivosIdentidade;
            _this2.ArquivosBalancoEDre = response.data.ArquivosBalancoEDre;
            _this2.ArquivosComprovanteEndereco = response.data.ArquivosComprovanteEndereco;
            _this2.created = response.data.Created;
            _this2.response = true;
        });

        __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getDocumentosSolicitacao(this.getId).then(function (response) {
            _this2.outros = response.data;

            if (_this2.outros.length > 0) {
                _this2.renderOutros = true;
            }
        });
    },


    computed: {
        getType: function getType() {
            return this.type;
        },
        getId: function getId() {
            return this.id;
        },
        receivedFiles: function receivedFiles() {
            return this.files.filter(function (file) {
                return file != null && file != undefined;
            });
        }
    }
});

/***/ }),

/***/ "k0rk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kDcK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row all-tickets"},[(_vm.showModal)?_c('modal',{on:{"close":function($event){return _vm.voltar()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"tit"},[_c('h2',[_vm._v("Enviar documento")])])]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Contrato Social")]),_vm._v(" "),_c('button',[_vm._v("Enviar documento")])])])])]):_vm._e(),_vm._v(" "),(_vm.type == 'INV')?_c('documentos-investidor',{attrs:{"type":_vm.type,"id":_vm.id}}):_vm._e(),_vm._v(" "),(_vm.type == 'EMPPES')?_c('documentos-emprestimo-pessoal',{attrs:{"type":_vm.type,"id":_vm.id}}):_vm._e(),_vm._v(" "),(_vm.type == 'EMPCOL')?_c('documentos-emprestimo-coletivo',{attrs:{"type":_vm.type,"id":_vm.id}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kJx+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  methods: {
    closeModal: function closeModal() {
      this.$emit("setCloseOpenModal");
    }
  }

});

/***/ }),

/***/ "kQYy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInformationPeerToPeer_vue__ = __webpack_require__("WfYT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b69f7f7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInformationPeerToPeer_vue__ = __webpack_require__("j5eA");
function injectStyle (ssrContext) {
  __webpack_require__("ERbv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b69f7f7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInformationPeerToPeer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b69f7f7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInformationPeerToPeer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kbL5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kceo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps"},[_c('header',{staticClass:"d-flex"},[_c('a',{staticClass:"left",attrs:{"href":_vm.lpUrl,"target":"blank"}},[_c('i',{staticClass:"ico-iouu logotipo",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("FNzu"),"alt":"Foto Liza"}}),_vm._v(" "),_c('a',{staticClass:"right c1",staticStyle:{"right":"90px"},attrs:{"href":"#","title":"Ir para Home"},on:{"click":_vm.Home}},[_c('i',{staticClass:"ico-home"}),_vm._v(" Ir para Home\n    ")]),_vm._v(" "),_c('a',{staticClass:"right",attrs:{"href":"#","title":"Sair"},on:{"click":_vm.Logout}},[_c('i',{staticClass:"ico-exit"}),_vm._v(" Sair\n    ")])]),_vm._v(" "),_c('main',{staticClass:"container"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kkQk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvestmentReservationData_vue__ = __webpack_require__("wepy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f16fc72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvestmentReservationData_vue__ = __webpack_require__("eXr5");
function injectStyle (ssrContext) {
  __webpack_require__("uimQ")
  __webpack_require__("uxOT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f16fc72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvestmentReservationData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f16fc72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvestmentReservationData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kltP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loansForms_EmprestimoColetivoForm__ = __webpack_require__("VKi3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_loansForms_EmprestimoImpactoForm__ = __webpack_require__("jNXd");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    metaInfo: {
        htmlAttrs: {
            lang: 'pt-br'
        },
        bodyAttrs: {
            class: 'solicita-emprestimo'
        }
    },
    data: function data() {
        return {
            type: this.$route.query.type
        };
    },

    methods: {
        getTypeLoan: function getTypeLoan() {
            var txt = void 0;

            switch (this.type) {
                case 'EMPPES':
                    txt = 'Pessoal';
                    break;

                case 'EMPVEI':
                    txt = 'com Garantia Veicular';
                    break;

                case 'EMPIMP':
                    txt = "de Impacto";
                    break;

                case 'EMPIMP2':
                    txt = "de Impacto";
                    break;

                case 'EMPIMB':
                    txt = "Imobiliario";
                    break;

                case 'EMPSOC':
                    txt = "Social";
                    break;

                default:
                    txt = "Coletivo";
                    break;
            }

            return txt;
        },
        changeType: function changeType(type) {
            this.type = type;
            this.$router.push("/tipo-de-emprestimo/simulacao?type=" + type);
            this.getTypeLoan();
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/tipo-de-emprestimo/solicitar-emprestimo',
                title: 'solicitar-emprestimo'
            });
        }
    },
    components: {
        EmprestimoColetivoForm: __WEBPACK_IMPORTED_MODULE_2__components_loansForms_EmprestimoColetivoForm__["a" /* default */],
        EmprestimoImpactoForm: __WEBPACK_IMPORTED_MODULE_3__components_loansForms_EmprestimoImpactoForm__["a" /* default */]
    },
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.taggingGA();

                        case 2:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ "ksmb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentosInvestidor_vue__ = __webpack_require__("7a+p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8665aa20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentosInvestidor_vue__ = __webpack_require__("WSi1");
function injectStyle (ssrContext) {
  __webpack_require__("3Esd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8665aa20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentosInvestidor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8665aa20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentosInvestidor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kyNv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      optionsNacionality: [{ value: 1, label: "Brasileira" }, { value: 2, label: "Estrangeira" }]
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = { Social: this.currentUser.Social };
      this.$emit('on-submit', newData);
    }
  },
  mounted: function mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");
  }
});

/***/ }),

/***/ "l16d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row content"},[_c('div',{staticClass:"item d-flex"},[_c('div',{staticClass:"col-12 align-self-center text-center"},[_c('div',{staticClass:"item_tit animate"},[_c('h1',{staticClass:"animated bounceIn"},[_vm._v("\n                    Seja bem-vindo, "+_vm._s(_vm.Name())+"\n                ")]),_vm._v(" "),_c('p',{staticClass:"animated bounceIn"},[_vm._v("\n                    Escolha o que mais se adequa a sua realidade.\n                ")])]),_vm._v(" "),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-10 animate"},[_c('ul',{staticClass:"row justify-content-center"},[_c('li',{staticClass:"col-12 col-md-4 animated fadeInDown"},[_c('a',{attrs:{"href":""}},[_vm._v("\n                                Emprestimo\n                            ")])]),_vm._v(" "),_c('li',{staticClass:"col-12 col-md-4 animated fadeInDown"},[_c('a',{attrs:{"href":""}},[_vm._v("\n                                Investimento\n                            ")])]),_vm._v(" "),_c('li',{staticClass:"col-12 col-md-4 animated fadeInDown"},[_c('a',{attrs:{"href":""}},[_vm._v("\n                                Parceiros\n                            ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l4O7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatisticsLoan_vue__ = __webpack_require__("ib30");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_934a5360_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatisticsLoan_vue__ = __webpack_require__("Tdp/");
function injectStyle (ssrContext) {
  __webpack_require__("ZWEX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-934a5360"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatisticsLoan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_934a5360_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatisticsLoan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l8Bu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        Nome: function Nome() {
            var nome = "";

            if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
                nome = this.User.username;
            } else {
                nome = this.User.name;
            }
            nome = nome.trim();
            return nome;
        },
        PrimeiraLetra: function PrimeiraLetra() {
            var nome = this.Nome();

            return nome.length > 0 ? nome[0] : "?";
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/perfil',
                title: 'perfil'
            });
        }
    },
    computed: {
        User: function User() {
            return this.$store.state.currentUser;
        }
    }, beforeCreate: function beforeCreate() {

        window.document.title = 'Dashboard IOUU';
    },
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.taggingGA();

                        case 2:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ "lJWH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AdditionalInformationInvestor__ = __webpack_require__("UG21");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_StepBackButton__ = __webpack_require__("g50h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_hub_consulta_client_js__ = __webpack_require__("pk4i");


//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







var components = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ StepBackButton: __WEBPACK_IMPORTED_MODULE_6__components_StepBackButton__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_3__components_AdditionalInformationInvestor__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      transitionName: 'slide-left',
      investor: null
    };
  },

  components: components,
  computed: {
    currentStepComponent: function currentStepComponent() {
      var stepNames = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3__components_AdditionalInformationInvestor__["a" /* default */]);
      var currentStatus = this.investor ? this.investor.Status : null;
      return stepNames.includes(currentStatus) ? currentStatus : stepNames[0];
    },
    progress: function progress() {
      var stepsAmount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3__components_AdditionalInformationInvestor__["a" /* default */]).length;
      var currentStepNumber = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3__components_AdditionalInformationInvestor__["a" /* default */]).indexOf(this.currentStepComponent) + 1;
      return Math.round(currentStepNumber * 100 / stepsAmount);
    },
    canGoPrevious: function canGoPrevious() {
      if (!this.investor) return false;

      var stepsThatCantGoBack = ['informacoes-pessoais', 'cadastro-concluido'];
      return !stepsThatCantGoBack.includes(this.investor.Status);
    }
  },
  methods: {
    updateInvestor: function updateInvestor(data) {
      var _this = this;

      this.transitionName = 'slide-left';

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].updateInvestorInformation('next', data).then(function (investor) {
        _this.investor = investor;

        //TASK: Automatizar Consultas de Cadastro de Investidores (Clickup - 24/09)
        // Roda após obter cpf e data de nascimento
        if (investor.Status == "endereco") {
          __WEBPACK_IMPORTED_MODULE_7__utils_hub_consulta_client_js__["a" /* default */].ConsultaInvestidor(_this.$store.state.currentUser.email);
        }

        _this.atualizarUser(investor.Status);
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
      }).catch(function (error) {
        var errorMessages = error.response ? error.response.data.errors.map(function (error) {
          return error.detail;
        }) : error.message;
        _this.$Notify.error(__WEBPACK_IMPORTED_MODULE_5__utils_array_helper__["a" /* default */].toSentence(errorMessages));
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
      });
    },
    atualizarUser: function atualizarUser(stepAtual) {
      var _this2 = this;

      if (stepAtual == "cadastro-concluido") {

        __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].updateUserInvestor().then(function () {

          _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);

          _this2.$store.dispatch('updateUser').then().catch(function (error) {
            var errorMessages = error.response.data.errors.map(function (error) {
              return error.detail;
            });
            _this2.$Notify.error(__WEBPACK_IMPORTED_MODULE_5__utils_array_helper__["a" /* default */].toSentence(errorMessages));
          });
        }).catch(function (error) {
          var errorMessages = error.response ? error.response.data.errors.map(function (error) {
            return error.detail;
          }) : error.message;
          _this2.$Notify.error(__WEBPACK_IMPORTED_MODULE_5__utils_array_helper__["a" /* default */].toSentence(errorMessages));
          _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });

        // ATUALIZA TAG NO ACTIVE CAMPAIN ...
        __WEBPACK_IMPORTED_MODULE_7__utils_hub_consulta_client_js__["a" /* default */].AtualizarActive(this.$store.state.currentUser.email, "usuario-suitability-incompleto").then().catch();
      }
    },
    onPrevious: function onPrevious() {
      var _this3 = this;

      this.transitionName = 'slide-right';

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);
      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].updateInvestorInformation('previous', {}).then(function (investor) {
        _this3.investor = investor;_this3.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
      });
    }
  },
  beforeCreate: function beforeCreate() {
    var _this4 = this;

    this.investorId = this.$route.params.id;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["c" /* START_LOADING */]);
    __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getInvestor().then(function (investor) {
      _this4.investor = investor;
      _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
    }).catch(function () {
      return _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types_js__["d" /* STOP_LOADING */]);
    });
  },
  beforeUpdate: function beforeUpdate() {
    this.$Loading.update(this.progress);
  }
});

/***/ }),

/***/ "lMPh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Nome),expression:"partner.Nome"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":"","placeholder":"Nome do Sócio"},domProps:{"value":(_vm.partner.Nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Nome", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"inputPassword4"}},[_vm._v("CPF")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Cpf),expression:"partner.Cpf"},{name:"mask",rawName:"v-mask",value:('cpf'),expression:"'cpf'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":"","pattern":"\\d{3}\\.\\d{3}\\.\\d{3}-\\d{2}","placeholder":"CPF"},domProps:{"value":(_vm.partner.Cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Cpf", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"DataNascimento"}},[_vm._v("Data de Nascimento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.DataNascimento),expression:"partner.DataNascimento"},{name:"mask",rawName:"v-mask",value:('date'),expression:"'date'"}],staticClass:"form-control form-control-lg",attrs:{"name":"DataNascimento","type":"text","placeholder":"__/__/____","required":""},domProps:{"value":(_vm.partner.DataNascimento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "DataNascimento", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"Celular"}},[_vm._v("Celular")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Celular),expression:"partner.Celular"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"name":"Celular","type":"text","placeholder":"","required":""},domProps:{"value":(_vm.partner.Celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Celular", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-8"},[_c('label',{attrs:{"for":"Email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Email),expression:"partner.Email"}],staticClass:"form-control form-control-lg",attrs:{"name":"Email","type":"email","placeholder":"","required":""},domProps:{"value":(_vm.partner.Email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"complemento"}},[_vm._v("Escolaridade")]),_vm._v(" "),_c('at-select',{attrs:{"size":"large","placeholder":"Escolaridade"},model:{value:(_vm.partner.Escolaridade),callback:function ($$v) {_vm.$set(_vm.partner, "Escolaridade", $$v)},expression:"partner.Escolaridade"}},_vm._l((_vm.optionsEscolaridade),function(escolaridade,escolaridadeIndex){return _c('at-option',{key:("escolaridadeOptions" + escolaridadeIndex),attrs:{"value":escolaridade.value}},[_vm._v(_vm._s(escolaridade.label))])}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"complemento"}},[_vm._v("Estado Cívil")]),_vm._v(" "),_c('at-select',{attrs:{"size":"large","placeholder":"Estado Cívil"},model:{value:(_vm.partner.EstadoCivil),callback:function ($$v) {_vm.$set(_vm.partner, "EstadoCivil", $$v)},expression:"partner.EstadoCivil"}},_vm._l((_vm.optionsMarital),function(marital,maritalIndex){return _c('at-option',{key:("maritalOptions" + maritalIndex),attrs:{"value":marital.value}},[_vm._v(_vm._s(marital.label))])}),1)],1),_vm._v(" "),(_vm.partner.EstadoCivil === 2 || _vm.partner.EstadoCivil === 5)?_c('div',{staticClass:"form-row noSpace col-12"},[_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"NomeConjuge"}},[_vm._v("Nome do cônjuge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.NomeConjuge),expression:"partner.NomeConjuge"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","name":"NomeConjuge","placeholder":"Nome do Cônjuge","required":""},domProps:{"value":(_vm.partner.NomeConjuge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "NomeConjuge", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"CpfConjuge"}},[_vm._v("Cpf do cônjuge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.CpfConjuge),expression:"partner.CpfConjuge"},{name:"mask",rawName:"v-mask",value:('cpf'),expression:"'cpf'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","pattern":"\\d{3}\\.\\d{3}\\.\\d{3}-\\d{2}","placeholder":"CPF do Cônjuge","required":""},domProps:{"value":(_vm.partner.CpfConjuge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "CpfConjuge", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"DataNascimentoConjugue"}},[_vm._v("Data de Nascimento do cônjuge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.DataNascimentoConjuge),expression:"partner.DataNascimentoConjuge"},{name:"mask",rawName:"v-mask",value:('date'),expression:"'date'"}],staticClass:"form-control form-control-lg",attrs:{"name":"DataNascimentoConjuge","type":"text","placeholder":"__/__/____","required":""},domProps:{"value":(_vm.partner.DataNascimentoConjuge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "DataNascimentoConjuge", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"CelularConjuge"}},[_vm._v("Celular do cônjuge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.CelularConjuge),expression:"partner.CelularConjuge"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"name":"CelularConjuge","type":"text","placeholder":"","required":""},domProps:{"value":(_vm.partner.CelularConjuge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "CelularConjuge", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-8"},[_c('label',{attrs:{"for":"EmailConjuge"}},[_vm._v("Email do cônjuge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.EmailConjuge),expression:"partner.EmailConjuge"}],staticClass:"form-control form-control-lg",attrs:{"name":"EmailConjuge","type":"text","placeholder":"","required":""},domProps:{"value":(_vm.partner.EmailConjuge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "EmailConjuge", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-12"},[_c('label',{attrs:{"for":"complemento"}},[_vm._v("Escolaridade do cônjuge")]),_vm._v(" "),_c('at-select',{attrs:{"size":"large","placeholder":"Escolaridade"},model:{value:(_vm.partner.EscolaridadeConjuge),callback:function ($$v) {_vm.$set(_vm.partner, "EscolaridadeConjuge", $$v)},expression:"partner.EscolaridadeConjuge"}},_vm._l((_vm.optionsEscolaridade),function(escolaridade,escolaridadeIndex){return _c('at-option',{key:("escolaridadeOptions" + escolaridadeIndex),attrs:{"value":escolaridade.value}},[_vm._v(_vm._s(escolaridade.label))])}),1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"Facebook"}},[_vm._v("Facebook")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Facebook),expression:"partner.Facebook"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: facebook.com/iouu"},domProps:{"value":(_vm.partner.Facebook)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Facebook", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"Linkedin"}},[_vm._v("Linkedin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partner.Linkedin),expression:"partner.Linkedin"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: linkedin.com/in/iouu/"},domProps:{"value":(_vm.partner.Linkedin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.partner, "Linkedin", $event.target.value)}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lMR3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      razaoSocial: this.solicitacao.Empresa.RazaoSocial
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    submitWithCorporateGroup: function submitWithCorporateGroup() {
      this.$emit('on-submit', { Empresa: { TemGrupoEconomico: true } });
    },
    submitWithoutCorporateGroup: function submitWithoutCorporateGroup() {
      this.$emit('on-submit', { Empresa: { TemGrupoEconomico: false } });
    }
  }
});

/***/ }),

/***/ "lYzJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeInvestor_vue__ = __webpack_require__("H9vF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16cc72b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeInvestor_vue__ = __webpack_require__("HAXa");
function injectStyle (ssrContext) {
  __webpack_require__("VY/Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16cc72b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeInvestor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16cc72b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeInvestor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lhu4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("96tf");



var _this = this;


var BASE_URI_GO_API = "https://api.iouu.com.br" + '/api/v1';

var AtualizaPropostaBndes = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(data) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthPut(BASE_URI_GO_API + '/parceiros/bndes/atualiza', data);

                    case 3:
                        return _context.abrupt('return', _context.sent);

                    case 6:
                        _context.prev = 6;
                        _context.t0 = _context['catch'](0);
                        throw new Error('Erro ao atualizar bndes');

                    case 9:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this, [[0, 6]]);
    }));

    return function AtualizaPropostaBndes(_x) {
        return _ref.apply(this, arguments);
    };
}();

/* harmony default export */ __webpack_exports__["a"] = ({ AtualizaPropostaBndes: AtualizaPropostaBndes });

/***/ }),

/***/ "ljZJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderize)?_c('div',{staticClass:"margin"},[_c('form',{attrs:{"id":"form-editar-infoscadastrais"},on:{"submit":function($event){$event.preventDefault();return _vm.updateProfile($event)}}},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.Email),expression:"investorProfile.Email"}],staticClass:"form-control form-control-lg",attrs:{"type":"email","id":"email","placeholder":"Email","disabled":""},domProps:{"value":(_vm.investorProfile.Email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile, "Email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-8"},[_c('label',{attrs:{"for":"nome"}},[_vm._v("Nome completo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.NomeCompleto),expression:"investorProfile.NomeCompleto"}],staticClass:"form-control form-control-lg",style:([ _vm.fullNameError ? { 'border-color': 'red'} : { 'border-color': 'none' } ]),attrs:{"required":"","type":"text","id":"nome","placeholder":"Nome completo"},domProps:{"value":(_vm.investorProfile.NomeCompleto)},on:{"keyup":function($event){return _vm.validateFullName()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile, "NomeCompleto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4"},[_c('label',{attrs:{"for":"investorProfile.Sexo"}},[_vm._v("Sexo")]),_vm._v(" "),_c('at-select',{attrs:{"name":"sexo","id":"sexo","size":"large"},model:{value:(_vm.investorProfile.Sexo),callback:function ($$v) {_vm.$set(_vm.investorProfile, "Sexo", $$v)},expression:"investorProfile.Sexo"}},[_c('at-option',{attrs:{"value":2}},[_vm._v("Feminino")]),_vm._v(" "),_c('at-option',{attrs:{"value":1}},[_vm._v("Masculino")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',{attrs:{"for":"estado-civil"}},[_vm._v("Estado civil")]),_vm._v(" "),_c('at-select',{attrs:{"name":"estado-civil","id":"estado-civil","size":"large"},model:{value:(_vm.investorProfile.EstadoCivil),callback:function ($$v) {_vm.$set(_vm.investorProfile, "EstadoCivil", $$v)},expression:"investorProfile.EstadoCivil"}},[_c('at-option',{attrs:{"value":1}},[_vm._v("Solteiro(a)")]),_vm._v(" "),_c('at-option',{attrs:{"value":2}},[_vm._v("Casado(a)")]),_vm._v(" "),_c('at-option',{attrs:{"value":3}},[_vm._v("Separado(a)")]),_vm._v(" "),_c('at-option',{attrs:{"value":4}},[_vm._v("Viúvo(a)")]),_vm._v(" "),_c('at-option',{attrs:{"value":5}},[_vm._v("União estável")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',{attrs:{"for":"nome-mae"}},[_vm._v("Nome da mãe")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.NomeMae),expression:"investorProfile.NomeMae"}],staticClass:"form-control form-control-lg",attrs:{"required":"","type":"text","id":"nome-mae","value":"Diva Angêla de Oliveira Macedo"},domProps:{"value":(_vm.investorProfile.NomeMae)},on:{"keyup":function($event){return _vm.validateMothersName()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile, "NomeMae", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',{attrs:{"for":"nome-pai"}},[_vm._v("Nome do pai")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.NomePai),expression:"investorProfile.NomePai"}],staticClass:"form-control form-control-lg",attrs:{"required":"","type":"text","id":"nome-pai","value":"Mario de Moreira Macedo"},domProps:{"value":(_vm.investorProfile.NomePai)},on:{"keyup":function($event){return _vm.validateFathersName()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile, "NomePai", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',{attrs:{"for":"tel-fixo"}},[_vm._v("Telefone fixo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.TelefoneFixo),expression:"investorProfile.TelefoneFixo"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"tel-fixo","placeholder":"(00) 0000-0000"},domProps:{"value":(_vm.investorProfile.TelefoneFixo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile, "TelefoneFixo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',{attrs:{"for":"tel-celular"}},[_vm._v("Telefone celular")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.Celular),expression:"investorProfile.Celular"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],staticClass:"form-control form-control-lg",attrs:{"required":"","type":"text","id":"tel-celular","placeholder":"(00) 00000-0000"},domProps:{"value":(_vm.investorProfile.Celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile, "Celular", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',{attrs:{"for":"cpf"}},[_vm._v("CPF")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.Cpf),expression:"investorProfile.Cpf"},{name:"mask",rawName:"v-mask",value:('cpf'),expression:"'cpf'"}],staticClass:"form-control form-control-lg",attrs:{"disabled":"","type":"text","id":"cpf","placeholder":"Seu CPF"},domProps:{"value":(_vm.investorProfile.Cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile, "Cpf", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',{attrs:{"for":"nacionalidade"}},[_vm._v("Nacionalidade")]),_vm._v(" "),_c('at-select',{ref:"nationalitySelect",attrs:{"required":"","name":"nacionalidade","id":"nacionalidade","size":"large","placeholder":"Selecione","filterable":""},model:{value:(_vm.investorProfile.Nacionalidade),callback:function ($$v) {_vm.$set(_vm.investorProfile, "Nacionalidade", $$v)},expression:"investorProfile.Nacionalidade"}},[_c('at-option',{attrs:{"value":1}},[_vm._v("Brasileira(o) Nata(o)")]),_vm._v(" "),_c('at-option',{attrs:{"value":2}},[_vm._v("Brasileira(o) Naturalizada(o)")]),_vm._v(" "),_c('at-option',{attrs:{"value":3}},[_vm._v("Estrangeira(o)")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-4"},[_c('label',{attrs:{"for":"naturalidade"}},[_vm._v("Estado Onde Nasceu")]),_vm._v(" "),_c('at-select',{ref:"placeOfBirthSelect",attrs:{"id":"naturalidade","size":"large","placeholder":"Selecione","filterable":"","required":""},model:{value:(_vm.investorProfile.Naturalidade),callback:function ($$v) {_vm.$set(_vm.investorProfile, "Naturalidade", $$v)},expression:"investorProfile.Naturalidade"}},[_c('at-option',{attrs:{"value":"Exterior"}},[_vm._v("--Exterior--")]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('at-option',{key:state.uf,attrs:{"value":state.nome}},[_vm._v(_vm._s(state.nome))])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4"},[_c('label',{attrs:{"for":"naturalidade"}},[_vm._v("Cidade Onde Nasceu")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.NaturalidadeCidade),expression:"investorProfile.NaturalidadeCidade"}],staticClass:"form-control form-control-lg",attrs:{"required":"","type":"text","id":"naturalidade","placeholder":"Cidade Onde Nasceu"},domProps:{"value":(_vm.investorProfile.NaturalidadeCidade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile, "NaturalidadeCidade", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4"},[_c('label',{attrs:{"for":"data-nasc"}},[_vm._v("Data de Nascimento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.DataNascimentoExibicao),expression:"investorProfile.DataNascimentoExibicao"},{name:"mask",rawName:"v-mask",value:('date'),expression:"'date'"}],staticClass:"form-control form-control-lg",attrs:{"required":"","type":"text","id":"data-nasc","format":"dd/MM/yyyy","placeholder":"dd/mm/aaaa"},domProps:{"value":(_vm.investorProfile.DataNascimentoExibicao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile, "DataNascimentoExibicao", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',{attrs:{"for":"rg"}},[_vm._v("RG")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.RgNumero),expression:"investorProfile.RgNumero"}],staticClass:"form-control form-control-lg",attrs:{"required":"","type":"text","id":"rg","placeholder":"0.000.000-00","value":"Goioerê/PR"},domProps:{"value":(_vm.investorProfile.RgNumero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile, "RgNumero", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',{attrs:{"for":"naturalidade"}},[_vm._v("Orgão Emissor")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.RgOrgaoEmissor),expression:"investorProfile.RgOrgaoEmissor"}],staticClass:"form-control form-control-lg",attrs:{"required":"","type":"text","id":"naturalidade","value":"SSP"},domProps:{"value":(_vm.investorProfile.RgOrgaoEmissor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile, "RgOrgaoEmissor", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',{attrs:{"for":"estado-emissor"}},[_vm._v("Estado emissor")]),_vm._v(" "),_c('at-select',{attrs:{"required":"","name":"estado-emissor","id":"estado-civil","size":"large","filterable":""},model:{value:(_vm.investorProfile.RgEstadoEmissor),callback:function ($$v) {_vm.$set(_vm.investorProfile, "RgEstadoEmissor", $$v)},expression:"investorProfile.RgEstadoEmissor"}},[_c('at-option',{attrs:{"value":"AC"}},[_vm._v("AC")]),_vm._v(" "),_c('at-option',{attrs:{"value":"AL"}},[_vm._v("AL")]),_vm._v(" "),_c('at-option',{attrs:{"value":"AP"}},[_vm._v("AP")]),_vm._v(" "),_c('at-option',{attrs:{"value":"AM"}},[_vm._v("AM")]),_vm._v(" "),_c('at-option',{attrs:{"value":"BA"}},[_vm._v("BA")]),_vm._v(" "),_c('at-option',{attrs:{"value":"CE"}},[_vm._v("CE")]),_vm._v(" "),_c('at-option',{attrs:{"value":"DF"}},[_vm._v("DF")]),_vm._v(" "),_c('at-option',{attrs:{"value":"ES"}},[_vm._v("ES")]),_vm._v(" "),_c('at-option',{attrs:{"value":"GO"}},[_vm._v("GO")]),_vm._v(" "),_c('at-option',{attrs:{"value":"MA"}},[_vm._v("MA")]),_vm._v(" "),_c('at-option',{attrs:{"value":"MT"}},[_vm._v("MT")]),_vm._v(" "),_c('at-option',{attrs:{"value":"MS"}},[_vm._v("MS")]),_vm._v(" "),_c('at-option',{attrs:{"value":"MG"}},[_vm._v("MG")]),_vm._v(" "),_c('at-option',{attrs:{"value":"PA"}},[_vm._v("PA")]),_vm._v(" "),_c('at-option',{attrs:{"value":"PB"}},[_vm._v("PB")]),_vm._v(" "),_c('at-option',{attrs:{"value":"PR"}},[_vm._v("PR")]),_vm._v(" "),_c('at-option',{attrs:{"value":"PE"}},[_vm._v("PE")]),_vm._v(" "),_c('at-option',{attrs:{"value":"PI"}},[_vm._v("PI")]),_vm._v(" "),_c('at-option',{attrs:{"value":"RJ"}},[_vm._v("RJ")]),_vm._v(" "),_c('at-option',{attrs:{"value":"RN"}},[_vm._v("RN")]),_vm._v(" "),_c('at-option',{attrs:{"value":"RS"}},[_vm._v("RS")]),_vm._v(" "),_c('at-option',{attrs:{"value":"RO"}},[_vm._v("RO")]),_vm._v(" "),_c('at-option',{attrs:{"value":"RR"}},[_vm._v("RR")]),_vm._v(" "),_c('at-option',{attrs:{"value":"SC"}},[_vm._v("SC")]),_vm._v(" "),_c('at-option',{attrs:{"value":"SP"}},[_vm._v("SP")]),_vm._v(" "),_c('at-option',{attrs:{"value":"SE"}},[_vm._v("SE")]),_vm._v(" "),_c('at-option',{attrs:{"value":"TO"}},[_vm._v("TO")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',{attrs:{"for":"data-nasc"}},[_vm._v("Data de Emissão")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.RgDataEmissaoExibicao),expression:"investorProfile.RgDataEmissaoExibicao"},{name:"mask",rawName:"v-mask",value:('date'),expression:"'date'"}],staticClass:"form-control form-control-lg",attrs:{"required":"","type":"text","id":"data-nasc","format":"dd/MM/yyyy","placeholder":"dd/mm/yyyy"},domProps:{"value":(_vm.investorProfile.RgDataEmissaoExibicao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile, "RgDataEmissaoExibicao", $event.target.value)}}})])])])]),_vm._v(" "),_c('section',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',{attrs:{"for":"cep"}},[_vm._v("CEP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.Endereco.Cep),expression:"investorProfile.Endereco.Cep"},{name:"mask",rawName:"v-mask",value:('zipcode'),expression:"'zipcode'"}],staticClass:"form-control form-control-lg",attrs:{"required":"","type":"text","id":"cep","placeholder":"00000-000","pattern":"\\d{5}-?\\d{3}"},domProps:{"value":(_vm.investorProfile.Endereco.Cep)},on:{"change":_vm.handleZipcodeChange,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile.Endereco, "Cep", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',{attrs:{"for":"endereco"}},[_vm._v("Endereço")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.Endereco.Logradouro),expression:"investorProfile.Endereco.Logradouro"}],staticClass:"form-control form-control-lg",attrs:{"required":"","type":"text","id":"endereco","placeholder":"Endereço","value":"Rua José Dambrósio, 49"},domProps:{"value":(_vm.investorProfile.Endereco.Logradouro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile.Endereco, "Logradouro", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',{attrs:{"for":"numero"}},[_vm._v("Número")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.Endereco.Numero),expression:"investorProfile.Endereco.Numero"}],staticClass:"form-control form-control-lg",attrs:{"required":"","type":"text","id":"numero","placeholder":"","value":"47"},domProps:{"value":(_vm.investorProfile.Endereco.Numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile.Endereco, "Numero", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',{attrs:{"for":"compl"}},[_vm._v("Complemento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.Endereco.Complemento),expression:"investorProfile.Endereco.Complemento"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"compl","placeholder":"","value":"Apt 05"},domProps:{"value":(_vm.investorProfile.Endereco.Complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile.Endereco, "Complemento", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-4"},[_c('label',{attrs:{"for":"bairro"}},[_vm._v("Bairro")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.Endereco.Bairro),expression:"investorProfile.Endereco.Bairro"}],staticClass:"form-control form-control-lg",attrs:{"required":"","type":"text","id":"bairro","placeholder":"","value":"Caputera"},domProps:{"value":(_vm.investorProfile.Endereco.Bairro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile.Endereco, "Bairro", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4"},[_c('label',{attrs:{"for":"estado"}},[_vm._v("Estado")]),_vm._v(" "),_c('at-select',{attrs:{"required":"","filterable":"","name":"estado","id":"estado-civil","size":"large"},on:{"on-change":_vm.onUfChange},model:{value:(_vm.investorProfile.Endereco.Uf),callback:function ($$v) {_vm.$set(_vm.investorProfile.Endereco, "Uf", $$v)},expression:"investorProfile.Endereco.Uf"}},[_c('at-option',{attrs:{"value":"AC"}},[_vm._v("AC")]),_vm._v(" "),_c('at-option',{attrs:{"value":"AL"}},[_vm._v("AL")]),_vm._v(" "),_c('at-option',{attrs:{"value":"AP"}},[_vm._v("AP")]),_vm._v(" "),_c('at-option',{attrs:{"value":"AM"}},[_vm._v("AM")]),_vm._v(" "),_c('at-option',{attrs:{"value":"BA"}},[_vm._v("BA")]),_vm._v(" "),_c('at-option',{attrs:{"value":"CE"}},[_vm._v("CE")]),_vm._v(" "),_c('at-option',{attrs:{"value":"DF"}},[_vm._v("DF")]),_vm._v(" "),_c('at-option',{attrs:{"value":"ES"}},[_vm._v("ES")]),_vm._v(" "),_c('at-option',{attrs:{"value":"GO"}},[_vm._v("GO")]),_vm._v(" "),_c('at-option',{attrs:{"value":"MA"}},[_vm._v("MA")]),_vm._v(" "),_c('at-option',{attrs:{"value":"MT"}},[_vm._v("MT")]),_vm._v(" "),_c('at-option',{attrs:{"value":"MS"}},[_vm._v("MS")]),_vm._v(" "),_c('at-option',{attrs:{"value":"MG"}},[_vm._v("MG")]),_vm._v(" "),_c('at-option',{attrs:{"value":"PA"}},[_vm._v("PA")]),_vm._v(" "),_c('at-option',{attrs:{"value":"PB"}},[_vm._v("PB")]),_vm._v(" "),_c('at-option',{attrs:{"value":"PR"}},[_vm._v("PR")]),_vm._v(" "),_c('at-option',{attrs:{"value":"PE"}},[_vm._v("PE")]),_vm._v(" "),_c('at-option',{attrs:{"value":"PI"}},[_vm._v("PI")]),_vm._v(" "),_c('at-option',{attrs:{"value":"RJ"}},[_vm._v("RJ")]),_vm._v(" "),_c('at-option',{attrs:{"value":"RN"}},[_vm._v("RN")]),_vm._v(" "),_c('at-option',{attrs:{"value":"RS"}},[_vm._v("RS")]),_vm._v(" "),_c('at-option',{attrs:{"value":"RO"}},[_vm._v("RO")]),_vm._v(" "),_c('at-option',{attrs:{"value":"RR"}},[_vm._v("RR")]),_vm._v(" "),_c('at-option',{attrs:{"value":"SC"}},[_vm._v("SC")]),_vm._v(" "),_c('at-option',{attrs:{"value":"SP"}},[_vm._v("SP")]),_vm._v(" "),_c('at-option',{attrs:{"value":"SE"}},[_vm._v("SE")]),_vm._v(" "),_c('at-option',{attrs:{"value":"TO"}},[_vm._v("TO")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4"},[_c('label',{attrs:{"for":"cidade"}},[_vm._v("Cidade")]),_vm._v(" "),_c('at-select',{ref:"citySelect",attrs:{"required":"","filterable":"","name":"cidade","id":"cidade","size":"large"},model:{value:(_vm.investorProfile.Endereco.Cidade),callback:function ($$v) {_vm.$set(_vm.investorProfile.Endereco, "Cidade", $$v)},expression:"investorProfile.Endereco.Cidade"}},_vm._l((_vm.cities),function(city){return _c('at-option',{key:city._id,attrs:{"value":city.nome}},[_vm._v(_vm._s(city.nome))])}),1)],1)])])]),_vm._v(" "),_c('section',{staticClass:"row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',{attrs:{"for":"renda"}},[_vm._v("Renda mensal aprox. (R$)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.RendaMensal),expression:"investorProfile.RendaMensal"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"required":"","type":"text","id":"renda","placeholder":"","value":"R$ 0.000,00"},domProps:{"value":(_vm.investorProfile.RendaMensal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile, "RendaMensal", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',{attrs:{"for":"renda"}},[_vm._v("Patrimômio aprox. (R$)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.Patrimonio),expression:"investorProfile.Patrimonio"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"required":"","type":"text","id":"renda","placeholder":"","value":"R$ 00.000,00"},domProps:{"value":(_vm.investorProfile.Patrimonio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.investorProfile, "Patrimonio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',{attrs:{"for":"renda"}},[_vm._v("Você é uma pessoa politicamente exposta?")]),_vm._v(" "),_c('div',{staticClass:"inline-radio"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.PessoaPoliticamenteExposta),expression:"investorProfile.PessoaPoliticamenteExposta"}],staticClass:"form-check-input",attrs:{"required":"","type":"radio","name":"ppe","id":"inlineRadio2"},domProps:{"value":true,"checked":_vm._q(_vm.investorProfile.PessoaPoliticamenteExposta,true)},on:{"change":function($event){return _vm.$set(_vm.investorProfile, "PessoaPoliticamenteExposta", true)}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"inlineRadio2"}},[_vm._v("Sim, declaro ser PPE.")])])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('div',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.investorProfile.PessoaPoliticamenteExposta),expression:"investorProfile.PessoaPoliticamenteExposta"}],staticClass:"form-check-input",attrs:{"required":"","type":"radio","name":"ppe","id":"inlineRadio1"},domProps:{"value":false,"checked":_vm._q(_vm.investorProfile.PessoaPoliticamenteExposta,false)},on:{"change":function($event){return _vm.$set(_vm.investorProfile, "PessoaPoliticamenteExposta", false)}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"inlineRadio1"}},[_vm._v("Não, Declaro não ser PPE.")])])])])])])])]),_vm._v(" "),_vm._m(4)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"row"},[_c('div',{staticClass:"tit col-12"},[_c('h2',[_vm._v("Edite suas informações")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Informações pessoais")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Endereço")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Outras informações")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Dados bancários")])]),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"10px"}},[_c('p',[_vm._v("Para solicitar a troca de dados bancários, por favor entre em contato com nossa equipe através do telefone "),_c('strong',[_vm._v("(11) 4858-0862")]),_vm._v(" ou via e-mail "),_c('strong',[_vm._v("meajuda@iouu.com.br")]),_vm._v(".")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 bts"},[_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"submit"}},[_vm._v("\n                            Atualizar\n                        ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lmfZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("NtoT");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a56966d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("/pfM");
function injectStyle (ssrContext) {
  __webpack_require__("ysMO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a56966d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a56966d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "ln6W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: this.solicitacao.ArquivosDeclaracaoEndividamento || []
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio da declaração de endividamento é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {
        var newData = {
          ArquivosDeclaracaoEndividamento: this.arquivosRecebidos
        };
        this.$emit('on-submit', newData);
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "loe/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatisticsInvestor_vue__ = __webpack_require__("Awsi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_439abc6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatisticsInvestor_vue__ = __webpack_require__("68Qy");
function injectStyle (ssrContext) {
  __webpack_require__("2fUy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-439abc6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatisticsInvestor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_439abc6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatisticsInvestor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "luJi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finishedLoading)?_c('div',[(_vm.faturas != null && _vm.solicitacao != null)?_c('div',{staticClass:"row all-tickets"},[(_vm.showModal)?_c('modal',{staticClass:"modal-invited",on:{"close":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"tit float-left"},[_c('h2',{staticStyle:{"padding-right":"50px"}},[_c('i',{staticClass:"icon icon-airplane xl"}),_vm._v(" Enviar comprovante de pagamento")])])]),_vm._v(" "),_c('div',{staticStyle:{"overflow-x":"auto"},attrs:{"slot":"body"},slot:"body"},[(_vm.submitted)?_c('div',{staticClass:"success d-flex flex-column justify-content-center align-items-center"},[_c('i',{staticClass:"icon icon-success xll"}),_vm._v(" "),_c('h3',[_vm._v("Documento enviado com sucesso!")])]):_c('div',[_c('files-input',{attrs:{"files":_vm.files,"accept":_vm.acceptedFormats,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"float-md-right"},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"color":"#fff !important"},on:{"click":function($event){return _vm.submit()}}},[_vm._v("Enviar Documentos")])])],1),_vm._v(" "),_c('br')])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("\n                                Meus empréstimos\n                                "),_c('strong',[_vm._v("\n                                    "+_vm._s(_vm.Document)+"\n                                ")]),_vm._v(" "),_c('span',[_vm._v("\n                                    id#"+_vm._s(_vm.ajustIdOportunidade(_vm.id,5))+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"options float-right"},[_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"back"},[_vm._v("\n                                     \n                                ")]),_vm._v(" "),_c('span',[_vm._v("\n                                    Voltar\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('hr',{staticClass:"divider"})])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-td"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.faturas),function(fatura,index){return _c('tr',{key:index,class:_vm.verifyCanceled(fatura.StatusBoleto)},[_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                               "+_vm._s(fatura.IndiceFatura + 1)+"\n                                            ")]),_vm._v(" "),(fatura.HistoricoBoletos)?_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                               "+_vm._s(fatura.HistoricoBoletos[fatura.HistoricoBoletos.length - 1].total)+"\n                                            ")]):_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                               "+_vm._s(fatura.Boleto.total)+"\n                                            ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                                "+_vm._s(_vm.formatDate(fatura.Boleto.due_date))+"\n                                            ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"display":"none"}},[_vm._v("\n                                                09/09/2017\n                                            ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(fatura.HistoricoBoletos)?_c('a',{attrs:{"href":fatura.HistoricoBoletos[fatura.HistoricoBoletos.length - 1].secure_url,"target":"_blank"}},[_c('i',{staticClass:"fas fa-barcode"})]):_c('a',{attrs:{"href":fatura.Boleto.secure_url,"target":"_blank"}},[_c('i',{staticClass:"fas fa-barcode"})])]),_vm._v(" "),_c('td',{staticClass:"status align-middle",class:_vm.getFaturaStatusClass(fatura)},[_c('span',{staticClass:"sts md"}),_vm._v(" "),_c('span',[_vm._v("\n                                                    "+_vm._s(_vm.getFaturaStatusText(fatura))+"\n                                                ")])]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_c('a',{staticClass:"td-link",attrs:{"id":"show-modal"},on:{"click":function($event){return _vm.exibeModal(fatura._id, 'Boleto.arquivoComprovantePagamento')}}},[_c('i',{staticClass:"icon icon-send-file sm"},[_vm._v("\n                                                         \n                                                    ")]),_vm._v("\n                                                    Enviar comprovante\n                                                ")])]),_vm._v(" "),(fatura.Boleto.arquivoComprovantePagamento && fatura.Boleto.arquivoComprovantePagamento.length > 0)?_c('td',{staticClass:"align-middle text-center"},[_c('a',{staticClass:"td-link",attrs:{"href":_vm.getComprovanteUrl(fatura.Boleto.arquivoComprovantePagamento),"target":"_blank"}},[_c('i',{staticClass:"icon icon-eye-2 md"},[_vm._v("\n                                                         \n                                                    ")]),_vm._v("\n                                                    Visualizar comprovante\n                                                ")])]):_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                                -\n                                            ")])])}),0)])])])])])])])],1):_vm._e()]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_c('i',{staticClass:"fas fa-barcode"}),_vm._v("\n                            Boletos\n                        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"50"}},[_vm._v("\n                                                Parcela\n                                            ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n                                                Valor\n                                            ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"120"}},[_vm._v("\n                                                Vencimento\n                                            ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",staticStyle:{"display":"none"},attrs:{"scope":"col","width":"130"}},[_vm._v("\n                                                Data de Pagamento\n                                            ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"50"}},[_vm._v("\n                                                Boleto\n                                            ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"160"}},[_vm._v("\n                                                Status\n                                            ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}}),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "luuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalhesImpacto_vue__ = __webpack_require__("53Yj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab82996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalhesImpacto_vue__ = __webpack_require__("43e/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalhesImpacto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab82996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalhesImpacto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m//o":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "m0Nm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m1Vc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mEW5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (render)?_c('div',{staticClass:"row form-container justify-content-center"},[(_vm.renderLoad)?_c('div',{staticClass:"col-12 col-md-10 col-lg-10 col-xl-10"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.renderSuccess)?_c('div',{staticClass:"col-12 col-md-10 col-lg-10 col-xl-10"},[(_vm.hasAccount)?_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_vm._m(1),_vm._v(" "),(_vm.hasAccount)?_c('div',{staticClass:"text-center suitability-link-container"},[_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":("/login?loansId=" + _vm.loansId),"title":"Fazer login"}},[_vm._v("Entendi, quero fazer login")])],1):_vm._e(),_vm._v(" "),_vm._m(2)])]):_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"text-center suitability-link-container"},[_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":("/criar-conta-lead?name=" + _vm.name + "&email=" + _vm.email + "&loansId=" + _vm.loansId),"title":"Completar cadastro"}},[_vm._v("Entendi, quero completar meu cadastro")])],1),_vm._v(" "),_vm._m(4)])])]):_vm._e(),_vm._v(" "),(_vm.renderDanger)?_c('div',{staticClass:"col-12 col-md-10 col-lg-10 col-xl-10"},[_vm._m(5)]):_vm._e(),_vm._v(" "),(_vm.renderDenied)?_c('div',{staticClass:"col-12 col-md-10 col-lg-10 col-xl-10"},[_vm._m(6)]):_vm._e()]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_c('div',{staticClass:"tit text-center"},[_c('div',{staticClass:"svg"},[_c('div',{staticClass:"relogio"})]),_vm._v(" "),_c('h1',[_vm._v("Estamos carregando as informações, por favor aguarde um instante...")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})]),_vm._v(" "),_c('p',{staticClass:"obs"},[_vm._v("Juntos vamos reinventar os serviços financeiros tradicionais e garantir um melhor negócio para todos.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('img',{attrs:{"src":"/static/assets/images/ico-smile.svg","alt":"Icone feliz"}}),_vm._v(" "),_c('h1',[_vm._v("O 1º passo para você fazer parte da IOUU foi concluído com sucesso! ")]),_vm._v(" "),_c('p',[_vm._v("Identificamos que você já possui um cadastro conosco, faça "),_c('b',[_vm._v("login")]),_vm._v(" para poder finalizar o cadastro  e aguardar o processo de análise e aprovação.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})]),_vm._v(" "),_c('p',{staticClass:"obs"},[_vm._v("Juntos vamos reinventar os serviços financeiros tradicionais e garantir um melhor negócio para todos.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('img',{attrs:{"src":"/static/assets/images/ico-smile.svg","alt":"Icone feliz"}}),_vm._v(" "),_c('h1',[_vm._v("O 1º passo para você fazer parte da IOUU foi concluído com sucesso! ")]),_vm._v(" "),_c('p',[_vm._v("O próximo passo é criar um usuário, completar o "),_c('b',[_vm._v("cadastro")]),_vm._v(", enviar os documentos e aguardar o processo de análise e aprovação.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})]),_vm._v(" "),_c('p',{staticClass:"obs"},[_vm._v("Juntos vamos reinventar os serviços financeiros tradicionais e garantir um melhor negócio para todos.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_c('div',{staticClass:"tit text-center"},[_c('img',{attrs:{"src":"/static/assets/images/emoticon-triste.svg","alt":"Icone feliz"}}),_vm._v(" "),_c('h1',[_vm._v("Infelizmente ocorreu um erro ao carregar as informações ")]),_vm._v(" "),_c('p',[_vm._v("Tente novamente mais tarde, sentimos muito pelo inconveniente!!!")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})]),_vm._v(" "),_c('p',{staticClass:"obs"},[_vm._v("Juntos vamos reinventar os serviços financeiros tradicionais e garantir um melhor negócio para todos.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_c('div',{staticClass:"tit text-center"},[_c('img',{attrs:{"src":"/static/assets/images/ico-negado.svg","width":"100","alt":"Icone crédito negado."}}),_vm._v(" "),_c('h1',[_vm._v("Sua solicitação de crédito não foi aprovada.")]),_vm._v(" "),_c('p',[_vm._v("Você já possui uma solicitação conosco, há um periodo de 3 meses para poder realizar uma nova solicitação!")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})]),_vm._v(" "),_c('p',{staticClass:"obs"},[_vm._v("Juntos vamos reinventar os serviços financeiros tradicionais e garantir um melhor negócio para todos.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mHLF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("96tf");



var _this = this;


var BASE_URI_GO_API = "https://api.iouu.com.br" + '/api/v1';

var GetInvestor = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(userId) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/investidor/userId/' + userId);

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function GetInvestor(_x) {
        return _ref.apply(this, arguments);
    };
}();

var GetReservaPendente = function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/reserva/investidorId/' + id);

                    case 2:
                        return _context2.abrupt('return', _context2.sent);

                    case 3:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this);
    }));

    return function GetReservaPendente(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

/* harmony default export */ __webpack_exports__["a"] = ({ GetInvestor: GetInvestor, GetReservaPendente: GetReservaPendente });

/***/ }),

/***/ "mOtU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mRyX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mTyb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmCadastroLead_vue__ = __webpack_require__("O63G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f80daab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmCadastroLead_vue__ = __webpack_require__("mEW5");
function injectStyle (ssrContext) {
  __webpack_require__("+yYx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f80daab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmCadastroLead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f80daab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmCadastroLead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mVKm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoComoNosConheceu_vue__ = __webpack_require__("uH2j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc7a370_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoComoNosConheceu_vue__ = __webpack_require__("wBMG");
function injectStyle (ssrContext) {
  __webpack_require__("SUhN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cc7a370"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoComoNosConheceu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc7a370_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoComoNosConheceu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mcyq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mfOW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__ = __webpack_require__("DC4C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e76399c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel_vue__ = __webpack_require__("QEur");
function injectStyle (ssrContext) {
  __webpack_require__("8P55")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e76399c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e76399c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mm4S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mmRC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      acceptedFormats: 'application/pdf, image/jpeg, image/png',
      files: this.investor.ArquivosComprovanteResidencia || [null]
    };
  },

  computed: {
    receivedFiles: function receivedFiles() {
      return this.files.filter(function (file) {
        return file != null && file != undefined;
      });
    }
  },
  props: {
    investor: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.files = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.files.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.files, index, null);
    },
    validate: function validate() {
      if (this.receivedFiles.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do comprovante de residência é obrigatório'] };
      }
    },
    submit: function submit() {
      var validation = this.validate();

      if (validation.isValid) {
        var newData = {
          ArquivosComprovanteResidencia: this.receivedFiles
        };
        this.$emit('submit', newData);
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors)
        });
      }
    }
  }
});

/***/ }),

/***/ "mmm7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var FormularioCapacidade = this.suitability.FormularioCapacidade;
    return {
      HorizonteInvestimento: FormularioCapacidade ? FormularioCapacidade.HorizonteInvestimento : null,
      MomentoVida: FormularioCapacidade ? FormularioCapacidade.MomentoVida : null,
      DistribuicaoInvestimento: FormularioCapacidade ? FormularioCapacidade.DistribuicaoInvestimento : null,
      SitucaoFinanceira: FormularioCapacidade ? FormularioCapacidade.SitucaoFinanceira : null,
      Patrimonio: FormularioCapacidade ? FormularioCapacidade.Patrimonio : null
    };
  },

  props: {
    suitability: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      this.$emit('on-submit', {
        FormularioCapacidade: {
          HorizonteInvestimento: this.HorizonteInvestimento,
          MomentoVida: this.MomentoVida,
          DistribuicaoInvestimento: this.DistribuicaoInvestimento,
          SitucaoFinanceira: this.SitucaoFinanceira,
          Patrimonio: this.Patrimonio
        }
      });
    },
    verificaPreenchimento: function verificaPreenchimento() {
      console.log("verificaPreenchimento");
      return this.HorizonteInvestimento == null || this.MomentoVida == null || this.DistribuicaoInvestimento == null || this.SitucaoFinanceira == null || this.Patrimonio == null;
    }
  }
});

/***/ }),

/***/ "mnSO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  date: function date() {
    return {
      solicitacaoId: 0,
      IdOportunidade: 0
    };
  },
  created: function created() {
    var _this = this;

    sessionStorage.removeItem("redirectINV");

    this.solicitacaoId = this.$route.params.id;

    __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getLoanRequest(this.solicitacaoId).then(function (loanRequest) {
      _this.IdOportunidade = loanRequest.IdOportunidade;
    });
  }
});

/***/ }),

/***/ "mpAF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploadDeclaracaoIRStep_vue__ = __webpack_require__("MtJj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf3e5a18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploadDeclaracaoIRStep_vue__ = __webpack_require__("B+ee");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploadDeclaracaoIRStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf3e5a18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploadDeclaracaoIRStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mpXM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v(_vm._s(_vm.stepTitle))]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-link",attrs:{"type":"button"},on:{"click":function($event){_vm.showPartnerType = true}}},[_c('span',{staticClass:"icon icon-plus-circle"}),_vm._v(" Adicionar sócio")])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-11 col-xl-11"},[_c('form',{on:{"submit":_vm.onSubmit}},[_vm._l((_vm.socios),function(socio,index){return _c('div',{key:("partnerFields" + index),staticClass:"form-row"},[_c('div',{staticClass:"col-md-11"},[(socio.Tipo == 2)?_c('company-fields',{attrs:{"partner":socio}}):_c('person-fields',{attrs:{"partner":socio}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-1 align-self-center text-center"},[(!_vm.isMei)?_c('a',{staticClass:"icon icon-minus-circle remove",attrs:{"title":"Remover sócio"},on:{"click":function($event){return _vm.removePartner(index)}}}):_vm._e()])])}),_vm._v(" "),_c('div',{staticClass:"btns text-center"},[(!_vm.isMei)?_c('button',{staticClass:"btn btn-lg btn-link",attrs:{"type":"button"},on:{"click":function($event){_vm.showPartnerType = true}}},[_c('span',{staticClass:"icon icon-plus-circle"}),_vm._v(" Adicionar sócio")]):_vm._e(),_vm._v(" "),(_vm.showPartnerType)?_c('at-select',{attrs:{"size":"large","placeholder":"Tipo de Sócio"},on:{"on-change":_vm.addPartner}},[_c('at-option',{attrs:{"value":"1"}},[_vm._v("Pessoa Física")]),_vm._v(" "),_c('at-option',{attrs:{"value":"2"}},[_vm._v("Pessoa Jurídica")])],1):_vm._e(),_vm._v(" "),_vm._m(0)],1)],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mpiK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10 col-xl-10"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-10 col-xl-10"},[_vm._m(0),_vm._v(" "),_c('form',{on:{"submit":_vm.onSubmit}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"item row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-8"},[_c('table',{staticClass:"table table-responsive"},[_vm._m(2),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Renda fixa")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.RendaFixa),expression:"RendaFixa"}],attrs:{"type":"radio","name":"RendaFixa","id":"","value":"1"},domProps:{"checked":_vm._q(_vm.RendaFixa,"1")},on:{"change":function($event){_vm.RendaFixa="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.RendaFixa),expression:"RendaFixa"}],attrs:{"type":"radio","name":"RendaFixa","id":"","value":"2"},domProps:{"checked":_vm._q(_vm.RendaFixa,"2")},on:{"change":function($event){_vm.RendaFixa="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.RendaFixa),expression:"RendaFixa"}],attrs:{"type":"radio","name":"RendaFixa","id":"","value":"3"},domProps:{"checked":_vm._q(_vm.RendaFixa,"3")},on:{"change":function($event){_vm.RendaFixa="3"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Fundos multimercados e estruturados")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.FundosMultimercados),expression:"FundosMultimercados"}],attrs:{"type":"radio","name":"FundosMultimercados","id":"","value":"1"},domProps:{"checked":_vm._q(_vm.FundosMultimercados,"1")},on:{"change":function($event){_vm.FundosMultimercados="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.FundosMultimercados),expression:"FundosMultimercados"}],attrs:{"type":"radio","name":"FundosMultimercados","id":"","value":"2"},domProps:{"checked":_vm._q(_vm.FundosMultimercados,"2")},on:{"change":function($event){_vm.FundosMultimercados="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.FundosMultimercados),expression:"FundosMultimercados"}],attrs:{"type":"radio","name":"FundosMultimercados","id":"","value":"3"},domProps:{"checked":_vm._q(_vm.FundosMultimercados,"3")},on:{"change":function($event){_vm.FundosMultimercados="3"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Renda variável")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.RendaVariavel),expression:"RendaVariavel"}],attrs:{"type":"radio","name":"RendaVariavel","id":"","value":"1"},domProps:{"checked":_vm._q(_vm.RendaVariavel,"1")},on:{"change":function($event){_vm.RendaVariavel="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.RendaVariavel),expression:"RendaVariavel"}],attrs:{"type":"radio","name":"RendaVariavel","id":"","value":"2"},domProps:{"checked":_vm._q(_vm.RendaVariavel,"2")},on:{"change":function($event){_vm.RendaVariavel="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.RendaVariavel),expression:"RendaVariavel"}],attrs:{"type":"radio","name":"RendaVariavel","id":"","value":"3"},domProps:{"checked":_vm._q(_vm.RendaVariavel,"3")},on:{"change":function($event){_vm.RendaVariavel="3"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Fundos imobiliários")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.FundosImobiliarios),expression:"FundosImobiliarios"}],attrs:{"type":"radio","name":"FundosImobiliarios","id":"","value":"1"},domProps:{"checked":_vm._q(_vm.FundosImobiliarios,"1")},on:{"change":function($event){_vm.FundosImobiliarios="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.FundosImobiliarios),expression:"FundosImobiliarios"}],attrs:{"type":"radio","name":"FundosImobiliarios","id":"","value":"2"},domProps:{"checked":_vm._q(_vm.FundosImobiliarios,"2")},on:{"change":function($event){_vm.FundosImobiliarios="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.FundosImobiliarios),expression:"FundosImobiliarios"}],attrs:{"type":"radio","name":"FundosImobiliarios","id":"","value":"3"},domProps:{"checked":_vm._q(_vm.FundosImobiliarios,"3")},on:{"change":function($event){_vm.FundosImobiliarios="3"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Derivativos, COE e Private Equity")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Derivativos),expression:"Derivativos"}],attrs:{"type":"radio","name":"Derivativos","id":"","value":"1"},domProps:{"checked":_vm._q(_vm.Derivativos,"1")},on:{"change":function($event){_vm.Derivativos="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Derivativos),expression:"Derivativos"}],attrs:{"type":"radio","name":"Derivativos","id":"","value":"2"},domProps:{"checked":_vm._q(_vm.Derivativos,"2")},on:{"change":function($event){_vm.Derivativos="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"checkContainer checkTable"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Derivativos),expression:"Derivativos"}],attrs:{"type":"radio","name":"Derivativos","id":"","value":"3"},domProps:{"checked":_vm._q(_vm.Derivativos,"3")},on:{"change":function($event){_vm.Derivativos="3"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('table',{staticClass:"forms"},[_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ExpectativaAtrativos),expression:"ExpectativaAtrativos"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"ExpectativaAtrativos","id":"","value":"1"},domProps:{"checked":_vm._q(_vm.ExpectativaAtrativos,"1")},on:{"change":function($event){_vm.ExpectativaAtrativos="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ExpectativaAtrativos),expression:"ExpectativaAtrativos"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"ExpectativaAtrativos","id":"","value":"2"},domProps:{"checked":_vm._q(_vm.ExpectativaAtrativos,"2")},on:{"change":function($event){_vm.ExpectativaAtrativos="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ExpectativaAtrativos),expression:"ExpectativaAtrativos"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"ExpectativaAtrativos","id":"","value":"3"},domProps:{"checked":_vm._q(_vm.ExpectativaAtrativos,"3")},on:{"change":function($event){_vm.ExpectativaAtrativos="3"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(6)])])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('table',{staticClass:"forms"},[_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Conforto),expression:"Conforto"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Conforto","id":"","value":"1"},domProps:{"checked":_vm._q(_vm.Conforto,"1")},on:{"change":function($event){_vm.Conforto="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Conforto),expression:"Conforto"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Conforto","id":"","value":"2"},domProps:{"checked":_vm._q(_vm.Conforto,"2")},on:{"change":function($event){_vm.Conforto="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Conforto),expression:"Conforto"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Conforto","id":"","value":"3"},domProps:{"checked":_vm._q(_vm.Conforto,"3")},on:{"change":function($event){_vm.Conforto="3"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(10)])])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('table',{staticClass:"forms"},[_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Expectativa),expression:"Expectativa"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Expectativa","id":"","value":"1"},domProps:{"checked":_vm._q(_vm.Expectativa,"1")},on:{"change":function($event){_vm.Expectativa="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(12)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Expectativa),expression:"Expectativa"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Expectativa","id":"","value":"2"},domProps:{"checked":_vm._q(_vm.Expectativa,"2")},on:{"change":function($event){_vm.Expectativa="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(13)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Expectativa),expression:"Expectativa"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Expectativa","id":"","value":"3"},domProps:{"checked":_vm._q(_vm.Expectativa,"3")},on:{"change":function($event){_vm.Expectativa="3"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(14)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Expectativa),expression:"Expectativa"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Expectativa","id":"","value":"4"},domProps:{"checked":_vm._q(_vm.Expectativa,"4")},on:{"change":function($event){_vm.Expectativa="4"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(15)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Expectativa),expression:"Expectativa"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Expectativa","id":"","value":"5"},domProps:{"checked":_vm._q(_vm.Expectativa,"5")},on:{"change":function($event){_vm.Expectativa="5"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(16)])])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._m(17),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('table',{staticClass:"forms"},[_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Formacao),expression:"Formacao"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Formacao","id":"","value":"1"},domProps:{"checked":_vm._q(_vm.Formacao,"1")},on:{"change":function($event){_vm.Formacao="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(18)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Formacao),expression:"Formacao"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Formacao","id":"","value":"2"},domProps:{"checked":_vm._q(_vm.Formacao,"2")},on:{"change":function($event){_vm.Formacao="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(19)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}},[_c('div',{staticClass:"checkContainer suitability"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Formacao),expression:"Formacao"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"Formacao","id":"","value":"3"},domProps:{"checked":_vm._q(_vm.Formacao,"3")},on:{"change":function($event){_vm.Formacao="3"}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_vm._m(20)])])])]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":_vm.verificaPreenchimento()}},[_vm._v("Próximo "),_c('img',{attrs:{"src":"/static/assets/images/angle-right.svg"}})])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h2',[_vm._v("2. Avaliação de tolerância a risco")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('p',[_c('strong',[_vm._v("a.")]),_vm._v(" Conhecimento e Experiência: Informe o seu grau de conhecimento e experiência, o volume e a frequência das operações em cada uma das classes de produtos, levando em consideração as ponderações abaixo:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('table',{staticClass:"forms"},[_c('tr',[_c('td',{attrs:{"width":"10"}}),_vm._v(" "),_c('td',[_c('p',{staticClass:"form-check-label",attrs:{"for":""}},[_c('b',[_vm._v("Baixo")]),_vm._v(": Não tenho familiaridade com o produto ou a classe de ativo.\n                                    ")])])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}}),_vm._v(" "),_c('td',[_c('p',{staticClass:"form-check-label",attrs:{"for":""}},[_c('b',[_vm._v("Médio")]),_vm._v(": Compreendo as características e os riscos, porém não tenho nem realizei investimento no produto ou na classe de ativo, em volumes superiores a 5% da minha carteira há mais de 2 anos.\n                                    ")])])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"10"}}),_vm._v(" "),_c('td',[_c('p',{staticClass:"form-check-label",attrs:{"for":""}},[_c('b',[_vm._v("Alto")]),_vm._v(": Tenho e/ou realizei investimentos no produto ou na classe em volumes superiores a 5% da minha carteira há mais de 2 anos.\n                                    ")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col","width":"200"}},[_vm._v(" ")]),_vm._v(" "),_c('th',{attrs:{"scope":"col","width":"80"}},[_vm._v("Baixo")]),_vm._v(" "),_c('th',{attrs:{"scope":"col","width":"80"}},[_vm._v("Médio")]),_vm._v(" "),_c('th',{attrs:{"scope":"col","width":"80"}},[_vm._v("Alto")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("b.")]),_vm._v(" Expectativa: Você acredita que, em períodos de mais de três anos, produtos de maior risco (ex. ações) são mais atrativos do que produtos de menor risco?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("Não")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("Depende")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("Sim")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("c.")]),_vm._v(" Conforto: Como você reagiria se os seus investimentos caíssem mais de 10% (mesmo que temporariamente)?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("Venderia imediatamente.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("Entendo que isso pode acontecer para determinados ativos, mas não para o portfólio como um todo.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("Entendo que o meu portfólio está sujeito a sofrer flutuações dessa magnitude.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("d.")]),_vm._v(" Expectativa dos investimentos.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Não admito perder nada do capital investido. Procuro um retorno seguro e sem oscilações. Segurança é mais importante do que rentabilidade.\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Não admito perder nada do capital investido, no entanto, posso arriscar uma parte do capital para alcançar resultados melhores que a renda fixa tradicional.\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Posso correr riscos para conseguir uma rentabilidade acima da média, no entanto, prezo a preservação de 100% do capital investido. Divido minhas preferências entre segurança e rentabilidade, mas ainda prefiro segurança à rentabilidade.\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Admito perdas de até 20% do capital investido, se a proposta de investimento gerar possibilidade de altos retornos. A procura por rentabilidade é mais importante do que segurança.\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Minha prioridade é maximizar a rentabilidade, com segurança em segundo plano. Posso correr grandes riscos para obter elevados retornos, admitindo perder mais de 20% do meu principal investido.\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("e.")]),_vm._v(" Formação acadêmica e experiência profissional: Você considera que sua formação acadêmica e/ou experiência profissional lhe traz conhecimento sobre o mercado financeiro?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Nenhum ou pouco conhecimento para entender a relação risco-retorno de produtos complexos.\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Algum conhecimento para entender a relação risco-retorno de produtos complexos.\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"form-check-label",attrs:{"for":""}},[_vm._v("\n                                        Conhecimento para entender a relação risco-retorno de produtos complexos.\n                                    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nAhn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nYQX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.operacao.Tipo === 'PAGAMENTO')?_c('ComponentePagamento',{attrs:{"operacao":_vm.operacao}}):_vm._e(),_vm._v(" "),(_vm.operacao.Tipo === 'TRANSFERENCIA')?_c('ComponenteTransferencia',{attrs:{"operacao":_vm.operacao}}):_vm._e(),_vm._v(" "),(_vm.operacao.Tipo === 'DEPOSITO')?_c('ComponenteDeposito',{attrs:{"operacao":_vm.operacao}}):_vm._e(),_vm._v(" "),(_vm.operacao.Tipo === 'EXTORNO' || _vm.operacao.Tipo === 'ESTORNO')?_c('ComponenteExtorno',{attrs:{"operacao":_vm.operacao}}):_vm._e(),_vm._v(" "),(_vm.operacao.Tipo === 'INVESTIMENTO')?_c('ComponenteInvestimento',{attrs:{"operacao":_vm.operacao}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ndya":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nkvo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nsmI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finishedLoading)?_c('div',[_c('modal',{staticStyle:{"display":"none"},on:{"close":function($event){return _vm.voltar()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"tit float-left"},[_c('h2',[_vm._v("Cancelar investimento")])])]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('section',{staticClass:"row cancel-investiment"},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v("Tem certeza que deseja cancelar o seu investimento?")]),_vm._v(" "),_c('p',[_vm._v("Sentimos muito que você esteja cancelando o seu investimento na oportunidade. Por favor, nos informe abaixo o motivo pelo qual está cancelando o seu investimento:")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('form',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('textarea',{attrs:{"name":"","id":"","rows":"5"}})]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Sim, desejo cancelar meu investimento")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-link"},[_vm._v("Não, irei manter meu investimento")])]),_vm._v(" "),_c('div',{staticClass:"col-12 text-center",staticStyle:{"display":"none"}},[_c('h2',{staticStyle:{"margin":"60px 0"}},[_vm._v("Oferta de investimento cancelada.")])])])])])])]),_vm._v(" "),(_vm.solicitacao != null)?_c('div',{staticClass:"row company-view",class:_vm.scoreClass},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("Oportunidade "),_c('span',[_vm._v("id#"+_vm._s(_vm.id))])])]),_vm._v(" "),_c('div',{staticClass:"back float-right"},[_c('router-link',{attrs:{"to":'/investimentos/oportunidades'+_vm.voltarLink(),"title":"Voltar"}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('hr',{staticClass:"divider"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-8"},[_c('div',{staticClass:"tit"},[_c('div',{staticClass:"float-left"},[_c('h2',[_vm._v(_vm._s(_vm.nomeFantasia))]),_vm._v(" "),_c('span',[_vm._v("CNPJ: "+_vm._s(_vm.formattedCnpj))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.formatarTipoEmprestimo(_vm.loanType)))])]),_vm._v(" "),_c('div',{staticClass:"rating float-left float-md-right"},[_c('strong',[_vm._v("Score da operação "),_c('span',{staticClass:"circle score"}),_vm._v(" "+_vm._s(_vm.score))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('section',[_c('at-tabs',[_c('at-tab-pane',{attrs:{"label":"Fotos","name":"name1","icon":"icon-camera"}},[_c('carousel',{attrs:{"pictures":_vm.pictures}})],1),_vm._v(" "),_c('at-tab-pane',{attrs:{"label":"Vídeo","name":"name2","icon":"icon-video"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"src":_vm.vimeoVideoUrl,"webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})])])])])],1),_vm._v(" "),_c('div'),_vm._v(" "),_c('h4',{staticStyle:{"margin-top":"30px"}},[_vm._v("Descrição breve sobre a empresa")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.companyDescription)}})],1),_vm._v(" "),_c('section',[_c('h3',[_vm._v("Dados da empresa")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.razaoSocial))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("CPF/CNPJ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formattedCnpj))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Nome do responsável")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.nomeSolicitante))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Nome fantasia")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.nomeFantasia))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Telefone comercial")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.telefoneComercial))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Data de fundação")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.dataFundacao))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Número de funcionários")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.quantidadeEmpregados)+" empregados")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Nome do grupo ecônomico")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.nomeGrupoEconomico))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('label',[_vm._v("Endereço")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.address))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-5"},[_c('label',[_vm._v("Site")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.site))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-7"},[_c('label',[_vm._v("Redes Sociais")]),_vm._v(" "),_c('span',[(_vm.companyFacebook)?_c('a',{staticClass:"fab fa-facebook-square",attrs:{"href":_vm.companyFacebook}}):_vm._e(),_vm._v(" "),(_vm.companyTwitter)?_c('a',{staticClass:"fab fa-twitter",attrs:{"href":_vm.companyTwitter}}):_vm._e(),_vm._v(" "),(_vm.companyLinkedin)?_c('a',{staticClass:"fab fa-linkedin-in",attrs:{"href":_vm.companyLinkedin}}):_vm._e(),_vm._v(" "),(_vm.companyInstagram)?_c('a',{staticClass:"fab fa-instagram",attrs:{"href":_vm.companyInstagram}}):_vm._e(),_vm._v(" "),(_vm.companyVimeo)?_c('a',{staticClass:"fab fa-vimeo-v",attrs:{"href":_vm.companyVimeo}}):_vm._e()])]),_vm._v(" "),(_vm.formatoInvestimento)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-secondary",attrs:{"role":"alert"}},[_c('strong',[_vm._v("Formato do Investimento:")]),_vm._v("  "+_vm._s(_vm.formatoInvestimento)+"\n                  ")])]):_vm._e()]),_vm._v(" "),_c('iframe',{staticStyle:{"border":"0","border-radius":"5px"},attrs:{"src":_vm.mapUrl,"width":"100%","height":"280","frameborder":"0","allowfullscreen":""}}),_vm._v(" "),_c('div',[_c('h4',[_vm._v("Motivo da solicitação do empréstimo")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.motivoSolicitacao))])]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("Garantias oferecidas")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.garantiasOferecidas))])]),_vm._v(" "),_c('h4',[_vm._v("Índices financeiros")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Faturamento anual")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.faturamentoAnual))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Lucro líquido mensal")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.lucroLiquido))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Endividamento")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.divida))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Data base da consulta")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.dataConsultaEndividamento))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Negativações")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.negativacoes))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_vm._m(1),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.atrasos))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-12"},[_c('div',{staticClass:"box box_chart"},[_c('h2',[_vm._v("Faturamento dos últimos 12 meses")]),_vm._v(" "),_c('bar-chart',{attrs:{"data":_vm.chartData}})],1)])])]),_vm._v(" "),_c('section',[_c('h3',[_vm._v("Análise sobre a empresa")]),_vm._v(" "),_c('div',{staticClass:"em-analise",domProps:{"innerHTML":_vm._s(_vm.analiseEmpresa)}})])]),_vm._v(" "),_c('aside',{staticClass:"col-12 col-lg-4"},[_c('investment-reservation-form',{attrs:{"loan-request":_vm.solicitacao,"sDisponivel":this.sDisponivel,"investment-confirmed":this.investmentConfirmed},on:{"submit":_vm.submitInvestment}})],1)])])]):_vm._e()],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Empresa "),_c('span',[_vm._v("(Razão social)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Atrasos/restritivos "),_c('span',[_vm._v("(90 dias)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nu1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		data: {
			required: true,
			type: Array
		}
	},
	extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
	mounted: function mounted() {

		if (this.data != undefined) {
			this.renderChart({
				datasets: this.data.map(function (item) {
					return {
						label: item.label,
						fill: false,
						backgroundColor: item.color,
						data: [item.value]

					};
				})
			}, {
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					enabled: true,
					mode: 'single',
					callbacks: {
						label: function label(tooltipItems, data) {

							return data.datasets[tooltipItems.datasetIndex].label + ' - R$ ' + tooltipItems.yLabel.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }); //
						}
					}
				},
				legend: {
					position: 'bottom',
					display: false,
					labels: {
						padding: 15
					}
				},
				scales: {
					yAxes: [{
						display: true,
						ticks: {
							suggestedMin: 0, // minimum will be 0, unless there is a lower value.
							beginAtZero: true // minimum value will be 0.
						},
						gridLines: {
							display: false
						}
					}],
					xAxes: [{
						display: true,
						gridLines: {
							display: false
						}
					}]
				}
			});
		}
	},

	methods: {}
});

/***/ }),

/***/ "nuHT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-7 text-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.submitWithCorporateGroup}},[_vm._v("Sim")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.submitWithoutCorporateGroup}},[_vm._v("Não")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('p',[_vm._v("Já possui algum outro emprestimo contratado?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nvMk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListHistoric_vue__ = __webpack_require__("g36g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac2c6258_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListHistoric_vue__ = __webpack_require__("oxzu");
function injectStyle (ssrContext) {
  __webpack_require__("WW3i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ac2c6258"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListHistoric_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac2c6258_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListHistoric_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nwlg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Simulation_vue__ = __webpack_require__("5obF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0acc2d64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Simulation_vue__ = __webpack_require__("KHP5");
function injectStyle (ssrContext) {
  __webpack_require__("z74w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0acc2d64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Simulation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0acc2d64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Simulation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nyYf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_InformationSuitability_InicioQuestionario__ = __webpack_require__("+sT0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_InformationSuitability_AvaliacaodeRisco__ = __webpack_require__("t28z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_InformationSuitability_AceiteConfirmacao__ = __webpack_require__("2YlQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_InformationSuitability_ConfirmacaoPerfil__ = __webpack_require__("paKT");





var steps = {
    'inicio-questionario-step': __WEBPACK_IMPORTED_MODULE_0__components_InformationSuitability_InicioQuestionario__["a" /* default */],
    'avalicao-de-risco-step': __WEBPACK_IMPORTED_MODULE_1__components_InformationSuitability_AvaliacaodeRisco__["a" /* default */],
    'aceite-step': __WEBPACK_IMPORTED_MODULE_2__components_InformationSuitability_AceiteConfirmacao__["a" /* default */],
    'confirmacao-step': __WEBPACK_IMPORTED_MODULE_3__components_InformationSuitability_ConfirmacaoPerfil__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (steps);

/***/ }),

/***/ "oG/H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_wallet__ = __webpack_require__("c/xH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Wallet_WalletDetalhes__ = __webpack_require__("L/O1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_client__ = __webpack_require__("6Yc5");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    WalletDetalhe: __WEBPACK_IMPORTED_MODULE_3__components_Wallet_WalletDetalhes__["a" /* default */]
  },

  data: function data() {
    return {
      operacaoDetalhes: {}
    };
  },


  props: {
    item: { type: Object },
    index: { type: Number }
  },

  computed: {
    dataDia: function dataDia() {
      return this.pegarDataDia(this.item.Data);
    },
    formatadoMesEAno: function formatadoMesEAno() {
      return this.pegarDataFormatada(this.item.Data);
    },
    formatadoValor: function formatadoValor() {
      return this.formatarDinheiro(this.item.Valor);
    },
    tipo: function tipo() {
      return this.item.Tipo;
    },
    descricao: function descricao() {
      return this.item.Descricao;
    },
    classeItem: function classeItem() {
      return this.pegarClasseItem(this.item.Valor);
    },
    nomeEmpresa: function nomeEmpresa() {
      var NomeEmpresa = this.item.Detalhes.Pagamento.NomeEmpresa;

      return NomeEmpresa;
    },
    registroCancelado: function registroCancelado() {
      return this.item.Cancelado;
    }
  },

  methods: {
    AbrirCollapse: function AbrirCollapse(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var detalhesOperacao;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                detalhesOperacao = void 0;


                $(".collapse").collapse("hide");
                $(".active").removeClass("active");
                $("#collapse" + id).collapse("toggle");

                console.log(!$("#collapseLink" + id).hasClass("active"));

                if (!$("#collapseLink" + id).hasClass("active")) {

                  $("#collapseLink" + id).addClass("active");
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    activeCollapse: function activeCollapse(id) {
      var el = document.getElementById(id);

      var classAct = el.classList.contains("active");

      if (classAct) el.classList.remove("active");else el.classList.add("active");
    },
    pegarClasseItem: function pegarClasseItem(valor) {
      if (valor > 0) return "text-success";else return "text-danger";
    },
    pegarDataDia: function pegarDataDia(data) {
      data = new Date(data);

      data = data.toLocaleString("pt-BR", { timeZone: "UTC" }).split(" ")[0];

      data = data.split("/");

      return data[0];
    },
    pegarDataFormatada: function pegarDataFormatada(data) {
      data = new Date(data);

      var mes = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

      data = data.toLocaleString("pt-BR", { timeZone: "UTC" }).split(" ")[0];

      data = data.split("/");

      return mes[data[1] - 1] + " - " + data[2].substring(2);
    },
    formatarDinheiro: function formatarDinheiro(value) {
      if (value != null) {
        if (typeof value == "string") value = parseFloat(value);

        var options = {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        };

        return value.toLocaleString("pt-BR", options);
      }

      return 0;
    }
  }
});

/***/ }),

/***/ "oN8B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpportunitiesList_vue__ = __webpack_require__("ogyX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36485f5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpportunitiesList_vue__ = __webpack_require__("2gzv");
function injectStyle (ssrContext) {
  __webpack_require__("KUCq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36485f5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpportunitiesList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36485f5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpportunitiesList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oW/d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "obLK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ogyX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        oportunidatesAux: { type: Array },
        mudarOportunidade: { type: Function },
        ajustIdOportunidade: { type: Function },
        formatarScore: { type: Function },
        formatarTipoEmprestimo: { type: Function },
        money: { type: Function },
        inteiro: { type: Function },
        levantado: { type: Function },
        faltam: { type: Function },
        diffDate: { type: Function },
        valor: { type: Function },
        templateRender: { type: Function },
        lowerCase: { type: Function }
    }
});

/***/ }),

/***/ "ouWo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-info"},[(_vm.modalVisible)?_c('modal',{on:{"close":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"tit"},[_c('h2',[_vm._v(_vm._s(_vm.selectedItem.Impacto.NomeEmpresa))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedItem.Nome)+" – "+_vm._s(_vm.selectedItem.Impacto.Cidade)+" / "+_vm._s(_vm.selectedItem.Impacto.UF))]),_vm._v(" "),_c('small',[_c('strong',[_vm._v("ID#"+_vm._s(_vm.ajustIdOportunidade(_vm.selectedItem.IdOportunidade, 5)))])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor solicitado")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.selectedItem.Valor)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Duração")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.selectedItem.Prazo)+" meses")])])])]),_vm._v(" "),_c('div',{staticClass:"row items"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-6"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"clearfix"},[_c('span',{staticClass:"float-left item__info"},[_vm._v("Levantado: "+_vm._s(_vm.formatCurrency(_vm.selectedItem.ValorCaptado)))]),_vm._v(" "),_c('span',{staticClass:"float-right item__info"},[_vm._v("Faltam: "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.calcValorRestante(_vm.selectedItem))))])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:('width:' + _vm.selectedItem.PercValorRestante + '%'),attrs:{"role":"progressbar","aria-valuenow":"50","aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"progress-value"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.selectedItem.PercValorRestante))+"%")])])]),_vm._v(" "),_c('div',{staticClass:"itens"},[_c('p',[_vm._v("Início da captação: "),_c('strong',[_vm._v(_vm._s(_vm.dataLonga(_vm.selectedItem.InicioCaptacao )))])]),_vm._v(" "),_c('p',[_vm._v("Expira: "),_c('strong',[_vm._v(_vm._s(_vm.dataLonga(_vm.selectedItem.FimCaptacao )))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-6"},[_c('div',{staticClass:"item"},[_c('form',[(_vm.canInvest && !_vm.InvestidorBloqueado())?_c('div',{staticClass:"form-row"},[(!_vm.selectedItem.JaInvestiu && _vm.showInputInvestment)?_c('div',{staticClass:"col-12 col-md-8"},[_c('label',{attrs:{"for":"exampleFormControlInput1"}},[_vm._v("Valor que deseja aportar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valorInv),expression:"valorInv"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"exampleFormControlInput1","placeholder":'Invest. Mínimo R$ '+_vm.formatCurrency(_vm.selectedItem.InvestimentoMinimo)},domProps:{"value":(_vm.valorInv)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valorInv=$event.target.value}}})]):_vm._e(),_vm._v(" "),(!_vm.selectedItem.JaInvestiu && _vm.showInputInvestment)?_c('div',{staticClass:"col-12 col-md-4 d-flex align-items-end"},[_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.ShowSaldo()}}},[_vm._v("Investir")])]):_vm._e(),_vm._v(" "),(_vm.showInputSaldo)?_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"reinvestir"},[_c('div',{staticClass:"col-12 d-flex align-items-center"},[_c('img',{attrs:{"src":"/static/assets/images/ico-reinvestir.svg","alt":"icone reinvestir"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.Nome())+", você possuí saldo em sua Carteira virtual. Gostaria de reinvestir o seu saldo?")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex"},[_c('span',[_vm._v("Total disponível para reinvestir: "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.sDisponivel||0.00)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-7 col-xl-8"},[_c('label',{attrs:{"for":"exampleFormControlInput2"}},[_vm._v("Valor que deseja utilizar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valorReinvestimento),expression:"valorReinvestimento"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"id":"exampleFormControlInput2","type":"text","placeholder":"R$ 1.500,00"},domProps:{"value":(_vm.valorReinvestimento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valorReinvestimento=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-5 col-xl-4 d-flex align-items-end"},[_c('button',{staticClass:"btn btn-primary btn-lg btn-block",on:{"click":function($event){$event.preventDefault();return _vm.UsarSaldo()}}},[_vm._v("Usar saldo")])]),_vm._v(" "),_c('a',{staticClass:"btn btn-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.NaoUsarSaldo()}}},[_vm._v("Não utilizar saldo disponível.")]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("O valor para reinvestimento não pode ser superior ao disponível em sua carteira virtual.")])]):_vm._e(),_vm._v(" "),(_vm.selectedItem.JaInvestiu)?_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"alert alert_reserve alert-warning text-center",staticStyle:{"width":"100%"}},[_c('h2',[_vm._v("Você já efetuou um aporte para este investimento.")])])]):_vm._e()]):_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"alert alert_reserve alert-warning text-center",staticStyle:{"width":"100%"}},[(_vm.InvestidorBloqueado())?_c('h2',[_vm._v("Cadastro Bloqueado")]):_c('h2',[_vm._v("Falta pouco para você investir")]),_vm._v(" "),_c('div',[(_vm.InvestidorBloqueado())?_c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tPerfil bloqueado, favor retornar após "+_vm._s(_vm.$store.state.currentUser.investor.Bloqueio.Dias)+" dias.\n\t\t\t\t\t\t\t\t\t\t\t")]):(_vm.temCadastroInvestidor && _vm.temSuitability && !_vm.investidorAprovado)?_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v("Agora estamos analisando suas informações e retornaremos em até 1 dia útil.")]):_c('p',[(!_vm.temCadastroInvestidor)?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/informacoes-adicionais/investidor"}},[_vm._v("Complete o cadastro de investidor")]):_vm._e(),_vm._v(" "),(!_vm.temSuitability)?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/informacoes-adicionais/suitability"}},[_vm._v("Preencha o formulário de suitability")]):_vm._e()],1)])])])]),_vm._v(" "),(!(_vm.canInvest && !_vm.InvestidorBloqueado()) && _vm.investmentConfirmed)?_c('div',{staticClass:"confirm"},[_c('img',{staticClass:"float-left",attrs:{"src":"/static/assets/images/ico-confirm.svg","alt":"icone de confirmação"}}),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\tInvestimento registrado com sucesso."),_c('br'),_vm._v(" "),_c('small',[_vm._v("Assim que o valor atingir 100% captado, você vai receber as instruções por e-mail e basta seguir os passos informados.")])])]):_vm._e(),_vm._v(" "),(!_vm.InvestidorBloqueado())?_c('router-link',{staticClass:"item__link",attrs:{"to":'/investimentos/investimento-de-impacto/perfil-impacto/' + _vm.selectedItem._id,"title":"Exibir perfil detalhado"}},[_vm._v("Exibir perfil detalhado "),_c('i',[_vm._v(" ")])]):_vm._e()],1)])])])]):_vm._e(),_vm._v(" "),(_vm.modalInfoAdicional)?_c('modal',{on:{"close":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"tit"},[_c('h2',[_vm._v("Informações Adicionais")])])]),_vm._v(" "),(!_vm.finalizado)?_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"tit"},[_c('h4',[_vm._v("Deseja exibir o seu nome na lista de investidores?")])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-check form-check-inline d-flex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.anonimo),expression:"anonimo"}],attrs:{"type":"radio","name":"anonimo","required":""},domProps:{"value":false,"checked":_vm._q(_vm.anonimo,false)},on:{"change":function($event){_vm.anonimo=false}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",staticStyle:{"padding-left":"0px","font-weight":"normal"}},[_vm._v("Sim. Desejo exibir o meu nome na lista de investidores.")])])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-check form-check-inline d-flex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.anonimo),expression:"anonimo"}],attrs:{"type":"radio","name":"anonimo","required":""},domProps:{"value":true,"checked":_vm._q(_vm.anonimo,true)},on:{"change":function($event){_vm.anonimo=true}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",staticStyle:{"padding-left":"0px","font-weight":"normal"}},[_vm._v("Não. Desejo estar presente na lista de investidores somente como "),_c('strong',[_vm._v("anônimo")]),_vm._v(".")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"tit"},[_c('h4',[_vm._v("Deseja exibir a quantia do seu aporte na lista de investidores?")])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-check form-check-inline d-flex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.exibirQuantia),expression:"exibirQuantia"}],attrs:{"type":"checkbox","name":"anonimo","required":""},domProps:{"checked":Array.isArray(_vm.exibirQuantia)?_vm._i(_vm.exibirQuantia,null)>-1:(_vm.exibirQuantia)},on:{"change":function($event){var $$a=_vm.exibirQuantia,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.exibirQuantia=$$a.concat([$$v]))}else{$$i>-1&&(_vm.exibirQuantia=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.exibirQuantia=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",staticStyle:{"padding-left":"0px","font-weight":"normal"}},[_vm._v("Sim. Desejo exibir a quantia do meu aporte na lista de investidores.")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('button',{staticClass:"btn btn-primary btn-lg",staticStyle:{"background-color":"#40CD28","border-color":"#40CD28"},on:{"click":function($event){return _vm.apoiar(_vm.selectedItem._id, _vm.valorInv)}}},[_vm._v("Finalizar")])])]):_c('div',{staticClass:"success d-flex flex-column justify-content-center align-items-center",attrs:{"slot":"body"},slot:"body"},[_c('i',{staticClass:"icon icon-success xll"}),_vm._v(" "),_c('h3',[_vm._v("Aporte realizado com sucesso!")]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\tPor favor, verifique no seu e-mail o boleto para pagamento do aporte realizado.\n\t\t\t")])]):_vm._e(),_vm._v(" "),(!_vm.emBreveNovosInvestimentosImpacto)?_c('div',{staticClass:"row list-view"},[_c('div',{staticClass:"col-12 tit_page"},[_vm._m(0),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),(_vm.response)?_c('ul',{staticClass:"row"},_vm._l((_vm.listImpacts),function(impact,index){return _c('li',{key:impact._id,staticClass:"col-12 col-md-4 col-lg-3"},[_c('div',{staticClass:"item-card"},[_c('figure',[_c('router-link',{attrs:{"to":'/investimentos/investimento-de-impacto/perfil-social-new/' + impact._id}},[_c('img',{staticClass:"card-img-top",attrs:{"src":impact.Impacto != null ?impact.Impacto.ImagemLista:'',"alt":"Card image cap"}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(impact.Impacto.Categoria != null ? impact.Impacto.Categoria.toUpperCase() : ''))])])],1),_vm._v(" "),_c('div',{staticClass:"card-body text-center"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(impact.Impacto.TituloCampanha))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(impact.Impacto.Cidade)+" / "+_vm._s(impact.Impacto.UF))]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('span',{staticClass:"info-invest"},[_c('strong',[_vm._v(_vm._s(_vm.listImpacts[index].QuantidadeReservasInvestimento))]),_vm._v(" Investidores\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"item-progress"},[_c('p',[_c('span',{staticClass:"text-muted"},[_vm._v("Valor levantado")]),_vm._v("\n\t\t\t\t\t\t\t\t\t\tR$ "+_vm._s(_vm.formatCurrency(_vm.listImpacts[index].ValorCaptado))+"\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:('width:' + _vm.listImpacts[index].PercValorRestante  + '%'),attrs:{"role":"progressbar","aria-valuenow":"50","aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"progress-value"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.formatCurrency(_vm.listImpacts[index].PercValorRestante))+"%\n\t\t\t\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Faltam: "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(_vm.listImpacts[index].ValorRestante)))])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"text-muted"},[_vm._v("Rendimento")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatCurrency(_vm.listImpacts[index].TaxaJuros))+"% a.m.")])]),_vm._v(" "),(_vm.listImpacts[index].PermiteAporte)?_c('router-link',{staticClass:"btn btn-primary",attrs:{"id":"show-modal","to":'/investimentos/investimento-de-impacto/perfil-social-new/' + impact._id,"title":"Apoiar"}},[_vm._v("Investir")]):_c('a',{staticClass:"btn btn-primary",staticStyle:{"background-color":"gray"},attrs:{"id":"show-modal","title":"Apoiar"}},[_vm._v("Encerrado")]),_vm._v(" "),(!_vm.InvestidorBloqueado())?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":'/investimentos/investimento-de-impacto/perfil-social-new/' + impact._id,"title":"Exibir detalhes"}},[_vm._v("Exibir detalhes")]):_vm._e()],1)])])}),0):_vm._e()])]):_c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard"},[_vm._m(1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6 float-left"},[_c('h1',[_vm._v("Investimentos sociais")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard__complete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Em breve novos investimentos sociais")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oxzu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"historic"},[_c('div',{staticClass:"row align-items-center historic__tit-page tit_page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4"},[_c('div',{staticClass:"back back-hide float-md-right"},[_c('router-link',{attrs:{"to":"/investimentos/meus-investimentos","title":"Voltar"}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row historic__filter"},[_c('div',{staticClass:"col-12"},[_c('form',{staticClass:"row",attrs:{"id":"formFilter"}},[_c('div',{staticClass:"tipos col-3"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"inputs"},[_c('at-select',{attrs:{"size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.tipoEmprestimoFiltro),callback:function ($$v) {_vm.tipoEmprestimoFiltro=$$v},expression:"tipoEmprestimoFiltro"}},_vm._l((_vm.tiposEmprestimos),function(tipo,index){return _c('at-option',{key:("tiposOptions" + index),attrs:{"value":tipo.value}},[_vm._v(_vm._s(tipo.name))])}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"datas col-6"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"inputs"},[_c('datetime',{staticClass:"theme-iouu",attrs:{"input-class":"form-control","type":"text","format":"dd/MM/yyyy"},model:{value:(_vm.dataIni),callback:function ($$v) {_vm.dataIni=$$v},expression:"dataIni"}}),_vm._v("\n                     a\n                     "),_c('datetime',{staticClass:"theme-iouu",attrs:{"input-class":"form-control","type":"text","format":"dd/MM/yyyy"},model:{value:(_vm.dataFim),callback:function ($$v) {_vm.dataFim=$$v},expression:"dataFim"}})],1)]),_vm._v(" "),_c('div',{staticClass:"scores col-1"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"inputs"},[_c('at-select',{attrs:{"size":"large","required":"","placeholder":"--"},model:{value:(_vm.scoreFiltro),callback:function ($$v) {_vm.scoreFiltro=$$v},expression:"scoreFiltro"}},_vm._l((_vm.scoresArray),function(score,index){return _c('at-option',{key:("scoreOptions" + index),attrs:{"value":score.value}},[_vm._v(_vm._s(score.value))])}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"btn col-2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.Buscar}},[_vm._v("Procurar")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('form',{staticClass:"bg-pag pagination d-flex flex-column flex-md-row justify-content-between align-items-center"},[_c('div',{staticClass:"font-weight-bold"},[_vm._v("\n                        "+_vm._s((_vm.itensPorPage*this.currentPage)+1)+" - "+_vm._s((_vm.itensPorPage*this.currentPage)+this.MeusInvestPG.length)+" de "+_vm._s(this.MeusInvestimentosAll.length)+" investimentos\n                    ")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center font-weight-bold"},[_vm._v("\n                        Página "),_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"1","max":this.Paginas.length,"id":"pgCorrente"},domProps:{"value":_vm.paginaTopo},on:{"change":function($event){return _vm.PaginaTopo($event)}}}),_vm._v(" "),_c('span',[_vm._v("de "+_vm._s(this.Paginas.length))]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.MudarPaginaNumero()}}},[_vm._v("IR")])]),_vm._v(" "),_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item"},[_c('a',{class:'nav-link back '+(_vm.VerifyCurrentPage(1)?'disabled':''),on:{"click":function($event){return _vm.MudarPagina('-')}}},[_c('i'),_vm._v(" Voltar")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{class:'nav-link next '+(_vm.VerifyCurrentPage(this.Paginas.length)?'disabled':''),on:{"click":function($event){return _vm.MudarPagina('+')}}},[_vm._v("Avançar "),_c('i')])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover"},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((this.MeusInvestPG),function(item){return _c('tr',{class:'rating-'+_vm.lowerCase(item.SolicitacaoId.Score)},[_c('th',{attrs:{"scope":"row"}},[_c('router-link',{staticClass:"text-secondary",attrs:{"to":'/investimentos/historico/historico-de-investimento/'+item._id,"title":"Ver detalhes do investimento"}},[_vm._v("\n                                    #"+_vm._s(_vm.ajustIdOportunidade(item.SolicitacaoId.IdOportunidade,5)))])],1),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.linkReserva(item._id)}}},[_vm._v(_vm._s(_vm.ObterNome(item.SolicitacaoId)))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.linkReserva(item._id)}}},[_vm._v("R$ "+_vm._s(_vm.formatCurrency(item.Valor))+" @ "+_vm._s(_vm.formatCurrency(item.SolicitacaoId.RetornoBrutoAnual))+"% a.a.")]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.linkReserva(item._id)}}},[_vm._v(_vm._s(_vm.formatData(item.Created)))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.linkReserva(item._id)}}},[_vm._v(_vm._s(_vm.formatDataVencimento(item.DataVencimento)))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.linkReserva(item._id)}}},[_vm._v(_vm._s(item.SolicitacaoId.Alongamento ? item.SolicitacaoId.PrazoFinal : item.SolicitacaoId.Prazo)+" meses")]),_vm._v(" "),(_vm.lowerCase(item.SolicitacaoId.Score) != '')?_c('td',{class:'rating rating-'+_vm.lowerCase(item.SolicitacaoId.Score),on:{"click":function($event){return _vm.linkReserva(item._id)}}},[_c('span',{staticClass:"circle score"}),_vm._v(" "+_vm._s(_vm.lowerCase(item.SolicitacaoId.Score).toUpperCase()))]):_vm._e(),_vm._v(" "),(_vm.lowerCase(item.SolicitacaoId.Score) == '')?_c('td',{on:{"click":function($event){return _vm.linkReserva(item._id)}}}):_vm._e(),_vm._v(" "),_c('td',[(new Date(item.DataVencimento) < new Date() )?_c('router-link',{staticClass:"text-success",attrs:{"to":'/investimentos/historico/historico-de-investimento/'+item._id,"title":"Ver detalhes do investimento"}},[_vm._v("Em atraso")]):(new Date(item.DataVencimento) >= new Date() )?_c('router-link',{staticClass:"text-success",attrs:{"to":'/investimentos/historico/historico-de-investimento/'+item._id,"title":"Ver detalhes do investimento"}},[_vm._v("Ativo")]):(item.Status == 1)?_c('router-link',{staticClass:"text-success",attrs:{"to":'/investimentos/historico/historico-de-investimento/'+item._id,"title":"Ver detalhes do investimento"}},[_vm._v("Encerrado")]):_vm._e()],1)])}),0)])]),_vm._v(" "),_c('Pagination',{attrs:{"paginasTotais":this.PaginasTotais,"paginaAtual":this.currentPage+1,"navigate":function (route){route == null ? '' : this$1.currentPage = route-1}}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-8"},[_c('h1',[_vm._v("Histórico de investimentos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text_label"},[_c('label',{attrs:{"for":"tipo"}},[_c('span',[_vm._v("\n                            Tipo do investimento:\n                          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text_label"},[_c('label',{attrs:{"for":"Datas"}},[_vm._v("\n                        Data do investimento:\n                      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text_label"},[_c('label',{attrs:{"for":"score"}},[_vm._v("\n                         Score:\n                       ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col","width":"110"}},[_vm._v("ID")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Nome da Empresa")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Participação @ Tx. de juros")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Data do invest.")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Data prox. repagamento")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Duração")]),_vm._v(" "),_c('th',{attrs:{"scope":"col","width":"70"}},[_vm._v("Score")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oynA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnersStep_vue__ = __webpack_require__("xgdo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299e284e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnersStep_vue__ = __webpack_require__("mpXM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnersStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299e284e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnersStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p1Om":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p6b1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p7hj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pE5z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    var pessoal = this.currentUser.Pessoal;
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: pessoal.ArquivoFotoIdentificacao || [null]
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.arquivos.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.arquivos, index, null);
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio da foto de identificação é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {

        this.currentUser.Pessoal.ArquivoFotoIdentificacao = this.arquivosRecebidos;

        this.$emit('on-submit', { Pessoal: this.currentUser.Pessoal });
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "pGKU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"Escolaridade"}},[_vm._v("\n            Escolaridade\n          ")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.currentUser.Pessoal.Escolaridade),callback:function ($$v) {_vm.$set(_vm.currentUser.Pessoal, "Escolaridade", $$v)},expression:"currentUser.Pessoal.Escolaridade"}},_vm._l((_vm.degrees),function(degree,index){return _c('at-option',{key:("degreesOptions" + index),attrs:{"value":degree.value}},[_vm._v(_vm._s(degree.label))])}),1)],1),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Escolaridade")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pRyu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CentralCobrancaView_vue__ = __webpack_require__("dGg6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c43a2fd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CentralCobrancaView_vue__ = __webpack_require__("rLp4");
function injectStyle (ssrContext) {
  __webpack_require__("QR4F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c43a2fd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CentralCobrancaView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c43a2fd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CentralCobrancaView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pVr/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankDataForm_vue__ = __webpack_require__("Ch5J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ac2babb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankDataForm_vue__ = __webpack_require__("aPYQ");
function injectStyle (ssrContext) {
  __webpack_require__("Du6A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ac2babb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankDataForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ac2babb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankDataForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "paKT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmacaoPerfil_vue__ = __webpack_require__("wTS/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a1e0422_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmacaoPerfil_vue__ = __webpack_require__("1SP8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmacaoPerfil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a1e0422_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmacaoPerfil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pgra":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioIdentidadeStep_vue__ = __webpack_require__("KNDX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_763d3dc6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioIdentidadeStep_vue__ = __webpack_require__("Dl1J");
function injectStyle (ssrContext) {
  __webpack_require__("/mNV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-763d3dc6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioIdentidadeStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_763d3dc6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioIdentidadeStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pk4i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_es6_promise__ = __webpack_require__("hKoQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_session_manager__ = __webpack_require__("J7hJ");



/* eslint-disable */


var NODE_URI = "https://server-app.iouu.com.br/api/v1";
var BASE_URI = "https://hub-app.iouu.com.br";
var IPIFY_URL = 'https://api.ipify.org';


var HubConsultaClient = function () {
  function HubConsultaClient() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, HubConsultaClient);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(HubConsultaClient, null, [{
    key: 'getIP',
    value: function getIP() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_4_es6_promise___default.a(function (resolve, reject) {
        _this._requisitar({ url: IPIFY_URL + '?format=json', method: 'GET' }).then(function (response) {
          resolve(response.data.ip);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'pegarCeps',
    value: function pegarCeps(cep) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_es6_promise___default.a(function (resolve, reject) {
        _this2._requisitar({ url: BASE_URI + '/cep/' + cep, method: 'GET' }).then(function (response) {
          resolve(response.data);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'pegarEstados',
    value: function pegarEstados() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_es6_promise___default.a(function (resolve, reject) {
        // this._requisitar({url: `${BASE_URI}/iouu/estados`, method: 'GET'})
        //   .then(response => {
        //     const estados = response.data.map(estado => {
        //       return {uf: estado.dados.uf, nome: estado.dados.estado}
        //     })
        //     resolve(estados)
        //   })
        //   .catch(error => reject(error))

        _this3._requisitar({ url: NODE_URI + '/estados', method: 'GET' }).then(function (response) {
          var estados = response.data.map(function (estado) {
            return { uf: estado.sigla, nome: estado.nome };
          });
          resolve(estados);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'pegarCidades',
    value: function pegarCidades(uf) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_es6_promise___default.a(function (resolve, reject) {
        // this._requisitar({url: `${BASE_URI}/iouu/estados/${uf}/cidades`, method: 'GET'})
        //   .then(response => {
        //     const cidades = response.data.map(cidade => {
        //       return {uf: cidade.dados.uf, nome: cidade.dados.cidade}
        //     })
        //     resolve(cidades)
        //   })
        //   .catch(error => reject(error))
        _this4._requisitar({ url: NODE_URI + '/estados/' + uf + '/cidades', method: 'GET' }).then(function (response) {
          var cidades = response.data.map(function (cidade) {
            return { uf: cidade.estado, nome: cidade.nome };
          });

          cidades.sort(function (a, b) {
            if (a.nome.toLowerCase() < b.nome.toLowerCase()) return -1;
            if (a.nome.toLowerCase() > b.nome.toLowerCase()) return 1;
            return 0;
          });

          resolve(cidades);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'pegarBancos',
    value: function pegarBancos() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_es6_promise___default.a(function (resolve, reject) {
        _this5._requisitar({ url: BASE_URI + '/iouu/bancos', method: 'GET' }).then(function (response) {
          resolve(response.data);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'pegarPerguntas',
    value: function pegarPerguntas(cpf) {
      var _this6 = this;

      var attemptNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      return new __WEBPACK_IMPORTED_MODULE_4_es6_promise___default.a(function (resolve, reject) {
        // THIS IS A WORKAROUND TO GIVE IT A FAST FIX
        // Actually what is needed to do here is to replicate what is done in the server,
        // with the function _getAsyncProcessResult in server/lib/utils/hub-consulta-client.js.
        // But before doing it, the HubConsulta endpoint should start to respond in the same way
        // as Ph3a endpoint and others that return a Status of async processing stuff.
        if (attemptNumber >= 5) {
          reject(new Error("Exceeded maximum attempts to get the questions"));
        }
        _this6._requisitar({ url: BASE_URI + '/bigID/pergunta/cpf/' + cpf, method: 'GET' }).then(function (response) {
          var data = response.data;
          if (data.DadosConsulta) {
            if (data.DadosConsulta.ResultCode == 0) {
              resolve(response.data);
            } else {
              throw new Error(data.DadosConsulta.ResultMessage);
            }
          } else {
            setTimeout(function () {
              _this6.pegarPerguntas(cpf, attemptNumber + 1).then(function (result) {
                return resolve(result);
              }).catch(function (error) {
                return reject(error);
              });
            }, 1000);
          }
        }).catch(function (error) {
          return reject(error);
        });
      });
    }

    /* Suitability*/

  }, {
    key: 'obterPerfilInvestidor',
    value: function obterPerfilInvestidor(idSuitability) {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_es6_promise___default.a(function (resolve, reject) {
        _this7._requisitar({ url: BASE_URI + '/iouu/suitability/' + idSuitability, method: 'GET' }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: '_requisitar',
    value: function _requisitar() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_3_axios___default()(options);
    }
  }, {
    key: 'request',
    value: function request() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_3_axios___default()(this._prepareOptions(options));
    }
  }, {
    key: '_prepareOptions',
    value: function _prepareOptions(givenOptions) {
      if (!givenOptions.headers) {
        givenOptions.headers = {};
      }
      if (!givenOptions.headers["Accept"]) {
        givenOptions.headers["Accept"] = 'application/json';
      }
      if (!givenOptions.headers["Content-Type"]) {
        givenOptions.headers["Content-Type"] = 'application/json';
      }

      // const accessToken = SessionManager.getAuthToken()

      // if(accessToken) {
      //   givenOptions.headers = Object.assign(givenOptions.headers, {
      //     Authorization: `${accessToken}`
      //   })
      // }


      givenOptions.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(givenOptions.data);
      givenOptions.url = BASE_URI + '/' + givenOptions.url;
      return givenOptions;
    }
  }, {
    key: 'simulator',
    value: function simulator(vr, n, fat, tipo) {
      return this.request({
        url: 'iouu/calc',
        method: 'POST',
        data: {
          vr: vr,
          n: n,
          fat: fat,
          tipo: tipo
        }
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: 'createLoans',
    value: function createLoans(data) {
      return this.request({
        url: 'iouu/solicitacao',
        method: 'POST',
        data: data
      }).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    }
  }, {
    key: 'getPdf',
    value: function getPdf(cpf) {
      var _this8 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_es6_promise___default.a(function (resolve, reject) {
        _this8._requisitar({ url: BASE_URI + '/informe?cpf=' + cpf, method: 'GET' }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'downloadPdf',
    value: function downloadPdf(data) {
      return this.request({
        url: 'informe',
        method: 'POST',
        data: data
      }).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    }
  }, {
    key: 'theCheckerPost',
    value: function theCheckerPost(email) {
      return this.request({
        url: 'theChecker/' + email,
        method: 'GET'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return reject(error);
      });
    }
  }, {
    key: 'PreValidacaoEmail',
    value: function PreValidacaoEmail(email) {
      return this.request({
        url: 'verifyEmail/' + email,
        method: 'GET'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return reject(error);
      });
    }
  }, {
    key: 'ExisteUsuario',
    value: function ExisteUsuario(email) {
      return this.request({
        url: 'existeUsuario/' + email,
        method: 'GET'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        console.log(error);
        return error;
      });
    }
  }, {
    key: 'GerarEstatistica',
    value: function GerarEstatistica() {
      return this.request({
        url: 'GerarEstatisticas',
        method: 'GET'
      }).then(function (response) {
        return response;
      }).catch(function (error) {
        console.log(error);
        return error;
      });
    }
  }, {
    key: 'GerarEstatisticaEmprestimo',
    value: function GerarEstatisticaEmprestimo() {
      return this.request({
        url: 'GerarEstatisticasEmprestimos',
        method: 'GET'
      }).then(function (response) {
        return response;
      }).catch(function (error) {
        console.log(error);
        return error;
      });
    }
  }, {
    key: 'CadastrarActive',
    value: function CadastrarActive(email) {
      return this.request({
        url: 'active/cadastrar/' + email,
        method: "GET"
      });
    }
  }, {
    key: 'AtualizarActive',
    value: function AtualizarActive(email, tag) {
      return this.request({
        url: 'active/atualizar/' + email + '/' + tag,
        method: "GET"
      });
    }
  }, {
    key: 'CadastrarTomadorActive',
    value: function CadastrarTomadorActive(email) {
      return this.request({
        url: 'active/tomadores/' + email,
        method: "GET"
      });
    }
  }, {
    key: 'ConsultaInvestidor',
    value: function ConsultaInvestidor(email) {
      return this.request({
        url: 'iouu/consultaInvestidor/' + email,
        method: 'GET'
      }).then(function (response) {
        return response;
      }).catch(function (resp) {
        console.log(resp);
      });
    }
  }, {
    key: 'ConsultaTerceiroDiaUtil',
    value: function ConsultaTerceiroDiaUtil(dia, mes, ano) {
      return this.request({
        url: 'calendario/terceiroDiaUtil/' + dia + '/' + mes + '/' + ano,
        method: 'GET'
      }).then(function (response) {
        return response;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: 'LeadSerasa',
    value: function LeadSerasa(authCode) {
      return this.request({
        url: 'call/serasa/' + authCode,
        method: 'GET'
      }).then(function (response) {
        return response;
      }).catch(function (resp) {
        console.log(resp);
      });
    }
  }, {
    key: 'LeadTest',
    value: function LeadTest() {
      return this.request({
        url: 'teste/call/serasa',
        method: 'GET'
      }).then(function (response) {
        return response;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }]);

  return HubConsultaClient;
}();

/* harmony default export */ __webpack_exports__["a"] = (HubConsultaClient);

/***/ }),

/***/ "plnP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__ = __webpack_require__("Du/2");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            User: null
        };
    },

    methods: {
        showMeInfo: function showMeInfo() {
            // Verifica se o investidor tem acesso as estatísticas
            // Verifica cadastro completo 
            if (this.User.hasinvestor && this.User.hassuitability && this.User.investor.Status == "APROVADO") {
                return true;
            } else {
                return false;
            }
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/estatisticas',
                title: 'Estatisticas'
            });
        }
    },
    beforeCreate: function beforeCreate() {
        this.$store.dispatch('updateUser');
    },
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (_this.$store.state.currentUser.investor != null) {
                                if (typeof _this.$store.state.currentUser.investor.Bloqueio != 'undefined') window.location.href = "#/";
                            }

                            _this.User = _this.$store.state.currentUser;

                            //tagueamento GA
                            _context.next = 4;
                            return _this.taggingGA();

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ "psaY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoOutrasInformacoes_vue__ = __webpack_require__("4WV/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fc729ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoOutrasInformacoes_vue__ = __webpack_require__("f3CH");
function injectStyle (ssrContext) {
  __webpack_require__("z8QB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fc729ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoOutrasInformacoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fc729ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoOutrasInformacoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q4WM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    partner: { required: true, type: Object }
  }
});

/***/ }),

/***/ "qE+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonFields_vue__ = __webpack_require__("uLM3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b566eb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonFields_vue__ = __webpack_require__("lMPh");
function injectStyle (ssrContext) {
  __webpack_require__("glKg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b566eb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonFields_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b566eb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonFields_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qJuA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletFundsTransfer_vue__ = __webpack_require__("s3n1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d4ed2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletFundsTransfer_vue__ = __webpack_require__("8fww");
function injectStyle (ssrContext) {
  __webpack_require__("768j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27d4ed2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletFundsTransfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d4ed2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletFundsTransfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qOVB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"feature background background-243499767",attrs:{"id":"cta"}},[_c('div',{staticClass:"feature-margin"},[_c('div',{staticClass:"form-cta shadow"},[_c('form',{attrs:{"id":"form-cadastro-LandingPageInvistaIouu"},on:{"submit":function($event){$event.preventDefault();return _vm.signUp($event)}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","name":"firstname","placeholder":"Seu nome","required":"","autofocus":""},domProps:{"value":(_vm.name)},on:{"keyup":function($event){return _vm.validateName()},"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",class:{campoInvalido:!_vm.EmailConfirmado, campoValido:_vm.EmailConfirmado && _vm.msg != ''},attrs:{"type":"email","id":"Email","aria-describedby":"emailHelp","placeholder":"Seu email","required":""},domProps:{"value":(_vm.email)},on:{"focusout":_vm.ValidarEmail,"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"validacao"},[(_vm.msg != '' && !_vm.EmailConfirmado)?_c('span',[_c('p',{staticClass:"invalido"},[_c('i',{staticClass:"fas fa-exclamation-circle",attrs:{"id":"IconeInvalido"}}),_vm._v("\n                                         "+_vm._s(_vm.msg)+"\n                                     ")])]):_vm._e(),_vm._v(" "),(_vm.msg != '' && _vm.EmailConfirmado)?_c('span',[_c('p',{staticClass:"valido"},[_c('i',{staticClass:"fas fa-check",attrs:{"id":"IconeValido"}}),_vm._v("\n                                         "+_vm._s(_vm.msg)+"\n                                     ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control form-control-lg",attrs:{"type":"password","id":"password","name":"password","data-toggle":"password","placeholder":"Senha","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row d-flex flex-md-row-reverse align-items-center"},[_c('div',{staticClass:"col-12 col-md-5"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"submit","disabled":!_vm.EmailConfirmado &&  _vm.msg != ''}},[_vm._v("Comece a investir")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-7 text-center text-md-left"},[_c('span',{staticClass:"font-low"},[_vm._v(_vm._s(this.cdi)+" do CDI")]),_vm._v(" "),_vm._m(1)])])])])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v("Invista com alta rentabilidade na IOUU")]),_vm._v(" "),_c('p',[_vm._v("Cadastre-se gratuitamente e invista sem taxas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_vm._v("Retorno potencial no ano "),_c('i',{staticClass:"far fa-question-circle",attrs:{"data-toggle":"tooltip","title":"Considerando o retorno médio dos empréstimos em curso (CDI) até o mês de abril/2019."}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row text-center text-md-left"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('h3',[_vm._v("Por que investir na IOUU?")]),_vm._v(" "),_c('p',[_vm._v("Nossa plataforma conecta você com empresas qualificadas de uma forma rápida, simples e transparente, usando o melhor das tecnologias atuais. Garantimos retornos altos, superiores aos investimentos tradicionais como Poupança, CDB e Tesouro direto.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('h3',[_vm._v("Cuidamos do seu investimento")]),_vm._v(" "),_c('p',[_vm._v("Realizamos uma avaliação de crédito rigorosa através do nosso motor de crédito de alta tecnologia, de modo que você empresta seu dinheiro para empresas com capacidade de pagamento, de acordo com nossas expectativas.")])])]),_vm._v(" "),_c('hr',{staticClass:"tealish"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h2',[_vm._v("Investimentos em 3 passos")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 text-center text-md-left"},[_c('span',{staticClass:"circle"},[_c('strong',[_vm._v("1")])]),_vm._v(" "),_c('h3',[_vm._v("Tomador solicita empréstimo")]),_vm._v(" "),_c('p',[_vm._v("Nossa plataforma conecta você com empresas qualificadas de uma forma rápida, simples e transparente, usando o melhor das tecnologias atuais. Garantimos retornos altos, superiores aos investimentos tradicionais como Poupança, CDB e Tesouro direto.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 text-center text-md-left"},[_c('span',{staticClass:"circle"},[_c('strong',[_vm._v("2")])]),_vm._v(" "),_c('h3',[_vm._v("Voce consulta as rodadas disponíveis")]),_vm._v(" "),_c('p',[_vm._v("Acesse as oportunidades disponíveis na plataforma e confira o resultado completo de nossa análise de crédito, podendo escolher onde investir de acordo com seu perfil.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 text-center text-md-left"},[_c('span',{staticClass:"circle"},[_c('strong',[_vm._v("3")])]),_vm._v(" "),_c('h3',[_vm._v("Invista nas oportunidades Abertas")]),_vm._v(" "),_c('p',[_vm._v("Escolha a rodada de acordo com seu perfil de investidor e realize seu investimento. As parcelas são recebidas mensalmente na sua carteira virtual de acordo com a rentabilidade e prazo estabelecido.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature-margin pt-2 pt-md-4 pt-lg-5 pb-2 pb-md-4 pb-lg-5"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"jumbotron dusk text-center"},[_c('h3',[_vm._v("Porque realizar um investimento coletivo ou um investimento de impacto?")]),_vm._v(" "),_c('hr',{staticClass:"tealish"}),_vm._v(" "),_c('p',[_vm._v("Rápido. Simples. Bom para você e para o mundo")]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-3 col-lg-2"},[_c('div',{staticClass:"icon icon-online"}),_vm._v(" "),_c('span',[_vm._v("100% online")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 col-lg-2"},[_c('div',{staticClass:"icon icon-rentabilidade"}),_vm._v(" "),_c('span',[_vm._v("Alta rentabilidade")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 col-lg-2"},[_c('div',{staticClass:"icon icon-taxas"}),_vm._v(" "),_c('span',[_vm._v("Taxas mais justas")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 col-lg-2"},[_c('div',{staticClass:"icon icon-transparencia"}),_vm._v(" "),_c('span',[_vm._v("Transparência no processo")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 col-lg-2"},[_c('div',{staticClass:"icon icon-acessivel"}),_vm._v(" "),_c('span',[_vm._v("Acessível para todos")])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center data"},[_c('div',{staticClass:"col-12 text-center"},[_c('h2',[_vm._v("Rentabilidade dos empréstimos em curso")])]),_vm._v(" "),_c('div',{staticClass:"col-10"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v("384,07%")]),_vm._v(" "),_c('small',[_vm._v("retorno médio (CDI)")]),_vm._v(" "),_c('p',[_vm._v("Retorno médio dos empréstimos em curso (CDI).")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v("1,40%")]),_vm._v(" "),_c('small',[_vm._v("crédito vencido")]),_vm._v(" "),_c('p',[_vm._v("% de capital em atraso há mais de 60 dias e que está em processo de recuperação.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v("356,70%")]),_vm._v(" "),_c('small',[_vm._v("retorno médio real(CDI)")]),_vm._v(" "),_c('p',[_vm._v("Retorno médio dos empréstimos em curso descontando a % de crédito vencido.")])])])])]),_vm._v(" "),_c('hr',{staticClass:"tealish"}),_vm._v(" "),_c('div',{staticClass:"row justify-content-center data"},[_c('div',{staticClass:"col-12 text-center"},[_c('h2',[_vm._v("Acumululada desde o lançamento")])]),_vm._v(" "),_c('div',{staticClass:"col-10"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v("24,54%")]),_vm._v(" "),_c('small',[_vm._v("rentabilidade acomuludada bruta")]),_vm._v(" "),_c('p',[_vm._v("Rentabilidade acumulada bruta dos empréstimos realizados desde o lançamento (12 meses).")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v("00,00%")]),_vm._v(" "),_c('small',[_vm._v("débito podre")]),_vm._v(" "),_c('p',[_vm._v("% de crédito perdido.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v("24,54%")]),_vm._v(" "),_c('small',[_vm._v("retorno acumulado ajustado")]),_vm._v(" "),_c('p',[_vm._v("Rentabilidade acumulada bruta decontando a % de crédito perdido.")])])])])]),_vm._v(" "),_c('hr',{staticClass:"tealish"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('section',{staticClass:"col-12 depoimentos"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_c('h2',{staticClass:"main-title"},[_vm._v("Depoimentos")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"carousel slide",attrs:{"id":"depoimentos","data-ride":"carousel"}},[_c('ol',{staticClass:"carousel-indicators"},[_c('li',{attrs:{"data-target":"#depoimentos","data-slide-to":"0"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#depoimentos","data-slide-to":"1"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#depoimentos","data-slide-to":"2"}}),_vm._v(" "),_c('li',{staticClass:"active",attrs:{"data-target":"#depoimentos","data-slide-to":"3"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#depoimentos","data-slide-to":"4"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#depoimentos","data-slide-to":"5"}})]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-10 text-center"},[_c('div',{staticClass:"carousel-inner"},[_c('div',{staticClass:"carousel-item"},[_c('p',[_vm._v("Realizado investimentos P2P com a IOUU e até o momento me sinto muito satisfeito. Acompanho diariamente minha carteira e tenho notado uma baixa inadimplência. Não tenho dúvidas que isto se deve ao trabalho\n                                                 sério que realizam com as empresas tomadoras dos empréstimos. Sempre que precisei esclarecer minhas dúvidas sobre quaisquer assuntos fui prontamente atendido. Tenho conversado com amigos dispostos a investir\n                                                 nesta modalidade e recomendo a IOUU.")]),_vm._v(" "),_c('h3',[_vm._v("Gilberto Domingues")]),_vm._v(" "),_c('small',[_vm._v("São Paulo, São Paulo - Brasil")])]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('p',[_vm._v("Gostaria de parabenizar pelo trabalho de vocês. A ideia da carteira virtual é sensacional e facilita muito para reinvestir. E o site de vocês é muito bonito e fácil de navegar. Já usei outras plataformas e\n                                                 posso dizer que vocês são muito melhores.")]),_vm._v(" "),_c('h3',[_vm._v("Roberto Sávio")]),_vm._v(" "),_c('small',[_vm._v("São José dos Campos, São Paulo - Brasil")])]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('p',[_vm._v("Plataforma simples e completa, com as informações necessárias fáceis de achar, rendimento digno e, se não houver inadimplência, é perfeita.")]),_vm._v(" "),_c('h3',[_vm._v("Paolo dos Santos")]),_vm._v(" "),_c('small',[_vm._v("Itapira, São Paulo - Brasil")])]),_vm._v(" "),_c('div',{staticClass:"carousel-item active"},[_c('p',[_vm._v("Tudo vem ocorrendo de forma clara e bem informada. Pra ser sincero, até extrapolei o que havia considerado como valor ideal para um início de relação com vocês, justamente por estar satisfeito com as\n                                                 condições/estrutura/feedback oferecidos pela IOUU.")]),_vm._v(" "),_c('h3',[_vm._v("Jorge Araújo")]),_vm._v(" "),_c('small',[_vm._v("Guarujá, São Paulo - Brasil")])]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('p',[_vm._v("Acho que a IOUU montou uma plataforma bem estruturada, interativa e prática, além da qualidade das empresas investidas que trazem uma boa rentabilidade alternativa aos produtos bancários comuns.")]),_vm._v(" "),_c('h3',[_vm._v("Fernando de Marco")]),_vm._v(" "),_c('small',[_vm._v("São José dos Campos, São Paulo - Brasil")])]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('p',[_vm._v("Investir na IOUU foi uma grata surpresa, onde tem sido possível obter uma rentabilidade superior às aplicações tradicionais. Somado a isso, confio na empresa pois a IOUU demonstra um grande comprometimento com\n                                                 os seus investidores.")]),_vm._v(" "),_c('h3',[_vm._v("Samuel Poeta")]),_vm._v(" "),_c('small',[_vm._v("Montenegro, Rio Grande do Sul - Brasil")])])])])])])])])])]),_vm._v(" "),_c('hr',{staticClass:"tealish"}),_vm._v(" "),_c('div',{staticClass:"row text-center text-md-left"},[_c('div',{staticClass:"col-12 text-center"},[_c('h2',[_vm._v("Conheça a IOUU")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('h3',[_vm._v("O que é a IOUU?")]),_vm._v(" "),_c('p',[_vm._v("Conectamos empresas que procuram crédito e investidores com dinheiro para emprestar. Nossa plataforma é mais eficiente e transparente do que os empréstimos tradicionais e acreditamos que é um sistema melhor para todos.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('h3',[_vm._v("O que significa investir?")]),_vm._v(" "),_c('p',[_vm._v("Você escolhe e investe nas melhores oportunidades da plataforma conforme seu perfil de investidor e, mês a mês, recebe pagamentos conforme a rentabilidade e prazo estimados.")])])]),_vm._v(" "),_c('hr',{staticClass:"tealish"}),_vm._v(" "),_c('div',{staticClass:"row questions"},[_c('div',{staticClass:"col-12 text-center"},[_c('h2',[_vm._v("Resposta para suas dúvidas")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('ul',{staticClass:"column-1"},[_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#id-001"}},[_vm._v("Quais serviços a IOUU oferece para os investidores?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#id-002"}},[_vm._v("Qual o valor mínimo de investimento?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#id-003"}},[_vm._v("Quanto custa investir na IOUU?")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('ul',{staticClass:"column-2"},[_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#id-004"}},[_vm._v("Qual o procedimento em caso de atraso da parcela mensal?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#id-005"}},[_vm._v("Qual a garantia que receberei meu investimento de volta?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#id-006"}},[_vm._v("A IOUU é um banco ou instituição financeira?")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature-margin pt-2 pt-md-4 pt-lg-5 pb-2 pb-md-4 pb-lg-5"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"jumbotron background background-200852716 cta"},[_c('div',{staticClass:"alpha"}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('h3',[_vm._v("Pronto para ganhar dinheiro e garantir o futuro?")]),_vm._v(" "),_c('a',{staticClass:"btn btn-light btn-lg",attrs:{"href":"#cta","role":"button"}},[_vm._v("Comece a investir")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qQMI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioComprovanteEndereco_vue__ = __webpack_require__("7XyA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48759f3f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioComprovanteEndereco_vue__ = __webpack_require__("0OJJ");
function injectStyle (ssrContext) {
  __webpack_require__("sxXF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48759f3f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioComprovanteEndereco_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48759f3f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioComprovanteEndereco_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qSRk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvisoDocumentosStep_vue__ = __webpack_require__("DdtL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bcdc836_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvisoDocumentosStep_vue__ = __webpack_require__("FgIv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvisoDocumentosStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bcdc836_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvisoDocumentosStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qSzJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"right"},[_c('div',{staticClass:"top"},[_c('router-link',{staticClass:"login",attrs:{"to":"/login"}},[_c('img',{attrs:{"src":__webpack_require__("u9Ef"),"alt":"icone login"}}),_vm._v(_vm._s(_vm.alreadyAccount))]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.titleForm))])],1),_vm._v(" "),_c('form',{staticClass:"form",attrs:{"action":"","id":"form-cadastro"},on:{"submit":function($event){$event.preventDefault();return _vm.createAccount($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nome"}},[_vm._v("Nome Completo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAccount.fullname),expression:"newAccount.fullname"}],staticClass:"js-input",class:{ 'error': _vm.hasError.name },attrs:{"type":"text","name":"firstname","id":"nome"},domProps:{"value":(_vm.newAccount.fullname)},on:{"focusout":_vm.validateName,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newAccount, "fullname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAccount.email),expression:"newAccount.email"}],staticClass:"js-input",class:{ 'error': _vm.hasError.email },attrs:{"type":"email","name":"email","id":"email"},domProps:{"value":(_vm.newAccount.email)},on:{"focusout":[_vm.isEmailDeliverable,_vm.validateEmail],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newAccount, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"senha"}},[_vm._v("Senha")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAccount.password),expression:"newAccount.password"}],staticClass:"js-input password",class:{ 'error': _vm.hasError.password },attrs:{"type":"password","name":"senha","id":"senha","onmouseover":"this.type='text'","onmouseout":"this.type='password'"},domProps:{"value":(_vm.newAccount.password)},on:{"focusout":_vm.validatePassword,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newAccount, "password", $event.target.value)}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"form-group terms"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowTerms),expression:"allowTerms"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"termo","name":"termo"},domProps:{"checked":Array.isArray(_vm.allowTerms)?_vm._i(_vm.allowTerms,null)>-1:(_vm.allowTerms)},on:{"change":function($event){var $$a=_vm.allowTerms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.allowTerms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.allowTerms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.allowTerms=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn",attrs:{"type":"submit","disabled":_vm.disable}},[_vm._v("\n          Comece a investir melhor\n          "),_c('img',{attrs:{"src":__webpack_require__("RYdq"),"alt":"icone seta"}})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":__webpack_require__("LQU4"),"alt":"icone senha"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"termo"}},[_vm._v("Li e concordo com os\n          "),_c('a',{staticClass:"term",attrs:{"href":"https://iouu.com.br/termos","target":"_blank"}},[_vm._v("termos e condições")]),_vm._v("\n          e\n          "),_c('a',{staticClass:"condition",attrs:{"href":"https://iouu.com.br/politica-de-privacidade/","target":"_blank"}},[_vm._v("política de privacidade")]),_vm._v("\n          da IOUU.\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qTZk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wallet"},[(_vm.renderizado)?_c('div',[_c('div',{staticClass:"row align-items-center wallet__tit-page tit_page"},[_c('div',{staticClass:"col-8 col-md-8 col-lg-8 d-flex align-items-center"},[_c('h1',[_vm._v("Carteira virtual")]),_vm._v(" "),(false)?_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/investimentos/carteira-investimento/adicionar-fundos","title":"Adicionar fundos"}},[_c('i',{staticClass:"ico-din-4"}),_vm._v(" \n                        Adicionar fundos\n                ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-4 col-md-4 col-lg-4"},[_c('div',{staticClass:"back back-hide float-right"},[_c('router-link',{attrs:{"to":"/investimentos/meus-investimentos","title":"Voltar"}},[_c('i',[_vm._v(" ")]),_vm._v(" \n                            voltar\n                    ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('wallet-header',{attrs:{"saldo":_vm.Saldo}}),_vm._v(" "),_c('div',{staticClass:"box-border wallet__extrato"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"accordion",class:(_vm.loadingList) ? 'loading-accordion' : '',attrs:{"id":"accordion"}},[(_vm.loadingList)?[_c('div',{staticClass:"loader"})]:[_c('WalletExtratoLista',{attrs:{"operacoes":_vm.Operacoes}})]],2),_vm._v(" "),_c('Pagination',{attrs:{"paginasTotais":this.Paginas,"paginaAtual":this.PaginaAtual,"navigate":_vm.mudarPagina}})],1)],1)])]):_c('div',[_c('div',{staticClass:"row align-items-center wallet__tit-page tit_page"},[_c('div',{staticClass:"col-8 col-md-8 col-lg-8 d-flex align-items-center"},[_c('h1',[_vm._v("Carteira virtual")]),_vm._v(" "),(false)?_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/investimentos/carteira-investimento/adicionar-fundos","title":"Adicionar fundos"}},[_c('i',{staticClass:"ico-din-4"}),_vm._v(" \n                        Adicionar fundos\n                ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-4 col-md-4 col-lg-4"},[_c('div',{staticClass:"back back-hide float-right"},[_c('router-link',{attrs:{"to":"/investimentos/meus-investimentos","title":"Voltar"}},[_c('i',[_vm._v(" ")]),_vm._v(" \n                            voltar\n                    ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('wallet-header',{attrs:{"saldo":0.0}}),_vm._v(" "),_vm._m(1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wallet__extrato--tit"},[_c('h2',[_vm._v("Minhas transações")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion--btn text-center"},[_c('div',{staticClass:"box-border wallet__extrato empty"},[_c('h4',[_vm._v("\n                            Nenhuma transação realizada\n                        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qYbp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('p',[_vm._v("Declaração de endividamento assinado pelo contador contendo: instituição, limite, modalidade, garantias, saldo, devedor, data inicial, data final, valor da PMT")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qeVz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_client__ = __webpack_require__("6Yc5");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            finishedLoading: false,
            user: null,
            EmailOportunidades: true,
            EmailRepagamento: true,
            EmailNewsletter: true,
            SmsOportunidades: true,
            SaqueAutomatico: false,
            SmsRepagamento: true,
            WhatsOportunidates: true,
            WhatsRepagamento: true
        };
    },

    methods: {
        EnviarDados: function EnviarDados() {
            var _this = this;

            console.log(this.EmailOportunidades);
            console.log(this.EmailRepagamento);
            console.log(this.EmailRepagamento);
            console.log(this.SmsOportunidades);
            console.log(this.SmsRepagamento);
            console.log(this.WhatsOportunidates);
            console.log(this.WhatsRepagamento);
            console.log(this.SaqueAutomatico);

            var options = {
                "EmailOportunidades": this.EmailOportunidades,
                "EmailRepagamento": this.EmailRepagamento,
                "EmailNewsletter": this.EmailNewsletter,
                "SmsOportunidades": this.SmsOportunidades,
                "SmsRepagamento": this.SmsRepagamento,
                "WhatsOportunidates": this.WhatsOportunidates,
                "WhatsRepagamento": this.WhatsRepagamento,
                "SaqueAutomatico": this.SaqueAutomatico
            };

            __WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].userNotificationInvestor(this.user._id, options).then(function (response) {
                if (response.status === 200) {
                    _this.$Notify.info('Notificações atualizadas');
                } else {
                    _this.$Notify.info('Ops, Ocorreu algum problema, tente mais tarde!');
                }
            });
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: 'perfil/configuracoes',
                title: 'Configuracoes'
            });
        }
    },
    beforeCreate: function beforeCreate() {
        var _this2 = this;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["c" /* START_LOADING */]);

        __WEBPACK_IMPORTED_MODULE_3__utils_api_client__["a" /* default */].getUser().then(function (response) {
            _this2.user = response;

            if (_this2.user.NotificacoesInvestidor) {
                _this2.EmailOportunidades = _this2.user.NotificacoesInvestidor.EmailOportunidades != null || _this2.user.NotificacoesInvestidor.EmailOportunidades != undefined ? _this2.user.NotificacoesInvestidor.EmailOportunidades : true;
                _this2.EmailRepagamento = _this2.user.NotificacoesInvestidor.EmailRepagamento != null || _this2.user.NotificacoesInvestidor.EmailRepagamento != undefined ? _this2.user.NotificacoesInvestidor.EmailOportunidades : true;
                _this2.EmailNewsletter = _this2.user.NotificacoesInvestidor.EmailNewsletter != null || _this2.user.NotificacoesInvestidor.EmailNewsletter != undefined ? _this2.user.NotificacoesInvestidor.EmailOportunidades : true;
                _this2.SmsOportunidades = _this2.user.NotificacoesInvestidor.SmsOportunidades != null || _this2.user.NotificacoesInvestidor.SmsOportunidades != undefined ? _this2.user.NotificacoesInvestidor.EmailOportunidades : true;
                _this2.SmsRepagamento = _this2.user.NotificacoesInvestidor.SmsRepagamento != null || _this2.user.NotificacoesInvestidor.SmsRepagamento != undefined ? _this2.user.NotificacoesInvestidor.EmailOportunidades : true;
                _this2.WhatsOportunidates = _this2.user.NotificacoesInvestidor.WhatsOportunidates != null || _this2.user.NotificacoesInvestidor.WhatsOportunidates != undefined ? _this2.user.NotificacoesInvestidor.EmailOportunidades : true;
                _this2.WhatsRepagamento = _this2.user.NotificacoesInvestidor.WhatsRepagamento != null || _this2.user.NotificacoesInvestidor.WhatsRepagamento != undefined ? _this2.user.NotificacoesInvestidor.EmailOportunidades : true;
                _this2.SaqueAutomatico = _this2.user.NotificacoesInvestidor.SaqueAutomatico != null || _this2.user.NotificacoesInvestidor.SaqueAutomatico != undefined ? _this2.user.NotificacoesInvestidor.SaqueAutomatico : false;
            }

            _this2.finishedLoading = true;
            _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
        }).catch(function () {
            _this2.finishedLoading = true;
            _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    },
    created: function created() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this3.taggingGA();

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this3);
        }))();
    }
});

/***/ }),

/***/ "qgnJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      transitionName: 'slide-left',
      investor: null
    };
  },


  methods: {
    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/cadastrar-senha',
        title: 'CadastrarSenha'
      });
    }
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.taggingGA();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "qiTp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qtvW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',[_c('div',{staticClass:"form-group"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Documento de identidade")]),_vm._v(" "),_c('p',[_vm._v("Envie uma cópia de um dos documentos de identidade "),_c('strong',[_vm._v("(RG ou CNH)")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r/tM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',[_c('div',{staticClass:"form-group"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit page"},[_c('h1',[_vm._v("Comprovante de Endereço")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r6Tt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"Genre"}},[_vm._v("Sexo")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","required":"","placeholder":"Selecione..."},model:{value:(_vm.currentUser.Pessoal.Sexo),callback:function ($$v) {_vm.$set(_vm.currentUser.Pessoal, "Sexo", $$v)},expression:"currentUser.Pessoal.Sexo"}},_vm._l((_vm.optionsGenre),function(genre,index){return _c('at-option',{key:("genreOptions" + index),attrs:{"value":genre.value}},[_vm._v(_vm._s(genre.label))])}),1)],1),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Sexo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rDa/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wallet"},[_c('div',{staticClass:"row align-items-center funds-transfer__tit-page tit_page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4"},[_c('div',{staticClass:"back back-hide float-md-right"},[_c('router-link',{attrs:{"to":"/investimentos/carteira-investimento","title":"Voltar"}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar")])],1)])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-7"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-12 col-md-6 d-flex justify-content-sm-center justify-content-md-end"},[_c('div',{staticClass:"coupon",attrs:{"id":"cupom"}},[_c('div',{staticClass:"coupon__head"}),_vm._v(" "),_c('div',{staticClass:"coupon__body"},[_c('img',{attrs:{"src":"/static/assets/images/logotipo-iouu.png","width":"70","alt":"Logotipo IOUU"}}),_vm._v(" "),_c('p',{staticClass:"id"},[_vm._v("COMPROVANTE "+_vm._s(_vm.idComprovante))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                                RECEBIDO EM: "),_c('br'),_c('span',[_vm._v(_vm._s(_vm.dataOperacao))])]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("De: "),_c('span',[_vm._v(_vm._s(_vm.nomeEmpresa))])]),_vm._v(" "),_c('li',[_vm._v("Parcela: "),_c('span',[_vm._v(_vm._s(_vm.recebimentoParcela))])]),_vm._v(" "),_c('li',[_vm._v("Principal: "),_c('span',[_vm._v(_vm._s(_vm.valorPrincipal))])]),_vm._v(" "),_c('li',[_vm._v("Juros: "),_c('span',[_vm._v(_vm._s(_vm.juros))])]),_vm._v(" "),_c('li',[_vm._v("Multa por atraso: "),_c('span',[_vm._v(_vm._s(_vm.multa))])]),_vm._v(" "),_c('li',[_vm._v("Valor bruto pago: "),_c('span',[_vm._v(_vm._s(_vm.valorBruto))])]),_vm._v(" "),_c('li',[_vm._v("IR: "),_c('span',[_vm._v(_vm._s(_vm.ir))])]),_vm._v(" "),_c('li',[_vm._v("Valor Liquido: "),_c('span',[_vm._v(_vm._s(_vm.valorLiquido))])]),_vm._v(" "),_c('li',[_vm._v("CNPJ: "),_c('span',[_vm._v(_vm._s(_vm.documento))])])])]),_vm._v(" "),_c('div',{staticClass:"coupon__foot"})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"wallet__description"},[_c('h2',[_vm._v("Recebimento realizado")]),_vm._v(" "),_c('div',[_c('p',[_c('strong',[_vm._v("Valor bruto pago")]),_vm._v(" "),_c('span',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.valorBruto))])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("IR")]),_vm._v(" "),_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.ir))])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Valor líquido pago")]),_vm._v(" "),_c('span',{staticClass:"text-success"},[_vm._v(_vm._s(_vm.valorLiquido))])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary btn-lg",attrs:{"title":"Imprimir comprovante"},on:{"click":function($event){return _vm.printPdf()}}},[_c('i',{staticClass:"fas fa-print"}),_vm._v("Imprimir comprovante")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary btn-lg",attrs:{"title":"Salvar comprovante"},on:{"click":function($event){return _vm.savePdf()}}},[_c('i',{staticClass:"fas fa-download"}),_vm._v("Salvar comprovante")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-8"},[_c('h1',[_vm._v("Comprovante de Pagamento")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rI+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rLp4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"back float-right"},[_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._m(1)])])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-9 info-business"},[_c('div',{class:'d-flex business align-items-center ' + 'status-' + _vm.abreviaStatus(_vm.solicitacao.StatusAtraso)},[_c('h3',[_vm._v(_vm._s(_vm.solicitacao.NomeEmpresa))]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":'/investimentos/historico/historico-de-investimento/' + _vm.reserva._id}},[_vm._v("Ver solicitação")]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("Status:")]),_vm._v(" "+_vm._s(_vm.formataStatus(_vm.solicitacao.StatusAtraso)))])],1),_vm._v(" "),_c('p',[_c('span',{staticClass:"cnpj"},[_vm._v("CNPJ: "+_vm._s(_vm.formatarCnpj(_vm.solicitacao.Cnpj)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formataEmprestimo(_vm.solicitacao.TipoEmprestimo)))])])]),_vm._v(" "),_c('div',{class:'col-12 col-md-3 text-left text-md-right align-self-end mt-2 rating rating-' + _vm.abreviaStatus(_vm.solicitacao.StatusAtraso)},[_c('strong',{staticClass:"d-flex justify-content-md-end align-items-center"},[_vm._v("\n                        Score da operação "),_c('span',{class:'circle ' + 'score-' + _vm.formatarScore(_vm.solicitacao.Score)}),_vm._v(" "+_vm._s(_vm.solicitacao.Score)+"\n                    ")])])]),_vm._v(" "),(_vm.regua === true)?_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"regua-cobranca rounded"},[_c('div',{staticClass:"row align-items-center"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 col-lg-9"},[_c('div',{staticClass:"container-progress"},[_vm._m(3),_vm._v(" "),_c('div',{class:'point point-15 ' + _vm.isActive(15, _vm.solicitacao.DataVencimento)},[_vm._m(4),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("15")])]),_vm._v(" "),_c('div',{class:'point point-30 ' + _vm.isActive(30, _vm.solicitacao.DataVencimento)},[_vm._m(5),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("30")])]),_vm._v(" "),_c('div',{class:'point point-60 ' + _vm.isActive(60, _vm.solicitacao.DataVencimento)},[_vm._m(6),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("60")])]),_vm._v(" "),_c('div',{class:'point point-90 ' + _vm.isActive(90, _vm.solicitacao.DataVencimento)},[_vm._m(7),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("90")])]),_vm._v(" "),_c('div',{class:'point right ' + _vm.isActive(120, _vm.solicitacao.DataVencimento)},[_vm._m(8),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("+120")])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"amount"},[_c('div',{staticClass:"amount-indicator",style:('width: ' + _vm.formatarPorcentagem(_vm.solicitacao.DataVencimento) + '%')})])])])])])])])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),(_vm.notificacoes.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},_vm._l((_vm.notificacoes),function(notificacao){return _c('div',{key:notificacao,staticClass:"item"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v("Parcela "+_vm._s(parseInt(_vm.solicitacao.ParcelasAtrasadas))+" de "+_vm._s(_vm.solicitacao.Informacoes.Prazo)+" : Vencido desde "+_vm._s(_vm.formataData(_vm.solicitacao.DataVencimento)))])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(9,true),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('strong',[_vm._v(_vm._s(_vm.formataData(notificacao.Updated))+" - "+_vm._s(notificacao.Titulo))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(notificacao.Mensagem)}})])]),_vm._v(" "),_c('br'),_vm._v(" "),(notificacao.Documento)?_c('div',{staticClass:"row"},[_vm._m(10,true),_vm._v(" "),_vm._l((notificacao.Documento),function(doc){return _c('div',{key:doc,staticClass:"col-12 col-md-16"},[_c('ul',[_c('li',{staticClass:"d-flex align-items-center"},[_c('img',{attrs:{"src":"/static/assets/images/ico-pdf.png","alt":"Icone pdf"}}),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.abrirDoc(doc.TokenAzure)}}},[_vm._v(_vm._s(doc.NomeArquivo))])])])])})],2):_vm._e()])}),0)]):_c('div',{staticClass:"row align-items-center info"},[_c('div',{staticClass:"col-12 d-flex flex-column justify-content-center"},[_c('div',{staticClass:"text-center"},[(_vm.solicitacao.StatusAtraso == 'Emdia')?_c('h5',[_vm._v("O empréstimo dessa empresa está em dia até o momento.")]):(_vm.notificacoes.length == 0)?_c('h5',[_vm._v("Não há notificações sobre recebíveis desta empresa até o momento.")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-outline-secondary",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._m(11)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("Central de cobranças")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{attrs:{"src":"/static/assets/images/ico-back.svg"}}),_vm._v(" Voltar")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-4 col-lg-3"},[_c('h4',[_vm._v("Régua de cobrança")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"point left active"},[_c('span',{staticClass:"point-bullet",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Pagamentos em dia"}},[_c('i')]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"point-bullet",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Negativado"}},[_c('i')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"point-bullet",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Protesto"}},[_c('i')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"point-bullet",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Processo judicial"}},[_c('i')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"point-bullet",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Processo judicial em andamento"}},[_c('i')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"point-bullet",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Processo judicial em andamento"}},[_c('i')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-10"},[_c('strong',[_vm._v("Notificação:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('strong',[_vm._v("Documentos anexados:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{attrs:{"src":"/static/assets/images/ico-back.svg"}}),_vm._v(" Voltar página")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rMFz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoEnvioIdentidade_vue__ = __webpack_require__("ZdCC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c0e7728_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoEnvioIdentidade_vue__ = __webpack_require__("DVzr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassoEnvioIdentidade_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c0e7728_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassoEnvioIdentidade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rMKe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NovaSenha_vue__ = __webpack_require__("b4kQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_110c839a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NovaSenha_vue__ = __webpack_require__("OOMu");
function injectStyle (ssrContext) {
  __webpack_require__("mcyq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-110c839a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NovaSenha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_110c839a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NovaSenha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rSIk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AdditionalInformationPeerToPeer_LizaStep__ = __webpack_require__("W1wB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AdditionalInformationPeerToPeer_ConfirmacaoIdentidadePasso__ = __webpack_require__("/vPs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AdditionalInformationPeerToPeer_RetentativaConfirmacaoIdentidadePasso__ = __webpack_require__("bEzG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AdditionalInformationPeerToPeer_RepresentativeFullNameStep__ = __webpack_require__("fZam");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AdditionalInformationPeerToPeer_ContactsStep__ = __webpack_require__("Tjzq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AdditionalInformationPeerToPeer_FoundingDateStep__ = __webpack_require__("Hd66");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AdditionalInformationPeerToPeer_CompanyTypeStep__ = __webpack_require__("SrdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AdditionalInformationPeerToPeer_HasAccountantStep__ = __webpack_require__("QBtY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AdditionalInformationPeerToPeer_AccountantDataStep__ = __webpack_require__("yB1K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AdditionalInformationPeerToPeer_FaturamentoMensalStep__ = __webpack_require__("gne+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AdditionalInformationPeerToPeer_LucroMensalStep__ = __webpack_require__("htp1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AdditionalInformationPeerToPeer_AddressStep__ = __webpack_require__("riPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AdditionalInformationPeerToPeer_InscricaoEstadualStep__ = __webpack_require__("UkDW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AdditionalInformationPeerToPeer_DataInscricaoEstadualStep__ = __webpack_require__("2jPX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AdditionalInformationPeerToPeer_TributationStep__ = __webpack_require__("1g+n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_AdditionalInformationPeerToPeer_EmployeesAmountStep__ = __webpack_require__("rVm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_AdditionalInformationPeerToPeer_PartnersStep__ = __webpack_require__("oynA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_AdditionalInformationPeerToPeer_GuarantorsStep__ = __webpack_require__("EoRA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_AdditionalInformationPeerToPeer_NetWorthStep__ = __webpack_require__("SoQC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AdditionalInformationPeerToPeer_HasBankDebtStep__ = __webpack_require__("4VZC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_AdditionalInformationPeerToPeer_BankDebtValueStep__ = __webpack_require__("IPRP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_AdditionalInformationPeerToPeer_FinaciamentosContratadosStep__ = __webpack_require__("bNNB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_AdditionalInformationPeerToPeer_FinanciamentosSociosStep__ = __webpack_require__("bJJT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_AdditionalInformationPeerToPeer_HasCorporateGroupStep__ = __webpack_require__("UAl2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_AdditionalInformationPeerToPeer_SocialMediaStep__ = __webpack_require__("Unc7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_AdditionalInformationPeerToPeer_CompaniesCorporateGroupStep__ = __webpack_require__("UWMW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_AdditionalInformationPeerToPeer_InstitutionalInformationStep__ = __webpack_require__("eiIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_AdditionalInformationPeerToPeer_BankDataStep__ = __webpack_require__("OUpg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_AdditionalInformationPeerToPeer_ConfirmacaoTokenStep__ = __webpack_require__("h9EJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_AdditionalInformationPeerToPeer_AvisoDocumentosStep__ = __webpack_require__("qSRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_AdditionalInformationPeerToPeer_EnvioComprovanteEndereco__ = __webpack_require__("qQMI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_AdditionalInformationPeerToPeer_EnvioFaturamentoPasso__ = __webpack_require__("5Tm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_AdditionalInformationPeerToPeer_EnvioContratoSocialPasso__ = __webpack_require__("3mVv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_AdditionalInformationPeerToPeer_EnvioComprovanteMeiStep__ = __webpack_require__("f8wk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_AdditionalInformationPeerToPeer_EnvioUltimosExtratosTodasContasPasso__ = __webpack_require__("sKK0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_AdditionalInformationPeerToPeer_EnvioIrpfPasso__ = __webpack_require__("rYYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_AdditionalInformationPeerToPeer_EnvioIdentidadeStep__ = __webpack_require__("pgra");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_AdditionalInformationPeerToPeer_EnvioBalancoDrePasso__ = __webpack_require__("OORf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_AdditionalInformationPeerToPeer_EnvioDeclaracaoEndividamentoPasso__ = __webpack_require__("Zs6t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_AdditionalInformationPeerToPeer_ConfirmacaoEnvioPasso__ = __webpack_require__("juYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_AdditionalInformationPeerToPeer_CanceledStep__ = __webpack_require__("SgFN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_AdditionalInformationPeerToPeer_FinishedStep__ = __webpack_require__("xsY1");















//import TaxRegimeStep                            from '@/components/AdditionalInformationPeerToPeer/TaxRegimeStep'






























var steps = {
  'PREAPROVADO-step': __WEBPACK_IMPORTED_MODULE_0__components_AdditionalInformationPeerToPeer_LizaStep__["a" /* default */],
  'nome-completo-step': __WEBPACK_IMPORTED_MODULE_3__components_AdditionalInformationPeerToPeer_RepresentativeFullNameStep__["a" /* default */],
  'confirmacao-identidade-step': __WEBPACK_IMPORTED_MODULE_1__components_AdditionalInformationPeerToPeer_ConfirmacaoIdentidadePasso__["a" /* default */],
  'retentativa-confirmacao-identidade-step': __WEBPACK_IMPORTED_MODULE_2__components_AdditionalInformationPeerToPeer_RetentativaConfirmacaoIdentidadePasso__["a" /* default */],
  'contatos-telefone-step': __WEBPACK_IMPORTED_MODULE_4__components_AdditionalInformationPeerToPeer_ContactsStep__["a" /* default */],
  'data-fundacao-step': __WEBPACK_IMPORTED_MODULE_5__components_AdditionalInformationPeerToPeer_FoundingDateStep__["a" /* default */],
  'tipo-empresa-step': __WEBPACK_IMPORTED_MODULE_6__components_AdditionalInformationPeerToPeer_CompanyTypeStep__["a" /* default */],
  'tem-contador-step': __WEBPACK_IMPORTED_MODULE_7__components_AdditionalInformationPeerToPeer_HasAccountantStep__["a" /* default */],
  'dados-contador-step': __WEBPACK_IMPORTED_MODULE_8__components_AdditionalInformationPeerToPeer_AccountantDataStep__["a" /* default */],
  'endereco-step': __WEBPACK_IMPORTED_MODULE_11__components_AdditionalInformationPeerToPeer_AddressStep__["a" /* default */],
  'inscricao-estadual-step': __WEBPACK_IMPORTED_MODULE_12__components_AdditionalInformationPeerToPeer_InscricaoEstadualStep__["a" /* default */],
  'data-inscricao-estadual-step': __WEBPACK_IMPORTED_MODULE_13__components_AdditionalInformationPeerToPeer_DataInscricaoEstadualStep__["a" /* default */],
  'regime-de-tributacao-step': __WEBPACK_IMPORTED_MODULE_14__components_AdditionalInformationPeerToPeer_TributationStep__["a" /* default */],
  'quantidade-empregados-step': __WEBPACK_IMPORTED_MODULE_15__components_AdditionalInformationPeerToPeer_EmployeesAmountStep__["a" /* default */],
  'social-media-step': __WEBPACK_IMPORTED_MODULE_24__components_AdditionalInformationPeerToPeer_SocialMediaStep__["a" /* default */],
  'socios-step': __WEBPACK_IMPORTED_MODULE_16__components_AdditionalInformationPeerToPeer_PartnersStep__["a" /* default */],
  'avalistas-step': __WEBPACK_IMPORTED_MODULE_17__components_AdditionalInformationPeerToPeer_GuarantorsStep__["a" /* default */],
  'tem-divida-bancaria-step': __WEBPACK_IMPORTED_MODULE_19__components_AdditionalInformationPeerToPeer_HasBankDebtStep__["a" /* default */],
  'valor-divida-bancaria-step': __WEBPACK_IMPORTED_MODULE_20__components_AdditionalInformationPeerToPeer_BankDebtValueStep__["a" /* default */],
  'tem-financiamento-empresa-step': __WEBPACK_IMPORTED_MODULE_21__components_AdditionalInformationPeerToPeer_FinaciamentosContratadosStep__["a" /* default */],
  'tem-financiamento-socios-step': __WEBPACK_IMPORTED_MODULE_22__components_AdditionalInformationPeerToPeer_FinanciamentosSociosStep__["a" /* default */],
  'tem-grupo-economico-step': __WEBPACK_IMPORTED_MODULE_23__components_AdditionalInformationPeerToPeer_HasCorporateGroupStep__["a" /* default */],
  'empresas-grupo-economico-step': __WEBPACK_IMPORTED_MODULE_25__components_AdditionalInformationPeerToPeer_CompaniesCorporateGroupStep__["a" /* default */],
  'informacoes-institucionais-step': __WEBPACK_IMPORTED_MODULE_26__components_AdditionalInformationPeerToPeer_InstitutionalInformationStep__["a" /* default */],
  'dados-bancarios-step': __WEBPACK_IMPORTED_MODULE_27__components_AdditionalInformationPeerToPeer_BankDataStep__["a" /* default */],
  'confirmacao-token-step': __WEBPACK_IMPORTED_MODULE_28__components_AdditionalInformationPeerToPeer_ConfirmacaoTokenStep__["a" /* default */],
  'aviso-documentos-step': __WEBPACK_IMPORTED_MODULE_29__components_AdditionalInformationPeerToPeer_AvisoDocumentosStep__["a" /* default */],
  'envio-comprovante-endereco-step': __WEBPACK_IMPORTED_MODULE_30__components_AdditionalInformationPeerToPeer_EnvioComprovanteEndereco__["a" /* default */],
  'envio-faturamento-step': __WEBPACK_IMPORTED_MODULE_31__components_AdditionalInformationPeerToPeer_EnvioFaturamentoPasso__["a" /* default */],
  'envio-contrato-social-step': __WEBPACK_IMPORTED_MODULE_32__components_AdditionalInformationPeerToPeer_EnvioContratoSocialPasso__["a" /* default */],
  'envio-comprovante-mei-step': __WEBPACK_IMPORTED_MODULE_33__components_AdditionalInformationPeerToPeer_EnvioComprovanteMeiStep__["a" /* default */],
  'envio-ultimos-extratos-todas-contas-step': __WEBPACK_IMPORTED_MODULE_34__components_AdditionalInformationPeerToPeer_EnvioUltimosExtratosTodasContasPasso__["a" /* default */],
  'envio-irpf-step': __WEBPACK_IMPORTED_MODULE_35__components_AdditionalInformationPeerToPeer_EnvioIrpfPasso__["a" /* default */],
  'envio-identidade-step': __WEBPACK_IMPORTED_MODULE_36__components_AdditionalInformationPeerToPeer_EnvioIdentidadeStep__["a" /* default */],
  'envio-balanco-dre-step': __WEBPACK_IMPORTED_MODULE_37__components_AdditionalInformationPeerToPeer_EnvioBalancoDrePasso__["a" /* default */],
  'faturamento-mensal-step': __WEBPACK_IMPORTED_MODULE_9__components_AdditionalInformationPeerToPeer_FaturamentoMensalStep__["a" /* default */],
  'patrimonio-liquido-step': __WEBPACK_IMPORTED_MODULE_18__components_AdditionalInformationPeerToPeer_NetWorthStep__["a" /* default */],
  'lucro-mensal-step': __WEBPACK_IMPORTED_MODULE_10__components_AdditionalInformationPeerToPeer_LucroMensalStep__["a" /* default */],
  'envio-declaracao-endividamento-step': __WEBPACK_IMPORTED_MODULE_38__components_AdditionalInformationPeerToPeer_EnvioDeclaracaoEndividamentoPasso__["a" /* default */],
  'confirmacao-envio-step': __WEBPACK_IMPORTED_MODULE_39__components_AdditionalInformationPeerToPeer_ConfirmacaoEnvioPasso__["a" /* default */],
  'cancelado-step': __WEBPACK_IMPORTED_MODULE_40__components_AdditionalInformationPeerToPeer_CanceledStep__["a" /* default */],
  'finished-step': __WEBPACK_IMPORTED_MODULE_41__components_AdditionalInformationPeerToPeer_FinishedStep__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (steps);

/***/ }),

/***/ "rTd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('div',[_c('div',{staticClass:"carregando"},[_vm._v(" Carregando... ")]),_vm._v(" "),_c('div',{staticClass:"loader"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rVm8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeesAmountStep_vue__ = __webpack_require__("z2yU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be742fb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeesAmountStep_vue__ = __webpack_require__("CuWB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeesAmountStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be742fb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeesAmountStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rYYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioIrpfPasso_vue__ = __webpack_require__("gtE8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_892ac3f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioIrpfPasso_vue__ = __webpack_require__("/LYO");
function injectStyle (ssrContext) {
  __webpack_require__("p6b1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-892ac3f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioIrpfPasso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_892ac3f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioIrpfPasso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rhLV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ico-viacredi.79b8c55.png";

/***/ }),

/***/ "riPg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressStep_vue__ = __webpack_require__("Z4cu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01b63ce0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressStep_vue__ = __webpack_require__("T+5B");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01b63ce0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rvI3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("96tf");



var _this = this;


var BASE_URI_GO_API = "https://api.iouu.com.br" + '/api/v1';

var GetFaturasTomador = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(solicitacaoID) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* default */].AxiosAuthGet(BASE_URI_GO_API + '/fatura/' + solicitacaoID);

                    case 3:
                        return _context.abrupt('return', _context.sent);

                    case 6:
                        _context.prev = 6;
                        _context.t0 = _context['catch'](0);
                        throw new Error('Erro ao carregar as faturas do tomador');

                    case 9:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this, [[0, 6]]);
    }));

    return function GetFaturasTomador(_x) {
        return _ref.apply(this, arguments);
    };
}();

/* harmony default export */ __webpack_exports__["a"] = ({ GetFaturasTomador: GetFaturasTomador });

/***/ }),

/***/ "rxd5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((this.emprestimo),function(item){return _c('div',{key:item._id,class:'loans-details rating-'+_vm.lowerCase(item.Score)},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"float-left"},[_c('h1',[_vm._v("\n                        Meus empréstimos\n                        "),_c('span',[_vm._v(_vm._s(_vm.ajustIdOportunidade(item.IdOportunidade, 5)))]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.formatted(item.Documento)))])])]),_vm._v(" "),_c('iframe',{attrs:{"src":'https://robinacademia.com/p.ashx?o=90&e=10&f=pb&t='+item.IdOportunidade,"height":"1","width":"1","frameborder":"0"}}),_vm._v(" "),_c('div',{staticClass:"options float-right"},[(!_vm.sms)?_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"back"},[_vm._v(" ")]),_vm._v(" "),_c('span',[_vm._v("Voltar")])]):_vm._e(),_vm._v(" "),(_vm.sms)?_c('a',{attrs:{"href":"javascript:;","title":"Voltar"},on:{"click":function($event){return _vm.$router.push('/emprestimos/meus-emprestimos')}}},[_c('i',{staticClass:"back"},[_vm._v(" ")]),_vm._v(" "),_c('span',[_vm._v("Voltar")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),(_vm.VerificaStatus(item))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-7 col-lg-8"},[_c('section',[_c('div',{staticClass:"tit"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"float-right rating"},[_c('strong',[_vm._v("Score da operação "),_c('span',{staticClass:"circle score"}),_vm._v(" "+_vm._s(_vm.formatarScore(item.Score)))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor Solicitado")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s((item.ValorSolicitado != undefined && item.ValorSolicitado != 0)? _vm.money(item.ValorSolicitado) : _vm.money(item.Valor)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor Aprovado")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.money(item.Valor)))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Duração")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.Prazo)+" meses")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor da parcela")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.money(item.ValorParcela)))])])]),_vm._v(" "),(item.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor total do empréstimo")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.money(_vm.Total(item.Prazo, item.ValorParcela))))])])]):_vm._e(),_vm._v(" "),(item.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Juros")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.TaxaJuros == undefined ?"-":_vm.money(item.TaxaJuros)+ "% a.m"))])])]):_vm._e(),_vm._v(" "),(item.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Taxa total efetiva")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.money(item.Rendimento))+"% a.a.")])])]):_vm._e(),_vm._v(" "),(item.CustoEfetivoTotalam != undefined && item.CustoEfetivoTotalam != 0 && item.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Custo Efetivo Total")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.CustoEfetivoTotalam == undefined ?"-":_vm.money(item.CustoEfetivoTotalam)+ "% a.m."))])])]):_vm._e(),_vm._v(" "),(item.CustoEfetivoTotalaa != undefined && item.CustoEfetivoTotalaa != 0 && item.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Custo Efetivo Total")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.CustoEfetivoTotalaa == undefined ?"-":_vm.money(item.CustoEfetivoTotalaa)+ "% a.a."))])])]):_vm._e(),_vm._v(" "),(item.Iof != undefined && item.Iof != 0 && item.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("IOF")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(item.Iof == undefined ?"-":_vm.money(item.Iof)))])])]):_vm._e(),_vm._v(" "),(item.TaxaIouu != undefined && item.TaxaIouu != 0)?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Taxa IOUU")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(item.TaxaIouu == undefined ?"-":_vm.money(item.TaxaIouu)))])])]):_vm._e(),_vm._v(" "),(item.TaxaParceira != undefined && item.TaxaParceira != 0 && item.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Taxa Instituição Financeira")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(item.TaxaParceira == undefined ?"-":_vm.money(item.TaxaParceira)))])])]):_vm._e(),_vm._v(" "),(item.ValorLiquido != undefined && item.ValorLiquido != 0 && item.TipoEmprestimo != 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-12 col-lg-12"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor Liquido a Receber")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.money(item.ValorLiquido)))])])]):_vm._e(),_vm._v(" "),(item.ValorLiquido != undefined && item.ValorLiquido != 0 && item.TipoEmprestimo == 'emprestimo-social')?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"box"},[_c('label',[_vm._v("Valor Liquido a Receber")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.money(item.ValorLiquido)))])])]):_vm._e()])]),_vm._v(" "),_c('section',[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"row"},[(item.CodProduto != 'EMPSOC')?_c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(2,true),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Empresa.RazaoSocial))])]):_vm._e(),_vm._v(" "),(item.CodProduto == 'EMPSOC' && item.TipoPessoa == 'pessoa juridica')?_c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(3,true),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Social.RazaoSocial))])]):_vm._e(),_vm._v(" "),(item.CodProduto == 'EMPSOC' && item.TipoPessoa == 'pessoa fisica')?_c('div',{staticClass:"col-12 col-lg-6"},[_c('label',[_vm._v("Empresa")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.Social.NomeCompleto))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("CPF/CNPJ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatted(item.Documento)))])]),_vm._v(" "),(item.CodProduto != 'EMPSOC')?_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Nome do responsável")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatenome(item.Solicitante.NomeCompleto)))])]):_vm._e(),_vm._v(" "),(item.CodProduto == 'EMPSOC')?_c('div',{staticClass:"col-12 col-lg-3"},[_c('label',[_vm._v("Nome do responsável")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatenome(item.Social.NomeCompleto)))])]):_vm._e()])])]),_vm._v(" "),_c('aside',{staticClass:"col-12 col-md-5 col-lg-4"},[_c('div',{staticClass:"box"},[(!_vm.aceite)?_c('div',{staticClass:"content"},[_c('h3',[_vm._v(_vm._s(_vm.formatenome(item.Nome))+", sua solicitação de empréstimo foi aprovada.")]),_vm._v(" "),_c('p',[_vm._v("Falta pouco, agora você deve aceitar a proposta para darmos andamento na sua captação.")]),_vm._v(" "),_c('form',[_c('ul',[_c('li',[_c('div',{staticClass:"form-check d-flex justify-content-center"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.concordo),expression:"concordo"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"noOther"},domProps:{"checked":Array.isArray(_vm.concordo)?_vm._i(_vm.concordo,null)>-1:(_vm.concordo)},on:{"change":function($event){var $$a=_vm.concordo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.concordo=$$a.concat([$$v]))}else{$$i>-1&&(_vm.concordo=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.concordo=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_vm._m(4,true)])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"type":"button","disabled":!_vm.concordo},on:{"click":function($event){_vm.aceite = true;}}},[_vm._v("Sim, aceito os termos")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-link btn-block",attrs:{"type":"button"},on:{"click":function($event){_vm.rejeita = true; _vm.aceite = true;}}},[_vm._v("Não aceito a proposta")])])]):_vm._e(),_vm._v(" "),(_vm.aceite && !_vm.rejeita)?_c('div',{staticClass:"content"},[(!_vm.confirmasenha)?_c('div',{attrs:{"id":"password"}},[_c('p',[_vm._v("Por favor insira sua senha no campo abaixo para formalizar sua solicitação de empréstimo.")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.ConfirmaSenha($event)}}},[_c('div',{staticClass:"form form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","id":"password","placeholder":"Sua senha aqui"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"disabled":_vm.password == ''}},[_vm._v("Confirmar solicitação")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-link btn-block",attrs:{"type":"button"},on:{"click":function($event){_vm.aceite = false; _vm.concordo = false;}}},[_vm._v("Cancelar")])])]):_vm._e(),_vm._v(" "),(_vm.confirmasenha && !_vm.sms)?_c('div',{attrs:{"id":"token-sms"}},[_c('h3',[_vm._v(_vm._s(_vm.formatenome(item.Nome))+", falta só mais um passo!")]),_vm._v(" "),_c('p',[_vm._v("Por favor insira o código enviado por SMS para o seu telefone celular.")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.CheckSms($event)}}},[_c('div',{staticClass:"form form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.smsToken),expression:"smsToken"}],staticClass:"form-control ",attrs:{"type":"text","id":"sms","placeholder":"Código SMS"},domProps:{"value":(_vm.smsToken)},on:{"input":function($event){if($event.target.composing){ return; }_vm.smsToken=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"disabled":_vm.smsToken == ''}},[_vm._v("Autorizar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-link btn-block",attrs:{"type":"button"},on:{"click":function($event){_vm.aceite = false; _vm.concordo = false; _vm.confirmasenha = false;}}},[_vm._v("Cancelar")])])]):_vm._e(),_vm._v(" "),(_vm.sms)?_c('div',{attrs:{"id":"confirmacao-aceite"}},[_c('h3',[_vm._v(_vm._s(_vm.formatenome(item.Nome))+", parabéns!")]),_vm._v(" "),_vm._m(5,true)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.rejeita)?_c('div',{staticClass:"content"},[(!_vm.checkmotivo)?_c('div',{attrs:{"id":"opcoes"}},[_c('h3',[_vm._v(_vm._s(_vm.formatenome(item.Nome))+", tem certeza que deseja rejeitar a proposta?")]),_vm._v(" "),_c('p',[_vm._v("Por favor, liste abaixo os motivos da não aprovação da proposta.")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.RecusaEmprestimo($event)}}},[_c('ul',[_c('li',[_c('div',{staticClass:"form-check d-flex justify-content-left"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prazo),expression:"prazo"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"noOther"},domProps:{"checked":Array.isArray(_vm.prazo)?_vm._i(_vm.prazo,null)>-1:(_vm.prazo)},on:{"change":function($event){var $$a=_vm.prazo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.prazo=$$a.concat([$$v]))}else{$$i>-1&&(_vm.prazo=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.prazo=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_vm._m(6,true)])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"form-check d-flex justify-content-left"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parcela),expression:"parcela"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"noOther"},domProps:{"checked":Array.isArray(_vm.parcela)?_vm._i(_vm.parcela,null)>-1:(_vm.parcela)},on:{"change":function($event){var $$a=_vm.parcela,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.parcela=$$a.concat([$$v]))}else{$$i>-1&&(_vm.parcela=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.parcela=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_vm._m(7,true)])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"form-check d-flex justify-content-left"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.juros),expression:"juros"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"noOther"},domProps:{"checked":Array.isArray(_vm.juros)?_vm._i(_vm.juros,null)>-1:(_vm.juros)},on:{"change":function($event){var $$a=_vm.juros,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.juros=$$a.concat([$$v]))}else{$$i>-1&&(_vm.juros=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.juros=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_vm._m(8,true)])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"form-check d-flex justify-content-left"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.condicoes),expression:"condicoes"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"noOther"},domProps:{"checked":Array.isArray(_vm.condicoes)?_vm._i(_vm.condicoes,null)>-1:(_vm.condicoes)},on:{"change":function($event){var $$a=_vm.condicoes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.condicoes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.condicoes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.condicoes=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_vm._m(9,true)])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"form-check d-flex justify-content-left"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.outros),expression:"outros"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"noOther"},domProps:{"checked":Array.isArray(_vm.outros)?_vm._i(_vm.outros,null)>-1:(_vm.outros)},on:{"change":function($event){var $$a=_vm.outros,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.outros=$$a.concat([$$v]))}else{$$i>-1&&(_vm.outros=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.outros=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_vm._m(10,true)])]),_vm._v(" "),(_vm.outros)?_c('li',{staticClass:"outros"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motivo),expression:"motivo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Informe o motivo..."},domProps:{"value":(_vm.motivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motivo=$event.target.value}}})])]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"disabled":!_vm.prazo && !_vm.parcela && !_vm.juros && !_vm.condicoes && (!_vm.outros || _vm.motivo == '')}},[_vm._v("Não aceito a proposta")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-link btn-block",attrs:{"type":"button"},on:{"click":function($event){_vm.aceite = false; _vm.rejeita = false}}},[_vm._v("Cancelar")])])]):_vm._e(),_vm._v(" "),(_vm.checkmotivo)?_c('div',{attrs:{"id":"confirmacao-rejeite"}},[_c('h3',[_vm._v("Obrigado, "+_vm._s(_vm.formatenome(item.Nome))+".")]),_vm._v(" "),_c('p',[_vm._v("Estareamos a disposição a qualquer momento.")])]):_vm._e()]):_vm._e()])])]):_vm._e()])}),0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left"},[_c('h3',[_vm._v("Dados financeiros")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('h3',[_vm._v("Dados da Empresa")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Empresa "),_c('span',[_vm._v("(Razão social) empresa")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Empresa "),_c('span',[_vm._v("(Razão social)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"accept",attrs:{"for":"noOther"}},[_c('span',[_vm._v("Sim, aceito as condições propostas para minha solicitação de empréstimo.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Seu aceite foi concluído com sucesso."),_c('br'),_vm._v("\n                            Em breve sua proposta estará cadastrada na plataforma para captação.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"accept",attrs:{"for":"noOther"}},[_c('span',[_vm._v("Prazo de pagamento")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"accept",attrs:{"for":"noOther"}},[_c('span',[_vm._v("Valor da parcela")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"accept",attrs:{"for":"noOther"}},[_c('span',[_vm._v("Taxa de juros")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"accept",attrs:{"for":"noOther"}},[_c('span',[_vm._v("Condições gerais")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"accept",attrs:{"for":"noOther"}},[_c('span',[_vm._v("Outros")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rzJh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_join__ = __webpack_require__("vGd1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var ArrayHelper = function () {
  function ArrayHelper() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ArrayHelper);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ArrayHelper, null, [{
    key: 'toSentence',

    /**
     * @param {boolean} noExtraTransform - If should or not do some extra text transform, like lowercase beginning of each string and removing dots at the end of those.
     */
    value: function toSentence(array) {
      var wordsConnector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ', ';
      var lastWordConnector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ' e ';
      var noExtraTransform = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (array.length == 1) return array[0];

      var firstWords = array.slice(0, array.length - 1);
      var lastWord = array[array.length - 1];

      if (!noExtraTransform) {
        firstWords = firstWords.map(function (word, index) {
          word = word.replace(/[,.]$/, '');
          return index != 0 ? word.replace(/^([A-Z])/, function (match) {
            return match.toLowerCase();
          }) : word;
        });
        lastWord = lastWord.replace(/[,.]$/, '').replace(/^([A-Z])/, function (match) {
          return match.toLowerCase();
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_join___default()(firstWords, wordsConnector) + lastWordConnector + lastWord;
    }
  }]);

  return ArrayHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (ArrayHelper);

/***/ }),

/***/ "s3n1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_wallet_index_js__ = __webpack_require__("c/xH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PasswordField__ = __webpack_require__("i7i+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon__ = __webpack_require__("H9QG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_luxon__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            Saldo: 0,
            mindate: __WEBPACK_IMPORTED_MODULE_6_luxon__["DateTime"].local().toISO(),
            dataText: __WEBPACK_IMPORTED_MODULE_6_luxon__["DateTime"].local().toISO(),
            tentativas: 0,
            step: 1,
            enabled: false,
            loading: false,
            bank: null,
            bankRender: false,
            valueSaque: "",
            userId: "",
            ted: "0,00",
            password: null,
            dateSaque: new Date(),
            dateModel: null,
            Pendente: 0,
            PorcentagemRetorno: 0,
            isLoading: false,
            InvTotal: 0,
            RendimentoTotal: 0,
            IdInvestidor: 0,
            Infos: {},
            renderizou: false,
            legendMarkup: "",
            DadosLegenda: [],
            Credito: 0,
            Debito: 0,
            dadoSaldo: {},
            dadosBanco: {}
        };
    },

    components: {
        PasswordField: __WEBPACK_IMPORTED_MODULE_3__components_PasswordField__["a" /* default */]
    },
    methods: {
        nomeBanco: function nomeBanco() {
            if (this.bank != null) return this.bank.length > 0 ? this.bank[0].nome : 'Outro - Codigo do banco: ' + this.dadosBanco.DadosBancarios.CodigoBanco;

            return "";
        },
        tipoConta: function tipoConta(conta) {
            return conta == 1 ? "Conta Corrente" : "Conta Poupança";
        },
        formatCurrency: function formatCurrency(value) {
            if (value != null) {

                if (typeof value == "string") value = parseFloat(value);

                return value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
            }

            return 0;
        },
        formatReal: function formatReal(num) {
            var real = void 0;
            real = parseFloat(num.replace(/[^\d]+/g, '')) / 100;
            return real;
        },
        formatDate: function formatDate(date) {
            var aux = date.split("T");
            var formDate = aux[0].split("-");

            return formDate[2] + '/' + formDate[1] + '/' + formDate[0];
        },
        isValidValue: function isValidValue() {
            return this.valueSaqueDate != '';
        },


        // Requisição para trazer saldo atualizado
        saldoAtualizado: function saldoAtualizado() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2__services_api_wallet_index_js__["a" /* default */].GetSaldoWallet();

                            case 2:
                                _ref = _context.sent;
                                data = _ref.data;


                                console.log("data -> ", data);

                                _this.dadoSaldo = data;
                                _this.Saldo = data.Saldo;
                                _this.userId = data.UserId;

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        dadosBancarios: function dadosBancarios(userId) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _ref2, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2__services_api_wallet_index_js__["a" /* default */].GetDadosBancariosWallet(userId);

                            case 2:
                                _ref2 = _context2.sent;
                                data = _ref2.data;


                                console.log("dados -> ", data);

                                _this2.dadosBanco = data;

                                if (_this2.dadosBanco.DadosBancarios.CodigoBanco) {

                                    __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getWalletBank(_this2.dadosBanco.DadosBancarios.CodigoBanco).then(function (response) {

                                        console.log("bank -> ", response.data);
                                        _this2.bank = response.data;
                                        _this2.loading = true;
                                    });
                                } else {
                                    _this2.loading = true;
                                }

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        PMT: function PMT(rate, periods, present, future, type) {
            // Credits: algorithm inspired by Apache OpenOffice

            // Initialize type
            type = typeof type === 'undefined' ? 0 : type;

            // Initialize future
            future = 0;

            // Evaluate rate (TODO: replace with secure expression evaluator)
            rate = eval(rate);

            // Return payment
            var result;
            if (rate === 0) {
                result = (present + future) / periods;
            } else {
                var term = Math.pow(1 + rate, periods);
                if (type === 1) {
                    result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
                } else {
                    result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
                }
            }

            // result = Math.round(result * 100) / 100;

            return -result;
        },
        backStep: function backStep() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this3.step = _this3.step - 1;

                                _context3.next = 3;
                                return _this3.saldoAtualizado();

                            case 3:
                                _context3.next = 5;
                                return _this3.dadosBancarios(_this3.userId);

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        validateValue: function validateValue(e) {
            e.preventDefault();

            var value = this.formatReal(this.valueSaque);

            if (value < 2) {
                this.$Notify.error('O valor da transferência não pode ser inferior a R$ 2,00');
            } else if (value > parseFloat(Math.floor(this.Saldo * 100) / 100)) {
                this.$Notify.error('O valor solicitado é superior ao disponível para saque');
            } else {
                this.step = 2;
            }
        },
        isValidDate: function isValidDate() {
            return this.transferDate != '';
        },
        validateDate: function validateDate(e) {
            e.preventDefault();

            var aux = this.dataText.split("T");
            var spliter = aux[0].split('-');
            var year = this.dateSaque.getFullYear();
            var month = this.dateSaque.getMonth();
            var day = this.dateSaque.getDate();

            if (parseInt(spliter[2]) < day && spliter[1] < month && parseInt(spliter[0]) < year) {
                this.$Notify.error('Data inválida, favor selecionar uma data válida');
            } else {
                this.step = 3;
            }
        },
        confirmTransfer: function confirmTransfer(e) {
            e.preventDefault();

            this.step = 4;
        },
        calcTotalTransfer: function calcTotalTransfer(value) {
            var total = this.formatReal(value) - this.formatReal(this.ted);

            return this.formatCurrency(total);
        },
        isValidPassword: function isValidPassword() {
            return this.password != null;
        },
        validatePassword: function validatePassword(e) {
            var _this4 = this;

            this.isLoading = true;
            e.preventDefault();
            var carteira = {
                "Data": this.dataText,
                "Valor": this.formatReal(this.valueSaque),
                "DadosBancarios": this.dadosBanco.DadosBancarios,
                "InvestidorId": this.investor._id
            };

            console.log("CARTEIRA ->", carteira);

            var resposta = __WEBPACK_IMPORTED_MODULE_2__services_api_wallet_index_js__["a" /* default */].CreateTransfer(carteira).then(function (response) {
                if (response.data.msg === "SaldoInsuficiente") {
                    _this4.isLoading = false;
                    _this4.$Notify.error("Saldo total da carteira é insuficiente.");
                } else {
                    _this4.$router.push('/investimentos/carteira-investimento/');
                }
            }).catch(function (error) {
                if (_this4.tentativas < 3) {
                    console.error('ERROR: ' + error.message);
                    _this4.isLoading = false;
                    _this4.$Notify.error('Senha inválida!!! tente novamente');
                    _this4.tentativas++;
                } else {
                    _this4.$store.dispatch('logout');
                    _this4.$router.push('/login');
                }
            });
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/carteira-investimento/',
                title: 'CarteiraInvestimento'
            });
        }
    },
    computed: {

        transferDate: {
            get: function get() {
                if (this.dateModel === null) {
                    var now = new Date();
                    var day = ("0" + now.getDate()).slice(-2);
                    var month = ("0" + (now.getMonth() + 1)).slice(-2);
                    var today = day + '/' + month + '/' + now.getFullYear();

                    this.dateModel = today;
                }

                return this.dateModel;
            },

            set: function set(newValue) {
                this.dateModel = newValue;
            }
        },
        valueSaqueDate: {
            get: function get() {
                return this.valueSaque;
            },
            set: function set(newValue) {
                this.valueSaque = newValue;
            }
        },
        User: function User() {
            return this.$store.state.currentUser;
        }
    },
    created: function created() {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return _this5.saldoAtualizado();

                        case 2:
                            _context4.next = 4;
                            return _this5.dadosBancarios(_this5.userId);

                        case 4:

                            // ApiClient.getMyAvalibleMoney()
                            // .then(item => {

                            //     item.data.credito = (item.data.credito).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
                            //     this.Credito =  parseFloat(item.data.credito) ;

                            //     item.data.debito = (item.data.debito).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
                            //     this.Debito =  parseFloat(item.data.debito) ;

                            // });

                            __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getInfosMyInvestments().then(function (infos) {
                                var total = 0;
                                _this5.Infos = infos;

                                if (_this5.Infos.data != null && _this5.Infos.data.length > 0) _this5.renderizou = true;

                                if (infos != null && infos != undefined && infos.data != undefined) {
                                    _this5.Pendente = 0;

                                    var solicitacoes = Array();

                                    //this.Pendente
                                    infos.data.forEach(function (item) {
                                        if (item.Boleto == undefined || item.StatusBoleto == "expired" || item.Boleto != undefined && item.StatusBoleto == undefined) _this5.Pendente += item.Valor;
                                        _this5.IdInvestidor = item.InvestidorId;
                                    });

                                    //this.PorcentagemRetorno
                                    var temp = 0.0,
                                        count = 0,
                                        somaValorNP = 0;

                                    infos.data.forEach(function (item) {

                                        if (item.SolicitacaoId != null && item.StatusBoleto == "paid") {

                                            if (item.SolicitacaoId.TipoEmprestimo != "emprestimo-de-impacto") {
                                                temp += item.SolicitacaoId.RetornoBrutoMensal;
                                                count++;
                                            }
                                        }
                                    });

                                    if (count > 0) _this5.PorcentagemRetorno = temp / count;else _this5.PorcentagemRetorno = 0;

                                    //this.Receber
                                    var temp = 0.0,
                                        count = 0,
                                        somaValor = 0;
                                    _this5.RendimentoTotal = 0;

                                    infos.data.forEach(function (item) {

                                        if (item.SolicitacaoId != null && item.StatusBoleto == "paid") {

                                            if (item.SolicitacaoId.RetornoBrutoMensal == undefined) {
                                                item.SolicitacaoId.RetornoBrutoMensal = 0;
                                            }

                                            var valorParcela = -_this5.PMT(item.SolicitacaoId.RetornoBrutoMensal / 100, item.SolicitacaoId.Prazo, item.Valor);

                                            var with2Decimals = (item.SolicitacaoId.Prazo * valorParcela).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];

                                            _this5.RendimentoTotal += parseFloat(with2Decimals);

                                            total += item.Valor;
                                        }
                                    });

                                    _this5.InvTotal = total;
                                }
                            }).catch(function (error) {
                                console.log('error', error);
                            });
                            //tagueamento GA
                            _context4.next = 7;
                            return _this5.taggingGA();

                        case 7:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this5);
        }))();
    },
    beforeCreate: function beforeCreate() {
        var _this6 = this;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["c" /* START_LOADING */]);

        __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getInvestor().then(function (response) {
            _this6.investor = response;

            console.log(_this6.investor);

            __WEBPACK_IMPORTED_MODULE_4__utils_api_client__["a" /* default */].getWalletBank(_this6.investor.DadosBancarios.CodigoBanco).then(function (response) {
                _this6.bank = response.data;

                _this6.bankRender = true;
            });

            _this6.loading = true;
            _this6.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
        }).catch(function (error) {
            console.log("request fail", error);
            _this6.loading = true;
            _this6.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    }
});

/***/ }),

/***/ "s5lK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_c('div',{staticClass:"tit text-center"},[_c('h1',[_c('span',[_vm._v("Parabéns, "+_vm._s(_vm.solicitacao.Nome.split(" ")[0]))]),_vm._v("VOCÊ FOI PRÉ-APROVADO!")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"nomeCompleto"}},[_vm._v("Nome completo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nomeCompleto),expression:"nomeCompleto"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Nome Completo","required":""},domProps:{"value":(_vm.nomeCompleto)},on:{"keyup":_vm.AlterarNome,"input":function($event){if($event.target.composing){ return; }_vm.nomeCompleto=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{staticClass:"float-left",attrs:{"for":"Cpf"}},[_vm._v("CPF")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cpf),expression:"cpf"},{name:"mask",rawName:"v-mask",value:('cpf'),expression:"'cpf'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"CPF","required":""},domProps:{"value":(_vm.cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cpf=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"DataNascimento"}},[_vm._v("Data de Nascimento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataNascimento),expression:"dataNascimento"},{name:"mask",rawName:"v-mask",value:('date'),expression:"'date'"}],staticClass:"form-control form-control-lg",attrs:{"name":"DataNascimento","type":"text","placeholder":"__/__/____","required":""},domProps:{"value":(_vm.dataNascimento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dataNascimento=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Agora, por favor, forneça seu "),_c('strong',[_vm._v("nome completo")]),_vm._v(" e seu "),_c('strong',[_vm._v("CPF")]),_vm._v(".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s7tP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Declaração do MEI")]),_vm._v(" "),_c('p',[_vm._v("Envie a declaração do MEI dos ultimos 2 anos.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sKK0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioUltimosExtratosTodasContasPasso_vue__ = __webpack_require__("aupi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5be53cad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioUltimosExtratosTodasContasPasso_vue__ = __webpack_require__("5+9B");
function injectStyle (ssrContext) {
  __webpack_require__("wTSQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5be53cad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnvioUltimosExtratosTodasContasPasso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5be53cad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnvioUltimosExtratosTodasContasPasso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sPfU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (true)?_c('div',{staticClass:"wallet"},[_c('div',{staticClass:"row align-items-center funds-transfer__tit-page tit_page"},[_c('div',{staticClass:"col-12 col-lg-8"},[_c('h1',[_vm._v("Comprovante de "+_vm._s(_vm.getComprovanteType()))]),_vm._v("\n            teste\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4"},[_c('div',{staticClass:"back back-hide float-md-right"},[_c('router-link',{attrs:{"to":"/investimentos/carteira-investimento","title":"Voltar"}},[_c('i',[_vm._v(" ")]),_vm._v(" voltar")])],1)])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-7"},[(true)?_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-12 col-md-6 d-flex justify-content-sm-center justify-content-md-end"},[_c('div',{staticClass:"coupon",attrs:{"id":"cupom"}},[_c('div',{staticClass:"coupon__head"}),_vm._v(" "),_c('div',{staticClass:"coupon__body"},[_c('img',{attrs:{"src":"/static/assets/images/logotipo-iouu.png","width":"70","alt":"Logotipo IOUU"}}),_vm._v(" "),_c('p',{staticClass:"id"},[_vm._v("COMPROVANTE "+_vm._s(this.idComprovante))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                                RECEBIDO EM: "),_c('span',[_vm._v(_vm._s(_vm.formatDate(this.transferencia.Data)))])]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("De: "),_c('span',[_vm._v(_vm._s(_vm.NomeEmpresa))])]),_vm._v(" "),_c('li',[_vm._v("Parcela: "),_c('span',[_vm._v(_vm._s(_vm.RecebimentoParcela))])]),_vm._v(" "),_c('li',[_vm._v("Principal: "),_c('span',[_vm._v("R$ "+_vm._s(_vm.CalcCapital))])]),_vm._v(" "),(this.transferencia.Ipmt)?_c('li',[_vm._v("Juros: "),_c('span',[_vm._v("R$ "+_vm._s(this.formatCurrency(this.transferencia.Ipmt))+" ")])]):_vm._e(),_vm._v(" "),(!this.transferencia.Ipmt)?_c('li',[_vm._v("Juros: "),_c('span',[_vm._v("+ R$ "+_vm._s(_vm.CalcJuros))])]):_vm._e(),_vm._v(" "),(_vm.CalcMulta > 0)?_c('li',[_vm._v("Multa por atraso: "),_c('span',[_vm._v("+ R$ "+_vm._s(this.formatCurrency(_vm.CalcMulta)))])]):_vm._e(),_vm._v(" "),_c('li',[_vm._v("Valor bruto pago: "),_c('span',[_vm._v("R$ "+_vm._s(_vm.valor))])]),_vm._v(" "),(this.transferencia.IR > 0)?_c('li',[_vm._v("IR: "),_c('span',[_vm._v("R$ "+_vm._s(_vm.impostoRenda))])]):_vm._e(),_vm._v(" "),_c('li',[_vm._v("CNPJ: "),_c('span',[_vm._v(_vm._s(_vm.DocumentoEmpresa))])])]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Para: "),_c('span',[_vm._v(_vm._s(_vm.nome))])]),_vm._v(" "),(this.transferencia.ValorLiquido > 0)?_c('li',[_vm._v("Valor Liquido Recebido: "),_c('span',[_vm._v("R$ "+_vm._s(_vm.valorLiquido))])]):_c('li',[_vm._v("Valor Recebido: "),_c('span',[_vm._v("R$ "+_vm._s(_vm.valor))])]),_vm._v(" "),_c('li',[_vm._v("CPF/CNPJ: "),_c('span',[_vm._v(_vm._s(_vm.documento))])])])]),_vm._v(" "),_c('div',{staticClass:"coupon__foot"})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"wallet__description"},[_c('h2',[_vm._v("Recebimento realizado")]),_vm._v(" "),_c('div',[_c('p',[_c('strong',[_vm._v("Principal")]),_vm._v(" "),_c('span',{staticClass:"text-primary"},[_vm._v("R$ "+_vm._s(_vm.CalcCapital))])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Juros")]),_vm._v(" "),(this.transferencia.Ipmt)?_c('span',{staticClass:"text-primary"},[_vm._v("+ "+_vm._s(this.formatCurrency(this.transferencia.Ipmt))+" ")]):_vm._e(),_vm._v(" "),(!this.transferencia.Ipmt)?_c('span',{staticClass:"text-primary"},[_vm._v("+ R$ "+_vm._s(_vm.CalcJuros)+" ")]):_vm._e()]),_vm._v(" "),(_vm.CalcMulta > 0)?_c('p',[_c('strong',[_vm._v("Multa por atraso")]),_vm._v(" "),_c('span',{staticClass:"text-primary"},[_vm._v("+ R$ "+_vm._s(this.formatCurrency(_vm.CalcMulta)))])]):_vm._e(),_vm._v(" "),_c('p',[(_vm.CalcMulta > 0)?_c('strong',[_vm._v("Valor bruto pago (Principal + Juros + Multa)")]):_vm._e(),_vm._v(" "),(_vm.CalcMulta == 0)?_c('strong',[_vm._v("Valor bruto pago (Principal + Juros)")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text-success"},[_vm._v("R$ "+_vm._s(_vm.valor))])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary btn-lg",attrs:{"title":"Imprimir comprovante"},on:{"click":function($event){return _vm.printPdf()}}},[_c('i',{staticClass:"fas fa-print"}),_vm._v(" Imprimir comprovante")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary btn-lg",attrs:{"title":"Salvar comprovante"},on:{"click":function($event){return _vm.savePdf()}}},[_c('i',{staticClass:"fas fa-download"}),_vm._v(" Salvar comprovante")])])])]):(_vm.type === 'DEBITO' && !this.transferencia.ReInvestimento)?_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-12 col-md-6 d-flex justify-content-sm-center justify-content-md-end"},[_c('div',{staticClass:"coupon",attrs:{"id":"cupom"}},[_c('div',{staticClass:"coupon__head"}),_vm._v(" "),_c('div',{staticClass:"coupon__body"},[_c('img',{attrs:{"src":"/static/assets/images/logotipo-iouu.png","width":"70","alt":"Logotipo IOUU"}}),_vm._v(" "),_c('p',{staticClass:"id"},[_vm._v("COMPROVANTE "+_vm._s(this.idComprovante))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                                AGENDADO EM: "),_c('span',[_vm._v(_vm._s(_vm.formatDate(this.transferencia.DataTransferencia)))])]),_vm._v(" "),_c('ul',[_vm._m(0),_vm._v(" "),_c('li',[_vm._v("Valor: "),_c('span',[_vm._v("R$ "+_vm._s(_vm.valor))])]),_vm._v(" "),_c('li',[_vm._v("TED: "),_c('span',[_vm._v("- R$ "+_vm._s(this.ted))])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Para: "),_c('span',[_vm._v(_vm._s(_vm.nome))])]),_vm._v(" "),_c('li',[_vm._v("Valor: "),_c('span',[_vm._v("R$ "+_vm._s(_vm.valorComTed))])]),_vm._v(" "),_c('li',[_vm._v("CPF/CNPJ: "),_c('span',[_vm._v(_vm._s(_vm.documento))])]),_vm._v(" "),_c('li',[_vm._v("Banco: "),_c('span',[_vm._v(_vm._s(_vm.nomeBanco))])]),_vm._v(" "),_c('li',[_vm._v("Agência: "+_vm._s(_vm.agencia)+" "),_c('span',[_vm._v("Conta: "+_vm._s(_vm.NumeroConta))])])])]),_vm._v(" "),_c('div',{staticClass:"coupon__foot"})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"wallet__description"},[_c('h2',[_vm._v("Agendamento realizado")]),_vm._v(" "),_c('div',[_c('p',[_c('strong',[_vm._v("Valor solicitado")]),_vm._v(" "),_c('span',{staticClass:"text-secondary"},[_vm._v("R$ "+_vm._s(_vm.valor))])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Custo de TED")]),_vm._v(" "),_c('span',{staticClass:"text-danger"},[_vm._v(" R$ "+_vm._s(this.ted))])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Valor total da transferência")]),_vm._v(" "),_c('span',{staticClass:"text-primary"},[_vm._v("R$ "+_vm._s(_vm.valorComTed))])])]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("\n                            Transferência para: "+_vm._s(_vm.nomeBanco)),_c('br'),_vm._v("\n                            Agência: "+_vm._s(_vm.agencia)+" - "+_vm._s(_vm.tipoConta)+": "+_vm._s(_vm.NumeroConta)+"\n                        ")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary btn-lg",attrs:{"title":"Imprimir comprovante"},on:{"click":function($event){return _vm.printPdf()}}},[_c('i',{staticClass:"fas fa-print"}),_vm._v(" Imprimir comprovante")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary btn-lg",attrs:{"title":"Salvar comprovante"},on:{"click":function($event){return _vm.savePdf()}}},[_c('i',{staticClass:"fas fa-download"}),_vm._v(" Salvar comprovante")])])])]):(_vm.type === 'DEBITO' && this.transferencia.ReInvestimento)?_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-12 col-md-6 d-flex justify-content-sm-center justify-content-md-end"},[_c('div',{staticClass:"coupon",attrs:{"id":"cupom"}},[_c('div',{staticClass:"coupon__head"}),_vm._v(" "),_c('div',{staticClass:"coupon__body"},[_c('img',{attrs:{"src":"/static/assets/images/logotipo-iouu.png","width":"70","alt":"Logotipo IOUU"}}),_vm._v(" "),_c('p',{staticClass:"id"},[_vm._v("COMPROVANTE "+_vm._s(this.idComprovante))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                                REINVESTIDO EM: "),_c('span',[_vm._v(_vm._s(_vm.formatDate(this.transferencia.Data)))])]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Empresa: "),_c('span',[_vm._v(_vm._s(_vm.NomeEmpresa))])]),_vm._v(" "),_c('li',[_vm._v("Valor: "),_c('span',[_vm._v("R$ "+_vm._s(_vm.valor))])]),_vm._v(" "),_c('li',[_vm._v("CNPJ: "),_c('span',[_vm._v(_vm._s(_vm.DocumentoEmpresa))])])])]),_vm._v(" "),_c('div',{staticClass:"coupon__foot"})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"wallet__description"},[_c('h2',[_vm._v("Reinvestimento realizado")]),_vm._v(" "),_c('div',[_c('p',[_c('strong',[_vm._v("Valor total da transferência")]),_vm._v(" "),_c('span',{staticClass:"text-primary"},[_vm._v("R$ "+_vm._s(_vm.valor))])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary btn-lg",attrs:{"title":"Imprimir comprovante"},on:{"click":function($event){return _vm.printPdf()}}},[_c('i',{staticClass:"fas fa-print"}),_vm._v(" Imprimir comprovante")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary btn-lg",attrs:{"title":"Salvar comprovante"},on:{"click":function($event){return _vm.savePdf()}}},[_c('i',{staticClass:"fas fa-download"}),_vm._v(" Salvar comprovante")])])])]):_vm._e()])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._v("De: "),_c('span',[_vm._v("IOUU Tecnologia e Serviços Financeiros")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._v("CNPJ: "),_c('span',[_vm._v("26.484.548/0001-48")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"small"},[_vm._v("\n                          Em caso de finais de semana e feriados a transferência"),_c('br'),_vm._v("\n                          é agendada para o próximo dia útil e efetivada em até dois dias úteis.\n                        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sgy8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Investment_vue__ = __webpack_require__("TYZs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10e7eff2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Investment_vue__ = __webpack_require__("x9G1");
function injectStyle (ssrContext) {
  __webpack_require__("Dho/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10e7eff2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Investment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10e7eff2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Investment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sngR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");


//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: null
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    var query = this.$route.query;
    __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].put('email-confirmation', { data: { email: query.email, token: query.token } }).then(function () {
      _this.$router.push("/");
      _this.$Message.info("Seu cadastro foi confirmado com sucesso");
    }).catch(function () {
      _this.$router.push("/");
      _this.message = "Houve um problema ao tentar confirmar seu e-mail";
    });
  },

  methods: {
    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/confirmacao-email',
        title: 'EmailConfirmation'
      });
    }
  },

  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.taggingGA();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),

/***/ "su++":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-7 text-center"},[_c('div',{staticClass:"tit"},[_c('p',[_vm._v("A(O) "),_c('strong',[_vm._v(_vm._s(_vm.razaoSocial))]),_vm._v(" possui contador?")])]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.submitWithAccountant}},[_vm._v("Sim")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.submitWithoutAccountant}},[_vm._v("Não")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "suTU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sug5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacaoInstitucionalStep_vue__ = __webpack_require__("ZqXk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25101352_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacaoInstitucionalStep_vue__ = __webpack_require__("fkOh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformacaoInstitucionalStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25101352_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformacaoInstitucionalStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "svYq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        operacao: { type: Object }
    },

    created: function created() {

        console.log(this.operacao);
    },


    computed: {
        valor: function valor() {
            return this.operacao.Valor;
        },
        transacao: function transacao() {
            return this.operacao.id;
        },
        boletoUrl: function boletoUrl() {
            return 'https://faturas.iugu.com/' + this.operacao.Detalhes.Deposito.BoletoId;
        }
    },

    methods: {
        formatDocument: function formatDocument(doc) {

            if (doc.length > 11) {
                return __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].maskCnpj(doc);
            } else {
                return __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].maskCpf(doc);
            }
        },
        formatarDinheiro: function formatarDinheiro(value) {

            if (value != null) {

                if (typeof value == "string") value = parseFloat(value);

                var options = {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                };

                return value.toLocaleString('pt-BR', options);
            }

            return 0;
        }
    }
});

/***/ }),

/***/ "sx5J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      empresasGrupoEconomico: this.solicitacao.Empresa.EmpresasGrupoEconomico || []
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    validate: function validate() {
      if (this.empresasGrupoEconomico.length >= 1) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['Por favor, informe as empresas que fazem parte do grupo econômico'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {
        var newData = {
          Empresa: {
            EmpresasGrupoEconomico: this.empresasGrupoEconomico.map(function (company) {
              return {
                RazaoSocial: company.RazaoSocial,
                Cnpj: __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskCnpj(company.Cnpj)
              };
            })
          }
        };
        this.$emit('on-submit', newData);
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    },
    addCorporateGroupCompany: function addCorporateGroupCompany() {
      this.empresasGrupoEconomico.push({});
    },
    removeCorporateGroupCompany: function removeCorporateGroupCompany(index) {
      this.empresasGrupoEconomico.splice(index, 1);
    }
  }
});

/***/ }),

/***/ "sxXF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "syAn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "szOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalIncomeStep_vue__ = __webpack_require__("cGe7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce36f0a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalIncomeStep_vue__ = __webpack_require__("eOnu");
function injectStyle (ssrContext) {
  __webpack_require__("MHaR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce36f0a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalIncomeStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce36f0a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalIncomeStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t28z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvaliacaodeRisco_vue__ = __webpack_require__("ds0P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27383246_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvaliacaodeRisco_vue__ = __webpack_require__("mpiK");
function injectStyle (ssrContext) {
  __webpack_require__("+OiO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27383246"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvaliacaodeRisco_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27383246_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvaliacaodeRisco_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t2i1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Documentos_DocumentosInvestidor__ = __webpack_require__("ksmb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Documentos_DocumentosEmprestimoColetivo__ = __webpack_require__("7tYq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Documentos_DocumentosEmprestimoPessoal__ = __webpack_require__("VqRp");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import Modal from "@/components/Modal";




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showModal: false,
            type: this.$route.query.type,
            id: this.$route.query.id
        };
    },


    components: {
        DocumentosInvestidor: __WEBPACK_IMPORTED_MODULE_2__components_Documentos_DocumentosInvestidor__["a" /* default */],
        DocumentosEmprestimoColetivo: __WEBPACK_IMPORTED_MODULE_3__components_Documentos_DocumentosEmprestimoColetivo__["a" /* default */],
        DocumentosEmprestimoPessoal: __WEBPACK_IMPORTED_MODULE_4__components_Documentos_DocumentosEmprestimoPessoal__["a" /* default */]
    },

    // methods: {
    //     components: { Modal }
    // }

    methods: {
        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/perfil/documentos',
                title: 'Documentos'
            });
        }
    },

    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.taggingGA();

                        case 2:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ "tAXx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('a',{attrs:{"id":"show-modal","title":"Noma da empresa"},on:{"click":function($event){return _vm.mudarOportunidade(_vm.item);}}},[(this.item.IdOportunidade == 12345 || this.item.IdOportunidade == 12320 || this.item.IdOportunidade == 12264 || this.item.IdOportunidade == 12005 || this.item.IdOportunidade == 11668)?_c('div',{staticClass:"card-img-top card-background",class:{blackfriday: true}},[_c('div',{staticClass:"badge badge-id"},[_vm._v("ID: "+_vm._s(_vm.ajustIdOportunidade(this.item.IdOportunidade,5)))]),_vm._v(" "),_c('img',{staticClass:"card-img-top",attrs:{"src":"/static/assets/images/transparent.png"}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.item.Empresa.NomeFantasia ? _vm.item.Empresa.NomeFantasia : _vm.formatarScore(_vm.item.Score)))]),_vm._v(" "),_c('div',{staticClass:"rating"},[_c('span',{staticClass:"circle"},[_vm._v(_vm._s(_vm.formatarScore(_vm.item.Score)))])])]):_c('div',{staticClass:"card-img-top card-background"},[_c('div',{staticClass:"badge badge-id"},[_vm._v("ID: "+_vm._s(_vm.ajustIdOportunidade(this.item.IdOportunidade,5)))]),_vm._v(" "),_c('img',{staticClass:"card-img-top",attrs:{"src":"/static/assets/images/transparent.png"}}),_vm._v(" "),(_vm.item.Garantia == 'Sim')?_c('img',{staticClass:"selo-garantia",attrs:{"src":"/static/assets/images/selo-garantia.png","title":"Oportunidade com garantia pelo tomador e indicada pelo canal BNDES"}}):_vm._e(),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.item.Empresa.NomeFantasia ? _vm.item.Empresa.NomeFantasia : _vm.formatarScore(_vm.item.Score)))]),_vm._v(" "),_c('div',{staticClass:"rating"},[_c('span',{staticClass:"circle"},[_vm._v(_vm._s(_vm.formatarScore(_vm.item.Score)))])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('dd',{staticClass:"cat"},[_vm._v(_vm._s(_vm.formatarTipoEmprestimo(_vm.item.TipoEmprestimo)))]),_vm._v(" "),_c('dt',[_vm._v("Valor solicitado")]),_vm._v(" "),_c('dd',{staticClass:"value"},[_vm._v("R$ "+_vm._s(_vm.money(_vm.item.Valor)))]),_vm._v(" "),_c('dd',[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:('width: ' + _vm.inteiro(_vm.levantado(_vm.item)) + '%'),attrs:{"role":"progressbar","aria-valuenow":"0","aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"progress-value"},[_vm._v(_vm._s(_vm.money(_vm.levantado(_vm.item)))+"%")])])]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("Faltam:\n                    "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.money(_vm.faltam(_vm.item))))])])]),_vm._v(" "),(!_vm.item.Encerrado)?_c('dd',{staticClass:"end"},[_vm._v("Termina em "),_c('strong',[_vm._v(_vm._s(_vm.diffDate(_vm.item.FimCaptacao)))])]):_c('dd',{staticClass:"end"},[_vm._v("Encerrado")])]),_vm._v(" "),_c('div',{staticClass:"card-footer d-flex align-items-center"},[_c('div',{staticClass:"tax"},[_c('strong',[_vm._v("Rendimento")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.valor(_vm.item.Rendimento))+"% a.a.")])]),_vm._v(" "),_c('div',{staticClass:"links"},[(!_vm.item.Encerrado && _vm.item.TipoEmprestimo != 'emprestimo-ccb')?_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"id":'buttonInvestmentList'+_vm.index,"title":"Investir"},on:{"click":function($event){return _vm.mudarOportunidade(_vm.item);}}},[_vm._v(_vm._s((_vm.item.Valor - (_vm.item.ValorCaptado == undefined ? 0 :_vm.item.ValorCaptado) ) > 0 ? 'Investir' : 'Lista de Espera'))]):_vm._e(),_vm._v(" "),(_vm.item.Encerrado)?_c('button',{staticClass:"btn btn-secondary btn-block",attrs:{"title":"Encerrado"},on:{"click":function($event){return _vm.mudarOportunidade(_vm.item);}}},[_vm._v("Encerrado")]):_vm._e(),_vm._v(" "),(_vm.item.TipoEmprestimo != 'emprestimo-ccb')?_c('router-link',{staticClass:"btn btn-outline-primary btn-block",attrs:{"to":_vm.templateRender(_vm.item),"title":"+ detalhes"}},[_vm._v("+ detalhes")]):_c('router-link',{staticClass:"btn btn-outline-primary btn-block",attrs:{"to":'/investimentos/oportunidades/'+_vm.item._id+'/perfil-ccb',"title":"+ detalhes"}},[_vm._v("+ detalhes")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tFCg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 text-center title-loan"},[_c('h1',[_vm._v("Solicitação de Empréstimo "+_vm._s(_vm.getTypeLoan()))])]),_vm._v(" "),(_vm.type == 'EMPCOL')?_c('emprestimo-coletivo-form',{attrs:{"type":_vm.type}}):_vm._e(),_vm._v(" "),(_vm.type == 'EMPIMP2')?_c('emprestimo-coletivo-form',{attrs:{"type":_vm.type}}):_vm._e(),_vm._v(" "),(_vm.type == 'EMPSOC')?_c('emprestimo-impacto-form',{attrs:{"type":_vm.type,"changeType":_vm.changeType}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tFiN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-info"},[(_vm.oportunidadesEmBreve)?_c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(!_vm.oportunidadesEmBreve)?_c('div',{staticClass:"row list-view"},[(_vm.showModal)?_c('Modal',{attrs:{"solicitacaoProps":_vm.solicitacao,"investidor":_vm.investidor,"usuario":_vm.User},on:{"close":function($event){return _vm.voltar()}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 tit_page"},[_c('div',{staticClass:"row align-items-center"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 float-right text-lg-right"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 control-group"},[_c('strong',[_vm._v("Score: ")]),_vm._v(" "),_c('label',{staticClass:"control control-aa control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tAA\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"AA",attrs:{"id":"AA","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreClick($event, 'AA')}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})]),_vm._v(" "),_c('label',{staticClass:"control control-a control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"A",attrs:{"id":"A","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreClick($event, 'A')}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})]),_vm._v(" "),_c('label',{staticClass:"control control-b control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tB\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"B",attrs:{"id":"B","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreClick($event, 'B')}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})]),_vm._v(" "),_c('label',{staticClass:"control control-c control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tC\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"C",attrs:{"id":"C","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreClick($event, 'C')}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})]),_vm._v(" "),_c('label',{staticClass:"control control-d control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tD\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"D",attrs:{"id":"D","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreClick($event, 'D')}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})]),_vm._v(" "),_c('label',{staticClass:"control control-e control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tE\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"E",attrs:{"id":"E","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreClick($event, 'E')}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})]),_vm._v(" "),_c('label',{staticClass:"control control-hr control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tHR\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"HR",attrs:{"id":"HR","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreClick($event, 'HR')}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})]),_vm._v(" "),_c('label',{staticClass:"control control-todos control-checkbox"},[_vm._v("\n\t\t\t\t\t\t\t\t\tTodos\n\t\t\t\t\t\t\t\t\t"),_c('input',{ref:"all",attrs:{"id":"all","type":"checkbox","checked":"checked"},on:{"click":function($event){return _vm.scoreAll($event)}}}),_vm._v(" "),_c('div',{staticClass:"control_indicator"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-2 d-flex justify-content-end align-items-center display"},[_c('span',[_vm._v("Exibir como")]),_vm._v(" "),_c('ul',{staticClass:"display-loans"},[_c('li',{staticClass:"display-loan grid"},[_c('label',{attrs:{"for":"grid"}},[_c('input',{attrs:{"type":"radio","name":"loans","id":"grid","value":"grid"},domProps:{"checked":_vm.showCards},on:{"click":_vm.setCards}}),_vm._v(" "),_c('svg',{attrs:{"viewBox":"0 0 19.2 19.2"}},[_c('g',{attrs:{"transform":"translate(0.6 0.6)"}},[_c('path',{attrs:{"d":"M81.548,8.138a.334.334,0,0,1-.31.31H74.41a.334.334,0,0,1-.31-.31V1.31A.334.334,0,0,1,74.41,1h6.828a.334.334,0,0,1,.31.31Z","transform":"translate(-74.1 -1)"}}),_c('path',{attrs:{"d":"M115.548,8.138a.334.334,0,0,1-.31.31H108.41a.334.334,0,0,1-.31-.31V1.31a.334.334,0,0,1,.31-.31h6.828a.334.334,0,0,1,.31.31Z","transform":"translate(-97.548 -1)"}}),_c('path',{attrs:{"d":"M81.548,42.138a.334.334,0,0,1-.31.31H74.41a.334.334,0,0,1-.31-.31V35.31a.334.334,0,0,1,.31-.31h6.828a.334.334,0,0,1,.31.31Z","transform":"translate(-74.1 -24.448)"}}),_c('path',{attrs:{"d":"M115.548,42.138a.334.334,0,0,1-.31.31H108.41a.334.334,0,0,1-.31-.31V35.31a.334.334,0,0,1,.31-.31h6.828a.334.334,0,0,1,.31.31Z","transform":"translate(-97.548 -24.448)"}})])])])]),_vm._v(" "),_c('li',{staticClass:"display-loan list"},[_c('label',{attrs:{"for":"list"}},[_c('input',{attrs:{"type":"radio","name":"loans","id":"list","value":"list"},domProps:{"checked":_vm.showCards==''},on:{"click":_vm.unsetCards}}),_vm._v(" "),_c('svg',{attrs:{"viewBox":"0 0 19.2 19.2"}},[_c('g',{attrs:{"transform":"translate(0.6 0.6)"}},[_c('rect',{attrs:{"width":"18","height":"4.345","transform":"translate(0)"}}),_c('rect',{attrs:{"width":"18","height":"4.345","transform":"translate(0 6.828)"}}),_c('rect',{attrs:{"width":"18","height":"4.345","transform":"translate(0 13.655)"}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),(_vm.showCards)?_c('div',{staticClass:"view"},[_c('div',{staticClass:"row cards"},_vm._l((this.oportunidades),function(item,index){return _c('div',{key:item._id,class:'column rating-' + _vm.lowerCase(item.Score)},[_c('opportunityCard',{attrs:{"index":index,"item":item,"mudarOportunidade":_vm.mudarOportunidade,"ajustIdOportunidade":_vm.ajustIdOportunidade,"formatarScore":_vm.formatarScore,"formatarTipoEmprestimo":_vm.formatarTipoEmprestimo,"money":_vm.money,"inteiro":_vm.inteiro,"levantado":_vm.levantado,"faltam":_vm.faltam,"diffDate":_vm.diffDate,"valor":_vm.valor,"templateRender":_vm.templateRender}})],1)}),0)]):_vm._e(),_vm._v(" "),(!_vm.showCards)?_c('opportunitiesList',{attrs:{"oportunidatesAux":_vm.oportunidades,"mudarOportunidade":_vm.mudarOportunidade,"ajustIdOportunidade":_vm.ajustIdOportunidade,"formatarScore":_vm.formatarScore,"formatarTipoEmprestimo":_vm.formatarTipoEmprestimo,"money":_vm.money,"inteiro":_vm.inteiro,"levantado":_vm.levantado,"faltam":_vm.faltam,"diffDate":_vm.diffDate,"valor":_vm.valor,"templateRender":_vm.templateRender,"lowerCase":_vm.lowerCase,"InvestidorBloqueado":_vm.InvestidorBloqueado()}}):_vm._e(),_vm._v(" "),_c('Pagination',{attrs:{"paginasTotais":this.Paginas,"paginaAtual":this.indexPage,"navigate":function (rota){ return this$1.paginacao(rota-1); }}})],1)],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard__complete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Em breve novas oportunidades")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-4 float-left"},[_c('h1',[_vm._v("Oportunidades")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tbCL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extra),expression:"extra"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"id":"extra","type":"text","placeholder":"R$","required":""},domProps:{"value":(_vm.extra)},on:{"input":function($event){if($event.target.composing){ return; }_vm.extra=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-check d-flex justify-content-center"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":"noOther"},on:{"click":_vm.noHaveOther}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"noOther"}},[_vm._v("Não possuo outra fonte de renda!")])]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.RendaValida}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Renda Adicional")]),_vm._v(" "),_c('p',[_vm._v("Você possui outra fonte de renda?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tcXY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,/9j/4AAQSkZJRgABAQEAkACQAAD/4QA2RXhpZgAATU0AKgAAAAgAAgESAAMAAAABAAEAAAExAAIAAAAHAAAAJgAAAABHb29nbGUAAP/bAEMAAgEBAgEBAgICAgICAgIDBQMDAwMDBgQEAwUHBgcHBwYHBwgJCwkICAoIBwcKDQoKCwwMDAwHCQ4PDQwOCwwMDP/bAEMBAgICAwMDBgMDBgwIBwgMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDP/AABEIALQAtAMBIgACEQEDEQH/xAAfAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgv/xAC1EAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+fr/xAAfAQADAQEBAQEBAQEBAAAAAAAAAQIDBAUGBwgJCgv/xAC1EQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/AP38ooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAy/Gd3q1h4U1CbQrO01DWIoGa0trqcwQzyAcKzhW2g+uPxHUfnb8Vv27vi9rOu3unXmpf8IlNaSNb3Fhp9mtvJA6nBDPJvlDD2cA9cYxX6Tda+ef23f2L4fj1o8niDw/FDb+M7CLAGQiavGo4hc9BIB9xzx/CxCkMnwPH2U5ri8H7XKq0oyhvCLtzryas7rtez2tff5fijA46vh+fA1JJx3inbmXy1v5bP1PgvWPix4s8RsW1HxV4m1An/n51WeX/wBCc1yfxH+O2qfBnwFqviL+2tYjbTYd8Sx38sZmmJCxJkMD8zsoJHQEntWjc20tjdTW9xDLb3FvI0UsUqFJInUkMrKeVYEEEHkEYr5m/wCChPjspH4f8Lwyf6zdqt0ueoG6KH8M+cfqBX888P4WvmWaU8PUlJ3d5O7vZavXdXtb1Z+J1MRVvzSk7+rP1e/4Ibftrah+13+yI1h4n1WbVvHPgC8Olarc3Mm+4vrd8yWl056ndHuiLElme1kY9a+0K/A7/ggV+0VJ8E/2/dN8P3Fx5ei/Euxl0O4Rn2xrdRq1xaSEd23RyQr73R/D98c1/XGAqc9FLtoftnB+ZvG5bBzd5Q91/LZ/c187hmjOa+d/+ClHxE1j4Z/CHw3qWg6pd6Tqi+JIfLnt32tgW1yxBHRlJAyrAqehBFR/sd/t42PxyMHh3xILfSvF+MRFPlttWAGSY8/dkABJjJOQNykjcqeLU4swNLNnk9d8tSycW9pX6X6Psnv010O+WeYaGO/s+o+WVk1fZ36ev59NT6Mooor6Y9kKKKKACiiigAooooAKKKKACiiigArn/in8TtJ+DvgPUfEeuTNDp+mx732jdJKxICxoOMuzEKBkDJ5IGTXQV+ef/BR79oZ/if8AFVvCen3G7QvCUzRyhD8tzfYKyMf+uWWiHHDeb1BFfK8Y8SQyXLpYneb92C7yffyW7+7do8TiDOI5dhHW+09Iru/8lu/u6njXx/8A+C4vxn/Z2+L8d+NB8Ha94H8QEy22nXUEsNxpxjwGt0uo2GflKPvkicks2AoG0e5fs2f8HE/wZ+LcltY+OLHW/hfq02FaS9X+0NK3k42i5hXeo9WlhiUDqa+NPj18J4vjN8Mr7Rv3aXoxc2ErnAiuUB2ZPZWBZCeyuT1Ar4Eu7KbTrua2uYZLe5tpGhmikGHidSQysOxBBBHtXyPAvF1fMMFy1581WDtK/VPZ/p6rzPyTDcZZrhp3dTnXaSv+OjXydvI/qw8FeOtE+JXhez1zw5rGleINF1BPMtdQ027jurW5XOMpJGSrDIIyCelatfy6/s7/ALUvxE/ZN8Wf218O/Fur+F7uRw9xDbyB7O+wMDz7dw0U2ASAXUlc5Uqea/Wn9gr/AIOE/CPxkuLLwz8ZLXT/AIf+JJsRRa7C7DQb9ycDzC5LWbHP/LRni+UkyoSqV+kYfMIT0no/wP0DJuOMHi2qWI/dz8/hfz6fO3qz2r/gof8Ase/8JPY3PxC8MWpbVrRN+s2cS83sKjH2hR/z0RR8w/jQZHzKA/4YftWeKv8AhLv2gPEUytuhsZl0+IA52iFQjD/v4JD+Nf1CRSrcRK8bK6sAysDkMOxBr8Lf+C5f/BN5v2VfjG/xK8J2YX4e+Pr53uYIQdug6o+ZJIsfwwznfJHjhWEkeEURBvl8RwnhsPmc84w6s5xtJdLtpuS83bXz16s8Hjjh3lTzHDLT7aX/AKV/n9/c+Ifh98Qb34R/EHw/4t03/kI+FdUtdZtfeW2mSZB+LIK/qn0DXbXxPoVlqVjMtxY6hAlzbyr92WN1DKw+oINfygN8yexr+lX/AIJieMm8ef8ABPL4M6g7tJKvhHT7KVycs728K27MfctESfc172VS1lEz8N8Q1VrUO6T+52f5o82/4K26z5PhbwPpuf8Aj5vbq6x6+VGiZ/8AI3618TwyyW08c0MkkM0LiSOSNijxsDlWVhyGBAII5BFfS/8AwWN+KOk+EvH/AIUh1nUrPTLPTdKluhJcyhAxnl24UdWY/Z+igk+lfnJ4/wD+CgGi6U7w+G9Ju9akHAubpvstufdVwZGHswQ1/P8AxplWPzTiPEfU6bkouMb7JWjG+rst79bnh8YYhSzaq77WX3RX6n7KfsHfteH48+GW8P69Ko8X6LCHeQ4X+1LcEKJwB0dSQJABjJVhgNtX6Gr8PP8Agj/8TfiZ+1X+374Zht7y10bw/wCFYZ9e1ttOtVT/AEZEMSQb5N7fvZpYkZQwLRmUjG04/cMcCv3LhF5ksujTzSzqR0une6VrN6LXo972ve7Z+lcH5lXxuXqdfeL5U/5kra/pfrbvcKKKK+oPqgooooAKKKKACiiigAooooA4X9pX4r/8KS+B/iLxIjJ9qsbUpZhhuDXMhEcOR3HmMpPsDX5Qs7yuzySPLJIxZ3c7mdjyST3JPJNfo1+398IfGXx08FeH/D/hTT4bqH+0Gvb+WW7jgSIRxlI1O45YMZGPyg4MYzjjPzvpX/BLL4jXoVrrUvB9krdQbyeWRfwEO3/x6vwfxKyzOM1zONHCUJyp04qzto5S1bTdk9LL1TPzHjHB5hjsYqdClKUILR20u9Xrt2XyPm2vmX9uH4CNvk8caTDkYVdYhQdMYVbkD8lfH+y3981+qel/8EkdYmUfbPHWm2rdxDpLz/zmStRP+CQ1rPBJFd+PHuIpVKSRjRFCSKRgqQ0zAggkEHgivn+H+D+KcuxccXRw3k05wV0918V/TTR2Z8z/AKm5vNfwv/Jo/wCZ+AVBGRX7BeIv+DYrwvqGr3U2m/FjXNNtZpGeG2bRIpxbqeQgbzgWA6AnnGMknk87qP8Awa7SNk2fx0WP0WfwZ5mfxW+X88V+5xwOIaTcfldf5mUuCc4W1L/yaP8AmfPP/BLT/gsX4k/Yk1Wx8HeMpr7xJ8JZpFjEJzNeeGM8GW17tAOr23IAG6La25Zf2y+Jnw68F/tjfs9X+gap9j8R+CfHmlIyz20qyR3NvKqyQ3MEgyNwPlyxyDOGVGHIFfk34s/4NlPidYN/xI/iV4D1Vc9b60u9P4+iCev08/4J/wD7Mmpfsc/sh+DfhzrGux+JNS8OQ3Anvoo2jiLTXMtx5UYYlvLiEojUnBKxg7VztHp4GNZJ06q0/rQ+94So5rSjPA5lTfs7aNtPy5d3dNfda3U/nh/a4/Zf8Qfsa/tB+Ivh34kDS3mizBrW9EXlx6rZvloLuMZI2uvUAtsdZEJJQ1+7/wDwRZimh/4Jh/CcTBlZrC6Zc/3DfXJT/wAdK1L/AMFHP+CWvg3/AIKLaVoU2qale+FvE/hxmjs9asIEmke2cgyW0yNgSJkbkyQY3yQcPIr+4/DP4f8Ah/8AZr+COieGdMb7B4Z8EaPFYwyXDgtHbW0QXzJGwNzbULM2OSSe9PC4R0qspdOhpw/wzUyzMq1ZfwmrR111adn6Wtfrv3PwY/4Lj/FBvij/AMFMPHiLMtxZ+FIbLQLRgc7VjtkllX2xcTzg/SvkmR1hjZmIVVBJJ7Cuh+LPxNufjV8WPFXjO8Vo7rxfrN5rcsZP+qa5nebZ9F37QOwAr7S/4Iif8Ezp/wBrH4s2/wASfGGnr/wrPwXeCSCG4jyniTUYyGWEKeHt4WAaUn5WYLFhwZgnkcsq1W0erPy/2FbNszkqCu6km/RN3u/JL/I/QL/ghn+w/N+yT+yYmva9ZyWfjb4mNFq+pRSoUlsbRVb7FaMD0ZY3eVgQGWS5kQ52CvtWiuV+Ivxq8N/CvUtDsdY1CODUPEd/Dp2nWi/PNcSSyLGGCjoilgWc4A4GclQfelUo4WjepJRiurdt/wDN/ifvGEw9DL8JGgmlCKSu9Pn6t/izqqKKK6j0AooooAKKKKACiiigAooooAKKKKACgmvjv9uz/gtX8Kf2Lr2+8P2cknxA8fWbNFJoekXCrDYSAkFby6IZICCCCirJKpxmMA7q/JX9rP8A4K7fHL9ru4uLbU/FU3hPw1NlV0Hwy76fbMhBG2aUMZ58rjcskhjJGRGucVx18dTp6bvyPlc44wwGAbp355rpHp6vZfi/I/cD9oP/AIKQfA79l27uLTxp8SvDen6patsm0u1lbUNShb0e1thJMn1ZAOvPBr5p1b/g5L+Amn6z9lt9B+KOo2+4L9tt9ItFhx/e2yXSS4/4Bn2r8OIbeO2jCxqsar0VRgCvdP8Agn/+wd4q/wCCgXxyi8L6F5mn6HpojuvEWuGPdDo9qzEDHZp5NrrFH1YqzH5I3ZfP/tGtOXLBI+J/16zTF140cHTinJ2Ss2/m3ZfOyP6L/gv8YvD37QPws0Pxp4T1BdU8O+IrVbyxuRG0ZdDkEMrAMrKwKsrAFWUgjIrqK5n4N/CTQ/gN8KvD/gzwzafYdB8M2MWn2UOdzCONQoLN1Z25ZmPLMxJ5Jrpq9qN7e9ufrlHn5F7W3NZXttfrbyCvF/8Agop4e8WeL/2F/itpHgexn1LxPq3hu7srS1gAM1wssZSVIh3kMTSBQOS23HOK9ooIzRKPMnEnEUVVpSpN25k1dbq6tofhF/wT/wD+CFnxI/aO8YWuqfE7R9Y+G/gCzkV7iO+i+y6xq2DzDDA3zwLxhpZVUgMNiuSSn7hfDn4daH8IvAuk+GfDOl2mi6DodstpY2Nqm2K3iXgAD9STkkkkkkk14l+2J/wVI+Df7EkNxa+KvEiah4njXcnhvRQt5qrk4IDoGCQAg5DTvGrAHBJ4r8i/20f+C4vxg/ap1NrHw/dH4a+DY5MppmlzebdXwxjF3csoMin5sxIqRkNtcSYDV5cqlHCRah70v63dnZfJ+jPhI4rJ+G6UqdJ89V72s5Pyb2ivLfrZn6y/tQf8FFdD+FyXOi+Dza+JPEikxvcBt+n2B77mU/vXHTYhwDkMykbT8QXHxM1jxR8VLPxVrWpXOpasuoQXUlzORu/dyKwCgYCqMcKoCqOABXyz8EP25bHX3h0zxhHb6TeHCR6jCNtnKe3mLyYj/tZKdSdgFfQkK/amiWPD+cV2FTkNnGCD3ByOa/mvjbOM8r4xRzNckU7wivg06p/afm9VfZbHweacQ4rMaqnUdop6RWy/zfm/lY/Ziiiiv6qP30KKKKACiiigAooooAKKKKAMH4n/ABQ8P/BfwDqninxVrFjoPh/RYTcXt/eSeXDAmQBk92LEKqjLMzBQCSAfxY/4KRf8F2fFn7SVzqPhD4Tzal4J+H7Zgn1NSYNZ15O53D5rSBj0RCJWUDeyh3hH6W/8FXfgXp3xv/ZWl/tLTbXVoPDGpQaubeePzAVAeB2A/hKrMW3DBAVsHkg/lNrP7E/w91dmaLS77TWbnNpqEv8AKQuB+AxX53xVxxQyrGfUcTCSTipKSSaad13TVmmup+Y8cZ1jaVX6lR92LV21u73Vr9F6av00PiaKJYI1VFVVUYAAwBTq+uLv/gnv4RdiYNa8URezzW74/wDIK1XH/BPfwynL+IPEe0dh5H/xBr5xeIWS2vzy/wDAWflvs5Hz/wDs/wDwF8TftP8Axl0HwH4Ps1vfEHiG48mHzCVgtkA3STzMASsUaAuxAJwuFDMVU/0d/sR/sbeF/wBhb4BaX4G8Mj7QYT9p1TU5IhHPrN6wUS3MgBOM7VVVydiIiAkLmvI/+CUn/BM7w7+wp4BvNdaG8uvHHi+FPt1zqBjkuNMtR8yWUZVFCDOHkAGWcKCWEUZHR/8ABWv9ref9jb9iDxR4i0u6+yeKNaKeH/D8gOGivbkMPNU9N0MKTzjPBMAB61+n5bGMcOsTNNXV7PRpb2a6PuvkfsXDOS08owUsxxi9/lbf92O9vV9fkvXLvP8Agsb8G7f9s+x+CMN5rV7r15qP9ivrNvbRto1tqRJVbJpfMEhkMgEWUjZBI6qWBD7fqqv5Tfhr43k+FHxC8NeJ7ff5vhbVbPWIyp+bdbTpMMe+U/Ov6sIJ0uYVkjZZI5AGVlOVYHkEH0rqwOKlW5ubod3CPEFbNFWdZJOLVrdE72Xna246vkP/AILTaD8bvEX7IXkfBOTXPty6kj+IINBZl1i504RSZS2KHzD+98oukP711G0ZUujfnlo//Bfj4/fCD9pbxRJ4n/sbxV4bt9Zu7SXwtdWMNh/Zkcdw6+Tb3UMYlWRAuzdP54ODlcnI/Tn9iz/gqn8If24ra3s/Duuf2L4ukTMvhnWSttqQIBLeUMlLhQATuhZ8AjcEJwCOKpV04J2ZpRz7L83pzwUKjhKV1r7svl0fpvbdH84+o2r6Bq1xY30MtjqEEhFxbXMZhnifqd6Nhg3rkZpu8Yr+q7xv8MfDfxMsVtfEnh7Q/EFsvSLUrCK7QfhIpFefn/gn/wDAc3Xnf8KT+EfndfM/4Q/Tt35+TmuN5VK+kj5Op4b1eb93XTXnFr9WfzHLdRzXCQq6vNKwVI1OXcnoAOpPsK+8/wDgl3+zb8ffFHj3w7YzfDbxY/w3+328k+o6xB/ZkelwearPLbm5KNPFjOY4g/PK4O4N+3HgX4R+E/hfC0fhnwx4e8OxsNpXTNOhs1I9MRqOK6LGK5sXw1hsZS9jjFzR322a6p9H/wAMd+B8O6dOaniKzduiVvxbf5BRRRX0Z+khRRRQAUUUUAFFFFABRRRQBT8RaDaeKvD99peoQrc2OpW8lrcxN0lidSrqfqpIr8lvi78ML74MfEzWvC+obmn0m4MaSsMfaYjhopR2+dCrY7EkdQa/XWvmn/gor+y7N8WvB0fi7Q7VpvEXhyErPDGMyX9mCWKAdS8ZLOoHJDSAAkqK/M/E3hmWZZesVh1erRu7dXF/EvNqya9Glqz47jLJpYzCqtSV507v1XVevVfNdT8/a+lv+CcX7NY+J3j5vGWrW+/Q/C86/ZEb7t3fDDKfdYgVc9PnaPrhhXgHw68C6h8V/HGk+HdHRZtQ1mdYISclEB5aRsfwIgZ2I/hU1+sHwo+Gmm/B74daT4a0lWWx0mARKzfembJZ5GxxudyzHHGWNfmPhjwusxx317EK9Ki0/KU90vRfE/ktmfGcGZL9bxP1mqvcp/jLovlu/l3Ohr8Yf+Dlr48t4o/aG8C/Dm2lzZ+EtHfWbwI/D3V45RFcf3o4bcMD6XR9eP2eNfzZ/wDBU74nSfF3/gov8YdXYtttfEU2ixg9FWwVLHj2Jti3uWJ71/RWZVLUuXuz6vxAxjpZaqS+3JL5LX80jwGZBLGyt91hg1/S3/wTX+LP/C7v2CPhL4iab7TdXHhq0tLyXOfMurZPs1wf+/0MnHav5pXYIuTxjmv3h/4N/JtW8OfsUzeEddl26hoWqy3tvZFSGsLO8/fRo/8AtGYXLEYGC2DyCa8nAYylSxMaE5JSqXUV1bSu7eiufI+HuK9nmEqL2nF/etfyufn/AP8ABej9jeb9nH9sK58aaba+X4T+KzyarE6L8ltqYx9thPJ5kZhcAnG4zyhRiM18PFfmVujRsHUjqrA5BB7EHnNf01/tyfsfaB+3J+zlrfgHXmFo12BdaXqIiEkmkX8YPk3KjIzgsVZQV3xvImQGJr+bv40fBrxJ+zx8Vdc8E+LtPbS/EXh25NrdwHJRuAVkjYgb4pEKuj4G5WU8ZxWuPw7pz5lszm40yOWCxbxNNfu6jv6S3a/VeWnQ+3v+CYH/AAVs+MXgzxdceE/EHiSbx1oUWnmeyt9fY3F1AySIGVLv/XnKucea0iqE4Ar9NPhb/wAFOfAPjOOOHX49Q8I3zABvtEZubUseyzRjOPd0QV+Bf7JesHRf2ivDMm7CXEstq4/veZDIg/8AHip/Cvuw9K/KOKuMs2yTM4xw81KnKKfLJXV7tOz0a26O3kc+V8WZlhIqKnzRXSWv47/jY/YPwl460Tx9p32zQ9Y0zWbXoZrG6S4QH0JQkCtUHNfmv+wV+znffGj4vQ6w32qz8P8AhqVZb66gkaF7iT7yWqOuD82Az46JwcF0J/SgV+mcHcQ4nOcF9cr0fZq9lrfmtu0rKyvpu9Uz9b4fzatmGG+sVafIr2Wt792tFZX069Qooor6w90KKKKACiiigAooooAKKKKACiiigDy/4dfsm+Ffhf8AGzXPG2k27Q3etQCNbXA8mxdmLTvEP4fMITI/h2tggOVHqFFFcmDwOHwkHTw0FFNttJW1bu3/AF6LQww+FpUIuFGKim29O73Cv5UPiR4qfx18SfEmuyMXk1zV7zUXY/xGad5Cf/Hq/qvNfzIfsofsu3XxdWz1jWo5rXwvb4zklZNUdesaHqEBGGce6r82SnicUZlh8Bh1icTK0Vf1b0sl3b/rQ/N/EhtrDwX9/wD9t/zOl/Yy/Z0PizU4fGGuW+dJs5N2mwSLxezKf9aR/wA842HH95x6KQ36Yf8ABNv4l/8ACDftIw6bPIVtPFdpJYHJwvnr+9iY+/yug95a+fbS0hsLSG3t4o4Le3RYooo1CpEijCqoHAAAAAHQCr2h69eeFdesdU0+QRX+l3Md5bORkJLGwdCfbcor+bKvF2Iq51TzaeipyVorpFPVerV7vq32sj4LK8U8HiaeIj9lp+q6r5rQ/Y6vk3/gqf8A8EuNC/4KE/DyG+0+Sz0H4neHYGTRNZkUiK6jyW+w3ZUFmt2YkqwBaF2LqGDSxy/THw58cWfxL8BaP4gsD/oetWcV5GCcmMOobaf9pSSCOxBrar+s06eIpKS1jJJp909Uz+gMVhcPjcO6VVc0JL/hmvzTP5f9C+F/ib4B/tY6F4U8YaLfeHfEuieIbO3vbC6UCSItOgBDKSrxspysiFkdSGViCDX6V/s3/s1a/wDtK+MP7P0tWtdLtXH9o6pIm6GyXrgf35SPuoD3BOFya+9/2ov2Gvhv+2A+hXPjTQluNY8MXkN7pWr2j/Z9QsjHKshjEo5aFyMNGwZTncAHVXX0jwP4F0f4beGLXRdC0+20vTLJdkNvAuFX1JPVmJ5LMSWJJJJOa/Pc84BjmuZUq+Jn+5gtUvilre3ku737W3X57hfD3kxb9rUvRWq/mfk+3m1v0S6U/hX8LtG+DXgax8PaDa/ZtPsUwNx3STOeWkdv4nY5JP5YGAOioor9Eo0adGnGlSSjGKsktEktkj9Lp0404qEFZLRJdEFFFFaFhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAB1rw3xn/AME6PhR4sj/0bw+3hx1UIh0adrWOJQMBUh5hUAcABBxx0r3KiuDMMrweOh7PGUo1EtuZJ29L7fI5cVgcPiY8uIgpLzSdvTsfIuv/APBJXRZpD/ZPjTWbRM8C9soroj8UMX8qy7b/AIJGMsv774hF4+4j0LY35m4P8q+zqK+Xn4ccOSlzPDL5Sml9ylY8WXCOUSd3R/GX+Zw/7PHwUj/Z9+GVt4Yt9WvtXtbWaWWKS5REaISMXZFCgfLvLNzk5Y84xXcUUV9fhcLSw1GOHoK0IpJLV2S0S110PfoUYUacaVNWjFWS7JBRRRXQahRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQB//9k="

/***/ }),

/***/ "tg80":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "togB":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "tpd9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ttus":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-7 text-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.submitWithCorporateGroup}},[_vm._v("Sim")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.submitWithoutCorporateGroup}},[_vm._v("Não")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('p',[_vm._v("A empresa possui algum financiamento já contratado?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "txFT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OutrosEmprestimosStep_vue__ = __webpack_require__("/pnt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95098f12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OutrosEmprestimosStep_vue__ = __webpack_require__("nuHT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OutrosEmprestimosStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95098f12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OutrosEmprestimosStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tz5f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u6H3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressConfirmationStep_vue__ = __webpack_require__("2cBF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3333419a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressConfirmationStep_vue__ = __webpack_require__("zFeu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressConfirmationStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3333419a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressConfirmationStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u9Cq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    metaInfo: {
        htmlAttrs: {
            lang: 'pt-br'
        },
        bodyAttrs: {
            class: 'select-loan'
        }
    },
    data: function data() {
        return {
            lpUrl: "https://iouu.com.br",
            user: null,
            finishedLoading: false
        };
    },

    computed: {
        firstName: function firstName() {
            if (this.user.name) {
                return this.getFirstName(this.user.name);
            } else {
                return this.getFirstName(this.user.username);
            }
        }
    },
    methods: {
        getFirstName: function getFirstName(name) {
            var firstName = name.split(" ");

            return firstName[0];
        }
    },
    beforeCreate: function beforeCreate() {
        var _this = this;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["c" /* START_LOADING */]);

        __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getUser().then(function (response) {
            _this.user = response;

            _this.finishedLoading = true;
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["d" /* STOP_LOADING */]);
        }).catch(function () {
            _this.finishedLoading = true;
            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    }
});

/***/ }),

/***/ "u9Ef":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxNyAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjMzMzEgMTQuNjg5NEMxNS45MDY2IDEzLjY3OSAxNS4yODc4IDEyLjc2MTIgMTQuNTExIDExLjk4NzJDMTMuNzM2NiAxMS4yMTA5IDEyLjgxOTIgMTAuNTkyIDExLjgwOTYgMTAuMTY0NkMxMS44MDA1IDEwLjE2MDEgMTEuNzkxNSAxMC4xNTc4IDExLjc4MjQgMTAuMTUzM0MxMy4xOTA4IDkuMTM1NjggMTQuMTA2MyA3LjQ3ODE0IDE0LjEwNjMgNS42MDgwNEMxNC4xMDYzIDIuNTEwMDUgMTEuNTk3MSAwIDguNSAwQzUuNDAyOTUgMCAyLjg5MzY1IDIuNTEwMDUgMi44OTM2NSA1LjYwODA0QzIuODkzNjUgNy40NzgxNCAzLjgwOTIxIDkuMTM1NjggNS4yMTc1OCAxMC4xNTU1QzUuMjA4NTMgMTAuMTYgNS4xOTk0OSAxMC4xNjIzIDUuMTkwNDUgMTAuMTY2OEM0LjE3NzY5IDEwLjU5NDIgMy4yNjg5MiAxMS4yMDcgMi40ODkgMTEuOTg5NEMxLjcxMjk1IDEyLjc2NDEgMS4wOTQyMSAxMy42ODE3IDAuNjY2OTQgMTQuNjkxN0MwLjI0NzE5MyAxNS42ODA1IDAuMDIwODEzNCAxNi43NDA2IDUuNjUyOTFlLTA1IDE3LjgxNDZDLTAuMDAwNTQ2ODQzIDE3LjgzODcgMC4wMDM2ODUxMSAxNy44NjI3IDAuMDEyNTAzMSAxNy44ODUyQzAuMDIxMzIxMiAxNy45MDc3IDAuMDM0NTQ2OCAxNy45MjgxIDAuMDUxNDAwNyAxNy45NDU0QzAuMDY4MjU0NiAxNy45NjI3IDAuMDg4Mzk1OSAxNy45NzY0IDAuMTEwNjM4IDE3Ljk4NThDMC4xMzI4NzkgMTcuOTk1MiAwLjE1Njc3MiAxOCAwLjE4MDkwNiAxOEgxLjUzNzI4QzEuNjM2NzUgMTggMS43MTU4NyAxNy45MjA5IDEuNzE4MTMgMTcuODIzNkMxLjc2MzM0IDE2LjA3NzkgMi40NjQxNCAxNC40NDMgMy43MDI5NiAxMy4yMDM4QzQuOTg0NzMgMTEuOTIxNiA2LjY4Njk4IDExLjIxNjEgOC41IDExLjIxNjFDMTAuMzEzIDExLjIxNjEgMTIuMDE1MyAxMS45MjE2IDEzLjI5NyAxMy4yMDM4QzE0LjUzNTkgMTQuNDQzIDE1LjIzNjcgMTYuMDc3OSAxNS4yODE5IDE3LjgyMzZDMTUuMjg0MSAxNy45MjMxIDE1LjM2MzMgMTggMTUuNDYyNyAxOEgxNi44MTkxQzE2Ljg0MzIgMTggMTYuODY3MSAxNy45OTUyIDE2Ljg4OTQgMTcuOTg1OEMxNi45MTE2IDE3Ljk3NjQgMTYuOTMxNyAxNy45NjI3IDE2Ljk0ODYgMTcuOTQ1NEMxNi45NjU1IDE3LjkyODEgMTYuOTc4NyAxNy45MDc3IDE2Ljk4NzUgMTcuODg1MkMxNi45OTYzIDE3Ljg2MjcgMTcuMDAwNSAxNy44Mzg3IDE2Ljk5OTkgMTcuODE0NkMxNi45NzczIDE2LjczMzcgMTYuNzUzNSAxNS42ODIyIDE2LjMzMzEgMTQuNjg5NFpNOC41IDkuNDk3NDlDNy40NjIzNyA5LjQ5NzQ5IDYuNDg1NzggOS4wOTI3MSA1Ljc1MTA4IDguMzU3NzlDNS4wMTYzOCA3LjYyMjg2IDQuNjExNzMgNi42NDU5OCA0LjYxMTczIDUuNjA4MDRDNC42MTE3MyA0LjU3MDEgNS4wMTYzOCAzLjU5MzIyIDUuNzUxMDggMi44NTgyOUM2LjQ4NTc4IDIuMTIzMzcgNy40NjIzNyAxLjcxODU5IDguNSAxLjcxODU5QzkuNTM3NjMgMS43MTg1OSAxMC41MTQyIDIuMTIzMzcgMTEuMjQ4OSAyLjg1ODI5QzExLjk4MzYgMy41OTMyMiAxMi4zODgzIDQuNTcwMSAxMi4zODgzIDUuNjA4MDRDMTIuMzg4MyA2LjY0NTk4IDExLjk4MzYgNy42MjI4NiAxMS4yNDg5IDguMzU3NzlDMTAuNTE0MiA5LjA5MjcxIDkuNTM3NjMgOS40OTc0OSA4LjUgOS40OTc0OVoiIGZpbGw9IiM0MUQzQkQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "uDCq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            to: "",
            name: "",
            msg: "",
            submited: false
        };
    },

    methods: {
        submit: function submit() {
            var _this = this;

            this.submited = true;

            if (!this.isNullOrEmpty(this.to) && !this.isNullOrEmpty(this.msg) && !this.isNullOrEmpty(this.name)) {
                __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].inviteFriend(this.to, this.msg, this.name).then(function (result) {
                    if (result.status == 200) {
                        _this.$emit("finished");
                    } else {
                        _this.$emit("finished");
                    }
                }).catch(function () {});
            }
        },
        isNullOrEmpty: function isNullOrEmpty(value) {
            if (value == null || value == '') return true;

            return false;
        }
    }
});

/***/ }),

/***/ "uH2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedComunication: this.selectedComunication,
      comunications: ['Facebook', 'Instagram', 'Google', 'Twitter', 'Rádio', 'Tv', 'Indicação', 'Outros'],
      other: ''
    };
  },

  methods: {
    submit: function submit() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.selectedComunication) != undefined || this.selectedComunication == 'Outros' && this.other != '') {
        var newData = {
          selectedComunication: this.selectedComunication,
          other: this.other
        };
        this.$emit('submit', newData);
      }
    }
  },
  mounted: function mounted() {
    this.$refs.comunicationSelect.$el.children[0].children[2].required = true;
  }
});

/***/ }),

/***/ "uIh4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformationSuitability_vue__ = __webpack_require__("Bfri");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21cb266c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformationSuitability_vue__ = __webpack_require__("Vt9/");
function injectStyle (ssrContext) {
  __webpack_require__("1IUG")
  __webpack_require__("eOrP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21cb266c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformationSuitability_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21cb266c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformationSuitability_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uK8N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListImpact_vue__ = __webpack_require__("7XGb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af1a0e26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListImpact_vue__ = __webpack_require__("ouWo");
function injectStyle (ssrContext) {
  __webpack_require__("Jt5P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af1a0e26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListImpact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af1a0e26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListImpact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uLM3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    partner: { required: true, type: Object }
  },
  data: function data() {
    return {
      optionsEscolaridade: [{ value: 1, label: "Ensino Fundamental Incompleto" }, { value: 2, label: "Ensino Fundamental Completo" }, { value: 3, label: "Ensino Médio Incompleto" }, { value: 4, label: "Ensino Médio Completo" }, { value: 5, label: "Ensino Superior Incompleto" }, { value: 6, label: "Ensino Superior Completo" }, { value: 7, label: "Pós-Graduação" }],
      optionsMarital: [{ value: 1, label: "Solteiro (a)" }, { value: 2, label: "Casado (a)" }, { value: 3, label: "Divorciado (a)" }, { value: 4, label: "Viúvo (a)" }, { value: 5, label: "União Estável" }]
    };
  }
});

/***/ }),

/***/ "uLuI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"margin"},[_c('div',{staticClass:"form-check d-flex justify-content-center"},[_c('div',{staticClass:"checkboxContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.naoPossuiBalancoEDre),expression:"naoPossuiBalancoEDre"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.naoPossuiBalancoEDre)?_vm._i(_vm.naoPossuiBalancoEDre,null)>-1:(_vm.naoPossuiBalancoEDre)},on:{"change":function($event){var $$a=_vm.naoPossuiBalancoEDre,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.naoPossuiBalancoEDre=$$a.concat([$$v]))}else{$$i>-1&&(_vm.naoPossuiBalancoEDre=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.naoPossuiBalancoEDre=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exCheck01"}},[_vm._v("Não possuo o balanço e DRE da minha empresa")])])]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('p',[_vm._v("Balanço e DRE do último exercício assinado pelo contador")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uMvy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types_js__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lpUrl: "https://iouu.com.br"
    };
  },

  methods: {
    Logout: function Logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    Home: function Home() {
      sessionStorage.removeItem("redirectINV");
      this.$router.push('/emprestimos/meus-emprestimos');
    }
  }, beforeCreate: function beforeCreate() {

    window.document.title = 'Dashboard IOUU';
  }
});

/***/ }),

/***/ "uQ9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaritalStatusStep_vue__ = __webpack_require__("0R8B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f7e713_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaritalStatusStep_vue__ = __webpack_require__("F46k");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaritalStatusStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f7e713_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaritalStatusStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uQpZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lottie_vue__ = __webpack_require__("2ghZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd502da6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lottie_vue__ = __webpack_require__("PGe6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lottie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd502da6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lottie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uRog":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdca17fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleLoader_vue__ = __webpack_require__("rTd3");
function injectStyle (ssrContext) {
  __webpack_require__("zFu2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cdca17fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdca17fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uUwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SocialNetworkDashboard__ = __webpack_require__("eye1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SideMenu__ = __webpack_require__("a1CX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Invite_Friend__ = __webpack_require__("XZRT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Invite_Company__ = __webpack_require__("VCVs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Alerts__ = __webpack_require__("MGb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__package_json__ = __webpack_require__("7YgM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__package_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */










/* harmony default export */ __webpack_exports__["a"] = ({
	metaInfo: {
		htmlAttrs: {
			lang: 'pt-br'
		},
		bodyAttrs: {
			class: 'bg-light'
		}
	},

	data: function data() {
		return {
			version: __WEBPACK_IMPORTED_MODULE_8__package_json___default.a.version,
			menuItems: [{ iconClass: "ico-din-3", title: "Quero empréstimo", path: "/emprestimos/meus-emprestimos", title2: "Quero empréstimo", modal: true }, { iconClass: "ico-gra-4", title: "Meus investimentos", path: "/investimentos/meus-investimentos" }, { iconClass: "ico-ps", title: "Oportunidades", path: "/investimentos/oportunidades" }, { iconClass: "ico-imp", title: "Investimentos sociais", path: "/investimentos/investimento-de-impacto" }, { iconClass: "ico-lib", title: "Meu histórico", path: "/investimentos/historico" }, { iconClass: "ico-ct-4", title: "Carteira virtual", path: "/investimentos/carteira-investimento" },
			// {iconClass: "ico-ct-2", title: "Portfólios", path: "/investimentos/portfolios"},
			// {iconClass: "ico-gra-3", title: "Estatísticas", path: "/investimentos/estatisticas"},
			// {iconClass: "ico-ct-4", title: "Central de cobranças", path: "/investimentos/central-de-cobranca" },
			{ iconClass: "ico-ch", title: "Perguntas e respostas", url: "http://ajuda.iouu.com.br" }],
			InvestorAprovado: false,
			TemInvestimento: false,
			showModal: false,
			modalStep: 1,
			auxModalStep: 1,
			from: "ENV"
		};
	},


	components: {
		SideMenu: __WEBPACK_IMPORTED_MODULE_1__components_SideMenu__["a" /* default */],
		SocialNetwork: __WEBPACK_IMPORTED_MODULE_0__components_SocialNetworkDashboard__["a" /* default */],
		Modal: __WEBPACK_IMPORTED_MODULE_4__components_Modal__["a" /* default */],
		Friend: __WEBPACK_IMPORTED_MODULE_5__components_Invite_Friend__["a" /* default */],
		Company: __WEBPACK_IMPORTED_MODULE_6__components_Invite_Company__["a" /* default */],
		Alerts: __WEBPACK_IMPORTED_MODULE_7__components_Alerts__["a" /* default */]
	},

	methods: {
		Investidor: function Investidor() {
			window.variavel = this;
			if (this.User.hasinvestor == undefined) return false;
			return this.User.hasinvestor;
		},
		Suitability: function Suitability() {
			if (this.User.hassuitability == undefined) return false;
			return this.User.hassuitability;
		},
		Logout: function Logout() {
			this.$store.dispatch('logout');
			this.$router.push('/login');
		},
		Nome: function Nome() {
			var nome = "",
			    letra = "";
			if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
				nome = this.User.username;
			} else {
				nome = this.User.name;
			}
			nome = nome.trim();
			var primeiroNome = nome.split(" ")[0];
			return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
		},
		LetraNome: function LetraNome() {
			var nome = this.Nome();
			if (nome != null && nome != undefined && nome.length > 0) return nome[0].toUpperCase();
			return "";
		},
		InvestidorComInvestimento: function InvestidorComInvestimento() {
			return this.User.hasinvestments;
		},


		// METHOD TO SHOW MOBILE MENU
		ShowMobMenu: function ShowMobMenu(status) {
			var menu = document.getElementsByClassName('collapsed-menu');
			if (status == true && menu.length >= 1) {
				menu[0].classList.add("show");
			}
		},
		finishInvite: function finishInvite() {
			this.modalStep = 3;
		},
		activeButton: function activeButton(name) {
			var buttonName = name;

			if (buttonName === "person") {
				document.getElementsByClassName('invited-person')[0].classList.add('active');
				document.getElementsByClassName('invited-company')[0].classList.remove('active');
			} else {
				document.getElementsByClassName('invited-person')[0].classList.remove('active');
				document.getElementsByClassName('invited-company')[0].classList.add('active');
			}
		}
	},

	computed: {
		User: function User() {
			return this.$store.state.currentUser;
		},

		created: function created() {
			var _this = this;

			this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["c" /* START_LOADING */]);
			__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getInvestor().then(function (investor) {
				console.log(investor);
				_this.InvestorAprovado = investor.Status == "APROVADO";
				_this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
			}).catch(function () {
				return _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
			});
		}
	},

	created: function created() {
		var _this2 = this;

		this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["c" /* START_LOADING */]);

		if (sessionStorage.getItem("redirectINV") == null) {
			sessionStorage.setItem("redirectINV", "true");

			if (this.User.tipo != null && this.User.tipo.length > 0 && this.User.tipo[0] == "TOM") {
				this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
				window.location.href = "/#/emprestimos/meus-emprestimos";
				return;
			} else {
				this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
				window.location.href = "/#/investimentos/meus-investimentos";
				return;
				// this.$store.commit(mutationTypes.START_LOADING)
				// ApiClient.getInvestor()
				//   .then(investor => {
				//     this.InvestorAprovado = investor.Status == "APROVADO";
				//   })
				//   .finally(() => this.$store.commit(mutationTypes.STOP_LOADING))
			}
		} else {

			__WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getInvestor().then(function (investor) {
				_this2.InvestorAprovado = investor.Status == "APROVADO";
			}).finally(function () {
				return _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
			});
		}
	}, beforeCreate: function beforeCreate() {

		window.document.title = 'Dashboard IOUU';
	}
});

/***/ }),

/***/ "uZqD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EstadoCivilStep_vue__ = __webpack_require__("ybHO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_297e0704_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EstadoCivilStep_vue__ = __webpack_require__("OFhL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EstadoCivilStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_297e0704_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EstadoCivilStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uaHA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    partner: { required: true, type: Object }
  },
  data: function data() {
    return {
      optionsEscolaridade: [{ value: 1, label: "Ensino Fundamental Incompleto" }, { value: 2, label: "Ensino Fundamental Completo" }, { value: 3, label: "Ensino Médio Incompleto" }, { value: 4, label: "Ensino Médio Completo" }, { value: 5, label: "Ensino Superior Incompleto" }, { value: 6, label: "Ensino Superior Completo" }, { value: 7, label: "Pós-Graduação" }],
      optionsMarital: [{ value: 1, label: "Solteiro (a)" }, { value: 2, label: "Casado (a)" }, { value: 3, label: "Divorciado (a)" }, { value: 4, label: "Viúvo (a)" }, { value: 5, label: "União Estável" }]
    };
  }
});

/***/ }),

/***/ "ucxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CompanyProfile_InvestmentReservationData__ = __webpack_require__("kkQk");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { InvestmentReservationData: __WEBPACK_IMPORTED_MODULE_1__components_CompanyProfile_InvestmentReservationData__["a" /* default */] },
  props: {
    loanRequest: { required: true },
    investmentConfirmed: { required: true, type: Boolean }
  },
  data: function data() {
    return {
      antecipacaoGambiarra: false,
      taxaGambiarra: 5.26,
      CDIGambiarra: 641.46
    };
  },

  computed: {
    fimCaptacao: function fimCaptacao() {
      return this.loanRequest.FimCaptacao.toLocaleDateString('pt-BR');
    },
    valorSolicitacao: function valorSolicitacao() {
      return this.formatCurrency(this.loanRequest.Valor);
    },
    taxaInternaRetorno: function taxaInternaRetorno() {
      return this.loanRequest.TaxaInternaRetorno;
    },
    taxaTotalEfetiva: function taxaTotalEfetiva() {
      return this.loanRequest.TaxaTotalEfetiva;
    },
    retornoBrutoAnual: function retornoBrutoAnual() {
      return this.loanRequest.RetornoBrutoAnual;
    },
    retornoBrutoMensal: function retornoBrutoMensal() {
      return this.loanRequest.RetornoBrutoMensal;
    },
    cdi: function cdi() {
      return this.loanRequest.Cdi;
    },
    score: function score() {
      return this.loanRequest.Score;
    },
    prazo: function prazo() {
      return this.loanRequest.Prazo;
    },
    inicioCaptacao: function inicioCaptacao() {
      return this.loanRequest.InicioCaptacao.toLocaleDateString('pt-BR');
    },
    daysToFinish: function daysToFinish() {
      var miliSecs = this.loanRequest.FimCaptacao.getTime() + 86400000 - new Date().getTime();
      if (miliSecs > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(miliSecs / 1000 / 60 / 60 / 24);
      } else {
        return 0;
      }
    },
    reachedValuePercentageINT: function reachedValuePercentageINT() {
      var val = this.loanRequest.ValorCaptado * 100 / this.loanRequest.Valor;
      val = val < 100 ? val : 100;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(val);
    },
    reachedValuePercentage: function reachedValuePercentage() {
      var val = this.loanRequest.ValorCaptado * 100 / this.loanRequest.Valor;
      val = val < 100.00 ? val : 100.00;

      return this.formatCurrency(val);
    },
    missingValue: function missingValue() {
      var val = this.loanRequest.Valor - this.loanRequest.ValorCaptado;
      val = val > 0 ? val : 0;

      return this.formatCurrency(val);
    },
    countInvestmentReservations: function countInvestmentReservations() {
      return this.loanRequest.QuantidadeReservasInvestimento;
    }
  },
  methods: {
    formatCurrency: function formatCurrency(value) {
      return value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
    },
    formatInt: function formatInt(value) {
      return value.toLocaleString('pt-BR', { minimumFractionDigits: "0", maximumFractionDigits: 0 });
    },
    Cancelar: function Cancelar() {
      this.$refs.investData.Cancelado();
    },
    verificaProduto: function verificaProduto(produto) {

      if (produto != "EMPRES") {
        return true;
      }

      return false;
    }
  },
  created: function created() {
    if (this.loanRequest._id === "5e9de72f796877415093cb1d" || this.loanRequest._id === "5ea348604e46501f80f6641f") this.antecipacaoGambiarra = true;
  }
});

/***/ }),

/***/ "ugvs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "uimQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uvE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"estado"}},[_vm._v("Estado")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","placeholder":"Estado"},on:{"on-change":_vm.onUfChange},model:{value:(_vm.uf),callback:function ($$v) {_vm.uf=$$v},expression:"uf"}},_vm._l((_vm.estados),function(state,i){return _c('at-option',{key:("stateOptions" + i),attrs:{"value":state.uf}},[_vm._v(_vm._s(state.nome))])}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"cidade"}},[_vm._v("Cidade")]),_vm._v(" "),_c('at-select',{ref:"citySelect",attrs:{"filterable":"","size":"large","disabled":_vm.estaCidadeDesabilitado,"placeholder":"Cidade"},model:{value:(_vm.currentUser.Pessoal.CidadeOrigem),callback:function ($$v) {_vm.$set(_vm.currentUser.Pessoal, "CidadeOrigem", $$v)},expression:"currentUser.Pessoal.CidadeOrigem"}},_vm._l((_vm.cidades),function(city,i){return _c('at-option',{key:("cityOptions" + i),attrs:{"value":city.nome}},[_vm._v(_vm._s(city.nome))])}),1)],1),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Cidade/UF de Nascimento")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uw+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      cpf: this.solicitacao.Solicitante.Cpf,
      ticketId: null,
      perguntas: [],
      perguntaAtual: 0,
      respostas: []
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  computed: {
    showQuestions: function showQuestions() {
      return this.respostas.length < this.perguntas.length;
    }
  },
  created: function created() {
    var _this = this;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["c" /* START_LOADING */]);
    __WEBPACK_IMPORTED_MODULE_0__utils_hub_consulta_client__["a" /* default */].pegarPerguntas(this.cpf).then(function (data) {
      _this.ticketId = data.DadosConsulta.TicketId;
      _this.perguntas = data.DadosConsulta.Questions;
      _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["d" /* STOP_LOADING */]);
    }).catch(function (error) {
      _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["d" /* STOP_LOADING */]);
      _this.$emit('on-submit', {
        ErroAoConfirmarIdentidade: error.message
      });
    });
  },
  updated: function updated() {
    if (this.respostas.length == this.perguntas.length) {
      this.$emit('on-submit', {
        TicketId: this.ticketId,
        Parameters: this.respostas
      });
    }
  }
});

/***/ }),

/***/ "uxLS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uxOT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v9SY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal__ = __webpack_require__("/o5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_client_go__ = __webpack_require__("879M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NoDataProfile__ = __webpack_require__("xalN");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_3__components_Modal__["a" /* default */],
        NoDataProfile: __WEBPACK_IMPORTED_MODULE_6__components_NoDataProfile__["a" /* default */]
    },
    ready: function ready() {
        this.legendMarkup = this._chart.generateLegend();
    },
    data: function data() {
        return {
            valor: true,
            User: null,
            Estatisticas: "Loading",
            Renderizou: true,
            GraficoInvestimentos: true,
            Criou: false,
            Solicitacoes: [],
            VisualizarTodos: false,
            ShowModalRendimento: false,
            ShowModalInvestimento: false,
            showMeMsg: 3,

            TIR: 0,
            CDI: 0,

            Scores: null,
            TipoInvestimento: null,
            Rendimento: null,

            Atrasados: null,
            ProximoMes: null,
            EsteMes: null,
            Carencia: null,

            HistoricoReservas: null,
            AuxHistoricoReservas: null,

            ValorExpirados: 0
        };
    },

    computed: {
        AtrasosExpirados: function AtrasosExpirados() {
            return;
        }
    },
    methods: {
        money: function money(n) {
            var c = 2,
                d = ",",
                t = ".",
                s = n < 0 ? "-" : "",
                i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        },
        porcentagemCdi: function porcentagemCdi(n) {
            var c = 0,
                d = ",",
                t = ".",
                s = n < 0 ? "-" : "",
                i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        },
        ajustIdOportunidade: function ajustIdOportunidade(id, qtd) {
            var s = String(id);

            if (id == undefined || id == 0) return "";

            while (s.length < (qtd || 2)) {
                s = "0" + s;
            }
            return "#" + s;
        },
        formatDate: function formatDate(date) {
            var dateaux = date.split("T");
            var dateArray = dateaux[0].split('-');
            var day = dateArray[2];
            var month = dateArray[1];
            var year = dateArray[0];

            return day + "/" + month + "/" + year;
        },
        lowerCase: function lowerCase(texto) {
            if (texto == null || texto == undefined || texto == "") return "-";

            if (texto == "AA" || texto == "HR") return "dot rating-" + texto.toLowerCase();

            if (texto == "Social") return "dot socialrating";

            return "dot rating-" + texto[0].toLowerCase();
        },
        ajustaScore: function ajustaScore(score) {
            if (score == null || score == undefined || score == "") return "-";

            if (score == "AA" || score == "HR") return score;

            if (score == "Social") return "SO";

            return score[0];
        },
        PorcentagemRendimento: function PorcentagemRendimento(Investido, Rendimento) {
            Rendimento = Investido * (1 + Rendimento / 100);
            var porcentagem = Rendimento * 100 / Investido;
            return "width:" + Math.round(porcentagem) + "%";
        },
        MostraInvestimentos: function MostraInvestimentos() {
            if (!this.VisualizarTodos) {
                this.HistoricoReservas = this.AuxHistoricoReservas;
                this.VisualizarTodos = true;
            }
            return;
        },

        CriaGrafico: function CriaGrafico() {
            // Bar chart Investimentos por Score
            new Chart(document.getElementById("GraficoInvestimentosScores"), {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [{
                        label: "AA",
                        backgroundColor: ["#C1CF2E"],
                        data: [this.Scores.AA.Valor.toFixed(2)]
                    }, {
                        label: "A",
                        backgroundColor: ["#2DC2BF"],
                        data: [this.Scores.A.Valor.toFixed(2)]
                    }, {
                        label: "B",
                        backgroundColor: ["#6FC30D"],
                        data: [this.Scores.B.Valor.toFixed(2)]
                    }, {
                        label: "C",
                        backgroundColor: ["#F04887"],
                        data: [this.Scores.C.Valor.toFixed(2)]
                    }, {
                        label: "D",
                        backgroundColor: ["#FFB928"],
                        data: [this.Scores.D.Valor.toFixed(2)]
                    }, {
                        label: "E",
                        backgroundColor: ["#FD615D"],
                        data: [this.Scores.E.Valor.toFixed(2)]
                    }, {
                        label: "HR",
                        backgroundColor: ["#B61843"],
                        data: [this.Scores.HR.Valor.toFixed(2)]
                    }, {
                        label: "Social",
                        backgroundColor: ["#52B3D9"],
                        data: [this.TipoInvestimento.Social.Valor.toFixed(2)]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function label(tooltipItems, data) {
                                return data.datasets[tooltipItems.datasetIndex].label + ' - R$ ' + tooltipItems.yLabel.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
                            }
                        }
                    },
                    legend: {
                        display: true,
                        position: "bottom"
                    },
                    title: {
                        display: false,
                        text: 'Investimentos por score'
                    },
                    responsive: true,
                    scales: {
                        xAxes: [{
                            gridLines: {
                                display: false
                            }
                        }],
                        yAxes: [{
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                beginAtZero: true,
                                callback: function callback(label, index, labels) {
                                    if (label == '0') {
                                        return '0';
                                    }
                                    return 'R$ ' + label.toLocaleString('pt-BR', { minimumFractionDigits: "0", maximumFractionDigits: 2 });
                                }
                            }
                        }]
                    }
                }
            });

            // Bar chart Investimentos 
            new Chart(document.getElementById("GraficoInvestimentos"), {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [{
                        label: "Atual",
                        backgroundColor: ["#FF8600"],
                        data: [this.Rendimento.AReceber.Valor.toFixed(2)]
                    }, {
                        label: "Período de carência",
                        backgroundColor: ["#FF441D"],
                        data: [this.Carencia.Valor.toFixed(2)]
                    }, {
                        label: "1-15 dias de atraso",
                        backgroundColor: ["#DC0033"],
                        data: [this.Atrasados.Reservas.Atrasados1.Valor.toFixed(2)]
                    }, {
                        label: "16-30 dias de atraso",
                        backgroundColor: ["#A1003D"],
                        data: [this.Atrasados.Reservas.Atrasados2.Valor.toFixed(2)]
                    }, {
                        label: "31-60 dias de atraso",
                        backgroundColor: ["#5A0C4C"],
                        data: [this.Atrasados.Reservas.Atrasados3.Valor.toFixed(2)]
                    }, {
                        label: "+60 dias de atraso",
                        backgroundColor: ["#3B3A6D"],
                        data: [this.Atrasados.Reservas.Expirado.Valor.toFixed(2)]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function label(tooltipItems, data) {
                                return data.datasets[tooltipItems.datasetIndex].label + ' - R$ ' + tooltipItems.yLabel.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
                            }
                        }
                    },
                    legend: {
                        display: true,
                        position: "bottom",
                        labels: {
                            padding: 25
                        }
                    },
                    title: {
                        display: false,
                        text: 'Investimentos'
                    },
                    responsive: true,
                    scales: {
                        xAxes: [{
                            gridLines: {
                                display: false
                            }
                        }],
                        yAxes: [{
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                beginAtZero: true,
                                callback: function callback(label, index, labels) {
                                    return label == '0' ? '0' : 'R$ ' + label.toLocaleString('pt-BR', { minimumFractionDigits: "0", maximumFractionDigits: 2 });
                                }
                            }
                        }]
                    }
                }
            });

            // Bar chart Rendimento geral da carteira
            new Chart(document.getElementById("GraficoRendimentoGeral"), {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [{
                        label: "Valor total investido",
                        backgroundColor: ["#434272"],
                        data: [this.Rendimento.Investido.Valor.toFixed(2)]
                    }, {
                        label: "Rendimentos a receber",
                        backgroundColor: ["#36D4BD"],
                        data: [(this.Rendimento.AReceber.Valor - this.Atrasados.Valor).toFixed(2)]
                    }, {
                        label: "Rendimento recebido",
                        backgroundColor: ["#68C700"],
                        data: [this.Rendimento.Recebido.Valor.toFixed(2)]
                    }, {
                        label: "Rendimento em atraso",
                        backgroundColor: ["#FF453A"],
                        data: [this.Atrasados.Valor.toFixed(2)]
                    }, {
                        label: "Multa/Mora",
                        backgroundColor: ["#FFBB00"],
                        data: [this.Rendimento.Multa.Valor.toFixed(2)]
                    }]
                },
                options: {
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function label(tooltipItems, data) {

                                return data.datasets[tooltipItems.datasetIndex].label + ' - R$ ' + tooltipItems.yLabel.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
                            }
                        }
                    },
                    legend: {
                        display: true,
                        position: "bottom",
                        fontSize: "16px"
                    },
                    title: {
                        display: false,
                        text: 'Investimentos por score'
                    },
                    responsive: false,
                    scales: {
                        xAxes: [{
                            categoryPercentage: 1.0,
                            barPercentage: 0.3,
                            gridLines: {
                                display: false
                            }
                        }],
                        yAxes: [{
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                beginAtZero: true,
                                callback: function callback(label, index, labels) {
                                    if (label == '0') {
                                        return '0';
                                    }
                                    return 'R$ ' + label.toLocaleString('pt-BR', { minimumFractionDigits: "0", maximumFractionDigits: 2 });
                                }
                            }
                        }]
                    }
                }
            });

            //Doughnut chart Rendimento Geral da Carteira
            // new Chart(document.getElementById("GraficoRendimentoGeral"), {
            //     type: 'doughnut',
            //     data: {
            //         labels:["Valor Total Investido", "Rendimento Recebido", "Rendimento em Atraso","Rendimento a Receber","Multas e Atrasos"],
            //         datasets:[
            //             {
            //                 label:["Teste"],
            //                 backgroundColor: ["#434371", "#6FC30D", "#FF4949","#41D3BD", "#FFB928"],
            //                 data: [this.Estatisticas.TotalInvestido, this.Estatisticas.TotalRendimentoRecebido, this.Estatisticas.TotalRendimentoAtrasado, this.Estatisticas.TotalRendimento, this.Estatisticas.TotalRendimentoMulta],
            //                 borderWidth: [0, 0, 0, 0, 0]
            //             }
            //         ]
            //     },
            //     options: {
            //        tooltips: {
            //             enabled: true,
            //             mode: 'single',
            //             callbacks: {
            //                 label: function(tooltipItems,data) {
            //                     return data.labels[tooltipItems.index] + ' - ' + data.datasets[0].data[tooltipItems.index].toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2,  style: 'currency', currency: 'BRL'}) ;
            //                 }
            //             }
            //         },
            //         responsive: true,
            //         legend:{
            //             position: "bottom",
            //             labels:{
            //                 padding: 30
            //             }
            //         },
            //         cutoutPercentage: 55
            //     }
            // });

            //Bar chart Rendimento por Tipo de Investimento 
            // new Chart(document.getElementById("GraficoRendimentoTipo"), {
            //     type: 'bar',
            //     data: {
            //         labels: ["Empréstimo Coletivo", "Empréstimo de Impacto", "Empréstimo Social", "Empréstimo Antecipado"],
            //         datasets: [
            //             {
            //                 label: "Investimento Amortizado",
            //                 backgroundColor: ["#6FC30D","#6FC30D","#6FC30D"],
            //                 stack: 'Stack 0',
            //                 data: [(this.Rendimento.TotalInvestimentos.Valor - this.Rendimento.Investido.Valor),this.Rendimento.Recebido.Valor]
            //             },
            //             {
            //                 label: "Investimento Atrasado",
            //                 backgroundColor: ["#FF4949","#FF4949","#FF4949"],
            //                 stack: 'Stack 0',
            //                 data: [(this.Rendimento.TotalInvestimentos.Valor - this.Rendimento.Investido.Valor),this.Rendimento.Recebido.Valor]
            //             },
            //             {
            //                 label: "Investimento a Receber",
            //                 backgroundColor: ["#434371","#434371","#434371"],
            //                 stack: 'Stack 0',
            //                 data: [(this.Rendimento.TotalInvestimentos.Valor - this.Rendimento.Investido.Valor),this.Rendimento.Recebido.Valor]
            //             },
            //             {
            //                 label: "Rendimento",
            //                 backgroundColor: ["#41D3BD","#41D3BD","#41D3BD"],
            //                 stack: 'Stack 1',
            //                 data: [(this.Rendimento.TotalInvestimentos.Valor - this.Rendimento.Investido.Valor),this.Rendimento.Recebido.Valor]
            //             }
            //         ]
            //     },
            //     options: {
            //         tooltips: {
            //             enabled: true,
            //             mode: 'single',
            //             callbacks: {
            //                 label: function(tooltipItems,data) {

            //                     return data.datasets[tooltipItems.datasetIndex].label + ' - R$ ' + tooltipItems.yLabel.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) ;
            //                 }
            //             }
            // 		},
            //         responsive: true,
            //         legend: {
            //             display: true,
            //             position: "bottom",
            //             labels: {
            //                 padding: 30
            //             }
            //         },
            //         scales: {
            //             xAxes: [{
            //                 gridLines: {
            //                     display: false
            //                 },
            //                 stacked: true
            //             }],
            //             yAxes: [{
            //                 gridLines: {
            //                     display: true,
            //                     color: 'rgba(0, 0, 0, 0.1)'
            //                 },
            //                 ticks: {
            //                     beginAtZero: true,
            //                     callback: function(label, index, labels) {
            //                             if(label == '0') {
            //                                 return '0'
            //                             }
            //                             return 'R$ ' + label.toLocaleString('pt-BR', {minimumFractionDigits: "0", maximumFractionDigits: 2}) 
            //                         }
            //                 },
            //                 stacked: true
            //             }]
            //         }
            //     }
            // });
        },
        Status: function Status(status) {
            if (status == "Carencia" || status == "ProximoMes") {
                return "label bg-success text-white";
            } else {
                return "label bg-danger text-white";
            }
        },
        TextoStatus: function TextoStatus(status) {
            if (status == "ProximoMes") return "Pagamento em dia";
            if (status == "Carencia") return "Em Carencia";
            if (status == "expirado") return "+61 dias de atraso";
            if (status <= 15) return "1 - 15 dias de atraso";
            if (status <= 30) return "16 - 30 dias de atraso";
            if (status <= 60) return "30 - 60 dias de atraso";
            return "Finalizado";
        },
        NomeEmpresa: function NomeEmpresa(nomeEmpresa) {

            return nomeEmpresa;
        },
        linkReserva: function linkReserva(id) {
            window.location.href = '/#/investimentos/historico/historico-de-investimento/' + id;
        },
        showMeInfo: function showMeInfo() {
            // Verifica se o investidor tem acesso as estatísticas
            // Verifica cadastro completo 
            if (this.User.hasinvestor && this.User.hassuitability && this.User.investor.Status == "APROVADO") {
                this.showMeMsg = 1;
                return true;
            } else {
                if (this.User.hasinvestor && this.User.hassuitability) {
                    this.showMeMsg = 2;
                } else {
                    this.showMeMsg = 3;
                }
                return false;
            }
        },
        formataRegistrosVazios: function formataRegistrosVazios(Registro) {
            if (Registro.Numero == 0) {
                Registro.Valor = 0;
            }
            return Registro;
        },
        formatarAtrasos: function formatarAtrasos(Atrasados) {
            var Reservas = {
                Atrasados1: {
                    Valor: 0,
                    Numero: 0,
                    Reservas: []
                },
                Atrasados2: {
                    Valor: 0,
                    Numero: 0,
                    Reservas: []
                },
                Atrasados3: {
                    Valor: 0,
                    Numero: 0,
                    Reservas: []
                },
                Expirado: {
                    Valor: 0,
                    Numero: 0,
                    Reservas: []
                }
            };
            Atrasados.Reservas.forEach(function (reserva) {
                if (reserva.Status <= 15) {
                    Reservas.Atrasados1.Valor += reserva.ValorRetorno;
                    Reservas.Atrasados1.Numero++;
                    Reservas.Atrasados1.Reservas.push(reserva);
                } else if (reserva.Status <= 30) {
                    Reservas.Atrasados2.Valor += reserva.ValorRetorno;
                    Reservas.Atrasados2.Numero++;
                    Reservas.Atrasados2.Reservas.push(reserva);
                } else if (reserva.Status <= 60) {
                    Reservas.Atrasados3.Valor += reserva.ValorRetorno;
                    Reservas.Atrasados3.Numero++;
                    Reservas.Atrasados3.Reservas.push(reserva);
                } else {
                    Reservas.Expirado.Valor += reserva.ValorRetorno;
                    Reservas.Expirado.Numero++;
                    Reservas.Expirado.Reservas.push(reserva);
                }
            });
            Atrasados.Reservas = Reservas;
            return Atrasados;
        },

        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/estatisticas/',
                title: 'estatisticas home'
            });
        }
    },
    updated: function updated() {
        if (!this.Criou) {
            this.CriaGrafico();
            this.Criou = true;
        }
    },
    beforeCreate: function beforeCreate() {
        this.$store.dispatch('updateUser');
    },
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["c" /* START_LOADING */]);

                            if (_this.$store.state.currentUser.investor != null) {
                                if (typeof _this.$store.state.currentUser.investor.Bloqueio != 'undefined') window.location.href = "#/";
                            }
                            _this.User = _this.$store.state.currentUser;
                            __WEBPACK_IMPORTED_MODULE_4__utils_api_client_go__["a" /* default */].gerarEstatistica(_this.User.investor._id).then(function (resposta) {
                                if (typeof resposta.data.Rendimento == 'undefined') {
                                    _this.Estatisticas = 'Não Possui Investimentos';
                                } else {
                                    _this.TIR = resposta.data.MediaRendimento;
                                    _this.CDI = resposta.data.RendimentoCDI;

                                    _this.Scores = resposta.data.Scores;
                                    _this.TipoInvestimento = resposta.data.TipoInvestimento;
                                    _this.Rendimento = resposta.data.Rendimento;

                                    var Atrasados = _this.formataRegistrosVazios(resposta.data.Atrasados);

                                    _this.ProximoMes = _this.formataRegistrosVazios(resposta.data.ProximoMes);
                                    _this.EsteMes = _this.formataRegistrosVazios(resposta.data.EsteMes);
                                    _this.Carencia = _this.formataRegistrosVazios(resposta.data.Carencia);

                                    var Reservas = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.ProximoMes.Reservas));
                                    Reservas = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Reservas), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.EsteMes.Reservas));
                                    Reservas = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Reservas), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.Carencia.Reservas));
                                    Reservas = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Reservas), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Atrasados.Reservas));
                                    _this.AuxHistoricoReservas = Reservas;
                                    _this.HistoricoReservas = Reservas.slice(0, 5);
                                    _this.Atrasados = _this.formatarAtrasos(Atrasados);
                                    _this.ValorExpirados = _this.Atrasados.Valor + _this.Rendimento.AReceber.Valor - _this.Rendimento.TotalInvestimentos.Valor;
                                    _this.Estatisticas = 'Possui Investimentos';
                                }
                                _this.Renderizou = true;

                                _this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            });
                            //tagueamento GA
                            _context.next = 6;
                            return _this.taggingGA();

                        case 6:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ "vA1A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vKqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center entry"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',{attrs:{"id":"h1Titulo"}},[_c('strong',[_vm._v("Simulação:")]),_vm._v(_vm._s(_vm.loansName))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-8"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-6 pad"},[_c('div',{staticClass:"bg-box text-center"},[_c('div',{staticClass:"box box-iouu"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box__finance"},[_c('p',[_vm._v("Valor financiado")]),_vm._v(" "),_c('strong',{staticClass:"valorFinanciado"},[_vm._v("R$ "+_vm._s(_vm.valor))])]),_vm._v(" "),_c('div',{staticClass:"box__tax"},[_c('p',[_vm._v("Juros")]),_vm._v(" "),_c('span',[_c('span',[_c('strong',[_c('span',{attrs:{"id":"iouu_jaa"}},[_vm._v(_vm._s(_vm.jurosaaIouu)+"%")]),_vm._v(" "),_c('small',[_vm._v("a.a.")])])]),_vm._v(" "),_c('span',[_c('strong',[_c('span',{attrs:{"id":"iouu_jam"}},[_vm._v(_vm._s(_vm.jurosamIouu)+"%")]),_vm._v(" "),_c('small',[_vm._v("a.m.")])])])])]),_vm._v(" "),_c('div',{staticClass:"box__amount"},[_c('p',[_vm._v("Total")]),_vm._v(" "),_c('strong',{attrs:{"id":"iouu_t"}},[_vm._v("R$ "+_vm._s(_vm.totalIouu))])]),_vm._v(" "),_c('div',{staticClass:"box__payment"},[_c('div',[_c('span',{staticClass:"parc"},[_vm._v(_vm._s(_vm.numeroParcelas))]),_vm._v(" "),_c('span',{staticClass:"info"},[_vm._v("\n                                    Parcelas de\n                                    "),_c('strong',{attrs:{"id":"iouu_vp"}},[_vm._v("R$ "+_vm._s(_vm.parcelaIouu))])])])]),_vm._v(" "),_c('div',{staticClass:"box__taxs"},[_c('p',[_vm._v("Taxa efetiva")]),_vm._v(" "),_c('span',[_c('span',[_c('strong',[_c('span',{attrs:{"id":"iouu_cet_jaa"}},[_vm._v(_vm._s(_vm.jurosaacet)+"%")]),_vm._v(" "),_c('small',[_vm._v("a.a.")])])]),_vm._v(" "),_c('span',[_c('strong',[_c('span',{attrs:{"id":"iouu_cet_jam"}},[_vm._v(_vm._s(_vm.juroscetIouu)+"%")]),_vm._v(" "),_c('small',[_vm._v("a.m.")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 col-lg-3 pad"},[_c('div',{staticClass:"box box-compare text-center"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box__finance"},[_c('p',[_vm._v("Valor financiado")]),_vm._v(" "),_c('strong',{staticClass:"valorFinanciado"},[_vm._v("R$ "+_vm._s(_vm.valor))])]),_vm._v(" "),_c('div',{staticClass:"box__tax"},[_c('p',[_vm._v("Juros")]),_vm._v(" "),_c('span',[_c('span',[_c('strong',[_c('span',{attrs:{"id":"CS_jaa"}},[_vm._v(_vm._s(_vm.jurosaaCheque)+"%")]),_vm._v(" "),_c('small',[_vm._v("a.a.")])])]),_vm._v(" "),_c('span',[_c('strong',[_c('span',{attrs:{"id":"CS_jaa"}},[_vm._v(_vm._s(_vm.jurosamCheque)+"%")]),_vm._v(" "),_c('small',[_vm._v("a.m.")])])])])]),_vm._v(" "),_c('div',{staticClass:"box__amount"},[_c('p',[_vm._v("Total")]),_vm._v(" "),_c('strong',{attrs:{"id":"CS_t"}},[_vm._v("R$ "+_vm._s(_vm.totalCheque))])]),_vm._v(" "),_c('div',{staticClass:"box__payment"},[_c('div',[_c('span',{staticClass:"parc"},[_vm._v(_vm._s(_vm.numeroParcelas))]),_vm._v(" "),_c('span',{staticClass:"info"},[_vm._v("\n                                Parcelas de\n                                "),_c('strong',{attrs:{"id":"CS_vp"}},[_vm._v("R$ "+_vm._s(_vm.parcelaCheque))])])])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 col-lg-3 pad"},[_c('div',{staticClass:"box box-compare text-center"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"box__finance"},[_c('p',[_vm._v("Valor financiado")]),_vm._v(" "),_c('strong',{staticClass:"valorFinanciado"},[_vm._v("R$ "+_vm._s(_vm.valor))])]),_vm._v(" "),_c('div',{staticClass:"box__tax"},[_c('p',[_vm._v("Juros")]),_vm._v(" "),_c('span',[_c('span',[_c('strong',[_c('span',{attrs:{"id":"CC_jaa"}},[_vm._v(_vm._s(_vm.jurosaaCartao)+"%")]),_vm._v(" "),_c('small',[_vm._v("a.a.")])])]),_vm._v(" "),_c('span',[_c('strong',[_c('span',{attrs:{"id":"CC_jam"}},[_vm._v(_vm._s(_vm.jurosamCartao)+"%")]),_vm._v(" "),_c('small',[_vm._v("a.m.")])])])])]),_vm._v(" "),_c('div',{staticClass:"box__amount"},[_c('p',[_vm._v("Total")]),_vm._v(" "),_c('strong',{attrs:{"id":"CC_t"}},[_vm._v("R$ "+_vm._s(_vm.totalCartao))])]),_vm._v(" "),_c('div',{staticClass:"box__payment"},[_c('div',[_c('span',{staticClass:"parc"},[_vm._v(_vm._s(_vm.numeroParcelas))]),_vm._v(" "),_c('span',{staticClass:"info"},[_vm._v("\n                                Parcelas de\n                                "),_c('strong',{attrs:{"id":"CC_vp"}},[_vm._v("R$ "+_vm._s(_vm.parcelaCartao))])])])]),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center obs"},[_vm._m(5),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link",attrs:{"to":("/tipo-de-emprestimo/simulacao?type=" + (this.type))}},[_vm._v("Nova simulação")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-lg btn-primary",attrs:{"to":("/tipo-de-emprestimo/solicitar-emprestimo?type=" + (this.type))}},[_vm._v("Crie sua proposta")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box__head"},[_c('a',{staticClass:"link",attrs:{"href":"/","title":"IOUU"}},[_c('i',{staticClass:"ico-iouu"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box__head"},[_c('p',[_vm._v("Cheque especial")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box__taxs"},[_c('p',[_vm._v("Taxa efetiva")]),_vm._v(" "),_c('span',[_c('span',[_c('strong',[_c('span',{attrs:{"id":"CS_cet_jaa"}},[_vm._v("368,79%")]),_vm._v(" "),_c('small',[_vm._v("a.a.")])])]),_vm._v(" "),_c('span',[_c('strong',[_c('span',{attrs:{"id":"CS_cet_jam"}},[_vm._v("13,54%")]),_vm._v(" "),_c('small',[_vm._v("a.m.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box__head"},[_c('p',[_vm._v("Cartão de crédito")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box__taxs"},[_c('p',[_vm._v("Taxa efetiva")]),_vm._v(" "),_c('span',[_c('span',[_c('strong',[_c('span',{attrs:{"id":"CC_cet_jaa"}},[_vm._v("250,40%")]),_vm._v(" "),_c('small',[_vm._v("a.a.")])])]),_vm._v(" "),_c('span',[_c('strong',[_c('span',{attrs:{"id":"CC_cet_jam"}},[_vm._v("10,85%")]),_vm._v(" "),_c('small',[_vm._v("a.m.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n                    Valores sujeitos à análise de crédito. Para valores exatos crie uma proposta."),_c('br'),_vm._v("\n                    CET corresponde ao índice que engloba todos os encargos, tributos, taxas e despesas\n                ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vPU2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvestorLayout_vue__ = __webpack_require__("89ll");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af667ba0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvestorLayout_vue__ = __webpack_require__("VR55");
function injectStyle (ssrContext) {
  __webpack_require__("GYq5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af667ba0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvestorLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af667ba0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvestorLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vbUL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoansLayout_vue__ = __webpack_require__("EGk3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c2d0df7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoansLayout_vue__ = __webpack_require__("8sjP");
function injectStyle (ssrContext) {
  __webpack_require__("p1Om")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c2d0df7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoansLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c2d0df7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoansLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vbrb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('section',{staticClass:"no-space"},[_c('div',{staticClass:"tit"},[_c('h2',{staticClass:"float-left"},[_vm._v("\n                 "+_vm._s(_vm.Nome())+"\n             ")]),_vm._v(" "),(_vm.IsInvestidor())?_c('router-link',{staticClass:"btn btn-secondary",attrs:{"to":{path:'editar-perfil'}}},[_vm._v("Editar suas informações")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('p',[_vm._v("\n                 "+_vm._s(_vm.Email())+"\n             ")])],1)]),_vm._v(" "),(_vm.existesenha)?_c('section',[_c('h3',[_vm._v("\n             Senha\n         ")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-row align-items-center"},[_c('div',{staticClass:"form-group text-left col-12 col-lg-4 col-xl-3"},[_c('label',{staticClass:"float-left",attrs:{"for":"password"}},[_vm._v("\n                         Senha atual\n                     ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.senhaAtual),expression:"senhaAtual"}],attrs:{"type":"password","id":"senha","name":"senha"},domProps:{"value":(_vm.senhaAtual)},on:{"input":function($event){if($event.target.composing){ return; }_vm.senhaAtual=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left col-12 col-lg-4 col-xl-3"},[_c('label',{staticClass:"float-left",attrs:{"for":"password"}},[_vm._v("\n                         Nova senha\n                     ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.senhaNova),expression:"senhaNova"}],attrs:{"type":"password","id":"novaSenha","name":"novaSenha"},domProps:{"value":(_vm.senhaNova)},on:{"input":function($event){if($event.target.composing){ return; }_vm.senhaNova=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left col-12 col-lg-4 col-xl-3"},[_c('label',{staticClass:"float-left",attrs:{"for":"password"}},[_vm._v("\n                         Repetir senha\n                     ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmacaoSenhaNova),expression:"confirmacaoSenhaNova"}],attrs:{"type":"password","id":"confirmarSenha","name":"confirmarSenha"},domProps:{"value":(_vm.confirmacaoSenhaNova)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmacaoSenhaNova=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.alterarSenha()}}},[_vm._v("\n                         alterar senha\n                     ")])])])])]):_vm._e(),_vm._v(" "),(!_vm.existesenha)?_c('section',[_c('h3',[_vm._v("\n             Cadastrar Senha\n         ")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-row align-items-center"},[_c('div',{staticClass:"form-group text-left col-12 col-lg-4 col-xl-3"},[_c('label',{staticClass:"float-left",attrs:{"for":"password"}},[_vm._v("\n                        Senha\n                     ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.senhaNova),expression:"senhaNova"}],attrs:{"type":"password","id":"novaSenha","name":"novaSenha"},domProps:{"value":(_vm.senhaNova)},on:{"input":function($event){if($event.target.composing){ return; }_vm.senhaNova=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left col-12 col-lg-4 col-xl-3"},[_c('label',{staticClass:"float-left",attrs:{"for":"password"}},[_vm._v("\n                         Repetir senha\n                     ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmacaoSenhaNova),expression:"confirmacaoSenhaNova"}],attrs:{"type":"password","id":"confirmarSenha","name":"confirmarSenha"},domProps:{"value":(_vm.confirmacaoSenhaNova)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmacaoSenhaNova=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.cadastrarSenha()}}},[_vm._v("\n                         cadastrar senha\n                     ")])])])])]):_vm._e(),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"no-space",staticStyle:{"display":"none"}},[_c('h3',[_vm._v("\n             Documentos enviados por você\n         ")]),_vm._v(" "),_c('div',{staticClass:"row docs"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box-doc"},[_c('h5',[_vm._v("\n                         Dados pessoais \n                     ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('p',[_vm._v("\n                             Atualizado em 00.00.2018\n                         ")]),_vm._v(" "),_c('a',{attrs:{"href":""}},[_vm._v("\n                             Editar\n                         ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box-doc"},[_c('h5',[_vm._v("\n                         Perfil do investidor \n                     ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('p',[_vm._v("\n                             Atualizado em 00.00.2018\n                         ")]),_vm._v(" "),_c('a',{attrs:{"href":""}},[_vm._v("\n                             Editar\n                         ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"box-doc"},[_c('h5',[_vm._v("\n                         Formulario de suitability\n                     ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('p',[_vm._v("\n                             Atualizado em 00.00.2018\n                         ")]),_vm._v(" "),_c('a',{attrs:{"href":""}},[_vm._v("\n                             Editar\n                         ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vd++":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit page"},[_c('h1',[_vm._v("Comprovante de Endereço")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ve9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChartAnaliseHorizontal_vue__ = __webpack_require__("anOL");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChartAnaliseHorizontal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vh3o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CCBResponse_vue__ = __webpack_require__("MZu1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_575c63f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CCBResponse_vue__ = __webpack_require__("/jo7");
function injectStyle (ssrContext) {
  __webpack_require__("nkvo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-575c63f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CCBResponse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_575c63f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CCBResponse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vmUM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vnQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"action":"","method":"POST"},on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6 text-left"},[_c('label',{attrs:{"for":"nome"}},[_vm._v("\n            Nome\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control form-control-lg",class:{ error: this.name == '' && _vm.submited },attrs:{"type":"text","autofocus":"autofocus","required":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6 text-left"},[_c('label',{attrs:{"for":"email"}},[_vm._v("\n            email\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.to),expression:"to"}],staticClass:"form-control form-control-lg",class:{ error: this.to == '' && _vm.submited },attrs:{"type":"email","autofocus":"autofocus","required":""},domProps:{"value":(_vm.to)},on:{"input":function($event){if($event.target.composing){ return; }_vm.to=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 text-left"},[_c('label',{attrs:{"for":"mensagem"}},[_vm._v("\n            Mensagem\n        ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],staticClass:"form-control",class:{ error: this.msg == '' && _vm.submited },attrs:{"name":"mensagem","id":"mensagem","rows":"5","required":""},domProps:{"value":(_vm.msg)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("Enviar")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vp1w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BankDataForm__ = __webpack_require__("pVr/");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { BankDataForm: __WEBPACK_IMPORTED_MODULE_0__components_BankDataForm__["a" /* default */] },
  props: {
    investor: { type: Object, required: true }
  },
  computed: {
    bankData: function bankData() {
      var bankData = this.investor.DadosBancarios || {};
      return {
        bankCode: bankData.CodigoBanco,
        agency: bankData.Agencia,
        account: bankData.Conta,
        accountType: bankData.TipoConta
      };
    }
  },
  methods: {
    handleSubmit: function handleSubmit(formData) {
      this.$emit('submit', {
        DadosBancarios: {
          CodigoBanco: formData.bankCode,
          Agencia: formData.agency,
          Conta: formData.account,
          TipoConta: formData.accountType
        },
        NaoTemContaBancaria: formData.hasNoAccount
      });
    }
  }
});

/***/ }),

/***/ "vrbk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CriarContaLead_vue__ = __webpack_require__("xD49");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15e6280e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CriarContaLead_vue__ = __webpack_require__("h5MU");
function injectStyle (ssrContext) {
  __webpack_require__("0c8x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15e6280e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CriarContaLead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15e6280e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CriarContaLead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w2yp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RendaExtraStep_vue__ = __webpack_require__("1EOR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8f295e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RendaExtraStep_vue__ = __webpack_require__("tbCL");
function injectStyle (ssrContext) {
  __webpack_require__("QFX9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a8f295e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RendaExtraStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8f295e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RendaExtraStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w3wm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.suitability != null)?_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-10 col-xl-10 form-container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-10 col-xl-10"},[_c('div',{staticClass:"tit text-center"},[_c('img',{staticStyle:{"margin-bottom":"40px","width":"60px"},attrs:{"src":"/static/assets/images/ico-complete.svg","alt":"icone arquivo"}}),_vm._v(" "),_c('h1',[_c('span',[_vm._v("Seu perfil de investimento é:")]),_vm._v(" "+_vm._s(this.suitability.Tipo)+"\n                ")]),_vm._v(" "),_c('div',[_c('p',{staticClass:"nome"},[_vm._v("\n                         \n                    ")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.texto)}}),_vm._v(" "),_c('p',{staticClass:"obs"},[_vm._v("\n                        Juntos vamos reinventar o sistema bancário ultrapassado e garantir um melhor negócio para todos.\n                    ")]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":"/informacoes-adicionais/suitability","title":"Preencher novamente"}},[_vm._v("Preencher novamente")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":"/investimentos/meus-investimentos","title":"Oportunidades abertas"}},[_vm._v("Oportunidades abertas "),_c('img',{attrs:{"src":"/static/assets/images/angle-right.svg"}})])],1)])])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wBMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-8"},[_vm._m(0),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-12"},[_c('label',{attrs:{"for":"comunicationSelect"}},[_vm._v("Meio de comunicação *")]),_vm._v(" "),_c('at-select',{ref:"comunicationSelect",attrs:{"filterable":"","size":"large","placeholder":"Meio de comunicação","required":""},model:{value:(_vm.selectedComunication),callback:function ($$v) {_vm.selectedComunication=$$v},expression:"selectedComunication"}},_vm._l((_vm.comunications),function(comunication){return _c('at-option',{key:comunication,attrs:{"value":comunication}},[_vm._v(_vm._s(comunication))])}),1)],1)]),_vm._v(" "),(_vm.selectedComunication == 'Outros')?_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-12"},[_c('label',{attrs:{"for":"other"}},[_vm._v("Qual?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.other),expression:"other"}],staticClass:"form-control form-control-lg",attrs:{"id":"other","type":"text"},domProps:{"value":(_vm.other)},on:{"input":function($event){if($event.target.composing){ return; }_vm.other=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h2',[_vm._v("Como nos conheceu?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":"/static/assets/images/angle-right.svg"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wLMa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormNewLogin_vue__ = __webpack_require__("Bt+k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cd983f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormNewLogin_vue__ = __webpack_require__("Fzm+");
function injectStyle (ssrContext) {
  __webpack_require__("9OQo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cd983f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormNewLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cd983f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormNewLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wOxi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social mt-auto"},[_c('a',{staticClass:"fa-stack fa",attrs:{"href":"https://www.facebook.com/IouuBrasil/","target":"_blank","title":"Facebook"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-facebook-f fa-stack-1x"})]),_vm._v(" "),_c('a',{staticClass:"fa-stack fa",attrs:{"href":"https://twitter.com/iouubrasil","target":"_blank","title":"Twitter"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-twitter fa-stack-1x"})]),_vm._v(" "),_c('a',{staticClass:"fa-stack fa",attrs:{"href":"https://www.linkedin.com/company/iouu","target":"_blank","Title":"Linkedin"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-linkedin-in fa-stack-1x"})]),_vm._v(" "),_c('a',{staticClass:"fa-stack fa",attrs:{"href":"https://vimeo.com/iouubrasil","target":"_blank","title":"Instagram"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-instagram fa-stack-1x"})]),_vm._v(" "),_c('a',{staticClass:"fa-stack fa",attrs:{"href":"https://www.instagram.com/iouubrasil/","target":"_blank","title":"Vimeo"}},[_c('i',{staticClass:"fas fa-circle fa-stack-2x fa-inverse"}),_vm._v(" "),_c('i',{staticClass:"fab fa-vimeo-v fa-stack-1x"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wTS/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_hub_consulta_client_js__ = __webpack_require__("pk4i");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return { texto: "" };
    },

    props: {
        suitability: { required: true, type: Object }
    },
    methods: {},
    created: function created() {

        if (this.suitability.Tipo == "Conservador") {
            this.texto = "Verificamos que voc\xEA busca rendimentos modestos, o investidor conservador possui a seguranc\u0327a como refere\u0302ncia para as suas aplicac\u0327o\u0303es, assumindo os menores riscos possi\u0301veis. Em raza\u0303o da sua baixa tolera\u0302ncia ao risco, mante\u0301m em sua carteira percentual reduzido de produtos de renda varia\u0301vel, dando prefere\u0302ncia aos produtos de renda fixa.\n                        <br>Dessa forma, esteja ciente dos riscos e benef\xEDcios de investir atrav\xE9s do empr\xE9stimo coletivo (peer-to-peer lending).\n                        <br>Esperamos que este seja o come\xE7o de uma parceria de muito sucesso entre voc\xEA e a IOUU.";
        }
        if (this.suitability.Tipo == "Moderado") {
            this.texto = "Voc\xEA procura equilibrar rentabilidade com risco. \xC9 um investidor que prefere a seguran\xE7a da renda fixa, mas tamb\xE9m aplica parte de seus recursos em renda vari\xE1vel, visando retornos acima da m\xE9dia do mercado. Por isso, ficamos felizes em informar que voc\xEA j\xE1 pode come\xE7ar seus investimentos conosco. Esperamos que este seja o come\xE7o de uma parceria de muito sucesso entre voc\xEA e a IOUU.";
        }

        if (this.suitability.Tipo == "Arrojado") {
            this.texto = "Voc\xEA busca sempre alta rentabilidade, mesmo que corra riscos de perder parte do patrim\xF4nio. Assume posi\xE7\xF5es mais concentradas e especulativas como forma de alcan\xE7ar um maior retorno.\n                        <br/>Voc\xEA tem cie\u0302ncia dos riscos e benef\xEDcios de investir atr\xE1ves do empr\xE9stimo coletivo (peer-to-peer lending).\n                        <br/>Esperamos que este seja o come\xE7o de uma parceria de muito sucesso entre voc\xEA e a IOUU.";
        }

        if (this.suitability.Tipo == "Super Agressivo" || this.suitability.Tipo == "Agressivo") {
            this.texto = "Voc\xEA possui total conhecimento e amplo domi\u0301nio dos produtos de investimento. Voc\xEA busca retornos muito expressivos no curto prazo, suportando quaisquer riscos.\n                        <br/>Voc\xEA tem cie\u0302ncia dos riscos e benef\xEDcios de investir atr\xE1ves do empr\xE9stimo coletivo (peer-to-peer lending).\n                        <br/>Esperamos que este seja o come\xE7o de uma parceria de muito sucesso entre voc\xEA e a IOUU.";
        }
    }
});

/***/ }),

/***/ "wTSQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wVEN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



// import DateHelper from '@/utils/date-helper'

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            notificacoes: null,
            finishedLoading: false,
            hasNotify: false,
            statusGo: false
        };
    },

    methods: {
        filterNotifications: function filterNotifications(notifications) {
            var aux = [];
            var cont = 0;

            notifications.forEach(function (element) {
                if (element.Status !== 'Visualizado' && element.Status !== 'Deletado' && cont < 5) {
                    aux.push(element);
                    cont++;
                }

                if (cont > 5) {
                    return true;
                }
            });

            return aux;
        },
        formatUrl: function formatUrl(url) {
            var urlForm = void 0;

            if (url.indexOf("/") !== 0) {
                urlForm = url.replace(/^/gm, "/");
            } else {
                urlForm = url;
            }

            return urlForm;
        },
        verifyStatus: function verifyStatus(status) {
            var bgClass = void 0;
            switch (status) {
                case 'Publicado':
                    bgClass = 'bg-primary';
                    break;

                case 'Atencao':
                    bgClass = 'bg-warning';
                    break;

                case 'Atrasado':
                    bgClass = 'bg-danger';
                    break;

                case 'Visualizado':
                    bgClass = 'bg-success';
                    break;
            }

            return bgClass;
        },
        changeStatus: function changeStatus(id, url) {
            var _this = this;

            var status = "Visualizado";

            if (!this.statusGo) {
                __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].changeStatusNotification(id, status).then(function (response) {
                    if (response.status === 200) {
                        _this.Atualizar(url);
                    }
                });
            }
        },
        convertDate: function convertDate(date) {
            var today = new Date();
            var timeStampToday = Math.round(today.getTime() / 1000);
            var h = today.getHours();
            var m = today.getMinutes();
            var s = today.getSeconds();
            var arrayDate = __WEBPACK_IMPORTED_MODULE_2__utils_masker__["a" /* default */].maskIsoDate(date).split('/');
            var objDate = new Date(arrayDate[2], arrayDate[1] - 1, arrayDate[0], h, m, s);
            var timeStampDate = Math.round(objDate.getTime() / 1000);
            var hours = (timeStampToday - timeStampDate) / 3600;
            var days = parseInt(hours / 24);
            var msg = void 0;

            if (days <= 0) {
                msg = 'Enviado Hoje';
            } else if (days <= 4) {
                msg = 'Enviado h\xE1 ' + days + ' dias';
            } else {
                msg = 'Enviado em: ' + arrayDate[0] + '/' + arrayDate[1] + '/' + arrayDate[2];
            }

            return msg;
        },
        Atualizar: function Atualizar(url) {
            if (this.formatUrl(url) === this.$route.fullPath) {
                location.reload();
            } else {
                this.$router.push(this.formatUrl(url));
                this.finishedLoading = true;
            }
        }
    },
    props: ['from', 'tipoUsuario'],
    computed: {
        getFrom: function getFrom() {
            return this.from;
        }
    },
    watch: {
        $route: function $route(to, from) {
            var _this2 = this;

            this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["c" /* START_LOADING */]);

            // PROMISES FOR GET USER ID TO GET NOTIFICATIONS FROM USER
            __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getUser().then(function (user) {

                //verificar blacklist
                if (user.status == "BLACKLIST") {

                    var reloadPage = function reloadPage() {
                        _this2.$router.push('/login');
                    };

                    localStorage.clear();
                    _this2.$store.dispatch('logout');
                    reloadPage();
                    return;
                }

                __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getNotificationsUser(user._id).then(function (notifications) {
                    _this2.notificacoes = notifications;

                    if (notifications.length > 0) {
                        _this2.finishedLoading = true;
                    }

                    for (var i = 0; i < notifications.length; i++) {
                        if (notifications[i].Status !== 'Visualizado' && notifications[i].Status !== 'Deletado') {
                            _this2.hasNotify = true;
                            break;
                        } else {
                            _this2.hasNotify = false;
                        }
                    }

                    _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["d" /* STOP_LOADING */]);
                });
            }).catch(function () {
                _this2.finishedLoading = true;
                _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["d" /* STOP_LOADING */]);
            });
        }
    },
    beforeCreate: function beforeCreate() {
        var _this3 = this;

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["c" /* START_LOADING */]);

        // PROMISES FOR GET USER ID TO GET NOTIFICATIONS FROM USER
        __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getUser().then(function (user) {
            __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].getNotificationsUser(user._id).then(function (notifications) {
                _this3.notificacoes = notifications;

                if (notifications.length > 0) {
                    _this3.finishedLoading = true;
                }

                for (var i = 0; i < notifications.length; i++) {
                    if (notifications[i].Status !== 'Visualizado' && notifications[i].Status !== 'Deletado') {
                        _this3.hasNotify = true;
                        break;
                    } else {
                        _this3.hasNotify = false;
                    }
                }

                _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["d" /* STOP_LOADING */]);
            });
        }).catch(function () {
            _this3.finishedLoading = true;
            _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["d" /* STOP_LOADING */]);
        });
    }
});

/***/ }),

/***/ "wWmm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdentificationPhotoStep_vue__ = __webpack_require__("pE5z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_180a163a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdentificationPhotoStep_vue__ = __webpack_require__("P/F8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdentificationPhotoStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_180a163a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdentificationPhotoStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wepy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array_helper__ = __webpack_require__("rzJh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    loanRequest: {
      required: true
    },
    investmentConfirmed: {
      required: true,
      type: Boolean
    }
  },
  data: function data() {
    return {
      selected: "",
      values: [],
      totalLiquidoIR: 0,
      totalRetornoBruto: 0,
      valorInvestimento: undefined,
      valorReinvestimento: undefined,
      valorParcela: 0,
      impostoRendaTotalFormatado: 0,
      retornoBrutoFormatado: 0,
      retornoLiquidoFormatado: 0,
      investment: {},
      showQueueForm: false,
      liberaFormValor: false,
      indiceShowForm: 1,
      carregado: false,
      Status: 1
    };
  },


  /*TODO: FAZER ISSO: */
  beforeCreate: function beforeCreate() {
    var _this = this;

    var solicitacaoId = this.$route.params.id;

    __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getInvestmentReservation({
      loanRequestId: solicitacaoId
    }).then(function (investmentReservation) {
      _this.investment = investmentReservation;

      if (_this.investment != null) {
        _this.Status = _this.investment.Status;
        _this.valorInvestimento = _this.formatCurrency(_this.investment.Valor);
      }

      _this.AjustaTela();

      _this.CalculaInformacoesGerais();

      _this.carregado = true;
    }).catch(function (error) {
      console.log('error', error);
    });
  },
  created: function created() {

    this.values = [];
    var valorSelect = 0;
    var valorRestante = this.loanRequest.Valor - this.loanRequest.ValorCaptado;
    var quantidade = this.loanRequest.InvestimentoMaximo / this.loanRequest.InvestimentoMinimo;

    for (var i = 1; i <= quantidade && valorRestante > valorSelect; i++) {
      this.values.push("R$ " + (this.loanRequest.InvestimentoMinimo * i).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }));
      valorSelect = this.loanRequest.InvestimentoMinimo * i;
    }

    if (this.investmentConfirmed) {
      for (var _i = 1; _i <= quantidade; _i++) {
        this.values.push("R$ " + (this.loanRequest.InvestimentoMinimo * _i).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }));
      }
    }
  },

  computed: {
    investmentPaid: function investmentPaid() {
      if (this.investment) return this.investment.Valor == this.investment.ReInvestimento || this.investment.StatusBoleto == 'paid' ? false : true;
      return true;
    },

    User: function User() {
      return this.$store.state.currentUser;
    },
    minPercentToQueue: function minPercentToQueue() {
      return this.$config.investment.minPercentToQueue;
    },
    valueToInvest: function valueToInvest() {
      if (this.investment) return this.formatCurrency(this.investment.Valor);

      return 0;
    },
    resumoVisivel: function resumoVisivel() {

      if (this.loanRequest && this.loanRequest.ResumoVisivel != undefined) return this.loanRequest.ResumoVisivel;

      return true;
    },
    valueToInvestNaoFormatado: function valueToInvestNaoFormatado() {
      if (this.investment) return this.investment.Valor;

      return 0;
    },
    retornoBrutoMensal: function retornoBrutoMensal() {
      return this.loanRequest.RetornoBrutoMensal;
    },
    retornoBrutoAnual: function retornoBrutoAnual() {
      return this.loanRequest.RetornoBrutoAnual;
    },
    taxaInternaRetorno: function taxaInternaRetorno() {
      return this.loanRequest.TaxaInternaRetorno;
    },
    taxaTotalEfetiva: function taxaTotalEfetiva() {
      return this.loanRequest.TaxaTotalEfetiva;
    },
    prazo: function prazo() {
      return this.loanRequest.Prazo;
    },
    investmentId: function investmentId() {
      return this.investment ? this.investment._id : 0;
    },
    currentUser: function currentUser() {
      return this.$store.state.currentUser;
    },
    hasInvestor: function hasInvestor() {
      return this.currentUser.hasinvestor;
    },
    hasSuitability: function hasSuitability() {
      return this.currentUser.hassuitability;
    },
    isInvestorApproved: function isInvestorApproved() {
      return this.hasInvestor && this.currentUser.investor != null && this.currentUser.investor.Status == 'APROVADO';
    },
    canInvest: function canInvest() {
      return this.hasInvestor && this.hasSuitability && this.isInvestorApproved;
    },
    reachedValuePercentage: function reachedValuePercentage() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.loanRequest.ValorCaptado * 100 / this.loanRequest.Valor);
    },
    startedQueue: function startedQueue() {
      return this.reachedValuePercentage >= this.minPercentToQueue;
    },
    shouldShowQueueNotification: function shouldShowQueueNotification() {
      return this.startedQueue && !this.showQueueForm && !this.investmentConfirmed;
    },
    shouldShowReservationForm: function shouldShowReservationForm() {
      return !this.investmentConfirmed && (!this.startedQueue || this.showQueueForm);
    },
    investorSuitability: function investorSuitability() {
      return this.canInvest ? this.$store.state.currentUser.suitability.Tipo : null;
    },
    isSuitable: function isSuitable() {
      return this.loanRequest.PerfisAptos.includes(this.investorSuitability);
    },
    retornoBruto: function retornoBruto() {
      var interest = Math.pow(1 + this.taxaTotalEfetiva / 100, this.prazo) - 1;
      var interestValue = __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].unmaskMoney(this.valueToInvest) * interest;
      return __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].unmaskMoney(this.valueToInvest) + interestValue;
    },
    impostoRendaTotal: function impostoRendaTotal() {
      var years = Math.round(this.prazo / 12);
      var interest = Math.pow(1 + this.loanRequest.TaxaImpostoRenda / 100, years) - 1;
      var gainValue = this.retornoBruto - __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].unmaskMoney(this.valueToInvest);
      return gainValue * interest;
    }
  },
  methods: {
    abreModal: function abreModal() {
      this.selected = this.loanRequest.InvestimentoMinimo.toString();
      this.$emit('submit', this.selected);
    },
    verificaMsg: function verificaMsg() {
      if (this.Status === 2) {
        return false;
      }

      return true;
    },
    verificaMsg2: function verificaMsg2() {

      if (this.Status === 1 || this.loanRequest.ValorCaptado < this.loanRequest.Valor) {
        return true;
      }

      return false;
    },
    InvestidorBloqueado: function InvestidorBloqueado() {

      if (this.currentUser.investor == null || this.currentUser.investor.Bloqueio == null || this.currentUser.investor.Bloqueio.FimBloqueio == null) return false;

      var FimBloqueio = new Date(this.currentUser.investor.Bloqueio.FimBloqueio);

      return FimBloqueio > new Date();
    },
    Block: function Block(isBlock) {

      $("#btnInvestir").prop("disabled", isBlock);

      if (isBlock) $("#lnkNaoUsarSaldo").hide();else $("#lnkNaoUsarSaldo").show();

      $("#btnUsarSaldo").prop("disabled", isBlock);
    },
    MostrarRelatorio: function MostrarRelatorio() {

      if (document.getElementById("valor") !== undefined) {

        document.getElementById("valor").addEventListener("keyup", function () {
          if (!document.getElementsByClassName("at-collapse__item")[0].classList.contains('at-collapse__item--active')) {
            document.getElementsByClassName("at-collapse__item")[0].classList.add("at-collapse__item--active");
            document.getElementsByClassName("at-collapse__item")[0].classList.add("keyPress");
            document.getElementsByClassName("at-collapse__body")[0].removeAttribute("style");
          }
        });
      }

      if (this.selected != null && this.selected != "") {
        document.getElementsByClassName("at-collapse__item")[0].classList.add("at-collapse__item--active");
        document.getElementsByClassName("at-collapse__body")[0].removeAttribute("style");
      }
    },
    CalculaInformacoesGerais: function CalculaInformacoesGerais() {

      var valor;
      if (document.getElementById("valor") == undefined) {
        valor = "0,00";
      } else {
        valor = document.getElementById("valor").value;
      }

      if (this.selected != null && this.selected != "") {
        valor = this.selected.trim().replace("R$", "");
        valor = valor.replace(".", "");
      }

      valor = valor.replace(/[^0-9]/g, "");
      valor = valor.substring(0, valor.length - 2) + "." + valor.substring(valor.length - 2);

      var novoValor = parseFloat(valor);
      this.valorParcela = -this.PMT(this.loanRequest.RetornoBrutoMensal / 100, this.prazo, novoValor);
      this.retornoBrutoFormatado = this.RetornoBruto(this.prazo, this.loanRequest.RetornoBrutoMensal / 100, novoValor);
      this.impostoRendaTotalFormatado = this.ImpostoRendaTotal(this.prazo, this.loanRequest.RetornoBrutoMensal / 100, novoValor);
      this.retornoLiquidoFormatado = this.RetornoTotalLiquido();
    },
    formatCurrencyInv: function formatCurrencyInv() {

      if (document.getElementById("valor") != undefined) {
        var valor = document.getElementById("valor").value;

        if (valor == "") valor = "0,00";

        if (this.selected != null && this.selected != "") {
          valor = this.selected.trim().replace("R$", "");
          valor = valor.replace(".", "");
        }

        valor = valor.replace(/[^0-9]/g, "");
        valor = valor.substring(0, valor.length - 2) + "." + valor.substring(valor.length - 2);

        var novoValor = parseFloat(valor);
        return novoValor.toLocaleString('pt-BR', {
          minimumFractionDigits: "2",
          maximumFractionDigits: 2
        });
      }

      return this.valorInvestimento;
    },
    TemLimitadorMaximoInvestimento: function TemLimitadorMaximoInvestimento(InvestimentoMaximo) {
      if (InvestimentoMaximo !== 0 && InvestimentoMaximo !== null && InvestimentoMaximo !== undefined) {
        return true;
      }
      return false;
    },
    formatCurrency: function formatCurrency(value) {

      if (!isNaN(parseFloat(value)) && isFinite(value)) return value.toLocaleString('pt-BR', {
        minimumFractionDigits: "2",
        maximumFractionDigits: 2
      });else {
        value = 0;
      }
      return value.toLocaleString('pt-BR', {
        minimumFractionDigits: "2",
        maximumFractionDigits: 2
      });;
    },
    submit: function submit() {
      var value = void 0;
      this.valorReinvestimento ? value = this.valorReinvestimento : value = "0,00";
      if (value.indexOf(',') == value.length - 2) {
        value = value.replace(/\D/g, '');
        value = value.substr(0, value.length - 2) + ',' + value.substr(value.length - 2, value.length);
      }
      var val = __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].unmaskMoney(this.valorInvestimento);
      var valReInv = __WEBPACK_IMPORTED_MODULE_1__utils_masker__["a" /* default */].unmaskMoney(value);

      if (this.loanRequest.InvestimentoMinimo == 0) {
        this.loanRequest.InvestimentoMinimo = 500;
      }

      if (val < this.loanRequest.InvestimentoMinimo || val % this.loanRequest.InvestimentoMinimo != 0) {

        this.$Notify.error("Valor deve ser de pelo menos R$ " + this.formatCurrency(this.loanRequest.InvestimentoMinimo) + " e deve ser multiplo de R$ " + this.formatCurrency(this.loanRequest.InvestimentoMinimo));
      }

      if (valReInv > val) {
        valReInv = val;
        this.Block(false);
      } else {
        this.$emit('submit', {
          _id: this.investment != null ? this.investment._id : null,
          Valor: val,
          ReInvestimento: valReInv
        });

        this.Block(false);

        this.indiceShowForm = 3; //enviar para investimento realizado com sucesso
        this.liberaFormValor = false;
      }
    },
    ValidarInvestimento: function ValidarInvestimento() {

      var value = 0;
      if (typeof this.valorInvestimento === 'string') {
        var inv = this.valorInvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
        value = parseFloat(inv / 100);
      }

      if (value == 0 || isNaN(value)) {
        this.$Notify.error({
          title: "Desculpe",
          message: "Por favor, insira um valor."
        });

        return false;
      }

      if (value < this.loanRequest.InvestimentoMinimo || isNaN(value)) {
        this.$Notify.error({
          title: "Desculpe",
          message: "O valor mínimo de aporte é de R$ " + this.formatCurrency(this.loanRequest.InvestimentoMinimo)
        });

        return false;
      }
      if (value > this.loanRequest.InvestimentoMaximo && this.loanRequest.InvestimentoMaximo != 0 || isNaN(value)) {

        this.$Notify.error({
          title: "Desculpe",
          message: "O valor máximo de aporte é de R$ " + this.formatCurrency(this.loanRequest.InvestimentoMaximo)
        });

        return false;
      }

      if (value % this.loanRequest.InvestimentoMinimo != 0 || isNaN(value)) {
        this.$Notify.error({
          title: "Desculpe",
          message: "O valor deve ser multiplo de R$ " + this.formatCurrency(this.loanRequest.InvestimentoMinimo)
        });

        return false;
      }

      if (this.investment != null && this.investment.Valor > 0) {

        if (value > this.loanRequest.Valor) {
          this.$Notify.error({
            title: "Desculpe",
            message: "O valor de aporte é maior que o solicitado."
          });

          return false;
        }

        if (value > this.loanRequest.Valor - this.loanRequest.ValorCaptado + this.investment.Valor) {
          this.$Notify.error({
            title: "Desculpe",
            message: "O valor de aporte é maior que o disponível."
          });

          return false;
        }
      } else {

        if (value > this.loanRequest.Valor) {
          this.$Notify.error({
            title: "Desculpe",
            message: "O valor de aporte é maior que o solicitado."
          });

          return false;
        }

        //verifica se existe saldo, caso ñ é porque esta na lista de espera
        if (this.loanRequest.Valor - this.loanRequest.ValorCaptado > 0 && value > this.loanRequest.Valor - this.loanRequest.ValorCaptado) {
          this.$Notify.error({
            title: "Desculpe",
            message: "O valor de aporte é maior que o disponível."
          });

          return false;
        }
      }

      return true;
    },
    AjustaTela: function AjustaTela() {

      if (this.shouldShowQueueNotification) {
        this.indiceShowForm = 0; // mostra a lista de espera
      }

      if (this.investmentConfirmed) {
        this.indiceShowForm = 3;
      }
    },
    FV: function FV(rate, periods, payment, value, type) {
      // Credits: algorithm inspired by Apache OpenOffice

      // Initialize type
      type = typeof type === 'undefined' ? 0 : type;

      // Evaluate rate (TODO: replace with secure expression evaluator)
      rate = eval(rate);

      // Return future value
      var result;
      if (rate === 0) {
        result = value + payment * periods;
      } else {
        var term = Math.pow(1 + rate, periods);
        if (type === 1) {
          result = value * term + payment * (1 + rate) * (term - 1.0) / rate;
        } else {
          result = value * term + payment * (term - 1) / rate;
        }
      }

      // result = Math.round(result * 100) / 100;

      return -result;
    },
    IPMT: function IPMT(rate, period, periods, present, future, type) {
      // Credits: algorithm inspired by Apache OpenOffice

      // Initialize type
      type = typeof type === 'undefined' ? 0 : type;

      // Initialize future
      future = typeof future === 'undefined' ? 0 : future;

      // Evaluate rate and periods (TODO: replace with secure expression evaluator)
      rate = eval(rate);
      periods = eval(periods);

      // Compute payment
      var payment = this.PMT(rate, periods, present, future, type);

      // Compute interest
      var interest;
      if (period === 1) {
        if (type === 1) {
          interest = 0;
        } else {
          interest = -present;
        }
      } else {
        if (type === 1) {
          interest = this.FV(rate, period - 2, payment, present, 1) - payment;
        } else {
          interest = this.FV(rate, period - 1, payment, present, 0);
        }
      }

      var result = interest * rate;
      // result = Math.round(result * 100) / 100;

      // Return interest
      return interest * rate;
    },
    PMT: function PMT(rate, periods, present, future, type) {
      // Credits: algorithm inspired by Apache OpenOffice

      // Initialize type
      type = typeof type === 'undefined' ? 0 : type;

      // Initialize future
      future = 0;

      // Evaluate rate (TODO: replace with secure expression evaluator)
      rate = eval(rate);

      // Return payment
      var result;
      if (rate === 0) {
        result = (present + future) / periods;
      } else {
        var term = Math.pow(1 + rate, periods);
        if (type === 1) {
          result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
        } else {
          result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
        }
      }

      // result = Math.round(result * 100) / 100;

      return -result;
    },
    ImpostoRendaTotal: function ImpostoRendaTotal(totalParcelas, taxa, totalInvestido) {
      var sum = 0;

      for (var periodo = 1; periodo <= totalParcelas; periodo++) {
        var aliqIR = 0;
        var IR = 0;
        var ipmt = -this.IPMT(taxa, periodo, totalParcelas, totalInvestido);

        ipmt = Math.round(ipmt * 100) / 100;

        if (periodo >= 1 && periodo < 6) aliqIR = 0.225;else if (periodo >= 6 && periodo < 12) aliqIR = 0.2;else if (periodo >= 12 && periodo < 24) aliqIR = 0.175;else aliqIR = 0.15;

        IR = ipmt * aliqIR;
        IR = Math.round(IR * 100) / 100;

        sum += IR;
      }

      this.totalLiquidoIR = sum;

      return sum;
    },
    RetornoTotalLiquido: function RetornoTotalLiquido() {
      return this.totalRetornoBruto - this.totalLiquidoIR;
    },
    RetornoBruto: function RetornoBruto(parcelas) {
      this.totalRetornoBruto = parcelas * this.valorParcela;

      return this.totalRetornoBruto;
    },
    Nome: function Nome() {
      var nome = "",
          letra = "";
      if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
        nome = this.User.username;
      } else {
        nome = this.User.name;
      }
      nome = nome.trim();
      var primeiroNome = nome.split(" ")[0];
      return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
    },
    recalcValues: function recalcValues() {

      this.values = [];
      var quantidade = this.loanRequest.InvestimentoMaximo / this.loanRequest.InvestimentoMinimo;
      for (var i = 1; i <= quantidade; i++) {
        this.values.push("R$ " + (this.loanRequest.InvestimentoMinimo * i).toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 }));
      }
    }
  },
  watch: {
    selected: function selected() {
      this.CalculaInformacoesGerais();
      this.MostrarRelatorio();
    }
  }
});

/***/ }),

/***/ "whVA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "whwM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyFields_vue__ = __webpack_require__("q4WM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7ce94ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyFields_vue__ = __webpack_require__("aWzu");
function injectStyle (ssrContext) {
  __webpack_require__("VMi4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7ce94ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyFields_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7ce94ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyFields_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wkKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"action":"","method":"POST"},on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-6 text-left"},[_c('label',{attrs:{"for":"company"}},[_vm._v("\n            Nome da empresa\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company),expression:"company"}],staticClass:"form-control form-control-lg",class:{ error: this.company == '' && _vm.submited },attrs:{"type":"text","autofocus":"autofocus","required":""},domProps:{"value":(_vm.company)},on:{"input":function($event){if($event.target.composing){ return; }_vm.company=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6 text-left"},[_c('label',{attrs:{"for":"to"}},[_vm._v("\n            Email da empresa\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.to),expression:"to"}],staticClass:"form-control form-control-lg",class:{ error: this.to == '' && _vm.submited },attrs:{"type":"email","autofocus":"autofocus","required":""},domProps:{"value":(_vm.to)},on:{"input":function($event){if($event.target.composing){ return; }_vm.to=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-6 text-left"},[_c('label',{attrs:{"for":"contactName"}},[_vm._v("\n            Nome do responsável\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contact),expression:"contact"}],staticClass:"form-control form-control-lg",class:{ error: this.contact == '' && _vm.submited },attrs:{"type":"nomeResponsavel","autofocus":"autofocus","required":""},domProps:{"value":(_vm.contact)},on:{"input":function($event){if($event.target.composing){ return; }_vm.contact=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6 text-left"},[_c('label',{attrs:{"for":"phone"}},[_vm._v("\n            Telefone (opcional)\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"form-control form-control-lg",attrs:{"type":"telefone","autofocus":"autofocus"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"msg"}},[_vm._v("\n        Mensagem\n        ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],staticClass:"form-control",class:{ error: this.msg == '' && _vm.submited },attrs:{"name":"mensagem","id":"mensagem","rows":"5","required":""},domProps:{"value":(_vm.msg)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"submit"}},[_vm._v("\n        Enviar\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wkqA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_155d4fff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("hVPI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_155d4fff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wlqh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('p',[_vm._v("Faturamento dos últimos 2 anos(mês a mês) ou Extrato do Simples")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x6II":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      occupations: [{ value: 1, label: 'MEI' }, { value: 2, label: 'Autônomo' }, { value: 3, label: 'Profissional liberal' }]
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = { Social: this.currentUser.Social };
      this.$emit('on-submit', newData);
    }
  },
  mounted: function mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");
  }
});

/***/ }),

/***/ "x9G1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.modal)?_c('div',{staticClass:"investment"},[_c('label',{staticClass:"investment__title"},[_vm._v("Valor que deseja")]),_vm._v(" "),_c('at-select',{staticClass:"investment__value--select",attrs:{"id":"selectInvestment","placeholder":"Selecione um valor ..."},model:{value:(_vm.valorSelecionado),callback:function ($$v) {_vm.valorSelecionado=$$v},expression:"valorSelecionado"}},_vm._l((_vm.valores),function(option){return _c('at-option',{key:option,attrs:{"value":option}},[_vm._v("R$ "+_vm._s(option))])}),1),_vm._v(" "),(!_vm.aviso(_vm.usuario, _vm.investidor))?_c('input',{staticClass:"investment__btn",attrs:{"id":"buttonInvestment","type":"button","value":"Investir"},on:{"click":function($event){return _vm.submeterInvestimento()}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"investment__footer"},[_vm._v("** Ao confirmar o seu investimento, o boleto é gerado imediatamente e o pagamento do valor investido deve ser realizado em até 24 horas.")]),_vm._v(" "),_c('label',{staticStyle:{"visibility":"hidden","font-size":"1px"}},[_vm._v(_vm._s(_vm.valor))]),_vm._v(" "),(_vm.aviso(_vm.usuario, _vm.investidor))?_c('div',{staticClass:"investment__warning"},[_c('span',[_vm._v("\n                    "+_vm._s(_vm.aviso(_vm.usuario, _vm.investidor))+"\n                ")])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.aba==1 && _vm.modal == false)?_c('div',{staticClass:"investment"},[_c('label',{staticClass:"investment__title"},[_vm._v("Valor que deseja")]),_vm._v(" "),_c('at-select',{staticClass:"investment__value--select",attrs:{"id":"selectInvestment","placeholder":"Selecione um valor ..."},model:{value:(_vm.valorSelecionado),callback:function ($$v) {_vm.valorSelecionado=$$v},expression:"valorSelecionado"}},_vm._l((_vm.valores),function(option){return _c('at-option',{key:option,attrs:{"value":option}},[_vm._v("R$ "+_vm._s(option))])}),1),_vm._v(" "),(!_vm.aviso(_vm.usuario, _vm.investidor))?_c('input',{staticClass:"investment__btn",attrs:{"id":"buttonInvestment","type":"button","value":"Investir"},on:{"click":function($event){return _vm.submeterInvestimento()}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"investment__footer"},[_vm._v("** Ao confirmar o seu investimento, o boleto é gerado imediatamente e o pagamento do valor investido deve ser realizado em até 24 horas.")]),_vm._v(" "),_c('label',{staticStyle:{"visibility":"hidden","font-size":"1px"}},[_vm._v(_vm._s(_vm.valor))]),_vm._v(" "),(_vm.aviso(_vm.usuario, _vm.investidor))?_c('div',{staticClass:"investment__warning"},[_c('span',[_vm._v("\n                    "+_vm._s(_vm.aviso(_vm.usuario, _vm.investidor))+"\n                ")])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.aba==2)?_c('div',{staticClass:"reinvestiment"},[_c('div',{staticClass:"reinvestiment__header"},[_c('div',{staticClass:"reinvestiment__header__message"},[_c('img',{attrs:{"src":"/static/assets/images/ico-reinvestir.svg","alt":"icone reinvestir"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.nomeUsuario)+", você possuí saldo em sua carteira virtual. Gostaria de reinvestir o seu saldo?")])]),_vm._v(" "),_c('div',{staticClass:"reinvestiment__header__value"},[_c('span',[_vm._v("\n                        Total disponível para reinvestir: \n                        "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.formataValor(Math.floor(_vm.saldo * 100) / 100)))])])])]),_vm._v(" "),_c('div',{staticClass:"reinvestiment__value"},[_c('label',{attrs:{"for":""}},[_vm._v("Valor que deseja utilizar")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"},{name:"model",rawName:"v-model",value:(_vm.reinvestimento),expression:"reinvestimento"}],attrs:{"id":"inputReinvestment","type":"text","placeholder":"R$ 1.500,00"},domProps:{"value":(_vm.reinvestimento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reinvestimento=$event.target.value}}}),_vm._v(" "),_c('input',{attrs:{"id":"buttonSubmitReinvestment","type":"button","value":"Usar saldo"},on:{"click":function($event){return _vm.submeterReinvestimento()}}})])]),_vm._v(" "),_c('div',{staticClass:"reinvestiment__footer"},[_c('button',{attrs:{"id":"buttonSubmitNoReinvestment"},on:{"click":function($event){return _vm.zerarReinvestimento()}}},[_vm._v("Não utilizar saldo disponível.")]),_vm._v(" "),_c('small',[_vm._v("O valor para reinvestimento não pode ser superior ao disponível em sua carteira virtual.")])])]):_vm._e(),_vm._v(" "),(_vm.aba==3)?_c('div',{staticClass:"cancellation"},[(_vm.cancelado)?_c('div',{staticClass:"cancellation__confirm"},[_c('img',{attrs:{"src":"/static/assets/images/ico-confirm.svg","alt":"icone de confirmação"}}),_vm._v(" "),_c('h2',[_vm._v("Oferta de investimento cancelada.")])]):_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cancellation__body"},[_c('div',{staticClass:"cancellation__body__form"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.motivo),expression:"motivo"}],attrs:{"id":"textCancelReason","rows":"3"},domProps:{"value":(_vm.motivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motivo=$event.target.value}}}),_vm._v(" "),_c('div',[_c('input',{attrs:{"id":"buttonSubmitCancel","type":"button","value":"Sim, desejo cancelar"},on:{"click":function($event){return _vm.submeterCancelamento()}}}),_vm._v(" "),_c('input',{attrs:{"type":"button","value":"Não, irei manter"},on:{"click":function($event){return _vm.sairCancelamento()}}})])])])])]):_vm._e(),_vm._v(" "),(_vm.aba==4)?_c('div',{staticClass:"waitlist"},[_c('h2',{staticClass:"waitlist__title"},[_vm._v("Tem interesse em investir nesta empresa?")]),_vm._v(" "),_c('div',{staticClass:"waitlist__message"},[(_vm.aviso(_vm.usuario, _vm.investidor))?_c('p',[_vm._v("\n                    "+_vm._s(_vm.aviso(_vm.usuario, _vm.investidor))+"\n                ")]):_c('p',[_c('strong',[_vm._v("Clique no botão")]),_vm._v(" abaixo e coloque sua oferta na lista de espera.\n                ")]),_vm._v(" "),(!_vm.aviso(_vm.usuario, _vm.investidor))?_c('input',{staticClass:"waitlist__message__btn",attrs:{"id":"buttonWaitlist","type":"button","value":"Lista de espera"},on:{"click":function($event){return _vm.submeterLista()}}}):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.aba==5)?_c('div',{staticClass:"reserved"},[_c('div',{staticClass:"reserved__message"},[_c('img',{attrs:{"src":"/static/assets/images/ico-confirm.svg","alt":"icone de confirmação"}}),_vm._v(" "),_c('p',[_vm._v("\n                    Investimento registrado com sucesso.\n                    "),_c('br'),_vm._v(" "),(_vm.reservaStatus==2)?_c('small',[_vm._v("\n                        Parabéns, você entrou na lista de espera. Caso tenhamos alguma desistência, você será chamado para confirmar o seu investimento e receberá as instruções por e-mail.\n                    ")]):(!_vm.cancelavel)?_c('small',[_vm._v("\n                        Pagamento já realizado! Seu investimento foi gerado com sucesso e enviado para o seu e-mail, assim como as informações referentes ao seu investimento.\n                    ")]):(_vm.reservaStatus==1)?_c('small',[_vm._v("\n                        Seu boleto bancário já foi gerado com sucesso e enviado para o seu e-mail, assim como as informações referentes ao seu investimento.\n                    ")]):_vm._e()])]),_vm._v(" "),(_vm.cancelavel)?_c('input',{staticClass:"btn btn-danger",attrs:{"id":"buttonCancel","type":"button","value":"Cancelar investimento"},on:{"click":function($event){return _vm.submeterMotivo()}}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.aba==6)?_c('div',{staticClass:"closed"},[_c('div',[_vm._v("\n                Oportunidade encerrada\n            ")])]):_vm._e(),_vm._v(" "),(_vm.aba==7)?_c('div',{staticClass:"reinvestiment"},[_c('div',{staticClass:"reinvestiment__header"},[_c('div',{staticClass:"reinvestiment__header__message"},[_c('img',{attrs:{"src":"/static/assets/images/ico-reinvestir.svg","alt":"icone reinvestir"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.nomeUsuario)+", você possuí saldo em sua carteira virtual superior à R$50,00\n                         e por isso pode reinvestir a partir de R$50,00 até o valor total do seu saldo. \n                         "),_c('strong',[_vm._v("Válido apenas para múltiplos de R$50,00. Ex: R$50,00, R$100,00, R$150,00")])])]),_vm._v(" "),_c('div',{staticClass:"reinvestiment__header__value"},[_c('span',[_vm._v("\n                        Total disponível para reinvestir: \n                        "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.formataValor(Math.floor(_vm.saldo * 100) / 100)))])])])]),_vm._v(" "),_c('div',{staticClass:"reinvestiment__value"},[_c('label',{attrs:{"for":""}},[_vm._v("Valor que deseja utilizar. Investimento mínimo R$50,00")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"},{name:"model",rawName:"v-model",value:(_vm.reinvestimento),expression:"reinvestimento"}],attrs:{"id":"inputReinvestment","type":"text","placeholder":"R$ 1.500,00"},domProps:{"value":(_vm.reinvestimento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reinvestimento=$event.target.value}}}),_vm._v(" "),_c('input',{attrs:{"id":"buttonSubmitReinvestment","type":"button","value":"Usar saldo"},on:{"click":function($event){return _vm.submeterCampanhaReinvestimento()}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"footer"},[(true)?_c('a',{staticClass:"footer__link",attrs:{"to":'/investimentos/oportunidades/perfil-empresa/'+_vm.solicitacao._id,"title":"Exibir perfil detalhado da empresa"},on:{"click":function($event){return _vm.perfilEmpresa()}}},[_vm._v("\n                Exibir perfil detalhado da empresa\n                "),_c('i',[_vm._v(" ")])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cancellation__header"},[_c('h2',[_vm._v("Tem certeza que deseja cancelar o seu investimento?")]),_vm._v(" "),_c('p',[_vm._v("Sentimos muito que você esteja cancelando o seu investimento na oportunidade. Por favor, nos informe abaixo o motivo\n                        pelo qual está cancelando o seu investimento:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xCYr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalhesCcb_vue__ = __webpack_require__("XyBL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f63b728_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalhesCcb_vue__ = __webpack_require__("Kgxv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalhesCcb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f63b728_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalhesCcb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xD49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PasswordField__ = __webpack_require__("i7i+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lpUrl: "https://iouu.com.br",
      name: '',
      email: '',
      password: '',
      CodConvite: '',
      id: '',
      enabled: false,
      validate: false,
      visivel: false
    };
  },

  components: {
    PasswordField: __WEBPACK_IMPORTED_MODULE_4__components_PasswordField__["a" /* default */]
  },
  methods: {
    signUp: function signUp() {
      var _this = this;

      this.$store.dispatch('signup_lead', { name: this.name, email: this.email, password: this.password, tipo: "TOM" }).then(function () {
        console.log("teste");
        if (_this.id !== "") {
          _this.$router.push('/informacoes-adicionais/emprestimo-coletivo/' + _this.id);
        } else {
          _this.$router.push("/");
        }
      }).catch(function (error) {
        var errorMessages = error.response.data.errors.map(function (error) {
          return error.detail;
        });
        _this.$Notify.error(__WEBPACK_IMPORTED_MODULE_3__utils_array_helper__["a" /* default */].toSentence(errorMessages));
      });
    },
    validateCampos: function validateCampos() {
      this.enabled = document.getElementById("terms").checked;

      if (this.enabled) {
        if (this.name !== "" && this.email !== "" && this.password !== "") {
          this.validate = true;
        } else {
          this.enabled = false;
          document.getElementById("terms").checked = false;

          if (this.name === "" && this.email === "" && this.password || this.name === "" && this.email === "" || this.email === "" && this.password === "" || this.name === "" && this.password === "") {
            this.$Notify.error("Preencha todos os campos!!!");
          } else {
            if (this.name === "") {
              this.$Notify.error("Preencha o seu nome!");
            }

            if (this.email === "") {
              this.$Notify.error("Preencha o seu Email!");
            }

            if (this.password === "") {
              this.$Notify.error("Preencha a sua senha!");
            }
          }
        }
      }
    },
    setCampos: function setCampos() {
      if (this.$route.query.email) {
        this.email = this.$route.query.email;
      }

      if (this.$route.query.loansId) {
        this.id = this.$route.query.loansId;
      }

      if (this.$route.query.name) {
        this.name = this.$route.query.name;
        document.getElementById("Nome").setAttribute("disabled", true);
      }
    },


    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/criar-conta-lead/',
        title: 'Criar conta lead'
      });
    }
  },
  mounted: function mounted() {
    this.setCampos();
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.taggingGA();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),

/***/ "xIpc":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "xIqt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Facebook")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Facebook),expression:"Facebook"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: www.facebook.com/IouuBrasil/"},domProps:{"value":(_vm.Facebook)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Facebook=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Linkedin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Linkedin),expression:"Linkedin"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: www.linkedin.com/company/iouu/"},domProps:{"value":(_vm.Linkedin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Linkedin=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Nos informe as redes sociais da sua empresa:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api_client__ = __webpack_require__("6Yc5");
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  computed: {
    isLoading: function isLoading() {
      return this.$store.state.isLoading;
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    // window.document.title= 'Dashboard IOUU';

    var reloadPage = function reloadPage() {
      var oldPath = _this.$route.fullPath;
      _this.$router.push('/');
      _this.$router.push(oldPath);
    };
    __WEBPACK_IMPORTED_MODULE_1__utils_api_client__["a" /* default */].validateToken().then(function (result) {
      if (result) {
        _this.$store.dispatch('updateUser');
      } else {
        _this.$store.dispatch('logout');
        reloadPage();
      }
    }).catch(function () {
      _this.$store.dispatch('logout');
      reloadPage();
    });
  },


  metaInfo: {
    title: 'Dashboard',
    titleTemplate: '%s | IOUU'
  }
});

/***/ }),

/***/ "xJvq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        pagination: function pagination() {
            var arrayResposta = [];
            for (var i = 1; i <= this.paginasTotais; i++) {
                arrayResposta.push({ display: i, route: i });
            }
            if (this.paginasTotais > 5) {
                if (this.paginaAtual <= 2) {
                    arrayResposta = arrayResposta.slice(0, 4);
                    arrayResposta.push({ display: "...", route: null });
                } else if (this.paginaAtual > this.paginasTotais - 1) {
                    arrayResposta = arrayResposta.slice(this.paginaAtual - 4, this.paginaAtual + 1);
                    arrayResposta.unshift({ display: "...", route: null });
                } else if (this.paginaAtual > this.paginasTotais - 2) {
                    arrayResposta = arrayResposta.slice(this.paginaAtual - 3, this.paginaAtual + 1);
                    arrayResposta.unshift({ display: "...", route: null });
                } else {
                    arrayResposta = arrayResposta.slice(this.paginaAtual - 2, this.paginaAtual + 1);
                    arrayResposta.push({ display: "...", route: null });
                    arrayResposta.unshift({ display: "...", route: null });
                }
            }
            if (this.paginaAtual == 1 || this.paginasTotais <= 1) {
                arrayResposta.unshift({ display: "<", route: null });
                arrayResposta.unshift({ display: "<<", route: null });
            } else {
                arrayResposta.unshift({ display: "<", route: this.paginaAtual - 1 });
                arrayResposta.unshift({ display: "<<", route: 1 });
            }
            if (this.paginaAtual >= this.paginasTotais) {
                arrayResposta.push({ display: ">", route: null });
                arrayResposta.push({ display: ">>", route: null });
            } else {
                arrayResposta.push({ display: ">", route: this.paginaAtual + 1 });
                arrayResposta.push({ display: ">>", route: this.paginasTotais });
            }
            return arrayResposta;
        }
    },
    props: ['paginasTotais', 'paginaAtual', 'navigate'],
    computed: {
        Pages: function Pages() {
            return this.pagination();
        }
    }
});

/***/ }),

/***/ "xMmZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xOzg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_LineChartInvestment__ = __webpack_require__("Dzg6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Calculos__ = __webpack_require__("SuNK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masker__ = __webpack_require__("7VWg");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Calculos__["a" /* default */]],
    data: function data() {
        return {
            aba: 1,
            editavel: false,
            antecipacaoGambiarra: false,
            taxaGambiarra: 5.26,
            CDIGambiarra: 641.46
        };
    },

    props: {
        valor: { type: String },
        solicitacao: { type: Object }
    },
    components: {
        Chart: __WEBPACK_IMPORTED_MODULE_2__charts_LineChartInvestment__["a" /* default */]
    },
    computed: {
        parcelas: function parcelas() {
            var parcelas = [],
                valorAcumulativo = this.valorFormatado;
            this.CalculosSimulados.tabela.forEach(function (element) {
                valorAcumulativo = parseFloat((valorAcumulativo + parseFloat(element.juros)).toFixed(2));
                parcelas = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(parcelas), [{ mes: element.parcela, valorAcumulativo: valorAcumulativo }]);
            });
            for (var i = 1; i <= this.solicitacao.Prazo; i++) {}
            return parcelas;
        },
        parcelasCDI: function parcelasCDI() {
            var cdi = 0.059;
            var parcelas = [],
                valorAcumulativo = this.valorFormatado;
            var juros = this.valorFormatado * cdi;
            for (var i = 1; i <= this.solicitacao.Prazo; i++) {
                valorAcumulativo = parseFloat((valorAcumulativo + juros / 12).toFixed(2));
                parcelas = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(parcelas), [{ mes: i, valorAcumulativo: valorAcumulativo }]);
            }
            return parcelas;
        },
        valorParcela: function valorParcela() {
            var parcela = this.PMT(this.valorFormatado, this.solicitacao.RetornoBrutoMensal / 100, this.solicitacao.Prazo);
            return parseFloat(parcela.toFixed(2));
        },
        valorBruto: function valorBruto() {
            var bruto = this.valorParcela * this.solicitacao.Prazo;
            return parseFloat(bruto.toFixed(2));
        },
        valorLiquido: function valorLiquido() {
            var liquido = this.valorBruto - parseFloat(this.CalculosSimulados.IR);
            return parseFloat(liquido.toFixed(2));
        },
        valorFormatado: function valorFormatado() {
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.valor));
            return typeof this.valor == 'string' ? __WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].unmaskMoney(this.valor) : this.valor;
        },
        valorMascara: function valorMascara() {
            return 'R$ ' + this.valorFormatado + ',00';
        },
        CalculosSimulados: function CalculosSimulados() {
            var calculos = this.GerarCalculos(this.valorFormatado, this.solicitacao.RetornoBrutoMensal / 100, this.solicitacao.Prazo);

            console.log(calculos);

            return calculos;
        }
    },
    methods: {
        mudarAba: function mudarAba(aba) {
            this.aba = aba;
        },
        editarValor: function editarValor(status) {
            this.editavel = status;
        },
        formataValor: function formataValor(valor) {
            if (valor.toString().indexOf('.') == -1) {
                valor = valor + '.00';
            }
            return __WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].maskMoney(valor.toString());
        },
        removeMascara: function removeMascara(valor) {
            return __WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].unmaskMoney(valor.replace('R$ ', ''));
        },
        totalEmprestimos: function totalEmprestimos(Prazo, ValorParcela) {
            return this.formataValor(Prazo * Math.floor(ValorParcela * 100) / 100);
        },
        verificaProduto: function verificaProduto(produto) {

            if (produto != "EMPRES") {
                return true;
            }

            return false;
        },
        valorBrutoAmortizado: function valorBrutoAmortizado(valor, juros) {
            var valorBruto = parseFloat(valor) + parseFloat(juros);

            return this.formataValor(valorBruto);
        }
    },
    created: function created() {
        if (this.solicitacao._id === "5e9de72f796877415093cb1d" || this.solicitacao._id === "5ea348604e46501f80f6641f") this.antecipacaoGambiarra = true;
    }
});

/***/ }),

/***/ "xTBZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_pdf_helper__ = __webpack_require__("WTek");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      investor: null,
      tranferencia: null,
      type: "teste",
      idComprovante: "",
      loading: false,
      loadingTransaction: false,
      loadingBank: false,
      ted: "0,00",
      currentPage: 0,
      pageCount: 0
    };
  },


  methods: {
    getComprovanteType: function getComprovanteType() {
      var tipoComprovante = void 0;

      if (this.type === "CREDITO") {
        tipoComprovante = "Repagamento";
      } else {
        tipoComprovante = "Transferência";
      }

      return tipoComprovante;
    },
    FV: function FV(rate, periods, payment, value, type) {
      // Credits: algorithm inspired by Apache OpenOffice

      // Initialize type
      type = typeof type === 'undefined' ? 0 : type;

      // Evaluate rate (TODO: replace with secure expression evaluator)
      rate = eval(rate);

      // Return future value
      var result;
      if (rate === 0) {
        result = value + payment * periods;
      } else {
        var term = Math.pow(1 + rate, periods);
        if (type === 1) {
          result = value * term + payment * (1 + rate) * (term - 1.0) / rate;
        } else {
          result = value * term + payment * (term - 1) / rate;
        }
      }

      // result = Math.round(result * 100) / 100;

      return -result;
    },
    IPMT: function IPMT(rate, period, periods, present, future, type) {
      // Credits: algorithm inspired by Apache OpenOffice

      // Initialize type
      type = typeof type === 'undefined' ? 0 : type;

      // Initialize future
      future = typeof future === 'undefined' ? 0 : future;

      // Evaluate rate and periods (TODO: replace with secure expression evaluator)
      rate = eval(rate);
      periods = eval(periods);

      // Compute payment
      var payment = this.PMT(rate, periods, present, future, type);

      // Compute interest
      var interest;
      if (period === 1) {
        if (type === 1) {
          interest = 0;
        } else {
          interest = -present;
        }
      } else {
        if (type === 1) {
          interest = this.FV(rate, period - 2, payment, present, 1) - payment;
        } else {
          interest = this.FV(rate, period - 1, payment, present, 0);
        }
      }

      var result = interest * rate;
      // result = Math.round(result * 100) / 100;

      // Return interest
      return interest * rate;
    },
    PMT: function PMT(rate, periods, present, future, type) {
      // Credits: algorithm inspired by Apache OpenOffice

      // Initialize type
      type = typeof type === 'undefined' ? 0 : type;

      // Initialize future
      future = 0;

      // Evaluate rate (TODO: replace with secure expression evaluator)
      rate = eval(rate);

      // Return payment
      var result;
      if (rate === 0) {
        result = (present + future) / periods;
      } else {
        var term = Math.pow(1 + rate, periods);
        if (type === 1) {
          result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
        } else {
          result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
        }
      }

      // result = Math.round(result * 100) / 100;

      return -result;
    },
    formatCurrency: function formatCurrency(value) {
      if (value != null) return value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });

      return 0;
    },
    formatReal: function formatReal(num) {
      var real = void 0;
      real = parseFloat(num.replace(/[^\d]+/g, '')) / 100;
      return real;
    },
    formatDate: function formatDate(date) {
      var spliter = date.split("T");
      var newDate = spliter[0].split('-');
      var time = spliter[1].split(':');

      return newDate[2] + '/' + newDate[1] + '/' + newDate[0];
    },
    savePdf: function savePdf() {
      __WEBPACK_IMPORTED_MODULE_5__utils_pdf_helper__["a" /* default */].Save('cupom', this.idComprovante);
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_5__utils_pdf_helper__["a" /* default */].Print('cupom', this.idComprovante);
    },
    getIndiceFatura: function getIndiceFatura(fatura) {
      return fatura != null ? fatura.IndiceFatura + 1 : "";
    },

    //tagueamento GA
    taggingGA: function taggingGA() {
      this.$ga.page({
        page: '/carteira-investimento/comprovante/:id',
        title: 'Comprovante'
      });
    }
  },
  computed: {

    CalcLiquid: function CalcLiquid() {
      var ipmt = void 0,
          RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
          IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
          Prazo = this.transferencia.SolicitacaoID.Prazo,
          Valor = this.transferencia.ReservaInvestimentoID.Valor,
          aliqIR = void 0,
          Ir = void 0;

      ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
      ipmt = Math.round(ipmt * 100) / 100;

      if (IndiceFatura >= 1 && IndiceFatura < 6) aliqIR = 0.225;else if (IndiceFatura >= 6 && IndiceFatura < 12) aliqIR = 0.2;else if (IndiceFatura >= 12 && IndiceFatura < 24) aliqIR = 0.175;else aliqIR = 0.15;

      Ir = ipmt * aliqIR;

      return this.formatCurrency(this.transferencia.Valor - Ir);
    },
    CalcIR: function CalcIR() {
      var ipmt = void 0,
          RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
          IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
          Prazo = this.transferencia.SolicitacaoID.Prazo,
          Valor = this.transferencia.ReservaInvestimentoID.Valor,
          aliqIR = void 0;

      ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
      ipmt = Math.round(ipmt * 100) / 100;

      if (IndiceFatura >= 1 && IndiceFatura < 6) aliqIR = 0.225;else if (IndiceFatura >= 6 && IndiceFatura < 12) aliqIR = 0.2;else if (IndiceFatura >= 12 && IndiceFatura < 24) aliqIR = 0.175;else aliqIR = 0.15;

      return this.formatCurrency(ipmt * aliqIR);
    },
    CalcJuros: function CalcJuros() {
      var ipmt = void 0,
          RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
          IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
          Prazo = this.transferencia.SolicitacaoID.Prazo,
          Valor = this.transferencia.ReservaInvestimentoID.Valor;

      ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
      ipmt = Math.round(ipmt * 100) / 100;

      console.log(this.transferencia);

      return this.formatCurrency(ipmt);
    },

    CalcMulta: function CalcMulta() {
      if (this.transferencia.Juros != undefined && this.transferencia.Juros > 0) return this.transferencia.Juros;

      return 0;
    },
    CalcCapital: function CalcCapital() {
      var ipmt = void 0,
          RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
          IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
          Prazo = this.transferencia.SolicitacaoID.Prazo,
          Valor = this.transferencia.ReservaInvestimentoID.Valor;

      ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
      ipmt = Math.round(ipmt * 100) / 100;

      if (this.transferencia.Ipmt > 0) ipmt = this.transferencia.Ipmt;

      if (this.transferencia.Juros == undefined || this.transferencia.Juros == null) this.transferencia.Juros = 0;

      return this.formatCurrency(this.transferencia.Valor - this.transferencia.Juros - ipmt);
    },
    NomeEmpresa: function NomeEmpresa() {
      return this.transferencia.SolicitacaoID.TipoEmprestimo === "emprestimo-de-impacto" ? this.transferencia.SolicitacaoID.Impacto.NomeEmpresa : this.transferencia.SolicitacaoID.Empresa.RazaoSocial;
    },
    DocumentoEmpresa: function DocumentoEmpresa() {
      return __WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].maskCpf(this.transferencia.SolicitacaoID.Documento);
    },
    RecebimentoParcela: function RecebimentoParcela() {
      return this.getIndiceFatura(this.transferencia.FaturaID) + ' / ' + this.transferencia.SolicitacaoID.Prazo;
    },
    valor: function valor() {
      return this.formatCurrency(this.transferencia.Valor);
    },
    valorLiquido: function valorLiquido() {
      return this.formatCurrency(this.transferencia.ValorLiquido);
    },
    impostoRenda: function impostoRenda() {
      return this.formatCurrency(this.transferencia.IR);
    },
    valorComTed: function valorComTed() {
      return this.formatCurrency(this.transferencia.Valor - this.formatReal(this.ted));
    },
    nome: function nome() {
      return this.investor.NomeCompleto;
    },
    documento: function documento() {
      return __WEBPACK_IMPORTED_MODULE_4__utils_masker__["a" /* default */].maskCpf(this.investor.Cpf);
    },
    nomeBanco: function nomeBanco() {
      if (this.investor != null && this.investor.DadosBancarios != null && this.bank != null) return this.bank.length > 0 ? this.bank[0].nome : 'Outro - Codigo do banco: ' + this.investor.DadosBancarios.CodigoBanco;

      return "";
    },
    tipoConta: function tipoConta() {
      if (this.transferencia != null && this.transferencia.DadosBancarios != null) return this.transferencia.DadosBancarios.TipoConta === 1 ? "Conta Corrente" : "Conta Poupança";
      return "";
    },
    NumeroConta: function NumeroConta() {
      if (this.transferencia != null && this.transferencia.DadosBancarios != null) return this.transferencia.DadosBancarios.Conta;
      return "";
    },
    agencia: function agencia() {

      if (this.transferencia != null && this.transferencia.DadosBancarios != null) return this.transferencia.DadosBancarios.Agencia;
      return "";
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    this.type = this.$route.query.type;

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["c" /* START_LOADING */]);

    __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getInvestor().then(function (response) {
      _this.investor = response;

      __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getComprovante(_this.$route.params.id).then(function (response) {
        _this.idComprovante = _this.$route.params.id;
        _this.transferencia = response.data;

        if (_this.transferencia.ReservaInvestimentoID != null && _this.transferencia.ReservaInvestimentoID.Valor == _this.transferencia.ReservaInvestimentoID.ReInvestimento) {

          _this.transferencia.ReInvestimento = true;
        }

        _this.loadingTransaction = true;

        if (new Date(_this.transferencia.Data).getFullYear() > 2018) {

          _this.ted = "0,00";
        } else {

          _this.ted = "2,00";
        }

        if (_this.type === "DEBITO" && !_this.transferencia.ReInvestimento) {

          __WEBPACK_IMPORTED_MODULE_2__utils_api_client__["a" /* default */].getWalletBank(_this.transferencia.DadosBancarios.CodigoBanco).then(function (response) {

            _this.bank = response.data;
            _this.loadingBank = true;
          });
        } else {

          _this.loadingBank = true;
        }
      });

      console.log("teste");

      _this.loading = true;
      _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
    }).catch(function (error) {
      console.log("request fail", error);
      _this.loading = true;
      _this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types_js__["d" /* STOP_LOADING */]);
    });
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.taggingGA();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),

/***/ "xX/1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    metaInfo: {
        htmlAttrs: {
            lang: 'pt-br'
        },
        link: [{ rel: 'stylesheet', href: 'https://stackpath.bootstrapcdn.com/bootstrap/4.2.1/css/bootstrap.min.css' }, { rel: 'stylesheet', href: 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css' }],
        script: [{ src: '/static/assets/js/bootstrap-password-toggler.min.js' }, { src: '/static/assets/js/landingpage.js' }]
    },
    data: function data() {
        return {
            lpUrl: "https://iouu.com.br",
            "cdi": "384,07%"
        };
    }
});

/***/ }),

/***/ "xXoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loanRequest != 'undefined' && _vm.carregado)?_c('div',[(!_vm.loanRequest.Encerrado)?_c('div',[(_vm.canInvest)?_c('div',[_c('div',{staticClass:"row justify-content-center no-gutters text-center"},[_c('div',{staticClass:"col-12 col-md-7 text-center"},[(this.indiceShowForm == 0)?_c('div',{staticClass:"alert alert_reserve alert-warning text-center",attrs:{"role":"alert"}},[_c('h2',[_vm._v("Tem interesse em investir nesta empresa?")]),_vm._v(" "),_c('div',[_vm._m(0),_vm._v(" "),_c('a',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showQueueForm = true;_vm.indiceShowForm = 1; _vm.recalcValues();}}},[_vm._v("LISTA DE ESPERA")])])]):_vm._e(),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(this.indiceShowForm == 1),expression:"this.indiceShowForm == 1"}]},[_c('div',{staticClass:"form-group"},[_c('img',{staticClass:"mt-4 mb-4",attrs:{"src":"/static/assets/images/ico-reinvestir.svg","width":"80px","alt":"icone investir"}}),_vm._v(" "),_c('label',{staticStyle:{"display":"block"},attrs:{"for":"valor"}},[_vm._v("Valor que deseja investir")]),_vm._v(" "),(this.TemLimitadorMaximoInvestimento(_vm.loanRequest.InvestimentoMaximo))?_c('at-select',{attrs:{"size":"large","placeholder":"Selecione um valor ..."},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((_vm.values),function(option){return _c('at-option',{key:option,attrs:{"value":option}},[_vm._v(_vm._s(option))])}),1):_vm._e(),_vm._v(" "),(!this.TemLimitadorMaximoInvestimento(_vm.loanRequest.InvestimentoMaximo))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valorInvestimento),expression:"valorInvestimento"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"id":"valor","placeholder":'Investimento mínimo R$ ' + _vm.formatCurrency2(_vm.loanRequest.InvestimentoMinimo)},domProps:{"value":(_vm.valorInvestimento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valorInvestimento=$event.target.value}}}):_vm._e()],1),_vm._v(" "),(this.InvestidorBloqueado() && (typeof _vm.loanRequest.StatusBoleto == undefined || _vm.loanRequest.StatusBoleto!='pending'))?_c('button',{staticClass:"btn btn-lg btn-danger btn-block",staticStyle:{"cursor":"not-allowed"},attrs:{"disabled":""}},[_vm._v("Bloqueado")]):_vm._e(),_vm._v(" "),(!this.InvestidorBloqueado())?_c('button',{staticClass:"btn btn-primary btn-lg btn-block",on:{"click":function($event){$event.preventDefault();return _vm.VerificaSaldo($event)}}},[_vm._v("Investir")]):_vm._e()]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(this.indiceShowForm == 2),expression:"this.indiceShowForm == 2"}]},[_c('div',{staticClass:"reinvestir"},[_c('img',{attrs:{"src":"/static/assets/images/ico-reinvestir.svg","alt":"icone reinvestir"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.Nome())+", você possuí saldo em sua Carteira virtual."),_c('br'),_vm._v("Gostaria de reinvestir como parte do pagamento?")]),_vm._v(" "),_c('label',[_vm._v("Total disponível para reinvestir:")]),_vm._v(" "),_c('span',[_vm._v("R$ "+_vm._s(_vm.formatCurrency(this.sDisponivel)))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"valor"}},[_vm._v("Valor que dejesa utilizar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valorReinvestimento),expression:"valorReinvestimento"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],staticClass:"form-control form-control-lg",attrs:{"id":"valor","placeholder":'Investimento mínimo R$ ' + _vm.formatCurrency(_vm.loanRequest.InvestimentoMinimo)},domProps:{"value":(_vm.valorReinvestimento)},on:{"keyup":function($event){return _vm.CalculaInformacoesGerais()},"click":function($event){return _vm.MostrarRelatorio()},"input":function($event){if($event.target.composing){ return; }_vm.valorReinvestimento=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("O valor para reinvestimento não pode ser superior ao disponível em sua carteira virtual.")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg btn-block",on:{"click":function($event){$event.preventDefault();return _vm.UsarSaldo()}}},[_vm._v("Sim, usar saldo disponível")]),_vm._v(" "),_c('a',{staticClass:"btn btn-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.NaoUsarSaldo()}}},[_vm._v("Não utilizar saldo disponível")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.indiceShowForm == 3),expression:"this.indiceShowForm == 3"}],staticClass:"confirm"},[_c('img',{attrs:{"src":"/static/assets/images/ico-confirm.svg","alt":"icone de confirmação"}}),_vm._v(" "),_c('h2',{staticClass:"mt-5 mb-3"},[_vm._v("Investimento registrado com sucesso.")]),_vm._v(" "),(_vm.loanRequest.Valor - _vm.loanRequest.ValorCaptado > 0)?_c('p',[_vm._v("\n                Seu boleto bancário já foi gerado com sucesso e enviado para o seu e-mail, assim como as informações referentes ao seu investimento.\n              ")]):_c('p',[_vm._v("\n                Parabéns, você entrou na lista de espera. Caso tenhamos alguma desistência, você será chamado para confirmar o seu investimento e receberá as instruções por e-mail.\n              ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-link",staticStyle:{"display":"none"},attrs:{"href":"#"}},[_vm._v("Clique aqui para cancelar sua oferta de investimento")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.indiceShowForm == 4),expression:"this.indiceShowForm == 4"}],staticClass:"confirm"},[_vm._m(1)]),_vm._v(" "),(_vm.loanRequest.Valor - _vm.loanRequest.ValorCaptado > 0)?_c('p',{staticClass:"small mt-4 mb-4"},[_vm._v("\n            ** Ao confirmar o seu investimento, o boleto é gerado imediatamente e o pagamento do valor investido deve ser realizado em até 24 horas.\n          ")]):_c('p',[_vm._v("\n            **Caso você seja chamado pela lista de reserva, você receberá as instruções por e-mail e o pagamento do valor investido deve ser realizado em 24 horas.\n          ")])])])]):_c('div',{staticClass:"alert alert_reserve alert-warning text-center"},[_c('h2',[_vm._v("Falta pouco para você investir")]),_vm._v(" "),_c('div',[(_vm.hasInvestor && _vm.hasSuitability && !_vm.isInvestorApproved)?_c('p',[_vm._v("Agora estamos analisando suas informações e retornaremos em até 1 dia útil.")]):_c('p',[(!_vm.hasInvestor)?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/informacoes-adicionais/investidor"}},[_vm._v("Complete o cadastro de investidor")]):_vm._e(),_vm._v(" "),(!_vm.hasSuitability)?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/informacoes-adicionais/suitability"}},[_vm._v("Preencha o formulário de suitability")]):_vm._e()],1)])])]):_c('div',[_vm._m(2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"queue-message-paragraph"},[_c('strong',[_vm._v("Clique no botão")]),_vm._v(" abaixo e coloque sua oferta na lista de espera. Enquanto estamos esperando a transferência\n                de recursos você ainda pode ser um dos investidores.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n              Oportunidade encerrada:\n              "),_c('br'),_vm._v(" "),_c('small',[_vm._v("\n                Sua reserva de investimento foi realizada com sucesso. Efetue o pagamento do boleto enviado para o seu e-mail para confirmar o seu investimento ou clique abaixo para cancelar sua reserva.\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert_reserve alert-dark text-center",attrs:{"role":"alert"}},[_c('h2',{staticStyle:{"color":"#555"}},[_vm._v("Oportunidade encerrada")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xalN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoDataProfile_vue__ = __webpack_require__("T3gA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4faab06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoDataProfile_vue__ = __webpack_require__("L3io");
function injectStyle (ssrContext) {
  __webpack_require__("eh7W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4faab06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoDataProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4faab06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoDataProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xbS8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"investimento operacao row"},[_c('div',{staticClass:"col-12 col-md-7 sep"},[_c('div',[_c('strong',[_vm._v("Informações")]),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.nomeEmpresa)+" - "+_vm._s(_vm.formatDocument(_vm.documento)))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("ID Oportunidade")]),_vm._v(" "+_vm._s(_vm.idOportunidade)+" ")])]),_vm._v(" "),_c('table',{staticClass:"info"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Valor")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("R$ "+_vm._s(_vm.formatarDinheiro(_vm.valor)))])])])])]),_vm._v(" "),_c('div',{staticClass:"detalhes col-12 col-md-5"},[_c('div',{staticClass:"options"},[_c('p',[_vm._v("\n                ID da Transação\n                "),_c('strong',[_vm._v("\n                    "+_vm._s(_vm.transacao)+"\n                ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("\n                    Detalhes de Investimento\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xgdo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_for_each__ = __webpack_require__("mKqZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_for_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_for_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_masker__ = __webpack_require__("7VWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AdditionalInformationPeerToPeer_PartnersStep_PersonFields__ = __webpack_require__("qE+O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AdditionalInformationPeerToPeer_PartnersStep_CompanyFields__ = __webpack_require__("JybC");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var COMPANY_TYPE_MEI = 1;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PersonFields: __WEBPACK_IMPORTED_MODULE_4__components_AdditionalInformationPeerToPeer_PartnersStep_PersonFields__["a" /* default */], CompanyFields: __WEBPACK_IMPORTED_MODULE_5__components_AdditionalInformationPeerToPeer_PartnersStep_CompanyFields__["a" /* default */] },
  data: function data() {
    var partners = this.solicitacao.Empresa.Socios || [];
    return {
      showPartnerType: false,
      socios: partners.map(function (partner) {
        return {
          Tipo: partner.Tipo,
          Nome: partner.Nome,
          Cpf: partner.Cpf,
          DataNascimento: partner.DataNascimento ? new Date(partner.DataNascimento).toLocaleDateString("pt-BR") : null,
          Escolaridade: partner.Escolaridade,
          EstadoCivil: partner.EstadoCivil,
          Celular: partner.Celular,
          Email: partner.Email,
          Site: partner.Site,
          Facebook: partner.Facebook,
          Linkedin: partner.Linkedin,
          NomeConjuge: partner.NomeConjuge,
          CpfConjuge: partner.CpfConjuge,
          DataNascimentoConjuge: partner.DataNascimentoConjuge ? new Date(partner.DataNascimentoConjuge).toLocaleDateString("pt-BR") : null,
          CelularConjuge: partner.CelularConjuge,
          EmailConjuge: partner.EmailConjuge,
          EscolaridadeConjuge: partner.EscolaridadeConjuge,
          RazaoSocial: partner.RazaoSocial,
          Cnpj: partner.Cnpj
        };
      }),
      isMei: this.solicitacao.Empresa.TipoEmpresa == COMPANY_TYPE_MEI,
      errors: []
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  computed: {
    stepTitle: function stepTitle() {
      if (this.socios.length == 1) {
        return "Os dados do sócio abaixo estão corretos?";
      } else {
        return "Os dados dos sócios abaixo estão corretos?";
      }
    }
  },
  methods: {
    validate: function validate() {
      var hasEmptyFields = false;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_for_each___default()(this.socios, function (partner) {
        if (partner.Tipo == 1 && (partner.Nome == null || partner.Cpf == null || partner.Escolaridade == null, partner.EstadoCivil == null)) {
          hasEmptyFields = true;
        }
        if (partner.Tipo == 2 && (!partner.RazaoSocial || !partner.Cnpj)) {
          hasEmptyFields = true;
        }
      });

      var errors = hasEmptyFields ? ["Nessa etapa é obrigatório o preenchimento de todos as informações solicitadas"] : [];
      return { isValid: !hasEmptyFields, errors: errors };
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();
      if (validation.isValid) {
        var newData = {
          Empresa: {
            Socios: this.socios.map(function (socio) {
              var dataNascSocio = null;
              var dataNascConjuge = null;

              if (socio.DataNascimento !== null && socio.DataNascimento !== undefined) {
                // eslint-disable-next-line
                dataNascSocio = new Date(socio.DataNascimento.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"));
              }

              if (socio.DataNascimentoConjuge !== null && socio.DataNascimentoConjuge !== undefined) {
                // eslint-disable-next-line
                dataNascConjuge = new Date(socio.DataNascimentoConjuge.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"));
              }

              if (socio.Tipo == 1) {
                return {
                  Tipo: socio.Tipo,
                  Nome: socio.Nome,
                  DataNascimento: dataNascSocio,
                  Cpf: __WEBPACK_IMPORTED_MODULE_2__utils_masker__["a" /* default */].unmaskCpf(socio.Cpf),
                  Escolaridade: socio.Escolaridade,
                  EstadoCivil: socio.EstadoCivil,
                  Celular: socio.Celular,
                  Email: socio.Email,
                  Facebook: socio.Facebook,
                  Linkedin: socio.Linkedin,
                  NomeConjuge: socio.EstadoCivil === 2 || socio.EstadoCivil === 5 ? socio.NomeConjuge : "",
                  CpfConjuge: socio.EstadoCivil === 2 || socio.EstadoCivil === 5 ? socio.CpfConjuge : "",
                  DataNascimentoConjuge: socio.EstadoCivil === 2 || socio.EstadoCivil === 5 ? dataNascConjuge : null,

                  CelularConjuge: socio.EstadoCivil === 2 || socio.EstadoCivil === 5 ? socio.CelularConjuge : "",

                  EmailConjuge: socio.EstadoCivil === 2 || socio.EstadoCivil === 5 ? socio.EmailConjuge : "",

                  EscolaridadeConjuge: socio.EstadoCivil === 2 || socio.EstadoCivil === 5 ? socio.EscolaridadeConjuge : 0
                };
              } else {
                return {
                  Tipo: socio.Tipo,
                  RazaoSocial: socio.RazaoSocial,
                  Cnpj: socio.Cnpj,
                  Site: socio.Site,
                  Celular: socio.Celular,
                  Email: socio.Email,
                  Facebook: socio.Facebook,
                  Linkedin: socio.Linkedin
                };
              }
            }),
            Avalistas: this.socios.filter(function (socio) {
              if (socio.EstadoCivil === 2 || socio.EstadoCivil === 5) return true;else return false;
            }).map(function (socio) {
              var dataNasc = null;
              var dataNascConjuge = null;

              if (socio.DataNascimento !== null && socio.DataNascimento !== undefined) {
                // eslint-disable-next-line
                dataNasc = new Date(socio.DataNascimento.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"));
              }

              if (socio.DataNascimentoConjuge !== null && socio.DataNascimentoConjuge !== undefined) {
                // eslint-disable-next-line
                dataNascConjuge = new Date(socio.DataNascimentoConjuge.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"));
              }

              if (socio.EstadoCivil === 2 || socio.EstadoCivil === 5) {
                return {
                  Tipo: socio.Tipo,

                  Nome: socio.NomeConjuge,
                  DataNascimento: dataNascConjuge,
                  Cpf: __WEBPACK_IMPORTED_MODULE_2__utils_masker__["a" /* default */].unmaskCpf(socio.CpfConjuge),
                  EstadoCivil: socio.EstadoCivil,
                  Celular: socio.CelularConjuge,
                  Email: socio.EmailConjuge,
                  Escolaridade: socio.EscolaridadeConjuge,

                  NomeConjuge: socio.Nome,
                  CpfConjuge: __WEBPACK_IMPORTED_MODULE_2__utils_masker__["a" /* default */].unmaskCpf(socio.Cpf),
                  DataNascimentoConjuge: dataNasc,
                  CelularConjuge: socio.Celular,
                  EmailConjuge: socio.Email,
                  EscolaridadeConjuge: socio.Escolaridade
                };
              }
            })
          }
        };

        if (newData.Empresa.Socios.length > 0) {
          this.$emit("on-submit", newData);
        } else {
          this.$Notify.error("Por Favor cadastre o sócio(s)");
        }
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_3__utils_array_helper__["a" /* default */].toSentence(validation.errors)
        });
      }
    },
    addPartner: function addPartner(partnerType) {
      this.socios.push({ Tipo: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(partnerType) });
      this.showPartnerType = false;
    },
    removePartner: function removePartner(index) {
      this.socios.splice(index, 1);
    }
  }
});

/***/ }),

/***/ "xhIC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "xjz2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xqTD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SolicitacaoAnalise_vue__ = __webpack_require__("YLnY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12434e78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SolicitacaoAnalise_vue__ = __webpack_require__("9vKK");
function injectStyle (ssrContext) {
  __webpack_require__("m0Nm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12434e78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SolicitacaoAnalise_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12434e78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SolicitacaoAnalise_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xsY1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinishedStep_vue__ = __webpack_require__("IymS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6486fad6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishedStep_vue__ = __webpack_require__("T9Bt");
function injectStyle (ssrContext) {
  __webpack_require__("MO9q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6486fad6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinishedStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6486fad6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishedStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xt6L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__("INCx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
var interval = null;
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'vuejsCountDown',
    props: {
        deadline: {
            type: String
        },
        end: {
            type: String
        },
        stop: {
            type: Boolean
        }
    },
    data: function data() {
        return {
            now: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000),
            date: null,
            diff: 0
        };
    },
    created: function created() {
        var _this = this;

        if (!this.deadline && !this.end) {
            throw new Error("Missing props 'deadline' or 'end'");
        }
        var endTime = this.deadline ? this.deadline : this.end;

        var dataAux1 = new Date(endTime);

        var timeStampEnd = dataAux1.getTime() + 86400000;

        var dataAux = Date.parse(endTime.replace(/-/g, "/") / 1000);
        this.date = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(timeStampEnd / 1000);

        if (!this.date) {
            throw new Error("Invalid props value, correct the 'deadline' or 'end'");
        }
        interval = setInterval(function () {
            _this.now = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000);
        }, 1000);
    },

    computed: {
        seconds: function seconds() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff) % 60;
        },
        minutes: function minutes() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff / 60) % 60;
        },
        hours: function hours() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff / 60 / 60) % 24;
        },
        days: function days() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff / 60 / 60 / 24);
        }
    },
    watch: {
        now: function now(value) {
            this.diff = this.date - this.now;
            if (this.diff <= 0 || this.stop) {
                this.diff = 0;
                // Remove interval
                clearInterval(interval);
            }
        }
    },
    filters: {
        twoDigits: function twoDigits(value) {
            if (value.toString().length <= 1) {
                return '0' + value.toString();
            }
            return value.toString();
        }
    },
    destroyed: function destroyed() {
        clearInterval(interval);
    }
});

/***/ }),

/***/ "xuWV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8"},[_c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Para sua segurança, enviamos um código para o seu celular.")]),_vm._v(" "),_c('p',[_vm._v("\n      Enviamos para o número "),_c('strong',[_vm._v(_vm._s(_vm.numeroCelular))]),_vm._v(" um código de 6 dígitos.\n      "),_c('a',{attrs:{"href":""},on:{"click":_vm.showCellphoneField}},[_vm._v("(Trocar número)")]),_vm._v(" "),_c('br'),_vm._v("\n      Preencha abaixo com o número recebido\n    ")])]),_vm._v(" "),(_vm.isCellphoneFieldVisible)?_c('div',[_c('div',[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8"},[_c('div',{staticClass:"form-group text-left"},[_c('label',{staticClass:"float-left",attrs:{"for":"newCellphone"}},[_vm._v("Telefone celular")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCellphone),expression:"newCellphone"},{name:"mask",rawName:"v-mask",value:('phone'),expression:"'phone'"}],key:'newCellphoneField',staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Celular"},domProps:{"value":(_vm.newCellphone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newCellphone=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary float-right",on:{"click":_vm.updateCellphone}},[_vm._v("Confirmar")])])])])])]):_c('div',[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8"},[_c('div',{staticClass:"form-group text-left",class:_vm.isTokenValid == false ? 'invalid-field' : ''},[_c('label',{staticClass:"float-left",attrs:{"for":""}},[_vm._v("Código de confirmação")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tokenConfirmacao),expression:"tokenConfirmacao"}],staticClass:"form-control form-control-lg token-field",attrs:{"type":"text","maxlength":"6","placeholder":"Token de confirmação","required":""},domProps:{"value":(_vm.tokenConfirmacao)},on:{"keyup":_vm.handleTokenKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.tokenConfirmacao=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"validation-message"},[_vm._v("Token Inválido")])]),_vm._v(" "),_c('div',{staticClass:"btns text-center"},[_c('a',{staticClass:"btn btn-lg btn-link",attrs:{"href":""},on:{"click":_vm.resendToken}},[_vm._v("SMS não chegou")]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":!_vm.isTokenValid}},[_vm._v("Próximo")])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xx6E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagamento operacao row"},[_c('div',{staticClass:"col-12 col-md-7 sep"},[_c('div',[_c('strong',[_vm._v("Informações")]),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.nomeEmpresa)+" - "+_vm._s(_vm.formatDocument(_vm.documento)))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("ID Oportunidade")]),_vm._v(" "+_vm._s(_vm.idOportunidade)+" ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Parcela")]),_vm._v(" "+_vm._s(_vm.parcela + 1)+" / "+_vm._s(_vm.prazo))])]),_vm._v(" "),_c('table',{staticClass:"info"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Principal")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("R$ "+_vm._s(_vm.formatarDinheiro(_vm.valorPrincipal)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Juros")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("R$ + "+_vm._s(_vm.juros ? _vm.formatarDinheiro(_vm.juros) : _vm.formatarDinheiro(0)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Multa por Atraso")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("R$ + "+_vm._s(_vm.multa ? _vm.formatarDinheiro(_vm.multa) : _vm.formatarDinheiro(0)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Valor Bruto (Principal + Juros + Multa)")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("R$ "+_vm._s(_vm.formatarDinheiro(_vm.valorBruto)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("IR ("+_vm._s(_vm.aliquota)+"%)")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("R$ - "+_vm._s(_vm.ir ? _vm.formatarDinheiro(_vm.ir) : _vm.formatarDinheiro(0)))])]),_vm._v(" "),_c('tr',{staticClass:"tfooter"},[_vm._m(1),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v("R$ "+_vm._s(_vm.formatarDinheiro(_vm.valorLiquido)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"detalhes col-12 col-md-5"},[_c('div',{staticClass:"options"},[_c('p',[_vm._v("\n                ID da Fatura: \n                "),_c('strong',[_vm._v("\n                    "+_vm._s(_vm.fatura)+"\n                ")])]),_vm._v(" "),_c('p',[_vm._v("\n                ID da Transação:\n                "),_c('strong',[_vm._v("\n                    "+_vm._s(_vm.transacao)+"\n                ")])]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link",attrs:{"to":("/investimentos/carteira-investimento/comprovante/pagamento/" + (_vm.operacao.id) + "?type=CREDITO")}},[_c('img',{attrs:{"src":"/static/assets/images/ico-printer-2.svg","alt":"Icone impressora"}}),_vm._v(" Imprimir detalhes\n            ")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("\n                    Detalhes de Recebimento\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Liquido (Valor Bruto - IR)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xyjk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectLoanType_vue__ = __webpack_require__("u9Cq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4646d356_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectLoanType_vue__ = __webpack_require__("55Fs");
function injectStyle (ssrContext) {
  __webpack_require__("fNRR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4646d356"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectLoanType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4646d356_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectLoanType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y/il":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['saldo'],

    computed: {
        formatadoSaldo: function formatadoSaldo() {
            return this.formatarDinheiro(Math.floor(this.saldo * 100) / 100);
        }
    },

    methods: {
        formatarDinheiro: function formatarDinheiro(value) {
            var options = {
                minimumFractionDigits: "2",
                maximumFractionDigits: 2,
                style: 'currency',
                currency: 'BRL'
            };

            if (value != null) {

                if (typeof value == "string") value = parseFloat(value);

                return value.toLocaleString('pt-BR', options);
            }
            value = 0;

            return value.toLocaleString('pt-BR', options);
        }
    }
});

/***/ }),

/***/ "y0cm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkout_vue__ = __webpack_require__("BABd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2717bf6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkout_vue__ = __webpack_require__("EtEi");
function injectStyle (ssrContext) {
  __webpack_require__("/01O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b2717bf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2717bf6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y2LK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y2QI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressDocumentStep_vue__ = __webpack_require__("Rabh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d71804_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressDocumentStep_vue__ = __webpack_require__("r/tM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressDocumentStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d71804_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressDocumentStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yB1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountantDataStep_vue__ = __webpack_require__("JrBI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a5bd410_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountantDataStep_vue__ = __webpack_require__("i/t5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountantDataStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a5bd410_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountantDataStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yGdU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-10 col-xl-10"},[_c('form',{on:{"submit":_vm.onSubmit}},[_vm._l((_vm.empresasGrupoEconomico),function(empresa,index){return _c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Empresa")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(empresa.RazaoSocial),expression:"empresa.RazaoSocial"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Razão Social","required":""},domProps:{"value":(empresa.RazaoSocial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(empresa, "RazaoSocial", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-5"},[_c('label',{attrs:{"for":"inputPassword4"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(empresa.Cnpj),expression:"empresa.Cnpj"},{name:"mask",rawName:"v-mask",value:('cnpj'),expression:"'cnpj'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","pattern":"\\d{2}\\.\\d{3}\\.\\d{3}\\/\\d{4}-\\d{2}","placeholder":"CNPJ","required":""},domProps:{"value":(empresa.Cnpj)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(empresa, "Cnpj", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-1 align-self-center text-center"},[_c('a',{staticClass:"icon icon-minus-circle remove",attrs:{"title":"Remover empresa"},on:{"click":function($event){return _vm.removeCorporateGroupCompany(index)}}})])])}),_vm._v(" "),_c('div',{staticClass:"btns text-center"},[_c('button',{staticClass:"btn btn-lg btn-link",attrs:{"type":"button"},on:{"click":_vm.addCorporateGroupCompany}},[_c('span',{staticClass:"icon icon-plus-circle"}),_vm._v(" Adicionar empresa")]),_vm._v(" "),_vm._m(1)])],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Quais as empresas que compõem o grupo econômico?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yHxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    var social = this.currentUser.Social;
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: social.ArquivoCertificacaoMei || [null]
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    removeFile: function removeFile(index) {
      this.arquivos.splice(index, 1);
    },
    clearFile: function clearFile(index) {
      this.$set(this.arquivos, index, null);
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do Certificado do MEI é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {

        this.currentUser.Social.ArquivoCertificacaoMei = this.arquivosRecebidos;

        this.$emit('on-submit', { Social: this.currentUser.Social });
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "yKT3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yNFo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Facebook")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Facebook),expression:"Facebook"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: www.facebook.com/IouuBrasil/"},domProps:{"value":(_vm.Facebook)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Facebook=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Linkedin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Linkedin),expression:"Linkedin"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Ex: www.linkedin.com/company/iouu/"},domProps:{"value":(_vm.Linkedin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Linkedin=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Para nos conhecermos melhor, nos informe suas redes socias:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yRdc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInformationInvestor_vue__ = __webpack_require__("lJWH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_319a288f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInformationInvestor_vue__ = __webpack_require__("SZ4o");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInformationInvestor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_319a288f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInformationInvestor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ybHO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_0_vue_select___default.a
  },
  data: function data() {
    return {
      optionsMarital: [{ value: 1, label: 'Solteira(o)' }, { value: 2, label: 'Casada(o)' }, { value: 4, label: 'Divorciada(o)' }, { value: 5, label: 'Viúva(o)' }, { value: 6, label: 'União Estavel' }]
    };
  },

  props: {
    currentUser: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = { Social: this.currentUser.Social };
      this.$emit('on-submit', newData);
    }
  },
  mounted: function mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");
  }
});

/***/ }),

/***/ "yex4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"feature background background-220263617",attrs:{"id":"cta"}},[_c('div',{staticClass:"feature-margin"},[_c('div',{staticClass:"form-cta shadow"},[_c('form',{attrs:{"id":"form-cadastro-LandingPageInvista"},on:{"submit":function($event){$event.preventDefault();return _vm.signUp($event)}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","name":"firtname","placeholder":"Seu nome","required":"","autofocus":""},domProps:{"value":(_vm.name)},on:{"keyup":function($event){return _vm.validateName()},"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",class:{campoInvalido:!_vm.EmailConfirmado, campoValido:_vm.EmailConfirmado && _vm.msg != ''},attrs:{"type":"email","id":"Email","aria-describedby":"emailHelp","placeholder":"Seu email","required":""},domProps:{"value":(_vm.email)},on:{"focusout":_vm.ValidarEmail,"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"validacao"},[(_vm.msg != '' && !_vm.EmailConfirmado)?_c('span',[_c('p',{staticClass:"invalido"},[_c('i',{staticClass:"fas fa-exclamation-circle",attrs:{"id":"IconeInvalido"}}),_vm._v("\n                                         "+_vm._s(_vm.msg)+"\n                                     ")])]):_vm._e(),_vm._v(" "),(_vm.msg != '' && _vm.EmailConfirmado)?_c('span',[_c('p',{staticClass:"valido"},[_c('i',{staticClass:"fas fa-check",attrs:{"id":"IconeValido"}}),_vm._v("\n                                         "+_vm._s(_vm.msg)+"\n                                     ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control form-control-lg",attrs:{"type":"password","id":"password","name":"password","data-toggle":"password","placeholder":"Senha","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row d-flex flex-md-row-reverse align-items-center"},[_c('div',{staticClass:"col-12 col-md-5"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"submit","disabled":!_vm.EmailConfirmado &&  _vm.msg != ''}},[_vm._v("Comece a investir")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-7 text-center text-md-left"},[_c('span',{staticClass:"font-low"},[_vm._v(_vm._s(this.cdi)+" do CDI")]),_vm._v(" "),_vm._m(1)])])])])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v("Invista com alta rentabilidade na IOUU")]),_vm._v(" "),_c('p',[_vm._v("Cadastre-se gratuitamente e invista sem taxas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_vm._v("Retorno potencial no ano "),_c('i',{staticClass:"far fa-question-circle",attrs:{"data-toggle":"tooltip","title":"Considerando o retorno médio dos empréstimos em curso (CDI) até o mês de abril/2019."}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row text-center text-md-left"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('h3',[_vm._v("Por que investir na IOUU?")]),_vm._v(" "),_c('p',[_vm._v("Nossa plataforma conecta você com empresas qualificadas de uma forma rápida, simples e transparente, usando o melhor das tecnologias atuais. Garantimos retornos altos, superiores aos investimentos tradicionais como Poupança, CDB e Tesouro direto.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('h3',[_vm._v("Cuidamos do seu investimento")]),_vm._v(" "),_c('p',[_vm._v("Realizamos uma avaliação de crédito rigorosa através do nosso motor de crédito de alta tecnologia, de modo que você empresta seu dinheiro para empresas com capacidade de pagamento, de acordo com nossas expectativas.")])])]),_vm._v(" "),_c('hr',{staticClass:"tealish"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h2',[_vm._v("Investimentos em 3 passos")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 text-center text-md-left"},[_c('span',{staticClass:"circle"},[_c('strong',[_vm._v("1")])]),_vm._v(" "),_c('h3',[_vm._v("Tomador solicita empréstimo")]),_vm._v(" "),_c('p',[_vm._v("Nossa plataforma conecta você com empresas qualificadas de uma forma rápida, simples e transparente, usando o melhor das tecnologias atuais. Garantimos retornos altos, superiores aos investimentos tradicionais como Poupança, CDB e Tesouro direto.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 text-center text-md-left"},[_c('span',{staticClass:"circle"},[_c('strong',[_vm._v("2")])]),_vm._v(" "),_c('h3',[_vm._v("Voce consulta as rodadas disponíveis")]),_vm._v(" "),_c('p',[_vm._v("Acesse as oportunidades disponíveis na plataforma e confira o resultado completo de nossa análise de crédito, podendo escolher onde investir de acordo com seu perfil.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 text-center text-md-left"},[_c('span',{staticClass:"circle"},[_c('strong',[_vm._v("3")])]),_vm._v(" "),_c('h3',[_vm._v("Invista nas oportunidades Abertas")]),_vm._v(" "),_c('p',[_vm._v("Escolha a rodada de acordo com seu perfil de investidor e realize seu investimento. As parcelas são recebidas mensalmente na sua carteira virtual de acordo com a rentabilidade e prazo estabelecido.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature-margin pt-2 pt-md-4 pt-lg-5 pb-2 pb-md-4 pb-lg-5"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"jumbotron dusk text-center"},[_c('h3',[_vm._v("Porque realizar um investimento coletivo ou um investimento de impacto?")]),_vm._v(" "),_c('hr',{staticClass:"tealish"}),_vm._v(" "),_c('p',[_vm._v("Rápido. Simples. Bom para você e para o mundo")]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-3 col-lg-2"},[_c('div',{staticClass:"icon icon-online"}),_vm._v(" "),_c('span',[_vm._v("100% online")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 col-lg-2"},[_c('div',{staticClass:"icon icon-rentabilidade"}),_vm._v(" "),_c('span',[_vm._v("Alta rentabilidade")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 col-lg-2"},[_c('div',{staticClass:"icon icon-taxas"}),_vm._v(" "),_c('span',[_vm._v("Taxas mais justas")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 col-lg-2"},[_c('div',{staticClass:"icon icon-transparencia"}),_vm._v(" "),_c('span',[_vm._v("Transparência no processo")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 col-lg-2"},[_c('div',{staticClass:"icon icon-acessivel"}),_vm._v(" "),_c('span',[_vm._v("Acessível para todos")])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center data"},[_c('div',{staticClass:"col-12 text-center"},[_c('h2',[_vm._v("Rentabilidade dos empréstimos em curso")])]),_vm._v(" "),_c('div',{staticClass:"col-10"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v("384,07%")]),_vm._v(" "),_c('small',[_vm._v("retorno médio (CDI)")]),_vm._v(" "),_c('p',[_vm._v("Retorno médio dos empréstimos em curso (CDI).")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v("1,40%")]),_vm._v(" "),_c('small',[_vm._v("crédito vencido")]),_vm._v(" "),_c('p',[_vm._v("% de capital em atraso há mais de 60 dias e que está em processo de recuperação.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v("356,70%")]),_vm._v(" "),_c('small',[_vm._v("retorno médio real(CDI)")]),_vm._v(" "),_c('p',[_vm._v("Retorno médio dos empréstimos em curso descontando a % de crédito vencido.")])])])])]),_vm._v(" "),_c('hr',{staticClass:"tealish"}),_vm._v(" "),_c('div',{staticClass:"row justify-content-center data"},[_c('div',{staticClass:"col-12 text-center"},[_c('h2',[_vm._v("Acumululada desde o lançamento")])]),_vm._v(" "),_c('div',{staticClass:"col-10"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v("24,54%")]),_vm._v(" "),_c('small',[_vm._v("rentabilidade acomuludada bruta")]),_vm._v(" "),_c('p',[_vm._v("Rentabilidade acumulada bruta dos empréstimos realizados desde o lançamento (12 meses).")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v("00,00%")]),_vm._v(" "),_c('small',[_vm._v("débito podre")]),_vm._v(" "),_c('p',[_vm._v("% de crédito perdido.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('span',[_vm._v("24,54%")]),_vm._v(" "),_c('small',[_vm._v("retorno acumulado ajustado")]),_vm._v(" "),_c('p',[_vm._v("Rentabilidade acumulada bruta decontando a % de crédito perdido.")])])])])]),_vm._v(" "),_c('hr',{staticClass:"tealish"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('section',{staticClass:"col-12 depoimentos"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_c('h2',{staticClass:"main-title"},[_vm._v("Depoimentos")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"carousel slide",attrs:{"id":"depoimentos","data-ride":"carousel"}},[_c('ol',{staticClass:"carousel-indicators"},[_c('li',{attrs:{"data-target":"#depoimentos","data-slide-to":"0"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#depoimentos","data-slide-to":"1"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#depoimentos","data-slide-to":"2"}}),_vm._v(" "),_c('li',{staticClass:"active",attrs:{"data-target":"#depoimentos","data-slide-to":"3"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#depoimentos","data-slide-to":"4"}}),_vm._v(" "),_c('li',{attrs:{"data-target":"#depoimentos","data-slide-to":"5"}})]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-10 text-center"},[_c('div',{staticClass:"carousel-inner"},[_c('div',{staticClass:"carousel-item"},[_c('p',[_vm._v("Realizado investimentos P2P com a IOUU e até o momento me sinto muito satisfeito. Acompanho diariamente minha carteira e tenho notado uma baixa inadimplência. Não tenho dúvidas que isto se deve ao trabalho\n                                                 sério que realizam com as empresas tomadoras dos empréstimos. Sempre que precisei esclarecer minhas dúvidas sobre quaisquer assuntos fui prontamente atendido. Tenho conversado com amigos dispostos a investir\n                                                 nesta modalidade e recomendo a IOUU.")]),_vm._v(" "),_c('h3',[_vm._v("Gilberto Domingues")]),_vm._v(" "),_c('small',[_vm._v("São Paulo, São Paulo - Brasil")])]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('p',[_vm._v("Gostaria de parabenizar pelo trabalho de vocês. A ideia da carteira virtual é sensacional e facilita muito para reinvestir. E o site de vocês é muito bonito e fácil de navegar. Já usei outras plataformas e\n                                                 posso dizer que vocês são muito melhores.")]),_vm._v(" "),_c('h3',[_vm._v("Roberto Sávio")]),_vm._v(" "),_c('small',[_vm._v("São José dos Campos, São Paulo - Brasil")])]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('p',[_vm._v("Plataforma simples e completa, com as informações necessárias fáceis de achar, rendimento digno e, se não houver inadimplência, é perfeita.")]),_vm._v(" "),_c('h3',[_vm._v("Paolo dos Santos")]),_vm._v(" "),_c('small',[_vm._v("Itapira, São Paulo - Brasil")])]),_vm._v(" "),_c('div',{staticClass:"carousel-item active"},[_c('p',[_vm._v("Tudo vem ocorrendo de forma clara e bem informada. Pra ser sincero, até extrapolei o que havia considerado como valor ideal para um início de relação com vocês, justamente por estar satisfeito com as\n                                                 condições/estrutura/feedback oferecidos pela IOUU.")]),_vm._v(" "),_c('h3',[_vm._v("Jorge Araújo")]),_vm._v(" "),_c('small',[_vm._v("Guarujá, São Paulo - Brasil")])]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('p',[_vm._v("Acho que a IOUU montou uma plataforma bem estruturada, interativa e prática, além da qualidade das empresas investidas que trazem uma boa rentabilidade alternativa aos produtos bancários comuns.")]),_vm._v(" "),_c('h3',[_vm._v("Fernando de Marco")]),_vm._v(" "),_c('small',[_vm._v("São José dos Campos, São Paulo - Brasil")])]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('p',[_vm._v("Investir na IOUU foi uma grata surpresa, onde tem sido possível obter uma rentabilidade superior às aplicações tradicionais. Somado a isso, confio na empresa pois a IOUU demonstra um grande comprometimento com\n                                                 os seus investidores.")]),_vm._v(" "),_c('h3',[_vm._v("Samuel Poeta")]),_vm._v(" "),_c('small',[_vm._v("Montenegro, Rio Grande do Sul - Brasil")])])])])])])])])])]),_vm._v(" "),_c('hr',{staticClass:"tealish"}),_vm._v(" "),_c('div',{staticClass:"row text-center text-md-left"},[_c('div',{staticClass:"col-12 text-center"},[_c('h2',[_vm._v("Conheça a IOUU")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('h3',[_vm._v("O que é a IOUU?")]),_vm._v(" "),_c('p',[_vm._v("Conectamos empresas que procuram crédito e investidores com dinheiro para emprestar. Nossa plataforma é mais eficiente e transparente do que os empréstimos tradicionais e acreditamos que é um sistema melhor para todos.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('h3',[_vm._v("O que significa investir?")]),_vm._v(" "),_c('p',[_vm._v("Você escolhe e investe nas melhores oportunidades da plataforma conforme seu perfil de investidor e, mês a mês, recebe pagamentos conforme a rentabilidade e prazo estimados.")])])]),_vm._v(" "),_c('hr',{staticClass:"tealish"}),_vm._v(" "),_c('div',{staticClass:"row questions"},[_c('div',{staticClass:"col-12 text-center"},[_c('h2',[_vm._v("Resposta para suas dúvidas")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('ul',{staticClass:"column-1"},[_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#id-001"}},[_vm._v("Quais serviços a IOUU oferece para os investidores?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#id-002"}},[_vm._v("Qual o valor mínimo de investimento?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#id-003"}},[_vm._v("Quanto custa investir na IOUU?")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('ul',{staticClass:"column-2"},[_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#id-004"}},[_vm._v("Qual o procedimento em caso de atraso da parcela mensal?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#id-005"}},[_vm._v("Qual a garantia que receberei meu investimento de volta?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#id-006"}},[_vm._v("A IOUU é um banco ou instituição financeira?")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature-margin pt-2 pt-md-4 pt-lg-5 pb-2 pb-md-4 pb-lg-5"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"jumbotron background background-200852716 cta"},[_c('div',{staticClass:"alpha"}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('h3',[_vm._v("Pronto para ganhar dinheiro e garantir o futuro?")]),_vm._v(" "),_c('a',{staticClass:"btn btn-light btn-lg",attrs:{"href":"#cta","role":"button"}},[_vm._v("Comece a investir")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yhcd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-10 col-xl-10"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"cep"}},[_vm._v("CEP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cep),expression:"cep"},{name:"mask",rawName:"v-mask",value:('zipcode'),expression:"'zipcode'"},{name:"focus",rawName:"v-focus"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","pattern":"\\d{5}-?\\d{3}","placeholder":"CEP","required":""},domProps:{"value":(_vm.cep)},on:{"change":_vm.aoMudarCep,"input":function($event){if($event.target.composing){ return; }_vm.cep=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Endereço")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.logradouro),expression:"logradouro"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Logradouro","disabled":_vm.estaBuscandoEndereco},domProps:{"value":(_vm.logradouro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.logradouro=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-2"},[_c('label',{attrs:{"for":"inputPassword4"}},[_vm._v("Número")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numero),expression:"numero"},{name:"mask",rawName:"v-mask",value:('integer'),expression:"'integer'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","pattern":"\\d+","title":"Números apenas","placeholder":"Nº","disabled":_vm.estaBuscandoEndereco,"required":""},domProps:{"value":(_vm.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numero=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"complemento"}},[_vm._v("Complemento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complemento),expression:"complemento"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Complemento","disabled":_vm.estaBuscandoEndereco},domProps:{"value":(_vm.complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.complemento=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"bairro"}},[_vm._v("Bairro")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bairro),expression:"bairro"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Bairro","disabled":_vm.estaBuscandoEndereco},domProps:{"value":(_vm.bairro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bairro=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"estado"}},[_vm._v("Estado")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","placeholder":"Estado","disabled":_vm.estaBuscandoEndereco},on:{"on-change":_vm.onUfChange},model:{value:(_vm.uf),callback:function ($$v) {_vm.uf=$$v},expression:"uf"}},_vm._l((_vm.estados),function(state,i){return _c('at-option',{key:("stateOptions" + i),attrs:{"value":state.uf}},[_vm._v(_vm._s(state.nome))])}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-4"},[_c('label',{attrs:{"for":"cidade"}},[_vm._v("Cidade")]),_vm._v(" "),_c('at-select',{attrs:{"filterable":"","size":"large","disabled":_vm.estaCidadeDesabilitado,"placeholder":"Cidade"},model:{value:(_vm.cidade),callback:function ($$v) {_vm.cidade=$$v},expression:"cidade"}},_vm._l((_vm.cidades),function(city,i){return _c('at-option',{key:("cityOptions" + i),attrs:{"value":city.nome}},[_vm._v(_vm._s(city.nome))])}),1)],1)]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Qual é o endereço da sua empresa?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yoNT":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ysEb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_masker__ = __webpack_require__("7VWg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var solicitante = this.solicitacao.Solicitante;
    return {
      nomeCompleto: solicitante ? solicitante.NomeCompleto : this.solicitacao.Nome,
      cpf: solicitante ? solicitante.Cpf : null,
      dataNascimento: solicitante && solicitante.DataNascimento ? new Date(solicitante.DataNascimento).toLocaleDateString('pt-BR') : null
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      if (this.nomeCompleto.indexOf(" ") <= -1) {
        this.$Notify.error('Digite seu nome completo!');
      } else {
        this.$emit('on-submit', {
          Solicitante: {
            NomeCompleto: this.nomeCompleto,
            Cpf: __WEBPACK_IMPORTED_MODULE_0__utils_masker__["a" /* default */].unmaskCpf(this.cpf),
            DataNascimento: new Date(this.dataNascimento.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"))
          }
        });
      }
    },
    AlterarNome: function AlterarNome(event) {

      var texto = event.target.value;

      var textoFinal = "";
      texto = texto.toLowerCase();

      if (texto.length > 0) {
        textoFinal = texto.substr(0, 1).toUpperCase();

        for (var i = 1; i < texto.length; i++) {
          if (texto.substr(i - 1, 1) == " ") {
            textoFinal += texto.substr(i, 1).toUpperCase();
          } else {
            textoFinal += texto.substr(i, 1);
          }
        }
      }

      event.target.value = textoFinal;
    }
  }
});

/***/ }),

/***/ "ysMO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ytGx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    partner: { required: true, type: Object }
  }
});

/***/ }),

/***/ "yyPQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvestmentReservationForm_vue__ = __webpack_require__("ucxp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_383bbe8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvestmentReservationForm_vue__ = __webpack_require__("j435");
function injectStyle (ssrContext) {
  __webpack_require__("DvuM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-383bbe8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvestmentReservationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_383bbe8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvestmentReservationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z2yU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      QuantidadeEmpregados: this.solicitacao.Empresa.QuantidadeEmpregados
    };
  },

  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      var newData = {
        Empresa: {
          QuantidadeEmpregados: this.QuantidadeEmpregados
        }
      };
      this.$emit('on-submit', newData);
    }
  }
});

/***/ }),

/***/ "z74w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z8QB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zFeu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-12 text-left"},[_c('label',{attrs:{"for":"cep"}},[_vm._v("CEP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cep),expression:"cep"},{name:"mask",rawName:"v-mask",value:('zipcode'),expression:"'zipcode'"},{name:"focus",rawName:"v-focus"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","pattern":"\\d{5}-?\\d{3}","placeholder":"CEP","required":""},domProps:{"value":(_vm.cep)},on:{"change":_vm.aoMudarCep,"input":function($event){if($event.target.composing){ return; }_vm.cep=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-9 text-left"},[_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Endereço")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.logradouro),expression:"logradouro"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Logradouro","required":""},domProps:{"value":(_vm.logradouro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.logradouro=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-3 text-left"},[_c('label',{attrs:{"for":"Numero"}},[_vm._v("Número")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numero),expression:"numero"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","pattern":"\\d+","title":"Números apenas","placeholder":"Nº","required":""},domProps:{"value":(_vm.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numero=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-12 text-left"},[_c('label',{attrs:{"for":"complemento"}},[_vm._v("Complemento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complemento),expression:"complemento"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Complemento"},domProps:{"value":(_vm.complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.complemento=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-12 col-md-12 text-left"},[_c('label',{attrs:{"for":"bairro"}},[_vm._v("Bairro")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bairro),expression:"bairro"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Bairro","required":""},domProps:{"value":(_vm.bairro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bairro=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-12 text-left"},[_c('label',{attrs:{"for":"estado"}},[_vm._v("Estado")]),_vm._v(" "),_c('at-select',{ref:"ufSelect",attrs:{"filterable":"","size":"large","placeholder":"Estado","required":""},on:{"on-change":_vm.onUfChange},model:{value:(_vm.uf),callback:function ($$v) {_vm.uf=$$v},expression:"uf"}},_vm._l((_vm.estados),function(state,i){return _c('at-option',{key:("stateOptions" + i),attrs:{"value":state.uf}},[_vm._v(_vm._s(state.nome))])}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-12 text-left"},[_c('label',{attrs:{"for":"cidade"}},[_vm._v("Cidade")]),_vm._v(" "),_c('at-select',{ref:"citySelect",attrs:{"filterable":"","size":"large","placeholder":"Cidade","required":""},model:{value:(_vm.cidade),callback:function ($$v) {_vm.cidade=$$v},expression:"cidade"}},_vm._l((_vm.cidades),function(city,i){return _c('at-option',{key:("cityOptions" + i),attrs:{"value":city.nome}},[_vm._v(_vm._s(city.nome))])}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Endereço Residencial")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zFu2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zGJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SocialNetwork__ = __webpack_require__("TYgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_array_helper__ = __webpack_require__("rzJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PasswordField__ = __webpack_require__("i7i+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lpUrl: "https://iouu.com.br",
      name: '',
      email: '',
      password: '',
      enabled: false
    };
  },

  components: {
    SocialNetwork: __WEBPACK_IMPORTED_MODULE_1__components_SocialNetwork__["a" /* default */], PasswordField: __WEBPACK_IMPORTED_MODULE_3__components_PasswordField__["a" /* default */]
  },
  methods: {
    signUp: function signUp() {
      var _this = this;

      this.$store.dispatch('signup', { name: this.name, email: this.email, password: this.password }).then(function () {
        return _this.$router.push("/");
      }).catch(function (error) {
        var errorMessages = error.response.data.errors.map(function (error) {
          return error.detail;
        });
        _this.$Notify.error(__WEBPACK_IMPORTED_MODULE_2__utils_array_helper__["a" /* default */].toSentence(errorMessages));
      });
      fbq('track', 'Lead', { userID: email }); //PIXEL DO FACEBOOK
    },
    facebookLogin: function facebookLogin(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].get('oauth/facebook/url').then(function (response) {
        window.location.href = response.data.loginUrl;
      });
    },
    googleLogin: function googleLogin(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].get('oauth/google/url').then(function (response) {
        window.location.href = response.data.loginUrl;
      });
    },
    linkedinLogin: function linkedinLogin(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_0__utils_api_client__["a" /* default */].get('oauth/linkedin/url').then(function (response) {
        window.location.href = response.data.loginUrl;
      });
    }
  }
});

/***/ }),

/***/ "zGMT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_client_go__ = __webpack_require__("879M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_hub_consulta_client__ = __webpack_require__("pk4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_api_client__ = __webpack_require__("6Yc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_masker__ = __webpack_require__("7VWg");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            encontrado: false,
            Naoencontrado: false,
            infosDarf: {},
            PagAtual: {},
            wallet: {},
            DataApuracao: null,
            DataVencimento: null
        };
    },


    methods: {
        companyName: function companyName(solicitacao) {
            var name = void 0;

            if (solicitacao == null) {
                name = "";
            } else if (solicitacao.TipoEmprestimo == "emprestimo-de-impacto") {
                name = solicitacao.Impacto.NomeEmpresa;
            } else if (solicitacao.TipoEmprestimo == "emprestimo-social") {

                if (solicitacao.Social.RazaoSocial == "") name = solicitacao.Social.NomeCompleto;else name = solicitacao.Social.RazaoSocial;
            } else {

                if (solicitacao.Empresa.NomeFantasia != "") name = solicitacao.Empresa.NomeFantasia;else name = solicitacao.Empresa.RazaoSocial;
            }

            return name;
        },
        CalcIR: function CalcIR(darf) {

            var solicitacao = darf.Solicitacao;
            var fatura = darf.Fatura.IndiceFatura + 1;
            var reserva = darf.ReservaInvestimento;
            var juros = darf.Carteira.Juros == undefined ? 0 : darf.Carteira.Juros;

            var aliqIR = void 0;
            var ipmt = void 0;

            if (solicitacao != null || solicitacao != undefined) {
                ipmt = -this.IPMT(solicitacao.RetornoBrutoMensal / 100, fatura, solicitacao.Prazo, reserva.Valor);
                ipmt = Math.round(ipmt * 100) / 100;
            }

            if (fatura >= 1 && fatura < 6) aliqIR = 0.225;else if (fatura >= 6 && fatura < 12) aliqIR = 0.2;else if (fatura >= 12 && fatura < 24) aliqIR = 0.175;else aliqIR = 0.15;

            if (juros == undefined || juros == null) juros = 0;

            return this.formatCurrency((ipmt + juros) * aliqIR);
        },
        IPMT: function IPMT(rate, period, periods, present, future, type) {
            // Credits: algorithm inspired by Apache OpenOffice

            // Initialize type
            type = typeof type === 'undefined' ? 0 : type;

            // Initialize future
            future = typeof future === 'undefined' ? 0 : future;

            // Evaluate rate and periods (TODO: replace with secure expression evaluator)
            rate = eval(rate);
            periods = eval(periods);

            // Compute payment
            var payment = this.PMT(rate, periods, present, future, type);

            // Compute interest
            var interest;
            if (period === 1) {
                if (type === 1) {
                    interest = 0;
                } else {
                    interest = -present;
                }
            } else {
                if (type === 1) {
                    interest = this.FV(rate, period - 2, payment, present, 1) - payment;
                } else {
                    interest = this.FV(rate, period - 1, payment, present, 0);
                }
            }

            var result = interest * rate;
            // result = Math.round(result * 100) / 100;

            // Return interest
            return interest * rate;
        },
        PMT: function PMT(rate, periods, present, future, type) {
            // Credits: algorithm inspired by Apache OpenOffice

            // Initialize type
            type = typeof type === 'undefined' ? 0 : type;

            // Initialize future
            future = 0;

            // Evaluate rate (TODO: replace with secure expression evaluator)
            rate = eval(rate);

            // Return payment
            var result;
            if (rate === 0) {
                result = (present + future) / periods;
            } else {
                var term = Math.pow(1 + rate, periods);
                if (type === 1) {
                    result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
                } else {
                    result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
                }
            }

            // result = Math.round(result * 100) / 100;

            return -result;
        },
        VerificarDarf: function VerificarDarf(op, wallet) {

            var indiceFatura = op.FaturaID.IndiceFatura;
            var ir = 0;

            for (var i = 0; i < indiceFatura; i++) {

                var juros = 0;
                if (op.FaturaID != null) {

                    juros = this.EncontrarJuros(op.FaturaID._id, i, wallet);
                }

                var darf = {};
                darf.Solicitacao = op.SolicitacaoID, darf.Fatura = {};
                darf.Fatura.IndiceFatura = i;
                darf.ReservaInvestimento = op.ReservaInvestimentoID;
                darf.Carteira = {};
                darf.Carteira.Juros = juros;

                var vIR = this.CalcIR(darf);

                vIR = vIR.replace(/\./g, '');
                vIR = vIR.replace(',', '.');

                ir += parseFloat(vIR);
                if (ir > 10) ir = 0;
            }

            var darf = {};
            darf.Solicitacao = op.SolicitacaoID, darf.Fatura = {};
            darf.Fatura.IndiceFatura = indiceFatura;
            darf.ReservaInvestimento = op.ReservaInvestimentoID;
            darf.Carteira = {};
            darf.Carteira.Juros = op.Juros == undefined ? 0 : op.Juros;

            var vIR = this.CalcIR(darf);
            vIR = vIR.replace(/\./g, '');
            vIR = vIR.replace(',', '.');
            ir += parseFloat(vIR);

            // op.IR = ir;
            // if(ir >= 10)
            //     return ir
            return this.formatCurrency(ir);
        },
        EncontrarJuros: function EncontrarJuros(faturaID, indice, wallet) {

            for (var i = 0; i < wallet.length; i++) {
                if (wallet[i].FaturaID != null && wallet[i].FaturaID != undefined && wallet[i].FaturaID._id == faturaID && wallet[i].FaturaID.IndiceFatura == indice) {
                    return wallet[i].Juros;
                }
            }

            return 0;
        },
        formatCurrency: function formatCurrency(value) {
            if (value != null) {
                if (typeof value == "string") value = parseFloat(value);

                value = parseInt(value * 100) / 100.0;

                return value.toLocaleString('pt-BR', { minimumFractionDigits: "2", maximumFractionDigits: 2 });
            }

            return 0;
        },
        FV: function FV(rate, periods, payment, value, type) {
            // Credits: algorithm inspired by Apache OpenOffice

            // Initialize type
            type = typeof type === 'undefined' ? 0 : type;

            // Evaluate rate (TODO: replace with secure expression evaluator)
            rate = eval(rate);

            // Return future value
            var result;
            if (rate === 0) {
                result = value + payment * periods;
            } else {
                var term = Math.pow(1 + rate, periods);
                if (type === 1) {
                    result = value * term + payment * (1 + rate) * (term - 1.0) / rate;
                } else {
                    result = value * term + payment * (term - 1) / rate;
                }
            }

            // result = Math.round(result * 100) / 100;

            return -result;
        },
        getYear: function getYear(data) {
            var aux = data.split("T");
            var day = aux[0].split("-");

            return day[0];
        },
        getMonth: function getMonth(data) {
            var aux = data.split("T");
            var month = aux[0].split("-");

            return month[1];
        },
        getDataApuracao: function getDataApuracao(data) {
            var _this = this;

            if (data == undefined) return "";

            var d2 = new Date(data);
            var dIR = new Date();

            if (d2.getDate() < 11) {
                dIR = new Date(d2.getFullYear(), d2.getMonth(), 11);
            } else {

                if (d2.getDate() < 21) dIR = new Date(d2.getFullYear(), d2.getMonth(), 21);else dIR = new Date(d2.getFullYear(), d2.getMonth() + 1, 1);
            }

            __WEBPACK_IMPORTED_MODULE_4__utils_hub_consulta_client__["a" /* default */].ConsultaTerceiroDiaUtil(dIR.getDate(), dIR.getMonth() + 1, dIR.getFullYear()).then(function (resp) {
                dIR = new Date(resp.data);
                dIR.setHours(dIR.getHours() + 4);

                var dia = dIR.getDate() + "";
                if (dia.length < 2) dia = "0" + dia;
                var mes = dIR.getMonth() + 1 + "";
                if (mes.length < 2) mes = "0" + mes;
                var ano = dIR.getFullYear();

                _this.DataVencimento = dia + "/" + mes + "/" + ano;
            });

            return "";
        },
        getDataVencimento: function getDataVencimento(data) {

            if (data == undefined) return " ";

            var d = new Date(data);

            var dia = d.getDate();
            if (dia.length < 2) dia = "0" + dia;
            var mes = d.getMonth() + 1 + "";
            if (mes.length < 2) mes = "0" + mes;
            var ano = d.getFullYear();

            console.log(dia, mes, ano);

            return dia + "/" + mes + "/" + ano;

            // d = new Date(d.getFullYear(),d.getMonth(),d.getDate());
            // var d2 = d

            // var dia = d2.getDate()

            // if(dia < 10)
            //     dia= 10
            // else
            // { 
            //     if(dia < 20)
            //         dia= 20
            //     else
            //         dia= 1
            // }
            // var mes = this.getMonth(d.toISOString())+""
            // if(mes.length < 2)
            //     mes ="0"+mes
            // var ano = this.getYear(d.toISOString())

            // if(dia == 1)
            // {
            //     d.setMonth(d.getMonth()+1);
            //     d.setDate(0)
            //     dia = d.getDate();
            // }


            return dia + "/" + mes + "/" + ano;
        },
        formatCPF: function formatCPF(cpf) {
            return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        },


        //tagueamento GA
        taggingGA: function taggingGA() {
            this.$ga.page({
                page: '/darf/:id/:idINV/ ',
                title: 'DARF'
            });
        }
    },

    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var transactionID, invID;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            transactionID = _this2.$route.params.id;
                            invID = _this2.$route.params.idINV;


                            __WEBPACK_IMPORTED_MODULE_3__utils_api_client_go__["a" /* default */].getInfoDarf(transactionID).then(function (response) {

                                _this2.infosDarf = response.data;

                                _this2.encontrado = true;

                                __WEBPACK_IMPORTED_MODULE_5__utils_api_client__["a" /* default */].getAllWallet(invID).then(function (infos) {
                                    var Wallet = infos.data.Carteira.sort(function (a, b) {
                                        if (a.Data < b.Data) {
                                            return 1;
                                        } else if (a.Data > b.Data) {
                                            return -1;
                                        } else {
                                            return 0;
                                        }
                                    });

                                    var repagAtual;

                                    for (var i = 0; i < Wallet.length; i++) {
                                        if (Wallet[i]._id == transactionID) {
                                            repagAtual = Wallet[i];

                                            _this2.PagAtual = repagAtual;

                                            break;
                                        }
                                    }

                                    _this2.infosDarf.Valor = _this2.VerificarDarf(repagAtual, Wallet);

                                    _this2.$forceUpdate();
                                }).catch(function (ex) {
                                    console.log(":-(   ", ex);
                                    _this2.Naoencontrado = true;
                                    _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
                                });
                            }).catch(function () {
                                _this2.Naoencontrado = true;
                                _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types_js__["d" /* STOP_LOADING */]);
                            });

                            window.onafterprint = function () {
                                document.getElementById('sumir').style = '';
                            };

                            //tagueamento GA
                            _context.next = 6;
                            return _this2.taggingGA();

                        case 6:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    }
});

/***/ }),

/***/ "zN5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-8 text-center"},[_vm._m(0),_vm._v(" "),_c('form',[_c('div',{staticClass:"margin"},[_c('files-input',{attrs:{"files":_vm.arquivos,"accept":_vm.formatosAceitos,"uploadEndpoint":_vm.uploadEndpoint},on:{"files-changed":_vm.onFilesChanged}})],1),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",on:{"click":_vm.onSubmit}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit"},[_c('p',[_vm._v("Comprovante de MEI")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zRgK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__ = __webpack_require__("/7yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__ = __webpack_require__("rzJh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilesInput: __WEBPACK_IMPORTED_MODULE_0__components_FilesInput__["a" /* default */]
  },
  data: function data() {
    return {
      /* eslint-disable */
      uploadEndpoint: "https://server-app.iouu.com.br/api/v1" + '/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: this.solicitacao.ArquivosComprovanteMei || []
    };
  },

  computed: {
    arquivosRecebidos: function arquivosRecebidos() {
      return this.arquivos.filter(function (arquivo) {
        return arquivo != null && arquivo != undefined;
      });
    }
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  methods: {
    onFilesChanged: function onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles;
    },
    validate: function validate() {
      if (this.arquivosRecebidos.length > 0) {
        return { isValid: true, errors: [] };
      } else {
        return { isValid: false, errors: ['O envio do comprovante de MEI é obrigatório'] };
      }
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var validation = this.validate();

      if (validation.isValid) {
        var newData = {
          ArquivosComprovanteMei: this.arquivosRecebidos
        };
        this.$emit('on-submit', newData);
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: __WEBPACK_IMPORTED_MODULE_1__utils_array_helper__["a" /* default */].toSentence(validation.errors) });
      }
    }
  }
});

/***/ }),

/***/ "zVRO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginBanner_vue__ = __webpack_require__("8IUl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18135a09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginBanner_vue__ = __webpack_require__("2yOF");
function injectStyle (ssrContext) {
  __webpack_require__("yKT3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18135a09"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18135a09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zWtS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-7"},[_c('div',{staticClass:"tit text-center"},[_c('p',[_vm._v("Por favor, poderia me informar o Patrimônio Líquido da(o) "),_c('strong',[_vm._v(_vm._s(_vm.razaoSocial))]),_vm._v("?")])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-7 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"celular"}},[_vm._v("Valor em reais")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.patrimonioLiquido),expression:"patrimonioLiquido"},{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"},{name:"focus",rawName:"v-focus"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"R$","required":""},domProps:{"value":(_vm.patrimonioLiquido)},on:{"input":function($event){if($event.target.composing){ return; }_vm.patrimonioLiquido=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"disabled":_vm.patrimonioValido}},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zaBb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-12 col-lg-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-7"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"nomeCompleto"}},[_vm._v("Nome completo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fullName),expression:"fullName"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":""},domProps:{"value":(_vm.fullName)},on:{"keyup":_vm.AlterarNome,"input":function($event){if($event.target.composing){ return; }_vm.fullName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',[_vm._v("Nome Completo da Mãe")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.Pessoal.NomeCompletoMae),expression:"currentUser.Pessoal.NomeCompletoMae"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","required":""},domProps:{"value":(_vm.currentUser.Pessoal.NomeCompletoMae)},on:{"keyup":_vm.AlterarNome,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentUser.Pessoal, "NomeCompletoMae", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-left"},[_c('label',{attrs:{"for":"DataNascimento"}},[_vm._v("Data de Nascimento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.Pessoal.DataNascimento),expression:"currentUser.Pessoal.DataNascimento"},{name:"mask",rawName:"v-mask",value:('date'),expression:"'date'"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"__/__/____","title":"dd/mm/yyyy","required":"","pattern":"\\d{2}/\\d{2}/\\d{4}"},domProps:{"value":(_vm.currentUser.Pessoal.DataNascimento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentUser.Pessoal, "DataNascimento", $event.target.value)}}})]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tit text-center"},[_c('h1',[_vm._v("Nome Completo")]),_vm._v(" "),_c('p',[_vm._v("Agora, por favor, forneça seu "),_c('strong',[_vm._v("Nome completo")]),_vm._v(", sua "),_c('strong',[_vm._v("Data de Nascimento")]),_vm._v(" e o "),_c('strong',[_vm._v("Nome Completo da sua Mãe")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center fixedOptions"},[_c('button',{staticClass:"btn btn-lg btn-primary"},[_vm._v("Próximo "),_c('img',{attrs:{"src":__webpack_require__("CVSu")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zdor":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.emprestimosEmBreve)?_c('div',{staticClass:"d-flex justify-content-center align-items-top dashboard"},[_c('div',{staticClass:"MyLoans"},[_vm._m(0),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"MyLoansContent"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"d-block d-sm-none"},[_c('div',{staticClass:"cards"},_vm._l((this.emprestimos),function(item){return _c('dl',{key:item.IdOportunidade,class:'rating-' + _vm.lowerCase(item.Score)},[_c('dt',{staticClass:"rating"},[_vm._v("Score "),_c('span',{staticClass:"circle score"},[_vm._v(_vm._s(_vm.formatarScore(item.Score)))])]),_vm._v(" "),_c('dt',[_vm._v("ID: "),_c('router-link',{attrs:{"to":""}},[_vm._v(_vm._s(_vm.ajustIdOportunidade(item.IdOportunidade,5)))])],1),_vm._v(" "),_c('dt',[_vm._v("Solicitante")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.Nome(item))),(item.BoletosAtrasados != undefined && item.BoletosAtrasados != 0)?_c('router-link',{staticClass:"badge badge-pill badge-danger",staticStyle:{"text-decoration":"none!important"},attrs:{"to":_vm.Detalhes(item.CodProduto, item._id),"title":"Atualizar"}},[_vm._v(_vm._s(item.BoletosAtrasados))]):_vm._e()],1),_vm._v(" "),_c('dt',[_vm._v("CNPJ/CPF")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.formatted(item.Documento)))]),_vm._v(" "),_c('dt',[_vm._v("Tipo do empréstimo")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.formatarTipoEmprestimo(item.TipoEmprestimo)))]),_vm._v(" "),_c('dt',[_vm._v("Valor solicitado")]),_vm._v(" "),_c('dd',[_vm._v("R$ "+_vm._s(_vm.money(item.Valor)))]),_vm._v(" "),_c('dt',[_vm._v("Taxa de juros")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(item.TaxaJuros==0 || item.TaxaJuros == undefined ?"-":item.TaxaJuros+ "% a.m"))]),_vm._v(" "),_c('dt',[_vm._v("Prazo")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(item.PrazoFinal)+" Meses")]),_vm._v(" "),_c('dd',{staticClass:"align-middle text-center"},[( _vm.AjustaStatus(item)  == 'Incompleto')?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-analise"},[_vm._v(_vm._s(_vm.AjustaStatus(item)))])]):_vm._e(),_vm._v(" "),(_vm.AjustaStatus(item) == 'Processando')?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-analise"},[_vm._v(_vm._s(item.StatusDocumentos == "PENDENTE" ?"Documento Pendente":"Processando"))])]):_vm._e(),_vm._v(" "),(_vm.AjustaStatus(item) == 'Publicado')?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-captando"},[_vm._v(_vm._s(_vm.AjustaStatus(item) == 'Publicado' ?"Captando":_vm.AjustaStatus(item)))])]):_vm._e(),_vm._v(" "),( _vm.AjustaStatus(item) == 'Encerrado' && (!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) && (item.CCBsAssinaturas == false || item.CCBsAssinaturas == undefined))?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-aprovado"},[_vm._v("Aguardando Formalização")])]):_vm._e(),_vm._v(" "),( _vm.AjustaStatus(item) == 'Encerrado' && (!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined)  && (item.CCBsAssinaturas == true))?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-encerrado"},[_vm._v("Processando Desembolso")])]):_vm._e(),_vm._v(" "),( _vm.AjustaStatus(item)  == 'Aprovado')?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-aprovado"},[_vm._v(_vm._s(_vm.AjustaStatus(item) == 'Aprovado' && (!item.AprovadoCliente && item.AprovadoCliente != undefined) ?"Proposta Gerada":"Aguardando Publicação"))])]):_vm._e(),_vm._v(" "),( _vm.AjustaStatus(item)  == 'Negado' )?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-negado"},[_vm._v(_vm._s(_vm.AjustaStatus(item) == 'Negado' && !item.NegadoCliente ?"Negado":"Negado"))])]):_vm._e(),_vm._v(" "),( _vm.AjustaStatus(item)  == 'Encerrado' && item.GerouBoletosPagamento && (item.BoletosAtrasados == undefined || item.BoletosAtrasados == 0))?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-emprestimoativo"},[_vm._v("Empréstimo Ativo")])]):_vm._e(),_vm._v(" "),( _vm.AjustaStatus(item)  == 'Encerrado' && item.GerouBoletosPagamento && (item.BoletosAtrasados != undefined && item.BoletosAtrasados != 0))?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-negado"},[_vm._v("Boleto em atraso")])]):_vm._e()]),_vm._v(" "),(( item.TipoEmprestimo == 'emprestimo-coletivo' || item.TipoEmprestimo == 'emprestimo-de-impacto2' || item.TipoEmprestimo == 'emprestimo-social' ) && ( _vm.AjustaStatus(item) =='Processando' || _vm.AjustaStatus(item)  == 'Negado' || (item.AprovadoCliente != undefined && !item.AprovadoCliente && _vm.AjustaStatus(item) != 'Publicado' && _vm.AjustaStatus(item) != 'Encerrado'  && _vm.AjustaStatus(item) != 'Incompleto' )))?_c('dd',{staticClass:"align-middle"},[(item.StatusAnalise != 'APROVADO' && item.StatusDocumentos != 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.documentos('EMPCOL', item._id),"title":"Atualizar"}},[_vm._v("Ver mais detalhes")]):_vm._e(),_vm._v(" "),(item.StatusAnalise == 'APROVADO' && item.StatusDocumentos != 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.documentos('EMPCOL', item._id),"title":"Atualizar"}},[_vm._v("Visualizar Proposta")]):(item.StatusDocumentos == 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.DocumentosFaltantes('EMPCOL', item._id),"title":"Atualizar"}},[_vm._v("Documentos")]):_vm._e()],1):((item.TipoEmprestimo == 'emprestimo-coletivo' || item.TipoEmprestimo == 'emprestimo-de-impacto2'|| item.TipoEmprestimo == 'emprestimo-social') && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO'|| item.StatusAnalise =='ENCERRADO') && (item.AprovadoCliente || item.AprovadoCliente == undefined))?_c('dd',{staticClass:"align-middle"},[((!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) && (item.CCBsAssinaturas == false || item.CCBsAssinaturas == undefined) && item.StatusAnalise =='ENCERRADO'  )?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.AssinaturaCCB(item._id),"title":"Assinar"}},[_vm._v("Assinar CCBs")]):_vm._e(),_vm._v(" "),((!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) &&item.StatusAnalise !='ENCERRADO')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.Detalhes('EMPCOL', item._id),"title":"Atualizar"}},[_vm._v("Ver mais detalhes")]):_vm._e(),_vm._v(" "),((!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) && item.CCBsAssinaturas == true )?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.Detalhes('EMPCOL', item._id),"title":"Atualizar"}},[_vm._v("Ver mais detalhes")]):_vm._e(),_vm._v(" "),(item.GerouBoletosPagamento && (item.BoletosAtrasados == undefined || item.BoletosAtrasados == 0))?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.Detalhes('EMPCOL', item._id),"title":"Atualizar"}},[_vm._v("Boletos")]):_vm._e(),_vm._v(" "),(item.GerouBoletosPagamento && (item.BoletosAtrasados != undefined && item.BoletosAtrasados != 0))?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.Detalhes('EMPCOL', item._id),"title":"Atualizar"}},[_vm._v("Ver mais detalhes")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.Detalhes('EMPCOL', item._id),"title":"Atualizar"}},[_c('i',{staticClass:"icon icon-eye-2 md"},[_vm._v(" ")])])],1):_vm._e(),_vm._v(" "),( item.TipoEmprestimo == 'emprestimo-pessoal' && ( _vm.AjustaStatus(item) =='Processando' || _vm.AjustaStatus(item)  == 'Negado' || (item.AprovadoCliente != undefined && !item.AprovadoCliente && _vm.AjustaStatus(item) != 'Publicado')))?_c('dd',{staticClass:"align-middle"},[(item.StatusAnalise != 'APROVADO' && item.StatusDocumentos != 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.documentos('EMPPES', item._id),"title":"Atualizar"}},[_vm._v("Ver mais detalhes")]):_vm._e(),_vm._v(" "),(item.StatusAnalise == 'APROVADO' && item.StatusDocumentos != 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.documentos('EMPPES', item._id),"title":"Atualizar"}},[_vm._v("Visualizar Proposta")]):(item.StatusDocumentos == 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.DocumentosFaltantes('EMPPES', item._id),"title":"Atualizar"}},[_vm._v("Documentos")]):_vm._e()],1):_vm._e(),_vm._v(" "),((item.TipoEmprestimo == 'emprestimo-de-impacto' || item.TipoEmprestimo == 'emprestimo-social') && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO' || item.StatusAnalise =='ENCERRADO') && item.AprovadoCliente)?_c('dd',{staticClass:"align-middle"},[_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.Detalhes('EMPIMP', item._id),"title":"Atualizar"}},[_vm._v("Ver mais detalhes")])],1):_vm._e(),_vm._v(" "),(item.TipoEmprestimo == 'emprestimo-ccb' && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO' || item.StatusAnalise =='ENCERRADO'))?_c('dd',{staticClass:"align-middle"},[_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.Detalhes('EMPCCB', item._id),"title":"Atualizar"}},[_vm._v("Ver mais detalhes")])],1):_vm._e(),_vm._v(" "),_c('dd',{staticClass:"align-middle"},[(_vm.AjustaStatus(item) =='Incompleto')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.AjustaLink(item),"title":"Atualizar"}},[_vm._v("Atualizar")]):_vm._e()],1)])}),0)]),_vm._v(" "),_c('div',{staticClass:"table-responsive d-none d-sm-block"},[_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((this.emprestimos),function(item){return _c('tr',{key:item.IdOportunidade,class:'rating-' + _vm.lowerCase(item.Score)},[_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                            "+_vm._s(_vm.ajustIdOportunidade(item.IdOportunidade,5))+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("\n                                           "+_vm._s(_vm.formatarTipoEmprestimo(item.TipoEmprestimo))+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("\n                                           "+_vm._s(_vm.Nome(item))),(item.BoletosAtrasados != undefined && item.BoletosAtrasados != 0)?_c('router-link',{staticClass:"badge badge-pill badge-danger",staticStyle:{"text-decoration":"none!important"},attrs:{"to":_vm.Detalhes(item.CodProduto, item._id),"title":"Atualizar"}},[_vm._v(_vm._s(item.BoletosAtrasados))]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                            "+_vm._s(_vm.formatted(item.Documento))+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"rating align-middle text-center",attrs:{"scope":"col"}},[_c('span',{staticClass:"rounded-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatarScore(item.Score)))])]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                            "+_vm._s(item.TaxaJuros==0 || item.TaxaJuros == undefined ?"-":item.TaxaJuros+ "% a.m")+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("\n                                            "+_vm._s(item.Alongamento ? item.PrazoFinal : item.Prazo)+" Meses\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_vm._v("\n                                            R$ "+_vm._s((item.ValorSolicitado == 0 || item.ValorSolicitado == undefined) ? _vm.money(item.Valor) : _vm.money(item.ValorSolicitado))+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[( _vm.AjustaStatus(item)  == 'Incompleto')?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-analise"},[_vm._v(_vm._s(_vm.AjustaStatus(item)))])]):_vm._e(),_vm._v(" "),(_vm.AjustaStatus(item) == 'Processando')?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-analise"},[_vm._v(_vm._s(item.StatusDocumentos == "PENDENTE" ?"Documento Pendente":"Processando"))])]):_vm._e(),_vm._v(" "),(_vm.AjustaStatus(item) == 'Publicado')?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-captando"},[_vm._v(_vm._s(_vm.AjustaStatus(item) == 'Publicado' ?"Captando":_vm.AjustaStatus(item)))])]):_vm._e(),_vm._v(" "),( _vm.AjustaStatus(item) == 'Encerrado' && (!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) && (item.CCBsAssinaturas == false || item.CCBsAssinaturas == undefined))?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-aprovado"},[_vm._v("Aguardando Formalização")])]):_vm._e(),_vm._v(" "),( _vm.AjustaStatus(item) == 'Encerrado' && (!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) && (item.CCBsAssinaturas == true))?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-encerrado"},[_vm._v("Processando Desembolso")])]):_vm._e(),_vm._v(" "),( _vm.AjustaStatus(item)  == 'Aprovado')?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-aprovado"},[_vm._v(_vm._s(_vm.AjustaStatus(item) == 'Aprovado' && (!item.AprovadoCliente && item.AprovadoCliente != undefined) ?"Proposta Gerada":"Aguardando Publicação"))])]):_vm._e(),_vm._v(" "),( _vm.AjustaStatus(item)  == 'Negado' )?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-negado"},[_vm._v(_vm._s(_vm.AjustaStatus(item) == 'Negado' && !item.NegadoCliente ?"Negado":"Negado"))])]):_vm._e(),_vm._v(" "),( (item.BoletosAtrasados == undefined || item.BoletosAtrasados == 0) && _vm.AjustaStatus(item)  == 'Encerrado' && item.GerouBoletosPagamento)?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-emprestimoativo"},[_vm._v("Empréstimo Ativo")])]):_vm._e(),_vm._v(" "),( _vm.AjustaStatus(item)  == 'Encerrado' && item.GerouBoletosPagamento && (item.BoletosAtrasados != undefined && item.BoletosAtrasados != 0))?_c('div',{staticClass:"ss"},[_c('span',{staticClass:"ss-negado"},[_vm._v("Boleto em atraso")])]):_vm._e()]),_vm._v(" "),(( item.TipoEmprestimo == 'emprestimo-coletivo' || item.TipoEmprestimo == 'emprestimo-de-impacto2' || item.TipoEmprestimo == 'emprestimo-social' ) && ( _vm.AjustaStatus(item) =='Processando' || _vm.AjustaStatus(item)  == 'Negado' || (item.AprovadoCliente != undefined && !item.AprovadoCliente && _vm.AjustaStatus(item) != 'Publicado' && _vm.AjustaStatus(item) != 'Encerrado'  && _vm.AjustaStatus(item) != 'Incompleto' )))?_c('td',{staticClass:"align-middle"},[(item.StatusAnalise != 'APROVADO' && item.StatusDocumentos != 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link desk",attrs:{"to":_vm.documentos('EMPCOL', item._id),"title":"Atualizar"}},[_vm._v("Ver mais detalhes")]):_vm._e(),_vm._v(" "),(item.StatusAnalise == 'APROVADO' && item.StatusDocumentos != 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link desk",attrs:{"to":_vm.documentos('EMPCOL', item._id),"title":"Atualizar"}},[_vm._v("Visualizar Proposta")]):(item.StatusDocumentos == 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link desk",attrs:{"to":_vm.DocumentosFaltantes('EMPCOL', item._id),"title":"Atualizar"}},[_vm._v("Documentos")]):_vm._e(),_vm._v(" "),(item.StatusAnalise != 'APROVADO' && item.StatusDocumentos != 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.documentos('EMPCOL', item._id),"title":"Atualizar"}},[_c('i',{staticClass:"icon icon-eye-2 md"},[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(item.StatusAnalise == 'APROVADO' && item.StatusDocumentos != 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.documentos('EMPCOL', item._id),"title":"Atualizar"}},[_c('i',{staticClass:"icon icon-eye-2 md"},[_vm._v(" ")])]):(item.StatusDocumentos == 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.DocumentosFaltantes('EMPCOL', item._id),"title":"Atualizar"}},[_c('i',{staticClass:"icon icon-eye-2 md"},[_vm._v(" ")])]):_vm._e()],1):((item.TipoEmprestimo == 'emprestimo-coletivo' || item.TipoEmprestimo == 'emprestimo-de-impacto2' || item.TipoEmprestimo == 'emprestimo-social') && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO'|| item.StatusAnalise =='ENCERRADO') && (item.AprovadoCliente || item.AprovadoCliente == undefined))?_c('td',{staticClass:"align-middle"},[((!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) && (item.CCBsAssinaturas == false || item.CCBsAssinaturas == undefined) && item.StatusAnalise =='ENCERRADO'  )?_c('router-link',{staticClass:"btn btn-link desk",attrs:{"to":_vm.AssinaturaCCB(item._id),"title":"Assinar"}},[_vm._v("Assinar CCBs")]):_vm._e(),_vm._v(" "),((!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) &&item.StatusAnalise !='ENCERRADO')?_c('router-link',{staticClass:"btn btn-link desk",attrs:{"to":_vm.Detalhes('EMPCOL', item._id),"title":"Atualizar"}},[_vm._v("Ver mais detalhes")]):_vm._e(),_vm._v(" "),((!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) && item.CCBsAssinaturas == true )?_c('router-link',{staticClass:"btn btn-link desk",attrs:{"to":_vm.Detalhes('EMPCOL', item._id),"title":"Atualizar"}},[_vm._v("Ver mais detalhes")]):_vm._e(),_vm._v(" "),(item.GerouBoletosPagamento && (item.BoletosAtrasados == undefined || item.BoletosAtrasados == 0))?_c('router-link',{staticClass:"btn btn-link desk",attrs:{"to":_vm.Detalhes('EMPCOL', item._id),"title":"Atualizar"}},[_vm._v("Boletos")]):_vm._e(),_vm._v(" "),(item.GerouBoletosPagamento && (item.BoletosAtrasados != undefined && item.BoletosAtrasados != 0))?_c('router-link',{staticClass:"btn btn-link desk",attrs:{"to":_vm.Detalhes('EMPCOL', item._id),"title":"Atualizar"}},[_vm._v("Ver mais detalhes")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.Detalhes('EMPCOL', item._id),"title":"Atualizar"}},[_c('i',{staticClass:"icon icon-eye-2 md"},[_vm._v(" ")])])],1):_vm._e(),_vm._v(" "),( item.TipoEmprestimo == 'emprestimo-pessoal' && ( _vm.AjustaStatus(item) =='Processando' || _vm.AjustaStatus(item)  == 'Negado' || (item.AprovadoCliente != undefined && !item.AprovadoCliente && _vm.AjustaStatus(item) != 'Publicado')))?_c('td',{staticClass:"align-middle"},[(item.StatusAnalise != 'APROVADO' && item.StatusDocumentos != 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link desk",attrs:{"to":_vm.documentos('EMPPES', item._id),"title":"Atualizar"}},[_vm._v("Ver mais detalhes")]):_vm._e(),_vm._v(" "),(item.StatusAnalise == 'APROVADO' && item.StatusDocumentos != 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link desk",attrs:{"to":_vm.documentos('EMPPES', item._id),"title":"Atualizar"}},[_vm._v("Visualizar Proposta")]):(item.StatusDocumentos == 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link desk",attrs:{"to":_vm.DocumentosFaltantes('EMPPES', item._id),"title":"Atualizar"}},[_vm._v("Documentos")]):_vm._e(),_vm._v(" "),(item.StatusAnalise != 'APROVADO' && item.StatusDocumentos != 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.documentos('EMPCOL', item._id),"title":"Atualizar"}},[_c('i',{staticClass:"icon icon-eye-2 md"},[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(item.StatusAnalise == 'APROVADO' && item.StatusDocumentos != 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.documentos('EMPCOL', item._id),"title":"Atualizar"}},[_c('i',{staticClass:"icon icon-eye-2 md"},[_vm._v(" ")])]):(item.StatusDocumentos == 'PENDENTE')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.DocumentosFaltantes('EMPCOL', item._id),"title":"Atualizar"}},[_c('i',{staticClass:"icon icon-eye-2 md"},[_vm._v(" ")])]):_vm._e()],1):_vm._e(),_vm._v(" "),((item.TipoEmprestimo == 'emprestimo-de-impacto' || item.TipoEmprestimo == 'emprestimo-social') && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO' || item.StatusAnalise =='ENCERRADO') && item.AprovadoCliente)?_c('td',{staticClass:"align-middle"},[_c('router-link',{staticClass:"btn btn-link desk",attrs:{"to":_vm.Detalhes('EMPIMP', item._id),"title":"Atualizar"}},[_vm._v("Ver mais detalhes")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.Detalhes('EMPIMP', item._id),"title":"Atualizar"}},[_c('i',{staticClass:"icon icon-eye-2 md"},[_vm._v(" ")])])],1):_vm._e(),_vm._v(" "),(item.TipoEmprestimo == 'emprestimo-ccb' && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO' || item.StatusAnalise =='ENCERRADO'))?_c('td',{staticClass:"align-middle"},[_c('router-link',{staticClass:"btn btn-link desk",attrs:{"to":_vm.Detalhes('EMPCCB', item._id),"title":"Atualizar"}},[_vm._v("Ver mais detalhes")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.Detalhes('EMPCCB', item._id),"title":"Atualizar"}},[_c('i',{staticClass:"icon icon-eye-2 md"},[_vm._v(" ")])])],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"align-middle"},[(_vm.AjustaStatus(item) =='Incompleto')?_c('router-link',{staticClass:"btn btn-link desk",attrs:{"to":_vm.AjustaLink(item),"title":"Atualizar"}},[_vm._v("Atualizar")]):_vm._e(),_vm._v(" "),(_vm.AjustaStatus(item) =='Incompleto')?_c('router-link',{staticClass:"btn btn-link mob",attrs:{"to":_vm.AjustaLink(item),"title":"Atualizar"}},[_c('i',{staticClass:"icon icon-eye-2 md"},[_vm._v(" ")])]):_vm._e()],1),_vm._v(" "),(_vm.AjustaStatus(item) =='Incompleto'  )?_c('td',{staticClass:"align-middle"}):_vm._e()])}),0)])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.emprestimosEmBreve)?_c('div',{staticClass:"d-flex justify-content-center align-items-center dashboard"},[_vm._m(2)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MyLoansHeader"},[_c('div',{staticClass:"row tit_page"},[_c('div',{staticClass:"col-12 col-lg-6 text-left align-middle"},[_c('h1',[_vm._v("Meus empréstimos")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 text-right align-middle d-flex justify-content-end"},[_c('div',{staticClass:"RequestLoan"},[_c('a',{staticClass:"t-head",attrs:{"href":"https://emprestimos.iouu.com.br/pedido","title":"Solicitar novo empréstimo"}},[_c('i',{staticClass:"icon-bg-plus"}),_vm._v(" Solicitar novo empréstimo\n                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"70"}},[_vm._v("\n                                            ID\n                                        ")]),_vm._v(" "),_c('th',{staticClass:"align-middle",attrs:{"scope":"col","width":"150"}},[_vm._v("\n                                            Empréstimo\n                                        ")]),_vm._v(" "),_c('th',{staticClass:"align-middle",attrs:{"scope":"col"}},[_vm._v("\n                                            Solicitante\n                                        ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"150"}},[_vm._v("\n                                            CNPJ/CPF\n                                        ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n                                            Score\n                                        ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n                                            Taxa de Juros\n                                        ")]),_vm._v(" "),_c('th',{staticClass:"align-middle",attrs:{"scope":"col","width":"90"}},[_vm._v("\n                                            Prazo\n                                        ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col"}},[_vm._v("\n                                            Valor solicitado\n                                        ")]),_vm._v(" "),_c('th',{staticClass:"align-middle text-center",attrs:{"scope":"col","width":"150"}},[_vm._v("\n                                            Status\n                                        ")]),_vm._v(" "),_c('th',{attrs:{"scope":"col","width":"10"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard__complete"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Meus empréstimos")]),_vm._v(" "),_c('div',[_c('p',[_vm._v("Você não tem nenhuma solicitação de empréstimo cadastrada!")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zhCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileConf_vue__ = __webpack_require__("iWKg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f9ac4d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileConf_vue__ = __webpack_require__("vbrb");
function injectStyle (ssrContext) {
  __webpack_require__("bPRD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f9ac4d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileConf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f9ac4d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileConf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.cb86e1b279725ab93b79.js